/* eslint-disable */
(function () {
  "use strict";
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(
        document.createTextNode(
          '@import"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap";._typography_iuw1x_1{font-family:Inter,sans-serif}._regular_iuw1x_5{font-weight:400}._medium_iuw1x_9{font-weight:500}._semiBold_iuw1x_13{font-weight:600}._bold_iuw1x_17{font-weight:700}._heading1_iuw1x_21{font-size:72px;line-height:1;letter-spacing:-2.16px}._heading2_iuw1x_27{font-size:48px;line-height:58px}._heading3_iuw1x_32{font-size:24px;line-height:32px}._heading4_iuw1x_37{font-size:12px;line-height:16px;letter-spacing:.36px}._paragraph1_iuw1x_43{font-size:20px;line-height:28px}._paragraph2_iuw1x_48{font-size:16px;line-height:24px;letter-spacing:-.16px}._paragraph3_iuw1x_54{font-size:14px;line-height:20px}._paragraph4_iuw1x_59{font-size:12px;line-height:20px;letter-spacing:-.18px}._paragraph5_iuw1x_65{font-size:10px;line-height:1;letter-spacing:.3px}._btn_yuknb_1{display:flex;flex-flow:row nowrap;align-items:center;cursor:pointer}._btn_yuknb_1:hover ._icon_yuknb_7,._btn_yuknb_1:hover ._text_yuknb_8{color:#eef9fc}._icon_yuknb_7{color:#bbc2ca;transition:all .15s ease-out}._text_yuknb_8{margin-left:8px;flex:1;color:#bbc2ca;transition:all .15s ease-out}._button_amk7b_1{min-width:160px;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;border-radius:10px;padding:10px 0;font-family:Inter,sans-serif;font-size:16px;line-height:24px;font-weight:400;letter-spacing:.16px;outline:none;border:1px solid transparent;color:var(--ui-color-soft-sky);cursor:pointer;transition:all .15s ease-out}._button_amk7b_1:disabled{opacity:.5}._buttonDisabled_amk7b_24{pointer-events:none}._default_amk7b_28{background:linear-gradient(82deg,#2a52ee .15%,#00c8ff 87.75%)!important;border-color:linear-gradient(82deg,#2a52ee .15%,#00c8ff 87.75%)}._secondary_amk7b_33{background:var(--ui-color-soft-sky-25)!important;border-color:var(--ui-color-soft-sky-25)}._outlined_amk7b_38{background:transparent;border-color:#eef9fc3d}._outlined_amk7b_38:not(._buttonDisabled_amk7b_24):hover{background:#eef9fc3d}._success_amk7b_46{background:transparent;border-color:#10aa44;color:#10aa44}._success_amk7b_46:not(._buttonDisabled_amk7b_24):hover{background:#10aa44;color:#eef9fc}._error_amk7b_56{background:transparent;border-color:#b83e3e;color:#b83e3e}._error_amk7b_56:not(._buttonDisabled_amk7b_24):hover{background:#b83e3e;color:#eef9fc}._buttonDisabled_amk7b_24{opacity:.7}._startAdornment_amk7b_70{display:flex;flex-flow:column nowrap;margin-right:10px}._endAdornment_amk7b_76{display:flex;flex-flow:column nowrap;margin-left:10px}._input_1c6qh_1{width:100%;display:flex;flex-flow:row nowrap;align-items:center;background-color:inherit;border-radius:14px}._field_1c6qh_10{width:100%;border:0;background-color:transparent;outline:none;font-family:Inter,sans-serif;font-size:16px;line-height:24px;font-weight:600;color:var(--ui-color-soft-sky)}._icon_1c6qh_22{display:flex;flex-flow:column nowrap;margin-right:6px;color:var(--ui-color-brisk-winter-morning);width:30px;height:30px}._button_yv9b1_1{display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;padding:7px 8px;height:18px;border-radius:6px;background-color:#0099ff4d;cursor:pointer;transition:all .15s ease-out}._button_yv9b1_1:hover{background-color:var(--ui-color-electric-teal)}._button_yv9b1_1:hover ._text_yv9b1_16{color:var(--ui-color-soft-sky)}._text_yv9b1_16{color:var(--ui-color-electric-teal)}._enterPanel_19jrb_1{background-color:var(--ui-color-dee-dark-cyan);padding:16px;border-radius:18px}._balance_19jrb_7{display:flex;align-items:center}._balanceText_19jrb_12{color:var(--ui-color-soft-steel);margin-right:4px}._inputs_19jrb_17{margin-top:10px}._root_4hx65_1{display:flex}._vertical_4hx65_5{flex-flow:column nowrap;align-items:flex-start}._vertical_4hx65_5 ._value_4hx65_9{margin-top:4px}._horizontal_4hx65_13{flex-flow:row nowrap;align-items:center;justify-content:space-between}._label_4hx65_19{color:var(--ui-color-misty-lavender);text-transform:uppercase}._value_4hx65_9{color:var(--ui-color-soft-sky)}._root_ux4rg_1{margin-top:16px;display:flex;flex-flow:column nowrap}._title_ux4rg_7{color:#bbc2ca}._items_ux4rg_11{margin-top:8px;background-color:#5865793d;border-radius:10px;width:-moz-max-content;width:max-content;position:relative}._itemsInner_ux4rg_19{position:relative;display:flex;flex-flow:row nowrap;align-items:center;z-index:2}._item_ux4rg_11{display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;width:68px;padding:4px 24px;border-radius:10px;cursor:pointer}._item_ux4rg_11:not(._itemSelected_ux4rg_37):hover{background-color:#eef9fc3d}._itemSelected_ux4rg_37{background-color:#0098ff}._itemSelected_ux4rg_37 ._itemText_ux4rg_44{color:#eef9fc}._itemDisabled_ux4rg_48{pointer-events:none;opacity:.5}._itemText_ux4rg_44{color:#bbc2ca}._step_1d3rs_1{display:flex;flex-flow:column nowrap}._backButton_1d3rs_6{position:absolute;top:26px;right:24px}._title_1d3rs_12{color:#eef9fc}._enterPanel_1d3rs_16{margin-top:16px}._infoItem_1d3rs_20{margin-top:12px}._infoItemInner_1d3rs_24{display:flex;flex-flow:row nowrap;align-items:center}._infoItemFromValue_1d3rs_30{width:-moz-max-content;width:max-content;color:#eef9fc}._infoItemToValue_1d3rs_35{width:-moz-max-content;width:max-content}._infoItemToValuePositive_1d3rs_39{color:#10aa44}._infoItemToValueNegative_1d3rs_43{color:#b83e3e}._infoItemIcon_1d3rs_47{margin:0 8px}._action_1d3rs_51{width:100%;margin-top:16px}._step_bv5td_1{display:flex;flex-flow:column nowrap}._title_bv5td_6{color:#eef9fc}._infoItem_bv5td_10{margin-top:12px}._tokenIcon_bv5td_14{color:var(--ui-color-brisk-winter-morning);width:30px;height:30px}._actions_bv5td_20{margin-top:16px;display:flex;flex-flow:row nowrap;align-items:center;-moz-column-gap:4px;column-gap:4px}._action_bv5td_20{flex:1}._step_e4elo_1{display:flex;flex-flow:column nowrap}._backButton_e4elo_6{position:absolute;top:26px;right:24px}._title_e4elo_12{color:#eef9fc}._text_e4elo_16{margin-top:16px;color:#eef9fc}._textCaption_e4elo_21{color:#b83e3e}._info_e4elo_25{margin-top:16px;display:flex;flex-flow:column nowrap}._infoText_e4elo_31{color:#bbc2ca;text-transform:uppercase}._infoInner_e4elo_36{margin-top:4px;display:flex;flex-flow:row nowrap;align-items:center}._infoIcon_e4elo_43{width:30px;height:30px}._infoValue_e4elo_48{flex:1;margin-left:6px;color:#eef9fc}._infoValueWithLose_e4elo_54{color:#b83e3e}._actions_e4elo_58{margin-top:16px;display:flex;flex-flow:row nowrap;align-items:center;-moz-column-gap:16px;column-gap:16px}._action_e4elo_58{flex:1}._loader_ga1u1_1{width:24px;aspect-ratio:1;border-radius:50%;background:radial-gradient(farthest-side,#3652e5 94%,#0000) top/4px 4px no-repeat,conic-gradient(#0000 30%,#3652e5);-webkit-mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 4px),#000 0);mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 4px),#000 0);animation:_loaderAnimation_ga1u1_1 1s infinite linear}@keyframes _loaderAnimation_ga1u1_1{to{transform:rotate(1turn)}}._staking_1qai0_1{position:relative;width:392px;min-height:200px;display:flex;flex-flow:column nowrap;background-color:#131c28;padding:24px;border-radius:24px}._loading_1qai0_12{align-self:center;margin-top:74px}html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,main,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}*[hidden]{display:none}body{line-height:1}menu,ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:"";content:none}table{border-collapse:collapse;border-spacing:0}:root{--ui-color-black: #000;--ui-color-white: #fff;--ui-color-2: #050b15;--ui-color-1: rgba(88, 101, 121, .25);--ui-color-3: rgba(16, 168, 66, .3);--ui-color-4: rgba(0, 153, 255, .3);--ui-color-soft-sky-10: rgba(238, 249, 252, .1);--ui-color-soft-sky-25: rgba(238, 249, 252, .25);--ui-color-soft-sky: #f2fcff;--ui-color-misty-lavender: #bac1c9;--ui-color-misty-lavender-50: rgba(186, 193, 201, .5);--ui-color-electric-teal: #0099ff;--ui-color-dark-plum: #141d2a;--ui-color-deep-jungle-green: #10a842;--ui-color-crimson-red: #b83d3d;--ui-color-dee-dark-cyan: #050d17;--ui-color-soft-steel: #bbc2ca;--ui-color-brisk-winter-morning: #eef9fc}*{box-sizing:border-box}body{font-family:Inter,sans-serif}'
        )
      ),
        document.head.appendChild(e);
    }
  } catch (o) {
    console.error("vite-plugin-css-injected-by-js", o);
  }
})();
var Oc = (t, e, n) => {
  if (!e.has(t)) throw TypeError("Cannot " + n);
};
var De = (t, e, n) => (Oc(t, e, "read from private field"), n ? n.call(t) : e.get(t)),
  kt = (t, e, n) => {
    if (e.has(t)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(t) : e.set(t, n);
  },
  Mt = (t, e, n, i) => (Oc(t, e, "write to private field"), i ? i.call(t, n) : e.set(t, n), n);
var Vf = (t, e, n, i) => ({
    set _(l) {
      Mt(t, e, l, n);
    },
    get _() {
      return De(t, e, i);
    },
  }),
  $t = (t, e, n) => (Oc(t, e, "access private method"), n);
import {
  useTonConnectUI as __,
  useTonWallet as b_,
  TonConnectButton as w_,
  useTonAddress as y_,
} from "@tonconnect/ui-react";
import * as jt from "react";
import br, {
  useLayoutEffect as g_,
  useEffect as ip,
  useCallback as m_,
  useRef as v_,
  useState as yn,
} from "react";
import { formatUnits as tf, parseUnits as x_ } from "viem";
function M_(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var B6 = { exports: {} },
  pr = (B6.exports = {}),
  Fn,
  qn;
function ap() {
  throw new Error("setTimeout has not been defined");
}
function sp() {
  throw new Error("clearTimeout has not been defined");
}
(function () {
  try {
    typeof setTimeout == "function" ? (Fn = setTimeout) : (Fn = ap);
  } catch {
    Fn = ap;
  }
  try {
    typeof clearTimeout == "function" ? (qn = clearTimeout) : (qn = sp);
  } catch {
    qn = sp;
  }
})();
function C6(t) {
  if (Fn === setTimeout) return setTimeout(t, 0);
  if ((Fn === ap || !Fn) && setTimeout) return (Fn = setTimeout), setTimeout(t, 0);
  try {
    return Fn(t, 0);
  } catch {
    try {
      return Fn.call(null, t, 0);
    } catch {
      return Fn.call(this, t, 0);
    }
  }
}
function S_(t) {
  if (qn === clearTimeout) return clearTimeout(t);
  if ((qn === sp || !qn) && clearTimeout) return (qn = clearTimeout), clearTimeout(t);
  try {
    return qn(t);
  } catch {
    try {
      return qn.call(null, t);
    } catch {
      return qn.call(this, t);
    }
  }
}
var bi = [],
  bs = !1,
  xa,
  ml = -1;
function E_() {
  !bs || !xa || ((bs = !1), xa.length ? (bi = xa.concat(bi)) : (ml = -1), bi.length && T6());
}
function T6() {
  if (!bs) {
    var t = C6(E_);
    bs = !0;
    for (var e = bi.length; e; ) {
      for (xa = bi, bi = []; ++ml < e; ) xa && xa[ml].run();
      (ml = -1), (e = bi.length);
    }
    (xa = null), (bs = !1), S_(t);
  }
}
pr.nextTick = function (t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
  bi.push(new P6(t, e)), bi.length === 1 && !bs && C6(T6);
};
function P6(t, e) {
  (this.fun = t), (this.array = e);
}
P6.prototype.run = function () {
  this.fun.apply(null, this.array);
};
pr.title = "browser";
pr.browser = !0;
pr.env = {};
pr.argv = [];
pr.version = "";
pr.versions = {};
function Ei() {}
pr.on = Ei;
pr.addListener = Ei;
pr.once = Ei;
pr.off = Ei;
pr.removeListener = Ei;
pr.removeAllListeners = Ei;
pr.emit = Ei;
pr.prependListener = Ei;
pr.prependOnceListener = Ei;
pr.listeners = function (t) {
  return [];
};
pr.binding = function (t) {
  throw new Error("process.binding is not supported");
};
pr.cwd = function () {
  return "/";
};
pr.chdir = function (t) {
  throw new Error("process.chdir is not supported");
};
pr.umask = function () {
  return 0;
};
var A_ = B6.exports;
const Et = /* @__PURE__ */ M_(A_);
var mt =
  typeof globalThis < "u"
    ? globalThis
    : typeof window < "u"
    ? window
    : typeof global < "u"
    ? global
    : typeof self < "u"
    ? self
    : {};
function k_(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function R6(t) {
  if (t.__esModule) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function i() {
      return this instanceof i
        ? Reflect.construct(e, arguments, this.constructor)
        : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return (
    Object.defineProperty(n, "__esModule", { value: !0 }),
    Object.keys(t).forEach(function (i) {
      var l = Object.getOwnPropertyDescriptor(t, i);
      Object.defineProperty(
        n,
        i,
        l.get
          ? l
          : {
              enumerable: !0,
              get: function () {
                return t[i];
              },
            }
      );
    }),
    n
  );
}
var op = { exports: {} },
  co = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Km;
function B_() {
  if (Km) return co;
  Km = 1;
  var t = br,
    e = Symbol.for("react.element"),
    n = Symbol.for("react.fragment"),
    i = Object.prototype.hasOwnProperty,
    l = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(v, g, b) {
    var p,
      _ = {},
      M = null,
      S = null;
    b !== void 0 && (M = "" + b),
      g.key !== void 0 && (M = "" + g.key),
      g.ref !== void 0 && (S = g.ref);
    for (p in g) i.call(g, p) && !a.hasOwnProperty(p) && (_[p] = g[p]);
    if (v && v.defaultProps) for (p in ((g = v.defaultProps), g)) _[p] === void 0 && (_[p] = g[p]);
    return { $$typeof: e, type: v, key: M, ref: S, props: _, _owner: l.current };
  }
  return (co.Fragment = n), (co.jsx = c), (co.jsxs = c), co;
}
var ho = {},
  Zm;
function C_() {
  return (
    Zm ||
      ((Zm = 1),
      Et.env.NODE_ENV !== "production" &&
        (function () {
          var t = br,
            e = Symbol.for("react.element"),
            n = Symbol.for("react.portal"),
            i = Symbol.for("react.fragment"),
            l = Symbol.for("react.strict_mode"),
            a = Symbol.for("react.profiler"),
            c = Symbol.for("react.provider"),
            v = Symbol.for("react.context"),
            g = Symbol.for("react.forward_ref"),
            b = Symbol.for("react.suspense"),
            p = Symbol.for("react.suspense_list"),
            _ = Symbol.for("react.memo"),
            M = Symbol.for("react.lazy"),
            S = Symbol.for("react.offscreen"),
            A = Symbol.iterator,
            k = "@@iterator";
          function P(D) {
            if (D === null || typeof D != "object") return null;
            var re = (A && D[A]) || D[k];
            return typeof re == "function" ? re : null;
          }
          var B = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
          function T(D) {
            {
              for (
                var re = arguments.length, ye = new Array(re > 1 ? re - 1 : 0), pe = 1;
                pe < re;
                pe++
              )
                ye[pe - 1] = arguments[pe];
              F("error", D, ye);
            }
          }
          function F(D, re, ye) {
            {
              var pe = B.ReactDebugCurrentFrame,
                xe = pe.getStackAddendum();
              xe !== "" && ((re += "%s"), (ye = ye.concat([xe])));
              var tt = ye.map(function (Ke) {
                return String(Ke);
              });
              tt.unshift("Warning: " + re), Function.prototype.apply.call(console[D], console, tt);
            }
          }
          var O = !1,
            $ = !1,
            J = !1,
            he = !1,
            de = !1,
            ne;
          ne = Symbol.for("react.module.reference");
          function Ae(D) {
            return !!(
              typeof D == "string" ||
              typeof D == "function" ||
              D === i ||
              D === a ||
              de ||
              D === l ||
              D === b ||
              D === p ||
              he ||
              D === S ||
              O ||
              $ ||
              J ||
              (typeof D == "object" &&
                D !== null &&
                (D.$$typeof === M ||
                  D.$$typeof === _ ||
                  D.$$typeof === c ||
                  D.$$typeof === v ||
                  D.$$typeof === g || // This needs to include all possible module reference object
                  // types supported by any Flight configuration anywhere since
                  // we don't know which Flight build this will end up being used
                  // with.
                  D.$$typeof === ne ||
                  D.getModuleId !== void 0))
            );
          }
          function x(D, re, ye) {
            var pe = D.displayName;
            if (pe) return pe;
            var xe = re.displayName || re.name || "";
            return xe !== "" ? ye + "(" + xe + ")" : ye;
          }
          function r(D) {
            return D.displayName || "Context";
          }
          function o(D) {
            if (D == null) return null;
            if (
              (typeof D.tag == "number" &&
                T(
                  "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
                ),
              typeof D == "function")
            )
              return D.displayName || D.name || null;
            if (typeof D == "string") return D;
            switch (D) {
              case i:
                return "Fragment";
              case n:
                return "Portal";
              case a:
                return "Profiler";
              case l:
                return "StrictMode";
              case b:
                return "Suspense";
              case p:
                return "SuspenseList";
            }
            if (typeof D == "object")
              switch (D.$$typeof) {
                case v:
                  var re = D;
                  return r(re) + ".Consumer";
                case c:
                  var ye = D;
                  return r(ye._context) + ".Provider";
                case g:
                  return x(D, D.render, "ForwardRef");
                case _:
                  var pe = D.displayName || null;
                  return pe !== null ? pe : o(D.type) || "Memo";
                case M: {
                  var xe = D,
                    tt = xe._payload,
                    Ke = xe._init;
                  try {
                    return o(Ke(tt));
                  } catch {
                    return null;
                  }
                }
              }
            return null;
          }
          var f = Object.assign,
            u = 0,
            d,
            y,
            w,
            h,
            s,
            m,
            E;
          function R() {}
          R.__reactDisabledLog = !0;
          function z() {
            {
              if (u === 0) {
                (d = console.log),
                  (y = console.info),
                  (w = console.warn),
                  (h = console.error),
                  (s = console.group),
                  (m = console.groupCollapsed),
                  (E = console.groupEnd);
                var D = {
                  configurable: !0,
                  enumerable: !0,
                  value: R,
                  writable: !0,
                };
                Object.defineProperties(console, {
                  info: D,
                  log: D,
                  warn: D,
                  error: D,
                  group: D,
                  groupCollapsed: D,
                  groupEnd: D,
                });
              }
              u++;
            }
          }
          function Q() {
            {
              if ((u--, u === 0)) {
                var D = {
                  configurable: !0,
                  enumerable: !0,
                  writable: !0,
                };
                Object.defineProperties(console, {
                  log: f({}, D, {
                    value: d,
                  }),
                  info: f({}, D, {
                    value: y,
                  }),
                  warn: f({}, D, {
                    value: w,
                  }),
                  error: f({}, D, {
                    value: h,
                  }),
                  group: f({}, D, {
                    value: s,
                  }),
                  groupCollapsed: f({}, D, {
                    value: m,
                  }),
                  groupEnd: f({}, D, {
                    value: E,
                  }),
                });
              }
              u < 0 &&
                T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
          var G = B.ReactCurrentDispatcher,
            q;
          function Z(D, re, ye) {
            {
              if (q === void 0)
                try {
                  throw Error();
                } catch (xe) {
                  var pe = xe.stack.trim().match(/\n( *(at )?)/);
                  q = (pe && pe[1]) || "";
                }
              return (
                `
` +
                q +
                D
              );
            }
          }
          var te = !1,
            ue;
          {
            var ae = typeof WeakMap == "function" ? WeakMap : Map;
            ue = new ae();
          }
          function K(D, re) {
            if (!D || te) return "";
            {
              var ye = ue.get(D);
              if (ye !== void 0) return ye;
            }
            var pe;
            te = !0;
            var xe = Error.prepareStackTrace;
            Error.prepareStackTrace = void 0;
            var tt;
            (tt = G.current), (G.current = null), z();
            try {
              if (re) {
                var Ke = function () {
                  throw Error();
                };
                if (
                  (Object.defineProperty(Ke.prototype, "props", {
                    set: function () {
                      throw Error();
                    },
                  }),
                  typeof Reflect == "object" && Reflect.construct)
                ) {
                  try {
                    Reflect.construct(Ke, []);
                  } catch (me) {
                    pe = me;
                  }
                  Reflect.construct(D, [], Ke);
                } else {
                  try {
                    Ke.call();
                  } catch (me) {
                    pe = me;
                  }
                  D.call(Ke.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (me) {
                  pe = me;
                }
                D();
              }
            } catch (me) {
              if (me && pe && typeof me.stack == "string") {
                for (
                  var dt = me.stack.split(`
`),
                    st = pe.stack.split(`
`),
                    ce = dt.length - 1,
                    N = st.length - 1;
                  ce >= 1 && N >= 0 && dt[ce] !== st[N];

                )
                  N--;
                for (; ce >= 1 && N >= 0; ce--, N--)
                  if (dt[ce] !== st[N]) {
                    if (ce !== 1 || N !== 1)
                      do
                        if ((ce--, N--, N < 0 || dt[ce] !== st[N])) {
                          var Y =
                            `
` + dt[ce].replace(" at new ", " at ");
                          return (
                            D.displayName &&
                              Y.includes("<anonymous>") &&
                              (Y = Y.replace("<anonymous>", D.displayName)),
                            typeof D == "function" && ue.set(D, Y),
                            Y
                          );
                        }
                      while (ce >= 1 && N >= 0);
                    break;
                  }
              }
            } finally {
              (te = !1), (G.current = tt), Q(), (Error.prepareStackTrace = xe);
            }
            var ie = D ? D.displayName || D.name : "",
              ge = ie ? Z(ie) : "";
            return typeof D == "function" && ue.set(D, ge), ge;
          }
          function ve(D, re, ye) {
            return K(D, !1);
          }
          function Ye(D) {
            var re = D.prototype;
            return !!(re && re.isReactComponent);
          }
          function Ce(D, re, ye) {
            if (D == null) return "";
            if (typeof D == "function") return K(D, Ye(D));
            if (typeof D == "string") return Z(D);
            switch (D) {
              case b:
                return Z("Suspense");
              case p:
                return Z("SuspenseList");
            }
            if (typeof D == "object")
              switch (D.$$typeof) {
                case g:
                  return ve(D.render);
                case _:
                  return Ce(D.type, re, ye);
                case M: {
                  var pe = D,
                    xe = pe._payload,
                    tt = pe._init;
                  try {
                    return Ce(tt(xe), re, ye);
                  } catch {}
                }
              }
            return "";
          }
          var Te = Object.prototype.hasOwnProperty,
            ut = {},
            Ie = B.ReactDebugCurrentFrame;
          function be(D) {
            if (D) {
              var re = D._owner,
                ye = Ce(D.type, D._source, re ? re.type : null);
              Ie.setExtraStackFrame(ye);
            } else Ie.setExtraStackFrame(null);
          }
          function wt(D, re, ye, pe, xe) {
            {
              var tt = Function.call.bind(Te);
              for (var Ke in D)
                if (tt(D, Ke)) {
                  var dt = void 0;
                  try {
                    if (typeof D[Ke] != "function") {
                      var st = Error(
                        (pe || "React class") +
                          ": " +
                          ye +
                          " type `" +
                          Ke +
                          "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                          typeof D[Ke] +
                          "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                      );
                      throw ((st.name = "Invariant Violation"), st);
                    }
                    dt = D[Ke](
                      re,
                      Ke,
                      pe,
                      ye,
                      null,
                      "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"
                    );
                  } catch (ce) {
                    dt = ce;
                  }
                  dt &&
                    !(dt instanceof Error) &&
                    (be(xe),
                    T(
                      "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",
                      pe || "React class",
                      ye,
                      Ke,
                      typeof dt
                    ),
                    be(null)),
                    dt instanceof Error &&
                      !(dt.message in ut) &&
                      ((ut[dt.message] = !0),
                      be(xe),
                      T("Failed %s type: %s", ye, dt.message),
                      be(null));
                }
            }
          }
          var Oe = Array.isArray;
          function je(D) {
            return Oe(D);
          }
          function xt(D) {
            {
              var re = typeof Symbol == "function" && Symbol.toStringTag,
                ye = (re && D[Symbol.toStringTag]) || D.constructor.name || "Object";
              return ye;
            }
          }
          function Ue(D) {
            try {
              return se(D), !1;
            } catch {
              return !0;
            }
          }
          function se(D) {
            return "" + D;
          }
          function oe(D) {
            if (Ue(D))
              return (
                T(
                  "The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",
                  xt(D)
                ),
                se(D)
              );
          }
          var X = B.ReactCurrentOwner,
            le = {
              key: !0,
              ref: !0,
              __self: !0,
              __source: !0,
            },
            ke,
            I,
            C;
          C = {};
          function L(D) {
            if (Te.call(D, "ref")) {
              var re = Object.getOwnPropertyDescriptor(D, "ref").get;
              if (re && re.isReactWarning) return !1;
            }
            return D.ref !== void 0;
          }
          function j(D) {
            if (Te.call(D, "key")) {
              var re = Object.getOwnPropertyDescriptor(D, "key").get;
              if (re && re.isReactWarning) return !1;
            }
            return D.key !== void 0;
          }
          function ee(D, re) {
            if (typeof D.ref == "string" && X.current && re && X.current.stateNode !== re) {
              var ye = o(X.current.type);
              C[ye] ||
                (T(
                  'Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',
                  o(X.current.type),
                  D.ref
                ),
                (C[ye] = !0));
            }
          }
          function Me(D, re) {
            {
              var ye = function () {
                ke ||
                  ((ke = !0),
                  T(
                    "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    re
                  ));
              };
              (ye.isReactWarning = !0),
                Object.defineProperty(D, "key", {
                  get: ye,
                  configurable: !0,
                });
            }
          }
          function fe(D, re) {
            {
              var ye = function () {
                I ||
                  ((I = !0),
                  T(
                    "%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",
                    re
                  ));
              };
              (ye.isReactWarning = !0),
                Object.defineProperty(D, "ref", {
                  get: ye,
                  configurable: !0,
                });
            }
          }
          var Se = function (D, re, ye, pe, xe, tt, Ke) {
            var dt = {
              // This tag allows us to uniquely identify this as a React Element
              $$typeof: e,
              // Built-in properties that belong on the element
              type: D,
              key: re,
              ref: ye,
              props: Ke,
              // Record the component responsible for creating this element.
              _owner: tt,
            };
            return (
              (dt._store = {}),
              Object.defineProperty(dt._store, "validated", {
                configurable: !1,
                enumerable: !1,
                writable: !0,
                value: !1,
              }),
              Object.defineProperty(dt, "_self", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: pe,
              }),
              Object.defineProperty(dt, "_source", {
                configurable: !1,
                enumerable: !1,
                writable: !1,
                value: xe,
              }),
              Object.freeze && (Object.freeze(dt.props), Object.freeze(dt)),
              dt
            );
          };
          function ot(D, re, ye, pe, xe) {
            {
              var tt,
                Ke = {},
                dt = null,
                st = null;
              ye !== void 0 && (oe(ye), (dt = "" + ye)),
                j(re) && (oe(re.key), (dt = "" + re.key)),
                L(re) && ((st = re.ref), ee(re, xe));
              for (tt in re) Te.call(re, tt) && !le.hasOwnProperty(tt) && (Ke[tt] = re[tt]);
              if (D && D.defaultProps) {
                var ce = D.defaultProps;
                for (tt in ce) Ke[tt] === void 0 && (Ke[tt] = ce[tt]);
              }
              if (dt || st) {
                var N = typeof D == "function" ? D.displayName || D.name || "Unknown" : D;
                dt && Me(Ke, N), st && fe(Ke, N);
              }
              return Se(D, dt, st, xe, pe, X.current, Ke);
            }
          }
          var we = B.ReactCurrentOwner,
            Re = B.ReactDebugCurrentFrame;
          function at(D) {
            if (D) {
              var re = D._owner,
                ye = Ce(D.type, D._source, re ? re.type : null);
              Re.setExtraStackFrame(ye);
            } else Re.setExtraStackFrame(null);
          }
          var Ne;
          Ne = !1;
          function He(D) {
            return typeof D == "object" && D !== null && D.$$typeof === e;
          }
          function At() {
            {
              if (we.current) {
                var D = o(we.current.type);
                if (D)
                  return (
                    `

Check the render method of \`` +
                    D +
                    "`."
                  );
              }
              return "";
            }
          }
          function Le(D) {
            {
              if (D !== void 0) {
                var re = D.fileName.replace(/^.*[\\\/]/, ""),
                  ye = D.lineNumber;
                return (
                  `

Check your code at ` +
                  re +
                  ":" +
                  ye +
                  "."
                );
              }
              return "";
            }
          }
          var Ze = {};
          function Tt(D) {
            {
              var re = At();
              if (!re) {
                var ye = typeof D == "string" ? D : D.displayName || D.name;
                ye &&
                  (re =
                    `

Check the top-level render call using <` +
                    ye +
                    ">.");
              }
              return re;
            }
          }
          function Ve(D, re) {
            {
              if (!D._store || D._store.validated || D.key != null) return;
              D._store.validated = !0;
              var ye = Tt(re);
              if (Ze[ye]) return;
              Ze[ye] = !0;
              var pe = "";
              D &&
                D._owner &&
                D._owner !== we.current &&
                (pe = " It was passed a child from " + o(D._owner.type) + "."),
                at(D),
                T(
                  'Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',
                  ye,
                  pe
                ),
                at(null);
            }
          }
          function Je(D, re) {
            {
              if (typeof D != "object") return;
              if (je(D))
                for (var ye = 0; ye < D.length; ye++) {
                  var pe = D[ye];
                  He(pe) && Ve(pe, re);
                }
              else if (He(D)) D._store && (D._store.validated = !0);
              else if (D) {
                var xe = P(D);
                if (typeof xe == "function" && xe !== D.entries)
                  for (var tt = xe.call(D), Ke; !(Ke = tt.next()).done; )
                    He(Ke.value) && Ve(Ke.value, re);
              }
            }
          }
          function Rt(D) {
            {
              var re = D.type;
              if (re == null || typeof re == "string") return;
              var ye;
              if (typeof re == "function") ye = re.propTypes;
              else if (
                typeof re == "object" &&
                (re.$$typeof === g || // Note: Memo only checks outer props here.
                  // Inner props are checked in the reconciler.
                  re.$$typeof === _)
              )
                ye = re.propTypes;
              else return;
              if (ye) {
                var pe = o(re);
                wt(ye, D.props, "prop", pe, D);
              } else if (re.PropTypes !== void 0 && !Ne) {
                Ne = !0;
                var xe = o(re);
                T(
                  "Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",
                  xe || "Unknown"
                );
              }
              typeof re.getDefaultProps == "function" &&
                !re.getDefaultProps.isReactClassApproved &&
                T(
                  "getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead."
                );
            }
          }
          function $e(D) {
            {
              for (var re = Object.keys(D.props), ye = 0; ye < re.length; ye++) {
                var pe = re[ye];
                if (pe !== "children" && pe !== "key") {
                  at(D),
                    T(
                      "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                      pe
                    ),
                    at(null);
                  break;
                }
              }
              D.ref !== null &&
                (at(D), T("Invalid attribute `ref` supplied to `React.Fragment`."), at(null));
            }
          }
          function et(D, re, ye, pe, xe, tt) {
            {
              var Ke = Ae(D);
              if (!Ke) {
                var dt = "";
                (D === void 0 ||
                  (typeof D == "object" && D !== null && Object.keys(D).length === 0)) &&
                  (dt +=
                    " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var st = Le(xe);
                st ? (dt += st) : (dt += At());
                var ce;
                D === null
                  ? (ce = "null")
                  : je(D)
                  ? (ce = "array")
                  : D !== void 0 && D.$$typeof === e
                  ? ((ce = "<" + (o(D.type) || "Unknown") + " />"),
                    (dt = " Did you accidentally export a JSX literal instead of a component?"))
                  : (ce = typeof D),
                  T(
                    "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
                    ce,
                    dt
                  );
              }
              var N = ot(D, re, ye, xe, tt);
              if (N == null) return N;
              if (Ke) {
                var Y = re.children;
                if (Y !== void 0)
                  if (pe)
                    if (je(Y)) {
                      for (var ie = 0; ie < Y.length; ie++) Je(Y[ie], D);
                      Object.freeze && Object.freeze(Y);
                    } else
                      T(
                        "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
                      );
                  else Je(Y, D);
              }
              return D === i ? $e(N) : Rt(N), N;
            }
          }
          function H(D, re, ye) {
            return et(D, re, ye, !0);
          }
          function V(D, re, ye) {
            return et(D, re, ye, !1);
          }
          var W = V,
            U = H;
          (ho.Fragment = i), (ho.jsx = W), (ho.jsxs = U);
        })()),
    ho
  );
}
Et.env.NODE_ENV === "production" ? (op.exports = B_()) : (op.exports = C_());
var gt = op.exports,
  wr = {},
  du = {};
du.byteLength = R_;
du.toByteArray = O_;
du.fromByteArray = D_;
var Vn = [],
  bn = [],
  T_ = typeof Uint8Array < "u" ? Uint8Array : Array,
  Uc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var fs = 0, P_ = Uc.length; fs < P_; ++fs) (Vn[fs] = Uc[fs]), (bn[Uc.charCodeAt(fs)] = fs);
bn[45] = 62;
bn[95] = 63;
function I6(t) {
  var e = t.length;
  if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n = t.indexOf("=");
  n === -1 && (n = e);
  var i = n === e ? 0 : 4 - (n % 4);
  return [n, i];
}
function R_(t) {
  var e = I6(t),
    n = e[0],
    i = e[1];
  return ((n + i) * 3) / 4 - i;
}
function I_(t, e, n) {
  return ((e + n) * 3) / 4 - n;
}
function O_(t) {
  var e,
    n = I6(t),
    i = n[0],
    l = n[1],
    a = new T_(I_(t, i, l)),
    c = 0,
    v = l > 0 ? i - 4 : i,
    g;
  for (g = 0; g < v; g += 4)
    (e =
      (bn[t.charCodeAt(g)] << 18) |
      (bn[t.charCodeAt(g + 1)] << 12) |
      (bn[t.charCodeAt(g + 2)] << 6) |
      bn[t.charCodeAt(g + 3)]),
      (a[c++] = (e >> 16) & 255),
      (a[c++] = (e >> 8) & 255),
      (a[c++] = e & 255);
  return (
    l === 2 &&
      ((e = (bn[t.charCodeAt(g)] << 2) | (bn[t.charCodeAt(g + 1)] >> 4)), (a[c++] = e & 255)),
    l === 1 &&
      ((e =
        (bn[t.charCodeAt(g)] << 10) |
        (bn[t.charCodeAt(g + 1)] << 4) |
        (bn[t.charCodeAt(g + 2)] >> 2)),
      (a[c++] = (e >> 8) & 255),
      (a[c++] = e & 255)),
    a
  );
}
function U_(t) {
  return Vn[(t >> 18) & 63] + Vn[(t >> 12) & 63] + Vn[(t >> 6) & 63] + Vn[t & 63];
}
function N_(t, e, n) {
  for (var i, l = [], a = e; a < n; a += 3)
    (i = ((t[a] << 16) & 16711680) + ((t[a + 1] << 8) & 65280) + (t[a + 2] & 255)), l.push(U_(i));
  return l.join("");
}
function D_(t) {
  for (var e, n = t.length, i = n % 3, l = [], a = 16383, c = 0, v = n - i; c < v; c += a)
    l.push(N_(t, c, c + a > v ? v : c + a));
  return (
    i === 1
      ? ((e = t[n - 1]), l.push(Vn[e >> 2] + Vn[(e << 4) & 63] + "=="))
      : i === 2 &&
        ((e = (t[n - 2] << 8) + t[n - 1]),
        l.push(Vn[e >> 10] + Vn[(e >> 4) & 63] + Vn[(e << 2) & 63] + "=")),
    l.join("")
  );
}
var u1 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
u1.read = function (t, e, n, i, l) {
  var a,
    c,
    v = l * 8 - i - 1,
    g = (1 << v) - 1,
    b = g >> 1,
    p = -7,
    _ = n ? l - 1 : 0,
    M = n ? -1 : 1,
    S = t[e + _];
  for (
    _ += M, a = S & ((1 << -p) - 1), S >>= -p, p += v;
    p > 0;
    a = a * 256 + t[e + _], _ += M, p -= 8
  );
  for (c = a & ((1 << -p) - 1), a >>= -p, p += i; p > 0; c = c * 256 + t[e + _], _ += M, p -= 8);
  if (a === 0) a = 1 - b;
  else {
    if (a === g) return c ? NaN : (S ? -1 : 1) * (1 / 0);
    (c = c + Math.pow(2, i)), (a = a - b);
  }
  return (S ? -1 : 1) * c * Math.pow(2, a - i);
};
u1.write = function (t, e, n, i, l, a) {
  var c,
    v,
    g,
    b = a * 8 - l - 1,
    p = (1 << b) - 1,
    _ = p >> 1,
    M = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
    S = i ? 0 : a - 1,
    A = i ? 1 : -1,
    k = e < 0 || (e === 0 && 1 / e < 0) ? 1 : 0;
  for (
    e = Math.abs(e),
      isNaN(e) || e === 1 / 0
        ? ((v = isNaN(e) ? 1 : 0), (c = p))
        : ((c = Math.floor(Math.log(e) / Math.LN2)),
          e * (g = Math.pow(2, -c)) < 1 && (c--, (g *= 2)),
          c + _ >= 1 ? (e += M / g) : (e += M * Math.pow(2, 1 - _)),
          e * g >= 2 && (c++, (g /= 2)),
          c + _ >= p
            ? ((v = 0), (c = p))
            : c + _ >= 1
            ? ((v = (e * g - 1) * Math.pow(2, l)), (c = c + _))
            : ((v = e * Math.pow(2, _ - 1) * Math.pow(2, l)), (c = 0)));
    l >= 8;
    t[n + S] = v & 255, S += A, v /= 256, l -= 8
  );
  for (c = (c << l) | v, b += l; b > 0; t[n + S] = c & 255, S += A, c /= 256, b -= 8);
  t[n + S - A] |= k * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function (t) {
  const e = du,
    n = u1,
    i =
      typeof Symbol == "function" && typeof Symbol.for == "function"
        ? Symbol.for("nodejs.util.inspect.custom")
        : null;
  (t.Buffer = p), (t.SlowBuffer = $), (t.INSPECT_MAX_BYTES = 50);
  const l = 2147483647;
  t.kMaxLength = l;
  const { Uint8Array: a, ArrayBuffer: c, SharedArrayBuffer: v } = globalThis;
  (p.TYPED_ARRAY_SUPPORT = g()),
    !p.TYPED_ARRAY_SUPPORT &&
      typeof console < "u" &&
      typeof console.error == "function" &&
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
  function g() {
    try {
      const I = new a(1),
        C = {
          foo: function () {
            return 42;
          },
        };
      return Object.setPrototypeOf(C, a.prototype), Object.setPrototypeOf(I, C), I.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(p.prototype, "parent", {
    enumerable: !0,
    get: function () {
      if (p.isBuffer(this)) return this.buffer;
    },
  }),
    Object.defineProperty(p.prototype, "offset", {
      enumerable: !0,
      get: function () {
        if (p.isBuffer(this)) return this.byteOffset;
      },
    });
  function b(I) {
    if (I > l) throw new RangeError('The value "' + I + '" is invalid for option "size"');
    const C = new a(I);
    return Object.setPrototypeOf(C, p.prototype), C;
  }
  function p(I, C, L) {
    if (typeof I == "number") {
      if (typeof C == "string")
        throw new TypeError('The "string" argument must be of type string. Received type number');
      return A(I);
    }
    return _(I, C, L);
  }
  p.poolSize = 8192;
  function _(I, C, L) {
    if (typeof I == "string") return k(I, C);
    if (c.isView(I)) return B(I);
    if (I == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " +
          typeof I
      );
    if (
      se(I, c) ||
      (I && se(I.buffer, c)) ||
      (typeof v < "u" && (se(I, v) || (I && se(I.buffer, v))))
    )
      return T(I, C, L);
    if (typeof I == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    const j = I.valueOf && I.valueOf();
    if (j != null && j !== I) return p.from(j, C, L);
    const ee = F(I);
    if (ee) return ee;
    if (
      typeof Symbol < "u" &&
      Symbol.toPrimitive != null &&
      typeof I[Symbol.toPrimitive] == "function"
    )
      return p.from(I[Symbol.toPrimitive]("string"), C, L);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " +
        typeof I
    );
  }
  (p.from = function (I, C, L) {
    return _(I, C, L);
  }),
    Object.setPrototypeOf(p.prototype, a.prototype),
    Object.setPrototypeOf(p, a);
  function M(I) {
    if (typeof I != "number") throw new TypeError('"size" argument must be of type number');
    if (I < 0) throw new RangeError('The value "' + I + '" is invalid for option "size"');
  }
  function S(I, C, L) {
    return (
      M(I),
      I <= 0 ? b(I) : C !== void 0 ? (typeof L == "string" ? b(I).fill(C, L) : b(I).fill(C)) : b(I)
    );
  }
  p.alloc = function (I, C, L) {
    return S(I, C, L);
  };
  function A(I) {
    return M(I), b(I < 0 ? 0 : O(I) | 0);
  }
  (p.allocUnsafe = function (I) {
    return A(I);
  }),
    (p.allocUnsafeSlow = function (I) {
      return A(I);
    });
  function k(I, C) {
    if (((typeof C != "string" || C === "") && (C = "utf8"), !p.isEncoding(C)))
      throw new TypeError("Unknown encoding: " + C);
    const L = J(I, C) | 0;
    let j = b(L);
    const ee = j.write(I, C);
    return ee !== L && (j = j.slice(0, ee)), j;
  }
  function P(I) {
    const C = I.length < 0 ? 0 : O(I.length) | 0,
      L = b(C);
    for (let j = 0; j < C; j += 1) L[j] = I[j] & 255;
    return L;
  }
  function B(I) {
    if (se(I, a)) {
      const C = new a(I);
      return T(C.buffer, C.byteOffset, C.byteLength);
    }
    return P(I);
  }
  function T(I, C, L) {
    if (C < 0 || I.byteLength < C) throw new RangeError('"offset" is outside of buffer bounds');
    if (I.byteLength < C + (L || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let j;
    return (
      C === void 0 && L === void 0
        ? (j = new a(I))
        : L === void 0
        ? (j = new a(I, C))
        : (j = new a(I, C, L)),
      Object.setPrototypeOf(j, p.prototype),
      j
    );
  }
  function F(I) {
    if (p.isBuffer(I)) {
      const C = O(I.length) | 0,
        L = b(C);
      return L.length === 0 || I.copy(L, 0, 0, C), L;
    }
    if (I.length !== void 0) return typeof I.length != "number" || oe(I.length) ? b(0) : P(I);
    if (I.type === "Buffer" && Array.isArray(I.data)) return P(I.data);
  }
  function O(I) {
    if (I >= l)
      throw new RangeError(
        "Attempt to allocate Buffer larger than maximum size: 0x" + l.toString(16) + " bytes"
      );
    return I | 0;
  }
  function $(I) {
    return +I != I && (I = 0), p.alloc(+I);
  }
  (p.isBuffer = function (C) {
    return C != null && C._isBuffer === !0 && C !== p.prototype;
  }),
    (p.compare = function (C, L) {
      if (
        (se(C, a) && (C = p.from(C, C.offset, C.byteLength)),
        se(L, a) && (L = p.from(L, L.offset, L.byteLength)),
        !p.isBuffer(C) || !p.isBuffer(L))
      )
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (C === L) return 0;
      let j = C.length,
        ee = L.length;
      for (let Me = 0, fe = Math.min(j, ee); Me < fe; ++Me)
        if (C[Me] !== L[Me]) {
          (j = C[Me]), (ee = L[Me]);
          break;
        }
      return j < ee ? -1 : ee < j ? 1 : 0;
    }),
    (p.isEncoding = function (C) {
      switch (String(C).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }),
    (p.concat = function (C, L) {
      if (!Array.isArray(C)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (C.length === 0) return p.alloc(0);
      let j;
      if (L === void 0) for (L = 0, j = 0; j < C.length; ++j) L += C[j].length;
      const ee = p.allocUnsafe(L);
      let Me = 0;
      for (j = 0; j < C.length; ++j) {
        let fe = C[j];
        if (se(fe, a))
          Me + fe.length > ee.length
            ? (p.isBuffer(fe) || (fe = p.from(fe)), fe.copy(ee, Me))
            : a.prototype.set.call(ee, fe, Me);
        else if (p.isBuffer(fe)) fe.copy(ee, Me);
        else throw new TypeError('"list" argument must be an Array of Buffers');
        Me += fe.length;
      }
      return ee;
    });
  function J(I, C) {
    if (p.isBuffer(I)) return I.length;
    if (c.isView(I) || se(I, c)) return I.byteLength;
    if (typeof I != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' +
          typeof I
      );
    const L = I.length,
      j = arguments.length > 2 && arguments[2] === !0;
    if (!j && L === 0) return 0;
    let ee = !1;
    for (;;)
      switch (C) {
        case "ascii":
        case "latin1":
        case "binary":
          return L;
        case "utf8":
        case "utf-8":
          return wt(I).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return L * 2;
        case "hex":
          return L >>> 1;
        case "base64":
          return xt(I).length;
        default:
          if (ee) return j ? -1 : wt(I).length;
          (C = ("" + C).toLowerCase()), (ee = !0);
      }
  }
  p.byteLength = J;
  function he(I, C, L) {
    let j = !1;
    if (
      ((C === void 0 || C < 0) && (C = 0),
      C > this.length ||
        ((L === void 0 || L > this.length) && (L = this.length), L <= 0) ||
        ((L >>>= 0), (C >>>= 0), L <= C))
    )
      return "";
    for (I || (I = "utf8"); ; )
      switch (I) {
        case "hex":
          return E(this, C, L);
        case "utf8":
        case "utf-8":
          return y(this, C, L);
        case "ascii":
          return s(this, C, L);
        case "latin1":
        case "binary":
          return m(this, C, L);
        case "base64":
          return d(this, C, L);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R(this, C, L);
        default:
          if (j) throw new TypeError("Unknown encoding: " + I);
          (I = (I + "").toLowerCase()), (j = !0);
      }
  }
  p.prototype._isBuffer = !0;
  function de(I, C, L) {
    const j = I[C];
    (I[C] = I[L]), (I[L] = j);
  }
  (p.prototype.swap16 = function () {
    const C = this.length;
    if (C % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let L = 0; L < C; L += 2) de(this, L, L + 1);
    return this;
  }),
    (p.prototype.swap32 = function () {
      const C = this.length;
      if (C % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let L = 0; L < C; L += 4) de(this, L, L + 3), de(this, L + 1, L + 2);
      return this;
    }),
    (p.prototype.swap64 = function () {
      const C = this.length;
      if (C % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let L = 0; L < C; L += 8)
        de(this, L, L + 7), de(this, L + 1, L + 6), de(this, L + 2, L + 5), de(this, L + 3, L + 4);
      return this;
    }),
    (p.prototype.toString = function () {
      const C = this.length;
      return C === 0 ? "" : arguments.length === 0 ? y(this, 0, C) : he.apply(this, arguments);
    }),
    (p.prototype.toLocaleString = p.prototype.toString),
    (p.prototype.equals = function (C) {
      if (!p.isBuffer(C)) throw new TypeError("Argument must be a Buffer");
      return this === C ? !0 : p.compare(this, C) === 0;
    }),
    (p.prototype.inspect = function () {
      let C = "";
      const L = t.INSPECT_MAX_BYTES;
      return (
        (C = this.toString("hex", 0, L)
          .replace(/(.{2})/g, "$1 ")
          .trim()),
        this.length > L && (C += " ... "),
        "<Buffer " + C + ">"
      );
    }),
    i && (p.prototype[i] = p.prototype.inspect),
    (p.prototype.compare = function (C, L, j, ee, Me) {
      if ((se(C, a) && (C = p.from(C, C.offset, C.byteLength)), !p.isBuffer(C)))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' +
            typeof C
        );
      if (
        (L === void 0 && (L = 0),
        j === void 0 && (j = C ? C.length : 0),
        ee === void 0 && (ee = 0),
        Me === void 0 && (Me = this.length),
        L < 0 || j > C.length || ee < 0 || Me > this.length)
      )
        throw new RangeError("out of range index");
      if (ee >= Me && L >= j) return 0;
      if (ee >= Me) return -1;
      if (L >= j) return 1;
      if (((L >>>= 0), (j >>>= 0), (ee >>>= 0), (Me >>>= 0), this === C)) return 0;
      let fe = Me - ee,
        Se = j - L;
      const ot = Math.min(fe, Se),
        we = this.slice(ee, Me),
        Re = C.slice(L, j);
      for (let at = 0; at < ot; ++at)
        if (we[at] !== Re[at]) {
          (fe = we[at]), (Se = Re[at]);
          break;
        }
      return fe < Se ? -1 : Se < fe ? 1 : 0;
    });
  function ne(I, C, L, j, ee) {
    if (I.length === 0) return -1;
    if (
      (typeof L == "string"
        ? ((j = L), (L = 0))
        : L > 2147483647
        ? (L = 2147483647)
        : L < -2147483648 && (L = -2147483648),
      (L = +L),
      oe(L) && (L = ee ? 0 : I.length - 1),
      L < 0 && (L = I.length + L),
      L >= I.length)
    ) {
      if (ee) return -1;
      L = I.length - 1;
    } else if (L < 0)
      if (ee) L = 0;
      else return -1;
    if ((typeof C == "string" && (C = p.from(C, j)), p.isBuffer(C)))
      return C.length === 0 ? -1 : Ae(I, C, L, j, ee);
    if (typeof C == "number")
      return (
        (C = C & 255),
        typeof a.prototype.indexOf == "function"
          ? ee
            ? a.prototype.indexOf.call(I, C, L)
            : a.prototype.lastIndexOf.call(I, C, L)
          : Ae(I, [C], L, j, ee)
      );
    throw new TypeError("val must be string, number or Buffer");
  }
  function Ae(I, C, L, j, ee) {
    let Me = 1,
      fe = I.length,
      Se = C.length;
    if (
      j !== void 0 &&
      ((j = String(j).toLowerCase()),
      j === "ucs2" || j === "ucs-2" || j === "utf16le" || j === "utf-16le")
    ) {
      if (I.length < 2 || C.length < 2) return -1;
      (Me = 2), (fe /= 2), (Se /= 2), (L /= 2);
    }
    function ot(Re, at) {
      return Me === 1 ? Re[at] : Re.readUInt16BE(at * Me);
    }
    let we;
    if (ee) {
      let Re = -1;
      for (we = L; we < fe; we++)
        if (ot(I, we) === ot(C, Re === -1 ? 0 : we - Re)) {
          if ((Re === -1 && (Re = we), we - Re + 1 === Se)) return Re * Me;
        } else Re !== -1 && (we -= we - Re), (Re = -1);
    } else
      for (L + Se > fe && (L = fe - Se), we = L; we >= 0; we--) {
        let Re = !0;
        for (let at = 0; at < Se; at++)
          if (ot(I, we + at) !== ot(C, at)) {
            Re = !1;
            break;
          }
        if (Re) return we;
      }
    return -1;
  }
  (p.prototype.includes = function (C, L, j) {
    return this.indexOf(C, L, j) !== -1;
  }),
    (p.prototype.indexOf = function (C, L, j) {
      return ne(this, C, L, j, !0);
    }),
    (p.prototype.lastIndexOf = function (C, L, j) {
      return ne(this, C, L, j, !1);
    });
  function x(I, C, L, j) {
    L = Number(L) || 0;
    const ee = I.length - L;
    j ? ((j = Number(j)), j > ee && (j = ee)) : (j = ee);
    const Me = C.length;
    j > Me / 2 && (j = Me / 2);
    let fe;
    for (fe = 0; fe < j; ++fe) {
      const Se = parseInt(C.substr(fe * 2, 2), 16);
      if (oe(Se)) return fe;
      I[L + fe] = Se;
    }
    return fe;
  }
  function r(I, C, L, j) {
    return Ue(wt(C, I.length - L), I, L, j);
  }
  function o(I, C, L, j) {
    return Ue(Oe(C), I, L, j);
  }
  function f(I, C, L, j) {
    return Ue(xt(C), I, L, j);
  }
  function u(I, C, L, j) {
    return Ue(je(C, I.length - L), I, L, j);
  }
  (p.prototype.write = function (C, L, j, ee) {
    if (L === void 0) (ee = "utf8"), (j = this.length), (L = 0);
    else if (j === void 0 && typeof L == "string") (ee = L), (j = this.length), (L = 0);
    else if (isFinite(L))
      (L = L >>> 0),
        isFinite(j) ? ((j = j >>> 0), ee === void 0 && (ee = "utf8")) : ((ee = j), (j = void 0));
    else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const Me = this.length - L;
    if (
      ((j === void 0 || j > Me) && (j = Me), (C.length > 0 && (j < 0 || L < 0)) || L > this.length)
    )
      throw new RangeError("Attempt to write outside buffer bounds");
    ee || (ee = "utf8");
    let fe = !1;
    for (;;)
      switch (ee) {
        case "hex":
          return x(this, C, L, j);
        case "utf8":
        case "utf-8":
          return r(this, C, L, j);
        case "ascii":
        case "latin1":
        case "binary":
          return o(this, C, L, j);
        case "base64":
          return f(this, C, L, j);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return u(this, C, L, j);
        default:
          if (fe) throw new TypeError("Unknown encoding: " + ee);
          (ee = ("" + ee).toLowerCase()), (fe = !0);
      }
  }),
    (p.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0),
      };
    });
  function d(I, C, L) {
    return C === 0 && L === I.length ? e.fromByteArray(I) : e.fromByteArray(I.slice(C, L));
  }
  function y(I, C, L) {
    L = Math.min(I.length, L);
    const j = [];
    let ee = C;
    for (; ee < L; ) {
      const Me = I[ee];
      let fe = null,
        Se = Me > 239 ? 4 : Me > 223 ? 3 : Me > 191 ? 2 : 1;
      if (ee + Se <= L) {
        let ot, we, Re, at;
        switch (Se) {
          case 1:
            Me < 128 && (fe = Me);
            break;
          case 2:
            (ot = I[ee + 1]),
              (ot & 192) === 128 && ((at = ((Me & 31) << 6) | (ot & 63)), at > 127 && (fe = at));
            break;
          case 3:
            (ot = I[ee + 1]),
              (we = I[ee + 2]),
              (ot & 192) === 128 &&
                (we & 192) === 128 &&
                ((at = ((Me & 15) << 12) | ((ot & 63) << 6) | (we & 63)),
                at > 2047 && (at < 55296 || at > 57343) && (fe = at));
            break;
          case 4:
            (ot = I[ee + 1]),
              (we = I[ee + 2]),
              (Re = I[ee + 3]),
              (ot & 192) === 128 &&
                (we & 192) === 128 &&
                (Re & 192) === 128 &&
                ((at = ((Me & 15) << 18) | ((ot & 63) << 12) | ((we & 63) << 6) | (Re & 63)),
                at > 65535 && at < 1114112 && (fe = at));
        }
      }
      fe === null
        ? ((fe = 65533), (Se = 1))
        : fe > 65535 &&
          ((fe -= 65536), j.push(((fe >>> 10) & 1023) | 55296), (fe = 56320 | (fe & 1023))),
        j.push(fe),
        (ee += Se);
    }
    return h(j);
  }
  const w = 4096;
  function h(I) {
    const C = I.length;
    if (C <= w) return String.fromCharCode.apply(String, I);
    let L = "",
      j = 0;
    for (; j < C; ) L += String.fromCharCode.apply(String, I.slice(j, (j += w)));
    return L;
  }
  function s(I, C, L) {
    let j = "";
    L = Math.min(I.length, L);
    for (let ee = C; ee < L; ++ee) j += String.fromCharCode(I[ee] & 127);
    return j;
  }
  function m(I, C, L) {
    let j = "";
    L = Math.min(I.length, L);
    for (let ee = C; ee < L; ++ee) j += String.fromCharCode(I[ee]);
    return j;
  }
  function E(I, C, L) {
    const j = I.length;
    (!C || C < 0) && (C = 0), (!L || L < 0 || L > j) && (L = j);
    let ee = "";
    for (let Me = C; Me < L; ++Me) ee += X[I[Me]];
    return ee;
  }
  function R(I, C, L) {
    const j = I.slice(C, L);
    let ee = "";
    for (let Me = 0; Me < j.length - 1; Me += 2) ee += String.fromCharCode(j[Me] + j[Me + 1] * 256);
    return ee;
  }
  p.prototype.slice = function (C, L) {
    const j = this.length;
    (C = ~~C),
      (L = L === void 0 ? j : ~~L),
      C < 0 ? ((C += j), C < 0 && (C = 0)) : C > j && (C = j),
      L < 0 ? ((L += j), L < 0 && (L = 0)) : L > j && (L = j),
      L < C && (L = C);
    const ee = this.subarray(C, L);
    return Object.setPrototypeOf(ee, p.prototype), ee;
  };
  function z(I, C, L) {
    if (I % 1 !== 0 || I < 0) throw new RangeError("offset is not uint");
    if (I + C > L) throw new RangeError("Trying to access beyond buffer length");
  }
  (p.prototype.readUintLE = p.prototype.readUIntLE =
    function (C, L, j) {
      (C = C >>> 0), (L = L >>> 0), j || z(C, L, this.length);
      let ee = this[C],
        Me = 1,
        fe = 0;
      for (; ++fe < L && (Me *= 256); ) ee += this[C + fe] * Me;
      return ee;
    }),
    (p.prototype.readUintBE = p.prototype.readUIntBE =
      function (C, L, j) {
        (C = C >>> 0), (L = L >>> 0), j || z(C, L, this.length);
        let ee = this[C + --L],
          Me = 1;
        for (; L > 0 && (Me *= 256); ) ee += this[C + --L] * Me;
        return ee;
      }),
    (p.prototype.readUint8 = p.prototype.readUInt8 =
      function (C, L) {
        return (C = C >>> 0), L || z(C, 1, this.length), this[C];
      }),
    (p.prototype.readUint16LE = p.prototype.readUInt16LE =
      function (C, L) {
        return (C = C >>> 0), L || z(C, 2, this.length), this[C] | (this[C + 1] << 8);
      }),
    (p.prototype.readUint16BE = p.prototype.readUInt16BE =
      function (C, L) {
        return (C = C >>> 0), L || z(C, 2, this.length), (this[C] << 8) | this[C + 1];
      }),
    (p.prototype.readUint32LE = p.prototype.readUInt32LE =
      function (C, L) {
        return (
          (C = C >>> 0),
          L || z(C, 4, this.length),
          (this[C] | (this[C + 1] << 8) | (this[C + 2] << 16)) + this[C + 3] * 16777216
        );
      }),
    (p.prototype.readUint32BE = p.prototype.readUInt32BE =
      function (C, L) {
        return (
          (C = C >>> 0),
          L || z(C, 4, this.length),
          this[C] * 16777216 + ((this[C + 1] << 16) | (this[C + 2] << 8) | this[C + 3])
        );
      }),
    (p.prototype.readBigUInt64LE = le(function (C) {
      (C = C >>> 0), Te(C, "offset");
      const L = this[C],
        j = this[C + 7];
      (L === void 0 || j === void 0) && ut(C, this.length - 8);
      const ee = L + this[++C] * 2 ** 8 + this[++C] * 2 ** 16 + this[++C] * 2 ** 24,
        Me = this[++C] + this[++C] * 2 ** 8 + this[++C] * 2 ** 16 + j * 2 ** 24;
      return BigInt(ee) + (BigInt(Me) << BigInt(32));
    })),
    (p.prototype.readBigUInt64BE = le(function (C) {
      (C = C >>> 0), Te(C, "offset");
      const L = this[C],
        j = this[C + 7];
      (L === void 0 || j === void 0) && ut(C, this.length - 8);
      const ee = L * 2 ** 24 + this[++C] * 2 ** 16 + this[++C] * 2 ** 8 + this[++C],
        Me = this[++C] * 2 ** 24 + this[++C] * 2 ** 16 + this[++C] * 2 ** 8 + j;
      return (BigInt(ee) << BigInt(32)) + BigInt(Me);
    })),
    (p.prototype.readIntLE = function (C, L, j) {
      (C = C >>> 0), (L = L >>> 0), j || z(C, L, this.length);
      let ee = this[C],
        Me = 1,
        fe = 0;
      for (; ++fe < L && (Me *= 256); ) ee += this[C + fe] * Me;
      return (Me *= 128), ee >= Me && (ee -= Math.pow(2, 8 * L)), ee;
    }),
    (p.prototype.readIntBE = function (C, L, j) {
      (C = C >>> 0), (L = L >>> 0), j || z(C, L, this.length);
      let ee = L,
        Me = 1,
        fe = this[C + --ee];
      for (; ee > 0 && (Me *= 256); ) fe += this[C + --ee] * Me;
      return (Me *= 128), fe >= Me && (fe -= Math.pow(2, 8 * L)), fe;
    }),
    (p.prototype.readInt8 = function (C, L) {
      return (
        (C = C >>> 0), L || z(C, 1, this.length), this[C] & 128 ? (255 - this[C] + 1) * -1 : this[C]
      );
    }),
    (p.prototype.readInt16LE = function (C, L) {
      (C = C >>> 0), L || z(C, 2, this.length);
      const j = this[C] | (this[C + 1] << 8);
      return j & 32768 ? j | 4294901760 : j;
    }),
    (p.prototype.readInt16BE = function (C, L) {
      (C = C >>> 0), L || z(C, 2, this.length);
      const j = this[C + 1] | (this[C] << 8);
      return j & 32768 ? j | 4294901760 : j;
    }),
    (p.prototype.readInt32LE = function (C, L) {
      return (
        (C = C >>> 0),
        L || z(C, 4, this.length),
        this[C] | (this[C + 1] << 8) | (this[C + 2] << 16) | (this[C + 3] << 24)
      );
    }),
    (p.prototype.readInt32BE = function (C, L) {
      return (
        (C = C >>> 0),
        L || z(C, 4, this.length),
        (this[C] << 24) | (this[C + 1] << 16) | (this[C + 2] << 8) | this[C + 3]
      );
    }),
    (p.prototype.readBigInt64LE = le(function (C) {
      (C = C >>> 0), Te(C, "offset");
      const L = this[C],
        j = this[C + 7];
      (L === void 0 || j === void 0) && ut(C, this.length - 8);
      const ee = this[C + 4] + this[C + 5] * 2 ** 8 + this[C + 6] * 2 ** 16 + (j << 24);
      return (
        (BigInt(ee) << BigInt(32)) +
        BigInt(L + this[++C] * 2 ** 8 + this[++C] * 2 ** 16 + this[++C] * 2 ** 24)
      );
    })),
    (p.prototype.readBigInt64BE = le(function (C) {
      (C = C >>> 0), Te(C, "offset");
      const L = this[C],
        j = this[C + 7];
      (L === void 0 || j === void 0) && ut(C, this.length - 8);
      const ee =
        (L << 24) + // Overflow
        this[++C] * 2 ** 16 +
        this[++C] * 2 ** 8 +
        this[++C];
      return (
        (BigInt(ee) << BigInt(32)) +
        BigInt(this[++C] * 2 ** 24 + this[++C] * 2 ** 16 + this[++C] * 2 ** 8 + j)
      );
    })),
    (p.prototype.readFloatLE = function (C, L) {
      return (C = C >>> 0), L || z(C, 4, this.length), n.read(this, C, !0, 23, 4);
    }),
    (p.prototype.readFloatBE = function (C, L) {
      return (C = C >>> 0), L || z(C, 4, this.length), n.read(this, C, !1, 23, 4);
    }),
    (p.prototype.readDoubleLE = function (C, L) {
      return (C = C >>> 0), L || z(C, 8, this.length), n.read(this, C, !0, 52, 8);
    }),
    (p.prototype.readDoubleBE = function (C, L) {
      return (C = C >>> 0), L || z(C, 8, this.length), n.read(this, C, !1, 52, 8);
    });
  function Q(I, C, L, j, ee, Me) {
    if (!p.isBuffer(I)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (C > ee || C < Me) throw new RangeError('"value" argument is out of bounds');
    if (L + j > I.length) throw new RangeError("Index out of range");
  }
  (p.prototype.writeUintLE = p.prototype.writeUIntLE =
    function (C, L, j, ee) {
      if (((C = +C), (L = L >>> 0), (j = j >>> 0), !ee)) {
        const Se = Math.pow(2, 8 * j) - 1;
        Q(this, C, L, j, Se, 0);
      }
      let Me = 1,
        fe = 0;
      for (this[L] = C & 255; ++fe < j && (Me *= 256); ) this[L + fe] = (C / Me) & 255;
      return L + j;
    }),
    (p.prototype.writeUintBE = p.prototype.writeUIntBE =
      function (C, L, j, ee) {
        if (((C = +C), (L = L >>> 0), (j = j >>> 0), !ee)) {
          const Se = Math.pow(2, 8 * j) - 1;
          Q(this, C, L, j, Se, 0);
        }
        let Me = j - 1,
          fe = 1;
        for (this[L + Me] = C & 255; --Me >= 0 && (fe *= 256); ) this[L + Me] = (C / fe) & 255;
        return L + j;
      }),
    (p.prototype.writeUint8 = p.prototype.writeUInt8 =
      function (C, L, j) {
        return (C = +C), (L = L >>> 0), j || Q(this, C, L, 1, 255, 0), (this[L] = C & 255), L + 1;
      }),
    (p.prototype.writeUint16LE = p.prototype.writeUInt16LE =
      function (C, L, j) {
        return (
          (C = +C),
          (L = L >>> 0),
          j || Q(this, C, L, 2, 65535, 0),
          (this[L] = C & 255),
          (this[L + 1] = C >>> 8),
          L + 2
        );
      }),
    (p.prototype.writeUint16BE = p.prototype.writeUInt16BE =
      function (C, L, j) {
        return (
          (C = +C),
          (L = L >>> 0),
          j || Q(this, C, L, 2, 65535, 0),
          (this[L] = C >>> 8),
          (this[L + 1] = C & 255),
          L + 2
        );
      }),
    (p.prototype.writeUint32LE = p.prototype.writeUInt32LE =
      function (C, L, j) {
        return (
          (C = +C),
          (L = L >>> 0),
          j || Q(this, C, L, 4, 4294967295, 0),
          (this[L + 3] = C >>> 24),
          (this[L + 2] = C >>> 16),
          (this[L + 1] = C >>> 8),
          (this[L] = C & 255),
          L + 4
        );
      }),
    (p.prototype.writeUint32BE = p.prototype.writeUInt32BE =
      function (C, L, j) {
        return (
          (C = +C),
          (L = L >>> 0),
          j || Q(this, C, L, 4, 4294967295, 0),
          (this[L] = C >>> 24),
          (this[L + 1] = C >>> 16),
          (this[L + 2] = C >>> 8),
          (this[L + 3] = C & 255),
          L + 4
        );
      });
  function G(I, C, L, j, ee) {
    Ce(C, j, ee, I, L, 7);
    let Me = Number(C & BigInt(4294967295));
    (I[L++] = Me),
      (Me = Me >> 8),
      (I[L++] = Me),
      (Me = Me >> 8),
      (I[L++] = Me),
      (Me = Me >> 8),
      (I[L++] = Me);
    let fe = Number((C >> BigInt(32)) & BigInt(4294967295));
    return (
      (I[L++] = fe),
      (fe = fe >> 8),
      (I[L++] = fe),
      (fe = fe >> 8),
      (I[L++] = fe),
      (fe = fe >> 8),
      (I[L++] = fe),
      L
    );
  }
  function q(I, C, L, j, ee) {
    Ce(C, j, ee, I, L, 7);
    let Me = Number(C & BigInt(4294967295));
    (I[L + 7] = Me),
      (Me = Me >> 8),
      (I[L + 6] = Me),
      (Me = Me >> 8),
      (I[L + 5] = Me),
      (Me = Me >> 8),
      (I[L + 4] = Me);
    let fe = Number((C >> BigInt(32)) & BigInt(4294967295));
    return (
      (I[L + 3] = fe),
      (fe = fe >> 8),
      (I[L + 2] = fe),
      (fe = fe >> 8),
      (I[L + 1] = fe),
      (fe = fe >> 8),
      (I[L] = fe),
      L + 8
    );
  }
  (p.prototype.writeBigUInt64LE = le(function (C, L = 0) {
    return G(this, C, L, BigInt(0), BigInt("0xffffffffffffffff"));
  })),
    (p.prototype.writeBigUInt64BE = le(function (C, L = 0) {
      return q(this, C, L, BigInt(0), BigInt("0xffffffffffffffff"));
    })),
    (p.prototype.writeIntLE = function (C, L, j, ee) {
      if (((C = +C), (L = L >>> 0), !ee)) {
        const ot = Math.pow(2, 8 * j - 1);
        Q(this, C, L, j, ot - 1, -ot);
      }
      let Me = 0,
        fe = 1,
        Se = 0;
      for (this[L] = C & 255; ++Me < j && (fe *= 256); )
        C < 0 && Se === 0 && this[L + Me - 1] !== 0 && (Se = 1),
          (this[L + Me] = (((C / fe) >> 0) - Se) & 255);
      return L + j;
    }),
    (p.prototype.writeIntBE = function (C, L, j, ee) {
      if (((C = +C), (L = L >>> 0), !ee)) {
        const ot = Math.pow(2, 8 * j - 1);
        Q(this, C, L, j, ot - 1, -ot);
      }
      let Me = j - 1,
        fe = 1,
        Se = 0;
      for (this[L + Me] = C & 255; --Me >= 0 && (fe *= 256); )
        C < 0 && Se === 0 && this[L + Me + 1] !== 0 && (Se = 1),
          (this[L + Me] = (((C / fe) >> 0) - Se) & 255);
      return L + j;
    }),
    (p.prototype.writeInt8 = function (C, L, j) {
      return (
        (C = +C),
        (L = L >>> 0),
        j || Q(this, C, L, 1, 127, -128),
        C < 0 && (C = 255 + C + 1),
        (this[L] = C & 255),
        L + 1
      );
    }),
    (p.prototype.writeInt16LE = function (C, L, j) {
      return (
        (C = +C),
        (L = L >>> 0),
        j || Q(this, C, L, 2, 32767, -32768),
        (this[L] = C & 255),
        (this[L + 1] = C >>> 8),
        L + 2
      );
    }),
    (p.prototype.writeInt16BE = function (C, L, j) {
      return (
        (C = +C),
        (L = L >>> 0),
        j || Q(this, C, L, 2, 32767, -32768),
        (this[L] = C >>> 8),
        (this[L + 1] = C & 255),
        L + 2
      );
    }),
    (p.prototype.writeInt32LE = function (C, L, j) {
      return (
        (C = +C),
        (L = L >>> 0),
        j || Q(this, C, L, 4, 2147483647, -2147483648),
        (this[L] = C & 255),
        (this[L + 1] = C >>> 8),
        (this[L + 2] = C >>> 16),
        (this[L + 3] = C >>> 24),
        L + 4
      );
    }),
    (p.prototype.writeInt32BE = function (C, L, j) {
      return (
        (C = +C),
        (L = L >>> 0),
        j || Q(this, C, L, 4, 2147483647, -2147483648),
        C < 0 && (C = 4294967295 + C + 1),
        (this[L] = C >>> 24),
        (this[L + 1] = C >>> 16),
        (this[L + 2] = C >>> 8),
        (this[L + 3] = C & 255),
        L + 4
      );
    }),
    (p.prototype.writeBigInt64LE = le(function (C, L = 0) {
      return G(this, C, L, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    })),
    (p.prototype.writeBigInt64BE = le(function (C, L = 0) {
      return q(this, C, L, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }));
  function Z(I, C, L, j, ee, Me) {
    if (L + j > I.length) throw new RangeError("Index out of range");
    if (L < 0) throw new RangeError("Index out of range");
  }
  function te(I, C, L, j, ee) {
    return (C = +C), (L = L >>> 0), ee || Z(I, C, L, 4), n.write(I, C, L, j, 23, 4), L + 4;
  }
  (p.prototype.writeFloatLE = function (C, L, j) {
    return te(this, C, L, !0, j);
  }),
    (p.prototype.writeFloatBE = function (C, L, j) {
      return te(this, C, L, !1, j);
    });
  function ue(I, C, L, j, ee) {
    return (C = +C), (L = L >>> 0), ee || Z(I, C, L, 8), n.write(I, C, L, j, 52, 8), L + 8;
  }
  (p.prototype.writeDoubleLE = function (C, L, j) {
    return ue(this, C, L, !0, j);
  }),
    (p.prototype.writeDoubleBE = function (C, L, j) {
      return ue(this, C, L, !1, j);
    }),
    (p.prototype.copy = function (C, L, j, ee) {
      if (!p.isBuffer(C)) throw new TypeError("argument should be a Buffer");
      if (
        (j || (j = 0),
        !ee && ee !== 0 && (ee = this.length),
        L >= C.length && (L = C.length),
        L || (L = 0),
        ee > 0 && ee < j && (ee = j),
        ee === j || C.length === 0 || this.length === 0)
      )
        return 0;
      if (L < 0) throw new RangeError("targetStart out of bounds");
      if (j < 0 || j >= this.length) throw new RangeError("Index out of range");
      if (ee < 0) throw new RangeError("sourceEnd out of bounds");
      ee > this.length && (ee = this.length), C.length - L < ee - j && (ee = C.length - L + j);
      const Me = ee - j;
      return (
        this === C && typeof a.prototype.copyWithin == "function"
          ? this.copyWithin(L, j, ee)
          : a.prototype.set.call(C, this.subarray(j, ee), L),
        Me
      );
    }),
    (p.prototype.fill = function (C, L, j, ee) {
      if (typeof C == "string") {
        if (
          (typeof L == "string"
            ? ((ee = L), (L = 0), (j = this.length))
            : typeof j == "string" && ((ee = j), (j = this.length)),
          ee !== void 0 && typeof ee != "string")
        )
          throw new TypeError("encoding must be a string");
        if (typeof ee == "string" && !p.isEncoding(ee))
          throw new TypeError("Unknown encoding: " + ee);
        if (C.length === 1) {
          const fe = C.charCodeAt(0);
          ((ee === "utf8" && fe < 128) || ee === "latin1") && (C = fe);
        }
      } else typeof C == "number" ? (C = C & 255) : typeof C == "boolean" && (C = Number(C));
      if (L < 0 || this.length < L || this.length < j) throw new RangeError("Out of range index");
      if (j <= L) return this;
      (L = L >>> 0), (j = j === void 0 ? this.length : j >>> 0), C || (C = 0);
      let Me;
      if (typeof C == "number") for (Me = L; Me < j; ++Me) this[Me] = C;
      else {
        const fe = p.isBuffer(C) ? C : p.from(C, ee),
          Se = fe.length;
        if (Se === 0) throw new TypeError('The value "' + C + '" is invalid for argument "value"');
        for (Me = 0; Me < j - L; ++Me) this[Me + L] = fe[Me % Se];
      }
      return this;
    });
  const ae = {};
  function K(I, C, L) {
    ae[I] = class extends L {
      constructor() {
        super(),
          Object.defineProperty(this, "message", {
            value: C.apply(this, arguments),
            writable: !0,
            configurable: !0,
          }),
          (this.name = `${this.name} [${I}]`),
          this.stack,
          delete this.name;
      }
      get code() {
        return I;
      }
      set code(ee) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: ee,
          writable: !0,
        });
      }
      toString() {
        return `${this.name} [${I}]: ${this.message}`;
      }
    };
  }
  K(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function (I) {
      return I
        ? `${I} is outside of buffer bounds`
        : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ),
    K(
      "ERR_INVALID_ARG_TYPE",
      function (I, C) {
        return `The "${I}" argument must be of type number. Received type ${typeof C}`;
      },
      TypeError
    ),
    K(
      "ERR_OUT_OF_RANGE",
      function (I, C, L) {
        let j = `The value of "${I}" is out of range.`,
          ee = L;
        return (
          Number.isInteger(L) && Math.abs(L) > 2 ** 32
            ? (ee = ve(String(L)))
            : typeof L == "bigint" &&
              ((ee = String(L)),
              (L > BigInt(2) ** BigInt(32) || L < -(BigInt(2) ** BigInt(32))) && (ee = ve(ee)),
              (ee += "n")),
          (j += ` It must be ${C}. Received ${ee}`),
          j
        );
      },
      RangeError
    );
  function ve(I) {
    let C = "",
      L = I.length;
    const j = I[0] === "-" ? 1 : 0;
    for (; L >= j + 4; L -= 3) C = `_${I.slice(L - 3, L)}${C}`;
    return `${I.slice(0, L)}${C}`;
  }
  function Ye(I, C, L) {
    Te(C, "offset"), (I[C] === void 0 || I[C + L] === void 0) && ut(C, I.length - (L + 1));
  }
  function Ce(I, C, L, j, ee, Me) {
    if (I > L || I < C) {
      const fe = typeof C == "bigint" ? "n" : "";
      let Se;
      throw (
        (Me > 3
          ? C === 0 || C === BigInt(0)
            ? (Se = `>= 0${fe} and < 2${fe} ** ${(Me + 1) * 8}${fe}`)
            : (Se = `>= -(2${fe} ** ${(Me + 1) * 8 - 1}${fe}) and < 2 ** ${(Me + 1) * 8 - 1}${fe}`)
          : (Se = `>= ${C}${fe} and <= ${L}${fe}`),
        new ae.ERR_OUT_OF_RANGE("value", Se, I))
      );
    }
    Ye(j, ee, Me);
  }
  function Te(I, C) {
    if (typeof I != "number") throw new ae.ERR_INVALID_ARG_TYPE(C, "number", I);
  }
  function ut(I, C, L) {
    throw Math.floor(I) !== I
      ? (Te(I, L), new ae.ERR_OUT_OF_RANGE(L || "offset", "an integer", I))
      : C < 0
      ? new ae.ERR_BUFFER_OUT_OF_BOUNDS()
      : new ae.ERR_OUT_OF_RANGE(L || "offset", `>= ${L ? 1 : 0} and <= ${C}`, I);
  }
  const Ie = /[^+/0-9A-Za-z-_]/g;
  function be(I) {
    if (((I = I.split("=")[0]), (I = I.trim().replace(Ie, "")), I.length < 2)) return "";
    for (; I.length % 4 !== 0; ) I = I + "=";
    return I;
  }
  function wt(I, C) {
    C = C || 1 / 0;
    let L;
    const j = I.length;
    let ee = null;
    const Me = [];
    for (let fe = 0; fe < j; ++fe) {
      if (((L = I.charCodeAt(fe)), L > 55295 && L < 57344)) {
        if (!ee) {
          if (L > 56319) {
            (C -= 3) > -1 && Me.push(239, 191, 189);
            continue;
          } else if (fe + 1 === j) {
            (C -= 3) > -1 && Me.push(239, 191, 189);
            continue;
          }
          ee = L;
          continue;
        }
        if (L < 56320) {
          (C -= 3) > -1 && Me.push(239, 191, 189), (ee = L);
          continue;
        }
        L = (((ee - 55296) << 10) | (L - 56320)) + 65536;
      } else ee && (C -= 3) > -1 && Me.push(239, 191, 189);
      if (((ee = null), L < 128)) {
        if ((C -= 1) < 0) break;
        Me.push(L);
      } else if (L < 2048) {
        if ((C -= 2) < 0) break;
        Me.push((L >> 6) | 192, (L & 63) | 128);
      } else if (L < 65536) {
        if ((C -= 3) < 0) break;
        Me.push((L >> 12) | 224, ((L >> 6) & 63) | 128, (L & 63) | 128);
      } else if (L < 1114112) {
        if ((C -= 4) < 0) break;
        Me.push((L >> 18) | 240, ((L >> 12) & 63) | 128, ((L >> 6) & 63) | 128, (L & 63) | 128);
      } else throw new Error("Invalid code point");
    }
    return Me;
  }
  function Oe(I) {
    const C = [];
    for (let L = 0; L < I.length; ++L) C.push(I.charCodeAt(L) & 255);
    return C;
  }
  function je(I, C) {
    let L, j, ee;
    const Me = [];
    for (let fe = 0; fe < I.length && !((C -= 2) < 0); ++fe)
      (L = I.charCodeAt(fe)), (j = L >> 8), (ee = L % 256), Me.push(ee), Me.push(j);
    return Me;
  }
  function xt(I) {
    return e.toByteArray(be(I));
  }
  function Ue(I, C, L, j) {
    let ee;
    for (ee = 0; ee < j && !(ee + L >= C.length || ee >= I.length); ++ee) C[ee + L] = I[ee];
    return ee;
  }
  function se(I, C) {
    return (
      I instanceof C ||
      (I != null &&
        I.constructor != null &&
        I.constructor.name != null &&
        I.constructor.name === C.name)
    );
  }
  function oe(I) {
    return I !== I;
  }
  const X = (function () {
    const I = "0123456789abcdef",
      C = new Array(256);
    for (let L = 0; L < 16; ++L) {
      const j = L * 16;
      for (let ee = 0; ee < 16; ++ee) C[j + ee] = I[L] + I[ee];
    }
    return C;
  })();
  function le(I) {
    return typeof BigInt > "u" ? ke : I;
  }
  function ke() {
    throw new Error("BigInt not supported");
  }
})(wr);
const Qe = wr.Buffer,
  L_ = wr.Blob,
  F_ = wr.BlobOptions,
  q_ = wr.Buffer,
  z_ = wr.File,
  j_ = wr.FileOptions,
  $_ = wr.INSPECT_MAX_BYTES,
  H_ = wr.SlowBuffer,
  V_ = wr.TranscodeEncoding,
  W_ = wr.atob,
  K_ = wr.btoa,
  Z_ = wr.constants,
  G_ = wr.isAscii,
  Y_ = wr.isUtf8,
  J_ = wr.kMaxLength,
  Q_ = wr.kStringMaxLength,
  X_ = wr.resolveObjectURL,
  ex = wr.transcode,
  tx = /* @__PURE__ */ Object.freeze(
    /* @__PURE__ */ Object.defineProperty(
      {
        __proto__: null,
        Blob: L_,
        BlobOptions: F_,
        Buffer: q_,
        File: z_,
        FileOptions: j_,
        INSPECT_MAX_BYTES: $_,
        SlowBuffer: H_,
        TranscodeEncoding: V_,
        atob: W_,
        btoa: K_,
        constants: Z_,
        default: Qe,
        isAscii: G_,
        isUtf8: Y_,
        kMaxLength: J_,
        kStringMaxLength: Q_,
        resolveObjectURL: X_,
        transcode: ex,
      },
      Symbol.toStringTag,
      { value: "Module" }
    )
  );
var _t = {},
  cn = {};
const rx = Symbol.for("nodejs.util.inspect.custom");
var Js = rx,
  Qs = {};
Object.defineProperty(Qs, "__esModule", { value: !0 });
Qs.crc16 = void 0;
function nx(t) {
  let n = 0;
  const i = Qe.alloc(t.length + 2);
  i.set(t);
  for (let l of i) {
    let a = 128;
    for (; a > 0; )
      (n <<= 1), l & a && (n += 1), (a >>= 1), n > 65535 && ((n &= 65535), (n ^= 4129));
  }
  return Qe.from([Math.floor(n / 256), n % 256]);
}
Qs.crc16 = nx;
var ix =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    },
  O6;
Object.defineProperty(cn, "__esModule", { value: !0 });
cn.address = cn.Address = void 0;
const ax = ix(Js),
  U6 = Qs,
  fp = 17,
  N6 = 81,
  lp = 128;
function Gm(t) {
  if (typeof t == "string" && !Tn.isFriendly(t)) throw new Error("Unknown address type");
  const e = Qe.isBuffer(t) ? t : Qe.from(t, "base64");
  if (e.length !== 36) throw new Error("Unknown address type: byte length is not equal to 36");
  const n = e.subarray(0, 34),
    i = e.subarray(34, 36),
    l = (0, U6.crc16)(n);
  if (!(l[0] === i[0] && l[1] === i[1])) throw new Error("Invalid checksum: " + t);
  let a = n[0],
    c = !1,
    v = !1;
  if ((a & lp && ((c = !0), (a = a ^ lp)), a !== fp && a !== N6)) throw "Unknown address tag";
  v = a === fp;
  let g = null;
  n[1] === 255 ? (g = -1) : (g = n[1]);
  const b = n.subarray(2, 34);
  return { isTestOnly: c, isBounceable: v, workchain: g, hashPart: b };
}
class Tn {
  static isAddress(e) {
    return e instanceof Tn;
  }
  static isFriendly(e) {
    return !(e.length !== 48 || !/[A-Za-z0-9+/_-]+/.test(e));
  }
  static isRaw(e) {
    if (e.indexOf(":") === -1) return !1;
    let [n, i] = e.split(":");
    return !(
      !Number.isInteger(parseFloat(n)) ||
      !/[a-f0-9]+/.test(i.toLowerCase()) ||
      i.length !== 64
    );
  }
  static normalize(e) {
    return typeof e == "string" ? Tn.parse(e).toString() : e.toString();
  }
  static parse(e) {
    if (Tn.isFriendly(e)) return this.parseFriendly(e).address;
    if (Tn.isRaw(e)) return this.parseRaw(e);
    throw new Error("Unknown address type: " + e);
  }
  static parseRaw(e) {
    let n = parseInt(e.split(":")[0]),
      i = Qe.from(e.split(":")[1], "hex");
    return new Tn(n, i);
  }
  static parseFriendly(e) {
    if (Qe.isBuffer(e)) {
      let n = Gm(e);
      return {
        isBounceable: n.isBounceable,
        isTestOnly: n.isTestOnly,
        address: new Tn(n.workchain, n.hashPart),
      };
    } else {
      let n = e.replace(/\-/g, "+").replace(/_/g, "/"),
        i = Gm(n);
      return {
        isBounceable: i.isBounceable,
        isTestOnly: i.isTestOnly,
        address: new Tn(i.workchain, i.hashPart),
      };
    }
  }
  constructor(e, n) {
    if (
      ((this.toRawString = () => this.workChain + ":" + this.hash.toString("hex")),
      (this.toRaw = () => {
        const i = Qe.alloc(36);
        return (
          i.set(this.hash),
          i.set([this.workChain, this.workChain, this.workChain, this.workChain], 32),
          i
        );
      }),
      (this.toStringBuffer = (i) => {
        let l = i && i.testOnly !== void 0 ? i.testOnly : !1,
          c = (i && i.bounceable !== void 0 ? i.bounceable : !0) ? fp : N6;
        l && (c |= lp);
        const v = Qe.alloc(34);
        (v[0] = c), (v[1] = this.workChain), v.set(this.hash, 2);
        const g = Qe.alloc(36);
        return g.set(v), g.set((0, U6.crc16)(v), 34), g;
      }),
      (this.toString = (i) => {
        let l = i && i.urlSafe !== void 0 ? i.urlSafe : !0,
          a = this.toStringBuffer(i);
        return l
          ? a.toString("base64").replace(/\+/g, "-").replace(/\//g, "_")
          : a.toString("base64");
      }),
      (this[O6] = () => this.toString()),
      n.length !== 32)
    )
      throw new Error("Invalid address hash length: " + n.length);
    (this.workChain = e), (this.hash = n), Object.freeze(this);
  }
  equals(e) {
    return e.workChain !== this.workChain ? !1 : e.hash.equals(this.hash);
  }
}
cn.Address = Tn;
O6 = ax.default;
function sx(t) {
  return Tn.parse(t);
}
cn.address = sx;
var Xs = {},
  ox =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    },
  D6;
Object.defineProperty(Xs, "__esModule", { value: !0 });
Xs.ExternalAddress = void 0;
const fx = ox(Js);
class c1 {
  static isAddress(e) {
    return e instanceof c1;
  }
  constructor(e, n) {
    (this[D6] = () => this.toString()), (this.value = e), (this.bits = n);
  }
  toString() {
    return `External<${this.bits}:${this.value}>`;
  }
}
Xs.ExternalAddress = c1;
D6 = fx.default;
var pu = {},
  Ua = {};
Object.defineProperty(Ua, "__esModule", { value: !0 });
Ua.base32Decode = Ua.base32Encode = void 0;
const up = "abcdefghijklmnopqrstuvwxyz234567";
function lx(t) {
  const e = t.byteLength;
  let n = 0,
    i = 0,
    l = "";
  for (let a = 0; a < e; a++)
    for (i = (i << 8) | t[a], n += 8; n >= 5; ) (l += up[(i >>> (n - 5)) & 31]), (n -= 5);
  return n > 0 && (l += up[(i << (5 - n)) & 31]), l;
}
Ua.base32Encode = lx;
function ux(t, e) {
  const n = t.indexOf(e);
  if (n === -1) throw new Error("Invalid character found: " + e);
  return n;
}
function cx(t) {
  let e;
  e = t.toLowerCase();
  const { length: n } = e;
  let i = 0,
    l = 0,
    a = 0;
  const c = Qe.alloc(((n * 5) / 8) | 0);
  for (let v = 0; v < n; v++)
    (l = (l << 5) | ux(up, e[v])), (i += 5), i >= 8 && ((c[a++] = (l >>> (i - 8)) & 255), (i -= 8));
  return c;
}
Ua.base32Decode = cx;
var hx =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    },
  L6;
Object.defineProperty(pu, "__esModule", { value: !0 });
pu.ADNLAddress = void 0;
const dx = hx(Js),
  Ym = Ua,
  Jm = Qs;
class Zl {
  static parseFriendly(e) {
    if (e.length !== 55) throw Error("Invalid address");
    e = "f" + e;
    let n = (0, Ym.base32Decode)(e);
    if (n[0] !== 45) throw Error("Invalid address");
    let i = n.slice(33);
    if (!(0, Jm.crc16)(n.slice(0, 33)).equals(i)) throw Error("Invalid address");
    return new Zl(n.slice(1, 33));
  }
  static parseRaw(e) {
    const n = Qe.from(e, "base64");
    return new Zl(n);
  }
  constructor(e) {
    if (
      ((this.toRaw = () => this.address.toString("hex").toUpperCase()),
      (this.toString = () => {
        let n = Qe.concat([Qe.from([45]), this.address]),
          i = (0, Jm.crc16)(n);
        return (n = Qe.concat([n, i])), (0, Ym.base32Encode)(n).slice(1);
      }),
      (this[L6] = () => this.toString()),
      e.length !== 32)
    )
      throw Error("Invalid address");
    this.address = e;
  }
  equals(e) {
    return this.address.equals(e.address);
  }
}
pu.ADNLAddress = Zl;
L6 = dx.default;
var mu = {},
  la = {},
  po = {},
  mo = {},
  ua = {},
  Qm;
function vu() {
  if (Qm) return ua;
  (Qm = 1),
    Object.defineProperty(ua, "__esModule", { value: !0 }),
    (ua.paddedBufferToBits = ua.bitsToPaddedBuffer = void 0);
  const t = gu(),
    e = oa();
  function n(l) {
    let a = new t.BitBuilder(Math.ceil(l.length / 8) * 8);
    a.writeBits(l);
    let c = Math.ceil(l.length / 8) * 8 - l.length;
    for (let v = 0; v < c; v++) v === 0 ? a.writeBit(1) : a.writeBit(0);
    return a.buffer();
  }
  ua.bitsToPaddedBuffer = n;
  function i(l) {
    let a = 0;
    for (let c = l.length - 1; c >= 0; c--)
      if (l[c] !== 0) {
        const v = l[c];
        let g = v & -v;
        g & 1 || (g = Math.log2(g) + 1), c > 0 && (a = c << 3), (a += 8 - g);
        break;
      }
    return new e.BitString(l, 0, a);
  }
  return (ua.paddedBufferToBits = i), ua;
}
var Xm;
function oa() {
  if (Xm) return mo;
  Xm = 1;
  var t =
      (mt && mt.__importDefault) ||
      function (a) {
        return a && a.__esModule ? a : { default: a };
      },
    e;
  Object.defineProperty(mo, "__esModule", { value: !0 }), (mo.BitString = void 0);
  const n = vu(),
    i = t(Js);
  let l = class vl {
    /**
     * Checks if supplied object is BitString
     * @param src is unknow object
     * @returns true if object is BitString and false otherwise
     **/
    static isBitString(c) {
      return c instanceof vl;
    }
    /**
     * Constructing BitString from a buffer
     * @param data data that contains the bitstring data. NOTE: We are expecting this buffer to be NOT modified
     * @param offset offset in bits from the start of the buffer
     * @param length length of the bitstring in bits
     */
    constructor(c, v, g) {
      if (((this[e] = () => this.toString()), g < 0))
        throw new Error(`Length ${g} is out of bounds`);
      (this._length = g), (this._data = c), (this._offset = v);
    }
    /**
     * Returns the length of the bitstring
     */
    get length() {
      return this._length;
    }
    /**
     * Returns the bit at the specified index
     * @param index index of the bit
     * @throws Error if index is out of bounds
     * @returns true if the bit is set, false otherwise
     */
    at(c) {
      if (c >= this._length) throw new Error(`Index ${c} > ${this._length} is out of bounds`);
      if (c < 0) throw new Error(`Index ${c} < 0 is out of bounds`);
      let v = (this._offset + c) >> 3,
        g = 7 - ((this._offset + c) % 8);
      return (this._data[v] & (1 << g)) !== 0;
    }
    /**
     * Get a subscring of the bitstring
     * @param offset
     * @param length
     * @returns
     */
    substring(c, v) {
      if (c > this._length) throw new Error(`Offset(${c}) > ${this._length} is out of bounds`);
      if (c < 0) throw new Error(`Offset(${c}) < 0 is out of bounds`);
      if (v === 0) return vl.EMPTY;
      if (c + v > this._length)
        throw new Error(`Offset ${c} + Length ${v} > ${this._length} is out of bounds`);
      return new vl(this._data, this._offset + c, v);
    }
    /**
     * Try to get a buffer from the bitstring without allocations
     * @param offset offset in bits
     * @param length length in bits
     * @returns buffer if the bitstring is aligned to bytes, null otherwise
     */
    subbuffer(c, v) {
      if (c > this._length) throw new Error(`Offset ${c} is out of bounds`);
      if (c < 0) throw new Error(`Offset ${c} is out of bounds`);
      if (c + v > this._length) throw new Error(`Offset + Lenght = ${c + v} is out of bounds`);
      if (v % 8 !== 0 || (this._offset + c) % 8 !== 0) return null;
      let g = (this._offset + c) >> 3,
        b = g + (v >> 3);
      return this._data.subarray(g, b);
    }
    /**
     * Checks for equality
     * @param b other bitstring
     * @returns true if the bitstrings are equal, false otherwise
     */
    equals(c) {
      if (this._length !== c._length) return !1;
      for (let v = 0; v < this._length; v++) if (this.at(v) !== c.at(v)) return !1;
      return !0;
    }
    /**
     * Format to canonical string
     * @returns formatted bits as a string
     */
    toString() {
      const c = (0, n.bitsToPaddedBuffer)(this);
      if (this._length % 4 === 0) {
        const v = c
          .subarray(0, Math.ceil(this._length / 8))
          .toString("hex")
          .toUpperCase();
        return this._length % 8 === 0 ? v : v.substring(0, v.length - 1);
      } else {
        const v = c.toString("hex").toUpperCase();
        return this._length % 8 <= 4 ? v.substring(0, v.length - 1) + "_" : v + "_";
      }
    }
  };
  return (mo.BitString = l), (e = i.default), (l.EMPTY = new l(Qe.alloc(0), 0, 0)), mo;
}
var ev;
function gu() {
  if (ev) return po;
  (ev = 1), Object.defineProperty(po, "__esModule", { value: !0 }), (po.BitBuilder = void 0);
  const t = cn,
    e = Xs,
    n = oa();
  let i = class {
    constructor(a = 1023) {
      (this._buffer = Qe.alloc(Math.ceil(a / 8))), (this._length = 0);
    }
    /**
     * Current number of bits written
     */
    get length() {
      return this._length;
    }
    /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     */
    writeBit(a) {
      let c = this._length;
      if (c > this._buffer.length * 8) throw new Error("BitBuilder overflow");
      (a === !0 || a > 0) && (this._buffer[(c / 8) | 0] |= 1 << (7 - (c % 8))), this._length++;
    }
    /**
     * Copy bits from BitString
     * @param src source bits
     */
    writeBits(a) {
      for (let c = 0; c < a.length; c++) this.writeBit(a.at(c));
    }
    /**
     * Write bits from buffer
     * @param src source buffer
     */
    writeBuffer(a) {
      if (this._length % 8 === 0) {
        if (this._length + a.length * 8 > this._buffer.length * 8)
          throw new Error("BitBuilder overflow");
        a.copy(this._buffer, this._length / 8), (this._length += a.length * 8);
      } else for (let c = 0; c < a.length; c++) this.writeUint(a[c], 8);
    }
    /**
     * Write uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */
    writeUint(a, c) {
      if (c < 0 || !Number.isSafeInteger(c)) throw Error(`invalid bit length. Got ${c}`);
      const v = BigInt(a);
      if (c === 0) {
        if (v !== 0n) throw Error(`value is not zero for ${c} bits. Got ${a}`);
        return;
      }
      const g = 1n << BigInt(c);
      if (v < 0 || v >= g) throw Error(`bitLength is too small for a value ${a}. Got ${c}`);
      if (this._length + c > this._buffer.length * 8) throw new Error("BitBuilder overflow");
      const b = 8 - (this._length % 8);
      if (b > 0) {
        const p = Math.floor(this._length / 8);
        if (c < b) {
          const _ = Number(v);
          (this._buffer[p] |= _ << (b - c)), (this._length += c);
        } else {
          const _ = Number(v >> BigInt(c - b));
          (this._buffer[p] |= _), (this._length += b);
        }
      }
      for (c -= b; c > 0; )
        c >= 8
          ? ((this._buffer[this._length / 8] = Number((v >> BigInt(c - 8)) & 0xffn)),
            (this._length += 8),
            (c -= 8))
          : ((this._buffer[this._length / 8] = Number((v << BigInt(8 - c)) & 0xffn)),
            (this._length += c),
            (c = 0));
    }
    /**
     * Write int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */
    writeInt(a, c) {
      let v = BigInt(a);
      if (c < 0 || !Number.isSafeInteger(c)) throw Error(`invalid bit length. Got ${c}`);
      if (c === 0) {
        if (a !== 0n) throw Error(`value is not zero for ${c} bits. Got ${a}`);
        return;
      }
      if (c === 1) {
        if (a !== -1n && a !== 0n) throw Error(`value is not zero or -1 for ${c} bits. Got ${a}`);
        this.writeBit(a === -1n);
        return;
      }
      let g = 1n << (BigInt(c) - 1n);
      if (v < -g || v >= g) throw Error(`value is out of range for ${c} bits. Got ${a}`);
      v < 0 ? (this.writeBit(!0), (v = g + v)) : this.writeBit(!1), this.writeUint(v, c - 1);
    }
    /**
     * Wrtie var uint value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */
    writeVarUint(a, c) {
      let v = BigInt(a);
      if (c < 0 || !Number.isSafeInteger(c)) throw Error(`invalid bit length. Got ${c}`);
      if (v < 0) throw Error(`value is negative. Got ${a}`);
      if (v === 0n) {
        this.writeUint(0, c);
        return;
      }
      const g = Math.ceil(v.toString(2).length / 8),
        b = g * 8;
      this.writeUint(g, c), this.writeUint(v, b);
    }
    /**
     * Wrtie var int value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */
    writeVarInt(a, c) {
      let v = BigInt(a);
      if (c < 0 || !Number.isSafeInteger(c)) throw Error(`invalid bit length. Got ${c}`);
      if (v === 0n) {
        this.writeUint(0, c);
        return;
      }
      let g = v > 0 ? v : -v;
      const b = 1 + Math.ceil(g.toString(2).length / 8),
        p = b * 8;
      this.writeUint(b, c), this.writeInt(v, p);
    }
    /**
     * Write coins in var uint format
     * @param amount amount to write
     */
    writeCoins(a) {
      this.writeVarUint(a, 4);
    }
    /**
     * Write address
     * @param address write address or address external
     */
    writeAddress(a) {
      if (a == null) {
        this.writeUint(0, 2);
        return;
      }
      if (t.Address.isAddress(a)) {
        this.writeUint(2, 2),
          this.writeUint(0, 1),
          this.writeInt(a.workChain, 8),
          this.writeBuffer(a.hash);
        return;
      }
      if (e.ExternalAddress.isAddress(a)) {
        this.writeUint(1, 2), this.writeUint(a.bits, 9), this.writeUint(a.value, a.bits);
        return;
      }
      throw Error(`Invalid address. Got ${a}`);
    }
    /**
     * Build BitString
     * @returns result bit string
     */
    build() {
      return new n.BitString(this._buffer, 0, this._length);
    }
    /**
     * Build into Buffer
     * @returns result buffer
     */
    buffer() {
      if (this._length % 8 !== 0) throw new Error("BitBuilder buffer is not byte aligned");
      return this._buffer.subarray(0, this._length / 8);
    }
  };
  return (po.BitBuilder = i), po;
}
var vo = {},
  eo = {};
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.CellType = void 0),
    (function (e) {
      (e[(e.Ordinary = -1)] = "Ordinary"),
        (e[(e.PrunedBranch = 1)] = "PrunedBranch"),
        (e[(e.Library = 2)] = "Library"),
        (e[(e.MerkleProof = 3)] = "MerkleProof"),
        (e[(e.MerkleUpdate = 4)] = "MerkleUpdate");
    })(t.CellType || (t.CellType = {}));
})(eo);
var go = {},
  yo = {},
  bo = {},
  yu = {};
Object.defineProperty(yu, "__esModule", { value: !0 });
yu.readUnaryLength = void 0;
function px(t) {
  let e = 0;
  for (; t.loadBit(); ) e++;
  return e;
}
yu.readUnaryLength = px;
var tv;
function h1() {
  if (tv) return bo;
  (tv = 1),
    Object.defineProperty(bo, "__esModule", { value: !0 }),
    (bo.generateMerkleProof = void 0);
  const t = _r(),
    e = yu;
  function n(c) {
    return (0, t.beginCell)()
      .storeUint(1, 8)
      .storeUint(1, 8)
      .storeBuffer(c.hash(0))
      .storeUint(c.depth(0), 16)
      .endCell({ exotic: !0 });
  }
  function i(c) {
    return (0, t.beginCell)()
      .storeUint(3, 8)
      .storeBuffer(c.hash(0))
      .storeUint(c.depth(0), 16)
      .storeRef(c)
      .endCell({ exotic: !0 });
  }
  function l(c, v, g, b) {
    const p = v.asCell();
    let _ = v.loadBit() ? 1 : 0,
      M = 0,
      S = c;
    if (_ === 0) {
      M = (0, e.readUnaryLength)(v);
      for (let A = 0; A < M; A++) S += v.loadBit() ? "1" : "0";
    } else if ((v.loadBit() ? 1 : 0) === 0) {
      M = v.loadUint(Math.ceil(Math.log2(g + 1)));
      for (let k = 0; k < M; k++) S += v.loadBit() ? "1" : "0";
    } else {
      let k = v.loadBit() ? "1" : "0";
      M = v.loadUint(Math.ceil(Math.log2(g + 1)));
      for (let P = 0; P < M; P++) S += k;
    }
    if (g - M === 0) return p;
    {
      let A = p.beginParse(),
        k = A.loadRef(),
        P = A.loadRef();
      return (
        k.isExotic ||
          (S + "0" === b.slice(0, S.length + 1)
            ? (k = l(S + "0", k.beginParse(), g - M - 1, b))
            : (k = n(k))),
        P.isExotic ||
          (S + "1" === b.slice(0, S.length + 1)
            ? (P = l(S + "1", P.beginParse(), g - M - 1, b))
            : (P = n(P))),
        (0, t.beginCell)().storeSlice(A).storeRef(k).storeRef(P).endCell()
      );
    }
  }
  function a(c, v, g) {
    const b = (0, t.beginCell)().storeDictDirect(c).endCell().beginParse();
    return i(l("", b, g.bits, g.serialize(v).toString(2).padStart(g.bits, "0")));
  }
  return (bo.generateMerkleProof = a), bo;
}
var wo = {},
  rv;
function F6() {
  if (rv) return wo;
  (rv = 1),
    Object.defineProperty(wo, "__esModule", { value: !0 }),
    (wo.generateMerkleUpdate = void 0);
  const t = _r(),
    e = h1();
  function n(l, a) {
    return (0, t.beginCell)()
      .storeUint(4, 8)
      .storeBuffer(l.hash(0))
      .storeBuffer(a.hash(0))
      .storeUint(l.depth(0), 16)
      .storeUint(a.depth(0), 16)
      .storeRef(l)
      .storeRef(a)
      .endCell({ exotic: !0 });
  }
  function i(l, a, c, v) {
    const g = (0, e.generateMerkleProof)(l, a, c).refs[0];
    l.set(a, v);
    const b = (0, e.generateMerkleProof)(l, a, c).refs[0];
    return n(g, b);
  }
  return (wo.generateMerkleUpdate = i), wo;
}
var bu = {};
Object.defineProperty(bu, "__esModule", { value: !0 });
bu.parseDict = void 0;
function mx(t) {
  let e = 0;
  for (; t.loadBit(); ) e++;
  return e;
}
function cp(t, e, n, i, l) {
  let a = e.loadBit() ? 1 : 0,
    c = 0,
    v = t;
  if (a === 0) {
    c = mx(e);
    for (let g = 0; g < c; g++) v += e.loadBit() ? "1" : "0";
  } else if ((e.loadBit() ? 1 : 0) === 0) {
    c = e.loadUint(Math.ceil(Math.log2(n + 1)));
    for (let b = 0; b < c; b++) v += e.loadBit() ? "1" : "0";
  } else {
    let b = e.loadBit() ? "1" : "0";
    c = e.loadUint(Math.ceil(Math.log2(n + 1)));
    for (let p = 0; p < c; p++) v += b;
  }
  if (n - c === 0) i.set(BigInt("0b" + v), l(e));
  else {
    let g = e.loadRef(),
      b = e.loadRef();
    g.isExotic || cp(v + "0", g.beginParse(), n - c - 1, i, l),
      b.isExotic || cp(v + "1", b.beginParse(), n - c - 1, i, l);
  }
}
function vx(t, e, n) {
  let i = /* @__PURE__ */ new Map();
  return t && cp("", t, e, i, n), i;
}
bu.parseDict = vx;
var Nr = {},
  wu = {};
Object.defineProperty(wu, "__esModule", { value: !0 });
wu.findCommonPrefix = void 0;
function gx(t, e = 0) {
  if (t.length === 0) return "";
  let n = t[0].slice(e);
  for (let i = 1; i < t.length; i++) {
    const l = t[i];
    for (; l.indexOf(n, e) !== e; ) if (((n = n.substring(0, n.length - 1)), n === "")) return n;
  }
  return n;
}
wu.findCommonPrefix = gx;
var nv;
function yx() {
  if (nv) return Nr;
  (nv = 1),
    Object.defineProperty(Nr, "__esModule", { value: !0 }),
    (Nr.serializeDict =
      Nr.detectLabelType =
      Nr.writeLabelSame =
      Nr.writeLabelLong =
      Nr.writeLabelShort =
      Nr.buildTree =
        void 0);
  const t = _r(),
    e = wu;
  function n(F, O) {
    for (; F.length < O; ) F = "0" + F;
    return F;
  }
  function i(F, O) {
    if (F.size === 0) throw Error("Internal inconsistency");
    let $ = /* @__PURE__ */ new Map(),
      J = /* @__PURE__ */ new Map();
    for (let [he, de] of F.entries()) he[O] === "0" ? $.set(he, de) : J.set(he, de);
    if ($.size === 0) throw Error("Internal inconsistency. Left emtpy.");
    if (J.size === 0) throw Error("Internal inconsistency. Right emtpy.");
    return { left: $, right: J };
  }
  function l(F, O) {
    if (F.size === 0) throw Error("Internal inconsistency");
    if (F.size === 1) return { type: "leaf", value: Array.from(F.values())[0] };
    let { left: $, right: J } = i(F, O);
    return {
      type: "fork",
      left: a($, O + 1),
      right: a(J, O + 1),
    };
  }
  function a(F, O = 0) {
    if (F.size === 0) throw Error("Internal inconsistency");
    const $ = (0, e.findCommonPrefix)(Array.from(F.keys()), O);
    return { label: $, node: l(F, $.length + O) };
  }
  function c(F, O) {
    let $ = /* @__PURE__ */ new Map();
    for (let J of Array.from(F.keys())) {
      const he = n(J.toString(2), O);
      $.set(he, F.get(J));
    }
    return a($);
  }
  Nr.buildTree = c;
  function v(F, O) {
    O.storeBit(0);
    for (let $ = 0; $ < F.length; $++) O.storeBit(1);
    return O.storeBit(0), F.length > 0 && O.storeUint(BigInt("0b" + F), F.length), O;
  }
  Nr.writeLabelShort = v;
  function g(F) {
    return 1 + F.length + 1 + F.length;
  }
  function b(F, O, $) {
    $.storeBit(1), $.storeBit(0);
    let J = Math.ceil(Math.log2(O + 1));
    return $.storeUint(F.length, J), F.length > 0 && $.storeUint(BigInt("0b" + F), F.length), $;
  }
  Nr.writeLabelLong = b;
  function p(F, O) {
    return 2 + Math.ceil(Math.log2(O + 1)) + F.length;
  }
  function _(F, O, $, J) {
    J.storeBit(1), J.storeBit(1), J.storeBit(F);
    let he = Math.ceil(Math.log2($ + 1));
    J.storeUint(O, he);
  }
  Nr.writeLabelSame = _;
  function M(F) {
    return 3 + Math.ceil(Math.log2(F + 1));
  }
  function S(F) {
    if (F.length === 0 || F.length === 1) return !0;
    for (let O = 1; O < F.length; O++) if (F[O] !== F[0]) return !1;
    return !0;
  }
  function A(F, O) {
    let $ = "short",
      J = g(F),
      he = p(F, O);
    if ((he < J && ((J = he), ($ = "long")), S(F))) {
      let de = M(O);
      de < J && ((J = de), ($ = "same"));
    }
    return $;
  }
  Nr.detectLabelType = A;
  function k(F, O, $) {
    let J = A(F, O);
    J === "short"
      ? v(F, $)
      : J === "long"
      ? b(F, O, $)
      : J === "same" && _(F[0] === "1", F.length, O, $);
  }
  function P(F, O, $, J) {
    if ((F.type === "leaf" && $(F.value, J), F.type === "fork")) {
      const he = (0, t.beginCell)(),
        de = (0, t.beginCell)();
      B(F.left, O - 1, $, he), B(F.right, O - 1, $, de), J.storeRef(he), J.storeRef(de);
    }
  }
  function B(F, O, $, J) {
    k(F.label, O, J), P(F.node, O - F.label.length, $, J);
  }
  function T(F, O, $, J) {
    const he = c(F, O);
    B(he, O, $, J);
  }
  return (Nr.serializeDict = T), Nr;
}
var Ds = {};
Object.defineProperty(Ds, "__esModule", { value: !0 });
Ds.deserializeInternalKey = Ds.serializeInternalKey = void 0;
const q6 = cn,
  hp = oa(),
  bx = vu();
function wx(t) {
  if (typeof t == "number") {
    if (!Number.isSafeInteger(t)) throw Error("Invalid key type: not a safe integer: " + t);
    return "n:" + t.toString(10);
  } else {
    if (typeof t == "bigint") return "b:" + t.toString(10);
    if (q6.Address.isAddress(t)) return "a:" + t.toString();
    if (Qe.isBuffer(t)) return "f:" + t.toString("hex");
    if (hp.BitString.isBitString(t)) return "B:" + t.toString();
    throw Error("Invalid key type");
  }
}
Ds.serializeInternalKey = wx;
function _x(t) {
  let e = t.slice(0, 2),
    n = t.slice(2);
  if (e === "n:") return parseInt(n, 10);
  if (e === "b:") return BigInt(n);
  if (e === "a:") return q6.Address.parse(n);
  if (e === "f:") return Qe.from(n, "hex");
  if (e === "B:") {
    const i = n.slice(-1) == "_";
    if (i || n.length % 2 != 0) {
      let a = i ? n.length - 1 : n.length;
      const c = n.substr(0, a) + "0";
      return !i && a & 1
        ? new hp.BitString(Qe.from(c, "hex"), 0, a << 2)
        : (0, bx.paddedBufferToBits)(Qe.from(c, "hex"));
    } else return new hp.BitString(Qe.from(n, "hex"), 0, n.length << 2);
  }
  throw Error("Invalid key type: " + e);
}
Ds.deserializeInternalKey = _x;
var iv;
function as() {
  if (iv) return yo;
  (iv = 1), Object.defineProperty(yo, "__esModule", { value: !0 }), (yo.Dictionary = void 0);
  const t = cn,
    e = _r(),
    n = os(),
    i = oa(),
    l = h1(),
    a = F6(),
    c = bu,
    v = yx(),
    g = Ds;
  let b = class Oi {
    /**
     * Create an empty map
     * @param key key type
     * @param value value type
     * @returns Dictionary<K, V>
     */
    static empty(f, u) {
      return f && u
        ? new Oi(/* @__PURE__ */ new Map(), f, u)
        : new Oi(/* @__PURE__ */ new Map(), null, null);
    }
    /**
     * Load dictionary from slice
     * @param key key description
     * @param value value description
     * @param src slice
     * @returns Dictionary<K, V>
     */
    static load(f, u, d) {
      let y;
      if (d instanceof n.Cell) {
        if (d.isExotic) return Oi.empty(f, u);
        y = d.beginParse();
      } else y = d;
      let w = y.loadMaybeRef();
      return w && !w.isExotic ? Oi.loadDirect(f, u, w.beginParse()) : Oi.empty(f, u);
    }
    /**
     * Low level method for rare dictionaries from system contracts.
     * Loads dictionary from slice directly without going to the ref.
     *
     * @param key key description
     * @param value value description
     * @param sc slice
     * @returns Dictionary<K, V>
     */
    static loadDirect(f, u, d) {
      if (!d) return Oi.empty(f, u);
      let y;
      d instanceof n.Cell ? (y = d.beginParse()) : (y = d);
      let w = (0, c.parseDict)(y, f.bits, u.parse),
        h = /* @__PURE__ */ new Map();
      for (let [s, m] of w) h.set((0, g.serializeInternalKey)(f.parse(s)), m);
      return new Oi(h, f, u);
    }
    constructor(f, u, d) {
      (this._key = u), (this._value = d), (this._map = f);
    }
    get size() {
      return this._map.size;
    }
    get(f) {
      return this._map.get((0, g.serializeInternalKey)(f));
    }
    has(f) {
      return this._map.has((0, g.serializeInternalKey)(f));
    }
    set(f, u) {
      return this._map.set((0, g.serializeInternalKey)(f), u), this;
    }
    delete(f) {
      const u = (0, g.serializeInternalKey)(f);
      return this._map.delete(u);
    }
    clear() {
      this._map.clear();
    }
    *[Symbol.iterator]() {
      for (const [f, u] of this._map) yield [(0, g.deserializeInternalKey)(f), u];
    }
    keys() {
      return Array.from(this._map.keys()).map((f) => (0, g.deserializeInternalKey)(f));
    }
    values() {
      return Array.from(this._map.values());
    }
    store(f, u, d) {
      if (this._map.size === 0) f.storeBit(0);
      else {
        let y = this._key;
        u != null && (y = u);
        let w = this._value;
        if ((d != null && (w = d), !y)) throw Error("Key serializer is not defined");
        if (!w) throw Error("Value serializer is not defined");
        let h = /* @__PURE__ */ new Map();
        for (const [m, E] of this._map) h.set(y.serialize((0, g.deserializeInternalKey)(m)), E);
        f.storeBit(1);
        let s = (0, e.beginCell)();
        (0, v.serializeDict)(h, y.bits, w.serialize, s), f.storeRef(s.endCell());
      }
    }
    storeDirect(f, u, d) {
      if (this._map.size === 0) throw Error("Cannot store empty dictionary directly");
      let y = this._key;
      u != null && (y = u);
      let w = this._value;
      if ((d != null && (w = d), !y)) throw Error("Key serializer is not defined");
      if (!w) throw Error("Value serializer is not defined");
      let h = /* @__PURE__ */ new Map();
      for (const [s, m] of this._map) h.set(y.serialize((0, g.deserializeInternalKey)(s)), m);
      (0, v.serializeDict)(h, y.bits, w.serialize, f);
    }
    generateMerkleProof(f) {
      return (0, l.generateMerkleProof)(this, f, this._key);
    }
    generateMerkleUpdate(f, u) {
      return (0, a.generateMerkleUpdate)(this, f, this._key, u);
    }
  };
  (yo.Dictionary = b),
    (b.Keys = {
      /**
       * Standard address key
       * @returns DictionaryKey<Address>
       */
      Address: () => p(),
      /**
       * Create standard big integer key
       * @param bits number of bits
       * @returns DictionaryKey<bigint>
       */
      BigInt: (o) => _(o),
      /**
       * Create integer key
       * @param bits bits of integer
       * @returns DictionaryKey<number>
       */
      Int: (o) => M(o),
      /**
       * Create standard unsigned big integer key
       * @param bits number of bits
       * @returns DictionaryKey<bigint>
       */
      BigUint: (o) => S(o),
      /**
       * Create standard unsigned integer key
       * @param bits number of bits
       * @returns DictionaryKey<number>
       */
      Uint: (o) => A(o),
      /**
       * Create standard buffer key
       * @param bytes number of bytes of a buffer
       * @returns DictionaryKey<Buffer>
       */
      Buffer: (o) => k(o),
      /**
       * Create BitString key
       * @param bits key length
       * @returns DictionaryKey<BitString>
       * Point is that Buffer has to be 8 bit aligned,
       * while key is TVM dictionary doesn't have to be
       * aligned at all.
       */
      BitString: (o) => P(o),
    }),
    (b.Values = {
      /**
       * Create standard integer value
       * @returns DictionaryValue<bigint>
       */
      BigInt: (o) => T(o),
      /**
       * Create standard integer value
       * @returns DictionaryValue<number>
       */
      Int: (o) => B(o),
      /**
       * Create big var int
       * @param bits nubmer of header bits
       * @returns DictionaryValue<bigint>
       */
      BigVarInt: (o) => F(o),
      /**
       * Create standard unsigned integer value
       * @param bits number of bits
       * @returns DictionaryValue<bigint>
       */
      BigUint: (o) => J(o),
      /**
       * Create standard unsigned integer value
       * @param bits number of bits
       * @returns DictionaryValue<bigint>
       */
      Uint: (o) => $(o),
      /**
       * Create big var int
       * @param bits nubmer of header bits
       * @returns DictionaryValue<bigint>
       */
      BigVarUint: (o) => O(o),
      /**
       * Create standard boolean value
       * @returns DictionaryValue<boolean>
       */
      Bool: () => he(),
      /**
       * Create standard address value
       * @returns DictionaryValue<Address>
       */
      Address: () => de(),
      /**
       * Create standard cell value
       * @returns DictionaryValue<Cell>
       */
      Cell: () => ne(),
      /**
       * Create Builder value
       * @param bytes number of bytes of a buffer
       * @returns DictionaryValue<Builder>
       */
      Buffer: (o) => x(o),
      /**
       * Create BitString value
       * @param requested bit length
       * @returns DictionaryValue<BitString>
       * Point is that Buffer is not applicable
       * when length is not 8 bit alligned.
       */
      BitString: (o) => r(o),
      /**
       * Create dictionary value
       * @param key
       * @param value
       */
      Dictionary: (o, f) => Ae(o, f),
    });
  function p() {
    return {
      bits: 267,
      serialize: (o) => {
        if (!t.Address.isAddress(o)) throw Error("Key is not an address");
        return (0, e.beginCell)().storeAddress(o).endCell().beginParse().preloadUintBig(267);
      },
      parse: (o) => (0, e.beginCell)().storeUint(o, 267).endCell().beginParse().loadAddress(),
    };
  }
  function _(o) {
    return {
      bits: o,
      serialize: (f) => {
        if (typeof f != "bigint") throw Error("Key is not a bigint");
        return (0, e.beginCell)().storeInt(f, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (f) => (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadIntBig(o),
    };
  }
  function M(o) {
    return {
      bits: o,
      serialize: (f) => {
        if (typeof f != "number") throw Error("Key is not a number");
        if (!Number.isSafeInteger(f)) throw Error("Key is not a safe integer: " + f);
        return (0, e.beginCell)().storeInt(f, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (f) => (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadInt(o),
    };
  }
  function S(o) {
    return {
      bits: o,
      serialize: (f) => {
        if (typeof f != "bigint") throw Error("Key is not a bigint");
        if (f < 0) throw Error("Key is negative: " + f);
        return (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (f) => (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadUintBig(o),
    };
  }
  function A(o) {
    return {
      bits: o,
      serialize: (f) => {
        if (typeof f != "number") throw Error("Key is not a number");
        if (!Number.isSafeInteger(f)) throw Error("Key is not a safe integer: " + f);
        if (f < 0) throw Error("Key is negative: " + f);
        return (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (f) => Number((0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadUint(o)),
    };
  }
  function k(o) {
    return {
      bits: o * 8,
      serialize: (f) => {
        if (!Qe.isBuffer(f)) throw Error("Key is not a buffer");
        return (0, e.beginCell)()
          .storeBuffer(f)
          .endCell()
          .beginParse()
          .loadUintBig(o * 8);
      },
      parse: (f) =>
        (0, e.beginCell)()
          .storeUint(f, o * 8)
          .endCell()
          .beginParse()
          .loadBuffer(o),
    };
  }
  function P(o) {
    return {
      bits: o,
      serialize: (f) => {
        if (!i.BitString.isBitString(f)) throw Error("Key is not a BitString");
        return (0, e.beginCell)().storeBits(f).endCell().beginParse().loadUintBig(o);
      },
      parse: (f) => (0, e.beginCell)().storeUint(f, o).endCell().beginParse().loadBits(o),
    };
  }
  function B(o) {
    return {
      serialize: (f, u) => {
        u.storeInt(f, o);
      },
      parse: (f) => f.loadInt(o),
    };
  }
  function T(o) {
    return {
      serialize: (f, u) => {
        u.storeInt(f, o);
      },
      parse: (f) => f.loadIntBig(o),
    };
  }
  function F(o) {
    return {
      serialize: (f, u) => {
        u.storeVarInt(f, o);
      },
      parse: (f) => f.loadVarIntBig(o),
    };
  }
  function O(o) {
    return {
      serialize: (f, u) => {
        u.storeVarUint(f, o);
      },
      parse: (f) => f.loadVarUintBig(o),
    };
  }
  function $(o) {
    return {
      serialize: (f, u) => {
        u.storeUint(f, o);
      },
      parse: (f) => f.loadUint(o),
    };
  }
  function J(o) {
    return {
      serialize: (f, u) => {
        u.storeUint(f, o);
      },
      parse: (f) => f.loadUintBig(o),
    };
  }
  function he() {
    return {
      serialize: (o, f) => {
        f.storeBit(o);
      },
      parse: (o) => o.loadBit(),
    };
  }
  function de() {
    return {
      serialize: (o, f) => {
        f.storeAddress(o);
      },
      parse: (o) => o.loadAddress(),
    };
  }
  function ne() {
    return {
      serialize: (o, f) => {
        f.storeRef(o);
      },
      parse: (o) => o.loadRef(),
    };
  }
  function Ae(o, f) {
    return {
      serialize: (u, d) => {
        u.store(d);
      },
      parse: (u) => b.load(o, f, u),
    };
  }
  function x(o) {
    return {
      serialize: (f, u) => {
        if (f.length !== o) throw Error("Invalid buffer size");
        u.storeBuffer(f);
      },
      parse: (f) => f.loadBuffer(o),
    };
  }
  function r(o) {
    return {
      serialize: (f, u) => {
        if (f.length !== o) throw Error("Invalid BitString size");
        u.storeBits(f);
      },
      parse: (f) => f.loadBits(o),
    };
  }
  return yo;
}
var fi = {},
  av;
function z6() {
  if (av) return fi;
  (av = 1),
    Object.defineProperty(fi, "__esModule", { value: !0 }),
    (fi.writeString = fi.stringToCell = fi.readString = void 0);
  const t = _r();
  function e(c) {
    if (c.remainingBits % 8 !== 0) throw new Error(`Invalid string length: ${c.remainingBits}`);
    if (c.remainingRefs !== 0 && c.remainingRefs !== 1)
      throw new Error(`invalid number of refs: ${c.remainingRefs}`);
    let v;
    return (
      c.remainingBits === 0 ? (v = Qe.alloc(0)) : (v = c.loadBuffer(c.remainingBits / 8)),
      c.remainingRefs === 1 && (v = Qe.concat([v, e(c.loadRef().beginParse())])),
      v
    );
  }
  function n(c) {
    return e(c).toString();
  }
  fi.readString = n;
  function i(c, v) {
    if (c.length > 0) {
      let g = Math.floor(v.availableBits / 8);
      if (c.length > g) {
        let b = c.subarray(0, g),
          p = c.subarray(g);
        v = v.storeBuffer(b);
        let _ = (0, t.beginCell)();
        i(p, _), (v = v.storeRef(_.endCell()));
      } else v = v.storeBuffer(c);
    }
  }
  function l(c) {
    let v = (0, t.beginCell)();
    return i(Qe.from(c), v), v.endCell();
  }
  fi.stringToCell = l;
  function a(c, v) {
    i(Qe.from(c), v);
  }
  return (fi.writeString = a), fi;
}
var sv;
function d1() {
  if (sv) return go;
  sv = 1;
  var t =
      (mt && mt.__importDefault) ||
      function (v) {
        return v && v.__esModule ? v : { default: v };
      },
    e;
  Object.defineProperty(go, "__esModule", { value: !0 }), (go.Slice = void 0);
  const n = t(Js),
    i = as(),
    l = _r(),
    a = z6();
  let c = class dp {
    constructor(g, b) {
      (this[e] = () => this.toString()),
        (this._reader = g.clone()),
        (this._refs = [...b]),
        (this._refsOffset = 0);
    }
    /**
     * Get remaining bits
     */
    get remainingBits() {
      return this._reader.remaining;
    }
    /**
     * Get offset bits
     */
    get offsetBits() {
      return this._reader.offset;
    }
    /**
     * Get remaining refs
     */
    get remainingRefs() {
      return this._refs.length - this._refsOffset;
    }
    /**
     * Get offset refs
     */
    get offsetRefs() {
      return this._refsOffset;
    }
    /**
     * Skip bits
     * @param bits
     */
    skip(g) {
      return this._reader.skip(g), this;
    }
    /**
     * Load a single bit
     * @returns true or false depending on the bit value
     */
    loadBit() {
      return this._reader.loadBit();
    }
    /**
     * Preload a signle bit
     * @returns true or false depending on the bit value
     */
    preloadBit() {
      return this._reader.preloadBit();
    }
    /**
     * Load a boolean
     * @returns true or false depending on the bit value
     */
    loadBoolean() {
      return this.loadBit();
    }
    /**
     * Load maybe boolean
     * @returns true or false depending on the bit value or null
     */
    loadMaybeBoolean() {
      return this.loadBit() ? this.loadBoolean() : null;
    }
    /**
     * Load bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */
    loadBits(g) {
      return this._reader.loadBits(g);
    }
    /**
     * Preload bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */
    preloadBits(g) {
      return this._reader.preloadBits(g);
    }
    /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */
    loadUint(g) {
      return this._reader.loadUint(g);
    }
    /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */
    loadUintBig(g) {
      return this._reader.loadUintBig(g);
    }
    /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */
    preloadUint(g) {
      return this._reader.preloadUint(g);
    }
    /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */
    preloadUintBig(g) {
      return this._reader.preloadUintBig(g);
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeUint(g) {
      return this.loadBit() ? this.loadUint(g) : null;
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeUintBig(g) {
      return this.loadBit() ? this.loadUintBig(g) : null;
    }
    /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */
    loadInt(g) {
      return this._reader.loadInt(g);
    }
    /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */
    loadIntBig(g) {
      return this._reader.loadIntBig(g);
    }
    /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */
    preloadInt(g) {
      return this._reader.preloadInt(g);
    }
    /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */
    preloadIntBig(g) {
      return this._reader.preloadIntBig(g);
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeInt(g) {
      return this.loadBit() ? this.loadInt(g) : null;
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeIntBig(g) {
      return this.loadBit() ? this.loadIntBig(g) : null;
    }
    /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    loadVarUint(g) {
      return this._reader.loadVarUint(g);
    }
    /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    loadVarUintBig(g) {
      return this._reader.loadVarUintBig(g);
    }
    /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    preloadVarUint(g) {
      return this._reader.preloadVarUint(g);
    }
    /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    preloadVarUintBig(g) {
      return this._reader.preloadVarUintBig(g);
    }
    /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    loadVarInt(g) {
      return this._reader.loadVarInt(g);
    }
    /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    loadVarIntBig(g) {
      return this._reader.loadVarIntBig(g);
    }
    /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    preloadVarInt(g) {
      return this._reader.preloadVarInt(g);
    }
    /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    preloadVarIntBig(g) {
      return this._reader.preloadVarIntBig(g);
    }
    /**
     * Load coins
     * @returns coins value
     */
    loadCoins() {
      return this._reader.loadCoins();
    }
    /**
     * Preload coins
     * @returns coins value
     */
    preloadCoins() {
      return this._reader.preloadCoins();
    }
    /**
     * Load maybe coins
     * @returns coins value or null
     */
    loadMaybeCoins() {
      return this._reader.loadBit() ? this._reader.loadCoins() : null;
    }
    /**
     * Load internal Address
     * @returns Address
     */
    loadAddress() {
      return this._reader.loadAddress();
    }
    /**
     * Load optional internal Address
     * @returns Address or null
     */
    loadMaybeAddress() {
      return this._reader.loadMaybeAddress();
    }
    /**
     * Load external address
     * @returns ExternalAddress
     */
    loadExternalAddress() {
      return this._reader.loadExternalAddress();
    }
    /**
     * Load optional external address
     * @returns ExternalAddress or null
     */
    loadMaybeExternalAddress() {
      return this._reader.loadMaybeExternalAddress();
    }
    /**
     * Load address
     * @returns Address, ExternalAddress or null
     */
    loadAddressAny() {
      return this._reader.loadAddressAny();
    }
    /**
     * Load reference
     * @returns Cell
     */
    loadRef() {
      if (this._refsOffset >= this._refs.length) throw new Error("No more references");
      return this._refs[this._refsOffset++];
    }
    /**
     * Preload reference
     * @returns Cell
     */
    preloadRef() {
      if (this._refsOffset >= this._refs.length) throw new Error("No more references");
      return this._refs[this._refsOffset];
    }
    /**
     * Load optional reference
     * @returns Cell or null
     */
    loadMaybeRef() {
      return this.loadBit() ? this.loadRef() : null;
    }
    /**
     * Preload optional reference
     * @returns Cell or null
     */
    preloadMaybeRef() {
      return this.preloadBit() ? this.preloadRef() : null;
    }
    /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */
    loadBuffer(g) {
      return this._reader.loadBuffer(g);
    }
    /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */
    preloadBuffer(g) {
      return this._reader.preloadBuffer(g);
    }
    /**
     * Load string tail
     */
    loadStringTail() {
      return (0, a.readString)(this);
    }
    /**
     * Load maybe string tail
     * @returns string or null
     */
    loadMaybeStringTail() {
      return this.loadBit() ? (0, a.readString)(this) : null;
    }
    /**
     * Load string tail from ref
     * @returns string
     */
    loadStringRefTail() {
      return (0, a.readString)(this.loadRef().beginParse());
    }
    /**
     * Load maybe string tail from ref
     * @returns string or null
     */
    loadMaybeStringRefTail() {
      const g = this.loadMaybeRef();
      return g ? (0, a.readString)(g.beginParse()) : null;
    }
    /**
     * Loads dictionary
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */
    loadDict(g, b) {
      return i.Dictionary.load(g, b, this);
    }
    /**
     * Loads dictionary directly from current slice
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */
    loadDictDirect(g, b) {
      return i.Dictionary.loadDirect(g, b, this);
    }
    /**
     * Checks if slice is empty
     */
    endParse() {
      if (this.remainingBits > 0 || this.remainingRefs > 0) throw new Error("Slice is not empty");
    }
    /**
     * Convert slice to cell
     */
    asCell() {
      return (0, l.beginCell)().storeSlice(this).endCell();
    }
    /**
     *
     * @returns
     */
    asBuilder() {
      return (0, l.beginCell)().storeSlice(this);
    }
    /**
     * Clone slice
     * @returns cloned slice
     */
    clone(g = !1) {
      if (g) {
        let b = this._reader.clone();
        return b.reset(), new dp(b, this._refs);
      } else {
        let b = new dp(this._reader, this._refs);
        return (b._refsOffset = this._refsOffset), b;
      }
    }
    /**
     * Print slice as string by converting it to cell
     * @returns string
     */
    toString() {
      return this.asCell().toString();
    }
  };
  return (go.Slice = c), (e = n.default), go;
}
var _u = {},
  On = {};
Object.defineProperty(On, "__esModule", { value: !0 });
On.BitReader = void 0;
const xx = cn,
  Mx = Xs;
class p1 {
  constructor(e, n = 0) {
    (this._checkpoints = []), (this._bits = e), (this._offset = n);
  }
  /**
   * Offset in source bit string
   */
  get offset() {
    return this._offset;
  }
  /**
   * Number of bits remaining
   */
  get remaining() {
    return this._bits.length - this._offset;
  }
  /**
   * Skip bits
   * @param bits number of bits to skip
   */
  skip(e) {
    if (e < 0 || this._offset + e > this._bits.length)
      throw new Error(`Index ${this._offset + e} is out of bounds`);
    this._offset += e;
  }
  /**
   * Reset to the beginning or latest checkpoint
   */
  reset() {
    this._checkpoints.length > 0 ? (this._offset = this._checkpoints.pop()) : (this._offset = 0);
  }
  /**
   * Save checkpoint
   */
  save() {
    this._checkpoints.push(this._offset);
  }
  /**
   * Load a single bit
   * @returns true if the bit is set, false otherwise
   */
  loadBit() {
    let e = this._bits.at(this._offset);
    return this._offset++, e;
  }
  /**
   * Preload bit
   * @returns true if the bit is set, false otherwise
   */
  preloadBit() {
    return this._bits.at(this._offset);
  }
  /**
   * Load bit string
   * @param bits number of bits to read
   * @returns new bitstring
   */
  loadBits(e) {
    let n = this._bits.substring(this._offset, e);
    return (this._offset += e), n;
  }
  /**
   * Preload bit string
   * @param bits number of bits to read
   * @returns new bitstring
   */
  preloadBits(e) {
    return this._bits.substring(this._offset, e);
  }
  /**
   * Load buffer
   * @param bytes number of bytes
   * @returns new buffer
   */
  loadBuffer(e) {
    let n = this._preloadBuffer(e, this._offset);
    return (this._offset += e * 8), n;
  }
  /**
   * Preload buffer
   * @param bytes number of bytes
   * @returns new buffer
   */
  preloadBuffer(e) {
    return this._preloadBuffer(e, this._offset);
  }
  /**
   * Load uint value
   * @param bits uint bits
   * @returns read value as number
   */
  loadUint(e) {
    return Number(this.loadUintBig(e));
  }
  /**
   * Load uint value as bigint
   * @param bits uint bits
   * @returns read value as bigint
   */
  loadUintBig(e) {
    let n = this.preloadUintBig(e);
    return (this._offset += e), n;
  }
  /**
   * Preload uint value
   * @param bits uint bits
   * @returns read value as number
   */
  preloadUint(e) {
    return Number(this._preloadUint(e, this._offset));
  }
  /**
   * Preload uint value as bigint
   * @param bits uint bits
   * @returns read value as bigint
   */
  preloadUintBig(e) {
    return this._preloadUint(e, this._offset);
  }
  /**
   * Load int value
   * @param bits int bits
   * @returns read value as bigint
   */
  loadInt(e) {
    let n = this._preloadInt(e, this._offset);
    return (this._offset += e), Number(n);
  }
  /**
   * Load int value as bigint
   * @param bits int bits
   * @returns read value as bigint
   */
  loadIntBig(e) {
    let n = this._preloadInt(e, this._offset);
    return (this._offset += e), n;
  }
  /**
   * Preload int value
   * @param bits int bits
   * @returns read value as bigint
   */
  preloadInt(e) {
    return Number(this._preloadInt(e, this._offset));
  }
  /**
   * Preload int value
   * @param bits int bits
   * @returns read value as bigint
   */
  preloadIntBig(e) {
    return this._preloadInt(e, this._offset);
  }
  /**
   * Load varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarUint(e) {
    let n = Number(this.loadUint(e));
    return Number(this.loadUintBig(n * 8));
  }
  /**
   * Load varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarUintBig(e) {
    let n = Number(this.loadUint(e));
    return this.loadUintBig(n * 8);
  }
  /**
   * Preload varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarUint(e) {
    let n = Number(this._preloadUint(e, this._offset));
    return Number(this._preloadUint(n * 8, this._offset + e));
  }
  /**
   * Preload varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarUintBig(e) {
    let n = Number(this._preloadUint(e, this._offset));
    return this._preloadUint(n * 8, this._offset + e);
  }
  /**
   * Load varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarInt(e) {
    let n = Number(this.loadUint(e));
    return Number(this.loadIntBig(n * 8));
  }
  /**
   * Load varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarIntBig(e) {
    let n = Number(this.loadUint(e));
    return this.loadIntBig(n * 8);
  }
  /**
   * Preload varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarInt(e) {
    let n = Number(this._preloadUint(e, this._offset));
    return Number(this._preloadInt(n * 8, this._offset + e));
  }
  /**
   * Preload varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarIntBig(e) {
    let n = Number(this._preloadUint(e, this._offset));
    return this._preloadInt(n * 8, this._offset + e);
  }
  /**
   * Load coins value
   * @returns read value as bigint
   */
  loadCoins() {
    return this.loadVarUintBig(4);
  }
  /**
   * Preload coins value
   * @returns read value as bigint
   */
  preloadCoins() {
    return this.preloadVarUintBig(4);
  }
  /**
   * Load Address
   * @returns Address
   */
  loadAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 2) return this._loadInternalAddress();
    throw new Error("Invalid address: " + e);
  }
  /**
   * Load internal address
   * @returns Address or null
   */
  loadMaybeAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0) return (this._offset += 2), null;
    if (e === 2) return this._loadInternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Load external address
   * @returns ExternalAddress
   */
  loadExternalAddress() {
    if (Number(this._preloadUint(2, this._offset)) === 1) return this._loadExternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Load external address
   * @returns ExternalAddress or null
   */
  loadMaybeExternalAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0) return (this._offset += 2), null;
    if (e === 1) return this._loadExternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Read address of any type
   * @returns Address or ExternalAddress or null
   */
  loadAddressAny() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0) return (this._offset += 2), null;
    if (e === 2) return this._loadInternalAddress();
    if (e === 1) return this._loadExternalAddress();
    throw Error(e === 3 ? "Unsupported" : "Unreachable");
  }
  /**
   * Load bit string that was padded to make it byte alligned. Used in BOC serialization
   * @param bytes number of bytes to read
   */
  loadPaddedBits(e) {
    if (e % 8 !== 0) throw new Error("Invalid number of bits");
    let n = e;
    for (;;)
      if (this._bits.at(this._offset + n - 1)) {
        n--;
        break;
      } else n--;
    let i = this._bits.substring(this._offset, n);
    return (this._offset += e), i;
  }
  /**
   * Clone BitReader
   */
  clone() {
    return new p1(this._bits, this._offset);
  }
  /**
   * Preload int from specific offset
   * @param bits bits to preload
   * @param offset offset to start from
   * @returns read value as bigint
   */
  _preloadInt(e, n) {
    if (e == 0) return 0n;
    let i = this._bits.at(n),
      l = 0n;
    for (let a = 0; a < e - 1; a++) this._bits.at(n + 1 + a) && (l += 1n << BigInt(e - a - 1 - 1));
    return i && (l = l - (1n << BigInt(e - 1))), l;
  }
  /**
   * Preload uint from specific offset
   * @param bits bits to preload
   * @param offset offset to start from
   * @returns read value as bigint
   */
  _preloadUint(e, n) {
    if (e == 0) return 0n;
    let i = 0n;
    for (let l = 0; l < e; l++) this._bits.at(n + l) && (i += 1n << BigInt(e - l - 1));
    return i;
  }
  _preloadBuffer(e, n) {
    let i = this._bits.subbuffer(n, e * 8);
    if (i) return i;
    let l = Qe.alloc(e);
    for (let a = 0; a < e; a++) l[a] = Number(this._preloadUint(8, n + a * 8));
    return l;
  }
  _loadInternalAddress() {
    if (
      Number(this._preloadUint(2, this._offset)) !== 2 ||
      this._preloadUint(1, this._offset + 2) !== 0n
    )
      throw Error("Invalid address");
    let n = Number(this._preloadInt(8, this._offset + 3)),
      i = this._preloadBuffer(32, this._offset + 11);
    return (this._offset += 267), new xx.Address(n, i);
  }
  _loadExternalAddress() {
    if (Number(this._preloadUint(2, this._offset)) !== 1) throw Error("Invalid address");
    let n = Number(this._preloadUint(9, this._offset + 2)),
      i = this._preloadUint(n, this._offset + 11);
    return (this._offset += 11 + n), new Mx.ExternalAddress(i, n);
  }
}
On.BitReader = p1;
var xf = {};
Object.defineProperty(xf, "__esModule", { value: !0 });
xf.exoticLibrary = void 0;
const Sx = On;
function Ex(t, e) {
  const n = new Sx.BitReader(t);
  if (t.length !== 264)
    throw new Error(`Library cell must have exactly (8 + 256) bits, got "${t.length}"`);
  let l = n.loadUint(8);
  if (l !== 2) throw new Error(`Library cell must have type 2, got "${l}"`);
  return {};
}
xf.exoticLibrary = Ex;
var to = {};
Object.defineProperty(to, "__esModule", { value: !0 });
to.exoticMerkleProof = void 0;
const Ax = On;
function kx(t, e) {
  const n = new Ax.BitReader(t);
  if (t.length !== 280)
    throw new Error(`Merkle Proof cell must have exactly (8 + 256 + 16) bits, got "${t.length}"`);
  if (e.length !== 1)
    throw new Error(`Merkle Proof cell must have exactly 1 ref, got "${e.length}"`);
  let l = n.loadUint(8);
  if (l !== 3) throw new Error(`Merkle Proof cell must have type 3, got "${l}"`);
  const a = n.loadBuffer(32),
    c = n.loadUint(16),
    v = e[0].hash(0),
    g = e[0].depth(0);
  if (c !== g) throw new Error(`Merkle Proof cell ref depth must be exactly "${c}", got "${g}"`);
  if (!a.equals(v))
    throw new Error(
      `Merkle Proof cell ref hash must be exactly "${a.toString("hex")}", got "${v.toString(
        "hex"
      )}"`
    );
  return {
    proofDepth: c,
    proofHash: a,
  };
}
to.exoticMerkleProof = kx;
var ro = {};
Object.defineProperty(ro, "__esModule", { value: !0 });
ro.exoticMerkleUpdate = void 0;
const Bx = On;
function Cx(t, e) {
  const n = new Bx.BitReader(t),
    i = 8 + 2 * 272;
  if (t.length !== i)
    throw new Error(
      `Merkle Update cell must have exactly (8 + (2 * (256 + 16))) bits, got "${t.length}"`
    );
  if (e.length !== 2)
    throw new Error(`Merkle Update cell must have exactly 2 refs, got "${e.length}"`);
  let l = n.loadUint(8);
  if (l !== 4) throw new Error(`Merkle Update cell type must be exactly 4, got "${l}"`);
  const a = n.loadBuffer(32),
    c = n.loadBuffer(32),
    v = n.loadUint(16),
    g = n.loadUint(16);
  if (v !== e[0].depth(0))
    throw new Error(`Merkle Update cell ref depth must be exactly "${v}", got "${e[0].depth(0)}"`);
  if (!a.equals(e[0].hash(0)))
    throw new Error(
      `Merkle Update cell ref hash must be exactly "${a.toString("hex")}", got "${e[0]
        .hash(0)
        .toString("hex")}"`
    );
  if (g !== e[1].depth(0))
    throw new Error(`Merkle Update cell ref depth must be exactly "${g}", got "${e[1].depth(0)}"`);
  if (!c.equals(e[1].hash(0)))
    throw new Error(
      `Merkle Update cell ref hash must be exactly "${c.toString("hex")}", got "${e[1]
        .hash(0)
        .toString("hex")}"`
    );
  return {
    proofDepth1: v,
    proofDepth2: g,
    proofHash1: a,
    proofHash2: c,
  };
}
ro.exoticMerkleUpdate = Cx;
var no = {},
  io = {};
Object.defineProperty(io, "__esModule", { value: !0 });
io.LevelMask = void 0;
class m1 {
  constructor(e = 0) {
    (this._mask = 0),
      (this._mask = e),
      (this._hashIndex = Tx(this._mask)),
      (this._hashCount = this._hashIndex + 1);
  }
  get value() {
    return this._mask;
  }
  get level() {
    return 32 - Math.clz32(this._mask);
  }
  get hashIndex() {
    return this._hashIndex;
  }
  get hashCount() {
    return this._hashCount;
  }
  apply(e) {
    return new m1(this._mask & ((1 << e) - 1));
  }
  isSignificant(e) {
    return e === 0 || (this._mask >> (e - 1)) % 2 !== 0;
  }
}
io.LevelMask = m1;
function Tx(t) {
  return (
    (t = t - ((t >> 1) & 1431655765)),
    (t = (t & 858993459) + ((t >> 2) & 858993459)),
    (((t + (t >> 4)) & 252645135) * 16843009) >> 24
  );
}
Object.defineProperty(no, "__esModule", { value: !0 });
no.exoticPruned = void 0;
const Px = On,
  ov = io;
function Rx(t, e) {
  let n = new Px.BitReader(t),
    i = n.loadUint(8);
  if (i !== 1) throw new Error(`Pruned branch cell must have type 1, got "${i}"`);
  if (e.length !== 0) throw new Error(`Pruned Branch cell can't has refs, got "${e.length}"`);
  let l;
  if (t.length === 280) l = new ov.LevelMask(1);
  else {
    if (((l = new ov.LevelMask(n.loadUint(8))), l.level < 1 || l.level > 3))
      throw new Error(
        `Pruned Branch cell level must be >= 1 and <= 3, got "${l.level}/${l.value}"`
      );
    const g = 16 + l.apply(l.level - 1).hashCount * 272;
    if (t.length !== g)
      throw new Error(`Pruned branch cell must have exactly ${g} bits, got "${t.length}"`);
  }
  let a = [],
    c = [],
    v = [];
  for (let g = 0; g < l.level; g++) c.push(n.loadBuffer(32));
  for (let g = 0; g < l.level; g++) v.push(n.loadUint(16));
  for (let g = 0; g < l.level; g++)
    a.push({
      depth: v[g],
      hash: c[g],
    });
  return {
    mask: l.value,
    pruned: a,
  };
}
no.exoticPruned = Rx;
Object.defineProperty(_u, "__esModule", { value: !0 });
_u.resolveExotic = void 0;
const Ix = On,
  xu = eo,
  Ox = xf,
  Ux = to,
  Nx = ro,
  Dx = no,
  Mu = io;
function Lx(t, e) {
  let n = (0, Dx.exoticPruned)(t, e),
    i = [],
    l = [],
    a = new Mu.LevelMask(n.mask);
  for (let c = 0; c < n.pruned.length; c++) i.push(n.pruned[c].depth), l.push(n.pruned[c].hash);
  return {
    type: xu.CellType.PrunedBranch,
    depths: i,
    hashes: l,
    mask: a,
  };
}
function Fx(t, e) {
  (0, Ox.exoticLibrary)(t, e);
  let n = [],
    i = [],
    l = new Mu.LevelMask();
  return {
    type: xu.CellType.Library,
    depths: n,
    hashes: i,
    mask: l,
  };
}
function qx(t, e) {
  (0, Ux.exoticMerkleProof)(t, e);
  let n = [],
    i = [],
    l = new Mu.LevelMask(e[0].level() >> 1);
  return {
    type: xu.CellType.MerkleProof,
    depths: n,
    hashes: i,
    mask: l,
  };
}
function zx(t, e) {
  (0, Nx.exoticMerkleUpdate)(t, e);
  let n = [],
    i = [],
    l = new Mu.LevelMask((e[0].level() | e[1].level()) >> 1);
  return {
    type: xu.CellType.MerkleUpdate,
    depths: n,
    hashes: i,
    mask: l,
  };
}
function jx(t, e) {
  let i = new Ix.BitReader(t).preloadUint(8);
  if (i === 1) return Lx(t, e);
  if (i === 2) return Fx(t, e);
  if (i === 3) return qx(t, e);
  if (i === 4) return zx(t, e);
  throw Error("Invalid exotic cell type: " + i);
}
_u.resolveExotic = jx;
var Su = {},
  wi = {};
Object.defineProperty(wi, "__esModule", { value: !0 });
wi.getRepr = wi.getBitsDescriptor = wi.getRefsDescriptor = void 0;
const Do = eo,
  $x = vu();
function j6(t, e, n) {
  return t.length + (n !== Do.CellType.Ordinary ? 1 : 0) * 8 + e * 32;
}
wi.getRefsDescriptor = j6;
function $6(t) {
  let e = t.length;
  return Math.ceil(e / 8) + Math.floor(e / 8);
}
wi.getBitsDescriptor = $6;
function Hx(t, e, n, i, l, a) {
  const c = Math.ceil(e.length / 8),
    v = Qe.alloc(2 + c + 34 * n.length);
  let g = 0;
  (v[g++] = j6(n, l, a)), (v[g++] = $6(t)), (0, $x.bitsToPaddedBuffer)(e).copy(v, g), (g += c);
  for (const b of n) {
    let p;
    a == Do.CellType.MerkleProof || a == Do.CellType.MerkleUpdate
      ? (p = b.depth(i + 1))
      : (p = b.depth(i)),
      (v[g++] = Math.floor(p / 256)),
      (v[g++] = p % 256);
  }
  for (const b of n) {
    let p;
    a == Do.CellType.MerkleProof || a == Do.CellType.MerkleUpdate
      ? (p = b.hash(i + 1))
      : (p = b.hash(i)),
      p.copy(v, g),
      (g += 32);
  }
  return v;
}
wi.getRepr = Hx;
var Nc = {},
  Zi = {},
  H6 = { exports: {} };
(function (t, e) {
  (function (n, i) {
    t.exports = i();
  })(mt, function () {
    var n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    function i(se, oe, X, le) {
      var ke,
        I,
        C,
        L = oe || [0],
        j = (X = X || 0) >>> 3,
        ee = le === -1 ? 3 : 0;
      for (ke = 0; ke < se.length; ke += 1)
        (I = (C = ke + j) >>> 2),
          L.length <= I && L.push(0),
          (L[I] |= se[ke] << (8 * (ee + le * (C % 4))));
      return { value: L, binLen: 8 * se.length + X };
    }
    function l(se, oe, X) {
      switch (oe) {
        case "UTF8":
        case "UTF16BE":
        case "UTF16LE":
          break;
        default:
          throw new Error("encoding must be UTF8, UTF16BE, or UTF16LE");
      }
      switch (se) {
        case "HEX":
          return function (le, ke, I) {
            return (function (C, L, j, ee) {
              var Me, fe, Se, ot;
              if (C.length % 2 != 0)
                throw new Error("String of HEX type must be in byte increments");
              var we = L || [0],
                Re = (j = j || 0) >>> 3,
                at = ee === -1 ? 3 : 0;
              for (Me = 0; Me < C.length; Me += 2) {
                if (((fe = parseInt(C.substr(Me, 2), 16)), isNaN(fe)))
                  throw new Error("String of HEX type contains invalid characters");
                for (Se = (ot = (Me >>> 1) + Re) >>> 2; we.length <= Se; ) we.push(0);
                we[Se] |= fe << (8 * (at + ee * (ot % 4)));
              }
              return { value: we, binLen: 4 * C.length + j };
            })(le, ke, I, X);
          };
        case "TEXT":
          return function (le, ke, I) {
            return (function (C, L, j, ee, Me) {
              var fe,
                Se,
                ot,
                we,
                Re,
                at,
                Ne,
                He,
                At = 0,
                Le = j || [0],
                Ze = (ee = ee || 0) >>> 3;
              if (L === "UTF8")
                for (Ne = Me === -1 ? 3 : 0, ot = 0; ot < C.length; ot += 1)
                  for (
                    Se = [],
                      128 > (fe = C.charCodeAt(ot))
                        ? Se.push(fe)
                        : 2048 > fe
                        ? (Se.push(192 | (fe >>> 6)), Se.push(128 | (63 & fe)))
                        : 55296 > fe || 57344 <= fe
                        ? Se.push(224 | (fe >>> 12), 128 | ((fe >>> 6) & 63), 128 | (63 & fe))
                        : ((ot += 1),
                          (fe = 65536 + (((1023 & fe) << 10) | (1023 & C.charCodeAt(ot)))),
                          Se.push(
                            240 | (fe >>> 18),
                            128 | ((fe >>> 12) & 63),
                            128 | ((fe >>> 6) & 63),
                            128 | (63 & fe)
                          )),
                      we = 0;
                    we < Se.length;
                    we += 1
                  ) {
                    for (Re = (at = At + Ze) >>> 2; Le.length <= Re; ) Le.push(0);
                    (Le[Re] |= Se[we] << (8 * (Ne + Me * (at % 4)))), (At += 1);
                  }
              else
                for (
                  Ne = Me === -1 ? 2 : 0,
                    He = (L === "UTF16LE" && Me !== 1) || (L !== "UTF16LE" && Me === 1),
                    ot = 0;
                  ot < C.length;
                  ot += 1
                ) {
                  for (
                    fe = C.charCodeAt(ot),
                      He === !0 && (fe = ((we = 255 & fe) << 8) | (fe >>> 8)),
                      Re = (at = At + Ze) >>> 2;
                    Le.length <= Re;

                  )
                    Le.push(0);
                  (Le[Re] |= fe << (8 * (Ne + Me * (at % 4)))), (At += 2);
                }
              return { value: Le, binLen: 8 * At + ee };
            })(le, oe, ke, I, X);
          };
        case "B64":
          return function (le, ke, I) {
            return (function (C, L, j, ee) {
              var Me,
                fe,
                Se,
                ot,
                we,
                Re,
                at = 0,
                Ne = L || [0],
                He = (j = j || 0) >>> 3,
                At = ee === -1 ? 3 : 0,
                Le = C.indexOf("=");
              if (C.search(/^[a-zA-Z0-9=+/]+$/) === -1)
                throw new Error("Invalid character in base-64 string");
              if (((C = C.replace(/=/g, "")), Le !== -1 && Le < C.length))
                throw new Error("Invalid '=' found in base-64 string");
              for (Me = 0; Me < C.length; Me += 4) {
                for (ot = C.substr(Me, 4), Se = 0, fe = 0; fe < ot.length; fe += 1)
                  Se |= n.indexOf(ot.charAt(fe)) << (18 - 6 * fe);
                for (fe = 0; fe < ot.length - 1; fe += 1) {
                  for (we = (Re = at + He) >>> 2; Ne.length <= we; ) Ne.push(0);
                  (Ne[we] |= ((Se >>> (16 - 8 * fe)) & 255) << (8 * (At + ee * (Re % 4)))),
                    (at += 1);
                }
              }
              return { value: Ne, binLen: 8 * at + j };
            })(le, ke, I, X);
          };
        case "BYTES":
          return function (le, ke, I) {
            return (function (C, L, j, ee) {
              var Me,
                fe,
                Se,
                ot,
                we = L || [0],
                Re = (j = j || 0) >>> 3,
                at = ee === -1 ? 3 : 0;
              for (fe = 0; fe < C.length; fe += 1)
                (Me = C.charCodeAt(fe)),
                  (Se = (ot = fe + Re) >>> 2),
                  we.length <= Se && we.push(0),
                  (we[Se] |= Me << (8 * (at + ee * (ot % 4))));
              return { value: we, binLen: 8 * C.length + j };
            })(le, ke, I, X);
          };
        case "ARRAYBUFFER":
          try {
            new ArrayBuffer(0);
          } catch {
            throw new Error("ARRAYBUFFER not supported by this environment");
          }
          return function (le, ke, I) {
            return (function (C, L, j, ee) {
              return i(new Uint8Array(C), L, j, ee);
            })(le, ke, I, X);
          };
        case "UINT8ARRAY":
          try {
            new Uint8Array(0);
          } catch {
            throw new Error("UINT8ARRAY not supported by this environment");
          }
          return function (le, ke, I) {
            return i(le, ke, I, X);
          };
        default:
          throw new Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
      }
    }
    function a(se, oe, X, le) {
      switch (se) {
        case "HEX":
          return function (ke) {
            return (function (I, C, L, j) {
              var ee,
                Me,
                fe = "",
                Se = C / 8,
                ot = L === -1 ? 3 : 0;
              for (ee = 0; ee < Se; ee += 1)
                (Me = I[ee >>> 2] >>> (8 * (ot + L * (ee % 4)))),
                  (fe +=
                    "0123456789abcdef".charAt((Me >>> 4) & 15) +
                    "0123456789abcdef".charAt(15 & Me));
              return j.outputUpper ? fe.toUpperCase() : fe;
            })(ke, oe, X, le);
          };
        case "B64":
          return function (ke) {
            return (function (I, C, L, j) {
              var ee,
                Me,
                fe,
                Se,
                ot,
                we = "",
                Re = C / 8,
                at = L === -1 ? 3 : 0;
              for (ee = 0; ee < Re; ee += 3)
                for (
                  Se = ee + 1 < Re ? I[(ee + 1) >>> 2] : 0,
                    ot = ee + 2 < Re ? I[(ee + 2) >>> 2] : 0,
                    fe =
                      (((I[ee >>> 2] >>> (8 * (at + L * (ee % 4)))) & 255) << 16) |
                      (((Se >>> (8 * (at + L * ((ee + 1) % 4)))) & 255) << 8) |
                      ((ot >>> (8 * (at + L * ((ee + 2) % 4)))) & 255),
                    Me = 0;
                  Me < 4;
                  Me += 1
                )
                  we += 8 * ee + 6 * Me <= C ? n.charAt((fe >>> (6 * (3 - Me))) & 63) : j.b64Pad;
              return we;
            })(ke, oe, X, le);
          };
        case "BYTES":
          return function (ke) {
            return (function (I, C, L) {
              var j,
                ee,
                Me = "",
                fe = C / 8,
                Se = L === -1 ? 3 : 0;
              for (j = 0; j < fe; j += 1)
                (ee = (I[j >>> 2] >>> (8 * (Se + L * (j % 4)))) & 255),
                  (Me += String.fromCharCode(ee));
              return Me;
            })(ke, oe, X);
          };
        case "ARRAYBUFFER":
          try {
            new ArrayBuffer(0);
          } catch {
            throw new Error("ARRAYBUFFER not supported by this environment");
          }
          return function (ke) {
            return (function (I, C, L) {
              var j,
                ee = C / 8,
                Me = new ArrayBuffer(ee),
                fe = new Uint8Array(Me),
                Se = L === -1 ? 3 : 0;
              for (j = 0; j < ee; j += 1) fe[j] = (I[j >>> 2] >>> (8 * (Se + L * (j % 4)))) & 255;
              return Me;
            })(ke, oe, X);
          };
        case "UINT8ARRAY":
          try {
            new Uint8Array(0);
          } catch {
            throw new Error("UINT8ARRAY not supported by this environment");
          }
          return function (ke) {
            return (function (I, C, L) {
              var j,
                ee = C / 8,
                Me = L === -1 ? 3 : 0,
                fe = new Uint8Array(ee);
              for (j = 0; j < ee; j += 1) fe[j] = (I[j >>> 2] >>> (8 * (Me + L * (j % 4)))) & 255;
              return fe;
            })(ke, oe, X);
          };
        default:
          throw new Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
      }
    }
    var c = [
        1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748,
        2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206,
        2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122,
        1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891,
        3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700,
        1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771,
        3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877,
        958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452,
        2361852424, 2428436474, 2756734187, 3204031479, 3329325298,
      ],
      v = [
        3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839,
        3204075428,
      ],
      g = [
        1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635,
        1541459225,
      ],
      b = "Chosen SHA variant is not supported";
    function p(se, oe) {
      var X,
        le,
        ke = se.binLen >>> 3,
        I = oe.binLen >>> 3,
        C = ke << 3,
        L = (4 - ke) << 3;
      if (ke % 4 != 0) {
        for (X = 0; X < I; X += 4)
          (le = (ke + X) >>> 2),
            (se.value[le] |= oe.value[X >>> 2] << C),
            se.value.push(0),
            (se.value[le + 1] |= oe.value[X >>> 2] >>> L);
        return (
          (se.value.length << 2) - 4 >= I + ke && se.value.pop(),
          { value: se.value, binLen: se.binLen + oe.binLen }
        );
      }
      return { value: se.value.concat(oe.value), binLen: se.binLen + oe.binLen };
    }
    function _(se) {
      var oe = { outputUpper: !1, b64Pad: "=", outputLen: -1 },
        X = se || {},
        le = "Output length must be a multiple of 8";
      if (
        ((oe.outputUpper = X.outputUpper || !1), X.b64Pad && (oe.b64Pad = X.b64Pad), X.outputLen)
      ) {
        if (X.outputLen % 8 != 0) throw new Error(le);
        oe.outputLen = X.outputLen;
      } else if (X.shakeLen) {
        if (X.shakeLen % 8 != 0) throw new Error(le);
        oe.outputLen = X.shakeLen;
      }
      if (typeof oe.outputUpper != "boolean")
        throw new Error("Invalid outputUpper formatting option");
      if (typeof oe.b64Pad != "string") throw new Error("Invalid b64Pad formatting option");
      return oe;
    }
    function M(se, oe, X, le) {
      var ke = se + " must include a value and format";
      if (!oe) {
        if (!le) throw new Error(ke);
        return le;
      }
      if (oe.value === void 0 || !oe.format) throw new Error(ke);
      return l(oe.format, oe.encoding || "UTF8", X)(oe.value);
    }
    var S = (function () {
        function se(oe, X, le) {
          var ke = le || {};
          if (
            ((this.t = X),
            (this.i = ke.encoding || "UTF8"),
            (this.numRounds = ke.numRounds || 1),
            isNaN(this.numRounds) ||
              this.numRounds !== parseInt(this.numRounds, 10) ||
              1 > this.numRounds)
          )
            throw new Error("numRounds must a integer >= 1");
          (this.o = oe),
            (this.u = []),
            (this.s = 0),
            (this.h = !1),
            (this.v = 0),
            (this.A = !1),
            (this.l = []),
            (this.H = []);
        }
        return (
          (se.prototype.update = function (oe) {
            var X,
              le = 0,
              ke = this.S >>> 5,
              I = this.p(oe, this.u, this.s),
              C = I.binLen,
              L = I.value,
              j = C >>> 5;
            for (X = 0; X < j; X += ke)
              le + this.S <= C && ((this.m = this.R(L.slice(X, X + ke), this.m)), (le += this.S));
            (this.v += le), (this.u = L.slice(le >>> 5)), (this.s = C % this.S), (this.h = !0);
          }),
          (se.prototype.getHash = function (oe, X) {
            var le,
              ke,
              I = this.U,
              C = _(X);
            if (this.T) {
              if (C.outputLen === -1) throw new Error("Output length must be specified in options");
              I = C.outputLen;
            }
            var L = a(oe, I, this.C, C);
            if (this.A && this.F) return L(this.F(C));
            for (
              ke = this.K(this.u.slice(), this.s, this.v, this.B(this.m), I), le = 1;
              le < this.numRounds;
              le += 1
            )
              this.T && I % 32 != 0 && (ke[ke.length - 1] &= 16777215 >>> (24 - (I % 32))),
                (ke = this.K(ke, I, 0, this.L(this.o), I));
            return L(ke);
          }),
          (se.prototype.setHMACKey = function (oe, X, le) {
            if (!this.g) throw new Error("Variant does not support HMAC");
            if (this.h) throw new Error("Cannot set MAC key after calling update");
            var ke = l(X, (le || {}).encoding || "UTF8", this.C);
            this.k(ke(oe));
          }),
          (se.prototype.k = function (oe) {
            var X,
              le = this.S >>> 3,
              ke = le / 4 - 1;
            if (this.numRounds !== 1) throw new Error("Cannot set numRounds with MAC");
            if (this.A) throw new Error("MAC key already set");
            for (
              le < oe.binLen / 8 &&
              (oe.value = this.K(oe.value, oe.binLen, 0, this.L(this.o), this.U));
              oe.value.length <= ke;

            )
              oe.value.push(0);
            for (X = 0; X <= ke; X += 1)
              (this.l[X] = 909522486 ^ oe.value[X]), (this.H[X] = 1549556828 ^ oe.value[X]);
            (this.m = this.R(this.l, this.m)), (this.v = this.S), (this.A = !0);
          }),
          (se.prototype.getHMAC = function (oe, X) {
            var le = _(X);
            return a(oe, this.U, this.C, le)(this.Y());
          }),
          (se.prototype.Y = function () {
            var oe;
            if (!this.A) throw new Error("Cannot call getHMAC without first setting MAC key");
            var X = this.K(this.u.slice(), this.s, this.v, this.B(this.m), this.U);
            return (
              (oe = this.R(this.H, this.L(this.o))), (oe = this.K(X, this.U, this.S, oe, this.U))
            );
          }),
          se
        );
      })(),
      A = function (se, oe) {
        return (A =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (X, le) {
              X.__proto__ = le;
            }) ||
          function (X, le) {
            for (var ke in le) Object.prototype.hasOwnProperty.call(le, ke) && (X[ke] = le[ke]);
          })(se, oe);
      };
    function k(se, oe) {
      function X() {
        this.constructor = se;
      }
      A(se, oe),
        (se.prototype = oe === null ? Object.create(oe) : ((X.prototype = oe.prototype), new X()));
    }
    function P(se, oe) {
      return (se << oe) | (se >>> (32 - oe));
    }
    function B(se, oe) {
      return (se >>> oe) | (se << (32 - oe));
    }
    function T(se, oe) {
      return se >>> oe;
    }
    function F(se, oe, X) {
      return se ^ oe ^ X;
    }
    function O(se, oe, X) {
      return (se & oe) ^ (~se & X);
    }
    function $(se, oe, X) {
      return (se & oe) ^ (se & X) ^ (oe & X);
    }
    function J(se) {
      return B(se, 2) ^ B(se, 13) ^ B(se, 22);
    }
    function he(se, oe) {
      var X = (65535 & se) + (65535 & oe);
      return ((65535 & ((se >>> 16) + (oe >>> 16) + (X >>> 16))) << 16) | (65535 & X);
    }
    function de(se, oe, X, le) {
      var ke = (65535 & se) + (65535 & oe) + (65535 & X) + (65535 & le);
      return (
        ((65535 & ((se >>> 16) + (oe >>> 16) + (X >>> 16) + (le >>> 16) + (ke >>> 16))) << 16) |
        (65535 & ke)
      );
    }
    function ne(se, oe, X, le, ke) {
      var I = (65535 & se) + (65535 & oe) + (65535 & X) + (65535 & le) + (65535 & ke);
      return (
        ((65535 &
          ((se >>> 16) + (oe >>> 16) + (X >>> 16) + (le >>> 16) + (ke >>> 16) + (I >>> 16))) <<
          16) |
        (65535 & I)
      );
    }
    function Ae(se) {
      return B(se, 7) ^ B(se, 18) ^ T(se, 3);
    }
    function x(se) {
      return B(se, 6) ^ B(se, 11) ^ B(se, 25);
    }
    function r(se) {
      return [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    }
    function o(se, oe) {
      var X,
        le,
        ke,
        I,
        C,
        L,
        j,
        ee = [];
      for (X = oe[0], le = oe[1], ke = oe[2], I = oe[3], C = oe[4], j = 0; j < 80; j += 1)
        (ee[j] = j < 16 ? se[j] : P(ee[j - 3] ^ ee[j - 8] ^ ee[j - 14] ^ ee[j - 16], 1)),
          (L =
            j < 20
              ? ne(P(X, 5), O(le, ke, I), C, 1518500249, ee[j])
              : j < 40
              ? ne(P(X, 5), F(le, ke, I), C, 1859775393, ee[j])
              : j < 60
              ? ne(P(X, 5), $(le, ke, I), C, 2400959708, ee[j])
              : ne(P(X, 5), F(le, ke, I), C, 3395469782, ee[j])),
          (C = I),
          (I = ke),
          (ke = P(le, 30)),
          (le = X),
          (X = L);
      return (
        (oe[0] = he(X, oe[0])),
        (oe[1] = he(le, oe[1])),
        (oe[2] = he(ke, oe[2])),
        (oe[3] = he(I, oe[3])),
        (oe[4] = he(C, oe[4])),
        oe
      );
    }
    function f(se, oe, X, le) {
      for (var ke, I = 15 + (((oe + 65) >>> 9) << 4), C = oe + X; se.length <= I; ) se.push(0);
      for (
        se[oe >>> 5] |= 128 << (24 - (oe % 32)),
          se[I] = 4294967295 & C,
          se[I - 1] = (C / 4294967296) | 0,
          ke = 0;
        ke < se.length;
        ke += 16
      )
        le = o(se.slice(ke, ke + 16), le);
      return le;
    }
    var u = (function (se) {
      function oe(X, le, ke) {
        var I = this;
        if (X !== "SHA-1") throw new Error(b);
        var C = ke || {};
        return (
          ((I = se.call(this, X, le, ke) || this).g = !0),
          (I.F = I.Y),
          (I.C = -1),
          (I.p = l(I.t, I.i, I.C)),
          (I.R = o),
          (I.B = function (L) {
            return L.slice();
          }),
          (I.L = r),
          (I.K = f),
          (I.m = [1732584193, 4023233417, 2562383102, 271733878, 3285377520]),
          (I.S = 512),
          (I.U = 160),
          (I.T = !1),
          C.hmacKey && I.k(M("hmacKey", C.hmacKey, I.C)),
          I
        );
      }
      return k(oe, se), oe;
    })(S);
    function d(se) {
      return se == "SHA-224" ? v.slice() : g.slice();
    }
    function y(se, oe) {
      var X,
        le,
        ke,
        I,
        C,
        L,
        j,
        ee,
        Me,
        fe,
        Se,
        ot,
        we = [];
      for (
        X = oe[0],
          le = oe[1],
          ke = oe[2],
          I = oe[3],
          C = oe[4],
          L = oe[5],
          j = oe[6],
          ee = oe[7],
          Se = 0;
        Se < 64;
        Se += 1
      )
        (we[Se] =
          Se < 16
            ? se[Se]
            : de(
                B((ot = we[Se - 2]), 17) ^ B(ot, 19) ^ T(ot, 10),
                we[Se - 7],
                Ae(we[Se - 15]),
                we[Se - 16]
              )),
          (Me = ne(ee, x(C), O(C, L, j), c[Se], we[Se])),
          (fe = he(J(X), $(X, le, ke))),
          (ee = j),
          (j = L),
          (L = C),
          (C = he(I, Me)),
          (I = ke),
          (ke = le),
          (le = X),
          (X = he(Me, fe));
      return (
        (oe[0] = he(X, oe[0])),
        (oe[1] = he(le, oe[1])),
        (oe[2] = he(ke, oe[2])),
        (oe[3] = he(I, oe[3])),
        (oe[4] = he(C, oe[4])),
        (oe[5] = he(L, oe[5])),
        (oe[6] = he(j, oe[6])),
        (oe[7] = he(ee, oe[7])),
        oe
      );
    }
    var w = (function (se) {
        function oe(X, le, ke) {
          var I = this;
          if (X !== "SHA-224" && X !== "SHA-256") throw new Error(b);
          var C = ke || {};
          return (
            ((I = se.call(this, X, le, ke) || this).F = I.Y),
            (I.g = !0),
            (I.C = -1),
            (I.p = l(I.t, I.i, I.C)),
            (I.R = y),
            (I.B = function (L) {
              return L.slice();
            }),
            (I.L = d),
            (I.K = function (L, j, ee, Me) {
              return (function (fe, Se, ot, we, Re) {
                for (var at, Ne = 15 + (((Se + 65) >>> 9) << 4), He = Se + ot; fe.length <= Ne; )
                  fe.push(0);
                for (
                  fe[Se >>> 5] |= 128 << (24 - (Se % 32)),
                    fe[Ne] = 4294967295 & He,
                    fe[Ne - 1] = (He / 4294967296) | 0,
                    at = 0;
                  at < fe.length;
                  at += 16
                )
                  we = y(fe.slice(at, at + 16), we);
                return Re === "SHA-224" ? [we[0], we[1], we[2], we[3], we[4], we[5], we[6]] : we;
              })(L, j, ee, Me, X);
            }),
            (I.m = d(X)),
            (I.S = 512),
            (I.U = X === "SHA-224" ? 224 : 256),
            (I.T = !1),
            C.hmacKey && I.k(M("hmacKey", C.hmacKey, I.C)),
            I
          );
        }
        return k(oe, se), oe;
      })(S),
      h = function (se, oe) {
        (this.N = se), (this.I = oe);
      };
    function s(se, oe) {
      var X;
      return oe > 32
        ? ((X = 64 - oe), new h((se.I << oe) | (se.N >>> X), (se.N << oe) | (se.I >>> X)))
        : oe !== 0
        ? ((X = 32 - oe), new h((se.N << oe) | (se.I >>> X), (se.I << oe) | (se.N >>> X)))
        : se;
    }
    function m(se, oe) {
      var X;
      return oe < 32
        ? ((X = 32 - oe), new h((se.N >>> oe) | (se.I << X), (se.I >>> oe) | (se.N << X)))
        : ((X = 64 - oe), new h((se.I >>> oe) | (se.N << X), (se.N >>> oe) | (se.I << X)));
    }
    function E(se, oe) {
      return new h(se.N >>> oe, (se.I >>> oe) | (se.N << (32 - oe)));
    }
    function R(se, oe, X) {
      return new h((se.N & oe.N) ^ (~se.N & X.N), (se.I & oe.I) ^ (~se.I & X.I));
    }
    function z(se, oe, X) {
      return new h(
        (se.N & oe.N) ^ (se.N & X.N) ^ (oe.N & X.N),
        (se.I & oe.I) ^ (se.I & X.I) ^ (oe.I & X.I)
      );
    }
    function Q(se) {
      var oe = m(se, 28),
        X = m(se, 34),
        le = m(se, 39);
      return new h(oe.N ^ X.N ^ le.N, oe.I ^ X.I ^ le.I);
    }
    function G(se, oe) {
      var X, le;
      X = (65535 & se.I) + (65535 & oe.I);
      var ke = ((65535 & (le = (se.I >>> 16) + (oe.I >>> 16) + (X >>> 16))) << 16) | (65535 & X);
      return (
        (X = (65535 & se.N) + (65535 & oe.N) + (le >>> 16)),
        (le = (se.N >>> 16) + (oe.N >>> 16) + (X >>> 16)),
        new h(((65535 & le) << 16) | (65535 & X), ke)
      );
    }
    function q(se, oe, X, le) {
      var ke, I;
      ke = (65535 & se.I) + (65535 & oe.I) + (65535 & X.I) + (65535 & le.I);
      var C =
        ((65535 &
          (I = (se.I >>> 16) + (oe.I >>> 16) + (X.I >>> 16) + (le.I >>> 16) + (ke >>> 16))) <<
          16) |
        (65535 & ke);
      return (
        (ke = (65535 & se.N) + (65535 & oe.N) + (65535 & X.N) + (65535 & le.N) + (I >>> 16)),
        (I = (se.N >>> 16) + (oe.N >>> 16) + (X.N >>> 16) + (le.N >>> 16) + (ke >>> 16)),
        new h(((65535 & I) << 16) | (65535 & ke), C)
      );
    }
    function Z(se, oe, X, le, ke) {
      var I, C;
      I = (65535 & se.I) + (65535 & oe.I) + (65535 & X.I) + (65535 & le.I) + (65535 & ke.I);
      var L =
        ((65535 &
          (C =
            (se.I >>> 16) +
            (oe.I >>> 16) +
            (X.I >>> 16) +
            (le.I >>> 16) +
            (ke.I >>> 16) +
            (I >>> 16))) <<
          16) |
        (65535 & I);
      return (
        (I =
          (65535 & se.N) +
          (65535 & oe.N) +
          (65535 & X.N) +
          (65535 & le.N) +
          (65535 & ke.N) +
          (C >>> 16)),
        (C =
          (se.N >>> 16) +
          (oe.N >>> 16) +
          (X.N >>> 16) +
          (le.N >>> 16) +
          (ke.N >>> 16) +
          (I >>> 16)),
        new h(((65535 & C) << 16) | (65535 & I), L)
      );
    }
    function te(se, oe) {
      return new h(se.N ^ oe.N, se.I ^ oe.I);
    }
    function ue(se) {
      var oe = m(se, 1),
        X = m(se, 8),
        le = E(se, 7);
      return new h(oe.N ^ X.N ^ le.N, oe.I ^ X.I ^ le.I);
    }
    function ae(se) {
      var oe = m(se, 14),
        X = m(se, 18),
        le = m(se, 41);
      return new h(oe.N ^ X.N ^ le.N, oe.I ^ X.I ^ le.I);
    }
    var K = [
      new h(c[0], 3609767458),
      new h(c[1], 602891725),
      new h(c[2], 3964484399),
      new h(c[3], 2173295548),
      new h(c[4], 4081628472),
      new h(c[5], 3053834265),
      new h(c[6], 2937671579),
      new h(c[7], 3664609560),
      new h(c[8], 2734883394),
      new h(c[9], 1164996542),
      new h(c[10], 1323610764),
      new h(c[11], 3590304994),
      new h(c[12], 4068182383),
      new h(c[13], 991336113),
      new h(c[14], 633803317),
      new h(c[15], 3479774868),
      new h(c[16], 2666613458),
      new h(c[17], 944711139),
      new h(c[18], 2341262773),
      new h(c[19], 2007800933),
      new h(c[20], 1495990901),
      new h(c[21], 1856431235),
      new h(c[22], 3175218132),
      new h(c[23], 2198950837),
      new h(c[24], 3999719339),
      new h(c[25], 766784016),
      new h(c[26], 2566594879),
      new h(c[27], 3203337956),
      new h(c[28], 1034457026),
      new h(c[29], 2466948901),
      new h(c[30], 3758326383),
      new h(c[31], 168717936),
      new h(c[32], 1188179964),
      new h(c[33], 1546045734),
      new h(c[34], 1522805485),
      new h(c[35], 2643833823),
      new h(c[36], 2343527390),
      new h(c[37], 1014477480),
      new h(c[38], 1206759142),
      new h(c[39], 344077627),
      new h(c[40], 1290863460),
      new h(c[41], 3158454273),
      new h(c[42], 3505952657),
      new h(c[43], 106217008),
      new h(c[44], 3606008344),
      new h(c[45], 1432725776),
      new h(c[46], 1467031594),
      new h(c[47], 851169720),
      new h(c[48], 3100823752),
      new h(c[49], 1363258195),
      new h(c[50], 3750685593),
      new h(c[51], 3785050280),
      new h(c[52], 3318307427),
      new h(c[53], 3812723403),
      new h(c[54], 2003034995),
      new h(c[55], 3602036899),
      new h(c[56], 1575990012),
      new h(c[57], 1125592928),
      new h(c[58], 2716904306),
      new h(c[59], 442776044),
      new h(c[60], 593698344),
      new h(c[61], 3733110249),
      new h(c[62], 2999351573),
      new h(c[63], 3815920427),
      new h(3391569614, 3928383900),
      new h(3515267271, 566280711),
      new h(3940187606, 3454069534),
      new h(4118630271, 4000239992),
      new h(116418474, 1914138554),
      new h(174292421, 2731055270),
      new h(289380356, 3203993006),
      new h(460393269, 320620315),
      new h(685471733, 587496836),
      new h(852142971, 1086792851),
      new h(1017036298, 365543100),
      new h(1126000580, 2618297676),
      new h(1288033470, 3409855158),
      new h(1501505948, 4234509866),
      new h(1607167915, 987167468),
      new h(1816402316, 1246189591),
    ];
    function ve(se) {
      return se === "SHA-384"
        ? [
            new h(3418070365, v[0]),
            new h(1654270250, v[1]),
            new h(2438529370, v[2]),
            new h(355462360, v[3]),
            new h(1731405415, v[4]),
            new h(41048885895, v[5]),
            new h(3675008525, v[6]),
            new h(1203062813, v[7]),
          ]
        : [
            new h(g[0], 4089235720),
            new h(g[1], 2227873595),
            new h(g[2], 4271175723),
            new h(g[3], 1595750129),
            new h(g[4], 2917565137),
            new h(g[5], 725511199),
            new h(g[6], 4215389547),
            new h(g[7], 327033209),
          ];
    }
    function Ye(se, oe) {
      var X,
        le,
        ke,
        I,
        C,
        L,
        j,
        ee,
        Me,
        fe,
        Se,
        ot,
        we,
        Re,
        at,
        Ne,
        He = [];
      for (
        X = oe[0],
          le = oe[1],
          ke = oe[2],
          I = oe[3],
          C = oe[4],
          L = oe[5],
          j = oe[6],
          ee = oe[7],
          Se = 0;
        Se < 80;
        Se += 1
      )
        Se < 16
          ? ((ot = 2 * Se), (He[Se] = new h(se[ot], se[ot + 1])))
          : (He[Se] = q(
              ((we = He[Se - 2]),
              (Re = void 0),
              (at = void 0),
              (Ne = void 0),
              (Re = m(we, 19)),
              (at = m(we, 61)),
              (Ne = E(we, 6)),
              new h(Re.N ^ at.N ^ Ne.N, Re.I ^ at.I ^ Ne.I)),
              He[Se - 7],
              ue(He[Se - 15]),
              He[Se - 16]
            )),
          (Me = Z(ee, ae(C), R(C, L, j), K[Se], He[Se])),
          (fe = G(Q(X), z(X, le, ke))),
          (ee = j),
          (j = L),
          (L = C),
          (C = G(I, Me)),
          (I = ke),
          (ke = le),
          (le = X),
          (X = G(Me, fe));
      return (
        (oe[0] = G(X, oe[0])),
        (oe[1] = G(le, oe[1])),
        (oe[2] = G(ke, oe[2])),
        (oe[3] = G(I, oe[3])),
        (oe[4] = G(C, oe[4])),
        (oe[5] = G(L, oe[5])),
        (oe[6] = G(j, oe[6])),
        (oe[7] = G(ee, oe[7])),
        oe
      );
    }
    var Ce = (function (se) {
        function oe(X, le, ke) {
          var I = this;
          if (X !== "SHA-384" && X !== "SHA-512") throw new Error(b);
          var C = ke || {};
          return (
            ((I = se.call(this, X, le, ke) || this).F = I.Y),
            (I.g = !0),
            (I.C = -1),
            (I.p = l(I.t, I.i, I.C)),
            (I.R = Ye),
            (I.B = function (L) {
              return L.slice();
            }),
            (I.L = ve),
            (I.K = function (L, j, ee, Me) {
              return (function (fe, Se, ot, we, Re) {
                for (var at, Ne = 31 + (((Se + 129) >>> 10) << 5), He = Se + ot; fe.length <= Ne; )
                  fe.push(0);
                for (
                  fe[Se >>> 5] |= 128 << (24 - (Se % 32)),
                    fe[Ne] = 4294967295 & He,
                    fe[Ne - 1] = (He / 4294967296) | 0,
                    at = 0;
                  at < fe.length;
                  at += 32
                )
                  we = Ye(fe.slice(at, at + 32), we);
                return Re === "SHA-384"
                  ? [
                      (we = we)[0].N,
                      we[0].I,
                      we[1].N,
                      we[1].I,
                      we[2].N,
                      we[2].I,
                      we[3].N,
                      we[3].I,
                      we[4].N,
                      we[4].I,
                      we[5].N,
                      we[5].I,
                    ]
                  : [
                      we[0].N,
                      we[0].I,
                      we[1].N,
                      we[1].I,
                      we[2].N,
                      we[2].I,
                      we[3].N,
                      we[3].I,
                      we[4].N,
                      we[4].I,
                      we[5].N,
                      we[5].I,
                      we[6].N,
                      we[6].I,
                      we[7].N,
                      we[7].I,
                    ];
              })(L, j, ee, Me, X);
            }),
            (I.m = ve(X)),
            (I.S = 1024),
            (I.U = X === "SHA-384" ? 384 : 512),
            (I.T = !1),
            C.hmacKey && I.k(M("hmacKey", C.hmacKey, I.C)),
            I
          );
        }
        return k(oe, se), oe;
      })(S),
      Te = [
        new h(0, 1),
        new h(0, 32898),
        new h(2147483648, 32906),
        new h(2147483648, 2147516416),
        new h(0, 32907),
        new h(0, 2147483649),
        new h(2147483648, 2147516545),
        new h(2147483648, 32777),
        new h(0, 138),
        new h(0, 136),
        new h(0, 2147516425),
        new h(0, 2147483658),
        new h(0, 2147516555),
        new h(2147483648, 139),
        new h(2147483648, 32905),
        new h(2147483648, 32771),
        new h(2147483648, 32770),
        new h(2147483648, 128),
        new h(0, 32778),
        new h(2147483648, 2147483658),
        new h(2147483648, 2147516545),
        new h(2147483648, 32896),
        new h(0, 2147483649),
        new h(2147483648, 2147516424),
      ],
      ut = [
        [0, 36, 3, 41, 18],
        [1, 44, 10, 45, 2],
        [62, 6, 43, 15, 61],
        [28, 55, 25, 21, 56],
        [27, 20, 39, 8, 14],
      ];
    function Ie(se) {
      var oe,
        X = [];
      for (oe = 0; oe < 5; oe += 1)
        X[oe] = [new h(0, 0), new h(0, 0), new h(0, 0), new h(0, 0), new h(0, 0)];
      return X;
    }
    function be(se) {
      var oe,
        X = [];
      for (oe = 0; oe < 5; oe += 1) X[oe] = se[oe].slice();
      return X;
    }
    function wt(se, oe) {
      var X,
        le,
        ke,
        I,
        C,
        L,
        j,
        ee,
        Me,
        fe = [],
        Se = [];
      if (se !== null)
        for (le = 0; le < se.length; le += 2)
          oe[(le >>> 1) % 5][((le >>> 1) / 5) | 0] = te(
            oe[(le >>> 1) % 5][((le >>> 1) / 5) | 0],
            new h(se[le + 1], se[le])
          );
      for (X = 0; X < 24; X += 1) {
        for (I = Ie(), le = 0; le < 5; le += 1)
          fe[le] =
            ((C = oe[le][0]),
            (L = oe[le][1]),
            (j = oe[le][2]),
            (ee = oe[le][3]),
            (Me = oe[le][4]),
            new h(C.N ^ L.N ^ j.N ^ ee.N ^ Me.N, C.I ^ L.I ^ j.I ^ ee.I ^ Me.I));
        for (le = 0; le < 5; le += 1) Se[le] = te(fe[(le + 4) % 5], s(fe[(le + 1) % 5], 1));
        for (le = 0; le < 5; le += 1)
          for (ke = 0; ke < 5; ke += 1) oe[le][ke] = te(oe[le][ke], Se[le]);
        for (le = 0; le < 5; le += 1)
          for (ke = 0; ke < 5; ke += 1) I[ke][(2 * le + 3 * ke) % 5] = s(oe[le][ke], ut[le][ke]);
        for (le = 0; le < 5; le += 1)
          for (ke = 0; ke < 5; ke += 1)
            oe[le][ke] = te(
              I[le][ke],
              new h(
                ~I[(le + 1) % 5][ke].N & I[(le + 2) % 5][ke].N,
                ~I[(le + 1) % 5][ke].I & I[(le + 2) % 5][ke].I
              )
            );
        oe[0][0] = te(oe[0][0], Te[X]);
      }
      return oe;
    }
    function Oe(se) {
      var oe,
        X,
        le = 0,
        ke = [0, 0],
        I = [4294967295 & se, (se / 4294967296) & 2097151];
      for (oe = 6; oe >= 0; oe--)
        ((X = (I[oe >> 2] >>> (8 * oe)) & 255) === 0 && le === 0) ||
          ((ke[(le + 1) >> 2] |= X << (8 * (le + 1))), (le += 1));
      return (
        (le = le !== 0 ? le : 1),
        (ke[0] |= le),
        { value: le + 1 > 4 ? ke : [ke[0]], binLen: 8 + 8 * le }
      );
    }
    function je(se) {
      return p(Oe(se.binLen), se);
    }
    function xt(se, oe) {
      var X,
        le = Oe(oe),
        ke = oe >>> 2,
        I = (ke - ((le = p(le, se)).value.length % ke)) % ke;
      for (X = 0; X < I; X++) le.value.push(0);
      return le.value;
    }
    var Ue = (function (se) {
      function oe(X, le, ke) {
        var I = this,
          C = 6,
          L = 0,
          j = ke || {};
        if ((I = se.call(this, X, le, ke) || this).numRounds !== 1) {
          if (j.kmacKey || j.hmacKey) throw new Error("Cannot set numRounds with MAC");
          if (I.o === "CSHAKE128" || I.o === "CSHAKE256")
            throw new Error("Cannot set numRounds for CSHAKE variants");
        }
        switch (
          ((I.C = 1),
          (I.p = l(I.t, I.i, I.C)),
          (I.R = wt),
          (I.B = be),
          (I.L = Ie),
          (I.m = Ie()),
          (I.T = !1),
          X)
        ) {
          case "SHA3-224":
            (I.S = L = 1152), (I.U = 224), (I.g = !0), (I.F = I.Y);
            break;
          case "SHA3-256":
            (I.S = L = 1088), (I.U = 256), (I.g = !0), (I.F = I.Y);
            break;
          case "SHA3-384":
            (I.S = L = 832), (I.U = 384), (I.g = !0), (I.F = I.Y);
            break;
          case "SHA3-512":
            (I.S = L = 576), (I.U = 512), (I.g = !0), (I.F = I.Y);
            break;
          case "SHAKE128":
            (C = 31), (I.S = L = 1344), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = null);
            break;
          case "SHAKE256":
            (C = 31), (I.S = L = 1088), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = null);
            break;
          case "KMAC128":
            (C = 4), (I.S = L = 1344), I.M(ke), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = I.X);
            break;
          case "KMAC256":
            (C = 4), (I.S = L = 1088), I.M(ke), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = I.X);
            break;
          case "CSHAKE128":
            (I.S = L = 1344), (C = I.O(ke)), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = null);
            break;
          case "CSHAKE256":
            (I.S = L = 1088), (C = I.O(ke)), (I.U = -1), (I.T = !0), (I.g = !1), (I.F = null);
            break;
          default:
            throw new Error(b);
        }
        return (
          (I.K = function (ee, Me, fe, Se, ot) {
            return (function (we, Re, at, Ne, He, At, Le) {
              var Ze,
                Tt,
                Ve = 0,
                Je = [],
                Rt = He >>> 5,
                $e = Re >>> 5;
              for (Ze = 0; Ze < $e && Re >= He; Ze += Rt)
                (Ne = wt(we.slice(Ze, Ze + Rt), Ne)), (Re -= He);
              for (we = we.slice(Ze), Re %= He; we.length < Rt; ) we.push(0);
              for (
                we[(Ze = Re >>> 3) >> 2] ^= At << ((Ze % 4) * 8),
                  we[Rt - 1] ^= 2147483648,
                  Ne = wt(we, Ne);
                32 * Je.length < Le &&
                ((Tt = Ne[Ve % 5][(Ve / 5) | 0]), Je.push(Tt.I), !(32 * Je.length >= Le));

              )
                Je.push(Tt.N), (64 * (Ve += 1)) % He == 0 && (wt(null, Ne), (Ve = 0));
              return Je;
            })(ee, Me, 0, Se, L, C, ot);
          }),
          j.hmacKey && I.k(M("hmacKey", j.hmacKey, I.C)),
          I
        );
      }
      return (
        k(oe, se),
        (oe.prototype.O = function (X, le) {
          var ke = (function (j) {
            var ee = j || {};
            return {
              funcName: M("funcName", ee.funcName, 1, { value: [], binLen: 0 }),
              customization: M("Customization", ee.customization, 1, { value: [], binLen: 0 }),
            };
          })(X || {});
          le && (ke.funcName = le);
          var I = p(je(ke.funcName), je(ke.customization));
          if (ke.customization.binLen !== 0 || ke.funcName.binLen !== 0) {
            for (var C = xt(I, this.S >>> 3), L = 0; L < C.length; L += this.S >>> 5)
              (this.m = this.R(C.slice(L, L + (this.S >>> 5)), this.m)), (this.v += this.S);
            return 4;
          }
          return 31;
        }),
        (oe.prototype.M = function (X) {
          var le = (function (C) {
            var L = C || {};
            return {
              kmacKey: M("kmacKey", L.kmacKey, 1),
              funcName: { value: [1128353099], binLen: 32 },
              customization: M("Customization", L.customization, 1, { value: [], binLen: 0 }),
            };
          })(X || {});
          this.O(X, le.funcName);
          for (var ke = xt(je(le.kmacKey), this.S >>> 3), I = 0; I < ke.length; I += this.S >>> 5)
            (this.m = this.R(ke.slice(I, I + (this.S >>> 5)), this.m)), (this.v += this.S);
          this.A = !0;
        }),
        (oe.prototype.X = function (X) {
          var le = p(
            { value: this.u.slice(), binLen: this.s },
            (function (ke) {
              var I,
                C,
                L = 0,
                j = [0, 0],
                ee = [4294967295 & ke, (ke / 4294967296) & 2097151];
              for (I = 6; I >= 0; I--)
                ((C = (ee[I >> 2] >>> (8 * I)) & 255) == 0 && L === 0) ||
                  ((j[L >> 2] |= C << (8 * L)), (L += 1));
              return (
                (j[(L = L !== 0 ? L : 1) >> 2] |= L << (8 * L)),
                { value: L + 1 > 4 ? j : [j[0]], binLen: 8 + 8 * L }
              );
            })(X.outputLen)
          );
          return this.K(le.value, le.binLen, this.v, this.B(this.m), X.outputLen);
        }),
        oe
      );
    })(S);
    return (function () {
      function se(oe, X, le) {
        if (oe == "SHA-1") this.j = new u(oe, X, le);
        else if (oe == "SHA-224" || oe == "SHA-256") this.j = new w(oe, X, le);
        else if (oe == "SHA-384" || oe == "SHA-512") this.j = new Ce(oe, X, le);
        else {
          if (
            oe != "SHA3-224" &&
            oe != "SHA3-256" &&
            oe != "SHA3-384" &&
            oe != "SHA3-512" &&
            oe != "SHAKE128" &&
            oe != "SHAKE256" &&
            oe != "CSHAKE128" &&
            oe != "CSHAKE256" &&
            oe != "KMAC128" &&
            oe != "KMAC256"
          )
            throw new Error(b);
          this.j = new Ue(oe, X, le);
        }
      }
      return (
        (se.prototype.update = function (oe) {
          this.j.update(oe);
        }),
        (se.prototype.getHash = function (oe, X) {
          return this.j.getHash(oe, X);
        }),
        (se.prototype.setHMACKey = function (oe, X, le) {
          this.j.setHMACKey(oe, X, le);
        }),
        (se.prototype.getHMAC = function (oe, X) {
          return this.j.getHMAC(oe, X);
        }),
        se
      );
    })();
  });
})(H6);
var v1 = H6.exports,
  ao = {},
  Ls = {};
Object.defineProperty(Ls, "__esModule", { value: !0 });
Ls.getSecureRandomWords = Ls.getSecureRandomBytes = void 0;
function Vx(t) {
  return Qe.from(window.crypto.getRandomValues(new Uint8Array(t)));
}
Ls.getSecureRandomBytes = Vx;
function Wx(t) {
  return window.crypto.getRandomValues(new Uint16Array(t));
}
Ls.getSecureRandomWords = Wx;
var Eu = {};
Object.defineProperty(Eu, "__esModule", { value: !0 });
Eu.hmac_sha512 = void 0;
async function Kx(t, e) {
  let n = typeof t == "string" ? Qe.from(t, "utf-8") : t,
    i = typeof e == "string" ? Qe.from(e, "utf-8") : e;
  const l = { name: "HMAC", hash: "SHA-512" },
    a = await window.crypto.subtle.importKey("raw", n, l, !1, ["sign"]);
  return Qe.from(await crypto.subtle.sign(l, a, i));
}
Eu.hmac_sha512 = Kx;
var Au = {};
Object.defineProperty(Au, "__esModule", { value: !0 });
Au.pbkdf2_sha512 = void 0;
async function Zx(t, e, n, i) {
  const l = typeof t == "string" ? Qe.from(t, "utf-8") : t,
    a = typeof e == "string" ? Qe.from(e, "utf-8") : e,
    c = await window.crypto.subtle.importKey("raw", l, { name: "PBKDF2" }, !1, ["deriveBits"]),
    v = await window.crypto.subtle.deriveBits(
      { name: "PBKDF2", hash: "SHA-512", salt: a, iterations: n },
      c,
      i * 8
    );
  return Qe.from(v);
}
Au.pbkdf2_sha512 = Zx;
var ku = {};
Object.defineProperty(ku, "__esModule", { value: !0 });
ku.sha256 = void 0;
async function Gx(t) {
  return typeof t == "string"
    ? Qe.from(await crypto.subtle.digest("SHA-256", Qe.from(t, "utf-8")))
    : Qe.from(await crypto.subtle.digest("SHA-256", t));
}
ku.sha256 = Gx;
var Bu = {};
Object.defineProperty(Bu, "__esModule", { value: !0 });
Bu.sha512 = void 0;
async function Yx(t) {
  return typeof t == "string"
    ? Qe.from(await crypto.subtle.digest("SHA-512", Qe.from(t, "utf-8")))
    : Qe.from(await crypto.subtle.digest("SHA-512", t));
}
Bu.sha512 = Yx;
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.sha512 =
      t.sha256 =
      t.pbkdf2_sha512 =
      t.hmac_sha512 =
      t.getSecureRandomWords =
      t.getSecureRandomBytes =
        void 0);
  var e = Ls;
  Object.defineProperty(t, "getSecureRandomBytes", {
    enumerable: !0,
    get: function () {
      return e.getSecureRandomBytes;
    },
  }),
    Object.defineProperty(t, "getSecureRandomWords", {
      enumerable: !0,
      get: function () {
        return e.getSecureRandomWords;
      },
    });
  var n = Eu;
  Object.defineProperty(t, "hmac_sha512", {
    enumerable: !0,
    get: function () {
      return n.hmac_sha512;
    },
  });
  var i = Au;
  Object.defineProperty(t, "pbkdf2_sha512", {
    enumerable: !0,
    get: function () {
      return i.pbkdf2_sha512;
    },
  });
  var l = ku;
  Object.defineProperty(t, "sha256", {
    enumerable: !0,
    get: function () {
      return l.sha256;
    },
  });
  var a = Bu;
  Object.defineProperty(t, "sha512", {
    enumerable: !0,
    get: function () {
      return a.sha512;
    },
  });
})(ao);
var Jx =
  (mt && mt.__importDefault) ||
  function (t) {
    return t && t.__esModule ? t : { default: t };
  };
Object.defineProperty(Zi, "__esModule", { value: !0 });
Zi.sha256 = Zi.sha256_fallback = Zi.sha256_sync = void 0;
const Qx = Jx(v1),
  Xx = ao;
function V6(t) {
  let e;
  typeof t == "string" ? (e = Qe.from(t, "utf-8").toString("hex")) : (e = t.toString("hex"));
  let n = new Qx.default("SHA-256", "HEX");
  n.update(e);
  let i = n.getHash("HEX");
  return Qe.from(i, "hex");
}
Zi.sha256_sync = V6;
async function eM(t) {
  return V6(t);
}
Zi.sha256_fallback = eM;
function tM(t) {
  return (0, Xx.sha256)(t);
}
Zi.sha256 = tM;
var Gi = {},
  rM =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    };
Object.defineProperty(Gi, "__esModule", { value: !0 });
Gi.sha512 = Gi.sha512_fallback = Gi.sha512_sync = void 0;
const nM = rM(v1),
  iM = ao;
function W6(t) {
  let e;
  typeof t == "string" ? (e = Qe.from(t, "utf-8").toString("hex")) : (e = t.toString("hex"));
  let n = new nM.default("SHA-512", "HEX");
  n.update(e);
  let i = n.getHash("HEX");
  return Qe.from(i, "hex");
}
Gi.sha512_sync = W6;
async function aM(t) {
  return W6(t);
}
Gi.sha512_fallback = aM;
async function sM(t) {
  return (0, iM.sha512)(t);
}
Gi.sha512 = sM;
var Mf = {};
Object.defineProperty(Mf, "__esModule", { value: !0 });
Mf.pbkdf2_sha512 = void 0;
const oM = ao;
function fM(t, e, n, i) {
  return (0, oM.pbkdf2_sha512)(t, e, n, i);
}
Mf.pbkdf2_sha512 = fM;
var Qn = {},
  lM =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    };
Object.defineProperty(Qn, "__esModule", { value: !0 });
Qn.hmac_sha512 = Qn.hmac_sha512_fallback = void 0;
const uM = lM(v1),
  cM = ao;
async function hM(t, e) {
  let n = typeof t == "string" ? Qe.from(t, "utf-8") : t,
    i = typeof e == "string" ? Qe.from(e, "utf-8") : e;
  const l = new uM.default("SHA-512", "HEX", {
    hmacKey: { value: n.toString("hex"), format: "HEX" },
  });
  l.update(i.toString("hex"));
  const a = l.getHash("HEX");
  return Qe.from(a, "hex");
}
Qn.hmac_sha512_fallback = hM;
function dM(t, e) {
  return (0, cM.hmac_sha512)(t, e);
}
Qn.hmac_sha512 = dM;
var Zn = {};
Object.defineProperty(Zn, "__esModule", { value: !0 });
Zn.getSecureRandomNumber = Zn.getSecureRandomWords = Zn.getSecureRandomBytes = void 0;
const pM = ao;
async function K6(t) {
  return (0, pM.getSecureRandomBytes)(t);
}
Zn.getSecureRandomBytes = K6;
async function Z6(t) {
  return Z6();
}
Zn.getSecureRandomWords = Z6;
async function mM(t, e) {
  let n = e - t;
  var i = Math.ceil(Math.log2(n));
  if (i > 53) throw new Error("Range is too large");
  for (var l = Math.ceil(i / 8), a = Math.pow(2, i) - 1; ; ) {
    let v = await K6(i),
      g = (l - 1) * 8,
      b = 0;
    for (var c = 0; c < l; c++) (b += v[c] * Math.pow(2, g)), (g -= 8);
    if (((b = b & a), !(b >= n))) return t + b;
  }
}
Zn.getSecureRandomNumber = mM;
var Cu = {},
  Tu = {};
Object.defineProperty(Tu, "__esModule", { value: !0 });
Tu.wordlist = void 0;
Tu.wordlist = [
  "abacus",
  "abdomen",
  "abdominal",
  "abide",
  "abiding",
  "ability",
  "ablaze",
  "able",
  "abnormal",
  "abrasion",
  "abrasive",
  "abreast",
  "abridge",
  "abroad",
  "abruptly",
  "absence",
  "absentee",
  "absently",
  "absinthe",
  "absolute",
  "absolve",
  "abstain",
  "abstract",
  "absurd",
  "accent",
  "acclaim",
  "acclimate",
  "accompany",
  "account",
  "accuracy",
  "accurate",
  "accustom",
  "acetone",
  "achiness",
  "aching",
  "acid",
  "acorn",
  "acquaint",
  "acquire",
  "acre",
  "acrobat",
  "acronym",
  "acting",
  "action",
  "activate",
  "activator",
  "active",
  "activism",
  "activist",
  "activity",
  "actress",
  "acts",
  "acutely",
  "acuteness",
  "aeration",
  "aerobics",
  "aerosol",
  "aerospace",
  "afar",
  "affair",
  "affected",
  "affecting",
  "affection",
  "affidavit",
  "affiliate",
  "affirm",
  "affix",
  "afflicted",
  "affluent",
  "afford",
  "affront",
  "aflame",
  "afloat",
  "aflutter",
  "afoot",
  "afraid",
  "afterglow",
  "afterlife",
  "aftermath",
  "aftermost",
  "afternoon",
  "aged",
  "ageless",
  "agency",
  "agenda",
  "agent",
  "aggregate",
  "aghast",
  "agile",
  "agility",
  "aging",
  "agnostic",
  "agonize",
  "agonizing",
  "agony",
  "agreeable",
  "agreeably",
  "agreed",
  "agreeing",
  "agreement",
  "aground",
  "ahead",
  "ahoy",
  "aide",
  "aids",
  "aim",
  "ajar",
  "alabaster",
  "alarm",
  "albatross",
  "album",
  "alfalfa",
  "algebra",
  "algorithm",
  "alias",
  "alibi",
  "alienable",
  "alienate",
  "aliens",
  "alike",
  "alive",
  "alkaline",
  "alkalize",
  "almanac",
  "almighty",
  "almost",
  "aloe",
  "aloft",
  "aloha",
  "alone",
  "alongside",
  "aloof",
  "alphabet",
  "alright",
  "although",
  "altitude",
  "alto",
  "aluminum",
  "alumni",
  "always",
  "amaretto",
  "amaze",
  "amazingly",
  "amber",
  "ambiance",
  "ambiguity",
  "ambiguous",
  "ambition",
  "ambitious",
  "ambulance",
  "ambush",
  "amendable",
  "amendment",
  "amends",
  "amenity",
  "amiable",
  "amicably",
  "amid",
  "amigo",
  "amino",
  "amiss",
  "ammonia",
  "ammonium",
  "amnesty",
  "amniotic",
  "among",
  "amount",
  "amperage",
  "ample",
  "amplifier",
  "amplify",
  "amply",
  "amuck",
  "amulet",
  "amusable",
  "amused",
  "amusement",
  "amuser",
  "amusing",
  "anaconda",
  "anaerobic",
  "anagram",
  "anatomist",
  "anatomy",
  "anchor",
  "anchovy",
  "ancient",
  "android",
  "anemia",
  "anemic",
  "aneurism",
  "anew",
  "angelfish",
  "angelic",
  "anger",
  "angled",
  "angler",
  "angles",
  "angling",
  "angrily",
  "angriness",
  "anguished",
  "angular",
  "animal",
  "animate",
  "animating",
  "animation",
  "animator",
  "anime",
  "animosity",
  "ankle",
  "annex",
  "annotate",
  "announcer",
  "annoying",
  "annually",
  "annuity",
  "anointer",
  "another",
  "answering",
  "antacid",
  "antarctic",
  "anteater",
  "antelope",
  "antennae",
  "anthem",
  "anthill",
  "anthology",
  "antibody",
  "antics",
  "antidote",
  "antihero",
  "antiquely",
  "antiques",
  "antiquity",
  "antirust",
  "antitoxic",
  "antitrust",
  "antiviral",
  "antivirus",
  "antler",
  "antonym",
  "antsy",
  "anvil",
  "anybody",
  "anyhow",
  "anymore",
  "anyone",
  "anyplace",
  "anything",
  "anytime",
  "anyway",
  "anywhere",
  "aorta",
  "apache",
  "apostle",
  "appealing",
  "appear",
  "appease",
  "appeasing",
  "appendage",
  "appendix",
  "appetite",
  "appetizer",
  "applaud",
  "applause",
  "apple",
  "appliance",
  "applicant",
  "applied",
  "apply",
  "appointee",
  "appraisal",
  "appraiser",
  "apprehend",
  "approach",
  "approval",
  "approve",
  "apricot",
  "april",
  "apron",
  "aptitude",
  "aptly",
  "aqua",
  "aqueduct",
  "arbitrary",
  "arbitrate",
  "ardently",
  "area",
  "arena",
  "arguable",
  "arguably",
  "argue",
  "arise",
  "armadillo",
  "armband",
  "armchair",
  "armed",
  "armful",
  "armhole",
  "arming",
  "armless",
  "armoire",
  "armored",
  "armory",
  "armrest",
  "army",
  "aroma",
  "arose",
  "around",
  "arousal",
  "arrange",
  "array",
  "arrest",
  "arrival",
  "arrive",
  "arrogance",
  "arrogant",
  "arson",
  "art",
  "ascend",
  "ascension",
  "ascent",
  "ascertain",
  "ashamed",
  "ashen",
  "ashes",
  "ashy",
  "aside",
  "askew",
  "asleep",
  "asparagus",
  "aspect",
  "aspirate",
  "aspire",
  "aspirin",
  "astonish",
  "astound",
  "astride",
  "astrology",
  "astronaut",
  "astronomy",
  "astute",
  "atlantic",
  "atlas",
  "atom",
  "atonable",
  "atop",
  "atrium",
  "atrocious",
  "atrophy",
  "attach",
  "attain",
  "attempt",
  "attendant",
  "attendee",
  "attention",
  "attentive",
  "attest",
  "attic",
  "attire",
  "attitude",
  "attractor",
  "attribute",
  "atypical",
  "auction",
  "audacious",
  "audacity",
  "audible",
  "audibly",
  "audience",
  "audio",
  "audition",
  "augmented",
  "august",
  "authentic",
  "author",
  "autism",
  "autistic",
  "autograph",
  "automaker",
  "automated",
  "automatic",
  "autopilot",
  "available",
  "avalanche",
  "avatar",
  "avenge",
  "avenging",
  "avenue",
  "average",
  "aversion",
  "avert",
  "aviation",
  "aviator",
  "avid",
  "avoid",
  "await",
  "awaken",
  "award",
  "aware",
  "awhile",
  "awkward",
  "awning",
  "awoke",
  "awry",
  "axis",
  "babble",
  "babbling",
  "babied",
  "baboon",
  "backache",
  "backboard",
  "backboned",
  "backdrop",
  "backed",
  "backer",
  "backfield",
  "backfire",
  "backhand",
  "backing",
  "backlands",
  "backlash",
  "backless",
  "backlight",
  "backlit",
  "backlog",
  "backpack",
  "backpedal",
  "backrest",
  "backroom",
  "backshift",
  "backside",
  "backslid",
  "backspace",
  "backspin",
  "backstab",
  "backstage",
  "backtalk",
  "backtrack",
  "backup",
  "backward",
  "backwash",
  "backwater",
  "backyard",
  "bacon",
  "bacteria",
  "bacterium",
  "badass",
  "badge",
  "badland",
  "badly",
  "badness",
  "baffle",
  "baffling",
  "bagel",
  "bagful",
  "baggage",
  "bagged",
  "baggie",
  "bagginess",
  "bagging",
  "baggy",
  "bagpipe",
  "baguette",
  "baked",
  "bakery",
  "bakeshop",
  "baking",
  "balance",
  "balancing",
  "balcony",
  "balmy",
  "balsamic",
  "bamboo",
  "banana",
  "banish",
  "banister",
  "banjo",
  "bankable",
  "bankbook",
  "banked",
  "banker",
  "banking",
  "banknote",
  "bankroll",
  "banner",
  "bannister",
  "banshee",
  "banter",
  "barbecue",
  "barbed",
  "barbell",
  "barber",
  "barcode",
  "barge",
  "bargraph",
  "barista",
  "baritone",
  "barley",
  "barmaid",
  "barman",
  "barn",
  "barometer",
  "barrack",
  "barracuda",
  "barrel",
  "barrette",
  "barricade",
  "barrier",
  "barstool",
  "bartender",
  "barterer",
  "bash",
  "basically",
  "basics",
  "basil",
  "basin",
  "basis",
  "basket",
  "batboy",
  "batch",
  "bath",
  "baton",
  "bats",
  "battalion",
  "battered",
  "battering",
  "battery",
  "batting",
  "battle",
  "bauble",
  "bazooka",
  "blabber",
  "bladder",
  "blade",
  "blah",
  "blame",
  "blaming",
  "blanching",
  "blandness",
  "blank",
  "blaspheme",
  "blasphemy",
  "blast",
  "blatancy",
  "blatantly",
  "blazer",
  "blazing",
  "bleach",
  "bleak",
  "bleep",
  "blemish",
  "blend",
  "bless",
  "blighted",
  "blimp",
  "bling",
  "blinked",
  "blinker",
  "blinking",
  "blinks",
  "blip",
  "blissful",
  "blitz",
  "blizzard",
  "bloated",
  "bloating",
  "blob",
  "blog",
  "bloomers",
  "blooming",
  "blooper",
  "blot",
  "blouse",
  "blubber",
  "bluff",
  "bluish",
  "blunderer",
  "blunt",
  "blurb",
  "blurred",
  "blurry",
  "blurt",
  "blush",
  "blustery",
  "boaster",
  "boastful",
  "boasting",
  "boat",
  "bobbed",
  "bobbing",
  "bobble",
  "bobcat",
  "bobsled",
  "bobtail",
  "bodacious",
  "body",
  "bogged",
  "boggle",
  "bogus",
  "boil",
  "bok",
  "bolster",
  "bolt",
  "bonanza",
  "bonded",
  "bonding",
  "bondless",
  "boned",
  "bonehead",
  "boneless",
  "bonelike",
  "boney",
  "bonfire",
  "bonnet",
  "bonsai",
  "bonus",
  "bony",
  "boogeyman",
  "boogieman",
  "book",
  "boondocks",
  "booted",
  "booth",
  "bootie",
  "booting",
  "bootlace",
  "bootleg",
  "boots",
  "boozy",
  "borax",
  "boring",
  "borough",
  "borrower",
  "borrowing",
  "boss",
  "botanical",
  "botanist",
  "botany",
  "botch",
  "both",
  "bottle",
  "bottling",
  "bottom",
  "bounce",
  "bouncing",
  "bouncy",
  "bounding",
  "boundless",
  "bountiful",
  "bovine",
  "boxcar",
  "boxer",
  "boxing",
  "boxlike",
  "boxy",
  "breach",
  "breath",
  "breeches",
  "breeching",
  "breeder",
  "breeding",
  "breeze",
  "breezy",
  "brethren",
  "brewery",
  "brewing",
  "briar",
  "bribe",
  "brick",
  "bride",
  "bridged",
  "brigade",
  "bright",
  "brilliant",
  "brim",
  "bring",
  "brink",
  "brisket",
  "briskly",
  "briskness",
  "bristle",
  "brittle",
  "broadband",
  "broadcast",
  "broaden",
  "broadly",
  "broadness",
  "broadside",
  "broadways",
  "broiler",
  "broiling",
  "broken",
  "broker",
  "bronchial",
  "bronco",
  "bronze",
  "bronzing",
  "brook",
  "broom",
  "brought",
  "browbeat",
  "brownnose",
  "browse",
  "browsing",
  "bruising",
  "brunch",
  "brunette",
  "brunt",
  "brush",
  "brussels",
  "brute",
  "brutishly",
  "bubble",
  "bubbling",
  "bubbly",
  "buccaneer",
  "bucked",
  "bucket",
  "buckle",
  "buckshot",
  "buckskin",
  "bucktooth",
  "buckwheat",
  "buddhism",
  "buddhist",
  "budding",
  "buddy",
  "budget",
  "buffalo",
  "buffed",
  "buffer",
  "buffing",
  "buffoon",
  "buggy",
  "bulb",
  "bulge",
  "bulginess",
  "bulgur",
  "bulk",
  "bulldog",
  "bulldozer",
  "bullfight",
  "bullfrog",
  "bullhorn",
  "bullion",
  "bullish",
  "bullpen",
  "bullring",
  "bullseye",
  "bullwhip",
  "bully",
  "bunch",
  "bundle",
  "bungee",
  "bunion",
  "bunkbed",
  "bunkhouse",
  "bunkmate",
  "bunny",
  "bunt",
  "busboy",
  "bush",
  "busily",
  "busload",
  "bust",
  "busybody",
  "buzz",
  "cabana",
  "cabbage",
  "cabbie",
  "cabdriver",
  "cable",
  "caboose",
  "cache",
  "cackle",
  "cacti",
  "cactus",
  "caddie",
  "caddy",
  "cadet",
  "cadillac",
  "cadmium",
  "cage",
  "cahoots",
  "cake",
  "calamari",
  "calamity",
  "calcium",
  "calculate",
  "calculus",
  "caliber",
  "calibrate",
  "calm",
  "caloric",
  "calorie",
  "calzone",
  "camcorder",
  "cameo",
  "camera",
  "camisole",
  "camper",
  "campfire",
  "camping",
  "campsite",
  "campus",
  "canal",
  "canary",
  "cancel",
  "candied",
  "candle",
  "candy",
  "cane",
  "canine",
  "canister",
  "cannabis",
  "canned",
  "canning",
  "cannon",
  "cannot",
  "canola",
  "canon",
  "canopener",
  "canopy",
  "canteen",
  "canyon",
  "capable",
  "capably",
  "capacity",
  "cape",
  "capillary",
  "capital",
  "capitol",
  "capped",
  "capricorn",
  "capsize",
  "capsule",
  "caption",
  "captivate",
  "captive",
  "captivity",
  "capture",
  "caramel",
  "carat",
  "caravan",
  "carbon",
  "cardboard",
  "carded",
  "cardiac",
  "cardigan",
  "cardinal",
  "cardstock",
  "carefully",
  "caregiver",
  "careless",
  "caress",
  "caretaker",
  "cargo",
  "caring",
  "carless",
  "carload",
  "carmaker",
  "carnage",
  "carnation",
  "carnival",
  "carnivore",
  "carol",
  "carpenter",
  "carpentry",
  "carpool",
  "carport",
  "carried",
  "carrot",
  "carrousel",
  "carry",
  "cartel",
  "cartload",
  "carton",
  "cartoon",
  "cartridge",
  "cartwheel",
  "carve",
  "carving",
  "carwash",
  "cascade",
  "case",
  "cash",
  "casing",
  "casino",
  "casket",
  "cassette",
  "casually",
  "casualty",
  "catacomb",
  "catalog",
  "catalyst",
  "catalyze",
  "catapult",
  "cataract",
  "catatonic",
  "catcall",
  "catchable",
  "catcher",
  "catching",
  "catchy",
  "caterer",
  "catering",
  "catfight",
  "catfish",
  "cathedral",
  "cathouse",
  "catlike",
  "catnap",
  "catnip",
  "catsup",
  "cattail",
  "cattishly",
  "cattle",
  "catty",
  "catwalk",
  "caucasian",
  "caucus",
  "causal",
  "causation",
  "cause",
  "causing",
  "cauterize",
  "caution",
  "cautious",
  "cavalier",
  "cavalry",
  "caviar",
  "cavity",
  "cedar",
  "celery",
  "celestial",
  "celibacy",
  "celibate",
  "celtic",
  "cement",
  "census",
  "ceramics",
  "ceremony",
  "certainly",
  "certainty",
  "certified",
  "certify",
  "cesarean",
  "cesspool",
  "chafe",
  "chaffing",
  "chain",
  "chair",
  "chalice",
  "challenge",
  "chamber",
  "chamomile",
  "champion",
  "chance",
  "change",
  "channel",
  "chant",
  "chaos",
  "chaperone",
  "chaplain",
  "chapped",
  "chaps",
  "chapter",
  "character",
  "charbroil",
  "charcoal",
  "charger",
  "charging",
  "chariot",
  "charity",
  "charm",
  "charred",
  "charter",
  "charting",
  "chase",
  "chasing",
  "chaste",
  "chastise",
  "chastity",
  "chatroom",
  "chatter",
  "chatting",
  "chatty",
  "cheating",
  "cheddar",
  "cheek",
  "cheer",
  "cheese",
  "cheesy",
  "chef",
  "chemicals",
  "chemist",
  "chemo",
  "cherisher",
  "cherub",
  "chess",
  "chest",
  "chevron",
  "chevy",
  "chewable",
  "chewer",
  "chewing",
  "chewy",
  "chief",
  "chihuahua",
  "childcare",
  "childhood",
  "childish",
  "childless",
  "childlike",
  "chili",
  "chill",
  "chimp",
  "chip",
  "chirping",
  "chirpy",
  "chitchat",
  "chivalry",
  "chive",
  "chloride",
  "chlorine",
  "choice",
  "chokehold",
  "choking",
  "chomp",
  "chooser",
  "choosing",
  "choosy",
  "chop",
  "chosen",
  "chowder",
  "chowtime",
  "chrome",
  "chubby",
  "chuck",
  "chug",
  "chummy",
  "chump",
  "chunk",
  "churn",
  "chute",
  "cider",
  "cilantro",
  "cinch",
  "cinema",
  "cinnamon",
  "circle",
  "circling",
  "circular",
  "circulate",
  "circus",
  "citable",
  "citadel",
  "citation",
  "citizen",
  "citric",
  "citrus",
  "city",
  "civic",
  "civil",
  "clad",
  "claim",
  "clambake",
  "clammy",
  "clamor",
  "clamp",
  "clamshell",
  "clang",
  "clanking",
  "clapped",
  "clapper",
  "clapping",
  "clarify",
  "clarinet",
  "clarity",
  "clash",
  "clasp",
  "class",
  "clatter",
  "clause",
  "clavicle",
  "claw",
  "clay",
  "clean",
  "clear",
  "cleat",
  "cleaver",
  "cleft",
  "clench",
  "clergyman",
  "clerical",
  "clerk",
  "clever",
  "clicker",
  "client",
  "climate",
  "climatic",
  "cling",
  "clinic",
  "clinking",
  "clip",
  "clique",
  "cloak",
  "clobber",
  "clock",
  "clone",
  "cloning",
  "closable",
  "closure",
  "clothes",
  "clothing",
  "cloud",
  "clover",
  "clubbed",
  "clubbing",
  "clubhouse",
  "clump",
  "clumsily",
  "clumsy",
  "clunky",
  "clustered",
  "clutch",
  "clutter",
  "coach",
  "coagulant",
  "coastal",
  "coaster",
  "coasting",
  "coastland",
  "coastline",
  "coat",
  "coauthor",
  "cobalt",
  "cobbler",
  "cobweb",
  "cocoa",
  "coconut",
  "cod",
  "coeditor",
  "coerce",
  "coexist",
  "coffee",
  "cofounder",
  "cognition",
  "cognitive",
  "cogwheel",
  "coherence",
  "coherent",
  "cohesive",
  "coil",
  "coke",
  "cola",
  "cold",
  "coleslaw",
  "coliseum",
  "collage",
  "collapse",
  "collar",
  "collected",
  "collector",
  "collide",
  "collie",
  "collision",
  "colonial",
  "colonist",
  "colonize",
  "colony",
  "colossal",
  "colt",
  "coma",
  "come",
  "comfort",
  "comfy",
  "comic",
  "coming",
  "comma",
  "commence",
  "commend",
  "comment",
  "commerce",
  "commode",
  "commodity",
  "commodore",
  "common",
  "commotion",
  "commute",
  "commuting",
  "compacted",
  "compacter",
  "compactly",
  "compactor",
  "companion",
  "company",
  "compare",
  "compel",
  "compile",
  "comply",
  "component",
  "composed",
  "composer",
  "composite",
  "compost",
  "composure",
  "compound",
  "compress",
  "comprised",
  "computer",
  "computing",
  "comrade",
  "concave",
  "conceal",
  "conceded",
  "concept",
  "concerned",
  "concert",
  "conch",
  "concierge",
  "concise",
  "conclude",
  "concrete",
  "concur",
  "condense",
  "condiment",
  "condition",
  "condone",
  "conducive",
  "conductor",
  "conduit",
  "cone",
  "confess",
  "confetti",
  "confidant",
  "confident",
  "confider",
  "confiding",
  "configure",
  "confined",
  "confining",
  "confirm",
  "conflict",
  "conform",
  "confound",
  "confront",
  "confused",
  "confusing",
  "confusion",
  "congenial",
  "congested",
  "congrats",
  "congress",
  "conical",
  "conjoined",
  "conjure",
  "conjuror",
  "connected",
  "connector",
  "consensus",
  "consent",
  "console",
  "consoling",
  "consonant",
  "constable",
  "constant",
  "constrain",
  "constrict",
  "construct",
  "consult",
  "consumer",
  "consuming",
  "contact",
  "container",
  "contempt",
  "contend",
  "contented",
  "contently",
  "contents",
  "contest",
  "context",
  "contort",
  "contour",
  "contrite",
  "control",
  "contusion",
  "convene",
  "convent",
  "copartner",
  "cope",
  "copied",
  "copier",
  "copilot",
  "coping",
  "copious",
  "copper",
  "copy",
  "coral",
  "cork",
  "cornball",
  "cornbread",
  "corncob",
  "cornea",
  "corned",
  "corner",
  "cornfield",
  "cornflake",
  "cornhusk",
  "cornmeal",
  "cornstalk",
  "corny",
  "coronary",
  "coroner",
  "corporal",
  "corporate",
  "corral",
  "correct",
  "corridor",
  "corrode",
  "corroding",
  "corrosive",
  "corsage",
  "corset",
  "cortex",
  "cosigner",
  "cosmetics",
  "cosmic",
  "cosmos",
  "cosponsor",
  "cost",
  "cottage",
  "cotton",
  "couch",
  "cough",
  "could",
  "countable",
  "countdown",
  "counting",
  "countless",
  "country",
  "county",
  "courier",
  "covenant",
  "cover",
  "coveted",
  "coveting",
  "coyness",
  "cozily",
  "coziness",
  "cozy",
  "crabbing",
  "crabgrass",
  "crablike",
  "crabmeat",
  "cradle",
  "cradling",
  "crafter",
  "craftily",
  "craftsman",
  "craftwork",
  "crafty",
  "cramp",
  "cranberry",
  "crane",
  "cranial",
  "cranium",
  "crank",
  "crate",
  "crave",
  "craving",
  "crawfish",
  "crawlers",
  "crawling",
  "crayfish",
  "crayon",
  "crazed",
  "crazily",
  "craziness",
  "crazy",
  "creamed",
  "creamer",
  "creamlike",
  "crease",
  "creasing",
  "creatable",
  "create",
  "creation",
  "creative",
  "creature",
  "credible",
  "credibly",
  "credit",
  "creed",
  "creme",
  "creole",
  "crepe",
  "crept",
  "crescent",
  "crested",
  "cresting",
  "crestless",
  "crevice",
  "crewless",
  "crewman",
  "crewmate",
  "crib",
  "cricket",
  "cried",
  "crier",
  "crimp",
  "crimson",
  "cringe",
  "cringing",
  "crinkle",
  "crinkly",
  "crisped",
  "crisping",
  "crisply",
  "crispness",
  "crispy",
  "criteria",
  "critter",
  "croak",
  "crock",
  "crook",
  "croon",
  "crop",
  "cross",
  "crouch",
  "crouton",
  "crowbar",
  "crowd",
  "crown",
  "crucial",
  "crudely",
  "crudeness",
  "cruelly",
  "cruelness",
  "cruelty",
  "crumb",
  "crummiest",
  "crummy",
  "crumpet",
  "crumpled",
  "cruncher",
  "crunching",
  "crunchy",
  "crusader",
  "crushable",
  "crushed",
  "crusher",
  "crushing",
  "crust",
  "crux",
  "crying",
  "cryptic",
  "crystal",
  "cubbyhole",
  "cube",
  "cubical",
  "cubicle",
  "cucumber",
  "cuddle",
  "cuddly",
  "cufflink",
  "culinary",
  "culminate",
  "culpable",
  "culprit",
  "cultivate",
  "cultural",
  "culture",
  "cupbearer",
  "cupcake",
  "cupid",
  "cupped",
  "cupping",
  "curable",
  "curator",
  "curdle",
  "cure",
  "curfew",
  "curing",
  "curled",
  "curler",
  "curliness",
  "curling",
  "curly",
  "curry",
  "curse",
  "cursive",
  "cursor",
  "curtain",
  "curtly",
  "curtsy",
  "curvature",
  "curve",
  "curvy",
  "cushy",
  "cusp",
  "cussed",
  "custard",
  "custodian",
  "custody",
  "customary",
  "customer",
  "customize",
  "customs",
  "cut",
  "cycle",
  "cyclic",
  "cycling",
  "cyclist",
  "cylinder",
  "cymbal",
  "cytoplasm",
  "cytoplast",
  "dab",
  "dad",
  "daffodil",
  "dagger",
  "daily",
  "daintily",
  "dainty",
  "dairy",
  "daisy",
  "dallying",
  "dance",
  "dancing",
  "dandelion",
  "dander",
  "dandruff",
  "dandy",
  "danger",
  "dangle",
  "dangling",
  "daredevil",
  "dares",
  "daringly",
  "darkened",
  "darkening",
  "darkish",
  "darkness",
  "darkroom",
  "darling",
  "darn",
  "dart",
  "darwinism",
  "dash",
  "dastardly",
  "data",
  "datebook",
  "dating",
  "daughter",
  "daunting",
  "dawdler",
  "dawn",
  "daybed",
  "daybreak",
  "daycare",
  "daydream",
  "daylight",
  "daylong",
  "dayroom",
  "daytime",
  "dazzler",
  "dazzling",
  "deacon",
  "deafening",
  "deafness",
  "dealer",
  "dealing",
  "dealmaker",
  "dealt",
  "dean",
  "debatable",
  "debate",
  "debating",
  "debit",
  "debrief",
  "debtless",
  "debtor",
  "debug",
  "debunk",
  "decade",
  "decaf",
  "decal",
  "decathlon",
  "decay",
  "deceased",
  "deceit",
  "deceiver",
  "deceiving",
  "december",
  "decency",
  "decent",
  "deception",
  "deceptive",
  "decibel",
  "decidable",
  "decimal",
  "decimeter",
  "decipher",
  "deck",
  "declared",
  "decline",
  "decode",
  "decompose",
  "decorated",
  "decorator",
  "decoy",
  "decrease",
  "decree",
  "dedicate",
  "dedicator",
  "deduce",
  "deduct",
  "deed",
  "deem",
  "deepen",
  "deeply",
  "deepness",
  "deface",
  "defacing",
  "defame",
  "default",
  "defeat",
  "defection",
  "defective",
  "defendant",
  "defender",
  "defense",
  "defensive",
  "deferral",
  "deferred",
  "defiance",
  "defiant",
  "defile",
  "defiling",
  "define",
  "definite",
  "deflate",
  "deflation",
  "deflator",
  "deflected",
  "deflector",
  "defog",
  "deforest",
  "defraud",
  "defrost",
  "deftly",
  "defuse",
  "defy",
  "degraded",
  "degrading",
  "degrease",
  "degree",
  "dehydrate",
  "deity",
  "dejected",
  "delay",
  "delegate",
  "delegator",
  "delete",
  "deletion",
  "delicacy",
  "delicate",
  "delicious",
  "delighted",
  "delirious",
  "delirium",
  "deliverer",
  "delivery",
  "delouse",
  "delta",
  "deluge",
  "delusion",
  "deluxe",
  "demanding",
  "demeaning",
  "demeanor",
  "demise",
  "democracy",
  "democrat",
  "demote",
  "demotion",
  "demystify",
  "denatured",
  "deniable",
  "denial",
  "denim",
  "denote",
  "dense",
  "density",
  "dental",
  "dentist",
  "denture",
  "deny",
  "deodorant",
  "deodorize",
  "departed",
  "departure",
  "depict",
  "deplete",
  "depletion",
  "deplored",
  "deploy",
  "deport",
  "depose",
  "depraved",
  "depravity",
  "deprecate",
  "depress",
  "deprive",
  "depth",
  "deputize",
  "deputy",
  "derail",
  "deranged",
  "derby",
  "derived",
  "desecrate",
  "deserve",
  "deserving",
  "designate",
  "designed",
  "designer",
  "designing",
  "deskbound",
  "desktop",
  "deskwork",
  "desolate",
  "despair",
  "despise",
  "despite",
  "destiny",
  "destitute",
  "destruct",
  "detached",
  "detail",
  "detection",
  "detective",
  "detector",
  "detention",
  "detergent",
  "detest",
  "detonate",
  "detonator",
  "detoxify",
  "detract",
  "deuce",
  "devalue",
  "deviancy",
  "deviant",
  "deviate",
  "deviation",
  "deviator",
  "device",
  "devious",
  "devotedly",
  "devotee",
  "devotion",
  "devourer",
  "devouring",
  "devoutly",
  "dexterity",
  "dexterous",
  "diabetes",
  "diabetic",
  "diabolic",
  "diagnoses",
  "diagnosis",
  "diagram",
  "dial",
  "diameter",
  "diaper",
  "diaphragm",
  "diary",
  "dice",
  "dicing",
  "dictate",
  "dictation",
  "dictator",
  "difficult",
  "diffused",
  "diffuser",
  "diffusion",
  "diffusive",
  "dig",
  "dilation",
  "diligence",
  "diligent",
  "dill",
  "dilute",
  "dime",
  "diminish",
  "dimly",
  "dimmed",
  "dimmer",
  "dimness",
  "dimple",
  "diner",
  "dingbat",
  "dinghy",
  "dinginess",
  "dingo",
  "dingy",
  "dining",
  "dinner",
  "diocese",
  "dioxide",
  "diploma",
  "dipped",
  "dipper",
  "dipping",
  "directed",
  "direction",
  "directive",
  "directly",
  "directory",
  "direness",
  "dirtiness",
  "disabled",
  "disagree",
  "disallow",
  "disarm",
  "disarray",
  "disaster",
  "disband",
  "disbelief",
  "disburse",
  "discard",
  "discern",
  "discharge",
  "disclose",
  "discolor",
  "discount",
  "discourse",
  "discover",
  "discuss",
  "disdain",
  "disengage",
  "disfigure",
  "disgrace",
  "dish",
  "disinfect",
  "disjoin",
  "disk",
  "dislike",
  "disliking",
  "dislocate",
  "dislodge",
  "disloyal",
  "dismantle",
  "dismay",
  "dismiss",
  "dismount",
  "disobey",
  "disorder",
  "disown",
  "disparate",
  "disparity",
  "dispatch",
  "dispense",
  "dispersal",
  "dispersed",
  "disperser",
  "displace",
  "display",
  "displease",
  "disposal",
  "dispose",
  "disprove",
  "dispute",
  "disregard",
  "disrupt",
  "dissuade",
  "distance",
  "distant",
  "distaste",
  "distill",
  "distinct",
  "distort",
  "distract",
  "distress",
  "district",
  "distrust",
  "ditch",
  "ditto",
  "ditzy",
  "dividable",
  "divided",
  "dividend",
  "dividers",
  "dividing",
  "divinely",
  "diving",
  "divinity",
  "divisible",
  "divisibly",
  "division",
  "divisive",
  "divorcee",
  "dizziness",
  "dizzy",
  "doable",
  "docile",
  "dock",
  "doctrine",
  "document",
  "dodge",
  "dodgy",
  "doily",
  "doing",
  "dole",
  "dollar",
  "dollhouse",
  "dollop",
  "dolly",
  "dolphin",
  "domain",
  "domelike",
  "domestic",
  "dominion",
  "dominoes",
  "donated",
  "donation",
  "donator",
  "donor",
  "donut",
  "doodle",
  "doorbell",
  "doorframe",
  "doorknob",
  "doorman",
  "doormat",
  "doornail",
  "doorpost",
  "doorstep",
  "doorstop",
  "doorway",
  "doozy",
  "dork",
  "dormitory",
  "dorsal",
  "dosage",
  "dose",
  "dotted",
  "doubling",
  "douche",
  "dove",
  "down",
  "dowry",
  "doze",
  "drab",
  "dragging",
  "dragonfly",
  "dragonish",
  "dragster",
  "drainable",
  "drainage",
  "drained",
  "drainer",
  "drainpipe",
  "dramatic",
  "dramatize",
  "drank",
  "drapery",
  "drastic",
  "draw",
  "dreaded",
  "dreadful",
  "dreadlock",
  "dreamboat",
  "dreamily",
  "dreamland",
  "dreamless",
  "dreamlike",
  "dreamt",
  "dreamy",
  "drearily",
  "dreary",
  "drench",
  "dress",
  "drew",
  "dribble",
  "dried",
  "drier",
  "drift",
  "driller",
  "drilling",
  "drinkable",
  "drinking",
  "dripping",
  "drippy",
  "drivable",
  "driven",
  "driver",
  "driveway",
  "driving",
  "drizzle",
  "drizzly",
  "drone",
  "drool",
  "droop",
  "drop-down",
  "dropbox",
  "dropkick",
  "droplet",
  "dropout",
  "dropper",
  "drove",
  "drown",
  "drowsily",
  "drudge",
  "drum",
  "dry",
  "dubbed",
  "dubiously",
  "duchess",
  "duckbill",
  "ducking",
  "duckling",
  "ducktail",
  "ducky",
  "duct",
  "dude",
  "duffel",
  "dugout",
  "duh",
  "duke",
  "duller",
  "dullness",
  "duly",
  "dumping",
  "dumpling",
  "dumpster",
  "duo",
  "dupe",
  "duplex",
  "duplicate",
  "duplicity",
  "durable",
  "durably",
  "duration",
  "duress",
  "during",
  "dusk",
  "dust",
  "dutiful",
  "duty",
  "duvet",
  "dwarf",
  "dweeb",
  "dwelled",
  "dweller",
  "dwelling",
  "dwindle",
  "dwindling",
  "dynamic",
  "dynamite",
  "dynasty",
  "dyslexia",
  "dyslexic",
  "each",
  "eagle",
  "earache",
  "eardrum",
  "earflap",
  "earful",
  "earlobe",
  "early",
  "earmark",
  "earmuff",
  "earphone",
  "earpiece",
  "earplugs",
  "earring",
  "earshot",
  "earthen",
  "earthlike",
  "earthling",
  "earthly",
  "earthworm",
  "earthy",
  "earwig",
  "easeful",
  "easel",
  "easiest",
  "easily",
  "easiness",
  "easing",
  "eastbound",
  "eastcoast",
  "easter",
  "eastward",
  "eatable",
  "eaten",
  "eatery",
  "eating",
  "eats",
  "ebay",
  "ebony",
  "ebook",
  "ecard",
  "eccentric",
  "echo",
  "eclair",
  "eclipse",
  "ecologist",
  "ecology",
  "economic",
  "economist",
  "economy",
  "ecosphere",
  "ecosystem",
  "edge",
  "edginess",
  "edging",
  "edgy",
  "edition",
  "editor",
  "educated",
  "education",
  "educator",
  "eel",
  "effective",
  "effects",
  "efficient",
  "effort",
  "eggbeater",
  "egging",
  "eggnog",
  "eggplant",
  "eggshell",
  "egomaniac",
  "egotism",
  "egotistic",
  "either",
  "eject",
  "elaborate",
  "elastic",
  "elated",
  "elbow",
  "eldercare",
  "elderly",
  "eldest",
  "electable",
  "election",
  "elective",
  "elephant",
  "elevate",
  "elevating",
  "elevation",
  "elevator",
  "eleven",
  "elf",
  "eligible",
  "eligibly",
  "eliminate",
  "elite",
  "elitism",
  "elixir",
  "elk",
  "ellipse",
  "elliptic",
  "elm",
  "elongated",
  "elope",
  "eloquence",
  "eloquent",
  "elsewhere",
  "elude",
  "elusive",
  "elves",
  "email",
  "embargo",
  "embark",
  "embassy",
  "embattled",
  "embellish",
  "ember",
  "embezzle",
  "emblaze",
  "emblem",
  "embody",
  "embolism",
  "emboss",
  "embroider",
  "emcee",
  "emerald",
  "emergency",
  "emission",
  "emit",
  "emote",
  "emoticon",
  "emotion",
  "empathic",
  "empathy",
  "emperor",
  "emphases",
  "emphasis",
  "emphasize",
  "emphatic",
  "empirical",
  "employed",
  "employee",
  "employer",
  "emporium",
  "empower",
  "emptier",
  "emptiness",
  "empty",
  "emu",
  "enable",
  "enactment",
  "enamel",
  "enchanted",
  "enchilada",
  "encircle",
  "enclose",
  "enclosure",
  "encode",
  "encore",
  "encounter",
  "encourage",
  "encroach",
  "encrust",
  "encrypt",
  "endanger",
  "endeared",
  "endearing",
  "ended",
  "ending",
  "endless",
  "endnote",
  "endocrine",
  "endorphin",
  "endorse",
  "endowment",
  "endpoint",
  "endurable",
  "endurance",
  "enduring",
  "energetic",
  "energize",
  "energy",
  "enforced",
  "enforcer",
  "engaged",
  "engaging",
  "engine",
  "engorge",
  "engraved",
  "engraver",
  "engraving",
  "engross",
  "engulf",
  "enhance",
  "enigmatic",
  "enjoyable",
  "enjoyably",
  "enjoyer",
  "enjoying",
  "enjoyment",
  "enlarged",
  "enlarging",
  "enlighten",
  "enlisted",
  "enquirer",
  "enrage",
  "enrich",
  "enroll",
  "enslave",
  "ensnare",
  "ensure",
  "entail",
  "entangled",
  "entering",
  "entertain",
  "enticing",
  "entire",
  "entitle",
  "entity",
  "entomb",
  "entourage",
  "entrap",
  "entree",
  "entrench",
  "entrust",
  "entryway",
  "entwine",
  "enunciate",
  "envelope",
  "enviable",
  "enviably",
  "envious",
  "envision",
  "envoy",
  "envy",
  "enzyme",
  "epic",
  "epidemic",
  "epidermal",
  "epidermis",
  "epidural",
  "epilepsy",
  "epileptic",
  "epilogue",
  "epiphany",
  "episode",
  "equal",
  "equate",
  "equation",
  "equator",
  "equinox",
  "equipment",
  "equity",
  "equivocal",
  "eradicate",
  "erasable",
  "erased",
  "eraser",
  "erasure",
  "ergonomic",
  "errand",
  "errant",
  "erratic",
  "error",
  "erupt",
  "escalate",
  "escalator",
  "escapable",
  "escapade",
  "escapist",
  "escargot",
  "eskimo",
  "esophagus",
  "espionage",
  "espresso",
  "esquire",
  "essay",
  "essence",
  "essential",
  "establish",
  "estate",
  "esteemed",
  "estimate",
  "estimator",
  "estranged",
  "estrogen",
  "etching",
  "eternal",
  "eternity",
  "ethanol",
  "ether",
  "ethically",
  "ethics",
  "euphemism",
  "evacuate",
  "evacuee",
  "evade",
  "evaluate",
  "evaluator",
  "evaporate",
  "evasion",
  "evasive",
  "even",
  "everglade",
  "evergreen",
  "everybody",
  "everyday",
  "everyone",
  "evict",
  "evidence",
  "evident",
  "evil",
  "evoke",
  "evolution",
  "evolve",
  "exact",
  "exalted",
  "example",
  "excavate",
  "excavator",
  "exceeding",
  "exception",
  "excess",
  "exchange",
  "excitable",
  "exciting",
  "exclaim",
  "exclude",
  "excluding",
  "exclusion",
  "exclusive",
  "excretion",
  "excretory",
  "excursion",
  "excusable",
  "excusably",
  "excuse",
  "exemplary",
  "exemplify",
  "exemption",
  "exerciser",
  "exert",
  "exes",
  "exfoliate",
  "exhale",
  "exhaust",
  "exhume",
  "exile",
  "existing",
  "exit",
  "exodus",
  "exonerate",
  "exorcism",
  "exorcist",
  "expand",
  "expanse",
  "expansion",
  "expansive",
  "expectant",
  "expedited",
  "expediter",
  "expel",
  "expend",
  "expenses",
  "expensive",
  "expert",
  "expire",
  "expiring",
  "explain",
  "expletive",
  "explicit",
  "explode",
  "exploit",
  "explore",
  "exploring",
  "exponent",
  "exporter",
  "exposable",
  "expose",
  "exposure",
  "express",
  "expulsion",
  "exquisite",
  "extended",
  "extending",
  "extent",
  "extenuate",
  "exterior",
  "external",
  "extinct",
  "extortion",
  "extradite",
  "extras",
  "extrovert",
  "extrude",
  "extruding",
  "exuberant",
  "fable",
  "fabric",
  "fabulous",
  "facebook",
  "facecloth",
  "facedown",
  "faceless",
  "facelift",
  "faceplate",
  "faceted",
  "facial",
  "facility",
  "facing",
  "facsimile",
  "faction",
  "factoid",
  "factor",
  "factsheet",
  "factual",
  "faculty",
  "fade",
  "fading",
  "failing",
  "falcon",
  "fall",
  "false",
  "falsify",
  "fame",
  "familiar",
  "family",
  "famine",
  "famished",
  "fanatic",
  "fancied",
  "fanciness",
  "fancy",
  "fanfare",
  "fang",
  "fanning",
  "fantasize",
  "fantastic",
  "fantasy",
  "fascism",
  "fastball",
  "faster",
  "fasting",
  "fastness",
  "faucet",
  "favorable",
  "favorably",
  "favored",
  "favoring",
  "favorite",
  "fax",
  "feast",
  "federal",
  "fedora",
  "feeble",
  "feed",
  "feel",
  "feisty",
  "feline",
  "felt-tip",
  "feminine",
  "feminism",
  "feminist",
  "feminize",
  "femur",
  "fence",
  "fencing",
  "fender",
  "ferment",
  "fernlike",
  "ferocious",
  "ferocity",
  "ferret",
  "ferris",
  "ferry",
  "fervor",
  "fester",
  "festival",
  "festive",
  "festivity",
  "fetal",
  "fetch",
  "fever",
  "fiber",
  "fiction",
  "fiddle",
  "fiddling",
  "fidelity",
  "fidgeting",
  "fidgety",
  "fifteen",
  "fifth",
  "fiftieth",
  "fifty",
  "figment",
  "figure",
  "figurine",
  "filing",
  "filled",
  "filler",
  "filling",
  "film",
  "filter",
  "filth",
  "filtrate",
  "finale",
  "finalist",
  "finalize",
  "finally",
  "finance",
  "financial",
  "finch",
  "fineness",
  "finer",
  "finicky",
  "finished",
  "finisher",
  "finishing",
  "finite",
  "finless",
  "finlike",
  "fiscally",
  "fit",
  "five",
  "flaccid",
  "flagman",
  "flagpole",
  "flagship",
  "flagstick",
  "flagstone",
  "flail",
  "flakily",
  "flaky",
  "flame",
  "flammable",
  "flanked",
  "flanking",
  "flannels",
  "flap",
  "flaring",
  "flashback",
  "flashbulb",
  "flashcard",
  "flashily",
  "flashing",
  "flashy",
  "flask",
  "flatbed",
  "flatfoot",
  "flatly",
  "flatness",
  "flatten",
  "flattered",
  "flatterer",
  "flattery",
  "flattop",
  "flatware",
  "flatworm",
  "flavored",
  "flavorful",
  "flavoring",
  "flaxseed",
  "fled",
  "fleshed",
  "fleshy",
  "flick",
  "flier",
  "flight",
  "flinch",
  "fling",
  "flint",
  "flip",
  "flirt",
  "float",
  "flock",
  "flogging",
  "flop",
  "floral",
  "florist",
  "floss",
  "flounder",
  "flyable",
  "flyaway",
  "flyer",
  "flying",
  "flyover",
  "flypaper",
  "foam",
  "foe",
  "fog",
  "foil",
  "folic",
  "folk",
  "follicle",
  "follow",
  "fondling",
  "fondly",
  "fondness",
  "fondue",
  "font",
  "food",
  "fool",
  "footage",
  "football",
  "footbath",
  "footboard",
  "footer",
  "footgear",
  "foothill",
  "foothold",
  "footing",
  "footless",
  "footman",
  "footnote",
  "footpad",
  "footpath",
  "footprint",
  "footrest",
  "footsie",
  "footsore",
  "footwear",
  "footwork",
  "fossil",
  "foster",
  "founder",
  "founding",
  "fountain",
  "fox",
  "foyer",
  "fraction",
  "fracture",
  "fragile",
  "fragility",
  "fragment",
  "fragrance",
  "fragrant",
  "frail",
  "frame",
  "framing",
  "frantic",
  "fraternal",
  "frayed",
  "fraying",
  "frays",
  "freckled",
  "freckles",
  "freebase",
  "freebee",
  "freebie",
  "freedom",
  "freefall",
  "freehand",
  "freeing",
  "freeload",
  "freely",
  "freemason",
  "freeness",
  "freestyle",
  "freeware",
  "freeway",
  "freewill",
  "freezable",
  "freezing",
  "freight",
  "french",
  "frenzied",
  "frenzy",
  "frequency",
  "frequent",
  "fresh",
  "fretful",
  "fretted",
  "friction",
  "friday",
  "fridge",
  "fried",
  "friend",
  "frighten",
  "frightful",
  "frigidity",
  "frigidly",
  "frill",
  "fringe",
  "frisbee",
  "frisk",
  "fritter",
  "frivolous",
  "frolic",
  "from",
  "front",
  "frostbite",
  "frosted",
  "frostily",
  "frosting",
  "frostlike",
  "frosty",
  "froth",
  "frown",
  "frozen",
  "fructose",
  "frugality",
  "frugally",
  "fruit",
  "frustrate",
  "frying",
  "gab",
  "gaffe",
  "gag",
  "gainfully",
  "gaining",
  "gains",
  "gala",
  "gallantly",
  "galleria",
  "gallery",
  "galley",
  "gallon",
  "gallows",
  "gallstone",
  "galore",
  "galvanize",
  "gambling",
  "game",
  "gaming",
  "gamma",
  "gander",
  "gangly",
  "gangrene",
  "gangway",
  "gap",
  "garage",
  "garbage",
  "garden",
  "gargle",
  "garland",
  "garlic",
  "garment",
  "garnet",
  "garnish",
  "garter",
  "gas",
  "gatherer",
  "gathering",
  "gating",
  "gauging",
  "gauntlet",
  "gauze",
  "gave",
  "gawk",
  "gazing",
  "gear",
  "gecko",
  "geek",
  "geiger",
  "gem",
  "gender",
  "generic",
  "generous",
  "genetics",
  "genre",
  "gentile",
  "gentleman",
  "gently",
  "gents",
  "geography",
  "geologic",
  "geologist",
  "geology",
  "geometric",
  "geometry",
  "geranium",
  "gerbil",
  "geriatric",
  "germicide",
  "germinate",
  "germless",
  "germproof",
  "gestate",
  "gestation",
  "gesture",
  "getaway",
  "getting",
  "getup",
  "giant",
  "gibberish",
  "giblet",
  "giddily",
  "giddiness",
  "giddy",
  "gift",
  "gigabyte",
  "gigahertz",
  "gigantic",
  "giggle",
  "giggling",
  "giggly",
  "gigolo",
  "gilled",
  "gills",
  "gimmick",
  "girdle",
  "giveaway",
  "given",
  "giver",
  "giving",
  "gizmo",
  "gizzard",
  "glacial",
  "glacier",
  "glade",
  "gladiator",
  "gladly",
  "glamorous",
  "glamour",
  "glance",
  "glancing",
  "glandular",
  "glare",
  "glaring",
  "glass",
  "glaucoma",
  "glazing",
  "gleaming",
  "gleeful",
  "glider",
  "gliding",
  "glimmer",
  "glimpse",
  "glisten",
  "glitch",
  "glitter",
  "glitzy",
  "gloater",
  "gloating",
  "gloomily",
  "gloomy",
  "glorified",
  "glorifier",
  "glorify",
  "glorious",
  "glory",
  "gloss",
  "glove",
  "glowing",
  "glowworm",
  "glucose",
  "glue",
  "gluten",
  "glutinous",
  "glutton",
  "gnarly",
  "gnat",
  "goal",
  "goatskin",
  "goes",
  "goggles",
  "going",
  "goldfish",
  "goldmine",
  "goldsmith",
  "golf",
  "goliath",
  "gonad",
  "gondola",
  "gone",
  "gong",
  "good",
  "gooey",
  "goofball",
  "goofiness",
  "goofy",
  "google",
  "goon",
  "gopher",
  "gore",
  "gorged",
  "gorgeous",
  "gory",
  "gosling",
  "gossip",
  "gothic",
  "gotten",
  "gout",
  "gown",
  "grab",
  "graceful",
  "graceless",
  "gracious",
  "gradation",
  "graded",
  "grader",
  "gradient",
  "grading",
  "gradually",
  "graduate",
  "graffiti",
  "grafted",
  "grafting",
  "grain",
  "granddad",
  "grandkid",
  "grandly",
  "grandma",
  "grandpa",
  "grandson",
  "granite",
  "granny",
  "granola",
  "grant",
  "granular",
  "grape",
  "graph",
  "grapple",
  "grappling",
  "grasp",
  "grass",
  "gratified",
  "gratify",
  "grating",
  "gratitude",
  "gratuity",
  "gravel",
  "graveness",
  "graves",
  "graveyard",
  "gravitate",
  "gravity",
  "gravy",
  "gray",
  "grazing",
  "greasily",
  "greedily",
  "greedless",
  "greedy",
  "green",
  "greeter",
  "greeting",
  "grew",
  "greyhound",
  "grid",
  "grief",
  "grievance",
  "grieving",
  "grievous",
  "grill",
  "grimace",
  "grimacing",
  "grime",
  "griminess",
  "grimy",
  "grinch",
  "grinning",
  "grip",
  "gristle",
  "grit",
  "groggily",
  "groggy",
  "groin",
  "groom",
  "groove",
  "grooving",
  "groovy",
  "grope",
  "ground",
  "grouped",
  "grout",
  "grove",
  "grower",
  "growing",
  "growl",
  "grub",
  "grudge",
  "grudging",
  "grueling",
  "gruffly",
  "grumble",
  "grumbling",
  "grumbly",
  "grumpily",
  "grunge",
  "grunt",
  "guacamole",
  "guidable",
  "guidance",
  "guide",
  "guiding",
  "guileless",
  "guise",
  "gulf",
  "gullible",
  "gully",
  "gulp",
  "gumball",
  "gumdrop",
  "gumminess",
  "gumming",
  "gummy",
  "gurgle",
  "gurgling",
  "guru",
  "gush",
  "gusto",
  "gusty",
  "gutless",
  "guts",
  "gutter",
  "guy",
  "guzzler",
  "gyration",
  "habitable",
  "habitant",
  "habitat",
  "habitual",
  "hacked",
  "hacker",
  "hacking",
  "hacksaw",
  "had",
  "haggler",
  "haiku",
  "half",
  "halogen",
  "halt",
  "halved",
  "halves",
  "hamburger",
  "hamlet",
  "hammock",
  "hamper",
  "hamster",
  "hamstring",
  "handbag",
  "handball",
  "handbook",
  "handbrake",
  "handcart",
  "handclap",
  "handclasp",
  "handcraft",
  "handcuff",
  "handed",
  "handful",
  "handgrip",
  "handgun",
  "handheld",
  "handiness",
  "handiwork",
  "handlebar",
  "handled",
  "handler",
  "handling",
  "handmade",
  "handoff",
  "handpick",
  "handprint",
  "handrail",
  "handsaw",
  "handset",
  "handsfree",
  "handshake",
  "handstand",
  "handwash",
  "handwork",
  "handwoven",
  "handwrite",
  "handyman",
  "hangnail",
  "hangout",
  "hangover",
  "hangup",
  "hankering",
  "hankie",
  "hanky",
  "haphazard",
  "happening",
  "happier",
  "happiest",
  "happily",
  "happiness",
  "happy",
  "harbor",
  "hardcopy",
  "hardcore",
  "hardcover",
  "harddisk",
  "hardened",
  "hardener",
  "hardening",
  "hardhat",
  "hardhead",
  "hardiness",
  "hardly",
  "hardness",
  "hardship",
  "hardware",
  "hardwired",
  "hardwood",
  "hardy",
  "harmful",
  "harmless",
  "harmonica",
  "harmonics",
  "harmonize",
  "harmony",
  "harness",
  "harpist",
  "harsh",
  "harvest",
  "hash",
  "hassle",
  "haste",
  "hastily",
  "hastiness",
  "hasty",
  "hatbox",
  "hatchback",
  "hatchery",
  "hatchet",
  "hatching",
  "hatchling",
  "hate",
  "hatless",
  "hatred",
  "haunt",
  "haven",
  "hazard",
  "hazelnut",
  "hazily",
  "haziness",
  "hazing",
  "hazy",
  "headache",
  "headband",
  "headboard",
  "headcount",
  "headdress",
  "headed",
  "header",
  "headfirst",
  "headgear",
  "heading",
  "headlamp",
  "headless",
  "headlock",
  "headphone",
  "headpiece",
  "headrest",
  "headroom",
  "headscarf",
  "headset",
  "headsman",
  "headstand",
  "headstone",
  "headway",
  "headwear",
  "heap",
  "heat",
  "heave",
  "heavily",
  "heaviness",
  "heaving",
  "hedge",
  "hedging",
  "heftiness",
  "hefty",
  "helium",
  "helmet",
  "helper",
  "helpful",
  "helping",
  "helpless",
  "helpline",
  "hemlock",
  "hemstitch",
  "hence",
  "henchman",
  "henna",
  "herald",
  "herbal",
  "herbicide",
  "herbs",
  "heritage",
  "hermit",
  "heroics",
  "heroism",
  "herring",
  "herself",
  "hertz",
  "hesitancy",
  "hesitant",
  "hesitate",
  "hexagon",
  "hexagram",
  "hubcap",
  "huddle",
  "huddling",
  "huff",
  "hug",
  "hula",
  "hulk",
  "hull",
  "human",
  "humble",
  "humbling",
  "humbly",
  "humid",
  "humiliate",
  "humility",
  "humming",
  "hummus",
  "humongous",
  "humorist",
  "humorless",
  "humorous",
  "humpback",
  "humped",
  "humvee",
  "hunchback",
  "hundredth",
  "hunger",
  "hungrily",
  "hungry",
  "hunk",
  "hunter",
  "hunting",
  "huntress",
  "huntsman",
  "hurdle",
  "hurled",
  "hurler",
  "hurling",
  "hurray",
  "hurricane",
  "hurried",
  "hurry",
  "hurt",
  "husband",
  "hush",
  "husked",
  "huskiness",
  "hut",
  "hybrid",
  "hydrant",
  "hydrated",
  "hydration",
  "hydrogen",
  "hydroxide",
  "hyperlink",
  "hypertext",
  "hyphen",
  "hypnoses",
  "hypnosis",
  "hypnotic",
  "hypnotism",
  "hypnotist",
  "hypnotize",
  "hypocrisy",
  "hypocrite",
  "ibuprofen",
  "ice",
  "iciness",
  "icing",
  "icky",
  "icon",
  "icy",
  "idealism",
  "idealist",
  "idealize",
  "ideally",
  "idealness",
  "identical",
  "identify",
  "identity",
  "ideology",
  "idiocy",
  "idiom",
  "idly",
  "igloo",
  "ignition",
  "ignore",
  "iguana",
  "illicitly",
  "illusion",
  "illusive",
  "image",
  "imaginary",
  "imagines",
  "imaging",
  "imbecile",
  "imitate",
  "imitation",
  "immature",
  "immerse",
  "immersion",
  "imminent",
  "immobile",
  "immodest",
  "immorally",
  "immortal",
  "immovable",
  "immovably",
  "immunity",
  "immunize",
  "impaired",
  "impale",
  "impart",
  "impatient",
  "impeach",
  "impeding",
  "impending",
  "imperfect",
  "imperial",
  "impish",
  "implant",
  "implement",
  "implicate",
  "implicit",
  "implode",
  "implosion",
  "implosive",
  "imply",
  "impolite",
  "important",
  "importer",
  "impose",
  "imposing",
  "impotence",
  "impotency",
  "impotent",
  "impound",
  "imprecise",
  "imprint",
  "imprison",
  "impromptu",
  "improper",
  "improve",
  "improving",
  "improvise",
  "imprudent",
  "impulse",
  "impulsive",
  "impure",
  "impurity",
  "iodine",
  "iodize",
  "ion",
  "ipad",
  "iphone",
  "ipod",
  "irate",
  "irk",
  "iron",
  "irregular",
  "irrigate",
  "irritable",
  "irritably",
  "irritant",
  "irritate",
  "islamic",
  "islamist",
  "isolated",
  "isolating",
  "isolation",
  "isotope",
  "issue",
  "issuing",
  "italicize",
  "italics",
  "item",
  "itinerary",
  "itunes",
  "ivory",
  "ivy",
  "jab",
  "jackal",
  "jacket",
  "jackknife",
  "jackpot",
  "jailbird",
  "jailbreak",
  "jailer",
  "jailhouse",
  "jalapeno",
  "jam",
  "janitor",
  "january",
  "jargon",
  "jarring",
  "jasmine",
  "jaundice",
  "jaunt",
  "java",
  "jawed",
  "jawless",
  "jawline",
  "jaws",
  "jaybird",
  "jaywalker",
  "jazz",
  "jeep",
  "jeeringly",
  "jellied",
  "jelly",
  "jersey",
  "jester",
  "jet",
  "jiffy",
  "jigsaw",
  "jimmy",
  "jingle",
  "jingling",
  "jinx",
  "jitters",
  "jittery",
  "job",
  "jockey",
  "jockstrap",
  "jogger",
  "jogging",
  "john",
  "joining",
  "jokester",
  "jokingly",
  "jolliness",
  "jolly",
  "jolt",
  "jot",
  "jovial",
  "joyfully",
  "joylessly",
  "joyous",
  "joyride",
  "joystick",
  "jubilance",
  "jubilant",
  "judge",
  "judgingly",
  "judicial",
  "judiciary",
  "judo",
  "juggle",
  "juggling",
  "jugular",
  "juice",
  "juiciness",
  "juicy",
  "jujitsu",
  "jukebox",
  "july",
  "jumble",
  "jumbo",
  "jump",
  "junction",
  "juncture",
  "june",
  "junior",
  "juniper",
  "junkie",
  "junkman",
  "junkyard",
  "jurist",
  "juror",
  "jury",
  "justice",
  "justifier",
  "justify",
  "justly",
  "justness",
  "juvenile",
  "kabob",
  "kangaroo",
  "karaoke",
  "karate",
  "karma",
  "kebab",
  "keenly",
  "keenness",
  "keep",
  "keg",
  "kelp",
  "kennel",
  "kept",
  "kerchief",
  "kerosene",
  "kettle",
  "kick",
  "kiln",
  "kilobyte",
  "kilogram",
  "kilometer",
  "kilowatt",
  "kilt",
  "kimono",
  "kindle",
  "kindling",
  "kindly",
  "kindness",
  "kindred",
  "kinetic",
  "kinfolk",
  "king",
  "kinship",
  "kinsman",
  "kinswoman",
  "kissable",
  "kisser",
  "kissing",
  "kitchen",
  "kite",
  "kitten",
  "kitty",
  "kiwi",
  "kleenex",
  "knapsack",
  "knee",
  "knelt",
  "knickers",
  "knoll",
  "koala",
  "kooky",
  "kosher",
  "krypton",
  "kudos",
  "kung",
  "labored",
  "laborer",
  "laboring",
  "laborious",
  "labrador",
  "ladder",
  "ladies",
  "ladle",
  "ladybug",
  "ladylike",
  "lagged",
  "lagging",
  "lagoon",
  "lair",
  "lake",
  "lance",
  "landed",
  "landfall",
  "landfill",
  "landing",
  "landlady",
  "landless",
  "landline",
  "landlord",
  "landmark",
  "landmass",
  "landmine",
  "landowner",
  "landscape",
  "landside",
  "landslide",
  "language",
  "lankiness",
  "lanky",
  "lantern",
  "lapdog",
  "lapel",
  "lapped",
  "lapping",
  "laptop",
  "lard",
  "large",
  "lark",
  "lash",
  "lasso",
  "last",
  "latch",
  "late",
  "lather",
  "latitude",
  "latrine",
  "latter",
  "latticed",
  "launch",
  "launder",
  "laundry",
  "laurel",
  "lavender",
  "lavish",
  "laxative",
  "lazily",
  "laziness",
  "lazy",
  "lecturer",
  "left",
  "legacy",
  "legal",
  "legend",
  "legged",
  "leggings",
  "legible",
  "legibly",
  "legislate",
  "lego",
  "legroom",
  "legume",
  "legwarmer",
  "legwork",
  "lemon",
  "lend",
  "length",
  "lens",
  "lent",
  "leotard",
  "lesser",
  "letdown",
  "lethargic",
  "lethargy",
  "letter",
  "lettuce",
  "level",
  "leverage",
  "levers",
  "levitate",
  "levitator",
  "liability",
  "liable",
  "liberty",
  "librarian",
  "library",
  "licking",
  "licorice",
  "lid",
  "life",
  "lifter",
  "lifting",
  "liftoff",
  "ligament",
  "likely",
  "likeness",
  "likewise",
  "liking",
  "lilac",
  "lilly",
  "lily",
  "limb",
  "limeade",
  "limelight",
  "limes",
  "limit",
  "limping",
  "limpness",
  "line",
  "lingo",
  "linguini",
  "linguist",
  "lining",
  "linked",
  "linoleum",
  "linseed",
  "lint",
  "lion",
  "lip",
  "liquefy",
  "liqueur",
  "liquid",
  "lisp",
  "list",
  "litigate",
  "litigator",
  "litmus",
  "litter",
  "little",
  "livable",
  "lived",
  "lively",
  "liver",
  "livestock",
  "lividly",
  "living",
  "lizard",
  "lubricant",
  "lubricate",
  "lucid",
  "luckily",
  "luckiness",
  "luckless",
  "lucrative",
  "ludicrous",
  "lugged",
  "lukewarm",
  "lullaby",
  "lumber",
  "luminance",
  "luminous",
  "lumpiness",
  "lumping",
  "lumpish",
  "lunacy",
  "lunar",
  "lunchbox",
  "luncheon",
  "lunchroom",
  "lunchtime",
  "lung",
  "lurch",
  "lure",
  "luridness",
  "lurk",
  "lushly",
  "lushness",
  "luster",
  "lustfully",
  "lustily",
  "lustiness",
  "lustrous",
  "lusty",
  "luxurious",
  "luxury",
  "lying",
  "lyrically",
  "lyricism",
  "lyricist",
  "lyrics",
  "macarena",
  "macaroni",
  "macaw",
  "mace",
  "machine",
  "machinist",
  "magazine",
  "magenta",
  "maggot",
  "magical",
  "magician",
  "magma",
  "magnesium",
  "magnetic",
  "magnetism",
  "magnetize",
  "magnifier",
  "magnify",
  "magnitude",
  "magnolia",
  "mahogany",
  "maimed",
  "majestic",
  "majesty",
  "majorette",
  "majority",
  "makeover",
  "maker",
  "makeshift",
  "making",
  "malformed",
  "malt",
  "mama",
  "mammal",
  "mammary",
  "mammogram",
  "manager",
  "managing",
  "manatee",
  "mandarin",
  "mandate",
  "mandatory",
  "mandolin",
  "manger",
  "mangle",
  "mango",
  "mangy",
  "manhandle",
  "manhole",
  "manhood",
  "manhunt",
  "manicotti",
  "manicure",
  "manifesto",
  "manila",
  "mankind",
  "manlike",
  "manliness",
  "manly",
  "manmade",
  "manned",
  "mannish",
  "manor",
  "manpower",
  "mantis",
  "mantra",
  "manual",
  "many",
  "map",
  "marathon",
  "marauding",
  "marbled",
  "marbles",
  "marbling",
  "march",
  "mardi",
  "margarine",
  "margarita",
  "margin",
  "marigold",
  "marina",
  "marine",
  "marital",
  "maritime",
  "marlin",
  "marmalade",
  "maroon",
  "married",
  "marrow",
  "marry",
  "marshland",
  "marshy",
  "marsupial",
  "marvelous",
  "marxism",
  "mascot",
  "masculine",
  "mashed",
  "mashing",
  "massager",
  "masses",
  "massive",
  "mastiff",
  "matador",
  "matchbook",
  "matchbox",
  "matcher",
  "matching",
  "matchless",
  "material",
  "maternal",
  "maternity",
  "math",
  "mating",
  "matriarch",
  "matrimony",
  "matrix",
  "matron",
  "matted",
  "matter",
  "maturely",
  "maturing",
  "maturity",
  "mauve",
  "maverick",
  "maximize",
  "maximum",
  "maybe",
  "mayday",
  "mayflower",
  "moaner",
  "moaning",
  "mobile",
  "mobility",
  "mobilize",
  "mobster",
  "mocha",
  "mocker",
  "mockup",
  "modified",
  "modify",
  "modular",
  "modulator",
  "module",
  "moisten",
  "moistness",
  "moisture",
  "molar",
  "molasses",
  "mold",
  "molecular",
  "molecule",
  "molehill",
  "mollusk",
  "mom",
  "monastery",
  "monday",
  "monetary",
  "monetize",
  "moneybags",
  "moneyless",
  "moneywise",
  "mongoose",
  "mongrel",
  "monitor",
  "monkhood",
  "monogamy",
  "monogram",
  "monologue",
  "monopoly",
  "monorail",
  "monotone",
  "monotype",
  "monoxide",
  "monsieur",
  "monsoon",
  "monstrous",
  "monthly",
  "monument",
  "moocher",
  "moodiness",
  "moody",
  "mooing",
  "moonbeam",
  "mooned",
  "moonlight",
  "moonlike",
  "moonlit",
  "moonrise",
  "moonscape",
  "moonshine",
  "moonstone",
  "moonwalk",
  "mop",
  "morale",
  "morality",
  "morally",
  "morbidity",
  "morbidly",
  "morphine",
  "morphing",
  "morse",
  "mortality",
  "mortally",
  "mortician",
  "mortified",
  "mortify",
  "mortuary",
  "mosaic",
  "mossy",
  "most",
  "mothball",
  "mothproof",
  "motion",
  "motivate",
  "motivator",
  "motive",
  "motocross",
  "motor",
  "motto",
  "mountable",
  "mountain",
  "mounted",
  "mounting",
  "mourner",
  "mournful",
  "mouse",
  "mousiness",
  "moustache",
  "mousy",
  "mouth",
  "movable",
  "move",
  "movie",
  "moving",
  "mower",
  "mowing",
  "much",
  "muck",
  "mud",
  "mug",
  "mulberry",
  "mulch",
  "mule",
  "mulled",
  "mullets",
  "multiple",
  "multiply",
  "multitask",
  "multitude",
  "mumble",
  "mumbling",
  "mumbo",
  "mummified",
  "mummify",
  "mummy",
  "mumps",
  "munchkin",
  "mundane",
  "municipal",
  "muppet",
  "mural",
  "murkiness",
  "murky",
  "murmuring",
  "muscular",
  "museum",
  "mushily",
  "mushiness",
  "mushroom",
  "mushy",
  "music",
  "musket",
  "muskiness",
  "musky",
  "mustang",
  "mustard",
  "muster",
  "mustiness",
  "musty",
  "mutable",
  "mutate",
  "mutation",
  "mute",
  "mutilated",
  "mutilator",
  "mutiny",
  "mutt",
  "mutual",
  "muzzle",
  "myself",
  "myspace",
  "mystified",
  "mystify",
  "myth",
  "nacho",
  "nag",
  "nail",
  "name",
  "naming",
  "nanny",
  "nanometer",
  "nape",
  "napkin",
  "napped",
  "napping",
  "nappy",
  "narrow",
  "nastily",
  "nastiness",
  "national",
  "native",
  "nativity",
  "natural",
  "nature",
  "naturist",
  "nautical",
  "navigate",
  "navigator",
  "navy",
  "nearby",
  "nearest",
  "nearly",
  "nearness",
  "neatly",
  "neatness",
  "nebula",
  "nebulizer",
  "nectar",
  "negate",
  "negation",
  "negative",
  "neglector",
  "negligee",
  "negligent",
  "negotiate",
  "nemeses",
  "nemesis",
  "neon",
  "nephew",
  "nerd",
  "nervous",
  "nervy",
  "nest",
  "net",
  "neurology",
  "neuron",
  "neurosis",
  "neurotic",
  "neuter",
  "neutron",
  "never",
  "next",
  "nibble",
  "nickname",
  "nicotine",
  "niece",
  "nifty",
  "nimble",
  "nimbly",
  "nineteen",
  "ninetieth",
  "ninja",
  "nintendo",
  "ninth",
  "nuclear",
  "nuclei",
  "nucleus",
  "nugget",
  "nullify",
  "number",
  "numbing",
  "numbly",
  "numbness",
  "numeral",
  "numerate",
  "numerator",
  "numeric",
  "numerous",
  "nuptials",
  "nursery",
  "nursing",
  "nurture",
  "nutcase",
  "nutlike",
  "nutmeg",
  "nutrient",
  "nutshell",
  "nuttiness",
  "nutty",
  "nuzzle",
  "nylon",
  "oaf",
  "oak",
  "oasis",
  "oat",
  "obedience",
  "obedient",
  "obituary",
  "object",
  "obligate",
  "obliged",
  "oblivion",
  "oblivious",
  "oblong",
  "obnoxious",
  "oboe",
  "obscure",
  "obscurity",
  "observant",
  "observer",
  "observing",
  "obsessed",
  "obsession",
  "obsessive",
  "obsolete",
  "obstacle",
  "obstinate",
  "obstruct",
  "obtain",
  "obtrusive",
  "obtuse",
  "obvious",
  "occultist",
  "occupancy",
  "occupant",
  "occupier",
  "occupy",
  "ocean",
  "ocelot",
  "octagon",
  "octane",
  "october",
  "octopus",
  "ogle",
  "oil",
  "oink",
  "ointment",
  "okay",
  "old",
  "olive",
  "olympics",
  "omega",
  "omen",
  "ominous",
  "omission",
  "omit",
  "omnivore",
  "onboard",
  "oncoming",
  "ongoing",
  "onion",
  "online",
  "onlooker",
  "only",
  "onscreen",
  "onset",
  "onshore",
  "onslaught",
  "onstage",
  "onto",
  "onward",
  "onyx",
  "oops",
  "ooze",
  "oozy",
  "opacity",
  "opal",
  "open",
  "operable",
  "operate",
  "operating",
  "operation",
  "operative",
  "operator",
  "opium",
  "opossum",
  "opponent",
  "oppose",
  "opposing",
  "opposite",
  "oppressed",
  "oppressor",
  "opt",
  "opulently",
  "osmosis",
  "other",
  "otter",
  "ouch",
  "ought",
  "ounce",
  "outage",
  "outback",
  "outbid",
  "outboard",
  "outbound",
  "outbreak",
  "outburst",
  "outcast",
  "outclass",
  "outcome",
  "outdated",
  "outdoors",
  "outer",
  "outfield",
  "outfit",
  "outflank",
  "outgoing",
  "outgrow",
  "outhouse",
  "outing",
  "outlast",
  "outlet",
  "outline",
  "outlook",
  "outlying",
  "outmatch",
  "outmost",
  "outnumber",
  "outplayed",
  "outpost",
  "outpour",
  "output",
  "outrage",
  "outrank",
  "outreach",
  "outright",
  "outscore",
  "outsell",
  "outshine",
  "outshoot",
  "outsider",
  "outskirts",
  "outsmart",
  "outsource",
  "outspoken",
  "outtakes",
  "outthink",
  "outward",
  "outweigh",
  "outwit",
  "oval",
  "ovary",
  "oven",
  "overact",
  "overall",
  "overarch",
  "overbid",
  "overbill",
  "overbite",
  "overblown",
  "overboard",
  "overbook",
  "overbuilt",
  "overcast",
  "overcoat",
  "overcome",
  "overcook",
  "overcrowd",
  "overdraft",
  "overdrawn",
  "overdress",
  "overdrive",
  "overdue",
  "overeager",
  "overeater",
  "overexert",
  "overfed",
  "overfeed",
  "overfill",
  "overflow",
  "overfull",
  "overgrown",
  "overhand",
  "overhang",
  "overhaul",
  "overhead",
  "overhear",
  "overheat",
  "overhung",
  "overjoyed",
  "overkill",
  "overlabor",
  "overlaid",
  "overlap",
  "overlay",
  "overload",
  "overlook",
  "overlord",
  "overlying",
  "overnight",
  "overpass",
  "overpay",
  "overplant",
  "overplay",
  "overpower",
  "overprice",
  "overrate",
  "overreach",
  "overreact",
  "override",
  "overripe",
  "overrule",
  "overrun",
  "overshoot",
  "overshot",
  "oversight",
  "oversized",
  "oversleep",
  "oversold",
  "overspend",
  "overstate",
  "overstay",
  "overstep",
  "overstock",
  "overstuff",
  "oversweet",
  "overtake",
  "overthrow",
  "overtime",
  "overtly",
  "overtone",
  "overture",
  "overturn",
  "overuse",
  "overvalue",
  "overview",
  "overwrite",
  "owl",
  "oxford",
  "oxidant",
  "oxidation",
  "oxidize",
  "oxidizing",
  "oxygen",
  "oxymoron",
  "oyster",
  "ozone",
  "paced",
  "pacemaker",
  "pacific",
  "pacifier",
  "pacifism",
  "pacifist",
  "pacify",
  "padded",
  "padding",
  "paddle",
  "paddling",
  "padlock",
  "pagan",
  "pager",
  "paging",
  "pajamas",
  "palace",
  "palatable",
  "palm",
  "palpable",
  "palpitate",
  "paltry",
  "pampered",
  "pamperer",
  "pampers",
  "pamphlet",
  "panama",
  "pancake",
  "pancreas",
  "panda",
  "pandemic",
  "pang",
  "panhandle",
  "panic",
  "panning",
  "panorama",
  "panoramic",
  "panther",
  "pantomime",
  "pantry",
  "pants",
  "pantyhose",
  "paparazzi",
  "papaya",
  "paper",
  "paprika",
  "papyrus",
  "parabola",
  "parachute",
  "parade",
  "paradox",
  "paragraph",
  "parakeet",
  "paralegal",
  "paralyses",
  "paralysis",
  "paralyze",
  "paramedic",
  "parameter",
  "paramount",
  "parasail",
  "parasite",
  "parasitic",
  "parcel",
  "parched",
  "parchment",
  "pardon",
  "parish",
  "parka",
  "parking",
  "parkway",
  "parlor",
  "parmesan",
  "parole",
  "parrot",
  "parsley",
  "parsnip",
  "partake",
  "parted",
  "parting",
  "partition",
  "partly",
  "partner",
  "partridge",
  "party",
  "passable",
  "passably",
  "passage",
  "passcode",
  "passenger",
  "passerby",
  "passing",
  "passion",
  "passive",
  "passivism",
  "passover",
  "passport",
  "password",
  "pasta",
  "pasted",
  "pastel",
  "pastime",
  "pastor",
  "pastrami",
  "pasture",
  "pasty",
  "patchwork",
  "patchy",
  "paternal",
  "paternity",
  "path",
  "patience",
  "patient",
  "patio",
  "patriarch",
  "patriot",
  "patrol",
  "patronage",
  "patronize",
  "pauper",
  "pavement",
  "paver",
  "pavestone",
  "pavilion",
  "paving",
  "pawing",
  "payable",
  "payback",
  "paycheck",
  "payday",
  "payee",
  "payer",
  "paying",
  "payment",
  "payphone",
  "payroll",
  "pebble",
  "pebbly",
  "pecan",
  "pectin",
  "peculiar",
  "peddling",
  "pediatric",
  "pedicure",
  "pedigree",
  "pedometer",
  "pegboard",
  "pelican",
  "pellet",
  "pelt",
  "pelvis",
  "penalize",
  "penalty",
  "pencil",
  "pendant",
  "pending",
  "penholder",
  "penknife",
  "pennant",
  "penniless",
  "penny",
  "penpal",
  "pension",
  "pentagon",
  "pentagram",
  "pep",
  "perceive",
  "percent",
  "perch",
  "percolate",
  "perennial",
  "perfected",
  "perfectly",
  "perfume",
  "periscope",
  "perish",
  "perjurer",
  "perjury",
  "perkiness",
  "perky",
  "perm",
  "peroxide",
  "perpetual",
  "perplexed",
  "persecute",
  "persevere",
  "persuaded",
  "persuader",
  "pesky",
  "peso",
  "pessimism",
  "pessimist",
  "pester",
  "pesticide",
  "petal",
  "petite",
  "petition",
  "petri",
  "petroleum",
  "petted",
  "petticoat",
  "pettiness",
  "petty",
  "petunia",
  "phantom",
  "phobia",
  "phoenix",
  "phonebook",
  "phoney",
  "phonics",
  "phoniness",
  "phony",
  "phosphate",
  "photo",
  "phrase",
  "phrasing",
  "placard",
  "placate",
  "placidly",
  "plank",
  "planner",
  "plant",
  "plasma",
  "plaster",
  "plastic",
  "plated",
  "platform",
  "plating",
  "platinum",
  "platonic",
  "platter",
  "platypus",
  "plausible",
  "plausibly",
  "playable",
  "playback",
  "player",
  "playful",
  "playgroup",
  "playhouse",
  "playing",
  "playlist",
  "playmaker",
  "playmate",
  "playoff",
  "playpen",
  "playroom",
  "playset",
  "plaything",
  "playtime",
  "plaza",
  "pleading",
  "pleat",
  "pledge",
  "plentiful",
  "plenty",
  "plethora",
  "plexiglas",
  "pliable",
  "plod",
  "plop",
  "plot",
  "plow",
  "ploy",
  "pluck",
  "plug",
  "plunder",
  "plunging",
  "plural",
  "plus",
  "plutonium",
  "plywood",
  "poach",
  "pod",
  "poem",
  "poet",
  "pogo",
  "pointed",
  "pointer",
  "pointing",
  "pointless",
  "pointy",
  "poise",
  "poison",
  "poker",
  "poking",
  "polar",
  "police",
  "policy",
  "polio",
  "polish",
  "politely",
  "polka",
  "polo",
  "polyester",
  "polygon",
  "polygraph",
  "polymer",
  "poncho",
  "pond",
  "pony",
  "popcorn",
  "pope",
  "poplar",
  "popper",
  "poppy",
  "popsicle",
  "populace",
  "popular",
  "populate",
  "porcupine",
  "pork",
  "porous",
  "porridge",
  "portable",
  "portal",
  "portfolio",
  "porthole",
  "portion",
  "portly",
  "portside",
  "poser",
  "posh",
  "posing",
  "possible",
  "possibly",
  "possum",
  "postage",
  "postal",
  "postbox",
  "postcard",
  "posted",
  "poster",
  "posting",
  "postnasal",
  "posture",
  "postwar",
  "pouch",
  "pounce",
  "pouncing",
  "pound",
  "pouring",
  "pout",
  "powdered",
  "powdering",
  "powdery",
  "power",
  "powwow",
  "pox",
  "praising",
  "prance",
  "prancing",
  "pranker",
  "prankish",
  "prankster",
  "prayer",
  "praying",
  "preacher",
  "preaching",
  "preachy",
  "preamble",
  "precinct",
  "precise",
  "precision",
  "precook",
  "precut",
  "predator",
  "predefine",
  "predict",
  "preface",
  "prefix",
  "preflight",
  "preformed",
  "pregame",
  "pregnancy",
  "pregnant",
  "preheated",
  "prelaunch",
  "prelaw",
  "prelude",
  "premiere",
  "premises",
  "premium",
  "prenatal",
  "preoccupy",
  "preorder",
  "prepaid",
  "prepay",
  "preplan",
  "preppy",
  "preschool",
  "prescribe",
  "preseason",
  "preset",
  "preshow",
  "president",
  "presoak",
  "press",
  "presume",
  "presuming",
  "preteen",
  "pretended",
  "pretender",
  "pretense",
  "pretext",
  "pretty",
  "pretzel",
  "prevail",
  "prevalent",
  "prevent",
  "preview",
  "previous",
  "prewar",
  "prewashed",
  "prideful",
  "pried",
  "primal",
  "primarily",
  "primary",
  "primate",
  "primer",
  "primp",
  "princess",
  "print",
  "prior",
  "prism",
  "prison",
  "prissy",
  "pristine",
  "privacy",
  "private",
  "privatize",
  "prize",
  "proactive",
  "probable",
  "probably",
  "probation",
  "probe",
  "probing",
  "probiotic",
  "problem",
  "procedure",
  "process",
  "proclaim",
  "procreate",
  "procurer",
  "prodigal",
  "prodigy",
  "produce",
  "product",
  "profane",
  "profanity",
  "professed",
  "professor",
  "profile",
  "profound",
  "profusely",
  "progeny",
  "prognosis",
  "program",
  "progress",
  "projector",
  "prologue",
  "prolonged",
  "promenade",
  "prominent",
  "promoter",
  "promotion",
  "prompter",
  "promptly",
  "prone",
  "prong",
  "pronounce",
  "pronto",
  "proofing",
  "proofread",
  "proofs",
  "propeller",
  "properly",
  "property",
  "proponent",
  "proposal",
  "propose",
  "props",
  "prorate",
  "protector",
  "protegee",
  "proton",
  "prototype",
  "protozoan",
  "protract",
  "protrude",
  "proud",
  "provable",
  "proved",
  "proven",
  "provided",
  "provider",
  "providing",
  "province",
  "proving",
  "provoke",
  "provoking",
  "provolone",
  "prowess",
  "prowler",
  "prowling",
  "proximity",
  "proxy",
  "prozac",
  "prude",
  "prudishly",
  "prune",
  "pruning",
  "pry",
  "psychic",
  "public",
  "publisher",
  "pucker",
  "pueblo",
  "pug",
  "pull",
  "pulmonary",
  "pulp",
  "pulsate",
  "pulse",
  "pulverize",
  "puma",
  "pumice",
  "pummel",
  "punch",
  "punctual",
  "punctuate",
  "punctured",
  "pungent",
  "punisher",
  "punk",
  "pupil",
  "puppet",
  "puppy",
  "purchase",
  "pureblood",
  "purebred",
  "purely",
  "pureness",
  "purgatory",
  "purge",
  "purging",
  "purifier",
  "purify",
  "purist",
  "puritan",
  "purity",
  "purple",
  "purplish",
  "purposely",
  "purr",
  "purse",
  "pursuable",
  "pursuant",
  "pursuit",
  "purveyor",
  "pushcart",
  "pushchair",
  "pusher",
  "pushiness",
  "pushing",
  "pushover",
  "pushpin",
  "pushup",
  "pushy",
  "putdown",
  "putt",
  "puzzle",
  "puzzling",
  "pyramid",
  "pyromania",
  "python",
  "quack",
  "quadrant",
  "quail",
  "quaintly",
  "quake",
  "quaking",
  "qualified",
  "qualifier",
  "qualify",
  "quality",
  "qualm",
  "quantum",
  "quarrel",
  "quarry",
  "quartered",
  "quarterly",
  "quarters",
  "quartet",
  "quench",
  "query",
  "quicken",
  "quickly",
  "quickness",
  "quicksand",
  "quickstep",
  "quiet",
  "quill",
  "quilt",
  "quintet",
  "quintuple",
  "quirk",
  "quit",
  "quiver",
  "quizzical",
  "quotable",
  "quotation",
  "quote",
  "rabid",
  "race",
  "racing",
  "racism",
  "rack",
  "racoon",
  "radar",
  "radial",
  "radiance",
  "radiantly",
  "radiated",
  "radiation",
  "radiator",
  "radio",
  "radish",
  "raffle",
  "raft",
  "rage",
  "ragged",
  "raging",
  "ragweed",
  "raider",
  "railcar",
  "railing",
  "railroad",
  "railway",
  "raisin",
  "rake",
  "raking",
  "rally",
  "ramble",
  "rambling",
  "ramp",
  "ramrod",
  "ranch",
  "rancidity",
  "random",
  "ranged",
  "ranger",
  "ranging",
  "ranked",
  "ranking",
  "ransack",
  "ranting",
  "rants",
  "rare",
  "rarity",
  "rascal",
  "rash",
  "rasping",
  "ravage",
  "raven",
  "ravine",
  "raving",
  "ravioli",
  "ravishing",
  "reabsorb",
  "reach",
  "reacquire",
  "reaction",
  "reactive",
  "reactor",
  "reaffirm",
  "ream",
  "reanalyze",
  "reappear",
  "reapply",
  "reappoint",
  "reapprove",
  "rearrange",
  "rearview",
  "reason",
  "reassign",
  "reassure",
  "reattach",
  "reawake",
  "rebalance",
  "rebate",
  "rebel",
  "rebirth",
  "reboot",
  "reborn",
  "rebound",
  "rebuff",
  "rebuild",
  "rebuilt",
  "reburial",
  "rebuttal",
  "recall",
  "recant",
  "recapture",
  "recast",
  "recede",
  "recent",
  "recess",
  "recharger",
  "recipient",
  "recital",
  "recite",
  "reckless",
  "reclaim",
  "recliner",
  "reclining",
  "recluse",
  "reclusive",
  "recognize",
  "recoil",
  "recollect",
  "recolor",
  "reconcile",
  "reconfirm",
  "reconvene",
  "recopy",
  "record",
  "recount",
  "recoup",
  "recovery",
  "recreate",
  "rectal",
  "rectangle",
  "rectified",
  "rectify",
  "recycled",
  "recycler",
  "recycling",
  "reemerge",
  "reenact",
  "reenter",
  "reentry",
  "reexamine",
  "referable",
  "referee",
  "reference",
  "refill",
  "refinance",
  "refined",
  "refinery",
  "refining",
  "refinish",
  "reflected",
  "reflector",
  "reflex",
  "reflux",
  "refocus",
  "refold",
  "reforest",
  "reformat",
  "reformed",
  "reformer",
  "reformist",
  "refract",
  "refrain",
  "refreeze",
  "refresh",
  "refried",
  "refueling",
  "refund",
  "refurbish",
  "refurnish",
  "refusal",
  "refuse",
  "refusing",
  "refutable",
  "refute",
  "regain",
  "regalia",
  "regally",
  "reggae",
  "regime",
  "region",
  "register",
  "registrar",
  "registry",
  "regress",
  "regretful",
  "regroup",
  "regular",
  "regulate",
  "regulator",
  "rehab",
  "reheat",
  "rehire",
  "rehydrate",
  "reimburse",
  "reissue",
  "reiterate",
  "rejoice",
  "rejoicing",
  "rejoin",
  "rekindle",
  "relapse",
  "relapsing",
  "relatable",
  "related",
  "relation",
  "relative",
  "relax",
  "relay",
  "relearn",
  "release",
  "relenting",
  "reliable",
  "reliably",
  "reliance",
  "reliant",
  "relic",
  "relieve",
  "relieving",
  "relight",
  "relish",
  "relive",
  "reload",
  "relocate",
  "relock",
  "reluctant",
  "rely",
  "remake",
  "remark",
  "remarry",
  "rematch",
  "remedial",
  "remedy",
  "remember",
  "reminder",
  "remindful",
  "remission",
  "remix",
  "remnant",
  "remodeler",
  "remold",
  "remorse",
  "remote",
  "removable",
  "removal",
  "removed",
  "remover",
  "removing",
  "rename",
  "renderer",
  "rendering",
  "rendition",
  "renegade",
  "renewable",
  "renewably",
  "renewal",
  "renewed",
  "renounce",
  "renovate",
  "renovator",
  "rentable",
  "rental",
  "rented",
  "renter",
  "reoccupy",
  "reoccur",
  "reopen",
  "reorder",
  "repackage",
  "repacking",
  "repaint",
  "repair",
  "repave",
  "repaying",
  "repayment",
  "repeal",
  "repeated",
  "repeater",
  "repent",
  "rephrase",
  "replace",
  "replay",
  "replica",
  "reply",
  "reporter",
  "repose",
  "repossess",
  "repost",
  "repressed",
  "reprimand",
  "reprint",
  "reprise",
  "reproach",
  "reprocess",
  "reproduce",
  "reprogram",
  "reps",
  "reptile",
  "reptilian",
  "repugnant",
  "repulsion",
  "repulsive",
  "repurpose",
  "reputable",
  "reputably",
  "request",
  "require",
  "requisite",
  "reroute",
  "rerun",
  "resale",
  "resample",
  "rescuer",
  "reseal",
  "research",
  "reselect",
  "reseller",
  "resemble",
  "resend",
  "resent",
  "reset",
  "reshape",
  "reshoot",
  "reshuffle",
  "residence",
  "residency",
  "resident",
  "residual",
  "residue",
  "resigned",
  "resilient",
  "resistant",
  "resisting",
  "resize",
  "resolute",
  "resolved",
  "resonant",
  "resonate",
  "resort",
  "resource",
  "respect",
  "resubmit",
  "result",
  "resume",
  "resupply",
  "resurface",
  "resurrect",
  "retail",
  "retainer",
  "retaining",
  "retake",
  "retaliate",
  "retention",
  "rethink",
  "retinal",
  "retired",
  "retiree",
  "retiring",
  "retold",
  "retool",
  "retorted",
  "retouch",
  "retrace",
  "retract",
  "retrain",
  "retread",
  "retreat",
  "retrial",
  "retrieval",
  "retriever",
  "retry",
  "return",
  "retying",
  "retype",
  "reunion",
  "reunite",
  "reusable",
  "reuse",
  "reveal",
  "reveler",
  "revenge",
  "revenue",
  "reverb",
  "revered",
  "reverence",
  "reverend",
  "reversal",
  "reverse",
  "reversing",
  "reversion",
  "revert",
  "revisable",
  "revise",
  "revision",
  "revisit",
  "revivable",
  "revival",
  "reviver",
  "reviving",
  "revocable",
  "revoke",
  "revolt",
  "revolver",
  "revolving",
  "reward",
  "rewash",
  "rewind",
  "rewire",
  "reword",
  "rework",
  "rewrap",
  "rewrite",
  "rhyme",
  "ribbon",
  "ribcage",
  "rice",
  "riches",
  "richly",
  "richness",
  "rickety",
  "ricotta",
  "riddance",
  "ridden",
  "ride",
  "riding",
  "rifling",
  "rift",
  "rigging",
  "rigid",
  "rigor",
  "rimless",
  "rimmed",
  "rind",
  "rink",
  "rinse",
  "rinsing",
  "riot",
  "ripcord",
  "ripeness",
  "ripening",
  "ripping",
  "ripple",
  "rippling",
  "riptide",
  "rise",
  "rising",
  "risk",
  "risotto",
  "ritalin",
  "ritzy",
  "rival",
  "riverbank",
  "riverbed",
  "riverboat",
  "riverside",
  "riveter",
  "riveting",
  "roamer",
  "roaming",
  "roast",
  "robbing",
  "robe",
  "robin",
  "robotics",
  "robust",
  "rockband",
  "rocker",
  "rocket",
  "rockfish",
  "rockiness",
  "rocking",
  "rocklike",
  "rockslide",
  "rockstar",
  "rocky",
  "rogue",
  "roman",
  "romp",
  "rope",
  "roping",
  "roster",
  "rosy",
  "rotten",
  "rotting",
  "rotunda",
  "roulette",
  "rounding",
  "roundish",
  "roundness",
  "roundup",
  "roundworm",
  "routine",
  "routing",
  "rover",
  "roving",
  "royal",
  "rubbed",
  "rubber",
  "rubbing",
  "rubble",
  "rubdown",
  "ruby",
  "ruckus",
  "rudder",
  "rug",
  "ruined",
  "rule",
  "rumble",
  "rumbling",
  "rummage",
  "rumor",
  "runaround",
  "rundown",
  "runner",
  "running",
  "runny",
  "runt",
  "runway",
  "rupture",
  "rural",
  "ruse",
  "rush",
  "rust",
  "rut",
  "sabbath",
  "sabotage",
  "sacrament",
  "sacred",
  "sacrifice",
  "sadden",
  "saddlebag",
  "saddled",
  "saddling",
  "sadly",
  "sadness",
  "safari",
  "safeguard",
  "safehouse",
  "safely",
  "safeness",
  "saffron",
  "saga",
  "sage",
  "sagging",
  "saggy",
  "said",
  "saint",
  "sake",
  "salad",
  "salami",
  "salaried",
  "salary",
  "saline",
  "salon",
  "saloon",
  "salsa",
  "salt",
  "salutary",
  "salute",
  "salvage",
  "salvaging",
  "salvation",
  "same",
  "sample",
  "sampling",
  "sanction",
  "sanctity",
  "sanctuary",
  "sandal",
  "sandbag",
  "sandbank",
  "sandbar",
  "sandblast",
  "sandbox",
  "sanded",
  "sandfish",
  "sanding",
  "sandlot",
  "sandpaper",
  "sandpit",
  "sandstone",
  "sandstorm",
  "sandworm",
  "sandy",
  "sanitary",
  "sanitizer",
  "sank",
  "santa",
  "sapling",
  "sappiness",
  "sappy",
  "sarcasm",
  "sarcastic",
  "sardine",
  "sash",
  "sasquatch",
  "sassy",
  "satchel",
  "satiable",
  "satin",
  "satirical",
  "satisfied",
  "satisfy",
  "saturate",
  "saturday",
  "sauciness",
  "saucy",
  "sauna",
  "savage",
  "savanna",
  "saved",
  "savings",
  "savior",
  "savor",
  "saxophone",
  "say",
  "scabbed",
  "scabby",
  "scalded",
  "scalding",
  "scale",
  "scaling",
  "scallion",
  "scallop",
  "scalping",
  "scam",
  "scandal",
  "scanner",
  "scanning",
  "scant",
  "scapegoat",
  "scarce",
  "scarcity",
  "scarecrow",
  "scared",
  "scarf",
  "scarily",
  "scariness",
  "scarring",
  "scary",
  "scavenger",
  "scenic",
  "schedule",
  "schematic",
  "scheme",
  "scheming",
  "schilling",
  "schnapps",
  "scholar",
  "science",
  "scientist",
  "scion",
  "scoff",
  "scolding",
  "scone",
  "scoop",
  "scooter",
  "scope",
  "scorch",
  "scorebook",
  "scorecard",
  "scored",
  "scoreless",
  "scorer",
  "scoring",
  "scorn",
  "scorpion",
  "scotch",
  "scoundrel",
  "scoured",
  "scouring",
  "scouting",
  "scouts",
  "scowling",
  "scrabble",
  "scraggly",
  "scrambled",
  "scrambler",
  "scrap",
  "scratch",
  "scrawny",
  "screen",
  "scribble",
  "scribe",
  "scribing",
  "scrimmage",
  "script",
  "scroll",
  "scrooge",
  "scrounger",
  "scrubbed",
  "scrubber",
  "scruffy",
  "scrunch",
  "scrutiny",
  "scuba",
  "scuff",
  "sculptor",
  "sculpture",
  "scurvy",
  "scuttle",
  "secluded",
  "secluding",
  "seclusion",
  "second",
  "secrecy",
  "secret",
  "sectional",
  "sector",
  "secular",
  "securely",
  "security",
  "sedan",
  "sedate",
  "sedation",
  "sedative",
  "sediment",
  "seduce",
  "seducing",
  "segment",
  "seismic",
  "seizing",
  "seldom",
  "selected",
  "selection",
  "selective",
  "selector",
  "self",
  "seltzer",
  "semantic",
  "semester",
  "semicolon",
  "semifinal",
  "seminar",
  "semisoft",
  "semisweet",
  "senate",
  "senator",
  "send",
  "senior",
  "senorita",
  "sensation",
  "sensitive",
  "sensitize",
  "sensually",
  "sensuous",
  "sepia",
  "september",
  "septic",
  "septum",
  "sequel",
  "sequence",
  "sequester",
  "series",
  "sermon",
  "serotonin",
  "serpent",
  "serrated",
  "serve",
  "service",
  "serving",
  "sesame",
  "sessions",
  "setback",
  "setting",
  "settle",
  "settling",
  "setup",
  "sevenfold",
  "seventeen",
  "seventh",
  "seventy",
  "severity",
  "shabby",
  "shack",
  "shaded",
  "shadily",
  "shadiness",
  "shading",
  "shadow",
  "shady",
  "shaft",
  "shakable",
  "shakily",
  "shakiness",
  "shaking",
  "shaky",
  "shale",
  "shallot",
  "shallow",
  "shame",
  "shampoo",
  "shamrock",
  "shank",
  "shanty",
  "shape",
  "shaping",
  "share",
  "sharpener",
  "sharper",
  "sharpie",
  "sharply",
  "sharpness",
  "shawl",
  "sheath",
  "shed",
  "sheep",
  "sheet",
  "shelf",
  "shell",
  "shelter",
  "shelve",
  "shelving",
  "sherry",
  "shield",
  "shifter",
  "shifting",
  "shiftless",
  "shifty",
  "shimmer",
  "shimmy",
  "shindig",
  "shine",
  "shingle",
  "shininess",
  "shining",
  "shiny",
  "ship",
  "shirt",
  "shivering",
  "shock",
  "shone",
  "shoplift",
  "shopper",
  "shopping",
  "shoptalk",
  "shore",
  "shortage",
  "shortcake",
  "shortcut",
  "shorten",
  "shorter",
  "shorthand",
  "shortlist",
  "shortly",
  "shortness",
  "shorts",
  "shortwave",
  "shorty",
  "shout",
  "shove",
  "showbiz",
  "showcase",
  "showdown",
  "shower",
  "showgirl",
  "showing",
  "showman",
  "shown",
  "showoff",
  "showpiece",
  "showplace",
  "showroom",
  "showy",
  "shrank",
  "shrapnel",
  "shredder",
  "shredding",
  "shrewdly",
  "shriek",
  "shrill",
  "shrimp",
  "shrine",
  "shrink",
  "shrivel",
  "shrouded",
  "shrubbery",
  "shrubs",
  "shrug",
  "shrunk",
  "shucking",
  "shudder",
  "shuffle",
  "shuffling",
  "shun",
  "shush",
  "shut",
  "shy",
  "siamese",
  "siberian",
  "sibling",
  "siding",
  "sierra",
  "siesta",
  "sift",
  "sighing",
  "silenced",
  "silencer",
  "silent",
  "silica",
  "silicon",
  "silk",
  "silliness",
  "silly",
  "silo",
  "silt",
  "silver",
  "similarly",
  "simile",
  "simmering",
  "simple",
  "simplify",
  "simply",
  "sincere",
  "sincerity",
  "singer",
  "singing",
  "single",
  "singular",
  "sinister",
  "sinless",
  "sinner",
  "sinuous",
  "sip",
  "siren",
  "sister",
  "sitcom",
  "sitter",
  "sitting",
  "situated",
  "situation",
  "sixfold",
  "sixteen",
  "sixth",
  "sixties",
  "sixtieth",
  "sixtyfold",
  "sizable",
  "sizably",
  "size",
  "sizing",
  "sizzle",
  "sizzling",
  "skater",
  "skating",
  "skedaddle",
  "skeletal",
  "skeleton",
  "skeptic",
  "sketch",
  "skewed",
  "skewer",
  "skid",
  "skied",
  "skier",
  "skies",
  "skiing",
  "skilled",
  "skillet",
  "skillful",
  "skimmed",
  "skimmer",
  "skimming",
  "skimpily",
  "skincare",
  "skinhead",
  "skinless",
  "skinning",
  "skinny",
  "skintight",
  "skipper",
  "skipping",
  "skirmish",
  "skirt",
  "skittle",
  "skydiver",
  "skylight",
  "skyline",
  "skype",
  "skyrocket",
  "skyward",
  "slab",
  "slacked",
  "slacker",
  "slacking",
  "slackness",
  "slacks",
  "slain",
  "slam",
  "slander",
  "slang",
  "slapping",
  "slapstick",
  "slashed",
  "slashing",
  "slate",
  "slather",
  "slaw",
  "sled",
  "sleek",
  "sleep",
  "sleet",
  "sleeve",
  "slept",
  "sliceable",
  "sliced",
  "slicer",
  "slicing",
  "slick",
  "slider",
  "slideshow",
  "sliding",
  "slighted",
  "slighting",
  "slightly",
  "slimness",
  "slimy",
  "slinging",
  "slingshot",
  "slinky",
  "slip",
  "slit",
  "sliver",
  "slobbery",
  "slogan",
  "sloped",
  "sloping",
  "sloppily",
  "sloppy",
  "slot",
  "slouching",
  "slouchy",
  "sludge",
  "slug",
  "slum",
  "slurp",
  "slush",
  "sly",
  "small",
  "smartly",
  "smartness",
  "smasher",
  "smashing",
  "smashup",
  "smell",
  "smelting",
  "smile",
  "smilingly",
  "smirk",
  "smite",
  "smith",
  "smitten",
  "smock",
  "smog",
  "smoked",
  "smokeless",
  "smokiness",
  "smoking",
  "smoky",
  "smolder",
  "smooth",
  "smother",
  "smudge",
  "smudgy",
  "smuggler",
  "smuggling",
  "smugly",
  "smugness",
  "snack",
  "snagged",
  "snaking",
  "snap",
  "snare",
  "snarl",
  "snazzy",
  "sneak",
  "sneer",
  "sneeze",
  "sneezing",
  "snide",
  "sniff",
  "snippet",
  "snipping",
  "snitch",
  "snooper",
  "snooze",
  "snore",
  "snoring",
  "snorkel",
  "snort",
  "snout",
  "snowbird",
  "snowboard",
  "snowbound",
  "snowcap",
  "snowdrift",
  "snowdrop",
  "snowfall",
  "snowfield",
  "snowflake",
  "snowiness",
  "snowless",
  "snowman",
  "snowplow",
  "snowshoe",
  "snowstorm",
  "snowsuit",
  "snowy",
  "snub",
  "snuff",
  "snuggle",
  "snugly",
  "snugness",
  "speak",
  "spearfish",
  "spearhead",
  "spearman",
  "spearmint",
  "species",
  "specimen",
  "specked",
  "speckled",
  "specks",
  "spectacle",
  "spectator",
  "spectrum",
  "speculate",
  "speech",
  "speed",
  "spellbind",
  "speller",
  "spelling",
  "spendable",
  "spender",
  "spending",
  "spent",
  "spew",
  "sphere",
  "spherical",
  "sphinx",
  "spider",
  "spied",
  "spiffy",
  "spill",
  "spilt",
  "spinach",
  "spinal",
  "spindle",
  "spinner",
  "spinning",
  "spinout",
  "spinster",
  "spiny",
  "spiral",
  "spirited",
  "spiritism",
  "spirits",
  "spiritual",
  "splashed",
  "splashing",
  "splashy",
  "splatter",
  "spleen",
  "splendid",
  "splendor",
  "splice",
  "splicing",
  "splinter",
  "splotchy",
  "splurge",
  "spoilage",
  "spoiled",
  "spoiler",
  "spoiling",
  "spoils",
  "spoken",
  "spokesman",
  "sponge",
  "spongy",
  "sponsor",
  "spoof",
  "spookily",
  "spooky",
  "spool",
  "spoon",
  "spore",
  "sporting",
  "sports",
  "sporty",
  "spotless",
  "spotlight",
  "spotted",
  "spotter",
  "spotting",
  "spotty",
  "spousal",
  "spouse",
  "spout",
  "sprain",
  "sprang",
  "sprawl",
  "spray",
  "spree",
  "sprig",
  "spring",
  "sprinkled",
  "sprinkler",
  "sprint",
  "sprite",
  "sprout",
  "spruce",
  "sprung",
  "spry",
  "spud",
  "spur",
  "sputter",
  "spyglass",
  "squabble",
  "squad",
  "squall",
  "squander",
  "squash",
  "squatted",
  "squatter",
  "squatting",
  "squeak",
  "squealer",
  "squealing",
  "squeamish",
  "squeegee",
  "squeeze",
  "squeezing",
  "squid",
  "squiggle",
  "squiggly",
  "squint",
  "squire",
  "squirt",
  "squishier",
  "squishy",
  "stability",
  "stabilize",
  "stable",
  "stack",
  "stadium",
  "staff",
  "stage",
  "staging",
  "stagnant",
  "stagnate",
  "stainable",
  "stained",
  "staining",
  "stainless",
  "stalemate",
  "staleness",
  "stalling",
  "stallion",
  "stamina",
  "stammer",
  "stamp",
  "stand",
  "stank",
  "staple",
  "stapling",
  "starboard",
  "starch",
  "stardom",
  "stardust",
  "starfish",
  "stargazer",
  "staring",
  "stark",
  "starless",
  "starlet",
  "starlight",
  "starlit",
  "starring",
  "starry",
  "starship",
  "starter",
  "starting",
  "startle",
  "startling",
  "startup",
  "starved",
  "starving",
  "stash",
  "state",
  "static",
  "statistic",
  "statue",
  "stature",
  "status",
  "statute",
  "statutory",
  "staunch",
  "stays",
  "steadfast",
  "steadier",
  "steadily",
  "steadying",
  "steam",
  "steed",
  "steep",
  "steerable",
  "steering",
  "steersman",
  "stegosaur",
  "stellar",
  "stem",
  "stench",
  "stencil",
  "step",
  "stereo",
  "sterile",
  "sterility",
  "sterilize",
  "sterling",
  "sternness",
  "sternum",
  "stew",
  "stick",
  "stiffen",
  "stiffly",
  "stiffness",
  "stifle",
  "stifling",
  "stillness",
  "stilt",
  "stimulant",
  "stimulate",
  "stimuli",
  "stimulus",
  "stinger",
  "stingily",
  "stinging",
  "stingray",
  "stingy",
  "stinking",
  "stinky",
  "stipend",
  "stipulate",
  "stir",
  "stitch",
  "stock",
  "stoic",
  "stoke",
  "stole",
  "stomp",
  "stonewall",
  "stoneware",
  "stonework",
  "stoning",
  "stony",
  "stood",
  "stooge",
  "stool",
  "stoop",
  "stoplight",
  "stoppable",
  "stoppage",
  "stopped",
  "stopper",
  "stopping",
  "stopwatch",
  "storable",
  "storage",
  "storeroom",
  "storewide",
  "storm",
  "stout",
  "stove",
  "stowaway",
  "stowing",
  "straddle",
  "straggler",
  "strained",
  "strainer",
  "straining",
  "strangely",
  "stranger",
  "strangle",
  "strategic",
  "strategy",
  "stratus",
  "straw",
  "stray",
  "streak",
  "stream",
  "street",
  "strength",
  "strenuous",
  "strep",
  "stress",
  "stretch",
  "strewn",
  "stricken",
  "strict",
  "stride",
  "strife",
  "strike",
  "striking",
  "strive",
  "striving",
  "strobe",
  "strode",
  "stroller",
  "strongbox",
  "strongly",
  "strongman",
  "struck",
  "structure",
  "strudel",
  "struggle",
  "strum",
  "strung",
  "strut",
  "stubbed",
  "stubble",
  "stubbly",
  "stubborn",
  "stucco",
  "stuck",
  "student",
  "studied",
  "studio",
  "study",
  "stuffed",
  "stuffing",
  "stuffy",
  "stumble",
  "stumbling",
  "stump",
  "stung",
  "stunned",
  "stunner",
  "stunning",
  "stunt",
  "stupor",
  "sturdily",
  "sturdy",
  "styling",
  "stylishly",
  "stylist",
  "stylized",
  "stylus",
  "suave",
  "subarctic",
  "subatomic",
  "subdivide",
  "subdued",
  "subduing",
  "subfloor",
  "subgroup",
  "subheader",
  "subject",
  "sublease",
  "sublet",
  "sublevel",
  "sublime",
  "submarine",
  "submerge",
  "submersed",
  "submitter",
  "subpanel",
  "subpar",
  "subplot",
  "subprime",
  "subscribe",
  "subscript",
  "subsector",
  "subside",
  "subsiding",
  "subsidize",
  "subsidy",
  "subsoil",
  "subsonic",
  "substance",
  "subsystem",
  "subtext",
  "subtitle",
  "subtly",
  "subtotal",
  "subtract",
  "subtype",
  "suburb",
  "subway",
  "subwoofer",
  "subzero",
  "succulent",
  "such",
  "suction",
  "sudden",
  "sudoku",
  "suds",
  "sufferer",
  "suffering",
  "suffice",
  "suffix",
  "suffocate",
  "suffrage",
  "sugar",
  "suggest",
  "suing",
  "suitable",
  "suitably",
  "suitcase",
  "suitor",
  "sulfate",
  "sulfide",
  "sulfite",
  "sulfur",
  "sulk",
  "sullen",
  "sulphate",
  "sulphuric",
  "sultry",
  "superbowl",
  "superglue",
  "superhero",
  "superior",
  "superjet",
  "superman",
  "supermom",
  "supernova",
  "supervise",
  "supper",
  "supplier",
  "supply",
  "support",
  "supremacy",
  "supreme",
  "surcharge",
  "surely",
  "sureness",
  "surface",
  "surfacing",
  "surfboard",
  "surfer",
  "surgery",
  "surgical",
  "surging",
  "surname",
  "surpass",
  "surplus",
  "surprise",
  "surreal",
  "surrender",
  "surrogate",
  "surround",
  "survey",
  "survival",
  "survive",
  "surviving",
  "survivor",
  "sushi",
  "suspect",
  "suspend",
  "suspense",
  "sustained",
  "sustainer",
  "swab",
  "swaddling",
  "swagger",
  "swampland",
  "swan",
  "swapping",
  "swarm",
  "sway",
  "swear",
  "sweat",
  "sweep",
  "swell",
  "swept",
  "swerve",
  "swifter",
  "swiftly",
  "swiftness",
  "swimmable",
  "swimmer",
  "swimming",
  "swimsuit",
  "swimwear",
  "swinger",
  "swinging",
  "swipe",
  "swirl",
  "switch",
  "swivel",
  "swizzle",
  "swooned",
  "swoop",
  "swoosh",
  "swore",
  "sworn",
  "swung",
  "sycamore",
  "sympathy",
  "symphonic",
  "symphony",
  "symptom",
  "synapse",
  "syndrome",
  "synergy",
  "synopses",
  "synopsis",
  "synthesis",
  "synthetic",
  "syrup",
  "system",
  "t-shirt",
  "tabasco",
  "tabby",
  "tableful",
  "tables",
  "tablet",
  "tableware",
  "tabloid",
  "tackiness",
  "tacking",
  "tackle",
  "tackling",
  "tacky",
  "taco",
  "tactful",
  "tactical",
  "tactics",
  "tactile",
  "tactless",
  "tadpole",
  "taekwondo",
  "tag",
  "tainted",
  "take",
  "taking",
  "talcum",
  "talisman",
  "tall",
  "talon",
  "tamale",
  "tameness",
  "tamer",
  "tamper",
  "tank",
  "tanned",
  "tannery",
  "tanning",
  "tantrum",
  "tapeless",
  "tapered",
  "tapering",
  "tapestry",
  "tapioca",
  "tapping",
  "taps",
  "tarantula",
  "target",
  "tarmac",
  "tarnish",
  "tarot",
  "tartar",
  "tartly",
  "tartness",
  "task",
  "tassel",
  "taste",
  "tastiness",
  "tasting",
  "tasty",
  "tattered",
  "tattle",
  "tattling",
  "tattoo",
  "taunt",
  "tavern",
  "thank",
  "that",
  "thaw",
  "theater",
  "theatrics",
  "thee",
  "theft",
  "theme",
  "theology",
  "theorize",
  "thermal",
  "thermos",
  "thesaurus",
  "these",
  "thesis",
  "thespian",
  "thicken",
  "thicket",
  "thickness",
  "thieving",
  "thievish",
  "thigh",
  "thimble",
  "thing",
  "think",
  "thinly",
  "thinner",
  "thinness",
  "thinning",
  "thirstily",
  "thirsting",
  "thirsty",
  "thirteen",
  "thirty",
  "thong",
  "thorn",
  "those",
  "thousand",
  "thrash",
  "thread",
  "threaten",
  "threefold",
  "thrift",
  "thrill",
  "thrive",
  "thriving",
  "throat",
  "throbbing",
  "throng",
  "throttle",
  "throwaway",
  "throwback",
  "thrower",
  "throwing",
  "thud",
  "thumb",
  "thumping",
  "thursday",
  "thus",
  "thwarting",
  "thyself",
  "tiara",
  "tibia",
  "tidal",
  "tidbit",
  "tidiness",
  "tidings",
  "tidy",
  "tiger",
  "tighten",
  "tightly",
  "tightness",
  "tightrope",
  "tightwad",
  "tigress",
  "tile",
  "tiling",
  "till",
  "tilt",
  "timid",
  "timing",
  "timothy",
  "tinderbox",
  "tinfoil",
  "tingle",
  "tingling",
  "tingly",
  "tinker",
  "tinkling",
  "tinsel",
  "tinsmith",
  "tint",
  "tinwork",
  "tiny",
  "tipoff",
  "tipped",
  "tipper",
  "tipping",
  "tiptoeing",
  "tiptop",
  "tiring",
  "tissue",
  "trace",
  "tracing",
  "track",
  "traction",
  "tractor",
  "trade",
  "trading",
  "tradition",
  "traffic",
  "tragedy",
  "trailing",
  "trailside",
  "train",
  "traitor",
  "trance",
  "tranquil",
  "transfer",
  "transform",
  "translate",
  "transpire",
  "transport",
  "transpose",
  "trapdoor",
  "trapeze",
  "trapezoid",
  "trapped",
  "trapper",
  "trapping",
  "traps",
  "trash",
  "travel",
  "traverse",
  "travesty",
  "tray",
  "treachery",
  "treading",
  "treadmill",
  "treason",
  "treat",
  "treble",
  "tree",
  "trekker",
  "tremble",
  "trembling",
  "tremor",
  "trench",
  "trend",
  "trespass",
  "triage",
  "trial",
  "triangle",
  "tribesman",
  "tribunal",
  "tribune",
  "tributary",
  "tribute",
  "triceps",
  "trickery",
  "trickily",
  "tricking",
  "trickle",
  "trickster",
  "tricky",
  "tricolor",
  "tricycle",
  "trident",
  "tried",
  "trifle",
  "trifocals",
  "trillion",
  "trilogy",
  "trimester",
  "trimmer",
  "trimming",
  "trimness",
  "trinity",
  "trio",
  "tripod",
  "tripping",
  "triumph",
  "trivial",
  "trodden",
  "trolling",
  "trombone",
  "trophy",
  "tropical",
  "tropics",
  "trouble",
  "troubling",
  "trough",
  "trousers",
  "trout",
  "trowel",
  "truce",
  "truck",
  "truffle",
  "trump",
  "trunks",
  "trustable",
  "trustee",
  "trustful",
  "trusting",
  "trustless",
  "truth",
  "try",
  "tubby",
  "tubeless",
  "tubular",
  "tucking",
  "tuesday",
  "tug",
  "tuition",
  "tulip",
  "tumble",
  "tumbling",
  "tummy",
  "turban",
  "turbine",
  "turbofan",
  "turbojet",
  "turbulent",
  "turf",
  "turkey",
  "turmoil",
  "turret",
  "turtle",
  "tusk",
  "tutor",
  "tutu",
  "tux",
  "tweak",
  "tweed",
  "tweet",
  "tweezers",
  "twelve",
  "twentieth",
  "twenty",
  "twerp",
  "twice",
  "twiddle",
  "twiddling",
  "twig",
  "twilight",
  "twine",
  "twins",
  "twirl",
  "twistable",
  "twisted",
  "twister",
  "twisting",
  "twisty",
  "twitch",
  "twitter",
  "tycoon",
  "tying",
  "tyke",
  "udder",
  "ultimate",
  "ultimatum",
  "ultra",
  "umbilical",
  "umbrella",
  "umpire",
  "unabashed",
  "unable",
  "unadorned",
  "unadvised",
  "unafraid",
  "unaired",
  "unaligned",
  "unaltered",
  "unarmored",
  "unashamed",
  "unaudited",
  "unawake",
  "unaware",
  "unbaked",
  "unbalance",
  "unbeaten",
  "unbend",
  "unbent",
  "unbiased",
  "unbitten",
  "unblended",
  "unblessed",
  "unblock",
  "unbolted",
  "unbounded",
  "unboxed",
  "unbraided",
  "unbridle",
  "unbroken",
  "unbuckled",
  "unbundle",
  "unburned",
  "unbutton",
  "uncanny",
  "uncapped",
  "uncaring",
  "uncertain",
  "unchain",
  "unchanged",
  "uncharted",
  "uncheck",
  "uncivil",
  "unclad",
  "unclaimed",
  "unclamped",
  "unclasp",
  "uncle",
  "unclip",
  "uncloak",
  "unclog",
  "unclothed",
  "uncoated",
  "uncoiled",
  "uncolored",
  "uncombed",
  "uncommon",
  "uncooked",
  "uncork",
  "uncorrupt",
  "uncounted",
  "uncouple",
  "uncouth",
  "uncover",
  "uncross",
  "uncrown",
  "uncrushed",
  "uncured",
  "uncurious",
  "uncurled",
  "uncut",
  "undamaged",
  "undated",
  "undaunted",
  "undead",
  "undecided",
  "undefined",
  "underage",
  "underarm",
  "undercoat",
  "undercook",
  "undercut",
  "underdog",
  "underdone",
  "underfed",
  "underfeed",
  "underfoot",
  "undergo",
  "undergrad",
  "underhand",
  "underline",
  "underling",
  "undermine",
  "undermost",
  "underpaid",
  "underpass",
  "underpay",
  "underrate",
  "undertake",
  "undertone",
  "undertook",
  "undertow",
  "underuse",
  "underwear",
  "underwent",
  "underwire",
  "undesired",
  "undiluted",
  "undivided",
  "undocked",
  "undoing",
  "undone",
  "undrafted",
  "undress",
  "undrilled",
  "undusted",
  "undying",
  "unearned",
  "unearth",
  "unease",
  "uneasily",
  "uneasy",
  "uneatable",
  "uneaten",
  "unedited",
  "unelected",
  "unending",
  "unengaged",
  "unenvied",
  "unequal",
  "unethical",
  "uneven",
  "unexpired",
  "unexposed",
  "unfailing",
  "unfair",
  "unfasten",
  "unfazed",
  "unfeeling",
  "unfiled",
  "unfilled",
  "unfitted",
  "unfitting",
  "unfixable",
  "unfixed",
  "unflawed",
  "unfocused",
  "unfold",
  "unfounded",
  "unframed",
  "unfreeze",
  "unfrosted",
  "unfrozen",
  "unfunded",
  "unglazed",
  "ungloved",
  "unglue",
  "ungodly",
  "ungraded",
  "ungreased",
  "unguarded",
  "unguided",
  "unhappily",
  "unhappy",
  "unharmed",
  "unhealthy",
  "unheard",
  "unhearing",
  "unheated",
  "unhelpful",
  "unhidden",
  "unhinge",
  "unhitched",
  "unholy",
  "unhook",
  "unicorn",
  "unicycle",
  "unified",
  "unifier",
  "uniformed",
  "uniformly",
  "unify",
  "unimpeded",
  "uninjured",
  "uninstall",
  "uninsured",
  "uninvited",
  "union",
  "uniquely",
  "unisexual",
  "unison",
  "unissued",
  "unit",
  "universal",
  "universe",
  "unjustly",
  "unkempt",
  "unkind",
  "unknotted",
  "unknowing",
  "unknown",
  "unlaced",
  "unlatch",
  "unlawful",
  "unleaded",
  "unlearned",
  "unleash",
  "unless",
  "unleveled",
  "unlighted",
  "unlikable",
  "unlimited",
  "unlined",
  "unlinked",
  "unlisted",
  "unlit",
  "unlivable",
  "unloaded",
  "unloader",
  "unlocked",
  "unlocking",
  "unlovable",
  "unloved",
  "unlovely",
  "unloving",
  "unluckily",
  "unlucky",
  "unmade",
  "unmanaged",
  "unmanned",
  "unmapped",
  "unmarked",
  "unmasked",
  "unmasking",
  "unmatched",
  "unmindful",
  "unmixable",
  "unmixed",
  "unmolded",
  "unmoral",
  "unmovable",
  "unmoved",
  "unmoving",
  "unnamable",
  "unnamed",
  "unnatural",
  "unneeded",
  "unnerve",
  "unnerving",
  "unnoticed",
  "unopened",
  "unopposed",
  "unpack",
  "unpadded",
  "unpaid",
  "unpainted",
  "unpaired",
  "unpaved",
  "unpeeled",
  "unpicked",
  "unpiloted",
  "unpinned",
  "unplanned",
  "unplanted",
  "unpleased",
  "unpledged",
  "unplowed",
  "unplug",
  "unpopular",
  "unproven",
  "unquote",
  "unranked",
  "unrated",
  "unraveled",
  "unreached",
  "unread",
  "unreal",
  "unreeling",
  "unrefined",
  "unrelated",
  "unrented",
  "unrest",
  "unretired",
  "unrevised",
  "unrigged",
  "unripe",
  "unrivaled",
  "unroasted",
  "unrobed",
  "unroll",
  "unruffled",
  "unruly",
  "unrushed",
  "unsaddle",
  "unsafe",
  "unsaid",
  "unsalted",
  "unsaved",
  "unsavory",
  "unscathed",
  "unscented",
  "unscrew",
  "unsealed",
  "unseated",
  "unsecured",
  "unseeing",
  "unseemly",
  "unseen",
  "unselect",
  "unselfish",
  "unsent",
  "unsettled",
  "unshackle",
  "unshaken",
  "unshaved",
  "unshaven",
  "unsheathe",
  "unshipped",
  "unsightly",
  "unsigned",
  "unskilled",
  "unsliced",
  "unsmooth",
  "unsnap",
  "unsocial",
  "unsoiled",
  "unsold",
  "unsolved",
  "unsorted",
  "unspoiled",
  "unspoken",
  "unstable",
  "unstaffed",
  "unstamped",
  "unsteady",
  "unsterile",
  "unstirred",
  "unstitch",
  "unstopped",
  "unstuck",
  "unstuffed",
  "unstylish",
  "unsubtle",
  "unsubtly",
  "unsuited",
  "unsure",
  "unsworn",
  "untagged",
  "untainted",
  "untaken",
  "untamed",
  "untangled",
  "untapped",
  "untaxed",
  "unthawed",
  "unthread",
  "untidy",
  "untie",
  "until",
  "untimed",
  "untimely",
  "untitled",
  "untoasted",
  "untold",
  "untouched",
  "untracked",
  "untrained",
  "untreated",
  "untried",
  "untrimmed",
  "untrue",
  "untruth",
  "unturned",
  "untwist",
  "untying",
  "unusable",
  "unused",
  "unusual",
  "unvalued",
  "unvaried",
  "unvarying",
  "unveiled",
  "unveiling",
  "unvented",
  "unviable",
  "unvisited",
  "unvocal",
  "unwanted",
  "unwarlike",
  "unwary",
  "unwashed",
  "unwatched",
  "unweave",
  "unwed",
  "unwelcome",
  "unwell",
  "unwieldy",
  "unwilling",
  "unwind",
  "unwired",
  "unwitting",
  "unwomanly",
  "unworldly",
  "unworn",
  "unworried",
  "unworthy",
  "unwound",
  "unwoven",
  "unwrapped",
  "unwritten",
  "unzip",
  "upbeat",
  "upchuck",
  "upcoming",
  "upcountry",
  "update",
  "upfront",
  "upgrade",
  "upheaval",
  "upheld",
  "uphill",
  "uphold",
  "uplifted",
  "uplifting",
  "upload",
  "upon",
  "upper",
  "upright",
  "uprising",
  "upriver",
  "uproar",
  "uproot",
  "upscale",
  "upside",
  "upstage",
  "upstairs",
  "upstart",
  "upstate",
  "upstream",
  "upstroke",
  "upswing",
  "uptake",
  "uptight",
  "uptown",
  "upturned",
  "upward",
  "upwind",
  "uranium",
  "urban",
  "urchin",
  "urethane",
  "urgency",
  "urgent",
  "urging",
  "urologist",
  "urology",
  "usable",
  "usage",
  "useable",
  "used",
  "uselessly",
  "user",
  "usher",
  "usual",
  "utensil",
  "utility",
  "utilize",
  "utmost",
  "utopia",
  "utter",
  "vacancy",
  "vacant",
  "vacate",
  "vacation",
  "vagabond",
  "vagrancy",
  "vagrantly",
  "vaguely",
  "vagueness",
  "valiant",
  "valid",
  "valium",
  "valley",
  "valuables",
  "value",
  "vanilla",
  "vanish",
  "vanity",
  "vanquish",
  "vantage",
  "vaporizer",
  "variable",
  "variably",
  "varied",
  "variety",
  "various",
  "varmint",
  "varnish",
  "varsity",
  "varying",
  "vascular",
  "vaseline",
  "vastly",
  "vastness",
  "veal",
  "vegan",
  "veggie",
  "vehicular",
  "velcro",
  "velocity",
  "velvet",
  "vendetta",
  "vending",
  "vendor",
  "veneering",
  "vengeful",
  "venomous",
  "ventricle",
  "venture",
  "venue",
  "venus",
  "verbalize",
  "verbally",
  "verbose",
  "verdict",
  "verify",
  "verse",
  "version",
  "versus",
  "vertebrae",
  "vertical",
  "vertigo",
  "very",
  "vessel",
  "vest",
  "veteran",
  "veto",
  "vexingly",
  "viability",
  "viable",
  "vibes",
  "vice",
  "vicinity",
  "victory",
  "video",
  "viewable",
  "viewer",
  "viewing",
  "viewless",
  "viewpoint",
  "vigorous",
  "village",
  "villain",
  "vindicate",
  "vineyard",
  "vintage",
  "violate",
  "violation",
  "violator",
  "violet",
  "violin",
  "viper",
  "viral",
  "virtual",
  "virtuous",
  "virus",
  "visa",
  "viscosity",
  "viscous",
  "viselike",
  "visible",
  "visibly",
  "vision",
  "visiting",
  "visitor",
  "visor",
  "vista",
  "vitality",
  "vitalize",
  "vitally",
  "vitamins",
  "vivacious",
  "vividly",
  "vividness",
  "vixen",
  "vocalist",
  "vocalize",
  "vocally",
  "vocation",
  "voice",
  "voicing",
  "void",
  "volatile",
  "volley",
  "voltage",
  "volumes",
  "voter",
  "voting",
  "voucher",
  "vowed",
  "vowel",
  "voyage",
  "wackiness",
  "wad",
  "wafer",
  "waffle",
  "waged",
  "wager",
  "wages",
  "waggle",
  "wagon",
  "wake",
  "waking",
  "walk",
  "walmart",
  "walnut",
  "walrus",
  "waltz",
  "wand",
  "wannabe",
  "wanted",
  "wanting",
  "wasabi",
  "washable",
  "washbasin",
  "washboard",
  "washbowl",
  "washcloth",
  "washday",
  "washed",
  "washer",
  "washhouse",
  "washing",
  "washout",
  "washroom",
  "washstand",
  "washtub",
  "wasp",
  "wasting",
  "watch",
  "water",
  "waviness",
  "waving",
  "wavy",
  "whacking",
  "whacky",
  "wham",
  "wharf",
  "wheat",
  "whenever",
  "whiff",
  "whimsical",
  "whinny",
  "whiny",
  "whisking",
  "whoever",
  "whole",
  "whomever",
  "whoopee",
  "whooping",
  "whoops",
  "why",
  "wick",
  "widely",
  "widen",
  "widget",
  "widow",
  "width",
  "wieldable",
  "wielder",
  "wife",
  "wifi",
  "wikipedia",
  "wildcard",
  "wildcat",
  "wilder",
  "wildfire",
  "wildfowl",
  "wildland",
  "wildlife",
  "wildly",
  "wildness",
  "willed",
  "willfully",
  "willing",
  "willow",
  "willpower",
  "wilt",
  "wimp",
  "wince",
  "wincing",
  "wind",
  "wing",
  "winking",
  "winner",
  "winnings",
  "winter",
  "wipe",
  "wired",
  "wireless",
  "wiring",
  "wiry",
  "wisdom",
  "wise",
  "wish",
  "wisplike",
  "wispy",
  "wistful",
  "wizard",
  "wobble",
  "wobbling",
  "wobbly",
  "wok",
  "wolf",
  "wolverine",
  "womanhood",
  "womankind",
  "womanless",
  "womanlike",
  "womanly",
  "womb",
  "woof",
  "wooing",
  "wool",
  "woozy",
  "word",
  "work",
  "worried",
  "worrier",
  "worrisome",
  "worry",
  "worsening",
  "worshiper",
  "worst",
  "wound",
  "woven",
  "wow",
  "wrangle",
  "wrath",
  "wreath",
  "wreckage",
  "wrecker",
  "wrecking",
  "wrench",
  "wriggle",
  "wriggly",
  "wrinkle",
  "wrinkly",
  "wrist",
  "writing",
  "written",
  "wrongdoer",
  "wronged",
  "wrongful",
  "wrongly",
  "wrongness",
  "wrought",
  "xbox",
  "xerox",
  "yahoo",
  "yam",
  "yanking",
  "yapping",
  "yard",
  "yarn",
  "yeah",
  "yearbook",
  "yearling",
  "yearly",
  "yearning",
  "yeast",
  "yelling",
  "yelp",
  "yen",
  "yesterday",
  "yiddish",
  "yield",
  "yin",
  "yippee",
  "yo-yo",
  "yodel",
  "yoga",
  "yogurt",
  "yonder",
  "yoyo",
  "yummy",
  "zap",
  "zealous",
  "zebra",
  "zen",
  "zeppelin",
  "zero",
  "zestfully",
  "zesty",
  "zigzagged",
  "zipfile",
  "zipping",
  "zippy",
  "zips",
  "zit",
  "zodiac",
  "zombie",
  "zone",
  "zoning",
  "zookeeper",
  "zoologist",
  "zoology",
  "zoom",
];
Object.defineProperty(Cu, "__esModule", { value: !0 });
Cu.newSecureWords = void 0;
const vM = Zn,
  fv = Tu;
async function gM(t = 6) {
  let e = [];
  for (let n = 0; n < t; n++)
    e.push(fv.wordlist[await (0, vM.getSecureRandomNumber)(0, fv.wordlist.length)]);
  return e;
}
Cu.newSecureWords = gM;
var _o = {},
  lv;
function yM() {
  if (lv) return _o;
  (lv = 1),
    Object.defineProperty(_o, "__esModule", { value: !0 }),
    (_o.newSecurePassphrase = void 0);
  const t = ss();
  async function e(n = 6) {
    return (await (0, t.newSecureWords)(n)).join("-");
  }
  return (_o.newSecurePassphrase = e), _o;
}
var ar = {};
function bM(t) {
  throw new Error(
    'Could not dynamically require "' +
      t +
      '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.'
  );
}
var G6 = { exports: {} },
  Dt = {},
  Wf = { exports: {} },
  Kf = { exports: {} };
const Mr = /* @__PURE__ */ R6(tx);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var uv;
function zt() {
  return (
    uv ||
      ((uv = 1),
      (function (t, e) {
        var n = Mr,
          i = n.Buffer;
        function l(c, v) {
          for (var g in c) v[g] = c[g];
        }
        i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow
          ? (t.exports = n)
          : (l(n, e), (e.Buffer = a));
        function a(c, v, g) {
          return i(c, v, g);
        }
        (a.prototype = Object.create(i.prototype)),
          l(i, a),
          (a.from = function (c, v, g) {
            if (typeof c == "number") throw new TypeError("Argument must not be a number");
            return i(c, v, g);
          }),
          (a.alloc = function (c, v, g) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            var b = i(c);
            return v !== void 0 ? (typeof g == "string" ? b.fill(v, g) : b.fill(v)) : b.fill(0), b;
          }),
          (a.allocUnsafe = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return i(c);
          }),
          (a.allocUnsafeSlow = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return n.SlowBuffer(c);
          });
      })(Kf, Kf.exports)),
    Kf.exports
  );
}
var cv;
function so() {
  if (cv) return Wf.exports;
  cv = 1;
  var t = 65536,
    e = 4294967295;
  function n() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var i = zt().Buffer,
    l = mt.crypto || mt.msCrypto;
  l && l.getRandomValues ? (Wf.exports = a) : (Wf.exports = n);
  function a(c, v) {
    if (c > e) throw new RangeError("requested too many random bytes");
    var g = i.allocUnsafe(c);
    if (c > 0)
      if (c > t) for (var b = 0; b < c; b += t) l.getRandomValues(g.slice(b, b + t));
      else l.getRandomValues(g);
    return typeof v == "function"
      ? Et.nextTick(function () {
          v(null, g);
        })
      : g;
  }
  return Wf.exports;
}
var Zf = { exports: {} },
  hv;
function It() {
  return (
    hv ||
      ((hv = 1),
      typeof Object.create == "function"
        ? (Zf.exports = function (e, n) {
            n &&
              ((e.super_ = n),
              (e.prototype = Object.create(n.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })));
          })
        : (Zf.exports = function (e, n) {
            if (n) {
              e.super_ = n;
              var i = function () {};
              (i.prototype = n.prototype), (e.prototype = new i()), (e.prototype.constructor = e);
            }
          })),
    Zf.exports
  );
}
var Gf = { exports: {} },
  dv;
function Sf() {
  if (dv) return Gf.exports;
  dv = 1;
  var t = typeof Reflect == "object" ? Reflect : null,
    e =
      t && typeof t.apply == "function"
        ? t.apply
        : function ($, J, he) {
            return Function.prototype.apply.call($, J, he);
          },
    n;
  t && typeof t.ownKeys == "function"
    ? (n = t.ownKeys)
    : Object.getOwnPropertySymbols
    ? (n = function ($) {
        return Object.getOwnPropertyNames($).concat(Object.getOwnPropertySymbols($));
      })
    : (n = function ($) {
        return Object.getOwnPropertyNames($);
      });
  function i(O) {
    console && console.warn && console.warn(O);
  }
  var l =
    Number.isNaN ||
    function ($) {
      return $ !== $;
    };
  function a() {
    a.init.call(this);
  }
  (Gf.exports = a),
    (Gf.exports.once = B),
    (a.EventEmitter = a),
    (a.prototype._events = void 0),
    (a.prototype._eventsCount = 0),
    (a.prototype._maxListeners = void 0);
  var c = 10;
  function v(O) {
    if (typeof O != "function")
      throw new TypeError(
        'The "listener" argument must be of type Function. Received type ' + typeof O
      );
  }
  Object.defineProperty(a, "defaultMaxListeners", {
    enumerable: !0,
    get: function () {
      return c;
    },
    set: function (O) {
      if (typeof O != "number" || O < 0 || l(O))
        throw new RangeError(
          'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' +
            O +
            "."
        );
      c = O;
    },
  }),
    (a.init = function () {
      (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) &&
        ((this._events = /* @__PURE__ */ Object.create(null)), (this._eventsCount = 0)),
        (this._maxListeners = this._maxListeners || void 0);
    }),
    (a.prototype.setMaxListeners = function ($) {
      if (typeof $ != "number" || $ < 0 || l($))
        throw new RangeError(
          'The value of "n" is out of range. It must be a non-negative number. Received ' + $ + "."
        );
      return (this._maxListeners = $), this;
    });
  function g(O) {
    return O._maxListeners === void 0 ? a.defaultMaxListeners : O._maxListeners;
  }
  (a.prototype.getMaxListeners = function () {
    return g(this);
  }),
    (a.prototype.emit = function ($) {
      for (var J = [], he = 1; he < arguments.length; he++) J.push(arguments[he]);
      var de = $ === "error",
        ne = this._events;
      if (ne !== void 0) de = de && ne.error === void 0;
      else if (!de) return !1;
      if (de) {
        var Ae;
        if ((J.length > 0 && (Ae = J[0]), Ae instanceof Error)) throw Ae;
        var x = new Error("Unhandled error." + (Ae ? " (" + Ae.message + ")" : ""));
        throw ((x.context = Ae), x);
      }
      var r = ne[$];
      if (r === void 0) return !1;
      if (typeof r == "function") e(r, this, J);
      else for (var o = r.length, f = A(r, o), he = 0; he < o; ++he) e(f[he], this, J);
      return !0;
    });
  function b(O, $, J, he) {
    var de, ne, Ae;
    if (
      (v(J),
      (ne = O._events),
      ne === void 0
        ? ((ne = O._events = /* @__PURE__ */ Object.create(null)), (O._eventsCount = 0))
        : (ne.newListener !== void 0 &&
            (O.emit("newListener", $, J.listener ? J.listener : J), (ne = O._events)),
          (Ae = ne[$])),
      Ae === void 0)
    )
      (Ae = ne[$] = J), ++O._eventsCount;
    else if (
      (typeof Ae == "function"
        ? (Ae = ne[$] = he ? [J, Ae] : [Ae, J])
        : he
        ? Ae.unshift(J)
        : Ae.push(J),
      (de = g(O)),
      de > 0 && Ae.length > de && !Ae.warned)
    ) {
      Ae.warned = !0;
      var x = new Error(
        "Possible EventEmitter memory leak detected. " +
          Ae.length +
          " " +
          String($) +
          " listeners added. Use emitter.setMaxListeners() to increase limit"
      );
      (x.name = "MaxListenersExceededWarning"),
        (x.emitter = O),
        (x.type = $),
        (x.count = Ae.length),
        i(x);
    }
    return O;
  }
  (a.prototype.addListener = function ($, J) {
    return b(this, $, J, !1);
  }),
    (a.prototype.on = a.prototype.addListener),
    (a.prototype.prependListener = function ($, J) {
      return b(this, $, J, !0);
    });
  function p() {
    if (!this.fired)
      return (
        this.target.removeListener(this.type, this.wrapFn),
        (this.fired = !0),
        arguments.length === 0
          ? this.listener.call(this.target)
          : this.listener.apply(this.target, arguments)
      );
  }
  function _(O, $, J) {
    var he = { fired: !1, wrapFn: void 0, target: O, type: $, listener: J },
      de = p.bind(he);
    return (de.listener = J), (he.wrapFn = de), de;
  }
  (a.prototype.once = function ($, J) {
    return v(J), this.on($, _(this, $, J)), this;
  }),
    (a.prototype.prependOnceListener = function ($, J) {
      return v(J), this.prependListener($, _(this, $, J)), this;
    }),
    (a.prototype.removeListener = function ($, J) {
      var he, de, ne, Ae, x;
      if ((v(J), (de = this._events), de === void 0)) return this;
      if (((he = de[$]), he === void 0)) return this;
      if (he === J || he.listener === J)
        --this._eventsCount === 0
          ? (this._events = /* @__PURE__ */ Object.create(null))
          : (delete de[$], de.removeListener && this.emit("removeListener", $, he.listener || J));
      else if (typeof he != "function") {
        for (ne = -1, Ae = he.length - 1; Ae >= 0; Ae--)
          if (he[Ae] === J || he[Ae].listener === J) {
            (x = he[Ae].listener), (ne = Ae);
            break;
          }
        if (ne < 0) return this;
        ne === 0 ? he.shift() : k(he, ne),
          he.length === 1 && (de[$] = he[0]),
          de.removeListener !== void 0 && this.emit("removeListener", $, x || J);
      }
      return this;
    }),
    (a.prototype.off = a.prototype.removeListener),
    (a.prototype.removeAllListeners = function ($) {
      var J, he, de;
      if (((he = this._events), he === void 0)) return this;
      if (he.removeListener === void 0)
        return (
          arguments.length === 0
            ? ((this._events = /* @__PURE__ */ Object.create(null)), (this._eventsCount = 0))
            : he[$] !== void 0 &&
              (--this._eventsCount === 0
                ? (this._events = /* @__PURE__ */ Object.create(null))
                : delete he[$]),
          this
        );
      if (arguments.length === 0) {
        var ne = Object.keys(he),
          Ae;
        for (de = 0; de < ne.length; ++de)
          (Ae = ne[de]), Ae !== "removeListener" && this.removeAllListeners(Ae);
        return (
          this.removeAllListeners("removeListener"),
          (this._events = /* @__PURE__ */ Object.create(null)),
          (this._eventsCount = 0),
          this
        );
      }
      if (((J = he[$]), typeof J == "function")) this.removeListener($, J);
      else if (J !== void 0) for (de = J.length - 1; de >= 0; de--) this.removeListener($, J[de]);
      return this;
    });
  function M(O, $, J) {
    var he = O._events;
    if (he === void 0) return [];
    var de = he[$];
    return de === void 0
      ? []
      : typeof de == "function"
      ? J
        ? [de.listener || de]
        : [de]
      : J
      ? P(de)
      : A(de, de.length);
  }
  (a.prototype.listeners = function ($) {
    return M(this, $, !0);
  }),
    (a.prototype.rawListeners = function ($) {
      return M(this, $, !1);
    }),
    (a.listenerCount = function (O, $) {
      return typeof O.listenerCount == "function" ? O.listenerCount($) : S.call(O, $);
    }),
    (a.prototype.listenerCount = S);
  function S(O) {
    var $ = this._events;
    if ($ !== void 0) {
      var J = $[O];
      if (typeof J == "function") return 1;
      if (J !== void 0) return J.length;
    }
    return 0;
  }
  a.prototype.eventNames = function () {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function A(O, $) {
    for (var J = new Array($), he = 0; he < $; ++he) J[he] = O[he];
    return J;
  }
  function k(O, $) {
    for (; $ + 1 < O.length; $++) O[$] = O[$ + 1];
    O.pop();
  }
  function P(O) {
    for (var $ = new Array(O.length), J = 0; J < $.length; ++J) $[J] = O[J].listener || O[J];
    return $;
  }
  function B(O, $) {
    return new Promise(function (J, he) {
      function de(Ae) {
        O.removeListener($, ne), he(Ae);
      }
      function ne() {
        typeof O.removeListener == "function" && O.removeListener("error", de),
          J([].slice.call(arguments));
      }
      F(O, $, ne, { once: !0 }), $ !== "error" && T(O, de, { once: !0 });
    });
  }
  function T(O, $, J) {
    typeof O.on == "function" && F(O, "error", $, J);
  }
  function F(O, $, J, he) {
    if (typeof O.on == "function") he.once ? O.once($, J) : O.on($, J);
    else if (typeof O.addEventListener == "function")
      O.addEventListener($, function de(ne) {
        he.once && O.removeEventListener($, de), J(ne);
      });
    else
      throw new TypeError(
        'The "emitter" argument must be of type EventEmitter. Received type ' + typeof O
      );
  }
  return Gf.exports;
}
var Dc, pv;
function Y6() {
  return pv || ((pv = 1), (Dc = Sf().EventEmitter)), Dc;
}
var Lc = {},
  Fc = {},
  qc,
  mv;
function J6() {
  return (
    mv ||
      ((mv = 1),
      (qc = function () {
        if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
          return !1;
        if (typeof Symbol.iterator == "symbol") return !0;
        var e = {},
          n = Symbol("test"),
          i = Object(n);
        if (
          typeof n == "string" ||
          Object.prototype.toString.call(n) !== "[object Symbol]" ||
          Object.prototype.toString.call(i) !== "[object Symbol]"
        )
          return !1;
        var l = 42;
        e[n] = l;
        for (n in e) return !1;
        if (
          (typeof Object.keys == "function" && Object.keys(e).length !== 0) ||
          (typeof Object.getOwnPropertyNames == "function" &&
            Object.getOwnPropertyNames(e).length !== 0)
        )
          return !1;
        var a = Object.getOwnPropertySymbols(e);
        if (a.length !== 1 || a[0] !== n || !Object.prototype.propertyIsEnumerable.call(e, n))
          return !1;
        if (typeof Object.getOwnPropertyDescriptor == "function") {
          var c = Object.getOwnPropertyDescriptor(e, n);
          if (c.value !== l || c.enumerable !== !0) return !1;
        }
        return !0;
      })),
    qc
  );
}
var zc, vv;
function g1() {
  if (vv) return zc;
  vv = 1;
  var t = J6();
  return (
    (zc = function () {
      return t() && !!Symbol.toStringTag;
    }),
    zc
  );
}
var jc, gv;
function wM() {
  return gv || ((gv = 1), (jc = Error)), jc;
}
var $c, yv;
function _M() {
  return yv || ((yv = 1), ($c = EvalError)), $c;
}
var Hc, bv;
function xM() {
  return bv || ((bv = 1), (Hc = RangeError)), Hc;
}
var Vc, wv;
function MM() {
  return wv || ((wv = 1), (Vc = ReferenceError)), Vc;
}
var Wc, _v;
function Q6() {
  return _v || ((_v = 1), (Wc = SyntaxError)), Wc;
}
var Kc, xv;
function Pu() {
  return xv || ((xv = 1), (Kc = TypeError)), Kc;
}
var Zc, Mv;
function SM() {
  return Mv || ((Mv = 1), (Zc = URIError)), Zc;
}
var Gc, Sv;
function EM() {
  if (Sv) return Gc;
  Sv = 1;
  var t = typeof Symbol < "u" && Symbol,
    e = J6();
  return (
    (Gc = function () {
      return typeof t != "function" ||
        typeof Symbol != "function" ||
        typeof t("foo") != "symbol" ||
        typeof Symbol("bar") != "symbol"
        ? !1
        : e();
    }),
    Gc
  );
}
var Yc, Ev;
function AM() {
  if (Ev) return Yc;
  Ev = 1;
  var t = {
      __proto__: null,
      foo: {},
    },
    e = Object;
  return (
    (Yc = function () {
      return { __proto__: t }.foo === t.foo && !(t instanceof e);
    }),
    Yc
  );
}
var Jc, Av;
function kM() {
  if (Av) return Jc;
  Av = 1;
  var t = "Function.prototype.bind called on incompatible ",
    e = Object.prototype.toString,
    n = Math.max,
    i = "[object Function]",
    l = function (g, b) {
      for (var p = [], _ = 0; _ < g.length; _ += 1) p[_] = g[_];
      for (var M = 0; M < b.length; M += 1) p[M + g.length] = b[M];
      return p;
    },
    a = function (g, b) {
      for (var p = [], _ = b || 0, M = 0; _ < g.length; _ += 1, M += 1) p[M] = g[_];
      return p;
    },
    c = function (v, g) {
      for (var b = "", p = 0; p < v.length; p += 1) (b += v[p]), p + 1 < v.length && (b += g);
      return b;
    };
  return (
    (Jc = function (g) {
      var b = this;
      if (typeof b != "function" || e.apply(b) !== i) throw new TypeError(t + b);
      for (
        var p = a(arguments, 1),
          _,
          M = function () {
            if (this instanceof _) {
              var B = b.apply(this, l(p, arguments));
              return Object(B) === B ? B : this;
            }
            return b.apply(g, l(p, arguments));
          },
          S = n(0, b.length - p.length),
          A = [],
          k = 0;
        k < S;
        k++
      )
        A[k] = "$" + k;
      if (
        ((_ = Function(
          "binder",
          "return function (" + c(A, ",") + "){ return binder.apply(this,arguments); }"
        )(M)),
        b.prototype)
      ) {
        var P = function () {};
        (P.prototype = b.prototype), (_.prototype = new P()), (P.prototype = null);
      }
      return _;
    }),
    Jc
  );
}
var Qc, kv;
function y1() {
  if (kv) return Qc;
  kv = 1;
  var t = kM();
  return (Qc = Function.prototype.bind || t), Qc;
}
var Xc, Bv;
function BM() {
  if (Bv) return Xc;
  Bv = 1;
  var t = Function.prototype.call,
    e = Object.prototype.hasOwnProperty,
    n = y1();
  return (Xc = n.call(t, e)), Xc;
}
var eh, Cv;
function Ef() {
  if (Cv) return eh;
  Cv = 1;
  var t,
    e = wM(),
    n = _M(),
    i = xM(),
    l = MM(),
    a = Q6(),
    c = Pu(),
    v = SM(),
    g = Function,
    b = function (y) {
      try {
        return g('"use strict"; return (' + y + ").constructor;")();
      } catch {}
    },
    p = Object.getOwnPropertyDescriptor;
  if (p)
    try {
      p({}, "");
    } catch {
      p = null;
    }
  var _ = function () {
      throw new c();
    },
    M = p
      ? (function () {
          try {
            return arguments.callee, _;
          } catch {
            try {
              return p(arguments, "callee").get;
            } catch {
              return _;
            }
          }
        })()
      : _,
    S = EM()(),
    A = AM()(),
    k =
      Object.getPrototypeOf ||
      (A
        ? function (y) {
            return y.__proto__;
          }
        : null),
    P = {},
    B = typeof Uint8Array > "u" || !k ? t : k(Uint8Array),
    T = {
      __proto__: null,
      "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
      "%ArrayIteratorPrototype%": S && k ? k([][Symbol.iterator]()) : t,
      "%AsyncFromSyncIteratorPrototype%": t,
      "%AsyncFunction%": P,
      "%AsyncGenerator%": P,
      "%AsyncGeneratorFunction%": P,
      "%AsyncIteratorPrototype%": P,
      "%Atomics%": typeof Atomics > "u" ? t : Atomics,
      "%BigInt%": typeof BigInt > "u" ? t : BigInt,
      "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
      "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? t : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": e,
      "%eval%": eval,
      // eslint-disable-line no-eval
      "%EvalError%": n,
      "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
      "%Function%": g,
      "%GeneratorFunction%": P,
      "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": S && k ? k(k([][Symbol.iterator]())) : t,
      "%JSON%": typeof JSON == "object" ? JSON : t,
      "%Map%": typeof Map > "u" ? t : Map,
      "%MapIteratorPrototype%":
        typeof Map > "u" || !S || !k ? t : k(/* @__PURE__ */ new Map()[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? t : Promise,
      "%Proxy%": typeof Proxy > "u" ? t : Proxy,
      "%RangeError%": i,
      "%ReferenceError%": l,
      "%Reflect%": typeof Reflect > "u" ? t : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? t : Set,
      "%SetIteratorPrototype%":
        typeof Set > "u" || !S || !k ? t : k(/* @__PURE__ */ new Set()[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": S && k ? k(""[Symbol.iterator]()) : t,
      "%Symbol%": S ? Symbol : t,
      "%SyntaxError%": a,
      "%ThrowTypeError%": M,
      "%TypedArray%": B,
      "%TypeError%": c,
      "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
      "%URIError%": v,
      "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    };
  if (k)
    try {
      null.error;
    } catch (y) {
      var F = k(k(y));
      T["%Error.prototype%"] = F;
    }
  var O = function y(w) {
      var h;
      if (w === "%AsyncFunction%") h = b("async function () {}");
      else if (w === "%GeneratorFunction%") h = b("function* () {}");
      else if (w === "%AsyncGeneratorFunction%") h = b("async function* () {}");
      else if (w === "%AsyncGenerator%") {
        var s = y("%AsyncGeneratorFunction%");
        s && (h = s.prototype);
      } else if (w === "%AsyncIteratorPrototype%") {
        var m = y("%AsyncGenerator%");
        m && k && (h = k(m.prototype));
      }
      return (T[w] = h), h;
    },
    $ = {
      __proto__: null,
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"],
    },
    J = y1(),
    he = BM(),
    de = J.call(Function.call, Array.prototype.concat),
    ne = J.call(Function.apply, Array.prototype.splice),
    Ae = J.call(Function.call, String.prototype.replace),
    x = J.call(Function.call, String.prototype.slice),
    r = J.call(Function.call, RegExp.prototype.exec),
    o =
      /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
    f = /\\(\\)?/g,
    u = function (w) {
      var h = x(w, 0, 1),
        s = x(w, -1);
      if (h === "%" && s !== "%") throw new a("invalid intrinsic syntax, expected closing `%`");
      if (s === "%" && h !== "%") throw new a("invalid intrinsic syntax, expected opening `%`");
      var m = [];
      return (
        Ae(w, o, function (E, R, z, Q) {
          m[m.length] = z ? Ae(Q, f, "$1") : R || E;
        }),
        m
      );
    },
    d = function (w, h) {
      var s = w,
        m;
      if ((he($, s) && ((m = $[s]), (s = "%" + m[0] + "%")), he(T, s))) {
        var E = T[s];
        if ((E === P && (E = O(s)), typeof E > "u" && !h))
          throw new c("intrinsic " + w + " exists, but is not available. Please file an issue!");
        return {
          alias: m,
          name: s,
          value: E,
        };
      }
      throw new a("intrinsic " + w + " does not exist!");
    };
  return (
    (eh = function (w, h) {
      if (typeof w != "string" || w.length === 0)
        throw new c("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && typeof h != "boolean")
        throw new c('"allowMissing" argument must be a boolean');
      if (r(/^%?[^%]*%?$/, w) === null)
        throw new a(
          "`%` may not be present anywhere but at the beginning and end of the intrinsic name"
        );
      var s = u(w),
        m = s.length > 0 ? s[0] : "",
        E = d("%" + m + "%", h),
        R = E.name,
        z = E.value,
        Q = !1,
        G = E.alias;
      G && ((m = G[0]), ne(s, de([0, 1], G)));
      for (var q = 1, Z = !0; q < s.length; q += 1) {
        var te = s[q],
          ue = x(te, 0, 1),
          ae = x(te, -1);
        if (
          (ue === '"' || ue === "'" || ue === "`" || ae === '"' || ae === "'" || ae === "`") &&
          ue !== ae
        )
          throw new a("property names with quotes must have matching quotes");
        if (
          ((te === "constructor" || !Z) && (Q = !0), (m += "." + te), (R = "%" + m + "%"), he(T, R))
        )
          z = T[R];
        else if (z != null) {
          if (!(te in z)) {
            if (!h)
              throw new c(
                "base intrinsic for " + w + " exists, but the property is not available."
              );
            return;
          }
          if (p && q + 1 >= s.length) {
            var K = p(z, te);
            (Z = !!K), Z && "get" in K && !("originalValue" in K.get) ? (z = K.get) : (z = z[te]);
          } else (Z = he(z, te)), (z = z[te]);
          Z && !Q && (T[R] = z);
        }
      }
      return z;
    }),
    eh
  );
}
var th = { exports: {} },
  rh,
  Tv;
function b1() {
  if (Tv) return rh;
  Tv = 1;
  var t = Ef(),
    e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return (rh = e), rh;
}
var nh, Pv;
function w1() {
  if (Pv) return nh;
  Pv = 1;
  var t = Ef(),
    e = t("%Object.getOwnPropertyDescriptor%", !0);
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return (nh = e), nh;
}
var ih, Rv;
function CM() {
  if (Rv) return ih;
  Rv = 1;
  var t = b1(),
    e = Q6(),
    n = Pu(),
    i = w1();
  return (
    (ih = function (a, c, v) {
      if (!a || (typeof a != "object" && typeof a != "function"))
        throw new n("`obj` must be an object or a function`");
      if (typeof c != "string" && typeof c != "symbol")
        throw new n("`property` must be a string or a symbol`");
      if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
        throw new n("`nonEnumerable`, if provided, must be a boolean or null");
      if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
        throw new n("`nonWritable`, if provided, must be a boolean or null");
      if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
        throw new n("`nonConfigurable`, if provided, must be a boolean or null");
      if (arguments.length > 6 && typeof arguments[6] != "boolean")
        throw new n("`loose`, if provided, must be a boolean");
      var g = arguments.length > 3 ? arguments[3] : null,
        b = arguments.length > 4 ? arguments[4] : null,
        p = arguments.length > 5 ? arguments[5] : null,
        _ = arguments.length > 6 ? arguments[6] : !1,
        M = !!i && i(a, c);
      if (t)
        t(a, c, {
          configurable: p === null && M ? M.configurable : !p,
          enumerable: g === null && M ? M.enumerable : !g,
          value: v,
          writable: b === null && M ? M.writable : !b,
        });
      else if (_ || (!g && !b && !p)) a[c] = v;
      else
        throw new e(
          "This environment does not support defining a property as non-configurable, non-writable, or non-enumerable."
        );
    }),
    ih
  );
}
var ah, Iv;
function TM() {
  if (Iv) return ah;
  Iv = 1;
  var t = b1(),
    e = function () {
      return !!t;
    };
  return (
    (e.hasArrayLengthDefineBug = function () {
      if (!t) return null;
      try {
        return t([], "length", { value: 1 }).length !== 1;
      } catch {
        return !0;
      }
    }),
    (ah = e),
    ah
  );
}
var sh, Ov;
function PM() {
  if (Ov) return sh;
  Ov = 1;
  var t = Ef(),
    e = CM(),
    n = TM()(),
    i = w1(),
    l = Pu(),
    a = t("%Math.floor%");
  return (
    (sh = function (v, g) {
      if (typeof v != "function") throw new l("`fn` is not a function");
      if (typeof g != "number" || g < 0 || g > 4294967295 || a(g) !== g)
        throw new l("`length` must be a positive 32-bit integer");
      var b = arguments.length > 2 && !!arguments[2],
        p = !0,
        _ = !0;
      if ("length" in v && i) {
        var M = i(v, "length");
        M && !M.configurable && (p = !1), M && !M.writable && (_ = !1);
      }
      return (
        (p || _ || !b) &&
          (n
            ? e(
                /** @type {Parameters<define>[0]} */
                v,
                "length",
                g,
                !0,
                !0
              )
            : e(
                /** @type {Parameters<define>[0]} */
                v,
                "length",
                g
              )),
        v
      );
    }),
    sh
  );
}
var Uv;
function X6() {
  return (
    Uv ||
      ((Uv = 1),
      (function (t) {
        var e = y1(),
          n = Ef(),
          i = PM(),
          l = Pu(),
          a = n("%Function.prototype.apply%"),
          c = n("%Function.prototype.call%"),
          v = n("%Reflect.apply%", !0) || e.call(c, a),
          g = b1(),
          b = n("%Math.max%");
        t.exports = function (M) {
          if (typeof M != "function") throw new l("a function is required");
          var S = v(e, c, arguments);
          return i(S, 1 + b(0, M.length - (arguments.length - 1)), !0);
        };
        var p = function () {
          return v(e, a, arguments);
        };
        g ? g(t.exports, "apply", { value: p }) : (t.exports.apply = p);
      })(th)),
    th.exports
  );
}
var oh, Nv;
function ew() {
  if (Nv) return oh;
  Nv = 1;
  var t = Ef(),
    e = X6(),
    n = e(t("String.prototype.indexOf"));
  return (
    (oh = function (l, a) {
      var c = t(l, !!a);
      return typeof c == "function" && n(l, ".prototype.") > -1 ? e(c) : c;
    }),
    oh
  );
}
var fh, Dv;
function RM() {
  if (Dv) return fh;
  Dv = 1;
  var t = g1()(),
    e = ew(),
    n = e("Object.prototype.toString"),
    i = function (v) {
      return t && v && typeof v == "object" && Symbol.toStringTag in v
        ? !1
        : n(v) === "[object Arguments]";
    },
    l = function (v) {
      return i(v)
        ? !0
        : v !== null &&
            typeof v == "object" &&
            typeof v.length == "number" &&
            v.length >= 0 &&
            n(v) !== "[object Array]" &&
            n(v.callee) === "[object Function]";
    },
    a = (function () {
      return i(arguments);
    })();
  return (i.isLegacyArguments = l), (fh = a ? i : l), fh;
}
var lh, Lv;
function IM() {
  if (Lv) return lh;
  Lv = 1;
  var t = Object.prototype.toString,
    e = Function.prototype.toString,
    n = /^\s*(?:function)?\*/,
    i = g1()(),
    l = Object.getPrototypeOf,
    a = function () {
      if (!i) return !1;
      try {
        return Function("return function*() {}")();
      } catch {}
    },
    c;
  return (
    (lh = function (g) {
      if (typeof g != "function") return !1;
      if (n.test(e.call(g))) return !0;
      if (!i) {
        var b = t.call(g);
        return b === "[object GeneratorFunction]";
      }
      if (!l) return !1;
      if (typeof c > "u") {
        var p = a();
        c = p ? l(p) : !1;
      }
      return l(g) === c;
    }),
    lh
  );
}
var uh, Fv;
function OM() {
  if (Fv) return uh;
  Fv = 1;
  var t = Function.prototype.toString,
    e = typeof Reflect == "object" && Reflect !== null && Reflect.apply,
    n,
    i;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      (n = Object.defineProperty({}, "length", {
        get: function () {
          throw i;
        },
      })),
        (i = {}),
        e(
          function () {
            throw 42;
          },
          null,
          n
        );
    } catch (T) {
      T !== i && (e = null);
    }
  else e = null;
  var l = /^\s*class\b/,
    a = function (F) {
      try {
        var O = t.call(F);
        return l.test(O);
      } catch {
        return !1;
      }
    },
    c = function (F) {
      try {
        return a(F) ? !1 : (t.call(F), !0);
      } catch {
        return !1;
      }
    },
    v = Object.prototype.toString,
    g = "[object Object]",
    b = "[object Function]",
    p = "[object GeneratorFunction]",
    _ = "[object HTMLAllCollection]",
    M = "[object HTML document.all class]",
    S = "[object HTMLCollection]",
    A = typeof Symbol == "function" && !!Symbol.toStringTag,
    k = !(0 in [,]),
    P = function () {
      return !1;
    };
  if (typeof document == "object") {
    var B = document.all;
    v.call(B) === v.call(document.all) &&
      (P = function (F) {
        if ((k || !F) && (typeof F > "u" || typeof F == "object"))
          try {
            var O = v.call(F);
            return (O === _ || O === M || O === S || O === g) && F("") == null;
          } catch {}
        return !1;
      });
  }
  return (
    (uh = e
      ? function (F) {
          if (P(F)) return !0;
          if (!F || (typeof F != "function" && typeof F != "object")) return !1;
          try {
            e(F, null, n);
          } catch (O) {
            if (O !== i) return !1;
          }
          return !a(F) && c(F);
        }
      : function (F) {
          if (P(F)) return !0;
          if (!F || (typeof F != "function" && typeof F != "object")) return !1;
          if (A) return c(F);
          if (a(F)) return !1;
          var O = v.call(F);
          return O !== b && O !== p && !/^\[object HTML/.test(O) ? !1 : c(F);
        }),
    uh
  );
}
var ch, qv;
function UM() {
  if (qv) return ch;
  qv = 1;
  var t = OM(),
    e = Object.prototype.toString,
    n = Object.prototype.hasOwnProperty,
    i = function (g, b, p) {
      for (var _ = 0, M = g.length; _ < M; _++)
        n.call(g, _) && (p == null ? b(g[_], _, g) : b.call(p, g[_], _, g));
    },
    l = function (g, b, p) {
      for (var _ = 0, M = g.length; _ < M; _++)
        p == null ? b(g.charAt(_), _, g) : b.call(p, g.charAt(_), _, g);
    },
    a = function (g, b, p) {
      for (var _ in g) n.call(g, _) && (p == null ? b(g[_], _, g) : b.call(p, g[_], _, g));
    },
    c = function (g, b, p) {
      if (!t(b)) throw new TypeError("iterator must be a function");
      var _;
      arguments.length >= 3 && (_ = p),
        e.call(g) === "[object Array]"
          ? i(g, b, _)
          : typeof g == "string"
          ? l(g, b, _)
          : a(g, b, _);
    };
  return (ch = c), ch;
}
var hh, zv;
function NM() {
  return (
    zv ||
      ((zv = 1),
      (hh = [
        "Float32Array",
        "Float64Array",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "BigInt64Array",
        "BigUint64Array",
      ])),
    hh
  );
}
var dh, jv;
function DM() {
  if (jv) return dh;
  jv = 1;
  var t = NM(),
    e = typeof globalThis > "u" ? mt : globalThis;
  return (
    (dh = function () {
      for (var i = [], l = 0; l < t.length; l++)
        typeof e[t[l]] == "function" && (i[i.length] = t[l]);
      return i;
    }),
    dh
  );
}
var ph, $v;
function tw() {
  if ($v) return ph;
  $v = 1;
  var t = UM(),
    e = DM(),
    n = X6(),
    i = ew(),
    l = w1(),
    a = i("Object.prototype.toString"),
    c = g1()(),
    v = typeof globalThis > "u" ? mt : globalThis,
    g = e(),
    b = i("String.prototype.slice"),
    p = Object.getPrototypeOf,
    _ =
      i("Array.prototype.indexOf", !0) ||
      function (P, B) {
        for (var T = 0; T < P.length; T += 1) if (P[T] === B) return T;
        return -1;
      },
    M = { __proto__: null };
  c && l && p
    ? t(g, function (k) {
        var P = new v[k]();
        if (Symbol.toStringTag in P) {
          var B = p(P),
            T = l(B, Symbol.toStringTag);
          if (!T) {
            var F = p(B);
            T = l(F, Symbol.toStringTag);
          }
          M["$" + k] = n(T.get);
        }
      })
    : t(g, function (k) {
        var P = new v[k](),
          B = P.slice || P.set;
        B && (M["$" + k] = n(B));
      });
  var S = function (P) {
      var B = !1;
      return (
        t(
          // eslint-disable-next-line no-extra-parens
          /** @type {Record<`\$${TypedArrayName}`, Getter>} */
          /** @type {any} */
          M,
          /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
          function (T, F) {
            if (!B)
              try {
                "$" + T(P) === F && (B = b(F, 1));
              } catch {}
          }
        ),
        B
      );
    },
    A = function (P) {
      var B = !1;
      return (
        t(
          // eslint-disable-next-line no-extra-parens
          /** @type {Record<`\$${TypedArrayName}`, Getter>} */
          /** @type {any} */
          M,
          /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
          function (T, F) {
            if (!B)
              try {
                T(P), (B = b(F, 1));
              } catch {}
          }
        ),
        B
      );
    };
  return (
    (ph = function (P) {
      if (!P || typeof P != "object") return !1;
      if (!c) {
        var B = b(a(P), 8, -1);
        return _(g, B) > -1 ? B : B !== "Object" ? !1 : A(P);
      }
      return l ? S(P) : null;
    }),
    ph
  );
}
var mh, Hv;
function LM() {
  if (Hv) return mh;
  Hv = 1;
  var t = tw();
  return (
    (mh = function (n) {
      return !!t(n);
    }),
    mh
  );
}
var Vv;
function FM() {
  return (
    Vv ||
      ((Vv = 1),
      (function (t) {
        var e = RM(),
          n = IM(),
          i = tw(),
          l = LM();
        function a(be) {
          return be.call.bind(be);
        }
        var c = typeof BigInt < "u",
          v = typeof Symbol < "u",
          g = a(Object.prototype.toString),
          b = a(Number.prototype.valueOf),
          p = a(String.prototype.valueOf),
          _ = a(Boolean.prototype.valueOf);
        if (c) var M = a(BigInt.prototype.valueOf);
        if (v) var S = a(Symbol.prototype.valueOf);
        function A(be, wt) {
          if (typeof be != "object") return !1;
          try {
            return wt(be), !0;
          } catch {
            return !1;
          }
        }
        (t.isArgumentsObject = e), (t.isGeneratorFunction = n), (t.isTypedArray = l);
        function k(be) {
          return (
            (typeof Promise < "u" && be instanceof Promise) ||
            (be !== null &&
              typeof be == "object" &&
              typeof be.then == "function" &&
              typeof be.catch == "function")
          );
        }
        t.isPromise = k;
        function P(be) {
          return typeof ArrayBuffer < "u" && ArrayBuffer.isView
            ? ArrayBuffer.isView(be)
            : l(be) || R(be);
        }
        t.isArrayBufferView = P;
        function B(be) {
          return i(be) === "Uint8Array";
        }
        t.isUint8Array = B;
        function T(be) {
          return i(be) === "Uint8ClampedArray";
        }
        t.isUint8ClampedArray = T;
        function F(be) {
          return i(be) === "Uint16Array";
        }
        t.isUint16Array = F;
        function O(be) {
          return i(be) === "Uint32Array";
        }
        t.isUint32Array = O;
        function $(be) {
          return i(be) === "Int8Array";
        }
        t.isInt8Array = $;
        function J(be) {
          return i(be) === "Int16Array";
        }
        t.isInt16Array = J;
        function he(be) {
          return i(be) === "Int32Array";
        }
        t.isInt32Array = he;
        function de(be) {
          return i(be) === "Float32Array";
        }
        t.isFloat32Array = de;
        function ne(be) {
          return i(be) === "Float64Array";
        }
        t.isFloat64Array = ne;
        function Ae(be) {
          return i(be) === "BigInt64Array";
        }
        t.isBigInt64Array = Ae;
        function x(be) {
          return i(be) === "BigUint64Array";
        }
        t.isBigUint64Array = x;
        function r(be) {
          return g(be) === "[object Map]";
        }
        r.working = typeof Map < "u" && r(/* @__PURE__ */ new Map());
        function o(be) {
          return typeof Map > "u" ? !1 : r.working ? r(be) : be instanceof Map;
        }
        t.isMap = o;
        function f(be) {
          return g(be) === "[object Set]";
        }
        f.working = typeof Set < "u" && f(/* @__PURE__ */ new Set());
        function u(be) {
          return typeof Set > "u" ? !1 : f.working ? f(be) : be instanceof Set;
        }
        t.isSet = u;
        function d(be) {
          return g(be) === "[object WeakMap]";
        }
        d.working = typeof WeakMap < "u" && d(/* @__PURE__ */ new WeakMap());
        function y(be) {
          return typeof WeakMap > "u" ? !1 : d.working ? d(be) : be instanceof WeakMap;
        }
        t.isWeakMap = y;
        function w(be) {
          return g(be) === "[object WeakSet]";
        }
        w.working = typeof WeakSet < "u" && w(/* @__PURE__ */ new WeakSet());
        function h(be) {
          return w(be);
        }
        t.isWeakSet = h;
        function s(be) {
          return g(be) === "[object ArrayBuffer]";
        }
        s.working = typeof ArrayBuffer < "u" && s(new ArrayBuffer());
        function m(be) {
          return typeof ArrayBuffer > "u" ? !1 : s.working ? s(be) : be instanceof ArrayBuffer;
        }
        t.isArrayBuffer = m;
        function E(be) {
          return g(be) === "[object DataView]";
        }
        E.working =
          typeof ArrayBuffer < "u" &&
          typeof DataView < "u" &&
          E(new DataView(new ArrayBuffer(1), 0, 1));
        function R(be) {
          return typeof DataView > "u" ? !1 : E.working ? E(be) : be instanceof DataView;
        }
        t.isDataView = R;
        var z = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
        function Q(be) {
          return g(be) === "[object SharedArrayBuffer]";
        }
        function G(be) {
          return typeof z > "u"
            ? !1
            : (typeof Q.working > "u" && (Q.working = Q(new z())),
              Q.working ? Q(be) : be instanceof z);
        }
        t.isSharedArrayBuffer = G;
        function q(be) {
          return g(be) === "[object AsyncFunction]";
        }
        t.isAsyncFunction = q;
        function Z(be) {
          return g(be) === "[object Map Iterator]";
        }
        t.isMapIterator = Z;
        function te(be) {
          return g(be) === "[object Set Iterator]";
        }
        t.isSetIterator = te;
        function ue(be) {
          return g(be) === "[object Generator]";
        }
        t.isGeneratorObject = ue;
        function ae(be) {
          return g(be) === "[object WebAssembly.Module]";
        }
        t.isWebAssemblyCompiledModule = ae;
        function K(be) {
          return A(be, b);
        }
        t.isNumberObject = K;
        function ve(be) {
          return A(be, p);
        }
        t.isStringObject = ve;
        function Ye(be) {
          return A(be, _);
        }
        t.isBooleanObject = Ye;
        function Ce(be) {
          return c && A(be, M);
        }
        t.isBigIntObject = Ce;
        function Te(be) {
          return v && A(be, S);
        }
        t.isSymbolObject = Te;
        function ut(be) {
          return K(be) || ve(be) || Ye(be) || Ce(be) || Te(be);
        }
        t.isBoxedPrimitive = ut;
        function Ie(be) {
          return typeof Uint8Array < "u" && (m(be) || G(be));
        }
        (t.isAnyArrayBuffer = Ie),
          ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function (be) {
            Object.defineProperty(t, be, {
              enumerable: !1,
              value: function () {
                throw new Error(be + " is not supported in userland");
              },
            });
          });
      })(Fc)),
    Fc
  );
}
var vh, Wv;
function qM() {
  return (
    Wv ||
      ((Wv = 1),
      (vh = function (e) {
        return (
          e &&
          typeof e == "object" &&
          typeof e.copy == "function" &&
          typeof e.fill == "function" &&
          typeof e.readUInt8 == "function"
        );
      })),
    vh
  );
}
var Kv;
function Ru() {
  return (
    Kv ||
      ((Kv = 1),
      (function (t) {
        var e =
            Object.getOwnPropertyDescriptors ||
            function (R) {
              for (var z = Object.keys(R), Q = {}, G = 0; G < z.length; G++)
                Q[z[G]] = Object.getOwnPropertyDescriptor(R, z[G]);
              return Q;
            },
          n = /%[sdj%]/g;
        (t.format = function (E) {
          if (!$(E)) {
            for (var R = [], z = 0; z < arguments.length; z++) R.push(c(arguments[z]));
            return R.join(" ");
          }
          for (
            var z = 1,
              Q = arguments,
              G = Q.length,
              q = String(E).replace(n, function (te) {
                if (te === "%%") return "%";
                if (z >= G) return te;
                switch (te) {
                  case "%s":
                    return String(Q[z++]);
                  case "%d":
                    return Number(Q[z++]);
                  case "%j":
                    try {
                      return JSON.stringify(Q[z++]);
                    } catch {
                      return "[Circular]";
                    }
                  default:
                    return te;
                }
              }),
              Z = Q[z];
            z < G;
            Z = Q[++z]
          )
            T(Z) || !ne(Z) ? (q += " " + Z) : (q += " " + c(Z));
          return q;
        }),
          (t.deprecate = function (E, R) {
            if (typeof Et < "u" && Et.noDeprecation === !0) return E;
            if (typeof Et > "u")
              return function () {
                return t.deprecate(E, R).apply(this, arguments);
              };
            var z = !1;
            function Q() {
              if (!z) {
                if (Et.throwDeprecation) throw new Error(R);
                Et.traceDeprecation ? console.trace(R) : console.error(R), (z = !0);
              }
              return E.apply(this, arguments);
            }
            return Q;
          });
        var i = {},
          l = /^$/;
        if (Et.env.NODE_DEBUG) {
          var a = Et.env.NODE_DEBUG;
          (a = a
            .replace(/[|\\{}()[\]^$+?.]/g, "\\$&")
            .replace(/\*/g, ".*")
            .replace(/,/g, "$|^")
            .toUpperCase()),
            (l = new RegExp("^" + a + "$", "i"));
        }
        t.debuglog = function (E) {
          if (((E = E.toUpperCase()), !i[E]))
            if (l.test(E)) {
              var R = Et.pid;
              i[E] = function () {
                var z = t.format.apply(t, arguments);
                console.error("%s %d: %s", E, R, z);
              };
            } else i[E] = function () {};
          return i[E];
        };
        function c(E, R) {
          var z = {
            seen: [],
            stylize: g,
          };
          return (
            arguments.length >= 3 && (z.depth = arguments[2]),
            arguments.length >= 4 && (z.colors = arguments[3]),
            B(R) ? (z.showHidden = R) : R && t._extend(z, R),
            he(z.showHidden) && (z.showHidden = !1),
            he(z.depth) && (z.depth = 2),
            he(z.colors) && (z.colors = !1),
            he(z.customInspect) && (z.customInspect = !0),
            z.colors && (z.stylize = v),
            p(z, E, z.depth)
          );
        }
        (t.inspect = c),
          (c.colors = {
            bold: [1, 22],
            italic: [3, 23],
            underline: [4, 24],
            inverse: [7, 27],
            white: [37, 39],
            grey: [90, 39],
            black: [30, 39],
            blue: [34, 39],
            cyan: [36, 39],
            green: [32, 39],
            magenta: [35, 39],
            red: [31, 39],
            yellow: [33, 39],
          }),
          (c.styles = {
            special: "cyan",
            number: "yellow",
            boolean: "yellow",
            undefined: "grey",
            null: "bold",
            string: "green",
            date: "magenta",
            // "name": intentionally not styling
            regexp: "red",
          });
        function v(E, R) {
          var z = c.styles[R];
          return z ? "\x1B[" + c.colors[z][0] + "m" + E + "\x1B[" + c.colors[z][1] + "m" : E;
        }
        function g(E, R) {
          return E;
        }
        function b(E) {
          var R = {};
          return (
            E.forEach(function (z, Q) {
              R[z] = !0;
            }),
            R
          );
        }
        function p(E, R, z) {
          if (
            E.customInspect &&
            R &&
            r(R.inspect) && // Filter out the util module, it's inspect function is special
            R.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
            !(R.constructor && R.constructor.prototype === R)
          ) {
            var Q = R.inspect(z, E);
            return $(Q) || (Q = p(E, Q, z)), Q;
          }
          var G = _(E, R);
          if (G) return G;
          var q = Object.keys(R),
            Z = b(q);
          if (
            (E.showHidden && (q = Object.getOwnPropertyNames(R)),
            x(R) && (q.indexOf("message") >= 0 || q.indexOf("description") >= 0))
          )
            return M(R);
          if (q.length === 0) {
            if (r(R)) {
              var te = R.name ? ": " + R.name : "";
              return E.stylize("[Function" + te + "]", "special");
            }
            if (de(R)) return E.stylize(RegExp.prototype.toString.call(R), "regexp");
            if (Ae(R)) return E.stylize(Date.prototype.toString.call(R), "date");
            if (x(R)) return M(R);
          }
          var ue = "",
            ae = !1,
            K = ["{", "}"];
          if ((P(R) && ((ae = !0), (K = ["[", "]"])), r(R))) {
            var ve = R.name ? ": " + R.name : "";
            ue = " [Function" + ve + "]";
          }
          if (
            (de(R) && (ue = " " + RegExp.prototype.toString.call(R)),
            Ae(R) && (ue = " " + Date.prototype.toUTCString.call(R)),
            x(R) && (ue = " " + M(R)),
            q.length === 0 && (!ae || R.length == 0))
          )
            return K[0] + ue + K[1];
          if (z < 0)
            return de(R)
              ? E.stylize(RegExp.prototype.toString.call(R), "regexp")
              : E.stylize("[Object]", "special");
          E.seen.push(R);
          var Ye;
          return (
            ae
              ? (Ye = S(E, R, z, Z, q))
              : (Ye = q.map(function (Ce) {
                  return A(E, R, z, Z, Ce, ae);
                })),
            E.seen.pop(),
            k(Ye, ue, K)
          );
        }
        function _(E, R) {
          if (he(R)) return E.stylize("undefined", "undefined");
          if ($(R)) {
            var z =
              "'" +
              JSON.stringify(R).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') +
              "'";
            return E.stylize(z, "string");
          }
          if (O(R)) return E.stylize("" + R, "number");
          if (B(R)) return E.stylize("" + R, "boolean");
          if (T(R)) return E.stylize("null", "null");
        }
        function M(E) {
          return "[" + Error.prototype.toString.call(E) + "]";
        }
        function S(E, R, z, Q, G) {
          for (var q = [], Z = 0, te = R.length; Z < te; ++Z)
            w(R, String(Z)) ? q.push(A(E, R, z, Q, String(Z), !0)) : q.push("");
          return (
            G.forEach(function (ue) {
              ue.match(/^\d+$/) || q.push(A(E, R, z, Q, ue, !0));
            }),
            q
          );
        }
        function A(E, R, z, Q, G, q) {
          var Z, te, ue;
          if (
            ((ue = Object.getOwnPropertyDescriptor(R, G) || { value: R[G] }),
            ue.get
              ? ue.set
                ? (te = E.stylize("[Getter/Setter]", "special"))
                : (te = E.stylize("[Getter]", "special"))
              : ue.set && (te = E.stylize("[Setter]", "special")),
            w(Q, G) || (Z = "[" + G + "]"),
            te ||
              (E.seen.indexOf(ue.value) < 0
                ? (T(z) ? (te = p(E, ue.value, null)) : (te = p(E, ue.value, z - 1)),
                  te.indexOf(`
`) > -1 &&
                    (q
                      ? (te = te
                          .split(
                            `
`
                          )
                          .map(function (ae) {
                            return "  " + ae;
                          })
                          .join(
                            `
`
                          )
                          .slice(2))
                      : (te =
                          `
` +
                          te
                            .split(
                              `
`
                            )
                            .map(function (ae) {
                              return "   " + ae;
                            }).join(`
`))))
                : (te = E.stylize("[Circular]", "special"))),
            he(Z))
          ) {
            if (q && G.match(/^\d+$/)) return te;
            (Z = JSON.stringify("" + G)),
              Z.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)
                ? ((Z = Z.slice(1, -1)), (Z = E.stylize(Z, "name")))
                : ((Z = Z.replace(/'/g, "\\'")
                    .replace(/\\"/g, '"')
                    .replace(/(^"|"$)/g, "'")),
                  (Z = E.stylize(Z, "string")));
          }
          return Z + ": " + te;
        }
        function k(E, R, z) {
          var Q = E.reduce(function (G, q) {
            return (
              q.indexOf(`
`) >= 0,
              G + q.replace(/\u001b\[\d\d?m/g, "").length + 1
            );
          }, 0);
          return Q > 60
            ? z[0] +
                (R === ""
                  ? ""
                  : R +
                    `
 `) +
                " " +
                E.join(`,
  `) +
                " " +
                z[1]
            : z[0] + R + " " + E.join(", ") + " " + z[1];
        }
        t.types = FM();
        function P(E) {
          return Array.isArray(E);
        }
        t.isArray = P;
        function B(E) {
          return typeof E == "boolean";
        }
        t.isBoolean = B;
        function T(E) {
          return E === null;
        }
        t.isNull = T;
        function F(E) {
          return E == null;
        }
        t.isNullOrUndefined = F;
        function O(E) {
          return typeof E == "number";
        }
        t.isNumber = O;
        function $(E) {
          return typeof E == "string";
        }
        t.isString = $;
        function J(E) {
          return typeof E == "symbol";
        }
        t.isSymbol = J;
        function he(E) {
          return E === void 0;
        }
        t.isUndefined = he;
        function de(E) {
          return ne(E) && f(E) === "[object RegExp]";
        }
        (t.isRegExp = de), (t.types.isRegExp = de);
        function ne(E) {
          return typeof E == "object" && E !== null;
        }
        t.isObject = ne;
        function Ae(E) {
          return ne(E) && f(E) === "[object Date]";
        }
        (t.isDate = Ae), (t.types.isDate = Ae);
        function x(E) {
          return ne(E) && (f(E) === "[object Error]" || E instanceof Error);
        }
        (t.isError = x), (t.types.isNativeError = x);
        function r(E) {
          return typeof E == "function";
        }
        t.isFunction = r;
        function o(E) {
          return (
            E === null ||
            typeof E == "boolean" ||
            typeof E == "number" ||
            typeof E == "string" ||
            typeof E == "symbol" || // ES6 symbol
            typeof E > "u"
          );
        }
        (t.isPrimitive = o), (t.isBuffer = qM());
        function f(E) {
          return Object.prototype.toString.call(E);
        }
        function u(E) {
          return E < 10 ? "0" + E.toString(10) : E.toString(10);
        }
        var d = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        function y() {
          var E = /* @__PURE__ */ new Date(),
            R = [u(E.getHours()), u(E.getMinutes()), u(E.getSeconds())].join(":");
          return [E.getDate(), d[E.getMonth()], R].join(" ");
        }
        (t.log = function () {
          console.log("%s - %s", y(), t.format.apply(t, arguments));
        }),
          (t.inherits = It()),
          (t._extend = function (E, R) {
            if (!R || !ne(R)) return E;
            for (var z = Object.keys(R), Q = z.length; Q--; ) E[z[Q]] = R[z[Q]];
            return E;
          });
        function w(E, R) {
          return Object.prototype.hasOwnProperty.call(E, R);
        }
        var h = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
        (t.promisify = function (R) {
          if (typeof R != "function")
            throw new TypeError('The "original" argument must be of type Function');
          if (h && R[h]) {
            var z = R[h];
            if (typeof z != "function")
              throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            return (
              Object.defineProperty(z, h, {
                value: z,
                enumerable: !1,
                writable: !1,
                configurable: !0,
              }),
              z
            );
          }
          function z() {
            for (
              var Q,
                G,
                q = new Promise(function (ue, ae) {
                  (Q = ue), (G = ae);
                }),
                Z = [],
                te = 0;
              te < arguments.length;
              te++
            )
              Z.push(arguments[te]);
            Z.push(function (ue, ae) {
              ue ? G(ue) : Q(ae);
            });
            try {
              R.apply(this, Z);
            } catch (ue) {
              G(ue);
            }
            return q;
          }
          return (
            Object.setPrototypeOf(z, Object.getPrototypeOf(R)),
            h &&
              Object.defineProperty(z, h, {
                value: z,
                enumerable: !1,
                writable: !1,
                configurable: !0,
              }),
            Object.defineProperties(z, e(R))
          );
        }),
          (t.promisify.custom = h);
        function s(E, R) {
          if (!E) {
            var z = new Error("Promise was rejected with a falsy value");
            (z.reason = E), (E = z);
          }
          return R(E);
        }
        function m(E) {
          if (typeof E != "function")
            throw new TypeError('The "original" argument must be of type Function');
          function R() {
            for (var z = [], Q = 0; Q < arguments.length; Q++) z.push(arguments[Q]);
            var G = z.pop();
            if (typeof G != "function")
              throw new TypeError("The last argument must be of type Function");
            var q = this,
              Z = function () {
                return G.apply(q, arguments);
              };
            E.apply(this, z).then(
              function (te) {
                Et.nextTick(Z.bind(null, null, te));
              },
              function (te) {
                Et.nextTick(s.bind(null, te, Z));
              }
            );
          }
          return (
            Object.setPrototypeOf(R, Object.getPrototypeOf(E)), Object.defineProperties(R, e(E)), R
          );
        }
        t.callbackify = m;
      })(Lc)),
    Lc
  );
}
var gh, Zv;
function zM() {
  if (Zv) return gh;
  Zv = 1;
  function t(A, k) {
    var P = Object.keys(A);
    if (Object.getOwnPropertySymbols) {
      var B = Object.getOwnPropertySymbols(A);
      k &&
        (B = B.filter(function (T) {
          return Object.getOwnPropertyDescriptor(A, T).enumerable;
        })),
        P.push.apply(P, B);
    }
    return P;
  }
  function e(A) {
    for (var k = 1; k < arguments.length; k++) {
      var P = arguments[k] != null ? arguments[k] : {};
      k % 2
        ? t(Object(P), !0).forEach(function (B) {
            n(A, B, P[B]);
          })
        : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(P))
        : t(Object(P)).forEach(function (B) {
            Object.defineProperty(A, B, Object.getOwnPropertyDescriptor(P, B));
          });
    }
    return A;
  }
  function n(A, k, P) {
    return (
      (k = c(k)),
      k in A
        ? Object.defineProperty(A, k, { value: P, enumerable: !0, configurable: !0, writable: !0 })
        : (A[k] = P),
      A
    );
  }
  function i(A, k) {
    if (!(A instanceof k)) throw new TypeError("Cannot call a class as a function");
  }
  function l(A, k) {
    for (var P = 0; P < k.length; P++) {
      var B = k[P];
      (B.enumerable = B.enumerable || !1),
        (B.configurable = !0),
        "value" in B && (B.writable = !0),
        Object.defineProperty(A, c(B.key), B);
    }
  }
  function a(A, k, P) {
    return (
      k && l(A.prototype, k),
      P && l(A, P),
      Object.defineProperty(A, "prototype", { writable: !1 }),
      A
    );
  }
  function c(A) {
    var k = v(A, "string");
    return typeof k == "symbol" ? k : String(k);
  }
  function v(A, k) {
    if (typeof A != "object" || A === null) return A;
    var P = A[Symbol.toPrimitive];
    if (P !== void 0) {
      var B = P.call(A, k || "default");
      if (typeof B != "object") return B;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (k === "string" ? String : Number)(A);
  }
  var g = Mr,
    b = g.Buffer,
    p = Ru(),
    _ = p.inspect,
    M = (_ && _.custom) || "inspect";
  function S(A, k, P) {
    b.prototype.copy.call(A, k, P);
  }
  return (
    (gh = /* @__PURE__ */ (function () {
      function A() {
        i(this, A), (this.head = null), (this.tail = null), (this.length = 0);
      }
      return (
        a(A, [
          {
            key: "push",
            value: function (P) {
              var B = {
                data: P,
                next: null,
              };
              this.length > 0 ? (this.tail.next = B) : (this.head = B),
                (this.tail = B),
                ++this.length;
            },
          },
          {
            key: "unshift",
            value: function (P) {
              var B = {
                data: P,
                next: this.head,
              };
              this.length === 0 && (this.tail = B), (this.head = B), ++this.length;
            },
          },
          {
            key: "shift",
            value: function () {
              if (this.length !== 0) {
                var P = this.head.data;
                return (
                  this.length === 1 ? (this.head = this.tail = null) : (this.head = this.head.next),
                  --this.length,
                  P
                );
              }
            },
          },
          {
            key: "clear",
            value: function () {
              (this.head = this.tail = null), (this.length = 0);
            },
          },
          {
            key: "join",
            value: function (P) {
              if (this.length === 0) return "";
              for (var B = this.head, T = "" + B.data; (B = B.next); ) T += P + B.data;
              return T;
            },
          },
          {
            key: "concat",
            value: function (P) {
              if (this.length === 0) return b.alloc(0);
              for (var B = b.allocUnsafe(P >>> 0), T = this.head, F = 0; T; )
                S(T.data, B, F), (F += T.data.length), (T = T.next);
              return B;
            },
            // Consumes a specified amount of bytes or characters from the buffered data.
          },
          {
            key: "consume",
            value: function (P, B) {
              var T;
              return (
                P < this.head.data.length
                  ? ((T = this.head.data.slice(0, P)), (this.head.data = this.head.data.slice(P)))
                  : P === this.head.data.length
                  ? (T = this.shift())
                  : (T = B ? this._getString(P) : this._getBuffer(P)),
                T
              );
            },
          },
          {
            key: "first",
            value: function () {
              return this.head.data;
            },
            // Consumes a specified amount of characters from the buffered data.
          },
          {
            key: "_getString",
            value: function (P) {
              var B = this.head,
                T = 1,
                F = B.data;
              for (P -= F.length; (B = B.next); ) {
                var O = B.data,
                  $ = P > O.length ? O.length : P;
                if (($ === O.length ? (F += O) : (F += O.slice(0, P)), (P -= $), P === 0)) {
                  $ === O.length
                    ? (++T, B.next ? (this.head = B.next) : (this.head = this.tail = null))
                    : ((this.head = B), (B.data = O.slice($)));
                  break;
                }
                ++T;
              }
              return (this.length -= T), F;
            },
            // Consumes a specified amount of bytes from the buffered data.
          },
          {
            key: "_getBuffer",
            value: function (P) {
              var B = b.allocUnsafe(P),
                T = this.head,
                F = 1;
              for (T.data.copy(B), P -= T.data.length; (T = T.next); ) {
                var O = T.data,
                  $ = P > O.length ? O.length : P;
                if ((O.copy(B, B.length - P, 0, $), (P -= $), P === 0)) {
                  $ === O.length
                    ? (++F, T.next ? (this.head = T.next) : (this.head = this.tail = null))
                    : ((this.head = T), (T.data = O.slice($)));
                  break;
                }
                ++F;
              }
              return (this.length -= F), B;
            },
            // Make sure the linked list only shows the minimal necessary information.
          },
          {
            key: M,
            value: function (P, B) {
              return _(
                this,
                e(
                  e({}, B),
                  {},
                  {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: !1,
                  }
                )
              );
            },
          },
        ]),
        A
      );
    })()),
    gh
  );
}
var yh, Gv;
function rw() {
  if (Gv) return yh;
  Gv = 1;
  function t(c, v) {
    var g = this,
      b = this._readableState && this._readableState.destroyed,
      p = this._writableState && this._writableState.destroyed;
    return b || p
      ? (v
          ? v(c)
          : c &&
            (this._writableState
              ? this._writableState.errorEmitted ||
                ((this._writableState.errorEmitted = !0), Et.nextTick(l, this, c))
              : Et.nextTick(l, this, c)),
        this)
      : (this._readableState && (this._readableState.destroyed = !0),
        this._writableState && (this._writableState.destroyed = !0),
        this._destroy(c || null, function (_) {
          !v && _
            ? g._writableState
              ? g._writableState.errorEmitted
                ? Et.nextTick(n, g)
                : ((g._writableState.errorEmitted = !0), Et.nextTick(e, g, _))
              : Et.nextTick(e, g, _)
            : v
            ? (Et.nextTick(n, g), v(_))
            : Et.nextTick(n, g);
        }),
        this);
  }
  function e(c, v) {
    l(c, v), n(c);
  }
  function n(c) {
    (c._writableState && !c._writableState.emitClose) ||
      (c._readableState && !c._readableState.emitClose) ||
      c.emit("close");
  }
  function i() {
    this._readableState &&
      ((this._readableState.destroyed = !1),
      (this._readableState.reading = !1),
      (this._readableState.ended = !1),
      (this._readableState.endEmitted = !1)),
      this._writableState &&
        ((this._writableState.destroyed = !1),
        (this._writableState.ended = !1),
        (this._writableState.ending = !1),
        (this._writableState.finalCalled = !1),
        (this._writableState.prefinished = !1),
        (this._writableState.finished = !1),
        (this._writableState.errorEmitted = !1));
  }
  function l(c, v) {
    c.emit("error", v);
  }
  function a(c, v) {
    var g = c._readableState,
      b = c._writableState;
    (g && g.autoDestroy) || (b && b.autoDestroy) ? c.destroy(v) : c.emit("error", v);
  }
  return (
    (yh = {
      destroy: t,
      undestroy: i,
      errorOrDestroy: a,
    }),
    yh
  );
}
var bh = {},
  Yv;
function oo() {
  if (Yv) return bh;
  Yv = 1;
  function t(v, g) {
    (v.prototype = Object.create(g.prototype)), (v.prototype.constructor = v), (v.__proto__ = g);
  }
  var e = {};
  function n(v, g, b) {
    b || (b = Error);
    function p(M, S, A) {
      return typeof g == "string" ? g : g(M, S, A);
    }
    var _ = /* @__PURE__ */ (function (M) {
      t(S, M);
      function S(A, k, P) {
        return M.call(this, p(A, k, P)) || this;
      }
      return S;
    })(b);
    (_.prototype.name = b.name), (_.prototype.code = v), (e[v] = _);
  }
  function i(v, g) {
    if (Array.isArray(v)) {
      var b = v.length;
      return (
        (v = v.map(function (p) {
          return String(p);
        })),
        b > 2
          ? "one of ".concat(g, " ").concat(v.slice(0, b - 1).join(", "), ", or ") + v[b - 1]
          : b === 2
          ? "one of ".concat(g, " ").concat(v[0], " or ").concat(v[1])
          : "of ".concat(g, " ").concat(v[0])
      );
    } else return "of ".concat(g, " ").concat(String(v));
  }
  function l(v, g, b) {
    return v.substr(!b || b < 0 ? 0 : +b, g.length) === g;
  }
  function a(v, g, b) {
    return (b === void 0 || b > v.length) && (b = v.length), v.substring(b - g.length, b) === g;
  }
  function c(v, g, b) {
    return typeof b != "number" && (b = 0), b + g.length > v.length ? !1 : v.indexOf(g, b) !== -1;
  }
  return (
    n(
      "ERR_INVALID_OPT_VALUE",
      function (v, g) {
        return 'The value "' + g + '" is invalid for option "' + v + '"';
      },
      TypeError
    ),
    n(
      "ERR_INVALID_ARG_TYPE",
      function (v, g, b) {
        var p;
        typeof g == "string" && l(g, "not ")
          ? ((p = "must not be"), (g = g.replace(/^not /, "")))
          : (p = "must be");
        var _;
        if (a(v, " argument")) _ = "The ".concat(v, " ").concat(p, " ").concat(i(g, "type"));
        else {
          var M = c(v, ".") ? "property" : "argument";
          _ = 'The "'.concat(v, '" ').concat(M, " ").concat(p, " ").concat(i(g, "type"));
        }
        return (_ += ". Received type ".concat(typeof b)), _;
      },
      TypeError
    ),
    n("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"),
    n("ERR_METHOD_NOT_IMPLEMENTED", function (v) {
      return "The " + v + " method is not implemented";
    }),
    n("ERR_STREAM_PREMATURE_CLOSE", "Premature close"),
    n("ERR_STREAM_DESTROYED", function (v) {
      return "Cannot call " + v + " after a stream was destroyed";
    }),
    n("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"),
    n("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"),
    n("ERR_STREAM_WRITE_AFTER_END", "write after end"),
    n("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError),
    n(
      "ERR_UNKNOWN_ENCODING",
      function (v) {
        return "Unknown encoding: " + v;
      },
      TypeError
    ),
    n("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"),
    (bh.codes = e),
    bh
  );
}
var wh, Jv;
function nw() {
  if (Jv) return wh;
  Jv = 1;
  var t = oo().codes.ERR_INVALID_OPT_VALUE;
  function e(i, l, a) {
    return i.highWaterMark != null ? i.highWaterMark : l ? i[a] : null;
  }
  function n(i, l, a, c) {
    var v = e(l, c, a);
    if (v != null) {
      if (!(isFinite(v) && Math.floor(v) === v) || v < 0) {
        var g = c ? a : "highWaterMark";
        throw new t(g, v);
      }
      return Math.floor(v);
    }
    return i.objectMode ? 16 : 16 * 1024;
  }
  return (
    (wh = {
      getHighWaterMark: n,
    }),
    wh
  );
}
var _h, Qv;
function iw() {
  if (Qv) return _h;
  (Qv = 1), (_h = t);
  function t(n, i) {
    if (e("noDeprecation")) return n;
    var l = !1;
    function a() {
      if (!l) {
        if (e("throwDeprecation")) throw new Error(i);
        e("traceDeprecation") ? console.trace(i) : console.warn(i), (l = !0);
      }
      return n.apply(this, arguments);
    }
    return a;
  }
  function e(n) {
    try {
      if (!mt.localStorage) return !1;
    } catch {
      return !1;
    }
    var i = mt.localStorage[n];
    return i == null ? !1 : String(i).toLowerCase() === "true";
  }
  return _h;
}
var xh, Xv;
function aw() {
  if (Xv) return xh;
  (Xv = 1), (xh = de);
  function t(G) {
    var q = this;
    (this.next = null),
      (this.entry = null),
      (this.finish = function () {
        Q(q, G);
      });
  }
  var e;
  de.WritableState = J;
  var n = {
      deprecate: iw(),
    },
    i = Y6(),
    l = Mr.Buffer,
    a =
      (typeof mt < "u" ? mt : typeof window < "u" ? window : typeof self < "u" ? self : {})
        .Uint8Array || function () {};
  function c(G) {
    return l.from(G);
  }
  function v(G) {
    return l.isBuffer(G) || G instanceof a;
  }
  var g = rw(),
    b = nw(),
    p = b.getHighWaterMark,
    _ = oo().codes,
    M = _.ERR_INVALID_ARG_TYPE,
    S = _.ERR_METHOD_NOT_IMPLEMENTED,
    A = _.ERR_MULTIPLE_CALLBACK,
    k = _.ERR_STREAM_CANNOT_PIPE,
    P = _.ERR_STREAM_DESTROYED,
    B = _.ERR_STREAM_NULL_VALUES,
    T = _.ERR_STREAM_WRITE_AFTER_END,
    F = _.ERR_UNKNOWN_ENCODING,
    O = g.errorOrDestroy;
  It()(de, i);
  function $() {}
  function J(G, q, Z) {
    (e = e || Fs()),
      (G = G || {}),
      typeof Z != "boolean" && (Z = q instanceof e),
      (this.objectMode = !!G.objectMode),
      Z && (this.objectMode = this.objectMode || !!G.writableObjectMode),
      (this.highWaterMark = p(this, G, "writableHighWaterMark", Z)),
      (this.finalCalled = !1),
      (this.needDrain = !1),
      (this.ending = !1),
      (this.ended = !1),
      (this.finished = !1),
      (this.destroyed = !1);
    var te = G.decodeStrings === !1;
    (this.decodeStrings = !te),
      (this.defaultEncoding = G.defaultEncoding || "utf8"),
      (this.length = 0),
      (this.writing = !1),
      (this.corked = 0),
      (this.sync = !0),
      (this.bufferProcessing = !1),
      (this.onwrite = function (ue) {
        d(q, ue);
      }),
      (this.writecb = null),
      (this.writelen = 0),
      (this.bufferedRequest = null),
      (this.lastBufferedRequest = null),
      (this.pendingcb = 0),
      (this.prefinished = !1),
      (this.errorEmitted = !1),
      (this.emitClose = G.emitClose !== !1),
      (this.autoDestroy = !!G.autoDestroy),
      (this.bufferedRequestCount = 0),
      (this.corkedRequestsFree = new t(this));
  }
  (J.prototype.getBuffer = function () {
    for (var q = this.bufferedRequest, Z = []; q; ) Z.push(q), (q = q.next);
    return Z;
  }),
    (function () {
      try {
        Object.defineProperty(J.prototype, "buffer", {
          get: n.deprecate(
            function () {
              return this.getBuffer();
            },
            "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.",
            "DEP0003"
          ),
        });
      } catch {}
    })();
  var he;
  typeof Symbol == "function" &&
  Symbol.hasInstance &&
  typeof Function.prototype[Symbol.hasInstance] == "function"
    ? ((he = Function.prototype[Symbol.hasInstance]),
      Object.defineProperty(de, Symbol.hasInstance, {
        value: function (q) {
          return he.call(this, q) ? !0 : this !== de ? !1 : q && q._writableState instanceof J;
        },
      }))
    : (he = function (q) {
        return q instanceof this;
      });
  function de(G) {
    e = e || Fs();
    var q = this instanceof e;
    if (!q && !he.call(de, this)) return new de(G);
    (this._writableState = new J(G, this, q)),
      (this.writable = !0),
      G &&
        (typeof G.write == "function" && (this._write = G.write),
        typeof G.writev == "function" && (this._writev = G.writev),
        typeof G.destroy == "function" && (this._destroy = G.destroy),
        typeof G.final == "function" && (this._final = G.final)),
      i.call(this);
  }
  de.prototype.pipe = function () {
    O(this, new k());
  };
  function ne(G, q) {
    var Z = new T();
    O(G, Z), Et.nextTick(q, Z);
  }
  function Ae(G, q, Z, te) {
    var ue;
    return (
      Z === null
        ? (ue = new B())
        : typeof Z != "string" && !q.objectMode && (ue = new M("chunk", ["string", "Buffer"], Z)),
      ue ? (O(G, ue), Et.nextTick(te, ue), !1) : !0
    );
  }
  (de.prototype.write = function (G, q, Z) {
    var te = this._writableState,
      ue = !1,
      ae = !te.objectMode && v(G);
    return (
      ae && !l.isBuffer(G) && (G = c(G)),
      typeof q == "function" && ((Z = q), (q = null)),
      ae ? (q = "buffer") : q || (q = te.defaultEncoding),
      typeof Z != "function" && (Z = $),
      te.ending
        ? ne(this, Z)
        : (ae || Ae(this, te, G, Z)) && (te.pendingcb++, (ue = r(this, te, ae, G, q, Z))),
      ue
    );
  }),
    (de.prototype.cork = function () {
      this._writableState.corked++;
    }),
    (de.prototype.uncork = function () {
      var G = this._writableState;
      G.corked &&
        (G.corked--,
        !G.writing && !G.corked && !G.bufferProcessing && G.bufferedRequest && h(this, G));
    }),
    (de.prototype.setDefaultEncoding = function (q) {
      if (
        (typeof q == "string" && (q = q.toLowerCase()),
        !(
          [
            "hex",
            "utf8",
            "utf-8",
            "ascii",
            "binary",
            "base64",
            "ucs2",
            "ucs-2",
            "utf16le",
            "utf-16le",
            "raw",
          ].indexOf((q + "").toLowerCase()) > -1
        ))
      )
        throw new F(q);
      return (this._writableState.defaultEncoding = q), this;
    }),
    Object.defineProperty(de.prototype, "writableBuffer", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._writableState && this._writableState.getBuffer();
      },
    });
  function x(G, q, Z) {
    return !G.objectMode && G.decodeStrings !== !1 && typeof q == "string" && (q = l.from(q, Z)), q;
  }
  Object.defineProperty(de.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function () {
      return this._writableState.highWaterMark;
    },
  });
  function r(G, q, Z, te, ue, ae) {
    if (!Z) {
      var K = x(q, te, ue);
      te !== K && ((Z = !0), (ue = "buffer"), (te = K));
    }
    var ve = q.objectMode ? 1 : te.length;
    q.length += ve;
    var Ye = q.length < q.highWaterMark;
    if ((Ye || (q.needDrain = !0), q.writing || q.corked)) {
      var Ce = q.lastBufferedRequest;
      (q.lastBufferedRequest = {
        chunk: te,
        encoding: ue,
        isBuf: Z,
        callback: ae,
        next: null,
      }),
        Ce ? (Ce.next = q.lastBufferedRequest) : (q.bufferedRequest = q.lastBufferedRequest),
        (q.bufferedRequestCount += 1);
    } else o(G, q, !1, ve, te, ue, ae);
    return Ye;
  }
  function o(G, q, Z, te, ue, ae, K) {
    (q.writelen = te),
      (q.writecb = K),
      (q.writing = !0),
      (q.sync = !0),
      q.destroyed
        ? q.onwrite(new P("write"))
        : Z
        ? G._writev(ue, q.onwrite)
        : G._write(ue, ae, q.onwrite),
      (q.sync = !1);
  }
  function f(G, q, Z, te, ue) {
    --q.pendingcb,
      Z
        ? (Et.nextTick(ue, te),
          Et.nextTick(R, G, q),
          (G._writableState.errorEmitted = !0),
          O(G, te))
        : (ue(te), (G._writableState.errorEmitted = !0), O(G, te), R(G, q));
  }
  function u(G) {
    (G.writing = !1), (G.writecb = null), (G.length -= G.writelen), (G.writelen = 0);
  }
  function d(G, q) {
    var Z = G._writableState,
      te = Z.sync,
      ue = Z.writecb;
    if (typeof ue != "function") throw new A();
    if ((u(Z), q)) f(G, Z, te, q, ue);
    else {
      var ae = s(Z) || G.destroyed;
      !ae && !Z.corked && !Z.bufferProcessing && Z.bufferedRequest && h(G, Z),
        te ? Et.nextTick(y, G, Z, ae, ue) : y(G, Z, ae, ue);
    }
  }
  function y(G, q, Z, te) {
    Z || w(G, q), q.pendingcb--, te(), R(G, q);
  }
  function w(G, q) {
    q.length === 0 && q.needDrain && ((q.needDrain = !1), G.emit("drain"));
  }
  function h(G, q) {
    q.bufferProcessing = !0;
    var Z = q.bufferedRequest;
    if (G._writev && Z && Z.next) {
      var te = q.bufferedRequestCount,
        ue = new Array(te),
        ae = q.corkedRequestsFree;
      ae.entry = Z;
      for (var K = 0, ve = !0; Z; ) (ue[K] = Z), Z.isBuf || (ve = !1), (Z = Z.next), (K += 1);
      (ue.allBuffers = ve),
        o(G, q, !0, q.length, ue, "", ae.finish),
        q.pendingcb++,
        (q.lastBufferedRequest = null),
        ae.next
          ? ((q.corkedRequestsFree = ae.next), (ae.next = null))
          : (q.corkedRequestsFree = new t(q)),
        (q.bufferedRequestCount = 0);
    } else {
      for (; Z; ) {
        var Ye = Z.chunk,
          Ce = Z.encoding,
          Te = Z.callback,
          ut = q.objectMode ? 1 : Ye.length;
        if ((o(G, q, !1, ut, Ye, Ce, Te), (Z = Z.next), q.bufferedRequestCount--, q.writing)) break;
      }
      Z === null && (q.lastBufferedRequest = null);
    }
    (q.bufferedRequest = Z), (q.bufferProcessing = !1);
  }
  (de.prototype._write = function (G, q, Z) {
    Z(new S("_write()"));
  }),
    (de.prototype._writev = null),
    (de.prototype.end = function (G, q, Z) {
      var te = this._writableState;
      return (
        typeof G == "function"
          ? ((Z = G), (G = null), (q = null))
          : typeof q == "function" && ((Z = q), (q = null)),
        G != null && this.write(G, q),
        te.corked && ((te.corked = 1), this.uncork()),
        te.ending || z(this, te, Z),
        this
      );
    }),
    Object.defineProperty(de.prototype, "writableLength", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._writableState.length;
      },
    });
  function s(G) {
    return G.ending && G.length === 0 && G.bufferedRequest === null && !G.finished && !G.writing;
  }
  function m(G, q) {
    G._final(function (Z) {
      q.pendingcb--, Z && O(G, Z), (q.prefinished = !0), G.emit("prefinish"), R(G, q);
    });
  }
  function E(G, q) {
    !q.prefinished &&
      !q.finalCalled &&
      (typeof G._final == "function" && !q.destroyed
        ? (q.pendingcb++, (q.finalCalled = !0), Et.nextTick(m, G, q))
        : ((q.prefinished = !0), G.emit("prefinish")));
  }
  function R(G, q) {
    var Z = s(q);
    if (Z && (E(G, q), q.pendingcb === 0 && ((q.finished = !0), G.emit("finish"), q.autoDestroy))) {
      var te = G._readableState;
      (!te || (te.autoDestroy && te.endEmitted)) && G.destroy();
    }
    return Z;
  }
  function z(G, q, Z) {
    (q.ending = !0),
      R(G, q),
      Z && (q.finished ? Et.nextTick(Z) : G.once("finish", Z)),
      (q.ended = !0),
      (G.writable = !1);
  }
  function Q(G, q, Z) {
    var te = G.entry;
    for (G.entry = null; te; ) {
      var ue = te.callback;
      q.pendingcb--, ue(Z), (te = te.next);
    }
    q.corkedRequestsFree.next = G;
  }
  return (
    Object.defineProperty(de.prototype, "destroyed", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._writableState === void 0 ? !1 : this._writableState.destroyed;
      },
      set: function (q) {
        this._writableState && (this._writableState.destroyed = q);
      },
    }),
    (de.prototype.destroy = g.destroy),
    (de.prototype._undestroy = g.undestroy),
    (de.prototype._destroy = function (G, q) {
      q(G);
    }),
    xh
  );
}
var Mh, eg;
function Fs() {
  if (eg) return Mh;
  eg = 1;
  var t =
    Object.keys ||
    function (b) {
      var p = [];
      for (var _ in b) p.push(_);
      return p;
    };
  Mh = c;
  var e = sw(),
    n = aw();
  It()(c, e);
  for (var i = t(n.prototype), l = 0; l < i.length; l++) {
    var a = i[l];
    c.prototype[a] || (c.prototype[a] = n.prototype[a]);
  }
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    e.call(this, b),
      n.call(this, b),
      (this.allowHalfOpen = !0),
      b &&
        (b.readable === !1 && (this.readable = !1),
        b.writable === !1 && (this.writable = !1),
        b.allowHalfOpen === !1 && ((this.allowHalfOpen = !1), this.once("end", v)));
  }
  Object.defineProperty(c.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function () {
      return this._writableState.highWaterMark;
    },
  }),
    Object.defineProperty(c.prototype, "writableBuffer", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._writableState && this._writableState.getBuffer();
      },
    }),
    Object.defineProperty(c.prototype, "writableLength", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._writableState.length;
      },
    });
  function v() {
    this._writableState.ended || Et.nextTick(g, this);
  }
  function g(b) {
    b.end();
  }
  return (
    Object.defineProperty(c.prototype, "destroyed", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState === void 0 || this._writableState === void 0
          ? !1
          : this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function (p) {
        this._readableState === void 0 ||
          this._writableState === void 0 ||
          ((this._readableState.destroyed = p), (this._writableState.destroyed = p));
      },
    }),
    Mh
  );
}
var Sh = {},
  tg;
function pp() {
  if (tg) return Sh;
  tg = 1;
  var t = zt().Buffer,
    e =
      t.isEncoding ||
      function (B) {
        switch (((B = "" + B), B && B.toLowerCase())) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
  function n(B) {
    if (!B) return "utf8";
    for (var T; ; )
      switch (B) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return B;
        default:
          if (T) return;
          (B = ("" + B).toLowerCase()), (T = !0);
      }
  }
  function i(B) {
    var T = n(B);
    if (typeof T != "string" && (t.isEncoding === e || !e(B)))
      throw new Error("Unknown encoding: " + B);
    return T || B;
  }
  Sh.StringDecoder = l;
  function l(B) {
    this.encoding = i(B);
    var T;
    switch (this.encoding) {
      case "utf16le":
        (this.text = _), (this.end = M), (T = 4);
        break;
      case "utf8":
        (this.fillLast = g), (T = 4);
        break;
      case "base64":
        (this.text = S), (this.end = A), (T = 3);
        break;
      default:
        (this.write = k), (this.end = P);
        return;
    }
    (this.lastNeed = 0), (this.lastTotal = 0), (this.lastChar = t.allocUnsafe(T));
  }
  (l.prototype.write = function (B) {
    if (B.length === 0) return "";
    var T, F;
    if (this.lastNeed) {
      if (((T = this.fillLast(B)), T === void 0)) return "";
      (F = this.lastNeed), (this.lastNeed = 0);
    } else F = 0;
    return F < B.length ? (T ? T + this.text(B, F) : this.text(B, F)) : T || "";
  }),
    (l.prototype.end = p),
    (l.prototype.text = b),
    (l.prototype.fillLast = function (B) {
      if (this.lastNeed <= B.length)
        return (
          B.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed),
          this.lastChar.toString(this.encoding, 0, this.lastTotal)
        );
      B.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, B.length),
        (this.lastNeed -= B.length);
    });
  function a(B) {
    return B <= 127
      ? 0
      : B >> 5 === 6
      ? 2
      : B >> 4 === 14
      ? 3
      : B >> 3 === 30
      ? 4
      : B >> 6 === 2
      ? -1
      : -2;
  }
  function c(B, T, F) {
    var O = T.length - 1;
    if (O < F) return 0;
    var $ = a(T[O]);
    return $ >= 0
      ? ($ > 0 && (B.lastNeed = $ - 1), $)
      : --O < F || $ === -2
      ? 0
      : (($ = a(T[O])),
        $ >= 0
          ? ($ > 0 && (B.lastNeed = $ - 2), $)
          : --O < F || $ === -2
          ? 0
          : (($ = a(T[O])), $ >= 0 ? ($ > 0 && ($ === 2 ? ($ = 0) : (B.lastNeed = $ - 3)), $) : 0));
  }
  function v(B, T, F) {
    if ((T[0] & 192) !== 128) return (B.lastNeed = 0), "�";
    if (B.lastNeed > 1 && T.length > 1) {
      if ((T[1] & 192) !== 128) return (B.lastNeed = 1), "�";
      if (B.lastNeed > 2 && T.length > 2 && (T[2] & 192) !== 128) return (B.lastNeed = 2), "�";
    }
  }
  function g(B) {
    var T = this.lastTotal - this.lastNeed,
      F = v(this, B);
    if (F !== void 0) return F;
    if (this.lastNeed <= B.length)
      return (
        B.copy(this.lastChar, T, 0, this.lastNeed),
        this.lastChar.toString(this.encoding, 0, this.lastTotal)
      );
    B.copy(this.lastChar, T, 0, B.length), (this.lastNeed -= B.length);
  }
  function b(B, T) {
    var F = c(this, B, T);
    if (!this.lastNeed) return B.toString("utf8", T);
    this.lastTotal = F;
    var O = B.length - (F - this.lastNeed);
    return B.copy(this.lastChar, 0, O), B.toString("utf8", T, O);
  }
  function p(B) {
    var T = B && B.length ? this.write(B) : "";
    return this.lastNeed ? T + "�" : T;
  }
  function _(B, T) {
    if ((B.length - T) % 2 === 0) {
      var F = B.toString("utf16le", T);
      if (F) {
        var O = F.charCodeAt(F.length - 1);
        if (O >= 55296 && O <= 56319)
          return (
            (this.lastNeed = 2),
            (this.lastTotal = 4),
            (this.lastChar[0] = B[B.length - 2]),
            (this.lastChar[1] = B[B.length - 1]),
            F.slice(0, -1)
          );
      }
      return F;
    }
    return (
      (this.lastNeed = 1),
      (this.lastTotal = 2),
      (this.lastChar[0] = B[B.length - 1]),
      B.toString("utf16le", T, B.length - 1)
    );
  }
  function M(B) {
    var T = B && B.length ? this.write(B) : "";
    if (this.lastNeed) {
      var F = this.lastTotal - this.lastNeed;
      return T + this.lastChar.toString("utf16le", 0, F);
    }
    return T;
  }
  function S(B, T) {
    var F = (B.length - T) % 3;
    return F === 0
      ? B.toString("base64", T)
      : ((this.lastNeed = 3 - F),
        (this.lastTotal = 3),
        F === 1
          ? (this.lastChar[0] = B[B.length - 1])
          : ((this.lastChar[0] = B[B.length - 2]), (this.lastChar[1] = B[B.length - 1])),
        B.toString("base64", T, B.length - F));
  }
  function A(B) {
    var T = B && B.length ? this.write(B) : "";
    return this.lastNeed ? T + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : T;
  }
  function k(B) {
    return B.toString(this.encoding);
  }
  function P(B) {
    return B && B.length ? this.write(B) : "";
  }
  return Sh;
}
var Eh, rg;
function _1() {
  if (rg) return Eh;
  rg = 1;
  var t = oo().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(a) {
    var c = !1;
    return function () {
      if (!c) {
        c = !0;
        for (var v = arguments.length, g = new Array(v), b = 0; b < v; b++) g[b] = arguments[b];
        a.apply(this, g);
      }
    };
  }
  function n() {}
  function i(a) {
    return a.setHeader && typeof a.abort == "function";
  }
  function l(a, c, v) {
    if (typeof c == "function") return l(a, null, c);
    c || (c = {}), (v = e(v || n));
    var g = c.readable || (c.readable !== !1 && a.readable),
      b = c.writable || (c.writable !== !1 && a.writable),
      p = function () {
        a.writable || M();
      },
      _ = a._writableState && a._writableState.finished,
      M = function () {
        (b = !1), (_ = !0), g || v.call(a);
      },
      S = a._readableState && a._readableState.endEmitted,
      A = function () {
        (g = !1), (S = !0), b || v.call(a);
      },
      k = function (F) {
        v.call(a, F);
      },
      P = function () {
        var F;
        if (g && !S)
          return (!a._readableState || !a._readableState.ended) && (F = new t()), v.call(a, F);
        if (b && !_)
          return (!a._writableState || !a._writableState.ended) && (F = new t()), v.call(a, F);
      },
      B = function () {
        a.req.on("finish", M);
      };
    return (
      i(a)
        ? (a.on("complete", M), a.on("abort", P), a.req ? B() : a.on("request", B))
        : b && !a._writableState && (a.on("end", p), a.on("close", p)),
      a.on("end", A),
      a.on("finish", M),
      c.error !== !1 && a.on("error", k),
      a.on("close", P),
      function () {
        a.removeListener("complete", M),
          a.removeListener("abort", P),
          a.removeListener("request", B),
          a.req && a.req.removeListener("finish", M),
          a.removeListener("end", p),
          a.removeListener("close", p),
          a.removeListener("finish", M),
          a.removeListener("end", A),
          a.removeListener("error", k),
          a.removeListener("close", P);
      }
    );
  }
  return (Eh = l), Eh;
}
var Ah, ng;
function jM() {
  if (ng) return Ah;
  ng = 1;
  var t;
  function e(F, O, $) {
    return (
      (O = n(O)),
      O in F
        ? Object.defineProperty(F, O, { value: $, enumerable: !0, configurable: !0, writable: !0 })
        : (F[O] = $),
      F
    );
  }
  function n(F) {
    var O = i(F, "string");
    return typeof O == "symbol" ? O : String(O);
  }
  function i(F, O) {
    if (typeof F != "object" || F === null) return F;
    var $ = F[Symbol.toPrimitive];
    if ($ !== void 0) {
      var J = $.call(F, O || "default");
      if (typeof J != "object") return J;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (O === "string" ? String : Number)(F);
  }
  var l = _1(),
    a = Symbol("lastResolve"),
    c = Symbol("lastReject"),
    v = Symbol("error"),
    g = Symbol("ended"),
    b = Symbol("lastPromise"),
    p = Symbol("handlePromise"),
    _ = Symbol("stream");
  function M(F, O) {
    return {
      value: F,
      done: O,
    };
  }
  function S(F) {
    var O = F[a];
    if (O !== null) {
      var $ = F[_].read();
      $ !== null && ((F[b] = null), (F[a] = null), (F[c] = null), O(M($, !1)));
    }
  }
  function A(F) {
    Et.nextTick(S, F);
  }
  function k(F, O) {
    return function ($, J) {
      F.then(function () {
        if (O[g]) {
          $(M(void 0, !0));
          return;
        }
        O[p]($, J);
      }, J);
    };
  }
  var P = Object.getPrototypeOf(function () {}),
    B = Object.setPrototypeOf(
      ((t = {
        get stream() {
          return this[_];
        },
        next: function () {
          var O = this,
            $ = this[v];
          if ($ !== null) return Promise.reject($);
          if (this[g]) return Promise.resolve(M(void 0, !0));
          if (this[_].destroyed)
            return new Promise(function (ne, Ae) {
              Et.nextTick(function () {
                O[v] ? Ae(O[v]) : ne(M(void 0, !0));
              });
            });
          var J = this[b],
            he;
          if (J) he = new Promise(k(J, this));
          else {
            var de = this[_].read();
            if (de !== null) return Promise.resolve(M(de, !1));
            he = new Promise(this[p]);
          }
          return (this[b] = he), he;
        },
      }),
      e(t, Symbol.asyncIterator, function () {
        return this;
      }),
      e(t, "return", function () {
        var O = this;
        return new Promise(function ($, J) {
          O[_].destroy(null, function (he) {
            if (he) {
              J(he);
              return;
            }
            $(M(void 0, !0));
          });
        });
      }),
      t),
      P
    ),
    T = function (O) {
      var $,
        J = Object.create(
          B,
          (($ = {}),
          e($, _, {
            value: O,
            writable: !0,
          }),
          e($, a, {
            value: null,
            writable: !0,
          }),
          e($, c, {
            value: null,
            writable: !0,
          }),
          e($, v, {
            value: null,
            writable: !0,
          }),
          e($, g, {
            value: O._readableState.endEmitted,
            writable: !0,
          }),
          e($, p, {
            value: function (de, ne) {
              var Ae = J[_].read();
              Ae
                ? ((J[b] = null), (J[a] = null), (J[c] = null), de(M(Ae, !1)))
                : ((J[a] = de), (J[c] = ne));
            },
            writable: !0,
          }),
          $)
        );
      return (
        (J[b] = null),
        l(O, function (he) {
          if (he && he.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var de = J[c];
            de !== null && ((J[b] = null), (J[a] = null), (J[c] = null), de(he)), (J[v] = he);
            return;
          }
          var ne = J[a];
          ne !== null && ((J[b] = null), (J[a] = null), (J[c] = null), ne(M(void 0, !0))),
            (J[g] = !0);
        }),
        O.on("readable", A.bind(null, J)),
        J
      );
    };
  return (Ah = T), Ah;
}
var kh, ig;
function $M() {
  return (
    ig ||
      ((ig = 1),
      (kh = function () {
        throw new Error("Readable.from is not available in the browser");
      })),
    kh
  );
}
var Bh, ag;
function sw() {
  if (ag) return Bh;
  (ag = 1), (Bh = ne);
  var t;
  (ne.ReadableState = de), Sf().EventEmitter;
  var e = function (K, ve) {
      return K.listeners(ve).length;
    },
    n = Y6(),
    i = Mr.Buffer,
    l =
      (typeof mt < "u" ? mt : typeof window < "u" ? window : typeof self < "u" ? self : {})
        .Uint8Array || function () {};
  function a(ae) {
    return i.from(ae);
  }
  function c(ae) {
    return i.isBuffer(ae) || ae instanceof l;
  }
  var v = Ru(),
    g;
  v && v.debuglog ? (g = v.debuglog("stream")) : (g = function () {});
  var b = zM(),
    p = rw(),
    _ = nw(),
    M = _.getHighWaterMark,
    S = oo().codes,
    A = S.ERR_INVALID_ARG_TYPE,
    k = S.ERR_STREAM_PUSH_AFTER_EOF,
    P = S.ERR_METHOD_NOT_IMPLEMENTED,
    B = S.ERR_STREAM_UNSHIFT_AFTER_END_EVENT,
    T,
    F,
    O;
  It()(ne, n);
  var $ = p.errorOrDestroy,
    J = ["error", "close", "destroy", "pause", "resume"];
  function he(ae, K, ve) {
    if (typeof ae.prependListener == "function") return ae.prependListener(K, ve);
    !ae._events || !ae._events[K]
      ? ae.on(K, ve)
      : Array.isArray(ae._events[K])
      ? ae._events[K].unshift(ve)
      : (ae._events[K] = [ve, ae._events[K]]);
  }
  function de(ae, K, ve) {
    (t = t || Fs()),
      (ae = ae || {}),
      typeof ve != "boolean" && (ve = K instanceof t),
      (this.objectMode = !!ae.objectMode),
      ve && (this.objectMode = this.objectMode || !!ae.readableObjectMode),
      (this.highWaterMark = M(this, ae, "readableHighWaterMark", ve)),
      (this.buffer = new b()),
      (this.length = 0),
      (this.pipes = null),
      (this.pipesCount = 0),
      (this.flowing = null),
      (this.ended = !1),
      (this.endEmitted = !1),
      (this.reading = !1),
      (this.sync = !0),
      (this.needReadable = !1),
      (this.emittedReadable = !1),
      (this.readableListening = !1),
      (this.resumeScheduled = !1),
      (this.paused = !0),
      (this.emitClose = ae.emitClose !== !1),
      (this.autoDestroy = !!ae.autoDestroy),
      (this.destroyed = !1),
      (this.defaultEncoding = ae.defaultEncoding || "utf8"),
      (this.awaitDrain = 0),
      (this.readingMore = !1),
      (this.decoder = null),
      (this.encoding = null),
      ae.encoding &&
        (T || (T = pp().StringDecoder),
        (this.decoder = new T(ae.encoding)),
        (this.encoding = ae.encoding));
  }
  function ne(ae) {
    if (((t = t || Fs()), !(this instanceof ne))) return new ne(ae);
    var K = this instanceof t;
    (this._readableState = new de(ae, this, K)),
      (this.readable = !0),
      ae &&
        (typeof ae.read == "function" && (this._read = ae.read),
        typeof ae.destroy == "function" && (this._destroy = ae.destroy)),
      n.call(this);
  }
  Object.defineProperty(ne.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function () {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function (K) {
      this._readableState && (this._readableState.destroyed = K);
    },
  }),
    (ne.prototype.destroy = p.destroy),
    (ne.prototype._undestroy = p.undestroy),
    (ne.prototype._destroy = function (ae, K) {
      K(ae);
    }),
    (ne.prototype.push = function (ae, K) {
      var ve = this._readableState,
        Ye;
      return (
        ve.objectMode
          ? (Ye = !0)
          : typeof ae == "string" &&
            ((K = K || ve.defaultEncoding),
            K !== ve.encoding && ((ae = i.from(ae, K)), (K = "")),
            (Ye = !0)),
        Ae(this, ae, K, !1, Ye)
      );
    }),
    (ne.prototype.unshift = function (ae) {
      return Ae(this, ae, null, !0, !1);
    });
  function Ae(ae, K, ve, Ye, Ce) {
    g("readableAddChunk", K);
    var Te = ae._readableState;
    if (K === null) (Te.reading = !1), d(ae, Te);
    else {
      var ut;
      if ((Ce || (ut = r(Te, K)), ut)) $(ae, ut);
      else if (Te.objectMode || (K && K.length > 0))
        if (
          (typeof K != "string" &&
            !Te.objectMode &&
            Object.getPrototypeOf(K) !== i.prototype &&
            (K = a(K)),
          Ye)
        )
          Te.endEmitted ? $(ae, new B()) : x(ae, Te, K, !0);
        else if (Te.ended) $(ae, new k());
        else {
          if (Te.destroyed) return !1;
          (Te.reading = !1),
            Te.decoder && !ve
              ? ((K = Te.decoder.write(K)),
                Te.objectMode || K.length !== 0 ? x(ae, Te, K, !1) : h(ae, Te))
              : x(ae, Te, K, !1);
        }
      else Ye || ((Te.reading = !1), h(ae, Te));
    }
    return !Te.ended && (Te.length < Te.highWaterMark || Te.length === 0);
  }
  function x(ae, K, ve, Ye) {
    K.flowing && K.length === 0 && !K.sync
      ? ((K.awaitDrain = 0), ae.emit("data", ve))
      : ((K.length += K.objectMode ? 1 : ve.length),
        Ye ? K.buffer.unshift(ve) : K.buffer.push(ve),
        K.needReadable && y(ae)),
      h(ae, K);
  }
  function r(ae, K) {
    var ve;
    return (
      !c(K) &&
        typeof K != "string" &&
        K !== void 0 &&
        !ae.objectMode &&
        (ve = new A("chunk", ["string", "Buffer", "Uint8Array"], K)),
      ve
    );
  }
  (ne.prototype.isPaused = function () {
    return this._readableState.flowing === !1;
  }),
    (ne.prototype.setEncoding = function (ae) {
      T || (T = pp().StringDecoder);
      var K = new T(ae);
      (this._readableState.decoder = K),
        (this._readableState.encoding = this._readableState.decoder.encoding);
      for (var ve = this._readableState.buffer.head, Ye = ""; ve !== null; )
        (Ye += K.write(ve.data)), (ve = ve.next);
      return (
        this._readableState.buffer.clear(),
        Ye !== "" && this._readableState.buffer.push(Ye),
        (this._readableState.length = Ye.length),
        this
      );
    });
  var o = 1073741824;
  function f(ae) {
    return (
      ae >= o
        ? (ae = o)
        : (ae--,
          (ae |= ae >>> 1),
          (ae |= ae >>> 2),
          (ae |= ae >>> 4),
          (ae |= ae >>> 8),
          (ae |= ae >>> 16),
          ae++),
      ae
    );
  }
  function u(ae, K) {
    return ae <= 0 || (K.length === 0 && K.ended)
      ? 0
      : K.objectMode
      ? 1
      : ae !== ae
      ? K.flowing && K.length
        ? K.buffer.head.data.length
        : K.length
      : (ae > K.highWaterMark && (K.highWaterMark = f(ae)),
        ae <= K.length ? ae : K.ended ? K.length : ((K.needReadable = !0), 0));
  }
  ne.prototype.read = function (ae) {
    g("read", ae), (ae = parseInt(ae, 10));
    var K = this._readableState,
      ve = ae;
    if (
      (ae !== 0 && (K.emittedReadable = !1),
      ae === 0 &&
        K.needReadable &&
        ((K.highWaterMark !== 0 ? K.length >= K.highWaterMark : K.length > 0) || K.ended))
    )
      return (
        g("read: emitReadable", K.length, K.ended),
        K.length === 0 && K.ended ? Z(this) : y(this),
        null
      );
    if (((ae = u(ae, K)), ae === 0 && K.ended)) return K.length === 0 && Z(this), null;
    var Ye = K.needReadable;
    g("need readable", Ye),
      (K.length === 0 || K.length - ae < K.highWaterMark) &&
        ((Ye = !0), g("length less than watermark", Ye)),
      K.ended || K.reading
        ? ((Ye = !1), g("reading or ended", Ye))
        : Ye &&
          (g("do read"),
          (K.reading = !0),
          (K.sync = !0),
          K.length === 0 && (K.needReadable = !0),
          this._read(K.highWaterMark),
          (K.sync = !1),
          K.reading || (ae = u(ve, K)));
    var Ce;
    return (
      ae > 0 ? (Ce = q(ae, K)) : (Ce = null),
      Ce === null
        ? ((K.needReadable = K.length <= K.highWaterMark), (ae = 0))
        : ((K.length -= ae), (K.awaitDrain = 0)),
      K.length === 0 && (K.ended || (K.needReadable = !0), ve !== ae && K.ended && Z(this)),
      Ce !== null && this.emit("data", Ce),
      Ce
    );
  };
  function d(ae, K) {
    if ((g("onEofChunk"), !K.ended)) {
      if (K.decoder) {
        var ve = K.decoder.end();
        ve && ve.length && (K.buffer.push(ve), (K.length += K.objectMode ? 1 : ve.length));
      }
      (K.ended = !0),
        K.sync
          ? y(ae)
          : ((K.needReadable = !1), K.emittedReadable || ((K.emittedReadable = !0), w(ae)));
    }
  }
  function y(ae) {
    var K = ae._readableState;
    g("emitReadable", K.needReadable, K.emittedReadable),
      (K.needReadable = !1),
      K.emittedReadable ||
        (g("emitReadable", K.flowing), (K.emittedReadable = !0), Et.nextTick(w, ae));
  }
  function w(ae) {
    var K = ae._readableState;
    g("emitReadable_", K.destroyed, K.length, K.ended),
      !K.destroyed && (K.length || K.ended) && (ae.emit("readable"), (K.emittedReadable = !1)),
      (K.needReadable = !K.flowing && !K.ended && K.length <= K.highWaterMark),
      G(ae);
  }
  function h(ae, K) {
    K.readingMore || ((K.readingMore = !0), Et.nextTick(s, ae, K));
  }
  function s(ae, K) {
    for (
      ;
      !K.reading && !K.ended && (K.length < K.highWaterMark || (K.flowing && K.length === 0));

    ) {
      var ve = K.length;
      if ((g("maybeReadMore read 0"), ae.read(0), ve === K.length)) break;
    }
    K.readingMore = !1;
  }
  (ne.prototype._read = function (ae) {
    $(this, new P("_read()"));
  }),
    (ne.prototype.pipe = function (ae, K) {
      var ve = this,
        Ye = this._readableState;
      switch (Ye.pipesCount) {
        case 0:
          Ye.pipes = ae;
          break;
        case 1:
          Ye.pipes = [Ye.pipes, ae];
          break;
        default:
          Ye.pipes.push(ae);
          break;
      }
      (Ye.pipesCount += 1), g("pipe count=%d opts=%j", Ye.pipesCount, K);
      var Ce = (!K || K.end !== !1) && ae !== Et.stdout && ae !== Et.stderr,
        Te = Ce ? Ie : oe;
      Ye.endEmitted ? Et.nextTick(Te) : ve.once("end", Te), ae.on("unpipe", ut);
      function ut(X, le) {
        g("onunpipe"), X === ve && le && le.hasUnpiped === !1 && ((le.hasUnpiped = !0), Oe());
      }
      function Ie() {
        g("onend"), ae.end();
      }
      var be = m(ve);
      ae.on("drain", be);
      var wt = !1;
      function Oe() {
        g("cleanup"),
          ae.removeListener("close", Ue),
          ae.removeListener("finish", se),
          ae.removeListener("drain", be),
          ae.removeListener("error", xt),
          ae.removeListener("unpipe", ut),
          ve.removeListener("end", Ie),
          ve.removeListener("end", oe),
          ve.removeListener("data", je),
          (wt = !0),
          Ye.awaitDrain && (!ae._writableState || ae._writableState.needDrain) && be();
      }
      ve.on("data", je);
      function je(X) {
        g("ondata");
        var le = ae.write(X);
        g("dest.write", le),
          le === !1 &&
            (((Ye.pipesCount === 1 && Ye.pipes === ae) ||
              (Ye.pipesCount > 1 && ue(Ye.pipes, ae) !== -1)) &&
              !wt &&
              (g("false write response, pause", Ye.awaitDrain), Ye.awaitDrain++),
            ve.pause());
      }
      function xt(X) {
        g("onerror", X), oe(), ae.removeListener("error", xt), e(ae, "error") === 0 && $(ae, X);
      }
      he(ae, "error", xt);
      function Ue() {
        ae.removeListener("finish", se), oe();
      }
      ae.once("close", Ue);
      function se() {
        g("onfinish"), ae.removeListener("close", Ue), oe();
      }
      ae.once("finish", se);
      function oe() {
        g("unpipe"), ve.unpipe(ae);
      }
      return ae.emit("pipe", ve), Ye.flowing || (g("pipe resume"), ve.resume()), ae;
    });
  function m(ae) {
    return function () {
      var ve = ae._readableState;
      g("pipeOnDrain", ve.awaitDrain),
        ve.awaitDrain && ve.awaitDrain--,
        ve.awaitDrain === 0 && e(ae, "data") && ((ve.flowing = !0), G(ae));
    };
  }
  (ne.prototype.unpipe = function (ae) {
    var K = this._readableState,
      ve = {
        hasUnpiped: !1,
      };
    if (K.pipesCount === 0) return this;
    if (K.pipesCount === 1)
      return ae && ae !== K.pipes
        ? this
        : (ae || (ae = K.pipes),
          (K.pipes = null),
          (K.pipesCount = 0),
          (K.flowing = !1),
          ae && ae.emit("unpipe", this, ve),
          this);
    if (!ae) {
      var Ye = K.pipes,
        Ce = K.pipesCount;
      (K.pipes = null), (K.pipesCount = 0), (K.flowing = !1);
      for (var Te = 0; Te < Ce; Te++)
        Ye[Te].emit("unpipe", this, {
          hasUnpiped: !1,
        });
      return this;
    }
    var ut = ue(K.pipes, ae);
    return ut === -1
      ? this
      : (K.pipes.splice(ut, 1),
        (K.pipesCount -= 1),
        K.pipesCount === 1 && (K.pipes = K.pipes[0]),
        ae.emit("unpipe", this, ve),
        this);
  }),
    (ne.prototype.on = function (ae, K) {
      var ve = n.prototype.on.call(this, ae, K),
        Ye = this._readableState;
      return (
        ae === "data"
          ? ((Ye.readableListening = this.listenerCount("readable") > 0),
            Ye.flowing !== !1 && this.resume())
          : ae === "readable" &&
            !Ye.endEmitted &&
            !Ye.readableListening &&
            ((Ye.readableListening = Ye.needReadable = !0),
            (Ye.flowing = !1),
            (Ye.emittedReadable = !1),
            g("on readable", Ye.length, Ye.reading),
            Ye.length ? y(this) : Ye.reading || Et.nextTick(R, this)),
        ve
      );
    }),
    (ne.prototype.addListener = ne.prototype.on),
    (ne.prototype.removeListener = function (ae, K) {
      var ve = n.prototype.removeListener.call(this, ae, K);
      return ae === "readable" && Et.nextTick(E, this), ve;
    }),
    (ne.prototype.removeAllListeners = function (ae) {
      var K = n.prototype.removeAllListeners.apply(this, arguments);
      return (ae === "readable" || ae === void 0) && Et.nextTick(E, this), K;
    });
  function E(ae) {
    var K = ae._readableState;
    (K.readableListening = ae.listenerCount("readable") > 0),
      K.resumeScheduled && !K.paused
        ? (K.flowing = !0)
        : ae.listenerCount("data") > 0 && ae.resume();
  }
  function R(ae) {
    g("readable nexttick read 0"), ae.read(0);
  }
  ne.prototype.resume = function () {
    var ae = this._readableState;
    return (
      ae.flowing || (g("resume"), (ae.flowing = !ae.readableListening), z(this, ae)),
      (ae.paused = !1),
      this
    );
  };
  function z(ae, K) {
    K.resumeScheduled || ((K.resumeScheduled = !0), Et.nextTick(Q, ae, K));
  }
  function Q(ae, K) {
    g("resume", K.reading),
      K.reading || ae.read(0),
      (K.resumeScheduled = !1),
      ae.emit("resume"),
      G(ae),
      K.flowing && !K.reading && ae.read(0);
  }
  ne.prototype.pause = function () {
    return (
      g("call pause flowing=%j", this._readableState.flowing),
      this._readableState.flowing !== !1 &&
        (g("pause"), (this._readableState.flowing = !1), this.emit("pause")),
      (this._readableState.paused = !0),
      this
    );
  };
  function G(ae) {
    var K = ae._readableState;
    for (g("flow", K.flowing); K.flowing && ae.read() !== null; );
  }
  (ne.prototype.wrap = function (ae) {
    var K = this,
      ve = this._readableState,
      Ye = !1;
    ae.on("end", function () {
      if ((g("wrapped end"), ve.decoder && !ve.ended)) {
        var ut = ve.decoder.end();
        ut && ut.length && K.push(ut);
      }
      K.push(null);
    }),
      ae.on("data", function (ut) {
        if (
          (g("wrapped data"),
          ve.decoder && (ut = ve.decoder.write(ut)),
          !(ve.objectMode && ut == null) && !(!ve.objectMode && (!ut || !ut.length)))
        ) {
          var Ie = K.push(ut);
          Ie || ((Ye = !0), ae.pause());
        }
      });
    for (var Ce in ae)
      this[Ce] === void 0 &&
        typeof ae[Ce] == "function" &&
        (this[Ce] = /* @__PURE__ */ (function (Ie) {
          return function () {
            return ae[Ie].apply(ae, arguments);
          };
        })(Ce));
    for (var Te = 0; Te < J.length; Te++) ae.on(J[Te], this.emit.bind(this, J[Te]));
    return (
      (this._read = function (ut) {
        g("wrapped _read", ut), Ye && ((Ye = !1), ae.resume());
      }),
      this
    );
  }),
    typeof Symbol == "function" &&
      (ne.prototype[Symbol.asyncIterator] = function () {
        return F === void 0 && (F = jM()), F(this);
      }),
    Object.defineProperty(ne.prototype, "readableHighWaterMark", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState.highWaterMark;
      },
    }),
    Object.defineProperty(ne.prototype, "readableBuffer", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState && this._readableState.buffer;
      },
    }),
    Object.defineProperty(ne.prototype, "readableFlowing", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState.flowing;
      },
      set: function (K) {
        this._readableState && (this._readableState.flowing = K);
      },
    }),
    (ne._fromList = q),
    Object.defineProperty(ne.prototype, "readableLength", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState.length;
      },
    });
  function q(ae, K) {
    if (K.length === 0) return null;
    var ve;
    return (
      K.objectMode
        ? (ve = K.buffer.shift())
        : !ae || ae >= K.length
        ? (K.decoder
            ? (ve = K.buffer.join(""))
            : K.buffer.length === 1
            ? (ve = K.buffer.first())
            : (ve = K.buffer.concat(K.length)),
          K.buffer.clear())
        : (ve = K.buffer.consume(ae, K.decoder)),
      ve
    );
  }
  function Z(ae) {
    var K = ae._readableState;
    g("endReadable", K.endEmitted), K.endEmitted || ((K.ended = !0), Et.nextTick(te, K, ae));
  }
  function te(ae, K) {
    if (
      (g("endReadableNT", ae.endEmitted, ae.length),
      !ae.endEmitted &&
        ae.length === 0 &&
        ((ae.endEmitted = !0), (K.readable = !1), K.emit("end"), ae.autoDestroy))
    ) {
      var ve = K._writableState;
      (!ve || (ve.autoDestroy && ve.finished)) && K.destroy();
    }
  }
  typeof Symbol == "function" &&
    (ne.from = function (ae, K) {
      return O === void 0 && (O = $M()), O(ne, ae, K);
    });
  function ue(ae, K) {
    for (var ve = 0, Ye = ae.length; ve < Ye; ve++) if (ae[ve] === K) return ve;
    return -1;
  }
  return Bh;
}
var Ch, sg;
function ow() {
  if (sg) return Ch;
  (sg = 1), (Ch = v);
  var t = oo().codes,
    e = t.ERR_METHOD_NOT_IMPLEMENTED,
    n = t.ERR_MULTIPLE_CALLBACK,
    i = t.ERR_TRANSFORM_ALREADY_TRANSFORMING,
    l = t.ERR_TRANSFORM_WITH_LENGTH_0,
    a = Fs();
  It()(v, a);
  function c(p, _) {
    var M = this._transformState;
    M.transforming = !1;
    var S = M.writecb;
    if (S === null) return this.emit("error", new n());
    (M.writechunk = null), (M.writecb = null), _ != null && this.push(_), S(p);
    var A = this._readableState;
    (A.reading = !1), (A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
  }
  function v(p) {
    if (!(this instanceof v)) return new v(p);
    a.call(this, p),
      (this._transformState = {
        afterTransform: c.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null,
      }),
      (this._readableState.needReadable = !0),
      (this._readableState.sync = !1),
      p &&
        (typeof p.transform == "function" && (this._transform = p.transform),
        typeof p.flush == "function" && (this._flush = p.flush)),
      this.on("prefinish", g);
  }
  function g() {
    var p = this;
    typeof this._flush == "function" && !this._readableState.destroyed
      ? this._flush(function (_, M) {
          b(p, _, M);
        })
      : b(this, null, null);
  }
  (v.prototype.push = function (p, _) {
    return (this._transformState.needTransform = !1), a.prototype.push.call(this, p, _);
  }),
    (v.prototype._transform = function (p, _, M) {
      M(new e("_transform()"));
    }),
    (v.prototype._write = function (p, _, M) {
      var S = this._transformState;
      if (((S.writecb = M), (S.writechunk = p), (S.writeencoding = _), !S.transforming)) {
        var A = this._readableState;
        (S.needTransform || A.needReadable || A.length < A.highWaterMark) &&
          this._read(A.highWaterMark);
      }
    }),
    (v.prototype._read = function (p) {
      var _ = this._transformState;
      _.writechunk !== null && !_.transforming
        ? ((_.transforming = !0), this._transform(_.writechunk, _.writeencoding, _.afterTransform))
        : (_.needTransform = !0);
    }),
    (v.prototype._destroy = function (p, _) {
      a.prototype._destroy.call(this, p, function (M) {
        _(M);
      });
    });
  function b(p, _, M) {
    if (_) return p.emit("error", _);
    if ((M != null && p.push(M), p._writableState.length)) throw new l();
    if (p._transformState.transforming) throw new i();
    return p.push(null);
  }
  return Ch;
}
var Th, og;
function HM() {
  if (og) return Th;
  (og = 1), (Th = e);
  var t = ow();
  It()(e, t);
  function e(n) {
    if (!(this instanceof e)) return new e(n);
    t.call(this, n);
  }
  return (
    (e.prototype._transform = function (n, i, l) {
      l(null, n);
    }),
    Th
  );
}
var Ph, fg;
function VM() {
  if (fg) return Ph;
  fg = 1;
  var t;
  function e(M) {
    var S = !1;
    return function () {
      S || ((S = !0), M.apply(void 0, arguments));
    };
  }
  var n = oo().codes,
    i = n.ERR_MISSING_ARGS,
    l = n.ERR_STREAM_DESTROYED;
  function a(M) {
    if (M) throw M;
  }
  function c(M) {
    return M.setHeader && typeof M.abort == "function";
  }
  function v(M, S, A, k) {
    k = e(k);
    var P = !1;
    M.on("close", function () {
      P = !0;
    }),
      t === void 0 && (t = _1()),
      t(
        M,
        {
          readable: S,
          writable: A,
        },
        function (T) {
          if (T) return k(T);
          (P = !0), k();
        }
      );
    var B = !1;
    return function (T) {
      if (!P && !B) {
        if (((B = !0), c(M))) return M.abort();
        if (typeof M.destroy == "function") return M.destroy();
        k(T || new l("pipe"));
      }
    };
  }
  function g(M) {
    M();
  }
  function b(M, S) {
    return M.pipe(S);
  }
  function p(M) {
    return !M.length || typeof M[M.length - 1] != "function" ? a : M.pop();
  }
  function _() {
    for (var M = arguments.length, S = new Array(M), A = 0; A < M; A++) S[A] = arguments[A];
    var k = p(S);
    if ((Array.isArray(S[0]) && (S = S[0]), S.length < 2)) throw new i("streams");
    var P,
      B = S.map(function (T, F) {
        var O = F < S.length - 1,
          $ = F > 0;
        return v(T, O, $, function (J) {
          P || (P = J), J && B.forEach(g), !O && (B.forEach(g), k(P));
        });
      });
    return S.reduce(b);
  }
  return (Ph = _), Ph;
}
var Rh, lg;
function fw() {
  if (lg) return Rh;
  (lg = 1), (Rh = n);
  var t = Sf().EventEmitter,
    e = It();
  e(n, t),
    (n.Readable = sw()),
    (n.Writable = aw()),
    (n.Duplex = Fs()),
    (n.Transform = ow()),
    (n.PassThrough = HM()),
    (n.finished = _1()),
    (n.pipeline = VM()),
    (n.Stream = n);
  function n() {
    t.call(this);
  }
  return (
    (n.prototype.pipe = function (i, l) {
      var a = this;
      function c(S) {
        i.writable && i.write(S) === !1 && a.pause && a.pause();
      }
      a.on("data", c);
      function v() {
        a.readable && a.resume && a.resume();
      }
      i.on("drain", v), !i._isStdio && (!l || l.end !== !1) && (a.on("end", b), a.on("close", p));
      var g = !1;
      function b() {
        g || ((g = !0), i.end());
      }
      function p() {
        g || ((g = !0), typeof i.destroy == "function" && i.destroy());
      }
      function _(S) {
        if ((M(), t.listenerCount(this, "error") === 0)) throw S;
      }
      a.on("error", _), i.on("error", _);
      function M() {
        a.removeListener("data", c),
          i.removeListener("drain", v),
          a.removeListener("end", b),
          a.removeListener("close", p),
          a.removeListener("error", _),
          i.removeListener("error", _),
          a.removeListener("end", M),
          a.removeListener("close", M),
          i.removeListener("close", M);
      }
      return a.on("end", M), a.on("close", M), i.on("close", M), i.emit("pipe", a), i;
    }),
    Rh
  );
}
var Ih, ug;
function lw() {
  if (ug) return Ih;
  ug = 1;
  var t = zt().Buffer,
    e = fw().Transform,
    n = It();
  function i(a, c) {
    if (!t.isBuffer(a) && typeof a != "string")
      throw new TypeError(c + " must be a string or a buffer");
  }
  function l(a) {
    e.call(this),
      (this._block = t.allocUnsafe(a)),
      (this._blockSize = a),
      (this._blockOffset = 0),
      (this._length = [0, 0, 0, 0]),
      (this._finalized = !1);
  }
  return (
    n(l, e),
    (l.prototype._transform = function (a, c, v) {
      var g = null;
      try {
        this.update(a, c);
      } catch (b) {
        g = b;
      }
      v(g);
    }),
    (l.prototype._flush = function (a) {
      var c = null;
      try {
        this.push(this.digest());
      } catch (v) {
        c = v;
      }
      a(c);
    }),
    (l.prototype.update = function (a, c) {
      if ((i(a, "Data"), this._finalized)) throw new Error("Digest already called");
      t.isBuffer(a) || (a = t.from(a, c));
      for (var v = this._block, g = 0; this._blockOffset + a.length - g >= this._blockSize; ) {
        for (var b = this._blockOffset; b < this._blockSize; ) v[b++] = a[g++];
        this._update(), (this._blockOffset = 0);
      }
      for (; g < a.length; ) v[this._blockOffset++] = a[g++];
      for (var p = 0, _ = a.length * 8; _ > 0; ++p)
        (this._length[p] += _),
          (_ = (this._length[p] / 4294967296) | 0),
          _ > 0 && (this._length[p] -= 4294967296 * _);
      return this;
    }),
    (l.prototype._update = function () {
      throw new Error("_update is not implemented");
    }),
    (l.prototype.digest = function (a) {
      if (this._finalized) throw new Error("Digest already called");
      this._finalized = !0;
      var c = this._digest();
      a !== void 0 && (c = c.toString(a)), this._block.fill(0), (this._blockOffset = 0);
      for (var v = 0; v < 4; ++v) this._length[v] = 0;
      return c;
    }),
    (l.prototype._digest = function () {
      throw new Error("_digest is not implemented");
    }),
    (Ih = l),
    Ih
  );
}
var Oh, cg;
function x1() {
  if (cg) return Oh;
  cg = 1;
  var t = It(),
    e = lw(),
    n = zt().Buffer,
    i = new Array(16);
  function l() {
    e.call(this, 64),
      (this._a = 1732584193),
      (this._b = 4023233417),
      (this._c = 2562383102),
      (this._d = 271733878);
  }
  t(l, e),
    (l.prototype._update = function () {
      for (var p = i, _ = 0; _ < 16; ++_) p[_] = this._block.readInt32LE(_ * 4);
      var M = this._a,
        S = this._b,
        A = this._c,
        k = this._d;
      (M = c(M, S, A, k, p[0], 3614090360, 7)),
        (k = c(k, M, S, A, p[1], 3905402710, 12)),
        (A = c(A, k, M, S, p[2], 606105819, 17)),
        (S = c(S, A, k, M, p[3], 3250441966, 22)),
        (M = c(M, S, A, k, p[4], 4118548399, 7)),
        (k = c(k, M, S, A, p[5], 1200080426, 12)),
        (A = c(A, k, M, S, p[6], 2821735955, 17)),
        (S = c(S, A, k, M, p[7], 4249261313, 22)),
        (M = c(M, S, A, k, p[8], 1770035416, 7)),
        (k = c(k, M, S, A, p[9], 2336552879, 12)),
        (A = c(A, k, M, S, p[10], 4294925233, 17)),
        (S = c(S, A, k, M, p[11], 2304563134, 22)),
        (M = c(M, S, A, k, p[12], 1804603682, 7)),
        (k = c(k, M, S, A, p[13], 4254626195, 12)),
        (A = c(A, k, M, S, p[14], 2792965006, 17)),
        (S = c(S, A, k, M, p[15], 1236535329, 22)),
        (M = v(M, S, A, k, p[1], 4129170786, 5)),
        (k = v(k, M, S, A, p[6], 3225465664, 9)),
        (A = v(A, k, M, S, p[11], 643717713, 14)),
        (S = v(S, A, k, M, p[0], 3921069994, 20)),
        (M = v(M, S, A, k, p[5], 3593408605, 5)),
        (k = v(k, M, S, A, p[10], 38016083, 9)),
        (A = v(A, k, M, S, p[15], 3634488961, 14)),
        (S = v(S, A, k, M, p[4], 3889429448, 20)),
        (M = v(M, S, A, k, p[9], 568446438, 5)),
        (k = v(k, M, S, A, p[14], 3275163606, 9)),
        (A = v(A, k, M, S, p[3], 4107603335, 14)),
        (S = v(S, A, k, M, p[8], 1163531501, 20)),
        (M = v(M, S, A, k, p[13], 2850285829, 5)),
        (k = v(k, M, S, A, p[2], 4243563512, 9)),
        (A = v(A, k, M, S, p[7], 1735328473, 14)),
        (S = v(S, A, k, M, p[12], 2368359562, 20)),
        (M = g(M, S, A, k, p[5], 4294588738, 4)),
        (k = g(k, M, S, A, p[8], 2272392833, 11)),
        (A = g(A, k, M, S, p[11], 1839030562, 16)),
        (S = g(S, A, k, M, p[14], 4259657740, 23)),
        (M = g(M, S, A, k, p[1], 2763975236, 4)),
        (k = g(k, M, S, A, p[4], 1272893353, 11)),
        (A = g(A, k, M, S, p[7], 4139469664, 16)),
        (S = g(S, A, k, M, p[10], 3200236656, 23)),
        (M = g(M, S, A, k, p[13], 681279174, 4)),
        (k = g(k, M, S, A, p[0], 3936430074, 11)),
        (A = g(A, k, M, S, p[3], 3572445317, 16)),
        (S = g(S, A, k, M, p[6], 76029189, 23)),
        (M = g(M, S, A, k, p[9], 3654602809, 4)),
        (k = g(k, M, S, A, p[12], 3873151461, 11)),
        (A = g(A, k, M, S, p[15], 530742520, 16)),
        (S = g(S, A, k, M, p[2], 3299628645, 23)),
        (M = b(M, S, A, k, p[0], 4096336452, 6)),
        (k = b(k, M, S, A, p[7], 1126891415, 10)),
        (A = b(A, k, M, S, p[14], 2878612391, 15)),
        (S = b(S, A, k, M, p[5], 4237533241, 21)),
        (M = b(M, S, A, k, p[12], 1700485571, 6)),
        (k = b(k, M, S, A, p[3], 2399980690, 10)),
        (A = b(A, k, M, S, p[10], 4293915773, 15)),
        (S = b(S, A, k, M, p[1], 2240044497, 21)),
        (M = b(M, S, A, k, p[8], 1873313359, 6)),
        (k = b(k, M, S, A, p[15], 4264355552, 10)),
        (A = b(A, k, M, S, p[6], 2734768916, 15)),
        (S = b(S, A, k, M, p[13], 1309151649, 21)),
        (M = b(M, S, A, k, p[4], 4149444226, 6)),
        (k = b(k, M, S, A, p[11], 3174756917, 10)),
        (A = b(A, k, M, S, p[2], 718787259, 15)),
        (S = b(S, A, k, M, p[9], 3951481745, 21)),
        (this._a = (this._a + M) | 0),
        (this._b = (this._b + S) | 0),
        (this._c = (this._c + A) | 0),
        (this._d = (this._d + k) | 0);
    }),
    (l.prototype._digest = function () {
      (this._block[this._blockOffset++] = 128),
        this._blockOffset > 56 &&
          (this._block.fill(0, this._blockOffset, 64), this._update(), (this._blockOffset = 0)),
        this._block.fill(0, this._blockOffset, 56),
        this._block.writeUInt32LE(this._length[0], 56),
        this._block.writeUInt32LE(this._length[1], 60),
        this._update();
      var p = n.allocUnsafe(16);
      return (
        p.writeInt32LE(this._a, 0),
        p.writeInt32LE(this._b, 4),
        p.writeInt32LE(this._c, 8),
        p.writeInt32LE(this._d, 12),
        p
      );
    });
  function a(p, _) {
    return (p << _) | (p >>> (32 - _));
  }
  function c(p, _, M, S, A, k, P) {
    return (a((p + ((_ & M) | (~_ & S)) + A + k) | 0, P) + _) | 0;
  }
  function v(p, _, M, S, A, k, P) {
    return (a((p + ((_ & S) | (M & ~S)) + A + k) | 0, P) + _) | 0;
  }
  function g(p, _, M, S, A, k, P) {
    return (a((p + (_ ^ M ^ S) + A + k) | 0, P) + _) | 0;
  }
  function b(p, _, M, S, A, k, P) {
    return (a((p + (M ^ (_ | ~S)) + A + k) | 0, P) + _) | 0;
  }
  return (Oh = l), Oh;
}
var Uh, hg;
function M1() {
  if (hg) return Uh;
  hg = 1;
  var t = Mr.Buffer,
    e = It(),
    n = lw(),
    i = new Array(16),
    l = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5,
      2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4,
      13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13,
    ],
    a = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8,
      12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15,
      0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11,
    ],
    c = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15,
      9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14,
      15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6,
    ],
    v = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12,
      7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14,
      14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11,
    ],
    g = [0, 1518500249, 1859775393, 2400959708, 2840853838],
    b = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function p() {
    n.call(this, 64),
      (this._a = 1732584193),
      (this._b = 4023233417),
      (this._c = 2562383102),
      (this._d = 271733878),
      (this._e = 3285377520);
  }
  e(p, n),
    (p.prototype._update = function () {
      for (var B = i, T = 0; T < 16; ++T) B[T] = this._block.readInt32LE(T * 4);
      for (
        var F = this._a | 0,
          O = this._b | 0,
          $ = this._c | 0,
          J = this._d | 0,
          he = this._e | 0,
          de = this._a | 0,
          ne = this._b | 0,
          Ae = this._c | 0,
          x = this._d | 0,
          r = this._e | 0,
          o = 0;
        o < 80;
        o += 1
      ) {
        var f, u;
        o < 16
          ? ((f = M(F, O, $, J, he, B[l[o]], g[0], c[o])),
            (u = P(de, ne, Ae, x, r, B[a[o]], b[0], v[o])))
          : o < 32
          ? ((f = S(F, O, $, J, he, B[l[o]], g[1], c[o])),
            (u = k(de, ne, Ae, x, r, B[a[o]], b[1], v[o])))
          : o < 48
          ? ((f = A(F, O, $, J, he, B[l[o]], g[2], c[o])),
            (u = A(de, ne, Ae, x, r, B[a[o]], b[2], v[o])))
          : o < 64
          ? ((f = k(F, O, $, J, he, B[l[o]], g[3], c[o])),
            (u = S(de, ne, Ae, x, r, B[a[o]], b[3], v[o])))
          : ((f = P(F, O, $, J, he, B[l[o]], g[4], c[o])),
            (u = M(de, ne, Ae, x, r, B[a[o]], b[4], v[o]))),
          (F = he),
          (he = J),
          (J = _($, 10)),
          ($ = O),
          (O = f),
          (de = r),
          (r = x),
          (x = _(Ae, 10)),
          (Ae = ne),
          (ne = u);
      }
      var d = (this._b + $ + x) | 0;
      (this._b = (this._c + J + r) | 0),
        (this._c = (this._d + he + de) | 0),
        (this._d = (this._e + F + ne) | 0),
        (this._e = (this._a + O + Ae) | 0),
        (this._a = d);
    }),
    (p.prototype._digest = function () {
      (this._block[this._blockOffset++] = 128),
        this._blockOffset > 56 &&
          (this._block.fill(0, this._blockOffset, 64), this._update(), (this._blockOffset = 0)),
        this._block.fill(0, this._blockOffset, 56),
        this._block.writeUInt32LE(this._length[0], 56),
        this._block.writeUInt32LE(this._length[1], 60),
        this._update();
      var B = t.alloc ? t.alloc(20) : new t(20);
      return (
        B.writeInt32LE(this._a, 0),
        B.writeInt32LE(this._b, 4),
        B.writeInt32LE(this._c, 8),
        B.writeInt32LE(this._d, 12),
        B.writeInt32LE(this._e, 16),
        B
      );
    });
  function _(B, T) {
    return (B << T) | (B >>> (32 - T));
  }
  function M(B, T, F, O, $, J, he, de) {
    return (_((B + (T ^ F ^ O) + J + he) | 0, de) + $) | 0;
  }
  function S(B, T, F, O, $, J, he, de) {
    return (_((B + ((T & F) | (~T & O)) + J + he) | 0, de) + $) | 0;
  }
  function A(B, T, F, O, $, J, he, de) {
    return (_((B + ((T | ~F) ^ O) + J + he) | 0, de) + $) | 0;
  }
  function k(B, T, F, O, $, J, he, de) {
    return (_((B + ((T & O) | (F & ~O)) + J + he) | 0, de) + $) | 0;
  }
  function P(B, T, F, O, $, J, he, de) {
    return (_((B + (T ^ (F | ~O)) + J + he) | 0, de) + $) | 0;
  }
  return (Uh = p), Uh;
}
var Nh = { exports: {} },
  Dh,
  dg;
function fo() {
  if (dg) return Dh;
  dg = 1;
  var t = zt().Buffer;
  function e(n, i) {
    (this._block = t.alloc(n)), (this._finalSize = i), (this._blockSize = n), (this._len = 0);
  }
  return (
    (e.prototype.update = function (n, i) {
      typeof n == "string" && ((i = i || "utf8"), (n = t.from(n, i)));
      for (var l = this._block, a = this._blockSize, c = n.length, v = this._len, g = 0; g < c; ) {
        for (var b = v % a, p = Math.min(c - g, a - b), _ = 0; _ < p; _++) l[b + _] = n[g + _];
        (v += p), (g += p), v % a === 0 && this._update(l);
      }
      return (this._len += c), this;
    }),
    (e.prototype.digest = function (n) {
      var i = this._len % this._blockSize;
      (this._block[i] = 128),
        this._block.fill(0, i + 1),
        i >= this._finalSize && (this._update(this._block), this._block.fill(0));
      var l = this._len * 8;
      if (l <= 4294967295) this._block.writeUInt32BE(l, this._blockSize - 4);
      else {
        var a = (l & 4294967295) >>> 0,
          c = (l - a) / 4294967296;
        this._block.writeUInt32BE(c, this._blockSize - 8),
          this._block.writeUInt32BE(a, this._blockSize - 4);
      }
      this._update(this._block);
      var v = this._hash();
      return n ? v.toString(n) : v;
    }),
    (e.prototype._update = function () {
      throw new Error("_update must be implemented by subclass");
    }),
    (Dh = e),
    Dh
  );
}
var Lh, pg;
function WM() {
  if (pg) return Lh;
  pg = 1;
  var t = It(),
    e = fo(),
    n = zt().Buffer,
    i = [1518500249, 1859775393, -1894007588, -899497514],
    l = new Array(80);
  function a() {
    this.init(), (this._w = l), e.call(this, 64, 56);
  }
  t(a, e),
    (a.prototype.init = function () {
      return (
        (this._a = 1732584193),
        (this._b = 4023233417),
        (this._c = 2562383102),
        (this._d = 271733878),
        (this._e = 3285377520),
        this
      );
    });
  function c(b) {
    return (b << 5) | (b >>> 27);
  }
  function v(b) {
    return (b << 30) | (b >>> 2);
  }
  function g(b, p, _, M) {
    return b === 0 ? (p & _) | (~p & M) : b === 2 ? (p & _) | (p & M) | (_ & M) : p ^ _ ^ M;
  }
  return (
    (a.prototype._update = function (b) {
      for (
        var p = this._w,
          _ = this._a | 0,
          M = this._b | 0,
          S = this._c | 0,
          A = this._d | 0,
          k = this._e | 0,
          P = 0;
        P < 16;
        ++P
      )
        p[P] = b.readInt32BE(P * 4);
      for (; P < 80; ++P) p[P] = p[P - 3] ^ p[P - 8] ^ p[P - 14] ^ p[P - 16];
      for (var B = 0; B < 80; ++B) {
        var T = ~~(B / 20),
          F = (c(_) + g(T, M, S, A) + k + p[B] + i[T]) | 0;
        (k = A), (A = S), (S = v(M)), (M = _), (_ = F);
      }
      (this._a = (_ + this._a) | 0),
        (this._b = (M + this._b) | 0),
        (this._c = (S + this._c) | 0),
        (this._d = (A + this._d) | 0),
        (this._e = (k + this._e) | 0);
    }),
    (a.prototype._hash = function () {
      var b = n.allocUnsafe(20);
      return (
        b.writeInt32BE(this._a | 0, 0),
        b.writeInt32BE(this._b | 0, 4),
        b.writeInt32BE(this._c | 0, 8),
        b.writeInt32BE(this._d | 0, 12),
        b.writeInt32BE(this._e | 0, 16),
        b
      );
    }),
    (Lh = a),
    Lh
  );
}
var Fh, mg;
function KM() {
  if (mg) return Fh;
  mg = 1;
  var t = It(),
    e = fo(),
    n = zt().Buffer,
    i = [1518500249, 1859775393, -1894007588, -899497514],
    l = new Array(80);
  function a() {
    this.init(), (this._w = l), e.call(this, 64, 56);
  }
  t(a, e),
    (a.prototype.init = function () {
      return (
        (this._a = 1732584193),
        (this._b = 4023233417),
        (this._c = 2562383102),
        (this._d = 271733878),
        (this._e = 3285377520),
        this
      );
    });
  function c(p) {
    return (p << 1) | (p >>> 31);
  }
  function v(p) {
    return (p << 5) | (p >>> 27);
  }
  function g(p) {
    return (p << 30) | (p >>> 2);
  }
  function b(p, _, M, S) {
    return p === 0 ? (_ & M) | (~_ & S) : p === 2 ? (_ & M) | (_ & S) | (M & S) : _ ^ M ^ S;
  }
  return (
    (a.prototype._update = function (p) {
      for (
        var _ = this._w,
          M = this._a | 0,
          S = this._b | 0,
          A = this._c | 0,
          k = this._d | 0,
          P = this._e | 0,
          B = 0;
        B < 16;
        ++B
      )
        _[B] = p.readInt32BE(B * 4);
      for (; B < 80; ++B) _[B] = c(_[B - 3] ^ _[B - 8] ^ _[B - 14] ^ _[B - 16]);
      for (var T = 0; T < 80; ++T) {
        var F = ~~(T / 20),
          O = (v(M) + b(F, S, A, k) + P + _[T] + i[F]) | 0;
        (P = k), (k = A), (A = g(S)), (S = M), (M = O);
      }
      (this._a = (M + this._a) | 0),
        (this._b = (S + this._b) | 0),
        (this._c = (A + this._c) | 0),
        (this._d = (k + this._d) | 0),
        (this._e = (P + this._e) | 0);
    }),
    (a.prototype._hash = function () {
      var p = n.allocUnsafe(20);
      return (
        p.writeInt32BE(this._a | 0, 0),
        p.writeInt32BE(this._b | 0, 4),
        p.writeInt32BE(this._c | 0, 8),
        p.writeInt32BE(this._d | 0, 12),
        p.writeInt32BE(this._e | 0, 16),
        p
      );
    }),
    (Fh = a),
    Fh
  );
}
var qh, vg;
function uw() {
  if (vg) return qh;
  vg = 1;
  var t = It(),
    e = fo(),
    n = zt().Buffer,
    i = [
      1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221,
      3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580,
      3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986,
      2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895,
      666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037,
      2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344,
      430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779,
      1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479,
      3329325298,
    ],
    l = new Array(64);
  function a() {
    this.init(), (this._w = l), e.call(this, 64, 56);
  }
  t(a, e),
    (a.prototype.init = function () {
      return (
        (this._a = 1779033703),
        (this._b = 3144134277),
        (this._c = 1013904242),
        (this._d = 2773480762),
        (this._e = 1359893119),
        (this._f = 2600822924),
        (this._g = 528734635),
        (this._h = 1541459225),
        this
      );
    });
  function c(M, S, A) {
    return A ^ (M & (S ^ A));
  }
  function v(M, S, A) {
    return (M & S) | (A & (M | S));
  }
  function g(M) {
    return ((M >>> 2) | (M << 30)) ^ ((M >>> 13) | (M << 19)) ^ ((M >>> 22) | (M << 10));
  }
  function b(M) {
    return ((M >>> 6) | (M << 26)) ^ ((M >>> 11) | (M << 21)) ^ ((M >>> 25) | (M << 7));
  }
  function p(M) {
    return ((M >>> 7) | (M << 25)) ^ ((M >>> 18) | (M << 14)) ^ (M >>> 3);
  }
  function _(M) {
    return ((M >>> 17) | (M << 15)) ^ ((M >>> 19) | (M << 13)) ^ (M >>> 10);
  }
  return (
    (a.prototype._update = function (M) {
      for (
        var S = this._w,
          A = this._a | 0,
          k = this._b | 0,
          P = this._c | 0,
          B = this._d | 0,
          T = this._e | 0,
          F = this._f | 0,
          O = this._g | 0,
          $ = this._h | 0,
          J = 0;
        J < 16;
        ++J
      )
        S[J] = M.readInt32BE(J * 4);
      for (; J < 64; ++J) S[J] = (_(S[J - 2]) + S[J - 7] + p(S[J - 15]) + S[J - 16]) | 0;
      for (var he = 0; he < 64; ++he) {
        var de = ($ + b(T) + c(T, F, O) + i[he] + S[he]) | 0,
          ne = (g(A) + v(A, k, P)) | 0;
        ($ = O),
          (O = F),
          (F = T),
          (T = (B + de) | 0),
          (B = P),
          (P = k),
          (k = A),
          (A = (de + ne) | 0);
      }
      (this._a = (A + this._a) | 0),
        (this._b = (k + this._b) | 0),
        (this._c = (P + this._c) | 0),
        (this._d = (B + this._d) | 0),
        (this._e = (T + this._e) | 0),
        (this._f = (F + this._f) | 0),
        (this._g = (O + this._g) | 0),
        (this._h = ($ + this._h) | 0);
    }),
    (a.prototype._hash = function () {
      var M = n.allocUnsafe(32);
      return (
        M.writeInt32BE(this._a, 0),
        M.writeInt32BE(this._b, 4),
        M.writeInt32BE(this._c, 8),
        M.writeInt32BE(this._d, 12),
        M.writeInt32BE(this._e, 16),
        M.writeInt32BE(this._f, 20),
        M.writeInt32BE(this._g, 24),
        M.writeInt32BE(this._h, 28),
        M
      );
    }),
    (qh = a),
    qh
  );
}
var zh, gg;
function ZM() {
  if (gg) return zh;
  gg = 1;
  var t = It(),
    e = uw(),
    n = fo(),
    i = zt().Buffer,
    l = new Array(64);
  function a() {
    this.init(), (this._w = l), n.call(this, 64, 56);
  }
  return (
    t(a, e),
    (a.prototype.init = function () {
      return (
        (this._a = 3238371032),
        (this._b = 914150663),
        (this._c = 812702999),
        (this._d = 4144912697),
        (this._e = 4290775857),
        (this._f = 1750603025),
        (this._g = 1694076839),
        (this._h = 3204075428),
        this
      );
    }),
    (a.prototype._hash = function () {
      var c = i.allocUnsafe(28);
      return (
        c.writeInt32BE(this._a, 0),
        c.writeInt32BE(this._b, 4),
        c.writeInt32BE(this._c, 8),
        c.writeInt32BE(this._d, 12),
        c.writeInt32BE(this._e, 16),
        c.writeInt32BE(this._f, 20),
        c.writeInt32BE(this._g, 24),
        c
      );
    }),
    (zh = a),
    zh
  );
}
var jh, yg;
function cw() {
  if (yg) return jh;
  yg = 1;
  var t = It(),
    e = fo(),
    n = zt().Buffer,
    i = [
      1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548,
      961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560,
      3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994,
      1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868,
      3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933,
      770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837,
      2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956,
      3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936,
      666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823,
      1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627,
      2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008,
      3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720,
      430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280,
      958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899,
      1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044,
      2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427,
      3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992,
      116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315,
      685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676,
      1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591,
    ],
    l = new Array(160);
  function a() {
    this.init(), (this._w = l), e.call(this, 128, 112);
  }
  t(a, e),
    (a.prototype.init = function () {
      return (
        (this._ah = 1779033703),
        (this._bh = 3144134277),
        (this._ch = 1013904242),
        (this._dh = 2773480762),
        (this._eh = 1359893119),
        (this._fh = 2600822924),
        (this._gh = 528734635),
        (this._hh = 1541459225),
        (this._al = 4089235720),
        (this._bl = 2227873595),
        (this._cl = 4271175723),
        (this._dl = 1595750129),
        (this._el = 2917565137),
        (this._fl = 725511199),
        (this._gl = 4215389547),
        (this._hl = 327033209),
        this
      );
    });
  function c(k, P, B) {
    return B ^ (k & (P ^ B));
  }
  function v(k, P, B) {
    return (k & P) | (B & (k | P));
  }
  function g(k, P) {
    return ((k >>> 28) | (P << 4)) ^ ((P >>> 2) | (k << 30)) ^ ((P >>> 7) | (k << 25));
  }
  function b(k, P) {
    return ((k >>> 14) | (P << 18)) ^ ((k >>> 18) | (P << 14)) ^ ((P >>> 9) | (k << 23));
  }
  function p(k, P) {
    return ((k >>> 1) | (P << 31)) ^ ((k >>> 8) | (P << 24)) ^ (k >>> 7);
  }
  function _(k, P) {
    return ((k >>> 1) | (P << 31)) ^ ((k >>> 8) | (P << 24)) ^ ((k >>> 7) | (P << 25));
  }
  function M(k, P) {
    return ((k >>> 19) | (P << 13)) ^ ((P >>> 29) | (k << 3)) ^ (k >>> 6);
  }
  function S(k, P) {
    return ((k >>> 19) | (P << 13)) ^ ((P >>> 29) | (k << 3)) ^ ((k >>> 6) | (P << 26));
  }
  function A(k, P) {
    return k >>> 0 < P >>> 0 ? 1 : 0;
  }
  return (
    (a.prototype._update = function (k) {
      for (
        var P = this._w,
          B = this._ah | 0,
          T = this._bh | 0,
          F = this._ch | 0,
          O = this._dh | 0,
          $ = this._eh | 0,
          J = this._fh | 0,
          he = this._gh | 0,
          de = this._hh | 0,
          ne = this._al | 0,
          Ae = this._bl | 0,
          x = this._cl | 0,
          r = this._dl | 0,
          o = this._el | 0,
          f = this._fl | 0,
          u = this._gl | 0,
          d = this._hl | 0,
          y = 0;
        y < 32;
        y += 2
      )
        (P[y] = k.readInt32BE(y * 4)), (P[y + 1] = k.readInt32BE(y * 4 + 4));
      for (; y < 160; y += 2) {
        var w = P[y - 30],
          h = P[y - 15 * 2 + 1],
          s = p(w, h),
          m = _(h, w);
        (w = P[y - 2 * 2]), (h = P[y - 2 * 2 + 1]);
        var E = M(w, h),
          R = S(h, w),
          z = P[y - 7 * 2],
          Q = P[y - 7 * 2 + 1],
          G = P[y - 16 * 2],
          q = P[y - 16 * 2 + 1],
          Z = (m + Q) | 0,
          te = (s + z + A(Z, m)) | 0;
        (Z = (Z + R) | 0),
          (te = (te + E + A(Z, R)) | 0),
          (Z = (Z + q) | 0),
          (te = (te + G + A(Z, q)) | 0),
          (P[y] = te),
          (P[y + 1] = Z);
      }
      for (var ue = 0; ue < 160; ue += 2) {
        (te = P[ue]), (Z = P[ue + 1]);
        var ae = v(B, T, F),
          K = v(ne, Ae, x),
          ve = g(B, ne),
          Ye = g(ne, B),
          Ce = b($, o),
          Te = b(o, $),
          ut = i[ue],
          Ie = i[ue + 1],
          be = c($, J, he),
          wt = c(o, f, u),
          Oe = (d + Te) | 0,
          je = (de + Ce + A(Oe, d)) | 0;
        (Oe = (Oe + wt) | 0),
          (je = (je + be + A(Oe, wt)) | 0),
          (Oe = (Oe + Ie) | 0),
          (je = (je + ut + A(Oe, Ie)) | 0),
          (Oe = (Oe + Z) | 0),
          (je = (je + te + A(Oe, Z)) | 0);
        var xt = (Ye + K) | 0,
          Ue = (ve + ae + A(xt, Ye)) | 0;
        (de = he),
          (d = u),
          (he = J),
          (u = f),
          (J = $),
          (f = o),
          (o = (r + Oe) | 0),
          ($ = (O + je + A(o, r)) | 0),
          (O = F),
          (r = x),
          (F = T),
          (x = Ae),
          (T = B),
          (Ae = ne),
          (ne = (Oe + xt) | 0),
          (B = (je + Ue + A(ne, Oe)) | 0);
      }
      (this._al = (this._al + ne) | 0),
        (this._bl = (this._bl + Ae) | 0),
        (this._cl = (this._cl + x) | 0),
        (this._dl = (this._dl + r) | 0),
        (this._el = (this._el + o) | 0),
        (this._fl = (this._fl + f) | 0),
        (this._gl = (this._gl + u) | 0),
        (this._hl = (this._hl + d) | 0),
        (this._ah = (this._ah + B + A(this._al, ne)) | 0),
        (this._bh = (this._bh + T + A(this._bl, Ae)) | 0),
        (this._ch = (this._ch + F + A(this._cl, x)) | 0),
        (this._dh = (this._dh + O + A(this._dl, r)) | 0),
        (this._eh = (this._eh + $ + A(this._el, o)) | 0),
        (this._fh = (this._fh + J + A(this._fl, f)) | 0),
        (this._gh = (this._gh + he + A(this._gl, u)) | 0),
        (this._hh = (this._hh + de + A(this._hl, d)) | 0);
    }),
    (a.prototype._hash = function () {
      var k = n.allocUnsafe(64);
      function P(B, T, F) {
        k.writeInt32BE(B, F), k.writeInt32BE(T, F + 4);
      }
      return (
        P(this._ah, this._al, 0),
        P(this._bh, this._bl, 8),
        P(this._ch, this._cl, 16),
        P(this._dh, this._dl, 24),
        P(this._eh, this._el, 32),
        P(this._fh, this._fl, 40),
        P(this._gh, this._gl, 48),
        P(this._hh, this._hl, 56),
        k
      );
    }),
    (jh = a),
    jh
  );
}
var $h, bg;
function GM() {
  if (bg) return $h;
  bg = 1;
  var t = It(),
    e = cw(),
    n = fo(),
    i = zt().Buffer,
    l = new Array(160);
  function a() {
    this.init(), (this._w = l), n.call(this, 128, 112);
  }
  return (
    t(a, e),
    (a.prototype.init = function () {
      return (
        (this._ah = 3418070365),
        (this._bh = 1654270250),
        (this._ch = 2438529370),
        (this._dh = 355462360),
        (this._eh = 1731405415),
        (this._fh = 2394180231),
        (this._gh = 3675008525),
        (this._hh = 1203062813),
        (this._al = 3238371032),
        (this._bl = 914150663),
        (this._cl = 812702999),
        (this._dl = 4144912697),
        (this._el = 4290775857),
        (this._fl = 1750603025),
        (this._gl = 1694076839),
        (this._hl = 3204075428),
        this
      );
    }),
    (a.prototype._hash = function () {
      var c = i.allocUnsafe(48);
      function v(g, b, p) {
        c.writeInt32BE(g, p), c.writeInt32BE(b, p + 4);
      }
      return (
        v(this._ah, this._al, 0),
        v(this._bh, this._bl, 8),
        v(this._ch, this._cl, 16),
        v(this._dh, this._dl, 24),
        v(this._eh, this._el, 32),
        v(this._fh, this._fl, 40),
        c
      );
    }),
    ($h = a),
    $h
  );
}
var wg;
function S1() {
  if (wg) return Nh.exports;
  wg = 1;
  var t = (Nh.exports = function (n) {
    n = n.toLowerCase();
    var i = t[n];
    if (!i) throw new Error(n + " is not supported (we accept pull requests)");
    return new i();
  });
  return (
    (t.sha = WM()),
    (t.sha1 = KM()),
    (t.sha224 = ZM()),
    (t.sha256 = uw()),
    (t.sha384 = GM()),
    (t.sha512 = cw()),
    Nh.exports
  );
}
var Hh, _g;
function fa() {
  if (_g) return Hh;
  _g = 1;
  var t = zt().Buffer,
    e = fw().Transform,
    n = pp().StringDecoder,
    i = It();
  function l(a) {
    e.call(this),
      (this.hashMode = typeof a == "string"),
      this.hashMode ? (this[a] = this._finalOrDigest) : (this.final = this._finalOrDigest),
      this._final && ((this.__final = this._final), (this._final = null)),
      (this._decoder = null),
      (this._encoding = null);
  }
  return (
    i(l, e),
    (l.prototype.update = function (a, c, v) {
      typeof a == "string" && (a = t.from(a, c));
      var g = this._update(a);
      return this.hashMode ? this : (v && (g = this._toString(g, v)), g);
    }),
    (l.prototype.setAutoPadding = function () {}),
    (l.prototype.getAuthTag = function () {
      throw new Error("trying to get auth tag in unsupported state");
    }),
    (l.prototype.setAuthTag = function () {
      throw new Error("trying to set auth tag in unsupported state");
    }),
    (l.prototype.setAAD = function () {
      throw new Error("trying to set aad in unsupported state");
    }),
    (l.prototype._transform = function (a, c, v) {
      var g;
      try {
        this.hashMode ? this._update(a) : this.push(this._update(a));
      } catch (b) {
        g = b;
      } finally {
        v(g);
      }
    }),
    (l.prototype._flush = function (a) {
      var c;
      try {
        this.push(this.__final());
      } catch (v) {
        c = v;
      }
      a(c);
    }),
    (l.prototype._finalOrDigest = function (a) {
      var c = this.__final() || t.alloc(0);
      return a && (c = this._toString(c, a, !0)), c;
    }),
    (l.prototype._toString = function (a, c, v) {
      if (
        (this._decoder || ((this._decoder = new n(c)), (this._encoding = c)), this._encoding !== c)
      )
        throw new Error("can't switch encodings");
      var g = this._decoder.write(a);
      return v && (g += this._decoder.end()), g;
    }),
    (Hh = l),
    Hh
  );
}
var Vh, xg;
function Af() {
  if (xg) return Vh;
  xg = 1;
  var t = It(),
    e = x1(),
    n = M1(),
    i = S1(),
    l = fa();
  function a(c) {
    l.call(this, "digest"), (this._hash = c);
  }
  return (
    t(a, l),
    (a.prototype._update = function (c) {
      this._hash.update(c);
    }),
    (a.prototype._final = function () {
      return this._hash.digest();
    }),
    (Vh = function (v) {
      return (
        (v = v.toLowerCase()),
        v === "md5" ? new e() : v === "rmd160" || v === "ripemd160" ? new n() : new a(i(v))
      );
    }),
    Vh
  );
}
var Wh, Mg;
function YM() {
  if (Mg) return Wh;
  Mg = 1;
  var t = It(),
    e = zt().Buffer,
    n = fa(),
    i = e.alloc(128),
    l = 64;
  function a(c, v) {
    n.call(this, "digest"),
      typeof v == "string" && (v = e.from(v)),
      (this._alg = c),
      (this._key = v),
      v.length > l ? (v = c(v)) : v.length < l && (v = e.concat([v, i], l));
    for (
      var g = (this._ipad = e.allocUnsafe(l)), b = (this._opad = e.allocUnsafe(l)), p = 0;
      p < l;
      p++
    )
      (g[p] = v[p] ^ 54), (b[p] = v[p] ^ 92);
    this._hash = [g];
  }
  return (
    t(a, n),
    (a.prototype._update = function (c) {
      this._hash.push(c);
    }),
    (a.prototype._final = function () {
      var c = this._alg(e.concat(this._hash));
      return this._alg(e.concat([this._opad, c]));
    }),
    (Wh = a),
    Wh
  );
}
var Kh, Sg;
function hw() {
  if (Sg) return Kh;
  Sg = 1;
  var t = x1();
  return (
    (Kh = function (e) {
      return new t().update(e).digest();
    }),
    Kh
  );
}
var Zh, Eg;
function dw() {
  if (Eg) return Zh;
  Eg = 1;
  var t = It(),
    e = YM(),
    n = fa(),
    i = zt().Buffer,
    l = hw(),
    a = M1(),
    c = S1(),
    v = i.alloc(128);
  function g(b, p) {
    n.call(this, "digest"), typeof p == "string" && (p = i.from(p));
    var _ = b === "sha512" || b === "sha384" ? 128 : 64;
    if (((this._alg = b), (this._key = p), p.length > _)) {
      var M = b === "rmd160" ? new a() : c(b);
      p = M.update(p).digest();
    } else p.length < _ && (p = i.concat([p, v], _));
    for (
      var S = (this._ipad = i.allocUnsafe(_)), A = (this._opad = i.allocUnsafe(_)), k = 0;
      k < _;
      k++
    )
      (S[k] = p[k] ^ 54), (A[k] = p[k] ^ 92);
    (this._hash = b === "rmd160" ? new a() : c(b)), this._hash.update(S);
  }
  return (
    t(g, n),
    (g.prototype._update = function (b) {
      this._hash.update(b);
    }),
    (g.prototype._final = function () {
      var b = this._hash.digest(),
        p = this._alg === "rmd160" ? new a() : c(this._alg);
      return p.update(this._opad).update(b).digest();
    }),
    (Zh = function (p, _) {
      return (
        (p = p.toLowerCase()),
        p === "rmd160" || p === "ripemd160"
          ? new g("rmd160", _)
          : p === "md5"
          ? new e(l, _)
          : new g(p, _)
      );
    }),
    Zh
  );
}
const JM = {
    sign: "rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c",
  },
  QM = {
    sign: "rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420",
  },
  XM = {
    sign: "rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430",
  },
  e9 = {
    sign: "rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440",
  },
  t9 = {
    sign: "ecdsa",
    hash: "sha256",
    id: "",
  },
  r9 = {
    sign: "ecdsa",
    hash: "sha224",
    id: "",
  },
  n9 = {
    sign: "ecdsa",
    hash: "sha384",
    id: "",
  },
  i9 = {
    sign: "ecdsa",
    hash: "sha512",
    id: "",
  },
  a9 = {
    sign: "dsa",
    hash: "sha1",
    id: "",
  },
  s9 = {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414",
  },
  o9 = {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410",
  },
  pw = {
    sha224WithRSAEncryption: JM,
    "RSA-SHA224": {
      sign: "ecdsa/rsa",
      hash: "sha224",
      id: "302d300d06096086480165030402040500041c",
    },
    sha256WithRSAEncryption: QM,
    "RSA-SHA256": {
      sign: "ecdsa/rsa",
      hash: "sha256",
      id: "3031300d060960864801650304020105000420",
    },
    sha384WithRSAEncryption: XM,
    "RSA-SHA384": {
      sign: "ecdsa/rsa",
      hash: "sha384",
      id: "3041300d060960864801650304020205000430",
    },
    sha512WithRSAEncryption: e9,
    "RSA-SHA512": {
      sign: "ecdsa/rsa",
      hash: "sha512",
      id: "3051300d060960864801650304020305000440",
    },
    "RSA-SHA1": {
      sign: "rsa",
      hash: "sha1",
      id: "3021300906052b0e03021a05000414",
    },
    "ecdsa-with-SHA1": {
      sign: "ecdsa",
      hash: "sha1",
      id: "",
    },
    sha256: t9,
    sha224: r9,
    sha384: n9,
    sha512: i9,
    "DSA-SHA": {
      sign: "dsa",
      hash: "sha1",
      id: "",
    },
    "DSA-SHA1": {
      sign: "dsa",
      hash: "sha1",
      id: "",
    },
    DSA: a9,
    "DSA-WITH-SHA224": {
      sign: "dsa",
      hash: "sha224",
      id: "",
    },
    "DSA-SHA224": {
      sign: "dsa",
      hash: "sha224",
      id: "",
    },
    "DSA-WITH-SHA256": {
      sign: "dsa",
      hash: "sha256",
      id: "",
    },
    "DSA-SHA256": {
      sign: "dsa",
      hash: "sha256",
      id: "",
    },
    "DSA-WITH-SHA384": {
      sign: "dsa",
      hash: "sha384",
      id: "",
    },
    "DSA-SHA384": {
      sign: "dsa",
      hash: "sha384",
      id: "",
    },
    "DSA-WITH-SHA512": {
      sign: "dsa",
      hash: "sha512",
      id: "",
    },
    "DSA-SHA512": {
      sign: "dsa",
      hash: "sha512",
      id: "",
    },
    "DSA-RIPEMD160": {
      sign: "dsa",
      hash: "rmd160",
      id: "",
    },
    ripemd160WithRSA: s9,
    "RSA-RIPEMD160": {
      sign: "rsa",
      hash: "rmd160",
      id: "3021300906052b2403020105000414",
    },
    md5WithRSAEncryption: o9,
    "RSA-MD5": {
      sign: "rsa",
      hash: "md5",
      id: "3020300c06082a864886f70d020505000410",
    },
  };
var Gh, Ag;
function f9() {
  return Ag || ((Ag = 1), (Gh = pw)), Gh;
}
var Yf = {},
  Yh,
  kg;
function mw() {
  if (kg) return Yh;
  kg = 1;
  var t = Math.pow(2, 30) - 1;
  return (
    (Yh = function (e, n) {
      if (typeof e != "number") throw new TypeError("Iterations not a number");
      if (e < 0) throw new TypeError("Bad iterations");
      if (typeof n != "number") throw new TypeError("Key length not a number");
      if (n < 0 || n > t || n !== n) throw new TypeError("Bad key length");
    }),
    Yh
  );
}
var Jh, Bg;
function vw() {
  if (Bg) return Jh;
  Bg = 1;
  var t;
  if (mt.process && mt.process.browser) t = "utf-8";
  else if (mt.process && mt.process.version) {
    var e = parseInt(Et.version.split(".")[0].slice(1), 10);
    t = e >= 6 ? "utf-8" : "binary";
  } else t = "utf-8";
  return (Jh = t), Jh;
}
var Qh, Cg;
function gw() {
  if (Cg) return Qh;
  Cg = 1;
  var t = zt().Buffer;
  return (
    (Qh = function (e, n, i) {
      if (t.isBuffer(e)) return e;
      if (typeof e == "string") return t.from(e, n);
      if (ArrayBuffer.isView(e)) return t.from(e.buffer);
      throw new TypeError(i + " must be a string, a Buffer, a typed array or a DataView");
    }),
    Qh
  );
}
var Xh, Tg;
function yw() {
  if (Tg) return Xh;
  Tg = 1;
  var t = hw(),
    e = M1(),
    n = S1(),
    i = zt().Buffer,
    l = mw(),
    a = vw(),
    c = gw(),
    v = i.alloc(128),
    g = {
      md5: 16,
      sha1: 20,
      sha224: 28,
      sha256: 32,
      sha384: 48,
      sha512: 64,
      rmd160: 20,
      ripemd160: 20,
    };
  function b(M, S, A) {
    var k = p(M),
      P = M === "sha512" || M === "sha384" ? 128 : 64;
    S.length > P ? (S = k(S)) : S.length < P && (S = i.concat([S, v], P));
    for (var B = i.allocUnsafe(P + g[M]), T = i.allocUnsafe(P + g[M]), F = 0; F < P; F++)
      (B[F] = S[F] ^ 54), (T[F] = S[F] ^ 92);
    var O = i.allocUnsafe(P + A + 4);
    B.copy(O, 0, 0, P),
      (this.ipad1 = O),
      (this.ipad2 = B),
      (this.opad = T),
      (this.alg = M),
      (this.blocksize = P),
      (this.hash = k),
      (this.size = g[M]);
  }
  b.prototype.run = function (M, S) {
    M.copy(S, this.blocksize);
    var A = this.hash(S);
    return A.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function p(M) {
    function S(k) {
      return n(M).update(k).digest();
    }
    function A(k) {
      return new e().update(k).digest();
    }
    return M === "rmd160" || M === "ripemd160" ? A : M === "md5" ? t : S;
  }
  function _(M, S, A, k, P) {
    l(A, k), (M = c(M, a, "Password")), (S = c(S, a, "Salt")), (P = P || "sha1");
    var B = new b(P, M, S.length),
      T = i.allocUnsafe(k),
      F = i.allocUnsafe(S.length + 4);
    S.copy(F, 0, 0, S.length);
    for (var O = 0, $ = g[P], J = Math.ceil(k / $), he = 1; he <= J; he++) {
      F.writeUInt32BE(he, S.length);
      for (var de = B.run(F, B.ipad1), ne = de, Ae = 1; Ae < A; Ae++) {
        ne = B.run(ne, B.ipad2);
        for (var x = 0; x < $; x++) de[x] ^= ne[x];
      }
      de.copy(T, O), (O += $);
    }
    return T;
  }
  return (Xh = _), Xh;
}
var ed, Pg;
function l9() {
  if (Pg) return ed;
  Pg = 1;
  var t = zt().Buffer,
    e = mw(),
    n = vw(),
    i = yw(),
    l = gw(),
    a,
    c = mt.crypto && mt.crypto.subtle,
    v = {
      sha: "SHA-1",
      "sha-1": "SHA-1",
      sha1: "SHA-1",
      sha256: "SHA-256",
      "sha-256": "SHA-256",
      sha384: "SHA-384",
      "sha-384": "SHA-384",
      "sha-512": "SHA-512",
      sha512: "SHA-512",
    },
    g = [];
  function b(A) {
    if ((mt.process && !mt.process.browser) || !c || !c.importKey || !c.deriveBits)
      return Promise.resolve(!1);
    if (g[A] !== void 0) return g[A];
    a = a || t.alloc(8);
    var k = M(a, a, 10, 128, A)
      .then(function () {
        return !0;
      })
      .catch(function () {
        return !1;
      });
    return (g[A] = k), k;
  }
  var p;
  function _() {
    return (
      p ||
      (mt.process && mt.process.nextTick
        ? (p = mt.process.nextTick)
        : mt.queueMicrotask
        ? (p = mt.queueMicrotask)
        : mt.setImmediate
        ? (p = mt.setImmediate)
        : (p = mt.setTimeout),
      p)
    );
  }
  function M(A, k, P, B, T) {
    return c
      .importKey("raw", A, { name: "PBKDF2" }, !1, ["deriveBits"])
      .then(function (F) {
        return c.deriveBits(
          {
            name: "PBKDF2",
            salt: k,
            iterations: P,
            hash: {
              name: T,
            },
          },
          F,
          B << 3
        );
      })
      .then(function (F) {
        return t.from(F);
      });
  }
  function S(A, k) {
    A.then(
      function (P) {
        _()(function () {
          k(null, P);
        });
      },
      function (P) {
        _()(function () {
          k(P);
        });
      }
    );
  }
  return (
    (ed = function (A, k, P, B, T, F) {
      typeof T == "function" && ((F = T), (T = void 0)), (T = T || "sha1");
      var O = v[T.toLowerCase()];
      if (!O || typeof mt.Promise != "function") {
        _()(function () {
          var $;
          try {
            $ = i(A, k, P, B, T);
          } catch (J) {
            return F(J);
          }
          F(null, $);
        });
        return;
      }
      if ((e(P, B), (A = l(A, n, "Password")), (k = l(k, n, "Salt")), typeof F != "function"))
        throw new Error("No callback provided to pbkdf2");
      S(
        b(O).then(function ($) {
          return $ ? M(A, k, P, B, O) : i(A, k, P, B, T);
        }),
        F
      );
    }),
    ed
  );
}
var Rg;
function bw() {
  return Rg || ((Rg = 1), (Yf.pbkdf2 = l9()), (Yf.pbkdf2Sync = yw())), Yf;
}
var pn = {},
  ca = {},
  nn = {},
  Ig;
function ww() {
  if (Ig) return nn;
  (Ig = 1),
    (nn.readUInt32BE = function (l, a) {
      var c = (l[0 + a] << 24) | (l[1 + a] << 16) | (l[2 + a] << 8) | l[3 + a];
      return c >>> 0;
    }),
    (nn.writeUInt32BE = function (l, a, c) {
      (l[0 + c] = a >>> 24),
        (l[1 + c] = (a >>> 16) & 255),
        (l[2 + c] = (a >>> 8) & 255),
        (l[3 + c] = a & 255);
    }),
    (nn.ip = function (l, a, c, v) {
      for (var g = 0, b = 0, p = 6; p >= 0; p -= 2) {
        for (var _ = 0; _ <= 24; _ += 8) (g <<= 1), (g |= (a >>> (_ + p)) & 1);
        for (var _ = 0; _ <= 24; _ += 8) (g <<= 1), (g |= (l >>> (_ + p)) & 1);
      }
      for (var p = 6; p >= 0; p -= 2) {
        for (var _ = 1; _ <= 25; _ += 8) (b <<= 1), (b |= (a >>> (_ + p)) & 1);
        for (var _ = 1; _ <= 25; _ += 8) (b <<= 1), (b |= (l >>> (_ + p)) & 1);
      }
      (c[v + 0] = g >>> 0), (c[v + 1] = b >>> 0);
    }),
    (nn.rip = function (l, a, c, v) {
      for (var g = 0, b = 0, p = 0; p < 4; p++)
        for (var _ = 24; _ >= 0; _ -= 8)
          (g <<= 1), (g |= (a >>> (_ + p)) & 1), (g <<= 1), (g |= (l >>> (_ + p)) & 1);
      for (var p = 4; p < 8; p++)
        for (var _ = 24; _ >= 0; _ -= 8)
          (b <<= 1), (b |= (a >>> (_ + p)) & 1), (b <<= 1), (b |= (l >>> (_ + p)) & 1);
      (c[v + 0] = g >>> 0), (c[v + 1] = b >>> 0);
    }),
    (nn.pc1 = function (l, a, c, v) {
      for (var g = 0, b = 0, p = 7; p >= 5; p--) {
        for (var _ = 0; _ <= 24; _ += 8) (g <<= 1), (g |= (a >> (_ + p)) & 1);
        for (var _ = 0; _ <= 24; _ += 8) (g <<= 1), (g |= (l >> (_ + p)) & 1);
      }
      for (var _ = 0; _ <= 24; _ += 8) (g <<= 1), (g |= (a >> (_ + p)) & 1);
      for (var p = 1; p <= 3; p++) {
        for (var _ = 0; _ <= 24; _ += 8) (b <<= 1), (b |= (a >> (_ + p)) & 1);
        for (var _ = 0; _ <= 24; _ += 8) (b <<= 1), (b |= (l >> (_ + p)) & 1);
      }
      for (var _ = 0; _ <= 24; _ += 8) (b <<= 1), (b |= (l >> (_ + p)) & 1);
      (c[v + 0] = g >>> 0), (c[v + 1] = b >>> 0);
    }),
    (nn.r28shl = function (l, a) {
      return ((l << a) & 268435455) | (l >>> (28 - a));
    });
  var t = [
    // inL => outL
    14, 11, 17, 4, 27, 23, 25, 0, 13, 22, 7, 18, 5, 9, 16, 24, 2, 20, 12, 21, 1, 8, 15, 26,
    // inR => outR
    15, 4, 25, 19, 9, 1, 26, 16, 5, 11, 23, 8, 12, 7, 17, 0, 22, 3, 10, 14, 6, 20, 27, 24,
  ];
  (nn.pc2 = function (l, a, c, v) {
    for (var g = 0, b = 0, p = t.length >>> 1, _ = 0; _ < p; _++)
      (g <<= 1), (g |= (l >>> t[_]) & 1);
    for (var _ = p; _ < t.length; _++) (b <<= 1), (b |= (a >>> t[_]) & 1);
    (c[v + 0] = g >>> 0), (c[v + 1] = b >>> 0);
  }),
    (nn.expand = function (l, a, c) {
      var v = 0,
        g = 0;
      v = ((l & 1) << 5) | (l >>> 27);
      for (var b = 23; b >= 15; b -= 4) (v <<= 6), (v |= (l >>> b) & 63);
      for (var b = 11; b >= 3; b -= 4) (g |= (l >>> b) & 63), (g <<= 6);
      (g |= ((l & 31) << 1) | (l >>> 31)), (a[c + 0] = v >>> 0), (a[c + 1] = g >>> 0);
    });
  var e = [
    14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1, 3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5,
    0, 3, 7, 8, 4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7, 15, 5, 12, 11, 9, 3, 7, 14, 3,
    10, 10, 0, 5, 6, 0, 13, 15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14, 9, 12, 7, 0, 2, 1,
    13, 10, 12, 6, 0, 9, 5, 11, 10, 5, 0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2, 5, 11,
    8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9, 10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5,
    10, 1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1, 13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15,
    9, 3, 8, 0, 7, 11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12, 7, 13, 13, 8, 14, 11, 3,
    5, 0, 6, 6, 15, 9, 0, 10, 3, 1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9, 10, 3, 6, 15,
    9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8, 15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14, 2,
    14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1, 8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14,
    8, 9, 6, 4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13, 15, 6, 9, 15, 12, 0, 5, 9, 6,
    10, 3, 4, 0, 5, 14, 3, 12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5, 0, 6, 13, 1, 3, 13,
    4, 14, 14, 0, 7, 11, 5, 3, 11, 8, 9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10, 7, 11,
    0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13, 4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1,
    13, 10, 3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6, 1, 6, 4, 11, 11, 13, 13, 8, 12, 1,
    3, 4, 7, 10, 14, 7, 10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12, 13, 1, 2, 15, 8, 13, 4,
    8, 6, 10, 15, 3, 11, 7, 1, 4, 10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2, 7, 2, 11, 1,
    4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13, 0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11,
  ];
  nn.substitute = function (l, a) {
    for (var c = 0, v = 0; v < 4; v++) {
      var g = (l >>> (18 - v * 6)) & 63,
        b = e[v * 64 + g];
      (c <<= 4), (c |= b);
    }
    for (var v = 0; v < 4; v++) {
      var g = (a >>> (18 - v * 6)) & 63,
        b = e[4 * 64 + v * 64 + g];
      (c <<= 4), (c |= b);
    }
    return c >>> 0;
  };
  var n = [
    16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22, 30, 24, 8, 18, 0, 5, 29, 23, 13, 19,
    2, 26, 10, 21, 28, 7,
  ];
  return (
    (nn.permute = function (l) {
      for (var a = 0, c = 0; c < n.length; c++) (a <<= 1), (a |= (l >>> n[c]) & 1);
      return a >>> 0;
    }),
    (nn.padSplit = function (l, a, c) {
      for (var v = l.toString(2); v.length < a; ) v = "0" + v;
      for (var g = [], b = 0; b < a; b += c) g.push(v.slice(b, b + c));
      return g.join(" ");
    }),
    nn
  );
}
var td, Og;
function En() {
  if (Og) return td;
  (Og = 1), (td = t);
  function t(e, n) {
    if (!e) throw new Error(n || "Assertion failed");
  }
  return (
    (t.equal = function (n, i, l) {
      if (n != i) throw new Error(l || "Assertion failed: " + n + " != " + i);
    }),
    td
  );
}
var rd, Ug;
function E1() {
  if (Ug) return rd;
  Ug = 1;
  var t = En();
  function e(n) {
    (this.options = n),
      (this.type = this.options.type),
      (this.blockSize = 8),
      this._init(),
      (this.buffer = new Array(this.blockSize)),
      (this.bufferOff = 0),
      (this.padding = n.padding !== !1);
  }
  return (
    (rd = e),
    (e.prototype._init = function () {}),
    (e.prototype.update = function (i) {
      return i.length === 0
        ? []
        : this.type === "decrypt"
        ? this._updateDecrypt(i)
        : this._updateEncrypt(i);
    }),
    (e.prototype._buffer = function (i, l) {
      for (var a = Math.min(this.buffer.length - this.bufferOff, i.length - l), c = 0; c < a; c++)
        this.buffer[this.bufferOff + c] = i[l + c];
      return (this.bufferOff += a), a;
    }),
    (e.prototype._flushBuffer = function (i, l) {
      return this._update(this.buffer, 0, i, l), (this.bufferOff = 0), this.blockSize;
    }),
    (e.prototype._updateEncrypt = function (i) {
      var l = 0,
        a = 0,
        c = ((this.bufferOff + i.length) / this.blockSize) | 0,
        v = new Array(c * this.blockSize);
      this.bufferOff !== 0 &&
        ((l += this._buffer(i, l)),
        this.bufferOff === this.buffer.length && (a += this._flushBuffer(v, a)));
      for (var g = i.length - ((i.length - l) % this.blockSize); l < g; l += this.blockSize)
        this._update(i, l, v, a), (a += this.blockSize);
      for (; l < i.length; l++, this.bufferOff++) this.buffer[this.bufferOff] = i[l];
      return v;
    }),
    (e.prototype._updateDecrypt = function (i) {
      for (
        var l = 0,
          a = 0,
          c = Math.ceil((this.bufferOff + i.length) / this.blockSize) - 1,
          v = new Array(c * this.blockSize);
        c > 0;
        c--
      )
        (l += this._buffer(i, l)), (a += this._flushBuffer(v, a));
      return (l += this._buffer(i, l)), v;
    }),
    (e.prototype.final = function (i) {
      var l;
      i && (l = this.update(i));
      var a;
      return (
        this.type === "encrypt" ? (a = this._finalEncrypt()) : (a = this._finalDecrypt()),
        l ? l.concat(a) : a
      );
    }),
    (e.prototype._pad = function (i, l) {
      if (l === 0) return !1;
      for (; l < i.length; ) i[l++] = 0;
      return !0;
    }),
    (e.prototype._finalEncrypt = function () {
      if (!this._pad(this.buffer, this.bufferOff)) return [];
      var i = new Array(this.blockSize);
      return this._update(this.buffer, 0, i, 0), i;
    }),
    (e.prototype._unpad = function (i) {
      return i;
    }),
    (e.prototype._finalDecrypt = function () {
      t.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
      var i = new Array(this.blockSize);
      return this._flushBuffer(i, 0), this._unpad(i);
    }),
    rd
  );
}
var nd, Ng;
function _w() {
  if (Ng) return nd;
  Ng = 1;
  var t = En(),
    e = It(),
    n = ww(),
    i = E1();
  function l() {
    (this.tmp = new Array(2)), (this.keys = null);
  }
  function a(v) {
    i.call(this, v);
    var g = new l();
    (this._desState = g), this.deriveKeys(g, v.key);
  }
  e(a, i),
    (nd = a),
    (a.create = function (g) {
      return new a(g);
    });
  var c = [1, 1, 2, 2, 2, 2, 2, 2, 1, 2, 2, 2, 2, 2, 2, 1];
  return (
    (a.prototype.deriveKeys = function (g, b) {
      (g.keys = new Array(16 * 2)), t.equal(b.length, this.blockSize, "Invalid key length");
      var p = n.readUInt32BE(b, 0),
        _ = n.readUInt32BE(b, 4);
      n.pc1(p, _, g.tmp, 0), (p = g.tmp[0]), (_ = g.tmp[1]);
      for (var M = 0; M < g.keys.length; M += 2) {
        var S = c[M >>> 1];
        (p = n.r28shl(p, S)), (_ = n.r28shl(_, S)), n.pc2(p, _, g.keys, M);
      }
    }),
    (a.prototype._update = function (g, b, p, _) {
      var M = this._desState,
        S = n.readUInt32BE(g, b),
        A = n.readUInt32BE(g, b + 4);
      n.ip(S, A, M.tmp, 0),
        (S = M.tmp[0]),
        (A = M.tmp[1]),
        this.type === "encrypt"
          ? this._encrypt(M, S, A, M.tmp, 0)
          : this._decrypt(M, S, A, M.tmp, 0),
        (S = M.tmp[0]),
        (A = M.tmp[1]),
        n.writeUInt32BE(p, S, _),
        n.writeUInt32BE(p, A, _ + 4);
    }),
    (a.prototype._pad = function (g, b) {
      if (this.padding === !1) return !1;
      for (var p = g.length - b, _ = b; _ < g.length; _++) g[_] = p;
      return !0;
    }),
    (a.prototype._unpad = function (g) {
      if (this.padding === !1) return g;
      for (var b = g[g.length - 1], p = g.length - b; p < g.length; p++) t.equal(g[p], b);
      return g.slice(0, g.length - b);
    }),
    (a.prototype._encrypt = function (g, b, p, _, M) {
      for (var S = b, A = p, k = 0; k < g.keys.length; k += 2) {
        var P = g.keys[k],
          B = g.keys[k + 1];
        n.expand(A, g.tmp, 0), (P ^= g.tmp[0]), (B ^= g.tmp[1]);
        var T = n.substitute(P, B),
          F = n.permute(T),
          O = A;
        (A = (S ^ F) >>> 0), (S = O);
      }
      n.rip(A, S, _, M);
    }),
    (a.prototype._decrypt = function (g, b, p, _, M) {
      for (var S = p, A = b, k = g.keys.length - 2; k >= 0; k -= 2) {
        var P = g.keys[k],
          B = g.keys[k + 1];
        n.expand(S, g.tmp, 0), (P ^= g.tmp[0]), (B ^= g.tmp[1]);
        var T = n.substitute(P, B),
          F = n.permute(T),
          O = S;
        (S = (A ^ F) >>> 0), (A = O);
      }
      n.rip(S, A, _, M);
    }),
    nd
  );
}
var id = {},
  Dg;
function u9() {
  if (Dg) return id;
  Dg = 1;
  var t = En(),
    e = It(),
    n = {};
  function i(a) {
    t.equal(a.length, 8, "Invalid IV length"), (this.iv = new Array(8));
    for (var c = 0; c < this.iv.length; c++) this.iv[c] = a[c];
  }
  function l(a) {
    function c(p) {
      a.call(this, p), this._cbcInit();
    }
    e(c, a);
    for (var v = Object.keys(n), g = 0; g < v.length; g++) {
      var b = v[g];
      c.prototype[b] = n[b];
    }
    return (
      (c.create = function (_) {
        return new c(_);
      }),
      c
    );
  }
  return (
    (id.instantiate = l),
    (n._cbcInit = function () {
      var c = new i(this.options.iv);
      this._cbcState = c;
    }),
    (n._update = function (c, v, g, b) {
      var p = this._cbcState,
        _ = this.constructor.super_.prototype,
        M = p.iv;
      if (this.type === "encrypt") {
        for (var S = 0; S < this.blockSize; S++) M[S] ^= c[v + S];
        _._update.call(this, M, 0, g, b);
        for (var S = 0; S < this.blockSize; S++) M[S] = g[b + S];
      } else {
        _._update.call(this, c, v, g, b);
        for (var S = 0; S < this.blockSize; S++) g[b + S] ^= M[S];
        for (var S = 0; S < this.blockSize; S++) M[S] = c[v + S];
      }
    }),
    id
  );
}
var ad, Lg;
function c9() {
  if (Lg) return ad;
  Lg = 1;
  var t = En(),
    e = It(),
    n = E1(),
    i = _w();
  function l(c, v) {
    t.equal(v.length, 24, "Invalid key length");
    var g = v.slice(0, 8),
      b = v.slice(8, 16),
      p = v.slice(16, 24);
    c === "encrypt"
      ? (this.ciphers = [
          i.create({ type: "encrypt", key: g }),
          i.create({ type: "decrypt", key: b }),
          i.create({ type: "encrypt", key: p }),
        ])
      : (this.ciphers = [
          i.create({ type: "decrypt", key: p }),
          i.create({ type: "encrypt", key: b }),
          i.create({ type: "decrypt", key: g }),
        ]);
  }
  function a(c) {
    n.call(this, c);
    var v = new l(this.type, this.options.key);
    this._edeState = v;
  }
  return (
    e(a, n),
    (ad = a),
    (a.create = function (v) {
      return new a(v);
    }),
    (a.prototype._update = function (v, g, b, p) {
      var _ = this._edeState;
      _.ciphers[0]._update(v, g, b, p),
        _.ciphers[1]._update(b, p, b, p),
        _.ciphers[2]._update(b, p, b, p);
    }),
    (a.prototype._pad = i.prototype._pad),
    (a.prototype._unpad = i.prototype._unpad),
    ad
  );
}
var Fg;
function h9() {
  return (
    Fg ||
      ((Fg = 1),
      (ca.utils = ww()),
      (ca.Cipher = E1()),
      (ca.DES = _w()),
      (ca.CBC = u9()),
      (ca.EDE = c9())),
    ca
  );
}
var sd, qg;
function d9() {
  if (qg) return sd;
  qg = 1;
  var t = fa(),
    e = h9(),
    n = It(),
    i = zt().Buffer,
    l = {
      "des-ede3-cbc": e.CBC.instantiate(e.EDE),
      "des-ede3": e.EDE,
      "des-ede-cbc": e.CBC.instantiate(e.EDE),
      "des-ede": e.EDE,
      "des-cbc": e.CBC.instantiate(e.DES),
      "des-ecb": e.DES,
    };
  (l.des = l["des-cbc"]), (l.des3 = l["des-ede3-cbc"]), (sd = a), n(a, t);
  function a(c) {
    t.call(this);
    var v = c.mode.toLowerCase(),
      g = l[v],
      b;
    c.decrypt ? (b = "decrypt") : (b = "encrypt");
    var p = c.key;
    i.isBuffer(p) || (p = i.from(p)),
      (v === "des-ede" || v === "des-ede-cbc") && (p = i.concat([p, p.slice(0, 8)]));
    var _ = c.iv;
    i.isBuffer(_) || (_ = i.from(_)),
      (this._des = g.create({
        key: p,
        iv: _,
        type: b,
      }));
  }
  return (
    (a.prototype._update = function (c) {
      return i.from(this._des.update(c));
    }),
    (a.prototype._final = function () {
      return i.from(this._des.final());
    }),
    sd
  );
}
var mn = {},
  Jf = {},
  Qf = {},
  zg;
function p9() {
  return (
    zg ||
      ((zg = 1),
      (Qf.encrypt = function (t, e) {
        return t._cipher.encryptBlock(e);
      }),
      (Qf.decrypt = function (t, e) {
        return t._cipher.decryptBlock(e);
      })),
    Qf
  );
}
var Xf = {},
  od,
  jg;
function kf() {
  return (
    jg ||
      ((jg = 1),
      (od = function (e, n) {
        for (var i = Math.min(e.length, n.length), l = new Qe(i), a = 0; a < i; ++a)
          l[a] = e[a] ^ n[a];
        return l;
      })),
    od
  );
}
var $g;
function m9() {
  if ($g) return Xf;
  $g = 1;
  var t = kf();
  return (
    (Xf.encrypt = function (e, n) {
      var i = t(n, e._prev);
      return (e._prev = e._cipher.encryptBlock(i)), e._prev;
    }),
    (Xf.decrypt = function (e, n) {
      var i = e._prev;
      e._prev = n;
      var l = e._cipher.decryptBlock(n);
      return t(l, i);
    }),
    Xf
  );
}
var fd = {},
  Hg;
function v9() {
  if (Hg) return fd;
  Hg = 1;
  var t = zt().Buffer,
    e = kf();
  function n(i, l, a) {
    var c = l.length,
      v = e(l, i._cache);
    return (i._cache = i._cache.slice(c)), (i._prev = t.concat([i._prev, a ? l : v])), v;
  }
  return (
    (fd.encrypt = function (i, l, a) {
      for (var c = t.allocUnsafe(0), v; l.length; )
        if (
          (i._cache.length === 0 &&
            ((i._cache = i._cipher.encryptBlock(i._prev)), (i._prev = t.allocUnsafe(0))),
          i._cache.length <= l.length)
        )
          (v = i._cache.length), (c = t.concat([c, n(i, l.slice(0, v), a)])), (l = l.slice(v));
        else {
          c = t.concat([c, n(i, l, a)]);
          break;
        }
      return c;
    }),
    fd
  );
}
var ld = {},
  Vg;
function g9() {
  if (Vg) return ld;
  Vg = 1;
  var t = zt().Buffer;
  function e(n, i, l) {
    var a = n._cipher.encryptBlock(n._prev),
      c = a[0] ^ i;
    return (n._prev = t.concat([n._prev.slice(1), t.from([l ? i : c])])), c;
  }
  return (
    (ld.encrypt = function (n, i, l) {
      for (var a = i.length, c = t.allocUnsafe(a), v = -1; ++v < a; ) c[v] = e(n, i[v], l);
      return c;
    }),
    ld
  );
}
var ud = {},
  Wg;
function y9() {
  if (Wg) return ud;
  Wg = 1;
  var t = zt().Buffer;
  function e(i, l, a) {
    for (var c, v = -1, g = 8, b = 0, p, _; ++v < g; )
      (c = i._cipher.encryptBlock(i._prev)),
        (p = l & (1 << (7 - v)) ? 128 : 0),
        (_ = c[0] ^ p),
        (b += (_ & 128) >> v % 8),
        (i._prev = n(i._prev, a ? p : _));
    return b;
  }
  function n(i, l) {
    var a = i.length,
      c = -1,
      v = t.allocUnsafe(i.length);
    for (i = t.concat([i, t.from([l])]); ++c < a; ) v[c] = (i[c] << 1) | (i[c + 1] >> 7);
    return v;
  }
  return (
    (ud.encrypt = function (i, l, a) {
      for (var c = l.length, v = t.allocUnsafe(c), g = -1; ++g < c; ) v[g] = e(i, l[g], a);
      return v;
    }),
    ud
  );
}
var cd = {},
  Kg;
function b9() {
  if (Kg) return cd;
  Kg = 1;
  var t = kf();
  function e(n) {
    return (n._prev = n._cipher.encryptBlock(n._prev)), n._prev;
  }
  return (
    (cd.encrypt = function (n, i) {
      for (; n._cache.length < i.length; ) n._cache = Qe.concat([n._cache, e(n)]);
      var l = n._cache.slice(0, i.length);
      return (n._cache = n._cache.slice(i.length)), t(i, l);
    }),
    cd
  );
}
var hd = {},
  dd,
  Zg;
function xw() {
  if (Zg) return dd;
  Zg = 1;
  function t(e) {
    for (var n = e.length, i; n--; )
      if (((i = e.readUInt8(n)), i === 255)) e.writeUInt8(0, n);
      else {
        i++, e.writeUInt8(i, n);
        break;
      }
  }
  return (dd = t), dd;
}
var Gg;
function Yg() {
  if (Gg) return hd;
  Gg = 1;
  var t = kf(),
    e = zt().Buffer,
    n = xw();
  function i(a) {
    var c = a._cipher.encryptBlockRaw(a._prev);
    return n(a._prev), c;
  }
  var l = 16;
  return (
    (hd.encrypt = function (a, c) {
      var v = Math.ceil(c.length / l),
        g = a._cache.length;
      a._cache = e.concat([a._cache, e.allocUnsafe(v * l)]);
      for (var b = 0; b < v; b++) {
        var p = i(a),
          _ = g + b * l;
        a._cache.writeUInt32BE(p[0], _ + 0),
          a._cache.writeUInt32BE(p[1], _ + 4),
          a._cache.writeUInt32BE(p[2], _ + 8),
          a._cache.writeUInt32BE(p[3], _ + 12);
      }
      var M = a._cache.slice(0, c.length);
      return (a._cache = a._cache.slice(c.length)), t(c, M);
    }),
    hd
  );
}
const w9 = {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block",
  },
  _9 = {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block",
  },
  x9 = {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block",
  },
  Mw = {
    "aes-128-ecb": {
      cipher: "AES",
      key: 128,
      iv: 0,
      mode: "ECB",
      type: "block",
    },
    "aes-192-ecb": {
      cipher: "AES",
      key: 192,
      iv: 0,
      mode: "ECB",
      type: "block",
    },
    "aes-256-ecb": {
      cipher: "AES",
      key: 256,
      iv: 0,
      mode: "ECB",
      type: "block",
    },
    "aes-128-cbc": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "CBC",
      type: "block",
    },
    "aes-192-cbc": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "CBC",
      type: "block",
    },
    "aes-256-cbc": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "CBC",
      type: "block",
    },
    aes128: w9,
    aes192: _9,
    aes256: x9,
    "aes-128-cfb": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "CFB",
      type: "stream",
    },
    "aes-192-cfb": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "CFB",
      type: "stream",
    },
    "aes-256-cfb": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "CFB",
      type: "stream",
    },
    "aes-128-cfb8": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "CFB8",
      type: "stream",
    },
    "aes-192-cfb8": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "CFB8",
      type: "stream",
    },
    "aes-256-cfb8": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "CFB8",
      type: "stream",
    },
    "aes-128-cfb1": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "CFB1",
      type: "stream",
    },
    "aes-192-cfb1": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "CFB1",
      type: "stream",
    },
    "aes-256-cfb1": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "CFB1",
      type: "stream",
    },
    "aes-128-ofb": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "OFB",
      type: "stream",
    },
    "aes-192-ofb": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "OFB",
      type: "stream",
    },
    "aes-256-ofb": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "OFB",
      type: "stream",
    },
    "aes-128-ctr": {
      cipher: "AES",
      key: 128,
      iv: 16,
      mode: "CTR",
      type: "stream",
    },
    "aes-192-ctr": {
      cipher: "AES",
      key: 192,
      iv: 16,
      mode: "CTR",
      type: "stream",
    },
    "aes-256-ctr": {
      cipher: "AES",
      key: 256,
      iv: 16,
      mode: "CTR",
      type: "stream",
    },
    "aes-128-gcm": {
      cipher: "AES",
      key: 128,
      iv: 12,
      mode: "GCM",
      type: "auth",
    },
    "aes-192-gcm": {
      cipher: "AES",
      key: 192,
      iv: 12,
      mode: "GCM",
      type: "auth",
    },
    "aes-256-gcm": {
      cipher: "AES",
      key: 256,
      iv: 12,
      mode: "GCM",
      type: "auth",
    },
  };
var pd, Jg;
function A1() {
  if (Jg) return pd;
  Jg = 1;
  var t = {
      ECB: p9(),
      CBC: m9(),
      CFB: v9(),
      CFB8: g9(),
      CFB1: y9(),
      OFB: b9(),
      CTR: Yg(),
      GCM: Yg(),
    },
    e = Mw;
  for (var n in e) e[n].module = t[e[n].mode];
  return (pd = e), pd;
}
var md = {},
  Qg;
function Iu() {
  if (Qg) return md;
  Qg = 1;
  var t = zt().Buffer;
  function e(v) {
    t.isBuffer(v) || (v = t.from(v));
    for (var g = (v.length / 4) | 0, b = new Array(g), p = 0; p < g; p++)
      b[p] = v.readUInt32BE(p * 4);
    return b;
  }
  function n(v) {
    for (var g = 0; g < v.length; v++) v[g] = 0;
  }
  function i(v, g, b, p, _) {
    for (
      var M = b[0],
        S = b[1],
        A = b[2],
        k = b[3],
        P = v[0] ^ g[0],
        B = v[1] ^ g[1],
        T = v[2] ^ g[2],
        F = v[3] ^ g[3],
        O,
        $,
        J,
        he,
        de = 4,
        ne = 1;
      ne < _;
      ne++
    )
      (O = M[P >>> 24] ^ S[(B >>> 16) & 255] ^ A[(T >>> 8) & 255] ^ k[F & 255] ^ g[de++]),
        ($ = M[B >>> 24] ^ S[(T >>> 16) & 255] ^ A[(F >>> 8) & 255] ^ k[P & 255] ^ g[de++]),
        (J = M[T >>> 24] ^ S[(F >>> 16) & 255] ^ A[(P >>> 8) & 255] ^ k[B & 255] ^ g[de++]),
        (he = M[F >>> 24] ^ S[(P >>> 16) & 255] ^ A[(B >>> 8) & 255] ^ k[T & 255] ^ g[de++]),
        (P = O),
        (B = $),
        (T = J),
        (F = he);
    return (
      (O =
        ((p[P >>> 24] << 24) |
          (p[(B >>> 16) & 255] << 16) |
          (p[(T >>> 8) & 255] << 8) |
          p[F & 255]) ^
        g[de++]),
      ($ =
        ((p[B >>> 24] << 24) |
          (p[(T >>> 16) & 255] << 16) |
          (p[(F >>> 8) & 255] << 8) |
          p[P & 255]) ^
        g[de++]),
      (J =
        ((p[T >>> 24] << 24) |
          (p[(F >>> 16) & 255] << 16) |
          (p[(P >>> 8) & 255] << 8) |
          p[B & 255]) ^
        g[de++]),
      (he =
        ((p[F >>> 24] << 24) |
          (p[(P >>> 16) & 255] << 16) |
          (p[(B >>> 8) & 255] << 8) |
          p[T & 255]) ^
        g[de++]),
      (O = O >>> 0),
      ($ = $ >>> 0),
      (J = J >>> 0),
      (he = he >>> 0),
      [O, $, J, he]
    );
  }
  var l = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54],
    a = (function () {
      for (var v = new Array(256), g = 0; g < 256; g++)
        g < 128 ? (v[g] = g << 1) : (v[g] = (g << 1) ^ 283);
      for (
        var b = [], p = [], _ = [[], [], [], []], M = [[], [], [], []], S = 0, A = 0, k = 0;
        k < 256;
        ++k
      ) {
        var P = A ^ (A << 1) ^ (A << 2) ^ (A << 3) ^ (A << 4);
        (P = (P >>> 8) ^ (P & 255) ^ 99), (b[S] = P), (p[P] = S);
        var B = v[S],
          T = v[B],
          F = v[T],
          O = (v[P] * 257) ^ (P * 16843008);
        (_[0][S] = (O << 24) | (O >>> 8)),
          (_[1][S] = (O << 16) | (O >>> 16)),
          (_[2][S] = (O << 8) | (O >>> 24)),
          (_[3][S] = O),
          (O = (F * 16843009) ^ (T * 65537) ^ (B * 257) ^ (S * 16843008)),
          (M[0][P] = (O << 24) | (O >>> 8)),
          (M[1][P] = (O << 16) | (O >>> 16)),
          (M[2][P] = (O << 8) | (O >>> 24)),
          (M[3][P] = O),
          S === 0 ? (S = A = 1) : ((S = B ^ v[v[v[F ^ B]]]), (A ^= v[v[A]]));
      }
      return {
        SBOX: b,
        INV_SBOX: p,
        SUB_MIX: _,
        INV_SUB_MIX: M,
      };
    })();
  function c(v) {
    (this._key = e(v)), this._reset();
  }
  return (
    (c.blockSize = 4 * 4),
    (c.keySize = 256 / 8),
    (c.prototype.blockSize = c.blockSize),
    (c.prototype.keySize = c.keySize),
    (c.prototype._reset = function () {
      for (var v = this._key, g = v.length, b = g + 6, p = (b + 1) * 4, _ = [], M = 0; M < g; M++)
        _[M] = v[M];
      for (M = g; M < p; M++) {
        var S = _[M - 1];
        M % g === 0
          ? ((S = (S << 8) | (S >>> 24)),
            (S =
              (a.SBOX[S >>> 24] << 24) |
              (a.SBOX[(S >>> 16) & 255] << 16) |
              (a.SBOX[(S >>> 8) & 255] << 8) |
              a.SBOX[S & 255]),
            (S ^= l[(M / g) | 0] << 24))
          : g > 6 &&
            M % g === 4 &&
            (S =
              (a.SBOX[S >>> 24] << 24) |
              (a.SBOX[(S >>> 16) & 255] << 16) |
              (a.SBOX[(S >>> 8) & 255] << 8) |
              a.SBOX[S & 255]),
          (_[M] = _[M - g] ^ S);
      }
      for (var A = [], k = 0; k < p; k++) {
        var P = p - k,
          B = _[P - (k % 4 ? 0 : 4)];
        k < 4 || P <= 4
          ? (A[k] = B)
          : (A[k] =
              a.INV_SUB_MIX[0][a.SBOX[B >>> 24]] ^
              a.INV_SUB_MIX[1][a.SBOX[(B >>> 16) & 255]] ^
              a.INV_SUB_MIX[2][a.SBOX[(B >>> 8) & 255]] ^
              a.INV_SUB_MIX[3][a.SBOX[B & 255]]);
      }
      (this._nRounds = b), (this._keySchedule = _), (this._invKeySchedule = A);
    }),
    (c.prototype.encryptBlockRaw = function (v) {
      return (v = e(v)), i(v, this._keySchedule, a.SUB_MIX, a.SBOX, this._nRounds);
    }),
    (c.prototype.encryptBlock = function (v) {
      var g = this.encryptBlockRaw(v),
        b = t.allocUnsafe(16);
      return (
        b.writeUInt32BE(g[0], 0),
        b.writeUInt32BE(g[1], 4),
        b.writeUInt32BE(g[2], 8),
        b.writeUInt32BE(g[3], 12),
        b
      );
    }),
    (c.prototype.decryptBlock = function (v) {
      v = e(v);
      var g = v[1];
      (v[1] = v[3]), (v[3] = g);
      var b = i(v, this._invKeySchedule, a.INV_SUB_MIX, a.INV_SBOX, this._nRounds),
        p = t.allocUnsafe(16);
      return (
        p.writeUInt32BE(b[0], 0),
        p.writeUInt32BE(b[3], 4),
        p.writeUInt32BE(b[2], 8),
        p.writeUInt32BE(b[1], 12),
        p
      );
    }),
    (c.prototype.scrub = function () {
      n(this._keySchedule), n(this._invKeySchedule), n(this._key);
    }),
    (md.AES = c),
    md
  );
}
var vd, Xg;
function M9() {
  if (Xg) return vd;
  Xg = 1;
  var t = zt().Buffer,
    e = t.alloc(16, 0);
  function n(a) {
    return [a.readUInt32BE(0), a.readUInt32BE(4), a.readUInt32BE(8), a.readUInt32BE(12)];
  }
  function i(a) {
    var c = t.allocUnsafe(16);
    return (
      c.writeUInt32BE(a[0] >>> 0, 0),
      c.writeUInt32BE(a[1] >>> 0, 4),
      c.writeUInt32BE(a[2] >>> 0, 8),
      c.writeUInt32BE(a[3] >>> 0, 12),
      c
    );
  }
  function l(a) {
    (this.h = a), (this.state = t.alloc(16, 0)), (this.cache = t.allocUnsafe(0));
  }
  return (
    (l.prototype.ghash = function (a) {
      for (var c = -1; ++c < a.length; ) this.state[c] ^= a[c];
      this._multiply();
    }),
    (l.prototype._multiply = function () {
      for (var a = n(this.h), c = [0, 0, 0, 0], v, g, b, p = -1; ++p < 128; ) {
        for (
          g = (this.state[~~(p / 8)] & (1 << (7 - (p % 8)))) !== 0,
            g && ((c[0] ^= a[0]), (c[1] ^= a[1]), (c[2] ^= a[2]), (c[3] ^= a[3])),
            b = (a[3] & 1) !== 0,
            v = 3;
          v > 0;
          v--
        )
          a[v] = (a[v] >>> 1) | ((a[v - 1] & 1) << 31);
        (a[0] = a[0] >>> 1), b && (a[0] = a[0] ^ (225 << 24));
      }
      this.state = i(c);
    }),
    (l.prototype.update = function (a) {
      this.cache = t.concat([this.cache, a]);
      for (var c; this.cache.length >= 16; )
        (c = this.cache.slice(0, 16)), (this.cache = this.cache.slice(16)), this.ghash(c);
    }),
    (l.prototype.final = function (a, c) {
      return (
        this.cache.length && this.ghash(t.concat([this.cache, e], 16)),
        this.ghash(i([0, a, 0, c])),
        this.state
      );
    }),
    (vd = l),
    vd
  );
}
var gd, ey;
function Sw() {
  if (ey) return gd;
  ey = 1;
  var t = Iu(),
    e = zt().Buffer,
    n = fa(),
    i = It(),
    l = M9(),
    a = kf(),
    c = xw();
  function v(p, _) {
    var M = 0;
    p.length !== _.length && M++;
    for (var S = Math.min(p.length, _.length), A = 0; A < S; ++A) M += p[A] ^ _[A];
    return M;
  }
  function g(p, _, M) {
    if (_.length === 12)
      return (p._finID = e.concat([_, e.from([0, 0, 0, 1])])), e.concat([_, e.from([0, 0, 0, 2])]);
    var S = new l(M),
      A = _.length,
      k = A % 16;
    S.update(_), k && ((k = 16 - k), S.update(e.alloc(k, 0))), S.update(e.alloc(8, 0));
    var P = A * 8,
      B = e.alloc(8);
    B.writeUIntBE(P, 0, 8), S.update(B), (p._finID = S.state);
    var T = e.from(p._finID);
    return c(T), T;
  }
  function b(p, _, M, S) {
    n.call(this);
    var A = e.alloc(4, 0);
    this._cipher = new t.AES(_);
    var k = this._cipher.encryptBlock(A);
    (this._ghash = new l(k)),
      (M = g(this, M, k)),
      (this._prev = e.from(M)),
      (this._cache = e.allocUnsafe(0)),
      (this._secCache = e.allocUnsafe(0)),
      (this._decrypt = S),
      (this._alen = 0),
      (this._len = 0),
      (this._mode = p),
      (this._authTag = null),
      (this._called = !1);
  }
  return (
    i(b, n),
    (b.prototype._update = function (p) {
      if (!this._called && this._alen) {
        var _ = 16 - (this._alen % 16);
        _ < 16 && ((_ = e.alloc(_, 0)), this._ghash.update(_));
      }
      this._called = !0;
      var M = this._mode.encrypt(this, p);
      return (
        this._decrypt ? this._ghash.update(p) : this._ghash.update(M), (this._len += p.length), M
      );
    }),
    (b.prototype._final = function () {
      if (this._decrypt && !this._authTag)
        throw new Error("Unsupported state or unable to authenticate data");
      var p = a(
        this._ghash.final(this._alen * 8, this._len * 8),
        this._cipher.encryptBlock(this._finID)
      );
      if (this._decrypt && v(p, this._authTag))
        throw new Error("Unsupported state or unable to authenticate data");
      (this._authTag = p), this._cipher.scrub();
    }),
    (b.prototype.getAuthTag = function () {
      if (this._decrypt || !e.isBuffer(this._authTag))
        throw new Error("Attempting to get auth tag in unsupported state");
      return this._authTag;
    }),
    (b.prototype.setAuthTag = function (_) {
      if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
      this._authTag = _;
    }),
    (b.prototype.setAAD = function (_) {
      if (this._called) throw new Error("Attempting to set AAD in unsupported state");
      this._ghash.update(_), (this._alen += _.length);
    }),
    (gd = b),
    gd
  );
}
var yd, ty;
function Ew() {
  if (ty) return yd;
  ty = 1;
  var t = Iu(),
    e = zt().Buffer,
    n = fa(),
    i = It();
  function l(a, c, v, g) {
    n.call(this),
      (this._cipher = new t.AES(c)),
      (this._prev = e.from(v)),
      (this._cache = e.allocUnsafe(0)),
      (this._secCache = e.allocUnsafe(0)),
      (this._decrypt = g),
      (this._mode = a);
  }
  return (
    i(l, n),
    (l.prototype._update = function (a) {
      return this._mode.encrypt(this, a, this._decrypt);
    }),
    (l.prototype._final = function () {
      this._cipher.scrub();
    }),
    (yd = l),
    yd
  );
}
var bd, ry;
function Ou() {
  if (ry) return bd;
  ry = 1;
  var t = zt().Buffer,
    e = x1();
  function n(i, l, a, c) {
    if (
      (t.isBuffer(i) || (i = t.from(i, "binary")),
      l && (t.isBuffer(l) || (l = t.from(l, "binary")), l.length !== 8))
    )
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var v = a / 8, g = t.alloc(v), b = t.alloc(c || 0), p = t.alloc(0); v > 0 || c > 0; ) {
      var _ = new e();
      _.update(p), _.update(i), l && _.update(l), (p = _.digest());
      var M = 0;
      if (v > 0) {
        var S = g.length - v;
        (M = Math.min(v, p.length)), p.copy(g, S, 0, M), (v -= M);
      }
      if (M < p.length && c > 0) {
        var A = b.length - c,
          k = Math.min(c, p.length - M);
        p.copy(b, A, M, M + k), (c -= k);
      }
    }
    return p.fill(0), { key: g, iv: b };
  }
  return (bd = n), bd;
}
var ny;
function S9() {
  if (ny) return Jf;
  ny = 1;
  var t = A1(),
    e = Sw(),
    n = zt().Buffer,
    i = Ew(),
    l = fa(),
    a = Iu(),
    c = Ou(),
    v = It();
  function g(S, A, k) {
    l.call(this),
      (this._cache = new p()),
      (this._cipher = new a.AES(A)),
      (this._prev = n.from(k)),
      (this._mode = S),
      (this._autopadding = !0);
  }
  v(g, l),
    (g.prototype._update = function (S) {
      this._cache.add(S);
      for (var A, k, P = []; (A = this._cache.get()); )
        (k = this._mode.encrypt(this, A)), P.push(k);
      return n.concat(P);
    });
  var b = n.alloc(16, 16);
  (g.prototype._final = function () {
    var S = this._cache.flush();
    if (this._autopadding) return (S = this._mode.encrypt(this, S)), this._cipher.scrub(), S;
    if (!S.equals(b)) throw (this._cipher.scrub(), new Error("data not multiple of block length"));
  }),
    (g.prototype.setAutoPadding = function (S) {
      return (this._autopadding = !!S), this;
    });
  function p() {
    this.cache = n.allocUnsafe(0);
  }
  (p.prototype.add = function (S) {
    this.cache = n.concat([this.cache, S]);
  }),
    (p.prototype.get = function () {
      if (this.cache.length > 15) {
        var S = this.cache.slice(0, 16);
        return (this.cache = this.cache.slice(16)), S;
      }
      return null;
    }),
    (p.prototype.flush = function () {
      for (var S = 16 - this.cache.length, A = n.allocUnsafe(S), k = -1; ++k < S; )
        A.writeUInt8(S, k);
      return n.concat([this.cache, A]);
    });
  function _(S, A, k) {
    var P = t[S.toLowerCase()];
    if (!P) throw new TypeError("invalid suite type");
    if ((typeof A == "string" && (A = n.from(A)), A.length !== P.key / 8))
      throw new TypeError("invalid key length " + A.length);
    if ((typeof k == "string" && (k = n.from(k)), P.mode !== "GCM" && k.length !== P.iv))
      throw new TypeError("invalid iv length " + k.length);
    return P.type === "stream"
      ? new i(P.module, A, k)
      : P.type === "auth"
      ? new e(P.module, A, k)
      : new g(P.module, A, k);
  }
  function M(S, A) {
    var k = t[S.toLowerCase()];
    if (!k) throw new TypeError("invalid suite type");
    var P = c(A, !1, k.key, k.iv);
    return _(S, P.key, P.iv);
  }
  return (Jf.createCipheriv = _), (Jf.createCipher = M), Jf;
}
var el = {},
  iy;
function E9() {
  if (iy) return el;
  iy = 1;
  var t = Sw(),
    e = zt().Buffer,
    n = A1(),
    i = Ew(),
    l = fa(),
    a = Iu(),
    c = Ou(),
    v = It();
  function g(S, A, k) {
    l.call(this),
      (this._cache = new b()),
      (this._last = void 0),
      (this._cipher = new a.AES(A)),
      (this._prev = e.from(k)),
      (this._mode = S),
      (this._autopadding = !0);
  }
  v(g, l),
    (g.prototype._update = function (S) {
      this._cache.add(S);
      for (var A, k, P = []; (A = this._cache.get(this._autopadding)); )
        (k = this._mode.decrypt(this, A)), P.push(k);
      return e.concat(P);
    }),
    (g.prototype._final = function () {
      var S = this._cache.flush();
      if (this._autopadding) return p(this._mode.decrypt(this, S));
      if (S) throw new Error("data not multiple of block length");
    }),
    (g.prototype.setAutoPadding = function (S) {
      return (this._autopadding = !!S), this;
    });
  function b() {
    this.cache = e.allocUnsafe(0);
  }
  (b.prototype.add = function (S) {
    this.cache = e.concat([this.cache, S]);
  }),
    (b.prototype.get = function (S) {
      var A;
      if (S) {
        if (this.cache.length > 16)
          return (A = this.cache.slice(0, 16)), (this.cache = this.cache.slice(16)), A;
      } else if (this.cache.length >= 16)
        return (A = this.cache.slice(0, 16)), (this.cache = this.cache.slice(16)), A;
      return null;
    }),
    (b.prototype.flush = function () {
      if (this.cache.length) return this.cache;
    });
  function p(S) {
    var A = S[15];
    if (A < 1 || A > 16) throw new Error("unable to decrypt data");
    for (var k = -1; ++k < A; )
      if (S[k + (16 - A)] !== A) throw new Error("unable to decrypt data");
    if (A !== 16) return S.slice(0, 16 - A);
  }
  function _(S, A, k) {
    var P = n[S.toLowerCase()];
    if (!P) throw new TypeError("invalid suite type");
    if ((typeof k == "string" && (k = e.from(k)), P.mode !== "GCM" && k.length !== P.iv))
      throw new TypeError("invalid iv length " + k.length);
    if ((typeof A == "string" && (A = e.from(A)), A.length !== P.key / 8))
      throw new TypeError("invalid key length " + A.length);
    return P.type === "stream"
      ? new i(P.module, A, k, !0)
      : P.type === "auth"
      ? new t(P.module, A, k, !0)
      : new g(P.module, A, k);
  }
  function M(S, A) {
    var k = n[S.toLowerCase()];
    if (!k) throw new TypeError("invalid suite type");
    var P = c(A, !1, k.key, k.iv);
    return _(S, P.key, P.iv);
  }
  return (el.createDecipher = M), (el.createDecipheriv = _), el;
}
var ay;
function k1() {
  if (ay) return mn;
  ay = 1;
  var t = S9(),
    e = E9(),
    n = Mw;
  function i() {
    return Object.keys(n);
  }
  return (
    (mn.createCipher = mn.Cipher = t.createCipher),
    (mn.createCipheriv = mn.Cipheriv = t.createCipheriv),
    (mn.createDecipher = mn.Decipher = e.createDecipher),
    (mn.createDecipheriv = mn.Decipheriv = e.createDecipheriv),
    (mn.listCiphers = mn.getCiphers = i),
    mn
  );
}
var wd = {},
  sy;
function A9() {
  return (
    sy ||
      ((sy = 1),
      (function (t) {
        (t["des-ecb"] = {
          key: 8,
          iv: 0,
        }),
          (t["des-cbc"] = t.des =
            {
              key: 8,
              iv: 8,
            }),
          (t["des-ede3-cbc"] = t.des3 =
            {
              key: 24,
              iv: 8,
            }),
          (t["des-ede3"] = {
            key: 24,
            iv: 0,
          }),
          (t["des-ede-cbc"] = {
            key: 16,
            iv: 8,
          }),
          (t["des-ede"] = {
            key: 16,
            iv: 0,
          });
      })(wd)),
    wd
  );
}
var oy;
function k9() {
  if (oy) return pn;
  oy = 1;
  var t = d9(),
    e = k1(),
    n = A1(),
    i = A9(),
    l = Ou();
  function a(p, _) {
    p = p.toLowerCase();
    var M, S;
    if (n[p]) (M = n[p].key), (S = n[p].iv);
    else if (i[p]) (M = i[p].key * 8), (S = i[p].iv);
    else throw new TypeError("invalid suite type");
    var A = l(_, !1, M, S);
    return v(p, A.key, A.iv);
  }
  function c(p, _) {
    p = p.toLowerCase();
    var M, S;
    if (n[p]) (M = n[p].key), (S = n[p].iv);
    else if (i[p]) (M = i[p].key * 8), (S = i[p].iv);
    else throw new TypeError("invalid suite type");
    var A = l(_, !1, M, S);
    return g(p, A.key, A.iv);
  }
  function v(p, _, M) {
    if (((p = p.toLowerCase()), n[p])) return e.createCipheriv(p, _, M);
    if (i[p]) return new t({ key: _, iv: M, mode: p });
    throw new TypeError("invalid suite type");
  }
  function g(p, _, M) {
    if (((p = p.toLowerCase()), n[p])) return e.createDecipheriv(p, _, M);
    if (i[p]) return new t({ key: _, iv: M, mode: p, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function b() {
    return Object.keys(i).concat(e.getCiphers());
  }
  return (
    (pn.createCipher = pn.Cipher = a),
    (pn.createCipheriv = pn.Cipheriv = v),
    (pn.createDecipher = pn.Decipher = c),
    (pn.createDecipheriv = pn.Decipheriv = g),
    (pn.listCiphers = pn.getCiphers = b),
    pn
  );
}
var ha = {},
  gl = { exports: {} };
gl.exports;
var fy;
function Aw() {
  return (
    fy ||
      ((fy = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(gl)),
    gl.exports
  );
}
var yl = { exports: {} };
yl.exports;
var ly;
function B9() {
  return (
    ly ||
      ((ly = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(yl)),
    yl.exports
  );
}
var tl = { exports: {} },
  uy;
function B1() {
  if (uy) return tl.exports;
  uy = 1;
  var t;
  tl.exports = function (l) {
    return t || (t = new e(null)), t.generate(l);
  };
  function e(i) {
    this.rand = i;
  }
  if (
    ((tl.exports.Rand = e),
    (e.prototype.generate = function (l) {
      return this._rand(l);
    }),
    (e.prototype._rand = function (l) {
      if (this.rand.getBytes) return this.rand.getBytes(l);
      for (var a = new Uint8Array(l), c = 0; c < a.length; c++) a[c] = this.rand.getByte();
      return a;
    }),
    typeof self == "object")
  )
    self.crypto && self.crypto.getRandomValues
      ? (e.prototype._rand = function (l) {
          var a = new Uint8Array(l);
          return self.crypto.getRandomValues(a), a;
        })
      : self.msCrypto && self.msCrypto.getRandomValues
      ? (e.prototype._rand = function (l) {
          var a = new Uint8Array(l);
          return self.msCrypto.getRandomValues(a), a;
        })
      : typeof window == "object" &&
        (e.prototype._rand = function () {
          throw new Error("Not implemented yet");
        });
  else
    try {
      var n = Ww();
      if (typeof n.randomBytes != "function") throw new Error("Not supported");
      e.prototype._rand = function (l) {
        return n.randomBytes(l);
      };
    } catch {}
  return tl.exports;
}
var _d, cy;
function kw() {
  if (cy) return _d;
  cy = 1;
  var t = B9(),
    e = B1();
  function n(i) {
    this.rand = i || new e.Rand();
  }
  return (
    (_d = n),
    (n.create = function (l) {
      return new n(l);
    }),
    (n.prototype._randbelow = function (l) {
      var a = l.bitLength(),
        c = Math.ceil(a / 8);
      do var v = new t(this.rand.generate(c));
      while (v.cmp(l) >= 0);
      return v;
    }),
    (n.prototype._randrange = function (l, a) {
      var c = a.sub(l);
      return l.add(this._randbelow(c));
    }),
    (n.prototype.test = function (l, a, c) {
      var v = l.bitLength(),
        g = t.mont(l),
        b = new t(1).toRed(g);
      a || (a = Math.max(1, (v / 48) | 0));
      for (var p = l.subn(1), _ = 0; !p.testn(_); _++);
      for (var M = l.shrn(_), S = p.toRed(g), A = !0; a > 0; a--) {
        var k = this._randrange(new t(2), p);
        c && c(k);
        var P = k.toRed(g).redPow(M);
        if (!(P.cmp(b) === 0 || P.cmp(S) === 0)) {
          for (var B = 1; B < _; B++) {
            if (((P = P.redSqr()), P.cmp(b) === 0)) return !1;
            if (P.cmp(S) === 0) break;
          }
          if (B === _) return !1;
        }
      }
      return A;
    }),
    (n.prototype.getDivisor = function (l, a) {
      var c = l.bitLength(),
        v = t.mont(l),
        g = new t(1).toRed(v);
      a || (a = Math.max(1, (c / 48) | 0));
      for (var b = l.subn(1), p = 0; !b.testn(p); p++);
      for (var _ = l.shrn(p), M = b.toRed(v); a > 0; a--) {
        var S = this._randrange(new t(2), b),
          A = l.gcd(S);
        if (A.cmpn(1) !== 0) return A;
        var k = S.toRed(v).redPow(_);
        if (!(k.cmp(g) === 0 || k.cmp(M) === 0)) {
          for (var P = 1; P < p; P++) {
            if (((k = k.redSqr()), k.cmp(g) === 0)) return k.fromRed().subn(1).gcd(l);
            if (k.cmp(M) === 0) break;
          }
          if (P === p) return (k = k.redSqr()), k.fromRed().subn(1).gcd(l);
        }
      }
      return !1;
    }),
    _d
  );
}
var xd, hy;
function Bw() {
  if (hy) return xd;
  hy = 1;
  var t = so();
  (xd = P), (P.simpleSieve = A), (P.fermatTest = k);
  var e = Aw(),
    n = new e(24),
    i = kw(),
    l = new i(),
    a = new e(1),
    c = new e(2),
    v = new e(5);
  new e(16), new e(8);
  var g = new e(10),
    b = new e(3);
  new e(7);
  var p = new e(11),
    _ = new e(4);
  new e(12);
  var M = null;
  function S() {
    if (M !== null) return M;
    var B = 1048576,
      T = [];
    T[0] = 2;
    for (var F = 1, O = 3; O < B; O += 2) {
      for (var $ = Math.ceil(Math.sqrt(O)), J = 0; J < F && T[J] <= $ && O % T[J] !== 0; J++);
      (F !== J && T[J] <= $) || (T[F++] = O);
    }
    return (M = T), T;
  }
  function A(B) {
    for (var T = S(), F = 0; F < T.length; F++) if (B.modn(T[F]) === 0) return B.cmpn(T[F]) === 0;
    return !0;
  }
  function k(B) {
    var T = e.mont(B);
    return c.toRed(T).redPow(B.subn(1)).fromRed().cmpn(1) === 0;
  }
  function P(B, T) {
    if (B < 16) return T === 2 || T === 5 ? new e([140, 123]) : new e([140, 39]);
    T = new e(T);
    for (var F, O; ; ) {
      for (F = new e(t(Math.ceil(B / 8))); F.bitLength() > B; ) F.ishrn(1);
      if ((F.isEven() && F.iadd(a), F.testn(1) || F.iadd(c), T.cmp(c))) {
        if (!T.cmp(v)) for (; F.mod(g).cmp(b); ) F.iadd(_);
      } else for (; F.mod(n).cmp(p); ) F.iadd(_);
      if (((O = F.shrn(1)), A(O) && A(F) && k(O) && k(F) && l.test(O) && l.test(F))) return F;
    }
  }
  return xd;
}
const C9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff",
  },
  T9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff",
  },
  P9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff",
  },
  R9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff",
  },
  I9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff",
  },
  O9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff",
  },
  U9 = {
    gen: "02",
    prime:
      "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff",
  },
  N9 = {
    gen: "02",
    prime:
      "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",
  },
  D9 = {
    modp1: C9,
    modp2: T9,
    modp5: P9,
    modp14: R9,
    modp15: I9,
    modp16: O9,
    modp17: U9,
    modp18: N9,
  };
var Md, dy;
function L9() {
  if (dy) return Md;
  dy = 1;
  var t = Aw(),
    e = kw(),
    n = new e(),
    i = new t(24),
    l = new t(11),
    a = new t(10),
    c = new t(3),
    v = new t(7),
    g = Bw(),
    b = so();
  Md = A;
  function p(P, B) {
    return (B = B || "utf8"), Qe.isBuffer(P) || (P = new Qe(P, B)), (this._pub = new t(P)), this;
  }
  function _(P, B) {
    return (B = B || "utf8"), Qe.isBuffer(P) || (P = new Qe(P, B)), (this._priv = new t(P)), this;
  }
  var M = {};
  function S(P, B) {
    var T = B.toString("hex"),
      F = [T, P.toString(16)].join("_");
    if (F in M) return M[F];
    var O = 0;
    if (P.isEven() || !g.simpleSieve || !g.fermatTest(P) || !n.test(P))
      return (O += 1), T === "02" || T === "05" ? (O += 8) : (O += 4), (M[F] = O), O;
    n.test(P.shrn(1)) || (O += 2);
    var $;
    switch (T) {
      case "02":
        P.mod(i).cmp(l) && (O += 8);
        break;
      case "05":
        ($ = P.mod(a)), $.cmp(c) && $.cmp(v) && (O += 8);
        break;
      default:
        O += 4;
    }
    return (M[F] = O), O;
  }
  function A(P, B, T) {
    this.setGenerator(B),
      (this.__prime = new t(P)),
      (this._prime = t.mont(this.__prime)),
      (this._primeLen = P.length),
      (this._pub = void 0),
      (this._priv = void 0),
      (this._primeCode = void 0),
      T ? ((this.setPublicKey = p), (this.setPrivateKey = _)) : (this._primeCode = 8);
  }
  Object.defineProperty(A.prototype, "verifyError", {
    enumerable: !0,
    get: function () {
      return (
        typeof this._primeCode != "number" && (this._primeCode = S(this.__prime, this.__gen)),
        this._primeCode
      );
    },
  }),
    (A.prototype.generateKeys = function () {
      return (
        this._priv || (this._priv = new t(b(this._primeLen))),
        (this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed()),
        this.getPublicKey()
      );
    }),
    (A.prototype.computeSecret = function (P) {
      (P = new t(P)), (P = P.toRed(this._prime));
      var B = P.redPow(this._priv).fromRed(),
        T = new Qe(B.toArray()),
        F = this.getPrime();
      if (T.length < F.length) {
        var O = new Qe(F.length - T.length);
        O.fill(0), (T = Qe.concat([O, T]));
      }
      return T;
    }),
    (A.prototype.getPublicKey = function (B) {
      return k(this._pub, B);
    }),
    (A.prototype.getPrivateKey = function (B) {
      return k(this._priv, B);
    }),
    (A.prototype.getPrime = function (P) {
      return k(this.__prime, P);
    }),
    (A.prototype.getGenerator = function (P) {
      return k(this._gen, P);
    }),
    (A.prototype.setGenerator = function (P, B) {
      return (
        (B = B || "utf8"),
        Qe.isBuffer(P) || (P = new Qe(P, B)),
        (this.__gen = P),
        (this._gen = new t(P)),
        this
      );
    });
  function k(P, B) {
    var T = new Qe(P.toArray());
    return B ? T.toString(B) : T;
  }
  return Md;
}
var py;
function F9() {
  if (py) return ha;
  py = 1;
  var t = Bw(),
    e = D9,
    n = L9();
  function i(c) {
    var v = new Qe(e[c].prime, "hex"),
      g = new Qe(e[c].gen, "hex");
    return new n(v, g);
  }
  var l = {
    binary: !0,
    hex: !0,
    base64: !0,
  };
  function a(c, v, g, b) {
    return Qe.isBuffer(v) || l[v] === void 0
      ? a(c, "binary", v, g)
      : ((v = v || "binary"),
        (b = b || "binary"),
        (g = g || new Qe([2])),
        Qe.isBuffer(g) || (g = new Qe(g, b)),
        typeof c == "number"
          ? new n(t(c, g), g, !0)
          : (Qe.isBuffer(c) || (c = new Qe(c, v)), new n(c, g, !0)));
  }
  return (
    (ha.DiffieHellmanGroup = ha.createDiffieHellmanGroup = ha.getDiffieHellman = i),
    (ha.createDiffieHellman = ha.DiffieHellman = a),
    ha
  );
}
var rl = { exports: {} },
  nl = { exports: {} },
  my;
function Uu() {
  if (my) return nl.exports;
  (my = 1),
    typeof Et > "u" ||
    !Et.version ||
    Et.version.indexOf("v0.") === 0 ||
    (Et.version.indexOf("v1.") === 0 && Et.version.indexOf("v1.8.") !== 0)
      ? (nl.exports = { nextTick: t })
      : (nl.exports = Et);
  function t(e, n, i, l) {
    if (typeof e != "function") throw new TypeError('"callback" argument must be a function');
    var a = arguments.length,
      c,
      v;
    switch (a) {
      case 0:
      case 1:
        return Et.nextTick(e);
      case 2:
        return Et.nextTick(function () {
          e.call(null, n);
        });
      case 3:
        return Et.nextTick(function () {
          e.call(null, n, i);
        });
      case 4:
        return Et.nextTick(function () {
          e.call(null, n, i, l);
        });
      default:
        for (c = new Array(a - 1), v = 0; v < c.length; ) c[v++] = arguments[v];
        return Et.nextTick(function () {
          e.apply(null, c);
        });
    }
  }
  return nl.exports;
}
var Sd, vy;
function q9() {
  if (vy) return Sd;
  vy = 1;
  var t = {}.toString;
  return (
    (Sd =
      Array.isArray ||
      function (e) {
        return t.call(e) == "[object Array]";
      }),
    Sd
  );
}
var Ed, gy;
function Cw() {
  return gy || ((gy = 1), (Ed = Sf().EventEmitter)), Ed;
}
var il = { exports: {} },
  yy;
function C1() {
  return (
    yy ||
      ((yy = 1),
      (function (t, e) {
        var n = Mr,
          i = n.Buffer;
        function l(c, v) {
          for (var g in c) v[g] = c[g];
        }
        i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow
          ? (t.exports = n)
          : (l(n, e), (e.Buffer = a));
        function a(c, v, g) {
          return i(c, v, g);
        }
        l(i, a),
          (a.from = function (c, v, g) {
            if (typeof c == "number") throw new TypeError("Argument must not be a number");
            return i(c, v, g);
          }),
          (a.alloc = function (c, v, g) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            var b = i(c);
            return v !== void 0 ? (typeof g == "string" ? b.fill(v, g) : b.fill(v)) : b.fill(0), b;
          }),
          (a.allocUnsafe = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return i(c);
          }),
          (a.allocUnsafeSlow = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return n.SlowBuffer(c);
          });
      })(il, il.exports)),
    il.exports
  );
}
var Er = {},
  by;
function Bf() {
  if (by) return Er;
  by = 1;
  function t(k) {
    return Array.isArray ? Array.isArray(k) : A(k) === "[object Array]";
  }
  Er.isArray = t;
  function e(k) {
    return typeof k == "boolean";
  }
  Er.isBoolean = e;
  function n(k) {
    return k === null;
  }
  Er.isNull = n;
  function i(k) {
    return k == null;
  }
  Er.isNullOrUndefined = i;
  function l(k) {
    return typeof k == "number";
  }
  Er.isNumber = l;
  function a(k) {
    return typeof k == "string";
  }
  Er.isString = a;
  function c(k) {
    return typeof k == "symbol";
  }
  Er.isSymbol = c;
  function v(k) {
    return k === void 0;
  }
  Er.isUndefined = v;
  function g(k) {
    return A(k) === "[object RegExp]";
  }
  Er.isRegExp = g;
  function b(k) {
    return typeof k == "object" && k !== null;
  }
  Er.isObject = b;
  function p(k) {
    return A(k) === "[object Date]";
  }
  Er.isDate = p;
  function _(k) {
    return A(k) === "[object Error]" || k instanceof Error;
  }
  Er.isError = _;
  function M(k) {
    return typeof k == "function";
  }
  Er.isFunction = M;
  function S(k) {
    return (
      k === null ||
      typeof k == "boolean" ||
      typeof k == "number" ||
      typeof k == "string" ||
      typeof k == "symbol" || // ES6 symbol
      typeof k > "u"
    );
  }
  (Er.isPrimitive = S), (Er.isBuffer = Mr.Buffer.isBuffer);
  function A(k) {
    return Object.prototype.toString.call(k);
  }
  return Er;
}
var Ad = { exports: {} },
  wy;
function z9() {
  return (
    wy ||
      ((wy = 1),
      (function (t) {
        function e(a, c) {
          if (!(a instanceof c)) throw new TypeError("Cannot call a class as a function");
        }
        var n = C1().Buffer,
          i = Ru();
        function l(a, c, v) {
          a.copy(c, v);
        }
        (t.exports = (function () {
          function a() {
            e(this, a), (this.head = null), (this.tail = null), (this.length = 0);
          }
          return (
            (a.prototype.push = function (v) {
              var g = { data: v, next: null };
              this.length > 0 ? (this.tail.next = g) : (this.head = g),
                (this.tail = g),
                ++this.length;
            }),
            (a.prototype.unshift = function (v) {
              var g = { data: v, next: this.head };
              this.length === 0 && (this.tail = g), (this.head = g), ++this.length;
            }),
            (a.prototype.shift = function () {
              if (this.length !== 0) {
                var v = this.head.data;
                return (
                  this.length === 1 ? (this.head = this.tail = null) : (this.head = this.head.next),
                  --this.length,
                  v
                );
              }
            }),
            (a.prototype.clear = function () {
              (this.head = this.tail = null), (this.length = 0);
            }),
            (a.prototype.join = function (v) {
              if (this.length === 0) return "";
              for (var g = this.head, b = "" + g.data; (g = g.next); ) b += v + g.data;
              return b;
            }),
            (a.prototype.concat = function (v) {
              if (this.length === 0) return n.alloc(0);
              for (var g = n.allocUnsafe(v >>> 0), b = this.head, p = 0; b; )
                l(b.data, g, p), (p += b.data.length), (b = b.next);
              return g;
            }),
            a
          );
        })()),
          i &&
            i.inspect &&
            i.inspect.custom &&
            (t.exports.prototype[i.inspect.custom] = function () {
              var a = i.inspect({ length: this.length });
              return this.constructor.name + " " + a;
            });
      })(Ad)),
    Ad.exports
  );
}
var kd, _y;
function Tw() {
  if (_y) return kd;
  _y = 1;
  var t = Uu();
  function e(l, a) {
    var c = this,
      v = this._readableState && this._readableState.destroyed,
      g = this._writableState && this._writableState.destroyed;
    return v || g
      ? (a
          ? a(l)
          : l &&
            (this._writableState
              ? this._writableState.errorEmitted ||
                ((this._writableState.errorEmitted = !0), t.nextTick(i, this, l))
              : t.nextTick(i, this, l)),
        this)
      : (this._readableState && (this._readableState.destroyed = !0),
        this._writableState && (this._writableState.destroyed = !0),
        this._destroy(l || null, function (b) {
          !a && b
            ? c._writableState
              ? c._writableState.errorEmitted ||
                ((c._writableState.errorEmitted = !0), t.nextTick(i, c, b))
              : t.nextTick(i, c, b)
            : a && a(b);
        }),
        this);
  }
  function n() {
    this._readableState &&
      ((this._readableState.destroyed = !1),
      (this._readableState.reading = !1),
      (this._readableState.ended = !1),
      (this._readableState.endEmitted = !1)),
      this._writableState &&
        ((this._writableState.destroyed = !1),
        (this._writableState.ended = !1),
        (this._writableState.ending = !1),
        (this._writableState.finalCalled = !1),
        (this._writableState.prefinished = !1),
        (this._writableState.finished = !1),
        (this._writableState.errorEmitted = !1));
  }
  function i(l, a) {
    l.emit("error", a);
  }
  return (
    (kd = {
      destroy: e,
      undestroy: n,
    }),
    kd
  );
}
var Bd, xy;
function Pw() {
  if (xy) return Bd;
  xy = 1;
  var t = Uu();
  Bd = k;
  function e(y) {
    var w = this;
    (this.next = null),
      (this.entry = null),
      (this.finish = function () {
        d(w, y);
      });
  }
  var n =
      !Et.browser && ["v0.10", "v0.9."].indexOf(Et.version.slice(0, 5)) > -1
        ? setImmediate
        : t.nextTick,
    i;
  k.WritableState = S;
  var l = Object.create(Bf());
  l.inherits = It();
  var a = {
      deprecate: iw(),
    },
    c = Cw(),
    v = C1().Buffer,
    g =
      (typeof mt < "u" ? mt : typeof window < "u" ? window : typeof self < "u" ? self : {})
        .Uint8Array || function () {};
  function b(y) {
    return v.from(y);
  }
  function p(y) {
    return v.isBuffer(y) || y instanceof g;
  }
  var _ = Tw();
  l.inherits(k, c);
  function M() {}
  function S(y, w) {
    (i = i || qs()), (y = y || {});
    var h = w instanceof i;
    (this.objectMode = !!y.objectMode),
      h && (this.objectMode = this.objectMode || !!y.writableObjectMode);
    var s = y.highWaterMark,
      m = y.writableHighWaterMark,
      E = this.objectMode ? 16 : 16 * 1024;
    s || s === 0
      ? (this.highWaterMark = s)
      : h && (m || m === 0)
      ? (this.highWaterMark = m)
      : (this.highWaterMark = E),
      (this.highWaterMark = Math.floor(this.highWaterMark)),
      (this.finalCalled = !1),
      (this.needDrain = !1),
      (this.ending = !1),
      (this.ended = !1),
      (this.finished = !1),
      (this.destroyed = !1);
    var R = y.decodeStrings === !1;
    (this.decodeStrings = !R),
      (this.defaultEncoding = y.defaultEncoding || "utf8"),
      (this.length = 0),
      (this.writing = !1),
      (this.corked = 0),
      (this.sync = !0),
      (this.bufferProcessing = !1),
      (this.onwrite = function (z) {
        he(w, z);
      }),
      (this.writecb = null),
      (this.writelen = 0),
      (this.bufferedRequest = null),
      (this.lastBufferedRequest = null),
      (this.pendingcb = 0),
      (this.prefinished = !1),
      (this.errorEmitted = !1),
      (this.bufferedRequestCount = 0),
      (this.corkedRequestsFree = new e(this));
  }
  (S.prototype.getBuffer = function () {
    for (var w = this.bufferedRequest, h = []; w; ) h.push(w), (w = w.next);
    return h;
  }),
    (function () {
      try {
        Object.defineProperty(S.prototype, "buffer", {
          get: a.deprecate(
            function () {
              return this.getBuffer();
            },
            "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.",
            "DEP0003"
          ),
        });
      } catch {}
    })();
  var A;
  typeof Symbol == "function" &&
  Symbol.hasInstance &&
  typeof Function.prototype[Symbol.hasInstance] == "function"
    ? ((A = Function.prototype[Symbol.hasInstance]),
      Object.defineProperty(k, Symbol.hasInstance, {
        value: function (y) {
          return A.call(this, y) ? !0 : this !== k ? !1 : y && y._writableState instanceof S;
        },
      }))
    : (A = function (y) {
        return y instanceof this;
      });
  function k(y) {
    if (((i = i || qs()), !A.call(k, this) && !(this instanceof i))) return new k(y);
    (this._writableState = new S(y, this)),
      (this.writable = !0),
      y &&
        (typeof y.write == "function" && (this._write = y.write),
        typeof y.writev == "function" && (this._writev = y.writev),
        typeof y.destroy == "function" && (this._destroy = y.destroy),
        typeof y.final == "function" && (this._final = y.final)),
      c.call(this);
  }
  k.prototype.pipe = function () {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function P(y, w) {
    var h = new Error("write after end");
    y.emit("error", h), t.nextTick(w, h);
  }
  function B(y, w, h, s) {
    var m = !0,
      E = !1;
    return (
      h === null
        ? (E = new TypeError("May not write null values to stream"))
        : typeof h != "string" &&
          h !== void 0 &&
          !w.objectMode &&
          (E = new TypeError("Invalid non-string/buffer chunk")),
      E && (y.emit("error", E), t.nextTick(s, E), (m = !1)),
      m
    );
  }
  (k.prototype.write = function (y, w, h) {
    var s = this._writableState,
      m = !1,
      E = !s.objectMode && p(y);
    return (
      E && !v.isBuffer(y) && (y = b(y)),
      typeof w == "function" && ((h = w), (w = null)),
      E ? (w = "buffer") : w || (w = s.defaultEncoding),
      typeof h != "function" && (h = M),
      s.ended
        ? P(this, h)
        : (E || B(this, s, y, h)) && (s.pendingcb++, (m = F(this, s, E, y, w, h))),
      m
    );
  }),
    (k.prototype.cork = function () {
      var y = this._writableState;
      y.corked++;
    }),
    (k.prototype.uncork = function () {
      var y = this._writableState;
      y.corked &&
        (y.corked--,
        !y.writing && !y.corked && !y.bufferProcessing && y.bufferedRequest && Ae(this, y));
    }),
    (k.prototype.setDefaultEncoding = function (w) {
      if (
        (typeof w == "string" && (w = w.toLowerCase()),
        !(
          [
            "hex",
            "utf8",
            "utf-8",
            "ascii",
            "binary",
            "base64",
            "ucs2",
            "ucs-2",
            "utf16le",
            "utf-16le",
            "raw",
          ].indexOf((w + "").toLowerCase()) > -1
        ))
      )
        throw new TypeError("Unknown encoding: " + w);
      return (this._writableState.defaultEncoding = w), this;
    });
  function T(y, w, h) {
    return !y.objectMode && y.decodeStrings !== !1 && typeof w == "string" && (w = v.from(w, h)), w;
  }
  Object.defineProperty(k.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function () {
      return this._writableState.highWaterMark;
    },
  });
  function F(y, w, h, s, m, E) {
    if (!h) {
      var R = T(w, s, m);
      s !== R && ((h = !0), (m = "buffer"), (s = R));
    }
    var z = w.objectMode ? 1 : s.length;
    w.length += z;
    var Q = w.length < w.highWaterMark;
    if ((Q || (w.needDrain = !0), w.writing || w.corked)) {
      var G = w.lastBufferedRequest;
      (w.lastBufferedRequest = {
        chunk: s,
        encoding: m,
        isBuf: h,
        callback: E,
        next: null,
      }),
        G ? (G.next = w.lastBufferedRequest) : (w.bufferedRequest = w.lastBufferedRequest),
        (w.bufferedRequestCount += 1);
    } else O(y, w, !1, z, s, m, E);
    return Q;
  }
  function O(y, w, h, s, m, E, R) {
    (w.writelen = s),
      (w.writecb = R),
      (w.writing = !0),
      (w.sync = !0),
      h ? y._writev(m, w.onwrite) : y._write(m, E, w.onwrite),
      (w.sync = !1);
  }
  function $(y, w, h, s, m) {
    --w.pendingcb,
      h
        ? (t.nextTick(m, s),
          t.nextTick(f, y, w),
          (y._writableState.errorEmitted = !0),
          y.emit("error", s))
        : (m(s), (y._writableState.errorEmitted = !0), y.emit("error", s), f(y, w));
  }
  function J(y) {
    (y.writing = !1), (y.writecb = null), (y.length -= y.writelen), (y.writelen = 0);
  }
  function he(y, w) {
    var h = y._writableState,
      s = h.sync,
      m = h.writecb;
    if ((J(h), w)) $(y, h, s, w, m);
    else {
      var E = x(h);
      !E && !h.corked && !h.bufferProcessing && h.bufferedRequest && Ae(y, h),
        s ? n(de, y, h, E, m) : de(y, h, E, m);
    }
  }
  function de(y, w, h, s) {
    h || ne(y, w), w.pendingcb--, s(), f(y, w);
  }
  function ne(y, w) {
    w.length === 0 && w.needDrain && ((w.needDrain = !1), y.emit("drain"));
  }
  function Ae(y, w) {
    w.bufferProcessing = !0;
    var h = w.bufferedRequest;
    if (y._writev && h && h.next) {
      var s = w.bufferedRequestCount,
        m = new Array(s),
        E = w.corkedRequestsFree;
      E.entry = h;
      for (var R = 0, z = !0; h; ) (m[R] = h), h.isBuf || (z = !1), (h = h.next), (R += 1);
      (m.allBuffers = z),
        O(y, w, !0, w.length, m, "", E.finish),
        w.pendingcb++,
        (w.lastBufferedRequest = null),
        E.next
          ? ((w.corkedRequestsFree = E.next), (E.next = null))
          : (w.corkedRequestsFree = new e(w)),
        (w.bufferedRequestCount = 0);
    } else {
      for (; h; ) {
        var Q = h.chunk,
          G = h.encoding,
          q = h.callback,
          Z = w.objectMode ? 1 : Q.length;
        if ((O(y, w, !1, Z, Q, G, q), (h = h.next), w.bufferedRequestCount--, w.writing)) break;
      }
      h === null && (w.lastBufferedRequest = null);
    }
    (w.bufferedRequest = h), (w.bufferProcessing = !1);
  }
  (k.prototype._write = function (y, w, h) {
    h(new Error("_write() is not implemented"));
  }),
    (k.prototype._writev = null),
    (k.prototype.end = function (y, w, h) {
      var s = this._writableState;
      typeof y == "function"
        ? ((h = y), (y = null), (w = null))
        : typeof w == "function" && ((h = w), (w = null)),
        y != null && this.write(y, w),
        s.corked && ((s.corked = 1), this.uncork()),
        s.ending || u(this, s, h);
    });
  function x(y) {
    return y.ending && y.length === 0 && y.bufferedRequest === null && !y.finished && !y.writing;
  }
  function r(y, w) {
    y._final(function (h) {
      w.pendingcb--, h && y.emit("error", h), (w.prefinished = !0), y.emit("prefinish"), f(y, w);
    });
  }
  function o(y, w) {
    !w.prefinished &&
      !w.finalCalled &&
      (typeof y._final == "function"
        ? (w.pendingcb++, (w.finalCalled = !0), t.nextTick(r, y, w))
        : ((w.prefinished = !0), y.emit("prefinish")));
  }
  function f(y, w) {
    var h = x(w);
    return h && (o(y, w), w.pendingcb === 0 && ((w.finished = !0), y.emit("finish"))), h;
  }
  function u(y, w, h) {
    (w.ending = !0),
      f(y, w),
      h && (w.finished ? t.nextTick(h) : y.once("finish", h)),
      (w.ended = !0),
      (y.writable = !1);
  }
  function d(y, w, h) {
    var s = y.entry;
    for (y.entry = null; s; ) {
      var m = s.callback;
      w.pendingcb--, m(h), (s = s.next);
    }
    w.corkedRequestsFree.next = y;
  }
  return (
    Object.defineProperty(k.prototype, "destroyed", {
      get: function () {
        return this._writableState === void 0 ? !1 : this._writableState.destroyed;
      },
      set: function (y) {
        this._writableState && (this._writableState.destroyed = y);
      },
    }),
    (k.prototype.destroy = _.destroy),
    (k.prototype._undestroy = _.undestroy),
    (k.prototype._destroy = function (y, w) {
      this.end(), w(y);
    }),
    Bd
  );
}
var Cd, My;
function qs() {
  if (My) return Cd;
  My = 1;
  var t = Uu(),
    e =
      Object.keys ||
      function (_) {
        var M = [];
        for (var S in _) M.push(S);
        return M;
      };
  Cd = g;
  var n = Object.create(Bf());
  n.inherits = It();
  var i = Rw(),
    l = Pw();
  n.inherits(g, i);
  for (var a = e(l.prototype), c = 0; c < a.length; c++) {
    var v = a[c];
    g.prototype[v] || (g.prototype[v] = l.prototype[v]);
  }
  function g(_) {
    if (!(this instanceof g)) return new g(_);
    i.call(this, _),
      l.call(this, _),
      _ && _.readable === !1 && (this.readable = !1),
      _ && _.writable === !1 && (this.writable = !1),
      (this.allowHalfOpen = !0),
      _ && _.allowHalfOpen === !1 && (this.allowHalfOpen = !1),
      this.once("end", b);
  }
  Object.defineProperty(g.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function () {
      return this._writableState.highWaterMark;
    },
  });
  function b() {
    this.allowHalfOpen || this._writableState.ended || t.nextTick(p, this);
  }
  function p(_) {
    _.end();
  }
  return (
    Object.defineProperty(g.prototype, "destroyed", {
      get: function () {
        return this._readableState === void 0 || this._writableState === void 0
          ? !1
          : this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function (_) {
        this._readableState === void 0 ||
          this._writableState === void 0 ||
          ((this._readableState.destroyed = _), (this._writableState.destroyed = _));
      },
    }),
    (g.prototype._destroy = function (_, M) {
      this.push(null), this.end(), t.nextTick(M, _);
    }),
    Cd
  );
}
var Td = {},
  al = { exports: {} },
  Sy;
function j9() {
  return (
    Sy ||
      ((Sy = 1),
      (function (t, e) {
        var n = Mr,
          i = n.Buffer;
        function l(c, v) {
          for (var g in c) v[g] = c[g];
        }
        i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow
          ? (t.exports = n)
          : (l(n, e), (e.Buffer = a));
        function a(c, v, g) {
          return i(c, v, g);
        }
        l(i, a),
          (a.from = function (c, v, g) {
            if (typeof c == "number") throw new TypeError("Argument must not be a number");
            return i(c, v, g);
          }),
          (a.alloc = function (c, v, g) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            var b = i(c);
            return v !== void 0 ? (typeof g == "string" ? b.fill(v, g) : b.fill(v)) : b.fill(0), b;
          }),
          (a.allocUnsafe = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return i(c);
          }),
          (a.allocUnsafeSlow = function (c) {
            if (typeof c != "number") throw new TypeError("Argument must be a number");
            return n.SlowBuffer(c);
          });
      })(al, al.exports)),
    al.exports
  );
}
var Ey;
function Ay() {
  if (Ey) return Td;
  Ey = 1;
  var t = j9().Buffer,
    e =
      t.isEncoding ||
      function (B) {
        switch (((B = "" + B), B && B.toLowerCase())) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1;
        }
      };
  function n(B) {
    if (!B) return "utf8";
    for (var T; ; )
      switch (B) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return B;
        default:
          if (T) return;
          (B = ("" + B).toLowerCase()), (T = !0);
      }
  }
  function i(B) {
    var T = n(B);
    if (typeof T != "string" && (t.isEncoding === e || !e(B)))
      throw new Error("Unknown encoding: " + B);
    return T || B;
  }
  Td.StringDecoder = l;
  function l(B) {
    this.encoding = i(B);
    var T;
    switch (this.encoding) {
      case "utf16le":
        (this.text = _), (this.end = M), (T = 4);
        break;
      case "utf8":
        (this.fillLast = g), (T = 4);
        break;
      case "base64":
        (this.text = S), (this.end = A), (T = 3);
        break;
      default:
        (this.write = k), (this.end = P);
        return;
    }
    (this.lastNeed = 0), (this.lastTotal = 0), (this.lastChar = t.allocUnsafe(T));
  }
  (l.prototype.write = function (B) {
    if (B.length === 0) return "";
    var T, F;
    if (this.lastNeed) {
      if (((T = this.fillLast(B)), T === void 0)) return "";
      (F = this.lastNeed), (this.lastNeed = 0);
    } else F = 0;
    return F < B.length ? (T ? T + this.text(B, F) : this.text(B, F)) : T || "";
  }),
    (l.prototype.end = p),
    (l.prototype.text = b),
    (l.prototype.fillLast = function (B) {
      if (this.lastNeed <= B.length)
        return (
          B.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed),
          this.lastChar.toString(this.encoding, 0, this.lastTotal)
        );
      B.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, B.length),
        (this.lastNeed -= B.length);
    });
  function a(B) {
    return B <= 127
      ? 0
      : B >> 5 === 6
      ? 2
      : B >> 4 === 14
      ? 3
      : B >> 3 === 30
      ? 4
      : B >> 6 === 2
      ? -1
      : -2;
  }
  function c(B, T, F) {
    var O = T.length - 1;
    if (O < F) return 0;
    var $ = a(T[O]);
    return $ >= 0
      ? ($ > 0 && (B.lastNeed = $ - 1), $)
      : --O < F || $ === -2
      ? 0
      : (($ = a(T[O])),
        $ >= 0
          ? ($ > 0 && (B.lastNeed = $ - 2), $)
          : --O < F || $ === -2
          ? 0
          : (($ = a(T[O])), $ >= 0 ? ($ > 0 && ($ === 2 ? ($ = 0) : (B.lastNeed = $ - 3)), $) : 0));
  }
  function v(B, T, F) {
    if ((T[0] & 192) !== 128) return (B.lastNeed = 0), "�";
    if (B.lastNeed > 1 && T.length > 1) {
      if ((T[1] & 192) !== 128) return (B.lastNeed = 1), "�";
      if (B.lastNeed > 2 && T.length > 2 && (T[2] & 192) !== 128) return (B.lastNeed = 2), "�";
    }
  }
  function g(B) {
    var T = this.lastTotal - this.lastNeed,
      F = v(this, B);
    if (F !== void 0) return F;
    if (this.lastNeed <= B.length)
      return (
        B.copy(this.lastChar, T, 0, this.lastNeed),
        this.lastChar.toString(this.encoding, 0, this.lastTotal)
      );
    B.copy(this.lastChar, T, 0, B.length), (this.lastNeed -= B.length);
  }
  function b(B, T) {
    var F = c(this, B, T);
    if (!this.lastNeed) return B.toString("utf8", T);
    this.lastTotal = F;
    var O = B.length - (F - this.lastNeed);
    return B.copy(this.lastChar, 0, O), B.toString("utf8", T, O);
  }
  function p(B) {
    var T = B && B.length ? this.write(B) : "";
    return this.lastNeed ? T + "�" : T;
  }
  function _(B, T) {
    if ((B.length - T) % 2 === 0) {
      var F = B.toString("utf16le", T);
      if (F) {
        var O = F.charCodeAt(F.length - 1);
        if (O >= 55296 && O <= 56319)
          return (
            (this.lastNeed = 2),
            (this.lastTotal = 4),
            (this.lastChar[0] = B[B.length - 2]),
            (this.lastChar[1] = B[B.length - 1]),
            F.slice(0, -1)
          );
      }
      return F;
    }
    return (
      (this.lastNeed = 1),
      (this.lastTotal = 2),
      (this.lastChar[0] = B[B.length - 1]),
      B.toString("utf16le", T, B.length - 1)
    );
  }
  function M(B) {
    var T = B && B.length ? this.write(B) : "";
    if (this.lastNeed) {
      var F = this.lastTotal - this.lastNeed;
      return T + this.lastChar.toString("utf16le", 0, F);
    }
    return T;
  }
  function S(B, T) {
    var F = (B.length - T) % 3;
    return F === 0
      ? B.toString("base64", T)
      : ((this.lastNeed = 3 - F),
        (this.lastTotal = 3),
        F === 1
          ? (this.lastChar[0] = B[B.length - 1])
          : ((this.lastChar[0] = B[B.length - 2]), (this.lastChar[1] = B[B.length - 1])),
        B.toString("base64", T, B.length - F));
  }
  function A(B) {
    var T = B && B.length ? this.write(B) : "";
    return this.lastNeed ? T + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : T;
  }
  function k(B) {
    return B.toString(this.encoding);
  }
  function P(B) {
    return B && B.length ? this.write(B) : "";
  }
  return Td;
}
var Pd, ky;
function Rw() {
  if (ky) return Pd;
  ky = 1;
  var t = Uu();
  Pd = T;
  var e = q9(),
    n;
  (T.ReadableState = B), Sf().EventEmitter;
  var i = function (q, Z) {
      return q.listeners(Z).length;
    },
    l = Cw(),
    a = C1().Buffer,
    c =
      (typeof mt < "u" ? mt : typeof window < "u" ? window : typeof self < "u" ? self : {})
        .Uint8Array || function () {};
  function v(q) {
    return a.from(q);
  }
  function g(q) {
    return a.isBuffer(q) || q instanceof c;
  }
  var b = Object.create(Bf());
  b.inherits = It();
  var p = Ru(),
    _ = void 0;
  p && p.debuglog ? (_ = p.debuglog("stream")) : (_ = function () {});
  var M = z9(),
    S = Tw(),
    A;
  b.inherits(T, l);
  var k = ["error", "close", "destroy", "pause", "resume"];
  function P(q, Z, te) {
    if (typeof q.prependListener == "function") return q.prependListener(Z, te);
    !q._events || !q._events[Z]
      ? q.on(Z, te)
      : e(q._events[Z])
      ? q._events[Z].unshift(te)
      : (q._events[Z] = [te, q._events[Z]]);
  }
  function B(q, Z) {
    (n = n || qs()), (q = q || {});
    var te = Z instanceof n;
    (this.objectMode = !!q.objectMode),
      te && (this.objectMode = this.objectMode || !!q.readableObjectMode);
    var ue = q.highWaterMark,
      ae = q.readableHighWaterMark,
      K = this.objectMode ? 16 : 16 * 1024;
    ue || ue === 0
      ? (this.highWaterMark = ue)
      : te && (ae || ae === 0)
      ? (this.highWaterMark = ae)
      : (this.highWaterMark = K),
      (this.highWaterMark = Math.floor(this.highWaterMark)),
      (this.buffer = new M()),
      (this.length = 0),
      (this.pipes = null),
      (this.pipesCount = 0),
      (this.flowing = null),
      (this.ended = !1),
      (this.endEmitted = !1),
      (this.reading = !1),
      (this.sync = !0),
      (this.needReadable = !1),
      (this.emittedReadable = !1),
      (this.readableListening = !1),
      (this.resumeScheduled = !1),
      (this.destroyed = !1),
      (this.defaultEncoding = q.defaultEncoding || "utf8"),
      (this.awaitDrain = 0),
      (this.readingMore = !1),
      (this.decoder = null),
      (this.encoding = null),
      q.encoding &&
        (A || (A = Ay().StringDecoder),
        (this.decoder = new A(q.encoding)),
        (this.encoding = q.encoding));
  }
  function T(q) {
    if (((n = n || qs()), !(this instanceof T))) return new T(q);
    (this._readableState = new B(q, this)),
      (this.readable = !0),
      q &&
        (typeof q.read == "function" && (this._read = q.read),
        typeof q.destroy == "function" && (this._destroy = q.destroy)),
      l.call(this);
  }
  Object.defineProperty(T.prototype, "destroyed", {
    get: function () {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function (q) {
      this._readableState && (this._readableState.destroyed = q);
    },
  }),
    (T.prototype.destroy = S.destroy),
    (T.prototype._undestroy = S.undestroy),
    (T.prototype._destroy = function (q, Z) {
      this.push(null), Z(q);
    }),
    (T.prototype.push = function (q, Z) {
      var te = this._readableState,
        ue;
      return (
        te.objectMode
          ? (ue = !0)
          : typeof q == "string" &&
            ((Z = Z || te.defaultEncoding),
            Z !== te.encoding && ((q = a.from(q, Z)), (Z = "")),
            (ue = !0)),
        F(this, q, Z, !1, ue)
      );
    }),
    (T.prototype.unshift = function (q) {
      return F(this, q, null, !0, !1);
    });
  function F(q, Z, te, ue, ae) {
    var K = q._readableState;
    if (Z === null) (K.reading = !1), Ae(q, K);
    else {
      var ve;
      ae || (ve = $(K, Z)),
        ve
          ? q.emit("error", ve)
          : K.objectMode || (Z && Z.length > 0)
          ? (typeof Z != "string" &&
              !K.objectMode &&
              Object.getPrototypeOf(Z) !== a.prototype &&
              (Z = v(Z)),
            ue
              ? K.endEmitted
                ? q.emit("error", new Error("stream.unshift() after end event"))
                : O(q, K, Z, !0)
              : K.ended
              ? q.emit("error", new Error("stream.push() after EOF"))
              : ((K.reading = !1),
                K.decoder && !te
                  ? ((Z = K.decoder.write(Z)),
                    K.objectMode || Z.length !== 0 ? O(q, K, Z, !1) : o(q, K))
                  : O(q, K, Z, !1)))
          : ue || (K.reading = !1);
    }
    return J(K);
  }
  function O(q, Z, te, ue) {
    Z.flowing && Z.length === 0 && !Z.sync
      ? (q.emit("data", te), q.read(0))
      : ((Z.length += Z.objectMode ? 1 : te.length),
        ue ? Z.buffer.unshift(te) : Z.buffer.push(te),
        Z.needReadable && x(q)),
      o(q, Z);
  }
  function $(q, Z) {
    var te;
    return (
      !g(Z) &&
        typeof Z != "string" &&
        Z !== void 0 &&
        !q.objectMode &&
        (te = new TypeError("Invalid non-string/buffer chunk")),
      te
    );
  }
  function J(q) {
    return !q.ended && (q.needReadable || q.length < q.highWaterMark || q.length === 0);
  }
  (T.prototype.isPaused = function () {
    return this._readableState.flowing === !1;
  }),
    (T.prototype.setEncoding = function (q) {
      return (
        A || (A = Ay().StringDecoder),
        (this._readableState.decoder = new A(q)),
        (this._readableState.encoding = q),
        this
      );
    });
  var he = 8388608;
  function de(q) {
    return (
      q >= he
        ? (q = he)
        : (q--,
          (q |= q >>> 1),
          (q |= q >>> 2),
          (q |= q >>> 4),
          (q |= q >>> 8),
          (q |= q >>> 16),
          q++),
      q
    );
  }
  function ne(q, Z) {
    return q <= 0 || (Z.length === 0 && Z.ended)
      ? 0
      : Z.objectMode
      ? 1
      : q !== q
      ? Z.flowing && Z.length
        ? Z.buffer.head.data.length
        : Z.length
      : (q > Z.highWaterMark && (Z.highWaterMark = de(q)),
        q <= Z.length ? q : Z.ended ? Z.length : ((Z.needReadable = !0), 0));
  }
  T.prototype.read = function (q) {
    _("read", q), (q = parseInt(q, 10));
    var Z = this._readableState,
      te = q;
    if (
      (q !== 0 && (Z.emittedReadable = !1),
      q === 0 && Z.needReadable && (Z.length >= Z.highWaterMark || Z.ended))
    )
      return (
        _("read: emitReadable", Z.length, Z.ended),
        Z.length === 0 && Z.ended ? z(this) : x(this),
        null
      );
    if (((q = ne(q, Z)), q === 0 && Z.ended)) return Z.length === 0 && z(this), null;
    var ue = Z.needReadable;
    _("need readable", ue),
      (Z.length === 0 || Z.length - q < Z.highWaterMark) &&
        ((ue = !0), _("length less than watermark", ue)),
      Z.ended || Z.reading
        ? ((ue = !1), _("reading or ended", ue))
        : ue &&
          (_("do read"),
          (Z.reading = !0),
          (Z.sync = !0),
          Z.length === 0 && (Z.needReadable = !0),
          this._read(Z.highWaterMark),
          (Z.sync = !1),
          Z.reading || (q = ne(te, Z)));
    var ae;
    return (
      q > 0 ? (ae = s(q, Z)) : (ae = null),
      ae === null ? ((Z.needReadable = !0), (q = 0)) : (Z.length -= q),
      Z.length === 0 && (Z.ended || (Z.needReadable = !0), te !== q && Z.ended && z(this)),
      ae !== null && this.emit("data", ae),
      ae
    );
  };
  function Ae(q, Z) {
    if (!Z.ended) {
      if (Z.decoder) {
        var te = Z.decoder.end();
        te && te.length && (Z.buffer.push(te), (Z.length += Z.objectMode ? 1 : te.length));
      }
      (Z.ended = !0), x(q);
    }
  }
  function x(q) {
    var Z = q._readableState;
    (Z.needReadable = !1),
      Z.emittedReadable ||
        (_("emitReadable", Z.flowing), (Z.emittedReadable = !0), Z.sync ? t.nextTick(r, q) : r(q));
  }
  function r(q) {
    _("emit readable"), q.emit("readable"), h(q);
  }
  function o(q, Z) {
    Z.readingMore || ((Z.readingMore = !0), t.nextTick(f, q, Z));
  }
  function f(q, Z) {
    for (
      var te = Z.length;
      !Z.reading &&
      !Z.flowing &&
      !Z.ended &&
      Z.length < Z.highWaterMark &&
      (_("maybeReadMore read 0"), q.read(0), te !== Z.length);

    )
      te = Z.length;
    Z.readingMore = !1;
  }
  (T.prototype._read = function (q) {
    this.emit("error", new Error("_read() is not implemented"));
  }),
    (T.prototype.pipe = function (q, Z) {
      var te = this,
        ue = this._readableState;
      switch (ue.pipesCount) {
        case 0:
          ue.pipes = q;
          break;
        case 1:
          ue.pipes = [ue.pipes, q];
          break;
        default:
          ue.pipes.push(q);
          break;
      }
      (ue.pipesCount += 1), _("pipe count=%d opts=%j", ue.pipesCount, Z);
      var ae = (!Z || Z.end !== !1) && q !== Et.stdout && q !== Et.stderr,
        K = ae ? Ye : xt;
      ue.endEmitted ? t.nextTick(K) : te.once("end", K), q.on("unpipe", ve);
      function ve(Ue, se) {
        _("onunpipe"), Ue === te && se && se.hasUnpiped === !1 && ((se.hasUnpiped = !0), ut());
      }
      function Ye() {
        _("onend"), q.end();
      }
      var Ce = u(te);
      q.on("drain", Ce);
      var Te = !1;
      function ut() {
        _("cleanup"),
          q.removeListener("close", Oe),
          q.removeListener("finish", je),
          q.removeListener("drain", Ce),
          q.removeListener("error", wt),
          q.removeListener("unpipe", ve),
          te.removeListener("end", Ye),
          te.removeListener("end", xt),
          te.removeListener("data", be),
          (Te = !0),
          ue.awaitDrain && (!q._writableState || q._writableState.needDrain) && Ce();
      }
      var Ie = !1;
      te.on("data", be);
      function be(Ue) {
        _("ondata"), (Ie = !1);
        var se = q.write(Ue);
        se === !1 &&
          !Ie &&
          (((ue.pipesCount === 1 && ue.pipes === q) ||
            (ue.pipesCount > 1 && G(ue.pipes, q) !== -1)) &&
            !Te &&
            (_("false write response, pause", ue.awaitDrain), ue.awaitDrain++, (Ie = !0)),
          te.pause());
      }
      function wt(Ue) {
        _("onerror", Ue),
          xt(),
          q.removeListener("error", wt),
          i(q, "error") === 0 && q.emit("error", Ue);
      }
      P(q, "error", wt);
      function Oe() {
        q.removeListener("finish", je), xt();
      }
      q.once("close", Oe);
      function je() {
        _("onfinish"), q.removeListener("close", Oe), xt();
      }
      q.once("finish", je);
      function xt() {
        _("unpipe"), te.unpipe(q);
      }
      return q.emit("pipe", te), ue.flowing || (_("pipe resume"), te.resume()), q;
    });
  function u(q) {
    return function () {
      var Z = q._readableState;
      _("pipeOnDrain", Z.awaitDrain),
        Z.awaitDrain && Z.awaitDrain--,
        Z.awaitDrain === 0 && i(q, "data") && ((Z.flowing = !0), h(q));
    };
  }
  (T.prototype.unpipe = function (q) {
    var Z = this._readableState,
      te = { hasUnpiped: !1 };
    if (Z.pipesCount === 0) return this;
    if (Z.pipesCount === 1)
      return q && q !== Z.pipes
        ? this
        : (q || (q = Z.pipes),
          (Z.pipes = null),
          (Z.pipesCount = 0),
          (Z.flowing = !1),
          q && q.emit("unpipe", this, te),
          this);
    if (!q) {
      var ue = Z.pipes,
        ae = Z.pipesCount;
      (Z.pipes = null), (Z.pipesCount = 0), (Z.flowing = !1);
      for (var K = 0; K < ae; K++) ue[K].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var ve = G(Z.pipes, q);
    return ve === -1
      ? this
      : (Z.pipes.splice(ve, 1),
        (Z.pipesCount -= 1),
        Z.pipesCount === 1 && (Z.pipes = Z.pipes[0]),
        q.emit("unpipe", this, te),
        this);
  }),
    (T.prototype.on = function (q, Z) {
      var te = l.prototype.on.call(this, q, Z);
      if (q === "data") this._readableState.flowing !== !1 && this.resume();
      else if (q === "readable") {
        var ue = this._readableState;
        !ue.endEmitted &&
          !ue.readableListening &&
          ((ue.readableListening = ue.needReadable = !0),
          (ue.emittedReadable = !1),
          ue.reading ? ue.length && x(this) : t.nextTick(d, this));
      }
      return te;
    }),
    (T.prototype.addListener = T.prototype.on);
  function d(q) {
    _("readable nexttick read 0"), q.read(0);
  }
  T.prototype.resume = function () {
    var q = this._readableState;
    return q.flowing || (_("resume"), (q.flowing = !0), y(this, q)), this;
  };
  function y(q, Z) {
    Z.resumeScheduled || ((Z.resumeScheduled = !0), t.nextTick(w, q, Z));
  }
  function w(q, Z) {
    Z.reading || (_("resume read 0"), q.read(0)),
      (Z.resumeScheduled = !1),
      (Z.awaitDrain = 0),
      q.emit("resume"),
      h(q),
      Z.flowing && !Z.reading && q.read(0);
  }
  T.prototype.pause = function () {
    return (
      _("call pause flowing=%j", this._readableState.flowing),
      this._readableState.flowing !== !1 &&
        (_("pause"), (this._readableState.flowing = !1), this.emit("pause")),
      this
    );
  };
  function h(q) {
    var Z = q._readableState;
    for (_("flow", Z.flowing); Z.flowing && q.read() !== null; );
  }
  (T.prototype.wrap = function (q) {
    var Z = this,
      te = this._readableState,
      ue = !1;
    q.on("end", function () {
      if ((_("wrapped end"), te.decoder && !te.ended)) {
        var ve = te.decoder.end();
        ve && ve.length && Z.push(ve);
      }
      Z.push(null);
    }),
      q.on("data", function (ve) {
        if (
          (_("wrapped data"),
          te.decoder && (ve = te.decoder.write(ve)),
          !(te.objectMode && ve == null) && !(!te.objectMode && (!ve || !ve.length)))
        ) {
          var Ye = Z.push(ve);
          Ye || ((ue = !0), q.pause());
        }
      });
    for (var ae in q)
      this[ae] === void 0 &&
        typeof q[ae] == "function" &&
        (this[ae] = /* @__PURE__ */ (function (ve) {
          return function () {
            return q[ve].apply(q, arguments);
          };
        })(ae));
    for (var K = 0; K < k.length; K++) q.on(k[K], this.emit.bind(this, k[K]));
    return (
      (this._read = function (ve) {
        _("wrapped _read", ve), ue && ((ue = !1), q.resume());
      }),
      this
    );
  }),
    Object.defineProperty(T.prototype, "readableHighWaterMark", {
      // making it explicit this property is not enumerable
      // because otherwise some prototype manipulation in
      // userland will fail
      enumerable: !1,
      get: function () {
        return this._readableState.highWaterMark;
      },
    }),
    (T._fromList = s);
  function s(q, Z) {
    if (Z.length === 0) return null;
    var te;
    return (
      Z.objectMode
        ? (te = Z.buffer.shift())
        : !q || q >= Z.length
        ? (Z.decoder
            ? (te = Z.buffer.join(""))
            : Z.buffer.length === 1
            ? (te = Z.buffer.head.data)
            : (te = Z.buffer.concat(Z.length)),
          Z.buffer.clear())
        : (te = m(q, Z.buffer, Z.decoder)),
      te
    );
  }
  function m(q, Z, te) {
    var ue;
    return (
      q < Z.head.data.length
        ? ((ue = Z.head.data.slice(0, q)), (Z.head.data = Z.head.data.slice(q)))
        : q === Z.head.data.length
        ? (ue = Z.shift())
        : (ue = te ? E(q, Z) : R(q, Z)),
      ue
    );
  }
  function E(q, Z) {
    var te = Z.head,
      ue = 1,
      ae = te.data;
    for (q -= ae.length; (te = te.next); ) {
      var K = te.data,
        ve = q > K.length ? K.length : q;
      if ((ve === K.length ? (ae += K) : (ae += K.slice(0, q)), (q -= ve), q === 0)) {
        ve === K.length
          ? (++ue, te.next ? (Z.head = te.next) : (Z.head = Z.tail = null))
          : ((Z.head = te), (te.data = K.slice(ve)));
        break;
      }
      ++ue;
    }
    return (Z.length -= ue), ae;
  }
  function R(q, Z) {
    var te = a.allocUnsafe(q),
      ue = Z.head,
      ae = 1;
    for (ue.data.copy(te), q -= ue.data.length; (ue = ue.next); ) {
      var K = ue.data,
        ve = q > K.length ? K.length : q;
      if ((K.copy(te, te.length - q, 0, ve), (q -= ve), q === 0)) {
        ve === K.length
          ? (++ae, ue.next ? (Z.head = ue.next) : (Z.head = Z.tail = null))
          : ((Z.head = ue), (ue.data = K.slice(ve)));
        break;
      }
      ++ae;
    }
    return (Z.length -= ae), te;
  }
  function z(q) {
    var Z = q._readableState;
    if (Z.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    Z.endEmitted || ((Z.ended = !0), t.nextTick(Q, Z, q));
  }
  function Q(q, Z) {
    !q.endEmitted && q.length === 0 && ((q.endEmitted = !0), (Z.readable = !1), Z.emit("end"));
  }
  function G(q, Z) {
    for (var te = 0, ue = q.length; te < ue; te++) if (q[te] === Z) return te;
    return -1;
  }
  return Pd;
}
var Rd, By;
function Iw() {
  if (By) return Rd;
  (By = 1), (Rd = i);
  var t = qs(),
    e = Object.create(Bf());
  (e.inherits = It()), e.inherits(i, t);
  function n(c, v) {
    var g = this._transformState;
    g.transforming = !1;
    var b = g.writecb;
    if (!b) return this.emit("error", new Error("write callback called multiple times"));
    (g.writechunk = null), (g.writecb = null), v != null && this.push(v), b(c);
    var p = this._readableState;
    (p.reading = !1), (p.needReadable || p.length < p.highWaterMark) && this._read(p.highWaterMark);
  }
  function i(c) {
    if (!(this instanceof i)) return new i(c);
    t.call(this, c),
      (this._transformState = {
        afterTransform: n.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null,
      }),
      (this._readableState.needReadable = !0),
      (this._readableState.sync = !1),
      c &&
        (typeof c.transform == "function" && (this._transform = c.transform),
        typeof c.flush == "function" && (this._flush = c.flush)),
      this.on("prefinish", l);
  }
  function l() {
    var c = this;
    typeof this._flush == "function"
      ? this._flush(function (v, g) {
          a(c, v, g);
        })
      : a(this, null, null);
  }
  (i.prototype.push = function (c, v) {
    return (this._transformState.needTransform = !1), t.prototype.push.call(this, c, v);
  }),
    (i.prototype._transform = function (c, v, g) {
      throw new Error("_transform() is not implemented");
    }),
    (i.prototype._write = function (c, v, g) {
      var b = this._transformState;
      if (((b.writecb = g), (b.writechunk = c), (b.writeencoding = v), !b.transforming)) {
        var p = this._readableState;
        (b.needTransform || p.needReadable || p.length < p.highWaterMark) &&
          this._read(p.highWaterMark);
      }
    }),
    (i.prototype._read = function (c) {
      var v = this._transformState;
      v.writechunk !== null && v.writecb && !v.transforming
        ? ((v.transforming = !0), this._transform(v.writechunk, v.writeencoding, v.afterTransform))
        : (v.needTransform = !0);
    }),
    (i.prototype._destroy = function (c, v) {
      var g = this;
      t.prototype._destroy.call(this, c, function (b) {
        v(b), g.emit("close");
      });
    });
  function a(c, v, g) {
    if (v) return c.emit("error", v);
    if ((g != null && c.push(g), c._writableState.length))
      throw new Error("Calling transform done when ws.length != 0");
    if (c._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return c.push(null);
  }
  return Rd;
}
var Id, Cy;
function $9() {
  if (Cy) return Id;
  (Cy = 1), (Id = n);
  var t = Iw(),
    e = Object.create(Bf());
  (e.inherits = It()), e.inherits(n, t);
  function n(i) {
    if (!(this instanceof n)) return new n(i);
    t.call(this, i);
  }
  return (
    (n.prototype._transform = function (i, l, a) {
      a(null, i);
    }),
    Id
  );
}
var Ty;
function H9() {
  return (
    Ty ||
      ((Ty = 1),
      (function (t, e) {
        (e = t.exports = Rw()),
          (e.Stream = e),
          (e.Readable = e),
          (e.Writable = Pw()),
          (e.Duplex = qs()),
          (e.Transform = Iw()),
          (e.PassThrough = $9());
      })(rl, rl.exports)),
    rl.exports
  );
}
var xo = { exports: {} },
  bl = { exports: {} };
bl.exports;
var Py;
function T1() {
  return (
    Py ||
      ((Py = 1),
      (function (t) {
        (function (e, n) {
          function i(o, f) {
            if (!o) throw new Error(f || "Assertion failed");
          }
          function l(o, f) {
            o.super_ = f;
            var u = function () {};
            (u.prototype = f.prototype), (o.prototype = new u()), (o.prototype.constructor = o);
          }
          function a(o, f, u) {
            if (a.isBN(o)) return o;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              o !== null &&
                ((f === "le" || f === "be") && ((u = f), (f = 10)),
                this._init(o || 0, f || 10, u || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (f) {
            return f instanceof a
              ? !0
              : f !== null &&
                  typeof f == "object" &&
                  f.constructor.wordSize === a.wordSize &&
                  Array.isArray(f.words);
          }),
            (a.max = function (f, u) {
              return f.cmp(u) > 0 ? f : u;
            }),
            (a.min = function (f, u) {
              return f.cmp(u) < 0 ? f : u;
            }),
            (a.prototype._init = function (f, u, d) {
              if (typeof f == "number") return this._initNumber(f, u, d);
              if (typeof f == "object") return this._initArray(f, u, d);
              u === "hex" && (u = 16),
                i(u === (u | 0) && u >= 2 && u <= 36),
                (f = f.toString().replace(/\s+/g, ""));
              var y = 0;
              f[0] === "-" && (y++, (this.negative = 1)),
                y < f.length &&
                  (u === 16
                    ? this._parseHex(f, y, d)
                    : (this._parseBase(f, u, y),
                      d === "le" && this._initArray(this.toArray(), u, d)));
            }),
            (a.prototype._initNumber = function (f, u, d) {
              f < 0 && ((this.negative = 1), (f = -f)),
                f < 67108864
                  ? ((this.words = [f & 67108863]), (this.length = 1))
                  : f < 4503599627370496
                  ? ((this.words = [f & 67108863, (f / 67108864) & 67108863]), (this.length = 2))
                  : (i(f < 9007199254740992),
                    (this.words = [f & 67108863, (f / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                d === "le" && this._initArray(this.toArray(), u, d);
            }),
            (a.prototype._initArray = function (f, u, d) {
              if ((i(typeof f.length == "number"), f.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(f.length / 3)), (this.words = new Array(this.length));
              for (var y = 0; y < this.length; y++) this.words[y] = 0;
              var w,
                h,
                s = 0;
              if (d === "be")
                for (y = f.length - 1, w = 0; y >= 0; y -= 3)
                  (h = f[y] | (f[y - 1] << 8) | (f[y - 2] << 16)),
                    (this.words[w] |= (h << s) & 67108863),
                    (this.words[w + 1] = (h >>> (26 - s)) & 67108863),
                    (s += 24),
                    s >= 26 && ((s -= 26), w++);
              else if (d === "le")
                for (y = 0, w = 0; y < f.length; y += 3)
                  (h = f[y] | (f[y + 1] << 8) | (f[y + 2] << 16)),
                    (this.words[w] |= (h << s) & 67108863),
                    (this.words[w + 1] = (h >>> (26 - s)) & 67108863),
                    (s += 24),
                    s >= 26 && ((s -= 26), w++);
              return this._strip();
            });
          function v(o, f) {
            var u = o.charCodeAt(f);
            if (u >= 48 && u <= 57) return u - 48;
            if (u >= 65 && u <= 70) return u - 55;
            if (u >= 97 && u <= 102) return u - 87;
            i(!1, "Invalid character in " + o);
          }
          function g(o, f, u) {
            var d = v(o, u);
            return u - 1 >= f && (d |= v(o, u - 1) << 4), d;
          }
          a.prototype._parseHex = function (f, u, d) {
            (this.length = Math.ceil((f.length - u) / 6)), (this.words = new Array(this.length));
            for (var y = 0; y < this.length; y++) this.words[y] = 0;
            var w = 0,
              h = 0,
              s;
            if (d === "be")
              for (y = f.length - 1; y >= u; y -= 2)
                (s = g(f, u, y) << w),
                  (this.words[h] |= s & 67108863),
                  w >= 18 ? ((w -= 18), (h += 1), (this.words[h] |= s >>> 26)) : (w += 8);
            else {
              var m = f.length - u;
              for (y = m % 2 === 0 ? u + 1 : u; y < f.length; y += 2)
                (s = g(f, u, y) << w),
                  (this.words[h] |= s & 67108863),
                  w >= 18 ? ((w -= 18), (h += 1), (this.words[h] |= s >>> 26)) : (w += 8);
            }
            this._strip();
          };
          function b(o, f, u, d) {
            for (var y = 0, w = 0, h = Math.min(o.length, u), s = f; s < h; s++) {
              var m = o.charCodeAt(s) - 48;
              (y *= d),
                m >= 49 ? (w = m - 49 + 10) : m >= 17 ? (w = m - 17 + 10) : (w = m),
                i(m >= 0 && w < d, "Invalid character"),
                (y += w);
            }
            return y;
          }
          (a.prototype._parseBase = function (f, u, d) {
            (this.words = [0]), (this.length = 1);
            for (var y = 0, w = 1; w <= 67108863; w *= u) y++;
            y--, (w = (w / u) | 0);
            for (
              var h = f.length - d, s = h % y, m = Math.min(h, h - s) + d, E = 0, R = d;
              R < m;
              R += y
            )
              (E = b(f, R, R + y, u)),
                this.imuln(w),
                this.words[0] + E < 67108864 ? (this.words[0] += E) : this._iaddn(E);
            if (s !== 0) {
              var z = 1;
              for (E = b(f, R, f.length, u), R = 0; R < s; R++) z *= u;
              this.imuln(z), this.words[0] + E < 67108864 ? (this.words[0] += E) : this._iaddn(E);
            }
            this._strip();
          }),
            (a.prototype.copy = function (f) {
              f.words = new Array(this.length);
              for (var u = 0; u < this.length; u++) f.words[u] = this.words[u];
              (f.length = this.length), (f.negative = this.negative), (f.red = this.red);
            });
          function p(o, f) {
            (o.words = f.words), (o.length = f.length), (o.negative = f.negative), (o.red = f.red);
          }
          if (
            ((a.prototype._move = function (f) {
              p(f, this);
            }),
            (a.prototype.clone = function () {
              var f = new a(null);
              return this.copy(f), f;
            }),
            (a.prototype._expand = function (f) {
              for (; this.length < f; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype._strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            typeof Symbol < "u" && typeof Symbol.for == "function")
          )
            try {
              a.prototype[Symbol.for("nodejs.util.inspect.custom")] = _;
            } catch {
              a.prototype.inspect = _;
            }
          else a.prototype.inspect = _;
          function _() {
            return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
          }
          var M = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            S = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            A = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (f, u) {
            (f = f || 10), (u = u | 0 || 1);
            var d;
            if (f === 16 || f === "hex") {
              d = "";
              for (var y = 0, w = 0, h = 0; h < this.length; h++) {
                var s = this.words[h],
                  m = (((s << y) | w) & 16777215).toString(16);
                (w = (s >>> (24 - y)) & 16777215),
                  (y += 2),
                  y >= 26 && ((y -= 26), h--),
                  w !== 0 || h !== this.length - 1 ? (d = M[6 - m.length] + m + d) : (d = m + d);
              }
              for (w !== 0 && (d = w.toString(16) + d); d.length % u !== 0; ) d = "0" + d;
              return this.negative !== 0 && (d = "-" + d), d;
            }
            if (f === (f | 0) && f >= 2 && f <= 36) {
              var E = S[f],
                R = A[f];
              d = "";
              var z = this.clone();
              for (z.negative = 0; !z.isZero(); ) {
                var Q = z.modrn(R).toString(f);
                (z = z.idivn(R)), z.isZero() ? (d = Q + d) : (d = M[E - Q.length] + Q + d);
              }
              for (this.isZero() && (d = "0" + d); d.length % u !== 0; ) d = "0" + d;
              return this.negative !== 0 && (d = "-" + d), d;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var f = this.words[0];
              return (
                this.length === 2
                  ? (f += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (f += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -f : f
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16, 2);
            }),
            c &&
              (a.prototype.toBuffer = function (f, u) {
                return this.toArrayLike(c, f, u);
              }),
            (a.prototype.toArray = function (f, u) {
              return this.toArrayLike(Array, f, u);
            });
          var k = function (f, u) {
            return f.allocUnsafe ? f.allocUnsafe(u) : new f(u);
          };
          (a.prototype.toArrayLike = function (f, u, d) {
            this._strip();
            var y = this.byteLength(),
              w = d || Math.max(1, y);
            i(y <= w, "byte array longer than desired length"),
              i(w > 0, "Requested array length <= 0");
            var h = k(f, w),
              s = u === "le" ? "LE" : "BE";
            return this["_toArrayLike" + s](h, y), h;
          }),
            (a.prototype._toArrayLikeLE = function (f, u) {
              for (var d = 0, y = 0, w = 0, h = 0; w < this.length; w++) {
                var s = (this.words[w] << h) | y;
                (f[d++] = s & 255),
                  d < f.length && (f[d++] = (s >> 8) & 255),
                  d < f.length && (f[d++] = (s >> 16) & 255),
                  h === 6
                    ? (d < f.length && (f[d++] = (s >> 24) & 255), (y = 0), (h = 0))
                    : ((y = s >>> 24), (h += 2));
              }
              if (d < f.length) for (f[d++] = y; d < f.length; ) f[d++] = 0;
            }),
            (a.prototype._toArrayLikeBE = function (f, u) {
              for (var d = f.length - 1, y = 0, w = 0, h = 0; w < this.length; w++) {
                var s = (this.words[w] << h) | y;
                (f[d--] = s & 255),
                  d >= 0 && (f[d--] = (s >> 8) & 255),
                  d >= 0 && (f[d--] = (s >> 16) & 255),
                  h === 6
                    ? (d >= 0 && (f[d--] = (s >> 24) & 255), (y = 0), (h = 0))
                    : ((y = s >>> 24), (h += 2));
              }
              if (d >= 0) for (f[d--] = y; d >= 0; ) f[d--] = 0;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (f) {
                  return 32 - Math.clz32(f);
                })
              : (a.prototype._countBits = function (f) {
                  var u = f,
                    d = 0;
                  return (
                    u >= 4096 && ((d += 13), (u >>>= 13)),
                    u >= 64 && ((d += 7), (u >>>= 7)),
                    u >= 8 && ((d += 4), (u >>>= 4)),
                    u >= 2 && ((d += 2), (u >>>= 2)),
                    d + u
                  );
                }),
            (a.prototype._zeroBits = function (f) {
              if (f === 0) return 26;
              var u = f,
                d = 0;
              return (
                u & 8191 || ((d += 13), (u >>>= 13)),
                u & 127 || ((d += 7), (u >>>= 7)),
                u & 15 || ((d += 4), (u >>>= 4)),
                u & 3 || ((d += 2), (u >>>= 2)),
                u & 1 || d++,
                d
              );
            }),
            (a.prototype.bitLength = function () {
              var f = this.words[this.length - 1],
                u = this._countBits(f);
              return (this.length - 1) * 26 + u;
            });
          function P(o) {
            for (var f = new Array(o.bitLength()), u = 0; u < f.length; u++) {
              var d = (u / 26) | 0,
                y = u % 26;
              f[u] = (o.words[d] >>> y) & 1;
            }
            return f;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var f = 0, u = 0; u < this.length; u++) {
              var d = this._zeroBits(this.words[u]);
              if (((f += d), d !== 26)) break;
            }
            return f;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (f) {
              return this.negative !== 0 ? this.abs().inotn(f).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (f) {
              return this.testn(f - 1) ? this.notn(f).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (f) {
              for (; this.length < f.length; ) this.words[this.length++] = 0;
              for (var u = 0; u < f.length; u++) this.words[u] = this.words[u] | f.words[u];
              return this._strip();
            }),
            (a.prototype.ior = function (f) {
              return i((this.negative | f.negative) === 0), this.iuor(f);
            }),
            (a.prototype.or = function (f) {
              return this.length > f.length ? this.clone().ior(f) : f.clone().ior(this);
            }),
            (a.prototype.uor = function (f) {
              return this.length > f.length ? this.clone().iuor(f) : f.clone().iuor(this);
            }),
            (a.prototype.iuand = function (f) {
              var u;
              this.length > f.length ? (u = f) : (u = this);
              for (var d = 0; d < u.length; d++) this.words[d] = this.words[d] & f.words[d];
              return (this.length = u.length), this._strip();
            }),
            (a.prototype.iand = function (f) {
              return i((this.negative | f.negative) === 0), this.iuand(f);
            }),
            (a.prototype.and = function (f) {
              return this.length > f.length ? this.clone().iand(f) : f.clone().iand(this);
            }),
            (a.prototype.uand = function (f) {
              return this.length > f.length ? this.clone().iuand(f) : f.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (f) {
              var u, d;
              this.length > f.length ? ((u = this), (d = f)) : ((u = f), (d = this));
              for (var y = 0; y < d.length; y++) this.words[y] = u.words[y] ^ d.words[y];
              if (this !== u) for (; y < u.length; y++) this.words[y] = u.words[y];
              return (this.length = u.length), this._strip();
            }),
            (a.prototype.ixor = function (f) {
              return i((this.negative | f.negative) === 0), this.iuxor(f);
            }),
            (a.prototype.xor = function (f) {
              return this.length > f.length ? this.clone().ixor(f) : f.clone().ixor(this);
            }),
            (a.prototype.uxor = function (f) {
              return this.length > f.length ? this.clone().iuxor(f) : f.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (f) {
              i(typeof f == "number" && f >= 0);
              var u = Math.ceil(f / 26) | 0,
                d = f % 26;
              this._expand(u), d > 0 && u--;
              for (var y = 0; y < u; y++) this.words[y] = ~this.words[y] & 67108863;
              return (
                d > 0 && (this.words[y] = ~this.words[y] & (67108863 >> (26 - d))), this._strip()
              );
            }),
            (a.prototype.notn = function (f) {
              return this.clone().inotn(f);
            }),
            (a.prototype.setn = function (f, u) {
              i(typeof f == "number" && f >= 0);
              var d = (f / 26) | 0,
                y = f % 26;
              return (
                this._expand(d + 1),
                u
                  ? (this.words[d] = this.words[d] | (1 << y))
                  : (this.words[d] = this.words[d] & ~(1 << y)),
                this._strip()
              );
            }),
            (a.prototype.iadd = function (f) {
              var u;
              if (this.negative !== 0 && f.negative === 0)
                return (
                  (this.negative = 0), (u = this.isub(f)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && f.negative !== 0)
                return (f.negative = 0), (u = this.isub(f)), (f.negative = 1), u._normSign();
              var d, y;
              this.length > f.length ? ((d = this), (y = f)) : ((d = f), (y = this));
              for (var w = 0, h = 0; h < y.length; h++)
                (u = (d.words[h] | 0) + (y.words[h] | 0) + w),
                  (this.words[h] = u & 67108863),
                  (w = u >>> 26);
              for (; w !== 0 && h < d.length; h++)
                (u = (d.words[h] | 0) + w), (this.words[h] = u & 67108863), (w = u >>> 26);
              if (((this.length = d.length), w !== 0)) (this.words[this.length] = w), this.length++;
              else if (d !== this) for (; h < d.length; h++) this.words[h] = d.words[h];
              return this;
            }),
            (a.prototype.add = function (f) {
              var u;
              return f.negative !== 0 && this.negative === 0
                ? ((f.negative = 0), (u = this.sub(f)), (f.negative ^= 1), u)
                : f.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (u = f.sub(this)), (this.negative = 1), u)
                : this.length > f.length
                ? this.clone().iadd(f)
                : f.clone().iadd(this);
            }),
            (a.prototype.isub = function (f) {
              if (f.negative !== 0) {
                f.negative = 0;
                var u = this.iadd(f);
                return (f.negative = 1), u._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(f), (this.negative = 1), this._normSign();
              var d = this.cmp(f);
              if (d === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var y, w;
              d > 0 ? ((y = this), (w = f)) : ((y = f), (w = this));
              for (var h = 0, s = 0; s < w.length; s++)
                (u = (y.words[s] | 0) - (w.words[s] | 0) + h),
                  (h = u >> 26),
                  (this.words[s] = u & 67108863);
              for (; h !== 0 && s < y.length; s++)
                (u = (y.words[s] | 0) + h), (h = u >> 26), (this.words[s] = u & 67108863);
              if (h === 0 && s < y.length && y !== this)
                for (; s < y.length; s++) this.words[s] = y.words[s];
              return (
                (this.length = Math.max(this.length, s)),
                y !== this && (this.negative = 1),
                this._strip()
              );
            }),
            (a.prototype.sub = function (f) {
              return this.clone().isub(f);
            });
          function B(o, f, u) {
            u.negative = f.negative ^ o.negative;
            var d = (o.length + f.length) | 0;
            (u.length = d), (d = (d - 1) | 0);
            var y = o.words[0] | 0,
              w = f.words[0] | 0,
              h = y * w,
              s = h & 67108863,
              m = (h / 67108864) | 0;
            u.words[0] = s;
            for (var E = 1; E < d; E++) {
              for (
                var R = m >>> 26,
                  z = m & 67108863,
                  Q = Math.min(E, f.length - 1),
                  G = Math.max(0, E - o.length + 1);
                G <= Q;
                G++
              ) {
                var q = (E - G) | 0;
                (y = o.words[q] | 0),
                  (w = f.words[G] | 0),
                  (h = y * w + z),
                  (R += (h / 67108864) | 0),
                  (z = h & 67108863);
              }
              (u.words[E] = z | 0), (m = R | 0);
            }
            return m !== 0 ? (u.words[E] = m | 0) : u.length--, u._strip();
          }
          var T = function (f, u, d) {
            var y = f.words,
              w = u.words,
              h = d.words,
              s = 0,
              m,
              E,
              R,
              z = y[0] | 0,
              Q = z & 8191,
              G = z >>> 13,
              q = y[1] | 0,
              Z = q & 8191,
              te = q >>> 13,
              ue = y[2] | 0,
              ae = ue & 8191,
              K = ue >>> 13,
              ve = y[3] | 0,
              Ye = ve & 8191,
              Ce = ve >>> 13,
              Te = y[4] | 0,
              ut = Te & 8191,
              Ie = Te >>> 13,
              be = y[5] | 0,
              wt = be & 8191,
              Oe = be >>> 13,
              je = y[6] | 0,
              xt = je & 8191,
              Ue = je >>> 13,
              se = y[7] | 0,
              oe = se & 8191,
              X = se >>> 13,
              le = y[8] | 0,
              ke = le & 8191,
              I = le >>> 13,
              C = y[9] | 0,
              L = C & 8191,
              j = C >>> 13,
              ee = w[0] | 0,
              Me = ee & 8191,
              fe = ee >>> 13,
              Se = w[1] | 0,
              ot = Se & 8191,
              we = Se >>> 13,
              Re = w[2] | 0,
              at = Re & 8191,
              Ne = Re >>> 13,
              He = w[3] | 0,
              At = He & 8191,
              Le = He >>> 13,
              Ze = w[4] | 0,
              Tt = Ze & 8191,
              Ve = Ze >>> 13,
              Je = w[5] | 0,
              Rt = Je & 8191,
              $e = Je >>> 13,
              et = w[6] | 0,
              H = et & 8191,
              V = et >>> 13,
              W = w[7] | 0,
              U = W & 8191,
              D = W >>> 13,
              re = w[8] | 0,
              ye = re & 8191,
              pe = re >>> 13,
              xe = w[9] | 0,
              tt = xe & 8191,
              Ke = xe >>> 13;
            (d.negative = f.negative ^ u.negative),
              (d.length = 19),
              (m = Math.imul(Q, Me)),
              (E = Math.imul(Q, fe)),
              (E = (E + Math.imul(G, Me)) | 0),
              (R = Math.imul(G, fe));
            var dt = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (m = Math.imul(Z, Me)),
              (E = Math.imul(Z, fe)),
              (E = (E + Math.imul(te, Me)) | 0),
              (R = Math.imul(te, fe)),
              (m = (m + Math.imul(Q, ot)) | 0),
              (E = (E + Math.imul(Q, we)) | 0),
              (E = (E + Math.imul(G, ot)) | 0),
              (R = (R + Math.imul(G, we)) | 0);
            var st = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (m = Math.imul(ae, Me)),
              (E = Math.imul(ae, fe)),
              (E = (E + Math.imul(K, Me)) | 0),
              (R = Math.imul(K, fe)),
              (m = (m + Math.imul(Z, ot)) | 0),
              (E = (E + Math.imul(Z, we)) | 0),
              (E = (E + Math.imul(te, ot)) | 0),
              (R = (R + Math.imul(te, we)) | 0),
              (m = (m + Math.imul(Q, at)) | 0),
              (E = (E + Math.imul(Q, Ne)) | 0),
              (E = (E + Math.imul(G, at)) | 0),
              (R = (R + Math.imul(G, Ne)) | 0);
            var ce = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (m = Math.imul(Ye, Me)),
              (E = Math.imul(Ye, fe)),
              (E = (E + Math.imul(Ce, Me)) | 0),
              (R = Math.imul(Ce, fe)),
              (m = (m + Math.imul(ae, ot)) | 0),
              (E = (E + Math.imul(ae, we)) | 0),
              (E = (E + Math.imul(K, ot)) | 0),
              (R = (R + Math.imul(K, we)) | 0),
              (m = (m + Math.imul(Z, at)) | 0),
              (E = (E + Math.imul(Z, Ne)) | 0),
              (E = (E + Math.imul(te, at)) | 0),
              (R = (R + Math.imul(te, Ne)) | 0),
              (m = (m + Math.imul(Q, At)) | 0),
              (E = (E + Math.imul(Q, Le)) | 0),
              (E = (E + Math.imul(G, At)) | 0),
              (R = (R + Math.imul(G, Le)) | 0);
            var N = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (m = Math.imul(ut, Me)),
              (E = Math.imul(ut, fe)),
              (E = (E + Math.imul(Ie, Me)) | 0),
              (R = Math.imul(Ie, fe)),
              (m = (m + Math.imul(Ye, ot)) | 0),
              (E = (E + Math.imul(Ye, we)) | 0),
              (E = (E + Math.imul(Ce, ot)) | 0),
              (R = (R + Math.imul(Ce, we)) | 0),
              (m = (m + Math.imul(ae, at)) | 0),
              (E = (E + Math.imul(ae, Ne)) | 0),
              (E = (E + Math.imul(K, at)) | 0),
              (R = (R + Math.imul(K, Ne)) | 0),
              (m = (m + Math.imul(Z, At)) | 0),
              (E = (E + Math.imul(Z, Le)) | 0),
              (E = (E + Math.imul(te, At)) | 0),
              (R = (R + Math.imul(te, Le)) | 0),
              (m = (m + Math.imul(Q, Tt)) | 0),
              (E = (E + Math.imul(Q, Ve)) | 0),
              (E = (E + Math.imul(G, Tt)) | 0),
              (R = (R + Math.imul(G, Ve)) | 0);
            var Y = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (m = Math.imul(wt, Me)),
              (E = Math.imul(wt, fe)),
              (E = (E + Math.imul(Oe, Me)) | 0),
              (R = Math.imul(Oe, fe)),
              (m = (m + Math.imul(ut, ot)) | 0),
              (E = (E + Math.imul(ut, we)) | 0),
              (E = (E + Math.imul(Ie, ot)) | 0),
              (R = (R + Math.imul(Ie, we)) | 0),
              (m = (m + Math.imul(Ye, at)) | 0),
              (E = (E + Math.imul(Ye, Ne)) | 0),
              (E = (E + Math.imul(Ce, at)) | 0),
              (R = (R + Math.imul(Ce, Ne)) | 0),
              (m = (m + Math.imul(ae, At)) | 0),
              (E = (E + Math.imul(ae, Le)) | 0),
              (E = (E + Math.imul(K, At)) | 0),
              (R = (R + Math.imul(K, Le)) | 0),
              (m = (m + Math.imul(Z, Tt)) | 0),
              (E = (E + Math.imul(Z, Ve)) | 0),
              (E = (E + Math.imul(te, Tt)) | 0),
              (R = (R + Math.imul(te, Ve)) | 0),
              (m = (m + Math.imul(Q, Rt)) | 0),
              (E = (E + Math.imul(Q, $e)) | 0),
              (E = (E + Math.imul(G, Rt)) | 0),
              (R = (R + Math.imul(G, $e)) | 0);
            var ie = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (m = Math.imul(xt, Me)),
              (E = Math.imul(xt, fe)),
              (E = (E + Math.imul(Ue, Me)) | 0),
              (R = Math.imul(Ue, fe)),
              (m = (m + Math.imul(wt, ot)) | 0),
              (E = (E + Math.imul(wt, we)) | 0),
              (E = (E + Math.imul(Oe, ot)) | 0),
              (R = (R + Math.imul(Oe, we)) | 0),
              (m = (m + Math.imul(ut, at)) | 0),
              (E = (E + Math.imul(ut, Ne)) | 0),
              (E = (E + Math.imul(Ie, at)) | 0),
              (R = (R + Math.imul(Ie, Ne)) | 0),
              (m = (m + Math.imul(Ye, At)) | 0),
              (E = (E + Math.imul(Ye, Le)) | 0),
              (E = (E + Math.imul(Ce, At)) | 0),
              (R = (R + Math.imul(Ce, Le)) | 0),
              (m = (m + Math.imul(ae, Tt)) | 0),
              (E = (E + Math.imul(ae, Ve)) | 0),
              (E = (E + Math.imul(K, Tt)) | 0),
              (R = (R + Math.imul(K, Ve)) | 0),
              (m = (m + Math.imul(Z, Rt)) | 0),
              (E = (E + Math.imul(Z, $e)) | 0),
              (E = (E + Math.imul(te, Rt)) | 0),
              (R = (R + Math.imul(te, $e)) | 0),
              (m = (m + Math.imul(Q, H)) | 0),
              (E = (E + Math.imul(Q, V)) | 0),
              (E = (E + Math.imul(G, H)) | 0),
              (R = (R + Math.imul(G, V)) | 0);
            var ge = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (m = Math.imul(oe, Me)),
              (E = Math.imul(oe, fe)),
              (E = (E + Math.imul(X, Me)) | 0),
              (R = Math.imul(X, fe)),
              (m = (m + Math.imul(xt, ot)) | 0),
              (E = (E + Math.imul(xt, we)) | 0),
              (E = (E + Math.imul(Ue, ot)) | 0),
              (R = (R + Math.imul(Ue, we)) | 0),
              (m = (m + Math.imul(wt, at)) | 0),
              (E = (E + Math.imul(wt, Ne)) | 0),
              (E = (E + Math.imul(Oe, at)) | 0),
              (R = (R + Math.imul(Oe, Ne)) | 0),
              (m = (m + Math.imul(ut, At)) | 0),
              (E = (E + Math.imul(ut, Le)) | 0),
              (E = (E + Math.imul(Ie, At)) | 0),
              (R = (R + Math.imul(Ie, Le)) | 0),
              (m = (m + Math.imul(Ye, Tt)) | 0),
              (E = (E + Math.imul(Ye, Ve)) | 0),
              (E = (E + Math.imul(Ce, Tt)) | 0),
              (R = (R + Math.imul(Ce, Ve)) | 0),
              (m = (m + Math.imul(ae, Rt)) | 0),
              (E = (E + Math.imul(ae, $e)) | 0),
              (E = (E + Math.imul(K, Rt)) | 0),
              (R = (R + Math.imul(K, $e)) | 0),
              (m = (m + Math.imul(Z, H)) | 0),
              (E = (E + Math.imul(Z, V)) | 0),
              (E = (E + Math.imul(te, H)) | 0),
              (R = (R + Math.imul(te, V)) | 0),
              (m = (m + Math.imul(Q, U)) | 0),
              (E = (E + Math.imul(Q, D)) | 0),
              (E = (E + Math.imul(G, U)) | 0),
              (R = (R + Math.imul(G, D)) | 0);
            var me = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (m = Math.imul(ke, Me)),
              (E = Math.imul(ke, fe)),
              (E = (E + Math.imul(I, Me)) | 0),
              (R = Math.imul(I, fe)),
              (m = (m + Math.imul(oe, ot)) | 0),
              (E = (E + Math.imul(oe, we)) | 0),
              (E = (E + Math.imul(X, ot)) | 0),
              (R = (R + Math.imul(X, we)) | 0),
              (m = (m + Math.imul(xt, at)) | 0),
              (E = (E + Math.imul(xt, Ne)) | 0),
              (E = (E + Math.imul(Ue, at)) | 0),
              (R = (R + Math.imul(Ue, Ne)) | 0),
              (m = (m + Math.imul(wt, At)) | 0),
              (E = (E + Math.imul(wt, Le)) | 0),
              (E = (E + Math.imul(Oe, At)) | 0),
              (R = (R + Math.imul(Oe, Le)) | 0),
              (m = (m + Math.imul(ut, Tt)) | 0),
              (E = (E + Math.imul(ut, Ve)) | 0),
              (E = (E + Math.imul(Ie, Tt)) | 0),
              (R = (R + Math.imul(Ie, Ve)) | 0),
              (m = (m + Math.imul(Ye, Rt)) | 0),
              (E = (E + Math.imul(Ye, $e)) | 0),
              (E = (E + Math.imul(Ce, Rt)) | 0),
              (R = (R + Math.imul(Ce, $e)) | 0),
              (m = (m + Math.imul(ae, H)) | 0),
              (E = (E + Math.imul(ae, V)) | 0),
              (E = (E + Math.imul(K, H)) | 0),
              (R = (R + Math.imul(K, V)) | 0),
              (m = (m + Math.imul(Z, U)) | 0),
              (E = (E + Math.imul(Z, D)) | 0),
              (E = (E + Math.imul(te, U)) | 0),
              (R = (R + Math.imul(te, D)) | 0),
              (m = (m + Math.imul(Q, ye)) | 0),
              (E = (E + Math.imul(Q, pe)) | 0),
              (E = (E + Math.imul(G, ye)) | 0),
              (R = (R + Math.imul(G, pe)) | 0);
            var qe = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (m = Math.imul(L, Me)),
              (E = Math.imul(L, fe)),
              (E = (E + Math.imul(j, Me)) | 0),
              (R = Math.imul(j, fe)),
              (m = (m + Math.imul(ke, ot)) | 0),
              (E = (E + Math.imul(ke, we)) | 0),
              (E = (E + Math.imul(I, ot)) | 0),
              (R = (R + Math.imul(I, we)) | 0),
              (m = (m + Math.imul(oe, at)) | 0),
              (E = (E + Math.imul(oe, Ne)) | 0),
              (E = (E + Math.imul(X, at)) | 0),
              (R = (R + Math.imul(X, Ne)) | 0),
              (m = (m + Math.imul(xt, At)) | 0),
              (E = (E + Math.imul(xt, Le)) | 0),
              (E = (E + Math.imul(Ue, At)) | 0),
              (R = (R + Math.imul(Ue, Le)) | 0),
              (m = (m + Math.imul(wt, Tt)) | 0),
              (E = (E + Math.imul(wt, Ve)) | 0),
              (E = (E + Math.imul(Oe, Tt)) | 0),
              (R = (R + Math.imul(Oe, Ve)) | 0),
              (m = (m + Math.imul(ut, Rt)) | 0),
              (E = (E + Math.imul(ut, $e)) | 0),
              (E = (E + Math.imul(Ie, Rt)) | 0),
              (R = (R + Math.imul(Ie, $e)) | 0),
              (m = (m + Math.imul(Ye, H)) | 0),
              (E = (E + Math.imul(Ye, V)) | 0),
              (E = (E + Math.imul(Ce, H)) | 0),
              (R = (R + Math.imul(Ce, V)) | 0),
              (m = (m + Math.imul(ae, U)) | 0),
              (E = (E + Math.imul(ae, D)) | 0),
              (E = (E + Math.imul(K, U)) | 0),
              (R = (R + Math.imul(K, D)) | 0),
              (m = (m + Math.imul(Z, ye)) | 0),
              (E = (E + Math.imul(Z, pe)) | 0),
              (E = (E + Math.imul(te, ye)) | 0),
              (R = (R + Math.imul(te, pe)) | 0),
              (m = (m + Math.imul(Q, tt)) | 0),
              (E = (E + Math.imul(Q, Ke)) | 0),
              (E = (E + Math.imul(G, tt)) | 0),
              (R = (R + Math.imul(G, Ke)) | 0);
            var Pe = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (m = Math.imul(L, ot)),
              (E = Math.imul(L, we)),
              (E = (E + Math.imul(j, ot)) | 0),
              (R = Math.imul(j, we)),
              (m = (m + Math.imul(ke, at)) | 0),
              (E = (E + Math.imul(ke, Ne)) | 0),
              (E = (E + Math.imul(I, at)) | 0),
              (R = (R + Math.imul(I, Ne)) | 0),
              (m = (m + Math.imul(oe, At)) | 0),
              (E = (E + Math.imul(oe, Le)) | 0),
              (E = (E + Math.imul(X, At)) | 0),
              (R = (R + Math.imul(X, Le)) | 0),
              (m = (m + Math.imul(xt, Tt)) | 0),
              (E = (E + Math.imul(xt, Ve)) | 0),
              (E = (E + Math.imul(Ue, Tt)) | 0),
              (R = (R + Math.imul(Ue, Ve)) | 0),
              (m = (m + Math.imul(wt, Rt)) | 0),
              (E = (E + Math.imul(wt, $e)) | 0),
              (E = (E + Math.imul(Oe, Rt)) | 0),
              (R = (R + Math.imul(Oe, $e)) | 0),
              (m = (m + Math.imul(ut, H)) | 0),
              (E = (E + Math.imul(ut, V)) | 0),
              (E = (E + Math.imul(Ie, H)) | 0),
              (R = (R + Math.imul(Ie, V)) | 0),
              (m = (m + Math.imul(Ye, U)) | 0),
              (E = (E + Math.imul(Ye, D)) | 0),
              (E = (E + Math.imul(Ce, U)) | 0),
              (R = (R + Math.imul(Ce, D)) | 0),
              (m = (m + Math.imul(ae, ye)) | 0),
              (E = (E + Math.imul(ae, pe)) | 0),
              (E = (E + Math.imul(K, ye)) | 0),
              (R = (R + Math.imul(K, pe)) | 0),
              (m = (m + Math.imul(Z, tt)) | 0),
              (E = (E + Math.imul(Z, Ke)) | 0),
              (E = (E + Math.imul(te, tt)) | 0),
              (R = (R + Math.imul(te, Ke)) | 0);
            var Xe = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (m = Math.imul(L, at)),
              (E = Math.imul(L, Ne)),
              (E = (E + Math.imul(j, at)) | 0),
              (R = Math.imul(j, Ne)),
              (m = (m + Math.imul(ke, At)) | 0),
              (E = (E + Math.imul(ke, Le)) | 0),
              (E = (E + Math.imul(I, At)) | 0),
              (R = (R + Math.imul(I, Le)) | 0),
              (m = (m + Math.imul(oe, Tt)) | 0),
              (E = (E + Math.imul(oe, Ve)) | 0),
              (E = (E + Math.imul(X, Tt)) | 0),
              (R = (R + Math.imul(X, Ve)) | 0),
              (m = (m + Math.imul(xt, Rt)) | 0),
              (E = (E + Math.imul(xt, $e)) | 0),
              (E = (E + Math.imul(Ue, Rt)) | 0),
              (R = (R + Math.imul(Ue, $e)) | 0),
              (m = (m + Math.imul(wt, H)) | 0),
              (E = (E + Math.imul(wt, V)) | 0),
              (E = (E + Math.imul(Oe, H)) | 0),
              (R = (R + Math.imul(Oe, V)) | 0),
              (m = (m + Math.imul(ut, U)) | 0),
              (E = (E + Math.imul(ut, D)) | 0),
              (E = (E + Math.imul(Ie, U)) | 0),
              (R = (R + Math.imul(Ie, D)) | 0),
              (m = (m + Math.imul(Ye, ye)) | 0),
              (E = (E + Math.imul(Ye, pe)) | 0),
              (E = (E + Math.imul(Ce, ye)) | 0),
              (R = (R + Math.imul(Ce, pe)) | 0),
              (m = (m + Math.imul(ae, tt)) | 0),
              (E = (E + Math.imul(ae, Ke)) | 0),
              (E = (E + Math.imul(K, tt)) | 0),
              (R = (R + Math.imul(K, Ke)) | 0);
            var We = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (m = Math.imul(L, At)),
              (E = Math.imul(L, Le)),
              (E = (E + Math.imul(j, At)) | 0),
              (R = Math.imul(j, Le)),
              (m = (m + Math.imul(ke, Tt)) | 0),
              (E = (E + Math.imul(ke, Ve)) | 0),
              (E = (E + Math.imul(I, Tt)) | 0),
              (R = (R + Math.imul(I, Ve)) | 0),
              (m = (m + Math.imul(oe, Rt)) | 0),
              (E = (E + Math.imul(oe, $e)) | 0),
              (E = (E + Math.imul(X, Rt)) | 0),
              (R = (R + Math.imul(X, $e)) | 0),
              (m = (m + Math.imul(xt, H)) | 0),
              (E = (E + Math.imul(xt, V)) | 0),
              (E = (E + Math.imul(Ue, H)) | 0),
              (R = (R + Math.imul(Ue, V)) | 0),
              (m = (m + Math.imul(wt, U)) | 0),
              (E = (E + Math.imul(wt, D)) | 0),
              (E = (E + Math.imul(Oe, U)) | 0),
              (R = (R + Math.imul(Oe, D)) | 0),
              (m = (m + Math.imul(ut, ye)) | 0),
              (E = (E + Math.imul(ut, pe)) | 0),
              (E = (E + Math.imul(Ie, ye)) | 0),
              (R = (R + Math.imul(Ie, pe)) | 0),
              (m = (m + Math.imul(Ye, tt)) | 0),
              (E = (E + Math.imul(Ye, Ke)) | 0),
              (E = (E + Math.imul(Ce, tt)) | 0),
              (R = (R + Math.imul(Ce, Ke)) | 0);
            var rt = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (m = Math.imul(L, Tt)),
              (E = Math.imul(L, Ve)),
              (E = (E + Math.imul(j, Tt)) | 0),
              (R = Math.imul(j, Ve)),
              (m = (m + Math.imul(ke, Rt)) | 0),
              (E = (E + Math.imul(ke, $e)) | 0),
              (E = (E + Math.imul(I, Rt)) | 0),
              (R = (R + Math.imul(I, $e)) | 0),
              (m = (m + Math.imul(oe, H)) | 0),
              (E = (E + Math.imul(oe, V)) | 0),
              (E = (E + Math.imul(X, H)) | 0),
              (R = (R + Math.imul(X, V)) | 0),
              (m = (m + Math.imul(xt, U)) | 0),
              (E = (E + Math.imul(xt, D)) | 0),
              (E = (E + Math.imul(Ue, U)) | 0),
              (R = (R + Math.imul(Ue, D)) | 0),
              (m = (m + Math.imul(wt, ye)) | 0),
              (E = (E + Math.imul(wt, pe)) | 0),
              (E = (E + Math.imul(Oe, ye)) | 0),
              (R = (R + Math.imul(Oe, pe)) | 0),
              (m = (m + Math.imul(ut, tt)) | 0),
              (E = (E + Math.imul(ut, Ke)) | 0),
              (E = (E + Math.imul(Ie, tt)) | 0),
              (R = (R + Math.imul(Ie, Ke)) | 0);
            var ct = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (m = Math.imul(L, Rt)),
              (E = Math.imul(L, $e)),
              (E = (E + Math.imul(j, Rt)) | 0),
              (R = Math.imul(j, $e)),
              (m = (m + Math.imul(ke, H)) | 0),
              (E = (E + Math.imul(ke, V)) | 0),
              (E = (E + Math.imul(I, H)) | 0),
              (R = (R + Math.imul(I, V)) | 0),
              (m = (m + Math.imul(oe, U)) | 0),
              (E = (E + Math.imul(oe, D)) | 0),
              (E = (E + Math.imul(X, U)) | 0),
              (R = (R + Math.imul(X, D)) | 0),
              (m = (m + Math.imul(xt, ye)) | 0),
              (E = (E + Math.imul(xt, pe)) | 0),
              (E = (E + Math.imul(Ue, ye)) | 0),
              (R = (R + Math.imul(Ue, pe)) | 0),
              (m = (m + Math.imul(wt, tt)) | 0),
              (E = (E + Math.imul(wt, Ke)) | 0),
              (E = (E + Math.imul(Oe, tt)) | 0),
              (R = (R + Math.imul(Oe, Ke)) | 0);
            var ht = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (m = Math.imul(L, H)),
              (E = Math.imul(L, V)),
              (E = (E + Math.imul(j, H)) | 0),
              (R = Math.imul(j, V)),
              (m = (m + Math.imul(ke, U)) | 0),
              (E = (E + Math.imul(ke, D)) | 0),
              (E = (E + Math.imul(I, U)) | 0),
              (R = (R + Math.imul(I, D)) | 0),
              (m = (m + Math.imul(oe, ye)) | 0),
              (E = (E + Math.imul(oe, pe)) | 0),
              (E = (E + Math.imul(X, ye)) | 0),
              (R = (R + Math.imul(X, pe)) | 0),
              (m = (m + Math.imul(xt, tt)) | 0),
              (E = (E + Math.imul(xt, Ke)) | 0),
              (E = (E + Math.imul(Ue, tt)) | 0),
              (R = (R + Math.imul(Ue, Ke)) | 0);
            var Fe = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (m = Math.imul(L, U)),
              (E = Math.imul(L, D)),
              (E = (E + Math.imul(j, U)) | 0),
              (R = Math.imul(j, D)),
              (m = (m + Math.imul(ke, ye)) | 0),
              (E = (E + Math.imul(ke, pe)) | 0),
              (E = (E + Math.imul(I, ye)) | 0),
              (R = (R + Math.imul(I, pe)) | 0),
              (m = (m + Math.imul(oe, tt)) | 0),
              (E = (E + Math.imul(oe, Ke)) | 0),
              (E = (E + Math.imul(X, tt)) | 0),
              (R = (R + Math.imul(X, Ke)) | 0);
            var ze = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (m = Math.imul(L, ye)),
              (E = Math.imul(L, pe)),
              (E = (E + Math.imul(j, ye)) | 0),
              (R = Math.imul(j, pe)),
              (m = (m + Math.imul(ke, tt)) | 0),
              (E = (E + Math.imul(ke, Ke)) | 0),
              (E = (E + Math.imul(I, tt)) | 0),
              (R = (R + Math.imul(I, Ke)) | 0);
            var lt = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            (s = (((R + (E >>> 13)) | 0) + (lt >>> 26)) | 0),
              (lt &= 67108863),
              (m = Math.imul(L, tt)),
              (E = Math.imul(L, Ke)),
              (E = (E + Math.imul(j, tt)) | 0),
              (R = Math.imul(j, Ke));
            var nt = (((s + m) | 0) + ((E & 8191) << 13)) | 0;
            return (
              (s = (((R + (E >>> 13)) | 0) + (nt >>> 26)) | 0),
              (nt &= 67108863),
              (h[0] = dt),
              (h[1] = st),
              (h[2] = ce),
              (h[3] = N),
              (h[4] = Y),
              (h[5] = ie),
              (h[6] = ge),
              (h[7] = me),
              (h[8] = qe),
              (h[9] = Pe),
              (h[10] = Xe),
              (h[11] = We),
              (h[12] = rt),
              (h[13] = ct),
              (h[14] = ht),
              (h[15] = Fe),
              (h[16] = ze),
              (h[17] = lt),
              (h[18] = nt),
              s !== 0 && ((h[19] = s), d.length++),
              d
            );
          };
          Math.imul || (T = B);
          function F(o, f, u) {
            (u.negative = f.negative ^ o.negative), (u.length = o.length + f.length);
            for (var d = 0, y = 0, w = 0; w < u.length - 1; w++) {
              var h = y;
              y = 0;
              for (
                var s = d & 67108863,
                  m = Math.min(w, f.length - 1),
                  E = Math.max(0, w - o.length + 1);
                E <= m;
                E++
              ) {
                var R = w - E,
                  z = o.words[R] | 0,
                  Q = f.words[E] | 0,
                  G = z * Q,
                  q = G & 67108863;
                (h = (h + ((G / 67108864) | 0)) | 0),
                  (q = (q + s) | 0),
                  (s = q & 67108863),
                  (h = (h + (q >>> 26)) | 0),
                  (y += h >>> 26),
                  (h &= 67108863);
              }
              (u.words[w] = s), (d = h), (h = y);
            }
            return d !== 0 ? (u.words[w] = d) : u.length--, u._strip();
          }
          function O(o, f, u) {
            return F(o, f, u);
          }
          (a.prototype.mulTo = function (f, u) {
            var d,
              y = this.length + f.length;
            return (
              this.length === 10 && f.length === 10
                ? (d = T(this, f, u))
                : y < 63
                ? (d = B(this, f, u))
                : y < 1024
                ? (d = F(this, f, u))
                : (d = O(this, f, u)),
              d
            );
          }),
            (a.prototype.mul = function (f) {
              var u = new a(null);
              return (u.words = new Array(this.length + f.length)), this.mulTo(f, u);
            }),
            (a.prototype.mulf = function (f) {
              var u = new a(null);
              return (u.words = new Array(this.length + f.length)), O(this, f, u);
            }),
            (a.prototype.imul = function (f) {
              return this.clone().mulTo(f, this);
            }),
            (a.prototype.imuln = function (f) {
              var u = f < 0;
              u && (f = -f), i(typeof f == "number"), i(f < 67108864);
              for (var d = 0, y = 0; y < this.length; y++) {
                var w = (this.words[y] | 0) * f,
                  h = (w & 67108863) + (d & 67108863);
                (d >>= 26),
                  (d += (w / 67108864) | 0),
                  (d += h >>> 26),
                  (this.words[y] = h & 67108863);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), u ? this.ineg() : this;
            }),
            (a.prototype.muln = function (f) {
              return this.clone().imuln(f);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (f) {
              var u = P(f);
              if (u.length === 0) return new a(1);
              for (var d = this, y = 0; y < u.length && u[y] === 0; y++, d = d.sqr());
              if (++y < u.length)
                for (var w = d.sqr(); y < u.length; y++, w = w.sqr()) u[y] !== 0 && (d = d.mul(w));
              return d;
            }),
            (a.prototype.iushln = function (f) {
              i(typeof f == "number" && f >= 0);
              var u = f % 26,
                d = (f - u) / 26,
                y = (67108863 >>> (26 - u)) << (26 - u),
                w;
              if (u !== 0) {
                var h = 0;
                for (w = 0; w < this.length; w++) {
                  var s = this.words[w] & y,
                    m = ((this.words[w] | 0) - s) << u;
                  (this.words[w] = m | h), (h = s >>> (26 - u));
                }
                h && ((this.words[w] = h), this.length++);
              }
              if (d !== 0) {
                for (w = this.length - 1; w >= 0; w--) this.words[w + d] = this.words[w];
                for (w = 0; w < d; w++) this.words[w] = 0;
                this.length += d;
              }
              return this._strip();
            }),
            (a.prototype.ishln = function (f) {
              return i(this.negative === 0), this.iushln(f);
            }),
            (a.prototype.iushrn = function (f, u, d) {
              i(typeof f == "number" && f >= 0);
              var y;
              u ? (y = (u - (u % 26)) / 26) : (y = 0);
              var w = f % 26,
                h = Math.min((f - w) / 26, this.length),
                s = 67108863 ^ ((67108863 >>> w) << w),
                m = d;
              if (((y -= h), (y = Math.max(0, y)), m)) {
                for (var E = 0; E < h; E++) m.words[E] = this.words[E];
                m.length = h;
              }
              if (h !== 0)
                if (this.length > h)
                  for (this.length -= h, E = 0; E < this.length; E++)
                    this.words[E] = this.words[E + h];
                else (this.words[0] = 0), (this.length = 1);
              var R = 0;
              for (E = this.length - 1; E >= 0 && (R !== 0 || E >= y); E--) {
                var z = this.words[E] | 0;
                (this.words[E] = (R << (26 - w)) | (z >>> w)), (R = z & s);
              }
              return (
                m && R !== 0 && (m.words[m.length++] = R),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this._strip()
              );
            }),
            (a.prototype.ishrn = function (f, u, d) {
              return i(this.negative === 0), this.iushrn(f, u, d);
            }),
            (a.prototype.shln = function (f) {
              return this.clone().ishln(f);
            }),
            (a.prototype.ushln = function (f) {
              return this.clone().iushln(f);
            }),
            (a.prototype.shrn = function (f) {
              return this.clone().ishrn(f);
            }),
            (a.prototype.ushrn = function (f) {
              return this.clone().iushrn(f);
            }),
            (a.prototype.testn = function (f) {
              i(typeof f == "number" && f >= 0);
              var u = f % 26,
                d = (f - u) / 26,
                y = 1 << u;
              if (this.length <= d) return !1;
              var w = this.words[d];
              return !!(w & y);
            }),
            (a.prototype.imaskn = function (f) {
              i(typeof f == "number" && f >= 0);
              var u = f % 26,
                d = (f - u) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= d)
              )
                return this;
              if ((u !== 0 && d++, (this.length = Math.min(d, this.length)), u !== 0)) {
                var y = 67108863 ^ ((67108863 >>> u) << u);
                this.words[this.length - 1] &= y;
              }
              return this._strip();
            }),
            (a.prototype.maskn = function (f) {
              return this.clone().imaskn(f);
            }),
            (a.prototype.iaddn = function (f) {
              return (
                i(typeof f == "number"),
                i(f < 67108864),
                f < 0
                  ? this.isubn(-f)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) <= f
                    ? ((this.words[0] = f - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(f), (this.negative = 1), this)
                  : this._iaddn(f)
              );
            }),
            (a.prototype._iaddn = function (f) {
              this.words[0] += f;
              for (var u = 0; u < this.length && this.words[u] >= 67108864; u++)
                (this.words[u] -= 67108864),
                  u === this.length - 1 ? (this.words[u + 1] = 1) : this.words[u + 1]++;
              return (this.length = Math.max(this.length, u + 1)), this;
            }),
            (a.prototype.isubn = function (f) {
              if ((i(typeof f == "number"), i(f < 67108864), f < 0)) return this.iaddn(-f);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(f), (this.negative = 1), this;
              if (((this.words[0] -= f), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var u = 0; u < this.length && this.words[u] < 0; u++)
                  (this.words[u] += 67108864), (this.words[u + 1] -= 1);
              return this._strip();
            }),
            (a.prototype.addn = function (f) {
              return this.clone().iaddn(f);
            }),
            (a.prototype.subn = function (f) {
              return this.clone().isubn(f);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (f, u, d) {
              var y = f.length + d,
                w;
              this._expand(y);
              var h,
                s = 0;
              for (w = 0; w < f.length; w++) {
                h = (this.words[w + d] | 0) + s;
                var m = (f.words[w] | 0) * u;
                (h -= m & 67108863),
                  (s = (h >> 26) - ((m / 67108864) | 0)),
                  (this.words[w + d] = h & 67108863);
              }
              for (; w < this.length - d; w++)
                (h = (this.words[w + d] | 0) + s),
                  (s = h >> 26),
                  (this.words[w + d] = h & 67108863);
              if (s === 0) return this._strip();
              for (i(s === -1), s = 0, w = 0; w < this.length; w++)
                (h = -(this.words[w] | 0) + s), (s = h >> 26), (this.words[w] = h & 67108863);
              return (this.negative = 1), this._strip();
            }),
            (a.prototype._wordDiv = function (f, u) {
              var d = this.length - f.length,
                y = this.clone(),
                w = f,
                h = w.words[w.length - 1] | 0,
                s = this._countBits(h);
              (d = 26 - s),
                d !== 0 && ((w = w.ushln(d)), y.iushln(d), (h = w.words[w.length - 1] | 0));
              var m = y.length - w.length,
                E;
              if (u !== "mod") {
                (E = new a(null)), (E.length = m + 1), (E.words = new Array(E.length));
                for (var R = 0; R < E.length; R++) E.words[R] = 0;
              }
              var z = y.clone()._ishlnsubmul(w, 1, m);
              z.negative === 0 && ((y = z), E && (E.words[m] = 1));
              for (var Q = m - 1; Q >= 0; Q--) {
                var G = (y.words[w.length + Q] | 0) * 67108864 + (y.words[w.length + Q - 1] | 0);
                for (
                  G = Math.min((G / h) | 0, 67108863), y._ishlnsubmul(w, G, Q);
                  y.negative !== 0;

                )
                  G--, (y.negative = 0), y._ishlnsubmul(w, 1, Q), y.isZero() || (y.negative ^= 1);
                E && (E.words[Q] = G);
              }
              return (
                E && E._strip(),
                y._strip(),
                u !== "div" && d !== 0 && y.iushrn(d),
                {
                  div: E || null,
                  mod: y,
                }
              );
            }),
            (a.prototype.divmod = function (f, u, d) {
              if ((i(!f.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var y, w, h;
              return this.negative !== 0 && f.negative === 0
                ? ((h = this.neg().divmod(f, u)),
                  u !== "mod" && (y = h.div.neg()),
                  u !== "div" && ((w = h.mod.neg()), d && w.negative !== 0 && w.iadd(f)),
                  {
                    div: y,
                    mod: w,
                  })
                : this.negative === 0 && f.negative !== 0
                ? ((h = this.divmod(f.neg(), u)),
                  u !== "mod" && (y = h.div.neg()),
                  {
                    div: y,
                    mod: h.mod,
                  })
                : this.negative & f.negative
                ? ((h = this.neg().divmod(f.neg(), u)),
                  u !== "div" && ((w = h.mod.neg()), d && w.negative !== 0 && w.isub(f)),
                  {
                    div: h.div,
                    mod: w,
                  })
                : f.length > this.length || this.cmp(f) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : f.length === 1
                ? u === "div"
                  ? {
                      div: this.divn(f.words[0]),
                      mod: null,
                    }
                  : u === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modrn(f.words[0])),
                    }
                  : {
                      div: this.divn(f.words[0]),
                      mod: new a(this.modrn(f.words[0])),
                    }
                : this._wordDiv(f, u);
            }),
            (a.prototype.div = function (f) {
              return this.divmod(f, "div", !1).div;
            }),
            (a.prototype.mod = function (f) {
              return this.divmod(f, "mod", !1).mod;
            }),
            (a.prototype.umod = function (f) {
              return this.divmod(f, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (f) {
              var u = this.divmod(f);
              if (u.mod.isZero()) return u.div;
              var d = u.div.negative !== 0 ? u.mod.isub(f) : u.mod,
                y = f.ushrn(1),
                w = f.andln(1),
                h = d.cmp(y);
              return h < 0 || (w === 1 && h === 0)
                ? u.div
                : u.div.negative !== 0
                ? u.div.isubn(1)
                : u.div.iaddn(1);
            }),
            (a.prototype.modrn = function (f) {
              var u = f < 0;
              u && (f = -f), i(f <= 67108863);
              for (var d = (1 << 26) % f, y = 0, w = this.length - 1; w >= 0; w--)
                y = (d * y + (this.words[w] | 0)) % f;
              return u ? -y : y;
            }),
            (a.prototype.modn = function (f) {
              return this.modrn(f);
            }),
            (a.prototype.idivn = function (f) {
              var u = f < 0;
              u && (f = -f), i(f <= 67108863);
              for (var d = 0, y = this.length - 1; y >= 0; y--) {
                var w = (this.words[y] | 0) + d * 67108864;
                (this.words[y] = (w / f) | 0), (d = w % f);
              }
              return this._strip(), u ? this.ineg() : this;
            }),
            (a.prototype.divn = function (f) {
              return this.clone().idivn(f);
            }),
            (a.prototype.egcd = function (f) {
              i(f.negative === 0), i(!f.isZero());
              var u = this,
                d = f.clone();
              u.negative !== 0 ? (u = u.umod(f)) : (u = u.clone());
              for (
                var y = new a(1), w = new a(0), h = new a(0), s = new a(1), m = 0;
                u.isEven() && d.isEven();

              )
                u.iushrn(1), d.iushrn(1), ++m;
              for (var E = d.clone(), R = u.clone(); !u.isZero(); ) {
                for (var z = 0, Q = 1; !(u.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (u.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(E), w.isub(R)), y.iushrn(1), w.iushrn(1);
                for (var G = 0, q = 1; !(d.words[0] & q) && G < 26; ++G, q <<= 1);
                if (G > 0)
                  for (d.iushrn(G); G-- > 0; )
                    (h.isOdd() || s.isOdd()) && (h.iadd(E), s.isub(R)), h.iushrn(1), s.iushrn(1);
                u.cmp(d) >= 0
                  ? (u.isub(d), y.isub(h), w.isub(s))
                  : (d.isub(u), h.isub(y), s.isub(w));
              }
              return {
                a: h,
                b: s,
                gcd: d.iushln(m),
              };
            }),
            (a.prototype._invmp = function (f) {
              i(f.negative === 0), i(!f.isZero());
              var u = this,
                d = f.clone();
              u.negative !== 0 ? (u = u.umod(f)) : (u = u.clone());
              for (
                var y = new a(1), w = new a(0), h = d.clone();
                u.cmpn(1) > 0 && d.cmpn(1) > 0;

              ) {
                for (var s = 0, m = 1; !(u.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (u.iushrn(s); s-- > 0; ) y.isOdd() && y.iadd(h), y.iushrn(1);
                for (var E = 0, R = 1; !(d.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0) for (d.iushrn(E); E-- > 0; ) w.isOdd() && w.iadd(h), w.iushrn(1);
                u.cmp(d) >= 0 ? (u.isub(d), y.isub(w)) : (d.isub(u), w.isub(y));
              }
              var z;
              return u.cmpn(1) === 0 ? (z = y) : (z = w), z.cmpn(0) < 0 && z.iadd(f), z;
            }),
            (a.prototype.gcd = function (f) {
              if (this.isZero()) return f.abs();
              if (f.isZero()) return this.abs();
              var u = this.clone(),
                d = f.clone();
              (u.negative = 0), (d.negative = 0);
              for (var y = 0; u.isEven() && d.isEven(); y++) u.iushrn(1), d.iushrn(1);
              do {
                for (; u.isEven(); ) u.iushrn(1);
                for (; d.isEven(); ) d.iushrn(1);
                var w = u.cmp(d);
                if (w < 0) {
                  var h = u;
                  (u = d), (d = h);
                } else if (w === 0 || d.cmpn(1) === 0) break;
                u.isub(d);
              } while (!0);
              return d.iushln(y);
            }),
            (a.prototype.invm = function (f) {
              return this.egcd(f).a.umod(f);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (f) {
              return this.words[0] & f;
            }),
            (a.prototype.bincn = function (f) {
              i(typeof f == "number");
              var u = f % 26,
                d = (f - u) / 26,
                y = 1 << u;
              if (this.length <= d) return this._expand(d + 1), (this.words[d] |= y), this;
              for (var w = y, h = d; w !== 0 && h < this.length; h++) {
                var s = this.words[h] | 0;
                (s += w), (w = s >>> 26), (s &= 67108863), (this.words[h] = s);
              }
              return w !== 0 && ((this.words[h] = w), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (f) {
              var u = f < 0;
              if (this.negative !== 0 && !u) return -1;
              if (this.negative === 0 && u) return 1;
              this._strip();
              var d;
              if (this.length > 1) d = 1;
              else {
                u && (f = -f), i(f <= 67108863, "Number is too big");
                var y = this.words[0] | 0;
                d = y === f ? 0 : y < f ? -1 : 1;
              }
              return this.negative !== 0 ? -d | 0 : d;
            }),
            (a.prototype.cmp = function (f) {
              if (this.negative !== 0 && f.negative === 0) return -1;
              if (this.negative === 0 && f.negative !== 0) return 1;
              var u = this.ucmp(f);
              return this.negative !== 0 ? -u | 0 : u;
            }),
            (a.prototype.ucmp = function (f) {
              if (this.length > f.length) return 1;
              if (this.length < f.length) return -1;
              for (var u = 0, d = this.length - 1; d >= 0; d--) {
                var y = this.words[d] | 0,
                  w = f.words[d] | 0;
                if (y !== w) {
                  y < w ? (u = -1) : y > w && (u = 1);
                  break;
                }
              }
              return u;
            }),
            (a.prototype.gtn = function (f) {
              return this.cmpn(f) === 1;
            }),
            (a.prototype.gt = function (f) {
              return this.cmp(f) === 1;
            }),
            (a.prototype.gten = function (f) {
              return this.cmpn(f) >= 0;
            }),
            (a.prototype.gte = function (f) {
              return this.cmp(f) >= 0;
            }),
            (a.prototype.ltn = function (f) {
              return this.cmpn(f) === -1;
            }),
            (a.prototype.lt = function (f) {
              return this.cmp(f) === -1;
            }),
            (a.prototype.lten = function (f) {
              return this.cmpn(f) <= 0;
            }),
            (a.prototype.lte = function (f) {
              return this.cmp(f) <= 0;
            }),
            (a.prototype.eqn = function (f) {
              return this.cmpn(f) === 0;
            }),
            (a.prototype.eq = function (f) {
              return this.cmp(f) === 0;
            }),
            (a.red = function (f) {
              return new x(f);
            }),
            (a.prototype.toRed = function (f) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                f.convertTo(this)._forceRed(f)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (f) {
              return (this.red = f), this;
            }),
            (a.prototype.forceRed = function (f) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(f);
            }),
            (a.prototype.redAdd = function (f) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, f);
            }),
            (a.prototype.redIAdd = function (f) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, f);
            }),
            (a.prototype.redSub = function (f) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, f);
            }),
            (a.prototype.redISub = function (f) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, f);
            }),
            (a.prototype.redShl = function (f) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, f);
            }),
            (a.prototype.redMul = function (f) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, f),
                this.red.mul(this, f)
              );
            }),
            (a.prototype.redIMul = function (f) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, f),
                this.red.imul(this, f)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (f) {
              return (
                i(this.red && !f.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, f)
              );
            });
          var $ = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function J(o, f) {
            (this.name = o),
              (this.p = new a(f, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (J.prototype._tmp = function () {
            var f = new a(null);
            return (f.words = new Array(Math.ceil(this.n / 13))), f;
          }),
            (J.prototype.ireduce = function (f) {
              var u = f,
                d;
              do
                this.split(u, this.tmp),
                  (u = this.imulK(u)),
                  (u = u.iadd(this.tmp)),
                  (d = u.bitLength());
              while (d > this.n);
              var y = d < this.n ? -1 : u.ucmp(this.p);
              return (
                y === 0
                  ? ((u.words[0] = 0), (u.length = 1))
                  : y > 0
                  ? u.isub(this.p)
                  : u.strip !== void 0
                  ? u.strip()
                  : u._strip(),
                u
              );
            }),
            (J.prototype.split = function (f, u) {
              f.iushrn(this.n, 0, u);
            }),
            (J.prototype.imulK = function (f) {
              return f.imul(this.k);
            });
          function he() {
            J.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l(he, J),
            (he.prototype.split = function (f, u) {
              for (var d = 4194303, y = Math.min(f.length, 9), w = 0; w < y; w++)
                u.words[w] = f.words[w];
              if (((u.length = y), f.length <= 9)) {
                (f.words[0] = 0), (f.length = 1);
                return;
              }
              var h = f.words[9];
              for (u.words[u.length++] = h & d, w = 10; w < f.length; w++) {
                var s = f.words[w] | 0;
                (f.words[w - 10] = ((s & d) << 4) | (h >>> 22)), (h = s);
              }
              (h >>>= 22),
                (f.words[w - 10] = h),
                h === 0 && f.length > 10 ? (f.length -= 10) : (f.length -= 9);
            }),
            (he.prototype.imulK = function (f) {
              (f.words[f.length] = 0), (f.words[f.length + 1] = 0), (f.length += 2);
              for (var u = 0, d = 0; d < f.length; d++) {
                var y = f.words[d] | 0;
                (u += y * 977), (f.words[d] = u & 67108863), (u = y * 64 + ((u / 67108864) | 0));
              }
              return (
                f.words[f.length - 1] === 0 &&
                  (f.length--, f.words[f.length - 1] === 0 && f.length--),
                f
              );
            });
          function de() {
            J.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(de, J);
          function ne() {
            J.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(ne, J);
          function Ae() {
            J.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(Ae, J),
            (Ae.prototype.imulK = function (f) {
              for (var u = 0, d = 0; d < f.length; d++) {
                var y = (f.words[d] | 0) * 19 + u,
                  w = y & 67108863;
                (y >>>= 26), (f.words[d] = w), (u = y);
              }
              return u !== 0 && (f.words[f.length++] = u), f;
            }),
            (a._prime = function (f) {
              if ($[f]) return $[f];
              var u;
              if (f === "k256") u = new he();
              else if (f === "p224") u = new de();
              else if (f === "p192") u = new ne();
              else if (f === "p25519") u = new Ae();
              else throw new Error("Unknown prime " + f);
              return ($[f] = u), u;
            });
          function x(o) {
            if (typeof o == "string") {
              var f = a._prime(o);
              (this.m = f.p), (this.prime = f);
            } else i(o.gtn(1), "modulus must be greater than 1"), (this.m = o), (this.prime = null);
          }
          (x.prototype._verify1 = function (f) {
            i(f.negative === 0, "red works only with positives"),
              i(f.red, "red works only with red numbers");
          }),
            (x.prototype._verify2 = function (f, u) {
              i((f.negative | u.negative) === 0, "red works only with positives"),
                i(f.red && f.red === u.red, "red works only with red numbers");
            }),
            (x.prototype.imod = function (f) {
              return this.prime
                ? this.prime.ireduce(f)._forceRed(this)
                : (p(f, f.umod(this.m)._forceRed(this)), f);
            }),
            (x.prototype.neg = function (f) {
              return f.isZero() ? f.clone() : this.m.sub(f)._forceRed(this);
            }),
            (x.prototype.add = function (f, u) {
              this._verify2(f, u);
              var d = f.add(u);
              return d.cmp(this.m) >= 0 && d.isub(this.m), d._forceRed(this);
            }),
            (x.prototype.iadd = function (f, u) {
              this._verify2(f, u);
              var d = f.iadd(u);
              return d.cmp(this.m) >= 0 && d.isub(this.m), d;
            }),
            (x.prototype.sub = function (f, u) {
              this._verify2(f, u);
              var d = f.sub(u);
              return d.cmpn(0) < 0 && d.iadd(this.m), d._forceRed(this);
            }),
            (x.prototype.isub = function (f, u) {
              this._verify2(f, u);
              var d = f.isub(u);
              return d.cmpn(0) < 0 && d.iadd(this.m), d;
            }),
            (x.prototype.shl = function (f, u) {
              return this._verify1(f), this.imod(f.ushln(u));
            }),
            (x.prototype.imul = function (f, u) {
              return this._verify2(f, u), this.imod(f.imul(u));
            }),
            (x.prototype.mul = function (f, u) {
              return this._verify2(f, u), this.imod(f.mul(u));
            }),
            (x.prototype.isqr = function (f) {
              return this.imul(f, f.clone());
            }),
            (x.prototype.sqr = function (f) {
              return this.mul(f, f);
            }),
            (x.prototype.sqrt = function (f) {
              if (f.isZero()) return f.clone();
              var u = this.m.andln(3);
              if ((i(u % 2 === 1), u === 3)) {
                var d = this.m.add(new a(1)).iushrn(2);
                return this.pow(f, d);
              }
              for (var y = this.m.subn(1), w = 0; !y.isZero() && y.andln(1) === 0; )
                w++, y.iushrn(1);
              i(!y.isZero());
              var h = new a(1).toRed(this),
                s = h.redNeg(),
                m = this.m.subn(1).iushrn(1),
                E = this.m.bitLength();
              for (E = new a(2 * E * E).toRed(this); this.pow(E, m).cmp(s) !== 0; ) E.redIAdd(s);
              for (
                var R = this.pow(E, y),
                  z = this.pow(f, y.addn(1).iushrn(1)),
                  Q = this.pow(f, y),
                  G = w;
                Q.cmp(h) !== 0;

              ) {
                for (var q = Q, Z = 0; q.cmp(h) !== 0; Z++) q = q.redSqr();
                i(Z < G);
                var te = this.pow(R, new a(1).iushln(G - Z - 1));
                (z = z.redMul(te)), (R = te.redSqr()), (Q = Q.redMul(R)), (G = Z);
              }
              return z;
            }),
            (x.prototype.invm = function (f) {
              var u = f._invmp(this.m);
              return u.negative !== 0 ? ((u.negative = 0), this.imod(u).redNeg()) : this.imod(u);
            }),
            (x.prototype.pow = function (f, u) {
              if (u.isZero()) return new a(1).toRed(this);
              if (u.cmpn(1) === 0) return f.clone();
              var d = 4,
                y = new Array(1 << d);
              (y[0] = new a(1).toRed(this)), (y[1] = f);
              for (var w = 2; w < y.length; w++) y[w] = this.mul(y[w - 1], f);
              var h = y[0],
                s = 0,
                m = 0,
                E = u.bitLength() % 26;
              for (E === 0 && (E = 26), w = u.length - 1; w >= 0; w--) {
                for (var R = u.words[w], z = E - 1; z >= 0; z--) {
                  var Q = (R >> z) & 1;
                  if ((h !== y[0] && (h = this.sqr(h)), Q === 0 && s === 0)) {
                    m = 0;
                    continue;
                  }
                  (s <<= 1),
                    (s |= Q),
                    m++,
                    !(m !== d && (w !== 0 || z !== 0)) &&
                      ((h = this.mul(h, y[s])), (m = 0), (s = 0));
                }
                E = 26;
              }
              return h;
            }),
            (x.prototype.convertTo = function (f) {
              var u = f.umod(this.m);
              return u === f ? u.clone() : u;
            }),
            (x.prototype.convertFrom = function (f) {
              var u = f.clone();
              return (u.red = null), u;
            }),
            (a.mont = function (f) {
              return new r(f);
            });
          function r(o) {
            x.call(this, o),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(r, x),
            (r.prototype.convertTo = function (f) {
              return this.imod(f.ushln(this.shift));
            }),
            (r.prototype.convertFrom = function (f) {
              var u = this.imod(f.mul(this.rinv));
              return (u.red = null), u;
            }),
            (r.prototype.imul = function (f, u) {
              if (f.isZero() || u.isZero()) return (f.words[0] = 0), (f.length = 1), f;
              var d = f.imul(u),
                y = d.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                w = d.isub(y).iushrn(this.shift),
                h = w;
              return (
                w.cmp(this.m) >= 0 ? (h = w.isub(this.m)) : w.cmpn(0) < 0 && (h = w.iadd(this.m)),
                h._forceRed(this)
              );
            }),
            (r.prototype.mul = function (f, u) {
              if (f.isZero() || u.isZero()) return new a(0)._forceRed(this);
              var d = f.mul(u),
                y = d.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                w = d.isub(y).iushrn(this.shift),
                h = w;
              return (
                w.cmp(this.m) >= 0 ? (h = w.isub(this.m)) : w.cmpn(0) < 0 && (h = w.iadd(this.m)),
                h._forceRed(this)
              );
            }),
            (r.prototype.invm = function (f) {
              var u = this.imod(f._invmp(this.m).mul(this.r2));
              return u._forceRed(this);
            });
        })(t, mt);
      })(bl)),
    bl.exports
  );
}
var Od, Ry;
function P1() {
  if (Ry) return Od;
  Ry = 1;
  var t = T1(),
    e = so();
  function n(a) {
    var c = i(a),
      v = c.toRed(t.mont(a.modulus)).redPow(new t(a.publicExponent)).fromRed();
    return { blinder: v, unblinder: c.invm(a.modulus) };
  }
  function i(a) {
    var c = a.modulus.byteLength(),
      v;
    do v = new t(e(c));
    while (v.cmp(a.modulus) >= 0 || !v.umod(a.prime1) || !v.umod(a.prime2));
    return v;
  }
  function l(a, c) {
    var v = n(c),
      g = c.modulus.byteLength(),
      b = new t(a).mul(v.blinder).umod(c.modulus),
      p = b.toRed(t.mont(c.prime1)),
      _ = b.toRed(t.mont(c.prime2)),
      M = c.coefficient,
      S = c.prime1,
      A = c.prime2,
      k = p.redPow(c.exponent1).fromRed(),
      P = _.redPow(c.exponent2).fromRed(),
      B = k.isub(P).imul(M).umod(S).imul(A);
    return P.iadd(B).imul(v.unblinder).umod(c.modulus).toArrayLike(Qe, "be", g);
  }
  return (l.getr = i), (Od = l), Od;
}
var Ud = {};
const V9 = "elliptic",
  W9 = "6.5.5",
  K9 = "EC cryptography",
  Z9 = "lib/elliptic.js",
  G9 = ["lib"],
  Y9 = {
    lint: "eslint lib test",
    "lint:fix": "npm run lint -- --fix",
    unit: "istanbul test _mocha --reporter=spec test/index.js",
    test: "npm run lint && npm run unit",
    version: "grunt dist && git add dist/",
  },
  J9 = {
    type: "git",
    url: "git@github.com:indutny/elliptic",
  },
  Q9 = ["EC", "Elliptic", "curve", "Cryptography"],
  X9 = "Fedor Indutny <fedor@indutny.com>",
  e7 = "MIT",
  t7 = {
    url: "https://github.com/indutny/elliptic/issues",
  },
  r7 = "https://github.com/indutny/elliptic",
  n7 = {
    brfs: "^2.0.2",
    coveralls: "^3.1.0",
    eslint: "^7.6.0",
    grunt: "^1.2.1",
    "grunt-browserify": "^5.3.0",
    "grunt-cli": "^1.3.2",
    "grunt-contrib-connect": "^3.0.0",
    "grunt-contrib-copy": "^1.0.0",
    "grunt-contrib-uglify": "^5.0.0",
    "grunt-mocha-istanbul": "^5.0.2",
    "grunt-saucelabs": "^9.0.1",
    istanbul: "^0.4.5",
    mocha: "^8.0.1",
  },
  i7 = {
    "bn.js": "^4.11.9",
    brorand: "^1.1.0",
    "hash.js": "^1.0.0",
    "hmac-drbg": "^1.0.1",
    inherits: "^2.0.4",
    "minimalistic-assert": "^1.0.1",
    "minimalistic-crypto-utils": "^1.0.1",
  },
  a7 = {
    name: V9,
    version: W9,
    description: K9,
    main: Z9,
    files: G9,
    scripts: Y9,
    repository: J9,
    keywords: Q9,
    author: X9,
    license: e7,
    bugs: t7,
    homepage: r7,
    devDependencies: n7,
    dependencies: i7,
  };
var Nd = {},
  wl = { exports: {} };
wl.exports;
var Iy;
function Ai() {
  return (
    Iy ||
      ((Iy = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(wl)),
    wl.exports
  );
}
var Dd = {},
  Oy;
function Ow() {
  return (
    Oy ||
      ((Oy = 1),
      (function (t) {
        var e = t;
        function n(a, c) {
          if (Array.isArray(a)) return a.slice();
          if (!a) return [];
          var v = [];
          if (typeof a != "string") {
            for (var g = 0; g < a.length; g++) v[g] = a[g] | 0;
            return v;
          }
          if (c === "hex") {
            (a = a.replace(/[^a-z0-9]+/gi, "")), a.length % 2 !== 0 && (a = "0" + a);
            for (var g = 0; g < a.length; g += 2) v.push(parseInt(a[g] + a[g + 1], 16));
          } else
            for (var g = 0; g < a.length; g++) {
              var b = a.charCodeAt(g),
                p = b >> 8,
                _ = b & 255;
              p ? v.push(p, _) : v.push(_);
            }
          return v;
        }
        e.toArray = n;
        function i(a) {
          return a.length === 1 ? "0" + a : a;
        }
        e.zero2 = i;
        function l(a) {
          for (var c = "", v = 0; v < a.length; v++) c += i(a[v].toString(16));
          return c;
        }
        (e.toHex = l),
          (e.encode = function (c, v) {
            return v === "hex" ? l(c) : c;
          });
      })(Dd)),
    Dd
  );
}
var Uy;
function An() {
  return (
    Uy ||
      ((Uy = 1),
      (function (t) {
        var e = t,
          n = Ai(),
          i = En(),
          l = Ow();
        (e.assert = i),
          (e.toArray = l.toArray),
          (e.zero2 = l.zero2),
          (e.toHex = l.toHex),
          (e.encode = l.encode);
        function a(p, _, M) {
          var S = new Array(Math.max(p.bitLength(), M) + 1),
            A;
          for (A = 0; A < S.length; A += 1) S[A] = 0;
          var k = 1 << (_ + 1),
            P = p.clone();
          for (A = 0; A < S.length; A++) {
            var B,
              T = P.andln(k - 1);
            P.isOdd() ? (T > (k >> 1) - 1 ? (B = (k >> 1) - T) : (B = T), P.isubn(B)) : (B = 0),
              (S[A] = B),
              P.iushrn(1);
          }
          return S;
        }
        e.getNAF = a;
        function c(p, _) {
          var M = [[], []];
          (p = p.clone()), (_ = _.clone());
          for (var S = 0, A = 0, k; p.cmpn(-S) > 0 || _.cmpn(-A) > 0; ) {
            var P = (p.andln(3) + S) & 3,
              B = (_.andln(3) + A) & 3;
            P === 3 && (P = -1), B === 3 && (B = -1);
            var T;
            P & 1
              ? ((k = (p.andln(7) + S) & 7), (k === 3 || k === 5) && B === 2 ? (T = -P) : (T = P))
              : (T = 0),
              M[0].push(T);
            var F;
            B & 1
              ? ((k = (_.andln(7) + A) & 7), (k === 3 || k === 5) && P === 2 ? (F = -B) : (F = B))
              : (F = 0),
              M[1].push(F),
              2 * S === T + 1 && (S = 1 - S),
              2 * A === F + 1 && (A = 1 - A),
              p.iushrn(1),
              _.iushrn(1);
          }
          return M;
        }
        e.getJSF = c;
        function v(p, _, M) {
          var S = "_" + _;
          p.prototype[_] = function () {
            return this[S] !== void 0 ? this[S] : (this[S] = M.call(this));
          };
        }
        e.cachedProperty = v;
        function g(p) {
          return typeof p == "string" ? e.toArray(p, "hex") : p;
        }
        e.parseBytes = g;
        function b(p) {
          return new n(p, "hex", "le");
        }
        e.intFromLE = b;
      })(Nd)),
    Nd
  );
}
var Ld = {},
  Fd,
  Ny;
function Nu() {
  if (Ny) return Fd;
  Ny = 1;
  var t = Ai(),
    e = An(),
    n = e.getNAF,
    i = e.getJSF,
    l = e.assert;
  function a(v, g) {
    (this.type = v),
      (this.p = new t(g.p, 16)),
      (this.red = g.prime ? t.red(g.prime) : t.mont(this.p)),
      (this.zero = new t(0).toRed(this.red)),
      (this.one = new t(1).toRed(this.red)),
      (this.two = new t(2).toRed(this.red)),
      (this.n = g.n && new t(g.n, 16)),
      (this.g = g.g && this.pointFromJSON(g.g, g.gRed)),
      (this._wnafT1 = new Array(4)),
      (this._wnafT2 = new Array(4)),
      (this._wnafT3 = new Array(4)),
      (this._wnafT4 = new Array(4)),
      (this._bitLength = this.n ? this.n.bitLength() : 0);
    var b = this.n && this.p.div(this.n);
    !b || b.cmpn(100) > 0
      ? (this.redN = null)
      : ((this._maxwellTrick = !0), (this.redN = this.n.toRed(this.red)));
  }
  (Fd = a),
    (a.prototype.point = function () {
      throw new Error("Not implemented");
    }),
    (a.prototype.validate = function () {
      throw new Error("Not implemented");
    }),
    (a.prototype._fixedNafMul = function (g, b) {
      l(g.precomputed);
      var p = g._getDoubles(),
        _ = n(b, 1, this._bitLength),
        M = (1 << (p.step + 1)) - (p.step % 2 === 0 ? 2 : 1);
      M /= 3;
      var S = [],
        A,
        k;
      for (A = 0; A < _.length; A += p.step) {
        k = 0;
        for (var P = A + p.step - 1; P >= A; P--) k = (k << 1) + _[P];
        S.push(k);
      }
      for (
        var B = this.jpoint(null, null, null), T = this.jpoint(null, null, null), F = M;
        F > 0;
        F--
      ) {
        for (A = 0; A < S.length; A++)
          (k = S[A]),
            k === F
              ? (T = T.mixedAdd(p.points[A]))
              : k === -F && (T = T.mixedAdd(p.points[A].neg()));
        B = B.add(T);
      }
      return B.toP();
    }),
    (a.prototype._wnafMul = function (g, b) {
      var p = 4,
        _ = g._getNAFPoints(p);
      p = _.wnd;
      for (
        var M = _.points,
          S = n(b, p, this._bitLength),
          A = this.jpoint(null, null, null),
          k = S.length - 1;
        k >= 0;
        k--
      ) {
        for (var P = 0; k >= 0 && S[k] === 0; k--) P++;
        if ((k >= 0 && P++, (A = A.dblp(P)), k < 0)) break;
        var B = S[k];
        l(B !== 0),
          g.type === "affine"
            ? B > 0
              ? (A = A.mixedAdd(M[(B - 1) >> 1]))
              : (A = A.mixedAdd(M[(-B - 1) >> 1].neg()))
            : B > 0
            ? (A = A.add(M[(B - 1) >> 1]))
            : (A = A.add(M[(-B - 1) >> 1].neg()));
      }
      return g.type === "affine" ? A.toP() : A;
    }),
    (a.prototype._wnafMulAdd = function (g, b, p, _, M) {
      var S = this._wnafT1,
        A = this._wnafT2,
        k = this._wnafT3,
        P = 0,
        B,
        T,
        F;
      for (B = 0; B < _; B++) {
        F = b[B];
        var O = F._getNAFPoints(g);
        (S[B] = O.wnd), (A[B] = O.points);
      }
      for (B = _ - 1; B >= 1; B -= 2) {
        var $ = B - 1,
          J = B;
        if (S[$] !== 1 || S[J] !== 1) {
          (k[$] = n(p[$], S[$], this._bitLength)),
            (k[J] = n(p[J], S[J], this._bitLength)),
            (P = Math.max(k[$].length, P)),
            (P = Math.max(k[J].length, P));
          continue;
        }
        var he = [
          b[$],
          /* 1 */
          null,
          /* 3 */
          null,
          /* 5 */
          b[J],
          /* 7 */
        ];
        b[$].y.cmp(b[J].y) === 0
          ? ((he[1] = b[$].add(b[J])), (he[2] = b[$].toJ().mixedAdd(b[J].neg())))
          : b[$].y.cmp(b[J].y.redNeg()) === 0
          ? ((he[1] = b[$].toJ().mixedAdd(b[J])), (he[2] = b[$].add(b[J].neg())))
          : ((he[1] = b[$].toJ().mixedAdd(b[J])), (he[2] = b[$].toJ().mixedAdd(b[J].neg())));
        var de = [
            -3 /* -1 -1 */, -1 /* -1 0 */, -5 /* -1 1 */, -7 /* 0 -1 */, 0 /* 0 0 */, 7 /* 0 1 */,
            5 /* 1 -1 */, 1 /* 1 0 */, 3,
            /* 1 1 */
          ],
          ne = i(p[$], p[J]);
        for (
          P = Math.max(ne[0].length, P), k[$] = new Array(P), k[J] = new Array(P), T = 0;
          T < P;
          T++
        ) {
          var Ae = ne[0][T] | 0,
            x = ne[1][T] | 0;
          (k[$][T] = de[(Ae + 1) * 3 + (x + 1)]), (k[J][T] = 0), (A[$] = he);
        }
      }
      var r = this.jpoint(null, null, null),
        o = this._wnafT4;
      for (B = P; B >= 0; B--) {
        for (var f = 0; B >= 0; ) {
          var u = !0;
          for (T = 0; T < _; T++) (o[T] = k[T][B] | 0), o[T] !== 0 && (u = !1);
          if (!u) break;
          f++, B--;
        }
        if ((B >= 0 && f++, (r = r.dblp(f)), B < 0)) break;
        for (T = 0; T < _; T++) {
          var d = o[T];
          d !== 0 &&
            (d > 0 ? (F = A[T][(d - 1) >> 1]) : d < 0 && (F = A[T][(-d - 1) >> 1].neg()),
            F.type === "affine" ? (r = r.mixedAdd(F)) : (r = r.add(F)));
        }
      }
      for (B = 0; B < _; B++) A[B] = null;
      return M ? r : r.toP();
    });
  function c(v, g) {
    (this.curve = v), (this.type = g), (this.precomputed = null);
  }
  return (
    (a.BasePoint = c),
    (c.prototype.eq = function () {
      throw new Error("Not implemented");
    }),
    (c.prototype.validate = function () {
      return this.curve.validate(this);
    }),
    (a.prototype.decodePoint = function (g, b) {
      g = e.toArray(g, b);
      var p = this.p.byteLength();
      if ((g[0] === 4 || g[0] === 6 || g[0] === 7) && g.length - 1 === 2 * p) {
        g[0] === 6 ? l(g[g.length - 1] % 2 === 0) : g[0] === 7 && l(g[g.length - 1] % 2 === 1);
        var _ = this.point(g.slice(1, 1 + p), g.slice(1 + p, 1 + 2 * p));
        return _;
      } else if ((g[0] === 2 || g[0] === 3) && g.length - 1 === p)
        return this.pointFromX(g.slice(1, 1 + p), g[0] === 3);
      throw new Error("Unknown point format");
    }),
    (c.prototype.encodeCompressed = function (g) {
      return this.encode(g, !0);
    }),
    (c.prototype._encode = function (g) {
      var b = this.curve.p.byteLength(),
        p = this.getX().toArray("be", b);
      return g
        ? [this.getY().isEven() ? 2 : 3].concat(p)
        : [4].concat(p, this.getY().toArray("be", b));
    }),
    (c.prototype.encode = function (g, b) {
      return e.encode(this._encode(b), g);
    }),
    (c.prototype.precompute = function (g) {
      if (this.precomputed) return this;
      var b = {
        doubles: null,
        naf: null,
        beta: null,
      };
      return (
        (b.naf = this._getNAFPoints(8)),
        (b.doubles = this._getDoubles(4, g)),
        (b.beta = this._getBeta()),
        (this.precomputed = b),
        this
      );
    }),
    (c.prototype._hasDoubles = function (g) {
      if (!this.precomputed) return !1;
      var b = this.precomputed.doubles;
      return b ? b.points.length >= Math.ceil((g.bitLength() + 1) / b.step) : !1;
    }),
    (c.prototype._getDoubles = function (g, b) {
      if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
      for (var p = [this], _ = this, M = 0; M < b; M += g) {
        for (var S = 0; S < g; S++) _ = _.dbl();
        p.push(_);
      }
      return {
        step: g,
        points: p,
      };
    }),
    (c.prototype._getNAFPoints = function (g) {
      if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
      for (var b = [this], p = (1 << g) - 1, _ = p === 1 ? null : this.dbl(), M = 1; M < p; M++)
        b[M] = b[M - 1].add(_);
      return {
        wnd: g,
        points: b,
      };
    }),
    (c.prototype._getBeta = function () {
      return null;
    }),
    (c.prototype.dblp = function (g) {
      for (var b = this, p = 0; p < g; p++) b = b.dbl();
      return b;
    }),
    Fd
  );
}
var qd, Dy;
function s7() {
  if (Dy) return qd;
  Dy = 1;
  var t = An(),
    e = Ai(),
    n = It(),
    i = Nu(),
    l = t.assert;
  function a(g) {
    i.call(this, "short", g),
      (this.a = new e(g.a, 16).toRed(this.red)),
      (this.b = new e(g.b, 16).toRed(this.red)),
      (this.tinv = this.two.redInvm()),
      (this.zeroA = this.a.fromRed().cmpn(0) === 0),
      (this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0),
      (this.endo = this._getEndomorphism(g)),
      (this._endoWnafT1 = new Array(4)),
      (this._endoWnafT2 = new Array(4));
  }
  n(a, i),
    (qd = a),
    (a.prototype._getEndomorphism = function (b) {
      if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
        var p, _;
        if (b.beta) p = new e(b.beta, 16).toRed(this.red);
        else {
          var M = this._getEndoRoots(this.p);
          (p = M[0].cmp(M[1]) < 0 ? M[0] : M[1]), (p = p.toRed(this.red));
        }
        if (b.lambda) _ = new e(b.lambda, 16);
        else {
          var S = this._getEndoRoots(this.n);
          this.g.mul(S[0]).x.cmp(this.g.x.redMul(p)) === 0
            ? (_ = S[0])
            : ((_ = S[1]), l(this.g.mul(_).x.cmp(this.g.x.redMul(p)) === 0));
        }
        var A;
        return (
          b.basis
            ? (A = b.basis.map(function (k) {
                return {
                  a: new e(k.a, 16),
                  b: new e(k.b, 16),
                };
              }))
            : (A = this._getEndoBasis(_)),
          {
            beta: p,
            lambda: _,
            basis: A,
          }
        );
      }
    }),
    (a.prototype._getEndoRoots = function (b) {
      var p = b === this.p ? this.red : e.mont(b),
        _ = new e(2).toRed(p).redInvm(),
        M = _.redNeg(),
        S = new e(3).toRed(p).redNeg().redSqrt().redMul(_),
        A = M.redAdd(S).fromRed(),
        k = M.redSub(S).fromRed();
      return [A, k];
    }),
    (a.prototype._getEndoBasis = function (b) {
      for (
        var p = this.n.ushrn(Math.floor(this.n.bitLength() / 2)),
          _ = b,
          M = this.n.clone(),
          S = new e(1),
          A = new e(0),
          k = new e(0),
          P = new e(1),
          B,
          T,
          F,
          O,
          $,
          J,
          he,
          de = 0,
          ne,
          Ae;
        _.cmpn(0) !== 0;

      ) {
        var x = M.div(_);
        (ne = M.sub(x.mul(_))), (Ae = k.sub(x.mul(S)));
        var r = P.sub(x.mul(A));
        if (!F && ne.cmp(p) < 0) (B = he.neg()), (T = S), (F = ne.neg()), (O = Ae);
        else if (F && ++de === 2) break;
        (he = ne), (M = _), (_ = ne), (k = S), (S = Ae), (P = A), (A = r);
      }
      ($ = ne.neg()), (J = Ae);
      var o = F.sqr().add(O.sqr()),
        f = $.sqr().add(J.sqr());
      return (
        f.cmp(o) >= 0 && (($ = B), (J = T)),
        F.negative && ((F = F.neg()), (O = O.neg())),
        $.negative && (($ = $.neg()), (J = J.neg())),
        [
          { a: F, b: O },
          { a: $, b: J },
        ]
      );
    }),
    (a.prototype._endoSplit = function (b) {
      var p = this.endo.basis,
        _ = p[0],
        M = p[1],
        S = M.b.mul(b).divRound(this.n),
        A = _.b.neg().mul(b).divRound(this.n),
        k = S.mul(_.a),
        P = A.mul(M.a),
        B = S.mul(_.b),
        T = A.mul(M.b),
        F = b.sub(k).sub(P),
        O = B.add(T).neg();
      return { k1: F, k2: O };
    }),
    (a.prototype.pointFromX = function (b, p) {
      (b = new e(b, 16)), b.red || (b = b.toRed(this.red));
      var _ = b.redSqr().redMul(b).redIAdd(b.redMul(this.a)).redIAdd(this.b),
        M = _.redSqrt();
      if (M.redSqr().redSub(_).cmp(this.zero) !== 0) throw new Error("invalid point");
      var S = M.fromRed().isOdd();
      return ((p && !S) || (!p && S)) && (M = M.redNeg()), this.point(b, M);
    }),
    (a.prototype.validate = function (b) {
      if (b.inf) return !0;
      var p = b.x,
        _ = b.y,
        M = this.a.redMul(p),
        S = p.redSqr().redMul(p).redIAdd(M).redIAdd(this.b);
      return _.redSqr().redISub(S).cmpn(0) === 0;
    }),
    (a.prototype._endoWnafMulAdd = function (b, p, _) {
      for (var M = this._endoWnafT1, S = this._endoWnafT2, A = 0; A < b.length; A++) {
        var k = this._endoSplit(p[A]),
          P = b[A],
          B = P._getBeta();
        k.k1.negative && (k.k1.ineg(), (P = P.neg(!0))),
          k.k2.negative && (k.k2.ineg(), (B = B.neg(!0))),
          (M[A * 2] = P),
          (M[A * 2 + 1] = B),
          (S[A * 2] = k.k1),
          (S[A * 2 + 1] = k.k2);
      }
      for (var T = this._wnafMulAdd(1, M, S, A * 2, _), F = 0; F < A * 2; F++)
        (M[F] = null), (S[F] = null);
      return T;
    });
  function c(g, b, p, _) {
    i.BasePoint.call(this, g, "affine"),
      b === null && p === null
        ? ((this.x = null), (this.y = null), (this.inf = !0))
        : ((this.x = new e(b, 16)),
          (this.y = new e(p, 16)),
          _ && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)),
          this.x.red || (this.x = this.x.toRed(this.curve.red)),
          this.y.red || (this.y = this.y.toRed(this.curve.red)),
          (this.inf = !1));
  }
  n(c, i.BasePoint),
    (a.prototype.point = function (b, p, _) {
      return new c(this, b, p, _);
    }),
    (a.prototype.pointFromJSON = function (b, p) {
      return c.fromJSON(this, b, p);
    }),
    (c.prototype._getBeta = function () {
      if (this.curve.endo) {
        var b = this.precomputed;
        if (b && b.beta) return b.beta;
        var p = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
        if (b) {
          var _ = this.curve,
            M = function (S) {
              return _.point(S.x.redMul(_.endo.beta), S.y);
            };
          (b.beta = p),
            (p.precomputed = {
              beta: null,
              naf: b.naf && {
                wnd: b.naf.wnd,
                points: b.naf.points.map(M),
              },
              doubles: b.doubles && {
                step: b.doubles.step,
                points: b.doubles.points.map(M),
              },
            });
        }
        return p;
      }
    }),
    (c.prototype.toJSON = function () {
      return this.precomputed
        ? [
            this.x,
            this.y,
            this.precomputed && {
              doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1),
              },
              naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1),
              },
            },
          ]
        : [this.x, this.y];
    }),
    (c.fromJSON = function (b, p, _) {
      typeof p == "string" && (p = JSON.parse(p));
      var M = b.point(p[0], p[1], _);
      if (!p[2]) return M;
      function S(k) {
        return b.point(k[0], k[1], _);
      }
      var A = p[2];
      return (
        (M.precomputed = {
          beta: null,
          doubles: A.doubles && {
            step: A.doubles.step,
            points: [M].concat(A.doubles.points.map(S)),
          },
          naf: A.naf && {
            wnd: A.naf.wnd,
            points: [M].concat(A.naf.points.map(S)),
          },
        }),
        M
      );
    }),
    (c.prototype.inspect = function () {
      return this.isInfinity()
        ? "<EC Point Infinity>"
        : "<EC Point x: " +
            this.x.fromRed().toString(16, 2) +
            " y: " +
            this.y.fromRed().toString(16, 2) +
            ">";
    }),
    (c.prototype.isInfinity = function () {
      return this.inf;
    }),
    (c.prototype.add = function (b) {
      if (this.inf) return b;
      if (b.inf) return this;
      if (this.eq(b)) return this.dbl();
      if (this.neg().eq(b)) return this.curve.point(null, null);
      if (this.x.cmp(b.x) === 0) return this.curve.point(null, null);
      var p = this.y.redSub(b.y);
      p.cmpn(0) !== 0 && (p = p.redMul(this.x.redSub(b.x).redInvm()));
      var _ = p.redSqr().redISub(this.x).redISub(b.x),
        M = p.redMul(this.x.redSub(_)).redISub(this.y);
      return this.curve.point(_, M);
    }),
    (c.prototype.dbl = function () {
      if (this.inf) return this;
      var b = this.y.redAdd(this.y);
      if (b.cmpn(0) === 0) return this.curve.point(null, null);
      var p = this.curve.a,
        _ = this.x.redSqr(),
        M = b.redInvm(),
        S = _.redAdd(_).redIAdd(_).redIAdd(p).redMul(M),
        A = S.redSqr().redISub(this.x.redAdd(this.x)),
        k = S.redMul(this.x.redSub(A)).redISub(this.y);
      return this.curve.point(A, k);
    }),
    (c.prototype.getX = function () {
      return this.x.fromRed();
    }),
    (c.prototype.getY = function () {
      return this.y.fromRed();
    }),
    (c.prototype.mul = function (b) {
      return (
        (b = new e(b, 16)),
        this.isInfinity()
          ? this
          : this._hasDoubles(b)
          ? this.curve._fixedNafMul(this, b)
          : this.curve.endo
          ? this.curve._endoWnafMulAdd([this], [b])
          : this.curve._wnafMul(this, b)
      );
    }),
    (c.prototype.mulAdd = function (b, p, _) {
      var M = [this, p],
        S = [b, _];
      return this.curve.endo
        ? this.curve._endoWnafMulAdd(M, S)
        : this.curve._wnafMulAdd(1, M, S, 2);
    }),
    (c.prototype.jmulAdd = function (b, p, _) {
      var M = [this, p],
        S = [b, _];
      return this.curve.endo
        ? this.curve._endoWnafMulAdd(M, S, !0)
        : this.curve._wnafMulAdd(1, M, S, 2, !0);
    }),
    (c.prototype.eq = function (b) {
      return (
        this === b ||
        (this.inf === b.inf && (this.inf || (this.x.cmp(b.x) === 0 && this.y.cmp(b.y) === 0)))
      );
    }),
    (c.prototype.neg = function (b) {
      if (this.inf) return this;
      var p = this.curve.point(this.x, this.y.redNeg());
      if (b && this.precomputed) {
        var _ = this.precomputed,
          M = function (S) {
            return S.neg();
          };
        p.precomputed = {
          naf: _.naf && {
            wnd: _.naf.wnd,
            points: _.naf.points.map(M),
          },
          doubles: _.doubles && {
            step: _.doubles.step,
            points: _.doubles.points.map(M),
          },
        };
      }
      return p;
    }),
    (c.prototype.toJ = function () {
      if (this.inf) return this.curve.jpoint(null, null, null);
      var b = this.curve.jpoint(this.x, this.y, this.curve.one);
      return b;
    });
  function v(g, b, p, _) {
    i.BasePoint.call(this, g, "jacobian"),
      b === null && p === null && _ === null
        ? ((this.x = this.curve.one), (this.y = this.curve.one), (this.z = new e(0)))
        : ((this.x = new e(b, 16)), (this.y = new e(p, 16)), (this.z = new e(_, 16))),
      this.x.red || (this.x = this.x.toRed(this.curve.red)),
      this.y.red || (this.y = this.y.toRed(this.curve.red)),
      this.z.red || (this.z = this.z.toRed(this.curve.red)),
      (this.zOne = this.z === this.curve.one);
  }
  return (
    n(v, i.BasePoint),
    (a.prototype.jpoint = function (b, p, _) {
      return new v(this, b, p, _);
    }),
    (v.prototype.toP = function () {
      if (this.isInfinity()) return this.curve.point(null, null);
      var b = this.z.redInvm(),
        p = b.redSqr(),
        _ = this.x.redMul(p),
        M = this.y.redMul(p).redMul(b);
      return this.curve.point(_, M);
    }),
    (v.prototype.neg = function () {
      return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
    }),
    (v.prototype.add = function (b) {
      if (this.isInfinity()) return b;
      if (b.isInfinity()) return this;
      var p = b.z.redSqr(),
        _ = this.z.redSqr(),
        M = this.x.redMul(p),
        S = b.x.redMul(_),
        A = this.y.redMul(p.redMul(b.z)),
        k = b.y.redMul(_.redMul(this.z)),
        P = M.redSub(S),
        B = A.redSub(k);
      if (P.cmpn(0) === 0)
        return B.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
      var T = P.redSqr(),
        F = T.redMul(P),
        O = M.redMul(T),
        $ = B.redSqr().redIAdd(F).redISub(O).redISub(O),
        J = B.redMul(O.redISub($)).redISub(A.redMul(F)),
        he = this.z.redMul(b.z).redMul(P);
      return this.curve.jpoint($, J, he);
    }),
    (v.prototype.mixedAdd = function (b) {
      if (this.isInfinity()) return b.toJ();
      if (b.isInfinity()) return this;
      var p = this.z.redSqr(),
        _ = this.x,
        M = b.x.redMul(p),
        S = this.y,
        A = b.y.redMul(p).redMul(this.z),
        k = _.redSub(M),
        P = S.redSub(A);
      if (k.cmpn(0) === 0)
        return P.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
      var B = k.redSqr(),
        T = B.redMul(k),
        F = _.redMul(B),
        O = P.redSqr().redIAdd(T).redISub(F).redISub(F),
        $ = P.redMul(F.redISub(O)).redISub(S.redMul(T)),
        J = this.z.redMul(k);
      return this.curve.jpoint(O, $, J);
    }),
    (v.prototype.dblp = function (b) {
      if (b === 0) return this;
      if (this.isInfinity()) return this;
      if (!b) return this.dbl();
      var p;
      if (this.curve.zeroA || this.curve.threeA) {
        var _ = this;
        for (p = 0; p < b; p++) _ = _.dbl();
        return _;
      }
      var M = this.curve.a,
        S = this.curve.tinv,
        A = this.x,
        k = this.y,
        P = this.z,
        B = P.redSqr().redSqr(),
        T = k.redAdd(k);
      for (p = 0; p < b; p++) {
        var F = A.redSqr(),
          O = T.redSqr(),
          $ = O.redSqr(),
          J = F.redAdd(F).redIAdd(F).redIAdd(M.redMul(B)),
          he = A.redMul(O),
          de = J.redSqr().redISub(he.redAdd(he)),
          ne = he.redISub(de),
          Ae = J.redMul(ne);
        Ae = Ae.redIAdd(Ae).redISub($);
        var x = T.redMul(P);
        p + 1 < b && (B = B.redMul($)), (A = de), (P = x), (T = Ae);
      }
      return this.curve.jpoint(A, T.redMul(S), P);
    }),
    (v.prototype.dbl = function () {
      return this.isInfinity()
        ? this
        : this.curve.zeroA
        ? this._zeroDbl()
        : this.curve.threeA
        ? this._threeDbl()
        : this._dbl();
    }),
    (v.prototype._zeroDbl = function () {
      var b, p, _;
      if (this.zOne) {
        var M = this.x.redSqr(),
          S = this.y.redSqr(),
          A = S.redSqr(),
          k = this.x.redAdd(S).redSqr().redISub(M).redISub(A);
        k = k.redIAdd(k);
        var P = M.redAdd(M).redIAdd(M),
          B = P.redSqr().redISub(k).redISub(k),
          T = A.redIAdd(A);
        (T = T.redIAdd(T)),
          (T = T.redIAdd(T)),
          (b = B),
          (p = P.redMul(k.redISub(B)).redISub(T)),
          (_ = this.y.redAdd(this.y));
      } else {
        var F = this.x.redSqr(),
          O = this.y.redSqr(),
          $ = O.redSqr(),
          J = this.x.redAdd(O).redSqr().redISub(F).redISub($);
        J = J.redIAdd(J);
        var he = F.redAdd(F).redIAdd(F),
          de = he.redSqr(),
          ne = $.redIAdd($);
        (ne = ne.redIAdd(ne)),
          (ne = ne.redIAdd(ne)),
          (b = de.redISub(J).redISub(J)),
          (p = he.redMul(J.redISub(b)).redISub(ne)),
          (_ = this.y.redMul(this.z)),
          (_ = _.redIAdd(_));
      }
      return this.curve.jpoint(b, p, _);
    }),
    (v.prototype._threeDbl = function () {
      var b, p, _;
      if (this.zOne) {
        var M = this.x.redSqr(),
          S = this.y.redSqr(),
          A = S.redSqr(),
          k = this.x.redAdd(S).redSqr().redISub(M).redISub(A);
        k = k.redIAdd(k);
        var P = M.redAdd(M).redIAdd(M).redIAdd(this.curve.a),
          B = P.redSqr().redISub(k).redISub(k);
        b = B;
        var T = A.redIAdd(A);
        (T = T.redIAdd(T)),
          (T = T.redIAdd(T)),
          (p = P.redMul(k.redISub(B)).redISub(T)),
          (_ = this.y.redAdd(this.y));
      } else {
        var F = this.z.redSqr(),
          O = this.y.redSqr(),
          $ = this.x.redMul(O),
          J = this.x.redSub(F).redMul(this.x.redAdd(F));
        J = J.redAdd(J).redIAdd(J);
        var he = $.redIAdd($);
        he = he.redIAdd(he);
        var de = he.redAdd(he);
        (b = J.redSqr().redISub(de)), (_ = this.y.redAdd(this.z).redSqr().redISub(O).redISub(F));
        var ne = O.redSqr();
        (ne = ne.redIAdd(ne)),
          (ne = ne.redIAdd(ne)),
          (ne = ne.redIAdd(ne)),
          (p = J.redMul(he.redISub(b)).redISub(ne));
      }
      return this.curve.jpoint(b, p, _);
    }),
    (v.prototype._dbl = function () {
      var b = this.curve.a,
        p = this.x,
        _ = this.y,
        M = this.z,
        S = M.redSqr().redSqr(),
        A = p.redSqr(),
        k = _.redSqr(),
        P = A.redAdd(A).redIAdd(A).redIAdd(b.redMul(S)),
        B = p.redAdd(p);
      B = B.redIAdd(B);
      var T = B.redMul(k),
        F = P.redSqr().redISub(T.redAdd(T)),
        O = T.redISub(F),
        $ = k.redSqr();
      ($ = $.redIAdd($)), ($ = $.redIAdd($)), ($ = $.redIAdd($));
      var J = P.redMul(O).redISub($),
        he = _.redAdd(_).redMul(M);
      return this.curve.jpoint(F, J, he);
    }),
    (v.prototype.trpl = function () {
      if (!this.curve.zeroA) return this.dbl().add(this);
      var b = this.x.redSqr(),
        p = this.y.redSqr(),
        _ = this.z.redSqr(),
        M = p.redSqr(),
        S = b.redAdd(b).redIAdd(b),
        A = S.redSqr(),
        k = this.x.redAdd(p).redSqr().redISub(b).redISub(M);
      (k = k.redIAdd(k)), (k = k.redAdd(k).redIAdd(k)), (k = k.redISub(A));
      var P = k.redSqr(),
        B = M.redIAdd(M);
      (B = B.redIAdd(B)), (B = B.redIAdd(B)), (B = B.redIAdd(B));
      var T = S.redIAdd(k).redSqr().redISub(A).redISub(P).redISub(B),
        F = p.redMul(T);
      (F = F.redIAdd(F)), (F = F.redIAdd(F));
      var O = this.x.redMul(P).redISub(F);
      (O = O.redIAdd(O)), (O = O.redIAdd(O));
      var $ = this.y.redMul(T.redMul(B.redISub(T)).redISub(k.redMul(P)));
      ($ = $.redIAdd($)), ($ = $.redIAdd($)), ($ = $.redIAdd($));
      var J = this.z.redAdd(k).redSqr().redISub(_).redISub(P);
      return this.curve.jpoint(O, $, J);
    }),
    (v.prototype.mul = function (b, p) {
      return (b = new e(b, p)), this.curve._wnafMul(this, b);
    }),
    (v.prototype.eq = function (b) {
      if (b.type === "affine") return this.eq(b.toJ());
      if (this === b) return !0;
      var p = this.z.redSqr(),
        _ = b.z.redSqr();
      if (this.x.redMul(_).redISub(b.x.redMul(p)).cmpn(0) !== 0) return !1;
      var M = p.redMul(this.z),
        S = _.redMul(b.z);
      return this.y.redMul(S).redISub(b.y.redMul(M)).cmpn(0) === 0;
    }),
    (v.prototype.eqXToP = function (b) {
      var p = this.z.redSqr(),
        _ = b.toRed(this.curve.red).redMul(p);
      if (this.x.cmp(_) === 0) return !0;
      for (var M = b.clone(), S = this.curve.redN.redMul(p); ; ) {
        if ((M.iadd(this.curve.n), M.cmp(this.curve.p) >= 0)) return !1;
        if ((_.redIAdd(S), this.x.cmp(_) === 0)) return !0;
      }
    }),
    (v.prototype.inspect = function () {
      return this.isInfinity()
        ? "<EC JPoint Infinity>"
        : "<EC JPoint x: " +
            this.x.toString(16, 2) +
            " y: " +
            this.y.toString(16, 2) +
            " z: " +
            this.z.toString(16, 2) +
            ">";
    }),
    (v.prototype.isInfinity = function () {
      return this.z.cmpn(0) === 0;
    }),
    qd
  );
}
var zd, Ly;
function o7() {
  if (Ly) return zd;
  Ly = 1;
  var t = Ai(),
    e = It(),
    n = Nu(),
    i = An();
  function l(c) {
    n.call(this, "mont", c),
      (this.a = new t(c.a, 16).toRed(this.red)),
      (this.b = new t(c.b, 16).toRed(this.red)),
      (this.i4 = new t(4).toRed(this.red).redInvm()),
      (this.two = new t(2).toRed(this.red)),
      (this.a24 = this.i4.redMul(this.a.redAdd(this.two)));
  }
  e(l, n),
    (zd = l),
    (l.prototype.validate = function (v) {
      var g = v.normalize().x,
        b = g.redSqr(),
        p = b.redMul(g).redAdd(b.redMul(this.a)).redAdd(g),
        _ = p.redSqrt();
      return _.redSqr().cmp(p) === 0;
    });
  function a(c, v, g) {
    n.BasePoint.call(this, c, "projective"),
      v === null && g === null
        ? ((this.x = this.curve.one), (this.z = this.curve.zero))
        : ((this.x = new t(v, 16)),
          (this.z = new t(g, 16)),
          this.x.red || (this.x = this.x.toRed(this.curve.red)),
          this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return (
    e(a, n.BasePoint),
    (l.prototype.decodePoint = function (v, g) {
      return this.point(i.toArray(v, g), 1);
    }),
    (l.prototype.point = function (v, g) {
      return new a(this, v, g);
    }),
    (l.prototype.pointFromJSON = function (v) {
      return a.fromJSON(this, v);
    }),
    (a.prototype.precompute = function () {}),
    (a.prototype._encode = function () {
      return this.getX().toArray("be", this.curve.p.byteLength());
    }),
    (a.fromJSON = function (v, g) {
      return new a(v, g[0], g[1] || v.one);
    }),
    (a.prototype.inspect = function () {
      return this.isInfinity()
        ? "<EC Point Infinity>"
        : "<EC Point x: " +
            this.x.fromRed().toString(16, 2) +
            " z: " +
            this.z.fromRed().toString(16, 2) +
            ">";
    }),
    (a.prototype.isInfinity = function () {
      return this.z.cmpn(0) === 0;
    }),
    (a.prototype.dbl = function () {
      var v = this.x.redAdd(this.z),
        g = v.redSqr(),
        b = this.x.redSub(this.z),
        p = b.redSqr(),
        _ = g.redSub(p),
        M = g.redMul(p),
        S = _.redMul(p.redAdd(this.curve.a24.redMul(_)));
      return this.curve.point(M, S);
    }),
    (a.prototype.add = function () {
      throw new Error("Not supported on Montgomery curve");
    }),
    (a.prototype.diffAdd = function (v, g) {
      var b = this.x.redAdd(this.z),
        p = this.x.redSub(this.z),
        _ = v.x.redAdd(v.z),
        M = v.x.redSub(v.z),
        S = M.redMul(b),
        A = _.redMul(p),
        k = g.z.redMul(S.redAdd(A).redSqr()),
        P = g.x.redMul(S.redISub(A).redSqr());
      return this.curve.point(k, P);
    }),
    (a.prototype.mul = function (v) {
      for (
        var g = v.clone(), b = this, p = this.curve.point(null, null), _ = this, M = [];
        g.cmpn(0) !== 0;
        g.iushrn(1)
      )
        M.push(g.andln(1));
      for (var S = M.length - 1; S >= 0; S--)
        M[S] === 0
          ? ((b = b.diffAdd(p, _)), (p = p.dbl()))
          : ((p = b.diffAdd(p, _)), (b = b.dbl()));
      return p;
    }),
    (a.prototype.mulAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }),
    (a.prototype.jumlAdd = function () {
      throw new Error("Not supported on Montgomery curve");
    }),
    (a.prototype.eq = function (v) {
      return this.getX().cmp(v.getX()) === 0;
    }),
    (a.prototype.normalize = function () {
      return (this.x = this.x.redMul(this.z.redInvm())), (this.z = this.curve.one), this;
    }),
    (a.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }),
    zd
  );
}
var jd, Fy;
function f7() {
  if (Fy) return jd;
  Fy = 1;
  var t = An(),
    e = Ai(),
    n = It(),
    i = Nu(),
    l = t.assert;
  function a(v) {
    (this.twisted = (v.a | 0) !== 1),
      (this.mOneA = this.twisted && (v.a | 0) === -1),
      (this.extended = this.mOneA),
      i.call(this, "edwards", v),
      (this.a = new e(v.a, 16).umod(this.red.m)),
      (this.a = this.a.toRed(this.red)),
      (this.c = new e(v.c, 16).toRed(this.red)),
      (this.c2 = this.c.redSqr()),
      (this.d = new e(v.d, 16).toRed(this.red)),
      (this.dd = this.d.redAdd(this.d)),
      l(!this.twisted || this.c.fromRed().cmpn(1) === 0),
      (this.oneC = (v.c | 0) === 1);
  }
  n(a, i),
    (jd = a),
    (a.prototype._mulA = function (g) {
      return this.mOneA ? g.redNeg() : this.a.redMul(g);
    }),
    (a.prototype._mulC = function (g) {
      return this.oneC ? g : this.c.redMul(g);
    }),
    (a.prototype.jpoint = function (g, b, p, _) {
      return this.point(g, b, p, _);
    }),
    (a.prototype.pointFromX = function (g, b) {
      (g = new e(g, 16)), g.red || (g = g.toRed(this.red));
      var p = g.redSqr(),
        _ = this.c2.redSub(this.a.redMul(p)),
        M = this.one.redSub(this.c2.redMul(this.d).redMul(p)),
        S = _.redMul(M.redInvm()),
        A = S.redSqrt();
      if (A.redSqr().redSub(S).cmp(this.zero) !== 0) throw new Error("invalid point");
      var k = A.fromRed().isOdd();
      return ((b && !k) || (!b && k)) && (A = A.redNeg()), this.point(g, A);
    }),
    (a.prototype.pointFromY = function (g, b) {
      (g = new e(g, 16)), g.red || (g = g.toRed(this.red));
      var p = g.redSqr(),
        _ = p.redSub(this.c2),
        M = p.redMul(this.d).redMul(this.c2).redSub(this.a),
        S = _.redMul(M.redInvm());
      if (S.cmp(this.zero) === 0) {
        if (b) throw new Error("invalid point");
        return this.point(this.zero, g);
      }
      var A = S.redSqrt();
      if (A.redSqr().redSub(S).cmp(this.zero) !== 0) throw new Error("invalid point");
      return A.fromRed().isOdd() !== b && (A = A.redNeg()), this.point(A, g);
    }),
    (a.prototype.validate = function (g) {
      if (g.isInfinity()) return !0;
      g.normalize();
      var b = g.x.redSqr(),
        p = g.y.redSqr(),
        _ = b.redMul(this.a).redAdd(p),
        M = this.c2.redMul(this.one.redAdd(this.d.redMul(b).redMul(p)));
      return _.cmp(M) === 0;
    });
  function c(v, g, b, p, _) {
    i.BasePoint.call(this, v, "projective"),
      g === null && b === null && p === null
        ? ((this.x = this.curve.zero),
          (this.y = this.curve.one),
          (this.z = this.curve.one),
          (this.t = this.curve.zero),
          (this.zOne = !0))
        : ((this.x = new e(g, 16)),
          (this.y = new e(b, 16)),
          (this.z = p ? new e(p, 16) : this.curve.one),
          (this.t = _ && new e(_, 16)),
          this.x.red || (this.x = this.x.toRed(this.curve.red)),
          this.y.red || (this.y = this.y.toRed(this.curve.red)),
          this.z.red || (this.z = this.z.toRed(this.curve.red)),
          this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)),
          (this.zOne = this.z === this.curve.one),
          this.curve.extended &&
            !this.t &&
            ((this.t = this.x.redMul(this.y)),
            this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return (
    n(c, i.BasePoint),
    (a.prototype.pointFromJSON = function (g) {
      return c.fromJSON(this, g);
    }),
    (a.prototype.point = function (g, b, p, _) {
      return new c(this, g, b, p, _);
    }),
    (c.fromJSON = function (g, b) {
      return new c(g, b[0], b[1], b[2]);
    }),
    (c.prototype.inspect = function () {
      return this.isInfinity()
        ? "<EC Point Infinity>"
        : "<EC Point x: " +
            this.x.fromRed().toString(16, 2) +
            " y: " +
            this.y.fromRed().toString(16, 2) +
            " z: " +
            this.z.fromRed().toString(16, 2) +
            ">";
    }),
    (c.prototype.isInfinity = function () {
      return (
        this.x.cmpn(0) === 0 &&
        (this.y.cmp(this.z) === 0 || (this.zOne && this.y.cmp(this.curve.c) === 0))
      );
    }),
    (c.prototype._extDbl = function () {
      var g = this.x.redSqr(),
        b = this.y.redSqr(),
        p = this.z.redSqr();
      p = p.redIAdd(p);
      var _ = this.curve._mulA(g),
        M = this.x.redAdd(this.y).redSqr().redISub(g).redISub(b),
        S = _.redAdd(b),
        A = S.redSub(p),
        k = _.redSub(b),
        P = M.redMul(A),
        B = S.redMul(k),
        T = M.redMul(k),
        F = A.redMul(S);
      return this.curve.point(P, B, F, T);
    }),
    (c.prototype._projDbl = function () {
      var g = this.x.redAdd(this.y).redSqr(),
        b = this.x.redSqr(),
        p = this.y.redSqr(),
        _,
        M,
        S,
        A,
        k,
        P;
      if (this.curve.twisted) {
        A = this.curve._mulA(b);
        var B = A.redAdd(p);
        this.zOne
          ? ((_ = g.redSub(b).redSub(p).redMul(B.redSub(this.curve.two))),
            (M = B.redMul(A.redSub(p))),
            (S = B.redSqr().redSub(B).redSub(B)))
          : ((k = this.z.redSqr()),
            (P = B.redSub(k).redISub(k)),
            (_ = g.redSub(b).redISub(p).redMul(P)),
            (M = B.redMul(A.redSub(p))),
            (S = B.redMul(P)));
      } else
        (A = b.redAdd(p)),
          (k = this.curve._mulC(this.z).redSqr()),
          (P = A.redSub(k).redSub(k)),
          (_ = this.curve._mulC(g.redISub(A)).redMul(P)),
          (M = this.curve._mulC(A).redMul(b.redISub(p))),
          (S = A.redMul(P));
      return this.curve.point(_, M, S);
    }),
    (c.prototype.dbl = function () {
      return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
    }),
    (c.prototype._extAdd = function (g) {
      var b = this.y.redSub(this.x).redMul(g.y.redSub(g.x)),
        p = this.y.redAdd(this.x).redMul(g.y.redAdd(g.x)),
        _ = this.t.redMul(this.curve.dd).redMul(g.t),
        M = this.z.redMul(g.z.redAdd(g.z)),
        S = p.redSub(b),
        A = M.redSub(_),
        k = M.redAdd(_),
        P = p.redAdd(b),
        B = S.redMul(A),
        T = k.redMul(P),
        F = S.redMul(P),
        O = A.redMul(k);
      return this.curve.point(B, T, O, F);
    }),
    (c.prototype._projAdd = function (g) {
      var b = this.z.redMul(g.z),
        p = b.redSqr(),
        _ = this.x.redMul(g.x),
        M = this.y.redMul(g.y),
        S = this.curve.d.redMul(_).redMul(M),
        A = p.redSub(S),
        k = p.redAdd(S),
        P = this.x.redAdd(this.y).redMul(g.x.redAdd(g.y)).redISub(_).redISub(M),
        B = b.redMul(A).redMul(P),
        T,
        F;
      return (
        this.curve.twisted
          ? ((T = b.redMul(k).redMul(M.redSub(this.curve._mulA(_)))), (F = A.redMul(k)))
          : ((T = b.redMul(k).redMul(M.redSub(_))), (F = this.curve._mulC(A).redMul(k))),
        this.curve.point(B, T, F)
      );
    }),
    (c.prototype.add = function (g) {
      return this.isInfinity()
        ? g
        : g.isInfinity()
        ? this
        : this.curve.extended
        ? this._extAdd(g)
        : this._projAdd(g);
    }),
    (c.prototype.mul = function (g) {
      return this._hasDoubles(g) ? this.curve._fixedNafMul(this, g) : this.curve._wnafMul(this, g);
    }),
    (c.prototype.mulAdd = function (g, b, p) {
      return this.curve._wnafMulAdd(1, [this, b], [g, p], 2, !1);
    }),
    (c.prototype.jmulAdd = function (g, b, p) {
      return this.curve._wnafMulAdd(1, [this, b], [g, p], 2, !0);
    }),
    (c.prototype.normalize = function () {
      if (this.zOne) return this;
      var g = this.z.redInvm();
      return (
        (this.x = this.x.redMul(g)),
        (this.y = this.y.redMul(g)),
        this.t && (this.t = this.t.redMul(g)),
        (this.z = this.curve.one),
        (this.zOne = !0),
        this
      );
    }),
    (c.prototype.neg = function () {
      return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
    }),
    (c.prototype.getX = function () {
      return this.normalize(), this.x.fromRed();
    }),
    (c.prototype.getY = function () {
      return this.normalize(), this.y.fromRed();
    }),
    (c.prototype.eq = function (g) {
      return this === g || (this.getX().cmp(g.getX()) === 0 && this.getY().cmp(g.getY()) === 0);
    }),
    (c.prototype.eqXToP = function (g) {
      var b = g.toRed(this.curve.red).redMul(this.z);
      if (this.x.cmp(b) === 0) return !0;
      for (var p = g.clone(), _ = this.curve.redN.redMul(this.z); ; ) {
        if ((p.iadd(this.curve.n), p.cmp(this.curve.p) >= 0)) return !1;
        if ((b.redIAdd(_), this.x.cmp(b) === 0)) return !0;
      }
    }),
    (c.prototype.toP = c.prototype.normalize),
    (c.prototype.mixedAdd = c.prototype.add),
    jd
  );
}
var qy;
function Uw() {
  return (
    qy ||
      ((qy = 1),
      (function (t) {
        var e = t;
        (e.base = Nu()), (e.short = s7()), (e.mont = o7()), (e.edwards = f7());
      })(Ld)),
    Ld
  );
}
var $d = {},
  Hd = {},
  tr = {},
  zy;
function ni() {
  if (zy) return tr;
  zy = 1;
  var t = En(),
    e = It();
  tr.inherits = e;
  function n(r, o) {
    return (r.charCodeAt(o) & 64512) !== 55296 || o < 0 || o + 1 >= r.length
      ? !1
      : (r.charCodeAt(o + 1) & 64512) === 56320;
  }
  function i(r, o) {
    if (Array.isArray(r)) return r.slice();
    if (!r) return [];
    var f = [];
    if (typeof r == "string")
      if (o) {
        if (o === "hex")
          for (
            r = r.replace(/[^a-z0-9]+/gi, ""), r.length % 2 !== 0 && (r = "0" + r), d = 0;
            d < r.length;
            d += 2
          )
            f.push(parseInt(r[d] + r[d + 1], 16));
      } else
        for (var u = 0, d = 0; d < r.length; d++) {
          var y = r.charCodeAt(d);
          y < 128
            ? (f[u++] = y)
            : y < 2048
            ? ((f[u++] = (y >> 6) | 192), (f[u++] = (y & 63) | 128))
            : n(r, d)
            ? ((y = 65536 + ((y & 1023) << 10) + (r.charCodeAt(++d) & 1023)),
              (f[u++] = (y >> 18) | 240),
              (f[u++] = ((y >> 12) & 63) | 128),
              (f[u++] = ((y >> 6) & 63) | 128),
              (f[u++] = (y & 63) | 128))
            : ((f[u++] = (y >> 12) | 224),
              (f[u++] = ((y >> 6) & 63) | 128),
              (f[u++] = (y & 63) | 128));
        }
    else for (d = 0; d < r.length; d++) f[d] = r[d] | 0;
    return f;
  }
  tr.toArray = i;
  function l(r) {
    for (var o = "", f = 0; f < r.length; f++) o += v(r[f].toString(16));
    return o;
  }
  tr.toHex = l;
  function a(r) {
    var o = (r >>> 24) | ((r >>> 8) & 65280) | ((r << 8) & 16711680) | ((r & 255) << 24);
    return o >>> 0;
  }
  tr.htonl = a;
  function c(r, o) {
    for (var f = "", u = 0; u < r.length; u++) {
      var d = r[u];
      o === "little" && (d = a(d)), (f += g(d.toString(16)));
    }
    return f;
  }
  tr.toHex32 = c;
  function v(r) {
    return r.length === 1 ? "0" + r : r;
  }
  tr.zero2 = v;
  function g(r) {
    return r.length === 7
      ? "0" + r
      : r.length === 6
      ? "00" + r
      : r.length === 5
      ? "000" + r
      : r.length === 4
      ? "0000" + r
      : r.length === 3
      ? "00000" + r
      : r.length === 2
      ? "000000" + r
      : r.length === 1
      ? "0000000" + r
      : r;
  }
  tr.zero8 = g;
  function b(r, o, f, u) {
    var d = f - o;
    t(d % 4 === 0);
    for (var y = new Array(d / 4), w = 0, h = o; w < y.length; w++, h += 4) {
      var s;
      u === "big"
        ? (s = (r[h] << 24) | (r[h + 1] << 16) | (r[h + 2] << 8) | r[h + 3])
        : (s = (r[h + 3] << 24) | (r[h + 2] << 16) | (r[h + 1] << 8) | r[h]),
        (y[w] = s >>> 0);
    }
    return y;
  }
  tr.join32 = b;
  function p(r, o) {
    for (var f = new Array(r.length * 4), u = 0, d = 0; u < r.length; u++, d += 4) {
      var y = r[u];
      o === "big"
        ? ((f[d] = y >>> 24),
          (f[d + 1] = (y >>> 16) & 255),
          (f[d + 2] = (y >>> 8) & 255),
          (f[d + 3] = y & 255))
        : ((f[d + 3] = y >>> 24),
          (f[d + 2] = (y >>> 16) & 255),
          (f[d + 1] = (y >>> 8) & 255),
          (f[d] = y & 255));
    }
    return f;
  }
  tr.split32 = p;
  function _(r, o) {
    return (r >>> o) | (r << (32 - o));
  }
  tr.rotr32 = _;
  function M(r, o) {
    return (r << o) | (r >>> (32 - o));
  }
  tr.rotl32 = M;
  function S(r, o) {
    return (r + o) >>> 0;
  }
  tr.sum32 = S;
  function A(r, o, f) {
    return (r + o + f) >>> 0;
  }
  tr.sum32_3 = A;
  function k(r, o, f, u) {
    return (r + o + f + u) >>> 0;
  }
  tr.sum32_4 = k;
  function P(r, o, f, u, d) {
    return (r + o + f + u + d) >>> 0;
  }
  tr.sum32_5 = P;
  function B(r, o, f, u) {
    var d = r[o],
      y = r[o + 1],
      w = (u + y) >>> 0,
      h = (w < u ? 1 : 0) + f + d;
    (r[o] = h >>> 0), (r[o + 1] = w);
  }
  tr.sum64 = B;
  function T(r, o, f, u) {
    var d = (o + u) >>> 0,
      y = (d < o ? 1 : 0) + r + f;
    return y >>> 0;
  }
  tr.sum64_hi = T;
  function F(r, o, f, u) {
    var d = o + u;
    return d >>> 0;
  }
  tr.sum64_lo = F;
  function O(r, o, f, u, d, y, w, h) {
    var s = 0,
      m = o;
    (m = (m + u) >>> 0),
      (s += m < o ? 1 : 0),
      (m = (m + y) >>> 0),
      (s += m < y ? 1 : 0),
      (m = (m + h) >>> 0),
      (s += m < h ? 1 : 0);
    var E = r + f + d + w + s;
    return E >>> 0;
  }
  tr.sum64_4_hi = O;
  function $(r, o, f, u, d, y, w, h) {
    var s = o + u + y + h;
    return s >>> 0;
  }
  tr.sum64_4_lo = $;
  function J(r, o, f, u, d, y, w, h, s, m) {
    var E = 0,
      R = o;
    (R = (R + u) >>> 0),
      (E += R < o ? 1 : 0),
      (R = (R + y) >>> 0),
      (E += R < y ? 1 : 0),
      (R = (R + h) >>> 0),
      (E += R < h ? 1 : 0),
      (R = (R + m) >>> 0),
      (E += R < m ? 1 : 0);
    var z = r + f + d + w + s + E;
    return z >>> 0;
  }
  tr.sum64_5_hi = J;
  function he(r, o, f, u, d, y, w, h, s, m) {
    var E = o + u + y + h + m;
    return E >>> 0;
  }
  tr.sum64_5_lo = he;
  function de(r, o, f) {
    var u = (o << (32 - f)) | (r >>> f);
    return u >>> 0;
  }
  tr.rotr64_hi = de;
  function ne(r, o, f) {
    var u = (r << (32 - f)) | (o >>> f);
    return u >>> 0;
  }
  tr.rotr64_lo = ne;
  function Ae(r, o, f) {
    return r >>> f;
  }
  tr.shr64_hi = Ae;
  function x(r, o, f) {
    var u = (r << (32 - f)) | (o >>> f);
    return u >>> 0;
  }
  return (tr.shr64_lo = x), tr;
}
var Vd = {},
  jy;
function Cf() {
  if (jy) return Vd;
  jy = 1;
  var t = ni(),
    e = En();
  function n() {
    (this.pending = null),
      (this.pendingTotal = 0),
      (this.blockSize = this.constructor.blockSize),
      (this.outSize = this.constructor.outSize),
      (this.hmacStrength = this.constructor.hmacStrength),
      (this.padLength = this.constructor.padLength / 8),
      (this.endian = "big"),
      (this._delta8 = this.blockSize / 8),
      (this._delta32 = this.blockSize / 32);
  }
  return (
    (Vd.BlockHash = n),
    (n.prototype.update = function (l, a) {
      if (
        ((l = t.toArray(l, a)),
        this.pending ? (this.pending = this.pending.concat(l)) : (this.pending = l),
        (this.pendingTotal += l.length),
        this.pending.length >= this._delta8)
      ) {
        l = this.pending;
        var c = l.length % this._delta8;
        (this.pending = l.slice(l.length - c, l.length)),
          this.pending.length === 0 && (this.pending = null),
          (l = t.join32(l, 0, l.length - c, this.endian));
        for (var v = 0; v < l.length; v += this._delta32) this._update(l, v, v + this._delta32);
      }
      return this;
    }),
    (n.prototype.digest = function (l) {
      return this.update(this._pad()), e(this.pending === null), this._digest(l);
    }),
    (n.prototype._pad = function () {
      var l = this.pendingTotal,
        a = this._delta8,
        c = a - ((l + this.padLength) % a),
        v = new Array(c + this.padLength);
      v[0] = 128;
      for (var g = 1; g < c; g++) v[g] = 0;
      if (((l <<= 3), this.endian === "big")) {
        for (var b = 8; b < this.padLength; b++) v[g++] = 0;
        (v[g++] = 0),
          (v[g++] = 0),
          (v[g++] = 0),
          (v[g++] = 0),
          (v[g++] = (l >>> 24) & 255),
          (v[g++] = (l >>> 16) & 255),
          (v[g++] = (l >>> 8) & 255),
          (v[g++] = l & 255);
      } else
        for (
          v[g++] = l & 255,
            v[g++] = (l >>> 8) & 255,
            v[g++] = (l >>> 16) & 255,
            v[g++] = (l >>> 24) & 255,
            v[g++] = 0,
            v[g++] = 0,
            v[g++] = 0,
            v[g++] = 0,
            b = 8;
          b < this.padLength;
          b++
        )
          v[g++] = 0;
      return v;
    }),
    Vd
  );
}
var da = {},
  Nn = {},
  $y;
function Nw() {
  if ($y) return Nn;
  $y = 1;
  var t = ni(),
    e = t.rotr32;
  function n(p, _, M, S) {
    if (p === 0) return i(_, M, S);
    if (p === 1 || p === 3) return a(_, M, S);
    if (p === 2) return l(_, M, S);
  }
  Nn.ft_1 = n;
  function i(p, _, M) {
    return (p & _) ^ (~p & M);
  }
  Nn.ch32 = i;
  function l(p, _, M) {
    return (p & _) ^ (p & M) ^ (_ & M);
  }
  Nn.maj32 = l;
  function a(p, _, M) {
    return p ^ _ ^ M;
  }
  Nn.p32 = a;
  function c(p) {
    return e(p, 2) ^ e(p, 13) ^ e(p, 22);
  }
  Nn.s0_256 = c;
  function v(p) {
    return e(p, 6) ^ e(p, 11) ^ e(p, 25);
  }
  Nn.s1_256 = v;
  function g(p) {
    return e(p, 7) ^ e(p, 18) ^ (p >>> 3);
  }
  Nn.g0_256 = g;
  function b(p) {
    return e(p, 17) ^ e(p, 19) ^ (p >>> 10);
  }
  return (Nn.g1_256 = b), Nn;
}
var Wd, Hy;
function l7() {
  if (Hy) return Wd;
  Hy = 1;
  var t = ni(),
    e = Cf(),
    n = Nw(),
    i = t.rotl32,
    l = t.sum32,
    a = t.sum32_5,
    c = n.ft_1,
    v = e.BlockHash,
    g = [1518500249, 1859775393, 2400959708, 3395469782];
  function b() {
    if (!(this instanceof b)) return new b();
    v.call(this),
      (this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520]),
      (this.W = new Array(80));
  }
  return (
    t.inherits(b, v),
    (Wd = b),
    (b.blockSize = 512),
    (b.outSize = 160),
    (b.hmacStrength = 80),
    (b.padLength = 64),
    (b.prototype._update = function (_, M) {
      for (var S = this.W, A = 0; A < 16; A++) S[A] = _[M + A];
      for (; A < S.length; A++) S[A] = i(S[A - 3] ^ S[A - 8] ^ S[A - 14] ^ S[A - 16], 1);
      var k = this.h[0],
        P = this.h[1],
        B = this.h[2],
        T = this.h[3],
        F = this.h[4];
      for (A = 0; A < S.length; A++) {
        var O = ~~(A / 20),
          $ = a(i(k, 5), c(O, P, B, T), F, S[A], g[O]);
        (F = T), (T = B), (B = i(P, 30)), (P = k), (k = $);
      }
      (this.h[0] = l(this.h[0], k)),
        (this.h[1] = l(this.h[1], P)),
        (this.h[2] = l(this.h[2], B)),
        (this.h[3] = l(this.h[3], T)),
        (this.h[4] = l(this.h[4], F));
    }),
    (b.prototype._digest = function (_) {
      return _ === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
    }),
    Wd
  );
}
var Kd, Vy;
function Dw() {
  if (Vy) return Kd;
  Vy = 1;
  var t = ni(),
    e = Cf(),
    n = Nw(),
    i = En(),
    l = t.sum32,
    a = t.sum32_4,
    c = t.sum32_5,
    v = n.ch32,
    g = n.maj32,
    b = n.s0_256,
    p = n.s1_256,
    _ = n.g0_256,
    M = n.g1_256,
    S = e.BlockHash,
    A = [
      1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221,
      3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580,
      3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986,
      2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895,
      666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037,
      2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344,
      430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779,
      1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479,
      3329325298,
    ];
  function k() {
    if (!(this instanceof k)) return new k();
    S.call(this),
      (this.h = [
        1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635,
        1541459225,
      ]),
      (this.k = A),
      (this.W = new Array(64));
  }
  return (
    t.inherits(k, S),
    (Kd = k),
    (k.blockSize = 512),
    (k.outSize = 256),
    (k.hmacStrength = 192),
    (k.padLength = 64),
    (k.prototype._update = function (B, T) {
      for (var F = this.W, O = 0; O < 16; O++) F[O] = B[T + O];
      for (; O < F.length; O++) F[O] = a(M(F[O - 2]), F[O - 7], _(F[O - 15]), F[O - 16]);
      var $ = this.h[0],
        J = this.h[1],
        he = this.h[2],
        de = this.h[3],
        ne = this.h[4],
        Ae = this.h[5],
        x = this.h[6],
        r = this.h[7];
      for (i(this.k.length === F.length), O = 0; O < F.length; O++) {
        var o = c(r, p(ne), v(ne, Ae, x), this.k[O], F[O]),
          f = l(b($), g($, J, he));
        (r = x), (x = Ae), (Ae = ne), (ne = l(de, o)), (de = he), (he = J), (J = $), ($ = l(o, f));
      }
      (this.h[0] = l(this.h[0], $)),
        (this.h[1] = l(this.h[1], J)),
        (this.h[2] = l(this.h[2], he)),
        (this.h[3] = l(this.h[3], de)),
        (this.h[4] = l(this.h[4], ne)),
        (this.h[5] = l(this.h[5], Ae)),
        (this.h[6] = l(this.h[6], x)),
        (this.h[7] = l(this.h[7], r));
    }),
    (k.prototype._digest = function (B) {
      return B === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
    }),
    Kd
  );
}
var Zd, Wy;
function u7() {
  if (Wy) return Zd;
  Wy = 1;
  var t = ni(),
    e = Dw();
  function n() {
    if (!(this instanceof n)) return new n();
    e.call(this),
      (this.h = [
        3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839,
        3204075428,
      ]);
  }
  return (
    t.inherits(n, e),
    (Zd = n),
    (n.blockSize = 512),
    (n.outSize = 224),
    (n.hmacStrength = 192),
    (n.padLength = 64),
    (n.prototype._digest = function (l) {
      return l === "hex"
        ? t.toHex32(this.h.slice(0, 7), "big")
        : t.split32(this.h.slice(0, 7), "big");
    }),
    Zd
  );
}
var Gd, Ky;
function Lw() {
  if (Ky) return Gd;
  Ky = 1;
  var t = ni(),
    e = Cf(),
    n = En(),
    i = t.rotr64_hi,
    l = t.rotr64_lo,
    a = t.shr64_hi,
    c = t.shr64_lo,
    v = t.sum64,
    g = t.sum64_hi,
    b = t.sum64_lo,
    p = t.sum64_4_hi,
    _ = t.sum64_4_lo,
    M = t.sum64_5_hi,
    S = t.sum64_5_lo,
    A = e.BlockHash,
    k = [
      1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548,
      961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560,
      3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994,
      1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868,
      3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933,
      770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837,
      2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956,
      3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936,
      666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823,
      1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627,
      2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008,
      3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720,
      430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280,
      958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899,
      1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044,
      2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427,
      3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992,
      116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315,
      685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676,
      1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591,
    ];
  function P() {
    if (!(this instanceof P)) return new P();
    A.call(this),
      (this.h = [
        1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762,
        1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547,
        1541459225, 327033209,
      ]),
      (this.k = k),
      (this.W = new Array(160));
  }
  t.inherits(P, A),
    (Gd = P),
    (P.blockSize = 1024),
    (P.outSize = 512),
    (P.hmacStrength = 192),
    (P.padLength = 128),
    (P.prototype._prepareBlock = function (f, u) {
      for (var d = this.W, y = 0; y < 32; y++) d[y] = f[u + y];
      for (; y < d.length; y += 2) {
        var w = x(d[y - 4], d[y - 3]),
          h = r(d[y - 4], d[y - 3]),
          s = d[y - 14],
          m = d[y - 13],
          E = ne(d[y - 30], d[y - 29]),
          R = Ae(d[y - 30], d[y - 29]),
          z = d[y - 32],
          Q = d[y - 31];
        (d[y] = p(w, h, s, m, E, R, z, Q)), (d[y + 1] = _(w, h, s, m, E, R, z, Q));
      }
    }),
    (P.prototype._update = function (f, u) {
      this._prepareBlock(f, u);
      var d = this.W,
        y = this.h[0],
        w = this.h[1],
        h = this.h[2],
        s = this.h[3],
        m = this.h[4],
        E = this.h[5],
        R = this.h[6],
        z = this.h[7],
        Q = this.h[8],
        G = this.h[9],
        q = this.h[10],
        Z = this.h[11],
        te = this.h[12],
        ue = this.h[13],
        ae = this.h[14],
        K = this.h[15];
      n(this.k.length === d.length);
      for (var ve = 0; ve < d.length; ve += 2) {
        var Ye = ae,
          Ce = K,
          Te = he(Q, G),
          ut = de(Q, G),
          Ie = B(Q, G, q, Z, te),
          be = T(Q, G, q, Z, te, ue),
          wt = this.k[ve],
          Oe = this.k[ve + 1],
          je = d[ve],
          xt = d[ve + 1],
          Ue = M(Ye, Ce, Te, ut, Ie, be, wt, Oe, je, xt),
          se = S(Ye, Ce, Te, ut, Ie, be, wt, Oe, je, xt);
        (Ye = $(y, w)), (Ce = J(y, w)), (Te = F(y, w, h, s, m)), (ut = O(y, w, h, s, m, E));
        var oe = g(Ye, Ce, Te, ut),
          X = b(Ye, Ce, Te, ut);
        (ae = te),
          (K = ue),
          (te = q),
          (ue = Z),
          (q = Q),
          (Z = G),
          (Q = g(R, z, Ue, se)),
          (G = b(z, z, Ue, se)),
          (R = m),
          (z = E),
          (m = h),
          (E = s),
          (h = y),
          (s = w),
          (y = g(Ue, se, oe, X)),
          (w = b(Ue, se, oe, X));
      }
      v(this.h, 0, y, w),
        v(this.h, 2, h, s),
        v(this.h, 4, m, E),
        v(this.h, 6, R, z),
        v(this.h, 8, Q, G),
        v(this.h, 10, q, Z),
        v(this.h, 12, te, ue),
        v(this.h, 14, ae, K);
    }),
    (P.prototype._digest = function (f) {
      return f === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
    });
  function B(o, f, u, d, y) {
    var w = (o & u) ^ (~o & y);
    return w < 0 && (w += 4294967296), w;
  }
  function T(o, f, u, d, y, w) {
    var h = (f & d) ^ (~f & w);
    return h < 0 && (h += 4294967296), h;
  }
  function F(o, f, u, d, y) {
    var w = (o & u) ^ (o & y) ^ (u & y);
    return w < 0 && (w += 4294967296), w;
  }
  function O(o, f, u, d, y, w) {
    var h = (f & d) ^ (f & w) ^ (d & w);
    return h < 0 && (h += 4294967296), h;
  }
  function $(o, f) {
    var u = i(o, f, 28),
      d = i(f, o, 2),
      y = i(f, o, 7),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function J(o, f) {
    var u = l(o, f, 28),
      d = l(f, o, 2),
      y = l(f, o, 7),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function he(o, f) {
    var u = i(o, f, 14),
      d = i(o, f, 18),
      y = i(f, o, 9),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function de(o, f) {
    var u = l(o, f, 14),
      d = l(o, f, 18),
      y = l(f, o, 9),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function ne(o, f) {
    var u = i(o, f, 1),
      d = i(o, f, 8),
      y = a(o, f, 7),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function Ae(o, f) {
    var u = l(o, f, 1),
      d = l(o, f, 8),
      y = c(o, f, 7),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function x(o, f) {
    var u = i(o, f, 19),
      d = i(f, o, 29),
      y = a(o, f, 6),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  function r(o, f) {
    var u = l(o, f, 19),
      d = l(f, o, 29),
      y = c(o, f, 6),
      w = u ^ d ^ y;
    return w < 0 && (w += 4294967296), w;
  }
  return Gd;
}
var Yd, Zy;
function c7() {
  if (Zy) return Yd;
  Zy = 1;
  var t = ni(),
    e = Lw();
  function n() {
    if (!(this instanceof n)) return new n();
    e.call(this),
      (this.h = [
        3418070365, 3238371032, 1654270250, 914150663, 2438529370, 812702999, 355462360, 4144912697,
        1731405415, 4290775857, 2394180231, 1750603025, 3675008525, 1694076839, 1203062813,
        3204075428,
      ]);
  }
  return (
    t.inherits(n, e),
    (Yd = n),
    (n.blockSize = 1024),
    (n.outSize = 384),
    (n.hmacStrength = 192),
    (n.padLength = 128),
    (n.prototype._digest = function (l) {
      return l === "hex"
        ? t.toHex32(this.h.slice(0, 12), "big")
        : t.split32(this.h.slice(0, 12), "big");
    }),
    Yd
  );
}
var Gy;
function h7() {
  return (
    Gy ||
      ((Gy = 1),
      (da.sha1 = l7()),
      (da.sha224 = u7()),
      (da.sha256 = Dw()),
      (da.sha384 = c7()),
      (da.sha512 = Lw())),
    da
  );
}
var Jd = {},
  Yy;
function d7() {
  if (Yy) return Jd;
  Yy = 1;
  var t = ni(),
    e = Cf(),
    n = t.rotl32,
    i = t.sum32,
    l = t.sum32_3,
    a = t.sum32_4,
    c = e.BlockHash;
  function v() {
    if (!(this instanceof v)) return new v();
    c.call(this),
      (this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520]),
      (this.endian = "little");
  }
  t.inherits(v, c),
    (Jd.ripemd160 = v),
    (v.blockSize = 512),
    (v.outSize = 160),
    (v.hmacStrength = 192),
    (v.padLength = 64),
    (v.prototype._update = function (P, B) {
      for (
        var T = this.h[0],
          F = this.h[1],
          O = this.h[2],
          $ = this.h[3],
          J = this.h[4],
          he = T,
          de = F,
          ne = O,
          Ae = $,
          x = J,
          r = 0;
        r < 80;
        r++
      ) {
        var o = i(n(a(T, g(r, F, O, $), P[_[r] + B], b(r)), S[r]), J);
        (T = J),
          (J = $),
          ($ = n(O, 10)),
          (O = F),
          (F = o),
          (o = i(n(a(he, g(79 - r, de, ne, Ae), P[M[r] + B], p(r)), A[r]), x)),
          (he = x),
          (x = Ae),
          (Ae = n(ne, 10)),
          (ne = de),
          (de = o);
      }
      (o = l(this.h[1], O, Ae)),
        (this.h[1] = l(this.h[2], $, x)),
        (this.h[2] = l(this.h[3], J, he)),
        (this.h[3] = l(this.h[4], T, de)),
        (this.h[4] = l(this.h[0], F, ne)),
        (this.h[0] = o);
    }),
    (v.prototype._digest = function (P) {
      return P === "hex" ? t.toHex32(this.h, "little") : t.split32(this.h, "little");
    });
  function g(k, P, B, T) {
    return k <= 15
      ? P ^ B ^ T
      : k <= 31
      ? (P & B) | (~P & T)
      : k <= 47
      ? (P | ~B) ^ T
      : k <= 63
      ? (P & T) | (B & ~T)
      : P ^ (B | ~T);
  }
  function b(k) {
    return k <= 15
      ? 0
      : k <= 31
      ? 1518500249
      : k <= 47
      ? 1859775393
      : k <= 63
      ? 2400959708
      : 2840853838;
  }
  function p(k) {
    return k <= 15
      ? 1352829926
      : k <= 31
      ? 1548603684
      : k <= 47
      ? 1836072691
      : k <= 63
      ? 2053994217
      : 0;
  }
  var _ = [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5,
      2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4,
      13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13,
    ],
    M = [
      5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8,
      12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15,
      0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11,
    ],
    S = [
      11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8, 7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15,
      9, 11, 7, 13, 12, 11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5, 11, 12, 14, 15, 14,
      15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12, 9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6,
    ],
    A = [
      8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12,
      7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14,
      14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11,
    ];
  return Jd;
}
var Qd, Jy;
function p7() {
  if (Jy) return Qd;
  Jy = 1;
  var t = ni(),
    e = En();
  function n(i, l, a) {
    if (!(this instanceof n)) return new n(i, l, a);
    (this.Hash = i),
      (this.blockSize = i.blockSize / 8),
      (this.outSize = i.outSize / 8),
      (this.inner = null),
      (this.outer = null),
      this._init(t.toArray(l, a));
  }
  return (
    (Qd = n),
    (n.prototype._init = function (l) {
      l.length > this.blockSize && (l = new this.Hash().update(l).digest()),
        e(l.length <= this.blockSize);
      for (var a = l.length; a < this.blockSize; a++) l.push(0);
      for (a = 0; a < l.length; a++) l[a] ^= 54;
      for (this.inner = new this.Hash().update(l), a = 0; a < l.length; a++) l[a] ^= 106;
      this.outer = new this.Hash().update(l);
    }),
    (n.prototype.update = function (l, a) {
      return this.inner.update(l, a), this;
    }),
    (n.prototype.digest = function (l) {
      return this.outer.update(this.inner.digest()), this.outer.digest(l);
    }),
    Qd
  );
}
var Qy;
function R1() {
  return (
    Qy ||
      ((Qy = 1),
      (function (t) {
        var e = t;
        (e.utils = ni()),
          (e.common = Cf()),
          (e.sha = h7()),
          (e.ripemd = d7()),
          (e.hmac = p7()),
          (e.sha1 = e.sha.sha1),
          (e.sha256 = e.sha.sha256),
          (e.sha224 = e.sha.sha224),
          (e.sha384 = e.sha.sha384),
          (e.sha512 = e.sha.sha512),
          (e.ripemd160 = e.ripemd.ripemd160);
      })(Hd)),
    Hd
  );
}
var Xd, Xy;
function m7() {
  return (
    Xy ||
      ((Xy = 1),
      (Xd = {
        doubles: {
          step: 4,
          points: [
            [
              "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
              "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821",
            ],
            [
              "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
              "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf",
            ],
            [
              "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
              "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695",
            ],
            [
              "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
              "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9",
            ],
            [
              "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
              "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36",
            ],
            [
              "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
              "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f",
            ],
            [
              "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
              "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999",
            ],
            [
              "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
              "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09",
            ],
            [
              "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
              "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d",
            ],
            [
              "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
              "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088",
            ],
            [
              "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
              "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d",
            ],
            [
              "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
              "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8",
            ],
            [
              "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
              "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a",
            ],
            [
              "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
              "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453",
            ],
            [
              "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
              "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160",
            ],
            [
              "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
              "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0",
            ],
            [
              "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
              "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6",
            ],
            [
              "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
              "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589",
            ],
            [
              "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
              "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17",
            ],
            [
              "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
              "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda",
            ],
            [
              "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
              "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd",
            ],
            [
              "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
              "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2",
            ],
            [
              "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
              "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6",
            ],
            [
              "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
              "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f",
            ],
            [
              "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
              "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01",
            ],
            [
              "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
              "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3",
            ],
            [
              "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
              "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f",
            ],
            [
              "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
              "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7",
            ],
            [
              "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
              "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78",
            ],
            [
              "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
              "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1",
            ],
            [
              "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
              "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150",
            ],
            [
              "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
              "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82",
            ],
            [
              "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
              "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc",
            ],
            [
              "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
              "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b",
            ],
            [
              "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
              "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51",
            ],
            [
              "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
              "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45",
            ],
            [
              "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
              "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120",
            ],
            [
              "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
              "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84",
            ],
            [
              "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
              "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d",
            ],
            [
              "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
              "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d",
            ],
            [
              "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
              "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8",
            ],
            [
              "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
              "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8",
            ],
            [
              "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
              "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac",
            ],
            [
              "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
              "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f",
            ],
            [
              "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
              "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962",
            ],
            [
              "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
              "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907",
            ],
            [
              "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
              "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec",
            ],
            [
              "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
              "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d",
            ],
            [
              "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
              "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414",
            ],
            [
              "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
              "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd",
            ],
            [
              "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
              "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0",
            ],
            [
              "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
              "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811",
            ],
            [
              "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
              "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1",
            ],
            [
              "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
              "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c",
            ],
            [
              "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
              "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73",
            ],
            [
              "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
              "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd",
            ],
            [
              "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
              "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405",
            ],
            [
              "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
              "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589",
            ],
            [
              "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
              "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e",
            ],
            [
              "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
              "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27",
            ],
            [
              "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
              "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1",
            ],
            [
              "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
              "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482",
            ],
            [
              "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
              "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945",
            ],
            [
              "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
              "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573",
            ],
            [
              "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
              "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82",
            ],
          ],
        },
        naf: {
          wnd: 7,
          points: [
            [
              "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
              "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672",
            ],
            [
              "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
              "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6",
            ],
            [
              "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
              "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da",
            ],
            [
              "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
              "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37",
            ],
            [
              "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
              "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b",
            ],
            [
              "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
              "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81",
            ],
            [
              "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
              "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58",
            ],
            [
              "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
              "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77",
            ],
            [
              "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
              "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a",
            ],
            [
              "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
              "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c",
            ],
            [
              "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
              "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67",
            ],
            [
              "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
              "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402",
            ],
            [
              "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
              "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55",
            ],
            [
              "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
              "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482",
            ],
            [
              "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
              "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82",
            ],
            [
              "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
              "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396",
            ],
            [
              "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
              "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49",
            ],
            [
              "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
              "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf",
            ],
            [
              "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
              "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a",
            ],
            [
              "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
              "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7",
            ],
            [
              "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
              "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933",
            ],
            [
              "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
              "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a",
            ],
            [
              "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
              "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6",
            ],
            [
              "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
              "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37",
            ],
            [
              "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
              "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e",
            ],
            [
              "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
              "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6",
            ],
            [
              "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
              "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476",
            ],
            [
              "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
              "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40",
            ],
            [
              "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
              "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61",
            ],
            [
              "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
              "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683",
            ],
            [
              "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
              "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5",
            ],
            [
              "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
              "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b",
            ],
            [
              "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
              "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417",
            ],
            [
              "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
              "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868",
            ],
            [
              "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
              "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a",
            ],
            [
              "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
              "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6",
            ],
            [
              "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
              "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996",
            ],
            [
              "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
              "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e",
            ],
            [
              "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
              "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d",
            ],
            [
              "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
              "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2",
            ],
            [
              "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
              "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e",
            ],
            [
              "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
              "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437",
            ],
            [
              "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
              "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311",
            ],
            [
              "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
              "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4",
            ],
            [
              "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
              "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575",
            ],
            [
              "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
              "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d",
            ],
            [
              "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
              "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d",
            ],
            [
              "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
              "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629",
            ],
            [
              "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
              "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06",
            ],
            [
              "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
              "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374",
            ],
            [
              "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
              "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee",
            ],
            [
              "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
              "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1",
            ],
            [
              "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
              "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b",
            ],
            [
              "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
              "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661",
            ],
            [
              "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
              "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6",
            ],
            [
              "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
              "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e",
            ],
            [
              "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
              "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d",
            ],
            [
              "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
              "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc",
            ],
            [
              "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
              "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4",
            ],
            [
              "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
              "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c",
            ],
            [
              "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
              "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b",
            ],
            [
              "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
              "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913",
            ],
            [
              "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
              "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154",
            ],
            [
              "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
              "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865",
            ],
            [
              "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
              "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc",
            ],
            [
              "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
              "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224",
            ],
            [
              "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
              "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e",
            ],
            [
              "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
              "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6",
            ],
            [
              "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
              "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511",
            ],
            [
              "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
              "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b",
            ],
            [
              "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
              "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2",
            ],
            [
              "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
              "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c",
            ],
            [
              "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
              "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3",
            ],
            [
              "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
              "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d",
            ],
            [
              "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
              "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700",
            ],
            [
              "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
              "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4",
            ],
            [
              "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
              "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196",
            ],
            [
              "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
              "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4",
            ],
            [
              "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
              "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257",
            ],
            [
              "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
              "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13",
            ],
            [
              "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
              "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096",
            ],
            [
              "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
              "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38",
            ],
            [
              "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
              "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f",
            ],
            [
              "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
              "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448",
            ],
            [
              "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
              "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a",
            ],
            [
              "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
              "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4",
            ],
            [
              "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
              "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437",
            ],
            [
              "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
              "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7",
            ],
            [
              "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
              "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d",
            ],
            [
              "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
              "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a",
            ],
            [
              "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
              "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54",
            ],
            [
              "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
              "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77",
            ],
            [
              "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
              "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517",
            ],
            [
              "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
              "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10",
            ],
            [
              "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
              "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125",
            ],
            [
              "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
              "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e",
            ],
            [
              "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
              "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1",
            ],
            [
              "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
              "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2",
            ],
            [
              "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
              "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423",
            ],
            [
              "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
              "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8",
            ],
            [
              "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
              "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758",
            ],
            [
              "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
              "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375",
            ],
            [
              "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
              "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d",
            ],
            [
              "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
              "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec",
            ],
            [
              "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
              "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0",
            ],
            [
              "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
              "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c",
            ],
            [
              "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
              "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4",
            ],
            [
              "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
              "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f",
            ],
            [
              "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
              "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649",
            ],
            [
              "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
              "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826",
            ],
            [
              "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
              "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5",
            ],
            [
              "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
              "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87",
            ],
            [
              "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
              "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b",
            ],
            [
              "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
              "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc",
            ],
            [
              "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
              "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c",
            ],
            [
              "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
              "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f",
            ],
            [
              "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
              "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a",
            ],
            [
              "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
              "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46",
            ],
            [
              "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
              "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f",
            ],
            [
              "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
              "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03",
            ],
            [
              "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
              "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08",
            ],
            [
              "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
              "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8",
            ],
            [
              "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
              "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373",
            ],
            [
              "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
              "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3",
            ],
            [
              "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
              "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8",
            ],
            [
              "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
              "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1",
            ],
            [
              "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
              "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9",
            ],
          ],
        },
      })),
    Xd
  );
}
var eb;
function I1() {
  return (
    eb ||
      ((eb = 1),
      (function (t) {
        var e = t,
          n = R1(),
          i = Uw(),
          l = An(),
          a = l.assert;
        function c(b) {
          b.type === "short"
            ? (this.curve = new i.short(b))
            : b.type === "edwards"
            ? (this.curve = new i.edwards(b))
            : (this.curve = new i.mont(b)),
            (this.g = this.curve.g),
            (this.n = this.curve.n),
            (this.hash = b.hash),
            a(this.g.validate(), "Invalid curve"),
            a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
        }
        e.PresetCurve = c;
        function v(b, p) {
          Object.defineProperty(e, b, {
            configurable: !0,
            enumerable: !0,
            get: function () {
              var _ = new c(p);
              return (
                Object.defineProperty(e, b, {
                  configurable: !0,
                  enumerable: !0,
                  value: _,
                }),
                _
              );
            },
          });
        }
        v("p192", {
          type: "short",
          prime: "p192",
          p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
          a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
          b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
          n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
          hash: n.sha256,
          gRed: !1,
          g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811",
          ],
        }),
          v("p224", {
            type: "short",
            prime: "p224",
            p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
            a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
            b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
            n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
            hash: n.sha256,
            gRed: !1,
            g: [
              "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
              "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34",
            ],
          }),
          v("p256", {
            type: "short",
            prime: null,
            p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
            a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
            b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
            n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
            hash: n.sha256,
            gRed: !1,
            g: [
              "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
              "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5",
            ],
          }),
          v("p384", {
            type: "short",
            prime: null,
            p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
            a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
            b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
            n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
            hash: n.sha384,
            gRed: !1,
            g: [
              "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
              "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f",
            ],
          }),
          v("p521", {
            type: "short",
            prime: null,
            p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
            a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
            b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
            n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
            hash: n.sha512,
            gRed: !1,
            g: [
              "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
              "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650",
            ],
          }),
          v("curve25519", {
            type: "mont",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "76d06",
            b: "1",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: n.sha256,
            gRed: !1,
            g: ["9"],
          }),
          v("ed25519", {
            type: "edwards",
            prime: "p25519",
            p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
            a: "-1",
            c: "1",
            // -121665 * (121666^(-1)) (mod P)
            d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
            n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
            hash: n.sha256,
            gRed: !1,
            g: [
              "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
              // 4/5
              "6666666666666666666666666666666666666666666666666666666666666658",
            ],
          });
        var g;
        try {
          g = m7();
        } catch {
          g = void 0;
        }
        v("secp256k1", {
          type: "short",
          prime: "k256",
          p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
          a: "0",
          b: "7",
          n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
          h: "1",
          hash: n.sha256,
          // Precomputed endomorphism
          beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
          lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
          basis: [
            {
              a: "3086d221a7d46bcde86c90e49284eb15",
              b: "-e4437ed6010e88286f547fa90abfe4c3",
            },
            {
              a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
              b: "3086d221a7d46bcde86c90e49284eb15",
            },
          ],
          gRed: !1,
          g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            g,
          ],
        });
      })($d)),
    $d
  );
}
var e0, tb;
function v7() {
  if (tb) return e0;
  tb = 1;
  var t = R1(),
    e = Ow(),
    n = En();
  function i(l) {
    if (!(this instanceof i)) return new i(l);
    (this.hash = l.hash),
      (this.predResist = !!l.predResist),
      (this.outLen = this.hash.outSize),
      (this.minEntropy = l.minEntropy || this.hash.hmacStrength),
      (this._reseed = null),
      (this.reseedInterval = null),
      (this.K = null),
      (this.V = null);
    var a = e.toArray(l.entropy, l.entropyEnc || "hex"),
      c = e.toArray(l.nonce, l.nonceEnc || "hex"),
      v = e.toArray(l.pers, l.persEnc || "hex");
    n(
      a.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ),
      this._init(a, c, v);
  }
  return (
    (e0 = i),
    (i.prototype._init = function (a, c, v) {
      var g = a.concat(c).concat(v);
      (this.K = new Array(this.outLen / 8)), (this.V = new Array(this.outLen / 8));
      for (var b = 0; b < this.V.length; b++) (this.K[b] = 0), (this.V[b] = 1);
      this._update(g), (this._reseed = 1), (this.reseedInterval = 281474976710656);
    }),
    (i.prototype._hmac = function () {
      return new t.hmac(this.hash, this.K);
    }),
    (i.prototype._update = function (a) {
      var c = this._hmac().update(this.V).update([0]);
      a && (c = c.update(a)),
        (this.K = c.digest()),
        (this.V = this._hmac().update(this.V).digest()),
        a &&
          ((this.K = this._hmac().update(this.V).update([1]).update(a).digest()),
          (this.V = this._hmac().update(this.V).digest()));
    }),
    (i.prototype.reseed = function (a, c, v, g) {
      typeof c != "string" && ((g = v), (v = c), (c = null)),
        (a = e.toArray(a, c)),
        (v = e.toArray(v, g)),
        n(
          a.length >= this.minEntropy / 8,
          "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
        ),
        this._update(a.concat(v || [])),
        (this._reseed = 1);
    }),
    (i.prototype.generate = function (a, c, v, g) {
      if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
      typeof c != "string" && ((g = v), (v = c), (c = null)),
        v && ((v = e.toArray(v, g || "hex")), this._update(v));
      for (var b = []; b.length < a; )
        (this.V = this._hmac().update(this.V).digest()), (b = b.concat(this.V));
      var p = b.slice(0, a);
      return this._update(v), this._reseed++, e.encode(p, c);
    }),
    e0
  );
}
var t0, rb;
function g7() {
  if (rb) return t0;
  rb = 1;
  var t = Ai(),
    e = An(),
    n = e.assert;
  function i(l, a) {
    (this.ec = l),
      (this.priv = null),
      (this.pub = null),
      a.priv && this._importPrivate(a.priv, a.privEnc),
      a.pub && this._importPublic(a.pub, a.pubEnc);
  }
  return (
    (t0 = i),
    (i.fromPublic = function (a, c, v) {
      return c instanceof i
        ? c
        : new i(a, {
            pub: c,
            pubEnc: v,
          });
    }),
    (i.fromPrivate = function (a, c, v) {
      return c instanceof i
        ? c
        : new i(a, {
            priv: c,
            privEnc: v,
          });
    }),
    (i.prototype.validate = function () {
      var a = this.getPublic();
      return a.isInfinity()
        ? { result: !1, reason: "Invalid public key" }
        : a.validate()
        ? a.mul(this.ec.curve.n).isInfinity()
          ? { result: !0, reason: null }
          : { result: !1, reason: "Public key * N != O" }
        : { result: !1, reason: "Public key is not a point" };
    }),
    (i.prototype.getPublic = function (a, c) {
      return (
        typeof a == "string" && ((c = a), (a = null)),
        this.pub || (this.pub = this.ec.g.mul(this.priv)),
        c ? this.pub.encode(c, a) : this.pub
      );
    }),
    (i.prototype.getPrivate = function (a) {
      return a === "hex" ? this.priv.toString(16, 2) : this.priv;
    }),
    (i.prototype._importPrivate = function (a, c) {
      (this.priv = new t(a, c || 16)), (this.priv = this.priv.umod(this.ec.curve.n));
    }),
    (i.prototype._importPublic = function (a, c) {
      if (a.x || a.y) {
        this.ec.curve.type === "mont"
          ? n(a.x, "Need x coordinate")
          : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") &&
            n(a.x && a.y, "Need both x and y coordinate"),
          (this.pub = this.ec.curve.point(a.x, a.y));
        return;
      }
      this.pub = this.ec.curve.decodePoint(a, c);
    }),
    (i.prototype.derive = function (a) {
      return a.validate() || n(a.validate(), "public point not validated"), a.mul(this.priv).getX();
    }),
    (i.prototype.sign = function (a, c, v) {
      return this.ec.sign(a, this, c, v);
    }),
    (i.prototype.verify = function (a, c) {
      return this.ec.verify(a, c, this);
    }),
    (i.prototype.inspect = function () {
      return (
        "<Key priv: " +
        (this.priv && this.priv.toString(16, 2)) +
        " pub: " +
        (this.pub && this.pub.inspect()) +
        " >"
      );
    }),
    t0
  );
}
var r0, nb;
function y7() {
  if (nb) return r0;
  nb = 1;
  var t = Ai(),
    e = An(),
    n = e.assert;
  function i(g, b) {
    if (g instanceof i) return g;
    this._importDER(g, b) ||
      (n(g.r && g.s, "Signature without r or s"),
      (this.r = new t(g.r, 16)),
      (this.s = new t(g.s, 16)),
      g.recoveryParam === void 0
        ? (this.recoveryParam = null)
        : (this.recoveryParam = g.recoveryParam));
  }
  r0 = i;
  function l() {
    this.place = 0;
  }
  function a(g, b) {
    var p = g[b.place++];
    if (!(p & 128)) return p;
    var _ = p & 15;
    if (_ === 0 || _ > 4) return !1;
    for (var M = 0, S = 0, A = b.place; S < _; S++, A++) (M <<= 8), (M |= g[A]), (M >>>= 0);
    return M <= 127 ? !1 : ((b.place = A), M);
  }
  function c(g) {
    for (var b = 0, p = g.length - 1; !g[b] && !(g[b + 1] & 128) && b < p; ) b++;
    return b === 0 ? g : g.slice(b);
  }
  i.prototype._importDER = function (b, p) {
    b = e.toArray(b, p);
    var _ = new l();
    if (b[_.place++] !== 48) return !1;
    var M = a(b, _);
    if (M === !1 || M + _.place !== b.length || b[_.place++] !== 2) return !1;
    var S = a(b, _);
    if (S === !1) return !1;
    var A = b.slice(_.place, S + _.place);
    if (((_.place += S), b[_.place++] !== 2)) return !1;
    var k = a(b, _);
    if (k === !1 || b.length !== k + _.place) return !1;
    var P = b.slice(_.place, k + _.place);
    if (A[0] === 0)
      if (A[1] & 128) A = A.slice(1);
      else return !1;
    if (P[0] === 0)
      if (P[1] & 128) P = P.slice(1);
      else return !1;
    return (this.r = new t(A)), (this.s = new t(P)), (this.recoveryParam = null), !0;
  };
  function v(g, b) {
    if (b < 128) {
      g.push(b);
      return;
    }
    var p = 1 + ((Math.log(b) / Math.LN2) >>> 3);
    for (g.push(p | 128); --p; ) g.push((b >>> (p << 3)) & 255);
    g.push(b);
  }
  return (
    (i.prototype.toDER = function (b) {
      var p = this.r.toArray(),
        _ = this.s.toArray();
      for (
        p[0] & 128 && (p = [0].concat(p)), _[0] & 128 && (_ = [0].concat(_)), p = c(p), _ = c(_);
        !_[0] && !(_[1] & 128);

      )
        _ = _.slice(1);
      var M = [2];
      v(M, p.length), (M = M.concat(p)), M.push(2), v(M, _.length);
      var S = M.concat(_),
        A = [48];
      return v(A, S.length), (A = A.concat(S)), e.encode(A, b);
    }),
    r0
  );
}
var n0, ib;
function b7() {
  if (ib) return n0;
  ib = 1;
  var t = Ai(),
    e = v7(),
    n = An(),
    i = I1(),
    l = B1(),
    a = n.assert,
    c = g7(),
    v = y7();
  function g(b) {
    if (!(this instanceof g)) return new g(b);
    typeof b == "string" &&
      (a(Object.prototype.hasOwnProperty.call(i, b), "Unknown curve " + b), (b = i[b])),
      b instanceof i.PresetCurve && (b = { curve: b }),
      (this.curve = b.curve.curve),
      (this.n = this.curve.n),
      (this.nh = this.n.ushrn(1)),
      (this.g = this.curve.g),
      (this.g = b.curve.g),
      this.g.precompute(b.curve.n.bitLength() + 1),
      (this.hash = b.hash || b.curve.hash);
  }
  return (
    (n0 = g),
    (g.prototype.keyPair = function (p) {
      return new c(this, p);
    }),
    (g.prototype.keyFromPrivate = function (p, _) {
      return c.fromPrivate(this, p, _);
    }),
    (g.prototype.keyFromPublic = function (p, _) {
      return c.fromPublic(this, p, _);
    }),
    (g.prototype.genKeyPair = function (p) {
      p || (p = {});
      for (
        var _ = new e({
            hash: this.hash,
            pers: p.pers,
            persEnc: p.persEnc || "utf8",
            entropy: p.entropy || l(this.hash.hmacStrength),
            entropyEnc: (p.entropy && p.entropyEnc) || "utf8",
            nonce: this.n.toArray(),
          }),
          M = this.n.byteLength(),
          S = this.n.sub(new t(2));
        ;

      ) {
        var A = new t(_.generate(M));
        if (!(A.cmp(S) > 0)) return A.iaddn(1), this.keyFromPrivate(A);
      }
    }),
    (g.prototype._truncateToN = function (p, _) {
      var M = p.byteLength() * 8 - this.n.bitLength();
      return M > 0 && (p = p.ushrn(M)), !_ && p.cmp(this.n) >= 0 ? p.sub(this.n) : p;
    }),
    (g.prototype.sign = function (p, _, M, S) {
      typeof M == "object" && ((S = M), (M = null)),
        S || (S = {}),
        (_ = this.keyFromPrivate(_, M)),
        (p = this._truncateToN(new t(p, 16)));
      for (
        var A = this.n.byteLength(),
          k = _.getPrivate().toArray("be", A),
          P = p.toArray("be", A),
          B = new e({
            hash: this.hash,
            entropy: k,
            nonce: P,
            pers: S.pers,
            persEnc: S.persEnc || "utf8",
          }),
          T = this.n.sub(new t(1)),
          F = 0;
        ;
        F++
      ) {
        var O = S.k ? S.k(F) : new t(B.generate(this.n.byteLength()));
        if (((O = this._truncateToN(O, !0)), !(O.cmpn(1) <= 0 || O.cmp(T) >= 0))) {
          var $ = this.g.mul(O);
          if (!$.isInfinity()) {
            var J = $.getX(),
              he = J.umod(this.n);
            if (he.cmpn(0) !== 0) {
              var de = O.invm(this.n).mul(he.mul(_.getPrivate()).iadd(p));
              if (((de = de.umod(this.n)), de.cmpn(0) !== 0)) {
                var ne = ($.getY().isOdd() ? 1 : 0) | (J.cmp(he) !== 0 ? 2 : 0);
                return (
                  S.canonical && de.cmp(this.nh) > 0 && ((de = this.n.sub(de)), (ne ^= 1)),
                  new v({ r: he, s: de, recoveryParam: ne })
                );
              }
            }
          }
        }
      }
    }),
    (g.prototype.verify = function (p, _, M, S) {
      (p = this._truncateToN(new t(p, 16))), (M = this.keyFromPublic(M, S)), (_ = new v(_, "hex"));
      var A = _.r,
        k = _.s;
      if (A.cmpn(1) < 0 || A.cmp(this.n) >= 0 || k.cmpn(1) < 0 || k.cmp(this.n) >= 0) return !1;
      var P = k.invm(this.n),
        B = P.mul(p).umod(this.n),
        T = P.mul(A).umod(this.n),
        F;
      return this.curve._maxwellTrick
        ? ((F = this.g.jmulAdd(B, M.getPublic(), T)), F.isInfinity() ? !1 : F.eqXToP(A))
        : ((F = this.g.mulAdd(B, M.getPublic(), T)),
          F.isInfinity() ? !1 : F.getX().umod(this.n).cmp(A) === 0);
    }),
    (g.prototype.recoverPubKey = function (b, p, _, M) {
      a((3 & _) === _, "The recovery param is more than two bits"), (p = new v(p, M));
      var S = this.n,
        A = new t(b),
        k = p.r,
        P = p.s,
        B = _ & 1,
        T = _ >> 1;
      if (k.cmp(this.curve.p.umod(this.curve.n)) >= 0 && T)
        throw new Error("Unable to find sencond key candinate");
      T ? (k = this.curve.pointFromX(k.add(this.curve.n), B)) : (k = this.curve.pointFromX(k, B));
      var F = p.r.invm(S),
        O = S.sub(A).mul(F).umod(S),
        $ = P.mul(F).umod(S);
      return this.g.mulAdd(O, k, $);
    }),
    (g.prototype.getKeyRecoveryParam = function (b, p, _, M) {
      if (((p = new v(p, M)), p.recoveryParam !== null)) return p.recoveryParam;
      for (var S = 0; S < 4; S++) {
        var A;
        try {
          A = this.recoverPubKey(b, p, S);
        } catch {
          continue;
        }
        if (A.eq(_)) return S;
      }
      throw new Error("Unable to find valid recovery factor");
    }),
    n0
  );
}
var i0, ab;
function w7() {
  if (ab) return i0;
  ab = 1;
  var t = An(),
    e = t.assert,
    n = t.parseBytes,
    i = t.cachedProperty;
  function l(a, c) {
    (this.eddsa = a),
      (this._secret = n(c.secret)),
      a.isPoint(c.pub) ? (this._pub = c.pub) : (this._pubBytes = n(c.pub));
  }
  return (
    (l.fromPublic = function (c, v) {
      return v instanceof l ? v : new l(c, { pub: v });
    }),
    (l.fromSecret = function (c, v) {
      return v instanceof l ? v : new l(c, { secret: v });
    }),
    (l.prototype.secret = function () {
      return this._secret;
    }),
    i(l, "pubBytes", function () {
      return this.eddsa.encodePoint(this.pub());
    }),
    i(l, "pub", function () {
      return this._pubBytes
        ? this.eddsa.decodePoint(this._pubBytes)
        : this.eddsa.g.mul(this.priv());
    }),
    i(l, "privBytes", function () {
      var c = this.eddsa,
        v = this.hash(),
        g = c.encodingLength - 1,
        b = v.slice(0, c.encodingLength);
      return (b[0] &= 248), (b[g] &= 127), (b[g] |= 64), b;
    }),
    i(l, "priv", function () {
      return this.eddsa.decodeInt(this.privBytes());
    }),
    i(l, "hash", function () {
      return this.eddsa.hash().update(this.secret()).digest();
    }),
    i(l, "messagePrefix", function () {
      return this.hash().slice(this.eddsa.encodingLength);
    }),
    (l.prototype.sign = function (c) {
      return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(c, this);
    }),
    (l.prototype.verify = function (c, v) {
      return this.eddsa.verify(c, v, this);
    }),
    (l.prototype.getSecret = function (c) {
      return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), c);
    }),
    (l.prototype.getPublic = function (c) {
      return t.encode(this.pubBytes(), c);
    }),
    (i0 = l),
    i0
  );
}
var a0, sb;
function _7() {
  if (sb) return a0;
  sb = 1;
  var t = Ai(),
    e = An(),
    n = e.assert,
    i = e.cachedProperty,
    l = e.parseBytes;
  function a(c, v) {
    (this.eddsa = c),
      typeof v != "object" && (v = l(v)),
      Array.isArray(v) &&
        (v = {
          R: v.slice(0, c.encodingLength),
          S: v.slice(c.encodingLength),
        }),
      n(v.R && v.S, "Signature without R or S"),
      c.isPoint(v.R) && (this._R = v.R),
      v.S instanceof t && (this._S = v.S),
      (this._Rencoded = Array.isArray(v.R) ? v.R : v.Rencoded),
      (this._Sencoded = Array.isArray(v.S) ? v.S : v.Sencoded);
  }
  return (
    i(a, "S", function () {
      return this.eddsa.decodeInt(this.Sencoded());
    }),
    i(a, "R", function () {
      return this.eddsa.decodePoint(this.Rencoded());
    }),
    i(a, "Rencoded", function () {
      return this.eddsa.encodePoint(this.R());
    }),
    i(a, "Sencoded", function () {
      return this.eddsa.encodeInt(this.S());
    }),
    (a.prototype.toBytes = function () {
      return this.Rencoded().concat(this.Sencoded());
    }),
    (a.prototype.toHex = function () {
      return e.encode(this.toBytes(), "hex").toUpperCase();
    }),
    (a0 = a),
    a0
  );
}
var s0, ob;
function x7() {
  if (ob) return s0;
  ob = 1;
  var t = R1(),
    e = I1(),
    n = An(),
    i = n.assert,
    l = n.parseBytes,
    a = w7(),
    c = _7();
  function v(g) {
    if ((i(g === "ed25519", "only tested with ed25519 so far"), !(this instanceof v)))
      return new v(g);
    (g = e[g].curve),
      (this.curve = g),
      (this.g = g.g),
      this.g.precompute(g.n.bitLength() + 1),
      (this.pointClass = g.point().constructor),
      (this.encodingLength = Math.ceil(g.n.bitLength() / 8)),
      (this.hash = t.sha512);
  }
  return (
    (s0 = v),
    (v.prototype.sign = function (b, p) {
      b = l(b);
      var _ = this.keyFromSecret(p),
        M = this.hashInt(_.messagePrefix(), b),
        S = this.g.mul(M),
        A = this.encodePoint(S),
        k = this.hashInt(A, _.pubBytes(), b).mul(_.priv()),
        P = M.add(k).umod(this.curve.n);
      return this.makeSignature({ R: S, S: P, Rencoded: A });
    }),
    (v.prototype.verify = function (b, p, _) {
      (b = l(b)), (p = this.makeSignature(p));
      var M = this.keyFromPublic(_),
        S = this.hashInt(p.Rencoded(), M.pubBytes(), b),
        A = this.g.mul(p.S()),
        k = p.R().add(M.pub().mul(S));
      return k.eq(A);
    }),
    (v.prototype.hashInt = function () {
      for (var b = this.hash(), p = 0; p < arguments.length; p++) b.update(arguments[p]);
      return n.intFromLE(b.digest()).umod(this.curve.n);
    }),
    (v.prototype.keyFromPublic = function (b) {
      return a.fromPublic(this, b);
    }),
    (v.prototype.keyFromSecret = function (b) {
      return a.fromSecret(this, b);
    }),
    (v.prototype.makeSignature = function (b) {
      return b instanceof c ? b : new c(this, b);
    }),
    (v.prototype.encodePoint = function (b) {
      var p = b.getY().toArray("le", this.encodingLength);
      return (p[this.encodingLength - 1] |= b.getX().isOdd() ? 128 : 0), p;
    }),
    (v.prototype.decodePoint = function (b) {
      b = n.parseBytes(b);
      var p = b.length - 1,
        _ = b.slice(0, p).concat(b[p] & -129),
        M = (b[p] & 128) !== 0,
        S = n.intFromLE(_);
      return this.curve.pointFromY(S, M);
    }),
    (v.prototype.encodeInt = function (b) {
      return b.toArray("le", this.encodingLength);
    }),
    (v.prototype.decodeInt = function (b) {
      return n.intFromLE(b);
    }),
    (v.prototype.isPoint = function (b) {
      return b instanceof this.pointClass;
    }),
    s0
  );
}
var fb;
function O1() {
  return (
    fb ||
      ((fb = 1),
      (function (t) {
        var e = t;
        (e.version = a7.version),
          (e.utils = An()),
          (e.rand = B1()),
          (e.curve = Uw()),
          (e.curves = I1()),
          (e.ec = b7()),
          (e.eddsa = x7());
      })(Ud)),
    Ud
  );
}
var vn = {},
  o0 = {},
  _l = { exports: {} };
_l.exports;
var lb;
function M7() {
  return (
    lb ||
      ((lb = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(_l)),
    _l.exports
  );
}
var f0 = {};
const S7 = {},
  E7 = /* @__PURE__ */ Object.freeze(
    /* @__PURE__ */ Object.defineProperty(
      {
        __proto__: null,
        default: S7,
      },
      Symbol.toStringTag,
      { value: "Module" }
    )
  ),
  A7 = /* @__PURE__ */ R6(E7);
var ub;
function k7() {
  return (
    ub ||
      ((ub = 1),
      (function (t) {
        var e = Tf(),
          n = It(),
          i = t;
        i.define = function (c, v) {
          return new l(c, v);
        };
        function l(a, c) {
          (this.name = a), (this.body = c), (this.decoders = {}), (this.encoders = {});
        }
        (l.prototype._createNamed = function (c) {
          var v;
          try {
            v = A7.runInThisContext(
              "(function " +
                this.name +
                `(entity) {
  this._initNamed(entity);
})`
            );
          } catch {
            v = function (b) {
              this._initNamed(b);
            };
          }
          return (
            n(v, c),
            (v.prototype._initNamed = function (b) {
              c.call(this, b);
            }),
            new v(this)
          );
        }),
          (l.prototype._getDecoder = function (c) {
            return (
              (c = c || "der"),
              this.decoders.hasOwnProperty(c) ||
                (this.decoders[c] = this._createNamed(e.decoders[c])),
              this.decoders[c]
            );
          }),
          (l.prototype.decode = function (c, v, g) {
            return this._getDecoder(v).decode(c, g);
          }),
          (l.prototype._getEncoder = function (c) {
            return (
              (c = c || "der"),
              this.encoders.hasOwnProperty(c) ||
                (this.encoders[c] = this._createNamed(e.encoders[c])),
              this.encoders[c]
            );
          }),
          (l.prototype.encode = function (c, v, g) {
            return this._getEncoder(v).encode(c, g);
          });
      })(f0)),
    f0
  );
}
var l0 = {},
  u0 = {},
  cb;
function B7() {
  if (cb) return u0;
  cb = 1;
  var t = It();
  function e(i) {
    this._reporterState = {
      obj: null,
      path: [],
      options: i || {},
      errors: [],
    };
  }
  (u0.Reporter = e),
    (e.prototype.isError = function (l) {
      return l instanceof n;
    }),
    (e.prototype.save = function () {
      var l = this._reporterState;
      return { obj: l.obj, pathLen: l.path.length };
    }),
    (e.prototype.restore = function (l) {
      var a = this._reporterState;
      (a.obj = l.obj), (a.path = a.path.slice(0, l.pathLen));
    }),
    (e.prototype.enterKey = function (l) {
      return this._reporterState.path.push(l);
    }),
    (e.prototype.exitKey = function (l) {
      var a = this._reporterState;
      a.path = a.path.slice(0, l - 1);
    }),
    (e.prototype.leaveKey = function (l, a, c) {
      var v = this._reporterState;
      this.exitKey(l), v.obj !== null && (v.obj[a] = c);
    }),
    (e.prototype.path = function () {
      return this._reporterState.path.join("/");
    }),
    (e.prototype.enterObject = function () {
      var l = this._reporterState,
        a = l.obj;
      return (l.obj = {}), a;
    }),
    (e.prototype.leaveObject = function (l) {
      var a = this._reporterState,
        c = a.obj;
      return (a.obj = l), c;
    }),
    (e.prototype.error = function (l) {
      var a,
        c = this._reporterState,
        v = l instanceof n;
      if (
        (v
          ? (a = l)
          : (a = new n(
              c.path
                .map(function (g) {
                  return "[" + JSON.stringify(g) + "]";
                })
                .join(""),
              l.message || l,
              l.stack
            )),
        !c.options.partial)
      )
        throw a;
      return v || c.errors.push(a), a;
    }),
    (e.prototype.wrapResult = function (l) {
      var a = this._reporterState;
      return a.options.partial
        ? {
            result: this.isError(l) ? null : l,
            errors: a.errors,
          }
        : l;
    });
  function n(i, l) {
    (this.path = i), this.rethrow(l);
  }
  return (
    t(n, Error),
    (n.prototype.rethrow = function (l) {
      if (
        ((this.message = l + " at: " + (this.path || "(shallow)")),
        Error.captureStackTrace && Error.captureStackTrace(this, n),
        !this.stack)
      )
        try {
          throw new Error(this.message);
        } catch (a) {
          this.stack = a.stack;
        }
      return this;
    }),
    u0
  );
}
var sl = {},
  hb;
function db() {
  if (hb) return sl;
  hb = 1;
  var t = It(),
    e = Yo().Reporter,
    n = Mr.Buffer;
  function i(a, c) {
    if ((e.call(this, c), !n.isBuffer(a))) {
      this.error("Input not Buffer");
      return;
    }
    (this.base = a), (this.offset = 0), (this.length = a.length);
  }
  t(i, e),
    (sl.DecoderBuffer = i),
    (i.prototype.save = function () {
      return { offset: this.offset, reporter: e.prototype.save.call(this) };
    }),
    (i.prototype.restore = function (c) {
      var v = new i(this.base);
      return (
        (v.offset = c.offset),
        (v.length = this.offset),
        (this.offset = c.offset),
        e.prototype.restore.call(this, c.reporter),
        v
      );
    }),
    (i.prototype.isEmpty = function () {
      return this.offset === this.length;
    }),
    (i.prototype.readUInt8 = function (c) {
      return this.offset + 1 <= this.length
        ? this.base.readUInt8(this.offset++, !0)
        : this.error(c || "DecoderBuffer overrun");
    }),
    (i.prototype.skip = function (c, v) {
      if (!(this.offset + c <= this.length)) return this.error(v || "DecoderBuffer overrun");
      var g = new i(this.base);
      return (
        (g._reporterState = this._reporterState),
        (g.offset = this.offset),
        (g.length = this.offset + c),
        (this.offset += c),
        g
      );
    }),
    (i.prototype.raw = function (c) {
      return this.base.slice(c ? c.offset : this.offset, this.length);
    });
  function l(a, c) {
    if (Array.isArray(a))
      (this.length = 0),
        (this.value = a.map(function (v) {
          return v instanceof l || (v = new l(v, c)), (this.length += v.length), v;
        }, this));
    else if (typeof a == "number") {
      if (!(0 <= a && a <= 255)) return c.error("non-byte EncoderBuffer value");
      (this.value = a), (this.length = 1);
    } else if (typeof a == "string") (this.value = a), (this.length = n.byteLength(a));
    else if (n.isBuffer(a)) (this.value = a), (this.length = a.length);
    else return c.error("Unsupported type: " + typeof a);
  }
  return (
    (sl.EncoderBuffer = l),
    (l.prototype.join = function (c, v) {
      return (
        c || (c = new n(this.length)),
        v || (v = 0),
        this.length === 0 ||
          (Array.isArray(this.value)
            ? this.value.forEach(function (g) {
                g.join(c, v), (v += g.length);
              })
            : (typeof this.value == "number"
                ? (c[v] = this.value)
                : typeof this.value == "string"
                ? c.write(this.value, v)
                : n.isBuffer(this.value) && this.value.copy(c, v),
              (v += this.length))),
        c
      );
    }),
    sl
  );
}
var c0, pb;
function C7() {
  if (pb) return c0;
  pb = 1;
  var t = Yo().Reporter,
    e = Yo().EncoderBuffer,
    n = Yo().DecoderBuffer,
    i = En(),
    l = [
      "seq",
      "seqof",
      "set",
      "setof",
      "objid",
      "bool",
      "gentime",
      "utctime",
      "null_",
      "enum",
      "int",
      "objDesc",
      "bitstr",
      "bmpstr",
      "charstr",
      "genstr",
      "graphstr",
      "ia5str",
      "iso646str",
      "numstr",
      "octstr",
      "printstr",
      "t61str",
      "unistr",
      "utf8str",
      "videostr",
    ],
    a = [
      "key",
      "obj",
      "use",
      "optional",
      "explicit",
      "implicit",
      "def",
      "choice",
      "any",
      "contains",
    ].concat(l),
    c = [
      "_peekTag",
      "_decodeTag",
      "_use",
      "_decodeStr",
      "_decodeObjid",
      "_decodeTime",
      "_decodeNull",
      "_decodeInt",
      "_decodeBool",
      "_decodeList",
      "_encodeComposite",
      "_encodeStr",
      "_encodeObjid",
      "_encodeTime",
      "_encodeNull",
      "_encodeInt",
      "_encodeBool",
    ];
  function v(b, p) {
    var _ = {};
    (this._baseState = _),
      (_.enc = b),
      (_.parent = p || null),
      (_.children = null),
      (_.tag = null),
      (_.args = null),
      (_.reverseArgs = null),
      (_.choice = null),
      (_.optional = !1),
      (_.any = !1),
      (_.obj = !1),
      (_.use = null),
      (_.useDecoder = null),
      (_.key = null),
      (_.default = null),
      (_.explicit = null),
      (_.implicit = null),
      (_.contains = null),
      _.parent || ((_.children = []), this._wrap());
  }
  c0 = v;
  var g = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains",
  ];
  return (
    (v.prototype.clone = function () {
      var p = this._baseState,
        _ = {};
      g.forEach(function (S) {
        _[S] = p[S];
      });
      var M = new this.constructor(_.parent);
      return (M._baseState = _), M;
    }),
    (v.prototype._wrap = function () {
      var p = this._baseState;
      a.forEach(function (_) {
        this[_] = function () {
          var S = new this.constructor(this);
          return p.children.push(S), S[_].apply(S, arguments);
        };
      }, this);
    }),
    (v.prototype._init = function (p) {
      var _ = this._baseState;
      i(_.parent === null),
        p.call(this),
        (_.children = _.children.filter(function (M) {
          return M._baseState.parent === this;
        }, this)),
        i.equal(_.children.length, 1, "Root node can have only one child");
    }),
    (v.prototype._useArgs = function (p) {
      var _ = this._baseState,
        M = p.filter(function (S) {
          return S instanceof this.constructor;
        }, this);
      (p = p.filter(function (S) {
        return !(S instanceof this.constructor);
      }, this)),
        M.length !== 0 &&
          (i(_.children === null),
          (_.children = M),
          M.forEach(function (S) {
            S._baseState.parent = this;
          }, this)),
        p.length !== 0 &&
          (i(_.args === null),
          (_.args = p),
          (_.reverseArgs = p.map(function (S) {
            if (typeof S != "object" || S.constructor !== Object) return S;
            var A = {};
            return (
              Object.keys(S).forEach(function (k) {
                k == (k | 0) && (k |= 0);
                var P = S[k];
                A[P] = k;
              }),
              A
            );
          })));
    }),
    c.forEach(function (b) {
      v.prototype[b] = function () {
        var _ = this._baseState;
        throw new Error(b + " not implemented for encoding: " + _.enc);
      };
    }),
    l.forEach(function (b) {
      v.prototype[b] = function () {
        var _ = this._baseState,
          M = Array.prototype.slice.call(arguments);
        return i(_.tag === null), (_.tag = b), this._useArgs(M), this;
      };
    }),
    (v.prototype.use = function (p) {
      i(p);
      var _ = this._baseState;
      return i(_.use === null), (_.use = p), this;
    }),
    (v.prototype.optional = function () {
      var p = this._baseState;
      return (p.optional = !0), this;
    }),
    (v.prototype.def = function (p) {
      var _ = this._baseState;
      return i(_.default === null), (_.default = p), (_.optional = !0), this;
    }),
    (v.prototype.explicit = function (p) {
      var _ = this._baseState;
      return i(_.explicit === null && _.implicit === null), (_.explicit = p), this;
    }),
    (v.prototype.implicit = function (p) {
      var _ = this._baseState;
      return i(_.explicit === null && _.implicit === null), (_.implicit = p), this;
    }),
    (v.prototype.obj = function () {
      var p = this._baseState,
        _ = Array.prototype.slice.call(arguments);
      return (p.obj = !0), _.length !== 0 && this._useArgs(_), this;
    }),
    (v.prototype.key = function (p) {
      var _ = this._baseState;
      return i(_.key === null), (_.key = p), this;
    }),
    (v.prototype.any = function () {
      var p = this._baseState;
      return (p.any = !0), this;
    }),
    (v.prototype.choice = function (p) {
      var _ = this._baseState;
      return (
        i(_.choice === null),
        (_.choice = p),
        this._useArgs(
          Object.keys(p).map(function (M) {
            return p[M];
          })
        ),
        this
      );
    }),
    (v.prototype.contains = function (p) {
      var _ = this._baseState;
      return i(_.use === null), (_.contains = p), this;
    }),
    (v.prototype._decode = function (p, _) {
      var M = this._baseState;
      if (M.parent === null) return p.wrapResult(M.children[0]._decode(p, _));
      var S = M.default,
        A = !0,
        k = null;
      if ((M.key !== null && (k = p.enterKey(M.key)), M.optional)) {
        var P = null;
        if (
          (M.explicit !== null
            ? (P = M.explicit)
            : M.implicit !== null
            ? (P = M.implicit)
            : M.tag !== null && (P = M.tag),
          P === null && !M.any)
        ) {
          var B = p.save();
          try {
            M.choice === null ? this._decodeGeneric(M.tag, p, _) : this._decodeChoice(p, _),
              (A = !0);
          } catch {
            A = !1;
          }
          p.restore(B);
        } else if (((A = this._peekTag(p, P, M.any)), p.isError(A))) return A;
      }
      var T;
      if ((M.obj && A && (T = p.enterObject()), A)) {
        if (M.explicit !== null) {
          var F = this._decodeTag(p, M.explicit);
          if (p.isError(F)) return F;
          p = F;
        }
        var O = p.offset;
        if (M.use === null && M.choice === null) {
          if (M.any) var B = p.save();
          var $ = this._decodeTag(p, M.implicit !== null ? M.implicit : M.tag, M.any);
          if (p.isError($)) return $;
          M.any ? (S = p.raw(B)) : (p = $);
        }
        if (
          (_ && _.track && M.tag !== null && _.track(p.path(), O, p.length, "tagged"),
          _ && _.track && M.tag !== null && _.track(p.path(), p.offset, p.length, "content"),
          M.any
            ? (S = S)
            : M.choice === null
            ? (S = this._decodeGeneric(M.tag, p, _))
            : (S = this._decodeChoice(p, _)),
          p.isError(S))
        )
          return S;
        if (
          (!M.any &&
            M.choice === null &&
            M.children !== null &&
            M.children.forEach(function (de) {
              de._decode(p, _);
            }),
          M.contains && (M.tag === "octstr" || M.tag === "bitstr"))
        ) {
          var J = new n(S);
          S = this._getUse(M.contains, p._reporterState.obj)._decode(J, _);
        }
      }
      return (
        M.obj && A && (S = p.leaveObject(T)),
        M.key !== null && (S !== null || A === !0)
          ? p.leaveKey(k, M.key, S)
          : k !== null && p.exitKey(k),
        S
      );
    }),
    (v.prototype._decodeGeneric = function (p, _, M) {
      var S = this._baseState;
      return p === "seq" || p === "set"
        ? null
        : p === "seqof" || p === "setof"
        ? this._decodeList(_, p, S.args[0], M)
        : /str$/.test(p)
        ? this._decodeStr(_, p, M)
        : p === "objid" && S.args
        ? this._decodeObjid(_, S.args[0], S.args[1], M)
        : p === "objid"
        ? this._decodeObjid(_, null, null, M)
        : p === "gentime" || p === "utctime"
        ? this._decodeTime(_, p, M)
        : p === "null_"
        ? this._decodeNull(_, M)
        : p === "bool"
        ? this._decodeBool(_, M)
        : p === "objDesc"
        ? this._decodeStr(_, p, M)
        : p === "int" || p === "enum"
        ? this._decodeInt(_, S.args && S.args[0], M)
        : S.use !== null
        ? this._getUse(S.use, _._reporterState.obj)._decode(_, M)
        : _.error("unknown tag: " + p);
    }),
    (v.prototype._getUse = function (p, _) {
      var M = this._baseState;
      return (
        (M.useDecoder = this._use(p, _)),
        i(M.useDecoder._baseState.parent === null),
        (M.useDecoder = M.useDecoder._baseState.children[0]),
        M.implicit !== M.useDecoder._baseState.implicit &&
          ((M.useDecoder = M.useDecoder.clone()), (M.useDecoder._baseState.implicit = M.implicit)),
        M.useDecoder
      );
    }),
    (v.prototype._decodeChoice = function (p, _) {
      var M = this._baseState,
        S = null,
        A = !1;
      return (
        Object.keys(M.choice).some(function (k) {
          var P = p.save(),
            B = M.choice[k];
          try {
            var T = B._decode(p, _);
            if (p.isError(T)) return !1;
            (S = { type: k, value: T }), (A = !0);
          } catch {
            return p.restore(P), !1;
          }
          return !0;
        }, this),
        A ? S : p.error("Choice not matched")
      );
    }),
    (v.prototype._createEncoderBuffer = function (p) {
      return new e(p, this.reporter);
    }),
    (v.prototype._encode = function (p, _, M) {
      var S = this._baseState;
      if (!(S.default !== null && S.default === p)) {
        var A = this._encodeValue(p, _, M);
        if (A !== void 0 && !this._skipDefault(A, _, M)) return A;
      }
    }),
    (v.prototype._encodeValue = function (p, _, M) {
      var S = this._baseState;
      if (S.parent === null) return S.children[0]._encode(p, _ || new t());
      var B = null;
      if (((this.reporter = _), S.optional && p === void 0))
        if (S.default !== null) p = S.default;
        else return;
      var A = null,
        k = !1;
      if (S.any) B = this._createEncoderBuffer(p);
      else if (S.choice) B = this._encodeChoice(p, _);
      else if (S.contains) (A = this._getUse(S.contains, M)._encode(p, _)), (k = !0);
      else if (S.children)
        (A = S.children
          .map(function (O) {
            if (O._baseState.tag === "null_") return O._encode(null, _, p);
            if (O._baseState.key === null) return _.error("Child should have a key");
            var $ = _.enterKey(O._baseState.key);
            if (typeof p != "object") return _.error("Child expected, but input is not object");
            var J = O._encode(p[O._baseState.key], _, p);
            return _.leaveKey($), J;
          }, this)
          .filter(function (O) {
            return O;
          })),
          (A = this._createEncoderBuffer(A));
      else if (S.tag === "seqof" || S.tag === "setof") {
        if (!(S.args && S.args.length === 1)) return _.error("Too many args for : " + S.tag);
        if (!Array.isArray(p)) return _.error("seqof/setof, but data is not Array");
        var P = this.clone();
        (P._baseState.implicit = null),
          (A = this._createEncoderBuffer(
            p.map(function (O) {
              var $ = this._baseState;
              return this._getUse($.args[0], p)._encode(O, _);
            }, P)
          ));
      } else
        S.use !== null
          ? (B = this._getUse(S.use, M)._encode(p, _))
          : ((A = this._encodePrimitive(S.tag, p)), (k = !0));
      var B;
      if (!S.any && S.choice === null) {
        var T = S.implicit !== null ? S.implicit : S.tag,
          F = S.implicit === null ? "universal" : "context";
        T === null
          ? S.use === null && _.error("Tag could be omitted only for .use()")
          : S.use === null && (B = this._encodeComposite(T, k, F, A));
      }
      return S.explicit !== null && (B = this._encodeComposite(S.explicit, !1, "context", B)), B;
    }),
    (v.prototype._encodeChoice = function (p, _) {
      var M = this._baseState,
        S = M.choice[p.type];
      return (
        S || i(!1, p.type + " not found in " + JSON.stringify(Object.keys(M.choice))),
        S._encode(p.value, _)
      );
    }),
    (v.prototype._encodePrimitive = function (p, _) {
      var M = this._baseState;
      if (/str$/.test(p)) return this._encodeStr(_, p);
      if (p === "objid" && M.args) return this._encodeObjid(_, M.reverseArgs[0], M.args[1]);
      if (p === "objid") return this._encodeObjid(_, null, null);
      if (p === "gentime" || p === "utctime") return this._encodeTime(_, p);
      if (p === "null_") return this._encodeNull();
      if (p === "int" || p === "enum") return this._encodeInt(_, M.args && M.reverseArgs[0]);
      if (p === "bool") return this._encodeBool(_);
      if (p === "objDesc") return this._encodeStr(_, p);
      throw new Error("Unsupported tag: " + p);
    }),
    (v.prototype._isNumstr = function (p) {
      return /^[0-9 ]*$/.test(p);
    }),
    (v.prototype._isPrintstr = function (p) {
      return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(p);
    }),
    c0
  );
}
var mb;
function Yo() {
  return (
    mb ||
      ((mb = 1),
      (function (t) {
        var e = t;
        (e.Reporter = B7().Reporter),
          (e.DecoderBuffer = db().DecoderBuffer),
          (e.EncoderBuffer = db().EncoderBuffer),
          (e.Node = C7());
      })(l0)),
    l0
  );
}
var h0 = {},
  d0 = {},
  vb;
function T7() {
  return (
    vb ||
      ((vb = 1),
      (function (t) {
        var e = Fw();
        (t.tagClass = {
          0: "universal",
          1: "application",
          2: "context",
          3: "private",
        }),
          (t.tagClassByName = e._reverse(t.tagClass)),
          (t.tag = {
            0: "end",
            1: "bool",
            2: "int",
            3: "bitstr",
            4: "octstr",
            5: "null_",
            6: "objid",
            7: "objDesc",
            8: "external",
            9: "real",
            10: "enum",
            11: "embed",
            12: "utf8str",
            13: "relativeOid",
            16: "seq",
            17: "set",
            18: "numstr",
            19: "printstr",
            20: "t61str",
            21: "videostr",
            22: "ia5str",
            23: "utctime",
            24: "gentime",
            25: "graphstr",
            26: "iso646str",
            27: "genstr",
            28: "unistr",
            29: "charstr",
            30: "bmpstr",
          }),
          (t.tagByName = e._reverse(t.tag));
      })(d0)),
    d0
  );
}
var gb;
function Fw() {
  return (
    gb ||
      ((gb = 1),
      (function (t) {
        var e = t;
        (e._reverse = function (i) {
          var l = {};
          return (
            Object.keys(i).forEach(function (a) {
              (a | 0) == a && (a = a | 0);
              var c = i[a];
              l[c] = a;
            }),
            l
          );
        }),
          (e.der = T7());
      })(h0)),
    h0
  );
}
var p0 = {},
  m0,
  yb;
function qw() {
  if (yb) return m0;
  yb = 1;
  var t = It(),
    e = Tf(),
    n = e.base,
    i = e.bignum,
    l = e.constants.der;
  function a(b) {
    (this.enc = "der"),
      (this.name = b.name),
      (this.entity = b),
      (this.tree = new c()),
      this.tree._init(b.body);
  }
  (m0 = a),
    (a.prototype.decode = function (p, _) {
      return (
        p instanceof n.DecoderBuffer || (p = new n.DecoderBuffer(p, _)), this.tree._decode(p, _)
      );
    });
  function c(b) {
    n.Node.call(this, "der", b);
  }
  t(c, n.Node),
    (c.prototype._peekTag = function (p, _, M) {
      if (p.isEmpty()) return !1;
      var S = p.save(),
        A = v(p, 'Failed to peek tag: "' + _ + '"');
      return p.isError(A)
        ? A
        : (p.restore(S), A.tag === _ || A.tagStr === _ || A.tagStr + "of" === _ || M);
    }),
    (c.prototype._decodeTag = function (p, _, M) {
      var S = v(p, 'Failed to decode tag of "' + _ + '"');
      if (p.isError(S)) return S;
      var A = g(p, S.primitive, 'Failed to get length of "' + _ + '"');
      if (p.isError(A)) return A;
      if (!M && S.tag !== _ && S.tagStr !== _ && S.tagStr + "of" !== _)
        return p.error('Failed to match tag: "' + _ + '"');
      if (S.primitive || A !== null) return p.skip(A, 'Failed to match body of: "' + _ + '"');
      var k = p.save(),
        P = this._skipUntilEnd(p, 'Failed to skip indefinite length body: "' + this.tag + '"');
      return p.isError(P)
        ? P
        : ((A = p.offset - k.offset),
          p.restore(k),
          p.skip(A, 'Failed to match body of: "' + _ + '"'));
    }),
    (c.prototype._skipUntilEnd = function (p, _) {
      for (;;) {
        var M = v(p, _);
        if (p.isError(M)) return M;
        var S = g(p, M.primitive, _);
        if (p.isError(S)) return S;
        var A;
        if (
          (M.primitive || S !== null ? (A = p.skip(S)) : (A = this._skipUntilEnd(p, _)),
          p.isError(A))
        )
          return A;
        if (M.tagStr === "end") break;
      }
    }),
    (c.prototype._decodeList = function (p, _, M, S) {
      for (var A = []; !p.isEmpty(); ) {
        var k = this._peekTag(p, "end");
        if (p.isError(k)) return k;
        var P = M.decode(p, "der", S);
        if (p.isError(P) && k) break;
        A.push(P);
      }
      return A;
    }),
    (c.prototype._decodeStr = function (p, _) {
      if (_ === "bitstr") {
        var M = p.readUInt8();
        return p.isError(M) ? M : { unused: M, data: p.raw() };
      } else if (_ === "bmpstr") {
        var S = p.raw();
        if (S.length % 2 === 1) return p.error("Decoding of string type: bmpstr length mismatch");
        for (var A = "", k = 0; k < S.length / 2; k++)
          A += String.fromCharCode(S.readUInt16BE(k * 2));
        return A;
      } else if (_ === "numstr") {
        var P = p.raw().toString("ascii");
        return this._isNumstr(P)
          ? P
          : p.error("Decoding of string type: numstr unsupported characters");
      } else {
        if (_ === "octstr") return p.raw();
        if (_ === "objDesc") return p.raw();
        if (_ === "printstr") {
          var B = p.raw().toString("ascii");
          return this._isPrintstr(B)
            ? B
            : p.error("Decoding of string type: printstr unsupported characters");
        } else
          return /str$/.test(_)
            ? p.raw().toString()
            : p.error("Decoding of string type: " + _ + " unsupported");
      }
    }),
    (c.prototype._decodeObjid = function (p, _, M) {
      for (var S, A = [], k = 0; !p.isEmpty(); ) {
        var P = p.readUInt8();
        (k <<= 7), (k |= P & 127), P & 128 || (A.push(k), (k = 0));
      }
      P & 128 && A.push(k);
      var B = (A[0] / 40) | 0,
        T = A[0] % 40;
      if ((M ? (S = A) : (S = [B, T].concat(A.slice(1))), _)) {
        var F = _[S.join(" ")];
        F === void 0 && (F = _[S.join(".")]), F !== void 0 && (S = F);
      }
      return S;
    }),
    (c.prototype._decodeTime = function (p, _) {
      var M = p.raw().toString();
      if (_ === "gentime")
        var S = M.slice(0, 4) | 0,
          A = M.slice(4, 6) | 0,
          k = M.slice(6, 8) | 0,
          P = M.slice(8, 10) | 0,
          B = M.slice(10, 12) | 0,
          T = M.slice(12, 14) | 0;
      else if (_ === "utctime") {
        var S = M.slice(0, 2) | 0,
          A = M.slice(2, 4) | 0,
          k = M.slice(4, 6) | 0,
          P = M.slice(6, 8) | 0,
          B = M.slice(8, 10) | 0,
          T = M.slice(10, 12) | 0;
        S < 70 ? (S = 2e3 + S) : (S = 1900 + S);
      } else return p.error("Decoding " + _ + " time is not supported yet");
      return Date.UTC(S, A - 1, k, P, B, T, 0);
    }),
    (c.prototype._decodeNull = function (p) {
      return null;
    }),
    (c.prototype._decodeBool = function (p) {
      var _ = p.readUInt8();
      return p.isError(_) ? _ : _ !== 0;
    }),
    (c.prototype._decodeInt = function (p, _) {
      var M = p.raw(),
        S = new i(M);
      return _ && (S = _[S.toString(10)] || S), S;
    }),
    (c.prototype._use = function (p, _) {
      return typeof p == "function" && (p = p(_)), p._getDecoder("der").tree;
    });
  function v(b, p) {
    var _ = b.readUInt8(p);
    if (b.isError(_)) return _;
    var M = l.tagClass[_ >> 6],
      S = (_ & 32) === 0;
    if ((_ & 31) === 31) {
      var A = _;
      for (_ = 0; (A & 128) === 128; ) {
        if (((A = b.readUInt8(p)), b.isError(A))) return A;
        (_ <<= 7), (_ |= A & 127);
      }
    } else _ &= 31;
    var k = l.tag[_];
    return {
      cls: M,
      primitive: S,
      tag: _,
      tagStr: k,
    };
  }
  function g(b, p, _) {
    var M = b.readUInt8(_);
    if (b.isError(M)) return M;
    if (!p && M === 128) return null;
    if (!(M & 128)) return M;
    var S = M & 127;
    if (S > 4) return b.error("length octect is too long");
    M = 0;
    for (var A = 0; A < S; A++) {
      M <<= 8;
      var k = b.readUInt8(_);
      if (b.isError(k)) return k;
      M |= k;
    }
    return M;
  }
  return m0;
}
var v0, bb;
function P7() {
  if (bb) return v0;
  bb = 1;
  var t = It(),
    e = Mr.Buffer,
    n = qw();
  function i(l) {
    n.call(this, l), (this.enc = "pem");
  }
  return (
    t(i, n),
    (v0 = i),
    (i.prototype.decode = function (a, c) {
      for (
        var v = a.toString().split(/[\r\n]+/g),
          g = c.label.toUpperCase(),
          b = /^-----(BEGIN|END) ([^-]+)-----$/,
          p = -1,
          _ = -1,
          M = 0;
        M < v.length;
        M++
      ) {
        var S = v[M].match(b);
        if (S !== null && S[2] === g)
          if (p === -1) {
            if (S[1] !== "BEGIN") break;
            p = M;
          } else {
            if (S[1] !== "END") break;
            _ = M;
            break;
          }
      }
      if (p === -1 || _ === -1) throw new Error("PEM section not found for: " + g);
      var A = v.slice(p + 1, _).join("");
      A.replace(/[^a-z0-9\+\/=]+/gi, "");
      var k = new e(A, "base64");
      return n.prototype.decode.call(this, k, c);
    }),
    v0
  );
}
var wb;
function R7() {
  return (
    wb ||
      ((wb = 1),
      (function (t) {
        var e = t;
        (e.der = qw()), (e.pem = P7());
      })(p0)),
    p0
  );
}
var g0 = {},
  y0,
  _b;
function zw() {
  if (_b) return y0;
  _b = 1;
  var t = It(),
    e = Mr.Buffer,
    n = Tf(),
    i = n.base,
    l = n.constants.der;
  function a(b) {
    (this.enc = "der"),
      (this.name = b.name),
      (this.entity = b),
      (this.tree = new c()),
      this.tree._init(b.body);
  }
  (y0 = a),
    (a.prototype.encode = function (p, _) {
      return this.tree._encode(p, _).join();
    });
  function c(b) {
    i.Node.call(this, "der", b);
  }
  t(c, i.Node),
    (c.prototype._encodeComposite = function (p, _, M, S) {
      var A = g(p, _, M, this.reporter);
      if (S.length < 128) {
        var B = new e(2);
        return (B[0] = A), (B[1] = S.length), this._createEncoderBuffer([B, S]);
      }
      for (var k = 1, P = S.length; P >= 256; P >>= 8) k++;
      var B = new e(2 + k);
      (B[0] = A), (B[1] = 128 | k);
      for (var P = 1 + k, T = S.length; T > 0; P--, T >>= 8) B[P] = T & 255;
      return this._createEncoderBuffer([B, S]);
    }),
    (c.prototype._encodeStr = function (p, _) {
      if (_ === "bitstr") return this._createEncoderBuffer([p.unused | 0, p.data]);
      if (_ === "bmpstr") {
        for (var M = new e(p.length * 2), S = 0; S < p.length; S++)
          M.writeUInt16BE(p.charCodeAt(S), S * 2);
        return this._createEncoderBuffer(M);
      } else
        return _ === "numstr"
          ? this._isNumstr(p)
            ? this._createEncoderBuffer(p)
            : this.reporter.error("Encoding of string type: numstr supports only digits and space")
          : _ === "printstr"
          ? this._isPrintstr(p)
            ? this._createEncoderBuffer(p)
            : this.reporter.error(
                "Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark"
              )
          : /str$/.test(_)
          ? this._createEncoderBuffer(p)
          : _ === "objDesc"
          ? this._createEncoderBuffer(p)
          : this.reporter.error("Encoding of string type: " + _ + " unsupported");
    }),
    (c.prototype._encodeObjid = function (p, _, M) {
      if (typeof p == "string") {
        if (!_) return this.reporter.error("string objid given, but no values map found");
        if (!_.hasOwnProperty(p)) return this.reporter.error("objid not found in values map");
        p = _[p].split(/[\s\.]+/g);
        for (var S = 0; S < p.length; S++) p[S] |= 0;
      } else if (Array.isArray(p)) {
        p = p.slice();
        for (var S = 0; S < p.length; S++) p[S] |= 0;
      }
      if (!Array.isArray(p))
        return this.reporter.error(
          "objid() should be either array or string, got: " + JSON.stringify(p)
        );
      if (!M) {
        if (p[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        p.splice(0, 2, p[0] * 40 + p[1]);
      }
      for (var A = 0, S = 0; S < p.length; S++) {
        var k = p[S];
        for (A++; k >= 128; k >>= 7) A++;
      }
      for (var P = new e(A), B = P.length - 1, S = p.length - 1; S >= 0; S--) {
        var k = p[S];
        for (P[B--] = k & 127; (k >>= 7) > 0; ) P[B--] = 128 | (k & 127);
      }
      return this._createEncoderBuffer(P);
    });
  function v(b) {
    return b < 10 ? "0" + b : b;
  }
  (c.prototype._encodeTime = function (p, _) {
    var M,
      S = new Date(p);
    return (
      _ === "gentime"
        ? (M = [
            v(S.getFullYear()),
            v(S.getUTCMonth() + 1),
            v(S.getUTCDate()),
            v(S.getUTCHours()),
            v(S.getUTCMinutes()),
            v(S.getUTCSeconds()),
            "Z",
          ].join(""))
        : _ === "utctime"
        ? (M = [
            v(S.getFullYear() % 100),
            v(S.getUTCMonth() + 1),
            v(S.getUTCDate()),
            v(S.getUTCHours()),
            v(S.getUTCMinutes()),
            v(S.getUTCSeconds()),
            "Z",
          ].join(""))
        : this.reporter.error("Encoding " + _ + " time is not supported yet"),
      this._encodeStr(M, "octstr")
    );
  }),
    (c.prototype._encodeNull = function () {
      return this._createEncoderBuffer("");
    }),
    (c.prototype._encodeInt = function (p, _) {
      if (typeof p == "string") {
        if (!_) return this.reporter.error("String int or enum given, but no values map");
        if (!_.hasOwnProperty(p))
          return this.reporter.error("Values map doesn't contain: " + JSON.stringify(p));
        p = _[p];
      }
      if (typeof p != "number" && !e.isBuffer(p)) {
        var M = p.toArray();
        !p.sign && M[0] & 128 && M.unshift(0), (p = new e(M));
      }
      if (e.isBuffer(p)) {
        var S = p.length;
        p.length === 0 && S++;
        var k = new e(S);
        return p.copy(k), p.length === 0 && (k[0] = 0), this._createEncoderBuffer(k);
      }
      if (p < 128) return this._createEncoderBuffer(p);
      if (p < 256) return this._createEncoderBuffer([0, p]);
      for (var S = 1, A = p; A >= 256; A >>= 8) S++;
      for (var k = new Array(S), A = k.length - 1; A >= 0; A--) (k[A] = p & 255), (p >>= 8);
      return k[0] & 128 && k.unshift(0), this._createEncoderBuffer(new e(k));
    }),
    (c.prototype._encodeBool = function (p) {
      return this._createEncoderBuffer(p ? 255 : 0);
    }),
    (c.prototype._use = function (p, _) {
      return typeof p == "function" && (p = p(_)), p._getEncoder("der").tree;
    }),
    (c.prototype._skipDefault = function (p, _, M) {
      var S = this._baseState,
        A;
      if (S.default === null) return !1;
      var k = p.join();
      if (
        (S.defaultBuffer === void 0 &&
          (S.defaultBuffer = this._encodeValue(S.default, _, M).join()),
        k.length !== S.defaultBuffer.length)
      )
        return !1;
      for (A = 0; A < k.length; A++) if (k[A] !== S.defaultBuffer[A]) return !1;
      return !0;
    });
  function g(b, p, _, M) {
    var S;
    if ((b === "seqof" ? (b = "seq") : b === "setof" && (b = "set"), l.tagByName.hasOwnProperty(b)))
      S = l.tagByName[b];
    else if (typeof b == "number" && (b | 0) === b) S = b;
    else return M.error("Unknown tag: " + b);
    return S >= 31
      ? M.error("Multi-octet tag encoding unsupported")
      : (p || (S |= 32), (S |= l.tagClassByName[_ || "universal"] << 6), S);
  }
  return y0;
}
var b0, xb;
function I7() {
  if (xb) return b0;
  xb = 1;
  var t = It(),
    e = zw();
  function n(i) {
    e.call(this, i), (this.enc = "pem");
  }
  return (
    t(n, e),
    (b0 = n),
    (n.prototype.encode = function (l, a) {
      for (
        var c = e.prototype.encode.call(this, l),
          v = c.toString("base64"),
          g = ["-----BEGIN " + a.label + "-----"],
          b = 0;
        b < v.length;
        b += 64
      )
        g.push(v.slice(b, b + 64));
      return (
        g.push("-----END " + a.label + "-----"),
        g.join(`
`)
      );
    }),
    b0
  );
}
var Mb;
function O7() {
  return (
    Mb ||
      ((Mb = 1),
      (function (t) {
        var e = t;
        (e.der = zw()), (e.pem = I7());
      })(g0)),
    g0
  );
}
var Sb;
function Tf() {
  return (
    Sb ||
      ((Sb = 1),
      (function (t) {
        var e = t;
        (e.bignum = M7()),
          (e.define = k7().define),
          (e.base = Yo()),
          (e.constants = Fw()),
          (e.decoders = R7()),
          (e.encoders = O7());
      })(o0)),
    o0
  );
}
var w0, Eb;
function U7() {
  if (Eb) return w0;
  Eb = 1;
  var t = Tf(),
    e = t.define("Time", function () {
      this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime(),
      });
    }),
    n = t.define("AttributeTypeValue", function () {
      this.seq().obj(this.key("type").objid(), this.key("value").any());
    }),
    i = t.define("AlgorithmIdentifier", function () {
      this.seq().obj(
        this.key("algorithm").objid(),
        this.key("parameters").optional(),
        this.key("curve").objid().optional()
      );
    }),
    l = t.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(i), this.key("subjectPublicKey").bitstr());
    }),
    a = t.define("RelativeDistinguishedName", function () {
      this.setof(n);
    }),
    c = t.define("RDNSequence", function () {
      this.seqof(a);
    }),
    v = t.define("Name", function () {
      this.choice({
        rdnSequence: this.use(c),
      });
    }),
    g = t.define("Validity", function () {
      this.seq().obj(this.key("notBefore").use(e), this.key("notAfter").use(e));
    }),
    b = t.define("Extension", function () {
      this.seq().obj(
        this.key("extnID").objid(),
        this.key("critical").bool().def(!1),
        this.key("extnValue").octstr()
      );
    }),
    p = t.define("TBSCertificate", function () {
      this.seq().obj(
        this.key("version").explicit(0).int().optional(),
        this.key("serialNumber").int(),
        this.key("signature").use(i),
        this.key("issuer").use(v),
        this.key("validity").use(g),
        this.key("subject").use(v),
        this.key("subjectPublicKeyInfo").use(l),
        this.key("issuerUniqueID").implicit(1).bitstr().optional(),
        this.key("subjectUniqueID").implicit(2).bitstr().optional(),
        this.key("extensions").explicit(3).seqof(b).optional()
      );
    }),
    _ = t.define("X509Certificate", function () {
      this.seq().obj(
        this.key("tbsCertificate").use(p),
        this.key("signatureAlgorithm").use(i),
        this.key("signatureValue").bitstr()
      );
    });
  return (w0 = _), w0;
}
var Ab;
function N7() {
  if (Ab) return vn;
  Ab = 1;
  var t = Tf();
  vn.certificate = U7();
  var e = t.define("RSAPrivateKey", function () {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  vn.RSAPrivateKey = e;
  var n = t.define("RSAPublicKey", function () {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
  });
  vn.RSAPublicKey = n;
  var i = t.define("AlgorithmIdentifier", function () {
      this.seq().obj(
        this.key("algorithm").objid(),
        this.key("none").null_().optional(),
        this.key("curve").objid().optional(),
        this.key("params")
          .seq()
          .obj(this.key("p").int(), this.key("q").int(), this.key("g").int())
          .optional()
      );
    }),
    l = t.define("SubjectPublicKeyInfo", function () {
      this.seq().obj(this.key("algorithm").use(i), this.key("subjectPublicKey").bitstr());
    });
  vn.PublicKey = l;
  var a = t.define("PrivateKeyInfo", function () {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  vn.PrivateKey = a;
  var c = t.define("EncryptedPrivateKeyInfo", function () {
    this.seq().obj(
      this.key("algorithm")
        .seq()
        .obj(
          this.key("id").objid(),
          this.key("decrypt")
            .seq()
            .obj(
              this.key("kde")
                .seq()
                .obj(
                  this.key("id").objid(),
                  this.key("kdeparams")
                    .seq()
                    .obj(this.key("salt").octstr(), this.key("iters").int())
                ),
              this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr())
            )
        ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  vn.EncryptedPrivateKey = c;
  var v = t.define("DSAPrivateKey", function () {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  (vn.DSAPrivateKey = v),
    (vn.DSAparam = t.define("DSAparam", function () {
      this.int();
    }));
  var g = t.define("ECParameters", function () {
      this.choice({
        namedCurve: this.objid(),
      });
    }),
    b = t.define("ECPrivateKey", function () {
      this.seq().obj(
        this.key("version").int(),
        this.key("privateKey").octstr(),
        this.key("parameters").optional().explicit(0).use(g),
        this.key("publicKey").optional().explicit(1).bitstr()
      );
    });
  return (
    (vn.ECPrivateKey = b),
    (vn.signature = t.define("signature", function () {
      this.seq().obj(this.key("r").int(), this.key("s").int());
    })),
    vn
  );
}
const D7 = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb",
};
var _0, kb;
function L7() {
  if (kb) return _0;
  kb = 1;
  var t =
      /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m,
    e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,
    n = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m,
    i = Ou(),
    l = k1(),
    a = zt().Buffer;
  return (
    (_0 = function (c, v) {
      var g = c.toString(),
        b = g.match(t),
        p;
      if (b) {
        var M = "aes" + b[1],
          S = a.from(b[2], "hex"),
          A = a.from(b[3].replace(/[\r\n]/g, ""), "base64"),
          k = i(v, S.slice(0, 8), parseInt(b[1], 10)).key,
          P = [],
          B = l.createDecipheriv(M, k, S);
        P.push(B.update(A)), P.push(B.final()), (p = a.concat(P));
      } else {
        var _ = g.match(n);
        p = a.from(_[2].replace(/[\r\n]/g, ""), "base64");
      }
      var T = g.match(e)[1];
      return {
        tag: T,
        data: p,
      };
    }),
    _0
  );
}
var x0, Bb;
function Du() {
  if (Bb) return x0;
  Bb = 1;
  var t = N7(),
    e = D7,
    n = L7(),
    i = k1(),
    l = bw(),
    a = zt().Buffer;
  function c(g, b) {
    var p = g.algorithm.decrypt.kde.kdeparams.salt,
      _ = parseInt(g.algorithm.decrypt.kde.kdeparams.iters.toString(), 10),
      M = e[g.algorithm.decrypt.cipher.algo.join(".")],
      S = g.algorithm.decrypt.cipher.iv,
      A = g.subjectPrivateKey,
      k = parseInt(M.split("-")[1], 10) / 8,
      P = l.pbkdf2Sync(b, p, _, k, "sha1"),
      B = i.createDecipheriv(M, P, S),
      T = [];
    return T.push(B.update(A)), T.push(B.final()), a.concat(T);
  }
  function v(g) {
    var b;
    typeof g == "object" && !a.isBuffer(g) && ((b = g.passphrase), (g = g.key)),
      typeof g == "string" && (g = a.from(g));
    var p = n(g, b),
      _ = p.tag,
      M = p.data,
      S,
      A;
    switch (_) {
      case "CERTIFICATE":
        A = t.certificate.decode(M, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (
          (A || (A = t.PublicKey.decode(M, "der")), (S = A.algorithm.algorithm.join(".")), S)
        ) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPublicKey.decode(A.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return (
              (A.subjectPrivateKey = A.subjectPublicKey),
              {
                type: "ec",
                data: A,
              }
            );
          case "1.2.840.10040.4.1":
            return (
              (A.algorithm.params.pub_key = t.DSAparam.decode(A.subjectPublicKey.data, "der")),
              {
                type: "dsa",
                data: A.algorithm.params,
              }
            );
          default:
            throw new Error("unknown key id " + S);
        }
      case "ENCRYPTED PRIVATE KEY":
        (M = t.EncryptedPrivateKey.decode(M, "der")), (M = c(M, b));
      case "PRIVATE KEY":
        switch (((A = t.PrivateKey.decode(M, "der")), (S = A.algorithm.algorithm.join(".")), S)) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPrivateKey.decode(A.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: A.algorithm.curve,
              privateKey: t.ECPrivateKey.decode(A.subjectPrivateKey, "der").privateKey,
            };
          case "1.2.840.10040.4.1":
            return (
              (A.algorithm.params.priv_key = t.DSAparam.decode(A.subjectPrivateKey, "der")),
              {
                type: "dsa",
                params: A.algorithm.params,
              }
            );
          default:
            throw new Error("unknown key id " + S);
        }
      case "RSA PUBLIC KEY":
        return t.RSAPublicKey.decode(M, "der");
      case "RSA PRIVATE KEY":
        return t.RSAPrivateKey.decode(M, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: t.DSAPrivateKey.decode(M, "der"),
        };
      case "EC PRIVATE KEY":
        return (
          (M = t.ECPrivateKey.decode(M, "der")),
          {
            curve: M.parameters.value,
            privateKey: M.privateKey,
          }
        );
      default:
        throw new Error("unknown key type " + _);
    }
  }
  return (v.signature = t.signature), (x0 = v), x0;
}
const jw = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521",
};
var Cb;
function F7() {
  if (Cb) return xo.exports;
  Cb = 1;
  var t = zt().Buffer,
    e = dw(),
    n = P1(),
    i = O1().ec,
    l = T1(),
    a = Du(),
    c = jw,
    v = 1;
  function g(B, T, F, O, $) {
    var J = a(T);
    if (J.curve) {
      if (O !== "ecdsa" && O !== "ecdsa/rsa") throw new Error("wrong private key type");
      return b(B, J);
    } else if (J.type === "dsa") {
      if (O !== "dsa") throw new Error("wrong private key type");
      return p(B, J, F);
    }
    if (O !== "rsa" && O !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (T.padding !== void 0 && T.padding !== v)
      throw new Error("illegal or unsupported padding mode");
    B = t.concat([$, B]);
    for (var he = J.modulus.byteLength(), de = [0, 1]; B.length + de.length + 1 < he; )
      de.push(255);
    de.push(0);
    for (var ne = -1; ++ne < B.length; ) de.push(B[ne]);
    var Ae = n(de, J);
    return Ae;
  }
  function b(B, T) {
    var F = c[T.curve.join(".")];
    if (!F) throw new Error("unknown curve " + T.curve.join("."));
    var O = new i(F),
      $ = O.keyFromPrivate(T.privateKey),
      J = $.sign(B);
    return t.from(J.toDER());
  }
  function p(B, T, F) {
    for (
      var O = T.params.priv_key,
        $ = T.params.p,
        J = T.params.q,
        he = T.params.g,
        de = new l(0),
        ne,
        Ae = S(B, J).mod(J),
        x = !1,
        r = M(O, J, B, F);
      x === !1;

    )
      (ne = k(J, r, F)),
        (de = P(he, ne, $, J)),
        (x = ne
          .invm(J)
          .imul(Ae.add(O.mul(de)))
          .mod(J)),
        x.cmpn(0) === 0 && ((x = !1), (de = new l(0)));
    return _(de, x);
  }
  function _(B, T) {
    (B = B.toArray()),
      (T = T.toArray()),
      B[0] & 128 && (B = [0].concat(B)),
      T[0] & 128 && (T = [0].concat(T));
    var F = B.length + T.length + 4,
      O = [48, F, 2, B.length];
    return (O = O.concat(B, [2, T.length], T)), t.from(O);
  }
  function M(B, T, F, O) {
    if (((B = t.from(B.toArray())), B.length < T.byteLength())) {
      var $ = t.alloc(T.byteLength() - B.length);
      B = t.concat([$, B]);
    }
    var J = F.length,
      he = A(F, T),
      de = t.alloc(J);
    de.fill(1);
    var ne = t.alloc(J);
    return (
      (ne = e(O, ne)
        .update(de)
        .update(t.from([0]))
        .update(B)
        .update(he)
        .digest()),
      (de = e(O, ne).update(de).digest()),
      (ne = e(O, ne)
        .update(de)
        .update(t.from([1]))
        .update(B)
        .update(he)
        .digest()),
      (de = e(O, ne).update(de).digest()),
      { k: ne, v: de }
    );
  }
  function S(B, T) {
    var F = new l(B),
      O = (B.length << 3) - T.bitLength();
    return O > 0 && F.ishrn(O), F;
  }
  function A(B, T) {
    (B = S(B, T)), (B = B.mod(T));
    var F = t.from(B.toArray());
    if (F.length < T.byteLength()) {
      var O = t.alloc(T.byteLength() - F.length);
      F = t.concat([O, F]);
    }
    return F;
  }
  function k(B, T, F) {
    var O, $;
    do {
      for (O = t.alloc(0); O.length * 8 < B.bitLength(); )
        (T.v = e(F, T.k).update(T.v).digest()), (O = t.concat([O, T.v]));
      ($ = S(O, B)),
        (T.k = e(F, T.k)
          .update(T.v)
          .update(t.from([0]))
          .digest()),
        (T.v = e(F, T.k).update(T.v).digest());
    } while ($.cmp(B) !== -1);
    return $;
  }
  function P(B, T, F, O) {
    return B.toRed(l.mont(F)).redPow(T).fromRed().mod(O);
  }
  return (xo.exports = g), (xo.exports.getKey = M), (xo.exports.makeKey = k), xo.exports;
}
var M0, Tb;
function q7() {
  if (Tb) return M0;
  Tb = 1;
  var t = zt().Buffer,
    e = T1(),
    n = O1().ec,
    i = Du(),
    l = jw;
  function a(b, p, _, M, S) {
    var A = i(_);
    if (A.type === "ec") {
      if (M !== "ecdsa" && M !== "ecdsa/rsa") throw new Error("wrong public key type");
      return c(b, p, A);
    } else if (A.type === "dsa") {
      if (M !== "dsa") throw new Error("wrong public key type");
      return v(b, p, A);
    }
    if (M !== "rsa" && M !== "ecdsa/rsa") throw new Error("wrong public key type");
    p = t.concat([S, p]);
    for (var k = A.modulus.byteLength(), P = [1], B = 0; p.length + P.length + 2 < k; )
      P.push(255), (B += 1);
    P.push(0);
    for (var T = -1; ++T < p.length; ) P.push(p[T]);
    P = t.from(P);
    var F = e.mont(A.modulus);
    (b = new e(b).toRed(F)),
      (b = b.redPow(new e(A.publicExponent))),
      (b = t.from(b.fromRed().toArray()));
    var O = B < 8 ? 1 : 0;
    for (k = Math.min(b.length, P.length), b.length !== P.length && (O = 1), T = -1; ++T < k; )
      O |= b[T] ^ P[T];
    return O === 0;
  }
  function c(b, p, _) {
    var M = l[_.data.algorithm.curve.join(".")];
    if (!M) throw new Error("unknown curve " + _.data.algorithm.curve.join("."));
    var S = new n(M),
      A = _.data.subjectPrivateKey.data;
    return S.verify(p, b, A);
  }
  function v(b, p, _) {
    var M = _.data.p,
      S = _.data.q,
      A = _.data.g,
      k = _.data.pub_key,
      P = i.signature.decode(b, "der"),
      B = P.s,
      T = P.r;
    g(B, S), g(T, S);
    var F = e.mont(M),
      O = B.invm(S),
      $ = A.toRed(F)
        .redPow(new e(p).mul(O).mod(S))
        .fromRed()
        .mul(k.toRed(F).redPow(T.mul(O).mod(S)).fromRed())
        .mod(M)
        .mod(S);
    return $.cmp(T) === 0;
  }
  function g(b, p) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(p) >= 0) throw new Error("invalid sig");
  }
  return (M0 = a), M0;
}
var S0, Pb;
function z7() {
  if (Pb) return S0;
  Pb = 1;
  var t = zt().Buffer,
    e = Af(),
    n = H9(),
    i = It(),
    l = F7(),
    a = q7(),
    c = pw;
  Object.keys(c).forEach(function (_) {
    (c[_].id = t.from(c[_].id, "hex")), (c[_.toLowerCase()] = c[_]);
  });
  function v(_) {
    n.Writable.call(this);
    var M = c[_];
    if (!M) throw new Error("Unknown message digest");
    (this._hashType = M.hash),
      (this._hash = e(M.hash)),
      (this._tag = M.id),
      (this._signType = M.sign);
  }
  i(v, n.Writable),
    (v.prototype._write = function (M, S, A) {
      this._hash.update(M), A();
    }),
    (v.prototype.update = function (M, S) {
      return this._hash.update(typeof M == "string" ? t.from(M, S) : M), this;
    }),
    (v.prototype.sign = function (M, S) {
      this.end();
      var A = this._hash.digest(),
        k = l(A, M, this._hashType, this._signType, this._tag);
      return S ? k.toString(S) : k;
    });
  function g(_) {
    n.Writable.call(this);
    var M = c[_];
    if (!M) throw new Error("Unknown message digest");
    (this._hash = e(M.hash)), (this._tag = M.id), (this._signType = M.sign);
  }
  i(g, n.Writable),
    (g.prototype._write = function (M, S, A) {
      this._hash.update(M), A();
    }),
    (g.prototype.update = function (M, S) {
      return this._hash.update(typeof M == "string" ? t.from(M, S) : M), this;
    }),
    (g.prototype.verify = function (M, S, A) {
      var k = typeof S == "string" ? t.from(S, A) : S;
      this.end();
      var P = this._hash.digest();
      return a(k, P, M, this._signType, this._tag);
    });
  function b(_) {
    return new v(_);
  }
  function p(_) {
    return new g(_);
  }
  return (
    (S0 = {
      Sign: b,
      Verify: p,
      createSign: b,
      createVerify: p,
    }),
    S0
  );
}
var xl = { exports: {} };
xl.exports;
var Rb;
function j7() {
  return (
    Rb ||
      ((Rb = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(xl)),
    xl.exports
  );
}
var E0, Ib;
function $7() {
  if (Ib) return E0;
  Ib = 1;
  var t = O1(),
    e = j7();
  E0 = function (c) {
    return new i(c);
  };
  var n = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32,
    },
    secp224r1: {
      name: "p224",
      byteLength: 28,
    },
    prime256v1: {
      name: "p256",
      byteLength: 32,
    },
    prime192v1: {
      name: "p192",
      byteLength: 24,
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32,
    },
    secp384r1: {
      name: "p384",
      byteLength: 48,
    },
    secp521r1: {
      name: "p521",
      byteLength: 66,
    },
  };
  (n.p224 = n.secp224r1),
    (n.p256 = n.secp256r1 = n.prime256v1),
    (n.p192 = n.secp192r1 = n.prime192v1),
    (n.p384 = n.secp384r1),
    (n.p521 = n.secp521r1);
  function i(a) {
    (this.curveType = n[a]),
      this.curveType ||
        (this.curveType = {
          name: a,
        }),
      (this.curve = new t.ec(this.curveType.name)),
      (this.keys = void 0);
  }
  (i.prototype.generateKeys = function (a, c) {
    return (this.keys = this.curve.genKeyPair()), this.getPublicKey(a, c);
  }),
    (i.prototype.computeSecret = function (a, c, v) {
      (c = c || "utf8"), Qe.isBuffer(a) || (a = new Qe(a, c));
      var g = this.curve.keyFromPublic(a).getPublic(),
        b = g.mul(this.keys.getPrivate()).getX();
      return l(b, v, this.curveType.byteLength);
    }),
    (i.prototype.getPublicKey = function (a, c) {
      var v = this.keys.getPublic(c === "compressed", !0);
      return c === "hybrid" && (v[v.length - 1] % 2 ? (v[0] = 7) : (v[0] = 6)), l(v, a);
    }),
    (i.prototype.getPrivateKey = function (a) {
      return l(this.keys.getPrivate(), a);
    }),
    (i.prototype.setPublicKey = function (a, c) {
      return (
        (c = c || "utf8"), Qe.isBuffer(a) || (a = new Qe(a, c)), this.keys._importPublic(a), this
      );
    }),
    (i.prototype.setPrivateKey = function (a, c) {
      (c = c || "utf8"), Qe.isBuffer(a) || (a = new Qe(a, c));
      var v = new e(a);
      return (
        (v = v.toString(16)),
        (this.keys = this.curve.genKeyPair()),
        this.keys._importPrivate(v),
        this
      );
    });
  function l(a, c, v) {
    Array.isArray(a) || (a = a.toArray());
    var g = new Qe(a);
    if (v && g.length < v) {
      var b = new Qe(v - g.length);
      b.fill(0), (g = Qe.concat([b, g]));
    }
    return c ? g.toString(c) : g;
  }
  return E0;
}
var A0 = {},
  k0,
  Ob;
function $w() {
  if (Ob) return k0;
  Ob = 1;
  var t = Af(),
    e = zt().Buffer;
  k0 = function (i, l) {
    for (var a = e.alloc(0), c = 0, v; a.length < l; )
      (v = n(c++)), (a = e.concat([a, t("sha1").update(i).update(v).digest()]));
    return a.slice(0, l);
  };
  function n(i) {
    var l = e.allocUnsafe(4);
    return l.writeUInt32BE(i, 0), l;
  }
  return k0;
}
var B0, Ub;
function Hw() {
  return (
    Ub ||
      ((Ub = 1),
      (B0 = function (e, n) {
        for (var i = e.length, l = -1; ++l < i; ) e[l] ^= n[l];
        return e;
      })),
    B0
  );
}
var Ml = { exports: {} };
Ml.exports;
var Nb;
function U1() {
  return (
    Nb ||
      ((Nb = 1),
      (function (t) {
        (function (e, n) {
          function i(x, r) {
            if (!x) throw new Error(r || "Assertion failed");
          }
          function l(x, r) {
            x.super_ = r;
            var o = function () {};
            (o.prototype = r.prototype), (x.prototype = new o()), (x.prototype.constructor = x);
          }
          function a(x, r, o) {
            if (a.isBN(x)) return x;
            (this.negative = 0),
              (this.words = null),
              (this.length = 0),
              (this.red = null),
              x !== null &&
                ((r === "le" || r === "be") && ((o = r), (r = 10)),
                this._init(x || 0, r || 10, o || "be"));
          }
          typeof e == "object" ? (e.exports = a) : (n.BN = a), (a.BN = a), (a.wordSize = 26);
          var c;
          try {
            typeof window < "u" && typeof window.Buffer < "u"
              ? (c = window.Buffer)
              : (c = Mr.Buffer);
          } catch {}
          (a.isBN = function (r) {
            return r instanceof a
              ? !0
              : r !== null &&
                  typeof r == "object" &&
                  r.constructor.wordSize === a.wordSize &&
                  Array.isArray(r.words);
          }),
            (a.max = function (r, o) {
              return r.cmp(o) > 0 ? r : o;
            }),
            (a.min = function (r, o) {
              return r.cmp(o) < 0 ? r : o;
            }),
            (a.prototype._init = function (r, o, f) {
              if (typeof r == "number") return this._initNumber(r, o, f);
              if (typeof r == "object") return this._initArray(r, o, f);
              o === "hex" && (o = 16),
                i(o === (o | 0) && o >= 2 && o <= 36),
                (r = r.toString().replace(/\s+/g, ""));
              var u = 0;
              r[0] === "-" && (u++, (this.negative = 1)),
                u < r.length &&
                  (o === 16
                    ? this._parseHex(r, u, f)
                    : (this._parseBase(r, o, u),
                      f === "le" && this._initArray(this.toArray(), o, f)));
            }),
            (a.prototype._initNumber = function (r, o, f) {
              r < 0 && ((this.negative = 1), (r = -r)),
                r < 67108864
                  ? ((this.words = [r & 67108863]), (this.length = 1))
                  : r < 4503599627370496
                  ? ((this.words = [r & 67108863, (r / 67108864) & 67108863]), (this.length = 2))
                  : (i(r < 9007199254740992),
                    (this.words = [r & 67108863, (r / 67108864) & 67108863, 1]),
                    (this.length = 3)),
                f === "le" && this._initArray(this.toArray(), o, f);
            }),
            (a.prototype._initArray = function (r, o, f) {
              if ((i(typeof r.length == "number"), r.length <= 0))
                return (this.words = [0]), (this.length = 1), this;
              (this.length = Math.ceil(r.length / 3)), (this.words = new Array(this.length));
              for (var u = 0; u < this.length; u++) this.words[u] = 0;
              var d,
                y,
                w = 0;
              if (f === "be")
                for (u = r.length - 1, d = 0; u >= 0; u -= 3)
                  (y = r[u] | (r[u - 1] << 8) | (r[u - 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              else if (f === "le")
                for (u = 0, d = 0; u < r.length; u += 3)
                  (y = r[u] | (r[u + 1] << 8) | (r[u + 2] << 16)),
                    (this.words[d] |= (y << w) & 67108863),
                    (this.words[d + 1] = (y >>> (26 - w)) & 67108863),
                    (w += 24),
                    w >= 26 && ((w -= 26), d++);
              return this.strip();
            });
          function v(x, r) {
            var o = x.charCodeAt(r);
            return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : (o - 48) & 15;
          }
          function g(x, r, o) {
            var f = v(x, o);
            return o - 1 >= r && (f |= v(x, o - 1) << 4), f;
          }
          a.prototype._parseHex = function (r, o, f) {
            (this.length = Math.ceil((r.length - o) / 6)), (this.words = new Array(this.length));
            for (var u = 0; u < this.length; u++) this.words[u] = 0;
            var d = 0,
              y = 0,
              w;
            if (f === "be")
              for (u = r.length - 1; u >= o; u -= 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            else {
              var h = r.length - o;
              for (u = h % 2 === 0 ? o + 1 : o; u < r.length; u += 2)
                (w = g(r, o, u) << d),
                  (this.words[y] |= w & 67108863),
                  d >= 18 ? ((d -= 18), (y += 1), (this.words[y] |= w >>> 26)) : (d += 8);
            }
            this.strip();
          };
          function b(x, r, o, f) {
            for (var u = 0, d = Math.min(x.length, o), y = r; y < d; y++) {
              var w = x.charCodeAt(y) - 48;
              (u *= f), w >= 49 ? (u += w - 49 + 10) : w >= 17 ? (u += w - 17 + 10) : (u += w);
            }
            return u;
          }
          (a.prototype._parseBase = function (r, o, f) {
            (this.words = [0]), (this.length = 1);
            for (var u = 0, d = 1; d <= 67108863; d *= o) u++;
            u--, (d = (d / o) | 0);
            for (
              var y = r.length - f, w = y % u, h = Math.min(y, y - w) + f, s = 0, m = f;
              m < h;
              m += u
            )
              (s = b(r, m, m + u, o)),
                this.imuln(d),
                this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            if (w !== 0) {
              var E = 1;
              for (s = b(r, m, r.length, o), m = 0; m < w; m++) E *= o;
              this.imuln(E), this.words[0] + s < 67108864 ? (this.words[0] += s) : this._iaddn(s);
            }
            this.strip();
          }),
            (a.prototype.copy = function (r) {
              r.words = new Array(this.length);
              for (var o = 0; o < this.length; o++) r.words[o] = this.words[o];
              (r.length = this.length), (r.negative = this.negative), (r.red = this.red);
            }),
            (a.prototype.clone = function () {
              var r = new a(null);
              return this.copy(r), r;
            }),
            (a.prototype._expand = function (r) {
              for (; this.length < r; ) this.words[this.length++] = 0;
              return this;
            }),
            (a.prototype.strip = function () {
              for (; this.length > 1 && this.words[this.length - 1] === 0; ) this.length--;
              return this._normSign();
            }),
            (a.prototype._normSign = function () {
              return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
            }),
            (a.prototype.inspect = function () {
              return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
            });
          var p = [
              "",
              "0",
              "00",
              "000",
              "0000",
              "00000",
              "000000",
              "0000000",
              "00000000",
              "000000000",
              "0000000000",
              "00000000000",
              "000000000000",
              "0000000000000",
              "00000000000000",
              "000000000000000",
              "0000000000000000",
              "00000000000000000",
              "000000000000000000",
              "0000000000000000000",
              "00000000000000000000",
              "000000000000000000000",
              "0000000000000000000000",
              "00000000000000000000000",
              "000000000000000000000000",
              "0000000000000000000000000",
            ],
            _ = [
              0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5,
              5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
            ],
            M = [
              0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721,
              1e7, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224,
              47045881, 64e6, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907,
              17210368, 20511149, 243e5, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176,
            ];
          (a.prototype.toString = function (r, o) {
            (r = r || 10), (o = o | 0 || 1);
            var f;
            if (r === 16 || r === "hex") {
              f = "";
              for (var u = 0, d = 0, y = 0; y < this.length; y++) {
                var w = this.words[y],
                  h = (((w << u) | d) & 16777215).toString(16);
                (d = (w >>> (24 - u)) & 16777215),
                  d !== 0 || y !== this.length - 1 ? (f = p[6 - h.length] + h + f) : (f = h + f),
                  (u += 2),
                  u >= 26 && ((u -= 26), y--);
              }
              for (d !== 0 && (f = d.toString(16) + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            if (r === (r | 0) && r >= 2 && r <= 36) {
              var s = _[r],
                m = M[r];
              f = "";
              var E = this.clone();
              for (E.negative = 0; !E.isZero(); ) {
                var R = E.modn(m).toString(r);
                (E = E.idivn(m)), E.isZero() ? (f = R + f) : (f = p[s - R.length] + R + f);
              }
              for (this.isZero() && (f = "0" + f); f.length % o !== 0; ) f = "0" + f;
              return this.negative !== 0 && (f = "-" + f), f;
            }
            i(!1, "Base should be between 2 and 36");
          }),
            (a.prototype.toNumber = function () {
              var r = this.words[0];
              return (
                this.length === 2
                  ? (r += this.words[1] * 67108864)
                  : this.length === 3 && this.words[2] === 1
                  ? (r += 4503599627370496 + this.words[1] * 67108864)
                  : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"),
                this.negative !== 0 ? -r : r
              );
            }),
            (a.prototype.toJSON = function () {
              return this.toString(16);
            }),
            (a.prototype.toBuffer = function (r, o) {
              return i(typeof c < "u"), this.toArrayLike(c, r, o);
            }),
            (a.prototype.toArray = function (r, o) {
              return this.toArrayLike(Array, r, o);
            }),
            (a.prototype.toArrayLike = function (r, o, f) {
              var u = this.byteLength(),
                d = f || Math.max(1, u);
              i(u <= d, "byte array longer than desired length"),
                i(d > 0, "Requested array length <= 0"),
                this.strip();
              var y = o === "le",
                w = new r(d),
                h,
                s,
                m = this.clone();
              if (y) {
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[s] = h);
                for (; s < d; s++) w[s] = 0;
              } else {
                for (s = 0; s < d - u; s++) w[s] = 0;
                for (s = 0; !m.isZero(); s++) (h = m.andln(255)), m.iushrn(8), (w[d - s - 1] = h);
              }
              return w;
            }),
            Math.clz32
              ? (a.prototype._countBits = function (r) {
                  return 32 - Math.clz32(r);
                })
              : (a.prototype._countBits = function (r) {
                  var o = r,
                    f = 0;
                  return (
                    o >= 4096 && ((f += 13), (o >>>= 13)),
                    o >= 64 && ((f += 7), (o >>>= 7)),
                    o >= 8 && ((f += 4), (o >>>= 4)),
                    o >= 2 && ((f += 2), (o >>>= 2)),
                    f + o
                  );
                }),
            (a.prototype._zeroBits = function (r) {
              if (r === 0) return 26;
              var o = r,
                f = 0;
              return (
                o & 8191 || ((f += 13), (o >>>= 13)),
                o & 127 || ((f += 7), (o >>>= 7)),
                o & 15 || ((f += 4), (o >>>= 4)),
                o & 3 || ((f += 2), (o >>>= 2)),
                o & 1 || f++,
                f
              );
            }),
            (a.prototype.bitLength = function () {
              var r = this.words[this.length - 1],
                o = this._countBits(r);
              return (this.length - 1) * 26 + o;
            });
          function S(x) {
            for (var r = new Array(x.bitLength()), o = 0; o < r.length; o++) {
              var f = (o / 26) | 0,
                u = o % 26;
              r[o] = (x.words[f] & (1 << u)) >>> u;
            }
            return r;
          }
          (a.prototype.zeroBits = function () {
            if (this.isZero()) return 0;
            for (var r = 0, o = 0; o < this.length; o++) {
              var f = this._zeroBits(this.words[o]);
              if (((r += f), f !== 26)) break;
            }
            return r;
          }),
            (a.prototype.byteLength = function () {
              return Math.ceil(this.bitLength() / 8);
            }),
            (a.prototype.toTwos = function (r) {
              return this.negative !== 0 ? this.abs().inotn(r).iaddn(1) : this.clone();
            }),
            (a.prototype.fromTwos = function (r) {
              return this.testn(r - 1) ? this.notn(r).iaddn(1).ineg() : this.clone();
            }),
            (a.prototype.isNeg = function () {
              return this.negative !== 0;
            }),
            (a.prototype.neg = function () {
              return this.clone().ineg();
            }),
            (a.prototype.ineg = function () {
              return this.isZero() || (this.negative ^= 1), this;
            }),
            (a.prototype.iuor = function (r) {
              for (; this.length < r.length; ) this.words[this.length++] = 0;
              for (var o = 0; o < r.length; o++) this.words[o] = this.words[o] | r.words[o];
              return this.strip();
            }),
            (a.prototype.ior = function (r) {
              return i((this.negative | r.negative) === 0), this.iuor(r);
            }),
            (a.prototype.or = function (r) {
              return this.length > r.length ? this.clone().ior(r) : r.clone().ior(this);
            }),
            (a.prototype.uor = function (r) {
              return this.length > r.length ? this.clone().iuor(r) : r.clone().iuor(this);
            }),
            (a.prototype.iuand = function (r) {
              var o;
              this.length > r.length ? (o = r) : (o = this);
              for (var f = 0; f < o.length; f++) this.words[f] = this.words[f] & r.words[f];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.iand = function (r) {
              return i((this.negative | r.negative) === 0), this.iuand(r);
            }),
            (a.prototype.and = function (r) {
              return this.length > r.length ? this.clone().iand(r) : r.clone().iand(this);
            }),
            (a.prototype.uand = function (r) {
              return this.length > r.length ? this.clone().iuand(r) : r.clone().iuand(this);
            }),
            (a.prototype.iuxor = function (r) {
              var o, f;
              this.length > r.length ? ((o = this), (f = r)) : ((o = r), (f = this));
              for (var u = 0; u < f.length; u++) this.words[u] = o.words[u] ^ f.words[u];
              if (this !== o) for (; u < o.length; u++) this.words[u] = o.words[u];
              return (this.length = o.length), this.strip();
            }),
            (a.prototype.ixor = function (r) {
              return i((this.negative | r.negative) === 0), this.iuxor(r);
            }),
            (a.prototype.xor = function (r) {
              return this.length > r.length ? this.clone().ixor(r) : r.clone().ixor(this);
            }),
            (a.prototype.uxor = function (r) {
              return this.length > r.length ? this.clone().iuxor(r) : r.clone().iuxor(this);
            }),
            (a.prototype.inotn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = Math.ceil(r / 26) | 0,
                f = r % 26;
              this._expand(o), f > 0 && o--;
              for (var u = 0; u < o; u++) this.words[u] = ~this.words[u] & 67108863;
              return (
                f > 0 && (this.words[u] = ~this.words[u] & (67108863 >> (26 - f))), this.strip()
              );
            }),
            (a.prototype.notn = function (r) {
              return this.clone().inotn(r);
            }),
            (a.prototype.setn = function (r, o) {
              i(typeof r == "number" && r >= 0);
              var f = (r / 26) | 0,
                u = r % 26;
              return (
                this._expand(f + 1),
                o
                  ? (this.words[f] = this.words[f] | (1 << u))
                  : (this.words[f] = this.words[f] & ~(1 << u)),
                this.strip()
              );
            }),
            (a.prototype.iadd = function (r) {
              var o;
              if (this.negative !== 0 && r.negative === 0)
                return (
                  (this.negative = 0), (o = this.isub(r)), (this.negative ^= 1), this._normSign()
                );
              if (this.negative === 0 && r.negative !== 0)
                return (r.negative = 0), (o = this.isub(r)), (r.negative = 1), o._normSign();
              var f, u;
              this.length > r.length ? ((f = this), (u = r)) : ((f = r), (u = this));
              for (var d = 0, y = 0; y < u.length; y++)
                (o = (f.words[y] | 0) + (u.words[y] | 0) + d),
                  (this.words[y] = o & 67108863),
                  (d = o >>> 26);
              for (; d !== 0 && y < f.length; y++)
                (o = (f.words[y] | 0) + d), (this.words[y] = o & 67108863), (d = o >>> 26);
              if (((this.length = f.length), d !== 0)) (this.words[this.length] = d), this.length++;
              else if (f !== this) for (; y < f.length; y++) this.words[y] = f.words[y];
              return this;
            }),
            (a.prototype.add = function (r) {
              var o;
              return r.negative !== 0 && this.negative === 0
                ? ((r.negative = 0), (o = this.sub(r)), (r.negative ^= 1), o)
                : r.negative === 0 && this.negative !== 0
                ? ((this.negative = 0), (o = r.sub(this)), (this.negative = 1), o)
                : this.length > r.length
                ? this.clone().iadd(r)
                : r.clone().iadd(this);
            }),
            (a.prototype.isub = function (r) {
              if (r.negative !== 0) {
                r.negative = 0;
                var o = this.iadd(r);
                return (r.negative = 1), o._normSign();
              } else if (this.negative !== 0)
                return (this.negative = 0), this.iadd(r), (this.negative = 1), this._normSign();
              var f = this.cmp(r);
              if (f === 0) return (this.negative = 0), (this.length = 1), (this.words[0] = 0), this;
              var u, d;
              f > 0 ? ((u = this), (d = r)) : ((u = r), (d = this));
              for (var y = 0, w = 0; w < d.length; w++)
                (o = (u.words[w] | 0) - (d.words[w] | 0) + y),
                  (y = o >> 26),
                  (this.words[w] = o & 67108863);
              for (; y !== 0 && w < u.length; w++)
                (o = (u.words[w] | 0) + y), (y = o >> 26), (this.words[w] = o & 67108863);
              if (y === 0 && w < u.length && u !== this)
                for (; w < u.length; w++) this.words[w] = u.words[w];
              return (
                (this.length = Math.max(this.length, w)),
                u !== this && (this.negative = 1),
                this.strip()
              );
            }),
            (a.prototype.sub = function (r) {
              return this.clone().isub(r);
            });
          function A(x, r, o) {
            o.negative = r.negative ^ x.negative;
            var f = (x.length + r.length) | 0;
            (o.length = f), (f = (f - 1) | 0);
            var u = x.words[0] | 0,
              d = r.words[0] | 0,
              y = u * d,
              w = y & 67108863,
              h = (y / 67108864) | 0;
            o.words[0] = w;
            for (var s = 1; s < f; s++) {
              for (
                var m = h >>> 26,
                  E = h & 67108863,
                  R = Math.min(s, r.length - 1),
                  z = Math.max(0, s - x.length + 1);
                z <= R;
                z++
              ) {
                var Q = (s - z) | 0;
                (u = x.words[Q] | 0),
                  (d = r.words[z] | 0),
                  (y = u * d + E),
                  (m += (y / 67108864) | 0),
                  (E = y & 67108863);
              }
              (o.words[s] = E | 0), (h = m | 0);
            }
            return h !== 0 ? (o.words[s] = h | 0) : o.length--, o.strip();
          }
          var k = function (r, o, f) {
            var u = r.words,
              d = o.words,
              y = f.words,
              w = 0,
              h,
              s,
              m,
              E = u[0] | 0,
              R = E & 8191,
              z = E >>> 13,
              Q = u[1] | 0,
              G = Q & 8191,
              q = Q >>> 13,
              Z = u[2] | 0,
              te = Z & 8191,
              ue = Z >>> 13,
              ae = u[3] | 0,
              K = ae & 8191,
              ve = ae >>> 13,
              Ye = u[4] | 0,
              Ce = Ye & 8191,
              Te = Ye >>> 13,
              ut = u[5] | 0,
              Ie = ut & 8191,
              be = ut >>> 13,
              wt = u[6] | 0,
              Oe = wt & 8191,
              je = wt >>> 13,
              xt = u[7] | 0,
              Ue = xt & 8191,
              se = xt >>> 13,
              oe = u[8] | 0,
              X = oe & 8191,
              le = oe >>> 13,
              ke = u[9] | 0,
              I = ke & 8191,
              C = ke >>> 13,
              L = d[0] | 0,
              j = L & 8191,
              ee = L >>> 13,
              Me = d[1] | 0,
              fe = Me & 8191,
              Se = Me >>> 13,
              ot = d[2] | 0,
              we = ot & 8191,
              Re = ot >>> 13,
              at = d[3] | 0,
              Ne = at & 8191,
              He = at >>> 13,
              At = d[4] | 0,
              Le = At & 8191,
              Ze = At >>> 13,
              Tt = d[5] | 0,
              Ve = Tt & 8191,
              Je = Tt >>> 13,
              Rt = d[6] | 0,
              $e = Rt & 8191,
              et = Rt >>> 13,
              H = d[7] | 0,
              V = H & 8191,
              W = H >>> 13,
              U = d[8] | 0,
              D = U & 8191,
              re = U >>> 13,
              ye = d[9] | 0,
              pe = ye & 8191,
              xe = ye >>> 13;
            (f.negative = r.negative ^ o.negative),
              (f.length = 19),
              (h = Math.imul(R, j)),
              (s = Math.imul(R, ee)),
              (s = (s + Math.imul(z, j)) | 0),
              (m = Math.imul(z, ee));
            var tt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (tt >>> 26)) | 0),
              (tt &= 67108863),
              (h = Math.imul(G, j)),
              (s = Math.imul(G, ee)),
              (s = (s + Math.imul(q, j)) | 0),
              (m = Math.imul(q, ee)),
              (h = (h + Math.imul(R, fe)) | 0),
              (s = (s + Math.imul(R, Se)) | 0),
              (s = (s + Math.imul(z, fe)) | 0),
              (m = (m + Math.imul(z, Se)) | 0);
            var Ke = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Ke >>> 26)) | 0),
              (Ke &= 67108863),
              (h = Math.imul(te, j)),
              (s = Math.imul(te, ee)),
              (s = (s + Math.imul(ue, j)) | 0),
              (m = Math.imul(ue, ee)),
              (h = (h + Math.imul(G, fe)) | 0),
              (s = (s + Math.imul(G, Se)) | 0),
              (s = (s + Math.imul(q, fe)) | 0),
              (m = (m + Math.imul(q, Se)) | 0),
              (h = (h + Math.imul(R, we)) | 0),
              (s = (s + Math.imul(R, Re)) | 0),
              (s = (s + Math.imul(z, we)) | 0),
              (m = (m + Math.imul(z, Re)) | 0);
            var dt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (dt >>> 26)) | 0),
              (dt &= 67108863),
              (h = Math.imul(K, j)),
              (s = Math.imul(K, ee)),
              (s = (s + Math.imul(ve, j)) | 0),
              (m = Math.imul(ve, ee)),
              (h = (h + Math.imul(te, fe)) | 0),
              (s = (s + Math.imul(te, Se)) | 0),
              (s = (s + Math.imul(ue, fe)) | 0),
              (m = (m + Math.imul(ue, Se)) | 0),
              (h = (h + Math.imul(G, we)) | 0),
              (s = (s + Math.imul(G, Re)) | 0),
              (s = (s + Math.imul(q, we)) | 0),
              (m = (m + Math.imul(q, Re)) | 0),
              (h = (h + Math.imul(R, Ne)) | 0),
              (s = (s + Math.imul(R, He)) | 0),
              (s = (s + Math.imul(z, Ne)) | 0),
              (m = (m + Math.imul(z, He)) | 0);
            var st = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (st >>> 26)) | 0),
              (st &= 67108863),
              (h = Math.imul(Ce, j)),
              (s = Math.imul(Ce, ee)),
              (s = (s + Math.imul(Te, j)) | 0),
              (m = Math.imul(Te, ee)),
              (h = (h + Math.imul(K, fe)) | 0),
              (s = (s + Math.imul(K, Se)) | 0),
              (s = (s + Math.imul(ve, fe)) | 0),
              (m = (m + Math.imul(ve, Se)) | 0),
              (h = (h + Math.imul(te, we)) | 0),
              (s = (s + Math.imul(te, Re)) | 0),
              (s = (s + Math.imul(ue, we)) | 0),
              (m = (m + Math.imul(ue, Re)) | 0),
              (h = (h + Math.imul(G, Ne)) | 0),
              (s = (s + Math.imul(G, He)) | 0),
              (s = (s + Math.imul(q, Ne)) | 0),
              (m = (m + Math.imul(q, He)) | 0),
              (h = (h + Math.imul(R, Le)) | 0),
              (s = (s + Math.imul(R, Ze)) | 0),
              (s = (s + Math.imul(z, Le)) | 0),
              (m = (m + Math.imul(z, Ze)) | 0);
            var ce = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ce >>> 26)) | 0),
              (ce &= 67108863),
              (h = Math.imul(Ie, j)),
              (s = Math.imul(Ie, ee)),
              (s = (s + Math.imul(be, j)) | 0),
              (m = Math.imul(be, ee)),
              (h = (h + Math.imul(Ce, fe)) | 0),
              (s = (s + Math.imul(Ce, Se)) | 0),
              (s = (s + Math.imul(Te, fe)) | 0),
              (m = (m + Math.imul(Te, Se)) | 0),
              (h = (h + Math.imul(K, we)) | 0),
              (s = (s + Math.imul(K, Re)) | 0),
              (s = (s + Math.imul(ve, we)) | 0),
              (m = (m + Math.imul(ve, Re)) | 0),
              (h = (h + Math.imul(te, Ne)) | 0),
              (s = (s + Math.imul(te, He)) | 0),
              (s = (s + Math.imul(ue, Ne)) | 0),
              (m = (m + Math.imul(ue, He)) | 0),
              (h = (h + Math.imul(G, Le)) | 0),
              (s = (s + Math.imul(G, Ze)) | 0),
              (s = (s + Math.imul(q, Le)) | 0),
              (m = (m + Math.imul(q, Ze)) | 0),
              (h = (h + Math.imul(R, Ve)) | 0),
              (s = (s + Math.imul(R, Je)) | 0),
              (s = (s + Math.imul(z, Ve)) | 0),
              (m = (m + Math.imul(z, Je)) | 0);
            var N = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (N >>> 26)) | 0),
              (N &= 67108863),
              (h = Math.imul(Oe, j)),
              (s = Math.imul(Oe, ee)),
              (s = (s + Math.imul(je, j)) | 0),
              (m = Math.imul(je, ee)),
              (h = (h + Math.imul(Ie, fe)) | 0),
              (s = (s + Math.imul(Ie, Se)) | 0),
              (s = (s + Math.imul(be, fe)) | 0),
              (m = (m + Math.imul(be, Se)) | 0),
              (h = (h + Math.imul(Ce, we)) | 0),
              (s = (s + Math.imul(Ce, Re)) | 0),
              (s = (s + Math.imul(Te, we)) | 0),
              (m = (m + Math.imul(Te, Re)) | 0),
              (h = (h + Math.imul(K, Ne)) | 0),
              (s = (s + Math.imul(K, He)) | 0),
              (s = (s + Math.imul(ve, Ne)) | 0),
              (m = (m + Math.imul(ve, He)) | 0),
              (h = (h + Math.imul(te, Le)) | 0),
              (s = (s + Math.imul(te, Ze)) | 0),
              (s = (s + Math.imul(ue, Le)) | 0),
              (m = (m + Math.imul(ue, Ze)) | 0),
              (h = (h + Math.imul(G, Ve)) | 0),
              (s = (s + Math.imul(G, Je)) | 0),
              (s = (s + Math.imul(q, Ve)) | 0),
              (m = (m + Math.imul(q, Je)) | 0),
              (h = (h + Math.imul(R, $e)) | 0),
              (s = (s + Math.imul(R, et)) | 0),
              (s = (s + Math.imul(z, $e)) | 0),
              (m = (m + Math.imul(z, et)) | 0);
            var Y = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Y >>> 26)) | 0),
              (Y &= 67108863),
              (h = Math.imul(Ue, j)),
              (s = Math.imul(Ue, ee)),
              (s = (s + Math.imul(se, j)) | 0),
              (m = Math.imul(se, ee)),
              (h = (h + Math.imul(Oe, fe)) | 0),
              (s = (s + Math.imul(Oe, Se)) | 0),
              (s = (s + Math.imul(je, fe)) | 0),
              (m = (m + Math.imul(je, Se)) | 0),
              (h = (h + Math.imul(Ie, we)) | 0),
              (s = (s + Math.imul(Ie, Re)) | 0),
              (s = (s + Math.imul(be, we)) | 0),
              (m = (m + Math.imul(be, Re)) | 0),
              (h = (h + Math.imul(Ce, Ne)) | 0),
              (s = (s + Math.imul(Ce, He)) | 0),
              (s = (s + Math.imul(Te, Ne)) | 0),
              (m = (m + Math.imul(Te, He)) | 0),
              (h = (h + Math.imul(K, Le)) | 0),
              (s = (s + Math.imul(K, Ze)) | 0),
              (s = (s + Math.imul(ve, Le)) | 0),
              (m = (m + Math.imul(ve, Ze)) | 0),
              (h = (h + Math.imul(te, Ve)) | 0),
              (s = (s + Math.imul(te, Je)) | 0),
              (s = (s + Math.imul(ue, Ve)) | 0),
              (m = (m + Math.imul(ue, Je)) | 0),
              (h = (h + Math.imul(G, $e)) | 0),
              (s = (s + Math.imul(G, et)) | 0),
              (s = (s + Math.imul(q, $e)) | 0),
              (m = (m + Math.imul(q, et)) | 0),
              (h = (h + Math.imul(R, V)) | 0),
              (s = (s + Math.imul(R, W)) | 0),
              (s = (s + Math.imul(z, V)) | 0),
              (m = (m + Math.imul(z, W)) | 0);
            var ie = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ie >>> 26)) | 0),
              (ie &= 67108863),
              (h = Math.imul(X, j)),
              (s = Math.imul(X, ee)),
              (s = (s + Math.imul(le, j)) | 0),
              (m = Math.imul(le, ee)),
              (h = (h + Math.imul(Ue, fe)) | 0),
              (s = (s + Math.imul(Ue, Se)) | 0),
              (s = (s + Math.imul(se, fe)) | 0),
              (m = (m + Math.imul(se, Se)) | 0),
              (h = (h + Math.imul(Oe, we)) | 0),
              (s = (s + Math.imul(Oe, Re)) | 0),
              (s = (s + Math.imul(je, we)) | 0),
              (m = (m + Math.imul(je, Re)) | 0),
              (h = (h + Math.imul(Ie, Ne)) | 0),
              (s = (s + Math.imul(Ie, He)) | 0),
              (s = (s + Math.imul(be, Ne)) | 0),
              (m = (m + Math.imul(be, He)) | 0),
              (h = (h + Math.imul(Ce, Le)) | 0),
              (s = (s + Math.imul(Ce, Ze)) | 0),
              (s = (s + Math.imul(Te, Le)) | 0),
              (m = (m + Math.imul(Te, Ze)) | 0),
              (h = (h + Math.imul(K, Ve)) | 0),
              (s = (s + Math.imul(K, Je)) | 0),
              (s = (s + Math.imul(ve, Ve)) | 0),
              (m = (m + Math.imul(ve, Je)) | 0),
              (h = (h + Math.imul(te, $e)) | 0),
              (s = (s + Math.imul(te, et)) | 0),
              (s = (s + Math.imul(ue, $e)) | 0),
              (m = (m + Math.imul(ue, et)) | 0),
              (h = (h + Math.imul(G, V)) | 0),
              (s = (s + Math.imul(G, W)) | 0),
              (s = (s + Math.imul(q, V)) | 0),
              (m = (m + Math.imul(q, W)) | 0),
              (h = (h + Math.imul(R, D)) | 0),
              (s = (s + Math.imul(R, re)) | 0),
              (s = (s + Math.imul(z, D)) | 0),
              (m = (m + Math.imul(z, re)) | 0);
            var ge = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ge >>> 26)) | 0),
              (ge &= 67108863),
              (h = Math.imul(I, j)),
              (s = Math.imul(I, ee)),
              (s = (s + Math.imul(C, j)) | 0),
              (m = Math.imul(C, ee)),
              (h = (h + Math.imul(X, fe)) | 0),
              (s = (s + Math.imul(X, Se)) | 0),
              (s = (s + Math.imul(le, fe)) | 0),
              (m = (m + Math.imul(le, Se)) | 0),
              (h = (h + Math.imul(Ue, we)) | 0),
              (s = (s + Math.imul(Ue, Re)) | 0),
              (s = (s + Math.imul(se, we)) | 0),
              (m = (m + Math.imul(se, Re)) | 0),
              (h = (h + Math.imul(Oe, Ne)) | 0),
              (s = (s + Math.imul(Oe, He)) | 0),
              (s = (s + Math.imul(je, Ne)) | 0),
              (m = (m + Math.imul(je, He)) | 0),
              (h = (h + Math.imul(Ie, Le)) | 0),
              (s = (s + Math.imul(Ie, Ze)) | 0),
              (s = (s + Math.imul(be, Le)) | 0),
              (m = (m + Math.imul(be, Ze)) | 0),
              (h = (h + Math.imul(Ce, Ve)) | 0),
              (s = (s + Math.imul(Ce, Je)) | 0),
              (s = (s + Math.imul(Te, Ve)) | 0),
              (m = (m + Math.imul(Te, Je)) | 0),
              (h = (h + Math.imul(K, $e)) | 0),
              (s = (s + Math.imul(K, et)) | 0),
              (s = (s + Math.imul(ve, $e)) | 0),
              (m = (m + Math.imul(ve, et)) | 0),
              (h = (h + Math.imul(te, V)) | 0),
              (s = (s + Math.imul(te, W)) | 0),
              (s = (s + Math.imul(ue, V)) | 0),
              (m = (m + Math.imul(ue, W)) | 0),
              (h = (h + Math.imul(G, D)) | 0),
              (s = (s + Math.imul(G, re)) | 0),
              (s = (s + Math.imul(q, D)) | 0),
              (m = (m + Math.imul(q, re)) | 0),
              (h = (h + Math.imul(R, pe)) | 0),
              (s = (s + Math.imul(R, xe)) | 0),
              (s = (s + Math.imul(z, pe)) | 0),
              (m = (m + Math.imul(z, xe)) | 0);
            var me = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (me >>> 26)) | 0),
              (me &= 67108863),
              (h = Math.imul(I, fe)),
              (s = Math.imul(I, Se)),
              (s = (s + Math.imul(C, fe)) | 0),
              (m = Math.imul(C, Se)),
              (h = (h + Math.imul(X, we)) | 0),
              (s = (s + Math.imul(X, Re)) | 0),
              (s = (s + Math.imul(le, we)) | 0),
              (m = (m + Math.imul(le, Re)) | 0),
              (h = (h + Math.imul(Ue, Ne)) | 0),
              (s = (s + Math.imul(Ue, He)) | 0),
              (s = (s + Math.imul(se, Ne)) | 0),
              (m = (m + Math.imul(se, He)) | 0),
              (h = (h + Math.imul(Oe, Le)) | 0),
              (s = (s + Math.imul(Oe, Ze)) | 0),
              (s = (s + Math.imul(je, Le)) | 0),
              (m = (m + Math.imul(je, Ze)) | 0),
              (h = (h + Math.imul(Ie, Ve)) | 0),
              (s = (s + Math.imul(Ie, Je)) | 0),
              (s = (s + Math.imul(be, Ve)) | 0),
              (m = (m + Math.imul(be, Je)) | 0),
              (h = (h + Math.imul(Ce, $e)) | 0),
              (s = (s + Math.imul(Ce, et)) | 0),
              (s = (s + Math.imul(Te, $e)) | 0),
              (m = (m + Math.imul(Te, et)) | 0),
              (h = (h + Math.imul(K, V)) | 0),
              (s = (s + Math.imul(K, W)) | 0),
              (s = (s + Math.imul(ve, V)) | 0),
              (m = (m + Math.imul(ve, W)) | 0),
              (h = (h + Math.imul(te, D)) | 0),
              (s = (s + Math.imul(te, re)) | 0),
              (s = (s + Math.imul(ue, D)) | 0),
              (m = (m + Math.imul(ue, re)) | 0),
              (h = (h + Math.imul(G, pe)) | 0),
              (s = (s + Math.imul(G, xe)) | 0),
              (s = (s + Math.imul(q, pe)) | 0),
              (m = (m + Math.imul(q, xe)) | 0);
            var qe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (qe >>> 26)) | 0),
              (qe &= 67108863),
              (h = Math.imul(I, we)),
              (s = Math.imul(I, Re)),
              (s = (s + Math.imul(C, we)) | 0),
              (m = Math.imul(C, Re)),
              (h = (h + Math.imul(X, Ne)) | 0),
              (s = (s + Math.imul(X, He)) | 0),
              (s = (s + Math.imul(le, Ne)) | 0),
              (m = (m + Math.imul(le, He)) | 0),
              (h = (h + Math.imul(Ue, Le)) | 0),
              (s = (s + Math.imul(Ue, Ze)) | 0),
              (s = (s + Math.imul(se, Le)) | 0),
              (m = (m + Math.imul(se, Ze)) | 0),
              (h = (h + Math.imul(Oe, Ve)) | 0),
              (s = (s + Math.imul(Oe, Je)) | 0),
              (s = (s + Math.imul(je, Ve)) | 0),
              (m = (m + Math.imul(je, Je)) | 0),
              (h = (h + Math.imul(Ie, $e)) | 0),
              (s = (s + Math.imul(Ie, et)) | 0),
              (s = (s + Math.imul(be, $e)) | 0),
              (m = (m + Math.imul(be, et)) | 0),
              (h = (h + Math.imul(Ce, V)) | 0),
              (s = (s + Math.imul(Ce, W)) | 0),
              (s = (s + Math.imul(Te, V)) | 0),
              (m = (m + Math.imul(Te, W)) | 0),
              (h = (h + Math.imul(K, D)) | 0),
              (s = (s + Math.imul(K, re)) | 0),
              (s = (s + Math.imul(ve, D)) | 0),
              (m = (m + Math.imul(ve, re)) | 0),
              (h = (h + Math.imul(te, pe)) | 0),
              (s = (s + Math.imul(te, xe)) | 0),
              (s = (s + Math.imul(ue, pe)) | 0),
              (m = (m + Math.imul(ue, xe)) | 0);
            var Pe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Pe >>> 26)) | 0),
              (Pe &= 67108863),
              (h = Math.imul(I, Ne)),
              (s = Math.imul(I, He)),
              (s = (s + Math.imul(C, Ne)) | 0),
              (m = Math.imul(C, He)),
              (h = (h + Math.imul(X, Le)) | 0),
              (s = (s + Math.imul(X, Ze)) | 0),
              (s = (s + Math.imul(le, Le)) | 0),
              (m = (m + Math.imul(le, Ze)) | 0),
              (h = (h + Math.imul(Ue, Ve)) | 0),
              (s = (s + Math.imul(Ue, Je)) | 0),
              (s = (s + Math.imul(se, Ve)) | 0),
              (m = (m + Math.imul(se, Je)) | 0),
              (h = (h + Math.imul(Oe, $e)) | 0),
              (s = (s + Math.imul(Oe, et)) | 0),
              (s = (s + Math.imul(je, $e)) | 0),
              (m = (m + Math.imul(je, et)) | 0),
              (h = (h + Math.imul(Ie, V)) | 0),
              (s = (s + Math.imul(Ie, W)) | 0),
              (s = (s + Math.imul(be, V)) | 0),
              (m = (m + Math.imul(be, W)) | 0),
              (h = (h + Math.imul(Ce, D)) | 0),
              (s = (s + Math.imul(Ce, re)) | 0),
              (s = (s + Math.imul(Te, D)) | 0),
              (m = (m + Math.imul(Te, re)) | 0),
              (h = (h + Math.imul(K, pe)) | 0),
              (s = (s + Math.imul(K, xe)) | 0),
              (s = (s + Math.imul(ve, pe)) | 0),
              (m = (m + Math.imul(ve, xe)) | 0);
            var Xe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Xe >>> 26)) | 0),
              (Xe &= 67108863),
              (h = Math.imul(I, Le)),
              (s = Math.imul(I, Ze)),
              (s = (s + Math.imul(C, Le)) | 0),
              (m = Math.imul(C, Ze)),
              (h = (h + Math.imul(X, Ve)) | 0),
              (s = (s + Math.imul(X, Je)) | 0),
              (s = (s + Math.imul(le, Ve)) | 0),
              (m = (m + Math.imul(le, Je)) | 0),
              (h = (h + Math.imul(Ue, $e)) | 0),
              (s = (s + Math.imul(Ue, et)) | 0),
              (s = (s + Math.imul(se, $e)) | 0),
              (m = (m + Math.imul(se, et)) | 0),
              (h = (h + Math.imul(Oe, V)) | 0),
              (s = (s + Math.imul(Oe, W)) | 0),
              (s = (s + Math.imul(je, V)) | 0),
              (m = (m + Math.imul(je, W)) | 0),
              (h = (h + Math.imul(Ie, D)) | 0),
              (s = (s + Math.imul(Ie, re)) | 0),
              (s = (s + Math.imul(be, D)) | 0),
              (m = (m + Math.imul(be, re)) | 0),
              (h = (h + Math.imul(Ce, pe)) | 0),
              (s = (s + Math.imul(Ce, xe)) | 0),
              (s = (s + Math.imul(Te, pe)) | 0),
              (m = (m + Math.imul(Te, xe)) | 0);
            var We = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (We >>> 26)) | 0),
              (We &= 67108863),
              (h = Math.imul(I, Ve)),
              (s = Math.imul(I, Je)),
              (s = (s + Math.imul(C, Ve)) | 0),
              (m = Math.imul(C, Je)),
              (h = (h + Math.imul(X, $e)) | 0),
              (s = (s + Math.imul(X, et)) | 0),
              (s = (s + Math.imul(le, $e)) | 0),
              (m = (m + Math.imul(le, et)) | 0),
              (h = (h + Math.imul(Ue, V)) | 0),
              (s = (s + Math.imul(Ue, W)) | 0),
              (s = (s + Math.imul(se, V)) | 0),
              (m = (m + Math.imul(se, W)) | 0),
              (h = (h + Math.imul(Oe, D)) | 0),
              (s = (s + Math.imul(Oe, re)) | 0),
              (s = (s + Math.imul(je, D)) | 0),
              (m = (m + Math.imul(je, re)) | 0),
              (h = (h + Math.imul(Ie, pe)) | 0),
              (s = (s + Math.imul(Ie, xe)) | 0),
              (s = (s + Math.imul(be, pe)) | 0),
              (m = (m + Math.imul(be, xe)) | 0);
            var rt = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (rt >>> 26)) | 0),
              (rt &= 67108863),
              (h = Math.imul(I, $e)),
              (s = Math.imul(I, et)),
              (s = (s + Math.imul(C, $e)) | 0),
              (m = Math.imul(C, et)),
              (h = (h + Math.imul(X, V)) | 0),
              (s = (s + Math.imul(X, W)) | 0),
              (s = (s + Math.imul(le, V)) | 0),
              (m = (m + Math.imul(le, W)) | 0),
              (h = (h + Math.imul(Ue, D)) | 0),
              (s = (s + Math.imul(Ue, re)) | 0),
              (s = (s + Math.imul(se, D)) | 0),
              (m = (m + Math.imul(se, re)) | 0),
              (h = (h + Math.imul(Oe, pe)) | 0),
              (s = (s + Math.imul(Oe, xe)) | 0),
              (s = (s + Math.imul(je, pe)) | 0),
              (m = (m + Math.imul(je, xe)) | 0);
            var ct = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ct >>> 26)) | 0),
              (ct &= 67108863),
              (h = Math.imul(I, V)),
              (s = Math.imul(I, W)),
              (s = (s + Math.imul(C, V)) | 0),
              (m = Math.imul(C, W)),
              (h = (h + Math.imul(X, D)) | 0),
              (s = (s + Math.imul(X, re)) | 0),
              (s = (s + Math.imul(le, D)) | 0),
              (m = (m + Math.imul(le, re)) | 0),
              (h = (h + Math.imul(Ue, pe)) | 0),
              (s = (s + Math.imul(Ue, xe)) | 0),
              (s = (s + Math.imul(se, pe)) | 0),
              (m = (m + Math.imul(se, xe)) | 0);
            var ht = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (ht >>> 26)) | 0),
              (ht &= 67108863),
              (h = Math.imul(I, D)),
              (s = Math.imul(I, re)),
              (s = (s + Math.imul(C, D)) | 0),
              (m = Math.imul(C, re)),
              (h = (h + Math.imul(X, pe)) | 0),
              (s = (s + Math.imul(X, xe)) | 0),
              (s = (s + Math.imul(le, pe)) | 0),
              (m = (m + Math.imul(le, xe)) | 0);
            var Fe = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            (w = (((m + (s >>> 13)) | 0) + (Fe >>> 26)) | 0),
              (Fe &= 67108863),
              (h = Math.imul(I, pe)),
              (s = Math.imul(I, xe)),
              (s = (s + Math.imul(C, pe)) | 0),
              (m = Math.imul(C, xe));
            var ze = (((w + h) | 0) + ((s & 8191) << 13)) | 0;
            return (
              (w = (((m + (s >>> 13)) | 0) + (ze >>> 26)) | 0),
              (ze &= 67108863),
              (y[0] = tt),
              (y[1] = Ke),
              (y[2] = dt),
              (y[3] = st),
              (y[4] = ce),
              (y[5] = N),
              (y[6] = Y),
              (y[7] = ie),
              (y[8] = ge),
              (y[9] = me),
              (y[10] = qe),
              (y[11] = Pe),
              (y[12] = Xe),
              (y[13] = We),
              (y[14] = rt),
              (y[15] = ct),
              (y[16] = ht),
              (y[17] = Fe),
              (y[18] = ze),
              w !== 0 && ((y[19] = w), f.length++),
              f
            );
          };
          Math.imul || (k = A);
          function P(x, r, o) {
            (o.negative = r.negative ^ x.negative), (o.length = x.length + r.length);
            for (var f = 0, u = 0, d = 0; d < o.length - 1; d++) {
              var y = u;
              u = 0;
              for (
                var w = f & 67108863,
                  h = Math.min(d, r.length - 1),
                  s = Math.max(0, d - x.length + 1);
                s <= h;
                s++
              ) {
                var m = d - s,
                  E = x.words[m] | 0,
                  R = r.words[s] | 0,
                  z = E * R,
                  Q = z & 67108863;
                (y = (y + ((z / 67108864) | 0)) | 0),
                  (Q = (Q + w) | 0),
                  (w = Q & 67108863),
                  (y = (y + (Q >>> 26)) | 0),
                  (u += y >>> 26),
                  (y &= 67108863);
              }
              (o.words[d] = w), (f = y), (y = u);
            }
            return f !== 0 ? (o.words[d] = f) : o.length--, o.strip();
          }
          function B(x, r, o) {
            var f = new T();
            return f.mulp(x, r, o);
          }
          a.prototype.mulTo = function (r, o) {
            var f,
              u = this.length + r.length;
            return (
              this.length === 10 && r.length === 10
                ? (f = k(this, r, o))
                : u < 63
                ? (f = A(this, r, o))
                : u < 1024
                ? (f = P(this, r, o))
                : (f = B(this, r, o)),
              f
            );
          };
          function T(x, r) {
            (this.x = x), (this.y = r);
          }
          (T.prototype.makeRBT = function (r) {
            for (var o = new Array(r), f = a.prototype._countBits(r) - 1, u = 0; u < r; u++)
              o[u] = this.revBin(u, f, r);
            return o;
          }),
            (T.prototype.revBin = function (r, o, f) {
              if (r === 0 || r === f - 1) return r;
              for (var u = 0, d = 0; d < o; d++) (u |= (r & 1) << (o - d - 1)), (r >>= 1);
              return u;
            }),
            (T.prototype.permute = function (r, o, f, u, d, y) {
              for (var w = 0; w < y; w++) (u[w] = o[r[w]]), (d[w] = f[r[w]]);
            }),
            (T.prototype.transform = function (r, o, f, u, d, y) {
              this.permute(y, r, o, f, u, d);
              for (var w = 1; w < d; w <<= 1)
                for (
                  var h = w << 1,
                    s = Math.cos((2 * Math.PI) / h),
                    m = Math.sin((2 * Math.PI) / h),
                    E = 0;
                  E < d;
                  E += h
                )
                  for (var R = s, z = m, Q = 0; Q < w; Q++) {
                    var G = f[E + Q],
                      q = u[E + Q],
                      Z = f[E + Q + w],
                      te = u[E + Q + w],
                      ue = R * Z - z * te;
                    (te = R * te + z * Z),
                      (Z = ue),
                      (f[E + Q] = G + Z),
                      (u[E + Q] = q + te),
                      (f[E + Q + w] = G - Z),
                      (u[E + Q + w] = q - te),
                      Q !== h && ((ue = s * R - m * z), (z = s * z + m * R), (R = ue));
                  }
            }),
            (T.prototype.guessLen13b = function (r, o) {
              var f = Math.max(o, r) | 1,
                u = f & 1,
                d = 0;
              for (f = (f / 2) | 0; f; f = f >>> 1) d++;
              return 1 << (d + 1 + u);
            }),
            (T.prototype.conjugate = function (r, o, f) {
              if (!(f <= 1))
                for (var u = 0; u < f / 2; u++) {
                  var d = r[u];
                  (r[u] = r[f - u - 1]),
                    (r[f - u - 1] = d),
                    (d = o[u]),
                    (o[u] = -o[f - u - 1]),
                    (o[f - u - 1] = -d);
                }
            }),
            (T.prototype.normalize13b = function (r, o) {
              for (var f = 0, u = 0; u < o / 2; u++) {
                var d = Math.round(r[2 * u + 1] / o) * 8192 + Math.round(r[2 * u] / o) + f;
                (r[u] = d & 67108863), d < 67108864 ? (f = 0) : (f = (d / 67108864) | 0);
              }
              return r;
            }),
            (T.prototype.convert13b = function (r, o, f, u) {
              for (var d = 0, y = 0; y < o; y++)
                (d = d + (r[y] | 0)),
                  (f[2 * y] = d & 8191),
                  (d = d >>> 13),
                  (f[2 * y + 1] = d & 8191),
                  (d = d >>> 13);
              for (y = 2 * o; y < u; ++y) f[y] = 0;
              i(d === 0), i((d & -8192) === 0);
            }),
            (T.prototype.stub = function (r) {
              for (var o = new Array(r), f = 0; f < r; f++) o[f] = 0;
              return o;
            }),
            (T.prototype.mulp = function (r, o, f) {
              var u = 2 * this.guessLen13b(r.length, o.length),
                d = this.makeRBT(u),
                y = this.stub(u),
                w = new Array(u),
                h = new Array(u),
                s = new Array(u),
                m = new Array(u),
                E = new Array(u),
                R = new Array(u),
                z = f.words;
              (z.length = u),
                this.convert13b(r.words, r.length, w, u),
                this.convert13b(o.words, o.length, m, u),
                this.transform(w, y, h, s, u, d),
                this.transform(m, y, E, R, u, d);
              for (var Q = 0; Q < u; Q++) {
                var G = h[Q] * E[Q] - s[Q] * R[Q];
                (s[Q] = h[Q] * R[Q] + s[Q] * E[Q]), (h[Q] = G);
              }
              return (
                this.conjugate(h, s, u),
                this.transform(h, s, z, y, u, d),
                this.conjugate(z, y, u),
                this.normalize13b(z, u),
                (f.negative = r.negative ^ o.negative),
                (f.length = r.length + o.length),
                f.strip()
              );
            }),
            (a.prototype.mul = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), this.mulTo(r, o);
            }),
            (a.prototype.mulf = function (r) {
              var o = new a(null);
              return (o.words = new Array(this.length + r.length)), B(this, r, o);
            }),
            (a.prototype.imul = function (r) {
              return this.clone().mulTo(r, this);
            }),
            (a.prototype.imuln = function (r) {
              i(typeof r == "number"), i(r < 67108864);
              for (var o = 0, f = 0; f < this.length; f++) {
                var u = (this.words[f] | 0) * r,
                  d = (u & 67108863) + (o & 67108863);
                (o >>= 26),
                  (o += (u / 67108864) | 0),
                  (o += d >>> 26),
                  (this.words[f] = d & 67108863);
              }
              return o !== 0 && ((this.words[f] = o), this.length++), this;
            }),
            (a.prototype.muln = function (r) {
              return this.clone().imuln(r);
            }),
            (a.prototype.sqr = function () {
              return this.mul(this);
            }),
            (a.prototype.isqr = function () {
              return this.imul(this.clone());
            }),
            (a.prototype.pow = function (r) {
              var o = S(r);
              if (o.length === 0) return new a(1);
              for (var f = this, u = 0; u < o.length && o[u] === 0; u++, f = f.sqr());
              if (++u < o.length)
                for (var d = f.sqr(); u < o.length; u++, d = d.sqr()) o[u] !== 0 && (f = f.mul(d));
              return f;
            }),
            (a.prototype.iushln = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = (67108863 >>> (26 - o)) << (26 - o),
                d;
              if (o !== 0) {
                var y = 0;
                for (d = 0; d < this.length; d++) {
                  var w = this.words[d] & u,
                    h = ((this.words[d] | 0) - w) << o;
                  (this.words[d] = h | y), (y = w >>> (26 - o));
                }
                y && ((this.words[d] = y), this.length++);
              }
              if (f !== 0) {
                for (d = this.length - 1; d >= 0; d--) this.words[d + f] = this.words[d];
                for (d = 0; d < f; d++) this.words[d] = 0;
                this.length += f;
              }
              return this.strip();
            }),
            (a.prototype.ishln = function (r) {
              return i(this.negative === 0), this.iushln(r);
            }),
            (a.prototype.iushrn = function (r, o, f) {
              i(typeof r == "number" && r >= 0);
              var u;
              o ? (u = (o - (o % 26)) / 26) : (u = 0);
              var d = r % 26,
                y = Math.min((r - d) / 26, this.length),
                w = 67108863 ^ ((67108863 >>> d) << d),
                h = f;
              if (((u -= y), (u = Math.max(0, u)), h)) {
                for (var s = 0; s < y; s++) h.words[s] = this.words[s];
                h.length = y;
              }
              if (y !== 0)
                if (this.length > y)
                  for (this.length -= y, s = 0; s < this.length; s++)
                    this.words[s] = this.words[s + y];
                else (this.words[0] = 0), (this.length = 1);
              var m = 0;
              for (s = this.length - 1; s >= 0 && (m !== 0 || s >= u); s--) {
                var E = this.words[s] | 0;
                (this.words[s] = (m << (26 - d)) | (E >>> d)), (m = E & w);
              }
              return (
                h && m !== 0 && (h.words[h.length++] = m),
                this.length === 0 && ((this.words[0] = 0), (this.length = 1)),
                this.strip()
              );
            }),
            (a.prototype.ishrn = function (r, o, f) {
              return i(this.negative === 0), this.iushrn(r, o, f);
            }),
            (a.prototype.shln = function (r) {
              return this.clone().ishln(r);
            }),
            (a.prototype.ushln = function (r) {
              return this.clone().iushln(r);
            }),
            (a.prototype.shrn = function (r) {
              return this.clone().ishrn(r);
            }),
            (a.prototype.ushrn = function (r) {
              return this.clone().iushrn(r);
            }),
            (a.prototype.testn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return !1;
              var d = this.words[f];
              return !!(d & u);
            }),
            (a.prototype.imaskn = function (r) {
              i(typeof r == "number" && r >= 0);
              var o = r % 26,
                f = (r - o) / 26;
              if (
                (i(this.negative === 0, "imaskn works only with positive numbers"),
                this.length <= f)
              )
                return this;
              if ((o !== 0 && f++, (this.length = Math.min(f, this.length)), o !== 0)) {
                var u = 67108863 ^ ((67108863 >>> o) << o);
                this.words[this.length - 1] &= u;
              }
              return this.strip();
            }),
            (a.prototype.maskn = function (r) {
              return this.clone().imaskn(r);
            }),
            (a.prototype.iaddn = function (r) {
              return (
                i(typeof r == "number"),
                i(r < 67108864),
                r < 0
                  ? this.isubn(-r)
                  : this.negative !== 0
                  ? this.length === 1 && (this.words[0] | 0) < r
                    ? ((this.words[0] = r - (this.words[0] | 0)), (this.negative = 0), this)
                    : ((this.negative = 0), this.isubn(r), (this.negative = 1), this)
                  : this._iaddn(r)
              );
            }),
            (a.prototype._iaddn = function (r) {
              this.words[0] += r;
              for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
                (this.words[o] -= 67108864),
                  o === this.length - 1 ? (this.words[o + 1] = 1) : this.words[o + 1]++;
              return (this.length = Math.max(this.length, o + 1)), this;
            }),
            (a.prototype.isubn = function (r) {
              if ((i(typeof r == "number"), i(r < 67108864), r < 0)) return this.iaddn(-r);
              if (this.negative !== 0)
                return (this.negative = 0), this.iaddn(r), (this.negative = 1), this;
              if (((this.words[0] -= r), this.length === 1 && this.words[0] < 0))
                (this.words[0] = -this.words[0]), (this.negative = 1);
              else
                for (var o = 0; o < this.length && this.words[o] < 0; o++)
                  (this.words[o] += 67108864), (this.words[o + 1] -= 1);
              return this.strip();
            }),
            (a.prototype.addn = function (r) {
              return this.clone().iaddn(r);
            }),
            (a.prototype.subn = function (r) {
              return this.clone().isubn(r);
            }),
            (a.prototype.iabs = function () {
              return (this.negative = 0), this;
            }),
            (a.prototype.abs = function () {
              return this.clone().iabs();
            }),
            (a.prototype._ishlnsubmul = function (r, o, f) {
              var u = r.length + f,
                d;
              this._expand(u);
              var y,
                w = 0;
              for (d = 0; d < r.length; d++) {
                y = (this.words[d + f] | 0) + w;
                var h = (r.words[d] | 0) * o;
                (y -= h & 67108863),
                  (w = (y >> 26) - ((h / 67108864) | 0)),
                  (this.words[d + f] = y & 67108863);
              }
              for (; d < this.length - f; d++)
                (y = (this.words[d + f] | 0) + w),
                  (w = y >> 26),
                  (this.words[d + f] = y & 67108863);
              if (w === 0) return this.strip();
              for (i(w === -1), w = 0, d = 0; d < this.length; d++)
                (y = -(this.words[d] | 0) + w), (w = y >> 26), (this.words[d] = y & 67108863);
              return (this.negative = 1), this.strip();
            }),
            (a.prototype._wordDiv = function (r, o) {
              var f = this.length - r.length,
                u = this.clone(),
                d = r,
                y = d.words[d.length - 1] | 0,
                w = this._countBits(y);
              (f = 26 - w),
                f !== 0 && ((d = d.ushln(f)), u.iushln(f), (y = d.words[d.length - 1] | 0));
              var h = u.length - d.length,
                s;
              if (o !== "mod") {
                (s = new a(null)), (s.length = h + 1), (s.words = new Array(s.length));
                for (var m = 0; m < s.length; m++) s.words[m] = 0;
              }
              var E = u.clone()._ishlnsubmul(d, 1, h);
              E.negative === 0 && ((u = E), s && (s.words[h] = 1));
              for (var R = h - 1; R >= 0; R--) {
                var z = (u.words[d.length + R] | 0) * 67108864 + (u.words[d.length + R - 1] | 0);
                for (
                  z = Math.min((z / y) | 0, 67108863), u._ishlnsubmul(d, z, R);
                  u.negative !== 0;

                )
                  z--, (u.negative = 0), u._ishlnsubmul(d, 1, R), u.isZero() || (u.negative ^= 1);
                s && (s.words[R] = z);
              }
              return (
                s && s.strip(),
                u.strip(),
                o !== "div" && f !== 0 && u.iushrn(f),
                {
                  div: s || null,
                  mod: u,
                }
              );
            }),
            (a.prototype.divmod = function (r, o, f) {
              if ((i(!r.isZero()), this.isZero()))
                return {
                  div: new a(0),
                  mod: new a(0),
                };
              var u, d, y;
              return this.negative !== 0 && r.negative === 0
                ? ((y = this.neg().divmod(r, o)),
                  o !== "mod" && (u = y.div.neg()),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.iadd(r)),
                  {
                    div: u,
                    mod: d,
                  })
                : this.negative === 0 && r.negative !== 0
                ? ((y = this.divmod(r.neg(), o)),
                  o !== "mod" && (u = y.div.neg()),
                  {
                    div: u,
                    mod: y.mod,
                  })
                : this.negative & r.negative
                ? ((y = this.neg().divmod(r.neg(), o)),
                  o !== "div" && ((d = y.mod.neg()), f && d.negative !== 0 && d.isub(r)),
                  {
                    div: y.div,
                    mod: d,
                  })
                : r.length > this.length || this.cmp(r) < 0
                ? {
                    div: new a(0),
                    mod: this,
                  }
                : r.length === 1
                ? o === "div"
                  ? {
                      div: this.divn(r.words[0]),
                      mod: null,
                    }
                  : o === "mod"
                  ? {
                      div: null,
                      mod: new a(this.modn(r.words[0])),
                    }
                  : {
                      div: this.divn(r.words[0]),
                      mod: new a(this.modn(r.words[0])),
                    }
                : this._wordDiv(r, o);
            }),
            (a.prototype.div = function (r) {
              return this.divmod(r, "div", !1).div;
            }),
            (a.prototype.mod = function (r) {
              return this.divmod(r, "mod", !1).mod;
            }),
            (a.prototype.umod = function (r) {
              return this.divmod(r, "mod", !0).mod;
            }),
            (a.prototype.divRound = function (r) {
              var o = this.divmod(r);
              if (o.mod.isZero()) return o.div;
              var f = o.div.negative !== 0 ? o.mod.isub(r) : o.mod,
                u = r.ushrn(1),
                d = r.andln(1),
                y = f.cmp(u);
              return y < 0 || (d === 1 && y === 0)
                ? o.div
                : o.div.negative !== 0
                ? o.div.isubn(1)
                : o.div.iaddn(1);
            }),
            (a.prototype.modn = function (r) {
              i(r <= 67108863);
              for (var o = (1 << 26) % r, f = 0, u = this.length - 1; u >= 0; u--)
                f = (o * f + (this.words[u] | 0)) % r;
              return f;
            }),
            (a.prototype.idivn = function (r) {
              i(r <= 67108863);
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = (this.words[f] | 0) + o * 67108864;
                (this.words[f] = (u / r) | 0), (o = u % r);
              }
              return this.strip();
            }),
            (a.prototype.divn = function (r) {
              return this.clone().idivn(r);
            }),
            (a.prototype.egcd = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = new a(0), w = new a(1), h = 0;
                o.isEven() && f.isEven();

              )
                o.iushrn(1), f.iushrn(1), ++h;
              for (var s = f.clone(), m = o.clone(); !o.isZero(); ) {
                for (var E = 0, R = 1; !(o.words[0] & R) && E < 26; ++E, R <<= 1);
                if (E > 0)
                  for (o.iushrn(E); E-- > 0; )
                    (u.isOdd() || d.isOdd()) && (u.iadd(s), d.isub(m)), u.iushrn(1), d.iushrn(1);
                for (var z = 0, Q = 1; !(f.words[0] & Q) && z < 26; ++z, Q <<= 1);
                if (z > 0)
                  for (f.iushrn(z); z-- > 0; )
                    (y.isOdd() || w.isOdd()) && (y.iadd(s), w.isub(m)), y.iushrn(1), w.iushrn(1);
                o.cmp(f) >= 0
                  ? (o.isub(f), u.isub(y), d.isub(w))
                  : (f.isub(o), y.isub(u), w.isub(d));
              }
              return {
                a: y,
                b: w,
                gcd: f.iushln(h),
              };
            }),
            (a.prototype._invmp = function (r) {
              i(r.negative === 0), i(!r.isZero());
              var o = this,
                f = r.clone();
              o.negative !== 0 ? (o = o.umod(r)) : (o = o.clone());
              for (
                var u = new a(1), d = new a(0), y = f.clone();
                o.cmpn(1) > 0 && f.cmpn(1) > 0;

              ) {
                for (var w = 0, h = 1; !(o.words[0] & h) && w < 26; ++w, h <<= 1);
                if (w > 0) for (o.iushrn(w); w-- > 0; ) u.isOdd() && u.iadd(y), u.iushrn(1);
                for (var s = 0, m = 1; !(f.words[0] & m) && s < 26; ++s, m <<= 1);
                if (s > 0) for (f.iushrn(s); s-- > 0; ) d.isOdd() && d.iadd(y), d.iushrn(1);
                o.cmp(f) >= 0 ? (o.isub(f), u.isub(d)) : (f.isub(o), d.isub(u));
              }
              var E;
              return o.cmpn(1) === 0 ? (E = u) : (E = d), E.cmpn(0) < 0 && E.iadd(r), E;
            }),
            (a.prototype.gcd = function (r) {
              if (this.isZero()) return r.abs();
              if (r.isZero()) return this.abs();
              var o = this.clone(),
                f = r.clone();
              (o.negative = 0), (f.negative = 0);
              for (var u = 0; o.isEven() && f.isEven(); u++) o.iushrn(1), f.iushrn(1);
              do {
                for (; o.isEven(); ) o.iushrn(1);
                for (; f.isEven(); ) f.iushrn(1);
                var d = o.cmp(f);
                if (d < 0) {
                  var y = o;
                  (o = f), (f = y);
                } else if (d === 0 || f.cmpn(1) === 0) break;
                o.isub(f);
              } while (!0);
              return f.iushln(u);
            }),
            (a.prototype.invm = function (r) {
              return this.egcd(r).a.umod(r);
            }),
            (a.prototype.isEven = function () {
              return (this.words[0] & 1) === 0;
            }),
            (a.prototype.isOdd = function () {
              return (this.words[0] & 1) === 1;
            }),
            (a.prototype.andln = function (r) {
              return this.words[0] & r;
            }),
            (a.prototype.bincn = function (r) {
              i(typeof r == "number");
              var o = r % 26,
                f = (r - o) / 26,
                u = 1 << o;
              if (this.length <= f) return this._expand(f + 1), (this.words[f] |= u), this;
              for (var d = u, y = f; d !== 0 && y < this.length; y++) {
                var w = this.words[y] | 0;
                (w += d), (d = w >>> 26), (w &= 67108863), (this.words[y] = w);
              }
              return d !== 0 && ((this.words[y] = d), this.length++), this;
            }),
            (a.prototype.isZero = function () {
              return this.length === 1 && this.words[0] === 0;
            }),
            (a.prototype.cmpn = function (r) {
              var o = r < 0;
              if (this.negative !== 0 && !o) return -1;
              if (this.negative === 0 && o) return 1;
              this.strip();
              var f;
              if (this.length > 1) f = 1;
              else {
                o && (r = -r), i(r <= 67108863, "Number is too big");
                var u = this.words[0] | 0;
                f = u === r ? 0 : u < r ? -1 : 1;
              }
              return this.negative !== 0 ? -f | 0 : f;
            }),
            (a.prototype.cmp = function (r) {
              if (this.negative !== 0 && r.negative === 0) return -1;
              if (this.negative === 0 && r.negative !== 0) return 1;
              var o = this.ucmp(r);
              return this.negative !== 0 ? -o | 0 : o;
            }),
            (a.prototype.ucmp = function (r) {
              if (this.length > r.length) return 1;
              if (this.length < r.length) return -1;
              for (var o = 0, f = this.length - 1; f >= 0; f--) {
                var u = this.words[f] | 0,
                  d = r.words[f] | 0;
                if (u !== d) {
                  u < d ? (o = -1) : u > d && (o = 1);
                  break;
                }
              }
              return o;
            }),
            (a.prototype.gtn = function (r) {
              return this.cmpn(r) === 1;
            }),
            (a.prototype.gt = function (r) {
              return this.cmp(r) === 1;
            }),
            (a.prototype.gten = function (r) {
              return this.cmpn(r) >= 0;
            }),
            (a.prototype.gte = function (r) {
              return this.cmp(r) >= 0;
            }),
            (a.prototype.ltn = function (r) {
              return this.cmpn(r) === -1;
            }),
            (a.prototype.lt = function (r) {
              return this.cmp(r) === -1;
            }),
            (a.prototype.lten = function (r) {
              return this.cmpn(r) <= 0;
            }),
            (a.prototype.lte = function (r) {
              return this.cmp(r) <= 0;
            }),
            (a.prototype.eqn = function (r) {
              return this.cmpn(r) === 0;
            }),
            (a.prototype.eq = function (r) {
              return this.cmp(r) === 0;
            }),
            (a.red = function (r) {
              return new ne(r);
            }),
            (a.prototype.toRed = function (r) {
              return (
                i(!this.red, "Already a number in reduction context"),
                i(this.negative === 0, "red works only with positives"),
                r.convertTo(this)._forceRed(r)
              );
            }),
            (a.prototype.fromRed = function () {
              return (
                i(this.red, "fromRed works only with numbers in reduction context"),
                this.red.convertFrom(this)
              );
            }),
            (a.prototype._forceRed = function (r) {
              return (this.red = r), this;
            }),
            (a.prototype.forceRed = function (r) {
              return i(!this.red, "Already a number in reduction context"), this._forceRed(r);
            }),
            (a.prototype.redAdd = function (r) {
              return i(this.red, "redAdd works only with red numbers"), this.red.add(this, r);
            }),
            (a.prototype.redIAdd = function (r) {
              return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, r);
            }),
            (a.prototype.redSub = function (r) {
              return i(this.red, "redSub works only with red numbers"), this.red.sub(this, r);
            }),
            (a.prototype.redISub = function (r) {
              return i(this.red, "redISub works only with red numbers"), this.red.isub(this, r);
            }),
            (a.prototype.redShl = function (r) {
              return i(this.red, "redShl works only with red numbers"), this.red.shl(this, r);
            }),
            (a.prototype.redMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.mul(this, r)
              );
            }),
            (a.prototype.redIMul = function (r) {
              return (
                i(this.red, "redMul works only with red numbers"),
                this.red._verify2(this, r),
                this.red.imul(this, r)
              );
            }),
            (a.prototype.redSqr = function () {
              return (
                i(this.red, "redSqr works only with red numbers"),
                this.red._verify1(this),
                this.red.sqr(this)
              );
            }),
            (a.prototype.redISqr = function () {
              return (
                i(this.red, "redISqr works only with red numbers"),
                this.red._verify1(this),
                this.red.isqr(this)
              );
            }),
            (a.prototype.redSqrt = function () {
              return (
                i(this.red, "redSqrt works only with red numbers"),
                this.red._verify1(this),
                this.red.sqrt(this)
              );
            }),
            (a.prototype.redInvm = function () {
              return (
                i(this.red, "redInvm works only with red numbers"),
                this.red._verify1(this),
                this.red.invm(this)
              );
            }),
            (a.prototype.redNeg = function () {
              return (
                i(this.red, "redNeg works only with red numbers"),
                this.red._verify1(this),
                this.red.neg(this)
              );
            }),
            (a.prototype.redPow = function (r) {
              return (
                i(this.red && !r.red, "redPow(normalNum)"),
                this.red._verify1(this),
                this.red.pow(this, r)
              );
            });
          var F = {
            k256: null,
            p224: null,
            p192: null,
            p25519: null,
          };
          function O(x, r) {
            (this.name = x),
              (this.p = new a(r, 16)),
              (this.n = this.p.bitLength()),
              (this.k = new a(1).iushln(this.n).isub(this.p)),
              (this.tmp = this._tmp());
          }
          (O.prototype._tmp = function () {
            var r = new a(null);
            return (r.words = new Array(Math.ceil(this.n / 13))), r;
          }),
            (O.prototype.ireduce = function (r) {
              var o = r,
                f;
              do
                this.split(o, this.tmp),
                  (o = this.imulK(o)),
                  (o = o.iadd(this.tmp)),
                  (f = o.bitLength());
              while (f > this.n);
              var u = f < this.n ? -1 : o.ucmp(this.p);
              return (
                u === 0
                  ? ((o.words[0] = 0), (o.length = 1))
                  : u > 0
                  ? o.isub(this.p)
                  : o.strip !== void 0
                  ? o.strip()
                  : o._strip(),
                o
              );
            }),
            (O.prototype.split = function (r, o) {
              r.iushrn(this.n, 0, o);
            }),
            (O.prototype.imulK = function (r) {
              return r.imul(this.k);
            });
          function $() {
            O.call(
              this,
              "k256",
              "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
            );
          }
          l($, O),
            ($.prototype.split = function (r, o) {
              for (var f = 4194303, u = Math.min(r.length, 9), d = 0; d < u; d++)
                o.words[d] = r.words[d];
              if (((o.length = u), r.length <= 9)) {
                (r.words[0] = 0), (r.length = 1);
                return;
              }
              var y = r.words[9];
              for (o.words[o.length++] = y & f, d = 10; d < r.length; d++) {
                var w = r.words[d] | 0;
                (r.words[d - 10] = ((w & f) << 4) | (y >>> 22)), (y = w);
              }
              (y >>>= 22),
                (r.words[d - 10] = y),
                y === 0 && r.length > 10 ? (r.length -= 10) : (r.length -= 9);
            }),
            ($.prototype.imulK = function (r) {
              (r.words[r.length] = 0), (r.words[r.length + 1] = 0), (r.length += 2);
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = r.words[f] | 0;
                (o += u * 977), (r.words[f] = o & 67108863), (o = u * 64 + ((o / 67108864) | 0));
              }
              return (
                r.words[r.length - 1] === 0 &&
                  (r.length--, r.words[r.length - 1] === 0 && r.length--),
                r
              );
            });
          function J() {
            O.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
          }
          l(J, O);
          function he() {
            O.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
          }
          l(he, O);
          function de() {
            O.call(
              this,
              "25519",
              "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
            );
          }
          l(de, O),
            (de.prototype.imulK = function (r) {
              for (var o = 0, f = 0; f < r.length; f++) {
                var u = (r.words[f] | 0) * 19 + o,
                  d = u & 67108863;
                (u >>>= 26), (r.words[f] = d), (o = u);
              }
              return o !== 0 && (r.words[r.length++] = o), r;
            }),
            (a._prime = function (r) {
              if (F[r]) return F[r];
              var o;
              if (r === "k256") o = new $();
              else if (r === "p224") o = new J();
              else if (r === "p192") o = new he();
              else if (r === "p25519") o = new de();
              else throw new Error("Unknown prime " + r);
              return (F[r] = o), o;
            });
          function ne(x) {
            if (typeof x == "string") {
              var r = a._prime(x);
              (this.m = r.p), (this.prime = r);
            } else i(x.gtn(1), "modulus must be greater than 1"), (this.m = x), (this.prime = null);
          }
          (ne.prototype._verify1 = function (r) {
            i(r.negative === 0, "red works only with positives"),
              i(r.red, "red works only with red numbers");
          }),
            (ne.prototype._verify2 = function (r, o) {
              i((r.negative | o.negative) === 0, "red works only with positives"),
                i(r.red && r.red === o.red, "red works only with red numbers");
            }),
            (ne.prototype.imod = function (r) {
              return this.prime
                ? this.prime.ireduce(r)._forceRed(this)
                : r.umod(this.m)._forceRed(this);
            }),
            (ne.prototype.neg = function (r) {
              return r.isZero() ? r.clone() : this.m.sub(r)._forceRed(this);
            }),
            (ne.prototype.add = function (r, o) {
              this._verify2(r, o);
              var f = r.add(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f._forceRed(this);
            }),
            (ne.prototype.iadd = function (r, o) {
              this._verify2(r, o);
              var f = r.iadd(o);
              return f.cmp(this.m) >= 0 && f.isub(this.m), f;
            }),
            (ne.prototype.sub = function (r, o) {
              this._verify2(r, o);
              var f = r.sub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f._forceRed(this);
            }),
            (ne.prototype.isub = function (r, o) {
              this._verify2(r, o);
              var f = r.isub(o);
              return f.cmpn(0) < 0 && f.iadd(this.m), f;
            }),
            (ne.prototype.shl = function (r, o) {
              return this._verify1(r), this.imod(r.ushln(o));
            }),
            (ne.prototype.imul = function (r, o) {
              return this._verify2(r, o), this.imod(r.imul(o));
            }),
            (ne.prototype.mul = function (r, o) {
              return this._verify2(r, o), this.imod(r.mul(o));
            }),
            (ne.prototype.isqr = function (r) {
              return this.imul(r, r.clone());
            }),
            (ne.prototype.sqr = function (r) {
              return this.mul(r, r);
            }),
            (ne.prototype.sqrt = function (r) {
              if (r.isZero()) return r.clone();
              var o = this.m.andln(3);
              if ((i(o % 2 === 1), o === 3)) {
                var f = this.m.add(new a(1)).iushrn(2);
                return this.pow(r, f);
              }
              for (var u = this.m.subn(1), d = 0; !u.isZero() && u.andln(1) === 0; )
                d++, u.iushrn(1);
              i(!u.isZero());
              var y = new a(1).toRed(this),
                w = y.redNeg(),
                h = this.m.subn(1).iushrn(1),
                s = this.m.bitLength();
              for (s = new a(2 * s * s).toRed(this); this.pow(s, h).cmp(w) !== 0; ) s.redIAdd(w);
              for (
                var m = this.pow(s, u),
                  E = this.pow(r, u.addn(1).iushrn(1)),
                  R = this.pow(r, u),
                  z = d;
                R.cmp(y) !== 0;

              ) {
                for (var Q = R, G = 0; Q.cmp(y) !== 0; G++) Q = Q.redSqr();
                i(G < z);
                var q = this.pow(m, new a(1).iushln(z - G - 1));
                (E = E.redMul(q)), (m = q.redSqr()), (R = R.redMul(m)), (z = G);
              }
              return E;
            }),
            (ne.prototype.invm = function (r) {
              var o = r._invmp(this.m);
              return o.negative !== 0 ? ((o.negative = 0), this.imod(o).redNeg()) : this.imod(o);
            }),
            (ne.prototype.pow = function (r, o) {
              if (o.isZero()) return new a(1).toRed(this);
              if (o.cmpn(1) === 0) return r.clone();
              var f = 4,
                u = new Array(1 << f);
              (u[0] = new a(1).toRed(this)), (u[1] = r);
              for (var d = 2; d < u.length; d++) u[d] = this.mul(u[d - 1], r);
              var y = u[0],
                w = 0,
                h = 0,
                s = o.bitLength() % 26;
              for (s === 0 && (s = 26), d = o.length - 1; d >= 0; d--) {
                for (var m = o.words[d], E = s - 1; E >= 0; E--) {
                  var R = (m >> E) & 1;
                  if ((y !== u[0] && (y = this.sqr(y)), R === 0 && w === 0)) {
                    h = 0;
                    continue;
                  }
                  (w <<= 1),
                    (w |= R),
                    h++,
                    !(h !== f && (d !== 0 || E !== 0)) &&
                      ((y = this.mul(y, u[w])), (h = 0), (w = 0));
                }
                s = 26;
              }
              return y;
            }),
            (ne.prototype.convertTo = function (r) {
              var o = r.umod(this.m);
              return o === r ? o.clone() : o;
            }),
            (ne.prototype.convertFrom = function (r) {
              var o = r.clone();
              return (o.red = null), o;
            }),
            (a.mont = function (r) {
              return new Ae(r);
            });
          function Ae(x) {
            ne.call(this, x),
              (this.shift = this.m.bitLength()),
              this.shift % 26 !== 0 && (this.shift += 26 - (this.shift % 26)),
              (this.r = new a(1).iushln(this.shift)),
              (this.r2 = this.imod(this.r.sqr())),
              (this.rinv = this.r._invmp(this.m)),
              (this.minv = this.rinv.mul(this.r).isubn(1).div(this.m)),
              (this.minv = this.minv.umod(this.r)),
              (this.minv = this.r.sub(this.minv));
          }
          l(Ae, ne),
            (Ae.prototype.convertTo = function (r) {
              return this.imod(r.ushln(this.shift));
            }),
            (Ae.prototype.convertFrom = function (r) {
              var o = this.imod(r.mul(this.rinv));
              return (o.red = null), o;
            }),
            (Ae.prototype.imul = function (r, o) {
              if (r.isZero() || o.isZero()) return (r.words[0] = 0), (r.length = 1), r;
              var f = r.imul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.mul = function (r, o) {
              if (r.isZero() || o.isZero()) return new a(0)._forceRed(this);
              var f = r.mul(o),
                u = f.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),
                d = f.isub(u).iushrn(this.shift),
                y = d;
              return (
                d.cmp(this.m) >= 0 ? (y = d.isub(this.m)) : d.cmpn(0) < 0 && (y = d.iadd(this.m)),
                y._forceRed(this)
              );
            }),
            (Ae.prototype.invm = function (r) {
              var o = this.imod(r._invmp(this.m).mul(this.r2));
              return o._forceRed(this);
            });
        })(t, mt);
      })(Ml)),
    Ml.exports
  );
}
var C0, Db;
function Vw() {
  if (Db) return C0;
  Db = 1;
  var t = U1(),
    e = zt().Buffer;
  function n(i, l) {
    return e.from(i.toRed(t.mont(l.modulus)).redPow(new t(l.publicExponent)).fromRed().toArray());
  }
  return (C0 = n), C0;
}
var T0, Lb;
function H7() {
  if (Lb) return T0;
  Lb = 1;
  var t = Du(),
    e = so(),
    n = Af(),
    i = $w(),
    l = Hw(),
    a = U1(),
    c = Vw(),
    v = P1(),
    g = zt().Buffer;
  T0 = function (S, A, k) {
    var P;
    S.padding ? (P = S.padding) : k ? (P = 1) : (P = 4);
    var B = t(S),
      T;
    if (P === 4) T = b(B, A);
    else if (P === 1) T = p(B, A, k);
    else if (P === 3) {
      if (((T = new a(A)), T.cmp(B.modulus) >= 0)) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    return k ? v(T, B) : c(T, B);
  };
  function b(M, S) {
    var A = M.modulus.byteLength(),
      k = S.length,
      P = n("sha1").update(g.alloc(0)).digest(),
      B = P.length,
      T = 2 * B;
    if (k > A - T - 2) throw new Error("message too long");
    var F = g.alloc(A - k - T - 2),
      O = A - B - 1,
      $ = e(B),
      J = l(g.concat([P, F, g.alloc(1, 1), S], O), i($, O)),
      he = l($, i(J, B));
    return new a(g.concat([g.alloc(1), he, J], A));
  }
  function p(M, S, A) {
    var k = S.length,
      P = M.modulus.byteLength();
    if (k > P - 11) throw new Error("message too long");
    var B;
    return (
      A ? (B = g.alloc(P - k - 3, 255)) : (B = _(P - k - 3)),
      new a(g.concat([g.from([0, A ? 1 : 2]), B, g.alloc(1), S], P))
    );
  }
  function _(M) {
    for (var S = g.allocUnsafe(M), A = 0, k = e(M * 2), P = 0, B; A < M; )
      P === k.length && ((k = e(M * 2)), (P = 0)), (B = k[P++]), B && (S[A++] = B);
    return S;
  }
  return T0;
}
var P0, Fb;
function V7() {
  if (Fb) return P0;
  Fb = 1;
  var t = Du(),
    e = $w(),
    n = Hw(),
    i = U1(),
    l = P1(),
    a = Af(),
    c = Vw(),
    v = zt().Buffer;
  P0 = function (M, S, A) {
    var k;
    M.padding ? (k = M.padding) : A ? (k = 1) : (k = 4);
    var P = t(M),
      B = P.modulus.byteLength();
    if (S.length > B || new i(S).cmp(P.modulus) >= 0) throw new Error("decryption error");
    var T;
    A ? (T = c(new i(S), P)) : (T = l(S, P));
    var F = v.alloc(B - T.length);
    if (((T = v.concat([F, T], B)), k === 4)) return g(P, T);
    if (k === 1) return b(P, T, A);
    if (k === 3) return T;
    throw new Error("unknown padding");
  };
  function g(_, M) {
    var S = _.modulus.byteLength(),
      A = a("sha1").update(v.alloc(0)).digest(),
      k = A.length;
    if (M[0] !== 0) throw new Error("decryption error");
    var P = M.slice(1, k + 1),
      B = M.slice(k + 1),
      T = n(P, e(B, k)),
      F = n(B, e(T, S - k - 1));
    if (p(A, F.slice(0, k))) throw new Error("decryption error");
    for (var O = k; F[O] === 0; ) O++;
    if (F[O++] !== 1) throw new Error("decryption error");
    return F.slice(O);
  }
  function b(_, M, S) {
    for (var A = M.slice(0, 2), k = 2, P = 0; M[k++] !== 0; )
      if (k >= M.length) {
        P++;
        break;
      }
    var B = M.slice(2, k - 1);
    if (
      (((A.toString("hex") !== "0002" && !S) || (A.toString("hex") !== "0001" && S)) && P++,
      B.length < 8 && P++,
      P)
    )
      throw new Error("decryption error");
    return M.slice(k);
  }
  function p(_, M) {
    (_ = v.from(_)), (M = v.from(M));
    var S = 0,
      A = _.length;
    _.length !== M.length && (S++, (A = Math.min(_.length, M.length)));
    for (var k = -1; ++k < A; ) S += _[k] ^ M[k];
    return S;
  }
  return P0;
}
var qb;
function W7() {
  return (
    qb ||
      ((qb = 1),
      (function (t) {
        (t.publicEncrypt = H7()),
          (t.privateDecrypt = V7()),
          (t.privateEncrypt = function (n, i) {
            return t.publicEncrypt(n, i, !0);
          }),
          (t.publicDecrypt = function (n, i) {
            return t.privateDecrypt(n, i, !0);
          });
      })(A0)),
    A0
  );
}
var ls = {},
  zb;
function K7() {
  if (zb) return ls;
  zb = 1;
  function t() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = zt(),
    n = so(),
    i = e.Buffer,
    l = e.kMaxLength,
    a = mt.crypto || mt.msCrypto,
    c = Math.pow(2, 32) - 1;
  function v(M, S) {
    if (typeof M != "number" || M !== M) throw new TypeError("offset must be a number");
    if (M > c || M < 0) throw new TypeError("offset must be a uint32");
    if (M > l || M > S) throw new RangeError("offset out of range");
  }
  function g(M, S, A) {
    if (typeof M != "number" || M !== M) throw new TypeError("size must be a number");
    if (M > c || M < 0) throw new TypeError("size must be a uint32");
    if (M + S > A || M > l) throw new RangeError("buffer too small");
  }
  (a && a.getRandomValues) || !Et.browser
    ? ((ls.randomFill = b), (ls.randomFillSync = _))
    : ((ls.randomFill = t), (ls.randomFillSync = t));
  function b(M, S, A, k) {
    if (!i.isBuffer(M) && !(M instanceof mt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof S == "function") (k = S), (S = 0), (A = M.length);
    else if (typeof A == "function") (k = A), (A = M.length - S);
    else if (typeof k != "function") throw new TypeError('"cb" argument must be a function');
    return v(S, M.length), g(A, S, M.length), p(M, S, A, k);
  }
  function p(M, S, A, k) {
    if (Et.browser) {
      var P = M.buffer,
        B = new Uint8Array(P, S, A);
      if ((a.getRandomValues(B), k)) {
        Et.nextTick(function () {
          k(null, M);
        });
        return;
      }
      return M;
    }
    if (k) {
      n(A, function (F, O) {
        if (F) return k(F);
        O.copy(M, S), k(null, M);
      });
      return;
    }
    var T = n(A);
    return T.copy(M, S), M;
  }
  function _(M, S, A) {
    if ((typeof S > "u" && (S = 0), !i.isBuffer(M) && !(M instanceof mt.Uint8Array)))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return v(S, M.length), A === void 0 && (A = M.length - S), g(A, S, M.length), p(M, S, A);
  }
  return ls;
}
var jb;
function Ww() {
  if (jb) return Dt;
  (jb = 1),
    (Dt.randomBytes = Dt.rng = Dt.pseudoRandomBytes = Dt.prng = so()),
    (Dt.createHash = Dt.Hash = Af()),
    (Dt.createHmac = Dt.Hmac = dw());
  var t = f9(),
    e = Object.keys(t),
    n = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(e);
  Dt.getHashes = function () {
    return n;
  };
  var i = bw();
  (Dt.pbkdf2 = i.pbkdf2), (Dt.pbkdf2Sync = i.pbkdf2Sync);
  var l = k9();
  (Dt.Cipher = l.Cipher),
    (Dt.createCipher = l.createCipher),
    (Dt.Cipheriv = l.Cipheriv),
    (Dt.createCipheriv = l.createCipheriv),
    (Dt.Decipher = l.Decipher),
    (Dt.createDecipher = l.createDecipher),
    (Dt.Decipheriv = l.Decipheriv),
    (Dt.createDecipheriv = l.createDecipheriv),
    (Dt.getCiphers = l.getCiphers),
    (Dt.listCiphers = l.listCiphers);
  var a = F9();
  (Dt.DiffieHellmanGroup = a.DiffieHellmanGroup),
    (Dt.createDiffieHellmanGroup = a.createDiffieHellmanGroup),
    (Dt.getDiffieHellman = a.getDiffieHellman),
    (Dt.createDiffieHellman = a.createDiffieHellman),
    (Dt.DiffieHellman = a.DiffieHellman);
  var c = z7();
  (Dt.createSign = c.createSign),
    (Dt.Sign = c.Sign),
    (Dt.createVerify = c.createVerify),
    (Dt.Verify = c.Verify),
    (Dt.createECDH = $7());
  var v = W7();
  (Dt.publicEncrypt = v.publicEncrypt),
    (Dt.privateEncrypt = v.privateEncrypt),
    (Dt.publicDecrypt = v.publicDecrypt),
    (Dt.privateDecrypt = v.privateDecrypt);
  var g = K7();
  return (
    (Dt.randomFill = g.randomFill),
    (Dt.randomFillSync = g.randomFillSync),
    (Dt.createCredentials = function () {
      throw new Error(
        [
          "sorry, createCredentials is not implemented yet",
          "we accept pull requests",
          "https://github.com/crypto-browserify/crypto-browserify",
        ].join(`
`)
      );
    }),
    (Dt.constants = {
      DH_CHECK_P_NOT_SAFE_PRIME: 2,
      DH_CHECK_P_NOT_PRIME: 1,
      DH_UNABLE_TO_CHECK_GENERATOR: 4,
      DH_NOT_SUITABLE_GENERATOR: 8,
      NPN_ENABLED: 1,
      ALPN_ENABLED: 1,
      RSA_PKCS1_PADDING: 1,
      RSA_SSLV23_PADDING: 2,
      RSA_NO_PADDING: 3,
      RSA_PKCS1_OAEP_PADDING: 4,
      RSA_X931_PADDING: 5,
      RSA_PKCS1_PSS_PADDING: 6,
      POINT_CONVERSION_COMPRESSED: 2,
      POINT_CONVERSION_UNCOMPRESSED: 4,
      POINT_CONVERSION_HYBRID: 6,
    }),
    Dt
  );
}
(function (t) {
  (function (e) {
    var n = function (H) {
        var V,
          W = new Float64Array(16);
        if (H) for (V = 0; V < H.length; V++) W[V] = H[V];
        return W;
      },
      i = function () {
        throw new Error("no PRNG");
      },
      l = new Uint8Array(16),
      a = new Uint8Array(32);
    a[0] = 9;
    var c = n(),
      v = n([1]),
      g = n([56129, 1]),
      b = n([
        30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139,
        11119, 27886, 20995,
      ]),
      p = n([
        61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239,
        55772, 9222,
      ]),
      _ = n([
        54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502,
        52590, 14035, 8553,
      ]),
      M = n([
        26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214,
        26214, 26214, 26214,
      ]),
      S = n([
        41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099,
        20417, 9344, 11139,
      ]);
    function A(H, V, W, U) {
      (H[V] = (W >> 24) & 255),
        (H[V + 1] = (W >> 16) & 255),
        (H[V + 2] = (W >> 8) & 255),
        (H[V + 3] = W & 255),
        (H[V + 4] = (U >> 24) & 255),
        (H[V + 5] = (U >> 16) & 255),
        (H[V + 6] = (U >> 8) & 255),
        (H[V + 7] = U & 255);
    }
    function k(H, V, W, U, D) {
      var re,
        ye = 0;
      for (re = 0; re < D; re++) ye |= H[V + re] ^ W[U + re];
      return (1 & ((ye - 1) >>> 8)) - 1;
    }
    function P(H, V, W, U) {
      return k(H, V, W, U, 16);
    }
    function B(H, V, W, U) {
      return k(H, V, W, U, 32);
    }
    function T(H, V, W, U) {
      for (
        var D = (U[0] & 255) | ((U[1] & 255) << 8) | ((U[2] & 255) << 16) | ((U[3] & 255) << 24),
          re = (W[0] & 255) | ((W[1] & 255) << 8) | ((W[2] & 255) << 16) | ((W[3] & 255) << 24),
          ye = (W[4] & 255) | ((W[5] & 255) << 8) | ((W[6] & 255) << 16) | ((W[7] & 255) << 24),
          pe = (W[8] & 255) | ((W[9] & 255) << 8) | ((W[10] & 255) << 16) | ((W[11] & 255) << 24),
          xe = (W[12] & 255) | ((W[13] & 255) << 8) | ((W[14] & 255) << 16) | ((W[15] & 255) << 24),
          tt = (U[4] & 255) | ((U[5] & 255) << 8) | ((U[6] & 255) << 16) | ((U[7] & 255) << 24),
          Ke = (V[0] & 255) | ((V[1] & 255) << 8) | ((V[2] & 255) << 16) | ((V[3] & 255) << 24),
          dt = (V[4] & 255) | ((V[5] & 255) << 8) | ((V[6] & 255) << 16) | ((V[7] & 255) << 24),
          st = (V[8] & 255) | ((V[9] & 255) << 8) | ((V[10] & 255) << 16) | ((V[11] & 255) << 24),
          ce = (V[12] & 255) | ((V[13] & 255) << 8) | ((V[14] & 255) << 16) | ((V[15] & 255) << 24),
          N = (U[8] & 255) | ((U[9] & 255) << 8) | ((U[10] & 255) << 16) | ((U[11] & 255) << 24),
          Y = (W[16] & 255) | ((W[17] & 255) << 8) | ((W[18] & 255) << 16) | ((W[19] & 255) << 24),
          ie = (W[20] & 255) | ((W[21] & 255) << 8) | ((W[22] & 255) << 16) | ((W[23] & 255) << 24),
          ge = (W[24] & 255) | ((W[25] & 255) << 8) | ((W[26] & 255) << 16) | ((W[27] & 255) << 24),
          me = (W[28] & 255) | ((W[29] & 255) << 8) | ((W[30] & 255) << 16) | ((W[31] & 255) << 24),
          qe = (U[12] & 255) | ((U[13] & 255) << 8) | ((U[14] & 255) << 16) | ((U[15] & 255) << 24),
          Pe = D,
          Xe = re,
          We = ye,
          rt = pe,
          ct = xe,
          ht = tt,
          Fe = Ke,
          ze = dt,
          lt = st,
          nt = ce,
          ft = N,
          vt = Y,
          Bt = ie,
          Ot = ge,
          Nt = me,
          Ut = qe,
          Ee,
          qt = 0;
        qt < 20;
        qt += 2
      )
        (Ee = (Pe + Bt) | 0),
          (ct ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (ct + Pe) | 0),
          (lt ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (lt + ct) | 0),
          (Bt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Bt + lt) | 0),
          (Pe ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ht + Xe) | 0),
          (nt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (nt + ht) | 0),
          (Ot ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (Ot + nt) | 0),
          (Xe ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Xe + Ot) | 0),
          (ht ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ft + Fe) | 0),
          (Nt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Nt + ft) | 0),
          (We ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (We + Nt) | 0),
          (Fe ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Fe + We) | 0),
          (ft ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Ut + vt) | 0),
          (rt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (rt + Ut) | 0),
          (ze ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (ze + rt) | 0),
          (vt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (vt + ze) | 0),
          (Ut ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Pe + rt) | 0),
          (Xe ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Xe + Pe) | 0),
          (We ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (We + Xe) | 0),
          (rt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (rt + We) | 0),
          (Pe ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ht + ct) | 0),
          (Fe ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Fe + ht) | 0),
          (ze ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (ze + Fe) | 0),
          (ct ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (ct + ze) | 0),
          (ht ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ft + nt) | 0),
          (vt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (vt + ft) | 0),
          (lt ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (lt + vt) | 0),
          (nt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (nt + lt) | 0),
          (ft ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Ut + Nt) | 0),
          (Bt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Bt + Ut) | 0),
          (Ot ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (Ot + Bt) | 0),
          (Nt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Nt + Ot) | 0),
          (Ut ^= (Ee << 18) | (Ee >>> 14));
      (Pe = (Pe + D) | 0),
        (Xe = (Xe + re) | 0),
        (We = (We + ye) | 0),
        (rt = (rt + pe) | 0),
        (ct = (ct + xe) | 0),
        (ht = (ht + tt) | 0),
        (Fe = (Fe + Ke) | 0),
        (ze = (ze + dt) | 0),
        (lt = (lt + st) | 0),
        (nt = (nt + ce) | 0),
        (ft = (ft + N) | 0),
        (vt = (vt + Y) | 0),
        (Bt = (Bt + ie) | 0),
        (Ot = (Ot + ge) | 0),
        (Nt = (Nt + me) | 0),
        (Ut = (Ut + qe) | 0),
        (H[0] = (Pe >>> 0) & 255),
        (H[1] = (Pe >>> 8) & 255),
        (H[2] = (Pe >>> 16) & 255),
        (H[3] = (Pe >>> 24) & 255),
        (H[4] = (Xe >>> 0) & 255),
        (H[5] = (Xe >>> 8) & 255),
        (H[6] = (Xe >>> 16) & 255),
        (H[7] = (Xe >>> 24) & 255),
        (H[8] = (We >>> 0) & 255),
        (H[9] = (We >>> 8) & 255),
        (H[10] = (We >>> 16) & 255),
        (H[11] = (We >>> 24) & 255),
        (H[12] = (rt >>> 0) & 255),
        (H[13] = (rt >>> 8) & 255),
        (H[14] = (rt >>> 16) & 255),
        (H[15] = (rt >>> 24) & 255),
        (H[16] = (ct >>> 0) & 255),
        (H[17] = (ct >>> 8) & 255),
        (H[18] = (ct >>> 16) & 255),
        (H[19] = (ct >>> 24) & 255),
        (H[20] = (ht >>> 0) & 255),
        (H[21] = (ht >>> 8) & 255),
        (H[22] = (ht >>> 16) & 255),
        (H[23] = (ht >>> 24) & 255),
        (H[24] = (Fe >>> 0) & 255),
        (H[25] = (Fe >>> 8) & 255),
        (H[26] = (Fe >>> 16) & 255),
        (H[27] = (Fe >>> 24) & 255),
        (H[28] = (ze >>> 0) & 255),
        (H[29] = (ze >>> 8) & 255),
        (H[30] = (ze >>> 16) & 255),
        (H[31] = (ze >>> 24) & 255),
        (H[32] = (lt >>> 0) & 255),
        (H[33] = (lt >>> 8) & 255),
        (H[34] = (lt >>> 16) & 255),
        (H[35] = (lt >>> 24) & 255),
        (H[36] = (nt >>> 0) & 255),
        (H[37] = (nt >>> 8) & 255),
        (H[38] = (nt >>> 16) & 255),
        (H[39] = (nt >>> 24) & 255),
        (H[40] = (ft >>> 0) & 255),
        (H[41] = (ft >>> 8) & 255),
        (H[42] = (ft >>> 16) & 255),
        (H[43] = (ft >>> 24) & 255),
        (H[44] = (vt >>> 0) & 255),
        (H[45] = (vt >>> 8) & 255),
        (H[46] = (vt >>> 16) & 255),
        (H[47] = (vt >>> 24) & 255),
        (H[48] = (Bt >>> 0) & 255),
        (H[49] = (Bt >>> 8) & 255),
        (H[50] = (Bt >>> 16) & 255),
        (H[51] = (Bt >>> 24) & 255),
        (H[52] = (Ot >>> 0) & 255),
        (H[53] = (Ot >>> 8) & 255),
        (H[54] = (Ot >>> 16) & 255),
        (H[55] = (Ot >>> 24) & 255),
        (H[56] = (Nt >>> 0) & 255),
        (H[57] = (Nt >>> 8) & 255),
        (H[58] = (Nt >>> 16) & 255),
        (H[59] = (Nt >>> 24) & 255),
        (H[60] = (Ut >>> 0) & 255),
        (H[61] = (Ut >>> 8) & 255),
        (H[62] = (Ut >>> 16) & 255),
        (H[63] = (Ut >>> 24) & 255);
    }
    function F(H, V, W, U) {
      for (
        var D = (U[0] & 255) | ((U[1] & 255) << 8) | ((U[2] & 255) << 16) | ((U[3] & 255) << 24),
          re = (W[0] & 255) | ((W[1] & 255) << 8) | ((W[2] & 255) << 16) | ((W[3] & 255) << 24),
          ye = (W[4] & 255) | ((W[5] & 255) << 8) | ((W[6] & 255) << 16) | ((W[7] & 255) << 24),
          pe = (W[8] & 255) | ((W[9] & 255) << 8) | ((W[10] & 255) << 16) | ((W[11] & 255) << 24),
          xe = (W[12] & 255) | ((W[13] & 255) << 8) | ((W[14] & 255) << 16) | ((W[15] & 255) << 24),
          tt = (U[4] & 255) | ((U[5] & 255) << 8) | ((U[6] & 255) << 16) | ((U[7] & 255) << 24),
          Ke = (V[0] & 255) | ((V[1] & 255) << 8) | ((V[2] & 255) << 16) | ((V[3] & 255) << 24),
          dt = (V[4] & 255) | ((V[5] & 255) << 8) | ((V[6] & 255) << 16) | ((V[7] & 255) << 24),
          st = (V[8] & 255) | ((V[9] & 255) << 8) | ((V[10] & 255) << 16) | ((V[11] & 255) << 24),
          ce = (V[12] & 255) | ((V[13] & 255) << 8) | ((V[14] & 255) << 16) | ((V[15] & 255) << 24),
          N = (U[8] & 255) | ((U[9] & 255) << 8) | ((U[10] & 255) << 16) | ((U[11] & 255) << 24),
          Y = (W[16] & 255) | ((W[17] & 255) << 8) | ((W[18] & 255) << 16) | ((W[19] & 255) << 24),
          ie = (W[20] & 255) | ((W[21] & 255) << 8) | ((W[22] & 255) << 16) | ((W[23] & 255) << 24),
          ge = (W[24] & 255) | ((W[25] & 255) << 8) | ((W[26] & 255) << 16) | ((W[27] & 255) << 24),
          me = (W[28] & 255) | ((W[29] & 255) << 8) | ((W[30] & 255) << 16) | ((W[31] & 255) << 24),
          qe = (U[12] & 255) | ((U[13] & 255) << 8) | ((U[14] & 255) << 16) | ((U[15] & 255) << 24),
          Pe = D,
          Xe = re,
          We = ye,
          rt = pe,
          ct = xe,
          ht = tt,
          Fe = Ke,
          ze = dt,
          lt = st,
          nt = ce,
          ft = N,
          vt = Y,
          Bt = ie,
          Ot = ge,
          Nt = me,
          Ut = qe,
          Ee,
          qt = 0;
        qt < 20;
        qt += 2
      )
        (Ee = (Pe + Bt) | 0),
          (ct ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (ct + Pe) | 0),
          (lt ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (lt + ct) | 0),
          (Bt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Bt + lt) | 0),
          (Pe ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ht + Xe) | 0),
          (nt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (nt + ht) | 0),
          (Ot ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (Ot + nt) | 0),
          (Xe ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Xe + Ot) | 0),
          (ht ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ft + Fe) | 0),
          (Nt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Nt + ft) | 0),
          (We ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (We + Nt) | 0),
          (Fe ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Fe + We) | 0),
          (ft ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Ut + vt) | 0),
          (rt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (rt + Ut) | 0),
          (ze ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (ze + rt) | 0),
          (vt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (vt + ze) | 0),
          (Ut ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Pe + rt) | 0),
          (Xe ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Xe + Pe) | 0),
          (We ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (We + Xe) | 0),
          (rt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (rt + We) | 0),
          (Pe ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ht + ct) | 0),
          (Fe ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Fe + ht) | 0),
          (ze ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (ze + Fe) | 0),
          (ct ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (ct + ze) | 0),
          (ht ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (ft + nt) | 0),
          (vt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (vt + ft) | 0),
          (lt ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (lt + vt) | 0),
          (nt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (nt + lt) | 0),
          (ft ^= (Ee << 18) | (Ee >>> 14)),
          (Ee = (Ut + Nt) | 0),
          (Bt ^= (Ee << 7) | (Ee >>> 25)),
          (Ee = (Bt + Ut) | 0),
          (Ot ^= (Ee << 9) | (Ee >>> 23)),
          (Ee = (Ot + Bt) | 0),
          (Nt ^= (Ee << 13) | (Ee >>> 19)),
          (Ee = (Nt + Ot) | 0),
          (Ut ^= (Ee << 18) | (Ee >>> 14));
      (H[0] = (Pe >>> 0) & 255),
        (H[1] = (Pe >>> 8) & 255),
        (H[2] = (Pe >>> 16) & 255),
        (H[3] = (Pe >>> 24) & 255),
        (H[4] = (ht >>> 0) & 255),
        (H[5] = (ht >>> 8) & 255),
        (H[6] = (ht >>> 16) & 255),
        (H[7] = (ht >>> 24) & 255),
        (H[8] = (ft >>> 0) & 255),
        (H[9] = (ft >>> 8) & 255),
        (H[10] = (ft >>> 16) & 255),
        (H[11] = (ft >>> 24) & 255),
        (H[12] = (Ut >>> 0) & 255),
        (H[13] = (Ut >>> 8) & 255),
        (H[14] = (Ut >>> 16) & 255),
        (H[15] = (Ut >>> 24) & 255),
        (H[16] = (Fe >>> 0) & 255),
        (H[17] = (Fe >>> 8) & 255),
        (H[18] = (Fe >>> 16) & 255),
        (H[19] = (Fe >>> 24) & 255),
        (H[20] = (ze >>> 0) & 255),
        (H[21] = (ze >>> 8) & 255),
        (H[22] = (ze >>> 16) & 255),
        (H[23] = (ze >>> 24) & 255),
        (H[24] = (lt >>> 0) & 255),
        (H[25] = (lt >>> 8) & 255),
        (H[26] = (lt >>> 16) & 255),
        (H[27] = (lt >>> 24) & 255),
        (H[28] = (nt >>> 0) & 255),
        (H[29] = (nt >>> 8) & 255),
        (H[30] = (nt >>> 16) & 255),
        (H[31] = (nt >>> 24) & 255);
    }
    function O(H, V, W, U) {
      T(H, V, W, U);
    }
    function $(H, V, W, U) {
      F(H, V, W, U);
    }
    var J = new Uint8Array([
      101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107,
    ]);
    function he(H, V, W, U, D, re, ye) {
      var pe = new Uint8Array(16),
        xe = new Uint8Array(64),
        tt,
        Ke;
      for (Ke = 0; Ke < 16; Ke++) pe[Ke] = 0;
      for (Ke = 0; Ke < 8; Ke++) pe[Ke] = re[Ke];
      for (; D >= 64; ) {
        for (O(xe, pe, ye, J), Ke = 0; Ke < 64; Ke++) H[V + Ke] = W[U + Ke] ^ xe[Ke];
        for (tt = 1, Ke = 8; Ke < 16; Ke++)
          (tt = (tt + (pe[Ke] & 255)) | 0), (pe[Ke] = tt & 255), (tt >>>= 8);
        (D -= 64), (V += 64), (U += 64);
      }
      if (D > 0) for (O(xe, pe, ye, J), Ke = 0; Ke < D; Ke++) H[V + Ke] = W[U + Ke] ^ xe[Ke];
      return 0;
    }
    function de(H, V, W, U, D) {
      var re = new Uint8Array(16),
        ye = new Uint8Array(64),
        pe,
        xe;
      for (xe = 0; xe < 16; xe++) re[xe] = 0;
      for (xe = 0; xe < 8; xe++) re[xe] = U[xe];
      for (; W >= 64; ) {
        for (O(ye, re, D, J), xe = 0; xe < 64; xe++) H[V + xe] = ye[xe];
        for (pe = 1, xe = 8; xe < 16; xe++)
          (pe = (pe + (re[xe] & 255)) | 0), (re[xe] = pe & 255), (pe >>>= 8);
        (W -= 64), (V += 64);
      }
      if (W > 0) for (O(ye, re, D, J), xe = 0; xe < W; xe++) H[V + xe] = ye[xe];
      return 0;
    }
    function ne(H, V, W, U, D) {
      var re = new Uint8Array(32);
      $(re, U, D, J);
      for (var ye = new Uint8Array(8), pe = 0; pe < 8; pe++) ye[pe] = U[pe + 16];
      return de(H, V, W, ye, re);
    }
    function Ae(H, V, W, U, D, re, ye) {
      var pe = new Uint8Array(32);
      $(pe, re, ye, J);
      for (var xe = new Uint8Array(8), tt = 0; tt < 8; tt++) xe[tt] = re[tt + 16];
      return he(H, V, W, U, D, xe, pe);
    }
    var x = function (H) {
      (this.buffer = new Uint8Array(16)),
        (this.r = new Uint16Array(10)),
        (this.h = new Uint16Array(10)),
        (this.pad = new Uint16Array(8)),
        (this.leftover = 0),
        (this.fin = 0);
      var V, W, U, D, re, ye, pe, xe;
      (V = (H[0] & 255) | ((H[1] & 255) << 8)),
        (this.r[0] = V & 8191),
        (W = (H[2] & 255) | ((H[3] & 255) << 8)),
        (this.r[1] = ((V >>> 13) | (W << 3)) & 8191),
        (U = (H[4] & 255) | ((H[5] & 255) << 8)),
        (this.r[2] = ((W >>> 10) | (U << 6)) & 7939),
        (D = (H[6] & 255) | ((H[7] & 255) << 8)),
        (this.r[3] = ((U >>> 7) | (D << 9)) & 8191),
        (re = (H[8] & 255) | ((H[9] & 255) << 8)),
        (this.r[4] = ((D >>> 4) | (re << 12)) & 255),
        (this.r[5] = (re >>> 1) & 8190),
        (ye = (H[10] & 255) | ((H[11] & 255) << 8)),
        (this.r[6] = ((re >>> 14) | (ye << 2)) & 8191),
        (pe = (H[12] & 255) | ((H[13] & 255) << 8)),
        (this.r[7] = ((ye >>> 11) | (pe << 5)) & 8065),
        (xe = (H[14] & 255) | ((H[15] & 255) << 8)),
        (this.r[8] = ((pe >>> 8) | (xe << 8)) & 8191),
        (this.r[9] = (xe >>> 5) & 127),
        (this.pad[0] = (H[16] & 255) | ((H[17] & 255) << 8)),
        (this.pad[1] = (H[18] & 255) | ((H[19] & 255) << 8)),
        (this.pad[2] = (H[20] & 255) | ((H[21] & 255) << 8)),
        (this.pad[3] = (H[22] & 255) | ((H[23] & 255) << 8)),
        (this.pad[4] = (H[24] & 255) | ((H[25] & 255) << 8)),
        (this.pad[5] = (H[26] & 255) | ((H[27] & 255) << 8)),
        (this.pad[6] = (H[28] & 255) | ((H[29] & 255) << 8)),
        (this.pad[7] = (H[30] & 255) | ((H[31] & 255) << 8));
    };
    (x.prototype.blocks = function (H, V, W) {
      for (
        var U = this.fin ? 0 : 2048,
          D,
          re,
          ye,
          pe,
          xe,
          tt,
          Ke,
          dt,
          st,
          ce,
          N,
          Y,
          ie,
          ge,
          me,
          qe,
          Pe,
          Xe,
          We,
          rt = this.h[0],
          ct = this.h[1],
          ht = this.h[2],
          Fe = this.h[3],
          ze = this.h[4],
          lt = this.h[5],
          nt = this.h[6],
          ft = this.h[7],
          vt = this.h[8],
          Bt = this.h[9],
          Ot = this.r[0],
          Nt = this.r[1],
          Ut = this.r[2],
          Ee = this.r[3],
          qt = this.r[4],
          Kt = this.r[5],
          Zt = this.r[6],
          Lt = this.r[7],
          Ht = this.r[8],
          Vt = this.r[9];
        W >= 16;

      )
        (D = (H[V + 0] & 255) | ((H[V + 1] & 255) << 8)),
          (rt += D & 8191),
          (re = (H[V + 2] & 255) | ((H[V + 3] & 255) << 8)),
          (ct += ((D >>> 13) | (re << 3)) & 8191),
          (ye = (H[V + 4] & 255) | ((H[V + 5] & 255) << 8)),
          (ht += ((re >>> 10) | (ye << 6)) & 8191),
          (pe = (H[V + 6] & 255) | ((H[V + 7] & 255) << 8)),
          (Fe += ((ye >>> 7) | (pe << 9)) & 8191),
          (xe = (H[V + 8] & 255) | ((H[V + 9] & 255) << 8)),
          (ze += ((pe >>> 4) | (xe << 12)) & 8191),
          (lt += (xe >>> 1) & 8191),
          (tt = (H[V + 10] & 255) | ((H[V + 11] & 255) << 8)),
          (nt += ((xe >>> 14) | (tt << 2)) & 8191),
          (Ke = (H[V + 12] & 255) | ((H[V + 13] & 255) << 8)),
          (ft += ((tt >>> 11) | (Ke << 5)) & 8191),
          (dt = (H[V + 14] & 255) | ((H[V + 15] & 255) << 8)),
          (vt += ((Ke >>> 8) | (dt << 8)) & 8191),
          (Bt += (dt >>> 5) | U),
          (st = 0),
          (ce = st),
          (ce += rt * Ot),
          (ce += ct * (5 * Vt)),
          (ce += ht * (5 * Ht)),
          (ce += Fe * (5 * Lt)),
          (ce += ze * (5 * Zt)),
          (st = ce >>> 13),
          (ce &= 8191),
          (ce += lt * (5 * Kt)),
          (ce += nt * (5 * qt)),
          (ce += ft * (5 * Ee)),
          (ce += vt * (5 * Ut)),
          (ce += Bt * (5 * Nt)),
          (st += ce >>> 13),
          (ce &= 8191),
          (N = st),
          (N += rt * Nt),
          (N += ct * Ot),
          (N += ht * (5 * Vt)),
          (N += Fe * (5 * Ht)),
          (N += ze * (5 * Lt)),
          (st = N >>> 13),
          (N &= 8191),
          (N += lt * (5 * Zt)),
          (N += nt * (5 * Kt)),
          (N += ft * (5 * qt)),
          (N += vt * (5 * Ee)),
          (N += Bt * (5 * Ut)),
          (st += N >>> 13),
          (N &= 8191),
          (Y = st),
          (Y += rt * Ut),
          (Y += ct * Nt),
          (Y += ht * Ot),
          (Y += Fe * (5 * Vt)),
          (Y += ze * (5 * Ht)),
          (st = Y >>> 13),
          (Y &= 8191),
          (Y += lt * (5 * Lt)),
          (Y += nt * (5 * Zt)),
          (Y += ft * (5 * Kt)),
          (Y += vt * (5 * qt)),
          (Y += Bt * (5 * Ee)),
          (st += Y >>> 13),
          (Y &= 8191),
          (ie = st),
          (ie += rt * Ee),
          (ie += ct * Ut),
          (ie += ht * Nt),
          (ie += Fe * Ot),
          (ie += ze * (5 * Vt)),
          (st = ie >>> 13),
          (ie &= 8191),
          (ie += lt * (5 * Ht)),
          (ie += nt * (5 * Lt)),
          (ie += ft * (5 * Zt)),
          (ie += vt * (5 * Kt)),
          (ie += Bt * (5 * qt)),
          (st += ie >>> 13),
          (ie &= 8191),
          (ge = st),
          (ge += rt * qt),
          (ge += ct * Ee),
          (ge += ht * Ut),
          (ge += Fe * Nt),
          (ge += ze * Ot),
          (st = ge >>> 13),
          (ge &= 8191),
          (ge += lt * (5 * Vt)),
          (ge += nt * (5 * Ht)),
          (ge += ft * (5 * Lt)),
          (ge += vt * (5 * Zt)),
          (ge += Bt * (5 * Kt)),
          (st += ge >>> 13),
          (ge &= 8191),
          (me = st),
          (me += rt * Kt),
          (me += ct * qt),
          (me += ht * Ee),
          (me += Fe * Ut),
          (me += ze * Nt),
          (st = me >>> 13),
          (me &= 8191),
          (me += lt * Ot),
          (me += nt * (5 * Vt)),
          (me += ft * (5 * Ht)),
          (me += vt * (5 * Lt)),
          (me += Bt * (5 * Zt)),
          (st += me >>> 13),
          (me &= 8191),
          (qe = st),
          (qe += rt * Zt),
          (qe += ct * Kt),
          (qe += ht * qt),
          (qe += Fe * Ee),
          (qe += ze * Ut),
          (st = qe >>> 13),
          (qe &= 8191),
          (qe += lt * Nt),
          (qe += nt * Ot),
          (qe += ft * (5 * Vt)),
          (qe += vt * (5 * Ht)),
          (qe += Bt * (5 * Lt)),
          (st += qe >>> 13),
          (qe &= 8191),
          (Pe = st),
          (Pe += rt * Lt),
          (Pe += ct * Zt),
          (Pe += ht * Kt),
          (Pe += Fe * qt),
          (Pe += ze * Ee),
          (st = Pe >>> 13),
          (Pe &= 8191),
          (Pe += lt * Ut),
          (Pe += nt * Nt),
          (Pe += ft * Ot),
          (Pe += vt * (5 * Vt)),
          (Pe += Bt * (5 * Ht)),
          (st += Pe >>> 13),
          (Pe &= 8191),
          (Xe = st),
          (Xe += rt * Ht),
          (Xe += ct * Lt),
          (Xe += ht * Zt),
          (Xe += Fe * Kt),
          (Xe += ze * qt),
          (st = Xe >>> 13),
          (Xe &= 8191),
          (Xe += lt * Ee),
          (Xe += nt * Ut),
          (Xe += ft * Nt),
          (Xe += vt * Ot),
          (Xe += Bt * (5 * Vt)),
          (st += Xe >>> 13),
          (Xe &= 8191),
          (We = st),
          (We += rt * Vt),
          (We += ct * Ht),
          (We += ht * Lt),
          (We += Fe * Zt),
          (We += ze * Kt),
          (st = We >>> 13),
          (We &= 8191),
          (We += lt * qt),
          (We += nt * Ee),
          (We += ft * Ut),
          (We += vt * Nt),
          (We += Bt * Ot),
          (st += We >>> 13),
          (We &= 8191),
          (st = ((st << 2) + st) | 0),
          (st = (st + ce) | 0),
          (ce = st & 8191),
          (st = st >>> 13),
          (N += st),
          (rt = ce),
          (ct = N),
          (ht = Y),
          (Fe = ie),
          (ze = ge),
          (lt = me),
          (nt = qe),
          (ft = Pe),
          (vt = Xe),
          (Bt = We),
          (V += 16),
          (W -= 16);
      (this.h[0] = rt),
        (this.h[1] = ct),
        (this.h[2] = ht),
        (this.h[3] = Fe),
        (this.h[4] = ze),
        (this.h[5] = lt),
        (this.h[6] = nt),
        (this.h[7] = ft),
        (this.h[8] = vt),
        (this.h[9] = Bt);
    }),
      (x.prototype.finish = function (H, V) {
        var W = new Uint16Array(10),
          U,
          D,
          re,
          ye;
        if (this.leftover) {
          for (ye = this.leftover, this.buffer[ye++] = 1; ye < 16; ye++) this.buffer[ye] = 0;
          (this.fin = 1), this.blocks(this.buffer, 0, 16);
        }
        for (U = this.h[1] >>> 13, this.h[1] &= 8191, ye = 2; ye < 10; ye++)
          (this.h[ye] += U), (U = this.h[ye] >>> 13), (this.h[ye] &= 8191);
        for (
          this.h[0] += U * 5,
            U = this.h[0] >>> 13,
            this.h[0] &= 8191,
            this.h[1] += U,
            U = this.h[1] >>> 13,
            this.h[1] &= 8191,
            this.h[2] += U,
            W[0] = this.h[0] + 5,
            U = W[0] >>> 13,
            W[0] &= 8191,
            ye = 1;
          ye < 10;
          ye++
        )
          (W[ye] = this.h[ye] + U), (U = W[ye] >>> 13), (W[ye] &= 8191);
        for (W[9] -= 8192, D = (U ^ 1) - 1, ye = 0; ye < 10; ye++) W[ye] &= D;
        for (D = ~D, ye = 0; ye < 10; ye++) this.h[ye] = (this.h[ye] & D) | W[ye];
        for (
          this.h[0] = (this.h[0] | (this.h[1] << 13)) & 65535,
            this.h[1] = ((this.h[1] >>> 3) | (this.h[2] << 10)) & 65535,
            this.h[2] = ((this.h[2] >>> 6) | (this.h[3] << 7)) & 65535,
            this.h[3] = ((this.h[3] >>> 9) | (this.h[4] << 4)) & 65535,
            this.h[4] = ((this.h[4] >>> 12) | (this.h[5] << 1) | (this.h[6] << 14)) & 65535,
            this.h[5] = ((this.h[6] >>> 2) | (this.h[7] << 11)) & 65535,
            this.h[6] = ((this.h[7] >>> 5) | (this.h[8] << 8)) & 65535,
            this.h[7] = ((this.h[8] >>> 8) | (this.h[9] << 5)) & 65535,
            re = this.h[0] + this.pad[0],
            this.h[0] = re & 65535,
            ye = 1;
          ye < 8;
          ye++
        )
          (re = (((this.h[ye] + this.pad[ye]) | 0) + (re >>> 16)) | 0), (this.h[ye] = re & 65535);
        (H[V + 0] = (this.h[0] >>> 0) & 255),
          (H[V + 1] = (this.h[0] >>> 8) & 255),
          (H[V + 2] = (this.h[1] >>> 0) & 255),
          (H[V + 3] = (this.h[1] >>> 8) & 255),
          (H[V + 4] = (this.h[2] >>> 0) & 255),
          (H[V + 5] = (this.h[2] >>> 8) & 255),
          (H[V + 6] = (this.h[3] >>> 0) & 255),
          (H[V + 7] = (this.h[3] >>> 8) & 255),
          (H[V + 8] = (this.h[4] >>> 0) & 255),
          (H[V + 9] = (this.h[4] >>> 8) & 255),
          (H[V + 10] = (this.h[5] >>> 0) & 255),
          (H[V + 11] = (this.h[5] >>> 8) & 255),
          (H[V + 12] = (this.h[6] >>> 0) & 255),
          (H[V + 13] = (this.h[6] >>> 8) & 255),
          (H[V + 14] = (this.h[7] >>> 0) & 255),
          (H[V + 15] = (this.h[7] >>> 8) & 255);
      }),
      (x.prototype.update = function (H, V, W) {
        var U, D;
        if (this.leftover) {
          for (D = 16 - this.leftover, D > W && (D = W), U = 0; U < D; U++)
            this.buffer[this.leftover + U] = H[V + U];
          if (((W -= D), (V += D), (this.leftover += D), this.leftover < 16)) return;
          this.blocks(this.buffer, 0, 16), (this.leftover = 0);
        }
        if ((W >= 16 && ((D = W - (W % 16)), this.blocks(H, V, D), (V += D), (W -= D)), W)) {
          for (U = 0; U < W; U++) this.buffer[this.leftover + U] = H[V + U];
          this.leftover += W;
        }
      });
    function r(H, V, W, U, D, re) {
      var ye = new x(re);
      return ye.update(W, U, D), ye.finish(H, V), 0;
    }
    function o(H, V, W, U, D, re) {
      var ye = new Uint8Array(16);
      return r(ye, 0, W, U, D, re), P(H, V, ye, 0);
    }
    function f(H, V, W, U, D) {
      var re;
      if (W < 32) return -1;
      for (Ae(H, 0, V, 0, W, U, D), r(H, 16, H, 32, W - 32, H), re = 0; re < 16; re++) H[re] = 0;
      return 0;
    }
    function u(H, V, W, U, D) {
      var re,
        ye = new Uint8Array(32);
      if (W < 32 || (ne(ye, 0, 32, U, D), o(V, 16, V, 32, W - 32, ye) !== 0)) return -1;
      for (Ae(H, 0, V, 0, W, U, D), re = 0; re < 32; re++) H[re] = 0;
      return 0;
    }
    function d(H, V) {
      var W;
      for (W = 0; W < 16; W++) H[W] = V[W] | 0;
    }
    function y(H) {
      var V,
        W,
        U = 1;
      for (V = 0; V < 16; V++)
        (W = H[V] + U + 65535), (U = Math.floor(W / 65536)), (H[V] = W - U * 65536);
      H[0] += U - 1 + 37 * (U - 1);
    }
    function w(H, V, W) {
      for (var U, D = ~(W - 1), re = 0; re < 16; re++)
        (U = D & (H[re] ^ V[re])), (H[re] ^= U), (V[re] ^= U);
    }
    function h(H, V) {
      var W,
        U,
        D,
        re = n(),
        ye = n();
      for (W = 0; W < 16; W++) ye[W] = V[W];
      for (y(ye), y(ye), y(ye), U = 0; U < 2; U++) {
        for (re[0] = ye[0] - 65517, W = 1; W < 15; W++)
          (re[W] = ye[W] - 65535 - ((re[W - 1] >> 16) & 1)), (re[W - 1] &= 65535);
        (re[15] = ye[15] - 32767 - ((re[14] >> 16) & 1)),
          (D = (re[15] >> 16) & 1),
          (re[14] &= 65535),
          w(ye, re, 1 - D);
      }
      for (W = 0; W < 16; W++) (H[2 * W] = ye[W] & 255), (H[2 * W + 1] = ye[W] >> 8);
    }
    function s(H, V) {
      var W = new Uint8Array(32),
        U = new Uint8Array(32);
      return h(W, H), h(U, V), B(W, 0, U, 0);
    }
    function m(H) {
      var V = new Uint8Array(32);
      return h(V, H), V[0] & 1;
    }
    function E(H, V) {
      var W;
      for (W = 0; W < 16; W++) H[W] = V[2 * W] + (V[2 * W + 1] << 8);
      H[15] &= 32767;
    }
    function R(H, V, W) {
      for (var U = 0; U < 16; U++) H[U] = V[U] + W[U];
    }
    function z(H, V, W) {
      for (var U = 0; U < 16; U++) H[U] = V[U] - W[U];
    }
    function Q(H, V, W) {
      var U,
        D,
        re = 0,
        ye = 0,
        pe = 0,
        xe = 0,
        tt = 0,
        Ke = 0,
        dt = 0,
        st = 0,
        ce = 0,
        N = 0,
        Y = 0,
        ie = 0,
        ge = 0,
        me = 0,
        qe = 0,
        Pe = 0,
        Xe = 0,
        We = 0,
        rt = 0,
        ct = 0,
        ht = 0,
        Fe = 0,
        ze = 0,
        lt = 0,
        nt = 0,
        ft = 0,
        vt = 0,
        Bt = 0,
        Ot = 0,
        Nt = 0,
        Ut = 0,
        Ee = W[0],
        qt = W[1],
        Kt = W[2],
        Zt = W[3],
        Lt = W[4],
        Ht = W[5],
        Vt = W[6],
        hr = W[7],
        Qt = W[8],
        fr = W[9],
        lr = W[10],
        ur = W[11],
        yr = W[12],
        Br = W[13],
        Cr = W[14],
        Tr = W[15];
      (U = V[0]),
        (re += U * Ee),
        (ye += U * qt),
        (pe += U * Kt),
        (xe += U * Zt),
        (tt += U * Lt),
        (Ke += U * Ht),
        (dt += U * Vt),
        (st += U * hr),
        (ce += U * Qt),
        (N += U * fr),
        (Y += U * lr),
        (ie += U * ur),
        (ge += U * yr),
        (me += U * Br),
        (qe += U * Cr),
        (Pe += U * Tr),
        (U = V[1]),
        (ye += U * Ee),
        (pe += U * qt),
        (xe += U * Kt),
        (tt += U * Zt),
        (Ke += U * Lt),
        (dt += U * Ht),
        (st += U * Vt),
        (ce += U * hr),
        (N += U * Qt),
        (Y += U * fr),
        (ie += U * lr),
        (ge += U * ur),
        (me += U * yr),
        (qe += U * Br),
        (Pe += U * Cr),
        (Xe += U * Tr),
        (U = V[2]),
        (pe += U * Ee),
        (xe += U * qt),
        (tt += U * Kt),
        (Ke += U * Zt),
        (dt += U * Lt),
        (st += U * Ht),
        (ce += U * Vt),
        (N += U * hr),
        (Y += U * Qt),
        (ie += U * fr),
        (ge += U * lr),
        (me += U * ur),
        (qe += U * yr),
        (Pe += U * Br),
        (Xe += U * Cr),
        (We += U * Tr),
        (U = V[3]),
        (xe += U * Ee),
        (tt += U * qt),
        (Ke += U * Kt),
        (dt += U * Zt),
        (st += U * Lt),
        (ce += U * Ht),
        (N += U * Vt),
        (Y += U * hr),
        (ie += U * Qt),
        (ge += U * fr),
        (me += U * lr),
        (qe += U * ur),
        (Pe += U * yr),
        (Xe += U * Br),
        (We += U * Cr),
        (rt += U * Tr),
        (U = V[4]),
        (tt += U * Ee),
        (Ke += U * qt),
        (dt += U * Kt),
        (st += U * Zt),
        (ce += U * Lt),
        (N += U * Ht),
        (Y += U * Vt),
        (ie += U * hr),
        (ge += U * Qt),
        (me += U * fr),
        (qe += U * lr),
        (Pe += U * ur),
        (Xe += U * yr),
        (We += U * Br),
        (rt += U * Cr),
        (ct += U * Tr),
        (U = V[5]),
        (Ke += U * Ee),
        (dt += U * qt),
        (st += U * Kt),
        (ce += U * Zt),
        (N += U * Lt),
        (Y += U * Ht),
        (ie += U * Vt),
        (ge += U * hr),
        (me += U * Qt),
        (qe += U * fr),
        (Pe += U * lr),
        (Xe += U * ur),
        (We += U * yr),
        (rt += U * Br),
        (ct += U * Cr),
        (ht += U * Tr),
        (U = V[6]),
        (dt += U * Ee),
        (st += U * qt),
        (ce += U * Kt),
        (N += U * Zt),
        (Y += U * Lt),
        (ie += U * Ht),
        (ge += U * Vt),
        (me += U * hr),
        (qe += U * Qt),
        (Pe += U * fr),
        (Xe += U * lr),
        (We += U * ur),
        (rt += U * yr),
        (ct += U * Br),
        (ht += U * Cr),
        (Fe += U * Tr),
        (U = V[7]),
        (st += U * Ee),
        (ce += U * qt),
        (N += U * Kt),
        (Y += U * Zt),
        (ie += U * Lt),
        (ge += U * Ht),
        (me += U * Vt),
        (qe += U * hr),
        (Pe += U * Qt),
        (Xe += U * fr),
        (We += U * lr),
        (rt += U * ur),
        (ct += U * yr),
        (ht += U * Br),
        (Fe += U * Cr),
        (ze += U * Tr),
        (U = V[8]),
        (ce += U * Ee),
        (N += U * qt),
        (Y += U * Kt),
        (ie += U * Zt),
        (ge += U * Lt),
        (me += U * Ht),
        (qe += U * Vt),
        (Pe += U * hr),
        (Xe += U * Qt),
        (We += U * fr),
        (rt += U * lr),
        (ct += U * ur),
        (ht += U * yr),
        (Fe += U * Br),
        (ze += U * Cr),
        (lt += U * Tr),
        (U = V[9]),
        (N += U * Ee),
        (Y += U * qt),
        (ie += U * Kt),
        (ge += U * Zt),
        (me += U * Lt),
        (qe += U * Ht),
        (Pe += U * Vt),
        (Xe += U * hr),
        (We += U * Qt),
        (rt += U * fr),
        (ct += U * lr),
        (ht += U * ur),
        (Fe += U * yr),
        (ze += U * Br),
        (lt += U * Cr),
        (nt += U * Tr),
        (U = V[10]),
        (Y += U * Ee),
        (ie += U * qt),
        (ge += U * Kt),
        (me += U * Zt),
        (qe += U * Lt),
        (Pe += U * Ht),
        (Xe += U * Vt),
        (We += U * hr),
        (rt += U * Qt),
        (ct += U * fr),
        (ht += U * lr),
        (Fe += U * ur),
        (ze += U * yr),
        (lt += U * Br),
        (nt += U * Cr),
        (ft += U * Tr),
        (U = V[11]),
        (ie += U * Ee),
        (ge += U * qt),
        (me += U * Kt),
        (qe += U * Zt),
        (Pe += U * Lt),
        (Xe += U * Ht),
        (We += U * Vt),
        (rt += U * hr),
        (ct += U * Qt),
        (ht += U * fr),
        (Fe += U * lr),
        (ze += U * ur),
        (lt += U * yr),
        (nt += U * Br),
        (ft += U * Cr),
        (vt += U * Tr),
        (U = V[12]),
        (ge += U * Ee),
        (me += U * qt),
        (qe += U * Kt),
        (Pe += U * Zt),
        (Xe += U * Lt),
        (We += U * Ht),
        (rt += U * Vt),
        (ct += U * hr),
        (ht += U * Qt),
        (Fe += U * fr),
        (ze += U * lr),
        (lt += U * ur),
        (nt += U * yr),
        (ft += U * Br),
        (vt += U * Cr),
        (Bt += U * Tr),
        (U = V[13]),
        (me += U * Ee),
        (qe += U * qt),
        (Pe += U * Kt),
        (Xe += U * Zt),
        (We += U * Lt),
        (rt += U * Ht),
        (ct += U * Vt),
        (ht += U * hr),
        (Fe += U * Qt),
        (ze += U * fr),
        (lt += U * lr),
        (nt += U * ur),
        (ft += U * yr),
        (vt += U * Br),
        (Bt += U * Cr),
        (Ot += U * Tr),
        (U = V[14]),
        (qe += U * Ee),
        (Pe += U * qt),
        (Xe += U * Kt),
        (We += U * Zt),
        (rt += U * Lt),
        (ct += U * Ht),
        (ht += U * Vt),
        (Fe += U * hr),
        (ze += U * Qt),
        (lt += U * fr),
        (nt += U * lr),
        (ft += U * ur),
        (vt += U * yr),
        (Bt += U * Br),
        (Ot += U * Cr),
        (Nt += U * Tr),
        (U = V[15]),
        (Pe += U * Ee),
        (Xe += U * qt),
        (We += U * Kt),
        (rt += U * Zt),
        (ct += U * Lt),
        (ht += U * Ht),
        (Fe += U * Vt),
        (ze += U * hr),
        (lt += U * Qt),
        (nt += U * fr),
        (ft += U * lr),
        (vt += U * ur),
        (Bt += U * yr),
        (Ot += U * Br),
        (Nt += U * Cr),
        (Ut += U * Tr),
        (re += 38 * Xe),
        (ye += 38 * We),
        (pe += 38 * rt),
        (xe += 38 * ct),
        (tt += 38 * ht),
        (Ke += 38 * Fe),
        (dt += 38 * ze),
        (st += 38 * lt),
        (ce += 38 * nt),
        (N += 38 * ft),
        (Y += 38 * vt),
        (ie += 38 * Bt),
        (ge += 38 * Ot),
        (me += 38 * Nt),
        (qe += 38 * Ut),
        (D = 1),
        (U = re + D + 65535),
        (D = Math.floor(U / 65536)),
        (re = U - D * 65536),
        (U = ye + D + 65535),
        (D = Math.floor(U / 65536)),
        (ye = U - D * 65536),
        (U = pe + D + 65535),
        (D = Math.floor(U / 65536)),
        (pe = U - D * 65536),
        (U = xe + D + 65535),
        (D = Math.floor(U / 65536)),
        (xe = U - D * 65536),
        (U = tt + D + 65535),
        (D = Math.floor(U / 65536)),
        (tt = U - D * 65536),
        (U = Ke + D + 65535),
        (D = Math.floor(U / 65536)),
        (Ke = U - D * 65536),
        (U = dt + D + 65535),
        (D = Math.floor(U / 65536)),
        (dt = U - D * 65536),
        (U = st + D + 65535),
        (D = Math.floor(U / 65536)),
        (st = U - D * 65536),
        (U = ce + D + 65535),
        (D = Math.floor(U / 65536)),
        (ce = U - D * 65536),
        (U = N + D + 65535),
        (D = Math.floor(U / 65536)),
        (N = U - D * 65536),
        (U = Y + D + 65535),
        (D = Math.floor(U / 65536)),
        (Y = U - D * 65536),
        (U = ie + D + 65535),
        (D = Math.floor(U / 65536)),
        (ie = U - D * 65536),
        (U = ge + D + 65535),
        (D = Math.floor(U / 65536)),
        (ge = U - D * 65536),
        (U = me + D + 65535),
        (D = Math.floor(U / 65536)),
        (me = U - D * 65536),
        (U = qe + D + 65535),
        (D = Math.floor(U / 65536)),
        (qe = U - D * 65536),
        (U = Pe + D + 65535),
        (D = Math.floor(U / 65536)),
        (Pe = U - D * 65536),
        (re += D - 1 + 37 * (D - 1)),
        (D = 1),
        (U = re + D + 65535),
        (D = Math.floor(U / 65536)),
        (re = U - D * 65536),
        (U = ye + D + 65535),
        (D = Math.floor(U / 65536)),
        (ye = U - D * 65536),
        (U = pe + D + 65535),
        (D = Math.floor(U / 65536)),
        (pe = U - D * 65536),
        (U = xe + D + 65535),
        (D = Math.floor(U / 65536)),
        (xe = U - D * 65536),
        (U = tt + D + 65535),
        (D = Math.floor(U / 65536)),
        (tt = U - D * 65536),
        (U = Ke + D + 65535),
        (D = Math.floor(U / 65536)),
        (Ke = U - D * 65536),
        (U = dt + D + 65535),
        (D = Math.floor(U / 65536)),
        (dt = U - D * 65536),
        (U = st + D + 65535),
        (D = Math.floor(U / 65536)),
        (st = U - D * 65536),
        (U = ce + D + 65535),
        (D = Math.floor(U / 65536)),
        (ce = U - D * 65536),
        (U = N + D + 65535),
        (D = Math.floor(U / 65536)),
        (N = U - D * 65536),
        (U = Y + D + 65535),
        (D = Math.floor(U / 65536)),
        (Y = U - D * 65536),
        (U = ie + D + 65535),
        (D = Math.floor(U / 65536)),
        (ie = U - D * 65536),
        (U = ge + D + 65535),
        (D = Math.floor(U / 65536)),
        (ge = U - D * 65536),
        (U = me + D + 65535),
        (D = Math.floor(U / 65536)),
        (me = U - D * 65536),
        (U = qe + D + 65535),
        (D = Math.floor(U / 65536)),
        (qe = U - D * 65536),
        (U = Pe + D + 65535),
        (D = Math.floor(U / 65536)),
        (Pe = U - D * 65536),
        (re += D - 1 + 37 * (D - 1)),
        (H[0] = re),
        (H[1] = ye),
        (H[2] = pe),
        (H[3] = xe),
        (H[4] = tt),
        (H[5] = Ke),
        (H[6] = dt),
        (H[7] = st),
        (H[8] = ce),
        (H[9] = N),
        (H[10] = Y),
        (H[11] = ie),
        (H[12] = ge),
        (H[13] = me),
        (H[14] = qe),
        (H[15] = Pe);
    }
    function G(H, V) {
      Q(H, V, V);
    }
    function q(H, V) {
      var W = n(),
        U;
      for (U = 0; U < 16; U++) W[U] = V[U];
      for (U = 253; U >= 0; U--) G(W, W), U !== 2 && U !== 4 && Q(W, W, V);
      for (U = 0; U < 16; U++) H[U] = W[U];
    }
    function Z(H, V) {
      var W = n(),
        U;
      for (U = 0; U < 16; U++) W[U] = V[U];
      for (U = 250; U >= 0; U--) G(W, W), U !== 1 && Q(W, W, V);
      for (U = 0; U < 16; U++) H[U] = W[U];
    }
    function te(H, V, W) {
      var U = new Uint8Array(32),
        D = new Float64Array(80),
        re,
        ye,
        pe = n(),
        xe = n(),
        tt = n(),
        Ke = n(),
        dt = n(),
        st = n();
      for (ye = 0; ye < 31; ye++) U[ye] = V[ye];
      for (U[31] = (V[31] & 127) | 64, U[0] &= 248, E(D, W), ye = 0; ye < 16; ye++)
        (xe[ye] = D[ye]), (Ke[ye] = pe[ye] = tt[ye] = 0);
      for (pe[0] = Ke[0] = 1, ye = 254; ye >= 0; --ye)
        (re = (U[ye >>> 3] >>> (ye & 7)) & 1),
          w(pe, xe, re),
          w(tt, Ke, re),
          R(dt, pe, tt),
          z(pe, pe, tt),
          R(tt, xe, Ke),
          z(xe, xe, Ke),
          G(Ke, dt),
          G(st, pe),
          Q(pe, tt, pe),
          Q(tt, xe, dt),
          R(dt, pe, tt),
          z(pe, pe, tt),
          G(xe, pe),
          z(tt, Ke, st),
          Q(pe, tt, g),
          R(pe, pe, Ke),
          Q(tt, tt, pe),
          Q(pe, Ke, st),
          Q(Ke, xe, D),
          G(xe, dt),
          w(pe, xe, re),
          w(tt, Ke, re);
      for (ye = 0; ye < 16; ye++)
        (D[ye + 16] = pe[ye]), (D[ye + 32] = tt[ye]), (D[ye + 48] = xe[ye]), (D[ye + 64] = Ke[ye]);
      var ce = D.subarray(32),
        N = D.subarray(16);
      return q(ce, ce), Q(N, N, ce), h(H, N), 0;
    }
    function ue(H, V) {
      return te(H, V, a);
    }
    function ae(H, V) {
      return i(V, 32), ue(H, V);
    }
    function K(H, V, W) {
      var U = new Uint8Array(32);
      return te(U, W, V), $(H, l, U, J);
    }
    var ve = f,
      Ye = u;
    function Ce(H, V, W, U, D, re) {
      var ye = new Uint8Array(32);
      return K(ye, D, re), ve(H, V, W, U, ye);
    }
    function Te(H, V, W, U, D, re) {
      var ye = new Uint8Array(32);
      return K(ye, D, re), Ye(H, V, W, U, ye);
    }
    var ut = [
      1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548,
      961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560,
      3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994,
      1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868,
      3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933,
      770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837,
      2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956,
      3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936,
      666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823,
      1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627,
      2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008,
      3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720,
      430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280,
      958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899,
      1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044,
      2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427,
      3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992,
      116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315,
      685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676,
      1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591,
    ];
    function Ie(H, V, W, U) {
      for (
        var D = new Int32Array(16),
          re = new Int32Array(16),
          ye,
          pe,
          xe,
          tt,
          Ke,
          dt,
          st,
          ce,
          N,
          Y,
          ie,
          ge,
          me,
          qe,
          Pe,
          Xe,
          We,
          rt,
          ct,
          ht,
          Fe,
          ze,
          lt,
          nt,
          ft,
          vt,
          Bt = H[0],
          Ot = H[1],
          Nt = H[2],
          Ut = H[3],
          Ee = H[4],
          qt = H[5],
          Kt = H[6],
          Zt = H[7],
          Lt = V[0],
          Ht = V[1],
          Vt = V[2],
          hr = V[3],
          Qt = V[4],
          fr = V[5],
          lr = V[6],
          ur = V[7],
          yr = 0;
        U >= 128;

      ) {
        for (ct = 0; ct < 16; ct++)
          (ht = 8 * ct + yr),
            (D[ct] = (W[ht + 0] << 24) | (W[ht + 1] << 16) | (W[ht + 2] << 8) | W[ht + 3]),
            (re[ct] = (W[ht + 4] << 24) | (W[ht + 5] << 16) | (W[ht + 6] << 8) | W[ht + 7]);
        for (ct = 0; ct < 80; ct++)
          if (
            ((ye = Bt),
            (pe = Ot),
            (xe = Nt),
            (tt = Ut),
            (Ke = Ee),
            (dt = qt),
            (st = Kt),
            (ce = Zt),
            (N = Lt),
            (Y = Ht),
            (ie = Vt),
            (ge = hr),
            (me = Qt),
            (qe = fr),
            (Pe = lr),
            (Xe = ur),
            (Fe = Zt),
            (ze = ur),
            (lt = ze & 65535),
            (nt = ze >>> 16),
            (ft = Fe & 65535),
            (vt = Fe >>> 16),
            (Fe =
              ((Ee >>> 14) | (Qt << 18)) ^ ((Ee >>> 18) | (Qt << 14)) ^ ((Qt >>> 9) | (Ee << 23))),
            (ze =
              ((Qt >>> 14) | (Ee << 18)) ^ ((Qt >>> 18) | (Ee << 14)) ^ ((Ee >>> 9) | (Qt << 23))),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (Fe = (Ee & qt) ^ (~Ee & Kt)),
            (ze = (Qt & fr) ^ (~Qt & lr)),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (Fe = ut[ct * 2]),
            (ze = ut[ct * 2 + 1]),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (Fe = D[ct % 16]),
            (ze = re[ct % 16]),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (nt += lt >>> 16),
            (ft += nt >>> 16),
            (vt += ft >>> 16),
            (We = (ft & 65535) | (vt << 16)),
            (rt = (lt & 65535) | (nt << 16)),
            (Fe = We),
            (ze = rt),
            (lt = ze & 65535),
            (nt = ze >>> 16),
            (ft = Fe & 65535),
            (vt = Fe >>> 16),
            (Fe =
              ((Bt >>> 28) | (Lt << 4)) ^ ((Lt >>> 2) | (Bt << 30)) ^ ((Lt >>> 7) | (Bt << 25))),
            (ze =
              ((Lt >>> 28) | (Bt << 4)) ^ ((Bt >>> 2) | (Lt << 30)) ^ ((Bt >>> 7) | (Lt << 25))),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (Fe = (Bt & Ot) ^ (Bt & Nt) ^ (Ot & Nt)),
            (ze = (Lt & Ht) ^ (Lt & Vt) ^ (Ht & Vt)),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (nt += lt >>> 16),
            (ft += nt >>> 16),
            (vt += ft >>> 16),
            (ce = (ft & 65535) | (vt << 16)),
            (Xe = (lt & 65535) | (nt << 16)),
            (Fe = tt),
            (ze = ge),
            (lt = ze & 65535),
            (nt = ze >>> 16),
            (ft = Fe & 65535),
            (vt = Fe >>> 16),
            (Fe = We),
            (ze = rt),
            (lt += ze & 65535),
            (nt += ze >>> 16),
            (ft += Fe & 65535),
            (vt += Fe >>> 16),
            (nt += lt >>> 16),
            (ft += nt >>> 16),
            (vt += ft >>> 16),
            (tt = (ft & 65535) | (vt << 16)),
            (ge = (lt & 65535) | (nt << 16)),
            (Ot = ye),
            (Nt = pe),
            (Ut = xe),
            (Ee = tt),
            (qt = Ke),
            (Kt = dt),
            (Zt = st),
            (Bt = ce),
            (Ht = N),
            (Vt = Y),
            (hr = ie),
            (Qt = ge),
            (fr = me),
            (lr = qe),
            (ur = Pe),
            (Lt = Xe),
            ct % 16 === 15)
          )
            for (ht = 0; ht < 16; ht++)
              (Fe = D[ht]),
                (ze = re[ht]),
                (lt = ze & 65535),
                (nt = ze >>> 16),
                (ft = Fe & 65535),
                (vt = Fe >>> 16),
                (Fe = D[(ht + 9) % 16]),
                (ze = re[(ht + 9) % 16]),
                (lt += ze & 65535),
                (nt += ze >>> 16),
                (ft += Fe & 65535),
                (vt += Fe >>> 16),
                (We = D[(ht + 1) % 16]),
                (rt = re[(ht + 1) % 16]),
                (Fe = ((We >>> 1) | (rt << 31)) ^ ((We >>> 8) | (rt << 24)) ^ (We >>> 7)),
                (ze =
                  ((rt >>> 1) | (We << 31)) ^
                  ((rt >>> 8) | (We << 24)) ^
                  ((rt >>> 7) | (We << 25))),
                (lt += ze & 65535),
                (nt += ze >>> 16),
                (ft += Fe & 65535),
                (vt += Fe >>> 16),
                (We = D[(ht + 14) % 16]),
                (rt = re[(ht + 14) % 16]),
                (Fe = ((We >>> 19) | (rt << 13)) ^ ((rt >>> 29) | (We << 3)) ^ (We >>> 6)),
                (ze =
                  ((rt >>> 19) | (We << 13)) ^
                  ((We >>> 29) | (rt << 3)) ^
                  ((rt >>> 6) | (We << 26))),
                (lt += ze & 65535),
                (nt += ze >>> 16),
                (ft += Fe & 65535),
                (vt += Fe >>> 16),
                (nt += lt >>> 16),
                (ft += nt >>> 16),
                (vt += ft >>> 16),
                (D[ht] = (ft & 65535) | (vt << 16)),
                (re[ht] = (lt & 65535) | (nt << 16));
        (Fe = Bt),
          (ze = Lt),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[0]),
          (ze = V[0]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[0] = Bt = (ft & 65535) | (vt << 16)),
          (V[0] = Lt = (lt & 65535) | (nt << 16)),
          (Fe = Ot),
          (ze = Ht),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[1]),
          (ze = V[1]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[1] = Ot = (ft & 65535) | (vt << 16)),
          (V[1] = Ht = (lt & 65535) | (nt << 16)),
          (Fe = Nt),
          (ze = Vt),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[2]),
          (ze = V[2]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[2] = Nt = (ft & 65535) | (vt << 16)),
          (V[2] = Vt = (lt & 65535) | (nt << 16)),
          (Fe = Ut),
          (ze = hr),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[3]),
          (ze = V[3]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[3] = Ut = (ft & 65535) | (vt << 16)),
          (V[3] = hr = (lt & 65535) | (nt << 16)),
          (Fe = Ee),
          (ze = Qt),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[4]),
          (ze = V[4]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[4] = Ee = (ft & 65535) | (vt << 16)),
          (V[4] = Qt = (lt & 65535) | (nt << 16)),
          (Fe = qt),
          (ze = fr),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[5]),
          (ze = V[5]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[5] = qt = (ft & 65535) | (vt << 16)),
          (V[5] = fr = (lt & 65535) | (nt << 16)),
          (Fe = Kt),
          (ze = lr),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[6]),
          (ze = V[6]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[6] = Kt = (ft & 65535) | (vt << 16)),
          (V[6] = lr = (lt & 65535) | (nt << 16)),
          (Fe = Zt),
          (ze = ur),
          (lt = ze & 65535),
          (nt = ze >>> 16),
          (ft = Fe & 65535),
          (vt = Fe >>> 16),
          (Fe = H[7]),
          (ze = V[7]),
          (lt += ze & 65535),
          (nt += ze >>> 16),
          (ft += Fe & 65535),
          (vt += Fe >>> 16),
          (nt += lt >>> 16),
          (ft += nt >>> 16),
          (vt += ft >>> 16),
          (H[7] = Zt = (ft & 65535) | (vt << 16)),
          (V[7] = ur = (lt & 65535) | (nt << 16)),
          (yr += 128),
          (U -= 128);
      }
      return U;
    }
    function be(H, V, W) {
      var U = new Int32Array(8),
        D = new Int32Array(8),
        re = new Uint8Array(256),
        ye,
        pe = W;
      for (
        U[0] = 1779033703,
          U[1] = 3144134277,
          U[2] = 1013904242,
          U[3] = 2773480762,
          U[4] = 1359893119,
          U[5] = 2600822924,
          U[6] = 528734635,
          U[7] = 1541459225,
          D[0] = 4089235720,
          D[1] = 2227873595,
          D[2] = 4271175723,
          D[3] = 1595750129,
          D[4] = 2917565137,
          D[5] = 725511199,
          D[6] = 4215389547,
          D[7] = 327033209,
          Ie(U, D, V, W),
          W %= 128,
          ye = 0;
        ye < W;
        ye++
      )
        re[ye] = V[pe - W + ye];
      for (
        re[W] = 128,
          W = 256 - 128 * (W < 112 ? 1 : 0),
          re[W - 9] = 0,
          A(re, W - 8, (pe / 536870912) | 0, pe << 3),
          Ie(U, D, re, W),
          ye = 0;
        ye < 8;
        ye++
      )
        A(H, 8 * ye, U[ye], D[ye]);
      return 0;
    }
    function wt(H, V) {
      var W = n(),
        U = n(),
        D = n(),
        re = n(),
        ye = n(),
        pe = n(),
        xe = n(),
        tt = n(),
        Ke = n();
      z(W, H[1], H[0]),
        z(Ke, V[1], V[0]),
        Q(W, W, Ke),
        R(U, H[0], H[1]),
        R(Ke, V[0], V[1]),
        Q(U, U, Ke),
        Q(D, H[3], V[3]),
        Q(D, D, p),
        Q(re, H[2], V[2]),
        R(re, re, re),
        z(ye, U, W),
        z(pe, re, D),
        R(xe, re, D),
        R(tt, U, W),
        Q(H[0], ye, pe),
        Q(H[1], tt, xe),
        Q(H[2], xe, pe),
        Q(H[3], ye, tt);
    }
    function Oe(H, V, W) {
      var U;
      for (U = 0; U < 4; U++) w(H[U], V[U], W);
    }
    function je(H, V) {
      var W = n(),
        U = n(),
        D = n();
      q(D, V[2]), Q(W, V[0], D), Q(U, V[1], D), h(H, U), (H[31] ^= m(W) << 7);
    }
    function xt(H, V, W) {
      var U, D;
      for (d(H[0], c), d(H[1], v), d(H[2], v), d(H[3], c), D = 255; D >= 0; --D)
        (U = (W[(D / 8) | 0] >> (D & 7)) & 1), Oe(H, V, U), wt(V, H), wt(H, H), Oe(H, V, U);
    }
    function Ue(H, V) {
      var W = [n(), n(), n(), n()];
      d(W[0], _), d(W[1], M), d(W[2], v), Q(W[3], _, M), xt(H, W, V);
    }
    function se(H, V, W) {
      var U = new Uint8Array(64),
        D = [n(), n(), n(), n()],
        re;
      for (
        W || i(V, 32),
          be(U, V, 32),
          U[0] &= 248,
          U[31] &= 127,
          U[31] |= 64,
          Ue(D, U),
          je(H, D),
          re = 0;
        re < 32;
        re++
      )
        V[re + 32] = H[re];
      return 0;
    }
    var oe = new Float64Array([
      237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 16,
    ]);
    function X(H, V) {
      var W, U, D, re;
      for (U = 63; U >= 32; --U) {
        for (W = 0, D = U - 32, re = U - 12; D < re; ++D)
          (V[D] += W - 16 * V[U] * oe[D - (U - 32)]),
            (W = Math.floor((V[D] + 128) / 256)),
            (V[D] -= W * 256);
        (V[D] += W), (V[U] = 0);
      }
      for (W = 0, D = 0; D < 32; D++)
        (V[D] += W - (V[31] >> 4) * oe[D]), (W = V[D] >> 8), (V[D] &= 255);
      for (D = 0; D < 32; D++) V[D] -= W * oe[D];
      for (U = 0; U < 32; U++) (V[U + 1] += V[U] >> 8), (H[U] = V[U] & 255);
    }
    function le(H) {
      var V = new Float64Array(64),
        W;
      for (W = 0; W < 64; W++) V[W] = H[W];
      for (W = 0; W < 64; W++) H[W] = 0;
      X(H, V);
    }
    function ke(H, V, W, U) {
      var D = new Uint8Array(64),
        re = new Uint8Array(64),
        ye = new Uint8Array(64),
        pe,
        xe,
        tt = new Float64Array(64),
        Ke = [n(), n(), n(), n()];
      be(D, U, 32), (D[0] &= 248), (D[31] &= 127), (D[31] |= 64);
      var dt = W + 64;
      for (pe = 0; pe < W; pe++) H[64 + pe] = V[pe];
      for (pe = 0; pe < 32; pe++) H[32 + pe] = D[32 + pe];
      for (be(ye, H.subarray(32), W + 32), le(ye), Ue(Ke, ye), je(H, Ke), pe = 32; pe < 64; pe++)
        H[pe] = U[pe];
      for (be(re, H, W + 64), le(re), pe = 0; pe < 64; pe++) tt[pe] = 0;
      for (pe = 0; pe < 32; pe++) tt[pe] = ye[pe];
      for (pe = 0; pe < 32; pe++) for (xe = 0; xe < 32; xe++) tt[pe + xe] += re[pe] * D[xe];
      return X(H.subarray(32), tt), dt;
    }
    function I(H, V) {
      var W = n(),
        U = n(),
        D = n(),
        re = n(),
        ye = n(),
        pe = n(),
        xe = n();
      return (
        d(H[2], v),
        E(H[1], V),
        G(D, H[1]),
        Q(re, D, b),
        z(D, D, H[2]),
        R(re, H[2], re),
        G(ye, re),
        G(pe, ye),
        Q(xe, pe, ye),
        Q(W, xe, D),
        Q(W, W, re),
        Z(W, W),
        Q(W, W, D),
        Q(W, W, re),
        Q(W, W, re),
        Q(H[0], W, re),
        G(U, H[0]),
        Q(U, U, re),
        s(U, D) && Q(H[0], H[0], S),
        G(U, H[0]),
        Q(U, U, re),
        s(U, D) ? -1 : (m(H[0]) === V[31] >> 7 && z(H[0], c, H[0]), Q(H[3], H[0], H[1]), 0)
      );
    }
    function C(H, V, W, U) {
      var D,
        re = new Uint8Array(32),
        ye = new Uint8Array(64),
        pe = [n(), n(), n(), n()],
        xe = [n(), n(), n(), n()];
      if (W < 64 || I(xe, U)) return -1;
      for (D = 0; D < W; D++) H[D] = V[D];
      for (D = 0; D < 32; D++) H[D + 32] = U[D];
      if (
        (be(ye, H, W),
        le(ye),
        xt(pe, xe, ye),
        Ue(xe, V.subarray(32)),
        wt(pe, xe),
        je(re, pe),
        (W -= 64),
        B(V, 0, re, 0))
      ) {
        for (D = 0; D < W; D++) H[D] = 0;
        return -1;
      }
      for (D = 0; D < W; D++) H[D] = V[D + 64];
      return W;
    }
    var L = 32,
      j = 24,
      ee = 32,
      Me = 16,
      fe = 32,
      Se = 32,
      ot = 32,
      we = 32,
      Re = 32,
      at = j,
      Ne = ee,
      He = Me,
      At = 64,
      Le = 32,
      Ze = 64,
      Tt = 32,
      Ve = 64;
    e.lowlevel = {
      crypto_core_hsalsa20: $,
      crypto_stream_xor: Ae,
      crypto_stream: ne,
      crypto_stream_salsa20_xor: he,
      crypto_stream_salsa20: de,
      crypto_onetimeauth: r,
      crypto_onetimeauth_verify: o,
      crypto_verify_16: P,
      crypto_verify_32: B,
      crypto_secretbox: f,
      crypto_secretbox_open: u,
      crypto_scalarmult: te,
      crypto_scalarmult_base: ue,
      crypto_box_beforenm: K,
      crypto_box_afternm: ve,
      crypto_box: Ce,
      crypto_box_open: Te,
      crypto_box_keypair: ae,
      crypto_hash: be,
      crypto_sign: ke,
      crypto_sign_keypair: se,
      crypto_sign_open: C,
      crypto_secretbox_KEYBYTES: L,
      crypto_secretbox_NONCEBYTES: j,
      crypto_secretbox_ZEROBYTES: ee,
      crypto_secretbox_BOXZEROBYTES: Me,
      crypto_scalarmult_BYTES: fe,
      crypto_scalarmult_SCALARBYTES: Se,
      crypto_box_PUBLICKEYBYTES: ot,
      crypto_box_SECRETKEYBYTES: we,
      crypto_box_BEFORENMBYTES: Re,
      crypto_box_NONCEBYTES: at,
      crypto_box_ZEROBYTES: Ne,
      crypto_box_BOXZEROBYTES: He,
      crypto_sign_BYTES: At,
      crypto_sign_PUBLICKEYBYTES: Le,
      crypto_sign_SECRETKEYBYTES: Ze,
      crypto_sign_SEEDBYTES: Tt,
      crypto_hash_BYTES: Ve,
      gf: n,
      D: b,
      L: oe,
      pack25519: h,
      unpack25519: E,
      M: Q,
      A: R,
      S: G,
      Z: z,
      pow2523: Z,
      add: wt,
      set25519: d,
      modL: X,
      scalarmult: xt,
      scalarbase: Ue,
    };
    function Je(H, V) {
      if (H.length !== L) throw new Error("bad key size");
      if (V.length !== j) throw new Error("bad nonce size");
    }
    function Rt(H, V) {
      if (H.length !== ot) throw new Error("bad public key size");
      if (V.length !== we) throw new Error("bad secret key size");
    }
    function $e() {
      for (var H = 0; H < arguments.length; H++)
        if (!(arguments[H] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function et(H) {
      for (var V = 0; V < H.length; V++) H[V] = 0;
    }
    (e.randomBytes = function (H) {
      var V = new Uint8Array(H);
      return i(V, H), V;
    }),
      (e.secretbox = function (H, V, W) {
        $e(H, V, W), Je(W, V);
        for (
          var U = new Uint8Array(ee + H.length), D = new Uint8Array(U.length), re = 0;
          re < H.length;
          re++
        )
          U[re + ee] = H[re];
        return f(D, U, U.length, V, W), D.subarray(Me);
      }),
      (e.secretbox.open = function (H, V, W) {
        $e(H, V, W), Je(W, V);
        for (
          var U = new Uint8Array(Me + H.length), D = new Uint8Array(U.length), re = 0;
          re < H.length;
          re++
        )
          U[re + Me] = H[re];
        return U.length < 32 || u(D, U, U.length, V, W) !== 0 ? null : D.subarray(ee);
      }),
      (e.secretbox.keyLength = L),
      (e.secretbox.nonceLength = j),
      (e.secretbox.overheadLength = Me),
      (e.scalarMult = function (H, V) {
        if (($e(H, V), H.length !== Se)) throw new Error("bad n size");
        if (V.length !== fe) throw new Error("bad p size");
        var W = new Uint8Array(fe);
        return te(W, H, V), W;
      }),
      (e.scalarMult.base = function (H) {
        if (($e(H), H.length !== Se)) throw new Error("bad n size");
        var V = new Uint8Array(fe);
        return ue(V, H), V;
      }),
      (e.scalarMult.scalarLength = Se),
      (e.scalarMult.groupElementLength = fe),
      (e.box = function (H, V, W, U) {
        var D = e.box.before(W, U);
        return e.secretbox(H, V, D);
      }),
      (e.box.before = function (H, V) {
        $e(H, V), Rt(H, V);
        var W = new Uint8Array(Re);
        return K(W, H, V), W;
      }),
      (e.box.after = e.secretbox),
      (e.box.open = function (H, V, W, U) {
        var D = e.box.before(W, U);
        return e.secretbox.open(H, V, D);
      }),
      (e.box.open.after = e.secretbox.open),
      (e.box.keyPair = function () {
        var H = new Uint8Array(ot),
          V = new Uint8Array(we);
        return ae(H, V), { publicKey: H, secretKey: V };
      }),
      (e.box.keyPair.fromSecretKey = function (H) {
        if (($e(H), H.length !== we)) throw new Error("bad secret key size");
        var V = new Uint8Array(ot);
        return ue(V, H), { publicKey: V, secretKey: new Uint8Array(H) };
      }),
      (e.box.publicKeyLength = ot),
      (e.box.secretKeyLength = we),
      (e.box.sharedKeyLength = Re),
      (e.box.nonceLength = at),
      (e.box.overheadLength = e.secretbox.overheadLength),
      (e.sign = function (H, V) {
        if (($e(H, V), V.length !== Ze)) throw new Error("bad secret key size");
        var W = new Uint8Array(At + H.length);
        return ke(W, H, H.length, V), W;
      }),
      (e.sign.open = function (H, V) {
        if (($e(H, V), V.length !== Le)) throw new Error("bad public key size");
        var W = new Uint8Array(H.length),
          U = C(W, H, H.length, V);
        if (U < 0) return null;
        for (var D = new Uint8Array(U), re = 0; re < D.length; re++) D[re] = W[re];
        return D;
      }),
      (e.sign.detached = function (H, V) {
        for (var W = e.sign(H, V), U = new Uint8Array(At), D = 0; D < U.length; D++) U[D] = W[D];
        return U;
      }),
      (e.sign.detached.verify = function (H, V, W) {
        if (($e(H, V, W), V.length !== At)) throw new Error("bad signature size");
        if (W.length !== Le) throw new Error("bad public key size");
        var U = new Uint8Array(At + H.length),
          D = new Uint8Array(At + H.length),
          re;
        for (re = 0; re < At; re++) U[re] = V[re];
        for (re = 0; re < H.length; re++) U[re + At] = H[re];
        return C(D, U, U.length, W) >= 0;
      }),
      (e.sign.keyPair = function () {
        var H = new Uint8Array(Le),
          V = new Uint8Array(Ze);
        return se(H, V), { publicKey: H, secretKey: V };
      }),
      (e.sign.keyPair.fromSecretKey = function (H) {
        if (($e(H), H.length !== Ze)) throw new Error("bad secret key size");
        for (var V = new Uint8Array(Le), W = 0; W < V.length; W++) V[W] = H[32 + W];
        return { publicKey: V, secretKey: new Uint8Array(H) };
      }),
      (e.sign.keyPair.fromSeed = function (H) {
        if (($e(H), H.length !== Tt)) throw new Error("bad seed size");
        for (var V = new Uint8Array(Le), W = new Uint8Array(Ze), U = 0; U < 32; U++) W[U] = H[U];
        return se(V, W, !0), { publicKey: V, secretKey: W };
      }),
      (e.sign.publicKeyLength = Le),
      (e.sign.secretKeyLength = Ze),
      (e.sign.seedLength = Tt),
      (e.sign.signatureLength = At),
      (e.hash = function (H) {
        $e(H);
        var V = new Uint8Array(Ve);
        return be(V, H, H.length), V;
      }),
      (e.hash.hashLength = Ve),
      (e.verify = function (H, V) {
        return (
          $e(H, V),
          H.length === 0 || V.length === 0 || H.length !== V.length
            ? !1
            : k(H, 0, V, 0, H.length) === 0
        );
      }),
      (e.setPRNG = function (H) {
        i = H;
      }),
      (function () {
        var H = typeof self < "u" ? self.crypto || self.msCrypto : null;
        if (H && H.getRandomValues) {
          var V = 65536;
          e.setPRNG(function (W, U) {
            var D,
              re = new Uint8Array(U);
            for (D = 0; D < U; D += V) H.getRandomValues(re.subarray(D, D + Math.min(U - D, V)));
            for (D = 0; D < U; D++) W[D] = re[D];
            et(re);
          });
        } else
          typeof bM < "u" &&
            ((H = Ww()),
            H &&
              H.randomBytes &&
              e.setPRNG(function (W, U) {
                var D,
                  re = H.randomBytes(U);
                for (D = 0; D < U; D++) W[D] = re[D];
                et(re);
              }));
      })();
  })(t.exports ? t.exports : (self.nacl = self.nacl || {}));
})(G6);
var Kw = G6.exports,
  Yi = {};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.bitsToBytes = Yi.bytesToBits = Yi.lpad = void 0;
function Zw(t, e, n) {
  for (; t.length < n; ) t = e + t;
  return t;
}
Yi.lpad = Zw;
function Z7(t) {
  let e = "";
  for (let n = 0; n < t.length; n++) {
    let i = t.at(n);
    e += Zw(i.toString(2), "0", 8);
  }
  return e;
}
Yi.bytesToBits = Z7;
function G7(t) {
  if (t.length % 8 !== 0) throw Error("Uneven bits");
  let e = [];
  for (; t.length > 0; ) e.push(parseInt(t.slice(0, 8), 2)), (t = t.slice(8));
  return Qe.from(e);
}
Yi.bitsToBytes = G7;
var Pf = {};
Object.defineProperty(Pf, "__esModule", { value: !0 });
Pf.wordlist = void 0;
const Y7 = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo",
];
Pf.wordlist = Y7;
var J7 =
  (mt && mt.__importDefault) ||
  function (t) {
    return t && t.__esModule ? t : { default: t };
  };
Object.defineProperty(ar, "__esModule", { value: !0 });
ar.mnemonicFromRandomSeed =
  ar.mnemonicIndexesToBytes =
  ar.bytesToMnemonics =
  ar.bytesToMnemonicIndexes =
  ar.mnemonicNew =
  ar.mnemonicValidate =
  ar.mnemonicToHDSeed =
  ar.mnemonicToWalletKey =
  ar.mnemonicToPrivateKey =
  ar.mnemonicToSeed =
  ar.mnemonicToEntropy =
    void 0;
const Gw = J7(Kw),
  Q7 = Zn,
  X7 = Qn,
  Lu = Mf,
  mp = Yi,
  Gl = Pf,
  N1 = 1e5;
async function Yw(t) {
  const e = await Rf(t);
  return (await eS(e)) && !(await L1(e));
}
function D1(t) {
  return t.map((e) => e.toLowerCase().trim());
}
async function L1(t) {
  return (
    (
      await (0, Lu.pbkdf2_sha512)(t, "TON seed version", Math.max(1, Math.floor(N1 / 256)), 64)
    )[0] == 0
  );
}
async function eS(t) {
  return (await (0, Lu.pbkdf2_sha512)(t, "TON fast seed version", 1, 64))[0] == 1;
}
async function Rf(t, e) {
  return await (0, X7.hmac_sha512)(t.join(" "), e && e.length > 0 ? e : "");
}
ar.mnemonicToEntropy = Rf;
async function F1(t, e, n) {
  const i = await Rf(t, n);
  return await (0, Lu.pbkdf2_sha512)(i, e, N1, 64);
}
ar.mnemonicToSeed = F1;
async function Jw(t, e) {
  t = D1(t);
  const n = await F1(t, "TON default seed", e);
  let i = Gw.default.sign.keyPair.fromSeed(n.slice(0, 32));
  return {
    publicKey: Qe.from(i.publicKey),
    secretKey: Qe.from(i.secretKey),
  };
}
ar.mnemonicToPrivateKey = Jw;
async function tS(t, e) {
  let i = (await Jw(t, e)).secretKey.slice(0, 32);
  const l = Gw.default.sign.keyPair.fromSeed(i);
  return {
    publicKey: Qe.from(l.publicKey),
    secretKey: Qe.from(l.secretKey),
  };
}
ar.mnemonicToWalletKey = tS;
async function rS(t, e) {
  return (t = D1(t)), await F1(t, "TON HD Keys seed", e);
}
ar.mnemonicToHDSeed = rS;
async function Qw(t, e) {
  t = D1(t);
  for (let n of t) if (Gl.wordlist.indexOf(n) < 0) return !1;
  return e && e.length > 0 && !(await Yw(t)) ? !1 : await L1(await Rf(t, e));
}
ar.mnemonicValidate = Qw;
async function nS(t = 24, e) {
  let n = [];
  for (;;) {
    n = [];
    for (let i = 0; i < t; i++) {
      let l = await (0, Q7.getSecureRandomNumber)(0, Gl.wordlist.length);
      n.push(Gl.wordlist[l]);
    }
    if (!(e && e.length > 0 && !(await Yw(n))) && (await L1(await Rf(n, e)))) break;
  }
  return n;
}
ar.mnemonicNew = nS;
function Xw(t, e) {
  let n = (0, mp.bytesToBits)(t),
    i = [];
  for (let l = 0; l < e; l++) {
    let a = n.slice(l * 11, l * 11 + 11);
    i.push(parseInt(a, 2));
  }
  return i;
}
ar.bytesToMnemonicIndexes = Xw;
function e3(t, e) {
  let n = Xw(t, e),
    i = [];
  for (let l of n) i.push(Gl.wordlist[l]);
  return i;
}
ar.bytesToMnemonics = e3;
function iS(t) {
  let e = "";
  for (let n of t) {
    if (!Number.isSafeInteger(n) || n < 0 || n >= 2028) throw Error("Invalid input");
    e += (0, mp.lpad)(n.toString(2), "0", 11);
  }
  for (; e.length % 8 !== 0; ) e = e + "0";
  return (0, mp.bitsToBytes)(e);
}
ar.mnemonicIndexesToBytes = iS;
async function aS(t, e = 24, n) {
  const i = Math.ceil((e * 11) / 8);
  let l = t;
  for (;;) {
    let a = await (0, Lu.pbkdf2_sha512)(
        l,
        "TON mnemonic seed",
        Math.max(1, Math.floor(N1 / 256)),
        i
      ),
      c = e3(a, e);
    if (await Qw(c, n)) return c;
    l = a;
  }
}
ar.mnemonicFromRandomSeed = aS;
var jr = {},
  sS =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    };
Object.defineProperty(jr, "__esModule", { value: !0 });
jr.openBox =
  jr.sealBox =
  jr.signVerify =
  jr.sign =
  jr.keyPairFromSeed =
  jr.keyPairFromSecretKey =
    void 0;
const lo = sS(Kw);
function oS(t) {
  let e = lo.default.sign.keyPair.fromSecretKey(new Uint8Array(t));
  return {
    publicKey: Qe.from(e.publicKey),
    secretKey: Qe.from(e.secretKey),
  };
}
jr.keyPairFromSecretKey = oS;
function fS(t) {
  let e = lo.default.sign.keyPair.fromSeed(new Uint8Array(t));
  return {
    publicKey: Qe.from(e.publicKey),
    secretKey: Qe.from(e.secretKey),
  };
}
jr.keyPairFromSeed = fS;
function lS(t, e) {
  return Qe.from(lo.default.sign.detached(new Uint8Array(t), new Uint8Array(e)));
}
jr.sign = lS;
function uS(t, e, n) {
  return lo.default.sign.detached.verify(new Uint8Array(t), new Uint8Array(e), new Uint8Array(n));
}
jr.signVerify = uS;
function cS(t, e, n) {
  return Qe.from(lo.default.secretbox(t, e, n));
}
jr.sealBox = cS;
function hS(t, e, n) {
  let i = lo.default.secretbox.open(t, e, n);
  return i ? Qe.from(i) : null;
}
jr.openBox = hS;
var Ji = {};
Object.defineProperty(Ji, "__esModule", { value: !0 });
Ji.deriveEd25519Path = Ji.deriveED25519HardenedKey = Ji.getED25519MasterKeyFromSeed = void 0;
const t3 = Qn,
  dS = "ed25519 seed",
  $b = 2147483648;
async function r3(t) {
  const e = await (0, t3.hmac_sha512)(dS, t),
    n = e.slice(0, 32),
    i = e.slice(32);
  return {
    key: n,
    chainCode: i,
  };
}
Ji.getED25519MasterKeyFromSeed = r3;
async function n3(t, e) {
  if (e >= $b) throw Error("Key index must be less than offset");
  const n = Qe.alloc(4);
  n.writeUInt32BE(e + $b, 0);
  const i = Qe.concat([Qe.alloc(1, 0), t.key, n]),
    l = await (0, t3.hmac_sha512)(t.chainCode, i),
    a = l.slice(0, 32),
    c = l.slice(32);
  return {
    key: a,
    chainCode: c,
  };
}
Ji.deriveED25519HardenedKey = n3;
async function pS(t, e) {
  let n = await r3(t),
    i = [...e];
  for (; i.length > 0; ) {
    let l = i[0];
    (i = i.slice(1)), (n = await n3(n, l));
  }
  return n.key;
}
Ji.deriveEd25519Path = pS;
var Qi = {};
Object.defineProperty(Qi, "__esModule", { value: !0 });
Qi.deriveSymmetricPath = Qi.deriveSymmetricHardenedKey = Qi.getSymmetricMasterKeyFromSeed = void 0;
const i3 = Qn,
  mS = "Symmetric key seed";
async function a3(t) {
  const e = await (0, i3.hmac_sha512)(mS, t),
    n = e.slice(32),
    i = e.slice(0, 32);
  return {
    key: n,
    chainCode: i,
  };
}
Qi.getSymmetricMasterKeyFromSeed = a3;
async function s3(t, e) {
  const n = Qe.concat([Qe.alloc(1, 0), Qe.from(e)]),
    i = await (0, i3.hmac_sha512)(t.chainCode, n),
    l = i.slice(32),
    a = i.slice(0, 32);
  return {
    key: l,
    chainCode: a,
  };
}
Qi.deriveSymmetricHardenedKey = s3;
async function vS(t, e) {
  let n = await a3(t),
    i = [...e];
  for (; i.length > 0; ) {
    let l = i[0];
    (i = i.slice(1)), (n = await s3(n, l));
  }
  return n.key;
}
Qi.deriveSymmetricPath = vS;
var Xi = {};
Object.defineProperty(Xi, "__esModule", { value: !0 });
Xi.deriveMnemonicsPath = Xi.deriveMnemonicHardenedKey = Xi.getMnemonicsMasterKeyFromSeed = void 0;
const gS = ar,
  o3 = Qn,
  Hb = 2147483648,
  yS = "TON Mnemonics HD seed";
async function f3(t) {
  const e = await (0, o3.hmac_sha512)(yS, t),
    n = e.slice(0, 32),
    i = e.slice(32);
  return {
    key: n,
    chainCode: i,
  };
}
Xi.getMnemonicsMasterKeyFromSeed = f3;
async function l3(t, e) {
  if (e >= Hb) throw Error("Key index must be less than offset");
  const n = Qe.alloc(4);
  n.writeUInt32BE(e + Hb, 0);
  const i = Qe.concat([Qe.alloc(1, 0), t.key, n]),
    l = await (0, o3.hmac_sha512)(t.chainCode, i),
    a = l.slice(0, 32),
    c = l.slice(32);
  return {
    key: a,
    chainCode: c,
  };
}
Xi.deriveMnemonicHardenedKey = l3;
async function bS(t, e, n = 24, i) {
  let l = await f3(t),
    a = [...e];
  for (; a.length > 0; ) {
    let c = a[0];
    (a = a.slice(1)), (l = await l3(l, c));
  }
  return await (0, gS.mnemonicFromRandomSeed)(l.key, n, i);
}
Xi.deriveMnemonicsPath = bS;
var Vb;
function ss() {
  return (
    Vb ||
      ((Vb = 1),
      (function (t) {
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.getMnemonicsMasterKeyFromSeed =
            t.deriveMnemonicHardenedKey =
            t.deriveMnemonicsPath =
            t.deriveSymmetricPath =
            t.deriveSymmetricHardenedKey =
            t.getSymmetricMasterKeyFromSeed =
            t.deriveEd25519Path =
            t.deriveED25519HardenedKey =
            t.getED25519MasterKeyFromSeed =
            t.signVerify =
            t.sign =
            t.keyPairFromSecretKey =
            t.keyPairFromSeed =
            t.openBox =
            t.sealBox =
            t.mnemonicWordList =
            t.mnemonicToHDSeed =
            t.mnemonicToSeed =
            t.mnemonicToWalletKey =
            t.mnemonicToPrivateKey =
            t.mnemonicValidate =
            t.mnemonicNew =
            t.newSecurePassphrase =
            t.newSecureWords =
            t.getSecureRandomNumber =
            t.getSecureRandomWords =
            t.getSecureRandomBytes =
            t.hmac_sha512 =
            t.pbkdf2_sha512 =
            t.sha512_sync =
            t.sha512 =
            t.sha256_sync =
            t.sha256 =
              void 0);
        var e = Zi;
        Object.defineProperty(t, "sha256", {
          enumerable: !0,
          get: function () {
            return e.sha256;
          },
        }),
          Object.defineProperty(t, "sha256_sync", {
            enumerable: !0,
            get: function () {
              return e.sha256_sync;
            },
          });
        var n = Gi;
        Object.defineProperty(t, "sha512", {
          enumerable: !0,
          get: function () {
            return n.sha512;
          },
        }),
          Object.defineProperty(t, "sha512_sync", {
            enumerable: !0,
            get: function () {
              return n.sha512_sync;
            },
          });
        var i = Mf;
        Object.defineProperty(t, "pbkdf2_sha512", {
          enumerable: !0,
          get: function () {
            return i.pbkdf2_sha512;
          },
        });
        var l = Qn;
        Object.defineProperty(t, "hmac_sha512", {
          enumerable: !0,
          get: function () {
            return l.hmac_sha512;
          },
        });
        var a = Zn;
        Object.defineProperty(t, "getSecureRandomBytes", {
          enumerable: !0,
          get: function () {
            return a.getSecureRandomBytes;
          },
        }),
          Object.defineProperty(t, "getSecureRandomWords", {
            enumerable: !0,
            get: function () {
              return a.getSecureRandomWords;
            },
          }),
          Object.defineProperty(t, "getSecureRandomNumber", {
            enumerable: !0,
            get: function () {
              return a.getSecureRandomNumber;
            },
          });
        var c = Cu;
        Object.defineProperty(t, "newSecureWords", {
          enumerable: !0,
          get: function () {
            return c.newSecureWords;
          },
        });
        var v = yM();
        Object.defineProperty(t, "newSecurePassphrase", {
          enumerable: !0,
          get: function () {
            return v.newSecurePassphrase;
          },
        });
        var g = ar;
        Object.defineProperty(t, "mnemonicNew", {
          enumerable: !0,
          get: function () {
            return g.mnemonicNew;
          },
        }),
          Object.defineProperty(t, "mnemonicValidate", {
            enumerable: !0,
            get: function () {
              return g.mnemonicValidate;
            },
          }),
          Object.defineProperty(t, "mnemonicToPrivateKey", {
            enumerable: !0,
            get: function () {
              return g.mnemonicToPrivateKey;
            },
          }),
          Object.defineProperty(t, "mnemonicToWalletKey", {
            enumerable: !0,
            get: function () {
              return g.mnemonicToWalletKey;
            },
          }),
          Object.defineProperty(t, "mnemonicToSeed", {
            enumerable: !0,
            get: function () {
              return g.mnemonicToSeed;
            },
          }),
          Object.defineProperty(t, "mnemonicToHDSeed", {
            enumerable: !0,
            get: function () {
              return g.mnemonicToHDSeed;
            },
          });
        var b = Pf;
        Object.defineProperty(t, "mnemonicWordList", {
          enumerable: !0,
          get: function () {
            return b.wordlist;
          },
        });
        var p = jr;
        Object.defineProperty(t, "sealBox", {
          enumerable: !0,
          get: function () {
            return p.sealBox;
          },
        }),
          Object.defineProperty(t, "openBox", {
            enumerable: !0,
            get: function () {
              return p.openBox;
            },
          });
        var _ = jr;
        Object.defineProperty(t, "keyPairFromSeed", {
          enumerable: !0,
          get: function () {
            return _.keyPairFromSeed;
          },
        }),
          Object.defineProperty(t, "keyPairFromSecretKey", {
            enumerable: !0,
            get: function () {
              return _.keyPairFromSecretKey;
            },
          }),
          Object.defineProperty(t, "sign", {
            enumerable: !0,
            get: function () {
              return _.sign;
            },
          }),
          Object.defineProperty(t, "signVerify", {
            enumerable: !0,
            get: function () {
              return _.signVerify;
            },
          });
        var M = Ji;
        Object.defineProperty(t, "getED25519MasterKeyFromSeed", {
          enumerable: !0,
          get: function () {
            return M.getED25519MasterKeyFromSeed;
          },
        }),
          Object.defineProperty(t, "deriveED25519HardenedKey", {
            enumerable: !0,
            get: function () {
              return M.deriveED25519HardenedKey;
            },
          }),
          Object.defineProperty(t, "deriveEd25519Path", {
            enumerable: !0,
            get: function () {
              return M.deriveEd25519Path;
            },
          });
        var S = Qi;
        Object.defineProperty(t, "getSymmetricMasterKeyFromSeed", {
          enumerable: !0,
          get: function () {
            return S.getSymmetricMasterKeyFromSeed;
          },
        }),
          Object.defineProperty(t, "deriveSymmetricHardenedKey", {
            enumerable: !0,
            get: function () {
              return S.deriveSymmetricHardenedKey;
            },
          }),
          Object.defineProperty(t, "deriveSymmetricPath", {
            enumerable: !0,
            get: function () {
              return S.deriveSymmetricPath;
            },
          });
        var A = Xi;
        Object.defineProperty(t, "deriveMnemonicsPath", {
          enumerable: !0,
          get: function () {
            return A.deriveMnemonicsPath;
          },
        }),
          Object.defineProperty(t, "deriveMnemonicHardenedKey", {
            enumerable: !0,
            get: function () {
              return A.deriveMnemonicHardenedKey;
            },
          }),
          Object.defineProperty(t, "getMnemonicsMasterKeyFromSeed", {
            enumerable: !0,
            get: function () {
              return A.getMnemonicsMasterKeyFromSeed;
            },
          });
      })(Nc)),
    Nc
  );
}
Object.defineProperty(Su, "__esModule", { value: !0 });
Su.wonderCalculator = void 0;
const wS = oa(),
  Dn = eo,
  Mo = io,
  _S = no,
  xS = to,
  MS = wi,
  SS = ss(),
  ES = ro,
  AS = xf;
function kS(t, e, n) {
  let i,
    l = null;
  if (t === Dn.CellType.Ordinary) {
    let M = 0;
    for (let S of n) M = M | S.mask.value;
    i = new Mo.LevelMask(M);
  } else if (t === Dn.CellType.PrunedBranch)
    (l = (0, _S.exoticPruned)(e, n)), (i = new Mo.LevelMask(l.mask));
  else if (t === Dn.CellType.MerkleProof)
    (0, xS.exoticMerkleProof)(e, n), (i = new Mo.LevelMask(n[0].mask.value >> 1));
  else if (t === Dn.CellType.MerkleUpdate)
    (0, ES.exoticMerkleUpdate)(e, n),
      (i = new Mo.LevelMask((n[0].mask.value | n[1].mask.value) >> 1));
  else if (t === Dn.CellType.Library) (0, AS.exoticLibrary)(e, n), (i = new Mo.LevelMask());
  else throw new Error("Unsupported exotic type");
  let a = [],
    c = [],
    v = t === Dn.CellType.PrunedBranch ? 1 : i.hashCount,
    b = i.hashCount - v;
  for (let M = 0, S = 0; M <= i.level; M++) {
    if (!i.isSignificant(M)) continue;
    if (S < b) {
      S++;
      continue;
    }
    let A;
    if (S === b) {
      if (!(M === 0 || t === Dn.CellType.PrunedBranch)) throw Error("Invalid");
      A = e;
    } else {
      if (!(M !== 0 && t !== Dn.CellType.PrunedBranch)) throw Error("Invalid: " + M + ", " + t);
      A = new wS.BitString(c[S - b - 1], 0, 256);
    }
    let k = 0;
    for (let F of n) {
      let O;
      t == Dn.CellType.MerkleProof || t == Dn.CellType.MerkleUpdate
        ? (O = F.depth(M + 1))
        : (O = F.depth(M)),
        (k = Math.max(k, O));
    }
    n.length > 0 && k++;
    let P = (0, MS.getRepr)(e, A, n, M, i.apply(M).value, t),
      B = (0, SS.sha256_sync)(P),
      T = S - b;
    (a[T] = k), (c[T] = B), S++;
  }
  let p = [],
    _ = [];
  if (l)
    for (let M = 0; M < 4; M++) {
      const { hashIndex: S } = i.apply(M),
        { hashIndex: A } = i;
      S !== A
        ? (p.push(l.pruned[S].hash), _.push(l.pruned[S].depth))
        : (p.push(c[0]), _.push(a[0]));
    }
  else for (let M = 0; M < 4; M++) p.push(c[i.apply(M).hashIndex]), _.push(a[i.apply(M).hashIndex]);
  return {
    mask: i,
    hashes: p,
    depths: _,
  };
}
Su.wonderCalculator = kS;
var li = {},
  Fu = {};
Object.defineProperty(Fu, "__esModule", { value: !0 });
Fu.topologicalSort = void 0;
function BS(t) {
  let e = [t],
    n = /* @__PURE__ */ new Map(),
    i = /* @__PURE__ */ new Set(),
    l = [];
  for (; e.length > 0; ) {
    const b = [...e];
    e = [];
    for (let p of b) {
      const _ = p.hash().toString("hex");
      if (!n.has(_)) {
        i.add(_), n.set(_, { cell: p, refs: p.refs.map((M) => M.hash().toString("hex")) });
        for (let M of p.refs) e.push(M);
      }
    }
  }
  let a = /* @__PURE__ */ new Set();
  function c(b) {
    if (!i.has(b)) return;
    if (a.has(b)) throw Error("Not a DAG");
    a.add(b);
    let p = n.get(b).refs;
    for (let _ = p.length - 1; _ >= 0; _--) c(p[_]);
    l.push(b), a.delete(b), i.delete(b);
  }
  for (; i.size > 0; ) {
    const b = Array.from(i)[0];
    c(b);
  }
  let v = /* @__PURE__ */ new Map();
  for (let b = 0; b < l.length; b++) v.set(l[l.length - b - 1], b);
  let g = [];
  for (let b = l.length - 1; b >= 0; b--) {
    let p = l[b];
    const _ = n.get(p);
    g.push({ cell: _.cell, refs: _.refs.map((M) => v.get(M)) });
  }
  return g;
}
Fu.topologicalSort = BS;
var qu = {};
Object.defineProperty(qu, "__esModule", { value: !0 });
qu.bitsForNumber = void 0;
function CS(t, e) {
  let n = BigInt(t);
  if (e === "int") return n === 0n || n === -1n ? 1 : (n > 0 ? n : -n).toString(2).length + 1;
  if (e === "uint") {
    if (n < 0) throw Error(`value is negative. Got ${t}`);
    return n.toString(2).length;
  } else throw Error(`invalid mode. Got ${e}`);
}
qu.bitsForNumber = CS;
var If = {};
Object.defineProperty(If, "__esModule", { value: !0 });
If.crc32c = void 0;
const Ti = 2197175160;
function TS(t) {
  let e = -1;
  for (let i = 0; i < t.length; i++)
    (e ^= t[i]),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1),
      (e = e & 1 ? (e >>> 1) ^ Ti : e >>> 1);
  e = e ^ 4294967295;
  let n = Qe.alloc(4);
  return n.writeInt32LE(e), n;
}
If.crc32c = TS;
var Wb;
function PS() {
  if (Wb) return li;
  (Wb = 1),
    Object.defineProperty(li, "__esModule", { value: !0 }),
    (li.serializeBoc = li.deserializeBoc = li.parseBoc = void 0);
  const t = On,
    e = oa(),
    n = os(),
    i = Fu,
    l = qu,
    a = gu(),
    c = wi,
    v = vu(),
    g = If;
  function b(B) {
    return p(B & 7);
  }
  function p(B) {
    let T = 0;
    for (let F = 0; F < 3; F++) (T += B & 1), (B = B >> 1);
    return T + 1;
  }
  function _(B, T) {
    const F = B.loadUint(8),
      O = F % 8,
      $ = !!(F & 8),
      J = B.loadUint(8),
      he = Math.ceil(J / 2),
      de = !!(J % 2),
      ne = F >> 5,
      Ae = (F & 16) != 0,
      r = Ae ? b(ne) * 32 : 0,
      o = Ae ? b(ne) * 2 : 0;
    B.skip(r * 8), B.skip(o * 8);
    let f = e.BitString.EMPTY;
    he > 0 && (de ? (f = B.loadPaddedBits(he * 8)) : (f = B.loadBits(he * 8)));
    let u = [];
    for (let d = 0; d < O; d++) u.push(B.loadUint(T * 8));
    return {
      bits: f,
      refs: u,
      exotic: $,
    };
  }
  function M(B, T) {
    return 2 + Math.ceil(B.bits.length / 8) + B.refs.length * T;
  }
  function S(B) {
    let T = new t.BitReader(new e.BitString(B, 0, B.length * 8)),
      F = T.loadUint(32);
    if (F === 1761568243) {
      let O = T.loadUint(8),
        $ = T.loadUint(8),
        J = T.loadUint(O * 8),
        he = T.loadUint(O * 8),
        de = T.loadUint(O * 8),
        ne = T.loadUint($ * 8),
        Ae = T.loadBuffer(J * $),
        x = T.loadBuffer(ne);
      return {
        size: O,
        offBytes: $,
        cells: J,
        roots: he,
        absent: de,
        totalCellSize: ne,
        index: Ae,
        cellData: x,
        root: [0],
      };
    } else if (F === 2898503464) {
      let O = T.loadUint(8),
        $ = T.loadUint(8),
        J = T.loadUint(O * 8),
        he = T.loadUint(O * 8),
        de = T.loadUint(O * 8),
        ne = T.loadUint($ * 8),
        Ae = T.loadBuffer(J * $),
        x = T.loadBuffer(ne),
        r = T.loadBuffer(4);
      if (!(0, g.crc32c)(B.subarray(0, B.length - 4)).equals(r)) throw Error("Invalid CRC32C");
      return {
        size: O,
        offBytes: $,
        cells: J,
        roots: he,
        absent: de,
        totalCellSize: ne,
        index: Ae,
        cellData: x,
        root: [0],
      };
    } else if (F === 3052313714) {
      let O = T.loadUint(1),
        $ = T.loadUint(1);
      T.loadUint(1), T.loadUint(2);
      let J = T.loadUint(3),
        he = T.loadUint(8),
        de = T.loadUint(J * 8),
        ne = T.loadUint(J * 8),
        Ae = T.loadUint(J * 8),
        x = T.loadUint(he * 8),
        r = [];
      for (let u = 0; u < ne; u++) r.push(T.loadUint(J * 8));
      let o = null;
      O && (o = T.loadBuffer(de * he));
      let f = T.loadBuffer(x);
      if ($) {
        let u = T.loadBuffer(4);
        if (!(0, g.crc32c)(B.subarray(0, B.length - 4)).equals(u)) throw Error("Invalid CRC32C");
      }
      return {
        size: J,
        offBytes: he,
        cells: de,
        roots: ne,
        absent: Ae,
        totalCellSize: x,
        index: o,
        cellData: f,
        root: r,
      };
    } else throw Error("Invalid magic");
  }
  li.parseBoc = S;
  function A(B) {
    let T = S(B),
      F = new t.BitReader(new e.BitString(T.cellData, 0, T.cellData.length * 8)),
      O = [];
    for (let J = 0; J < T.cells; J++) {
      let he = _(F, T.size);
      O.push({ ...he, result: null });
    }
    for (let J = O.length - 1; J >= 0; J--) {
      if (O[J].result) throw Error("Impossible");
      let he = [];
      for (let de of O[J].refs) {
        if (!O[de].result) throw Error("Invalid BOC file");
        he.push(O[de].result);
      }
      O[J].result = new n.Cell({ bits: O[J].bits, refs: he, exotic: O[J].exotic });
    }
    let $ = [];
    for (let J = 0; J < T.root.length; J++) $.push(O[T.root[J]].result);
    return $;
  }
  li.deserializeBoc = A;
  function k(B, T, F, O) {
    let $ = (0, c.getRefsDescriptor)(B.refs, B.mask.value, B.type),
      J = (0, c.getBitsDescriptor)(B.bits);
    O.writeUint($, 8), O.writeUint(J, 8), O.writeBuffer((0, v.bitsToPaddedBuffer)(B.bits));
    for (let he of T) O.writeUint(he, F * 8);
  }
  function P(B, T) {
    let F = (0, i.topologicalSort)(B),
      O = F.length,
      $ = T.idx,
      J = T.crc32,
      he = !1,
      de = 0,
      ne = Math.max(Math.ceil((0, l.bitsForNumber)(O, "uint") / 8), 1),
      Ae = 0,
      x = [];
    for (let d of F) {
      let y = M(d.cell, ne);
      (Ae += y), x.push(Ae);
    }
    let r = Math.max(Math.ceil((0, l.bitsForNumber)(Ae, "uint") / 8), 1),
      o =
        (6 + // offset_bytes
          3 * ne + // cells_num, roots, complete
          r + // full_size
          1 * ne + // root_idx
          ($ ? O * r : 0) +
          Ae +
          (J ? 4 : 0)) *
        8,
      f = new a.BitBuilder(o);
    if (
      (f.writeUint(3052313714, 32),
      f.writeBit($),
      f.writeBit(J),
      f.writeBit(he),
      f.writeUint(de, 2),
      f.writeUint(ne, 3),
      f.writeUint(r, 8),
      f.writeUint(O, ne * 8),
      f.writeUint(1, ne * 8),
      f.writeUint(0, ne * 8),
      f.writeUint(Ae, r * 8),
      f.writeUint(0, ne * 8),
      $)
    )
      for (let d = 0; d < O; d++) f.writeUint(x[d], r * 8);
    for (let d = 0; d < O; d++) k(F[d].cell, F[d].refs, ne, f);
    if (J) {
      let d = (0, g.crc32c)(f.buffer());
      f.writeBuffer(d);
    }
    let u = f.buffer();
    if (u.length !== o / 8) throw Error("Internal error");
    return u;
  }
  return (li.serializeBoc = P), li;
}
var Kb;
function os() {
  if (Kb) return vo;
  Kb = 1;
  var t =
      (mt && mt.__importDefault) ||
      function (M) {
        return M && M.__esModule ? M : { default: M };
      },
    e;
  Object.defineProperty(vo, "__esModule", { value: !0 }), (vo.Cell = void 0);
  const n = t(Js),
    i = oa(),
    l = eo,
    a = d1(),
    c = _u,
    v = Su,
    g = PS(),
    b = On,
    p = _r();
  let _ = class u3 {
    /**
     * Deserialize cells from BOC
     * @param src source buffer
     * @returns array of cells
     */
    static fromBoc(S) {
      return (0, g.deserializeBoc)(S);
    }
    /**
     * Helper class that deserializes a single cell from BOC in base64
     * @param src source string
     */
    static fromBase64(S) {
      let A = u3.fromBoc(Qe.from(S, "base64"));
      if (A.length !== 1) throw new Error("Deserialized more than one cell");
      return A[0];
    }
    constructor(S) {
      (this._hashes = []),
        (this._depths = []),
        (this.beginParse = (O = !1) => {
          if (this.isExotic && !O) throw new Error("Exotic cells cannot be parsed");
          return new a.Slice(new b.BitReader(this.bits), this.refs);
        }),
        (this.hash = (O = 3) => this._hashes[Math.min(this._hashes.length - 1, O)]),
        (this.depth = (O = 3) => this._depths[Math.min(this._depths.length - 1, O)]),
        (this.level = () => this.mask.level),
        (this.equals = (O) => this.hash().equals(O.hash())),
        (this[e] = () => this.toString());
      let A = i.BitString.EMPTY;
      S && S.bits && (A = S.bits);
      let k = [];
      S && S.refs && (k = [...S.refs]);
      let P,
        B,
        T,
        F = l.CellType.Ordinary;
      if (S && S.exotic) {
        let O = (0, c.resolveExotic)(A, k),
          $ = (0, v.wonderCalculator)(O.type, A, k);
        (T = $.mask), (B = $.depths), (P = $.hashes), (F = O.type);
      } else {
        if (k.length > 4) throw new Error("Invalid number of references");
        if (A.length > 1023) throw new Error(`Bits overflow: ${A.length} > 1023`);
        let O = (0, v.wonderCalculator)(l.CellType.Ordinary, A, k);
        (T = O.mask), (B = O.depths), (P = O.hashes), (F = l.CellType.Ordinary);
      }
      (this.type = F),
        (this.bits = A),
        (this.refs = k),
        (this.mask = T),
        (this._depths = B),
        (this._hashes = P),
        Object.freeze(this),
        Object.freeze(this.refs),
        Object.freeze(this.bits),
        Object.freeze(this.mask),
        Object.freeze(this._depths),
        Object.freeze(this._hashes);
    }
    /**
     * Check if cell is exotic
     */
    get isExotic() {
      return this.type !== l.CellType.Ordinary;
    }
    /**
     * Serializes cell to BOC
     * @param opts options
     */
    toBoc(S) {
      let A = S && S.idx !== null && S.idx !== void 0 ? S.idx : !1,
        k = S && S.crc32 !== null && S.crc32 !== void 0 ? S.crc32 : !0;
      return (0, g.serializeBoc)(this, { idx: A, crc32: k });
    }
    /**
     * Format cell to string
     * @param indent indentation
     * @returns string representation
     */
    toString(S) {
      let A = S || "",
        k = "x";
      this.isExotic &&
        (this.type === l.CellType.MerkleProof
          ? (k = "p")
          : this.type === l.CellType.MerkleUpdate
          ? (k = "u")
          : this.type === l.CellType.PrunedBranch && (k = "p"));
      let P = A + (this.isExotic ? k : "x") + "{" + this.bits.toString() + "}";
      for (let B in this.refs) {
        const T = this.refs[B];
        P +=
          `
` + T.toString(A + " ");
      }
      return P;
    }
    /**
     * Covnert cell to slice
     * @returns slice
     */
    asSlice() {
      return this.beginParse();
    }
    /**
     * Convert cell to a builder that has this cell stored
     * @returns builder
     */
    asBuilder() {
      return (0, p.beginCell)().storeSlice(this.asSlice());
    }
  };
  return (vo.Cell = _), (e = n.default), (_.EMPTY = new _()), vo;
}
var Zb;
function _r() {
  if (Zb) return la;
  (Zb = 1),
    Object.defineProperty(la, "__esModule", { value: !0 }),
    (la.Builder = la.beginCell = void 0);
  const t = gu(),
    e = os(),
    n = z6();
  function i() {
    return new l();
  }
  la.beginCell = i;
  let l = class c3 {
    constructor() {
      (this._bits = new t.BitBuilder()), (this._refs = []);
    }
    /**
     * Bits written so far
     */
    get bits() {
      return this._bits.length;
    }
    /**
     * References written so far
     */
    get refs() {
      return this._refs.length;
    }
    /**
     * Available bits
     */
    get availableBits() {
      return 1023 - this.bits;
    }
    /**
     * Available references
     */
    get availableRefs() {
      return 4 - this.refs;
    }
    /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     * @returns this builder
     */
    storeBit(c) {
      return this._bits.writeBit(c), this;
    }
    /**
     * Write bits from BitString
     * @param src source bits
     * @returns this builder
     */
    storeBits(c) {
      return this._bits.writeBits(c), this;
    }
    /**
     * Store Buffer
     * @param src source buffer
     * @param bytes optional number of bytes to write
     * @returns this builder
     */
    storeBuffer(c, v) {
      if (v != null && c.length !== v)
        throw Error(`Buffer length ${c.length} is not equal to ${v}`);
      return this._bits.writeBuffer(c), this;
    }
    /**
     * Store Maybe Buffer
     * @param src source buffer or null
     * @param bytes optional number of bytes to write
     * @returns this builder
     */
    storeMaybeBuffer(c, v) {
      return c !== null ? (this.storeBit(1), this.storeBuffer(c, v)) : this.storeBit(0), this;
    }
    /**
     * Store uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */
    storeUint(c, v) {
      return this._bits.writeUint(c, v), this;
    }
    /**
     * Store maybe uint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */
    storeMaybeUint(c, v) {
      return c != null ? (this.storeBit(1), this.storeUint(c, v)) : this.storeBit(0), this;
    }
    /**
     * Store int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */
    storeInt(c, v) {
      return this._bits.writeInt(c, v), this;
    }
    /**
     * Store maybe int value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */
    storeMaybeInt(c, v) {
      return c != null ? (this.storeBit(1), this.storeInt(c, v)) : this.storeBit(0), this;
    }
    /**
     * Store varuint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeVarUint(c, v) {
      return this._bits.writeVarUint(c, v), this;
    }
    /**
     * Store maybe varuint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeMaybeVarUint(c, v) {
      return c != null ? (this.storeBit(1), this.storeVarUint(c, v)) : this.storeBit(0), this;
    }
    /**
     * Store varint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeVarInt(c, v) {
      return this._bits.writeVarInt(c, v), this;
    }
    /**
     * Store maybe varint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeMaybeVarInt(c, v) {
      return c != null ? (this.storeBit(1), this.storeVarInt(c, v)) : this.storeBit(0), this;
    }
    /**
     * Store coins value
     * @param amount amount of coins
     * @returns this builder
     */
    storeCoins(c) {
      return this._bits.writeCoins(c), this;
    }
    /**
     * Store maybe coins value
     * @param amount amount of coins, null or undefined
     * @returns this builder
     */
    storeMaybeCoins(c) {
      return c != null ? (this.storeBit(1), this.storeCoins(c)) : this.storeBit(0), this;
    }
    /**
     * Store address
     * @param addres address to store
     * @returns this builder
     */
    storeAddress(c) {
      return this._bits.writeAddress(c), this;
    }
    /**
     * Store reference
     * @param cell cell or builder to store
     * @returns this builder
     */
    storeRef(c) {
      if (this._refs.length >= 4) throw new Error("Too many references");
      if (c instanceof e.Cell) this._refs.push(c);
      else if (c instanceof c3) this._refs.push(c.endCell());
      else throw new Error("Invalid argument");
      return this;
    }
    /**
     * Store reference if not null
     * @param cell cell or builder to store
     * @returns this builder
     */
    storeMaybeRef(c) {
      return c ? (this.storeBit(1), this.storeRef(c)) : this.storeBit(0), this;
    }
    /**
     * Store slice it in this builder
     * @param src source slice
     */
    storeSlice(c) {
      let v = c.clone();
      for (
        v.remainingBits > 0 && this.storeBits(v.loadBits(v.remainingBits));
        v.remainingRefs > 0;

      )
        this.storeRef(v.loadRef());
      return this;
    }
    /**
     * Store slice in this builder if not null
     * @param src source slice
     */
    storeMaybeSlice(c) {
      return c ? (this.storeBit(1), this.storeSlice(c)) : this.storeBit(0), this;
    }
    /**
     * Store builder
     * @param src builder to store
     * @returns this builder
     */
    storeBuilder(c) {
      return this.storeSlice(c.endCell().beginParse());
    }
    /**
     * Store builder if not null
     * @param src builder to store
     * @returns this builder
     */
    storeMaybeBuilder(c) {
      return c ? (this.storeBit(1), this.storeBuilder(c)) : this.storeBit(0), this;
    }
    /**
     * Store writer or builder
     * @param writer writer or builder to store
     * @returns this builder
     */
    storeWritable(c) {
      return typeof c == "object" ? c.writeTo(this) : c(this), this;
    }
    /**
     * Store writer or builder if not null
     * @param writer writer or builder to store
     * @returns this builder
     */
    storeMaybeWritable(c) {
      return c ? (this.storeBit(1), this.storeWritable(c)) : this.storeBit(0), this;
    }
    /**
     * Store object in this builder
     * @param writer Writable or writer functuin
     */
    store(c) {
      return this.storeWritable(c), this;
    }
    /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */
    storeStringTail(c) {
      return (0, n.writeString)(c, this), this;
    }
    /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */
    storeMaybeStringTail(c) {
      return c != null ? (this.storeBit(1), (0, n.writeString)(c, this)) : this.storeBit(0), this;
    }
    /**
     * Store string tail in ref
     * @param src source string
     * @returns this builder
     */
    storeStringRefTail(c) {
      return this.storeRef(i().storeStringTail(c)), this;
    }
    /**
     * Store maybe string tail in ref
     * @param src source string
     * @returns this builder
     */
    storeMaybeStringRefTail(c) {
      return c != null ? (this.storeBit(1), this.storeStringRefTail(c)) : this.storeBit(0), this;
    }
    /**
     * Store dictionary in this builder
     * @param dict dictionary to store
     * @returns this builder
     */
    storeDict(c, v, g) {
      return c ? c.store(this, v, g) : this.storeBit(0), this;
    }
    /**
     * Store dictionary in this builder directly
     * @param dict dictionary to store
     * @returns this builder
     */
    storeDictDirect(c, v, g) {
      return c.storeDirect(this, v, g), this;
    }
    /**
     * Complete cell
     * @param opts options
     * @returns cell
     */
    endCell(c) {
      return new e.Cell({
        bits: this._bits.build(),
        refs: this._refs,
        exotic: c == null ? void 0 : c.exotic,
      });
    }
    /**
     * Convert to cell
     * @returns cell
     */
    asCell() {
      return this.endCell();
    }
    /**
     * Convert to slice
     * @returns slice
     */
    asSlice() {
      return this.endCell().beginParse();
    }
  };
  return (la.Builder = l), la;
}
var Xn = {},
  _i = {};
Object.defineProperty(_i, "__esModule", { value: !0 });
_i.SimpleLibraryValue = _i.storeSimpleLibrary = _i.loadSimpleLibrary = void 0;
function h3(t) {
  return {
    public: t.loadBit(),
    root: t.loadRef(),
  };
}
_i.loadSimpleLibrary = h3;
function d3(t) {
  return (e) => {
    e.storeBit(t.public), e.storeRef(t.root);
  };
}
_i.storeSimpleLibrary = d3;
_i.SimpleLibraryValue = {
  serialize(t, e) {
    d3(t)(e);
  },
  parse(t) {
    return h3(t);
  },
};
var Na = {};
Object.defineProperty(Na, "__esModule", { value: !0 });
Na.storeTickTock = Na.loadTickTock = void 0;
function RS(t) {
  return {
    tick: t.loadBit(),
    tock: t.loadBit(),
  };
}
Na.loadTickTock = RS;
function IS(t) {
  return (e) => {
    e.storeBit(t.tick), e.storeBit(t.tock);
  };
}
Na.storeTickTock = IS;
Object.defineProperty(Xn, "__esModule", { value: !0 });
Xn.storeStateInit = Xn.loadStateInit = void 0;
const OS = as(),
  US = _i,
  p3 = Na;
function NS(t) {
  let e;
  t.loadBit() && (e = t.loadUint(5));
  let n;
  t.loadBit() && (n = (0, p3.loadTickTock)(t));
  let i = t.loadMaybeRef(),
    l = t.loadMaybeRef(),
    a = t.loadDict(OS.Dictionary.Keys.BigUint(256), US.SimpleLibraryValue);
  return (
    a.size === 0 && (a = void 0),
    {
      splitDepth: e,
      special: n,
      code: i,
      data: l,
      libraries: a,
    }
  );
}
Xn.loadStateInit = NS;
function DS(t) {
  return (e) => {
    t.splitDepth !== null && t.splitDepth !== void 0
      ? (e.storeBit(!0), e.storeUint(t.splitDepth, 5))
      : e.storeBit(!1),
      t.special !== null && t.special !== void 0
        ? (e.storeBit(!0), e.store((0, p3.storeTickTock)(t.special)))
        : e.storeBit(!1),
      e.storeMaybeRef(t.code),
      e.storeMaybeRef(t.data),
      e.storeDict(t.libraries);
  };
}
Xn.storeStateInit = DS;
Object.defineProperty(mu, "__esModule", { value: !0 });
mu.contractAddress = void 0;
const LS = _r(),
  FS = Xn,
  qS = cn;
function zS(t, e) {
  let n = (0, LS.beginCell)()
    .store((0, FS.storeStateInit)(e))
    .endCell()
    .hash();
  return new qS.Address(t, n);
}
mu.contractAddress = zS;
var zs = {};
Object.defineProperty(zs, "__esModule", { value: !0 });
zs.parseTuple = zs.serializeTuple = void 0;
const rf = _r(),
  jS = BigInt("-9223372036854775808"),
  $S = BigInt("9223372036854775807");
function m3(t, e) {
  if (t.type === "null") e.storeUint(0, 8);
  else if (t.type === "int")
    t.value <= $S && t.value >= jS
      ? (e.storeUint(1, 8), e.storeInt(t.value, 64))
      : (e.storeUint(256, 15), e.storeInt(t.value, 257));
  else if (t.type === "nan") e.storeInt(767, 16);
  else if (t.type === "cell") e.storeUint(3, 8), e.storeRef(t.cell);
  else if (t.type === "slice")
    e.storeUint(4, 8),
      e.storeUint(0, 10),
      e.storeUint(t.cell.bits.length, 10),
      e.storeUint(0, 3),
      e.storeUint(t.cell.refs.length, 3),
      e.storeRef(t.cell);
  else if (t.type === "builder") e.storeUint(5, 8), e.storeRef(t.cell);
  else if (t.type === "tuple") {
    let n = null,
      i = null;
    for (let l = 0; l < t.items.length; l++) {
      let a = n;
      (n = i), (i = a), l > 1 && (n = (0, rf.beginCell)().storeRef(i).storeRef(n).endCell());
      let c = (0, rf.beginCell)();
      m3(t.items[l], c), (i = c.endCell());
    }
    e.storeUint(7, 8), e.storeUint(t.items.length, 16), n && e.storeRef(n), i && e.storeRef(i);
  } else throw Error("Invalid value");
}
function Lo(t) {
  let e = t.loadUint(8);
  if (e === 0) return { type: "null" };
  if (e === 1) return { type: "int", value: t.loadIntBig(64) };
  if (e === 2)
    return t.loadUint(7) === 0
      ? { type: "int", value: t.loadIntBig(257) }
      : (t.loadBit(), { type: "nan" });
  if (e === 3) return { type: "cell", cell: t.loadRef() };
  if (e === 4) {
    let n = t.loadUint(10),
      i = t.loadUint(10),
      l = t.loadUint(3),
      a = t.loadUint(3),
      c = t.loadRef().beginParse();
    c.skip(n);
    let v = c.loadBits(i - n),
      g = (0, rf.beginCell)().storeBits(v);
    if (l < a) {
      for (let b = 0; b < l; b++) c.loadRef();
      for (let b = 0; b < a - l; b++) g.storeRef(c.loadRef());
    }
    return { type: "slice", cell: g.endCell() };
  } else {
    if (e === 5) return { type: "builder", cell: t.loadRef() };
    if (e === 7) {
      let n = t.loadUint(16),
        i = [];
      if (n > 1) {
        let l = t.loadRef().beginParse(),
          a = t.loadRef().beginParse();
        i.unshift(Lo(a));
        for (let c = 0; c < n - 2; c++) {
          let v = l;
          (l = v.loadRef().beginParse()), (a = v.loadRef().beginParse()), i.unshift(Lo(a));
        }
        i.unshift(Lo(l));
      } else n === 1 && i.push(Lo(t.loadRef().beginParse()));
      return { type: "tuple", items: i };
    } else throw Error("Unsupported stack item");
  }
}
function v3(t, e) {
  if (t.length > 0) {
    let n = (0, rf.beginCell)();
    v3(t.slice(0, t.length - 1), n), e.storeRef(n.endCell()), m3(t[t.length - 1], e);
  }
}
function HS(t) {
  let e = (0, rf.beginCell)();
  e.storeUint(t.length, 24);
  let n = [...t];
  return v3(n, e), e.endCell();
}
zs.serializeTuple = HS;
function VS(t) {
  let e = [],
    n = t.beginParse(),
    i = n.loadUint(24);
  for (let l = 0; l < i; l++) {
    let a = n.loadRef();
    e.unshift(Lo(n)), (n = a.beginParse());
  }
  return e;
}
zs.parseTuple = VS;
var zu = {};
Object.defineProperty(zu, "__esModule", { value: !0 });
zu.TupleReader = void 0;
class vs {
  constructor(e) {
    this.items = [...e];
  }
  get remaining() {
    return this.items.length;
  }
  peek() {
    if (this.items.length === 0) throw Error("EOF");
    return this.items[0];
  }
  pop() {
    if (this.items.length === 0) throw Error("EOF");
    let e = this.items[0];
    return this.items.splice(0, 1), e;
  }
  skip(e = 1) {
    for (let n = 0; n < e; n++) this.pop();
    return this;
  }
  readBigNumber() {
    let e = this.pop();
    if (e.type !== "int") throw Error("Not a number");
    return e.value;
  }
  readBigNumberOpt() {
    let e = this.pop();
    if (e.type === "null") return null;
    if (e.type !== "int") throw Error("Not a number");
    return e.value;
  }
  readNumber() {
    return Number(this.readBigNumber());
  }
  readNumberOpt() {
    let e = this.readBigNumberOpt();
    return e !== null ? Number(e) : null;
  }
  readBoolean() {
    return this.readNumber() !== 0;
  }
  readBooleanOpt() {
    let e = this.readNumberOpt();
    return e !== null ? e !== 0 : null;
  }
  readAddress() {
    let e = this.readCell().beginParse().loadAddress();
    if (e !== null) return e;
    throw Error("Not an address");
  }
  readAddressOpt() {
    let e = this.readCellOpt();
    return e !== null ? e.beginParse().loadMaybeAddress() : null;
  }
  readCell() {
    let e = this.pop();
    if (e.type !== "cell" && e.type !== "slice" && e.type !== "builder")
      throw Error("Not a cell: " + e.type);
    return e.cell;
  }
  readCellOpt() {
    let e = this.pop();
    if (e.type === "null") return null;
    if (e.type !== "cell" && e.type !== "slice" && e.type !== "builder") throw Error("Not a cell");
    return e.cell;
  }
  readTuple() {
    let e = this.pop();
    if (e.type !== "tuple") throw Error("Not a tuple");
    return new vs(e.items);
  }
  readTupleOpt() {
    let e = this.pop();
    if (e.type === "null") return null;
    if (e.type !== "tuple") throw Error("Not a tuple");
    return new vs(e.items);
  }
  static readLispList(e) {
    const n = [];
    let i = e;
    for (; i !== null; ) {
      var l = i.pop();
      if (i.items.length === 0 || (i.items[0].type !== "tuple" && i.items[0].type !== "null"))
        throw Error("Lisp list consists only from (any, tuple) elements and ends with null");
      (i = i.readTupleOpt()), n.push(l);
    }
    return n;
  }
  readLispListDirect() {
    return this.items.length === 1 && this.items[0].type === "null" ? [] : vs.readLispList(this);
  }
  readLispList() {
    return vs.readLispList(this.readTupleOpt());
  }
  readBuffer() {
    let e = this.readCell().beginParse();
    if (e.remainingRefs !== 0 || e.remainingBits % 8 !== 0) throw Error("Not a buffer");
    return e.loadBuffer(e.remainingBits / 8);
  }
  readBufferOpt() {
    if (this.peek().type === "null") return null;
    let n = this.readCell().beginParse();
    if (n.remainingRefs !== 0 || n.remainingBits % 8 !== 0) throw Error("Not a buffer");
    return n.loadBuffer(n.remainingBits / 8);
  }
  readString() {
    return this.readCell().beginParse().loadStringTail();
  }
  readStringOpt() {
    return this.peek().type === "null" ? null : this.readCell().beginParse().loadStringTail();
  }
}
zu.TupleReader = vs;
var ju = {};
Object.defineProperty(ju, "__esModule", { value: !0 });
ju.TupleBuilder = void 0;
const R0 = _r(),
  I0 = os(),
  O0 = d1();
class WS {
  constructor() {
    this._tuple = [];
  }
  writeNumber(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : this._tuple.push({ type: "int", value: BigInt(e) });
  }
  writeBoolean(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : this._tuple.push({ type: "int", value: e ? -1n : 0n });
  }
  writeBuffer(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : this._tuple.push({ type: "slice", cell: (0, R0.beginCell)().storeBuffer(e).endCell() });
  }
  writeString(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : this._tuple.push({ type: "slice", cell: (0, R0.beginCell)().storeStringTail(e).endCell() });
  }
  writeCell(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : e instanceof I0.Cell
      ? this._tuple.push({ type: "cell", cell: e })
      : e instanceof O0.Slice && this._tuple.push({ type: "cell", cell: e.asCell() });
  }
  writeSlice(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : e instanceof I0.Cell
      ? this._tuple.push({ type: "slice", cell: e })
      : e instanceof O0.Slice && this._tuple.push({ type: "slice", cell: e.asCell() });
  }
  writeBuilder(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : e instanceof I0.Cell
      ? this._tuple.push({ type: "builder", cell: e })
      : e instanceof O0.Slice && this._tuple.push({ type: "builder", cell: e.asCell() });
  }
  writeTuple(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "tuple", items: e });
  }
  writeAddress(e) {
    e == null
      ? this._tuple.push({ type: "null" })
      : this._tuple.push({ type: "slice", cell: (0, R0.beginCell)().storeAddress(e).endCell() });
  }
  build() {
    return [...this._tuple];
  }
}
ju.TupleBuilder = WS;
var g3 = {},
  ea = {},
  Da = {};
Object.defineProperty(Da, "__esModule", { value: !0 });
Da.fromNano = Da.toNano = void 0;
function KS(t) {
  if (typeof t == "bigint") return t * 1000000000n;
  {
    if (typeof t == "number") {
      if (!Number.isFinite(t)) throw Error("Invalid number");
      if (Math.log10(t) <= 6)
        t = t.toLocaleString("en", { minimumFractionDigits: 9, useGrouping: !1 });
      else if (t - Math.trunc(t) === 0)
        t = t.toLocaleString("en", { maximumFractionDigits: 0, useGrouping: !1 });
      else throw Error("Not enough precision for a number value. Use string value instead");
    }
    let e = !1;
    for (; t.startsWith("-"); ) (e = !e), (t = t.slice(1));
    if (t === ".") throw Error("Invalid number");
    let n = t.split(".");
    if (n.length > 2) throw Error("Invalid number");
    let i = n[0],
      l = n[1];
    if ((i || (i = "0"), l || (l = "0"), l.length > 9)) throw Error("Invalid number");
    for (; l.length < 9; ) l += "0";
    let a = BigInt(i) * 1000000000n + BigInt(l);
    return e && (a = -a), a;
  }
}
Da.toNano = KS;
function ZS(t) {
  let e = BigInt(t),
    n = !1;
  e < 0 && ((n = !0), (e = -e));
  let l = (e % 1000000000n).toString();
  for (; l.length < 9; ) l = "0" + l;
  l = l.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  let v = `${(e / 1000000000n).toString()}${l === "0" ? "" : `.${l}`}`;
  return n && (v = "-" + v), v;
}
Da.fromNano = ZS;
Object.defineProperty(ea, "__esModule", { value: !0 });
ea.comment = ea.external = ea.internal = void 0;
const Yl = cn,
  y3 = os(),
  b3 = _r(),
  GS = Da;
function YS(t) {
  let e = !0;
  t.bounce !== null && t.bounce !== void 0 && (e = t.bounce);
  let n;
  if (typeof t.to == "string") n = Yl.Address.parse(t.to);
  else if (Yl.Address.isAddress(t.to)) n = t.to;
  else throw new Error(`Invalid address ${t.to}`);
  let i;
  typeof t.value == "string" ? (i = (0, GS.toNano)(t.value)) : (i = t.value);
  let l = y3.Cell.EMPTY;
  return (
    typeof t.body == "string"
      ? (l = (0, b3.beginCell)().storeUint(0, 32).storeStringTail(t.body).endCell())
      : t.body && (l = t.body),
    {
      info: {
        type: "internal",
        dest: n,
        value: { coins: i },
        bounce: e,
        ihrDisabled: !0,
        bounced: !1,
        ihrFee: 0n,
        forwardFee: 0n,
        createdAt: 0,
        createdLt: 0n,
      },
      init: t.init ?? void 0,
      body: l,
    }
  );
}
ea.internal = YS;
function JS(t) {
  let e;
  if (typeof t.to == "string") e = Yl.Address.parse(t.to);
  else if (Yl.Address.isAddress(t.to)) e = t.to;
  else throw new Error(`Invalid address ${t.to}`);
  return {
    info: {
      type: "external-in",
      dest: e,
      importFee: 0n,
    },
    init: t.init ?? void 0,
    body: t.body || y3.Cell.EMPTY,
  };
}
ea.external = JS;
function QS(t) {
  return (0, b3.beginCell)().storeUint(0, 32).storeStringTail(t).endCell();
}
ea.comment = QS;
var La = {},
  Fa = {},
  qa = {};
Object.defineProperty(qa, "__esModule", { value: !0 });
qa.storeAccountState = qa.loadAccountState = void 0;
const w3 = Xn;
function XS(t) {
  return t.loadBit()
    ? { type: "active", state: (0, w3.loadStateInit)(t) }
    : t.loadBit()
    ? { type: "frozen", stateHash: t.loadUintBig(256) }
    : { type: "uninit" };
}
qa.loadAccountState = XS;
function eE(t) {
  return (e) => {
    t.type === "active"
      ? (e.storeBit(!0), e.store((0, w3.storeStateInit)(t.state)))
      : t.type === "frozen"
      ? (e.storeBit(!1), e.storeBit(!0), e.storeUint(t.stateHash, 256))
      : t.type === "uninit" && (e.storeBit(!1), e.storeBit(!1));
  };
}
qa.storeAccountState = eE;
var hn = {};
Object.defineProperty(hn, "__esModule", { value: !0 });
hn.storeCurrencyCollection = hn.loadCurrencyCollection = void 0;
const Gb = as();
function tE(t) {
  const e = t.loadCoins(),
    n = t.loadDict(
      Gb.Dictionary.Keys.Uint(32),
      Gb.Dictionary.Values.BigVarUint(
        5
        /* log2(32) */
      )
    );
  return n.size === 0 ? { coins: e } : { other: n, coins: e };
}
hn.loadCurrencyCollection = tE;
function rE(t) {
  return (e) => {
    e.storeCoins(t.coins), t.other ? e.storeDict(t.other) : e.storeBit(0);
  };
}
hn.storeCurrencyCollection = rE;
Object.defineProperty(Fa, "__esModule", { value: !0 });
Fa.storeAccountStorage = Fa.loadAccountStorage = void 0;
const _3 = qa,
  x3 = hn;
function nE(t) {
  return {
    lastTransLt: t.loadUintBig(64),
    balance: (0, x3.loadCurrencyCollection)(t),
    state: (0, _3.loadAccountState)(t),
  };
}
Fa.loadAccountStorage = nE;
function iE(t) {
  return (e) => {
    e.storeUint(t.lastTransLt, 64),
      e.store((0, x3.storeCurrencyCollection)(t.balance)),
      e.store((0, _3.storeAccountState)(t.state));
  };
}
Fa.storeAccountStorage = iE;
var za = {},
  ja = {};
Object.defineProperty(ja, "__esModule", { value: !0 });
ja.storeStorageUsed = ja.loadStorageUsed = void 0;
function aE(t) {
  return {
    cells: t.loadVarUintBig(3),
    bits: t.loadVarUintBig(3),
    publicCells: t.loadVarUintBig(3),
  };
}
ja.loadStorageUsed = aE;
function sE(t) {
  return (e) => {
    e.storeVarUint(t.cells, 3), e.storeVarUint(t.bits, 3), e.storeVarUint(t.publicCells, 3);
  };
}
ja.storeStorageUsed = sE;
Object.defineProperty(za, "__esModule", { value: !0 });
za.storeStorageInfo = za.loadStorageInfo = void 0;
const M3 = ja;
function oE(t) {
  return {
    used: (0, M3.loadStorageUsed)(t),
    lastPaid: t.loadUint(32),
    duePayment: t.loadMaybeCoins(),
  };
}
za.loadStorageInfo = oE;
function fE(t) {
  return (e) => {
    e.store((0, M3.storeStorageUsed)(t.used)),
      e.storeUint(t.lastPaid, 32),
      e.storeMaybeCoins(t.duePayment);
  };
}
za.storeStorageInfo = fE;
Object.defineProperty(La, "__esModule", { value: !0 });
La.storeAccount = La.loadAccount = void 0;
const S3 = Fa,
  E3 = za;
function lE(t) {
  return {
    addr: t.loadAddress(),
    storageStats: (0, E3.loadStorageInfo)(t),
    storage: (0, S3.loadAccountStorage)(t),
  };
}
La.loadAccount = lE;
function uE(t) {
  return (e) => {
    e.storeAddress(t.addr),
      e.store((0, E3.storeStorageInfo)(t.storageStats)),
      e.store((0, S3.storeAccountStorage)(t.storage));
  };
}
La.storeAccount = uE;
var $a = {};
Object.defineProperty($a, "__esModule", { value: !0 });
$a.storeAccountStatus = $a.loadAccountStatus = void 0;
function cE(t) {
  const e = t.loadUint(2);
  if (e === 0) return "uninitialized";
  if (e === 1) return "frozen";
  if (e === 2) return "active";
  if (e === 3) return "non-existing";
  throw Error("Invalid data");
}
$a.loadAccountStatus = cE;
function hE(t) {
  return (e) => {
    if (t === "uninitialized") e.storeUint(0, 2);
    else if (t === "frozen") e.storeUint(1, 2);
    else if (t === "active") e.storeUint(2, 2);
    else if (t === "non-existing") e.storeUint(3, 2);
    else throw Error("Invalid data");
    return e;
  };
}
$a.storeAccountStatus = hE;
var ra = {};
Object.defineProperty(ra, "__esModule", { value: !0 });
ra.storeAccountStatusChange = ra.loadAccountStatusChange = void 0;
function dE(t) {
  return t.loadBit() ? (t.loadBit() ? "deleted" : "frozen") : "unchanged";
}
ra.loadAccountStatusChange = dE;
function pE(t) {
  return (e) => {
    if (t == "unchanged") e.storeBit(0);
    else if (t === "frozen") e.storeBit(1), e.storeBit(0);
    else if (t === "deleted") e.storeBit(1), e.storeBit(1);
    else throw Error("Invalid account status change");
  };
}
ra.storeAccountStatusChange = pE;
var Wn = {},
  Ha = {},
  Va = {};
Object.defineProperty(Va, "__esModule", { value: !0 });
Va.storeCommonMessageInfoRelaxed = Va.loadCommonMessageInfoRelaxed = void 0;
const A3 = hn;
function mE(t) {
  if (!t.loadBit()) {
    const a = t.loadBit(),
      c = t.loadBit(),
      v = t.loadBit(),
      g = t.loadMaybeAddress(),
      b = t.loadAddress(),
      p = (0, A3.loadCurrencyCollection)(t),
      _ = t.loadCoins(),
      M = t.loadCoins(),
      S = t.loadUintBig(64),
      A = t.loadUint(32);
    return {
      type: "internal",
      ihrDisabled: a,
      bounce: c,
      bounced: v,
      src: g,
      dest: b,
      value: p,
      ihrFee: _,
      forwardFee: M,
      createdLt: S,
      createdAt: A,
    };
  }
  if (!t.loadBit()) throw Error("External In message is not possible for CommonMessageInfoRelaxed");
  const e = t.loadMaybeAddress(),
    n = t.loadMaybeExternalAddress(),
    i = t.loadUintBig(64),
    l = t.loadUint(32);
  return {
    type: "external-out",
    src: e,
    dest: n,
    createdLt: i,
    createdAt: l,
  };
}
Va.loadCommonMessageInfoRelaxed = mE;
function vE(t) {
  return (e) => {
    if (t.type === "internal")
      e.storeBit(0),
        e.storeBit(t.ihrDisabled),
        e.storeBit(t.bounce),
        e.storeBit(t.bounced),
        e.storeAddress(t.src),
        e.storeAddress(t.dest),
        e.store((0, A3.storeCurrencyCollection)(t.value)),
        e.storeCoins(t.ihrFee),
        e.storeCoins(t.forwardFee),
        e.storeUint(t.createdLt, 64),
        e.storeUint(t.createdAt, 32);
    else if (t.type === "external-out")
      e.storeBit(1),
        e.storeBit(1),
        e.storeAddress(t.src),
        e.storeAddress(t.dest),
        e.storeUint(t.createdLt, 64),
        e.storeUint(t.createdAt, 32);
    else throw new Error("Unknown CommonMessageInfo type");
  };
}
Va.storeCommonMessageInfoRelaxed = vE;
Object.defineProperty(Ha, "__esModule", { value: !0 });
Ha.storeMessageRelaxed = Ha.loadMessageRelaxed = void 0;
const gE = _r(),
  k3 = Va,
  vp = Xn;
function yE(t) {
  const e = (0, k3.loadCommonMessageInfoRelaxed)(t);
  let n = null;
  t.loadBit() &&
    (t.loadBit()
      ? (n = (0, vp.loadStateInit)(t.loadRef().beginParse()))
      : (n = (0, vp.loadStateInit)(t)));
  const i = t.loadBit() ? t.loadRef() : t.asCell();
  return {
    info: e,
    init: n,
    body: i,
  };
}
Ha.loadMessageRelaxed = yE;
function bE(t, e) {
  return (n) => {
    if ((n.store((0, k3.storeCommonMessageInfoRelaxed)(t.info)), t.init)) {
      n.storeBit(!0);
      let l = (0, gE.beginCell)().store((0, vp.storeStateInit)(t.init)),
        a = !1;
      e && e.forceRef ? (a = !0) : n.availableBits - 2 >= l.bits ? (a = !1) : (a = !0),
        a ? (n.storeBit(!0), n.storeRef(l)) : (n.storeBit(!1), n.storeBuilder(l));
    } else n.storeBit(!1);
    let i = !1;
    e && e.forceRef
      ? (i = !0)
      : n.availableBits - 1 >= t.body.bits.length &&
        n.refs + t.body.refs.length <= 4 &&
        !t.body.isExotic
      ? (i = !1)
      : (i = !0),
      i
        ? (n.storeBit(!0), n.storeRef(t.body))
        : (n.storeBit(!1), n.storeBuilder(t.body.asBuilder()));
  };
}
Ha.storeMessageRelaxed = bE;
Object.defineProperty(Wn, "__esModule", { value: !0 });
Wn.loadOutList = Wn.storeOutList = Wn.loadOutAction = Wn.storeOutAction = void 0;
const B3 = Ha,
  gp = _r();
function C3(t) {
  switch (t.type) {
    case "sendMsg":
      return wE(t);
    case "setCode":
      return _E(t);
    default:
      throw new Error(`Unknown action type ${t.type}`);
  }
}
Wn.storeOutAction = C3;
const T3 = 247711853;
function wE(t) {
  return (e) => {
    e.storeUint(T3, 32)
      .storeUint(t.mode, 8)
      .storeRef(
        (0, gp.beginCell)()
          .store((0, B3.storeMessageRelaxed)(t.outMsg))
          .endCell()
      );
  };
}
const P3 = 2907562126;
function _E(t) {
  return (e) => {
    e.storeUint(P3, 32).storeRef(t.newCode);
  };
}
function R3(t) {
  const e = t.loadUint(32);
  if (e === T3) {
    const n = t.loadUint(8),
      i = (0, B3.loadMessageRelaxed)(t.loadRef().beginParse());
    return {
      type: "sendMsg",
      mode: n,
      outMsg: i,
    };
  }
  if (e === P3)
    return {
      type: "setCode",
      newCode: t.loadRef(),
    };
  throw new Error(`Unknown out action tag 0x${e.toString(16)}`);
}
Wn.loadOutAction = R3;
function xE(t) {
  const e = t.reduce(
    (n, i) => (0, gp.beginCell)().storeRef(n).store(C3(i)).endCell(),
    (0, gp.beginCell)().endCell()
  );
  return (n) => {
    n.storeSlice(e.beginParse());
  };
}
Wn.storeOutList = xE;
function ME(t) {
  const e = [];
  for (; t.remainingRefs; ) {
    const n = t.loadRef();
    e.push(R3(t)), (t = n.beginParse());
  }
  return e.reverse();
}
Wn.loadOutList = ME;
var Wa = {};
Object.defineProperty(Wa, "__esModule", { value: !0 });
Wa.storeCommonMessageInfo = Wa.loadCommonMessageInfo = void 0;
const I3 = hn;
function SE(t) {
  if (!t.loadBit()) {
    const a = t.loadBit(),
      c = t.loadBit(),
      v = t.loadBit(),
      g = t.loadAddress(),
      b = t.loadAddress(),
      p = (0, I3.loadCurrencyCollection)(t),
      _ = t.loadCoins(),
      M = t.loadCoins(),
      S = t.loadUintBig(64),
      A = t.loadUint(32);
    return {
      type: "internal",
      ihrDisabled: a,
      bounce: c,
      bounced: v,
      src: g,
      dest: b,
      value: p,
      ihrFee: _,
      forwardFee: M,
      createdLt: S,
      createdAt: A,
    };
  }
  if (!t.loadBit()) {
    const a = t.loadMaybeExternalAddress(),
      c = t.loadAddress(),
      v = t.loadCoins();
    return {
      type: "external-in",
      src: a,
      dest: c,
      importFee: v,
    };
  }
  const e = t.loadAddress(),
    n = t.loadMaybeExternalAddress(),
    i = t.loadUintBig(64),
    l = t.loadUint(32);
  return {
    type: "external-out",
    src: e,
    dest: n,
    createdLt: i,
    createdAt: l,
  };
}
Wa.loadCommonMessageInfo = SE;
function EE(t) {
  return (e) => {
    if (t.type === "internal")
      e.storeBit(0),
        e.storeBit(t.ihrDisabled),
        e.storeBit(t.bounce),
        e.storeBit(t.bounced),
        e.storeAddress(t.src),
        e.storeAddress(t.dest),
        e.store((0, I3.storeCurrencyCollection)(t.value)),
        e.storeCoins(t.ihrFee),
        e.storeCoins(t.forwardFee),
        e.storeUint(t.createdLt, 64),
        e.storeUint(t.createdAt, 32);
    else if (t.type === "external-in")
      e.storeBit(1),
        e.storeBit(0),
        e.storeAddress(t.src),
        e.storeAddress(t.dest),
        e.storeCoins(t.importFee);
    else if (t.type === "external-out")
      e.storeBit(1),
        e.storeBit(1),
        e.storeAddress(t.src),
        e.storeAddress(t.dest),
        e.storeUint(t.createdLt, 64),
        e.storeUint(t.createdAt, 32);
    else throw new Error("Unknown CommonMessageInfo type");
  };
}
Wa.storeCommonMessageInfo = EE;
var Ka = {};
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.storeComputeSkipReason = Ka.loadComputeSkipReason = void 0;
function AE(t) {
  let e = t.loadUint(2);
  if (e === 0) return "no-state";
  if (e === 1) return "bad-state";
  if (e === 2) return "no-gas";
  throw new Error(`Unknown ComputeSkipReason: ${e}`);
}
Ka.loadComputeSkipReason = AE;
function kE(t) {
  return (e) => {
    if (t === "no-state") e.storeUint(0, 2);
    else if (t === "bad-state") e.storeUint(1, 2);
    else if (t === "no-gas") e.storeUint(2, 2);
    else throw new Error(`Unknown ComputeSkipReason: ${t}`);
  };
}
Ka.storeComputeSkipReason = kE;
var Za = {};
Object.defineProperty(Za, "__esModule", { value: !0 });
Za.storeDepthBalanceInfo = Za.loadDepthBalanceInfo = void 0;
const O3 = hn;
function BE(t) {
  return {
    splitDepth: t.loadUint(5),
    balance: (0, O3.loadCurrencyCollection)(t),
  };
}
Za.loadDepthBalanceInfo = BE;
function CE(t) {
  return (e) => {
    e.storeUint(t.splitDepth, 5), e.store((0, O3.storeCurrencyCollection)(t.balance));
  };
}
Za.storeDepthBalanceInfo = CE;
var Ga = {};
Object.defineProperty(Ga, "__esModule", { value: !0 });
Ga.storeHashUpdate = Ga.loadHashUpdate = void 0;
function TE(t) {
  if (t.loadUint(8) !== 114) throw Error("Invalid data");
  const e = t.loadBuffer(32),
    n = t.loadBuffer(32);
  return { oldHash: e, newHash: n };
}
Ga.loadHashUpdate = TE;
function PE(t) {
  return (e) => {
    e.storeUint(114, 8), e.storeBuffer(t.oldHash), e.storeBuffer(t.newHash);
  };
}
Ga.storeHashUpdate = PE;
var Of = {};
Object.defineProperty(Of, "__esModule", { value: !0 });
Of.loadMasterchainStateExtra = void 0;
const U0 = as(),
  RE = hn;
function IE(t) {
  if (t.loadUint(16) !== 52262) throw Error("Invalid data");
  t.loadBit() && t.loadRef();
  let e = t.loadUintBig(256),
    n = U0.Dictionary.load(U0.Dictionary.Keys.Int(32), U0.Dictionary.Values.Cell(), t);
  const i = (0, RE.loadCurrencyCollection)(t);
  return {
    config: n,
    configAddress: e,
    globalBalance: i,
  };
}
Of.loadMasterchainStateExtra = IE;
var xi = {};
Object.defineProperty(xi, "__esModule", { value: !0 });
xi.MessageValue = xi.storeMessage = xi.loadMessage = void 0;
const U3 = _r(),
  N3 = Wa,
  yp = Xn;
function D3(t) {
  const e = (0, N3.loadCommonMessageInfo)(t);
  let n = null;
  t.loadBit() &&
    (t.loadBit()
      ? (n = (0, yp.loadStateInit)(t.loadRef().beginParse()))
      : (n = (0, yp.loadStateInit)(t)));
  const i = t.loadBit() ? t.loadRef() : t.asCell();
  return {
    info: e,
    init: n,
    body: i,
  };
}
xi.loadMessage = D3;
function L3(t, e) {
  return (n) => {
    if ((n.store((0, N3.storeCommonMessageInfo)(t.info)), t.init)) {
      n.storeBit(!0);
      let l = (0, U3.beginCell)().store((0, yp.storeStateInit)(t.init)),
        a = !1;
      e && e.forceRef ? (a = !0) : (a = n.availableBits - 2 < l.bits + t.body.bits.length),
        a ? (n.storeBit(!0), n.storeRef(l)) : (n.storeBit(!1), n.storeBuilder(l));
    } else n.storeBit(!1);
    let i = !1;
    e && e.forceRef
      ? (i = !0)
      : (i = n.availableBits - 1 < t.body.bits.length || n.refs + t.body.refs.length > 4),
      i
        ? (n.storeBit(!0), n.storeRef(t.body))
        : (n.storeBit(!1), n.storeBuilder(t.body.asBuilder()));
  };
}
xi.storeMessage = L3;
xi.MessageValue = {
  serialize(t, e) {
    e.storeRef((0, U3.beginCell)().store(L3(t)));
  },
  parse(t) {
    return D3(t.loadRef().beginParse());
  },
};
var F3 = {};
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.SendMode = void 0),
    (function (e) {
      (e[(e.CARRY_ALL_REMAINING_BALANCE = 128)] = "CARRY_ALL_REMAINING_BALANCE"),
        (e[(e.CARRY_ALL_REMAINING_INCOMING_VALUE = 64)] = "CARRY_ALL_REMAINING_INCOMING_VALUE"),
        (e[(e.DESTROY_ACCOUNT_IF_ZERO = 32)] = "DESTROY_ACCOUNT_IF_ZERO"),
        (e[(e.PAY_GAS_SEPARATELY = 1)] = "PAY_GAS_SEPARATELY"),
        (e[(e.IGNORE_ERRORS = 2)] = "IGNORE_ERRORS"),
        (e[(e.NONE = 0)] = "NONE");
    })(t.SendMode || (t.SendMode = {}));
})(F3);
var Ya = {};
Object.defineProperty(Ya, "__esModule", { value: !0 });
Ya.storeShardAccount = Ya.loadShardAccount = void 0;
const Yb = _r(),
  q3 = La;
function OE(t) {
  let e = t.loadRef(),
    n;
  if (!e.isExotic) {
    let i = e.beginParse();
    i.loadBit() && (n = (0, q3.loadAccount)(i));
  }
  return {
    account: n,
    lastTransactionHash: t.loadUintBig(256),
    lastTransactionLt: t.loadUintBig(64),
  };
}
Ya.loadShardAccount = OE;
function UE(t) {
  return (e) => {
    t.account
      ? e.storeRef(
          (0, Yb.beginCell)()
            .storeBit(!0)
            .store((0, q3.storeAccount)(t.account))
        )
      : e.storeRef((0, Yb.beginCell)().storeBit(!1)),
      e.storeUint(t.lastTransactionHash, 256),
      e.storeUint(t.lastTransactionLt, 64);
  };
}
Ya.storeShardAccount = UE;
var q1 = {};
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.storeShardAccounts = t.loadShardAccounts = t.ShardAccountRefValue = void 0);
  const e = as(),
    n = Za,
    i = Ya;
  t.ShardAccountRefValue = {
    parse: (c) => {
      let v = (0, n.loadDepthBalanceInfo)(c),
        g = (0, i.loadShardAccount)(c);
      return {
        depthBalanceInfo: v,
        shardAccount: g,
      };
    },
    serialize(c, v) {
      v.store((0, n.storeDepthBalanceInfo)(c.depthBalanceInfo)),
        v.store((0, i.storeShardAccount)(c.shardAccount));
    },
  };
  function l(c) {
    return e.Dictionary.load(e.Dictionary.Keys.BigUint(256), t.ShardAccountRefValue, c);
  }
  t.loadShardAccounts = l;
  function a(c) {
    return (v) => {
      v.storeDict(c);
    };
  }
  t.storeShardAccounts = a;
})(q1);
var Ja = {};
Object.defineProperty(Ja, "__esModule", { value: !0 });
Ja.storeShardIdent = Ja.loadShardIdent = void 0;
function NE(t) {
  if (t.loadUint(2) !== 0) throw Error("Invalid data");
  return {
    shardPrefixBits: t.loadUint(6),
    workchainId: t.loadInt(32),
    shardPrefix: t.loadUintBig(64),
  };
}
Ja.loadShardIdent = NE;
function DE(t) {
  return (e) => {
    e.storeUint(0, 2),
      e.storeUint(t.shardPrefixBits, 6),
      e.storeInt(t.workchainId, 32),
      e.storeUint(t.shardPrefix, 64);
  };
}
Ja.storeShardIdent = DE;
var $u = {};
Object.defineProperty($u, "__esModule", { value: !0 });
$u.loadShardStateUnsplit = void 0;
const LE = Of,
  FE = q1,
  qE = Ja;
function zE(t) {
  if (t.loadUint(32) !== 2418257890) throw Error("Invalid data");
  let e = t.loadInt(32),
    n = (0, qE.loadShardIdent)(t),
    i = t.loadUint(32),
    l = t.loadUint(32),
    a = t.loadUint(32),
    c = t.loadUintBig(64),
    v = t.loadUint(32);
  t.loadRef();
  let g = t.loadBit(),
    b = t.loadRef(),
    p;
  b.isExotic || (p = (0, FE.loadShardAccounts)(b.beginParse())), t.loadRef();
  let _ = t.loadBit(),
    M = null;
  if (_) {
    let S = t.loadRef();
    S.isExotic || (M = (0, LE.loadMasterchainStateExtra)(S.beginParse()));
  }
  return {
    globalId: e,
    shardId: n,
    seqno: i,
    vertSeqNo: l,
    genUtime: a,
    genLt: c,
    minRefMcSeqno: v,
    beforeSplit: g,
    accounts: p,
    extras: M,
  };
}
$u.loadShardStateUnsplit = zE;
var Qa = {};
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.storeSplitMergeInfo = Qa.loadSplitMergeInfo = void 0;
function jE(t) {
  let e = t.loadUint(6),
    n = t.loadUint(6),
    i = t.loadUintBig(256),
    l = t.loadUintBig(256);
  return {
    currentShardPrefixLength: e,
    accountSplitDepth: n,
    thisAddress: i,
    siblingAddress: l,
  };
}
Qa.loadSplitMergeInfo = jE;
function $E(t) {
  return (e) => {
    e.storeUint(t.currentShardPrefixLength, 6),
      e.storeUint(t.accountSplitDepth, 6),
      e.storeUint(t.thisAddress, 256),
      e.storeUint(t.siblingAddress, 256);
  };
}
Qa.storeSplitMergeInfo = $E;
var na = {};
Object.defineProperty(na, "__esModule", { value: !0 });
na.storeStorageUsedShort = na.loadStorageUsedShort = void 0;
function HE(t) {
  let e = t.loadVarUintBig(3),
    n = t.loadVarUintBig(3);
  return {
    cells: e,
    bits: n,
  };
}
na.loadStorageUsedShort = HE;
function VE(t) {
  return (e) => {
    e.storeVarUint(t.cells, 3), e.storeVarUint(t.bits, 3);
  };
}
na.storeStorageUsedShort = VE;
var pa = {},
  ma = {},
  Xa = {};
Object.defineProperty(Xa, "__esModule", { value: !0 });
Xa.storeTransactionActionPhase = Xa.loadTransactionActionPhase = void 0;
const z3 = ra,
  j3 = na;
function WE(t) {
  let e = t.loadBit(),
    n = t.loadBit(),
    i = t.loadBit(),
    l = (0, z3.loadAccountStatusChange)(t),
    a = t.loadBit() ? t.loadCoins() : void 0,
    c = t.loadBit() ? t.loadCoins() : void 0,
    v = t.loadInt(32),
    g = t.loadBit() ? t.loadInt(32) : void 0,
    b = t.loadUint(16),
    p = t.loadUint(16),
    _ = t.loadUint(16),
    M = t.loadUint(16),
    S = t.loadUintBig(256),
    A = (0, j3.loadStorageUsedShort)(t);
  return {
    success: e,
    valid: n,
    noFunds: i,
    statusChange: l,
    totalFwdFees: a,
    totalActionFees: c,
    resultCode: v,
    resultArg: g,
    totalActions: b,
    specActions: p,
    skippedActions: _,
    messagesCreated: M,
    actionListHash: S,
    totalMessageSize: A,
  };
}
Xa.loadTransactionActionPhase = WE;
function KE(t) {
  return (e) => {
    e.storeBit(t.success),
      e.storeBit(t.valid),
      e.storeBit(t.noFunds),
      e.store((0, z3.storeAccountStatusChange)(t.statusChange)),
      e.storeMaybeCoins(t.totalFwdFees),
      e.storeMaybeCoins(t.totalActionFees),
      e.storeInt(t.resultCode, 32),
      e.storeMaybeInt(t.resultArg, 32),
      e.storeUint(t.totalActions, 16),
      e.storeUint(t.specActions, 16),
      e.storeUint(t.skippedActions, 16),
      e.storeUint(t.messagesCreated, 16),
      e.storeUint(t.actionListHash, 256),
      e.store((0, j3.storeStorageUsedShort)(t.totalMessageSize));
  };
}
Xa.storeTransactionActionPhase = KE;
var es = {};
Object.defineProperty(es, "__esModule", { value: !0 });
es.storeTransactionBouncePhase = es.loadTransactionBouncePhase = void 0;
const Jl = na;
function ZE(t) {
  if (t.loadBit()) {
    let e = (0, Jl.loadStorageUsedShort)(t),
      n = t.loadCoins(),
      i = t.loadCoins();
    return {
      type: "ok",
      messageSize: e,
      messageFees: n,
      forwardFees: i,
    };
  }
  if (t.loadBit()) {
    let e = (0, Jl.loadStorageUsedShort)(t),
      n = t.loadCoins();
    return {
      type: "no-funds",
      messageSize: e,
      requiredForwardFees: n,
    };
  }
  return {
    type: "negative-funds",
  };
}
es.loadTransactionBouncePhase = ZE;
function GE(t) {
  return (e) => {
    if (t.type === "ok")
      e.storeBit(!0),
        e.store((0, Jl.storeStorageUsedShort)(t.messageSize)),
        e.storeCoins(t.messageFees),
        e.storeCoins(t.forwardFees);
    else if (t.type === "negative-funds") e.storeBit(!1), e.storeBit(!1);
    else if (t.type === "no-funds")
      e.storeBit(!1),
        e.storeBit(!0),
        e.store((0, Jl.storeStorageUsedShort)(t.messageSize)),
        e.storeCoins(t.requiredForwardFees);
    else throw new Error("Invalid TransactionBouncePhase type");
  };
}
es.storeTransactionBouncePhase = GE;
var ts = {};
Object.defineProperty(ts, "__esModule", { value: !0 });
ts.storeTransactionComputePhase = ts.loadTransactionComputePhase = void 0;
const YE = _r(),
  $3 = Ka;
function JE(t) {
  if (!t.loadBit())
    return {
      type: "skipped",
      reason: (0, $3.loadComputeSkipReason)(t),
    };
  let e = t.loadBit(),
    n = t.loadBit(),
    i = t.loadBit(),
    l = t.loadCoins();
  const a = t.loadRef().beginParse();
  let c = a.loadVarUintBig(3),
    v = a.loadVarUintBig(3),
    g = a.loadBit() ? a.loadVarUintBig(2) : void 0,
    b = a.loadUint(8),
    p = a.loadInt(32),
    _ = a.loadBit() ? a.loadInt(32) : void 0,
    M = a.loadUint(32),
    S = a.loadUintBig(256),
    A = a.loadUintBig(256);
  return {
    type: "vm",
    success: e,
    messageStateUsed: n,
    accountActivated: i,
    gasFees: l,
    gasUsed: c,
    gasLimit: v,
    gasCredit: g,
    mode: b,
    exitCode: p,
    exitArg: _,
    vmSteps: M,
    vmInitStateHash: S,
    vmFinalStateHash: A,
  };
}
ts.loadTransactionComputePhase = JE;
function QE(t) {
  return (e) => {
    if (t.type === "skipped") {
      e.storeBit(0), e.store((0, $3.storeComputeSkipReason)(t.reason));
      return;
    }
    e.storeBit(1),
      e.storeBit(t.success),
      e.storeBit(t.messageStateUsed),
      e.storeBit(t.accountActivated),
      e.storeCoins(t.gasFees),
      e.storeRef(
        (0, YE.beginCell)()
          .storeVarUint(t.gasUsed, 3)
          .storeVarUint(t.gasLimit, 3)
          .store((n) =>
            t.gasCredit !== void 0 && t.gasCredit !== null
              ? n.storeBit(1).storeVarUint(t.gasCredit, 2)
              : n.storeBit(0)
          )
          .storeUint(t.mode, 8)
          .storeInt(t.exitCode, 32)
          .store((n) =>
            t.exitArg !== void 0 && t.exitArg !== null
              ? n.storeBit(1).storeInt(t.exitArg, 32)
              : n.storeBit(0)
          )
          .storeUint(t.vmSteps, 32)
          .storeUint(t.vmInitStateHash, 256)
          .storeUint(t.vmFinalStateHash, 256)
          .endCell()
      );
  };
}
ts.storeTransactionComputePhase = QE;
var rs = {};
Object.defineProperty(rs, "__esModule", { value: !0 });
rs.storeTransactionCreditPhase = rs.loadTransactionCreditPhase = void 0;
const H3 = hn;
function XE(t) {
  const e = t.loadBit() ? t.loadCoins() : void 0,
    n = (0, H3.loadCurrencyCollection)(t);
  return {
    dueFeesColelcted: e,
    credit: n,
  };
}
rs.loadTransactionCreditPhase = XE;
function eA(t) {
  return (e) => {
    t.dueFeesColelcted === null || t.dueFeesColelcted === void 0
      ? e.storeBit(!1)
      : (e.storeBit(!0), e.storeCoins(t.dueFeesColelcted)),
      e.store((0, H3.storeCurrencyCollection)(t.credit));
  };
}
rs.storeTransactionCreditPhase = eA;
var ns = {};
Object.defineProperty(ns, "__esModule", { value: !0 });
ns.storeTransactionsStoragePhase = ns.loadTransactionStoragePhase = void 0;
const V3 = ra;
function tA(t) {
  const e = t.loadCoins();
  let n;
  t.loadBit() && (n = t.loadCoins());
  const i = (0, V3.loadAccountStatusChange)(t);
  return {
    storageFeesCollected: e,
    storageFeesDue: n,
    statusChange: i,
  };
}
ns.loadTransactionStoragePhase = tA;
function rA(t) {
  return (e) => {
    e.storeCoins(t.storageFeesCollected),
      t.storageFeesDue === null || t.storageFeesDue === void 0
        ? e.storeBit(!1)
        : (e.storeBit(!0), e.storeCoins(t.storageFeesDue)),
      e.store((0, V3.storeAccountStatusChange)(t.statusChange));
  };
}
ns.storeTransactionsStoragePhase = rA;
var Jb;
function W3() {
  if (Jb) return ma;
  (Jb = 1),
    Object.defineProperty(ma, "__esModule", { value: !0 }),
    (ma.storeTransactionDescription = ma.loadTransactionDescription = void 0);
  const t = _r(),
    e = Qa,
    n = K3(),
    i = Xa,
    l = es,
    a = ts,
    c = rs,
    v = ns;
  function g(p) {
    let _ = p.loadUint(4);
    if (_ === 0) {
      const M = p.loadBit();
      let S;
      p.loadBit() && (S = (0, v.loadTransactionStoragePhase)(p));
      let A;
      p.loadBit() && (A = (0, c.loadTransactionCreditPhase)(p));
      let k = (0, a.loadTransactionComputePhase)(p),
        P;
      p.loadBit() && (P = (0, i.loadTransactionActionPhase)(p.loadRef().beginParse()));
      let B = p.loadBit(),
        T;
      p.loadBit() && (T = (0, l.loadTransactionBouncePhase)(p));
      const F = p.loadBit();
      return {
        type: "generic",
        creditFirst: M,
        storagePhase: S,
        creditPhase: A,
        computePhase: k,
        actionPhase: P,
        bouncePhase: T,
        aborted: B,
        destroyed: F,
      };
    }
    if (_ === 1)
      return {
        type: "storage",
        storagePhase: (0, v.loadTransactionStoragePhase)(p),
      };
    if (_ === 2 || _ === 3) {
      const M = _ === 3;
      let S = (0, v.loadTransactionStoragePhase)(p),
        A = (0, a.loadTransactionComputePhase)(p),
        k;
      p.loadBit() && (k = (0, i.loadTransactionActionPhase)(p.loadRef().beginParse()));
      const P = p.loadBit(),
        B = p.loadBit();
      return {
        type: "tick-tock",
        isTock: M,
        storagePhase: S,
        computePhase: A,
        actionPhase: k,
        aborted: P,
        destroyed: B,
      };
    }
    if (_ === 4) {
      let M = (0, e.loadSplitMergeInfo)(p),
        S;
      p.loadBit() && (S = (0, v.loadTransactionStoragePhase)(p));
      let A = (0, a.loadTransactionComputePhase)(p),
        k;
      p.loadBit() && (k = (0, i.loadTransactionActionPhase)(p.loadRef().beginParse()));
      const P = p.loadBit(),
        B = p.loadBit();
      return {
        type: "split-prepare",
        splitInfo: M,
        storagePhase: S,
        computePhase: A,
        actionPhase: k,
        aborted: P,
        destroyed: B,
      };
    }
    if (_ === 5) {
      let M = (0, e.loadSplitMergeInfo)(p),
        S = (0, n.loadTransaction)(p.loadRef().beginParse());
      const A = p.loadBit();
      return {
        type: "split-install",
        splitInfo: M,
        prepareTransaction: S,
        installed: A,
      };
    }
    throw Error(`Unsupported transaction description type ${_}`);
  }
  ma.loadTransactionDescription = g;
  function b(p) {
    return (_) => {
      if (p.type === "generic")
        _.storeUint(0, 4),
          _.storeBit(p.creditFirst),
          p.storagePhase
            ? (_.storeBit(!0), _.store((0, v.storeTransactionsStoragePhase)(p.storagePhase)))
            : _.storeBit(!1),
          p.creditPhase
            ? (_.storeBit(!0), _.store((0, c.storeTransactionCreditPhase)(p.creditPhase)))
            : _.storeBit(!1),
          _.store((0, a.storeTransactionComputePhase)(p.computePhase)),
          p.actionPhase
            ? (_.storeBit(!0),
              _.storeRef(
                (0, t.beginCell)().store((0, i.storeTransactionActionPhase)(p.actionPhase))
              ))
            : _.storeBit(!1),
          _.storeBit(p.aborted),
          p.bouncePhase
            ? (_.storeBit(!0), _.store((0, l.storeTransactionBouncePhase)(p.bouncePhase)))
            : _.storeBit(!1),
          _.storeBit(p.destroyed);
      else if (p.type === "storage")
        _.storeUint(1, 4), _.store((0, v.storeTransactionsStoragePhase)(p.storagePhase));
      else if (p.type === "tick-tock")
        _.storeUint(p.isTock ? 3 : 2, 4),
          _.store((0, v.storeTransactionsStoragePhase)(p.storagePhase)),
          _.store((0, a.storeTransactionComputePhase)(p.computePhase)),
          p.actionPhase
            ? (_.storeBit(!0),
              _.storeRef(
                (0, t.beginCell)().store((0, i.storeTransactionActionPhase)(p.actionPhase))
              ))
            : _.storeBit(!1),
          _.storeBit(p.aborted),
          _.storeBit(p.destroyed);
      else if (p.type === "split-prepare")
        _.storeUint(4, 4),
          _.store((0, e.storeSplitMergeInfo)(p.splitInfo)),
          p.storagePhase
            ? (_.storeBit(!0), _.store((0, v.storeTransactionsStoragePhase)(p.storagePhase)))
            : _.storeBit(!1),
          _.store((0, a.storeTransactionComputePhase)(p.computePhase)),
          p.actionPhase
            ? (_.storeBit(!0), _.store((0, i.storeTransactionActionPhase)(p.actionPhase)))
            : _.storeBit(!1),
          _.storeBit(p.aborted),
          _.storeBit(p.destroyed);
      else if (p.type === "split-install")
        _.storeUint(5, 4),
          _.store((0, e.storeSplitMergeInfo)(p.splitInfo)),
          _.storeRef((0, t.beginCell)().store((0, n.storeTransaction)(p.prepareTransaction))),
          _.storeBit(p.installed);
      else throw Error(`Unsupported transaction description type ${p.type}`);
    };
  }
  return (ma.storeTransactionDescription = b), ma;
}
var Qb;
function K3() {
  if (Qb) return pa;
  (Qb = 1),
    Object.defineProperty(pa, "__esModule", { value: !0 }),
    (pa.storeTransaction = pa.loadTransaction = void 0);
  const t = _r(),
    e = as(),
    n = $a,
    i = hn,
    l = Ga,
    a = xi,
    c = W3();
  function v(b) {
    let p = b.asCell();
    if (b.loadUint(4) !== 7) throw Error("Invalid data");
    let _ = b.loadUintBig(256),
      M = b.loadUintBig(64),
      S = b.loadUintBig(256),
      A = b.loadUintBig(64),
      k = b.loadUint(32),
      P = b.loadUint(15),
      B = (0, n.loadAccountStatus)(b),
      T = (0, n.loadAccountStatus)(b),
      O = b.loadRef().beginParse(),
      $ = O.loadBit() ? (0, a.loadMessage)(O.loadRef().beginParse()) : void 0,
      J = O.loadDict(e.Dictionary.Keys.Uint(15), a.MessageValue);
    O.endParse();
    let he = (0, i.loadCurrencyCollection)(b),
      de = (0, l.loadHashUpdate)(b.loadRef().beginParse()),
      ne = (0, c.loadTransactionDescription)(b.loadRef().beginParse());
    return {
      address: _,
      lt: M,
      prevTransactionHash: S,
      prevTransactionLt: A,
      now: k,
      outMessagesCount: P,
      oldStatus: B,
      endStatus: T,
      inMessage: $,
      outMessages: J,
      totalFees: he,
      stateUpdate: de,
      description: ne,
      raw: p,
      hash: () => p.hash(),
    };
  }
  pa.loadTransaction = v;
  function g(b) {
    return (p) => {
      p.storeUint(7, 4),
        p.storeUint(b.address, 256),
        p.storeUint(b.lt, 64),
        p.storeUint(b.prevTransactionHash, 256),
        p.storeUint(b.prevTransactionLt, 64),
        p.storeUint(b.now, 32),
        p.storeUint(b.outMessagesCount, 15),
        p.store((0, n.storeAccountStatus)(b.oldStatus)),
        p.store((0, n.storeAccountStatus)(b.endStatus));
      let _ = (0, t.beginCell)();
      b.inMessage
        ? (_.storeBit(!0), _.storeRef((0, t.beginCell)().store((0, a.storeMessage)(b.inMessage))))
        : _.storeBit(!1),
        _.storeDict(b.outMessages),
        p.storeRef(_),
        p.store((0, i.storeCurrencyCollection)(b.totalFees)),
        p.storeRef((0, t.beginCell)().store((0, l.storeHashUpdate)(b.stateUpdate))),
        p.storeRef((0, t.beginCell)().store((0, c.storeTransactionDescription)(b.description)));
    };
  }
  return (pa.storeTransaction = g), pa;
}
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.loadStorageInfo =
      t.storeStateInit =
      t.loadStateInit =
      t.storeSplitMergeInfo =
      t.loadSplitMergeInfo =
      t.storeSimpleLibrary =
      t.loadSimpleLibrary =
      t.loadShardStateUnsplit =
      t.storeShardIdent =
      t.loadShardIdent =
      t.storeShardAccounts =
      t.loadShardAccounts =
      t.ShardAccountRefValue =
      t.storeShardAccount =
      t.loadShardAccount =
      t.SendMode =
      t.storeMessageRelaxed =
      t.loadMessageRelaxed =
      t.storeMessage =
      t.loadMessage =
      t.loadMasterchainStateExtra =
      t.storeHashUpdate =
      t.loadHashUpdate =
      t.storeDepthBalanceInfo =
      t.loadDepthBalanceInfo =
      t.storeCurrencyCollection =
      t.loadCurrencyCollection =
      t.storeComputeSkipReason =
      t.loadComputeSkipReason =
      t.storeCommonMessageInfoRelaxed =
      t.loadCommonMessageInfoRelaxed =
      t.storeCommonMessageInfo =
      t.loadCommonMessageInfo =
      t.storeOutList =
      t.loadOutList =
      t.storeOutAction =
      t.loadOutAction =
      t.storeAccountStorage =
      t.loadAccountStorage =
      t.storeAccountStatusChange =
      t.loadAccountStatusChange =
      t.storeAccountStatus =
      t.loadAccountStatus =
      t.storeAccountState =
      t.loadAccountState =
      t.storeAccount =
      t.loadAccount =
      t.comment =
      t.external =
      t.internal =
        void 0),
    (t.storeTransactionsStoragePhase =
      t.loadTransactionStoragePhase =
      t.storeTransactionDescription =
      t.loadTransactionDescription =
      t.storeTransactionCreditPhase =
      t.loadTransactionCreditPhase =
      t.storeTransactionComputePhase =
      t.loadTransactionComputePhase =
      t.storeTransactionBouncePhase =
      t.loadTransactionBouncePhase =
      t.storeTransactionActionPhase =
      t.loadTransactionActionPhase =
      t.storeTransaction =
      t.loadTransaction =
      t.storeTickTock =
      t.loadTickTock =
      t.storeStorageUsedShort =
      t.loadStorageUsedShort =
      t.storeStorageUsed =
      t.loadStorageUsed =
      t.storeStorageInfo =
        void 0);
  var e = ea;
  Object.defineProperty(t, "internal", {
    enumerable: !0,
    get: function () {
      return e.internal;
    },
  }),
    Object.defineProperty(t, "external", {
      enumerable: !0,
      get: function () {
        return e.external;
      },
    }),
    Object.defineProperty(t, "comment", {
      enumerable: !0,
      get: function () {
        return e.comment;
      },
    });
  var n = La;
  Object.defineProperty(t, "loadAccount", {
    enumerable: !0,
    get: function () {
      return n.loadAccount;
    },
  }),
    Object.defineProperty(t, "storeAccount", {
      enumerable: !0,
      get: function () {
        return n.storeAccount;
      },
    });
  var i = qa;
  Object.defineProperty(t, "loadAccountState", {
    enumerable: !0,
    get: function () {
      return i.loadAccountState;
    },
  }),
    Object.defineProperty(t, "storeAccountState", {
      enumerable: !0,
      get: function () {
        return i.storeAccountState;
      },
    });
  var l = $a;
  Object.defineProperty(t, "loadAccountStatus", {
    enumerable: !0,
    get: function () {
      return l.loadAccountStatus;
    },
  }),
    Object.defineProperty(t, "storeAccountStatus", {
      enumerable: !0,
      get: function () {
        return l.storeAccountStatus;
      },
    });
  var a = ra;
  Object.defineProperty(t, "loadAccountStatusChange", {
    enumerable: !0,
    get: function () {
      return a.loadAccountStatusChange;
    },
  }),
    Object.defineProperty(t, "storeAccountStatusChange", {
      enumerable: !0,
      get: function () {
        return a.storeAccountStatusChange;
      },
    });
  var c = Fa;
  Object.defineProperty(t, "loadAccountStorage", {
    enumerable: !0,
    get: function () {
      return c.loadAccountStorage;
    },
  }),
    Object.defineProperty(t, "storeAccountStorage", {
      enumerable: !0,
      get: function () {
        return c.storeAccountStorage;
      },
    });
  var v = Wn;
  Object.defineProperty(t, "loadOutAction", {
    enumerable: !0,
    get: function () {
      return v.loadOutAction;
    },
  }),
    Object.defineProperty(t, "storeOutAction", {
      enumerable: !0,
      get: function () {
        return v.storeOutAction;
      },
    }),
    Object.defineProperty(t, "loadOutList", {
      enumerable: !0,
      get: function () {
        return v.loadOutList;
      },
    }),
    Object.defineProperty(t, "storeOutList", {
      enumerable: !0,
      get: function () {
        return v.storeOutList;
      },
    });
  var g = Wa;
  Object.defineProperty(t, "loadCommonMessageInfo", {
    enumerable: !0,
    get: function () {
      return g.loadCommonMessageInfo;
    },
  }),
    Object.defineProperty(t, "storeCommonMessageInfo", {
      enumerable: !0,
      get: function () {
        return g.storeCommonMessageInfo;
      },
    });
  var b = Va;
  Object.defineProperty(t, "loadCommonMessageInfoRelaxed", {
    enumerable: !0,
    get: function () {
      return b.loadCommonMessageInfoRelaxed;
    },
  }),
    Object.defineProperty(t, "storeCommonMessageInfoRelaxed", {
      enumerable: !0,
      get: function () {
        return b.storeCommonMessageInfoRelaxed;
      },
    });
  var p = Ka;
  Object.defineProperty(t, "loadComputeSkipReason", {
    enumerable: !0,
    get: function () {
      return p.loadComputeSkipReason;
    },
  }),
    Object.defineProperty(t, "storeComputeSkipReason", {
      enumerable: !0,
      get: function () {
        return p.storeComputeSkipReason;
      },
    });
  var _ = hn;
  Object.defineProperty(t, "loadCurrencyCollection", {
    enumerable: !0,
    get: function () {
      return _.loadCurrencyCollection;
    },
  }),
    Object.defineProperty(t, "storeCurrencyCollection", {
      enumerable: !0,
      get: function () {
        return _.storeCurrencyCollection;
      },
    });
  var M = Za;
  Object.defineProperty(t, "loadDepthBalanceInfo", {
    enumerable: !0,
    get: function () {
      return M.loadDepthBalanceInfo;
    },
  }),
    Object.defineProperty(t, "storeDepthBalanceInfo", {
      enumerable: !0,
      get: function () {
        return M.storeDepthBalanceInfo;
      },
    });
  var S = Ga;
  Object.defineProperty(t, "loadHashUpdate", {
    enumerable: !0,
    get: function () {
      return S.loadHashUpdate;
    },
  }),
    Object.defineProperty(t, "storeHashUpdate", {
      enumerable: !0,
      get: function () {
        return S.storeHashUpdate;
      },
    });
  var A = Of;
  Object.defineProperty(t, "loadMasterchainStateExtra", {
    enumerable: !0,
    get: function () {
      return A.loadMasterchainStateExtra;
    },
  });
  var k = xi;
  Object.defineProperty(t, "loadMessage", {
    enumerable: !0,
    get: function () {
      return k.loadMessage;
    },
  }),
    Object.defineProperty(t, "storeMessage", {
      enumerable: !0,
      get: function () {
        return k.storeMessage;
      },
    });
  var P = Ha;
  Object.defineProperty(t, "loadMessageRelaxed", {
    enumerable: !0,
    get: function () {
      return P.loadMessageRelaxed;
    },
  }),
    Object.defineProperty(t, "storeMessageRelaxed", {
      enumerable: !0,
      get: function () {
        return P.storeMessageRelaxed;
      },
    });
  var B = F3;
  Object.defineProperty(t, "SendMode", {
    enumerable: !0,
    get: function () {
      return B.SendMode;
    },
  });
  var T = Ya;
  Object.defineProperty(t, "loadShardAccount", {
    enumerable: !0,
    get: function () {
      return T.loadShardAccount;
    },
  }),
    Object.defineProperty(t, "storeShardAccount", {
      enumerable: !0,
      get: function () {
        return T.storeShardAccount;
      },
    });
  var F = q1;
  Object.defineProperty(t, "ShardAccountRefValue", {
    enumerable: !0,
    get: function () {
      return F.ShardAccountRefValue;
    },
  }),
    Object.defineProperty(t, "loadShardAccounts", {
      enumerable: !0,
      get: function () {
        return F.loadShardAccounts;
      },
    }),
    Object.defineProperty(t, "storeShardAccounts", {
      enumerable: !0,
      get: function () {
        return F.storeShardAccounts;
      },
    });
  var O = Ja;
  Object.defineProperty(t, "loadShardIdent", {
    enumerable: !0,
    get: function () {
      return O.loadShardIdent;
    },
  }),
    Object.defineProperty(t, "storeShardIdent", {
      enumerable: !0,
      get: function () {
        return O.storeShardIdent;
      },
    });
  var $ = $u;
  Object.defineProperty(t, "loadShardStateUnsplit", {
    enumerable: !0,
    get: function () {
      return $.loadShardStateUnsplit;
    },
  });
  var J = _i;
  Object.defineProperty(t, "loadSimpleLibrary", {
    enumerable: !0,
    get: function () {
      return J.loadSimpleLibrary;
    },
  }),
    Object.defineProperty(t, "storeSimpleLibrary", {
      enumerable: !0,
      get: function () {
        return J.storeSimpleLibrary;
      },
    });
  var he = Qa;
  Object.defineProperty(t, "loadSplitMergeInfo", {
    enumerable: !0,
    get: function () {
      return he.loadSplitMergeInfo;
    },
  }),
    Object.defineProperty(t, "storeSplitMergeInfo", {
      enumerable: !0,
      get: function () {
        return he.storeSplitMergeInfo;
      },
    });
  var de = Xn;
  Object.defineProperty(t, "loadStateInit", {
    enumerable: !0,
    get: function () {
      return de.loadStateInit;
    },
  }),
    Object.defineProperty(t, "storeStateInit", {
      enumerable: !0,
      get: function () {
        return de.storeStateInit;
      },
    });
  var ne = za;
  Object.defineProperty(t, "loadStorageInfo", {
    enumerable: !0,
    get: function () {
      return ne.loadStorageInfo;
    },
  }),
    Object.defineProperty(t, "storeStorageInfo", {
      enumerable: !0,
      get: function () {
        return ne.storeStorageInfo;
      },
    });
  var Ae = ja;
  Object.defineProperty(t, "loadStorageUsed", {
    enumerable: !0,
    get: function () {
      return Ae.loadStorageUsed;
    },
  }),
    Object.defineProperty(t, "storeStorageUsed", {
      enumerable: !0,
      get: function () {
        return Ae.storeStorageUsed;
      },
    });
  var x = na;
  Object.defineProperty(t, "loadStorageUsedShort", {
    enumerable: !0,
    get: function () {
      return x.loadStorageUsedShort;
    },
  }),
    Object.defineProperty(t, "storeStorageUsedShort", {
      enumerable: !0,
      get: function () {
        return x.storeStorageUsedShort;
      },
    });
  var r = Na;
  Object.defineProperty(t, "loadTickTock", {
    enumerable: !0,
    get: function () {
      return r.loadTickTock;
    },
  }),
    Object.defineProperty(t, "storeTickTock", {
      enumerable: !0,
      get: function () {
        return r.storeTickTock;
      },
    });
  var o = K3();
  Object.defineProperty(t, "loadTransaction", {
    enumerable: !0,
    get: function () {
      return o.loadTransaction;
    },
  }),
    Object.defineProperty(t, "storeTransaction", {
      enumerable: !0,
      get: function () {
        return o.storeTransaction;
      },
    });
  var f = Xa;
  Object.defineProperty(t, "loadTransactionActionPhase", {
    enumerable: !0,
    get: function () {
      return f.loadTransactionActionPhase;
    },
  }),
    Object.defineProperty(t, "storeTransactionActionPhase", {
      enumerable: !0,
      get: function () {
        return f.storeTransactionActionPhase;
      },
    });
  var u = es;
  Object.defineProperty(t, "loadTransactionBouncePhase", {
    enumerable: !0,
    get: function () {
      return u.loadTransactionBouncePhase;
    },
  }),
    Object.defineProperty(t, "storeTransactionBouncePhase", {
      enumerable: !0,
      get: function () {
        return u.storeTransactionBouncePhase;
      },
    });
  var d = ts;
  Object.defineProperty(t, "loadTransactionComputePhase", {
    enumerable: !0,
    get: function () {
      return d.loadTransactionComputePhase;
    },
  }),
    Object.defineProperty(t, "storeTransactionComputePhase", {
      enumerable: !0,
      get: function () {
        return d.storeTransactionComputePhase;
      },
    });
  var y = rs;
  Object.defineProperty(t, "loadTransactionCreditPhase", {
    enumerable: !0,
    get: function () {
      return y.loadTransactionCreditPhase;
    },
  }),
    Object.defineProperty(t, "storeTransactionCreditPhase", {
      enumerable: !0,
      get: function () {
        return y.storeTransactionCreditPhase;
      },
    });
  var w = W3();
  Object.defineProperty(t, "loadTransactionDescription", {
    enumerable: !0,
    get: function () {
      return w.loadTransactionDescription;
    },
  }),
    Object.defineProperty(t, "storeTransactionDescription", {
      enumerable: !0,
      get: function () {
        return w.storeTransactionDescription;
      },
    });
  var h = ns;
  Object.defineProperty(t, "loadTransactionStoragePhase", {
    enumerable: !0,
    get: function () {
      return h.loadTransactionStoragePhase;
    },
  }),
    Object.defineProperty(t, "storeTransactionsStoragePhase", {
      enumerable: !0,
      get: function () {
        return h.storeTransactionsStoragePhase;
      },
    });
})(g3);
var Hu = {};
Object.defineProperty(Hu, "__esModule", { value: !0 });
Hu.openContract = void 0;
const nA = cn,
  Xb = os();
function iA(t, e) {
  let n,
    i = null;
  if (!nA.Address.isAddress(t.address)) throw Error("Invalid address");
  if (((n = t.address), t.init)) {
    if (!(t.init.code instanceof Xb.Cell)) throw Error("Invalid init.code");
    if (!(t.init.data instanceof Xb.Cell)) throw Error("Invalid init.data");
    i = t.init;
  }
  let l = e({ address: n, init: i });
  return new Proxy(t, {
    get(a, c) {
      const v = a[c];
      return typeof c == "string" &&
        (c.startsWith("get") || c.startsWith("send")) &&
        typeof v == "function"
        ? (...g) => v.apply(a, [l, ...g])
        : v;
    },
  });
}
Hu.openContract = iA;
var Vu = {};
Object.defineProperty(Vu, "__esModule", { value: !0 });
Vu.ComputeError = void 0;
class z1 extends Error {
  constructor(e, n, i) {
    super(e),
      (this.exitCode = n),
      (this.debugLogs = i && i.debugLogs ? i.debugLogs : null),
      (this.logs = i && i.logs ? i.logs : null),
      Object.setPrototypeOf(this, z1.prototype);
  }
}
Vu.ComputeError = z1;
var Wu = {};
Object.defineProperty(Wu, "__esModule", { value: !0 });
Wu.getMethodId = void 0;
const aA = new Int16Array([
  0, 4129, 8258, 12387, 16516, 20645, 24774, 28903, 33032, 37161, 41290, 45419, 49548, 53677, 57806,
  61935, 4657, 528, 12915, 8786, 21173, 17044, 29431, 25302, 37689, 33560, 45947, 41818, 54205,
  50076, 62463, 58334, 9314, 13379, 1056, 5121, 25830, 29895, 17572, 21637, 42346, 46411, 34088,
  38153, 58862, 62927, 50604, 54669, 13907, 9842, 5649, 1584, 30423, 26358, 22165, 18100, 46939,
  42874, 38681, 34616, 63455, 59390, 55197, 51132, 18628, 22757, 26758, 30887, 2112, 6241, 10242,
  14371, 51660, 55789, 59790, 63919, 35144, 39273, 43274, 47403, 23285, 19156, 31415, 27286, 6769,
  2640, 14899, 10770, 56317, 52188, 64447, 60318, 39801, 35672, 47931, 43802, 27814, 31879, 19684,
  23749, 11298, 15363, 3168, 7233, 60846, 64911, 52716, 56781, 44330, 48395, 36200, 40265, 32407,
  28342, 24277, 20212, 15891, 11826, 7761, 3696, 65439, 61374, 57309, 53244, 48923, 44858, 40793,
  36728, 37256, 33193, 45514, 41451, 53516, 49453, 61774, 57711, 4224, 161, 12482, 8419, 20484,
  16421, 28742, 24679, 33721, 37784, 41979, 46042, 49981, 54044, 58239, 62302, 689, 4752, 8947,
  13010, 16949, 21012, 25207, 29270, 46570, 42443, 38312, 34185, 62830, 58703, 54572, 50445, 13538,
  9411, 5280, 1153, 29798, 25671, 21540, 17413, 42971, 47098, 34713, 38840, 59231, 63358, 50973,
  55100, 9939, 14066, 1681, 5808, 26199, 30326, 17941, 22068, 55628, 51565, 63758, 59695, 39368,
  35305, 47498, 43435, 22596, 18533, 30726, 26663, 6336, 2273, 14466, 10403, 52093, 56156, 60223,
  64286, 35833, 39896, 43963, 48026, 19061, 23124, 27191, 31254, 2801, 6864, 10931, 14994, 64814,
  60687, 56684, 52557, 48554, 44427, 40424, 36297, 31782, 27655, 23652, 19525, 15522, 11395, 7392,
  3265, 61215, 65342, 53085, 57212, 44955, 49082, 36825, 40952, 28183, 32310, 20053, 24180, 11923,
  16050, 3793, 7920,
]);
function sA(t) {
  t instanceof Qe || (t = Qe.from(t));
  let e = 0;
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    e = (aA[((e >> 8) ^ i) & 255] ^ (e << 8)) & 65535;
  }
  return e;
}
function oA(t) {
  return (sA(t) & 65535) | 65536;
}
Wu.getMethodId = oA;
var js = {};
Object.defineProperty(js, "__esModule", { value: !0 });
js.safeSignVerify = js.safeSign = void 0;
const j1 = ss(),
  fA = 8,
  lA = 64;
function Z3(t, e) {
  let n = Qe.from(e);
  if (n.length > lA) throw Error("Seed can	 be longer than 64 bytes");
  if (n.length < fA) throw Error("Seed must be at least 8 bytes");
  return (0, j1.sha256_sync)(Qe.concat([Qe.from([255, 255]), n, t.hash()]));
}
function uA(t, e, n = "ton-safe-sign-magic") {
  return (0, j1.sign)(Z3(t, n), e);
}
js.safeSign = uA;
function cA(t, e, n, i = "ton-safe-sign-magic") {
  return (0, j1.signVerify)(Z3(t, i), e, n);
}
js.safeSignVerify = cA;
(function (t) {
  var e =
      (mt && mt.__createBinding) ||
      (Object.create
        ? function (u, d, y, w) {
            w === void 0 && (w = y);
            var h = Object.getOwnPropertyDescriptor(d, y);
            (!h || ("get" in h ? !d.__esModule : h.writable || h.configurable)) &&
              (h = {
                enumerable: !0,
                get: function () {
                  return d[y];
                },
              }),
              Object.defineProperty(u, w, h);
          }
        : function (u, d, y, w) {
            w === void 0 && (w = y), (u[w] = d[y]);
          }),
    n =
      (mt && mt.__exportStar) ||
      function (u, d) {
        for (var y in u)
          y !== "default" && !Object.prototype.hasOwnProperty.call(d, y) && e(d, u, y);
      };
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.safeSignVerify =
      t.safeSign =
      t.getMethodId =
      t.base32Encode =
      t.base32Decode =
      t.crc32c =
      t.crc16 =
      t.fromNano =
      t.toNano =
      t.ComputeError =
      t.openContract =
      t.TupleBuilder =
      t.TupleReader =
      t.serializeTuple =
      t.parseTuple =
      t.generateMerkleUpdate =
      t.generateMerkleProof =
      t.exoticPruned =
      t.exoticMerkleUpdate =
      t.exoticMerkleProof =
      t.Dictionary =
      t.Cell =
      t.CellType =
      t.Slice =
      t.beginCell =
      t.Builder =
      t.BitBuilder =
      t.BitReader =
      t.BitString =
      t.contractAddress =
      t.ADNLAddress =
      t.ExternalAddress =
      t.address =
      t.Address =
        void 0);
  var i = cn;
  Object.defineProperty(t, "Address", {
    enumerable: !0,
    get: function () {
      return i.Address;
    },
  }),
    Object.defineProperty(t, "address", {
      enumerable: !0,
      get: function () {
        return i.address;
      },
    });
  var l = Xs;
  Object.defineProperty(t, "ExternalAddress", {
    enumerable: !0,
    get: function () {
      return l.ExternalAddress;
    },
  });
  var a = pu;
  Object.defineProperty(t, "ADNLAddress", {
    enumerable: !0,
    get: function () {
      return a.ADNLAddress;
    },
  });
  var c = mu;
  Object.defineProperty(t, "contractAddress", {
    enumerable: !0,
    get: function () {
      return c.contractAddress;
    },
  });
  var v = oa();
  Object.defineProperty(t, "BitString", {
    enumerable: !0,
    get: function () {
      return v.BitString;
    },
  });
  var g = On;
  Object.defineProperty(t, "BitReader", {
    enumerable: !0,
    get: function () {
      return g.BitReader;
    },
  });
  var b = gu();
  Object.defineProperty(t, "BitBuilder", {
    enumerable: !0,
    get: function () {
      return b.BitBuilder;
    },
  });
  var p = _r();
  Object.defineProperty(t, "Builder", {
    enumerable: !0,
    get: function () {
      return p.Builder;
    },
  }),
    Object.defineProperty(t, "beginCell", {
      enumerable: !0,
      get: function () {
        return p.beginCell;
      },
    });
  var _ = d1();
  Object.defineProperty(t, "Slice", {
    enumerable: !0,
    get: function () {
      return _.Slice;
    },
  });
  var M = eo;
  Object.defineProperty(t, "CellType", {
    enumerable: !0,
    get: function () {
      return M.CellType;
    },
  });
  var S = os();
  Object.defineProperty(t, "Cell", {
    enumerable: !0,
    get: function () {
      return S.Cell;
    },
  });
  var A = as();
  Object.defineProperty(t, "Dictionary", {
    enumerable: !0,
    get: function () {
      return A.Dictionary;
    },
  });
  var k = to;
  Object.defineProperty(t, "exoticMerkleProof", {
    enumerable: !0,
    get: function () {
      return k.exoticMerkleProof;
    },
  });
  var P = ro;
  Object.defineProperty(t, "exoticMerkleUpdate", {
    enumerable: !0,
    get: function () {
      return P.exoticMerkleUpdate;
    },
  });
  var B = no;
  Object.defineProperty(t, "exoticPruned", {
    enumerable: !0,
    get: function () {
      return B.exoticPruned;
    },
  });
  var T = h1();
  Object.defineProperty(t, "generateMerkleProof", {
    enumerable: !0,
    get: function () {
      return T.generateMerkleProof;
    },
  });
  var F = F6();
  Object.defineProperty(t, "generateMerkleUpdate", {
    enumerable: !0,
    get: function () {
      return F.generateMerkleUpdate;
    },
  });
  var O = zs;
  Object.defineProperty(t, "parseTuple", {
    enumerable: !0,
    get: function () {
      return O.parseTuple;
    },
  }),
    Object.defineProperty(t, "serializeTuple", {
      enumerable: !0,
      get: function () {
        return O.serializeTuple;
      },
    });
  var $ = zu;
  Object.defineProperty(t, "TupleReader", {
    enumerable: !0,
    get: function () {
      return $.TupleReader;
    },
  });
  var J = ju;
  Object.defineProperty(t, "TupleBuilder", {
    enumerable: !0,
    get: function () {
      return J.TupleBuilder;
    },
  }),
    n(g3, t);
  var he = Hu;
  Object.defineProperty(t, "openContract", {
    enumerable: !0,
    get: function () {
      return he.openContract;
    },
  });
  var de = Vu;
  Object.defineProperty(t, "ComputeError", {
    enumerable: !0,
    get: function () {
      return de.ComputeError;
    },
  });
  var ne = Da;
  Object.defineProperty(t, "toNano", {
    enumerable: !0,
    get: function () {
      return ne.toNano;
    },
  }),
    Object.defineProperty(t, "fromNano", {
      enumerable: !0,
      get: function () {
        return ne.fromNano;
      },
    });
  var Ae = Qs;
  Object.defineProperty(t, "crc16", {
    enumerable: !0,
    get: function () {
      return Ae.crc16;
    },
  });
  var x = If;
  Object.defineProperty(t, "crc32c", {
    enumerable: !0,
    get: function () {
      return x.crc32c;
    },
  });
  var r = Ua;
  Object.defineProperty(t, "base32Decode", {
    enumerable: !0,
    get: function () {
      return r.base32Decode;
    },
  }),
    Object.defineProperty(t, "base32Encode", {
      enumerable: !0,
      get: function () {
        return r.base32Encode;
      },
    });
  var o = Wu;
  Object.defineProperty(t, "getMethodId", {
    enumerable: !0,
    get: function () {
      return o.getMethodId;
    },
  });
  var f = js;
  Object.defineProperty(t, "safeSign", {
    enumerable: !0,
    get: function () {
      return f.safeSign;
    },
  }),
    Object.defineProperty(t, "safeSignVerify", {
      enumerable: !0,
      get: function () {
        return f.safeSignVerify;
      },
    });
})(_t);
var hA = ss(),
  $1 = Object.defineProperty,
  dA = (t, e, n) =>
    e in t ? $1(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : (t[e] = n),
  Be = (t, e) => $1(t, "name", { value: e, configurable: !0 }),
  pA = (t, e) => {
    for (var n in e) $1(t, n, { get: e[n], enumerable: !0 });
  },
  Ge = (t, e, n) => (dA(t, typeof e != "symbol" ? e + "" : e, n), n),
  H1 = (t, e, n) => {
    if (!e.has(t)) throw TypeError("Cannot " + n);
  },
  pt = (t, e, n) => (H1(t, e, "read from private field"), n ? n.call(t) : e.get(t)),
  er = (t, e, n) => {
    if (e.has(t)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(t) : e.set(t, n);
  },
  Jt = (t, e, n, i) => (H1(t, e, "write to private field"), i ? i.call(t, n) : e.set(t, n), n),
  mA = (t, e, n, i) => ({
    set _(l) {
      Jt(t, e, l, n);
    },
    get _() {
      return pt(t, e, i);
    },
  }),
  cr = (t, e, n) => (H1(t, e, "access private method"), n),
  vA = {};
pA(vA, {
  GagarinMasterBridge__factory: () => Bk,
  GagarinStaking__factory: () => Ck,
});
var gA = "6.11.1";
function G3(t, e, n) {
  const i = e.split("|").map((a) => a.trim());
  for (let a = 0; a < i.length; a++)
    switch (e) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof t === e) return;
    }
  const l = new Error(`invalid value for type ${e}`);
  throw ((l.code = "INVALID_ARGUMENT"), (l.argument = `value.${n}`), (l.value = t), l);
}
Be(G3, "checkType");
async function Ql(t) {
  const e = Object.keys(t);
  return (await Promise.all(e.map((i) => Promise.resolve(t[i])))).reduce(
    (i, l, a) => ((i[e[a]] = l), i),
    {}
  );
}
Be(Ql, "resolveProperties");
function Ft(t, e, n) {
  for (let i in e) {
    let l = e[i];
    const a = n ? n[i] : null;
    a && G3(l, a, i),
      Object.defineProperty(t, i, {
        enumerable: !0,
        value: l,
        writable: !1,
      });
  }
}
Be(Ft, "defineProperties");
function Ma(t) {
  if (t == null) return "null";
  if (Array.isArray(t)) return "[ " + t.map(Ma).join(", ") + " ]";
  if (t instanceof Uint8Array) {
    const e = "0123456789abcdef";
    let n = "0x";
    for (let i = 0; i < t.length; i++) (n += e[t[i] >> 4]), (n += e[t[i] & 15]);
    return n;
  }
  if (typeof t == "object" && typeof t.toJSON == "function") return Ma(t.toJSON());
  switch (typeof t) {
    case "boolean":
    case "symbol":
      return t.toString();
    case "bigint":
      return BigInt(t).toString();
    case "number":
      return t.toString();
    case "string":
      return JSON.stringify(t);
    case "object": {
      const e = Object.keys(t);
      return e.sort(), "{ " + e.map((n) => `${Ma(n)}: ${Ma(t[n])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
Be(Ma, "stringify");
function is(t, e) {
  return t && t.code === e;
}
Be(is, "isError");
function V1(t) {
  return is(t, "CALL_EXCEPTION");
}
Be(V1, "isCallException");
function $s(t, e, n) {
  let i = t;
  {
    const a = [];
    if (n) {
      if ("message" in n || "code" in n || "name" in n)
        throw new Error(`value will overwrite populated values: ${Ma(n)}`);
      for (const c in n) {
        if (c === "shortMessage") continue;
        const v = n[c];
        a.push(c + "=" + Ma(v));
      }
    }
    a.push(`code=${e}`), a.push(`version=${gA}`), a.length && (t += " (" + a.join(", ") + ")");
  }
  let l;
  switch (e) {
    case "INVALID_ARGUMENT":
      l = new TypeError(t);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      l = new RangeError(t);
      break;
    default:
      l = new Error(t);
  }
  return (
    Ft(l, {
      code: e,
    }),
    n && Object.assign(l, n),
    l.shortMessage == null &&
      Ft(l, {
        shortMessage: i,
      }),
    l
  );
}
Be($s, "makeError");
function Pt(t, e, n, i) {
  if (!t) throw $s(e, n, i);
}
Be(Pt, "assert");
function bt(t, e, n, i) {
  Pt(t, e, "INVALID_ARGUMENT", {
    argument: n,
    value: i,
  });
}
Be(bt, "assertArgument");
function W1(t, e, n) {
  n == null && (n = ""),
    n && (n = ": " + n),
    Pt(t >= e, "missing arguemnt" + n, "MISSING_ARGUMENT", {
      count: t,
      expectedCount: e,
    }),
    Pt(t <= e, "too many arguments" + n, "UNEXPECTED_ARGUMENT", {
      count: t,
      expectedCount: e,
    });
}
Be(W1, "assertArgumentCount");
var yA = ["NFD", "NFC", "NFKD", "NFKC"].reduce((t, e) => {
  try {
    if ("test".normalize(e) !== "test") throw new Error("bad");
    if (e === "NFD" && "é".normalize("NFD") !== "é") throw new Error("broken");
    t.push(e);
  } catch {}
  return t;
}, []);
function Y3(t) {
  Pt(yA.indexOf(t) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
    operation: "String.prototype.normalize",
    info: {
      form: t,
    },
  });
}
Be(Y3, "assertNormalize");
function Ku(t, e, n) {
  if ((n == null && (n = ""), t !== e)) {
    let i = n,
      l = "new";
    n && ((i += "."), (l += " " + n)),
      Pt(!1, `private constructor; use ${i}from* methods`, "UNSUPPORTED_OPERATION", {
        operation: l,
      });
  }
}
Be(Ku, "assertPrivate");
function K1(t, e, n) {
  if (t instanceof Uint8Array) return n ? new Uint8Array(t) : t;
  if (typeof t == "string" && t.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
    const i = new Uint8Array((t.length - 2) / 2);
    let l = 2;
    for (let a = 0; a < i.length; a++) (i[a] = parseInt(t.substring(l, l + 2), 16)), (l += 2);
    return i;
  }
  bt(!1, "invalid BytesLike value", e || "value", t);
}
Be(K1, "_getBytes");
function dn(t, e) {
  return K1(t, e, !1);
}
Be(dn, "getBytes");
function In(t, e) {
  return K1(t, e, !0);
}
Be(In, "getBytesCopy");
function Si(t, e) {
  return !(
    typeof t != "string" ||
    !t.match(/^0x[0-9A-Fa-f]*$/) ||
    (typeof e == "number" && t.length !== 2 + 2 * e) ||
    (e === !0 && t.length % 2 !== 0)
  );
}
Be(Si, "isHexString");
var e2 = "0123456789abcdef";
function dr(t) {
  const e = dn(t);
  let n = "0x";
  for (let i = 0; i < e.length; i++) {
    const l = e[i];
    n += e2[(l & 240) >> 4] + e2[l & 15];
  }
  return n;
}
Be(dr, "hexlify");
function ta(t) {
  return "0x" + t.map((e) => dr(e).substring(2)).join("");
}
Be(ta, "concat");
function Li(t, e, n) {
  const i = dn(t);
  return (
    n != null &&
      n > i.length &&
      Pt(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
        buffer: i,
        length: i.length,
        offset: n,
      }),
    dr(i.slice(e ?? 0, n ?? i.length))
  );
}
Be(Li, "dataSlice");
function Z1(t, e, n) {
  const i = dn(t);
  Pt(e >= i.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(i),
    length: e,
    offset: e + 1,
  });
  const l = new Uint8Array(e);
  return l.fill(0), n ? l.set(i, e - i.length) : l.set(i, 0), dr(l);
}
Be(Z1, "zeroPad");
function J3(t, e) {
  return Z1(t, e, !0);
}
Be(J3, "zeroPadValue");
function Q3(t, e) {
  return Z1(t, e, !1);
}
Be(Q3, "zeroPadBytes");
var Zu = BigInt(0),
  Pn = BigInt(1),
  gs = 9007199254740991;
function X3(t, e) {
  const n = Uf(t, "value"),
    i = BigInt(ai(e, "width"));
  if (
    (Pt(n >> i === Zu, "overflow", "NUMERIC_FAULT", {
      operation: "fromTwos",
      fault: "overflow",
      value: t,
    }),
    n >> (i - Pn))
  ) {
    const l = (Pn << i) - Pn;
    return -((~n & l) + Pn);
  }
  return n;
}
Be(X3, "fromTwos");
function e5(t, e) {
  let n = ii(t, "value");
  const i = BigInt(ai(e, "width")),
    l = Pn << (i - Pn);
  if (n < Zu) {
    (n = -n),
      Pt(n <= l, "too low", "NUMERIC_FAULT", {
        operation: "toTwos",
        fault: "overflow",
        value: t,
      });
    const a = (Pn << i) - Pn;
    return (~n & a) + Pn;
  } else
    Pt(n < l, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: t,
    });
  return n;
}
Be(e5, "toTwos");
function Fo(t, e) {
  const n = Uf(t, "value"),
    i = BigInt(ai(e, "bits"));
  return n & ((Pn << i) - Pn);
}
Be(Fo, "mask");
function ii(t, e) {
  switch (typeof t) {
    case "bigint":
      return t;
    case "number":
      return (
        bt(Number.isInteger(t), "underflow", e || "value", t),
        bt(t >= -gs && t <= gs, "overflow", e || "value", t),
        BigInt(t)
      );
    case "string":
      try {
        if (t === "") throw new Error("empty string");
        return t[0] === "-" && t[1] !== "-" ? -BigInt(t.substring(1)) : BigInt(t);
      } catch (n) {
        bt(!1, `invalid BigNumberish string: ${n.message}`, e || "value", t);
      }
  }
  bt(!1, "invalid BigNumberish value", e || "value", t);
}
Be(ii, "getBigInt");
function Uf(t, e) {
  const n = ii(t, e);
  return (
    Pt(n >= Zu, "unsigned value cannot be negative", "NUMERIC_FAULT", {
      fault: "overflow",
      operation: "getUint",
      value: t,
    }),
    n
  );
}
Be(Uf, "getUint");
var t2 = "0123456789abcdef";
function G1(t) {
  if (t instanceof Uint8Array) {
    let e = "0x0";
    for (const n of t) (e += t2[n >> 4]), (e += t2[n & 15]);
    return BigInt(e);
  }
  return ii(t);
}
Be(G1, "toBigInt");
function ai(t, e) {
  switch (typeof t) {
    case "bigint":
      return bt(t >= -gs && t <= gs, "overflow", e || "value", t), Number(t);
    case "number":
      return (
        bt(Number.isInteger(t), "underflow", e || "value", t),
        bt(t >= -gs && t <= gs, "overflow", e || "value", t),
        t
      );
    case "string":
      try {
        if (t === "") throw new Error("empty string");
        return ai(BigInt(t), e);
      } catch (n) {
        bt(!1, `invalid numeric string: ${n.message}`, e || "value", t);
      }
  }
  bt(!1, "invalid numeric value", e || "value", t);
}
Be(ai, "getNumber");
function t5(t) {
  return ai(G1(t));
}
Be(t5, "toNumber");
function Y1(t, e) {
  let i = Uf(t, "value").toString(16);
  if (e == null) i.length % 2 && (i = "0" + i);
  else {
    const l = ai(e, "width");
    for (
      Pt(l * 2 >= i.length, `value exceeds width (${l} bytes)`, "NUMERIC_FAULT", {
        operation: "toBeHex",
        fault: "overflow",
        value: t,
      });
      i.length < l * 2;

    )
      i = "0" + i;
  }
  return "0x" + i;
}
Be(Y1, "toBeHex");
function r5(t) {
  const e = Uf(t, "value");
  if (e === Zu) return new Uint8Array([]);
  let n = e.toString(16);
  n.length % 2 && (n = "0" + n);
  const i = new Uint8Array(n.length / 2);
  for (let l = 0; l < i.length; l++) {
    const a = l * 2;
    i[l] = parseInt(n.substring(a, a + 2), 16);
  }
  return i;
}
Be(r5, "toBeArray");
var qo,
  n5 = class {
    /**
     *  Create a new **EventPayload** for %%emitter%% with
     *  the %%listener%% and for %%filter%%.
     */
    constructor(e, n, i) {
      Ge(this, "filter"),
        Ge(this, "emitter"),
        er(this, qo, void 0),
        Jt(this, qo, n),
        Ft(this, {
          emitter: e,
          filter: i,
        });
    }
    /**
     *  Unregister the triggered listener for future events.
     */
    async removeListener() {
      pt(this, qo) != null && (await this.emitter.off(this.filter, pt(this, qo)));
    }
  };
qo = /* @__PURE__ */ new WeakMap();
Be(n5, "EventPayload");
var bA = n5;
function i5(t, e, n, i, l) {
  bt(!1, `invalid codepoint at offset ${e}; ${t}`, "bytes", n);
}
Be(i5, "errorFunc");
function J1(t, e, n, i, l) {
  if (t === "BAD_PREFIX" || t === "UNEXPECTED_CONTINUE") {
    let a = 0;
    for (let c = e + 1; c < n.length && n[c] >> 6 === 2; c++) a++;
    return a;
  }
  return t === "OVERRUN" ? n.length - e - 1 : 0;
}
Be(J1, "ignoreFunc");
function a5(t, e, n, i, l) {
  return t === "OVERLONG"
    ? (bt(typeof l == "number", "invalid bad code point for replacement", "badCodepoint", l),
      i.push(l),
      0)
    : (i.push(65533), J1(t, e, n));
}
Be(a5, "replaceFunc");
var wA = Object.freeze({
  error: i5,
  ignore: J1,
  replace: a5,
});
function s5(t, e) {
  e == null && (e = wA.error);
  const n = dn(t, "bytes"),
    i = [];
  let l = 0;
  for (; l < n.length; ) {
    const a = n[l++];
    if (!(a >> 7)) {
      i.push(a);
      continue;
    }
    let c = null,
      v = null;
    if ((a & 224) === 192) (c = 1), (v = 127);
    else if ((a & 240) === 224) (c = 2), (v = 2047);
    else if ((a & 248) === 240) (c = 3), (v = 65535);
    else {
      (a & 192) === 128
        ? (l += e("UNEXPECTED_CONTINUE", l - 1, n, i))
        : (l += e("BAD_PREFIX", l - 1, n, i));
      continue;
    }
    if (l - 1 + c >= n.length) {
      l += e("OVERRUN", l - 1, n, i);
      continue;
    }
    let g = a & ((1 << (8 - c - 1)) - 1);
    for (let b = 0; b < c; b++) {
      let p = n[l];
      if ((p & 192) != 128) {
        (l += e("MISSING_CONTINUE", l, n, i)), (g = null);
        break;
      }
      (g = (g << 6) | (p & 63)), l++;
    }
    if (g !== null) {
      if (g > 1114111) {
        l += e("OUT_OF_RANGE", l - 1 - c, n, i, g);
        continue;
      }
      if (g >= 55296 && g <= 57343) {
        l += e("UTF16_SURROGATE", l - 1 - c, n, i, g);
        continue;
      }
      if (g <= v) {
        l += e("OVERLONG", l - 1 - c, n, i, g);
        continue;
      }
      i.push(g);
    }
  }
  return i;
}
Be(s5, "getUtf8CodePoints");
function Q1(t, e) {
  bt(typeof t == "string", "invalid string value", "str", t),
    e != null && (Y3(e), (t = t.normalize(e)));
  let n = [];
  for (let i = 0; i < t.length; i++) {
    const l = t.charCodeAt(i);
    if (l < 128) n.push(l);
    else if (l < 2048) n.push((l >> 6) | 192), n.push((l & 63) | 128);
    else if ((l & 64512) == 55296) {
      i++;
      const a = t.charCodeAt(i);
      bt(i < t.length && (a & 64512) === 56320, "invalid surrogate pair", "str", t);
      const c = 65536 + ((l & 1023) << 10) + (a & 1023);
      n.push((c >> 18) | 240),
        n.push(((c >> 12) & 63) | 128),
        n.push(((c >> 6) & 63) | 128),
        n.push((c & 63) | 128);
    } else n.push((l >> 12) | 224), n.push(((l >> 6) & 63) | 128), n.push((l & 63) | 128);
  }
  return new Uint8Array(n);
}
Be(Q1, "toUtf8Bytes");
function o5(t) {
  return t
    .map((e) =>
      e <= 65535
        ? String.fromCharCode(e)
        : ((e -= 65536), String.fromCharCode(((e >> 10) & 1023) + 55296, (e & 1023) + 56320))
    )
    .join("");
}
Be(o5, "_toUtf8String");
function f5(t, e) {
  return o5(s5(t, e));
}
Be(f5, "toUtf8String");
function bp(t) {
  const e = [];
  for (; t; ) e.unshift(t & 255), (t >>= 8);
  return e;
}
Be(bp, "arrayifyInteger");
function X1(t) {
  if (Array.isArray(t)) {
    let i = [];
    if (
      (t.forEach(function (a) {
        i = i.concat(X1(a));
      }),
      i.length <= 55)
    )
      return i.unshift(192 + i.length), i;
    const l = bp(i.length);
    return l.unshift(247 + l.length), l.concat(i);
  }
  const e = Array.prototype.slice.call(dn(t, "object"));
  if (e.length === 1 && e[0] <= 127) return e;
  if (e.length <= 55) return e.unshift(128 + e.length), e;
  const n = bp(e.length);
  return n.unshift(183 + n.length), n.concat(e);
}
Be(X1, "_encode");
var r2 = "0123456789abcdef";
function l5(t) {
  let e = "0x";
  for (const n of X1(t)) (e += r2[n >> 4]), (e += r2[n & 15]);
  return e;
}
Be(l5, "encodeRlp");
var $r = 32,
  wp = new Uint8Array($r),
  _A = ["then"],
  ol = {};
function hs(t, e) {
  const n = new Error(`deferred error during ABI decoding triggered accessing ${t}`);
  throw ((n.error = e), n);
}
Be(hs, "throwError");
var ga,
  u5 = class Sl extends Array {
    /**
     *  @private
     */
    constructor(...e) {
      const n = e[0];
      let i = e[1],
        l = (e[2] || []).slice(),
        a = !0;
      n !== ol && ((i = e), (l = []), (a = !1)),
        super(i.length),
        er(this, ga, void 0),
        i.forEach((v, g) => {
          this[g] = v;
        });
      const c = l.reduce(
        (v, g) => (typeof g == "string" && v.set(g, (v.get(g) || 0) + 1), v),
        /* @__PURE__ */ new Map()
      );
      if (
        (Jt(
          this,
          ga,
          Object.freeze(
            i.map((v, g) => {
              const b = l[g];
              return b != null && c.get(b) === 1 ? b : null;
            })
          )
        ),
        !!a)
      )
        return (
          Object.freeze(this),
          new Proxy(this, {
            get: (v, g, b) => {
              if (typeof g == "string") {
                if (g.match(/^[0-9]+$/)) {
                  const _ = ai(g, "%index");
                  if (_ < 0 || _ >= this.length) throw new RangeError("out of result range");
                  const M = v[_];
                  return M instanceof Error && hs(`index ${_}`, M), M;
                }
                if (_A.indexOf(g) >= 0) return Reflect.get(v, g, b);
                const p = v[g];
                if (p instanceof Function)
                  return function (..._) {
                    return p.apply(this === b ? v : this, _);
                  };
                if (!(g in v)) return v.getValue.apply(this === b ? v : this, [g]);
              }
              return Reflect.get(v, g, b);
            },
          })
        );
    }
    /**
     *  Returns the Result as a normal Array.
     *
     *  This will throw if there are any outstanding deferred
     *  errors.
     */
    toArray() {
      const e = [];
      return (
        this.forEach((n, i) => {
          n instanceof Error && hs(`index ${i}`, n), e.push(n);
        }),
        e
      );
    }
    /**
     *  Returns the Result as an Object with each name-value pair.
     *
     *  This will throw if any value is unnamed, or if there are
     *  any outstanding deferred errors.
     */
    toObject() {
      return pt(this, ga).reduce(
        (e, n, i) => (
          Pt(n != null, "value at index ${ index } unnamed", "UNSUPPORTED_OPERATION", {
            operation: "toObject()",
          }),
          n in e || (e[n] = this.getValue(n)),
          e
        ),
        {}
      );
    }
    /**
     *  @_ignore
     */
    slice(e, n) {
      e == null && (e = 0),
        e < 0 && ((e += this.length), e < 0 && (e = 0)),
        n == null && (n = this.length),
        n < 0 && ((n += this.length), n < 0 && (n = 0)),
        n > this.length && (n = this.length);
      const i = [],
        l = [];
      for (let a = e; a < n; a++) i.push(this[a]), l.push(pt(this, ga)[a]);
      return new Sl(ol, i, l);
    }
    /**
     *  @_ignore
     */
    filter(e, n) {
      const i = [],
        l = [];
      for (let a = 0; a < this.length; a++) {
        const c = this[a];
        c instanceof Error && hs(`index ${a}`, c),
          e.call(n, c, a, this) && (i.push(c), l.push(pt(this, ga)[a]));
      }
      return new Sl(ol, i, l);
    }
    /**
     *  @_ignore
     */
    map(e, n) {
      const i = [];
      for (let l = 0; l < this.length; l++) {
        const a = this[l];
        a instanceof Error && hs(`index ${l}`, a), i.push(e.call(n, a, l, this));
      }
      return i;
    }
    /**
     *  Returns the value for %%name%%.
     *
     *  Since it is possible to have a key whose name conflicts with
     *  a method on a [[Result]] or its superclass Array, or any
     *  JavaScript keyword, this ensures all named values are still
     *  accessible by name.
     */
    getValue(e) {
      const n = pt(this, ga).indexOf(e);
      if (n === -1) return;
      const i = this[n];
      return i instanceof Error && hs(`property ${JSON.stringify(e)}`, i.error), i;
    }
    /**
     *  Creates a new [[Result]] for %%items%% with each entry
     *  also accessible by its corresponding name in %%keys%%.
     */
    static fromItems(e, n) {
      return new Sl(ol, e, n);
    }
  };
ga = /* @__PURE__ */ new WeakMap();
Be(u5, "Result");
var c5 = u5;
function _p(t) {
  let e = r5(t);
  return (
    Pt(e.length <= $r, "value out-of-bounds", "BUFFER_OVERRUN", {
      buffer: e,
      length: $r,
      offset: e.length,
    }),
    e.length !== $r && (e = In(ta([wp.slice(e.length % $r), e]))),
    e
  );
}
Be(_p, "getValue");
var h5 = class {
  constructor(e, n, i, l) {
    Ge(this, "name"),
      Ge(this, "type"),
      Ge(this, "localName"),
      Ge(this, "dynamic"),
      Ft(
        this,
        {
          name: e,
          type: n,
          localName: i,
          dynamic: l,
        },
        {
          name: "string",
          type: "string",
          localName: "string",
          dynamic: "boolean",
        }
      );
  }
  _throwError(e, n) {
    bt(!1, e, this.localName, n);
  }
};
Be(h5, "Coder");
var ki = h5,
  Fi,
  qi,
  zo,
  El,
  d5 = class {
    constructor() {
      er(this, zo), er(this, Fi, void 0), er(this, qi, void 0), Jt(this, Fi, []), Jt(this, qi, 0);
    }
    get data() {
      return ta(pt(this, Fi));
    }
    get length() {
      return pt(this, qi);
    }
    appendWriter(e) {
      return cr(this, zo, El).call(this, In(e.data));
    }
    // Arrayish item; pad on the right to *nearest* WordSize
    writeBytes(e) {
      let n = In(e);
      const i = n.length % $r;
      return i && (n = In(ta([n, wp.slice(i)]))), cr(this, zo, El).call(this, n);
    }
    // Numeric item; pad on the left *to* WordSize
    writeValue(e) {
      return cr(this, zo, El).call(this, _p(e));
    }
    // Inserts a numeric place-holder, returning a callback that can
    // be used to asjust the value later
    writeUpdatableValue() {
      const e = pt(this, Fi).length;
      return (
        pt(this, Fi).push(wp),
        Jt(this, qi, pt(this, qi) + $r),
        (n) => {
          pt(this, Fi)[e] = _p(n);
        }
      );
    }
  };
Fi = /* @__PURE__ */ new WeakMap();
qi = /* @__PURE__ */ new WeakMap();
zo = /* @__PURE__ */ new WeakSet();
El = /* @__PURE__ */ Be(function (t) {
  return pt(this, Fi).push(t), Jt(this, qi, pt(this, qi) + t.length), t.length;
}, "#writeData");
Be(d5, "Writer");
var xp = d5,
  ln,
  un,
  Sa,
  ws,
  Oa,
  Xl,
  Mp,
  Sp,
  p5,
  m5 = class v5 {
    constructor(e, n, i) {
      er(this, Xl),
        er(this, Sp),
        Ge(this, "allowLoose"),
        er(this, ln, void 0),
        er(this, un, void 0),
        er(this, Sa, void 0),
        er(this, ws, void 0),
        er(this, Oa, void 0),
        Ft(this, {
          allowLoose: !!n,
        }),
        Jt(this, ln, In(e)),
        Jt(this, Sa, 0),
        Jt(this, ws, null),
        Jt(this, Oa, i ?? 1024),
        Jt(this, un, 0);
    }
    get data() {
      return dr(pt(this, ln));
    }
    get dataLength() {
      return pt(this, ln).length;
    }
    get consumed() {
      return pt(this, un);
    }
    get bytes() {
      return new Uint8Array(pt(this, ln));
    }
    // Create a sub-reader with the same underlying data, but offset
    subReader(e) {
      const n = new v5(pt(this, ln).slice(pt(this, un) + e), this.allowLoose, pt(this, Oa));
      return Jt(n, ws, this), n;
    }
    // Read bytes
    readBytes(e, n) {
      let i = cr(this, Sp, p5).call(this, 0, e, !!n);
      return cr(this, Xl, Mp).call(this, e), Jt(this, un, pt(this, un) + i.length), i.slice(0, e);
    }
    // Read a numeric values
    readValue() {
      return G1(this.readBytes($r));
    }
    readIndex() {
      return t5(this.readBytes($r));
    }
  };
ln = /* @__PURE__ */ new WeakMap();
un = /* @__PURE__ */ new WeakMap();
Sa = /* @__PURE__ */ new WeakMap();
ws = /* @__PURE__ */ new WeakMap();
Oa = /* @__PURE__ */ new WeakMap();
Xl = /* @__PURE__ */ new WeakSet();
Mp = /* @__PURE__ */ Be(function (t) {
  var e;
  if (pt(this, ws)) return cr((e = pt(this, ws)), Xl, Mp).call(e, t);
  Jt(this, Sa, pt(this, Sa) + t),
    Pt(
      pt(this, Oa) < 1 || pt(this, Sa) <= pt(this, Oa) * this.dataLength,
      `compressed ABI data exceeds inflation ratio of ${pt(
        this,
        Oa
      )} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`,
      "BUFFER_OVERRUN",
      {
        buffer: In(pt(this, ln)),
        offset: pt(this, un),
        length: t,
        info: {
          bytesRead: pt(this, Sa),
          dataLength: this.dataLength,
        },
      }
    );
}, "#incrementBytesRead");
Sp = /* @__PURE__ */ new WeakSet();
p5 = /* @__PURE__ */ Be(function (t, e, n) {
  let i = Math.ceil(e / $r) * $r;
  return (
    pt(this, un) + i > pt(this, ln).length &&
      (this.allowLoose && n && pt(this, un) + e <= pt(this, ln).length
        ? (i = e)
        : Pt(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
            buffer: In(pt(this, ln)),
            length: pt(this, ln).length,
            offset: pt(this, un) + i,
          })),
    pt(this, ln).slice(pt(this, un), pt(this, un) + i)
  );
}, "#peekBytes");
Be(m5, "Reader");
var xA = m5;
function Ep(t) {
  if (!Number.isSafeInteger(t) || t < 0) throw new Error(`Wrong positive integer: ${t}`);
}
Be(Ep, "number");
function em(t, ...e) {
  if (!(t instanceof Uint8Array)) throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
Be(em, "bytes");
function Ap(t, e = !0) {
  if (t.destroyed) throw new Error("Hash instance has been destroyed");
  if (e && t.finished) throw new Error("Hash#digest() has already been called");
}
Be(Ap, "exists");
function g5(t, e) {
  em(t);
  const n = e.outputLen;
  if (t.length < n) throw new Error(`digestInto() expects output buffer of length at least ${n}`);
}
Be(g5, "output");
var fl = /* @__PURE__ */ BigInt(2 ** 32 - 1),
  n2 = /* @__PURE__ */ BigInt(32);
function y5(t, e = !1) {
  return e
    ? {
        h: Number(t & fl),
        l: Number((t >> n2) & fl),
      }
    : {
        h: Number((t >> n2) & fl) | 0,
        l: Number(t & fl) | 0,
      };
}
Be(y5, "fromBig");
function b5(t, e = !1) {
  let n = new Uint32Array(t.length),
    i = new Uint32Array(t.length);
  for (let l = 0; l < t.length; l++) {
    const { h: a, l: c } = y5(t[l], e);
    [n[l], i[l]] = [a, c];
  }
  return [n, i];
}
Be(b5, "split");
var MA = /* @__PURE__ */ Be((t, e, n) => (t << n) | (e >>> (32 - n)), "rotlSH"),
  SA = /* @__PURE__ */ Be((t, e, n) => (e << n) | (t >>> (32 - n)), "rotlSL"),
  EA = /* @__PURE__ */ Be((t, e, n) => (e << (n - 32)) | (t >>> (64 - n)), "rotlBH"),
  AA = /* @__PURE__ */ Be((t, e, n) => (t << (n - 32)) | (e >>> (64 - n)), "rotlBL"),
  kA = /* @__PURE__ */ Be((t) => t instanceof Uint8Array, "u8a"),
  BA = /* @__PURE__ */ Be(
    (t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)),
    "u32"
  ),
  CA = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!CA) throw new Error("Non little-endian hardware is not supported");
function w5(t) {
  if (typeof t != "string") throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
Be(w5, "utf8ToBytes");
function Gu(t) {
  if ((typeof t == "string" && (t = w5(t)), !kA(t)))
    throw new Error(`expected Uint8Array, got ${typeof t}`);
  return t;
}
Be(Gu, "toBytes");
var _5 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
Be(_5, "Hash");
var TA = _5;
function x5(t) {
  const e = /* @__PURE__ */ Be((i) => t().update(Gu(i)).digest(), "hashC"),
    n = t();
  return (e.outputLen = n.outputLen), (e.blockLen = n.blockLen), (e.create = () => t()), e;
}
Be(x5, "wrapConstructor");
function PA(t) {
  const e = /* @__PURE__ */ Be((i, l) => t(l).update(Gu(i)).digest(), "hashC"),
    n = t({});
  return (e.outputLen = n.outputLen), (e.blockLen = n.blockLen), (e.create = (i) => t(i)), e;
}
Be(PA, "wrapXOFConstructorWithOpts");
var [M5, S5, E5] = [[], [], []],
  RA = /* @__PURE__ */ BigInt(0),
  So = /* @__PURE__ */ BigInt(1),
  IA = /* @__PURE__ */ BigInt(2),
  OA = /* @__PURE__ */ BigInt(7),
  UA = /* @__PURE__ */ BigInt(256),
  NA = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = So, n = 1, i = 0; t < 24; t++) {
  ([n, i] = [i, (2 * n + 3 * i) % 5]),
    M5.push(2 * (5 * i + n)),
    S5.push((((t + 1) * (t + 2)) / 2) % 64);
  let l = RA;
  for (let a = 0; a < 7; a++)
    (e = ((e << So) ^ ((e >> OA) * NA)) % UA),
      e & IA && (l ^= So << ((So << /* @__PURE__ */ BigInt(a)) - So));
  E5.push(l);
}
var [DA, LA] = /* @__PURE__ */ b5(E5, !0),
  i2 = /* @__PURE__ */ Be((t, e, n) => (n > 32 ? EA(t, e, n) : MA(t, e, n)), "rotlH"),
  a2 = /* @__PURE__ */ Be((t, e, n) => (n > 32 ? AA(t, e, n) : SA(t, e, n)), "rotlL");
function A5(t, e = 24) {
  const n = new Uint32Array(10);
  for (let i = 24 - e; i < 24; i++) {
    for (let c = 0; c < 10; c++) n[c] = t[c] ^ t[c + 10] ^ t[c + 20] ^ t[c + 30] ^ t[c + 40];
    for (let c = 0; c < 10; c += 2) {
      const v = (c + 8) % 10,
        g = (c + 2) % 10,
        b = n[g],
        p = n[g + 1],
        _ = i2(b, p, 1) ^ n[v],
        M = a2(b, p, 1) ^ n[v + 1];
      for (let S = 0; S < 50; S += 10) (t[c + S] ^= _), (t[c + S + 1] ^= M);
    }
    let l = t[2],
      a = t[3];
    for (let c = 0; c < 24; c++) {
      const v = S5[c],
        g = i2(l, a, v),
        b = a2(l, a, v),
        p = M5[c];
      (l = t[p]), (a = t[p + 1]), (t[p] = g), (t[p + 1] = b);
    }
    for (let c = 0; c < 50; c += 10) {
      for (let v = 0; v < 10; v++) n[v] = t[c + v];
      for (let v = 0; v < 10; v++) t[c + v] ^= ~n[(v + 2) % 10] & n[(v + 4) % 10];
    }
    (t[0] ^= DA[i]), (t[1] ^= LA[i]);
  }
  n.fill(0);
}
Be(A5, "keccakP");
var k5 = class B5 extends TA {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, n, i, l = !1, a = 24) {
    if (
      (super(),
      (this.blockLen = e),
      (this.suffix = n),
      (this.outputLen = i),
      (this.enableXOF = l),
      (this.rounds = a),
      (this.pos = 0),
      (this.posOut = 0),
      (this.finished = !1),
      (this.destroyed = !1),
      Ep(i),
      0 >= this.blockLen || this.blockLen >= 200)
    )
      throw new Error("Sha3 supports only keccak-f1600 function");
    (this.state = new Uint8Array(200)), (this.state32 = BA(this.state));
  }
  keccak() {
    A5(this.state32, this.rounds), (this.posOut = 0), (this.pos = 0);
  }
  update(e) {
    Ap(this);
    const { blockLen: n, state: i } = this;
    e = Gu(e);
    const l = e.length;
    for (let a = 0; a < l; ) {
      const c = Math.min(n - this.pos, l - a);
      for (let v = 0; v < c; v++) i[this.pos++] ^= e[a++];
      this.pos === n && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished) return;
    this.finished = !0;
    const { state: e, suffix: n, pos: i, blockLen: l } = this;
    (e[i] ^= n), n & 128 && i === l - 1 && this.keccak(), (e[l - 1] ^= 128), this.keccak();
  }
  writeInto(e) {
    Ap(this, !1), em(e), this.finish();
    const n = this.state,
      { blockLen: i } = this;
    for (let l = 0, a = e.length; l < a; ) {
      this.posOut >= i && this.keccak();
      const c = Math.min(i - this.posOut, a - l);
      e.set(n.subarray(this.posOut, this.posOut + c), l), (this.posOut += c), (l += c);
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return Ep(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if ((g5(e, this), this.finished)) throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    (this.destroyed = !0), this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: n, suffix: i, outputLen: l, rounds: a, enableXOF: c } = this;
    return (
      e || (e = new B5(n, i, l, c, a)),
      e.state32.set(this.state32),
      (e.pos = this.pos),
      (e.posOut = this.posOut),
      (e.finished = this.finished),
      (e.rounds = a),
      (e.suffix = i),
      (e.outputLen = l),
      (e.enableXOF = c),
      (e.destroyed = this.destroyed),
      e
    );
  }
};
Be(k5, "Keccak");
var FA = k5,
  qA = /* @__PURE__ */ Be((t, e, n) => x5(() => new FA(e, t, n)), "gen"),
  zA = /* @__PURE__ */ qA(1, 136, 256 / 8),
  C5 = !1,
  T5 = /* @__PURE__ */ Be(function (t) {
    return zA(t);
  }, "_keccak256"),
  P5 = T5;
function ei(t) {
  const e = dn(t, "data");
  return dr(P5(e));
}
Be(ei, "keccak256");
ei._ = T5;
ei.lock = function () {
  C5 = !0;
};
ei.register = function (t) {
  if (C5) throw new TypeError("keccak256 is locked");
  P5 = t;
};
Object.freeze(ei);
var jA = BigInt(0),
  $A = BigInt(36);
function kp(t) {
  t = t.toLowerCase();
  const e = t.substring(2).split(""),
    n = new Uint8Array(40);
  for (let l = 0; l < 40; l++) n[l] = e[l].charCodeAt(0);
  const i = dn(ei(n));
  for (let l = 0; l < 40; l += 2)
    i[l >> 1] >> 4 >= 8 && (e[l] = e[l].toUpperCase()),
      (i[l >> 1] & 15) >= 8 && (e[l + 1] = e[l + 1].toUpperCase());
  return "0x" + e.join("");
}
Be(kp, "getChecksumAddress");
var tm = {};
for (let t = 0; t < 10; t++) tm[String(t)] = String(t);
for (let t = 0; t < 26; t++) tm[String.fromCharCode(65 + t)] = String(10 + t);
var s2 = 15;
function R5(t) {
  (t = t.toUpperCase()), (t = t.substring(4) + t.substring(0, 2) + "00");
  let e = t
    .split("")
    .map((i) => tm[i])
    .join("");
  for (; e.length >= s2; ) {
    let i = e.substring(0, s2);
    e = (parseInt(i, 10) % 97) + e.substring(i.length);
  }
  let n = String(98 - (parseInt(e, 10) % 97));
  for (; n.length < 2; ) n = "0" + n;
  return n;
}
Be(R5, "ibanChecksum");
var HA = (function () {
  const t = {};
  for (let e = 0; e < 36; e++) {
    const n = "0123456789abcdefghijklmnopqrstuvwxyz"[e];
    t[n] = BigInt(e);
  }
  return t;
})();
function I5(t) {
  t = t.toLowerCase();
  let e = jA;
  for (let n = 0; n < t.length; n++) e = e * $A + HA[t[n]];
  return e;
}
Be(I5, "fromBase36");
function ti(t) {
  if (
    (bt(typeof t == "string", "invalid address", "address", t), t.match(/^(0x)?[0-9a-fA-F]{40}$/))
  ) {
    t.startsWith("0x") || (t = "0x" + t);
    const e = kp(t);
    return (
      bt(
        !t.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || e === t,
        "bad address checksum",
        "address",
        t
      ),
      e
    );
  }
  if (t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    bt(t.substring(2, 4) === R5(t), "bad icap checksum", "address", t);
    let e = I5(t.substring(4)).toString(16);
    for (; e.length < 40; ) e = "0" + e;
    return kp("0x" + e);
  }
  bt(!1, "invalid address", "address", t);
}
Be(ti, "getAddress");
function O5(t) {
  const e = ti(t.from);
  let i = ii(t.nonce, "tx.nonce").toString(16);
  return (
    i === "0" ? (i = "0x") : i.length % 2 ? (i = "0x0" + i) : (i = "0x" + i),
    ti(Li(ei(l5([e, i])), 12))
  );
}
Be(O5, "getCreateAddress");
function rm(t) {
  return t && typeof t.getAddress == "function";
}
Be(rm, "isAddressable");
async function Al(t, e) {
  const n = await e;
  return (
    (n == null || n === "0x0000000000000000000000000000000000000000") &&
      (Pt(typeof t != "string", "unconfigured name", "UNCONFIGURED_NAME", {
        value: t,
      }),
      bt(!1, "invalid AddressLike value; did not resolve to a value address", "target", t)),
    ti(n)
  );
}
Be(Al, "checkAddress");
function Hs(t, e) {
  if (typeof t == "string")
    return t.match(/^0x[0-9a-f]{40}$/i)
      ? ti(t)
      : (Pt(e != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
          operation: "resolveName",
        }),
        Al(t, e.resolveName(t)));
  if (rm(t)) return Al(t, t.getAddress());
  if (t && typeof t.then == "function") return Al(t, t);
  bt(!1, "unsupported addressable value", "target", t);
}
Be(Hs, "resolveAddress");
var pi = {};
function St(t, e) {
  let n = !1;
  return (
    e < 0 && ((n = !0), (e *= -1)),
    new tn(pi, `${n ? "" : "u"}int${e}`, t, {
      signed: n,
      width: e,
    })
  );
}
Be(St, "n");
function Yt(t, e) {
  return new tn(pi, `bytes${e || ""}`, t, {
    size: e,
  });
}
Be(Yt, "b");
var o2 = Symbol.for("_ethers_typed"),
  ds,
  U5 = class Ui {
    /**
     *  @_ignore:
     */
    constructor(e, n, i, l) {
      Ge(this, "type"),
        Ge(this, "value"),
        er(this, ds, void 0),
        Ge(this, "_typedSymbol"),
        l == null && (l = null),
        Ku(pi, e, "Typed"),
        Ft(this, {
          _typedSymbol: o2,
          type: n,
          value: i,
        }),
        Jt(this, ds, l),
        this.format();
    }
    /**
     *  Format the type as a Human-Readable type.
     */
    format() {
      if (this.type === "array") throw new Error("");
      if (this.type === "dynamicArray") throw new Error("");
      return this.type === "tuple"
        ? `tuple(${this.value.map((e) => e.format()).join(",")})`
        : this.type;
    }
    /**
     *  The default value returned by this type.
     */
    defaultValue() {
      return 0;
    }
    /**
     *  The minimum value for numeric types.
     */
    minValue() {
      return 0;
    }
    /**
     *  The maximum value for numeric types.
     */
    maxValue() {
      return 0;
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
     */
    isBigInt() {
      return !!this.type.match(/^u?int[0-9]+$/);
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
     */
    isData() {
      return this.type.startsWith("bytes");
    }
    /**
     *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
     */
    isString() {
      return this.type === "string";
    }
    /**
     *  Returns the tuple name, if this is a tuple. Throws otherwise.
     */
    get tupleName() {
      if (this.type !== "tuple") throw TypeError("not a tuple");
      return pt(this, ds);
    }
    // Returns the length of this type as an array
    // - `null` indicates the length is unforced, it could be dynamic
    // - `-1` indicates the length is dynamic
    // - any other value indicates it is a static array and is its length
    /**
     *  Returns the length of the array type or ``-1`` if it is dynamic.
     *
     *  Throws if the type is not an array.
     */
    get arrayLength() {
      if (this.type !== "array") throw TypeError("not an array");
      return pt(this, ds) === !0 ? -1 : pt(this, ds) === !1 ? this.value.length : null;
    }
    /**
     *  Returns a new **Typed** of %%type%% with the %%value%%.
     */
    static from(e, n) {
      return new Ui(pi, e, n);
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static uint8(e) {
      return St(e, 8);
    }
    /**
     *  Return a new ``uint16`` type for %%v%%.
     */
    static uint16(e) {
      return St(e, 16);
    }
    /**
     *  Return a new ``uint24`` type for %%v%%.
     */
    static uint24(e) {
      return St(e, 24);
    }
    /**
     *  Return a new ``uint32`` type for %%v%%.
     */
    static uint32(e) {
      return St(e, 32);
    }
    /**
     *  Return a new ``uint40`` type for %%v%%.
     */
    static uint40(e) {
      return St(e, 40);
    }
    /**
     *  Return a new ``uint48`` type for %%v%%.
     */
    static uint48(e) {
      return St(e, 48);
    }
    /**
     *  Return a new ``uint56`` type for %%v%%.
     */
    static uint56(e) {
      return St(e, 56);
    }
    /**
     *  Return a new ``uint64`` type for %%v%%.
     */
    static uint64(e) {
      return St(e, 64);
    }
    /**
     *  Return a new ``uint72`` type for %%v%%.
     */
    static uint72(e) {
      return St(e, 72);
    }
    /**
     *  Return a new ``uint80`` type for %%v%%.
     */
    static uint80(e) {
      return St(e, 80);
    }
    /**
     *  Return a new ``uint88`` type for %%v%%.
     */
    static uint88(e) {
      return St(e, 88);
    }
    /**
     *  Return a new ``uint96`` type for %%v%%.
     */
    static uint96(e) {
      return St(e, 96);
    }
    /**
     *  Return a new ``uint104`` type for %%v%%.
     */
    static uint104(e) {
      return St(e, 104);
    }
    /**
     *  Return a new ``uint112`` type for %%v%%.
     */
    static uint112(e) {
      return St(e, 112);
    }
    /**
     *  Return a new ``uint120`` type for %%v%%.
     */
    static uint120(e) {
      return St(e, 120);
    }
    /**
     *  Return a new ``uint128`` type for %%v%%.
     */
    static uint128(e) {
      return St(e, 128);
    }
    /**
     *  Return a new ``uint136`` type for %%v%%.
     */
    static uint136(e) {
      return St(e, 136);
    }
    /**
     *  Return a new ``uint144`` type for %%v%%.
     */
    static uint144(e) {
      return St(e, 144);
    }
    /**
     *  Return a new ``uint152`` type for %%v%%.
     */
    static uint152(e) {
      return St(e, 152);
    }
    /**
     *  Return a new ``uint160`` type for %%v%%.
     */
    static uint160(e) {
      return St(e, 160);
    }
    /**
     *  Return a new ``uint168`` type for %%v%%.
     */
    static uint168(e) {
      return St(e, 168);
    }
    /**
     *  Return a new ``uint176`` type for %%v%%.
     */
    static uint176(e) {
      return St(e, 176);
    }
    /**
     *  Return a new ``uint184`` type for %%v%%.
     */
    static uint184(e) {
      return St(e, 184);
    }
    /**
     *  Return a new ``uint192`` type for %%v%%.
     */
    static uint192(e) {
      return St(e, 192);
    }
    /**
     *  Return a new ``uint200`` type for %%v%%.
     */
    static uint200(e) {
      return St(e, 200);
    }
    /**
     *  Return a new ``uint208`` type for %%v%%.
     */
    static uint208(e) {
      return St(e, 208);
    }
    /**
     *  Return a new ``uint216`` type for %%v%%.
     */
    static uint216(e) {
      return St(e, 216);
    }
    /**
     *  Return a new ``uint224`` type for %%v%%.
     */
    static uint224(e) {
      return St(e, 224);
    }
    /**
     *  Return a new ``uint232`` type for %%v%%.
     */
    static uint232(e) {
      return St(e, 232);
    }
    /**
     *  Return a new ``uint240`` type for %%v%%.
     */
    static uint240(e) {
      return St(e, 240);
    }
    /**
     *  Return a new ``uint248`` type for %%v%%.
     */
    static uint248(e) {
      return St(e, 248);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint256(e) {
      return St(e, 256);
    }
    /**
     *  Return a new ``uint256`` type for %%v%%.
     */
    static uint(e) {
      return St(e, 256);
    }
    /**
     *  Return a new ``int8`` type for %%v%%.
     */
    static int8(e) {
      return St(e, -8);
    }
    /**
     *  Return a new ``int16`` type for %%v%%.
     */
    static int16(e) {
      return St(e, -16);
    }
    /**
     *  Return a new ``int24`` type for %%v%%.
     */
    static int24(e) {
      return St(e, -24);
    }
    /**
     *  Return a new ``int32`` type for %%v%%.
     */
    static int32(e) {
      return St(e, -32);
    }
    /**
     *  Return a new ``int40`` type for %%v%%.
     */
    static int40(e) {
      return St(e, -40);
    }
    /**
     *  Return a new ``int48`` type for %%v%%.
     */
    static int48(e) {
      return St(e, -48);
    }
    /**
     *  Return a new ``int56`` type for %%v%%.
     */
    static int56(e) {
      return St(e, -56);
    }
    /**
     *  Return a new ``int64`` type for %%v%%.
     */
    static int64(e) {
      return St(e, -64);
    }
    /**
     *  Return a new ``int72`` type for %%v%%.
     */
    static int72(e) {
      return St(e, -72);
    }
    /**
     *  Return a new ``int80`` type for %%v%%.
     */
    static int80(e) {
      return St(e, -80);
    }
    /**
     *  Return a new ``int88`` type for %%v%%.
     */
    static int88(e) {
      return St(e, -88);
    }
    /**
     *  Return a new ``int96`` type for %%v%%.
     */
    static int96(e) {
      return St(e, -96);
    }
    /**
     *  Return a new ``int104`` type for %%v%%.
     */
    static int104(e) {
      return St(e, -104);
    }
    /**
     *  Return a new ``int112`` type for %%v%%.
     */
    static int112(e) {
      return St(e, -112);
    }
    /**
     *  Return a new ``int120`` type for %%v%%.
     */
    static int120(e) {
      return St(e, -120);
    }
    /**
     *  Return a new ``int128`` type for %%v%%.
     */
    static int128(e) {
      return St(e, -128);
    }
    /**
     *  Return a new ``int136`` type for %%v%%.
     */
    static int136(e) {
      return St(e, -136);
    }
    /**
     *  Return a new ``int144`` type for %%v%%.
     */
    static int144(e) {
      return St(e, -144);
    }
    /**
     *  Return a new ``int52`` type for %%v%%.
     */
    static int152(e) {
      return St(e, -152);
    }
    /**
     *  Return a new ``int160`` type for %%v%%.
     */
    static int160(e) {
      return St(e, -160);
    }
    /**
     *  Return a new ``int168`` type for %%v%%.
     */
    static int168(e) {
      return St(e, -168);
    }
    /**
     *  Return a new ``int176`` type for %%v%%.
     */
    static int176(e) {
      return St(e, -176);
    }
    /**
     *  Return a new ``int184`` type for %%v%%.
     */
    static int184(e) {
      return St(e, -184);
    }
    /**
     *  Return a new ``int92`` type for %%v%%.
     */
    static int192(e) {
      return St(e, -192);
    }
    /**
     *  Return a new ``int200`` type for %%v%%.
     */
    static int200(e) {
      return St(e, -200);
    }
    /**
     *  Return a new ``int208`` type for %%v%%.
     */
    static int208(e) {
      return St(e, -208);
    }
    /**
     *  Return a new ``int216`` type for %%v%%.
     */
    static int216(e) {
      return St(e, -216);
    }
    /**
     *  Return a new ``int224`` type for %%v%%.
     */
    static int224(e) {
      return St(e, -224);
    }
    /**
     *  Return a new ``int232`` type for %%v%%.
     */
    static int232(e) {
      return St(e, -232);
    }
    /**
     *  Return a new ``int240`` type for %%v%%.
     */
    static int240(e) {
      return St(e, -240);
    }
    /**
     *  Return a new ``int248`` type for %%v%%.
     */
    static int248(e) {
      return St(e, -248);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int256(e) {
      return St(e, -256);
    }
    /**
     *  Return a new ``int256`` type for %%v%%.
     */
    static int(e) {
      return St(e, -256);
    }
    /**
     *  Return a new ``bytes1`` type for %%v%%.
     */
    static bytes1(e) {
      return Yt(e, 1);
    }
    /**
     *  Return a new ``bytes2`` type for %%v%%.
     */
    static bytes2(e) {
      return Yt(e, 2);
    }
    /**
     *  Return a new ``bytes3`` type for %%v%%.
     */
    static bytes3(e) {
      return Yt(e, 3);
    }
    /**
     *  Return a new ``bytes4`` type for %%v%%.
     */
    static bytes4(e) {
      return Yt(e, 4);
    }
    /**
     *  Return a new ``bytes5`` type for %%v%%.
     */
    static bytes5(e) {
      return Yt(e, 5);
    }
    /**
     *  Return a new ``bytes6`` type for %%v%%.
     */
    static bytes6(e) {
      return Yt(e, 6);
    }
    /**
     *  Return a new ``bytes7`` type for %%v%%.
     */
    static bytes7(e) {
      return Yt(e, 7);
    }
    /**
     *  Return a new ``bytes8`` type for %%v%%.
     */
    static bytes8(e) {
      return Yt(e, 8);
    }
    /**
     *  Return a new ``bytes9`` type for %%v%%.
     */
    static bytes9(e) {
      return Yt(e, 9);
    }
    /**
     *  Return a new ``bytes10`` type for %%v%%.
     */
    static bytes10(e) {
      return Yt(e, 10);
    }
    /**
     *  Return a new ``bytes11`` type for %%v%%.
     */
    static bytes11(e) {
      return Yt(e, 11);
    }
    /**
     *  Return a new ``bytes12`` type for %%v%%.
     */
    static bytes12(e) {
      return Yt(e, 12);
    }
    /**
     *  Return a new ``bytes13`` type for %%v%%.
     */
    static bytes13(e) {
      return Yt(e, 13);
    }
    /**
     *  Return a new ``bytes14`` type for %%v%%.
     */
    static bytes14(e) {
      return Yt(e, 14);
    }
    /**
     *  Return a new ``bytes15`` type for %%v%%.
     */
    static bytes15(e) {
      return Yt(e, 15);
    }
    /**
     *  Return a new ``bytes16`` type for %%v%%.
     */
    static bytes16(e) {
      return Yt(e, 16);
    }
    /**
     *  Return a new ``bytes17`` type for %%v%%.
     */
    static bytes17(e) {
      return Yt(e, 17);
    }
    /**
     *  Return a new ``bytes18`` type for %%v%%.
     */
    static bytes18(e) {
      return Yt(e, 18);
    }
    /**
     *  Return a new ``bytes19`` type for %%v%%.
     */
    static bytes19(e) {
      return Yt(e, 19);
    }
    /**
     *  Return a new ``bytes20`` type for %%v%%.
     */
    static bytes20(e) {
      return Yt(e, 20);
    }
    /**
     *  Return a new ``bytes21`` type for %%v%%.
     */
    static bytes21(e) {
      return Yt(e, 21);
    }
    /**
     *  Return a new ``bytes22`` type for %%v%%.
     */
    static bytes22(e) {
      return Yt(e, 22);
    }
    /**
     *  Return a new ``bytes23`` type for %%v%%.
     */
    static bytes23(e) {
      return Yt(e, 23);
    }
    /**
     *  Return a new ``bytes24`` type for %%v%%.
     */
    static bytes24(e) {
      return Yt(e, 24);
    }
    /**
     *  Return a new ``bytes25`` type for %%v%%.
     */
    static bytes25(e) {
      return Yt(e, 25);
    }
    /**
     *  Return a new ``bytes26`` type for %%v%%.
     */
    static bytes26(e) {
      return Yt(e, 26);
    }
    /**
     *  Return a new ``bytes27`` type for %%v%%.
     */
    static bytes27(e) {
      return Yt(e, 27);
    }
    /**
     *  Return a new ``bytes28`` type for %%v%%.
     */
    static bytes28(e) {
      return Yt(e, 28);
    }
    /**
     *  Return a new ``bytes29`` type for %%v%%.
     */
    static bytes29(e) {
      return Yt(e, 29);
    }
    /**
     *  Return a new ``bytes30`` type for %%v%%.
     */
    static bytes30(e) {
      return Yt(e, 30);
    }
    /**
     *  Return a new ``bytes31`` type for %%v%%.
     */
    static bytes31(e) {
      return Yt(e, 31);
    }
    /**
     *  Return a new ``bytes32`` type for %%v%%.
     */
    static bytes32(e) {
      return Yt(e, 32);
    }
    /**
     *  Return a new ``address`` type for %%v%%.
     */
    static address(e) {
      return new Ui(pi, "address", e);
    }
    /**
     *  Return a new ``bool`` type for %%v%%.
     */
    static bool(e) {
      return new Ui(pi, "bool", !!e);
    }
    /**
     *  Return a new ``bytes`` type for %%v%%.
     */
    static bytes(e) {
      return new Ui(pi, "bytes", e);
    }
    /**
     *  Return a new ``string`` type for %%v%%.
     */
    static string(e) {
      return new Ui(pi, "string", e);
    }
    /**
     *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
     */
    static array(e, n) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
     */
    static tuple(e, n) {
      throw new Error("not implemented yet");
    }
    /**
     *  Return a new ``uint8`` type for %%v%%.
     */
    static overrides(e) {
      return new Ui(pi, "overrides", Object.assign({}, e));
    }
    /**
     *  Returns true only if %%value%% is a [[Typed]] instance.
     */
    static isTyped(e) {
      return e && typeof e == "object" && "_typedSymbol" in e && e._typedSymbol === o2;
    }
    /**
     *  If the value is a [[Typed]] instance, validates the underlying value
     *  and returns it, otherwise returns value directly.
     *
     *  This is useful for functions that with to accept either a [[Typed]]
     *  object or values.
     */
    static dereference(e, n) {
      if (Ui.isTyped(e)) {
        if (e.type !== n) throw new Error(`invalid type: expecetd ${n}, got ${e.type}`);
        return e.value;
      }
      return e;
    }
  };
ds = /* @__PURE__ */ new WeakMap();
Be(U5, "Typed");
var tn = U5,
  N5 = class extends ki {
    constructor(e) {
      super("address", "address", e, !1);
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000";
    }
    encode(e, n) {
      let i = tn.dereference(n, "string");
      try {
        i = ti(i);
      } catch (l) {
        return this._throwError(l.message, n);
      }
      return e.writeValue(i);
    }
    decode(e) {
      return ti(Y1(e.readValue(), 20));
    }
  };
Be(N5, "AddressCoder");
var VA = N5,
  D5 = class extends ki {
    constructor(e) {
      super(e.name, e.type, "_", e.dynamic), Ge(this, "coder"), (this.coder = e);
    }
    defaultValue() {
      return this.coder.defaultValue();
    }
    encode(e, n) {
      return this.coder.encode(e, n);
    }
    decode(e) {
      return this.coder.decode(e);
    }
  };
Be(D5, "AnonymousCoder");
var WA = D5;
function nm(t, e, n) {
  let i = [];
  if (Array.isArray(n)) i = n;
  else if (n && typeof n == "object") {
    let g = {};
    i = e.map((b) => {
      const p = b.localName;
      return (
        Pt(p, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
          argument: "values",
          info: {
            coder: b,
          },
          value: n,
        }),
        Pt(!g[p], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
          argument: "values",
          info: {
            coder: b,
          },
          value: n,
        }),
        (g[p] = !0),
        n[p]
      );
    });
  } else bt(!1, "invalid tuple value", "tuple", n);
  bt(e.length === i.length, "types/value length mismatch", "tuple", n);
  let l = new xp(),
    a = new xp(),
    c = [];
  e.forEach((g, b) => {
    let p = i[b];
    if (g.dynamic) {
      let _ = a.length;
      g.encode(a, p);
      let M = l.writeUpdatableValue();
      c.push((S) => {
        M(S + _);
      });
    } else g.encode(l, p);
  }),
    c.forEach((g) => {
      g(l.length);
    });
  let v = t.appendWriter(l);
  return (v += t.appendWriter(a)), v;
}
Be(nm, "pack");
function im(t, e) {
  let n = [],
    i = [],
    l = t.subReader(0);
  return (
    e.forEach((a) => {
      let c = null;
      if (a.dynamic) {
        let v = t.readIndex(),
          g = l.subReader(v);
        try {
          c = a.decode(g);
        } catch (b) {
          if (is(b, "BUFFER_OVERRUN")) throw b;
          (c = b), (c.baseType = a.name), (c.name = a.localName), (c.type = a.type);
        }
      } else
        try {
          c = a.decode(t);
        } catch (v) {
          if (is(v, "BUFFER_OVERRUN")) throw v;
          (c = v), (c.baseType = a.name), (c.name = a.localName), (c.type = a.type);
        }
      if (c == null) throw new Error("investigate");
      n.push(c), i.push(a.localName || null);
    }),
    c5.fromItems(n, i)
  );
}
Be(im, "unpack");
var L5 = class extends ki {
  constructor(e, n, i) {
    const l = e.type + "[" + (n >= 0 ? n : "") + "]",
      a = n === -1 || e.dynamic;
    super("array", l, i, a),
      Ge(this, "coder"),
      Ge(this, "length"),
      Ft(this, {
        coder: e,
        length: n,
      });
  }
  defaultValue() {
    const e = this.coder.defaultValue(),
      n = [];
    for (let i = 0; i < this.length; i++) n.push(e);
    return n;
  }
  encode(e, n) {
    const i = tn.dereference(n, "array");
    Array.isArray(i) || this._throwError("expected array value", i);
    let l = this.length;
    l === -1 && ((l = i.length), e.writeValue(i.length)),
      W1(i.length, l, "coder array" + (this.localName ? " " + this.localName : ""));
    let a = [];
    for (let c = 0; c < i.length; c++) a.push(this.coder);
    return nm(e, a, i);
  }
  decode(e) {
    let n = this.length;
    n === -1 &&
      ((n = e.readIndex()),
      Pt(n * $r <= e.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
        buffer: e.bytes,
        offset: n * $r,
        length: e.dataLength,
      }));
    let i = [];
    for (let l = 0; l < n; l++) i.push(new WA(this.coder));
    return im(e, i);
  }
};
Be(L5, "ArrayCoder");
var KA = L5,
  F5 = class extends ki {
    constructor(e) {
      super("bool", "bool", e, !1);
    }
    defaultValue() {
      return !1;
    }
    encode(e, n) {
      const i = tn.dereference(n, "bool");
      return e.writeValue(i ? 1 : 0);
    }
    decode(e) {
      return !!e.readValue();
    }
  };
Be(F5, "BooleanCoder");
var ZA = F5,
  q5 = class extends ki {
    constructor(e, n) {
      super(e, e, n, !0);
    }
    defaultValue() {
      return "0x";
    }
    encode(e, n) {
      n = In(n);
      let i = e.writeValue(n.length);
      return (i += e.writeBytes(n)), i;
    }
    decode(e) {
      return e.readBytes(e.readIndex(), !0);
    }
  };
Be(q5, "DynamicBytesCoder");
var z5 = q5,
  j5 = class extends z5 {
    constructor(e) {
      super("bytes", e);
    }
    decode(e) {
      return dr(super.decode(e));
    }
  };
Be(j5, "BytesCoder");
var GA = j5,
  $5 = class extends ki {
    constructor(e, n) {
      let i = "bytes" + String(e);
      super(i, i, n, !1),
        Ge(this, "size"),
        Ft(
          this,
          {
            size: e,
          },
          {
            size: "number",
          }
        );
    }
    defaultValue() {
      return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(
        0,
        2 + this.size * 2
      );
    }
    encode(e, n) {
      let i = In(tn.dereference(n, this.type));
      return (
        i.length !== this.size && this._throwError("incorrect data length", n), e.writeBytes(i)
      );
    }
    decode(e) {
      return dr(e.readBytes(this.size));
    }
  };
Be($5, "FixedBytesCoder");
var YA = $5,
  JA = new Uint8Array([]),
  H5 = class extends ki {
    constructor(e) {
      super("null", "", e, !1);
    }
    defaultValue() {
      return null;
    }
    encode(e, n) {
      return n != null && this._throwError("not null", n), e.writeBytes(JA);
    }
    decode(e) {
      return e.readBytes(0), null;
    }
  };
Be(H5, "NullCoder");
var QA = H5,
  XA = BigInt(0),
  ek = BigInt(1),
  tk = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"),
  V5 = class extends ki {
    constructor(e, n, i) {
      const l = (n ? "int" : "uint") + e * 8;
      super(l, l, i, !1),
        Ge(this, "size"),
        Ge(this, "signed"),
        Ft(
          this,
          {
            size: e,
            signed: n,
          },
          {
            size: "number",
            signed: "boolean",
          }
        );
    }
    defaultValue() {
      return 0;
    }
    encode(e, n) {
      let i = ii(tn.dereference(n, this.type)),
        l = Fo(tk, $r * 8);
      if (this.signed) {
        let a = Fo(l, this.size * 8 - 1);
        (i > a || i < -(a + ek)) && this._throwError("value out-of-bounds", n), (i = e5(i, 8 * $r));
      } else (i < XA || i > Fo(l, this.size * 8)) && this._throwError("value out-of-bounds", n);
      return e.writeValue(i);
    }
    decode(e) {
      let n = Fo(e.readValue(), this.size * 8);
      return this.signed && (n = X3(n, this.size * 8)), n;
    }
  };
Be(V5, "NumberCoder");
var rk = V5,
  W5 = class extends z5 {
    constructor(e) {
      super("string", e);
    }
    defaultValue() {
      return "";
    }
    encode(e, n) {
      return super.encode(e, Q1(tn.dereference(n, "string")));
    }
    decode(e) {
      return f5(super.decode(e));
    }
  };
Be(W5, "StringCoder");
var nk = W5,
  K5 = class extends ki {
    constructor(e, n) {
      let i = !1;
      const l = [];
      e.forEach((c) => {
        c.dynamic && (i = !0), l.push(c.type);
      });
      const a = "tuple(" + l.join(",") + ")";
      super("tuple", a, n, i),
        Ge(this, "coders"),
        Ft(this, {
          coders: Object.freeze(e.slice()),
        });
    }
    defaultValue() {
      const e = [];
      this.coders.forEach((i) => {
        e.push(i.defaultValue());
      });
      const n = this.coders.reduce((i, l) => {
        const a = l.localName;
        return a && (i[a] || (i[a] = 0), i[a]++), i;
      }, {});
      return (
        this.coders.forEach((i, l) => {
          let a = i.localName;
          !a || n[a] !== 1 || (a === "length" && (a = "_length"), e[a] == null && (e[a] = e[l]));
        }),
        Object.freeze(e)
      );
    }
    encode(e, n) {
      const i = tn.dereference(n, "tuple");
      return nm(e, this.coders, i);
    }
    decode(e) {
      return im(e, this.coders);
    }
  };
Be(K5, "TupleCoder");
var kl = K5;
function Vs(t) {
  return ei(Q1(t));
}
Be(Vs, "id");
function Bl(t, e) {
  return {
    address: ti(t),
    storageKeys: e.map(
      (n, i) => (bt(Si(n, 32), "invalid slot", `storageKeys[${i}]`, n), n.toLowerCase())
    ),
  };
}
Be(Bl, "accessSetify");
function Z5(t) {
  if (Array.isArray(t))
    return t.map((n, i) =>
      Array.isArray(n)
        ? (bt(n.length === 2, "invalid slot set", `value[${i}]`, n), Bl(n[0], n[1]))
        : (bt(n != null && typeof n == "object", "invalid address-slot set", "value", t),
          Bl(n.address, n.storageKeys))
    );
  bt(t != null && typeof t == "object", "invalid access list", "value", t);
  const e = Object.keys(t).map((n) => {
    const i = t[n].reduce((l, a) => ((l[a] = !0), l), {});
    return Bl(n, Object.keys(i).sort());
  });
  return e.sort((n, i) => n.address.localeCompare(i.address)), e;
}
Be(Z5, "accessListify");
function Or(t) {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => e.add(n)), Object.freeze(e);
}
Be(Or, "setify");
var ik = "external public payable override",
  ak = Or(ik.split(" ")),
  G5 = "constant external internal payable private public pure view override",
  sk = Or(G5.split(" ")),
  Y5 = "constructor error event fallback function receive struct",
  J5 = Or(Y5.split(" ")),
  Q5 = "calldata memory storage payable indexed",
  ok = Or(Q5.split(" ")),
  fk = "tuple returns",
  lk = [Y5, Q5, fk, G5].join(" "),
  uk = Or(lk.split(" ")),
  ck = {
    "(": "OPEN_PAREN",
    ")": "CLOSE_PAREN",
    "[": "OPEN_BRACKET",
    "]": "CLOSE_BRACKET",
    ",": "COMMA",
    "@": "AT",
  },
  hk = new RegExp("^(\\s*)"),
  dk = new RegExp("^([0-9]+)"),
  pk = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"),
  X5 = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"),
  e4 = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$"),
  Pr,
  Ln,
  ll,
  N0,
  Eo,
  Bi =
    ((Eo = class {
      constructor(t) {
        er(this, ll),
          er(this, Pr, void 0),
          er(this, Ln, void 0),
          Jt(this, Pr, 0),
          Jt(this, Ln, t.slice());
      }
      get offset() {
        return pt(this, Pr);
      }
      get length() {
        return pt(this, Ln).length - pt(this, Pr);
      }
      clone() {
        return new Eo(pt(this, Ln));
      }
      reset() {
        Jt(this, Pr, 0);
      }
      // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
      popKeyword(t) {
        const e = this.peek();
        if (e.type !== "KEYWORD" || !t.has(e.text)) throw new Error(`expected keyword ${e.text}`);
        return this.pop().text;
      }
      // Pops and returns the value of the next token if it is `type`; throws if out of tokens
      popType(t) {
        if (this.peek().type !== t) {
          const e = this.peek();
          throw new Error(`expected ${t}; got ${e.type} ${JSON.stringify(e.text)}`);
        }
        return this.pop().text;
      }
      // Pops and returns a "(" TOKENS ")"
      popParen() {
        const t = this.peek();
        if (t.type !== "OPEN_PAREN") throw new Error("bad start");
        const e = cr(this, ll, N0).call(this, pt(this, Pr) + 1, t.match + 1);
        return Jt(this, Pr, t.match + 1), e;
      }
      // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
      popParams() {
        const t = this.peek();
        if (t.type !== "OPEN_PAREN") throw new Error("bad start");
        const e = [];
        for (; pt(this, Pr) < t.match - 1; ) {
          const n = this.peek().linkNext;
          e.push(cr(this, ll, N0).call(this, pt(this, Pr) + 1, n)), Jt(this, Pr, n);
        }
        return Jt(this, Pr, t.match + 1), e;
      }
      // Returns the top Token, throwing if out of tokens
      peek() {
        if (pt(this, Pr) >= pt(this, Ln).length) throw new Error("out-of-bounds");
        return pt(this, Ln)[pt(this, Pr)];
      }
      // Returns the next value, if it is a keyword in `allowed`
      peekKeyword(t) {
        const e = this.peekType("KEYWORD");
        return e != null && t.has(e) ? e : null;
      }
      // Returns the value of the next token if it is `type`
      peekType(t) {
        if (this.length === 0) return null;
        const e = this.peek();
        return e.type === t ? e.text : null;
      }
      // Returns the next token; throws if out of tokens
      pop() {
        const t = this.peek();
        return mA(this, Pr)._++, t;
      }
      toString() {
        const t = [];
        for (let e = pt(this, Pr); e < pt(this, Ln).length; e++) {
          const n = pt(this, Ln)[e];
          t.push(`${n.type}:${n.text}`);
        }
        return `<TokenString ${t.join(" ")}>`;
      }
    }),
    (Pr = /* @__PURE__ */ new WeakMap()),
    (Ln = /* @__PURE__ */ new WeakMap()),
    (ll = /* @__PURE__ */ new WeakSet()),
    (N0 = /* @__PURE__ */ Be(function (t = 0, e = 0) {
      return new Eo(
        pt(this, Ln)
          .slice(t, e)
          .map((n) =>
            Object.freeze(
              Object.assign({}, n, {
                match: n.match - t,
                linkBack: n.linkBack - t,
                linkNext: n.linkNext - t,
              })
            )
          )
      );
    }, "#subTokenString")),
    Be(Eo, "TokenString"),
    Eo);
function Ci(t) {
  const e = [],
    n = /* @__PURE__ */ Be((c) => {
      const v = a < t.length ? JSON.stringify(t[a]) : "$EOI";
      throw new Error(`invalid token ${v} at ${a}: ${c}`);
    }, "throwError");
  let i = [],
    l = [],
    a = 0;
  for (; a < t.length; ) {
    let c = t.substring(a),
      v = c.match(hk);
    v && ((a += v[1].length), (c = t.substring(a)));
    const g = {
      depth: i.length,
      linkBack: -1,
      linkNext: -1,
      match: -1,
      type: "",
      text: "",
      offset: a,
      value: -1,
    };
    e.push(g);
    let b = ck[c[0]] || "";
    if (b) {
      if (((g.type = b), (g.text = c[0]), a++, b === "OPEN_PAREN"))
        i.push(e.length - 1), l.push(e.length - 1);
      else if (b == "CLOSE_PAREN")
        i.length === 0 && n("no matching open bracket"),
          (g.match = i.pop()),
          (e[g.match].match = e.length - 1),
          g.depth--,
          (g.linkBack = l.pop()),
          (e[g.linkBack].linkNext = e.length - 1);
      else if (b === "COMMA")
        (g.linkBack = l.pop()), (e[g.linkBack].linkNext = e.length - 1), l.push(e.length - 1);
      else if (b === "OPEN_BRACKET") g.type = "BRACKET";
      else if (b === "CLOSE_BRACKET") {
        let p = e.pop().text;
        if (e.length > 0 && e[e.length - 1].type === "NUMBER") {
          const _ = e.pop().text;
          (p = _ + p), (e[e.length - 1].value = ai(_));
        }
        if (e.length === 0 || e[e.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        e[e.length - 1].text += p;
      }
      continue;
    }
    if (((v = c.match(pk)), v)) {
      if (((g.text = v[1]), (a += g.text.length), uk.has(g.text))) {
        g.type = "KEYWORD";
        continue;
      }
      if (g.text.match(e4)) {
        g.type = "TYPE";
        continue;
      }
      g.type = "ID";
      continue;
    }
    if (((v = c.match(dk)), v)) {
      (g.text = v[1]), (g.type = "NUMBER"), (a += g.text.length);
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(c[0])} at position ${a}`);
  }
  return new Bi(e.map((c) => Object.freeze(c)));
}
Be(Ci, "lex");
function Bp(t, e) {
  let n = [];
  for (const i in e.keys()) t.has(i) && n.push(i);
  if (n.length > 1) throw new Error(`conflicting types: ${n.join(", ")}`);
}
Be(Bp, "allowSingle");
function Nf(t, e) {
  if (e.peekKeyword(J5)) {
    const n = e.pop().text;
    if (n !== t) throw new Error(`expected ${t}, got ${n}`);
  }
  return e.popType("ID");
}
Be(Nf, "consumeName");
function ri(t, e) {
  const n = /* @__PURE__ */ new Set();
  for (;;) {
    const i = t.peekType("KEYWORD");
    if (i == null || (e && !e.has(i))) break;
    if ((t.pop(), n.has(i))) throw new Error(`duplicate keywords: ${JSON.stringify(i)}`);
    n.add(i);
  }
  return Object.freeze(n);
}
Be(ri, "consumeKeywords");
function am(t) {
  let e = ri(t, sk);
  return (
    Bp(e, Or("constant payable nonpayable".split(" "))),
    Bp(e, Or("pure view payable nonpayable".split(" "))),
    e.has("view")
      ? "view"
      : e.has("pure")
      ? "pure"
      : e.has("payable")
      ? "payable"
      : e.has("nonpayable")
      ? "nonpayable"
      : e.has("constant")
      ? "view"
      : "nonpayable"
  );
}
Be(am, "consumeMutability");
function Gn(t, e) {
  return t.popParams().map((n) => Hr.from(n, e));
}
Be(Gn, "consumeParams");
function sm(t) {
  if (t.peekType("AT")) {
    if ((t.pop(), t.peekType("NUMBER"))) return ii(t.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
Be(sm, "consumeGas");
function ia(t) {
  if (t.length) throw new Error(`unexpected tokens at offset ${t.offset}: ${t.toString()}`);
}
Be(ia, "consumeEoi");
var mk = new RegExp(/^(.*)\[([0-9]*)\]$/);
function Cp(t) {
  const e = t.match(e4);
  if ((bt(e, "invalid type", "type", t), t === "uint")) return "uint256";
  if (t === "int") return "int256";
  if (e[2]) {
    const n = parseInt(e[2]);
    bt(n !== 0 && n <= 32, "invalid bytes length", "type", t);
  } else if (e[3]) {
    const n = parseInt(e[3]);
    bt(n !== 0 && n <= 256 && n % 8 === 0, "invalid numeric width", "type", t);
  }
  return t;
}
Be(Cp, "verifyBasicType");
var or = {},
  rn = Symbol.for("_ethers_internal"),
  f2 = "_ParamTypeInternal",
  l2 = "_ErrorInternal",
  u2 = "_EventInternal",
  c2 = "_ConstructorInternal",
  h2 = "_FallbackInternal",
  d2 = "_FunctionInternal",
  p2 = "_StructInternal",
  nf,
  Cl,
  t4 = class Bn {
    /**
     *  @private
     */
    constructor(e, n, i, l, a, c, v, g) {
      if (
        (er(this, nf),
        Ge(this, "name"),
        Ge(this, "type"),
        Ge(this, "baseType"),
        Ge(this, "indexed"),
        Ge(this, "components"),
        Ge(this, "arrayLength"),
        Ge(this, "arrayChildren"),
        Ku(e, or, "ParamType"),
        Object.defineProperty(this, rn, {
          value: f2,
        }),
        c && (c = Object.freeze(c.slice())),
        l === "array")
      ) {
        if (v == null || g == null) throw new Error("");
      } else if (v != null || g != null) throw new Error("");
      if (l === "tuple") {
        if (c == null) throw new Error("");
      } else if (c != null) throw new Error("");
      Ft(this, {
        name: n,
        type: i,
        baseType: l,
        indexed: a,
        components: c,
        arrayLength: v,
        arrayChildren: g,
      });
    }
    /**
     *  Return a string representation of this type.
     *
     *  For example,
     *
     *  ``sighash" => "(uint256,address)"``
     *
     *  ``"minimal" => "tuple(uint256,address) indexed"``
     *
     *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
     */
    format(e) {
      if ((e == null && (e = "sighash"), e === "json")) {
        const i = this.name || "";
        if (this.isArray()) {
          const a = JSON.parse(this.arrayChildren.format("json"));
          return (
            (a.name = i),
            (a.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`),
            JSON.stringify(a)
          );
        }
        const l = {
          type: this.baseType === "tuple" ? "tuple" : this.type,
          name: i,
        };
        return (
          typeof this.indexed == "boolean" && (l.indexed = this.indexed),
          this.isTuple() && (l.components = this.components.map((a) => JSON.parse(a.format(e)))),
          JSON.stringify(l)
        );
      }
      let n = "";
      return (
        this.isArray()
          ? ((n += this.arrayChildren.format(e)),
            (n += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`))
          : this.isTuple()
          ? (n +=
              "(" + this.components.map((i) => i.format(e)).join(e === "full" ? ", " : ",") + ")")
          : (n += this.type),
        e !== "sighash" &&
          (this.indexed === !0 && (n += " indexed"),
          e === "full" && this.name && (n += " " + this.name)),
        n
      );
    }
    /**
     *  Returns true if %%this%% is an Array type.
     *
     *  This provides a type gaurd ensuring that [[arrayChildren]]
     *  and [[arrayLength]] are non-null.
     */
    isArray() {
      return this.baseType === "array";
    }
    /**
     *  Returns true if %%this%% is a Tuple type.
     *
     *  This provides a type gaurd ensuring that [[components]]
     *  is non-null.
     */
    isTuple() {
      return this.baseType === "tuple";
    }
    /**
     *  Returns true if %%this%% is an Indexable type.
     *
     *  This provides a type gaurd ensuring that [[indexed]]
     *  is non-null.
     */
    isIndexable() {
      return this.indexed != null;
    }
    /**
     *  Walks the **ParamType** with %%value%%, calling %%process%%
     *  on each type, destructing the %%value%% recursively.
     */
    walk(e, n) {
      if (this.isArray()) {
        if (!Array.isArray(e)) throw new Error("invalid array value");
        if (this.arrayLength !== -1 && e.length !== this.arrayLength)
          throw new Error("array is wrong length");
        const i = this;
        return e.map((l) => i.arrayChildren.walk(l, n));
      }
      if (this.isTuple()) {
        if (!Array.isArray(e)) throw new Error("invalid tuple value");
        if (e.length !== this.components.length) throw new Error("array is wrong length");
        const i = this;
        return e.map((l, a) => i.components[a].walk(l, n));
      }
      return n(this.type, e);
    }
    /**
     *  Walks the **ParamType** with %%value%%, asynchronously calling
     *  %%process%% on each type, destructing the %%value%% recursively.
     *
     *  This can be used to resolve ENS naes by walking and resolving each
     *  ``"address"`` type.
     */
    async walkAsync(e, n) {
      const i = [],
        l = [e];
      return (
        cr(this, nf, Cl).call(this, i, e, n, (a) => {
          l[0] = a;
        }),
        i.length && (await Promise.all(i)),
        l[0]
      );
    }
    /**
     *  Creates a new **ParamType** for %%obj%%.
     *
     *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
     *  otherwise the ``indexed`` keyword will throw an error.
     */
    static from(e, n) {
      if (Bn.isParamType(e)) return e;
      if (typeof e == "string")
        try {
          return Bn.from(Ci(e), n);
        } catch {
          bt(!1, "invalid param type", "obj", e);
        }
      else if (e instanceof Bi) {
        let v = "",
          g = "",
          b = null;
        ri(e, Or(["tuple"])).has("tuple") || e.peekType("OPEN_PAREN")
          ? ((g = "tuple"),
            (b = e.popParams().map((k) => Bn.from(k))),
            (v = `tuple(${b.map((k) => k.format()).join(",")})`))
          : ((v = Cp(e.popType("TYPE"))), (g = v));
        let p = null,
          _ = null;
        for (; e.length && e.peekType("BRACKET"); ) {
          const k = e.pop();
          (p = new Bn(or, "", v, g, null, b, _, p)),
            (_ = k.value),
            (v += k.text),
            (g = "array"),
            (b = null);
        }
        let M = null;
        if (ri(e, ok).has("indexed")) {
          if (!n) throw new Error("");
          M = !0;
        }
        const A = e.peekType("ID") ? e.pop().text : "";
        if (e.length) throw new Error("leftover tokens");
        return new Bn(or, A, v, g, M, b, _, p);
      }
      const i = e.name;
      bt(!i || (typeof i == "string" && i.match(X5)), "invalid name", "obj.name", i);
      let l = e.indexed;
      l != null && (bt(n, "parameter cannot be indexed", "obj.indexed", e.indexed), (l = !!l));
      let a = e.type,
        c = a.match(mk);
      if (c) {
        const v = parseInt(c[2] || "-1"),
          g = Bn.from({
            type: c[1],
            components: e.components,
          });
        return new Bn(or, i || "", a, "array", l, null, v, g);
      }
      if (
        a === "tuple" ||
        a.startsWith(
          "tuple("
          /* fix: ) */
        ) ||
        a.startsWith(
          "("
          /* fix: ) */
        )
      ) {
        const v = e.components != null ? e.components.map((b) => Bn.from(b)) : null;
        return new Bn(or, i || "", a, "tuple", l, v, null, null);
      }
      return (a = Cp(e.type)), new Bn(or, i || "", a, a, l, null, null, null);
    }
    /**
     *  Returns true if %%value%% is a **ParamType**.
     */
    static isParamType(e) {
      return e && e[rn] === f2;
    }
  };
nf = /* @__PURE__ */ new WeakSet();
Cl = /* @__PURE__ */ Be(function (t, e, n, i) {
  if (this.isArray()) {
    if (!Array.isArray(e)) throw new Error("invalid array value");
    if (this.arrayLength !== -1 && e.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const a = this.arrayChildren,
      c = e.slice();
    c.forEach((v, g) => {
      var b;
      cr((b = a), nf, Cl).call(b, t, v, n, (p) => {
        c[g] = p;
      });
    }),
      i(c);
    return;
  }
  if (this.isTuple()) {
    const a = this.components;
    let c;
    if (Array.isArray(e)) c = e.slice();
    else {
      if (e == null || typeof e != "object") throw new Error("invalid tuple value");
      c = a.map((v) => {
        if (!v.name) throw new Error("cannot use object value with unnamed components");
        if (!(v.name in e)) throw new Error(`missing value for component ${v.name}`);
        return e[v.name];
      });
    }
    if (c.length !== this.components.length) throw new Error("array is wrong length");
    c.forEach((v, g) => {
      var b;
      cr((b = a[g]), nf, Cl).call(b, t, v, n, (p) => {
        c[g] = p;
      });
    }),
      i(c);
    return;
  }
  const l = n(this.type, e);
  l.then
    ? t.push(
        (async function () {
          i(await l);
        })()
      )
    : i(l);
}, "#walkAsync");
Be(t4, "ParamType");
var Hr = t4,
  r4 = class Tp {
    /**
     *  @private
     */
    constructor(e, n, i) {
      Ge(this, "type"),
        Ge(this, "inputs"),
        Ku(e, or, "Fragment"),
        (i = Object.freeze(i.slice())),
        Ft(this, {
          type: n,
          inputs: i,
        });
    }
    /**
     *  Creates a new **Fragment** for %%obj%%, wich can be any supported
     *  ABI frgament type.
     */
    static from(e) {
      if (typeof e == "string") {
        try {
          Tp.from(JSON.parse(e));
        } catch {}
        return Tp.from(Ci(e));
      }
      if (e instanceof Bi)
        switch (e.peekKeyword(J5)) {
          case "constructor":
            return Pl.from(e);
          case "error":
            return mi.from(e);
          case "event":
            return Tl.from(e);
          case "fallback":
          case "receive":
            return m2.from(e);
          case "function":
            return Rl.from(e);
          case "struct":
            return D0.from(e);
        }
      else if (typeof e == "object") {
        switch (e.type) {
          case "constructor":
            return Pl.from(e);
          case "error":
            return mi.from(e);
          case "event":
            return Tl.from(e);
          case "fallback":
          case "receive":
            return m2.from(e);
          case "function":
            return Rl.from(e);
          case "struct":
            return D0.from(e);
        }
        Pt(!1, `unsupported type: ${e.type}`, "UNSUPPORTED_OPERATION", {
          operation: "Fragment.from",
        });
      }
      bt(!1, "unsupported frgament object", "obj", e);
    }
    /**
     *  Returns true if %%value%% is a [[ConstructorFragment]].
     */
    static isConstructor(e) {
      return Pl.isFragment(e);
    }
    /**
     *  Returns true if %%value%% is an [[ErrorFragment]].
     */
    static isError(e) {
      return mi.isFragment(e);
    }
    /**
     *  Returns true if %%value%% is an [[EventFragment]].
     */
    static isEvent(e) {
      return Tl.isFragment(e);
    }
    /**
     *  Returns true if %%value%% is a [[FunctionFragment]].
     */
    static isFunction(e) {
      return Rl.isFragment(e);
    }
    /**
     *  Returns true if %%value%% is a [[StructFragment]].
     */
    static isStruct(e) {
      return D0.isFragment(e);
    }
  };
Be(r4, "Fragment");
var Yu = r4,
  n4 = class extends Yu {
    /**
     *  @private
     */
    constructor(e, n, i, l) {
      super(e, n, l),
        Ge(this, "name"),
        bt(typeof i == "string" && i.match(X5), "invalid identifier", "name", i),
        (l = Object.freeze(l.slice())),
        Ft(this, {
          name: i,
        });
    }
  };
Be(n4, "NamedFragment");
var Ju = n4;
function Ws(t, e) {
  return "(" + e.map((n) => n.format(t)).join(t === "full" ? ", " : ",") + ")";
}
Be(Ws, "joinParams");
var i4 = class jo extends Ju {
  /**
   *  @private
   */
  constructor(e, n, i) {
    super(e, "error", n, i),
      Object.defineProperty(this, rn, {
        value: l2,
      });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return Vs(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(e) {
    if ((e == null && (e = "sighash"), e === "json"))
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
      });
    const n = [];
    return e !== "sighash" && n.push("error"), n.push(this.name + Ws(e, this.inputs)), n.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(e) {
    if (jo.isFragment(e)) return e;
    if (typeof e == "string") return jo.from(Ci(e));
    if (e instanceof Bi) {
      const n = Nf("error", e),
        i = Gn(e);
      return ia(e), new jo(or, n, i);
    }
    return new jo(or, e.name, e.inputs ? e.inputs.map(Hr.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(e) {
    return e && e[rn] === l2;
  }
};
Be(i4, "ErrorFragment");
var mi = i4,
  a4 = class ps extends Ju {
    /**
     *  @private
     */
    constructor(e, n, i, l) {
      super(e, "event", n, i),
        Ge(this, "anonymous"),
        Object.defineProperty(this, rn, {
          value: u2,
        }),
        Ft(this, {
          anonymous: l,
        });
    }
    /**
     *  The Event topic hash.
     */
    get topicHash() {
      return Vs(this.format("sighash"));
    }
    /**
     *  Returns a string representation of this event as %%format%%.
     */
    format(e) {
      if ((e == null && (e = "sighash"), e === "json"))
        return JSON.stringify({
          type: "event",
          anonymous: this.anonymous,
          name: this.name,
          inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
        });
      const n = [];
      return (
        e !== "sighash" && n.push("event"),
        n.push(this.name + Ws(e, this.inputs)),
        e !== "sighash" && this.anonymous && n.push("anonymous"),
        n.join(" ")
      );
    }
    /**
     *  Return the topic hash for an event with %%name%% and %%params%%.
     */
    static getTopicHash(e, n) {
      return (n = (n || []).map((l) => Hr.from(l))), new ps(or, e, n, !1).topicHash;
    }
    /**
     *  Returns a new **EventFragment** for %%obj%%.
     */
    static from(e) {
      if (ps.isFragment(e)) return e;
      if (typeof e == "string")
        try {
          return ps.from(Ci(e));
        } catch {
          bt(!1, "invalid event fragment", "obj", e);
        }
      else if (e instanceof Bi) {
        const n = Nf("event", e),
          i = Gn(e, !0),
          l = !!ri(e, Or(["anonymous"])).has("anonymous");
        return ia(e), new ps(or, n, i, l);
      }
      return new ps(or, e.name, e.inputs ? e.inputs.map((n) => Hr.from(n, !0)) : [], !!e.anonymous);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is an
     *  **EventFragment**.
     */
    static isFragment(e) {
      return e && e[rn] === u2;
    }
  };
Be(a4, "EventFragment");
var Tl = a4,
  s4 = class $o extends Yu {
    /**
     *  @private
     */
    constructor(e, n, i, l, a) {
      super(e, n, i),
        Ge(this, "payable"),
        Ge(this, "gas"),
        Object.defineProperty(this, rn, {
          value: c2,
        }),
        Ft(this, {
          payable: l,
          gas: a,
        });
    }
    /**
     *  Returns a string representation of this constructor as %%format%%.
     */
    format(e) {
      if (
        (Pt(
          e != null && e !== "sighash",
          "cannot format a constructor for sighash",
          "UNSUPPORTED_OPERATION",
          {
            operation: "format(sighash)",
          }
        ),
        e === "json")
      )
        return JSON.stringify({
          type: "constructor",
          stateMutability: this.payable ? "payable" : "undefined",
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
        });
      const n = [`constructor${Ws(e, this.inputs)}`];
      return (
        this.payable && n.push("payable"),
        this.gas != null && n.push(`@${this.gas.toString()}`),
        n.join(" ")
      );
    }
    /**
     *  Returns a new **ConstructorFragment** for %%obj%%.
     */
    static from(e) {
      if ($o.isFragment(e)) return e;
      if (typeof e == "string")
        try {
          return $o.from(Ci(e));
        } catch {
          bt(!1, "invalid constuctor fragment", "obj", e);
        }
      else if (e instanceof Bi) {
        ri(e, Or(["constructor"]));
        const n = Gn(e),
          i = !!ri(e, ak).has("payable"),
          l = sm(e);
        return ia(e), new $o(or, "constructor", n, i, l);
      }
      return new $o(
        or,
        "constructor",
        e.inputs ? e.inputs.map(Hr.from) : [],
        !!e.payable,
        e.gas != null ? e.gas : null
      );
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **ConstructorFragment**.
     */
    static isFragment(e) {
      return e && e[rn] === c2;
    }
  };
Be(s4, "ConstructorFragment");
var Pl = s4,
  o4 = class ya extends Yu {
    constructor(e, n, i) {
      super(e, "fallback", n),
        Ge(this, "payable"),
        Object.defineProperty(this, rn, {
          value: h2,
        }),
        Ft(this, {
          payable: i,
        });
    }
    /**
     *  Returns a string representation of this fallback as %%format%%.
     */
    format(e) {
      const n = this.inputs.length === 0 ? "receive" : "fallback";
      if (e === "json") {
        const i = this.payable ? "payable" : "nonpayable";
        return JSON.stringify({
          type: n,
          stateMutability: i,
        });
      }
      return `${n}()${this.payable ? " payable" : ""}`;
    }
    /**
     *  Returns a new **FallbackFragment** for %%obj%%.
     */
    static from(e) {
      if (ya.isFragment(e)) return e;
      if (typeof e == "string")
        try {
          return ya.from(Ci(e));
        } catch {
          bt(!1, "invalid fallback fragment", "obj", e);
        }
      else if (e instanceof Bi) {
        const n = e.toString(),
          i = e.peekKeyword(Or(["fallback", "receive"]));
        if (
          (bt(i, "type must be fallback or receive", "obj", n),
          e.popKeyword(Or(["fallback", "receive"])) === "receive")
        ) {
          const v = Gn(e);
          return (
            bt(v.length === 0, "receive cannot have arguments", "obj.inputs", v),
            ri(e, Or(["payable"])),
            ia(e),
            new ya(or, [], !0)
          );
        }
        let a = Gn(e);
        a.length
          ? bt(
              a.length === 1 && a[0].type === "bytes",
              "invalid fallback inputs",
              "obj.inputs",
              a.map((v) => v.format("minimal")).join(", ")
            )
          : (a = [Hr.from("bytes")]);
        const c = am(e);
        if (
          (bt(
            c === "nonpayable" || c === "payable",
            "fallback cannot be constants",
            "obj.stateMutability",
            c
          ),
          ri(e, Or(["returns"])).has("returns"))
        ) {
          const v = Gn(e);
          bt(
            v.length === 1 && v[0].type === "bytes",
            "invalid fallback outputs",
            "obj.outputs",
            v.map((g) => g.format("minimal")).join(", ")
          );
        }
        return ia(e), new ya(or, a, c === "payable");
      }
      if (e.type === "receive") return new ya(or, [], !0);
      if (e.type === "fallback") {
        const n = [Hr.from("bytes")],
          i = e.stateMutability === "payable";
        return new ya(or, n, i);
      }
      bt(!1, "invalid fallback description", "obj", e);
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FallbackFragment**.
     */
    static isFragment(e) {
      return e && e[rn] === h2;
    }
  };
Be(o4, "FallbackFragment");
var m2 = o4,
  f4 = class ms extends Ju {
    /**
     *  @private
     */
    constructor(e, n, i, l, a, c) {
      super(e, "function", n, l),
        Ge(this, "constant"),
        Ge(this, "outputs"),
        Ge(this, "stateMutability"),
        Ge(this, "payable"),
        Ge(this, "gas"),
        Object.defineProperty(this, rn, {
          value: d2,
        }),
        (a = Object.freeze(a.slice())),
        Ft(this, {
          constant: i === "view" || i === "pure",
          gas: c,
          outputs: a,
          payable: i === "payable",
          stateMutability: i,
        });
    }
    /**
     *  The Function selector.
     */
    get selector() {
      return Vs(this.format("sighash")).substring(0, 10);
    }
    /**
     *  Returns a string representation of this function as %%format%%.
     */
    format(e) {
      if ((e == null && (e = "sighash"), e === "json"))
        return JSON.stringify({
          type: "function",
          name: this.name,
          constant: this.constant,
          stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
          payable: this.payable,
          gas: this.gas != null ? this.gas : void 0,
          inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
          outputs: this.outputs.map((i) => JSON.parse(i.format(e))),
        });
      const n = [];
      return (
        e !== "sighash" && n.push("function"),
        n.push(this.name + Ws(e, this.inputs)),
        e !== "sighash" &&
          (this.stateMutability !== "nonpayable" && n.push(this.stateMutability),
          this.outputs && this.outputs.length && (n.push("returns"), n.push(Ws(e, this.outputs))),
          this.gas != null && n.push(`@${this.gas.toString()}`)),
        n.join(" ")
      );
    }
    /**
     *  Return the selector for a function with %%name%% and %%params%%.
     */
    static getSelector(e, n) {
      return (n = (n || []).map((l) => Hr.from(l))), new ms(or, e, "view", n, [], null).selector;
    }
    /**
     *  Returns a new **FunctionFragment** for %%obj%%.
     */
    static from(e) {
      if (ms.isFragment(e)) return e;
      if (typeof e == "string")
        try {
          return ms.from(Ci(e));
        } catch {
          bt(!1, "invalid function fragment", "obj", e);
        }
      else if (e instanceof Bi) {
        const i = Nf("function", e),
          l = Gn(e),
          a = am(e);
        let c = [];
        ri(e, Or(["returns"])).has("returns") && (c = Gn(e));
        const v = sm(e);
        return ia(e), new ms(or, i, a, l, c, v);
      }
      let n = e.stateMutability;
      return (
        n == null &&
          ((n = "payable"),
          typeof e.constant == "boolean"
            ? ((n = "view"),
              e.constant ||
                ((n = "payable"),
                typeof e.payable == "boolean" && !e.payable && (n = "nonpayable")))
            : typeof e.payable == "boolean" && !e.payable && (n = "nonpayable")),
        new ms(
          or,
          e.name,
          n,
          e.inputs ? e.inputs.map(Hr.from) : [],
          e.outputs ? e.outputs.map(Hr.from) : [],
          e.gas != null ? e.gas : null
        )
      );
    }
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **FunctionFragment**.
     */
    static isFragment(e) {
      return e && e[rn] === d2;
    }
  };
Be(f4, "FunctionFragment");
var Rl = f4,
  l4 = class Il extends Ju {
    /**
     *  @private
     */
    constructor(e, n, i) {
      super(e, "struct", n, i),
        Object.defineProperty(this, rn, {
          value: p2,
        });
    }
    /**
     *  Returns a string representation of this struct as %%format%%.
     */
    format() {
      throw new Error("@TODO");
    }
    /**
     *  Returns a new **StructFragment** for %%obj%%.
     */
    static from(e) {
      if (typeof e == "string")
        try {
          return Il.from(Ci(e));
        } catch {
          bt(!1, "invalid struct fragment", "obj", e);
        }
      else if (e instanceof Bi) {
        const n = Nf("struct", e),
          i = Gn(e);
        return ia(e), new Il(or, n, i);
      }
      return new Il(or, e.name, e.inputs ? e.inputs.map(Hr.from) : []);
    }
    // @TODO: fix this return type
    /**
     *  Returns ``true`` and provides a type guard if %%value%% is a
     *  **StructFragment**.
     */
    static isFragment(e) {
      return e && e[rn] === p2;
    }
  };
Be(l4, "StructFragment");
var D0 = l4,
  Un = /* @__PURE__ */ new Map();
Un.set(0, "GENERIC_PANIC");
Un.set(1, "ASSERT_FALSE");
Un.set(17, "OVERFLOW");
Un.set(18, "DIVIDE_BY_ZERO");
Un.set(33, "ENUM_RANGE_ERROR");
Un.set(34, "BAD_STORAGE_DATA");
Un.set(49, "STACK_UNDERFLOW");
Un.set(50, "ARRAY_RANGE_ERROR");
Un.set(65, "OUT_OF_MEMORY");
Un.set(81, "UNINITIALIZED_FUNCTION_CALL");
var vk = new RegExp(/^bytes([0-9]*)$/),
  gk = new RegExp(/^(u?int)([0-9]*)$/),
  L0 = null,
  v2 = 1024;
function u4(t, e, n, i) {
  let l = "missing revert data",
    a = null;
  const c = null;
  let v = null;
  if (n) {
    l = "execution reverted";
    const b = dn(n);
    if (((n = dr(n)), b.length === 0))
      (l += " (no data present; likely require(false) occurred"), (a = "require(false)");
    else if (b.length % 32 !== 4) l += " (could not decode reason; invalid data length)";
    else if (dr(b.slice(0, 4)) === "0x08c379a0")
      try {
        (a = i.decode(["string"], b.slice(4))[0]),
          (v = {
            signature: "Error(string)",
            name: "Error",
            args: [a],
          }),
          (l += `: ${JSON.stringify(a)}`);
      } catch {
        l += " (could not decode reason; invalid string data)";
      }
    else if (dr(b.slice(0, 4)) === "0x4e487b71")
      try {
        const p = Number(i.decode(["uint256"], b.slice(4))[0]);
        (v = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [p],
        }),
          (a = `Panic due to ${Un.get(p) || "UNKNOWN"}(${p})`),
          (l += `: ${a}`);
      } catch {
        l += " (could not decode panic code)";
      }
    else l += " (unknown custom error)";
  }
  const g = {
    to: e.to ? ti(e.to) : null,
    data: e.data || "0x",
  };
  return (
    e.from && (g.from = ti(e.from)),
    $s(l, "CALL_EXCEPTION", {
      action: t,
      data: n,
      reason: a,
      transaction: g,
      invocation: c,
      revert: v,
    })
  );
}
Be(u4, "getBuiltinCallException");
var Ea,
  _s,
  c4 = class Pp {
    constructor() {
      er(this, Ea);
    }
    /**
     *  Get the default values for the given %%types%%.
     *
     *  For example, a ``uint`` is by default ``0`` and ``bool``
     *  is by default ``false``.
     */
    getDefaultValue(e) {
      const n = e.map((l) => cr(this, Ea, _s).call(this, Hr.from(l)));
      return new kl(n, "_").defaultValue();
    }
    /**
     *  Encode the %%values%% as the %%types%% into ABI data.
     *
     *  @returns DataHexstring
     */
    encode(e, n) {
      W1(n.length, e.length, "types/values length mismatch");
      const i = e.map((c) => cr(this, Ea, _s).call(this, Hr.from(c))),
        l = new kl(i, "_"),
        a = new xp();
      return l.encode(a, n), a.data;
    }
    /**
     *  Decode the ABI %%data%% as the %%types%% into values.
     *
     *  If %%loose%% decoding is enabled, then strict padding is
     *  not enforced. Some older versions of Solidity incorrectly
     *  padded event data emitted from ``external`` functions.
     */
    decode(e, n, i) {
      const l = e.map((c) => cr(this, Ea, _s).call(this, Hr.from(c)));
      return new kl(l, "_").decode(new xA(n, i, v2));
    }
    static _setDefaultMaxInflation(e) {
      bt(
        typeof e == "number" && Number.isInteger(e),
        "invalid defaultMaxInflation factor",
        "value",
        e
      ),
        (v2 = e);
    }
    /**
     *  Returns the shared singleton instance of a default [[AbiCoder]].
     *
     *  On the first call, the instance is created internally.
     */
    static defaultAbiCoder() {
      return L0 == null && (L0 = new Pp()), L0;
    }
    /**
     *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
     *  result %%data%% for the [[CallExceptionAction]] %%action%% against
     *  the Transaction %%tx%%.
     */
    static getBuiltinCallException(e, n, i) {
      return u4(e, n, i, Pp.defaultAbiCoder());
    }
  };
Ea = /* @__PURE__ */ new WeakSet();
_s = /* @__PURE__ */ Be(function (t) {
  if (t.isArray())
    return new KA(cr(this, Ea, _s).call(this, t.arrayChildren), t.arrayLength, t.name);
  if (t.isTuple())
    return new kl(
      t.components.map((n) => cr(this, Ea, _s).call(this, n)),
      t.name
    );
  switch (t.baseType) {
    case "address":
      return new VA(t.name);
    case "bool":
      return new ZA(t.name);
    case "string":
      return new nk(t.name);
    case "bytes":
      return new GA(t.name);
    case "":
      return new QA(t.name);
  }
  let e = t.type.match(gk);
  if (e) {
    let n = parseInt(e[2] || "256");
    return (
      bt(n !== 0 && n <= 256 && n % 8 === 0, "invalid " + e[1] + " bit length", "param", t),
      new rk(n / 8, e[1] === "int", t.name)
    );
  }
  if (((e = t.type.match(vk)), e)) {
    let n = parseInt(e[1]);
    return bt(n !== 0 && n <= 32, "invalid bytes length", "param", t), new YA(n, t.name);
  }
  bt(!1, "invalid type", "type", t.type);
}, "#getCoder");
Be(c4, "AbiCoder");
var g2 = c4,
  h4 = class {
    /**
     *  @_ignore:
     */
    constructor(e, n, i) {
      Ge(this, "fragment"),
        Ge(this, "name"),
        Ge(this, "signature"),
        Ge(this, "topic"),
        Ge(this, "args");
      const l = e.name,
        a = e.format();
      Ft(this, {
        fragment: e,
        name: l,
        signature: a,
        topic: n,
        args: i,
      });
    }
  };
Be(h4, "LogDescription");
var yk = h4,
  d4 = class {
    /**
     *  @_ignore:
     */
    constructor(e, n, i, l) {
      Ge(this, "fragment"),
        Ge(this, "name"),
        Ge(this, "args"),
        Ge(this, "signature"),
        Ge(this, "selector"),
        Ge(this, "value");
      const a = e.name,
        c = e.format();
      Ft(this, {
        fragment: e,
        name: a,
        args: i,
        signature: c,
        selector: n,
        value: l,
      });
    }
  };
Be(d4, "TransactionDescription");
var bk = d4,
  p4 = class {
    /**
     *  @_ignore:
     */
    constructor(e, n, i) {
      Ge(this, "fragment"),
        Ge(this, "name"),
        Ge(this, "args"),
        Ge(this, "signature"),
        Ge(this, "selector");
      const l = e.name,
        a = e.format();
      Ft(this, {
        fragment: e,
        name: l,
        args: i,
        signature: a,
        selector: n,
      });
    }
  };
Be(p4, "ErrorDescription");
var wk = p4,
  m4 = class {
    /**
     *  @_ignore:
     */
    constructor(e) {
      Ge(this, "hash"),
        Ge(this, "_isIndexed"),
        Ft(this, {
          hash: e,
          _isIndexed: !0,
        });
    }
    /**
     *  Returns ``true`` if %%value%% is an **Indexed**.
     *
     *  This provides a Type Guard for property access.
     */
    static isIndexed(e) {
      return !!(e && e._isIndexed);
    }
  };
Be(m4, "Indexed");
var y2 = m4,
  b2 = {
    0: "generic panic",
    1: "assert(false)",
    17: "arithmetic overflow",
    18: "division or modulo by zero",
    33: "enum overflow",
    34: "invalid encoded storage byte array accessed",
    49: "out-of-bounds array access; popping on an empty array",
    50: "out-of-bounds access of an array or bytesN",
    65: "out of memory",
    81: "uninitialized function",
  },
  w2 = {
    "0x08c379a0": {
      signature: "Error(string)",
      name: "Error",
      inputs: ["string"],
      reason: (t) => `reverted with reason string ${JSON.stringify(t)}`,
    },
    "0x4e487b71": {
      signature: "Panic(uint256)",
      name: "Panic",
      inputs: ["uint256"],
      reason: (t) => {
        let e = "unknown panic code";
        return (
          t >= 0 && t <= 255 && b2[t.toString()] && (e = b2[t.toString()]),
          `reverted with panic code 0x${t.toString(16)} (${e})`
        );
      },
    },
  },
  ci,
  vi,
  gi,
  Dr,
  Ho,
  Ol,
  Vo,
  Ul,
  v4 = class Wo {
    /**
     *  Create a new Interface for the %%fragments%%.
     */
    constructor(e) {
      er(this, Ho),
        er(this, Vo),
        Ge(this, "fragments"),
        Ge(this, "deploy"),
        Ge(this, "fallback"),
        Ge(this, "receive"),
        er(this, ci, void 0),
        er(this, vi, void 0),
        er(this, gi, void 0),
        er(this, Dr, void 0);
      let n = [];
      typeof e == "string" ? (n = JSON.parse(e)) : (n = e),
        Jt(this, gi, /* @__PURE__ */ new Map()),
        Jt(this, ci, /* @__PURE__ */ new Map()),
        Jt(this, vi, /* @__PURE__ */ new Map());
      const i = [];
      for (const c of n)
        try {
          i.push(Yu.from(c));
        } catch (v) {
          console.log(`[Warning] Invalid Fragment ${JSON.stringify(c)}:`, v.message);
        }
      Ft(this, {
        fragments: Object.freeze(i),
      });
      let l = null,
        a = !1;
      Jt(this, Dr, this.getAbiCoder()),
        this.fragments.forEach((c, v) => {
          let g;
          switch (c.type) {
            case "constructor":
              if (this.deploy) {
                console.log("duplicate definition - constructor");
                return;
              }
              Ft(this, {
                deploy: c,
              });
              return;
            case "fallback":
              c.inputs.length === 0
                ? (a = !0)
                : (bt(
                    !l || c.payable !== l.payable,
                    "conflicting fallback fragments",
                    `fragments[${v}]`,
                    c
                  ),
                  (l = c),
                  (a = l.payable));
              return;
            case "function":
              g = pt(this, gi);
              break;
            case "event":
              g = pt(this, vi);
              break;
            case "error":
              g = pt(this, ci);
              break;
            default:
              return;
          }
          const b = c.format();
          g.has(b) || g.set(b, c);
        }),
        this.deploy ||
          Ft(this, {
            deploy: Pl.from("constructor()"),
          }),
        Ft(this, {
          fallback: l,
          receive: a,
        });
    }
    /**
     *  Returns the entire Human-Readable ABI, as an array of
     *  signatures, optionally as %%minimal%% strings, which
     *  removes parameter names and unneceesary spaces.
     */
    format(e) {
      const n = e ? "minimal" : "full";
      return this.fragments.map((l) => l.format(n));
    }
    /**
     *  Return the JSON-encoded ABI. This is the format Solidiy
     *  returns.
     */
    formatJson() {
      const e = this.fragments.map((n) => n.format("json"));
      return JSON.stringify(e.map((n) => JSON.parse(n)));
    }
    /**
     *  The ABI coder that will be used to encode and decode binary
     *  data.
     */
    getAbiCoder() {
      return g2.defaultAbiCoder();
    }
    /**
     *  Get the function name for %%key%%, which may be a function selector,
     *  function name or function signature that belongs to the ABI.
     */
    getFunctionName(e) {
      const n = cr(this, Ho, Ol).call(this, e, null, !1);
      return bt(n, "no matching function", "key", e), n.name;
    }
    /**
     *  Returns true if %%key%% (a function selector, function name or
     *  function signature) is present in the ABI.
     *
     *  In the case of a function name, the name may be ambiguous, so
     *  accessing the [[FunctionFragment]] may require refinement.
     */
    hasFunction(e) {
      return !!cr(this, Ho, Ol).call(this, e, null, !1);
    }
    /**
     *  Get the [[FunctionFragment]] for %%key%%, which may be a function
     *  selector, function name or function signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple functions match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single function in
     *  the ABI, this will throw.
     */
    getFunction(e, n) {
      return cr(this, Ho, Ol).call(this, e, n || null, !0);
    }
    /**
     *  Iterate over all functions, calling %%callback%%, sorted by their name.
     */
    forEachFunction(e) {
      const n = Array.from(pt(this, gi).keys());
      n.sort((i, l) => i.localeCompare(l));
      for (let i = 0; i < n.length; i++) {
        const l = n[i];
        e(pt(this, gi).get(l), i);
      }
    }
    /**
     *  Get the event name for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     */
    getEventName(e) {
      const n = cr(this, Vo, Ul).call(this, e, null, !1);
      return bt(n, "no matching event", "key", e), n.name;
    }
    /**
     *  Returns true if %%key%% (an event topic hash, event name or
     *  event signature) is present in the ABI.
     *
     *  In the case of an event name, the name may be ambiguous, so
     *  accessing the [[EventFragment]] may require refinement.
     */
    hasEvent(e) {
      return !!cr(this, Vo, Ul).call(this, e, null, !1);
    }
    /**
     *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
     *  event name or event signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple events match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single event in
     *  the ABI, this will throw.
     */
    getEvent(e, n) {
      return cr(this, Vo, Ul).call(this, e, n || null, !0);
    }
    /**
     *  Iterate over all events, calling %%callback%%, sorted by their name.
     */
    forEachEvent(e) {
      const n = Array.from(pt(this, vi).keys());
      n.sort((i, l) => i.localeCompare(l));
      for (let i = 0; i < n.length; i++) {
        const l = n[i];
        e(pt(this, vi).get(l), i);
      }
    }
    /**
     *  Get the [[ErrorFragment]] for %%key%%, which may be an error
     *  selector, error name or error signature that belongs to the ABI.
     *
     *  If %%values%% is provided, it will use the Typed API to handle
     *  ambiguous cases where multiple errors match by name.
     *
     *  If the %%key%% and %%values%% do not refine to a single error in
     *  the ABI, this will throw.
     */
    getError(e, n) {
      if (Si(e)) {
        const l = e.toLowerCase();
        if (w2[l]) return mi.from(w2[l].signature);
        for (const a of pt(this, ci).values()) if (l === a.selector) return a;
        return null;
      }
      if (e.indexOf("(") === -1) {
        const l = [];
        for (const [a, c] of pt(this, ci))
          a.split(
            "("
            /* fix:) */
          )[0] === e && l.push(c);
        if (l.length === 0)
          return e === "Error"
            ? mi.from("error Error(string)")
            : e === "Panic"
            ? mi.from("error Panic(uint256)")
            : null;
        if (l.length > 1) {
          const a = l.map((c) => JSON.stringify(c.format())).join(", ");
          bt(!1, `ambiguous error description (i.e. ${a})`, "name", e);
        }
        return l[0];
      }
      if (((e = mi.from(e).format()), e === "Error(string)")) return mi.from("error Error(string)");
      if (e === "Panic(uint256)") return mi.from("error Panic(uint256)");
      const i = pt(this, ci).get(e);
      return i || null;
    }
    /**
     *  Iterate over all errors, calling %%callback%%, sorted by their name.
     */
    forEachError(e) {
      const n = Array.from(pt(this, ci).keys());
      n.sort((i, l) => i.localeCompare(l));
      for (let i = 0; i < n.length; i++) {
        const l = n[i];
        e(pt(this, ci).get(l), i);
      }
    }
    // Get the 4-byte selector used by Solidity to identify a function
    /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];

          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }

          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }

          fragment = matches[0];
      }

      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
    // Get the 32-byte topic hash used by Solidity to identify an event
    /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
    _decodeParams(e, n) {
      return pt(this, Dr).decode(e, n);
    }
    _encodeParams(e, n) {
      return pt(this, Dr).encode(e, n);
    }
    /**
     *  Encodes a ``tx.data`` object for deploying the Contract with
     *  the %%values%% as the constructor arguments.
     */
    encodeDeploy(e) {
      return this._encodeParams(this.deploy.inputs, e || []);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified error (see [[getError]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */
    decodeErrorResult(e, n) {
      if (typeof e == "string") {
        const i = this.getError(e);
        bt(i, "unknown error", "fragment", e), (e = i);
      }
      return (
        bt(Li(n, 0, 4) === e.selector, `data signature does not match error ${e.name}.`, "data", n),
        this._decodeParams(e.inputs, Li(n, 4))
      );
    }
    /**
     *  Encodes the transaction revert data for a call result that
     *  reverted from the the Contract with the sepcified %%error%%
     *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */
    encodeErrorResult(e, n) {
      if (typeof e == "string") {
        const i = this.getError(e);
        bt(i, "unknown error", "fragment", e), (e = i);
      }
      return ta([e.selector, this._encodeParams(e.inputs, n || [])]);
    }
    /**
     *  Decodes the %%data%% from a transaction ``tx.data`` for
     *  the function specified (see [[getFunction]] for valid values
     *  for %%fragment%%).
     *
     *  Most developers should prefer the [[parseTransaction]] method
     *  instead, which will automatically detect the fragment.
     */
    decodeFunctionData(e, n) {
      if (typeof e == "string") {
        const i = this.getFunction(e);
        bt(i, "unknown function", "fragment", e), (e = i);
      }
      return (
        bt(
          Li(n, 0, 4) === e.selector,
          `data signature does not match function ${e.name}.`,
          "data",
          n
        ),
        this._decodeParams(e.inputs, Li(n, 4))
      );
    }
    /**
     *  Encodes the ``tx.data`` for a transaction that calls the function
     *  specified (see [[getFunction]] for valid values for %%fragment%%) with
     *  the %%values%%.
     */
    encodeFunctionData(e, n) {
      if (typeof e == "string") {
        const i = this.getFunction(e);
        bt(i, "unknown function", "fragment", e), (e = i);
      }
      return ta([e.selector, this._encodeParams(e.inputs, n || [])]);
    }
    /**
     *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values for
     *  %%key%%).
     *
     *  Most developers should prefer the [[parseCallResult]] method instead,
     *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
     *  corresponding error.
     */
    decodeFunctionResult(e, n) {
      if (typeof e == "string") {
        const a = this.getFunction(e);
        bt(a, "unknown function", "fragment", e), (e = a);
      }
      let i = "invalid length for result data";
      const l = In(n);
      if (l.length % 32 === 0)
        try {
          return pt(this, Dr).decode(e.outputs, l);
        } catch {
          i = "could not decode result data";
        }
      Pt(!1, i, "BAD_DATA", {
        value: dr(l),
        info: {
          method: e.name,
          signature: e.format(),
        },
      });
    }
    makeError(e, n) {
      const i = dn(e, "data"),
        l = g2.getBuiltinCallException("call", n, i);
      if (l.message.startsWith("execution reverted (unknown custom error)")) {
        const v = dr(i.slice(0, 4)),
          g = this.getError(v);
        if (g)
          try {
            const b = pt(this, Dr).decode(g.inputs, i.slice(4));
            (l.revert = {
              name: g.name,
              signature: g.format(),
              args: b,
            }),
              (l.reason = l.revert.signature),
              (l.message = `execution reverted: ${l.reason}`);
          } catch {
            l.message = "execution reverted (coult not decode custom error)";
          }
      }
      const c = this.parseTransaction(n);
      return (
        c &&
          (l.invocation = {
            method: c.name,
            signature: c.signature,
            args: c.args,
          }),
        l
      );
    }
    /**
     *  Encodes the result data (e.g. from an ``eth_call``) for the
     *  specified function (see [[getFunction]] for valid values
     *  for %%fragment%%) with %%values%%.
     *
     *  This is generally not used by most developers, unless trying to mock
     *  a result from a Contract.
     */
    encodeFunctionResult(e, n) {
      if (typeof e == "string") {
        const i = this.getFunction(e);
        bt(i, "unknown function", "fragment", e), (e = i);
      }
      return dr(pt(this, Dr).encode(e.outputs, n || []));
    }
    /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };

          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }

          };

          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(e, n) {
      if (typeof e == "string") {
        const a = this.getEvent(e);
        bt(a, "unknown event", "eventFragment", e), (e = a);
      }
      Pt(
        n.length <= e.inputs.length,
        `too many arguments for ${e.format()}`,
        "UNEXPECTED_ARGUMENT",
        {
          count: n.length,
          expectedCount: e.inputs.length,
        }
      );
      const i = [];
      e.anonymous || i.push(e.topicHash);
      const l = /* @__PURE__ */ Be(
        (a, c) =>
          a.type === "string"
            ? Vs(c)
            : a.type === "bytes"
            ? ei(dr(c))
            : (a.type === "bool" && typeof c == "boolean"
                ? (c = c ? "0x01" : "0x00")
                : a.type.match(/^u?int/)
                ? (c = Y1(c))
                : a.type.match(/^bytes/)
                ? (c = Q3(c, 32))
                : a.type === "address" && pt(this, Dr).encode(["address"], [c]),
              J3(dr(c), 32)),
        "encodeTopic"
      );
      for (
        n.forEach((a, c) => {
          const v = e.inputs[c];
          if (!v.indexed) {
            bt(
              a == null,
              "cannot filter non-indexed parameters; must be null",
              "contract." + v.name,
              a
            );
            return;
          }
          a == null
            ? i.push(null)
            : v.baseType === "array" || v.baseType === "tuple"
            ? bt(!1, "filtering with tuples or arrays not supported", "contract." + v.name, a)
            : Array.isArray(a)
            ? i.push(a.map((g) => l(v, g)))
            : i.push(l(v, a));
        });
        i.length && i[i.length - 1] === null;

      )
        i.pop();
      return i;
    }
    encodeEventLog(e, n) {
      if (typeof e == "string") {
        const c = this.getEvent(e);
        bt(c, "unknown event", "eventFragment", e), (e = c);
      }
      const i = [],
        l = [],
        a = [];
      return (
        e.anonymous || i.push(e.topicHash),
        bt(n.length === e.inputs.length, "event arguments/values mismatch", "values", n),
        e.inputs.forEach((c, v) => {
          const g = n[v];
          if (c.indexed)
            if (c.type === "string") i.push(Vs(g));
            else if (c.type === "bytes") i.push(ei(g));
            else {
              if (c.baseType === "tuple" || c.baseType === "array")
                throw new Error("not implemented");
              i.push(pt(this, Dr).encode([c.type], [g]));
            }
          else l.push(c), a.push(g);
        }),
        {
          data: pt(this, Dr).encode(l, a),
          topics: i,
        }
      );
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(e, n, i) {
      if (typeof e == "string") {
        const S = this.getEvent(e);
        bt(S, "unknown event", "eventFragment", e), (e = S);
      }
      if (i != null && !e.anonymous) {
        const S = e.topicHash;
        bt(Si(i[0], 32) && i[0].toLowerCase() === S, "fragment/topic mismatch", "topics[0]", i[0]),
          (i = i.slice(1));
      }
      const l = [],
        a = [],
        c = [];
      e.inputs.forEach((S, A) => {
        S.indexed
          ? S.type === "string" ||
            S.type === "bytes" ||
            S.baseType === "tuple" ||
            S.baseType === "array"
            ? (l.push(
                Hr.from({
                  type: "bytes32",
                  name: S.name,
                })
              ),
              c.push(!0))
            : (l.push(S), c.push(!1))
          : (a.push(S), c.push(!1));
      });
      const v = i != null ? pt(this, Dr).decode(l, ta(i)) : null,
        g = pt(this, Dr).decode(a, n, !0),
        b = [],
        p = [];
      let _ = 0,
        M = 0;
      return (
        e.inputs.forEach((S, A) => {
          let k = null;
          if (S.indexed)
            if (v == null) k = new y2(null);
            else if (c[A]) k = new y2(v[M++]);
            else
              try {
                k = v[M++];
              } catch (P) {
                k = P;
              }
          else
            try {
              k = g[_++];
            } catch (P) {
              k = P;
            }
          b.push(k), p.push(S.name || null);
        }),
        c5.fromItems(b, p)
      );
    }
    /**
     *  Parses a transaction, finding the matching function and extracts
     *  the parameter values along with other useful function details.
     *
     *  If the matching function cannot be found, return null.
     */
    parseTransaction(e) {
      const n = dn(e.data, "tx.data"),
        i = ii(e.value != null ? e.value : 0, "tx.value"),
        l = this.getFunction(dr(n.slice(0, 4)));
      if (!l) return null;
      const a = pt(this, Dr).decode(l.inputs, n.slice(4));
      return new bk(l, l.selector, a, i);
    }
    parseCallResult(e) {
      throw new Error("@TODO");
    }
    /**
     *  Parses a receipt log, finding the matching event and extracts
     *  the parameter values along with other useful event details.
     *
     *  If the matching event cannot be found, returns null.
     */
    parseLog(e) {
      const n = this.getEvent(e.topics[0]);
      return !n || n.anonymous
        ? null
        : new yk(n, n.topicHash, this.decodeEventLog(n, e.data, e.topics));
    }
    /**
     *  Parses a revert data, finding the matching error and extracts
     *  the parameter values along with other useful error details.
     *
     *  If the matching error cannot be found, returns null.
     */
    parseError(e) {
      const n = dr(e),
        i = this.getError(Li(n, 0, 4));
      if (!i) return null;
      const l = pt(this, Dr).decode(i.inputs, Li(n, 4));
      return new wk(i, i.selector, l);
    }
    /**
     *  Creates a new [[Interface]] from the ABI %%value%%.
     *
     *  The %%value%% may be provided as an existing [[Interface]] object,
     *  a JSON-encoded ABI or any Human-Readable ABI format.
     */
    static from(e) {
      return e instanceof Wo
        ? e
        : typeof e == "string"
        ? new Wo(JSON.parse(e))
        : typeof e.format == "function"
        ? new Wo(e.format("json"))
        : new Wo(e);
    }
  };
ci = /* @__PURE__ */ new WeakMap();
vi = /* @__PURE__ */ new WeakMap();
gi = /* @__PURE__ */ new WeakMap();
Dr = /* @__PURE__ */ new WeakMap();
Ho = /* @__PURE__ */ new WeakSet();
Ol = /* @__PURE__ */ Be(function (t, e, n) {
  if (Si(t)) {
    const l = t.toLowerCase();
    for (const a of pt(this, gi).values()) if (l === a.selector) return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const l = [];
    for (const [a, c] of pt(this, gi))
      a.split(
        "("
        /* fix:) */
      )[0] === t && l.push(c);
    if (e) {
      const a = e.length > 0 ? e[e.length - 1] : null;
      let c = e.length,
        v = !0;
      tn.isTyped(a) && a.type === "overrides" && ((v = !1), c--);
      for (let g = l.length - 1; g >= 0; g--) {
        const b = l[g].inputs.length;
        b !== c && (!v || b !== c - 1) && l.splice(g, 1);
      }
      for (let g = l.length - 1; g >= 0; g--) {
        const b = l[g].inputs;
        for (let p = 0; p < e.length; p++)
          if (tn.isTyped(e[p])) {
            if (p >= b.length) {
              if (e[p].type === "overrides") continue;
              l.splice(g, 1);
              break;
            }
            if (e[p].type !== b[p].baseType) {
              l.splice(g, 1);
              break;
            }
          }
      }
    }
    if (l.length === 1 && e && e.length !== l[0].inputs.length) {
      const a = e[e.length - 1];
      (a == null || Array.isArray(a) || typeof a != "object") && l.splice(0, 1);
    }
    if (l.length === 0) return null;
    if (l.length > 1 && n) {
      const a = l.map((c) => JSON.stringify(c.format())).join(", ");
      bt(!1, `ambiguous function description (i.e. matches ${a})`, "key", t);
    }
    return l[0];
  }
  const i = pt(this, gi).get(Rl.from(t).format());
  return i || null;
}, "#getFunction");
Vo = /* @__PURE__ */ new WeakSet();
Ul = /* @__PURE__ */ Be(function (t, e, n) {
  if (Si(t)) {
    const l = t.toLowerCase();
    for (const a of pt(this, vi).values()) if (l === a.topicHash) return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const l = [];
    for (const [a, c] of pt(this, vi))
      a.split(
        "("
        /* fix:) */
      )[0] === t && l.push(c);
    if (e) {
      for (let a = l.length - 1; a >= 0; a--) l[a].inputs.length < e.length && l.splice(a, 1);
      for (let a = l.length - 1; a >= 0; a--) {
        const c = l[a].inputs;
        for (let v = 0; v < e.length; v++)
          if (tn.isTyped(e[v]) && e[v].type !== c[v].baseType) {
            l.splice(a, 1);
            break;
          }
      }
    }
    if (l.length === 0) return null;
    if (l.length > 1 && n) {
      const a = l.map((c) => JSON.stringify(c.format())).join(", ");
      bt(!1, `ambiguous event description (i.e. matches ${a})`, "key", t);
    }
    return l[0];
  }
  const i = pt(this, vi).get(Tl.from(t).format());
  return i || null;
}, "#getEvent");
Be(v4, "Interface");
var Qu = v4,
  g4 = BigInt(0);
function fn(t) {
  return t == null ? null : t.toString();
}
Be(fn, "toJson");
function y4(t) {
  const e = {};
  t.to && (e.to = t.to), t.from && (e.from = t.from), t.data && (e.data = dr(t.data));
  const n = "chainId,gasLimit,gasPrice,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const l of n) !(l in t) || t[l] == null || (e[l] = ii(t[l], `request.${l}`));
  const i = "type,nonce".split(/,/);
  for (const l of i) !(l in t) || t[l] == null || (e[l] = ai(t[l], `request.${l}`));
  return (
    t.accessList && (e.accessList = Z5(t.accessList)),
    "blockTag" in t && (e.blockTag = t.blockTag),
    "enableCcipRead" in t && (e.enableCcipRead = !!t.enableCcipRead),
    "customData" in t && (e.customData = t.customData),
    e
  );
}
Be(y4, "copyRequest");
var b4 = class {
  /**
   *  @_ignore:
   */
  constructor(e, n) {
    Ge(this, "provider"),
      Ge(this, "transactionHash"),
      Ge(this, "blockHash"),
      Ge(this, "blockNumber"),
      Ge(this, "removed"),
      Ge(this, "address"),
      Ge(this, "data"),
      Ge(this, "topics"),
      Ge(this, "index"),
      Ge(this, "transactionIndex"),
      (this.provider = n);
    const i = Object.freeze(e.topics.slice());
    Ft(this, {
      transactionHash: e.transactionHash,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      removed: e.removed,
      address: e.address,
      data: e.data,
      topics: i,
      index: e.index,
      transactionIndex: e.transactionIndex,
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const {
      address: e,
      blockHash: n,
      blockNumber: i,
      data: l,
      index: a,
      removed: c,
      topics: v,
      transactionHash: g,
      transactionIndex: b,
    } = this;
    return {
      _type: "log",
      address: e,
      blockHash: n,
      blockNumber: i,
      data: l,
      index: a,
      removed: c,
      topics: v,
      transactionHash: g,
      transactionIndex: b,
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    return Pt(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.transactionHash);
    return Pt(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const e = await this.provider.getTransactionReceipt(this.transactionHash);
    return Pt(!!e, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return M4(this);
  }
};
Be(b4, "Log");
var Xu = b4,
  Nl,
  w4 = class {
    /**
     *  @_ignore:
     */
    constructor(e, n) {
      Ge(this, "provider"),
        Ge(this, "to"),
        Ge(this, "from"),
        Ge(this, "contractAddress"),
        Ge(this, "hash"),
        Ge(this, "index"),
        Ge(this, "blockHash"),
        Ge(this, "blockNumber"),
        Ge(this, "logsBloom"),
        Ge(this, "gasUsed"),
        Ge(this, "blobGasUsed"),
        Ge(this, "cumulativeGasUsed"),
        Ge(this, "gasPrice"),
        Ge(this, "blobGasPrice"),
        Ge(this, "type"),
        Ge(this, "status"),
        Ge(this, "root"),
        er(this, Nl, void 0),
        Jt(this, Nl, Object.freeze(e.logs.map((l) => new Xu(l, n))));
      let i = g4;
      e.effectiveGasPrice != null
        ? (i = e.effectiveGasPrice)
        : e.gasPrice != null && (i = e.gasPrice),
        Ft(this, {
          provider: n,
          to: e.to,
          from: e.from,
          contractAddress: e.contractAddress,
          hash: e.hash,
          index: e.index,
          blockHash: e.blockHash,
          blockNumber: e.blockNumber,
          logsBloom: e.logsBloom,
          gasUsed: e.gasUsed,
          cumulativeGasUsed: e.cumulativeGasUsed,
          blobGasUsed: e.blobGasUsed,
          gasPrice: i,
          blobGasPrice: e.blobGasPrice,
          type: e.type,
          //byzantium: tx.byzantium,
          status: e.status,
          root: e.root,
        });
    }
    /**
     *  The logs for this transaction.
     */
    get logs() {
      return pt(this, Nl);
    }
    /**
     *  Returns a JSON-compatible representation.
     */
    toJSON() {
      const {
        to: e,
        from: n,
        contractAddress: i,
        hash: l,
        index: a,
        blockHash: c,
        blockNumber: v,
        logsBloom: g,
        logs: b,
        status: p,
        root: _,
      } = this;
      return {
        _type: "TransactionReceipt",
        blockHash: c,
        blockNumber: v,
        //byzantium,
        contractAddress: i,
        cumulativeGasUsed: fn(this.cumulativeGasUsed),
        from: n,
        gasPrice: fn(this.gasPrice),
        blobGasUsed: fn(this.blobGasUsed),
        blobGasPrice: fn(this.blobGasPrice),
        gasUsed: fn(this.gasUsed),
        hash: l,
        index: a,
        logs: b,
        logsBloom: g,
        root: _,
        status: p,
        to: e,
      };
    }
    /**
     *  @_ignore:
     */
    get length() {
      return this.logs.length;
    }
    [Symbol.iterator]() {
      let e = 0;
      return {
        next: () =>
          e < this.length
            ? {
                value: this.logs[e++],
                done: !1,
              }
            : {
                value: void 0,
                done: !0,
              },
      };
    }
    /**
     *  The total fee for this transaction, in wei.
     */
    get fee() {
      return this.gasUsed * this.gasPrice;
    }
    /**
     *  Resolves to the block this transaction occurred in.
     */
    async getBlock() {
      const e = await this.provider.getBlock(this.blockHash);
      if (e == null) throw new Error("TODO");
      return e;
    }
    /**
     *  Resolves to the transaction this transaction occurred in.
     */
    async getTransaction() {
      const e = await this.provider.getTransaction(this.hash);
      if (e == null) throw new Error("TODO");
      return e;
    }
    /**
     *  Resolves to the return value of the execution of this transaction.
     *
     *  Support for this feature is limited, as it requires an archive node
     *  with the ``debug_`` or ``trace_`` API enabled.
     */
    async getResult() {
      return await this.provider.getTransactionResult(this.hash);
    }
    /**
     *  Resolves to the number of confirmations this transaction has.
     */
    async confirmations() {
      return (await this.provider.getBlockNumber()) - this.blockNumber + 1;
    }
    /**
     *  @_ignore:
     */
    removedEvent() {
      return fm(this);
    }
    /**
     *  @_ignore:
     */
    reorderedEvent(e) {
      return (
        Pt(
          !e || e.isMined(),
          "unmined 'other' transction cannot be orphaned",
          "UNSUPPORTED_OPERATION",
          {
            operation: "reorderedEvent(other)",
          }
        ),
        om(this, e)
      );
    }
  };
Nl = /* @__PURE__ */ new WeakMap();
Be(w4, "TransactionReceipt");
var _k = w4,
  ba,
  _4 = class x4 {
    /**
     *  @_ignore:
     */
    constructor(e, n) {
      Ge(this, "provider"),
        Ge(this, "blockNumber"),
        Ge(this, "blockHash"),
        Ge(this, "index"),
        Ge(this, "hash"),
        Ge(this, "type"),
        Ge(this, "to"),
        Ge(this, "from"),
        Ge(this, "nonce"),
        Ge(this, "gasLimit"),
        Ge(this, "gasPrice"),
        Ge(this, "maxPriorityFeePerGas"),
        Ge(this, "maxFeePerGas"),
        Ge(this, "maxFeePerBlobGas"),
        Ge(this, "data"),
        Ge(this, "value"),
        Ge(this, "chainId"),
        Ge(this, "signature"),
        Ge(this, "accessList"),
        Ge(this, "blobVersionedHashes"),
        er(this, ba, void 0),
        (this.provider = n),
        (this.blockNumber = e.blockNumber != null ? e.blockNumber : null),
        (this.blockHash = e.blockHash != null ? e.blockHash : null),
        (this.hash = e.hash),
        (this.index = e.index),
        (this.type = e.type),
        (this.from = e.from),
        (this.to = e.to || null),
        (this.gasLimit = e.gasLimit),
        (this.nonce = e.nonce),
        (this.data = e.data),
        (this.value = e.value),
        (this.gasPrice = e.gasPrice),
        (this.maxPriorityFeePerGas =
          e.maxPriorityFeePerGas != null ? e.maxPriorityFeePerGas : null),
        (this.maxFeePerGas = e.maxFeePerGas != null ? e.maxFeePerGas : null),
        (this.maxFeePerBlobGas = e.maxFeePerBlobGas != null ? e.maxFeePerBlobGas : null),
        (this.chainId = e.chainId),
        (this.signature = e.signature),
        (this.accessList = e.accessList != null ? e.accessList : null),
        (this.blobVersionedHashes = e.blobVersionedHashes != null ? e.blobVersionedHashes : null),
        Jt(this, ba, -1);
    }
    /**
     *  Returns a JSON-compatible representation of this transaction.
     */
    toJSON() {
      const {
        blockNumber: e,
        blockHash: n,
        index: i,
        hash: l,
        type: a,
        to: c,
        from: v,
        nonce: g,
        data: b,
        signature: p,
        accessList: _,
        blobVersionedHashes: M,
      } = this;
      return {
        _type: "TransactionResponse",
        accessList: _,
        blockNumber: e,
        blockHash: n,
        blobVersionedHashes: M,
        chainId: fn(this.chainId),
        data: b,
        from: v,
        gasLimit: fn(this.gasLimit),
        gasPrice: fn(this.gasPrice),
        hash: l,
        maxFeePerGas: fn(this.maxFeePerGas),
        maxPriorityFeePerGas: fn(this.maxPriorityFeePerGas),
        maxFeePerBlobGas: fn(this.maxFeePerBlobGas),
        nonce: g,
        signature: p,
        to: c,
        index: i,
        type: a,
        value: fn(this.value),
      };
    }
    /**
     *  Resolves to the Block that this transaction was included in.
     *
     *  This will return null if the transaction has not been included yet.
     */
    async getBlock() {
      let e = this.blockNumber;
      if (e == null) {
        const i = await this.getTransaction();
        i && (e = i.blockNumber);
      }
      if (e == null) return null;
      const n = this.provider.getBlock(e);
      if (n == null) throw new Error("TODO");
      return n;
    }
    /**
     *  Resolves to this transaction being re-requested from the
     *  provider. This can be used if you have an unmined transaction
     *  and wish to get an up-to-date populated instance.
     */
    async getTransaction() {
      return this.provider.getTransaction(this.hash);
    }
    /**
     *  Resolve to the number of confirmations this transaction has.
     */
    async confirmations() {
      if (this.blockNumber == null) {
        const { tx: n, blockNumber: i } = await Ql({
          tx: this.getTransaction(),
          blockNumber: this.provider.getBlockNumber(),
        });
        return n == null || n.blockNumber == null ? 0 : i - n.blockNumber + 1;
      }
      return (await this.provider.getBlockNumber()) - this.blockNumber + 1;
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(e, n) {
      const i = e ?? 1,
        l = n ?? 0;
      let a = pt(this, ba),
        c = -1,
        v = a === -1;
      const g = /* @__PURE__ */ Be(async () => {
          if (v) return null;
          const { blockNumber: M, nonce: S } = await Ql({
            blockNumber: this.provider.getBlockNumber(),
            nonce: this.provider.getTransactionCount(this.from),
          });
          if (S < this.nonce) {
            a = M;
            return;
          }
          if (v) return null;
          const A = await this.getTransaction();
          if (!(A && A.blockNumber != null))
            for (c === -1 && ((c = a - 3), c < pt(this, ba) && (c = pt(this, ba))); c <= M; ) {
              if (v) return null;
              const k = await this.provider.getBlock(c, !0);
              if (k == null) return;
              for (const P of k) if (P === this.hash) return;
              for (let P = 0; P < k.length; P++) {
                const B = await k.getTransaction(P);
                if (B.from === this.from && B.nonce === this.nonce) {
                  if (v) return null;
                  const T = await this.provider.getTransactionReceipt(B.hash);
                  if (T == null || M - T.blockNumber + 1 < i) return;
                  let F = "replaced";
                  B.data === this.data && B.to === this.to && B.value === this.value
                    ? (F = "repriced")
                    : B.data === "0x" && B.from === B.to && B.value === g4 && (F = "cancelled"),
                    Pt(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                      cancelled: F === "replaced" || F === "cancelled",
                      reason: F,
                      replacement: B.replaceableTransaction(a),
                      hash: B.hash,
                      receipt: T,
                    });
                }
              }
              c++;
            }
        }, "checkReplacement"),
        b = /* @__PURE__ */ Be((M) => {
          if (M == null || M.status !== 0) return M;
          Pt(!1, "transaction execution reverted", "CALL_EXCEPTION", {
            action: "sendTransaction",
            data: null,
            reason: null,
            invocation: null,
            revert: null,
            transaction: {
              to: M.to,
              from: M.from,
              data: "",
              // @TODO: in v7, split out sendTransaction properties
            },
            receipt: M,
          });
        }, "checkReceipt"),
        p = await this.provider.getTransactionReceipt(this.hash);
      if (i === 0) return b(p);
      if (p) {
        if ((await p.confirmations()) >= i) return b(p);
      } else if ((await g(), i === 0)) return null;
      return await new Promise((M, S) => {
        const A = [],
          k = /* @__PURE__ */ Be(() => {
            A.forEach((B) => B());
          }, "cancel");
        if (
          (A.push(() => {
            v = !0;
          }),
          l > 0)
        ) {
          const B = setTimeout(() => {
            k(), S($s("wait for transaction timeout", "TIMEOUT"));
          }, l);
          A.push(() => {
            clearTimeout(B);
          });
        }
        const P = /* @__PURE__ */ Be(async (B) => {
          if ((await B.confirmations()) >= i) {
            k();
            try {
              M(b(B));
            } catch (T) {
              S(T);
            }
          }
        }, "txListener");
        if (
          (A.push(() => {
            this.provider.off(this.hash, P);
          }),
          this.provider.on(this.hash, P),
          a >= 0)
        ) {
          const B = /* @__PURE__ */ Be(async () => {
            try {
              await g();
            } catch (T) {
              if (is(T, "TRANSACTION_REPLACED")) {
                k(), S(T);
                return;
              }
            }
            v || this.provider.once("block", B);
          }, "replaceListener");
          A.push(() => {
            this.provider.off("block", B);
          }),
            this.provider.once("block", B);
        }
      });
    }
    /**
     *  Returns ``true`` if this transaction has been included.
     *
     *  This is effective only as of the time the TransactionResponse
     *  was instantiated. To get up-to-date information, use
     *  [[getTransaction]].
     *
     *  This provides a Type Guard that this transaction will have
     *  non-null property values for properties that are null for
     *  unmined transactions.
     */
    isMined() {
      return this.blockHash != null;
    }
    /**
     *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
     *  transaction.
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLegacy() {
      return this.type === 0;
    }
    /**
     *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
     *  transaction. See [[link-eip-2070]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isBerlin() {
      return this.type === 1;
    }
    /**
     *  Returns true if the transaction is a London (i.e. ``type == 2``)
     *  transaction. See [[link-eip-1559]].
     *
     *  This provides a Type Guard that this transaction will have
     *  the ``null``-ness for hardfork-specific properties set correctly.
     */
    isLondon() {
      return this.type === 2;
    }
    /**
     *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
     *  transaction. See [[link-eip-4844]].
     */
    isCancun() {
      return this.type === 3;
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that evict this transaction.
     */
    removedEvent() {
      return (
        Pt(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
          operation: "removeEvent()",
        }),
        fm(this)
      );
    }
    /**
     *  Returns a filter which can be used to listen for orphan events
     *  that re-order this event against %%other%%.
     */
    reorderedEvent(e) {
      return (
        Pt(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
          operation: "removeEvent()",
        }),
        Pt(
          !e || e.isMined(),
          "unmined 'other' transaction canot be orphaned",
          "UNSUPPORTED_OPERATION",
          {
            operation: "removeEvent()",
          }
        ),
        om(this, e)
      );
    }
    /**
     *  Returns a new TransactionResponse instance which has the ability to
     *  detect (and throw an error) if the transaction is replaced, which
     *  will begin scanning at %%startBlock%%.
     *
     *  This should generally not be used by developers and is intended
     *  primarily for internal use. Setting an incorrect %%startBlock%% can
     *  have devastating performance consequences if used incorrectly.
     */
    replaceableTransaction(e) {
      bt(Number.isInteger(e) && e >= 0, "invalid startBlock", "startBlock", e);
      const n = new x4(this, this.provider);
      return Jt(n, ba, e), n;
    }
  };
ba = /* @__PURE__ */ new WeakMap();
Be(_4, "TransactionResponse");
var xk = _4;
function om(t, e) {
  return {
    orphan: "reorder-transaction",
    tx: t,
    other: e,
  };
}
Be(om, "createReorderedTransactionFilter");
function fm(t) {
  return {
    orphan: "drop-transaction",
    tx: t,
  };
}
Be(fm, "createRemovedTransactionFilter");
function M4(t) {
  return {
    orphan: "drop-log",
    log: {
      transactionHash: t.transactionHash,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      address: t.address,
      data: t.data,
      topics: Object.freeze(t.topics.slice()),
      index: t.index,
    },
  };
}
Be(M4, "createRemovedLogFilter");
var S4 = class extends Xu {
  /**
   * @_ignore:
   */
  constructor(e, n, i) {
    super(e, e.provider), Ge(this, "interface"), Ge(this, "fragment"), Ge(this, "args");
    const l = n.decodeEventLog(i, e.data, e.topics);
    Ft(this, {
      args: l,
      fragment: i,
      interface: n,
    });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
};
Be(S4, "EventLog");
var lm = S4,
  E4 = class extends Xu {
    /**
     * @_ignore:
     */
    constructor(e, n) {
      super(e, e.provider),
        Ge(this, "error"),
        Ft(this, {
          error: n,
        });
    }
  };
Be(E4, "UndecodedEventLog");
var A4 = E4,
  Ko,
  k4 = class extends _k {
    /**
     *  @_ignore:
     */
    constructor(e, n, i) {
      super(i, n), er(this, Ko, void 0), Jt(this, Ko, e);
    }
    /**
     *  The parsed logs for any [[Log]] which has a matching event in the
     *  Contract ABI.
     */
    get logs() {
      return super.logs.map((e) => {
        const n = e.topics.length ? pt(this, Ko).getEvent(e.topics[0]) : null;
        if (n)
          try {
            return new lm(e, pt(this, Ko), n);
          } catch (i) {
            return new A4(e, i);
          }
        return e;
      });
    }
  };
Ko = /* @__PURE__ */ new WeakMap();
Be(k4, "ContractTransactionReceipt");
var Mk = k4,
  Dl,
  B4 = class extends xk {
    /**
     *  @_ignore:
     */
    constructor(e, n, i) {
      super(i, n), er(this, Dl, void 0), Jt(this, Dl, e);
    }
    /**
     *  Resolves once this transaction has been mined and has
     *  %%confirms%% blocks including it (default: ``1``) with an
     *  optional %%timeout%%.
     *
     *  This can resolve to ``null`` only if %%confirms%% is ``0``
     *  and the transaction has not been mined, otherwise this will
     *  wait until enough confirmations have completed.
     */
    async wait(e, n) {
      const i = await super.wait(e, n);
      return i == null ? null : new Mk(pt(this, Dl), this.provider, i);
    }
  };
Dl = /* @__PURE__ */ new WeakMap();
Be(B4, "ContractTransactionResponse");
var um = B4,
  C4 = class extends bA {
    /**
     *  @_event:
     */
    constructor(e, n, i, l) {
      super(e, n, i),
        Ge(this, "log"),
        Ft(this, {
          log: l,
        });
    }
    /**
     *  Resolves to the block the event occured in.
     */
    async getBlock() {
      return await this.log.getBlock();
    }
    /**
     *  Resolves to the transaction the event occured in.
     */
    async getTransaction() {
      return await this.log.getTransaction();
    }
    /**
     *  Resolves to the transaction receipt the event occured in.
     */
    async getTransactionReceipt() {
      return await this.log.getTransactionReceipt();
    }
  };
Be(C4, "ContractUnknownEventPayload");
var T4 = C4,
  P4 = class extends T4 {
    /**
     *  @_ignore:
     */
    constructor(e, n, i, l, a) {
      super(e, n, i, new lm(a, e.interface, l));
      const c = e.interface.decodeEventLog(l, this.log.data, this.log.topics);
      Ft(this, {
        args: c,
        fragment: l,
      });
    }
    /**
     *  The event name.
     */
    get eventName() {
      return this.fragment.name;
    }
    /**
     *  The event signature.
     */
    get eventSignature() {
      return this.fragment.format();
    }
  };
Be(P4, "ContractEventPayload");
var Sk = P4,
  _2 = BigInt(0);
function cm(t) {
  return t && typeof t.call == "function";
}
Be(cm, "canCall");
function hm(t) {
  return t && typeof t.estimateGas == "function";
}
Be(hm, "canEstimate");
function Df(t) {
  return t && typeof t.resolveName == "function";
}
Be(Df, "canResolve");
function dm(t) {
  return t && typeof t.sendTransaction == "function";
}
Be(dm, "canSend");
function pm(t) {
  if (t != null) {
    if (Df(t)) return t;
    if (t.provider) return t.provider;
  }
}
Be(pm, "getResolver");
var ul,
  F0,
  Ek =
    ((F0 = class {
      constructor(t, e, n) {
        if (
          (er(this, ul, void 0),
          Ge(this, "fragment"),
          Ft(this, {
            fragment: e,
          }),
          e.inputs.length < n.length)
        )
          throw new Error("too many arguments");
        const i = aa(t.runner, "resolveName"),
          l = Df(i) ? i : null;
        Jt(
          this,
          ul,
          (async function () {
            const a = await Promise.all(
              e.inputs.map((c, v) =>
                n[v] == null
                  ? null
                  : c.walkAsync(n[v], (b, p) =>
                      b === "address"
                        ? Array.isArray(p)
                          ? Promise.all(p.map((_) => Hs(_, l)))
                          : Hs(p, l)
                        : p
                    )
              )
            );
            return t.interface.encodeFilterTopics(e, a);
          })()
        );
      }
      getTopicFilter() {
        return pt(this, ul);
      }
    }),
    (ul = /* @__PURE__ */ new WeakMap()),
    Be(F0, "PreparedTopicFilter"),
    F0);
function aa(t, e) {
  return t == null
    ? null
    : typeof t[e] == "function"
    ? t
    : t.provider && typeof t.provider[e] == "function"
    ? t.provider
    : null;
}
Be(aa, "getRunner");
function Ki(t) {
  return t == null ? null : t.provider || null;
}
Be(Ki, "getProvider");
async function ec(t, e) {
  const n = tn.dereference(t, "overrides");
  bt(typeof n == "object", "invalid overrides parameter", "overrides", t);
  const i = y4(n);
  return (
    bt(i.to == null || (e || []).indexOf("to") >= 0, "cannot override to", "overrides.to", i.to),
    bt(
      i.data == null || (e || []).indexOf("data") >= 0,
      "cannot override data",
      "overrides.data",
      i.data
    ),
    i.from && (i.from = i.from),
    i
  );
}
Be(ec, "copyOverrides");
async function mm(t, e, n) {
  const i = aa(t, "resolveName"),
    l = Df(i) ? i : null;
  return await Promise.all(
    e.map((a, c) =>
      a.walkAsync(n[c], (v, g) => ((g = tn.dereference(g, v)), v === "address" ? Hs(g, l) : g))
    )
  );
}
Be(mm, "resolveArgs");
function R4(t) {
  const e = /* @__PURE__ */ Be(async function (c) {
      const v = await ec(c, ["data"]);
      (v.to = await t.getAddress()), v.from && (v.from = await Hs(v.from, pm(t.runner)));
      const g = t.interface,
        b = ii(v.value || _2, "overrides.value") === _2,
        p = (v.data || "0x") === "0x";
      g.fallback &&
        !g.fallback.payable &&
        g.receive &&
        !p &&
        !b &&
        bt(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", c),
        bt(g.fallback || p, "cannot send data to receive-only contract", "overrides.data", v.data);
      const _ = g.receive || (g.fallback && g.fallback.payable);
      return (
        bt(_ || b, "cannot send value to non-payable fallback", "overrides.value", v.value),
        bt(g.fallback || p, "cannot send data to receive-only contract", "overrides.data", v.data),
        v
      );
    }, "populateTransaction"),
    n = /* @__PURE__ */ Be(async function (c) {
      const v = aa(t.runner, "call");
      Pt(cm(v), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
        operation: "call",
      });
      const g = await e(c);
      try {
        return await v.call(g);
      } catch (b) {
        throw V1(b) && b.data ? t.interface.makeError(b.data, g) : b;
      }
    }, "staticCall"),
    i = /* @__PURE__ */ Be(async function (c) {
      const v = t.runner;
      Pt(dm(v), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
        operation: "sendTransaction",
      });
      const g = await v.sendTransaction(await e(c)),
        b = Ki(t.runner);
      return new um(t.interface, b, g);
    }, "send"),
    l = /* @__PURE__ */ Be(async function (c) {
      const v = aa(t.runner, "estimateGas");
      return (
        Pt(hm(v), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
          operation: "estimateGas",
        }),
        await v.estimateGas(await e(c))
      );
    }, "estimateGas"),
    a = /* @__PURE__ */ Be(async (c) => await i(c), "method");
  return (
    Ft(a, {
      _contract: t,
      estimateGas: l,
      populateTransaction: e,
      send: i,
      staticCall: n,
    }),
    a
  );
}
Be(R4, "buildWrappedFallback");
function I4(t, e) {
  const n = /* @__PURE__ */ Be(function (...b) {
      const p = t.interface.getFunction(e, b);
      return (
        Pt(p, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: {
            key: e,
            args: b,
          },
        }),
        p
      );
    }, "getFragment"),
    i = /* @__PURE__ */ Be(async function (...b) {
      const p = n(...b);
      let _ = {};
      if (
        (p.inputs.length + 1 === b.length &&
          ((_ = await ec(b.pop())), _.from && (_.from = await Hs(_.from, pm(t.runner)))),
        p.inputs.length !== b.length)
      )
        throw new Error(
          "internal error: fragment inputs doesn't match arguments; should not happen"
        );
      const M = await mm(t.runner, p.inputs, b);
      return Object.assign(
        {},
        _,
        await Ql({
          to: t.getAddress(),
          data: t.interface.encodeFunctionData(p, M),
        })
      );
    }, "populateTransaction"),
    l = /* @__PURE__ */ Be(async function (...b) {
      const p = await v(...b);
      return p.length === 1 ? p[0] : p;
    }, "staticCall"),
    a = /* @__PURE__ */ Be(async function (...b) {
      const p = t.runner;
      Pt(dm(p), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
        operation: "sendTransaction",
      });
      const _ = await p.sendTransaction(await i(...b)),
        M = Ki(t.runner);
      return new um(t.interface, M, _);
    }, "send"),
    c = /* @__PURE__ */ Be(async function (...b) {
      const p = aa(t.runner, "estimateGas");
      return (
        Pt(hm(p), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
          operation: "estimateGas",
        }),
        await p.estimateGas(await i(...b))
      );
    }, "estimateGas"),
    v = /* @__PURE__ */ Be(async function (...b) {
      const p = aa(t.runner, "call");
      Pt(cm(p), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
        operation: "call",
      });
      const _ = await i(...b);
      let M = "0x";
      try {
        M = await p.call(_);
      } catch (A) {
        throw V1(A) && A.data ? t.interface.makeError(A.data, _) : A;
      }
      const S = n(...b);
      return t.interface.decodeFunctionResult(S, M);
    }, "staticCallResult"),
    g = /* @__PURE__ */ Be(
      async (...b) => (n(...b).constant ? await l(...b) : await a(...b)),
      "method"
    );
  return (
    Ft(g, {
      name: t.interface.getFunctionName(e),
      _contract: t,
      _key: e,
      getFragment: n,
      estimateGas: c,
      populateTransaction: i,
      send: a,
      staticCall: l,
      staticCallResult: v,
    }),
    Object.defineProperty(g, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const b = t.interface.getFunction(e);
        return (
          Pt(b, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
              key: e,
            },
          }),
          b
        );
      },
    }),
    g
  );
}
Be(I4, "buildWrappedMethod");
function O4(t, e) {
  const n = /* @__PURE__ */ Be(function (...l) {
      const a = t.interface.getEvent(e, l);
      return (
        Pt(a, "no matching fragment", "UNSUPPORTED_OPERATION", {
          operation: "fragment",
          info: {
            key: e,
            args: l,
          },
        }),
        a
      );
    }, "getFragment"),
    i = /* @__PURE__ */ Be(function (...l) {
      return new Ek(t, n(...l), l);
    }, "method");
  return (
    Ft(i, {
      name: t.interface.getEventName(e),
      _contract: t,
      _key: e,
      getFragment: n,
    }),
    Object.defineProperty(i, "fragment", {
      configurable: !1,
      enumerable: !0,
      get: () => {
        const l = t.interface.getEvent(e);
        return (
          Pt(l, "no matching fragment", "UNSUPPORTED_OPERATION", {
            operation: "fragment",
            info: {
              key: e,
            },
          }),
          l
        );
      },
    }),
    i
  );
}
Be(O4, "buildWrappedEvent");
var tc = Symbol.for("_ethersInternal_contract"),
  U4 = /* @__PURE__ */ new WeakMap();
function N4(t, e) {
  U4.set(t[tc], e);
}
Be(N4, "setInternal");
function Jr(t) {
  return U4.get(t[tc]);
}
Be(Jr, "getInternal");
function D4(t) {
  return (
    t &&
    typeof t == "object" &&
    "getTopicFilter" in t &&
    typeof t.getTopicFilter == "function" &&
    t.fragment
  );
}
Be(D4, "isDeferred");
async function rc(t, e) {
  let n,
    i = null;
  if (Array.isArray(e)) {
    const a = /* @__PURE__ */ Be(function (c) {
      if (Si(c, 32)) return c;
      const v = t.interface.getEvent(c);
      return bt(v, "unknown fragment", "name", c), v.topicHash;
    }, "topicHashify");
    n = e.map((c) => (c == null ? null : Array.isArray(c) ? c.map(a) : a(c)));
  } else
    e === "*"
      ? (n = [null])
      : typeof e == "string"
      ? Si(e, 32)
        ? (n = [e])
        : ((i = t.interface.getEvent(e)),
          bt(i, "unknown fragment", "event", e),
          (n = [i.topicHash]))
      : D4(e)
      ? (n = await e.getTopicFilter())
      : "fragment" in e
      ? ((i = e.fragment), (n = [i.topicHash]))
      : bt(!1, "unknown event name", "event", e);
  n = n.map((a) => {
    if (a == null) return null;
    if (Array.isArray(a)) {
      const c = Array.from(new Set(a.map((v) => v.toLowerCase())).values());
      return c.length === 1 ? c[0] : (c.sort(), c);
    }
    return a.toLowerCase();
  });
  const l = n.map((a) => (a == null ? "null" : Array.isArray(a) ? a.join("|") : a)).join("&");
  return {
    fragment: i,
    tag: l,
    topics: n,
  };
}
Be(rc, "getSubInfo");
async function ys(t, e) {
  const { subs: n } = Jr(t);
  return n.get((await rc(t, e)).tag) || null;
}
Be(ys, "hasSub");
async function Rp(t, e, n) {
  const i = Ki(t.runner);
  Pt(i, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
    operation: e,
  });
  const { fragment: l, tag: a, topics: c } = await rc(t, n),
    { addr: v, subs: g } = Jr(t);
  let b = g.get(a);
  if (!b) {
    const _ = {
        address: v || t,
        topics: c,
      },
      M = /* @__PURE__ */ Be((P) => {
        let B = l;
        if (B == null)
          try {
            B = t.interface.getEvent(P.topics[0]);
          } catch {}
        if (B) {
          const T = B,
            F = l ? t.interface.decodeEventLog(l, P.data, P.topics) : [];
          eu(t, n, F, (O) => new Sk(t, O, n, T, P));
        } else eu(t, n, [], (T) => new T4(t, T, n, P));
      }, "listener");
    let S = [];
    (b = {
      tag: a,
      listeners: [],
      start: /* @__PURE__ */ Be(() => {
        S.length || S.push(i.on(_, M));
      }, "start"),
      stop: /* @__PURE__ */ Be(async () => {
        if (S.length == 0) return;
        let P = S;
        (S = []), await Promise.all(P), i.off(_, M);
      }, "stop"),
    }),
      g.set(a, b);
  }
  return b;
}
Be(Rp, "getSub");
var Ip = Promise.resolve();
async function L4(t, e, n, i) {
  await Ip;
  const l = await ys(t, e);
  if (!l) return !1;
  const a = l.listeners.length;
  return (
    (l.listeners = l.listeners.filter(({ listener: c, once: v }) => {
      const g = Array.from(n);
      i && g.push(i(v ? null : c));
      try {
        c.call(t, ...g);
      } catch {}
      return !v;
    })),
    l.listeners.length === 0 && (l.stop(), Jr(t).subs.delete(l.tag)),
    a > 0
  );
}
Be(L4, "_emit");
async function eu(t, e, n, i) {
  try {
    await Ip;
  } catch {}
  const l = L4(t, e, n, i);
  return (Ip = l), await l;
}
Be(eu, "emit");
var cl = ["then"],
  F4,
  q4 = class Ll {
    /**
     *  Creates a new contract connected to %%target%% with the %%abi%% and
     *  optionally connected to a %%runner%% to perform operations on behalf
     *  of.
     */
    constructor(e, n, i, l) {
      Ge(this, "target"),
        Ge(this, "interface"),
        Ge(this, "runner"),
        Ge(this, "filters"),
        Ge(this, F4),
        Ge(this, "fallback"),
        bt(typeof e == "string" || rm(e), "invalid value for Contract target", "target", e),
        i == null && (i = null);
      const a = Qu.from(n);
      Ft(this, {
        target: e,
        runner: i,
        interface: a,
      }),
        Object.defineProperty(this, tc, {
          value: {},
        });
      let c,
        v = null,
        g = null;
      if (l) {
        const _ = Ki(i);
        g = new um(this.interface, _, l);
      }
      let b = /* @__PURE__ */ new Map();
      if (typeof e == "string")
        if (Si(e)) (v = e), (c = Promise.resolve(e));
        else {
          const _ = aa(i, "resolveName");
          if (!Df(_))
            throw $s("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
              operation: "resolveName",
            });
          c = _.resolveName(e).then((M) => {
            if (M == null)
              throw $s(
                "an ENS name used for a contract target must be correctly configured",
                "UNCONFIGURED_NAME",
                {
                  value: e,
                }
              );
            return (Jr(this).addr = M), M;
          });
        }
      else
        c = e.getAddress().then((_) => {
          if (_ == null) throw new Error("TODO");
          return (Jr(this).addr = _), _;
        });
      N4(this, {
        addrPromise: c,
        addr: v,
        deployTx: g,
        subs: b,
      });
      const p = new Proxy(
        {},
        {
          get: (_, M, S) => {
            if (typeof M == "symbol" || cl.indexOf(M) >= 0) return Reflect.get(_, M, S);
            try {
              return this.getEvent(M);
            } catch (A) {
              if (!is(A, "INVALID_ARGUMENT") || A.argument !== "key") throw A;
            }
          },
          has: (_, M) =>
            cl.indexOf(M) >= 0
              ? Reflect.has(_, M)
              : Reflect.has(_, M) || this.interface.hasEvent(String(M)),
        }
      );
      return (
        Ft(this, {
          filters: p,
        }),
        Ft(this, {
          fallback: a.receive || a.fallback ? R4(this) : null,
        }),
        new Proxy(this, {
          get: (_, M, S) => {
            if (typeof M == "symbol" || M in _ || cl.indexOf(M) >= 0) return Reflect.get(_, M, S);
            try {
              return _.getFunction(M);
            } catch (A) {
              if (!is(A, "INVALID_ARGUMENT") || A.argument !== "key") throw A;
            }
          },
          has: (_, M) =>
            typeof M == "symbol" || M in _ || cl.indexOf(M) >= 0
              ? Reflect.has(_, M)
              : _.interface.hasFunction(M),
        })
      );
    }
    /**
     *  Return a new Contract instance with the same target and ABI, but
     *  a different %%runner%%.
     */
    connect(e) {
      return new Ll(this.target, this.interface, e);
    }
    /**
     *  Return a new Contract instance with the same ABI and runner, but
     *  a different %%target%%.
     */
    attach(e) {
      return new Ll(e, this.interface, this.runner);
    }
    /**
     *  Return the resolved address of this Contract.
     */
    async getAddress() {
      return await Jr(this).addrPromise;
    }
    /**
     *  Return the deployed bytecode or null if no bytecode is found.
     */
    async getDeployedCode() {
      const e = Ki(this.runner);
      Pt(e, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
        operation: "getDeployedCode",
      });
      const n = await e.getCode(await this.getAddress());
      return n === "0x" ? null : n;
    }
    /**
     *  Resolve to this Contract once the bytecode has been deployed, or
     *  resolve immediately if already deployed.
     */
    async waitForDeployment() {
      const e = this.deploymentTransaction();
      if (e) return await e.wait(), this;
      if ((await this.getDeployedCode()) != null) return this;
      const i = Ki(this.runner);
      return (
        Pt(i != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
          operation: "waitForDeployment",
        }),
        new Promise((l, a) => {
          const c = /* @__PURE__ */ Be(async () => {
            try {
              if ((await this.getDeployedCode()) != null) return l(this);
              i.once("block", c);
            } catch (v) {
              a(v);
            }
          }, "checkCode");
          c();
        })
      );
    }
    /**
     *  Return the transaction used to deploy this contract.
     *
     *  This is only available if this instance was returned from a
     *  [[ContractFactory]].
     */
    deploymentTransaction() {
      return Jr(this).deployTx;
    }
    /**
     *  Return the function for a given name. This is useful when a contract
     *  method name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getFunction(e) {
      return typeof e != "string" && (e = e.format()), I4(this, e);
    }
    /**
     *  Return the event for a given name. This is useful when a contract
     *  event name conflicts with a JavaScript name such as ``prototype`` or
     *  when using a Contract programatically.
     */
    getEvent(e) {
      return typeof e != "string" && (e = e.format()), O4(this, e);
    }
    /**
     *  @_ignore:
     */
    async queryTransaction(e) {
      throw new Error("@TODO");
    }
    /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }

          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
    /**
     *  Provide historic access to event data for %%event%% in the range
     *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
     *  inclusive.
     */
    async queryFilter(e, n, i) {
      n == null && (n = 0), i == null && (i = "latest");
      const { addr: l, addrPromise: a } = Jr(this),
        c = l || (await a),
        { fragment: v, topics: g } = await rc(this, e),
        b = {
          address: c,
          topics: g,
          fromBlock: n,
          toBlock: i,
        },
        p = Ki(this.runner);
      return (
        Pt(p, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
          operation: "queryFilter",
        }),
        (await p.getLogs(b)).map((_) => {
          let M = v;
          if (M == null)
            try {
              M = this.interface.getEvent(_.topics[0]);
            } catch {}
          if (M)
            try {
              return new lm(_, this.interface, M);
            } catch (S) {
              return new A4(_, S);
            }
          return new Xu(_, p);
        })
      );
    }
    /**
     *  Add an event %%listener%% for the %%event%%.
     */
    async on(e, n) {
      const i = await Rp(this, "on", e);
      return (
        i.listeners.push({
          listener: n,
          once: !1,
        }),
        i.start(),
        this
      );
    }
    /**
     *  Add an event %%listener%% for the %%event%%, but remove the listener
     *  after it is fired once.
     */
    async once(e, n) {
      const i = await Rp(this, "once", e);
      return (
        i.listeners.push({
          listener: n,
          once: !0,
        }),
        i.start(),
        this
      );
    }
    /**
     *  Emit an %%event%% calling all listeners with %%args%%.
     *
     *  Resolves to ``true`` if any listeners were called.
     */
    async emit(e, ...n) {
      return await eu(this, e, n, null);
    }
    /**
     *  Resolves to the number of listeners of %%event%% or the total number
     *  of listeners if unspecified.
     */
    async listenerCount(e) {
      if (e) {
        const l = await ys(this, e);
        return l ? l.listeners.length : 0;
      }
      const { subs: n } = Jr(this);
      let i = 0;
      for (const { listeners: l } of n.values()) i += l.length;
      return i;
    }
    /**
     *  Resolves to the listeners subscribed to %%event%% or all listeners
     *  if unspecified.
     */
    async listeners(e) {
      if (e) {
        const l = await ys(this, e);
        return l ? l.listeners.map(({ listener: a }) => a) : [];
      }
      const { subs: n } = Jr(this);
      let i = [];
      for (const { listeners: l } of n.values()) i = i.concat(l.map(({ listener: a }) => a));
      return i;
    }
    /**
     *  Remove the %%listener%% from the listeners for %%event%% or remove
     *  all listeners if unspecified.
     */
    async off(e, n) {
      const i = await ys(this, e);
      if (!i) return this;
      if (n) {
        const l = i.listeners.map(({ listener: a }) => a).indexOf(n);
        l >= 0 && i.listeners.splice(l, 1);
      }
      return (
        (n == null || i.listeners.length === 0) && (i.stop(), Jr(this).subs.delete(i.tag)), this
      );
    }
    /**
     *  Remove all the listeners for %%event%% or remove all listeners if
     *  unspecified.
     */
    async removeAllListeners(e) {
      if (e) {
        const n = await ys(this, e);
        if (!n) return this;
        n.stop(), Jr(this).subs.delete(n.tag);
      } else {
        const { subs: n } = Jr(this);
        for (const { tag: i, stop: l } of n.values()) l(), n.delete(i);
      }
      return this;
    }
    /**
     *  Alias for [on].
     */
    async addListener(e, n) {
      return await this.on(e, n);
    }
    /**
     *  Alias for [off].
     */
    async removeListener(e, n) {
      return await this.off(e, n);
    }
    /**
     *  Create a new Class for the %%abi%%.
     */
    static buildClass(e) {
      var n;
      return (
        (n = class extends Ll {
          constructor(l, a = null) {
            super(l, e, a);
          }
        }),
        Be(n, "CustomContract"),
        n
      );
    }
    /**
     *  Create a new BaseContract with a specified Interface.
     */
    static from(e, n, i) {
      return i == null && (i = null), new this(e, n, i);
    }
  };
F4 = tc;
Be(q4, "BaseContract");
var Op = q4;
function z4() {
  return Op;
}
Be(z4, "_ContractBase");
var j4 = class extends z4() {};
Be(j4, "Contract");
var $4 = j4,
  H4 = class V4 {
    /**
     *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
     *  optionally connected to %%runner%%.
     *
     *  The %%bytecode%% may be the ``bytecode`` property within the
     *  standard Solidity JSON output.
     */
    constructor(e, n, i) {
      Ge(this, "interface"), Ge(this, "bytecode"), Ge(this, "runner");
      const l = Qu.from(e);
      n instanceof Uint8Array ||
        (typeof n == "object" && (n = n.object), n.startsWith("0x") || (n = "0x" + n)),
        (n = dr(dn(n))),
        Ft(this, {
          bytecode: n,
          interface: l,
          runner: i || null,
        });
    }
    attach(e) {
      return new Op(e, this.interface, this.runner);
    }
    /**
     *  Resolves to the transaction to deploy the contract, passing %%args%%
     *  into the constructor.
     */
    async getDeployTransaction(...e) {
      let n = {};
      const i = this.interface.deploy;
      if (
        (i.inputs.length + 1 === e.length && (n = await ec(e.pop())), i.inputs.length !== e.length)
      )
        throw new Error("incorrect number of arguments to constructor");
      const l = await mm(this.runner, i.inputs, e),
        a = ta([this.bytecode, this.interface.encodeDeploy(l)]);
      return Object.assign({}, n, {
        data: a,
      });
    }
    /**
     *  Resolves to the Contract deployed by passing %%args%% into the
     *  constructor.
     *
     *  This will resolve to the Contract before it has been deployed to the
     *  network, so the [[BaseContract-waitForDeployment]] should be used before
     *  sending any transactions to it.
     */
    async deploy(...e) {
      const n = await this.getDeployTransaction(...e);
      Pt(
        this.runner && typeof this.runner.sendTransaction == "function",
        "factory runner does not support sending transactions",
        "UNSUPPORTED_OPERATION",
        {
          operation: "sendTransaction",
        }
      );
      const i = await this.runner.sendTransaction(n),
        l = O5(i);
      return new Op(l, this.interface, this.runner, i);
    }
    /**
     *  Return a new **ContractFactory** with the same ABI and bytecode,
     *  but connected to %%runner%%.
     */
    connect(e) {
      return new V4(this.interface, this.bytecode, e);
    }
    /**
     *  Create a new **ContractFactory** from the standard Solidity JSON output.
     */
    static fromSolidity(e, n) {
      bt(e != null, "bad compiler output", "output", e),
        typeof e == "string" && (e = JSON.parse(e));
      const i = e.abi;
      let l = "";
      return (
        e.bytecode ? (l = e.bytecode) : e.evm && e.evm.bytecode && (l = e.evm.bytecode),
        new this(i, l, n)
      );
    }
  };
Be(H4, "ContractFactory");
var Ak = H4,
  Fl = [
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "uint8",
          name: "version",
          type: "uint8",
        },
      ],
      name: "Initialized",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          components: [
            {
              internalType: "address",
              name: "senderAddr",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "receiverAddrHash",
              type: "uint256",
            },
            {
              internalType: "int8",
              name: "receiverAddrWorkchain",
              type: "int8",
            },
          ],
          indexed: !1,
          internalType: "struct LockPayload",
          name: "lockPayload",
          type: "tuple",
        },
      ],
      name: "Locked",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "senderAddrHash",
              type: "uint256",
            },
            {
              internalType: "int8",
              name: "senderAddrWorkchain",
              type: "int8",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
            {
              internalType: "address",
              name: "receiverAddr",
              type: "address",
            },
            {
              internalType: "address",
              name: "bridgeAddr",
              type: "address",
            },
          ],
          indexed: !1,
          internalType: "struct UnlockPayload",
          name: "unlockPayload",
          type: "tuple",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "externalId",
          type: "uint256",
        },
      ],
      name: "Unlocked",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_validatorAddr",
          type: "address",
        },
        {
          internalType: "address",
          name: "_tokenAddr",
          type: "address",
        },
      ],
      name: "__Bridge_init",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_newValidatorAddr",
          type: "address",
        },
      ],
      name: "changeValidatorAddr",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "senderAddrHash",
              type: "uint256",
            },
            {
              internalType: "int8",
              name: "senderAddrWorkchain",
              type: "int8",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
            {
              internalType: "address",
              name: "receiverAddr",
              type: "address",
            },
            {
              internalType: "address",
              name: "bridgeAddr",
              type: "address",
            },
          ],
          internalType: "struct UnlockPayload",
          name: "_unlockPayload",
          type: "tuple",
        },
        {
          internalType: "uint256",
          name: "externalId",
          type: "uint256",
        },
      ],
      name: "getUnlockPayloadHash",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32",
        },
      ],
      stateMutability: "pure",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "_amount",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "_receiverAddrHash",
          type: "uint256",
        },
        {
          internalType: "int8",
          name: "_receiverAddrWorkchain",
          type: "int8",
        },
      ],
      name: "lock",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32",
        },
      ],
      name: "pulls",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "tokenAddr",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "bytes",
          name: "_signature",
          type: "bytes",
        },
        {
          components: [
            {
              internalType: "uint256",
              name: "senderAddrHash",
              type: "uint256",
            },
            {
              internalType: "int8",
              name: "senderAddrWorkchain",
              type: "int8",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
            {
              internalType: "address",
              name: "receiverAddr",
              type: "address",
            },
            {
              internalType: "address",
              name: "bridgeAddr",
              type: "address",
            },
          ],
          internalType: "struct UnlockPayload",
          name: "_unlockPayload",
          type: "tuple",
        },
        {
          internalType: "uint256",
          name: "_externalId",
          type: "uint256",
        },
      ],
      name: "unlock",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "validatorAddr",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "_tokenAddr",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "withdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  W4 =
    "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",
  kk = /* @__PURE__ */ Be((t) => t.length > 1, "isSuperArgs"),
  nc = class extends Ak {
    constructor(...e) {
      kk(e) ? super(...e) : super(Fl, W4, e[0]);
    }
    getDeployTransaction(e) {
      return super.getDeployTransaction(e || {});
    }
    deploy(e) {
      return super.deploy(e || {});
    }
    connect(e) {
      return super.connect(e);
    }
    static createInterface() {
      return new Qu(Fl);
    }
    static connect(e, n) {
      return new $4(e, Fl, n);
    }
  };
Be(nc, "GagarinMasterBridge__factory");
Ge(nc, "bytecode", W4);
Ge(nc, "abi", Fl);
var Bk = nc,
  Up = [
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "lockPeriod",
          type: "uint256",
        },
        {
          indexed: !1,
          internalType: "uint64",
          name: "alpPerGgr",
          type: "uint64",
        },
        {
          indexed: !1,
          internalType: "uint64",
          name: "emergencyWithdrawFee",
          type: "uint64",
        },
        {
          indexed: !1,
          internalType: "uint64",
          name: "apr",
          type: "uint64",
        },
        {
          indexed: !1,
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
      ],
      name: "CreatePool",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "Deposit",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "emergencyWithdrawFee",
          type: "uint256",
        },
      ],
      name: "EmergencyWithdraw",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "uint8",
          name: "version",
          type: "uint8",
        },
      ],
      name: "Initialized",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint256",
          name: "oldPid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "uint256",
          name: "newPid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "user",
          type: "address",
        },
      ],
      name: "ReStake",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !1,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "Withdraw",
      type: "event",
    },
    {
      anonymous: !1,
      inputs: [
        {
          indexed: !0,
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          indexed: !0,
          internalType: "address",
          name: "user",
          type: "address",
        },
        {
          indexed: !1,
          internalType: "uint256",
          name: "reward",
          type: "uint256",
        },
      ],
      name: "WithdrawReward",
      type: "event",
    },
    {
      inputs: [],
      name: "GGR",
      outputs: [
        {
          internalType: "contract IERC20Upgradeable",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "PERCENT_DECIMALS",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "ggr",
          type: "address",
        },
        {
          internalType: "address",
          name: "vault",
          type: "address",
        },
      ],
      name: "__GagarinStaking_init",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "lockPeriod",
          type: "uint256",
        },
        {
          internalType: "uint64",
          name: "alpPerGgr",
          type: "uint64",
        },
        {
          internalType: "uint64",
          name: "emergencyWithdrawFee",
          type: "uint64",
        },
        {
          internalType: "uint64",
          name: "apr",
          type: "uint64",
        },
        {
          internalType: "bool",
          name: "isActive",
          type: "bool",
        },
      ],
      name: "createPool",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "deposit",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "emergencyWithdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
      ],
      name: "getPool",
      outputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "pid",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "staked",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "paidReward",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "lockPeriod",
              type: "uint256",
            },
            {
              internalType: "uint64",
              name: "alpPerGgr",
              type: "uint64",
            },
            {
              internalType: "uint64",
              name: "emergencyWithdrawFee",
              type: "uint64",
            },
            {
              internalType: "uint64",
              name: "apr",
              type: "uint64",
            },
            {
              internalType: "bool",
              name: "isActive",
              type: "bool",
            },
          ],
          internalType: "struct GagarinStaking.PoolInfo",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "user",
          type: "address",
        },
      ],
      name: "getUser",
      outputs: [
        {
          components: [
            {
              internalType: "uint256",
              name: "pid",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "stakedAmount",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "totalReward",
              type: "uint256",
            },
            {
              internalType: "uint64",
              name: "stakedAt",
              type: "uint64",
            },
            {
              internalType: "uint64",
              name: "lastRewardAt",
              type: "uint64",
            },
          ],
          internalType: "struct GagarinStaking.UserInfo",
          name: "",
          type: "tuple",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
      ],
      name: "moveStakingData",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "pid",
          type: "uint256",
        },
      ],
      name: "reStake",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "userAddr",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "timestamp",
          type: "uint256",
        },
      ],
      name: "releasable",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "release",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "ggr",
          type: "address",
        },
        {
          internalType: "address",
          name: "vault",
          type: "address",
        },
      ],
      name: "setAddrs",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "totalPools",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalReward",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalStaked",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "withdraw",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  vm = class {
    static createInterface() {
      return new Qu(Up);
    }
    static connect(e, n) {
      return new $4(e, Up, n);
    }
  };
Be(vm, "GagarinStaking__factory");
Ge(vm, "abi", Up);
var Ck = vm,
  K4 = class ql {
    constructor(e, n) {
      Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
    }
    static createFromAddress(e) {
      return new ql(e);
    }
    static createFromConfig(e, n, i = 0) {
      const l = ql.buildDataCellFromConfig(e),
        a = {
          code: n,
          data: l,
        };
      return new ql(_t.contractAddress(i, a), a);
    }
    static buildDataCellFromConfig(e) {
      return _t
        .beginCell()
        .storeCoins(e.totalSupply)
        .storeAddress(e.adminAddr)
        .storeRef(e.content)
        .storeRef(e.jettonWalletCode)
        .endCell();
    }
    async sendDeploy(e, n, i) {
      await e.internal(n, {
        value: i,
        sendMode: _t.SendMode.PAY_GAS_SEPARATELY,
        body: _t.beginCell().endCell(),
      });
    }
    async sendMint(e, n, i) {
      return await e.internal(n, {
        value: i.value,
        body: _t
          .beginCell()
          .storeUint(21, 32)
          .storeUint(0, 64)
          .storeAddress(i.address)
          .storeCoins(i.value || _t.toNano("0.2"))
          .storeRef(
            _t
              .beginCell()
              .storeUint(395134233, 32)
              .storeUint(0, 64)
              .storeCoins(i.amount)
              .storeAddress(null)
              .storeAddress(null)
              .storeCoins(0)
              .storeBit(!1)
              .endCell()
          )
          .endCell(),
      });
    }
    static buildBodyChangeAdmin({ admin: e, queryId: n = 0 }) {
      return _t.beginCell().storeUint(3, 32).storeUint(n, 64).storeAddress(e).endCell();
    }
    async sendMsg(e, n, i) {
      return await e.internal(n, {
        value: i.value,
        body: i.body,
      });
    }
    async getWalletAddress(e, n) {
      const { stack: i } = await e.get("get_wallet_address", [
          {
            type: "slice",
            cell: _t.beginCell().storeAddress(n).endCell(),
          },
        ]),
        [l] = [i.readAddress()];
      return {
        address: l,
      };
    }
    async getJettonData(e) {
      const { stack: n } = await e.get("get_jetton_data", []),
        [i, l, a, c, v] = [
          n.readBigNumber(),
          n.readBoolean(),
          n.readAddress(),
          n.readCell(),
          n.readCell(),
        ];
      return {
        totalSupply: i,
        mintable: l,
        adminAddr: a,
        content: c,
        walletCode: v,
      };
    }
  };
Be(K4, "J");
var Z4 = K4,
  gm = class zl {
    constructor(e, n) {
      Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
    }
    static createFromAddress(e) {
      return new zl(e);
    }
    static buildSendTransferMsg(e) {
      return _t
        .beginCell()
        .storeUint(zl.OP_CODES.TRANSFER, 32)
        .storeUint(0, 64)
        .storeCoins(e.jettonAmount)
        .storeAddress(e.destAddr)
        .storeAddress(e.responseAddr)
        .storeDict(e.customPayload)
        .storeCoins(e.forwardToncoinAmount)
        .storeMaybeRef(e.forwardPayload || null)
        .endCell();
    }
    async sendTransfer(e, n, i) {
      return await e.internal(n, {
        value: i.coinAmount,
        body: _t
          .beginCell()
          .storeUint(zl.OP_CODES.TRANSFER, 32)
          .storeUint(0, 64)
          .storeCoins(i.jettonAmount)
          .storeAddress(i.destAddr)
          .storeAddress(i.responseAddr)
          .storeDict(i.customPayload)
          .storeCoins(i.forwardToncoinAmount)
          .storeMaybeRef(i.forwardPayload || null)
          .endCell(),
      });
    }
    async getBalance(e) {
      if ((await e.getState()).state.type !== "active")
        return {
          amount: 0n,
        };
      const { stack: i } = await e.get("get_wallet_data", []),
        [l] = [i.readBigNumber()];
      return {
        amount: l,
      };
    }
  };
Be(gm, "Jw");
Ge(gm, "OP_CODES", {
  TRANSFER: BigInt(260734629),
});
var G4 = gm,
  q0 = /* @__PURE__ */ Be((t) => BigInt(`0x${t.toString("hex")}`), "bufToBigInt"),
  Tk = /* @__PURE__ */ Be((t, e) => {
    let n = t.toString(16);
    return e && n.length < e * 2 && (n = "0".repeat(e * 2 - n.length) + n), Qe.from(n, "hex");
  }, "bigIntToBuf"),
  x2;
(function (t) {
  (t[(t.STOPPED = 0)] = "STOPPED"), (t[(t.RUNNING = 1)] = "RUNNING");
})(x2 || (x2 = {}));
var ic = class sr {
  constructor(e, n) {
    Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
  }
  static createFromAddress(e) {
    return new sr(e);
  }
  static async createFromCfg(e, n, i = 0) {
    const l = await sr.buildDataCellFromCfg(e),
      a = {
        code: n,
        data: l,
      };
    return new sr(_t.contractAddress(i, a), a);
  }
  static get poolsDictK() {
    return _t.Dictionary.Keys.BigInt(128);
  }
  static get poolsDictV() {
    return _t.Dictionary.Values.BigInt(128);
  }
  static get stakesDictK() {
    return _t.Dictionary.Keys.BigInt(256);
  }
  static get stakesDictV() {
    return {
      serialize: (e, n) => {
        n.storeSlice(e.beginParse());
      },
      parse: sr.parseStake,
    };
  }
  static parseStake(e) {
    const n = e.loadUint(8),
      i = e.loadUintBig(128),
      l = e.loadUintBig(128),
      a = e.loadCoins();
    return {
      wc: n,
      lock: i,
      updatedAt: l,
      amount: a,
    };
  }
  static async buildDataCellFromCfg(e) {
    const n = _t.Dictionary.empty(sr.poolsDictK, sr.poolsDictV);
    e.pools.forEach((a) => {
      n.set(a.lock, a.multiplier);
    });
    const i = _t.Dictionary.empty(sr.stakesDictK, sr.stakesDictV);
    e.stakes.forEach((a) => {
      i.set(
        q0(a.ownerAddr.hash),
        _t
          .beginCell()
          .storeUint(a.ownerAddr.workChain, 8)
          .storeUint(a.lock, 128)
          .storeUint(a.updatedAt, 128)
          .storeCoins(a.amount)
          .endCell()
      );
    });
    const l = _t
      .beginCell()
      .storeUint(e.state, 4)
      .storeAddress(e.jAddr)
      .storeAddress(e.adminAddr)
      .storeDict(n);
    return e.stakes.length ? l.storeDict(i) : l.storeBit(!1), l.storeRef(e.jwCode).endCell();
  }
  static buildStakeMsgBody({ lock: e }) {
    return _t.beginCell().storeUint(sr.OpCodes.STAKE, 32).storeUint(e, 128).endCell();
  }
  static buildWithdrawPayload() {
    return _t.beginCell().storeUint(sr.OpCodes.WITHDRAW, 32).storeUint(0, 64).endCell();
  }
  static async buildUpgradePayload({ queryId: e = 0, code: n, data: i }) {
    const l = _t.beginCell().storeUint(sr.OpCodes.UPGRADE, 32).storeUint(e, 64).storeRef(n);
    return i && l.storeRef(i), l.endCell();
  }
  static async buildChangeDataPayload({ queryId: e = 0, data: n }) {
    return _t
      .beginCell()
      .storeUint(sr.OpCodes.CHANGE_DATA, 32)
      .storeUint(e, 64)
      .storeRef(await sr.buildDataCellFromCfg(n))
      .endCell();
  }
  async sendMsg(e, n, i) {
    return await e.internal(n, {
      value: i.value,
      body: i.body,
    });
  }
  async sendDeploy(e, n, i) {
    await e.internal(n, {
      value: i,
      sendMode: _t.SendMode.PAY_GAS_SEPARATELY,
      body: _t.beginCell().endCell(),
    });
  }
  async getStoredData(e) {
    const { stack: n } = await e.get("get_stored_data", []),
      [i, l, a, c, v, g] = [
        n.readNumber(),
        n.readAddress(),
        n.readAddress(),
        n.readCell(),
        n.readCellOpt(),
        n.readCell(),
      ],
      b = _t.Dictionary.loadDirect(sr.poolsDictK, sr.poolsDictV, c.beginParse()),
      p = v
        ? _t.Dictionary.loadDirect(sr.stakesDictK, sr.stakesDictV, v.beginParse())
        : _t.Dictionary.empty(sr.stakesDictK, sr.stakesDictV),
      _ = b.keys().map((S) => ({
        lock: S,
        multiplier: b.get(S),
      })),
      M = p.keys().map((S) => {
        const A = p.get(S);
        return {
          ownerAddr: new _t.Address(+A.wc.toString(), Tk(S, 32)),
          lock: A.lock,
          updatedAt: A.updatedAt,
          amount: A.amount,
        };
      });
    return {
      state: i,
      jAddr: l,
      adminAddr: a,
      pools: _,
      stakes: M,
      jwCode: g,
    };
  }
  async getPools(e) {
    const { stack: n } = await e.get("get_pools", []),
      [i] = [n.readCell()],
      l = _t.Dictionary.loadDirect(sr.poolsDictK, sr.poolsDictV, i.beginParse());
    return {
      pools: l.keys().map((c) => ({
        lock: c,
        multiplier: l.get(c),
      })),
    };
  }
  async getCalcPenalty(e, { amount: n }) {
    const { stack: i } = await e.get("get_calc_penalty", [
        {
          type: "int",
          value: n,
        },
      ]),
      [l] = [i.readBigNumber()];
    return {
      penalty: l,
    };
  }
  async getEstimateWithdrawAmount(e, { owner: n }) {
    const { stack: i } = await e.get("get_estimate_withdraw_amount", [
        {
          type: "int",
          value: q0(n.hash),
        },
      ]),
      [l] = [i.readBigNumber()];
    return {
      amount: l,
    };
  }
  async getStake(e, { owner: n }) {
    const { stack: i } = await e.get("get_stake", [
        {
          type: "int",
          value: q0(n.hash),
        },
      ]),
      [l] = [i.readCellOpt()],
      { wc: a, ...c } = sr.parseStake(l.beginParse());
    return {
      stake: {
        ownerAddr: new _t.Address(a, n.hash),
        ...c,
      },
    };
  }
  async getMultiplierAndStakeAmount(e, { owner: n }) {
    const { pools: i } = await this.getPools(e),
      {
        stake: { amount: l, lock: a },
      } = await this.getStake(e, {
        owner: n,
      });
    i.sort((g, b) => (g.lock < b.lock ? -1 : 1));
    let c = -1;
    for (let g = 0; g < i.length && i[g].lock <= a; g++) c = g;
    return {
      multiplier: c !== -1 ? i[c].multiplier : BigInt(0),
      amount: l,
    };
  }
};
Be(ic, "LockPool");
Ge(ic, "OpCodes", {
  STAKE: BigInt(1254833821),
  WITHDRAW: BigInt(2354023824),
  CHANGE_DATA: BigInt(4038890404),
  UPGRADE: BigInt(621263097),
});
Ge(ic, "Errors", {
  BAD_SENDER_JW: 1001,
  STAKE_NOT_FOUND: 1002,
  POOL_NOT_FOUND: 1003,
  STOPPED: 1004,
  BAD_SENDER_ADMIN: 1005,
});
var z0 = ic,
  ac = class jl {
    constructor(e, n) {
      Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
    }
    static createFromAddress(e) {
      return new jl(e);
    }
    static async createFromCfg(e, n, i = 0) {
      const l = await jl.buildDataCellFromCfg(e),
        a = {
          code: n,
          data: l,
        };
      return new jl(_t.contractAddress(i, a), a);
    }
    static async buildDataCellFromCfg(e) {
      return _t
        .beginCell()
        .storeUint(e.inited ? 1 : 0, 1)
        .storeUint(e.mintHash, 256)
        .storeAddress(e.bridge)
        .endCell();
    }
    async getStoredData(e) {
      const { stack: n } = await e.get("get_stored_data", []),
        [i, l, a] = [n.readNumber() === 1, n.readBigNumber(), n.readAddress()];
      return {
        inited: i,
        mintHash: l,
        bridge: a,
      };
    }
  };
Be(ac, "MintRecord");
Ge(ac, "Ops", {
  INIT: BigInt(392720184),
});
Ge(ac, "Errors", {
  ALREADY_INITED: 2001,
  BAD_SENDER: 2002,
});
var Pk = ac,
  ym = class Ni {
    constructor(e, n) {
      Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
    }
    static createFromAddress(e) {
      return new Ni(e);
    }
    static async createFromConfig(e, n, i = 0) {
      const l = await Ni.buildDataCellFromCfg(e),
        a = {
          code: n,
          data: l,
        };
      return new Ni(_t.contractAddress(i, a), a);
    }
    static async buildDataCellFromCfg(e) {
      return _t
        .beginCell()
        .storeAddress(e.adminAddr)
        .storeAddress(e.srcJAddr)
        .storeAddress(e.dstJAddr)
        .storeRef(e.srcJwCode)
        .storeRef(e.dstJwCode)
        .endCell();
    }
    static buildSwapPayload() {
      return _t.beginCell().storeUint(Ni.OpCodes.SWAP, 32).endCell();
    }
    static async buildChangeDataPayload({ queryId: e = 0, data: n }) {
      return _t
        .beginCell()
        .storeUint(Ni.OpCodes.CHANGE_DATA, 32)
        .storeUint(e, 64)
        .storeRef(await Ni.buildDataCellFromCfg(n))
        .endCell();
    }
    static async buildUpgradePayload({ queryId: e = 0, code: n, data: i }) {
      const l = _t.beginCell().storeUint(Ni.OpCodes.UPGRADE, 32).storeUint(e, 64).storeRef(n);
      return i && l.storeRef(i), l.endCell();
    }
    async sendMsg(e, n, i) {
      return await e.internal(n, {
        value: i.value,
        body: i.body,
      });
    }
    async sendDeploy(e, n, i) {
      await e.internal(n, {
        value: i,
        sendMode: _t.SendMode.PAY_GAS_SEPARATELY,
        body: _t.beginCell().endCell(),
      });
    }
    async getStoredData(e) {
      const { stack: n } = await e.get("get_stored_data", []),
        [i, l, a, c, v] = [
          n.readAddress(),
          n.readAddress(),
          n.readAddress(),
          n.readCell(),
          n.readCell(),
        ];
      return {
        adminAddr: i,
        srcJAddr: l,
        dstJAddr: a,
        srcJwCode: c,
        dstJwCode: v,
      };
    }
  };
Be(ym, "Sdlp");
Ge(ym, "OpCodes", {
  SWAP: BigInt(3097994780),
  UPGRADE: BigInt(1951534160),
  CHANGE_DATA: BigInt(3643300756),
});
Ge(ym, "Errors", {
  BAD_SENDER_JW: 1001,
  BAD_SENDER_ADMIN: 1002,
});
var M2;
(function (t) {
  (t[(t.STOPPED = 0)] = "STOPPED"), (t[(t.RUNNING = 1)] = "RUNNING");
})(M2 || (M2 = {}));
var Ks = class hi {
  constructor(e, n) {
    Ge(this, "address"), Ge(this, "init"), (this.address = e), (this.init = n);
  }
  static createFromAddress(e) {
    return new hi(e);
  }
  static async createFromCfg(e, n, i = 0) {
    const l = await hi.buildDataCellFromCfg(e),
      a = {
        code: n,
        data: l,
      };
    return new hi(_t.contractAddress(i, a), a);
  }
  static async buildDataCellFromCfg(e) {
    return _t
      .beginCell()
      .storeUint(e.state, 4)
      .storeUint(e.validatorPubkey, 256)
      .storeUint(e.masterBridge, 160)
      .storeAddress(e.admin)
      .storeAddress(e.jAddr)
      .storeRef(e.jwCode)
      .storeRef(e.mintRecordCode)
      .endCell();
  }
  static buildBurnPayload({ receiver: e }) {
    return _t.beginCell().storeUint(hi.Ops.BURN, 32).storeUint(e, 256).endCell();
  }
  static buildBodyMint({ queryId: e = 0, mintSig: n, mint: i }) {
    return _t
      .beginCell()
      .storeUint(hi.Ops.MINT, 32)
      .storeUint(e, 64)
      .storeBuffer(n, 64)
      .storeRef(
        _t
          .beginCell()
          .storeUint(i.id, 128)
          .storeUint(i.masterBridge, 160)
          .storeUint(i.time, 64)
          .storeUint(i.sender, 160)
          .storeCoins(i.amount)
          .storeAddress(i.receiver)
          .endCell()
      )
      .endCell();
  }
  static async buildUpgradePayload({ queryId: e = 0, code: n, data: i }) {
    const l = _t.beginCell().storeUint(hi.Ops.UPGRADE, 32).storeUint(e, 64).storeRef(n);
    return i && l.storeRef(i), l.endCell();
  }
  static async buildChangeDataPayload({ queryId: e = 0, data: n }) {
    return _t
      .beginCell()
      .storeUint(hi.Ops.CHANGE_DATA, 32)
      .storeUint(e, 64)
      .storeRef(await hi.buildDataCellFromCfg(n))
      .endCell();
  }
  async sendMsg(e, n, i) {
    return await e.internal(n, {
      value: i.value,
      body: i.body,
    });
  }
  async sendDeploy(e, n, i) {
    await e.internal(n, {
      value: i,
      sendMode: _t.SendMode.PAY_GAS_SEPARATELY,
      body: _t.beginCell().endCell(),
    });
  }
  async getStoredData(e) {
    const { stack: n } = await e.get("get_stored_data", []),
      [i, l, a, c, v, g, b] = [
        n.readNumber(),
        n.readBigNumber(),
        n.readBigNumber(),
        n.readAddress(),
        n.readAddress(),
        n.readCell(),
        n.readCell(),
      ];
    return {
      state: i,
      validatorPubkey: l,
      masterBridge: a,
      admin: c,
      jAddr: v,
      jwCode: g,
      mintRecordCode: b,
    };
  }
  async getMintHash(e, n) {
    const { stack: i } = await e.get("get_mint_hash", [
        {
          type: "slice",
          cell: _t.beginCell().storeSlice(n[0]).endCell(),
        },
      ]),
      [l] = [i.readBigNumber()];
    return l;
  }
  async getMintRecord(e, n) {
    const { stack: i } = await e.get("get_mint_record", [
        {
          type: "int",
          value: n[0],
        },
      ]),
      [l] = [i.readAddress()];
    return Pk.createFromAddress(l);
  }
};
Be(Ks, "SlaveBridge");
Ge(Ks, "Ops", {
  MINT: BigInt(945679012),
  BURN: BigInt(1847002305),
  CHANGE_DATA: BigInt(3286364478),
  UPGRADE: BigInt(3182705805),
});
Ge(Ks, "Logs", {
  MINT: BigInt(613941062),
  BURN: BigInt(1927090467),
});
Ge(Ks, "Errors", {
  BAD_SENDER_JW: 1001,
  BAD_SENDER_MINT_RECORD: 1002,
  BAD_SIGNATURE: 1003,
  BAD_MASTER_BRIDGE: 1004,
  BAD_MSG_VALUE: 1005,
  BAD_SENDER_ADMIN: 1006,
  STOPPED: 1007,
});
Ge(
  Ks,
  "buildMint",
  /* @__PURE__ */ Be(
    async ({
      slaveBridge: t,
      validatorSecret: e,
      mint: { id: n, masterBridge: i, time: l, sender: a, amount: c, receiver: v },
    }) => {
      const g = Ks.buildBodyMint({
          mintSig: Qe.alloc(64),
          mint: {
            id: n,
            masterBridge: i,
            time: l,
            sender: a,
            amount: c,
            receiver: v,
          },
        })
          .beginParse()
          .loadRef()
          .beginParse(),
        b = await t.getMintHash([g]);
      return {
        mintSig: await hA.sign(Qe.from(b.toString(16), "hex"), e),
        mintSlice: g,
        mintHash: b,
        mint: {
          id: n,
          masterBridge: i,
          time: l,
          sender: a,
          amount: c,
          receiver: v,
        },
      };
    },
    "buildMint"
  )
);
/*! Bundled license information:

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/
var Ir = {},
  Lf = {},
  sc = {};
Object.defineProperty(sc, "__esModule", { value: !0 });
sc.InMemoryCache = void 0;
class Rk {
  constructor() {
    (this.cache = /* @__PURE__ */ new Map()),
      (this.set = async (e, n, i) => {
        i !== null ? this.cache.set(e + "$$" + n, i) : this.cache.delete(e + "$$" + n);
      }),
      (this.get = async (e, n) => {
        let i = this.cache.get(e + "$$" + n);
        return i !== void 0 ? i : null;
      });
  }
}
sc.InMemoryCache = Rk;
var Ik = /* @__PURE__ */ (function () {
    function t(n, i) {
      if (typeof n != "function")
        throw new TypeError(
          "DataLoader must be constructed with a function which accepts " +
            ("Array<key> and returns Promise<Array<value>>, but got: " + n + ".")
        );
      (this._batchLoadFn = n),
        (this._maxBatchSize = Dk(i)),
        (this._batchScheduleFn = Lk(i)),
        (this._cacheKeyFn = Fk(i)),
        (this._cacheMap = qk(i)),
        (this._batch = null),
        (this.name = zk(i));
    }
    var e = t.prototype;
    return (
      (e.load = function (i) {
        if (i == null)
          throw new TypeError(
            "The loader.load() function must be called with a value, " +
              ("but got: " + String(i) + ".")
          );
        var l = Uk(this),
          a = this._cacheMap,
          c = this._cacheKeyFn(i);
        if (a) {
          var v = a.get(c);
          if (v) {
            var g = l.cacheHits || (l.cacheHits = []);
            return new Promise(function (p) {
              g.push(function () {
                p(v);
              });
            });
          }
        }
        l.keys.push(i);
        var b = new Promise(function (p, _) {
          l.callbacks.push({
            resolve: p,
            reject: _,
          });
        });
        return a && a.set(c, b), b;
      }),
      (e.loadMany = function (i) {
        if (!Y4(i))
          throw new TypeError(
            "The loader.loadMany() function must be called with Array<key> " +
              ("but got: " + i + ".")
          );
        for (var l = [], a = 0; a < i.length; a++)
          l.push(
            this.load(i[a]).catch(function (c) {
              return c;
            })
          );
        return Promise.all(l);
      }),
      (e.clear = function (i) {
        var l = this._cacheMap;
        if (l) {
          var a = this._cacheKeyFn(i);
          l.delete(a);
        }
        return this;
      }),
      (e.clearAll = function () {
        var i = this._cacheMap;
        return i && i.clear(), this;
      }),
      (e.prime = function (i, l) {
        var a = this._cacheMap;
        if (a) {
          var c = this._cacheKeyFn(i);
          if (a.get(c) === void 0) {
            var v;
            l instanceof Error
              ? ((v = Promise.reject(l)), v.catch(function () {}))
              : (v = Promise.resolve(l)),
              a.set(c, v);
          }
        }
        return this;
      }),
      t
    );
  })(),
  Ok =
    typeof Et == "object" && typeof Et.nextTick == "function"
      ? function (t) {
          j0 || (j0 = Promise.resolve()),
            j0.then(function () {
              Et.nextTick(t);
            });
        }
      : typeof setImmediate == "function"
      ? function (t) {
          setImmediate(t);
        }
      : function (t) {
          setTimeout(t);
        },
  j0;
function Uk(t) {
  var e = t._batch;
  if (e !== null && !e.hasDispatched && e.keys.length < t._maxBatchSize) return e;
  var n = {
    hasDispatched: !1,
    keys: [],
    callbacks: [],
  };
  return (
    (t._batch = n),
    t._batchScheduleFn(function () {
      Nk(t, n);
    }),
    n
  );
}
function Nk(t, e) {
  if (((e.hasDispatched = !0), e.keys.length === 0)) {
    Np(e);
    return;
  }
  var n;
  try {
    n = t._batchLoadFn(e.keys);
  } catch (i) {
    return $0(
      t,
      e,
      new TypeError(
        "DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " +
          ("errored synchronously: " + String(i) + ".")
      )
    );
  }
  if (!n || typeof n.then != "function")
    return $0(
      t,
      e,
      new TypeError(
        "DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " +
          ("not return a Promise: " + String(n) + ".")
      )
    );
  n.then(function (i) {
    if (!Y4(i))
      throw new TypeError(
        "DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " +
          ("not return a Promise of an Array: " + String(i) + ".")
      );
    if (i.length !== e.keys.length)
      throw new TypeError(
        "DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." +
          (`

Keys:
` +
            String(e.keys)) +
          (`

Values:
` +
            String(i))
      );
    Np(e);
    for (var l = 0; l < e.callbacks.length; l++) {
      var a = i[l];
      a instanceof Error ? e.callbacks[l].reject(a) : e.callbacks[l].resolve(a);
    }
  }).catch(function (i) {
    $0(t, e, i);
  });
}
function $0(t, e, n) {
  Np(e);
  for (var i = 0; i < e.keys.length; i++) t.clear(e.keys[i]), e.callbacks[i].reject(n);
}
function Np(t) {
  if (t.cacheHits) for (var e = 0; e < t.cacheHits.length; e++) t.cacheHits[e]();
}
function Dk(t) {
  var e = !t || t.batch !== !1;
  if (!e) return 1;
  var n = t && t.maxBatchSize;
  if (n === void 0) return 1 / 0;
  if (typeof n != "number" || n < 1)
    throw new TypeError("maxBatchSize must be a positive number: " + n);
  return n;
}
function Lk(t) {
  var e = t && t.batchScheduleFn;
  if (e === void 0) return Ok;
  if (typeof e != "function") throw new TypeError("batchScheduleFn must be a function: " + e);
  return e;
}
function Fk(t) {
  var e = t && t.cacheKeyFn;
  if (e === void 0)
    return function (n) {
      return n;
    };
  if (typeof e != "function") throw new TypeError("cacheKeyFn must be a function: " + e);
  return e;
}
function qk(t) {
  var e = !t || t.cache !== !1;
  if (!e) return null;
  var n = t && t.cacheMap;
  if (n === void 0) return /* @__PURE__ */ new Map();
  if (n !== null) {
    var i = ["get", "set", "delete", "clear"],
      l = i.filter(function (a) {
        return n && typeof n[a] != "function";
      });
    if (l.length !== 0) throw new TypeError("Custom cacheMap missing methods: " + l.join(", "));
  }
  return n;
}
function zk(t) {
  return t && t.name ? t.name : null;
}
function Y4(t) {
  return (
    typeof t == "object" &&
    t !== null &&
    typeof t.length == "number" &&
    (t.length === 0 || (t.length > 0 && Object.prototype.hasOwnProperty.call(t, t.length - 1)))
  );
}
var jk = Ik;
function J4(t, e) {
  return function () {
    return t.apply(e, arguments);
  };
}
const { toString: $k } = Object.prototype,
  { getPrototypeOf: bm } = Object,
  oc = /* @__PURE__ */ ((t) => (e) => {
    const n = $k.call(e);
    return t[n] || (t[n] = n.slice(8, -1).toLowerCase());
  })(/* @__PURE__ */ Object.create(null)),
  si = (t) => ((t = t.toLowerCase()), (e) => oc(e) === t),
  fc = (t) => (e) => typeof e === t,
  { isArray: uo } = Array,
  af = fc("undefined");
function Hk(t) {
  return (
    t !== null &&
    !af(t) &&
    t.constructor !== null &&
    !af(t.constructor) &&
    Sn(t.constructor.isBuffer) &&
    t.constructor.isBuffer(t)
  );
}
const Q4 = si("ArrayBuffer");
function Vk(t) {
  let e;
  return (
    typeof ArrayBuffer < "u" && ArrayBuffer.isView
      ? (e = ArrayBuffer.isView(t))
      : (e = t && t.buffer && Q4(t.buffer)),
    e
  );
}
const Wk = fc("string"),
  Sn = fc("function"),
  X4 = fc("number"),
  lc = (t) => t !== null && typeof t == "object",
  Kk = (t) => t === !0 || t === !1,
  $l = (t) => {
    if (oc(t) !== "object") return !1;
    const e = bm(t);
    return (
      (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) &&
      !(Symbol.toStringTag in t) &&
      !(Symbol.iterator in t)
    );
  },
  Zk = si("Date"),
  Gk = si("File"),
  Yk = si("Blob"),
  Jk = si("FileList"),
  Qk = (t) => lc(t) && Sn(t.pipe),
  Xk = (t) => {
    let e;
    return (
      t &&
      ((typeof FormData == "function" && t instanceof FormData) ||
        (Sn(t.append) &&
          ((e = oc(t)) === "formdata" || // detect form-data instance
            (e === "object" && Sn(t.toString) && t.toString() === "[object FormData]"))))
    );
  },
  eB = si("URLSearchParams"),
  tB = (t) => (t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""));
function Ff(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t === null || typeof t > "u") return;
  let i, l;
  if ((typeof t != "object" && (t = [t]), uo(t)))
    for (i = 0, l = t.length; i < l; i++) e.call(null, t[i], i, t);
  else {
    const a = n ? Object.getOwnPropertyNames(t) : Object.keys(t),
      c = a.length;
    let v;
    for (i = 0; i < c; i++) (v = a[i]), e.call(null, t[v], v, t);
  }
}
function e8(t, e) {
  e = e.toLowerCase();
  const n = Object.keys(t);
  let i = n.length,
    l;
  for (; i-- > 0; ) if (((l = n[i]), e === l.toLowerCase())) return l;
  return null;
}
const t8 =
    typeof globalThis < "u"
      ? globalThis
      : typeof self < "u"
      ? self
      : typeof window < "u"
      ? window
      : mt,
  r8 = (t) => !af(t) && t !== t8;
function Dp() {
  const { caseless: t } = (r8(this) && this) || {},
    e = {},
    n = (i, l) => {
      const a = (t && e8(e, l)) || l;
      $l(e[a]) && $l(i)
        ? (e[a] = Dp(e[a], i))
        : $l(i)
        ? (e[a] = Dp({}, i))
        : uo(i)
        ? (e[a] = i.slice())
        : (e[a] = i);
    };
  for (let i = 0, l = arguments.length; i < l; i++) arguments[i] && Ff(arguments[i], n);
  return e;
}
const rB = (t, e, n, { allOwnKeys: i } = {}) => (
    Ff(
      e,
      (l, a) => {
        n && Sn(l) ? (t[a] = J4(l, n)) : (t[a] = l);
      },
      { allOwnKeys: i }
    ),
    t
  ),
  nB = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t),
  iB = (t, e, n, i) => {
    (t.prototype = Object.create(e.prototype, i)),
      (t.prototype.constructor = t),
      Object.defineProperty(t, "super", {
        value: e.prototype,
      }),
      n && Object.assign(t.prototype, n);
  },
  aB = (t, e, n, i) => {
    let l, a, c;
    const v = {};
    if (((e = e || {}), t == null)) return e;
    do {
      for (l = Object.getOwnPropertyNames(t), a = l.length; a-- > 0; )
        (c = l[a]), (!i || i(c, t, e)) && !v[c] && ((e[c] = t[c]), (v[c] = !0));
      t = n !== !1 && bm(t);
    } while (t && (!n || n(t, e)) && t !== Object.prototype);
    return e;
  },
  sB = (t, e, n) => {
    (t = String(t)), (n === void 0 || n > t.length) && (n = t.length), (n -= e.length);
    const i = t.indexOf(e, n);
    return i !== -1 && i === n;
  },
  oB = (t) => {
    if (!t) return null;
    if (uo(t)) return t;
    let e = t.length;
    if (!X4(e)) return null;
    const n = new Array(e);
    for (; e-- > 0; ) n[e] = t[e];
    return n;
  },
  fB = /* @__PURE__ */ (
    (t) => (e) =>
      t && e instanceof t
  )(typeof Uint8Array < "u" && bm(Uint8Array)),
  lB = (t, e) => {
    const i = (t && t[Symbol.iterator]).call(t);
    let l;
    for (; (l = i.next()) && !l.done; ) {
      const a = l.value;
      e.call(t, a[0], a[1]);
    }
  },
  uB = (t, e) => {
    let n;
    const i = [];
    for (; (n = t.exec(e)) !== null; ) i.push(n);
    return i;
  },
  cB = si("HTMLFormElement"),
  hB = (t) =>
    t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function (n, i, l) {
      return i.toUpperCase() + l;
    }),
  S2 = (
    ({ hasOwnProperty: t }) =>
    (e, n) =>
      t.call(e, n)
  )(Object.prototype),
  dB = si("RegExp"),
  n8 = (t, e) => {
    const n = Object.getOwnPropertyDescriptors(t),
      i = {};
    Ff(n, (l, a) => {
      let c;
      (c = e(l, a, t)) !== !1 && (i[a] = c || l);
    }),
      Object.defineProperties(t, i);
  },
  pB = (t) => {
    n8(t, (e, n) => {
      if (Sn(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
      const i = t[n];
      if (Sn(i)) {
        if (((e.enumerable = !1), "writable" in e)) {
          e.writable = !1;
          return;
        }
        e.set ||
          (e.set = () => {
            throw Error("Can not rewrite read-only method '" + n + "'");
          });
      }
    });
  },
  mB = (t, e) => {
    const n = {},
      i = (l) => {
        l.forEach((a) => {
          n[a] = !0;
        });
      };
    return uo(t) ? i(t) : i(String(t).split(e)), n;
  },
  vB = () => {},
  gB = (t, e) => ((t = +t), Number.isFinite(t) ? t : e),
  H0 = "abcdefghijklmnopqrstuvwxyz",
  E2 = "0123456789",
  i8 = {
    DIGIT: E2,
    ALPHA: H0,
    ALPHA_DIGIT: H0 + H0.toUpperCase() + E2,
  },
  yB = (t = 16, e = i8.ALPHA_DIGIT) => {
    let n = "";
    const { length: i } = e;
    for (; t--; ) n += e[(Math.random() * i) | 0];
    return n;
  };
function bB(t) {
  return !!(t && Sn(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const wB = (t) => {
    const e = new Array(10),
      n = (i, l) => {
        if (lc(i)) {
          if (e.indexOf(i) >= 0) return;
          if (!("toJSON" in i)) {
            e[l] = i;
            const a = uo(i) ? [] : {};
            return (
              Ff(i, (c, v) => {
                const g = n(c, l + 1);
                !af(g) && (a[v] = g);
              }),
              (e[l] = void 0),
              a
            );
          }
        }
        return i;
      };
    return n(t, 0);
  },
  _B = si("AsyncFunction"),
  xB = (t) => t && (lc(t) || Sn(t)) && Sn(t.then) && Sn(t.catch);
var it = {
  isArray: uo,
  isArrayBuffer: Q4,
  isBuffer: Hk,
  isFormData: Xk,
  isArrayBufferView: Vk,
  isString: Wk,
  isNumber: X4,
  isBoolean: Kk,
  isObject: lc,
  isPlainObject: $l,
  isUndefined: af,
  isDate: Zk,
  isFile: Gk,
  isBlob: Yk,
  isRegExp: dB,
  isFunction: Sn,
  isStream: Qk,
  isURLSearchParams: eB,
  isTypedArray: fB,
  isFileList: Jk,
  forEach: Ff,
  merge: Dp,
  extend: rB,
  trim: tB,
  stripBOM: nB,
  inherits: iB,
  toFlatObject: aB,
  kindOf: oc,
  kindOfTest: si,
  endsWith: sB,
  toArray: oB,
  forEachEntry: lB,
  matchAll: uB,
  isHTMLForm: cB,
  hasOwnProperty: S2,
  hasOwnProp: S2,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: n8,
  freezeMethods: pB,
  toObjectSet: mB,
  toCamelCase: hB,
  noop: vB,
  toFiniteNumber: gB,
  findKey: e8,
  global: t8,
  isContextDefined: r8,
  ALPHABET: i8,
  generateString: yB,
  isSpecCompliantForm: bB,
  toJSONObject: wB,
  isAsyncFn: _B,
  isThenable: xB,
};
function Wt(t, e, n, i, l) {
  Error.call(this),
    Error.captureStackTrace
      ? Error.captureStackTrace(this, this.constructor)
      : (this.stack = new Error().stack),
    (this.message = t),
    (this.name = "AxiosError"),
    e && (this.code = e),
    n && (this.config = n),
    i && (this.request = i),
    l && (this.response = l);
}
it.inherits(Wt, Error, {
  toJSON: function () {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: it.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null,
    };
  },
});
const a8 = Wt.prototype,
  s8 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL",
  // eslint-disable-next-line func-names
].forEach((t) => {
  s8[t] = { value: t };
});
Object.defineProperties(Wt, s8);
Object.defineProperty(a8, "isAxiosError", { value: !0 });
Wt.from = (t, e, n, i, l, a) => {
  const c = Object.create(a8);
  return (
    it.toFlatObject(
      t,
      c,
      function (g) {
        return g !== Error.prototype;
      },
      (v) => v !== "isAxiosError"
    ),
    Wt.call(c, t.message, e, n, i, l),
    (c.cause = t),
    (c.name = t.name),
    a && Object.assign(c, a),
    c
  );
};
var MB = null;
function Lp(t) {
  return it.isPlainObject(t) || it.isArray(t);
}
function o8(t) {
  return it.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function A2(t, e, n) {
  return t
    ? t
        .concat(e)
        .map(function (l, a) {
          return (l = o8(l)), !n && a ? "[" + l + "]" : l;
        })
        .join(n ? "." : "")
    : e;
}
function SB(t) {
  return it.isArray(t) && !t.some(Lp);
}
const EB = it.toFlatObject(it, {}, null, function (e) {
  return /^is[A-Z]/.test(e);
});
function uc(t, e, n) {
  if (!it.isObject(t)) throw new TypeError("target must be an object");
  (e = e || new FormData()),
    (n = it.toFlatObject(
      n,
      {
        metaTokens: !0,
        dots: !1,
        indexes: !1,
      },
      !1,
      function (k, P) {
        return !it.isUndefined(P[k]);
      }
    ));
  const i = n.metaTokens,
    l = n.visitor || p,
    a = n.dots,
    c = n.indexes,
    g = (n.Blob || (typeof Blob < "u" && Blob)) && it.isSpecCompliantForm(e);
  if (!it.isFunction(l)) throw new TypeError("visitor must be a function");
  function b(A) {
    if (A === null) return "";
    if (it.isDate(A)) return A.toISOString();
    if (!g && it.isBlob(A)) throw new Wt("Blob is not supported. Use a Buffer instead.");
    return it.isArrayBuffer(A) || it.isTypedArray(A)
      ? g && typeof Blob == "function"
        ? new Blob([A])
        : Qe.from(A)
      : A;
  }
  function p(A, k, P) {
    let B = A;
    if (A && !P && typeof A == "object") {
      if (it.endsWith(k, "{}")) (k = i ? k : k.slice(0, -2)), (A = JSON.stringify(A));
      else if (
        (it.isArray(A) && SB(A)) ||
        ((it.isFileList(A) || it.endsWith(k, "[]")) && (B = it.toArray(A)))
      )
        return (
          (k = o8(k)),
          B.forEach(function (F, O) {
            !(it.isUndefined(F) || F === null) &&
              e.append(
                // eslint-disable-next-line no-nested-ternary
                c === !0 ? A2([k], O, a) : c === null ? k : k + "[]",
                b(F)
              );
          }),
          !1
        );
    }
    return Lp(A) ? !0 : (e.append(A2(P, k, a), b(A)), !1);
  }
  const _ = [],
    M = Object.assign(EB, {
      defaultVisitor: p,
      convertValue: b,
      isVisitable: Lp,
    });
  function S(A, k) {
    if (!it.isUndefined(A)) {
      if (_.indexOf(A) !== -1) throw Error("Circular reference detected in " + k.join("."));
      _.push(A),
        it.forEach(A, function (B, T) {
          (!(it.isUndefined(B) || B === null) &&
            l.call(e, B, it.isString(T) ? T.trim() : T, k, M)) === !0 &&
            S(B, k ? k.concat(T) : [T]);
        }),
        _.pop();
    }
  }
  if (!it.isObject(t)) throw new TypeError("data must be an object");
  return S(t), e;
}
function k2(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0",
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function (i) {
    return e[i];
  });
}
function wm(t, e) {
  (this._pairs = []), t && uc(t, this, e);
}
const f8 = wm.prototype;
f8.append = function (e, n) {
  this._pairs.push([e, n]);
};
f8.toString = function (e) {
  const n = e
    ? function (i) {
        return e.call(this, i, k2);
      }
    : k2;
  return this._pairs
    .map(function (l) {
      return n(l[0]) + "=" + n(l[1]);
    }, "")
    .join("&");
};
function AB(t) {
  return encodeURIComponent(t)
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");
}
function l8(t, e, n) {
  if (!e) return t;
  const i = (n && n.encode) || AB,
    l = n && n.serialize;
  let a;
  if (
    (l ? (a = l(e, n)) : (a = it.isURLSearchParams(e) ? e.toString() : new wm(e, n).toString(i)), a)
  ) {
    const c = t.indexOf("#");
    c !== -1 && (t = t.slice(0, c)), (t += (t.indexOf("?") === -1 ? "?" : "&") + a);
  }
  return t;
}
class kB {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, n, i) {
    return (
      this.handlers.push({
        fulfilled: e,
        rejected: n,
        synchronous: i ? i.synchronous : !1,
        runWhen: i ? i.runWhen : null,
      }),
      this.handlers.length - 1
    );
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    it.forEach(this.handlers, function (i) {
      i !== null && e(i);
    });
  }
}
var B2 = kB,
  u8 = {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1,
  },
  BB = typeof URLSearchParams < "u" ? URLSearchParams : wm,
  CB = typeof FormData < "u" ? FormData : null,
  TB = typeof Blob < "u" ? Blob : null,
  PB = {
    isBrowser: !0,
    classes: {
      URLSearchParams: BB,
      FormData: CB,
      Blob: TB,
    },
    protocols: ["http", "https", "file", "blob", "url", "data"],
  };
const c8 = typeof window < "u" && typeof document < "u",
  RB = ((t) => c8 && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(
    typeof navigator < "u" && navigator.product
  ),
  IB =
    typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts == "function";
var OB = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    hasBrowserEnv: c8,
    hasStandardBrowserWebWorkerEnv: IB,
    hasStandardBrowserEnv: RB,
  }),
  Kn = {
    ...OB,
    ...PB,
  };
function UB(t, e) {
  return uc(
    t,
    new Kn.classes.URLSearchParams(),
    Object.assign(
      {
        visitor: function (n, i, l, a) {
          return Kn.isNode && it.isBuffer(n)
            ? (this.append(i, n.toString("base64")), !1)
            : a.defaultVisitor.apply(this, arguments);
        },
      },
      e
    )
  );
}
function NB(t) {
  return it.matchAll(/\w+|\[(\w*)]/g, t).map((e) => (e[0] === "[]" ? "" : e[1] || e[0]));
}
function DB(t) {
  const e = {},
    n = Object.keys(t);
  let i;
  const l = n.length;
  let a;
  for (i = 0; i < l; i++) (a = n[i]), (e[a] = t[a]);
  return e;
}
function h8(t) {
  function e(n, i, l, a) {
    let c = n[a++];
    if (c === "__proto__") return !0;
    const v = Number.isFinite(+c),
      g = a >= n.length;
    return (
      (c = !c && it.isArray(l) ? l.length : c),
      g
        ? (it.hasOwnProp(l, c) ? (l[c] = [l[c], i]) : (l[c] = i), !v)
        : ((!l[c] || !it.isObject(l[c])) && (l[c] = []),
          e(n, i, l[c], a) && it.isArray(l[c]) && (l[c] = DB(l[c])),
          !v)
    );
  }
  if (it.isFormData(t) && it.isFunction(t.entries)) {
    const n = {};
    return (
      it.forEachEntry(t, (i, l) => {
        e(NB(i), l, n, 0);
      }),
      n
    );
  }
  return null;
}
function LB(t, e, n) {
  if (it.isString(t))
    try {
      return (e || JSON.parse)(t), it.trim(t);
    } catch (i) {
      if (i.name !== "SyntaxError") throw i;
    }
  return (n || JSON.stringify)(t);
}
const _m = {
  transitional: u8,
  adapter: ["xhr", "http"],
  transformRequest: [
    function (e, n) {
      const i = n.getContentType() || "",
        l = i.indexOf("application/json") > -1,
        a = it.isObject(e);
      if ((a && it.isHTMLForm(e) && (e = new FormData(e)), it.isFormData(e)))
        return l ? JSON.stringify(h8(e)) : e;
      if (it.isArrayBuffer(e) || it.isBuffer(e) || it.isStream(e) || it.isFile(e) || it.isBlob(e))
        return e;
      if (it.isArrayBufferView(e)) return e.buffer;
      if (it.isURLSearchParams(e))
        return (
          n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString()
        );
      let v;
      if (a) {
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return UB(e, this.formSerializer).toString();
        if ((v = it.isFileList(e)) || i.indexOf("multipart/form-data") > -1) {
          const g = this.env && this.env.FormData;
          return uc(v ? { "files[]": e } : e, g && new g(), this.formSerializer);
        }
      }
      return a || l ? (n.setContentType("application/json", !1), LB(e)) : e;
    },
  ],
  transformResponse: [
    function (e) {
      const n = this.transitional || _m.transitional,
        i = n && n.forcedJSONParsing,
        l = this.responseType === "json";
      if (e && it.isString(e) && ((i && !this.responseType) || l)) {
        const c = !(n && n.silentJSONParsing) && l;
        try {
          return JSON.parse(e);
        } catch (v) {
          if (c)
            throw v.name === "SyntaxError"
              ? Wt.from(v, Wt.ERR_BAD_RESPONSE, this, null, this.response)
              : v;
        }
      }
      return e;
    },
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Kn.classes.FormData,
    Blob: Kn.classes.Blob,
  },
  validateStatus: function (e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0,
    },
  },
};
it.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  _m.headers[t] = {};
});
var xm = _m;
const FB = it.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent",
]);
var qB = (t) => {
  const e = {};
  let n, i, l;
  return (
    t &&
      t
        .split(
          `
`
        )
        .forEach(function (c) {
          (l = c.indexOf(":")),
            (n = c.substring(0, l).trim().toLowerCase()),
            (i = c.substring(l + 1).trim()),
            !(!n || (e[n] && FB[n])) &&
              (n === "set-cookie"
                ? e[n]
                  ? e[n].push(i)
                  : (e[n] = [i])
                : (e[n] = e[n] ? e[n] + ", " + i : i));
        }),
    e
  );
};
const C2 = Symbol("internals");
function Ao(t) {
  return t && String(t).trim().toLowerCase();
}
function Hl(t) {
  return t === !1 || t == null ? t : it.isArray(t) ? t.map(Hl) : String(t);
}
function zB(t) {
  const e = /* @__PURE__ */ Object.create(null),
    n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; (i = n.exec(t)); ) e[i[1]] = i[2];
  return e;
}
const jB = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function V0(t, e, n, i, l) {
  if (it.isFunction(i)) return i.call(this, e, n);
  if ((l && (e = n), !!it.isString(e))) {
    if (it.isString(i)) return e.indexOf(i) !== -1;
    if (it.isRegExp(i)) return i.test(e);
  }
}
function $B(t) {
  return t
    .trim()
    .toLowerCase()
    .replace(/([a-z\d])(\w*)/g, (e, n, i) => n.toUpperCase() + i);
}
function HB(t, e) {
  const n = it.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(t, i + n, {
      value: function (l, a, c) {
        return this[i].call(this, e, l, a, c);
      },
      configurable: !0,
    });
  });
}
class cc {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, i) {
    const l = this;
    function a(v, g, b) {
      const p = Ao(g);
      if (!p) throw new Error("header name must be a non-empty string");
      const _ = it.findKey(l, p);
      (!_ || l[_] === void 0 || b === !0 || (b === void 0 && l[_] !== !1)) && (l[_ || g] = Hl(v));
    }
    const c = (v, g) => it.forEach(v, (b, p) => a(b, p, g));
    return (
      it.isPlainObject(e) || e instanceof this.constructor
        ? c(e, n)
        : it.isString(e) && (e = e.trim()) && !jB(e)
        ? c(qB(e), n)
        : e != null && a(n, e, i),
      this
    );
  }
  get(e, n) {
    if (((e = Ao(e)), e)) {
      const i = it.findKey(this, e);
      if (i) {
        const l = this[i];
        if (!n) return l;
        if (n === !0) return zB(l);
        if (it.isFunction(n)) return n.call(this, l, i);
        if (it.isRegExp(n)) return n.exec(l);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (((e = Ao(e)), e)) {
      const i = it.findKey(this, e);
      return !!(i && this[i] !== void 0 && (!n || V0(this, this[i], i, n)));
    }
    return !1;
  }
  delete(e, n) {
    const i = this;
    let l = !1;
    function a(c) {
      if (((c = Ao(c)), c)) {
        const v = it.findKey(i, c);
        v && (!n || V0(i, i[v], v, n)) && (delete i[v], (l = !0));
      }
    }
    return it.isArray(e) ? e.forEach(a) : a(e), l;
  }
  clear(e) {
    const n = Object.keys(this);
    let i = n.length,
      l = !1;
    for (; i--; ) {
      const a = n[i];
      (!e || V0(this, this[a], a, e, !0)) && (delete this[a], (l = !0));
    }
    return l;
  }
  normalize(e) {
    const n = this,
      i = {};
    return (
      it.forEach(this, (l, a) => {
        const c = it.findKey(i, a);
        if (c) {
          (n[c] = Hl(l)), delete n[a];
          return;
        }
        const v = e ? $B(a) : String(a).trim();
        v !== a && delete n[a], (n[v] = Hl(l)), (i[v] = !0);
      }),
      this
    );
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return (
      it.forEach(this, (i, l) => {
        i != null && i !== !1 && (n[l] = e && it.isArray(i) ? i.join(", ") : i);
      }),
      n
    );
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const i = new this(e);
    return n.forEach((l) => i.set(l)), i;
  }
  static accessor(e) {
    const i = (this[C2] = this[C2] =
        {
          accessors: {},
        }).accessors,
      l = this.prototype;
    function a(c) {
      const v = Ao(c);
      i[v] || (HB(l, c), (i[v] = !0));
    }
    return it.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
cc.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization",
]);
it.reduceDescriptors(cc.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(i) {
      this[n] = i;
    },
  };
});
it.freezeMethods(cc);
var Mi = cc;
function W0(t, e) {
  const n = this || xm,
    i = e || n,
    l = Mi.from(i.headers);
  let a = i.data;
  return (
    it.forEach(t, function (v) {
      a = v.call(n, a, l.normalize(), e ? e.status : void 0);
    }),
    l.normalize(),
    a
  );
}
function d8(t) {
  return !!(t && t.__CANCEL__);
}
function qf(t, e, n) {
  Wt.call(this, t ?? "canceled", Wt.ERR_CANCELED, e, n), (this.name = "CanceledError");
}
it.inherits(qf, Wt, {
  __CANCEL__: !0,
});
function VB(t, e, n) {
  const i = n.config.validateStatus;
  !n.status || !i || i(n.status)
    ? t(n)
    : e(
        new Wt(
          "Request failed with status code " + n.status,
          [Wt.ERR_BAD_REQUEST, Wt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
          n.config,
          n.request,
          n
        )
      );
}
var WB = Kn.hasStandardBrowserEnv
  ? // Standard browser envs support document.cookie
    {
      write(t, e, n, i, l, a) {
        const c = [t + "=" + encodeURIComponent(e)];
        it.isNumber(n) && c.push("expires=" + new Date(n).toGMTString()),
          it.isString(i) && c.push("path=" + i),
          it.isString(l) && c.push("domain=" + l),
          a === !0 && c.push("secure"),
          (document.cookie = c.join("; "));
      },
      read(t) {
        const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
        return e ? decodeURIComponent(e[3]) : null;
      },
      remove(t) {
        this.write(t, "", Date.now() - 864e5);
      },
    }
  : // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {},
      read() {
        return null;
      },
      remove() {},
    };
function KB(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function ZB(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function p8(t, e) {
  return t && !KB(e) ? ZB(t, e) : e;
}
var GB = Kn.hasStandardBrowserEnv
  ? // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    (function () {
      const e = /(msie|trident)/i.test(navigator.userAgent),
        n = document.createElement("a");
      let i;
      function l(a) {
        let c = a;
        return (
          e && (n.setAttribute("href", c), (c = n.href)),
          n.setAttribute("href", c),
          {
            href: n.href,
            protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
            host: n.host,
            search: n.search ? n.search.replace(/^\?/, "") : "",
            hash: n.hash ? n.hash.replace(/^#/, "") : "",
            hostname: n.hostname,
            port: n.port,
            pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname,
          }
        );
      }
      return (
        (i = l(window.location.href)),
        function (c) {
          const v = it.isString(c) ? l(c) : c;
          return v.protocol === i.protocol && v.host === i.host;
        }
      );
    })()
  : // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ (function () {
      return function () {
        return !0;
      };
    })();
function YB(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return (e && e[1]) || "";
}
function JB(t, e) {
  t = t || 10;
  const n = new Array(t),
    i = new Array(t);
  let l = 0,
    a = 0,
    c;
  return (
    (e = e !== void 0 ? e : 1e3),
    function (g) {
      const b = Date.now(),
        p = i[a];
      c || (c = b), (n[l] = g), (i[l] = b);
      let _ = a,
        M = 0;
      for (; _ !== l; ) (M += n[_++]), (_ = _ % t);
      if (((l = (l + 1) % t), l === a && (a = (a + 1) % t), b - c < e)) return;
      const S = p && b - p;
      return S ? Math.round((M * 1e3) / S) : void 0;
    }
  );
}
function T2(t, e) {
  let n = 0;
  const i = JB(50, 250);
  return (l) => {
    const a = l.loaded,
      c = l.lengthComputable ? l.total : void 0,
      v = a - n,
      g = i(v),
      b = a <= c;
    n = a;
    const p = {
      loaded: a,
      total: c,
      progress: c ? a / c : void 0,
      bytes: v,
      rate: g || void 0,
      estimated: g && c && b ? (c - a) / g : void 0,
      event: l,
    };
    (p[e ? "download" : "upload"] = !0), t(p);
  };
}
const QB = typeof XMLHttpRequest < "u";
var XB =
  QB &&
  function (t) {
    return new Promise(function (n, i) {
      let l = t.data;
      const a = Mi.from(t.headers).normalize();
      let { responseType: c, withXSRFToken: v } = t,
        g;
      function b() {
        t.cancelToken && t.cancelToken.unsubscribe(g),
          t.signal && t.signal.removeEventListener("abort", g);
      }
      let p;
      if (it.isFormData(l)) {
        if (Kn.hasStandardBrowserEnv || Kn.hasStandardBrowserWebWorkerEnv) a.setContentType(!1);
        else if ((p = a.getContentType()) !== !1) {
          const [k, ...P] = p
            ? p
                .split(";")
                .map((B) => B.trim())
                .filter(Boolean)
            : [];
          a.setContentType([k || "multipart/form-data", ...P].join("; "));
        }
      }
      let _ = new XMLHttpRequest();
      if (t.auth) {
        const k = t.auth.username || "",
          P = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
        a.set("Authorization", "Basic " + btoa(k + ":" + P));
      }
      const M = p8(t.baseURL, t.url);
      _.open(t.method.toUpperCase(), l8(M, t.params, t.paramsSerializer), !0),
        (_.timeout = t.timeout);
      function S() {
        if (!_) return;
        const k = Mi.from("getAllResponseHeaders" in _ && _.getAllResponseHeaders()),
          B = {
            data: !c || c === "text" || c === "json" ? _.responseText : _.response,
            status: _.status,
            statusText: _.statusText,
            headers: k,
            config: t,
            request: _,
          };
        VB(
          function (F) {
            n(F), b();
          },
          function (F) {
            i(F), b();
          },
          B
        ),
          (_ = null);
      }
      if (
        ("onloadend" in _
          ? (_.onloadend = S)
          : (_.onreadystatechange = function () {
              !_ ||
                _.readyState !== 4 ||
                (_.status === 0 && !(_.responseURL && _.responseURL.indexOf("file:") === 0)) ||
                setTimeout(S);
            }),
        (_.onabort = function () {
          _ && (i(new Wt("Request aborted", Wt.ECONNABORTED, t, _)), (_ = null));
        }),
        (_.onerror = function () {
          i(new Wt("Network Error", Wt.ERR_NETWORK, t, _)), (_ = null);
        }),
        (_.ontimeout = function () {
          let P = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
          const B = t.transitional || u8;
          t.timeoutErrorMessage && (P = t.timeoutErrorMessage),
            i(new Wt(P, B.clarifyTimeoutError ? Wt.ETIMEDOUT : Wt.ECONNABORTED, t, _)),
            (_ = null);
        }),
        Kn.hasStandardBrowserEnv && (v && it.isFunction(v) && (v = v(t)), v || (v !== !1 && GB(M))))
      ) {
        const k = t.xsrfHeaderName && t.xsrfCookieName && WB.read(t.xsrfCookieName);
        k && a.set(t.xsrfHeaderName, k);
      }
      l === void 0 && a.setContentType(null),
        "setRequestHeader" in _ &&
          it.forEach(a.toJSON(), function (P, B) {
            _.setRequestHeader(B, P);
          }),
        it.isUndefined(t.withCredentials) || (_.withCredentials = !!t.withCredentials),
        c && c !== "json" && (_.responseType = t.responseType),
        typeof t.onDownloadProgress == "function" &&
          _.addEventListener("progress", T2(t.onDownloadProgress, !0)),
        typeof t.onUploadProgress == "function" &&
          _.upload &&
          _.upload.addEventListener("progress", T2(t.onUploadProgress)),
        (t.cancelToken || t.signal) &&
          ((g = (k) => {
            _ && (i(!k || k.type ? new qf(null, t, _) : k), _.abort(), (_ = null));
          }),
          t.cancelToken && t.cancelToken.subscribe(g),
          t.signal && (t.signal.aborted ? g() : t.signal.addEventListener("abort", g)));
      const A = YB(M);
      if (A && Kn.protocols.indexOf(A) === -1) {
        i(new Wt("Unsupported protocol " + A + ":", Wt.ERR_BAD_REQUEST, t));
        return;
      }
      _.send(l || null);
    });
  };
const Fp = {
  http: MB,
  xhr: XB,
};
it.forEach(Fp, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {}
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const P2 = (t) => `- ${t}`,
  eC = (t) => it.isFunction(t) || t === null || t === !1;
var m8 = {
  getAdapter: (t) => {
    t = it.isArray(t) ? t : [t];
    const { length: e } = t;
    let n, i;
    const l = {};
    for (let a = 0; a < e; a++) {
      n = t[a];
      let c;
      if (((i = n), !eC(n) && ((i = Fp[(c = String(n)).toLowerCase()]), i === void 0)))
        throw new Wt(`Unknown adapter '${c}'`);
      if (i) break;
      l[c || "#" + a] = i;
    }
    if (!i) {
      const a = Object.entries(l).map(
        ([v, g]) =>
          `adapter ${v} ` +
          (g === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let c = e
        ? a.length > 1
          ? `since :
` +
            a.map(P2).join(`
`)
          : " " + P2(a[0])
        : "as no adapter specified";
      throw new Wt("There is no suitable adapter to dispatch the request " + c, "ERR_NOT_SUPPORT");
    }
    return i;
  },
  adapters: Fp,
};
function K0(t) {
  if ((t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted))
    throw new qf(null, t);
}
function R2(t) {
  return (
    K0(t),
    (t.headers = Mi.from(t.headers)),
    (t.data = W0.call(t, t.transformRequest)),
    ["post", "put", "patch"].indexOf(t.method) !== -1 &&
      t.headers.setContentType("application/x-www-form-urlencoded", !1),
    m8
      .getAdapter(t.adapter || xm.adapter)(t)
      .then(
        function (i) {
          return (
            K0(t),
            (i.data = W0.call(t, t.transformResponse, i)),
            (i.headers = Mi.from(i.headers)),
            i
          );
        },
        function (i) {
          return (
            d8(i) ||
              (K0(t),
              i &&
                i.response &&
                ((i.response.data = W0.call(t, t.transformResponse, i.response)),
                (i.response.headers = Mi.from(i.response.headers)))),
            Promise.reject(i)
          );
        }
      )
  );
}
const I2 = (t) => (t instanceof Mi ? { ...t } : t);
function Zs(t, e) {
  e = e || {};
  const n = {};
  function i(b, p, _) {
    return it.isPlainObject(b) && it.isPlainObject(p)
      ? it.merge.call({ caseless: _ }, b, p)
      : it.isPlainObject(p)
      ? it.merge({}, p)
      : it.isArray(p)
      ? p.slice()
      : p;
  }
  function l(b, p, _) {
    if (it.isUndefined(p)) {
      if (!it.isUndefined(b)) return i(void 0, b, _);
    } else return i(b, p, _);
  }
  function a(b, p) {
    if (!it.isUndefined(p)) return i(void 0, p);
  }
  function c(b, p) {
    if (it.isUndefined(p)) {
      if (!it.isUndefined(b)) return i(void 0, b);
    } else return i(void 0, p);
  }
  function v(b, p, _) {
    if (_ in e) return i(b, p);
    if (_ in t) return i(void 0, b);
  }
  const g = {
    url: a,
    method: a,
    data: a,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: v,
    headers: (b, p) => l(I2(b), I2(p), !0),
  };
  return (
    it.forEach(Object.keys(Object.assign({}, t, e)), function (p) {
      const _ = g[p] || l,
        M = _(t[p], e[p], p);
      (it.isUndefined(M) && _ !== v) || (n[p] = M);
    }),
    n
  );
}
const v8 = "1.6.8",
  Mm = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Mm[t] = function (i) {
    return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const O2 = {};
Mm.transitional = function (e, n, i) {
  function l(a, c) {
    return "[Axios v" + v8 + "] Transitional option '" + a + "'" + c + (i ? ". " + i : "");
  }
  return (a, c, v) => {
    if (e === !1)
      throw new Wt(l(c, " has been removed" + (n ? " in " + n : "")), Wt.ERR_DEPRECATED);
    return (
      n &&
        !O2[c] &&
        ((O2[c] = !0),
        console.warn(
          l(c, " has been deprecated since v" + n + " and will be removed in the near future")
        )),
      e ? e(a, c, v) : !0
    );
  };
};
function tC(t, e, n) {
  if (typeof t != "object") throw new Wt("options must be an object", Wt.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(t);
  let l = i.length;
  for (; l-- > 0; ) {
    const a = i[l],
      c = e[a];
    if (c) {
      const v = t[a],
        g = v === void 0 || c(v, a, t);
      if (g !== !0) throw new Wt("option " + a + " must be " + g, Wt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0) throw new Wt("Unknown option " + a, Wt.ERR_BAD_OPTION);
  }
}
var qp = {
  assertOptions: tC,
  validators: Mm,
};
const Pi = qp.validators;
class tu {
  constructor(e) {
    (this.defaults = e),
      (this.interceptors = {
        request: new B2(),
        response: new B2(),
      });
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (i) {
      if (i instanceof Error) {
        let l;
        Error.captureStackTrace ? Error.captureStackTrace((l = {})) : (l = new Error());
        const a = l.stack ? l.stack.replace(/^.+\n/, "") : "";
        i.stack
          ? a &&
            !String(i.stack).endsWith(a.replace(/^.+\n.+\n/, "")) &&
            (i.stack +=
              `
` + a)
          : (i.stack = a);
      }
      throw i;
    }
  }
  _request(e, n) {
    typeof e == "string" ? ((n = n || {}), (n.url = e)) : (n = e || {}), (n = Zs(this.defaults, n));
    const { transitional: i, paramsSerializer: l, headers: a } = n;
    i !== void 0 &&
      qp.assertOptions(
        i,
        {
          silentJSONParsing: Pi.transitional(Pi.boolean),
          forcedJSONParsing: Pi.transitional(Pi.boolean),
          clarifyTimeoutError: Pi.transitional(Pi.boolean),
        },
        !1
      ),
      l != null &&
        (it.isFunction(l)
          ? (n.paramsSerializer = {
              serialize: l,
            })
          : qp.assertOptions(
              l,
              {
                encode: Pi.function,
                serialize: Pi.function,
              },
              !0
            )),
      (n.method = (n.method || this.defaults.method || "get").toLowerCase());
    let c = a && it.merge(a.common, a[n.method]);
    a &&
      it.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (A) => {
        delete a[A];
      }),
      (n.headers = Mi.concat(c, a));
    const v = [];
    let g = !0;
    this.interceptors.request.forEach(function (k) {
      (typeof k.runWhen == "function" && k.runWhen(n) === !1) ||
        ((g = g && k.synchronous), v.unshift(k.fulfilled, k.rejected));
    });
    const b = [];
    this.interceptors.response.forEach(function (k) {
      b.push(k.fulfilled, k.rejected);
    });
    let p,
      _ = 0,
      M;
    if (!g) {
      const A = [R2.bind(this), void 0];
      for (A.unshift.apply(A, v), A.push.apply(A, b), M = A.length, p = Promise.resolve(n); _ < M; )
        p = p.then(A[_++], A[_++]);
      return p;
    }
    M = v.length;
    let S = n;
    for (_ = 0; _ < M; ) {
      const A = v[_++],
        k = v[_++];
      try {
        S = A(S);
      } catch (P) {
        k.call(this, P);
        break;
      }
    }
    try {
      p = R2.call(this, S);
    } catch (A) {
      return Promise.reject(A);
    }
    for (_ = 0, M = b.length; _ < M; ) p = p.then(b[_++], b[_++]);
    return p;
  }
  getUri(e) {
    e = Zs(this.defaults, e);
    const n = p8(e.baseURL, e.url);
    return l8(n, e.params, e.paramsSerializer);
  }
}
it.forEach(["delete", "get", "head", "options"], function (e) {
  tu.prototype[e] = function (n, i) {
    return this.request(
      Zs(i || {}, {
        method: e,
        url: n,
        data: (i || {}).data,
      })
    );
  };
});
it.forEach(["post", "put", "patch"], function (e) {
  function n(i) {
    return function (a, c, v) {
      return this.request(
        Zs(v || {}, {
          method: e,
          headers: i
            ? {
                "Content-Type": "multipart/form-data",
              }
            : {},
          url: a,
          data: c,
        })
      );
    };
  }
  (tu.prototype[e] = n()), (tu.prototype[e + "Form"] = n(!0));
});
var Vl = tu;
class Sm {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function (a) {
      n = a;
    });
    const i = this;
    this.promise.then((l) => {
      if (!i._listeners) return;
      let a = i._listeners.length;
      for (; a-- > 0; ) i._listeners[a](l);
      i._listeners = null;
    }),
      (this.promise.then = (l) => {
        let a;
        const c = new Promise((v) => {
          i.subscribe(v), (a = v);
        }).then(l);
        return (
          (c.cancel = function () {
            i.unsubscribe(a);
          }),
          c
        );
      }),
      e(function (a, c, v) {
        i.reason || ((i.reason = new qf(a, c, v)), n(i.reason));
      });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : (this._listeners = [e]);
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Sm(function (l) {
        e = l;
      }),
      cancel: e,
    };
  }
}
var rC = Sm;
function nC(t) {
  return function (n) {
    return t.apply(null, n);
  };
}
function iC(t) {
  return it.isObject(t) && t.isAxiosError === !0;
}
const zp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};
Object.entries(zp).forEach(([t, e]) => {
  zp[e] = t;
});
var aC = zp;
function g8(t) {
  const e = new Vl(t),
    n = J4(Vl.prototype.request, e);
  return (
    it.extend(n, Vl.prototype, e, { allOwnKeys: !0 }),
    it.extend(n, e, null, { allOwnKeys: !0 }),
    (n.create = function (l) {
      return g8(Zs(t, l));
    }),
    n
  );
}
const gr = g8(xm);
gr.Axios = Vl;
gr.CanceledError = qf;
gr.CancelToken = rC;
gr.isCancel = d8;
gr.VERSION = v8;
gr.toFormData = uc;
gr.AxiosError = Wt;
gr.Cancel = gr.CanceledError;
gr.all = function (e) {
  return Promise.all(e);
};
gr.spread = nC;
gr.isAxiosError = iC;
gr.mergeConfig = Zs;
gr.AxiosHeaders = Mi;
gr.formToJSON = (t) => h8(it.isHTMLForm(t) ? new FormData(t) : t);
gr.getAdapter = m8.getAdapter;
gr.HttpStatusCode = aC;
gr.default = gr;
var y8 = gr,
  Em = {},
  jp = {},
  Yn = {},
  hc = {},
  zf = {};
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.getParsedType = t.ZodParsedType = t.objectUtil = t.util = void 0);
  var e;
  (function (i) {
    i.assertEqual = (v) => v;
    function l(v) {}
    i.assertIs = l;
    function a(v) {
      throw new Error();
    }
    (i.assertNever = a),
      (i.arrayToEnum = (v) => {
        const g = {};
        for (const b of v) g[b] = b;
        return g;
      }),
      (i.getValidEnumValues = (v) => {
        const g = i.objectKeys(v).filter((p) => typeof v[v[p]] != "number"),
          b = {};
        for (const p of g) b[p] = v[p];
        return i.objectValues(b);
      }),
      (i.objectValues = (v) =>
        i.objectKeys(v).map(function (g) {
          return v[g];
        })),
      (i.objectKeys =
        typeof Object.keys == "function"
          ? (v) => Object.keys(v)
          : (v) => {
              const g = [];
              for (const b in v) Object.prototype.hasOwnProperty.call(v, b) && g.push(b);
              return g;
            }),
      (i.find = (v, g) => {
        for (const b of v) if (g(b)) return b;
      }),
      (i.isInteger =
        typeof Number.isInteger == "function"
          ? (v) => Number.isInteger(v)
          : (v) => typeof v == "number" && isFinite(v) && Math.floor(v) === v);
    function c(v, g = " | ") {
      return v.map((b) => (typeof b == "string" ? `'${b}'` : b)).join(g);
    }
    (i.joinValues = c),
      (i.jsonStringifyReplacer = (v, g) => (typeof g == "bigint" ? g.toString() : g));
  })((e = t.util || (t.util = {}))),
    (function (i) {
      i.mergeShapes = (l, a) => ({
        ...l,
        ...a,
        // second overwrites first
      });
    })(t.objectUtil || (t.objectUtil = {})),
    (t.ZodParsedType = e.arrayToEnum([
      "string",
      "nan",
      "number",
      "integer",
      "float",
      "boolean",
      "date",
      "bigint",
      "symbol",
      "function",
      "undefined",
      "null",
      "array",
      "object",
      "unknown",
      "promise",
      "void",
      "never",
      "map",
      "set",
    ]));
  const n = (i) => {
    switch (typeof i) {
      case "undefined":
        return t.ZodParsedType.undefined;
      case "string":
        return t.ZodParsedType.string;
      case "number":
        return isNaN(i) ? t.ZodParsedType.nan : t.ZodParsedType.number;
      case "boolean":
        return t.ZodParsedType.boolean;
      case "function":
        return t.ZodParsedType.function;
      case "bigint":
        return t.ZodParsedType.bigint;
      case "symbol":
        return t.ZodParsedType.symbol;
      case "object":
        return Array.isArray(i)
          ? t.ZodParsedType.array
          : i === null
          ? t.ZodParsedType.null
          : i.then && typeof i.then == "function" && i.catch && typeof i.catch == "function"
          ? t.ZodParsedType.promise
          : typeof Map < "u" && i instanceof Map
          ? t.ZodParsedType.map
          : typeof Set < "u" && i instanceof Set
          ? t.ZodParsedType.set
          : typeof Date < "u" && i instanceof Date
          ? t.ZodParsedType.date
          : t.ZodParsedType.object;
      default:
        return t.ZodParsedType.unknown;
    }
  };
  t.getParsedType = n;
})(zf);
var Jn = {};
Object.defineProperty(Jn, "__esModule", { value: !0 });
Jn.ZodError = Jn.quotelessJson = Jn.ZodIssueCode = void 0;
const b8 = zf;
Jn.ZodIssueCode = b8.util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite",
]);
const sC = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
Jn.quotelessJson = sC;
class $p extends Error {
  constructor(e) {
    super(),
      (this.issues = []),
      (this.addIssue = (i) => {
        this.issues = [...this.issues, i];
      }),
      (this.addIssues = (i = []) => {
        this.issues = [...this.issues, ...i];
      });
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : (this.__proto__ = n),
      (this.name = "ZodError"),
      (this.issues = e);
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const n =
        e ||
        function (a) {
          return a.message;
        },
      i = { _errors: [] },
      l = (a) => {
        for (const c of a.issues)
          if (c.code === "invalid_union") c.unionErrors.map(l);
          else if (c.code === "invalid_return_type") l(c.returnTypeError);
          else if (c.code === "invalid_arguments") l(c.argumentsError);
          else if (c.path.length === 0) i._errors.push(n(c));
          else {
            let v = i,
              g = 0;
            for (; g < c.path.length; ) {
              const b = c.path[g];
              g === c.path.length - 1
                ? ((v[b] = v[b] || { _errors: [] }), v[b]._errors.push(n(c)))
                : (v[b] = v[b] || { _errors: [] }),
                (v = v[b]),
                g++;
            }
          }
      };
    return l(this), i;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b8.util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {},
      i = [];
    for (const l of this.issues)
      l.path.length > 0
        ? ((n[l.path[0]] = n[l.path[0]] || []), n[l.path[0]].push(e(l)))
        : i.push(e(l));
    return { formErrors: i, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Jn.ZodError = $p;
$p.create = (t) => new $p(t);
Object.defineProperty(hc, "__esModule", { value: !0 });
const va = zf,
  Rr = Jn,
  oC = (t, e) => {
    let n;
    switch (t.code) {
      case Rr.ZodIssueCode.invalid_type:
        t.received === va.ZodParsedType.undefined
          ? (n = "Required")
          : (n = `Expected ${t.expected}, received ${t.received}`);
        break;
      case Rr.ZodIssueCode.invalid_literal:
        n = `Invalid literal value, expected ${JSON.stringify(
          t.expected,
          va.util.jsonStringifyReplacer
        )}`;
        break;
      case Rr.ZodIssueCode.unrecognized_keys:
        n = `Unrecognized key(s) in object: ${va.util.joinValues(t.keys, ", ")}`;
        break;
      case Rr.ZodIssueCode.invalid_union:
        n = "Invalid input";
        break;
      case Rr.ZodIssueCode.invalid_union_discriminator:
        n = `Invalid discriminator value. Expected ${va.util.joinValues(t.options)}`;
        break;
      case Rr.ZodIssueCode.invalid_enum_value:
        n = `Invalid enum value. Expected ${va.util.joinValues(t.options)}, received '${
          t.received
        }'`;
        break;
      case Rr.ZodIssueCode.invalid_arguments:
        n = "Invalid function arguments";
        break;
      case Rr.ZodIssueCode.invalid_return_type:
        n = "Invalid function return type";
        break;
      case Rr.ZodIssueCode.invalid_date:
        n = "Invalid date";
        break;
      case Rr.ZodIssueCode.invalid_string:
        typeof t.validation == "object"
          ? "includes" in t.validation
            ? ((n = `Invalid input: must include "${t.validation.includes}"`),
              typeof t.validation.position == "number" &&
                (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`))
            : "startsWith" in t.validation
            ? (n = `Invalid input: must start with "${t.validation.startsWith}"`)
            : "endsWith" in t.validation
            ? (n = `Invalid input: must end with "${t.validation.endsWith}"`)
            : va.util.assertNever(t.validation)
          : t.validation !== "regex"
          ? (n = `Invalid ${t.validation}`)
          : (n = "Invalid");
        break;
      case Rr.ZodIssueCode.too_small:
        t.type === "array"
          ? (n = `Array must contain ${
              t.exact ? "exactly" : t.inclusive ? "at least" : "more than"
            } ${t.minimum} element(s)`)
          : t.type === "string"
          ? (n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${
              t.minimum
            } character(s)`)
          : t.type === "number"
          ? (n = `Number must be ${
              t.exact
                ? "exactly equal to "
                : t.inclusive
                ? "greater than or equal to "
                : "greater than "
            }${t.minimum}`)
          : t.type === "date"
          ? (n = `Date must be ${
              t.exact
                ? "exactly equal to "
                : t.inclusive
                ? "greater than or equal to "
                : "greater than "
            }${new Date(Number(t.minimum))}`)
          : (n = "Invalid input");
        break;
      case Rr.ZodIssueCode.too_big:
        t.type === "array"
          ? (n = `Array must contain ${
              t.exact ? "exactly" : t.inclusive ? "at most" : "less than"
            } ${t.maximum} element(s)`)
          : t.type === "string"
          ? (n = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${
              t.maximum
            } character(s)`)
          : t.type === "number"
          ? (n = `Number must be ${
              t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"
            } ${t.maximum}`)
          : t.type === "bigint"
          ? (n = `BigInt must be ${
              t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"
            } ${t.maximum}`)
          : t.type === "date"
          ? (n = `Date must be ${
              t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"
            } ${new Date(Number(t.maximum))}`)
          : (n = "Invalid input");
        break;
      case Rr.ZodIssueCode.custom:
        n = "Invalid input";
        break;
      case Rr.ZodIssueCode.invalid_intersection_types:
        n = "Intersection results could not be merged";
        break;
      case Rr.ZodIssueCode.not_multiple_of:
        n = `Number must be a multiple of ${t.multipleOf}`;
        break;
      case Rr.ZodIssueCode.not_finite:
        n = "Number must be finite";
        break;
      default:
        (n = e.defaultError), va.util.assertNever(t);
    }
    return { message: n };
  };
hc.default = oC;
var fC =
  (mt && mt.__importDefault) ||
  function (t) {
    return t && t.__esModule ? t : { default: t };
  };
Object.defineProperty(Yn, "__esModule", { value: !0 });
Yn.getErrorMap = Yn.setErrorMap = Yn.defaultErrorMap = void 0;
const w8 = fC(hc);
Yn.defaultErrorMap = w8.default;
let _8 = w8.default;
function lC(t) {
  _8 = t;
}
Yn.setErrorMap = lC;
function uC() {
  return _8;
}
Yn.getErrorMap = uC;
var Am = {};
(function (t) {
  var e =
    (mt && mt.__importDefault) ||
    function (S) {
      return S && S.__esModule ? S : { default: S };
    };
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.isAsync =
      t.isValid =
      t.isDirty =
      t.isAborted =
      t.OK =
      t.DIRTY =
      t.INVALID =
      t.ParseStatus =
      t.addIssueToContext =
      t.EMPTY_PATH =
      t.makeIssue =
        void 0);
  const n = Yn,
    i = e(hc),
    l = (S) => {
      const { data: A, path: k, errorMaps: P, issueData: B } = S,
        T = [...k, ...(B.path || [])],
        F = {
          ...B,
          path: T,
        };
      let O = "";
      const $ = P.filter((J) => !!J)
        .slice()
        .reverse();
      for (const J of $) O = J(F, { data: A, defaultError: O }).message;
      return {
        ...B,
        path: T,
        message: B.message || O,
      };
    };
  (t.makeIssue = l), (t.EMPTY_PATH = []);
  function a(S, A) {
    const k = (0, t.makeIssue)({
      issueData: A,
      data: S.data,
      path: S.path,
      errorMaps: [
        S.common.contextualErrorMap,
        S.schemaErrorMap,
        (0, n.getErrorMap)(),
        i.default,
        // then global default map
      ].filter((P) => !!P),
    });
    S.common.issues.push(k);
  }
  t.addIssueToContext = a;
  class c {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      this.value === "valid" && (this.value = "dirty");
    }
    abort() {
      this.value !== "aborted" && (this.value = "aborted");
    }
    static mergeArray(A, k) {
      const P = [];
      for (const B of k) {
        if (B.status === "aborted") return t.INVALID;
        B.status === "dirty" && A.dirty(), P.push(B.value);
      }
      return { status: A.value, value: P };
    }
    static async mergeObjectAsync(A, k) {
      const P = [];
      for (const B of k)
        P.push({
          key: await B.key,
          value: await B.value,
        });
      return c.mergeObjectSync(A, P);
    }
    static mergeObjectSync(A, k) {
      const P = {};
      for (const B of k) {
        const { key: T, value: F } = B;
        if (T.status === "aborted" || F.status === "aborted") return t.INVALID;
        T.status === "dirty" && A.dirty(),
          F.status === "dirty" && A.dirty(),
          T.value !== "__proto__" &&
            (typeof F.value < "u" || B.alwaysSet) &&
            (P[T.value] = F.value);
      }
      return { status: A.value, value: P };
    }
  }
  (t.ParseStatus = c),
    (t.INVALID = Object.freeze({
      status: "aborted",
    }));
  const v = (S) => ({ status: "dirty", value: S });
  t.DIRTY = v;
  const g = (S) => ({ status: "valid", value: S });
  t.OK = g;
  const b = (S) => S.status === "aborted";
  t.isAborted = b;
  const p = (S) => S.status === "dirty";
  t.isDirty = p;
  const _ = (S) => S.status === "valid";
  t.isValid = _;
  const M = (S) => typeof Promise < "u" && S instanceof Promise;
  t.isAsync = M;
})(Am);
var x8 = {};
Object.defineProperty(x8, "__esModule", { value: !0 });
var M8 = {},
  S8 = {};
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.errorUtil = void 0),
    (function (e) {
      (e.errToObj = (n) => (typeof n == "string" ? { message: n } : n || {})),
        (e.toString = (n) => (typeof n == "string" ? n : n == null ? void 0 : n.message));
    })(t.errorUtil || (t.errorUtil = {}));
})(S8);
(function (t) {
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.date =
      t.boolean =
      t.bigint =
      t.array =
      t.any =
      t.coerce =
      t.ZodFirstPartyTypeKind =
      t.late =
      t.ZodSchema =
      t.Schema =
      t.custom =
      t.ZodReadonly =
      t.ZodPipeline =
      t.ZodBranded =
      t.BRAND =
      t.ZodNaN =
      t.ZodCatch =
      t.ZodDefault =
      t.ZodNullable =
      t.ZodOptional =
      t.ZodTransformer =
      t.ZodEffects =
      t.ZodPromise =
      t.ZodNativeEnum =
      t.ZodEnum =
      t.ZodLiteral =
      t.ZodLazy =
      t.ZodFunction =
      t.ZodSet =
      t.ZodMap =
      t.ZodRecord =
      t.ZodTuple =
      t.ZodIntersection =
      t.ZodDiscriminatedUnion =
      t.ZodUnion =
      t.ZodObject =
      t.ZodArray =
      t.ZodVoid =
      t.ZodNever =
      t.ZodUnknown =
      t.ZodAny =
      t.ZodNull =
      t.ZodUndefined =
      t.ZodSymbol =
      t.ZodDate =
      t.ZodBoolean =
      t.ZodBigInt =
      t.ZodNumber =
      t.ZodString =
      t.ZodType =
        void 0),
    (t.NEVER =
      t.void =
      t.unknown =
      t.union =
      t.undefined =
      t.tuple =
      t.transformer =
      t.symbol =
      t.string =
      t.strictObject =
      t.set =
      t.record =
      t.promise =
      t.preprocess =
      t.pipeline =
      t.ostring =
      t.optional =
      t.onumber =
      t.oboolean =
      t.object =
      t.number =
      t.nullable =
      t.null =
      t.never =
      t.nativeEnum =
      t.nan =
      t.map =
      t.literal =
      t.lazy =
      t.intersection =
      t.instanceof =
      t.function =
      t.enum =
      t.effect =
      t.discriminatedUnion =
        void 0);
  const e = Yn,
    n = S8,
    i = Am,
    l = zf,
    a = Jn;
  class c {
    constructor(N, Y, ie, ge) {
      (this._cachedPath = []),
        (this.parent = N),
        (this.data = Y),
        (this._path = ie),
        (this._key = ge);
    }
    get path() {
      return (
        this._cachedPath.length ||
          (this._key instanceof Array
            ? this._cachedPath.push(...this._path, ...this._key)
            : this._cachedPath.push(...this._path, this._key)),
        this._cachedPath
      );
    }
  }
  const v = (ce, N) => {
    if ((0, i.isValid)(N)) return { success: !0, data: N.value };
    if (!ce.common.issues.length) throw new Error("Validation failed but no issues detected.");
    return {
      success: !1,
      get error() {
        if (this._error) return this._error;
        const Y = new a.ZodError(ce.common.issues);
        return (this._error = Y), this._error;
      },
    };
  };
  function g(ce) {
    if (!ce) return {};
    const { errorMap: N, invalid_type_error: Y, required_error: ie, description: ge } = ce;
    if (N && (Y || ie))
      throw new Error(
        `Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`
      );
    return N
      ? { errorMap: N, description: ge }
      : {
          errorMap: (qe, Pe) =>
            qe.code !== "invalid_type"
              ? { message: Pe.defaultError }
              : typeof Pe.data > "u"
              ? { message: ie ?? Pe.defaultError }
              : { message: Y ?? Pe.defaultError },
          description: ge,
        };
  }
  class b {
    constructor(N) {
      (this.spa = this.safeParseAsync),
        (this._def = N),
        (this.parse = this.parse.bind(this)),
        (this.safeParse = this.safeParse.bind(this)),
        (this.parseAsync = this.parseAsync.bind(this)),
        (this.safeParseAsync = this.safeParseAsync.bind(this)),
        (this.spa = this.spa.bind(this)),
        (this.refine = this.refine.bind(this)),
        (this.refinement = this.refinement.bind(this)),
        (this.superRefine = this.superRefine.bind(this)),
        (this.optional = this.optional.bind(this)),
        (this.nullable = this.nullable.bind(this)),
        (this.nullish = this.nullish.bind(this)),
        (this.array = this.array.bind(this)),
        (this.promise = this.promise.bind(this)),
        (this.or = this.or.bind(this)),
        (this.and = this.and.bind(this)),
        (this.transform = this.transform.bind(this)),
        (this.brand = this.brand.bind(this)),
        (this.default = this.default.bind(this)),
        (this.catch = this.catch.bind(this)),
        (this.describe = this.describe.bind(this)),
        (this.pipe = this.pipe.bind(this)),
        (this.readonly = this.readonly.bind(this)),
        (this.isNullable = this.isNullable.bind(this)),
        (this.isOptional = this.isOptional.bind(this));
    }
    get description() {
      return this._def.description;
    }
    _getType(N) {
      return (0, l.getParsedType)(N.data);
    }
    _getOrReturnCtx(N, Y) {
      return (
        Y || {
          common: N.parent.common,
          data: N.data,
          parsedType: (0, l.getParsedType)(N.data),
          schemaErrorMap: this._def.errorMap,
          path: N.path,
          parent: N.parent,
        }
      );
    }
    _processInputParams(N) {
      return {
        status: new i.ParseStatus(),
        ctx: {
          common: N.parent.common,
          data: N.data,
          parsedType: (0, l.getParsedType)(N.data),
          schemaErrorMap: this._def.errorMap,
          path: N.path,
          parent: N.parent,
        },
      };
    }
    _parseSync(N) {
      const Y = this._parse(N);
      if ((0, i.isAsync)(Y)) throw new Error("Synchronous parse encountered promise.");
      return Y;
    }
    _parseAsync(N) {
      const Y = this._parse(N);
      return Promise.resolve(Y);
    }
    parse(N, Y) {
      const ie = this.safeParse(N, Y);
      if (ie.success) return ie.data;
      throw ie.error;
    }
    safeParse(N, Y) {
      var ie;
      const ge = {
          common: {
            issues: [],
            async: (ie = Y == null ? void 0 : Y.async) !== null && ie !== void 0 ? ie : !1,
            contextualErrorMap: Y == null ? void 0 : Y.errorMap,
          },
          path: (Y == null ? void 0 : Y.path) || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data: N,
          parsedType: (0, l.getParsedType)(N),
        },
        me = this._parseSync({ data: N, path: ge.path, parent: ge });
      return v(ge, me);
    }
    async parseAsync(N, Y) {
      const ie = await this.safeParseAsync(N, Y);
      if (ie.success) return ie.data;
      throw ie.error;
    }
    async safeParseAsync(N, Y) {
      const ie = {
          common: {
            issues: [],
            contextualErrorMap: Y == null ? void 0 : Y.errorMap,
            async: !0,
          },
          path: (Y == null ? void 0 : Y.path) || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data: N,
          parsedType: (0, l.getParsedType)(N),
        },
        ge = this._parse({ data: N, path: ie.path, parent: ie }),
        me = await ((0, i.isAsync)(ge) ? ge : Promise.resolve(ge));
      return v(ie, me);
    }
    refine(N, Y) {
      const ie = (ge) =>
        typeof Y == "string" || typeof Y > "u"
          ? { message: Y }
          : typeof Y == "function"
          ? Y(ge)
          : Y;
      return this._refinement((ge, me) => {
        const qe = N(ge),
          Pe = () =>
            me.addIssue({
              code: a.ZodIssueCode.custom,
              ...ie(ge),
            });
        return typeof Promise < "u" && qe instanceof Promise
          ? qe.then((Xe) => (Xe ? !0 : (Pe(), !1)))
          : qe
          ? !0
          : (Pe(), !1);
      });
    }
    refinement(N, Y) {
      return this._refinement((ie, ge) =>
        N(ie) ? !0 : (ge.addIssue(typeof Y == "function" ? Y(ie, ge) : Y), !1)
      );
    }
    _refinement(N) {
      return new ut({
        schema: this,
        typeName: X.ZodEffects,
        effect: { type: "refinement", refinement: N },
      });
    }
    superRefine(N) {
      return this._refinement(N);
    }
    optional() {
      return Ie.create(this, this._def);
    }
    nullable() {
      return be.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return w.create(this, this._def);
    }
    promise() {
      return Te.create(this, this._def);
    }
    or(N) {
      return m.create([this, N], this._def);
    }
    and(N) {
      return Q.create(this, N, this._def);
    }
    transform(N) {
      return new ut({
        ...g(this._def),
        schema: this,
        typeName: X.ZodEffects,
        effect: { type: "transform", transform: N },
      });
    }
    default(N) {
      const Y = typeof N == "function" ? N : () => N;
      return new wt({
        ...g(this._def),
        innerType: this,
        defaultValue: Y,
        typeName: X.ZodDefault,
      });
    }
    brand() {
      return new xt({
        typeName: X.ZodBranded,
        type: this,
        ...g(this._def),
      });
    }
    catch(N) {
      const Y = typeof N == "function" ? N : () => N;
      return new Oe({
        ...g(this._def),
        innerType: this,
        catchValue: Y,
        typeName: X.ZodCatch,
      });
    }
    describe(N) {
      const Y = this.constructor;
      return new Y({
        ...this._def,
        description: N,
      });
    }
    pipe(N) {
      return Ue.create(this, N);
    }
    readonly() {
      return se.create(this);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  }
  (t.ZodType = b), (t.Schema = b), (t.ZodSchema = b);
  const p = /^c[^\s-]{8,}$/i,
    _ = /^[a-z][a-z0-9]*$/,
    M = /^[0-9A-HJKMNP-TV-Z]{26}$/,
    S = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,
    A = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,
    k = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
  let P;
  const B =
      /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/,
    T =
      /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/,
    F = (ce) =>
      ce.precision
        ? ce.offset
          ? new RegExp(
              `^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${ce.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`
            )
          : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${ce.precision}}Z$`)
        : ce.precision === 0
        ? ce.offset
          ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$")
          : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$")
        : ce.offset
        ? new RegExp(
            "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$"
          )
        : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
  function O(ce, N) {
    return !!(((N === "v4" || !N) && B.test(ce)) || ((N === "v6" || !N) && T.test(ce)));
  }
  class $ extends b {
    _parse(N) {
      if (
        (this._def.coerce && (N.data = String(N.data)), this._getType(N) !== l.ZodParsedType.string)
      ) {
        const me = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(
            me,
            {
              code: a.ZodIssueCode.invalid_type,
              expected: l.ZodParsedType.string,
              received: me.parsedType,
            }
            //
          ),
          i.INVALID
        );
      }
      const ie = new i.ParseStatus();
      let ge;
      for (const me of this._def.checks)
        if (me.kind === "min")
          N.data.length < me.value &&
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              code: a.ZodIssueCode.too_small,
              minimum: me.value,
              type: "string",
              inclusive: !0,
              exact: !1,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "max")
          N.data.length > me.value &&
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              code: a.ZodIssueCode.too_big,
              maximum: me.value,
              type: "string",
              inclusive: !0,
              exact: !1,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "length") {
          const qe = N.data.length > me.value,
            Pe = N.data.length < me.value;
          (qe || Pe) &&
            ((ge = this._getOrReturnCtx(N, ge)),
            qe
              ? (0, i.addIssueToContext)(ge, {
                  code: a.ZodIssueCode.too_big,
                  maximum: me.value,
                  type: "string",
                  inclusive: !0,
                  exact: !0,
                  message: me.message,
                })
              : Pe &&
                (0, i.addIssueToContext)(ge, {
                  code: a.ZodIssueCode.too_small,
                  minimum: me.value,
                  type: "string",
                  inclusive: !0,
                  exact: !0,
                  message: me.message,
                }),
            ie.dirty());
        } else if (me.kind === "email")
          A.test(N.data) ||
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              validation: "email",
              code: a.ZodIssueCode.invalid_string,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "emoji")
          P || (P = new RegExp(k, "u")),
            P.test(N.data) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                validation: "emoji",
                code: a.ZodIssueCode.invalid_string,
                message: me.message,
              }),
              ie.dirty());
        else if (me.kind === "uuid")
          S.test(N.data) ||
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              validation: "uuid",
              code: a.ZodIssueCode.invalid_string,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "cuid")
          p.test(N.data) ||
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              validation: "cuid",
              code: a.ZodIssueCode.invalid_string,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "cuid2")
          _.test(N.data) ||
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              validation: "cuid2",
              code: a.ZodIssueCode.invalid_string,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "ulid")
          M.test(N.data) ||
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              validation: "ulid",
              code: a.ZodIssueCode.invalid_string,
              message: me.message,
            }),
            ie.dirty());
        else if (me.kind === "url")
          try {
            new URL(N.data);
          } catch {
            (ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                validation: "url",
                code: a.ZodIssueCode.invalid_string,
                message: me.message,
              }),
              ie.dirty();
          }
        else
          me.kind === "regex"
            ? ((me.regex.lastIndex = 0),
              me.regex.test(N.data) ||
                ((ge = this._getOrReturnCtx(N, ge)),
                (0, i.addIssueToContext)(ge, {
                  validation: "regex",
                  code: a.ZodIssueCode.invalid_string,
                  message: me.message,
                }),
                ie.dirty()))
            : me.kind === "trim"
            ? (N.data = N.data.trim())
            : me.kind === "includes"
            ? N.data.includes(me.value, me.position) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                code: a.ZodIssueCode.invalid_string,
                validation: { includes: me.value, position: me.position },
                message: me.message,
              }),
              ie.dirty())
            : me.kind === "toLowerCase"
            ? (N.data = N.data.toLowerCase())
            : me.kind === "toUpperCase"
            ? (N.data = N.data.toUpperCase())
            : me.kind === "startsWith"
            ? N.data.startsWith(me.value) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                code: a.ZodIssueCode.invalid_string,
                validation: { startsWith: me.value },
                message: me.message,
              }),
              ie.dirty())
            : me.kind === "endsWith"
            ? N.data.endsWith(me.value) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                code: a.ZodIssueCode.invalid_string,
                validation: { endsWith: me.value },
                message: me.message,
              }),
              ie.dirty())
            : me.kind === "datetime"
            ? F(me).test(N.data) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                code: a.ZodIssueCode.invalid_string,
                validation: "datetime",
                message: me.message,
              }),
              ie.dirty())
            : me.kind === "ip"
            ? O(N.data, me.version) ||
              ((ge = this._getOrReturnCtx(N, ge)),
              (0, i.addIssueToContext)(ge, {
                validation: "ip",
                code: a.ZodIssueCode.invalid_string,
                message: me.message,
              }),
              ie.dirty())
            : l.util.assertNever(me);
      return { status: ie.value, value: N.data };
    }
    _regex(N, Y, ie) {
      return this.refinement((ge) => N.test(ge), {
        validation: Y,
        code: a.ZodIssueCode.invalid_string,
        ...n.errorUtil.errToObj(ie),
      });
    }
    _addCheck(N) {
      return new $({
        ...this._def,
        checks: [...this._def.checks, N],
      });
    }
    email(N) {
      return this._addCheck({ kind: "email", ...n.errorUtil.errToObj(N) });
    }
    url(N) {
      return this._addCheck({ kind: "url", ...n.errorUtil.errToObj(N) });
    }
    emoji(N) {
      return this._addCheck({ kind: "emoji", ...n.errorUtil.errToObj(N) });
    }
    uuid(N) {
      return this._addCheck({ kind: "uuid", ...n.errorUtil.errToObj(N) });
    }
    cuid(N) {
      return this._addCheck({ kind: "cuid", ...n.errorUtil.errToObj(N) });
    }
    cuid2(N) {
      return this._addCheck({ kind: "cuid2", ...n.errorUtil.errToObj(N) });
    }
    ulid(N) {
      return this._addCheck({ kind: "ulid", ...n.errorUtil.errToObj(N) });
    }
    ip(N) {
      return this._addCheck({ kind: "ip", ...n.errorUtil.errToObj(N) });
    }
    datetime(N) {
      var Y;
      return typeof N == "string"
        ? this._addCheck({
            kind: "datetime",
            precision: null,
            offset: !1,
            message: N,
          })
        : this._addCheck({
            kind: "datetime",
            precision:
              typeof (N == null ? void 0 : N.precision) > "u"
                ? null
                : N == null
                ? void 0
                : N.precision,
            offset: (Y = N == null ? void 0 : N.offset) !== null && Y !== void 0 ? Y : !1,
            ...n.errorUtil.errToObj(N == null ? void 0 : N.message),
          });
    }
    regex(N, Y) {
      return this._addCheck({
        kind: "regex",
        regex: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    includes(N, Y) {
      return this._addCheck({
        kind: "includes",
        value: N,
        position: Y == null ? void 0 : Y.position,
        ...n.errorUtil.errToObj(Y == null ? void 0 : Y.message),
      });
    }
    startsWith(N, Y) {
      return this._addCheck({
        kind: "startsWith",
        value: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    endsWith(N, Y) {
      return this._addCheck({
        kind: "endsWith",
        value: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    min(N, Y) {
      return this._addCheck({
        kind: "min",
        value: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    max(N, Y) {
      return this._addCheck({
        kind: "max",
        value: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    length(N, Y) {
      return this._addCheck({
        kind: "length",
        value: N,
        ...n.errorUtil.errToObj(Y),
      });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(N) {
      return this.min(1, n.errorUtil.errToObj(N));
    }
    trim() {
      return new $({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }],
      });
    }
    toLowerCase() {
      return new $({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }],
      });
    }
    toUpperCase() {
      return new $({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }],
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((N) => N.kind === "datetime");
    }
    get isEmail() {
      return !!this._def.checks.find((N) => N.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((N) => N.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((N) => N.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((N) => N.kind === "uuid");
    }
    get isCUID() {
      return !!this._def.checks.find((N) => N.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((N) => N.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((N) => N.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((N) => N.kind === "ip");
    }
    get minLength() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "min" && (N === null || Y.value > N) && (N = Y.value);
      return N;
    }
    get maxLength() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "max" && (N === null || Y.value < N) && (N = Y.value);
      return N;
    }
  }
  (t.ZodString = $),
    ($.create = (ce) => {
      var N;
      return new $({
        checks: [],
        typeName: X.ZodString,
        coerce: (N = ce == null ? void 0 : ce.coerce) !== null && N !== void 0 ? N : !1,
        ...g(ce),
      });
    });
  function J(ce, N) {
    const Y = (ce.toString().split(".")[1] || "").length,
      ie = (N.toString().split(".")[1] || "").length,
      ge = Y > ie ? Y : ie,
      me = parseInt(ce.toFixed(ge).replace(".", "")),
      qe = parseInt(N.toFixed(ge).replace(".", ""));
    return (me % qe) / Math.pow(10, ge);
  }
  class he extends b {
    constructor() {
      super(...arguments),
        (this.min = this.gte),
        (this.max = this.lte),
        (this.step = this.multipleOf);
    }
    _parse(N) {
      if (
        (this._def.coerce && (N.data = Number(N.data)), this._getType(N) !== l.ZodParsedType.number)
      ) {
        const me = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(me, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.number,
            received: me.parsedType,
          }),
          i.INVALID
        );
      }
      let ie;
      const ge = new i.ParseStatus();
      for (const me of this._def.checks)
        me.kind === "int"
          ? l.util.isInteger(N.data) ||
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.invalid_type,
              expected: "integer",
              received: "float",
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "min"
          ? (me.inclusive ? N.data < me.value : N.data <= me.value) &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.too_small,
              minimum: me.value,
              type: "number",
              inclusive: me.inclusive,
              exact: !1,
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "max"
          ? (me.inclusive ? N.data > me.value : N.data >= me.value) &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.too_big,
              maximum: me.value,
              type: "number",
              inclusive: me.inclusive,
              exact: !1,
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "multipleOf"
          ? J(N.data, me.value) !== 0 &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.not_multiple_of,
              multipleOf: me.value,
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "finite"
          ? Number.isFinite(N.data) ||
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.not_finite,
              message: me.message,
            }),
            ge.dirty())
          : l.util.assertNever(me);
      return { status: ge.value, value: N.data };
    }
    gte(N, Y) {
      return this.setLimit("min", N, !0, n.errorUtil.toString(Y));
    }
    gt(N, Y) {
      return this.setLimit("min", N, !1, n.errorUtil.toString(Y));
    }
    lte(N, Y) {
      return this.setLimit("max", N, !0, n.errorUtil.toString(Y));
    }
    lt(N, Y) {
      return this.setLimit("max", N, !1, n.errorUtil.toString(Y));
    }
    setLimit(N, Y, ie, ge) {
      return new he({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: N,
            value: Y,
            inclusive: ie,
            message: n.errorUtil.toString(ge),
          },
        ],
      });
    }
    _addCheck(N) {
      return new he({
        ...this._def,
        checks: [...this._def.checks, N],
      });
    }
    int(N) {
      return this._addCheck({
        kind: "int",
        message: n.errorUtil.toString(N),
      });
    }
    positive(N) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !1,
        message: n.errorUtil.toString(N),
      });
    }
    negative(N) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !1,
        message: n.errorUtil.toString(N),
      });
    }
    nonpositive(N) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !0,
        message: n.errorUtil.toString(N),
      });
    }
    nonnegative(N) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !0,
        message: n.errorUtil.toString(N),
      });
    }
    multipleOf(N, Y) {
      return this._addCheck({
        kind: "multipleOf",
        value: N,
        message: n.errorUtil.toString(Y),
      });
    }
    finite(N) {
      return this._addCheck({
        kind: "finite",
        message: n.errorUtil.toString(N),
      });
    }
    safe(N) {
      return this._addCheck({
        kind: "min",
        inclusive: !0,
        value: Number.MIN_SAFE_INTEGER,
        message: n.errorUtil.toString(N),
      })._addCheck({
        kind: "max",
        inclusive: !0,
        value: Number.MAX_SAFE_INTEGER,
        message: n.errorUtil.toString(N),
      });
    }
    get minValue() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "min" && (N === null || Y.value > N) && (N = Y.value);
      return N;
    }
    get maxValue() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "max" && (N === null || Y.value < N) && (N = Y.value);
      return N;
    }
    get isInt() {
      return !!this._def.checks.find(
        (N) => N.kind === "int" || (N.kind === "multipleOf" && l.util.isInteger(N.value))
      );
    }
    get isFinite() {
      let N = null,
        Y = null;
      for (const ie of this._def.checks) {
        if (ie.kind === "finite" || ie.kind === "int" || ie.kind === "multipleOf") return !0;
        ie.kind === "min"
          ? (Y === null || ie.value > Y) && (Y = ie.value)
          : ie.kind === "max" && (N === null || ie.value < N) && (N = ie.value);
      }
      return Number.isFinite(Y) && Number.isFinite(N);
    }
  }
  (t.ZodNumber = he),
    (he.create = (ce) =>
      new he({
        checks: [],
        typeName: X.ZodNumber,
        coerce: (ce == null ? void 0 : ce.coerce) || !1,
        ...g(ce),
      }));
  class de extends b {
    constructor() {
      super(...arguments), (this.min = this.gte), (this.max = this.lte);
    }
    _parse(N) {
      if (
        (this._def.coerce && (N.data = BigInt(N.data)), this._getType(N) !== l.ZodParsedType.bigint)
      ) {
        const me = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(me, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.bigint,
            received: me.parsedType,
          }),
          i.INVALID
        );
      }
      let ie;
      const ge = new i.ParseStatus();
      for (const me of this._def.checks)
        me.kind === "min"
          ? (me.inclusive ? N.data < me.value : N.data <= me.value) &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.too_small,
              type: "bigint",
              minimum: me.value,
              inclusive: me.inclusive,
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "max"
          ? (me.inclusive ? N.data > me.value : N.data >= me.value) &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.too_big,
              type: "bigint",
              maximum: me.value,
              inclusive: me.inclusive,
              message: me.message,
            }),
            ge.dirty())
          : me.kind === "multipleOf"
          ? N.data % me.value !== BigInt(0) &&
            ((ie = this._getOrReturnCtx(N, ie)),
            (0, i.addIssueToContext)(ie, {
              code: a.ZodIssueCode.not_multiple_of,
              multipleOf: me.value,
              message: me.message,
            }),
            ge.dirty())
          : l.util.assertNever(me);
      return { status: ge.value, value: N.data };
    }
    gte(N, Y) {
      return this.setLimit("min", N, !0, n.errorUtil.toString(Y));
    }
    gt(N, Y) {
      return this.setLimit("min", N, !1, n.errorUtil.toString(Y));
    }
    lte(N, Y) {
      return this.setLimit("max", N, !0, n.errorUtil.toString(Y));
    }
    lt(N, Y) {
      return this.setLimit("max", N, !1, n.errorUtil.toString(Y));
    }
    setLimit(N, Y, ie, ge) {
      return new de({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: N,
            value: Y,
            inclusive: ie,
            message: n.errorUtil.toString(ge),
          },
        ],
      });
    }
    _addCheck(N) {
      return new de({
        ...this._def,
        checks: [...this._def.checks, N],
      });
    }
    positive(N) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !1,
        message: n.errorUtil.toString(N),
      });
    }
    negative(N) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !1,
        message: n.errorUtil.toString(N),
      });
    }
    nonpositive(N) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !0,
        message: n.errorUtil.toString(N),
      });
    }
    nonnegative(N) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !0,
        message: n.errorUtil.toString(N),
      });
    }
    multipleOf(N, Y) {
      return this._addCheck({
        kind: "multipleOf",
        value: N,
        message: n.errorUtil.toString(Y),
      });
    }
    get minValue() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "min" && (N === null || Y.value > N) && (N = Y.value);
      return N;
    }
    get maxValue() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "max" && (N === null || Y.value < N) && (N = Y.value);
      return N;
    }
  }
  (t.ZodBigInt = de),
    (de.create = (ce) => {
      var N;
      return new de({
        checks: [],
        typeName: X.ZodBigInt,
        coerce: (N = ce == null ? void 0 : ce.coerce) !== null && N !== void 0 ? N : !1,
        ...g(ce),
      });
    });
  class ne extends b {
    _parse(N) {
      if ((this._def.coerce && (N.data = !!N.data), this._getType(N) !== l.ZodParsedType.boolean)) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.boolean,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodBoolean = ne),
    (ne.create = (ce) =>
      new ne({
        typeName: X.ZodBoolean,
        coerce: (ce == null ? void 0 : ce.coerce) || !1,
        ...g(ce),
      }));
  class Ae extends b {
    _parse(N) {
      if (
        (this._def.coerce && (N.data = new Date(N.data)), this._getType(N) !== l.ZodParsedType.date)
      ) {
        const me = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(me, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.date,
            received: me.parsedType,
          }),
          i.INVALID
        );
      }
      if (isNaN(N.data.getTime())) {
        const me = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(me, {
            code: a.ZodIssueCode.invalid_date,
          }),
          i.INVALID
        );
      }
      const ie = new i.ParseStatus();
      let ge;
      for (const me of this._def.checks)
        me.kind === "min"
          ? N.data.getTime() < me.value &&
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              code: a.ZodIssueCode.too_small,
              message: me.message,
              inclusive: !0,
              exact: !1,
              minimum: me.value,
              type: "date",
            }),
            ie.dirty())
          : me.kind === "max"
          ? N.data.getTime() > me.value &&
            ((ge = this._getOrReturnCtx(N, ge)),
            (0, i.addIssueToContext)(ge, {
              code: a.ZodIssueCode.too_big,
              message: me.message,
              inclusive: !0,
              exact: !1,
              maximum: me.value,
              type: "date",
            }),
            ie.dirty())
          : l.util.assertNever(me);
      return {
        status: ie.value,
        value: new Date(N.data.getTime()),
      };
    }
    _addCheck(N) {
      return new Ae({
        ...this._def,
        checks: [...this._def.checks, N],
      });
    }
    min(N, Y) {
      return this._addCheck({
        kind: "min",
        value: N.getTime(),
        message: n.errorUtil.toString(Y),
      });
    }
    max(N, Y) {
      return this._addCheck({
        kind: "max",
        value: N.getTime(),
        message: n.errorUtil.toString(Y),
      });
    }
    get minDate() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "min" && (N === null || Y.value > N) && (N = Y.value);
      return N != null ? new Date(N) : null;
    }
    get maxDate() {
      let N = null;
      for (const Y of this._def.checks)
        Y.kind === "max" && (N === null || Y.value < N) && (N = Y.value);
      return N != null ? new Date(N) : null;
    }
  }
  (t.ZodDate = Ae),
    (Ae.create = (ce) =>
      new Ae({
        checks: [],
        coerce: (ce == null ? void 0 : ce.coerce) || !1,
        typeName: X.ZodDate,
        ...g(ce),
      }));
  class x extends b {
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.symbol) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.symbol,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodSymbol = x),
    (x.create = (ce) =>
      new x({
        typeName: X.ZodSymbol,
        ...g(ce),
      }));
  class r extends b {
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.undefined) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.undefined,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodUndefined = r),
    (r.create = (ce) =>
      new r({
        typeName: X.ZodUndefined,
        ...g(ce),
      }));
  class o extends b {
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.null) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.null,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodNull = o),
    (o.create = (ce) =>
      new o({
        typeName: X.ZodNull,
        ...g(ce),
      }));
  class f extends b {
    constructor() {
      super(...arguments), (this._any = !0);
    }
    _parse(N) {
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodAny = f),
    (f.create = (ce) =>
      new f({
        typeName: X.ZodAny,
        ...g(ce),
      }));
  class u extends b {
    constructor() {
      super(...arguments), (this._unknown = !0);
    }
    _parse(N) {
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodUnknown = u),
    (u.create = (ce) =>
      new u({
        typeName: X.ZodUnknown,
        ...g(ce),
      }));
  class d extends b {
    _parse(N) {
      const Y = this._getOrReturnCtx(N);
      return (
        (0, i.addIssueToContext)(Y, {
          code: a.ZodIssueCode.invalid_type,
          expected: l.ZodParsedType.never,
          received: Y.parsedType,
        }),
        i.INVALID
      );
    }
  }
  (t.ZodNever = d),
    (d.create = (ce) =>
      new d({
        typeName: X.ZodNever,
        ...g(ce),
      }));
  class y extends b {
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.undefined) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.void,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
  }
  (t.ZodVoid = y),
    (y.create = (ce) =>
      new y({
        typeName: X.ZodVoid,
        ...g(ce),
      }));
  class w extends b {
    _parse(N) {
      const { ctx: Y, status: ie } = this._processInputParams(N),
        ge = this._def;
      if (Y.parsedType !== l.ZodParsedType.array)
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.array,
            received: Y.parsedType,
          }),
          i.INVALID
        );
      if (ge.exactLength !== null) {
        const qe = Y.data.length > ge.exactLength.value,
          Pe = Y.data.length < ge.exactLength.value;
        (qe || Pe) &&
          ((0, i.addIssueToContext)(Y, {
            code: qe ? a.ZodIssueCode.too_big : a.ZodIssueCode.too_small,
            minimum: Pe ? ge.exactLength.value : void 0,
            maximum: qe ? ge.exactLength.value : void 0,
            type: "array",
            inclusive: !0,
            exact: !0,
            message: ge.exactLength.message,
          }),
          ie.dirty());
      }
      if (
        (ge.minLength !== null &&
          Y.data.length < ge.minLength.value &&
          ((0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.too_small,
            minimum: ge.minLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: ge.minLength.message,
          }),
          ie.dirty()),
        ge.maxLength !== null &&
          Y.data.length > ge.maxLength.value &&
          ((0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.too_big,
            maximum: ge.maxLength.value,
            type: "array",
            inclusive: !0,
            exact: !1,
            message: ge.maxLength.message,
          }),
          ie.dirty()),
        Y.common.async)
      )
        return Promise.all(
          [...Y.data].map((qe, Pe) => ge.type._parseAsync(new c(Y, qe, Y.path, Pe)))
        ).then((qe) => i.ParseStatus.mergeArray(ie, qe));
      const me = [...Y.data].map((qe, Pe) => ge.type._parseSync(new c(Y, qe, Y.path, Pe)));
      return i.ParseStatus.mergeArray(ie, me);
    }
    get element() {
      return this._def.type;
    }
    min(N, Y) {
      return new w({
        ...this._def,
        minLength: { value: N, message: n.errorUtil.toString(Y) },
      });
    }
    max(N, Y) {
      return new w({
        ...this._def,
        maxLength: { value: N, message: n.errorUtil.toString(Y) },
      });
    }
    length(N, Y) {
      return new w({
        ...this._def,
        exactLength: { value: N, message: n.errorUtil.toString(Y) },
      });
    }
    nonempty(N) {
      return this.min(1, N);
    }
  }
  (t.ZodArray = w),
    (w.create = (ce, N) =>
      new w({
        type: ce,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: X.ZodArray,
        ...g(N),
      }));
  function h(ce) {
    if (ce instanceof s) {
      const N = {};
      for (const Y in ce.shape) {
        const ie = ce.shape[Y];
        N[Y] = Ie.create(h(ie));
      }
      return new s({
        ...ce._def,
        shape: () => N,
      });
    } else
      return ce instanceof w
        ? new w({
            ...ce._def,
            type: h(ce.element),
          })
        : ce instanceof Ie
        ? Ie.create(h(ce.unwrap()))
        : ce instanceof be
        ? be.create(h(ce.unwrap()))
        : ce instanceof G
        ? G.create(ce.items.map((N) => h(N)))
        : ce;
  }
  class s extends b {
    constructor() {
      super(...arguments),
        (this._cached = null),
        (this.nonstrict = this.passthrough),
        (this.augment = this.extend);
    }
    _getCached() {
      if (this._cached !== null) return this._cached;
      const N = this._def.shape(),
        Y = l.util.objectKeys(N);
      return (this._cached = { shape: N, keys: Y });
    }
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.object) {
        const We = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(We, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.object,
            received: We.parsedType,
          }),
          i.INVALID
        );
      }
      const { status: ie, ctx: ge } = this._processInputParams(N),
        { shape: me, keys: qe } = this._getCached(),
        Pe = [];
      if (!(this._def.catchall instanceof d && this._def.unknownKeys === "strip"))
        for (const We in ge.data) qe.includes(We) || Pe.push(We);
      const Xe = [];
      for (const We of qe) {
        const rt = me[We],
          ct = ge.data[We];
        Xe.push({
          key: { status: "valid", value: We },
          value: rt._parse(new c(ge, ct, ge.path, We)),
          alwaysSet: We in ge.data,
        });
      }
      if (this._def.catchall instanceof d) {
        const We = this._def.unknownKeys;
        if (We === "passthrough")
          for (const rt of Pe)
            Xe.push({
              key: { status: "valid", value: rt },
              value: { status: "valid", value: ge.data[rt] },
            });
        else if (We === "strict")
          Pe.length > 0 &&
            ((0, i.addIssueToContext)(ge, {
              code: a.ZodIssueCode.unrecognized_keys,
              keys: Pe,
            }),
            ie.dirty());
        else if (We !== "strip")
          throw new Error("Internal ZodObject error: invalid unknownKeys value.");
      } else {
        const We = this._def.catchall;
        for (const rt of Pe) {
          const ct = ge.data[rt];
          Xe.push({
            key: { status: "valid", value: rt },
            value: We._parse(
              new c(ge, ct, ge.path, rt)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: rt in ge.data,
          });
        }
      }
      return ge.common.async
        ? Promise.resolve()
            .then(async () => {
              const We = [];
              for (const rt of Xe) {
                const ct = await rt.key;
                We.push({
                  key: ct,
                  value: await rt.value,
                  alwaysSet: rt.alwaysSet,
                });
              }
              return We;
            })
            .then((We) => i.ParseStatus.mergeObjectSync(ie, We))
        : i.ParseStatus.mergeObjectSync(ie, Xe);
    }
    get shape() {
      return this._def.shape();
    }
    strict(N) {
      return (
        n.errorUtil.errToObj,
        new s({
          ...this._def,
          unknownKeys: "strict",
          ...(N !== void 0
            ? {
                errorMap: (Y, ie) => {
                  var ge, me, qe, Pe;
                  const Xe =
                    (qe =
                      (me = (ge = this._def).errorMap) === null || me === void 0
                        ? void 0
                        : me.call(ge, Y, ie).message) !== null && qe !== void 0
                      ? qe
                      : ie.defaultError;
                  return Y.code === "unrecognized_keys"
                    ? {
                        message:
                          (Pe = n.errorUtil.errToObj(N).message) !== null && Pe !== void 0
                            ? Pe
                            : Xe,
                      }
                    : {
                        message: Xe,
                      };
                },
              }
            : {}),
        })
      );
    }
    strip() {
      return new s({
        ...this._def,
        unknownKeys: "strip",
      });
    }
    passthrough() {
      return new s({
        ...this._def,
        unknownKeys: "passthrough",
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(N) {
      return new s({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...N,
        }),
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(N) {
      return new s({
        unknownKeys: N._def.unknownKeys,
        catchall: N._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...N._def.shape(),
        }),
        typeName: X.ZodObject,
      });
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(N, Y) {
      return this.augment({ [N]: Y });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(N) {
      return new s({
        ...this._def,
        catchall: N,
      });
    }
    pick(N) {
      const Y = {};
      return (
        l.util.objectKeys(N).forEach((ie) => {
          N[ie] && this.shape[ie] && (Y[ie] = this.shape[ie]);
        }),
        new s({
          ...this._def,
          shape: () => Y,
        })
      );
    }
    omit(N) {
      const Y = {};
      return (
        l.util.objectKeys(this.shape).forEach((ie) => {
          N[ie] || (Y[ie] = this.shape[ie]);
        }),
        new s({
          ...this._def,
          shape: () => Y,
        })
      );
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return h(this);
    }
    partial(N) {
      const Y = {};
      return (
        l.util.objectKeys(this.shape).forEach((ie) => {
          const ge = this.shape[ie];
          N && !N[ie] ? (Y[ie] = ge) : (Y[ie] = ge.optional());
        }),
        new s({
          ...this._def,
          shape: () => Y,
        })
      );
    }
    required(N) {
      const Y = {};
      return (
        l.util.objectKeys(this.shape).forEach((ie) => {
          if (N && !N[ie]) Y[ie] = this.shape[ie];
          else {
            let me = this.shape[ie];
            for (; me instanceof Ie; ) me = me._def.innerType;
            Y[ie] = me;
          }
        }),
        new s({
          ...this._def,
          shape: () => Y,
        })
      );
    }
    keyof() {
      return ve(l.util.objectKeys(this.shape));
    }
  }
  (t.ZodObject = s),
    (s.create = (ce, N) =>
      new s({
        shape: () => ce,
        unknownKeys: "strip",
        catchall: d.create(),
        typeName: X.ZodObject,
        ...g(N),
      })),
    (s.strictCreate = (ce, N) =>
      new s({
        shape: () => ce,
        unknownKeys: "strict",
        catchall: d.create(),
        typeName: X.ZodObject,
        ...g(N),
      })),
    (s.lazycreate = (ce, N) =>
      new s({
        shape: ce,
        unknownKeys: "strip",
        catchall: d.create(),
        typeName: X.ZodObject,
        ...g(N),
      }));
  class m extends b {
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N),
        ie = this._def.options;
      function ge(me) {
        for (const Pe of me) if (Pe.result.status === "valid") return Pe.result;
        for (const Pe of me)
          if (Pe.result.status === "dirty")
            return Y.common.issues.push(...Pe.ctx.common.issues), Pe.result;
        const qe = me.map((Pe) => new a.ZodError(Pe.ctx.common.issues));
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_union,
            unionErrors: qe,
          }),
          i.INVALID
        );
      }
      if (Y.common.async)
        return Promise.all(
          ie.map(async (me) => {
            const qe = {
              ...Y,
              common: {
                ...Y.common,
                issues: [],
              },
              parent: null,
            };
            return {
              result: await me._parseAsync({
                data: Y.data,
                path: Y.path,
                parent: qe,
              }),
              ctx: qe,
            };
          })
        ).then(ge);
      {
        let me;
        const qe = [];
        for (const Xe of ie) {
          const We = {
              ...Y,
              common: {
                ...Y.common,
                issues: [],
              },
              parent: null,
            },
            rt = Xe._parseSync({
              data: Y.data,
              path: Y.path,
              parent: We,
            });
          if (rt.status === "valid") return rt;
          rt.status === "dirty" && !me && (me = { result: rt, ctx: We }),
            We.common.issues.length && qe.push(We.common.issues);
        }
        if (me) return Y.common.issues.push(...me.ctx.common.issues), me.result;
        const Pe = qe.map((Xe) => new a.ZodError(Xe));
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_union,
            unionErrors: Pe,
          }),
          i.INVALID
        );
      }
    }
    get options() {
      return this._def.options;
    }
  }
  (t.ZodUnion = m),
    (m.create = (ce, N) =>
      new m({
        options: ce,
        typeName: X.ZodUnion,
        ...g(N),
      }));
  const E = (ce) =>
    ce instanceof ae
      ? E(ce.schema)
      : ce instanceof ut
      ? E(ce.innerType())
      : ce instanceof K
      ? [ce.value]
      : ce instanceof Ye
      ? ce.options
      : ce instanceof Ce
      ? Object.keys(ce.enum)
      : ce instanceof wt
      ? E(ce._def.innerType)
      : ce instanceof r
      ? [void 0]
      : ce instanceof o
      ? [null]
      : null;
  class R extends b {
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N);
      if (Y.parsedType !== l.ZodParsedType.object)
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.object,
            received: Y.parsedType,
          }),
          i.INVALID
        );
      const ie = this.discriminator,
        ge = Y.data[ie],
        me = this.optionsMap.get(ge);
      return me
        ? Y.common.async
          ? me._parseAsync({
              data: Y.data,
              path: Y.path,
              parent: Y,
            })
          : me._parseSync({
              data: Y.data,
              path: Y.path,
              parent: Y,
            })
        : ((0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_union_discriminator,
            options: Array.from(this.optionsMap.keys()),
            path: [ie],
          }),
          i.INVALID);
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(N, Y, ie) {
      const ge = /* @__PURE__ */ new Map();
      for (const me of Y) {
        const qe = E(me.shape[N]);
        if (!qe)
          throw new Error(
            `A discriminator value for key \`${N}\` could not be extracted from all schema options`
          );
        for (const Pe of qe) {
          if (ge.has(Pe))
            throw new Error(
              `Discriminator property ${String(N)} has duplicate value ${String(Pe)}`
            );
          ge.set(Pe, me);
        }
      }
      return new R({
        typeName: X.ZodDiscriminatedUnion,
        discriminator: N,
        options: Y,
        optionsMap: ge,
        ...g(ie),
      });
    }
  }
  t.ZodDiscriminatedUnion = R;
  function z(ce, N) {
    const Y = (0, l.getParsedType)(ce),
      ie = (0, l.getParsedType)(N);
    if (ce === N) return { valid: !0, data: ce };
    if (Y === l.ZodParsedType.object && ie === l.ZodParsedType.object) {
      const ge = l.util.objectKeys(N),
        me = l.util.objectKeys(ce).filter((Pe) => ge.indexOf(Pe) !== -1),
        qe = { ...ce, ...N };
      for (const Pe of me) {
        const Xe = z(ce[Pe], N[Pe]);
        if (!Xe.valid) return { valid: !1 };
        qe[Pe] = Xe.data;
      }
      return { valid: !0, data: qe };
    } else if (Y === l.ZodParsedType.array && ie === l.ZodParsedType.array) {
      if (ce.length !== N.length) return { valid: !1 };
      const ge = [];
      for (let me = 0; me < ce.length; me++) {
        const qe = ce[me],
          Pe = N[me],
          Xe = z(qe, Pe);
        if (!Xe.valid) return { valid: !1 };
        ge.push(Xe.data);
      }
      return { valid: !0, data: ge };
    } else
      return Y === l.ZodParsedType.date && ie === l.ZodParsedType.date && +ce == +N
        ? { valid: !0, data: ce }
        : { valid: !1 };
  }
  class Q extends b {
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N),
        ge = (me, qe) => {
          if ((0, i.isAborted)(me) || (0, i.isAborted)(qe)) return i.INVALID;
          const Pe = z(me.value, qe.value);
          return Pe.valid
            ? (((0, i.isDirty)(me) || (0, i.isDirty)(qe)) && Y.dirty(),
              { status: Y.value, value: Pe.data })
            : ((0, i.addIssueToContext)(ie, {
                code: a.ZodIssueCode.invalid_intersection_types,
              }),
              i.INVALID);
        };
      return ie.common.async
        ? Promise.all([
            this._def.left._parseAsync({
              data: ie.data,
              path: ie.path,
              parent: ie,
            }),
            this._def.right._parseAsync({
              data: ie.data,
              path: ie.path,
              parent: ie,
            }),
          ]).then(([me, qe]) => ge(me, qe))
        : ge(
            this._def.left._parseSync({
              data: ie.data,
              path: ie.path,
              parent: ie,
            }),
            this._def.right._parseSync({
              data: ie.data,
              path: ie.path,
              parent: ie,
            })
          );
    }
  }
  (t.ZodIntersection = Q),
    (Q.create = (ce, N, Y) =>
      new Q({
        left: ce,
        right: N,
        typeName: X.ZodIntersection,
        ...g(Y),
      }));
  class G extends b {
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N);
      if (ie.parsedType !== l.ZodParsedType.array)
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.array,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      if (ie.data.length < this._def.items.length)
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.too_small,
            minimum: this._def.items.length,
            inclusive: !0,
            exact: !1,
            type: "array",
          }),
          i.INVALID
        );
      !this._def.rest &&
        ie.data.length > this._def.items.length &&
        ((0, i.addIssueToContext)(ie, {
          code: a.ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: !0,
          exact: !1,
          type: "array",
        }),
        Y.dirty());
      const me = [...ie.data]
        .map((qe, Pe) => {
          const Xe = this._def.items[Pe] || this._def.rest;
          return Xe ? Xe._parse(new c(ie, qe, ie.path, Pe)) : null;
        })
        .filter((qe) => !!qe);
      return ie.common.async
        ? Promise.all(me).then((qe) => i.ParseStatus.mergeArray(Y, qe))
        : i.ParseStatus.mergeArray(Y, me);
    }
    get items() {
      return this._def.items;
    }
    rest(N) {
      return new G({
        ...this._def,
        rest: N,
      });
    }
  }
  (t.ZodTuple = G),
    (G.create = (ce, N) => {
      if (!Array.isArray(ce))
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
      return new G({
        items: ce,
        typeName: X.ZodTuple,
        rest: null,
        ...g(N),
      });
    });
  class q extends b {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N);
      if (ie.parsedType !== l.ZodParsedType.object)
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.object,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      const ge = [],
        me = this._def.keyType,
        qe = this._def.valueType;
      for (const Pe in ie.data)
        ge.push({
          key: me._parse(new c(ie, Pe, ie.path, Pe)),
          value: qe._parse(new c(ie, ie.data[Pe], ie.path, Pe)),
        });
      return ie.common.async
        ? i.ParseStatus.mergeObjectAsync(Y, ge)
        : i.ParseStatus.mergeObjectSync(Y, ge);
    }
    get element() {
      return this._def.valueType;
    }
    static create(N, Y, ie) {
      return Y instanceof b
        ? new q({
            keyType: N,
            valueType: Y,
            typeName: X.ZodRecord,
            ...g(ie),
          })
        : new q({
            keyType: $.create(),
            valueType: N,
            typeName: X.ZodRecord,
            ...g(Y),
          });
    }
  }
  t.ZodRecord = q;
  class Z extends b {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N);
      if (ie.parsedType !== l.ZodParsedType.map)
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.map,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      const ge = this._def.keyType,
        me = this._def.valueType,
        qe = [...ie.data.entries()].map(([Pe, Xe], We) => ({
          key: ge._parse(new c(ie, Pe, ie.path, [We, "key"])),
          value: me._parse(new c(ie, Xe, ie.path, [We, "value"])),
        }));
      if (ie.common.async) {
        const Pe = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const Xe of qe) {
            const We = await Xe.key,
              rt = await Xe.value;
            if (We.status === "aborted" || rt.status === "aborted") return i.INVALID;
            (We.status === "dirty" || rt.status === "dirty") && Y.dirty(),
              Pe.set(We.value, rt.value);
          }
          return { status: Y.value, value: Pe };
        });
      } else {
        const Pe = /* @__PURE__ */ new Map();
        for (const Xe of qe) {
          const We = Xe.key,
            rt = Xe.value;
          if (We.status === "aborted" || rt.status === "aborted") return i.INVALID;
          (We.status === "dirty" || rt.status === "dirty") && Y.dirty(), Pe.set(We.value, rt.value);
        }
        return { status: Y.value, value: Pe };
      }
    }
  }
  (t.ZodMap = Z),
    (Z.create = (ce, N, Y) =>
      new Z({
        valueType: N,
        keyType: ce,
        typeName: X.ZodMap,
        ...g(Y),
      }));
  class te extends b {
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N);
      if (ie.parsedType !== l.ZodParsedType.set)
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.set,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      const ge = this._def;
      ge.minSize !== null &&
        ie.data.size < ge.minSize.value &&
        ((0, i.addIssueToContext)(ie, {
          code: a.ZodIssueCode.too_small,
          minimum: ge.minSize.value,
          type: "set",
          inclusive: !0,
          exact: !1,
          message: ge.minSize.message,
        }),
        Y.dirty()),
        ge.maxSize !== null &&
          ie.data.size > ge.maxSize.value &&
          ((0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.too_big,
            maximum: ge.maxSize.value,
            type: "set",
            inclusive: !0,
            exact: !1,
            message: ge.maxSize.message,
          }),
          Y.dirty());
      const me = this._def.valueType;
      function qe(Xe) {
        const We = /* @__PURE__ */ new Set();
        for (const rt of Xe) {
          if (rt.status === "aborted") return i.INVALID;
          rt.status === "dirty" && Y.dirty(), We.add(rt.value);
        }
        return { status: Y.value, value: We };
      }
      const Pe = [...ie.data.values()].map((Xe, We) => me._parse(new c(ie, Xe, ie.path, We)));
      return ie.common.async ? Promise.all(Pe).then((Xe) => qe(Xe)) : qe(Pe);
    }
    min(N, Y) {
      return new te({
        ...this._def,
        minSize: { value: N, message: n.errorUtil.toString(Y) },
      });
    }
    max(N, Y) {
      return new te({
        ...this._def,
        maxSize: { value: N, message: n.errorUtil.toString(Y) },
      });
    }
    size(N, Y) {
      return this.min(N, Y).max(N, Y);
    }
    nonempty(N) {
      return this.min(1, N);
    }
  }
  (t.ZodSet = te),
    (te.create = (ce, N) =>
      new te({
        valueType: ce,
        minSize: null,
        maxSize: null,
        typeName: X.ZodSet,
        ...g(N),
      }));
  class ue extends b {
    constructor() {
      super(...arguments), (this.validate = this.implement);
    }
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N);
      if (Y.parsedType !== l.ZodParsedType.function)
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.function,
            received: Y.parsedType,
          }),
          i.INVALID
        );
      function ie(Pe, Xe) {
        return (0, i.makeIssue)({
          data: Pe,
          path: Y.path,
          errorMaps: [
            Y.common.contextualErrorMap,
            Y.schemaErrorMap,
            (0, e.getErrorMap)(),
            e.defaultErrorMap,
          ].filter((We) => !!We),
          issueData: {
            code: a.ZodIssueCode.invalid_arguments,
            argumentsError: Xe,
          },
        });
      }
      function ge(Pe, Xe) {
        return (0, i.makeIssue)({
          data: Pe,
          path: Y.path,
          errorMaps: [
            Y.common.contextualErrorMap,
            Y.schemaErrorMap,
            (0, e.getErrorMap)(),
            e.defaultErrorMap,
          ].filter((We) => !!We),
          issueData: {
            code: a.ZodIssueCode.invalid_return_type,
            returnTypeError: Xe,
          },
        });
      }
      const me = { errorMap: Y.common.contextualErrorMap },
        qe = Y.data;
      if (this._def.returns instanceof Te) {
        const Pe = this;
        return (0, i.OK)(async function (...Xe) {
          const We = new a.ZodError([]),
            rt = await Pe._def.args.parseAsync(Xe, me).catch((Fe) => {
              throw (We.addIssue(ie(Xe, Fe)), We);
            }),
            ct = await Reflect.apply(qe, this, rt);
          return await Pe._def.returns._def.type.parseAsync(ct, me).catch((Fe) => {
            throw (We.addIssue(ge(ct, Fe)), We);
          });
        });
      } else {
        const Pe = this;
        return (0, i.OK)(function (...Xe) {
          const We = Pe._def.args.safeParse(Xe, me);
          if (!We.success) throw new a.ZodError([ie(Xe, We.error)]);
          const rt = Reflect.apply(qe, this, We.data),
            ct = Pe._def.returns.safeParse(rt, me);
          if (!ct.success) throw new a.ZodError([ge(rt, ct.error)]);
          return ct.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...N) {
      return new ue({
        ...this._def,
        args: G.create(N).rest(u.create()),
      });
    }
    returns(N) {
      return new ue({
        ...this._def,
        returns: N,
      });
    }
    implement(N) {
      return this.parse(N);
    }
    strictImplement(N) {
      return this.parse(N);
    }
    static create(N, Y, ie) {
      return new ue({
        args: N || G.create([]).rest(u.create()),
        returns: Y || u.create(),
        typeName: X.ZodFunction,
        ...g(ie),
      });
    }
  }
  t.ZodFunction = ue;
  class ae extends b {
    get schema() {
      return this._def.getter();
    }
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N);
      return this._def.getter()._parse({ data: Y.data, path: Y.path, parent: Y });
    }
  }
  (t.ZodLazy = ae),
    (ae.create = (ce, N) =>
      new ae({
        getter: ce,
        typeName: X.ZodLazy,
        ...g(N),
      }));
  class K extends b {
    _parse(N) {
      if (N.data !== this._def.value) {
        const Y = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(Y, {
            received: Y.data,
            code: a.ZodIssueCode.invalid_literal,
            expected: this._def.value,
          }),
          i.INVALID
        );
      }
      return { status: "valid", value: N.data };
    }
    get value() {
      return this._def.value;
    }
  }
  (t.ZodLiteral = K),
    (K.create = (ce, N) =>
      new K({
        value: ce,
        typeName: X.ZodLiteral,
        ...g(N),
      }));
  function ve(ce, N) {
    return new Ye({
      values: ce,
      typeName: X.ZodEnum,
      ...g(N),
    });
  }
  class Ye extends b {
    _parse(N) {
      if (typeof N.data != "string") {
        const Y = this._getOrReturnCtx(N),
          ie = this._def.values;
        return (
          (0, i.addIssueToContext)(Y, {
            expected: l.util.joinValues(ie),
            received: Y.parsedType,
            code: a.ZodIssueCode.invalid_type,
          }),
          i.INVALID
        );
      }
      if (this._def.values.indexOf(N.data) === -1) {
        const Y = this._getOrReturnCtx(N),
          ie = this._def.values;
        return (
          (0, i.addIssueToContext)(Y, {
            received: Y.data,
            code: a.ZodIssueCode.invalid_enum_value,
            options: ie,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const N = {};
      for (const Y of this._def.values) N[Y] = Y;
      return N;
    }
    get Values() {
      const N = {};
      for (const Y of this._def.values) N[Y] = Y;
      return N;
    }
    get Enum() {
      const N = {};
      for (const Y of this._def.values) N[Y] = Y;
      return N;
    }
    extract(N) {
      return Ye.create(N);
    }
    exclude(N) {
      return Ye.create(this.options.filter((Y) => !N.includes(Y)));
    }
  }
  (t.ZodEnum = Ye), (Ye.create = ve);
  class Ce extends b {
    _parse(N) {
      const Y = l.util.getValidEnumValues(this._def.values),
        ie = this._getOrReturnCtx(N);
      if (ie.parsedType !== l.ZodParsedType.string && ie.parsedType !== l.ZodParsedType.number) {
        const ge = l.util.objectValues(Y);
        return (
          (0, i.addIssueToContext)(ie, {
            expected: l.util.joinValues(ge),
            received: ie.parsedType,
            code: a.ZodIssueCode.invalid_type,
          }),
          i.INVALID
        );
      }
      if (Y.indexOf(N.data) === -1) {
        const ge = l.util.objectValues(Y);
        return (
          (0, i.addIssueToContext)(ie, {
            received: ie.data,
            code: a.ZodIssueCode.invalid_enum_value,
            options: ge,
          }),
          i.INVALID
        );
      }
      return (0, i.OK)(N.data);
    }
    get enum() {
      return this._def.values;
    }
  }
  (t.ZodNativeEnum = Ce),
    (Ce.create = (ce, N) =>
      new Ce({
        values: ce,
        typeName: X.ZodNativeEnum,
        ...g(N),
      }));
  class Te extends b {
    unwrap() {
      return this._def.type;
    }
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N);
      if (Y.parsedType !== l.ZodParsedType.promise && Y.common.async === !1)
        return (
          (0, i.addIssueToContext)(Y, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.promise,
            received: Y.parsedType,
          }),
          i.INVALID
        );
      const ie = Y.parsedType === l.ZodParsedType.promise ? Y.data : Promise.resolve(Y.data);
      return (0, i.OK)(
        ie.then((ge) =>
          this._def.type.parseAsync(ge, {
            path: Y.path,
            errorMap: Y.common.contextualErrorMap,
          })
        )
      );
    }
  }
  (t.ZodPromise = Te),
    (Te.create = (ce, N) =>
      new Te({
        type: ce,
        typeName: X.ZodPromise,
        ...g(N),
      }));
  class ut extends b {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === X.ZodEffects
        ? this._def.schema.sourceType()
        : this._def.schema;
    }
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N),
        ge = this._def.effect || null,
        me = {
          addIssue: (qe) => {
            (0, i.addIssueToContext)(ie, qe), qe.fatal ? Y.abort() : Y.dirty();
          },
          get path() {
            return ie.path;
          },
        };
      if (((me.addIssue = me.addIssue.bind(me)), ge.type === "preprocess")) {
        const qe = ge.transform(ie.data, me);
        return ie.common.issues.length
          ? {
              status: "dirty",
              value: ie.data,
            }
          : ie.common.async
          ? Promise.resolve(qe).then((Pe) =>
              this._def.schema._parseAsync({
                data: Pe,
                path: ie.path,
                parent: ie,
              })
            )
          : this._def.schema._parseSync({
              data: qe,
              path: ie.path,
              parent: ie,
            });
      }
      if (ge.type === "refinement") {
        const qe = (Pe) => {
          const Xe = ge.refinement(Pe, me);
          if (ie.common.async) return Promise.resolve(Xe);
          if (Xe instanceof Promise)
            throw new Error(
              "Async refinement encountered during synchronous parse operation. Use .parseAsync instead."
            );
          return Pe;
        };
        if (ie.common.async === !1) {
          const Pe = this._def.schema._parseSync({
            data: ie.data,
            path: ie.path,
            parent: ie,
          });
          return Pe.status === "aborted"
            ? i.INVALID
            : (Pe.status === "dirty" && Y.dirty(),
              qe(Pe.value),
              { status: Y.value, value: Pe.value });
        } else
          return this._def.schema
            ._parseAsync({ data: ie.data, path: ie.path, parent: ie })
            .then((Pe) =>
              Pe.status === "aborted"
                ? i.INVALID
                : (Pe.status === "dirty" && Y.dirty(),
                  qe(Pe.value).then(() => ({ status: Y.value, value: Pe.value })))
            );
      }
      if (ge.type === "transform")
        if (ie.common.async === !1) {
          const qe = this._def.schema._parseSync({
            data: ie.data,
            path: ie.path,
            parent: ie,
          });
          if (!(0, i.isValid)(qe)) return qe;
          const Pe = ge.transform(qe.value, me);
          if (Pe instanceof Promise)
            throw new Error(
              "Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead."
            );
          return { status: Y.value, value: Pe };
        } else
          return this._def.schema
            ._parseAsync({ data: ie.data, path: ie.path, parent: ie })
            .then((qe) =>
              (0, i.isValid)(qe)
                ? Promise.resolve(ge.transform(qe.value, me)).then((Pe) => ({
                    status: Y.value,
                    value: Pe,
                  }))
                : qe
            );
      l.util.assertNever(ge);
    }
  }
  (t.ZodEffects = ut),
    (t.ZodTransformer = ut),
    (ut.create = (ce, N, Y) =>
      new ut({
        schema: ce,
        typeName: X.ZodEffects,
        effect: N,
        ...g(Y),
      })),
    (ut.createWithPreprocess = (ce, N, Y) =>
      new ut({
        schema: N,
        effect: { type: "preprocess", transform: ce },
        typeName: X.ZodEffects,
        ...g(Y),
      }));
  class Ie extends b {
    _parse(N) {
      return this._getType(N) === l.ZodParsedType.undefined
        ? (0, i.OK)(void 0)
        : this._def.innerType._parse(N);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  (t.ZodOptional = Ie),
    (Ie.create = (ce, N) =>
      new Ie({
        innerType: ce,
        typeName: X.ZodOptional,
        ...g(N),
      }));
  class be extends b {
    _parse(N) {
      return this._getType(N) === l.ZodParsedType.null
        ? (0, i.OK)(null)
        : this._def.innerType._parse(N);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  (t.ZodNullable = be),
    (be.create = (ce, N) =>
      new be({
        innerType: ce,
        typeName: X.ZodNullable,
        ...g(N),
      }));
  class wt extends b {
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N);
      let ie = Y.data;
      return (
        Y.parsedType === l.ZodParsedType.undefined && (ie = this._def.defaultValue()),
        this._def.innerType._parse({
          data: ie,
          path: Y.path,
          parent: Y,
        })
      );
    }
    removeDefault() {
      return this._def.innerType;
    }
  }
  (t.ZodDefault = wt),
    (wt.create = (ce, N) =>
      new wt({
        innerType: ce,
        typeName: X.ZodDefault,
        defaultValue: typeof N.default == "function" ? N.default : () => N.default,
        ...g(N),
      }));
  class Oe extends b {
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N),
        ie = {
          ...Y,
          common: {
            ...Y.common,
            issues: [],
          },
        },
        ge = this._def.innerType._parse({
          data: ie.data,
          path: ie.path,
          parent: {
            ...ie,
          },
        });
      return (0, i.isAsync)(ge)
        ? ge.then((me) => ({
            status: "valid",
            value:
              me.status === "valid"
                ? me.value
                : this._def.catchValue({
                    get error() {
                      return new a.ZodError(ie.common.issues);
                    },
                    input: ie.data,
                  }),
          }))
        : {
            status: "valid",
            value:
              ge.status === "valid"
                ? ge.value
                : this._def.catchValue({
                    get error() {
                      return new a.ZodError(ie.common.issues);
                    },
                    input: ie.data,
                  }),
          };
    }
    removeCatch() {
      return this._def.innerType;
    }
  }
  (t.ZodCatch = Oe),
    (Oe.create = (ce, N) =>
      new Oe({
        innerType: ce,
        typeName: X.ZodCatch,
        catchValue: typeof N.catch == "function" ? N.catch : () => N.catch,
        ...g(N),
      }));
  class je extends b {
    _parse(N) {
      if (this._getType(N) !== l.ZodParsedType.nan) {
        const ie = this._getOrReturnCtx(N);
        return (
          (0, i.addIssueToContext)(ie, {
            code: a.ZodIssueCode.invalid_type,
            expected: l.ZodParsedType.nan,
            received: ie.parsedType,
          }),
          i.INVALID
        );
      }
      return { status: "valid", value: N.data };
    }
  }
  (t.ZodNaN = je),
    (je.create = (ce) =>
      new je({
        typeName: X.ZodNaN,
        ...g(ce),
      })),
    (t.BRAND = Symbol("zod_brand"));
  class xt extends b {
    _parse(N) {
      const { ctx: Y } = this._processInputParams(N),
        ie = Y.data;
      return this._def.type._parse({
        data: ie,
        path: Y.path,
        parent: Y,
      });
    }
    unwrap() {
      return this._def.type;
    }
  }
  t.ZodBranded = xt;
  class Ue extends b {
    _parse(N) {
      const { status: Y, ctx: ie } = this._processInputParams(N);
      if (ie.common.async)
        return (async () => {
          const me = await this._def.in._parseAsync({
            data: ie.data,
            path: ie.path,
            parent: ie,
          });
          return me.status === "aborted"
            ? i.INVALID
            : me.status === "dirty"
            ? (Y.dirty(), (0, i.DIRTY)(me.value))
            : this._def.out._parseAsync({
                data: me.value,
                path: ie.path,
                parent: ie,
              });
        })();
      {
        const ge = this._def.in._parseSync({
          data: ie.data,
          path: ie.path,
          parent: ie,
        });
        return ge.status === "aborted"
          ? i.INVALID
          : ge.status === "dirty"
          ? (Y.dirty(),
            {
              status: "dirty",
              value: ge.value,
            })
          : this._def.out._parseSync({
              data: ge.value,
              path: ie.path,
              parent: ie,
            });
      }
    }
    static create(N, Y) {
      return new Ue({
        in: N,
        out: Y,
        typeName: X.ZodPipeline,
      });
    }
  }
  t.ZodPipeline = Ue;
  class se extends b {
    _parse(N) {
      const Y = this._def.innerType._parse(N);
      return (0, i.isValid)(Y) && (Y.value = Object.freeze(Y.value)), Y;
    }
  }
  (t.ZodReadonly = se),
    (se.create = (ce, N) =>
      new se({
        innerType: ce,
        typeName: X.ZodReadonly,
        ...g(N),
      }));
  const oe = (ce, N = {}, Y) =>
    ce
      ? f.create().superRefine((ie, ge) => {
          var me, qe;
          if (!ce(ie)) {
            const Pe = typeof N == "function" ? N(ie) : typeof N == "string" ? { message: N } : N,
              Xe =
                (qe = (me = Pe.fatal) !== null && me !== void 0 ? me : Y) !== null && qe !== void 0
                  ? qe
                  : !0,
              We = typeof Pe == "string" ? { message: Pe } : Pe;
            ge.addIssue({ code: "custom", ...We, fatal: Xe });
          }
        })
      : f.create();
  (t.custom = oe),
    (t.late = {
      object: s.lazycreate,
    });
  var X;
  (function (ce) {
    (ce.ZodString = "ZodString"),
      (ce.ZodNumber = "ZodNumber"),
      (ce.ZodNaN = "ZodNaN"),
      (ce.ZodBigInt = "ZodBigInt"),
      (ce.ZodBoolean = "ZodBoolean"),
      (ce.ZodDate = "ZodDate"),
      (ce.ZodSymbol = "ZodSymbol"),
      (ce.ZodUndefined = "ZodUndefined"),
      (ce.ZodNull = "ZodNull"),
      (ce.ZodAny = "ZodAny"),
      (ce.ZodUnknown = "ZodUnknown"),
      (ce.ZodNever = "ZodNever"),
      (ce.ZodVoid = "ZodVoid"),
      (ce.ZodArray = "ZodArray"),
      (ce.ZodObject = "ZodObject"),
      (ce.ZodUnion = "ZodUnion"),
      (ce.ZodDiscriminatedUnion = "ZodDiscriminatedUnion"),
      (ce.ZodIntersection = "ZodIntersection"),
      (ce.ZodTuple = "ZodTuple"),
      (ce.ZodRecord = "ZodRecord"),
      (ce.ZodMap = "ZodMap"),
      (ce.ZodSet = "ZodSet"),
      (ce.ZodFunction = "ZodFunction"),
      (ce.ZodLazy = "ZodLazy"),
      (ce.ZodLiteral = "ZodLiteral"),
      (ce.ZodEnum = "ZodEnum"),
      (ce.ZodEffects = "ZodEffects"),
      (ce.ZodNativeEnum = "ZodNativeEnum"),
      (ce.ZodOptional = "ZodOptional"),
      (ce.ZodNullable = "ZodNullable"),
      (ce.ZodDefault = "ZodDefault"),
      (ce.ZodCatch = "ZodCatch"),
      (ce.ZodPromise = "ZodPromise"),
      (ce.ZodBranded = "ZodBranded"),
      (ce.ZodPipeline = "ZodPipeline"),
      (ce.ZodReadonly = "ZodReadonly");
  })((X = t.ZodFirstPartyTypeKind || (t.ZodFirstPartyTypeKind = {})));
  const le = (
    ce,
    N = {
      message: `Input not instance of ${ce.name}`,
    }
  ) => (0, t.custom)((Y) => Y instanceof ce, N);
  t.instanceof = le;
  const ke = $.create;
  t.string = ke;
  const I = he.create;
  t.number = I;
  const C = je.create;
  t.nan = C;
  const L = de.create;
  t.bigint = L;
  const j = ne.create;
  t.boolean = j;
  const ee = Ae.create;
  t.date = ee;
  const Me = x.create;
  t.symbol = Me;
  const fe = r.create;
  t.undefined = fe;
  const Se = o.create;
  t.null = Se;
  const ot = f.create;
  t.any = ot;
  const we = u.create;
  t.unknown = we;
  const Re = d.create;
  t.never = Re;
  const at = y.create;
  t.void = at;
  const Ne = w.create;
  t.array = Ne;
  const He = s.create;
  t.object = He;
  const At = s.strictCreate;
  t.strictObject = At;
  const Le = m.create;
  t.union = Le;
  const Ze = R.create;
  t.discriminatedUnion = Ze;
  const Tt = Q.create;
  t.intersection = Tt;
  const Ve = G.create;
  t.tuple = Ve;
  const Je = q.create;
  t.record = Je;
  const Rt = Z.create;
  t.map = Rt;
  const $e = te.create;
  t.set = $e;
  const et = ue.create;
  t.function = et;
  const H = ae.create;
  t.lazy = H;
  const V = K.create;
  t.literal = V;
  const W = Ye.create;
  t.enum = W;
  const U = Ce.create;
  t.nativeEnum = U;
  const D = Te.create;
  t.promise = D;
  const re = ut.create;
  (t.effect = re), (t.transformer = re);
  const ye = Ie.create;
  t.optional = ye;
  const pe = be.create;
  t.nullable = pe;
  const xe = ut.createWithPreprocess;
  t.preprocess = xe;
  const tt = Ue.create;
  t.pipeline = tt;
  const Ke = () => ke().optional();
  t.ostring = Ke;
  const dt = () => I().optional();
  t.onumber = dt;
  const st = () => j().optional();
  (t.oboolean = st),
    (t.coerce = {
      string: (ce) => $.create({ ...ce, coerce: !0 }),
      number: (ce) => he.create({ ...ce, coerce: !0 }),
      boolean: (ce) =>
        ne.create({
          ...ce,
          coerce: !0,
        }),
      bigint: (ce) => de.create({ ...ce, coerce: !0 }),
      date: (ce) => Ae.create({ ...ce, coerce: !0 }),
    }),
    (t.NEVER = i.INVALID);
})(M8);
(function (t) {
  var e =
      (mt && mt.__createBinding) ||
      (Object.create
        ? function (i, l, a, c) {
            c === void 0 && (c = a),
              Object.defineProperty(i, c, {
                enumerable: !0,
                get: function () {
                  return l[a];
                },
              });
          }
        : function (i, l, a, c) {
            c === void 0 && (c = a), (i[c] = l[a]);
          }),
    n =
      (mt && mt.__exportStar) ||
      function (i, l) {
        for (var a in i)
          a !== "default" && !Object.prototype.hasOwnProperty.call(l, a) && e(l, i, a);
      };
  Object.defineProperty(t, "__esModule", { value: !0 }),
    n(Yn, t),
    n(Am, t),
    n(x8, t),
    n(zf, t),
    n(M8, t),
    n(Jn, t);
})(jp);
(function (t) {
  var e =
      (mt && mt.__createBinding) ||
      (Object.create
        ? function (c, v, g, b) {
            b === void 0 && (b = g),
              Object.defineProperty(c, b, {
                enumerable: !0,
                get: function () {
                  return v[g];
                },
              });
          }
        : function (c, v, g, b) {
            b === void 0 && (b = g), (c[b] = v[g]);
          }),
    n =
      (mt && mt.__setModuleDefault) ||
      (Object.create
        ? function (c, v) {
            Object.defineProperty(c, "default", { enumerable: !0, value: v });
          }
        : function (c, v) {
            c.default = v;
          }),
    i =
      (mt && mt.__importStar) ||
      function (c) {
        if (c && c.__esModule) return c;
        var v = {};
        if (c != null)
          for (var g in c)
            g !== "default" && Object.prototype.hasOwnProperty.call(c, g) && e(v, c, g);
        return n(v, c), v;
      },
    l =
      (mt && mt.__exportStar) ||
      function (c, v) {
        for (var g in c)
          g !== "default" && !Object.prototype.hasOwnProperty.call(v, g) && e(v, c, g);
      };
  Object.defineProperty(t, "__esModule", { value: !0 }), (t.z = void 0);
  const a = i(jp);
  (t.z = a), l(jp, t), (t.default = a);
})(Em);
const cC = "@ton/ton",
  hC = "13.11.1",
  dC = "https://github.com/ton-org/ton.git",
  pC = "Whales Corp. <developers@whalescorp.com>",
  mC = "MIT",
  vC = "dist/index.js",
  gC = ["dist"],
  yC = {
    docs: "rm -fr docs && typedoc src/index.ts",
    build: "rm -fr dist && tsc --declaration",
    test: "jest --verbose --runInBand",
    release: "yarn build && yarn release-it --npm.yarn1",
  },
  bC = {
    "@release-it/keep-a-changelog": "^5.0.0",
    "@ton/core": "^0.56.0",
    "@ton/crypto": "3.2.0",
    "@ton/emulator": "^2.1.1",
    "@types/jest": "^27.0.1",
    "@types/node": "^16.7.10",
    buffer: "^6.0.3",
    expect: "^27.1.0",
    jest: "^27.1.0",
    "jest-mock": "^27.1.0",
    karma: "^6.3.4",
    "karma-chrome-launcher": "^3.1.0",
    "karma-jasmine": "^4.0.1",
    "karma-typescript": "^5.5.2",
    "karma-webpack": "^5.0.0",
    prando: "^6.0.1",
    "release-it": "^17.1.1",
    "ts-jest": "^27.0.5",
    "ts-loader": "^9.2.5",
    "ts-node": "^10.7.0",
    typedoc: "^0.23.24",
    typescript: "^4.4.2",
    webpack: "^5.51.2",
  },
  wC = {
    axios: "^1.6.7",
    dataloader: "^2.0.0",
    "symbol.inspect": "1.0.1",
    teslabot: "^1.3.0",
    zod: "^3.21.4",
  },
  _C = {
    "@ton/core": ">=0.56.0",
    "@ton/crypto": ">=3.2.0",
  },
  xC = {
    access: "public",
    registry: "https://registry.npmjs.org/",
  },
  MC = "yarn@3.4.1",
  SC = {
    name: cC,
    version: hC,
    repository: dC,
    author: pC,
    license: mC,
    main: vC,
    files: gC,
    scripts: yC,
    devDependencies: bC,
    dependencies: wC,
    peerDependencies: _C,
    publishConfig: xC,
    "release-it": {
      github: {
        release: !0,
      },
      plugins: {
        "@release-it/keep-a-changelog": {
          filename: "CHANGELOG.md",
        },
      },
    },
    packageManager: MC,
  };
var E8 =
  (mt && mt.__importDefault) ||
  function (t) {
    return t && t.__esModule ? t : { default: t };
  };
Object.defineProperty(Lf, "__esModule", { value: !0 });
Lf.HttpApi = void 0;
const EC = sc,
  U2 = E8(jk),
  AC = E8(y8),
  yt = Em,
  kC = SC.version,
  Gs = yt.z.object({
    "@type": yt.z.literal("ton.blockIdExt"),
    workchain: yt.z.number(),
    shard: yt.z.string(),
    seqno: yt.z.number(),
    root_hash: yt.z.string(),
    file_hash: yt.z.string(),
  }),
  BC = yt.z.object({
    balance: yt.z.union([yt.z.number(), yt.z.string()]),
    state: yt.z.union([
      yt.z.literal("active"),
      yt.z.literal("uninitialized"),
      yt.z.literal("frozen"),
    ]),
    data: yt.z.string(),
    code: yt.z.string(),
    last_transaction_id: yt.z.object({
      "@type": yt.z.literal("internal.transactionId"),
      lt: yt.z.string(),
      hash: yt.z.string(),
    }),
    block_id: Gs,
    sync_utime: yt.z.number(),
  }),
  CC = yt.z.object({
    "@type": yt.z.literal("ok"),
  }),
  TC = yt.z.object({
    "@type": yt.z.literal("query.fees"),
    source_fees: yt.z.object({
      "@type": yt.z.literal("fees"),
      in_fwd_fee: yt.z.number(),
      storage_fee: yt.z.number(),
      gas_fee: yt.z.number(),
      fwd_fee: yt.z.number(),
    }),
  }),
  PC = yt.z.object({
    gas_used: yt.z.number(),
    exit_code: yt.z.number(),
    stack: yt.z.array(yt.z.unknown()),
  }),
  RC = yt.z.union([
    yt.z.object({
      "@type": yt.z.literal("msg.dataRaw"),
      body: yt.z.string(),
    }),
    yt.z.object({
      "@type": yt.z.literal("msg.dataText"),
      text: yt.z.string(),
    }),
    yt.z.object({
      "@type": yt.z.literal("msg.dataDecryptedText"),
      text: yt.z.string(),
    }),
    yt.z.object({
      "@type": yt.z.literal("msg.dataEncryptedText"),
      text: yt.z.string(),
    }),
  ]),
  N2 = yt.z.object({
    source: yt.z.string(),
    destination: yt.z.string(),
    value: yt.z.string(),
    fwd_fee: yt.z.string(),
    ihr_fee: yt.z.string(),
    created_lt: yt.z.string(),
    body_hash: yt.z.string(),
    msg_data: RC,
    message: yt.z.string(),
  }),
  Hp = yt.z.object({
    data: yt.z.string(),
    utime: yt.z.number(),
    transaction_id: yt.z.object({
      lt: yt.z.string(),
      hash: yt.z.string(),
    }),
    fee: yt.z.string(),
    storage_fee: yt.z.string(),
    other_fee: yt.z.string(),
    in_msg: yt.z.union([yt.z.undefined(), N2]),
    out_msgs: yt.z.array(N2),
  }),
  D2 = yt.z.array(Hp),
  IC = yt.z.object({
    state_root_hash: yt.z.string(),
    last: Gs,
    init: Gs,
  }),
  OC = yt.z.object({
    shards: yt.z.array(Gs),
  }),
  UC = yt.z.object({
    "@type": yt.z.literal("blocks.shortTxId"),
    mode: yt.z.number(),
    account: yt.z.string(),
    lt: yt.z.string(),
    hash: yt.z.string(),
  }),
  L2 = yt.z.object({
    id: Gs,
    req_count: yt.z.number(),
    incomplete: yt.z.boolean(),
    transactions: yt.z.array(UC),
  });
class F2 {
  constructor(e, n, i, l) {
    (this.namespace = e), (this.cache = n), (this.codec = i), (this.keyEncoder = l);
  }
  async get(e) {
    let n = await this.cache.get(this.namespace, this.keyEncoder(e));
    if (n) {
      let i = this.codec.safeParse(JSON.parse(n));
      if (i.success) return i.data;
    }
    return null;
  }
  async set(e, n) {
    n !== null
      ? await this.cache.set(this.namespace, this.keyEncoder(e), JSON.stringify(n))
      : await this.cache.set(this.namespace, this.keyEncoder(e), null);
  }
}
class NC {
  constructor(e, n) {
    (this.endpoint = e),
      (this.cache = new EC.InMemoryCache()),
      (this.parameters = {
        timeout: (n == null ? void 0 : n.timeout) || 3e4,
        apiKey: n == null ? void 0 : n.apiKey,
        adapter: n == null ? void 0 : n.adapter,
      }),
      (this.shardCache = new F2("ton-shard", this.cache, yt.z.array(Gs), (i) => i + "")),
      (this.shardLoader = new U2.default(
        async (i) =>
          await Promise.all(
            i.map(async (l) => {
              const a = await this.shardCache.get(l);
              if (a) return a;
              let c = (await this.doCall("shards", { seqno: l }, OC)).shards;
              return await this.shardCache.set(l, c), c;
            })
          )
      )),
      (this.shardTransactionsCache = new F2(
        "ton-shard-tx",
        this.cache,
        L2,
        (i) => i.workchain + ":" + i.shard + ":" + i.seqno
      )),
      (this.shardTransactionsLoader = new U2.default(
        async (i) =>
          await Promise.all(
            i.map(async (l) => {
              const a = await this.shardTransactionsCache.get(l);
              if (a) return a;
              let c = await this.doCall(
                "getBlockTransactions",
                { workchain: l.workchain, seqno: l.seqno, shard: l.shard },
                L2
              );
              return await this.shardTransactionsCache.set(l, c), c;
            })
          ),
        { cacheKeyFn: (i) => i.workchain + ":" + i.shard + ":" + i.seqno }
      ));
  }
  getAddressInformation(e) {
    return this.doCall("getAddressInformation", { address: e.toString() }, BC);
  }
  async getTransactions(e, n) {
    const i = n.inclusive;
    delete n.inclusive;
    let l;
    n.hash && (l = Qe.from(n.hash, "base64").toString("hex"));
    let a = n.limit;
    n.hash && n.lt && i !== !0 && a++;
    let c = await this.doCall(
      "getTransactions",
      { address: e.toString(), ...n, limit: a, hash: l },
      D2
    );
    return c.length > a && (c = c.slice(0, a)), n.hash && n.lt && i !== !0 && c.shift(), c;
  }
  async getMasterchainInfo() {
    return await this.doCall("getMasterchainInfo", {}, IC);
  }
  async getShards(e) {
    return await this.shardLoader.load(e);
  }
  async getBlockTransactions(e, n, i) {
    return await this.shardTransactionsLoader.load({ workchain: e, seqno: n, shard: i });
  }
  async getTransaction(e, n, i) {
    let l = Qe.from(i, "base64").toString("hex"),
      c = (
        await this.doCall(
          "getTransactions",
          { address: e.toString(), lt: n, hash: l, limit: 1 },
          D2
        )
      ).find((v) => v.transaction_id.lt === n && v.transaction_id.hash === i);
    return c || null;
  }
  async callGetMethod(e, n, i) {
    return await this.doCall(
      "runGetMethod",
      { address: e.toString(), method: n, stack: DC(i) },
      PC
    );
  }
  async sendBoc(e) {
    await this.doCall("sendBoc", { boc: e.toString("base64") }, CC);
  }
  async estimateFee(e, n) {
    return await this.doCall(
      "estimateFee",
      {
        address: e.toString(),
        body: n.body.toBoc().toString("base64"),
        init_data: n.initData ? n.initData.toBoc().toString("base64") : "",
        init_code: n.initCode ? n.initCode.toBoc().toString("base64") : "",
        ignore_chksig: n.ignoreSignature,
      },
      TC
    );
  }
  async tryLocateResultTx(e, n, i) {
    return await this.doCall(
      "tryLocateResultTx",
      { source: e.toString(), destination: n.toString(), created_lt: i },
      Hp
    );
  }
  async tryLocateSourceTx(e, n, i) {
    return await this.doCall(
      "tryLocateSourceTx",
      { source: e.toString(), destination: n.toString(), created_lt: i },
      Hp
    );
  }
  async doCall(e, n, i) {
    let l = {
      "Content-Type": "application/json",
      "X-Ton-Client-Version": kC,
    };
    this.parameters.apiKey && (l["X-API-Key"] = this.parameters.apiKey);
    let a = await AC.default.post(
      this.endpoint,
      JSON.stringify({
        id: "1",
        jsonrpc: "2.0",
        method: e,
        params: n,
      }),
      {
        headers: l,
        timeout: this.parameters.timeout,
        adapter: this.parameters.adapter,
      }
    );
    if (a.status !== 200 || !a.data.ok) throw Error("Received error: " + JSON.stringify(a.data));
    let c = i.safeParse(a.data.result);
    if (c.success) return c.data;
    throw Error("Malformed response: " + c.error.format()._errors.join(", "));
  }
}
Lf.HttpApi = NC;
function DC(t) {
  let e = [];
  for (let n of t)
    if (n.type === "int") e.push(["num", n.value.toString()]);
    else if (n.type === "cell") e.push(["tvm.Cell", n.cell.toBoc().toString("base64")]);
    else if (n.type === "slice") e.push(["tvm.Slice", n.cell.toBoc().toString("base64")]);
    else if (n.type === "builder") e.push(["tvm.Builder", n.cell.toBoc().toString("base64")]);
    else throw Error("Unsupported stack item type: " + n.type);
  return e;
}
var dc = {};
Object.defineProperty(dc, "__esModule", { value: !0 });
dc.TonClient = void 0;
const LC = Lf,
  ir = _t;
class FC {
  constructor(e) {
    (this.parameters = {
      endpoint: e.endpoint,
    }),
      (this.api = new LC.HttpApi(this.parameters.endpoint, {
        timeout: e.timeout,
        apiKey: e.apiKey,
        adapter: e.httpAdapter,
      }));
  }
  /**
   * Get Address Balance
   * @param address address for balance check
   * @returns balance
   */
  async getBalance(e) {
    return (await this.getContractState(e)).balance;
  }
  /**
   * Invoke get method
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   */
  async runMethod(e, n, i = []) {
    let l = await this.api.callGetMethod(e, n, i);
    if (l.exit_code !== 0)
      throw Error("Unable to execute get method. Got exit_code: " + l.exit_code);
    return { gas_used: l.gas_used, stack: q2(l.stack) };
  }
  /**
   * Invoke get method
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   * @deprecated use runMethod instead
   */
  async callGetMethod(e, n, i = []) {
    return this.runMethod(e, n, i);
  }
  /**
   * Invoke get method that returns error code instead of throwing error
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   */
  async runMethodWithError(e, n, i = []) {
    let l = await this.api.callGetMethod(e, n, i);
    return { gas_used: l.gas_used, stack: q2(l.stack), exit_code: l.exit_code };
  }
  /**
   * Invoke get method that returns error code instead of throwing error
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   * @deprecated use runMethodWithError instead
   */
  async callGetMethodWithError(e, n, i = []) {
    return this.runMethodWithError(e, n, i);
  }
  /**
   * Get transactions
   * @param address address
   */
  async getTransactions(e, n) {
    let i = await this.api.getTransactions(e, n),
      l = [];
    for (let a of i)
      l.push((0, ir.loadTransaction)(ir.Cell.fromBoc(Qe.from(a.data, "base64"))[0].beginParse()));
    return l;
  }
  /**
   * Get transaction by it's id
   * @param address address
   * @param lt logical time
   * @param hash transaction hash
   * @returns transaction or null if not exist
   */
  async getTransaction(e, n, i) {
    let l = await this.api.getTransaction(e, n, i);
    return l
      ? (0, ir.loadTransaction)(ir.Cell.fromBoc(Qe.from(l.data, "base64"))[0].beginParse())
      : null;
  }
  /**
   * Locate outcoming transaction of destination address by incoming message
   * @param source message source address
   * @param destination message destination address
   * @param created_lt message's created lt
   * @returns transaction
   */
  async tryLocateResultTx(e, n, i) {
    let l = await this.api.tryLocateResultTx(e, n, i);
    return (0, ir.loadTransaction)(ir.Cell.fromBase64(l.data).beginParse());
  }
  /**
   * Locate incoming transaction of source address by outcoming message
   * @param source message source address
   * @param destination message destination address
   * @param created_lt message's created lt
   * @returns transaction
   */
  async tryLocateSourceTx(e, n, i) {
    let l = await this.api.tryLocateSourceTx(e, n, i);
    return (0, ir.loadTransaction)(ir.Cell.fromBase64(l.data).beginParse());
  }
  /**
   * Fetch latest masterchain info
   * @returns masterchain info
   */
  async getMasterchainInfo() {
    let e = await this.api.getMasterchainInfo();
    return {
      workchain: e.init.workchain,
      shard: e.last.shard,
      initSeqno: e.init.seqno,
      latestSeqno: e.last.seqno,
    };
  }
  /**
   * Fetch latest workchain shards
   * @param seqno masterchain seqno
   */
  async getWorkchainShards(e) {
    return (await this.api.getShards(e)).map((i) => ({
      workchain: i.workchain,
      shard: i.shard,
      seqno: i.seqno,
    }));
  }
  /**
   * Fetch transactions inf shards
   * @param workchain
   * @param seqno
   * @param shard
   */
  async getShardTransactions(e, n, i) {
    let l = await this.api.getBlockTransactions(e, n, i);
    if (l.incomplete) throw Error("Unsupported");
    return l.transactions.map((a) => ({
      account: ir.Address.parseRaw(a.account),
      lt: a.lt,
      hash: a.hash,
    }));
  }
  /**
   * Send message to a network
   * @param src source message
   */
  async sendMessage(e) {
    const n = (0, ir.beginCell)()
      .store((0, ir.storeMessage)(e))
      .endCell()
      .toBoc();
    await this.api.sendBoc(n);
  }
  /**
   * Send file to a network
   * @param src source file
   */
  async sendFile(e) {
    await this.api.sendBoc(e);
  }
  /**
   * Estimate fees for external message
   * @param address target address
   * @returns
   */
  async estimateExternalMessageFee(e, n) {
    return await this.api.estimateFee(e, {
      body: n.body,
      initCode: n.initCode,
      initData: n.initData,
      ignoreSignature: n.ignoreSignature,
    });
  }
  /**
   * Send external message to contract
   * @param contract contract to send message
   * @param src message body
   */
  async sendExternalMessage(e, n) {
    if ((await this.isContractDeployed(e.address)) || !e.init) {
      const i = (0, ir.external)({
        to: e.address,
        body: n,
      });
      await this.sendMessage(i);
    } else {
      const i = (0, ir.external)({
        to: e.address,
        init: e.init,
        body: n,
      });
      await this.sendMessage(i);
    }
  }
  /**
   * Check if contract is deployed
   * @param address addres to check
   * @returns true if contract is in active state
   */
  async isContractDeployed(e) {
    return (await this.getContractState(e)).state === "active";
  }
  /**
   * Resolves contract state
   * @param address contract address
   */
  async getContractState(e) {
    let n = await this.api.getAddressInformation(e),
      i = BigInt(n.balance),
      l = n.state;
    return {
      balance: i,
      state: l,
      code: n.code !== "" ? Qe.from(n.code, "base64") : null,
      data: n.data !== "" ? Qe.from(n.data, "base64") : null,
      lastTransaction:
        n.last_transaction_id.lt !== "0"
          ? {
              lt: n.last_transaction_id.lt,
              hash: n.last_transaction_id.hash,
            }
          : null,
      blockId: {
        workchain: n.block_id.workchain,
        shard: n.block_id.shard,
        seqno: n.block_id.seqno,
      },
      timestampt: n.sync_utime,
    };
  }
  /**
   * Open contract
   * @param src source contract
   * @returns contract
   */
  open(e) {
    return (0, ir.openContract)(e, (n) => Vp(this, n.address, n.init));
  }
  /**
   * Create a provider
   * @param address address
   * @param init optional init
   * @returns provider
   */
  provider(e, n) {
    return Vp(this, e, n ?? null);
  }
}
dc.TonClient = FC;
function A8(t) {
  switch (t["@type"]) {
    case "tvm.stackEntryNumber":
      return { type: "int", value: BigInt(t.number.number) };
    case "tvm.stackEntryCell":
      return { type: "cell", cell: ir.Cell.fromBase64(t.cell) };
    case "tvm.stackEntryTuple":
      return { type: "tuple", items: t.tuple.elements.map(A8) };
    default:
      throw Error("Unsupported item type: " + t["@type"]);
  }
}
function qC(t) {
  if (t[0] === "num") {
    let e = t[1];
    return e.startsWith("-")
      ? { type: "int", value: -BigInt(e.slice(1)) }
      : { type: "int", value: BigInt(e) };
  } else {
    if (t[0] === "null") return { type: "null" };
    if (t[0] === "cell")
      return { type: "cell", cell: ir.Cell.fromBoc(Qe.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "slice")
      return { type: "slice", cell: ir.Cell.fromBoc(Qe.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "builder")
      return { type: "builder", cell: ir.Cell.fromBoc(Qe.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "tuple" || t[0] === "list")
      return t[1].elements.length === 0
        ? { type: "null" }
        : {
            type: t[0],
            items: t[1].elements.map(A8),
          };
    throw Error("Unsupported stack item type: " + t[0]);
  }
}
function q2(t) {
  let e = [];
  for (let n of t) e.push(qC(n));
  return new ir.TupleReader(e);
}
function Vp(t, e, n) {
  return {
    async getState() {
      let i = await t.getContractState(e),
        l = i.balance,
        a = i.lastTransaction
          ? { lt: BigInt(i.lastTransaction.lt), hash: Qe.from(i.lastTransaction.hash, "base64") }
          : null,
        c;
      if (i.state === "active")
        c = {
          type: "active",
          code: i.code ? i.code : null,
          data: i.data ? i.data : null,
        };
      else if (i.state === "uninitialized")
        c = {
          type: "uninit",
        };
      else if (i.state === "frozen")
        c = {
          type: "frozen",
          stateHash: Qe.alloc(0),
        };
      else throw Error("Unsupported state");
      return {
        balance: l,
        last: a,
        state: c,
      };
    },
    async get(i, l) {
      return { stack: (await t.callGetMethod(e, i, l)).stack };
    },
    async external(i) {
      let l = null;
      n && !(await t.isContractDeployed(e)) && (l = n);
      const a = (0, ir.external)({
        to: e,
        init: l,
        body: i,
      });
      let c = (0, ir.beginCell)()
        .store((0, ir.storeMessage)(a))
        .endCell()
        .toBoc();
      await t.sendFile(c);
    },
    async internal(i, l) {
      let a = null;
      n && !(await t.isContractDeployed(e)) && (a = n);
      let c = !0;
      l.bounce !== null && l.bounce !== void 0 && (c = l.bounce);
      let v;
      typeof l.value == "string" ? (v = (0, ir.toNano)(l.value)) : (v = l.value);
      let g = null;
      typeof l.body == "string" ? (g = (0, ir.comment)(l.body)) : l.body && (g = l.body),
        await i.send({
          to: e,
          value: v,
          bounce: c,
          sendMode: l.sendMode,
          init: a,
          body: g,
        });
    },
    open(i) {
      return (0, ir.openContract)(i, (l) => Vp(t, l.address, l.init ?? null));
    },
    getTransactions(i, l, a, c) {
      return t.getTransactions(i, {
        limit: c ?? 100,
        lt: l.toString(),
        hash: a.toString("base64"),
        inclusive: !0,
      });
    },
  };
}
var pc = {},
  mc = {};
Object.defineProperty(mc, "__esModule", { value: !0 });
mc.toUrlSafe = void 0;
function zC(t) {
  for (; t.indexOf("/") >= 0; ) t = t.replace("/", "_");
  for (; t.indexOf("+") >= 0; ) t = t.replace("+", "-");
  for (; t.indexOf("=") >= 0; ) t = t.replace("=", "");
  return t;
}
mc.toUrlSafe = zC;
var Z0 =
    (mt && mt.__classPrivateFieldSet) ||
    function (t, e, n, i, l) {
      if (i === "m") throw new TypeError("Private method is not writable");
      if (i === "a" && !l) throw new TypeError("Private accessor was defined without a setter");
      if (typeof e == "function" ? t !== e || !l : !e.has(t))
        throw new TypeError(
          "Cannot write private member to an object whose class did not declare it"
        );
      return i === "a" ? l.call(t, n) : l ? (l.value = n) : e.set(t, n), n;
    },
  Gt =
    (mt && mt.__classPrivateFieldGet) ||
    function (t, e, n, i) {
      if (n === "a" && !i) throw new TypeError("Private accessor was defined without a getter");
      if (typeof e == "function" ? t !== e || !i : !e.has(t))
        throw new TypeError(
          "Cannot read private member from an object whose class did not declare it"
        );
      return n === "m" ? i : n === "a" ? i.call(t) : i ? i.value : e.get(t);
    },
  jC =
    (mt && mt.__importDefault) ||
    function (t) {
      return t && t.__esModule ? t : { default: t };
    },
  Kr,
  Zr,
  Gr;
Object.defineProperty(pc, "__esModule", { value: !0 });
pc.TonClient4 = void 0;
const kn = jC(y8),
  zr = _t,
  G0 = mc,
  _e = Em;
class $C {
  constructor(e) {
    Kr.set(this, void 0),
      Zr.set(this, void 0),
      Gr.set(this, void 0),
      Z0(this, Kr, e.endpoint, "f"),
      Z0(this, Zr, e.timeout || 5e3, "f"),
      Z0(this, Gr, e.httpAdapter, "f");
  }
  /**
   * Get Last Block
   * @returns last block info
   */
  async getLastBlock() {
    let e = await kn.default.get(Gt(this, Kr, "f") + "/block/latest", {
        adapter: Gt(this, Gr, "f"),
        timeout: Gt(this, Zr, "f"),
      }),
      n = HC.safeParse(e.data);
    if (!n.success) throw Error("Mailformed response: " + n.error.format()._errors.join(", "));
    return n.data;
  }
  /**
   * Get block info
   * @param seqno block sequence number
   * @returns block info
   */
  async getBlock(e) {
    let n = await kn.default.get(Gt(this, Kr, "f") + "/block/" + e, {
        adapter: Gt(this, Gr, "f"),
        timeout: Gt(this, Zr, "f"),
      }),
      i = z2.safeParse(n.data);
    if (!i.success) throw Error("Mailformed response");
    if (!i.data.exist) throw Error("Block is out of scope");
    return i.data.block;
  }
  /**
   * Get block info by unix timestamp
   * @param ts unix timestamp
   * @returns block info
   */
  async getBlockByUtime(e) {
    let n = await kn.default.get(Gt(this, Kr, "f") + "/block/utime/" + e, {
        adapter: Gt(this, Gr, "f"),
        timeout: Gt(this, Zr, "f"),
      }),
      i = z2.safeParse(n.data);
    if (!i.success) throw Error("Mailformed response");
    if (!i.data.exist) throw Error("Block is out of scope");
    return i.data.block;
  }
  /**
   * Get block info by unix timestamp
   * @param seqno block sequence number
   * @param address account address
   * @returns account info
   */
  async getAccount(e, n) {
    let i = await kn.default.get(
        Gt(this, Kr, "f") + "/block/" + e + "/" + n.toString({ urlSafe: !0 }),
        { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }
      ),
      l = VC.safeParse(i.data);
    if (!l.success) throw Error("Mailformed response");
    return l.data;
  }
  /**
   * Get account lite info (without code and data)
   * @param seqno block sequence number
   * @param address account address
   * @returns account lite info
   */
  async getAccountLite(e, n) {
    let i = await kn.default.get(
        Gt(this, Kr, "f") + "/block/" + e + "/" + n.toString({ urlSafe: !0 }) + "/lite",
        { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }
      ),
      l = WC.safeParse(i.data);
    if (!l.success) throw Error("Mailformed response");
    return l.data;
  }
  /**
   * Check if contract is deployed
   * @param address addres to check
   * @returns true if contract is in active state
   */
  async isContractDeployed(e, n) {
    return (await this.getAccountLite(e, n)).account.state.type === "active";
  }
  /**
   * Check if account was updated since
   * @param seqno block sequence number
   * @param address account address
   * @param lt account last transaction lt
   * @returns account change info
   */
  async isAccountChanged(e, n, i) {
    let l = await kn.default.get(
        Gt(this, Kr, "f") +
          "/block/" +
          e +
          "/" +
          n.toString({ urlSafe: !0 }) +
          "/changed/" +
          i.toString(10),
        { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }
      ),
      a = KC.safeParse(l.data);
    if (!a.success) throw Error("Mailformed response");
    return a.data;
  }
  /**
   * Load unparsed account transactions
   * @param address address
   * @param lt last transaction lt
   * @param hash last transaction hash
   * @returns unparsed transactions
   */
  async getAccountTransactions(e, n, i) {
    let l = await kn.default.get(
        Gt(this, Kr, "f") +
          "/account/" +
          e.toString({ urlSafe: !0 }) +
          "/tx/" +
          n.toString(10) +
          "/" +
          (0, G0.toUrlSafe)(i.toString("base64")),
        { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }
      ),
      a = JC.safeParse(l.data);
    if (!a.success) throw Error("Mailformed response");
    let c = a.data,
      v = [],
      g = zr.Cell.fromBoc(Qe.from(c.boc, "base64"));
    for (let b = 0; b < c.blocks.length; b++)
      v.push({
        block: c.blocks[b],
        tx: (0, zr.loadTransaction)(g[b].beginParse()),
      });
    return v;
  }
  /**
   * Load parsed account transactions
   * @param address address
   * @param lt last transaction lt
   * @param hash last transaction hash
   * @param count number of transactions to load
   * @returns parsed transactions
   */
  async getAccountTransactionsParsed(e, n, i, l = 20) {
    let a = await kn.default.get(
        Gt(this, Kr, "f") +
          "/account/" +
          e.toString({ urlSafe: !0 }) +
          "/tx/parsed/" +
          n.toString(10) +
          "/" +
          (0, G0.toUrlSafe)(i.toString("base64")),
        {
          adapter: Gt(this, Gr, "f"),
          timeout: Gt(this, Zr, "f"),
          params: {
            count: l,
          },
        }
      ),
      c = sT.safeParse(a.data);
    if (!c.success) throw Error("Mailformed response");
    return c.data;
  }
  /**
   * Get network config
   * @param seqno block sequence number
   * @param ids optional config ids
   * @returns network config
   */
  async getConfig(e, n) {
    let i = "";
    n && n.length > 0 && (i = "/" + [...n].sort().join(","));
    let l = await kn.default.get(Gt(this, Kr, "f") + "/block/" + e + "/config" + i, {
        adapter: Gt(this, Gr, "f"),
        timeout: Gt(this, Zr, "f"),
      }),
      a = GC.safeParse(l.data);
    if (!a.success) throw Error("Mailformed response");
    return a.data;
  }
  /**
   * Execute run method
   * @param seqno block sequence number
   * @param address account address
   * @param name method name
   * @param args method arguments
   * @returns method result
   */
  async runMethod(e, n, i, l) {
    let a =
        l && l.length > 0
          ? "/" +
            (0, G0.toUrlSafe)(
              (0, zr.serializeTuple)(l).toBoc({ idx: !1, crc32: !1 }).toString("base64")
            )
          : "",
      c =
        Gt(this, Kr, "f") +
        "/block/" +
        e +
        "/" +
        n.toString({ urlSafe: !0 }) +
        "/run/" +
        encodeURIComponent(i) +
        a,
      v = await kn.default.get(c, { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }),
      g = ZC.safeParse(v.data);
    if (!g.success) throw Error("Mailformed response");
    let b = g.data.resultRaw
      ? (0, zr.parseTuple)(zr.Cell.fromBoc(Qe.from(g.data.resultRaw, "base64"))[0])
      : [];
    return {
      exitCode: g.data.exitCode,
      result: b,
      resultRaw: g.data.resultRaw,
      block: g.data.block,
      shardBlock: g.data.shardBlock,
      reader: new zr.TupleReader(b),
    };
  }
  /**
   * Send external message
   * @param message message boc
   * @returns message status
   */
  async sendMessage(e) {
    let n = await kn.default.post(
      Gt(this, Kr, "f") + "/send",
      { boc: e.toString("base64") },
      { adapter: Gt(this, Gr, "f"), timeout: Gt(this, Zr, "f") }
    );
    if (!YC.safeParse(n.data).success) throw Error("Mailformed response");
    return { status: n.data.status };
  }
  /**
   * Open smart contract
   * @param contract contract
   * @returns opened contract
   */
  open(e) {
    return (0, zr.openContract)(e, (n) => Zo(this, null, n.address, n.init));
  }
  /**
   * Open smart contract
   * @param block block number
   * @param contract contract
   * @returns opened contract
   */
  openAt(e, n) {
    return (0, zr.openContract)(n, (i) => Zo(this, e, i.address, i.init));
  }
  /**
   * Create provider
   * @param address address
   * @param init optional init data
   * @returns provider
   */
  provider(e, n) {
    return Zo(this, null, e, n ?? null);
  }
  /**
   * Create provider at specified block number
   * @param block block number
   * @param address address
   * @param init optional init data
   * @returns provider
   */
  providerAt(e, n, i) {
    return Zo(this, e, n, i ?? null);
  }
}
pc.TonClient4 = $C;
(Kr = /* @__PURE__ */ new WeakMap()),
  (Zr = /* @__PURE__ */ new WeakMap()),
  (Gr = /* @__PURE__ */ new WeakMap());
function Zo(t, e, n, i) {
  return {
    async getState() {
      let l = e;
      l === null && (l = (await t.getLastBlock()).last.seqno);
      let a = await t.getAccount(l, n),
        c = a.account.last
          ? { lt: BigInt(a.account.last.lt), hash: Qe.from(a.account.last.hash, "base64") }
          : null,
        v;
      if (a.account.state.type === "active")
        v = {
          type: "active",
          code: a.account.state.code ? Qe.from(a.account.state.code, "base64") : null,
          data: a.account.state.data ? Qe.from(a.account.state.data, "base64") : null,
        };
      else if (a.account.state.type === "uninit")
        v = {
          type: "uninit",
        };
      else if (a.account.state.type === "frozen")
        v = {
          type: "frozen",
          stateHash: Qe.from(a.account.state.stateHash, "base64"),
        };
      else throw Error("Unsupported state");
      return {
        balance: BigInt(a.account.balance.coins),
        last: c,
        state: v,
      };
    },
    async get(l, a) {
      let c = e;
      c === null && (c = (await t.getLastBlock()).last.seqno);
      let v = await t.runMethod(c, n, l, a);
      if (v.exitCode !== 0 && v.exitCode !== 1) throw Error("Exit code: " + v.exitCode);
      return {
        stack: new zr.TupleReader(v.result),
      };
    },
    async external(l) {
      let a = await t.getLastBlock(),
        c = null;
      i && (await t.getAccountLite(a.last.seqno, n)).account.state.type !== "active" && (c = i);
      const v = (0, zr.external)({
        to: n,
        init: c,
        body: l,
      });
      let g = (0, zr.beginCell)()
        .store((0, zr.storeMessage)(v))
        .endCell()
        .toBoc();
      await t.sendMessage(g);
    },
    async internal(l, a) {
      let c = await t.getLastBlock(),
        v = null;
      i && (await t.getAccountLite(c.last.seqno, n)).account.state.type !== "active" && (v = i);
      let g = !0;
      a.bounce !== null && a.bounce !== void 0 && (g = a.bounce);
      let b;
      typeof a.value == "string" ? (b = (0, zr.toNano)(a.value)) : (b = a.value);
      let p = null;
      typeof a.body == "string" ? (p = (0, zr.comment)(a.body)) : a.body && (p = a.body),
        await l.send({
          to: n,
          value: b,
          bounce: g,
          sendMode: a.sendMode,
          init: v,
          body: p,
        });
    },
    open(l) {
      return (0, zr.openContract)(l, (a) => Zo(t, e, a.address, a.init ?? null));
    },
    async getTransactions(l, a, c, v) {
      const g = typeof v == "number";
      if (g && v <= 0) return [];
      let b = [];
      do {
        const p = await t.getAccountTransactions(l, a, c),
          _ = p[0].tx,
          [M, S] = [_.lt, _.hash()];
        if ((b.length > 0 && M === a && S.equals(c) && p.shift(), p.length === 0)) break;
        const k = p[p.length - 1].tx,
          [P, B] = [k.lt, k.hash()];
        if (P === a && B.equals(c)) break;
        b.push(...p.map((T) => T.tx)), (a = P), (c = B);
      } while (g && b.length < v);
      return g && (b = b.slice(0, v)), b;
    },
  };
}
const HC = _e.z.object({
    last: _e.z.object({
      seqno: _e.z.number(),
      shard: _e.z.string(),
      workchain: _e.z.number(),
      fileHash: _e.z.string(),
      rootHash: _e.z.string(),
    }),
    init: _e.z.object({
      fileHash: _e.z.string(),
      rootHash: _e.z.string(),
    }),
    stateRootHash: _e.z.string(),
    now: _e.z.number(),
  }),
  z2 = _e.z.union([
    _e.z.object({
      exist: _e.z.literal(!1),
    }),
    _e.z.object({
      exist: _e.z.literal(!0),
      block: _e.z.object({
        shards: _e.z.array(
          _e.z.object({
            workchain: _e.z.number(),
            seqno: _e.z.number(),
            shard: _e.z.string(),
            rootHash: _e.z.string(),
            fileHash: _e.z.string(),
            transactions: _e.z.array(
              _e.z.object({
                account: _e.z.string(),
                hash: _e.z.string(),
                lt: _e.z.string(),
              })
            ),
          })
        ),
      }),
    }),
  ]),
  k8 = _e.z.object({
    lastPaid: _e.z.number(),
    duePayment: _e.z.union([_e.z.null(), _e.z.string()]),
    used: _e.z.object({
      bits: _e.z.number(),
      cells: _e.z.number(),
      publicCells: _e.z.number(),
    }),
  }),
  VC = _e.z.object({
    account: _e.z.object({
      state: _e.z.union([
        _e.z.object({ type: _e.z.literal("uninit") }),
        _e.z.object({
          type: _e.z.literal("active"),
          code: _e.z.union([_e.z.string(), _e.z.null()]),
          data: _e.z.union([_e.z.string(), _e.z.null()]),
        }),
        _e.z.object({ type: _e.z.literal("frozen"), stateHash: _e.z.string() }),
      ]),
      balance: _e.z.object({
        coins: _e.z.string(),
      }),
      last: _e.z.union([
        _e.z.null(),
        _e.z.object({
          lt: _e.z.string(),
          hash: _e.z.string(),
        }),
      ]),
      storageStat: _e.z.union([_e.z.null(), k8]),
    }),
    block: _e.z.object({
      workchain: _e.z.number(),
      seqno: _e.z.number(),
      shard: _e.z.string(),
      rootHash: _e.z.string(),
      fileHash: _e.z.string(),
    }),
  }),
  WC = _e.z.object({
    account: _e.z.object({
      state: _e.z.union([
        _e.z.object({ type: _e.z.literal("uninit") }),
        _e.z.object({
          type: _e.z.literal("active"),
          codeHash: _e.z.string(),
          dataHash: _e.z.string(),
        }),
        _e.z.object({ type: _e.z.literal("frozen"), stateHash: _e.z.string() }),
      ]),
      balance: _e.z.object({
        coins: _e.z.string(),
      }),
      last: _e.z.union([
        _e.z.null(),
        _e.z.object({
          lt: _e.z.string(),
          hash: _e.z.string(),
        }),
      ]),
      storageStat: _e.z.union([_e.z.null(), k8]),
    }),
  }),
  KC = _e.z.object({
    changed: _e.z.boolean(),
    block: _e.z.object({
      workchain: _e.z.number(),
      seqno: _e.z.number(),
      shard: _e.z.string(),
      rootHash: _e.z.string(),
      fileHash: _e.z.string(),
    }),
  }),
  ZC = _e.z.object({
    exitCode: _e.z.number(),
    resultRaw: _e.z.union([_e.z.string(), _e.z.null()]),
    block: _e.z.object({
      workchain: _e.z.number(),
      seqno: _e.z.number(),
      shard: _e.z.string(),
      rootHash: _e.z.string(),
      fileHash: _e.z.string(),
    }),
    shardBlock: _e.z.object({
      workchain: _e.z.number(),
      seqno: _e.z.number(),
      shard: _e.z.string(),
      rootHash: _e.z.string(),
      fileHash: _e.z.string(),
    }),
  }),
  GC = _e.z.object({
    config: _e.z.object({
      cell: _e.z.string(),
      address: _e.z.string(),
      globalBalance: _e.z.object({
        coins: _e.z.string(),
      }),
    }),
  }),
  YC = _e.z.object({
    status: _e.z.number(),
  }),
  B8 = _e.z.array(
    _e.z.object({
      workchain: _e.z.number(),
      seqno: _e.z.number(),
      shard: _e.z.string(),
      rootHash: _e.z.string(),
      fileHash: _e.z.string(),
    })
  ),
  JC = _e.z.object({
    blocks: B8,
    boc: _e.z.string(),
  }),
  j2 = _e.z.object({
    bits: _e.z.number(),
    data: _e.z.string(),
  }),
  QC = _e.z.union([
    _e.z.object({
      type: _e.z.literal("internal"),
      value: _e.z.string(),
      dest: _e.z.string(),
      src: _e.z.string(),
      bounced: _e.z.boolean(),
      bounce: _e.z.boolean(),
      ihrDisabled: _e.z.boolean(),
      createdAt: _e.z.number(),
      createdLt: _e.z.string(),
      fwdFee: _e.z.string(),
      ihrFee: _e.z.string(),
    }),
    _e.z.object({
      type: _e.z.literal("external-in"),
      dest: _e.z.string(),
      src: _e.z.union([j2, _e.z.null()]),
      importFee: _e.z.string(),
    }),
    _e.z.object({
      type: _e.z.literal("external-out"),
      dest: _e.z.union([j2, _e.z.null()]),
    }),
  ]),
  XC = _e.z.object({
    splitDepth: _e.z.union([_e.z.number(), _e.z.null()]),
    code: _e.z.union([_e.z.string(), _e.z.null()]),
    data: _e.z.union([_e.z.string(), _e.z.null()]),
    special: _e.z.union([_e.z.object({ tick: _e.z.boolean(), tock: _e.z.boolean() }), _e.z.null()]),
  }),
  $2 = _e.z.object({
    body: _e.z.string(),
    info: QC,
    init: _e.z.union([XC, _e.z.null()]),
  }),
  H2 = _e.z.union([
    _e.z.literal("uninitialized"),
    _e.z.literal("frozen"),
    _e.z.literal("active"),
    _e.z.literal("non-existing"),
  ]),
  eT = _e.z.union([
    _e.z.object({ type: _e.z.literal("comment"), comment: _e.z.string() }),
    _e.z.object({ type: _e.z.literal("payload"), cell: _e.z.string() }),
  ]),
  tT = _e.z.union([
    _e.z.object({ kind: _e.z.literal("ton"), amount: _e.z.string() }),
    _e.z.object({ kind: _e.z.literal("token"), amount: _e.z.string() }),
  ]),
  rT = _e.z.union([
    _e.z.literal("jetton::excesses"),
    _e.z.literal("jetton::transfer"),
    _e.z.literal("jetton::transfer_notification"),
    _e.z.literal("deposit"),
    _e.z.literal("deposit::ok"),
    _e.z.literal("withdraw"),
    _e.z.literal("withdraw::all"),
    _e.z.literal("withdraw::delayed"),
    _e.z.literal("withdraw::ok"),
    _e.z.literal("airdrop"),
  ]),
  nT = _e.z.object({
    type: rT,
    options: _e.z.optional(_e.z.record(_e.z.string())),
  }),
  iT = _e.z.object({
    address: _e.z.string(),
    comment: _e.z.optional(_e.z.string()),
    items: _e.z.array(tT),
    op: _e.z.optional(nT),
  }),
  aT = _e.z.object({
    address: _e.z.string(),
    lt: _e.z.string(),
    hash: _e.z.string(),
    prevTransaction: _e.z.object({
      lt: _e.z.string(),
      hash: _e.z.string(),
    }),
    time: _e.z.number(),
    outMessagesCount: _e.z.number(),
    oldStatus: H2,
    newStatus: H2,
    fees: _e.z.string(),
    update: _e.z.object({
      oldHash: _e.z.string(),
      newHash: _e.z.string(),
    }),
    inMessage: _e.z.union([$2, _e.z.null()]),
    outMessages: _e.z.array($2),
    parsed: _e.z.object({
      seqno: _e.z.union([_e.z.number(), _e.z.null()]),
      body: _e.z.union([eT, _e.z.null()]),
      status: _e.z.union([
        _e.z.literal("success"),
        _e.z.literal("failed"),
        _e.z.literal("pending"),
      ]),
      dest: _e.z.union([_e.z.string(), _e.z.null()]),
      kind: _e.z.union([_e.z.literal("out"), _e.z.literal("in")]),
      amount: _e.z.string(),
      resolvedAddress: _e.z.string(),
      bounced: _e.z.boolean(),
      mentioned: _e.z.array(_e.z.string()),
    }),
    operation: iT,
  }),
  sT = _e.z.object({
    blocks: B8,
    transactions: _e.z.array(aT),
  });
var vc = {},
  kr = {};
Object.defineProperty(kr, "__esModule", { value: !0 });
kr.createWalletTransferV4 =
  kr.createWalletTransferV3 =
  kr.createWalletTransferV2 =
  kr.createWalletTransferV1 =
    void 0;
const Ur = _t,
  gc = ss();
function oT(t) {
  let e = (0, Ur.beginCell)().storeUint(t.seqno, 32);
  t.message &&
    (e.storeUint(t.sendMode, 8),
    e.storeRef((0, Ur.beginCell)().store((0, Ur.storeMessageRelaxed)(t.message))));
  let n = (0, gc.sign)(e.endCell().hash(), t.secretKey);
  return (0, Ur.beginCell)().storeBuffer(n).storeBuilder(e).endCell();
}
kr.createWalletTransferV1 = oT;
function fT(t) {
  if (t.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, Ur.beginCell)().storeUint(t.seqno, 32);
  if (t.seqno === 0) for (let l = 0; l < 32; l++) e.storeBit(1);
  else e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  for (let l of t.messages)
    e.storeUint(t.sendMode, 8),
      e.storeRef((0, Ur.beginCell)().store((0, Ur.storeMessageRelaxed)(l)));
  let n = (0, gc.sign)(e.endCell().hash(), t.secretKey);
  return (0, Ur.beginCell)().storeBuffer(n).storeBuilder(e).endCell();
}
kr.createWalletTransferV2 = fT;
function lT(t) {
  if (t.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, Ur.beginCell)().storeUint(t.walletId, 32);
  if (t.seqno === 0) for (let l = 0; l < 32; l++) e.storeBit(1);
  else e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  e.storeUint(t.seqno, 32);
  for (let l of t.messages)
    e.storeUint(t.sendMode, 8),
      e.storeRef((0, Ur.beginCell)().store((0, Ur.storeMessageRelaxed)(l)));
  let n = (0, gc.sign)(e.endCell().hash(), t.secretKey);
  return (0, Ur.beginCell)().storeBuffer(n).storeBuilder(e).endCell();
}
kr.createWalletTransferV3 = lT;
function uT(t) {
  if (t.messages.length > 4) throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, Ur.beginCell)().storeUint(t.walletId, 32);
  if (t.seqno === 0) for (let l = 0; l < 32; l++) e.storeBit(1);
  else e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  e.storeUint(t.seqno, 32), e.storeUint(0, 8);
  for (let l of t.messages)
    e.storeUint(t.sendMode, 8),
      e.storeRef((0, Ur.beginCell)().store((0, Ur.storeMessageRelaxed)(l)));
  let n = (0, gc.sign)(e.endCell().hash(), t.secretKey);
  return (0, Ur.beginCell)().storeBuffer(n).storeBuilder(e).endCell();
}
kr.createWalletTransferV4 = uT;
Object.defineProperty(vc, "__esModule", { value: !0 });
vc.WalletContractV1R1 = void 0;
const us = _t,
  cT = kr;
class km {
  static create(e) {
    return new km(e.workchain, e.publicKey);
  }
  constructor(e, n) {
    (this.workchain = e), (this.publicKey = n);
    let i = us.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEARAAAhP8AIN2k8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVEH98Ik=",
          "base64"
        )
      )[0],
      l = (0, us.beginCell)().storeUint(0, 32).storeBuffer(n).endCell();
    (this.init = { code: i, data: l }),
      (this.address = (0, us.contractAddress)(e, { code: i, data: l }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    let n = await e.getState();
    return n.state.type === "active"
      ? us.Cell.fromBoc(n.state.data)[0].beginParse().loadUint(32)
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = us.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, cT.createWalletTransferV1)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        message: e.message,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            message: (0, us.internal)({
              to: i.to,
              value: i.value,
              init: i.init,
              body: i.body,
              bounce: i.bounce,
            }),
          });
        await this.send(e, a);
      },
    };
  }
}
vc.WalletContractV1R1 = km;
var yc = {};
Object.defineProperty(yc, "__esModule", { value: !0 });
yc.WalletContractV1R2 = void 0;
const ko = _t,
  hT = kr;
class Bm {
  static create(e) {
    return new Bm(e.workchain, e.publicKey);
  }
  constructor(e, n) {
    (this.workchain = e), (this.publicKey = n);
    let i = ko.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAUwAAov8AIN0gggFMl7qXMO1E0NcLH+Ck8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVNDieG8=",
          "base64"
        )
      )[0],
      l = (0, ko.beginCell)().storeUint(0, 32).storeBuffer(n).endCell();
    (this.init = { code: i, data: l }),
      (this.address = (0, ko.contractAddress)(e, { code: i, data: l }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = ko.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, hT.createWalletTransferV1)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        message: e.message,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            message: (0, ko.internal)({
              to: i.to,
              value: i.value,
              init: i.init,
              body: i.body,
              bounce: i.bounce,
            }),
          });
        await this.send(e, a);
      },
    };
  }
}
yc.WalletContractV1R2 = Bm;
var bc = {};
Object.defineProperty(bc, "__esModule", { value: !0 });
bc.WalletContractV1R3 = void 0;
const Bo = _t,
  dT = kr;
class Cm {
  static create(e) {
    return new Cm(e.workchain, e.publicKey);
  }
  constructor(e, n) {
    (this.workchain = e), (this.publicKey = n);
    let i = Bo.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAXwAAuv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVLW4bkI=",
          "base64"
        )
      )[0],
      l = (0, Bo.beginCell)().storeUint(0, 32).storeBuffer(n).endCell();
    (this.init = { code: i, data: l }),
      (this.address = (0, Bo.contractAddress)(e, { code: i, data: l }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = Bo.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, dT.createWalletTransferV1)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        message: e.message,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            message: (0, Bo.internal)({
              to: i.to,
              value: i.value,
              init: i.init,
              body: i.body,
              bounce: i.bounce,
            }),
          });
        await this.send(e, a);
      },
    };
  }
}
bc.WalletContractV1R3 = Cm;
var wc = {};
Object.defineProperty(wc, "__esModule", { value: !0 });
wc.WalletContractV2R1 = void 0;
const Co = _t,
  pT = kr;
class Tm {
  static create(e) {
    return new Tm(e.workchain, e.publicKey);
  }
  constructor(e, n) {
    (this.workchain = e), (this.publicKey = n);
    let i = Co.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAVwAAqv8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VShNwu2",
          "base64"
        )
      )[0],
      l = (0, Co.beginCell)().storeUint(0, 32).storeBuffer(n).endCell();
    (this.init = { code: i, data: l }),
      (this.address = (0, Co.contractAddress)(e, { code: i, data: l }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = Co.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, pT.createWalletTransferV2)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        messages: e.messages,
        timeout: e.timeout,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            messages: [
              (0, Co.internal)({
                to: i.to,
                value: i.value,
                init: i.init,
                body: i.body,
                bounce: i.bounce,
              }),
            ],
          });
        await this.send(e, a);
      },
    };
  }
}
wc.WalletContractV2R1 = Tm;
var _c = {};
Object.defineProperty(_c, "__esModule", { value: !0 });
_c.WalletContractV2R2 = void 0;
const To = _t,
  mT = kr;
class Pm {
  static create(e) {
    return new Pm(e.workchain, e.publicKey);
  }
  constructor(e, n) {
    (this.workchain = e), (this.publicKey = n);
    let i = To.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAYwAAwv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VQETNeh",
          "base64"
        )
      )[0],
      l = (0, To.beginCell)().storeUint(0, 32).storeBuffer(n).endCell();
    (this.init = { code: i, data: l }),
      (this.address = (0, To.contractAddress)(e, { code: i, data: l }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = To.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, mT.createWalletTransferV2)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        messages: e.messages,
        timeout: e.timeout,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            messages: [
              (0, To.internal)({
                to: i.to,
                value: i.value,
                init: i.init,
                body: i.body,
                bounce: i.bounce,
              }),
            ],
          });
        await this.send(e, a);
      },
    };
  }
}
_c.WalletContractV2R2 = Pm;
var xc = {};
Object.defineProperty(xc, "__esModule", { value: !0 });
xc.WalletContractV3R1 = void 0;
const Po = _t,
  vT = kr;
class Rm {
  static create(e) {
    return new Rm(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, n, i) {
    (this.workchain = e),
      (this.publicKey = n),
      i != null ? (this.walletId = i) : (this.walletId = 698983191 + e);
    let l = Po.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAYgAAwP8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVD++buA=",
          "base64"
        )
      )[0],
      a = (0, Po.beginCell)()
        .storeUint(0, 32)
        .storeUint(this.walletId, 32)
        .storeBuffer(n)
        .endCell();
    (this.init = { code: l, data: a }),
      (this.address = (0, Po.contractAddress)(e, { code: l, data: a }));
  }
  /**
   * Get wallet balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create transfer
   */
  createTransfer(e) {
    let n = Po.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, vT.createWalletTransferV3)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        messages: e.messages,
        timeout: e.timeout,
        walletId: this.walletId,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            messages: [
              (0, Po.internal)({
                to: i.to,
                value: i.value,
                init: i.init,
                body: i.body,
                bounce: i.bounce,
              }),
            ],
          });
        await this.send(e, a);
      },
    };
  }
}
xc.WalletContractV3R1 = Rm;
var Mc = {};
Object.defineProperty(Mc, "__esModule", { value: !0 });
Mc.WalletContractV3R2 = void 0;
const Ro = _t,
  gT = kr;
class Im {
  static create(e) {
    return new Im(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, n, i) {
    (this.workchain = e),
      (this.publicKey = n),
      i != null ? (this.walletId = i) : (this.walletId = 698983191 + e);
    let l = Ro.Cell.fromBoc(
        Qe.from(
          "te6cckEBAQEAcQAA3v8AIN0gggFMl7ohggEznLqxn3Gw7UTQ0x/THzHXC//jBOCk8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVBC9ba0=",
          "base64"
        )
      )[0],
      a = (0, Ro.beginCell)()
        .storeUint(0, 32)
        .storeUint(this.walletId, 32)
        .storeBuffer(n)
        .endCell();
    (this.init = { code: l, data: a }),
      (this.address = (0, Ro.contractAddress)(e, { code: l, data: a }));
  }
  /**
   * Get wallet balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create transfer
   */
  createTransfer(e) {
    let n = Ro.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, gT.createWalletTransferV3)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        messages: e.messages,
        timeout: e.timeout,
        walletId: this.walletId,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            messages: [
              (0, Ro.internal)({
                to: i.to,
                value: i.value,
                init: i.init,
                body: i.body,
                bounce: i.bounce,
              }),
            ],
          });
        await this.send(e, a);
      },
    };
  }
}
Mc.WalletContractV3R2 = Im;
var Sc = {};
Object.defineProperty(Sc, "__esModule", { value: !0 });
Sc.WalletContractV4 = void 0;
const Io = _t,
  yT = kr;
class Om {
  static create(e) {
    return new Om(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, n, i) {
    (this.workchain = e),
      (this.publicKey = n),
      i != null ? (this.walletId = i) : (this.walletId = 698983191 + e);
    let l = Io.Cell.fromBoc(
        Qe.from(
          "te6ccgECFAEAAtQAART/APSkE/S88sgLAQIBIAIDAgFIBAUE+PKDCNcYINMf0x/THwL4I7vyZO1E0NMf0x/T//QE0VFDuvKhUVG68qIF+QFUEGT5EPKj+AAkpMjLH1JAyx9SMMv/UhD0AMntVPgPAdMHIcAAn2xRkyDXSpbTB9QC+wDoMOAhwAHjACHAAuMAAcADkTDjDQOkyMsfEssfy/8QERITAubQAdDTAyFxsJJfBOAi10nBIJJfBOAC0x8hghBwbHVnvSKCEGRzdHK9sJJfBeAD+kAwIPpEAcjKB8v/ydDtRNCBAUDXIfQEMFyBAQj0Cm+hMbOSXwfgBdM/yCWCEHBsdWe6kjgw4w0DghBkc3RyupJfBuMNBgcCASAICQB4AfoA9AQw+CdvIjBQCqEhvvLgUIIQcGx1Z4MesXCAGFAEywUmzxZY+gIZ9ADLaRfLH1Jgyz8gyYBA+wAGAIpQBIEBCPRZMO1E0IEBQNcgyAHPFvQAye1UAXKwjiOCEGRzdHKDHrFwgBhQBcsFUAPPFiP6AhPLassfyz/JgED7AJJfA+ICASAKCwBZvSQrb2omhAgKBrkPoCGEcNQICEekk30pkQzmkD6f+YN4EoAbeBAUiYcVnzGEAgFYDA0AEbjJftRNDXCx+AA9sp37UTQgQFA1yH0BDACyMoHy//J0AGBAQj0Cm+hMYAIBIA4PABmtznaiaEAga5Drhf/AABmvHfaiaEAQa5DrhY/AAG7SB/oA1NQi+QAFyMoHFcv/ydB3dIAYyMsFywIizxZQBfoCFMtrEszMyXP7AMhAFIEBCPRR8qcCAHCBAQjXGPoA0z/IVCBHgQEI9FHyp4IQbm90ZXB0gBjIywXLAlAGzxZQBPoCFMtqEssfyz/Jc/sAAgBsgQEI1xj6ANM/MFIkgQEI9Fnyp4IQZHN0cnB0gBjIywXLAlAFzxZQA/oCE8tqyx8Syz/Jc/sAAAr0AMntVA==",
          "base64"
        )
      )[0],
      a = (0, Io.beginCell)()
        .storeUint(0, 32)
        .storeUint(this.walletId, 32)
        .storeBuffer(this.publicKey)
        .storeBit(0)
        .endCell();
    (this.init = { code: l, data: a }),
      (this.address = (0, Io.contractAddress)(e, { code: l, data: a }));
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active"
      ? (await e.get("seqno", [])).stack.readNumber()
      : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, n) {
    await e.external(n);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, n) {
    let i = this.createTransfer(n);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let n = Io.SendMode.PAY_GAS_SEPARATELY;
    return (
      e.sendMode !== null && e.sendMode !== void 0 && (n = e.sendMode),
      (0, yT.createWalletTransferV4)({
        seqno: e.seqno,
        sendMode: n,
        secretKey: e.secretKey,
        messages: e.messages,
        timeout: e.timeout,
        walletId: this.walletId,
      })
    );
  }
  /**
   * Create sender
   */
  sender(e, n) {
    return {
      send: async (i) => {
        let l = await this.getSeqno(e),
          a = this.createTransfer({
            seqno: l,
            secretKey: n,
            sendMode: i.sendMode,
            messages: [
              (0, Io.internal)({
                to: i.to,
                value: i.value,
                init: i.init,
                body: i.body,
                bounce: i.bounce,
              }),
            ],
          });
        await this.send(e, a);
      },
    };
  }
}
Sc.WalletContractV4 = Om;
var Ec = {};
Object.defineProperty(Ec, "__esModule", { value: !0 });
Ec.JettonMaster = void 0;
const bT = _t;
class Um {
  static create(e) {
    return new Um(e);
  }
  constructor(e) {
    this.address = e;
  }
  async getWalletAddress(e, n) {
    return (
      await e.get("get_wallet_address", [
        { type: "slice", cell: (0, bT.beginCell)().storeAddress(n).endCell() },
      ])
    ).stack.readAddress();
  }
  async getJettonData(e) {
    let n = await e.get("get_jetton_data", []),
      i = n.stack.readBigNumber(),
      l = n.stack.readBoolean(),
      a = n.stack.readAddress(),
      c = n.stack.readCell(),
      v = n.stack.readCell();
    return {
      totalSupply: i,
      mintable: l,
      adminAddress: a,
      content: c,
      walletCode: v,
    };
  }
}
Ec.JettonMaster = Um;
var Ac = {};
Object.defineProperty(Ac, "__esModule", { value: !0 });
Ac.JettonWallet = void 0;
class Nm {
  static create(e) {
    return new Nm(e);
  }
  constructor(e) {
    this.address = e;
  }
  async getBalance(e) {
    return (await e.getState()).state.type !== "active"
      ? 0n
      : (await e.get("get_wallet_data", [])).stack.readBigNumber();
  }
}
Ac.JettonWallet = Nm;
var jf = {};
Object.defineProperty(jf, "__esModule", { value: !0 });
jf.MultisigOrder = void 0;
const V2 = ss(),
  hl = _t;
class ru {
  constructor(e) {
    (this.signatures = {}), (this.payload = e);
  }
  static fromCell(e) {
    var c;
    let n = e.beginParse(),
      i = (c = n.loadMaybeRef()) == null ? void 0 : c.beginParse();
    const l = n.asCell();
    let a = new ru(l);
    if (i) {
      for (; i.remainingBits > 0; ) {
        const v = i.loadBuffer(64),
          g = i.loadUint(8);
        (a.signatures[g] = v), i.remainingRefs > 0 ? (i = i.loadRef().asSlice()) : i.skip(1);
      }
      i.endParse();
    }
    return a;
  }
  static fromPayload(e) {
    return new ru(e);
  }
  addSignature(e, n, i) {
    const l = this.payload.hash();
    if (!(0, V2.signVerify)(l, n, i.owners.get(e).slice(0, -1))) throw Error("invalid signature");
    this.signatures[e] = n;
  }
  sign(e, n) {
    const i = this.payload.hash();
    return (this.signatures[e] = (0, V2.sign)(i, n)), i;
  }
  unionSignatures(e) {
    this.signatures = Object.assign({}, this.signatures, e.signatures);
  }
  clearSignatures() {
    this.signatures = {};
  }
  toCell(e) {
    let n = (0, hl.beginCell)().storeBit(0);
    for (const i in this.signatures) {
      const l = this.signatures[i];
      n = (0, hl.beginCell)()
        .storeBit(1)
        .storeRef(
          (0, hl.beginCell)().storeBuffer(l).storeUint(parseInt(i), 8).storeBuilder(n).endCell()
        );
    }
    return (0, hl.beginCell)()
      .storeUint(e, 8)
      .storeBuilder(n)
      .storeBuilder(this.payload.asBuilder())
      .endCell();
  }
}
jf.MultisigOrder = ru;
var kc = {};
Object.defineProperty(kc, "__esModule", { value: !0 });
kc.MultisigOrderBuilder = void 0;
const Oo = _t,
  wT = jf;
class _T {
  constructor(e, n) {
    (this.messages = (0, Oo.beginCell)()),
      (this.queryId = 0n),
      (this.walletId = e),
      (this.queryOffset = n || 7200);
  }
  addMessage(e, n) {
    if (this.messages.refs >= 4) throw Error("only 4 refs are allowed");
    this.updateQueryId(),
      this.messages.storeUint(n, 8),
      this.messages.storeRef(
        (0, Oo.beginCell)()
          .store((0, Oo.storeMessageRelaxed)(e))
          .endCell()
      );
  }
  clearMessages() {
    this.messages = (0, Oo.beginCell)();
  }
  build() {
    return wT.MultisigOrder.fromPayload(
      (0, Oo.beginCell)()
        .storeUint(this.walletId, 32)
        .storeUint(this.queryId, 64)
        .storeBuilder(this.messages)
        .endCell()
    );
  }
  updateQueryId() {
    const e = BigInt(Math.floor(Date.now() / 1e3 + this.queryOffset));
    this.queryId = e << 32n;
  }
}
kc.MultisigOrderBuilder = _T;
var Bc = {};
Object.defineProperty(Bc, "__esModule", { value: !0 });
Bc.MultisigWallet = void 0;
const W2 = ss(),
  an = _t,
  xT = an.Cell.fromBase64(
    "te6ccgECKwEABBgAART/APSkE/S88sgLAQIBIAIDAgFIBAUE2vIgxwCOgzDbPOCDCNcYIPkBAdMH2zwiwAAToVNxePQOb6Hyn9s8VBq6+RDyoAb0BCD5AQHTH1EYuvKq0z9wUwHwCgHCCAGDCryx8mhTFYBA9A5voSCYDqQgwgryZw7f+COqH1NAufJhVCOjU04gIyEiAgLMBgcCASAMDQIBIAgJAgFmCgsAA9GEAiPymAvHoHN9CYbZ5S7Z4BPHohwhJQAtAKkItdJEqCTItdKlwLUAdAT8ArobBKAATwhbpEx4CBukTDgAdAg10rDAJrUAvALyFjPFszJ4HHXI8gBzxb0AMmACASAODwIBIBQVARW77ZbVA0cFUg2zyCoCAUgQEQIBIBITAXOxHXQgwjXGCD5AQHTB4IB1MTtQ9hTIHj0Dm+h8p/XC/9eMfkQ8qCuAfQEIW6TW3Ey4PkBWNs8AaQBgJwA9rtqA6ADoAPoCAXoCEfyAgPyA3XlP+AXkegAA54tkwAAXrhlXP8EA1WZ2oexAAgEgFhcCASAYGQFRtyVbZ4YmRmpGEAgegc30McJNhFpAADMaYeYuAFrgJhwLb+4cC3d0bhAjAYm1WZtnhqvgb+2xxsoicAgej430pBHEoFpAADHDhBACGuQkuuBk9kUWE5kAOeLKhACQCB6IYFImHFImHFImXEA2YlzNijAjAgEgGhsAF7UGtc4QQDVZnah7EAIBIBwdAgOZOB4fARGsGm2eL4G2CUAjABWt+UEAzJV2oewYQAENqTbPBVfBYCMAFa3f3CCAarM7UPYgAiDbPALyZfgAUENxQxPbPO1UIyoACtP/0wcwBKDbPC+uUyCw8mISsQKkJbNTHLmwJYEA4aojoCi8sPJpggGGoPgBBZcCERACPj4wjo0REB/bPEDXePRDEL0F4lQWW1Rz51YQU9zbPFRxClR6vCQlKCYAIO1E0NMf0wfTB9M/9AT0BNEAXgGOGjDSAAHyo9MH0wdQA9cBIPkBBfkBFbrypFAD4GwhIddKqgIi10m68qtwVCATAAwByMv/ywcE1ts87VT4D3AlblOJvrGYEG4QLVDHXwePGzBUJANQTds8UFWgRlAQSRA6SwlTuds8UFQWf+L4AAeDJaGOLCaAQPSWb6UglDBTA7neII4WODk5CNIAAZfTBzAW8AcFkTDifwgHBZJsMeKz5jAGKicoKQBgcI4pA9CDCNcY0wf0BDBTFnj0Dm+h8qXXC/9URUT5EPKmrlIgsVIDvRShI27mbCIyAH5SML6OIF8D+ACTItdKmALTB9QC+wAC6DJwyMoAQBSAQPRDAvAHjhdxyMsAFMsHEssHWM8BWM8WQBOAQPRDAeIBII6KEEUQNEMA2zztVJJfBuIqABzIyx/LB8sHyz/0APQAyQ=="
  );
class Dm {
  constructor(e, n, i, l, a) {
    (this.provider = null),
      (this.owners = an.Dictionary.empty()),
      (this.workchain = n),
      (this.walletId = i),
      (this.k = l);
    for (let c = 0; c < e.length; c += 1) this.owners.set(c, Qe.concat([e[c], Qe.alloc(1)]));
    (this.init = {
      code: xT,
      data: (0, an.beginCell)()
        .storeUint(this.walletId, 32)
        .storeUint(this.owners.size, 8)
        .storeUint(this.k, 8)
        .storeUint(0, 64)
        .storeDict(this.owners, an.Dictionary.Keys.Uint(8), an.Dictionary.Values.Buffer(33))
        .storeBit(0)
        .endCell(),
    }),
      (this.address = (a == null ? void 0 : a.address) || (0, an.contractAddress)(n, this.init)),
      a != null && a.provider
        ? (this.provider = a.provider)
        : a != null &&
          a.client &&
          (this.provider = a.client.provider(this.address, {
            code: this.init.code,
            data: this.init.data,
          }));
  }
  static async fromAddress(e, n) {
    let i;
    if (n.provider) i = n.provider;
    else {
      if (!n.client) throw Error("Either provider or client must be specified");
      i = n.client.provider(e, {
        code: null,
        data: null,
      });
    }
    const l = (await i.getState()).state;
    if (l.type !== "active") throw Error("Contract must be active");
    const a = an.Cell.fromBoc(l.data)[0].beginParse(),
      c = a.loadUint(32);
    a.skip(8);
    const v = a.loadUint(8);
    a.skip(64);
    const g = a.loadDict(an.Dictionary.Keys.Uint(8), an.Dictionary.Values.Buffer(33));
    let b = [];
    for (const [p, _] of g) {
      const M = _.subarray(0, 32);
      b.push(M);
    }
    return new Dm(b, e.workChain, c, v, {
      address: e,
      provider: i,
      client: n.client,
    });
  }
  async deployExternal(e) {
    if (!e && !this.provider)
      throw Error(
        "you must specify provider if there is no such property in MultisigWallet instance"
      );
    e || (e = this.provider), await e.external(an.Cell.EMPTY);
  }
  async deployInternal(e, n = 1000000000n) {
    await e.send({
      sendMode: 3,
      to: this.address,
      value: n,
      init: this.init,
      body: an.Cell.EMPTY,
      bounce: !0,
    });
  }
  async sendOrder(e, n, i) {
    if (!i && !this.provider)
      throw Error(
        "you must specify provider if there is no such property in MultisigWallet instance"
      );
    i || (i = this.provider);
    let l = (0, W2.keyPairFromSecretKey)(n).publicKey,
      a = this.getOwnerIdByPubkey(l),
      c = e.toCell(a),
      v = (0, W2.sign)(c.hash(), n);
    (c = (0, an.beginCell)().storeBuffer(v).storeSlice(c.asSlice()).endCell()), await i.external(c);
  }
  async sendOrderWithoutSecretKey(e, n, i, l) {
    if (!l && !this.provider)
      throw Error(
        "you must specify provider if there is no such property in MultisigWallet instance"
      );
    l || (l = this.provider);
    let a = e.toCell(i);
    (a = (0, an.beginCell)().storeBuffer(n).storeSlice(a.asSlice()).endCell()), await l.external(a);
  }
  getOwnerIdByPubkey(e) {
    for (const [n, i] of this.owners) if (i.subarray(0, 32).equals(e)) return n;
    throw Error("public key is not an owner");
  }
}
Bc.MultisigWallet = Dm;
var Cc = {};
Object.defineProperty(Cc, "__esModule", { value: !0 });
Cc.ElectorContract = void 0;
const gn = _t,
  MT = {
    serialize(t, e) {
      throw Error("not implemented");
    },
    parse(t) {
      const e = new gn.Address(-1, t.loadBuffer(32)),
        n = t.loadUintBig(64),
        i = t.loadCoins();
      return { address: e, weight: n, stake: i };
    },
  },
  ST = {
    serialize(t, e) {
      throw Error("not implemented");
    },
    parse(t) {
      const e = t.loadCoins();
      t.skip(64);
      const n = new gn.Address(-1, t.loadBuffer(32)),
        i = t.loadBuffer(32);
      return { stake: e, address: n, adnl: i };
    },
  };
class Lm {
  //readonly source: ContractSource = new UnknownContractSource('org.ton.elector', -1, 'Elector Contract');
  static create() {
    return new Lm();
  }
  constructor() {
    this.address = gn.Address.parseRaw(
      "-1:3333333333333333333333333333333333333333333333333333333333333333"
    );
  }
  async getReturnedStake(e, n) {
    if (n.workChain !== -1) throw Error("Only masterchain addresses could have stake");
    return (
      await e.get("compute_returned_stake", [
        { type: "int", value: BigInt("0x" + n.hash.toString("hex")) },
      ])
    ).stack.readBigNumber();
  }
  async getPastElectionsList(e) {
    const n = await e.get("past_elections_list", []),
      i = new gn.TupleReader(n.stack.readLispList()),
      l = [];
    for (; i.remaining > 0; ) {
      const a = i.readTuple(),
        c = a.readNumber(),
        v = a.readNumber();
      a.pop();
      const g = a.readNumber();
      l.push({ id: c, unfreezeAt: v, stakeHeld: g });
    }
    return l;
  }
  async getPastElections(e) {
    const n = await e.get("past_elections", []),
      i = new gn.TupleReader(n.stack.readLispList()),
      l = [];
    for (; i.remaining > 0; ) {
      const a = i.readTuple(),
        c = a.readNumber(),
        v = a.readNumber(),
        g = a.readNumber();
      a.pop();
      const b = a.readCell(),
        p = a.readBigNumber(),
        _ = a.readBigNumber();
      let M = /* @__PURE__ */ new Map();
      const S = b.beginParse().loadDictDirect(gn.Dictionary.Keys.Buffer(32), MT);
      for (const [A, k] of S)
        M.set(BigInt("0x" + A.toString("hex")).toString(10), {
          address: k.address,
          weight: k.weight,
          stake: k.stake,
        });
      l.push({ id: c, unfreezeAt: v, stakeHeld: g, totalStake: p, bonuses: _, frozen: M });
    }
    return l;
  }
  async getElectionEntities(e) {
    const n = await e.getState();
    if (n.state.type !== "active") throw Error("Unexpected error");
    const l = gn.Cell.fromBoc(n.state.data)[0].beginParse();
    if (!l.loadBit()) return null;
    const a = l.loadRef().beginParse(),
      c = a.loadUint(32),
      v = a.loadUint(32),
      g = a.loadCoins(),
      b = a.loadCoins(),
      p = a.loadDict(gn.Dictionary.Keys.Buffer(32), ST);
    let _ = [];
    if (p)
      for (const [M, S] of p)
        _.push({ pubkey: M, stake: S.stake, address: S.address, adnl: S.adnl });
    return { minStake: g, allStakes: b, endElectionsTime: v, startWorkTime: c, entities: _ };
  }
  // possible code for fetching data via get method if it is possible to set gas limit by request
  // async getElectionEntities(block: number) {
  //     const res = await this.client.runMethod(block, this.address, 'participant_list_extended');
  //     if (res.exitCode !== 0 && res.exitCode !== 1) {
  //         throw Error('Exit code: ' + res.exitCode);
  //     }
  //     let tuple = new TupleReader(res.result);
  //     const startWorkTime = tuple.readNumber();
  //     const endElectionsTime = tuple.readNumber();
  //     const minStake = tuple.readBigNumber();
  //     const allStakes = tuple.readBigNumber();
  //     let entriesTuple = tuple.readTuple();
  //     const entriesRaw = new TupleReader(entriesTuple.readLispList());
  //     let entities: { pubkey: Buffer, stake: bigint, address: Address, adnl: Buffer }[] = [];
  //     while (entriesRaw.remaining > 0) {
  //         const electionsEntry = entriesRaw.readTuple();
  //         const pubkey = electionsEntry.readBuffer();
  //         const stake = electionsEntry.readBigNumber();
  //         const address = electionsEntry.readAddress();
  //         const adnl = electionsEntry.readBuffer();
  //         entities.push({ pubkey, stake, address, adnl });
  //     }
  //     return { minStake, allStakes, endElectionsTime, startWorkTime, entities };
  // }
  async getActiveElectionId(e) {
    const i = (await e.get("active_election_id", [])).stack.readNumber();
    return i > 0 ? i : null;
  }
  async getComplaints(e, n) {
    const i = new gn.TupleBuilder();
    i.writeNumber(n);
    const l = await e.get("list_complaints", i.build());
    if (l.stack.peek().type === "null") return [];
    const a = new gn.TupleReader(l.stack.readLispList()),
      c = [];
    for (; a.remaining > 0; ) {
      const v = a.readTuple(),
        g = v.readBigNumber(),
        b = v.readTuple(),
        p = b.readTuple(),
        _ = Qe.from(p.readBigNumber().toString(16), "hex");
      p.readCell();
      const M = p.readNumber(),
        S = p.readNumber(),
        A = new gn.Address(-1, Qe.from(p.readBigNumber().toString(16), "hex")),
        k = p.readBigNumber(),
        P = p.readBigNumber(),
        B = p.readBigNumber(),
        T = [],
        F = new gn.TupleReader(b.readLispList());
      for (; F.remaining > 0; ) T.push(F.readNumber());
      const O = b.readBigNumber(),
        $ = b.readBigNumber();
      c.push({
        id: g,
        publicKey: _,
        createdAt: M,
        severity: S,
        paid: k,
        suggestedFine: P,
        suggestedFinePart: B,
        rewardAddress: A,
        votes: T,
        remainingWeight: $,
        vsetId: O,
      });
    }
    return c;
  }
}
Cc.ElectorContract = Lm;
var Ct = {};
Object.defineProperty(Ct, "__esModule", { value: !0 });
Ct.parseFullConfig =
  Ct.loadConfigParamsAsSlice =
  Ct.loadConfigParamById =
  Ct.parseVotingSetup =
  Ct.parseProposalSetup =
  Ct.configParse29 =
  Ct.configParse28 =
  Ct.configParseMsgPrices =
  Ct.configParseGasLimitsPrices =
  Ct.configParseBridge =
  Ct.configParseValidatorSet =
  Ct.configParse12 =
  Ct.configParseWorkchainDescriptor =
  Ct.configParse40 =
  Ct.configParse8 =
  Ct.configParse18 =
  Ct.configParse17 =
  Ct.configParse16 =
  Ct.configParse15 =
  Ct.configParse13 =
  Ct.configParse5 =
  Ct.configParseMasterAddressRequired =
  Ct.parseBridge =
  Ct.parseValidatorSet =
  Ct.configParseMasterAddress =
    void 0;
const Qr = _t;
function Jo(t) {
  return t ? new Qr.Address(-1, t.loadBuffer(32)) : null;
}
Ct.configParseMasterAddress = Jo;
function K2(t) {
  if (t.loadUint(32) !== 2390828938) throw Error("Invalid config");
  return t.loadBuffer(32);
}
const Z2 = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    const e = t.loadUint(8);
    if (e === 83)
      return {
        publicKey: K2(t),
        weight: t.loadUintBig(64),
        adnlAddress: null,
      };
    if (e === 115)
      return {
        publicKey: K2(t),
        weight: t.loadUintBig(64),
        adnlAddress: t.loadBuffer(32),
      };
    throw Error("Invalid config");
  },
};
function C8(t) {
  const e = t.loadUint(8);
  if (e === 17) {
    const n = t.loadUint(32),
      i = t.loadUint(32),
      l = t.loadUint(16),
      a = t.loadUint(16),
      c = t.loadDictDirect(Qr.Dictionary.Keys.Uint(16), Z2);
    return {
      timeSince: n,
      timeUntil: i,
      total: l,
      main: a,
      totalWeight: null,
      list: c,
    };
  } else if (e === 18) {
    const n = t.loadUint(32),
      i = t.loadUint(32),
      l = t.loadUint(16),
      a = t.loadUint(16),
      c = t.loadUintBig(64),
      v = t.loadDict(Qr.Dictionary.Keys.Uint(16), Z2);
    return {
      timeSince: n,
      timeUntil: i,
      total: l,
      main: a,
      totalWeight: c,
      list: v,
    };
  }
}
Ct.parseValidatorSet = C8;
function T8(t) {
  const e = new Qr.Address(-1, t.loadBuffer(32)),
    n = new Qr.Address(-1, t.loadBuffer(32)),
    i = t.loadDict(Qr.Dictionary.Keys.Buffer(32), Qr.Dictionary.Values.Buffer(32)),
    l = /* @__PURE__ */ new Map();
  for (const [c, v] of i) l.set(new Qr.Address(-1, c).toString(), v);
  const a = t.loadBuffer(32);
  return {
    bridgeAddress: e,
    oracleMultisigAddress: n,
    oracles: l,
    externalChainAddress: a,
  };
}
Ct.parseBridge = T8;
function Wp(t) {
  if (!t) throw Error("Invalid config");
  return Jo(t);
}
Ct.configParseMasterAddressRequired = Wp;
function P8(t) {
  if (!t) throw Error("Invalid config");
  if (t.loadUint(8) === 1) {
    const n = t.loadBit() ? new Qr.Address(-1, t.loadBuffer(32)) : null,
      i = t.loadUint(32),
      l = t.loadUint(32);
    return {
      blackholeAddr: n,
      feeBurnNominator: i,
      feeBurnDenominator: l,
    };
  }
  throw new Error("Invalid config");
}
Ct.configParse5 = P8;
function ET(t) {
  if (!t) throw Error("Invalid config");
  if (t.loadUint(8) === 26) {
    const n = t.loadCoins(),
      i = t.loadCoins(),
      l = t.loadCoins();
    return {
      deposit: n,
      bitPrice: i,
      cellPrice: l,
    };
  }
  throw new Error("Invalid config");
}
Ct.configParse13 = ET;
function R8(t) {
  if (!t) throw Error("Invalid config");
  const e = t.loadUint(32),
    n = t.loadUint(32),
    i = t.loadUint(32),
    l = t.loadUint(32);
  return {
    validatorsElectedFor: e,
    electorsStartBefore: n,
    electorsEndBefore: i,
    stakeHeldFor: l,
  };
}
Ct.configParse15 = R8;
function I8(t) {
  if (!t) throw Error("Invalid config");
  const e = t.loadUint(16),
    n = t.loadUint(16),
    i = t.loadUint(16);
  return {
    maxValidators: e,
    maxMainValidators: n,
    minValidators: i,
  };
}
Ct.configParse16 = I8;
function O8(t) {
  if (!t) throw Error("Invalid config");
  const e = t.loadCoins(),
    n = t.loadCoins(),
    i = t.loadCoins(),
    l = t.loadUint(32);
  return {
    minStake: e,
    maxStake: n,
    minTotalStake: i,
    maxStakeFactor: l,
  };
}
Ct.configParse17 = O8;
const AT = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    if (t.loadUint(8) !== 204) throw Error("Invalid config");
    const n = t.loadUint(32),
      i = t.loadUintBig(64),
      l = t.loadUintBig(64),
      a = t.loadUintBig(64),
      c = t.loadUintBig(64);
    return {
      utime_since: n,
      bit_price_ps: i,
      cell_price_ps: l,
      mc_bit_price_ps: a,
      mc_cell_price_ps: c,
    };
  },
};
function U8(t) {
  if (!t) throw Error("Invalid config");
  return t.loadDictDirect(Qr.Dictionary.Keys.Buffer(4), AT).values();
}
Ct.configParse18 = U8;
function N8(t) {
  if (!t)
    return {
      version: 0,
      capabilities: 0n,
    };
  const e = t.loadUint(32),
    n = t.loadUintBig(64);
  return {
    version: e,
    capabilities: n,
  };
}
Ct.configParse8 = N8;
function D8(t) {
  if (!t) return null;
  if (t.loadUint(8) !== 1) throw Error("Invalid config");
  const n = t.loadCoins(),
    i = t.loadCoins(),
    l = t.loadUint(16),
    a = t.loadUint(16),
    c = t.loadUint(16),
    v = t.loadUint(16),
    g = t.loadUint(16),
    b = t.loadUint(16),
    p = t.loadUint(16),
    _ = t.loadUint(16),
    M = t.loadUint(16);
  return {
    defaultFlatFine: n,
    defaultProportionaFine: i,
    severityFlatMult: l,
    severityProportionalMult: a,
    unfunishableInterval: c,
    longInterval: v,
    longFlatMult: g,
    longProportionalMult: b,
    mediumInterval: p,
    mediumFlatMult: _,
    mediumProportionalMult: M,
  };
}
Ct.configParse40 = D8;
function kT(t) {
  if (t.loadUint(8) !== 166) throw Error("Invalid config");
  const e = t.loadUint(32),
    n = t.loadUint(8),
    i = t.loadUint(8),
    l = t.loadUint(8),
    a = t.loadBit(),
    c = t.loadBit(),
    v = t.loadBit(),
    g = t.loadUint(13),
    b = t.loadBuffer(32),
    p = t.loadBuffer(32),
    _ = t.loadUint(32);
  if (t.loadBit()) throw Error("Invalid config");
  const M = t.loadUint(32),
    S = t.loadUintBig(64);
  return {
    enabledSince: e,
    actialMinSplit: n,
    min_split: i,
    max_split: l,
    basic: a,
    active: c,
    accept_msgs: v,
    flags: g,
    zerostateRootHash: b,
    zerostateFileHash: p,
    version: _,
    format: {
      vmVersion: M,
      vmMode: S,
    },
  };
}
Ct.configParseWorkchainDescriptor = kT;
const BT = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    if (t.loadUint(8) !== 166) throw Error("Invalid config");
    const e = t.loadUint(32),
      n = t.loadUint(8),
      i = t.loadUint(8),
      l = t.loadUint(8),
      a = t.loadBit(),
      c = t.loadBit(),
      v = t.loadBit(),
      g = t.loadUint(13),
      b = t.loadBuffer(32),
      p = t.loadBuffer(32),
      _ = t.loadUint(32);
    if (t.loadBit()) throw Error("Invalid config");
    const M = t.loadUint(32),
      S = t.loadUintBig(64);
    return {
      enabledSince: e,
      actialMinSplit: n,
      min_split: i,
      max_split: l,
      basic: a,
      active: c,
      accept_msgs: v,
      flags: g,
      zerostateRootHash: b,
      zerostateFileHash: p,
      version: _,
      format: {
        vmVersion: M,
        vmMode: S,
      },
    };
  },
};
function L8(t) {
  if (!t) throw Error("Invalid config");
  const e = t.loadDict(Qr.Dictionary.Keys.Uint(32), BT);
  if (e) return e;
  throw Error("No workchains exist");
}
Ct.configParse12 = L8;
function wa(t) {
  return t ? C8(t) : null;
}
Ct.configParseValidatorSet = wa;
function Wl(t) {
  return t ? T8(t) : null;
}
Ct.configParseBridge = Wl;
function CT(t) {
  const e = t.loadUint(8);
  if (e === 222) {
    const n = t.loadUintBig(64),
      i = t.loadUintBig(64),
      l = t.loadUintBig(64),
      a = t.loadUintBig(64),
      c = t.loadUintBig(64),
      v = t.loadUintBig(64),
      g = t.loadUintBig(64);
    return {
      gasPrice: n,
      gasLimit: i,
      specialGasLimit: l,
      gasCredit: a,
      blockGasLimit: c,
      freezeDueLimit: v,
      deleteDueLimit: g,
    };
  } else if (e === 221) {
    const n = t.loadUintBig(64),
      i = t.loadUintBig(64),
      l = t.loadUintBig(64),
      a = t.loadUintBig(64),
      c = t.loadUintBig(64),
      v = t.loadUintBig(64);
    return {
      gasPrice: n,
      gasLimit: i,
      gasCredit: l,
      blockGasLimit: a,
      freezeDueLimit: c,
      deleteDueLimit: v,
    };
  } else throw Error("Invalid config");
}
function Kp(t) {
  if (!t) throw Error("Invalid config");
  if (t.loadUint(8) === 209) {
    const n = t.loadUintBig(64),
      i = t.loadUintBig(64),
      l = CT(t);
    return {
      flatLimit: n,
      flatGasPrice: i,
      other: l,
    };
  } else throw Error("Invalid config");
}
Ct.configParseGasLimitsPrices = Kp;
function Zp(t) {
  if (!t) throw new Error("Invalid config");
  if (t.loadUint(8) !== 234) throw new Error("Invalid msg prices param");
  return {
    lumpPrice: t.loadUintBig(64),
    bitPrice: t.loadUintBig(64),
    cellPrice: t.loadUintBig(64),
    ihrPriceFactor: t.loadUint(32),
    firstFrac: t.loadUint(16),
    nextFrac: t.loadUint(16),
  };
}
Ct.configParseMsgPrices = Zp;
function F8(t) {
  if (!t) throw new Error("Invalid config");
  const e = t.loadUint(8);
  if (e === 193) {
    const n = t.loadUint(32),
      i = t.loadUint(32),
      l = t.loadUint(32),
      a = t.loadUint(32);
    return {
      masterCatchainLifetime: n,
      shardCatchainLifetime: i,
      shardValidatorsLifetime: l,
      shardValidatorsCount: a,
    };
  }
  if (e === 194) {
    const n = t.loadUint(7),
      i = t.loadBit(),
      l = t.loadUint(32),
      a = t.loadUint(32),
      c = t.loadUint(32),
      v = t.loadUint(32);
    return {
      flags: n,
      suffleMasterValidators: i,
      masterCatchainLifetime: l,
      shardCatchainLifetime: a,
      shardValidatorsLifetime: c,
      shardValidatorsCount: v,
    };
  }
  throw new Error("Invalid config");
}
Ct.configParse28 = F8;
function q8(t) {
  if (!t) throw new Error("Invalid config");
  const e = t.loadUint(8);
  if (e === 214) {
    const n = t.loadUint(32),
      i = t.loadUint(32),
      l = t.loadUint(32),
      a = t.loadUint(32),
      c = t.loadUint(32),
      v = t.loadUint(32),
      g = t.loadUint(32),
      b = t.loadUint(32);
    return {
      roundCandidates: n,
      nextCandidateDelay: i,
      consensusTimeout: l,
      fastAttempts: a,
      attemptDuration: c,
      catchainMaxDeps: v,
      maxBlockBytes: g,
      maxColaltedBytes: b,
    };
  } else if (e === 215) {
    const n = t.loadUint(7),
      i = t.loadBit(),
      l = t.loadUint(8),
      a = t.loadUint(32),
      c = t.loadUint(32),
      v = t.loadUint(32),
      g = t.loadUint(32),
      b = t.loadUint(32),
      p = t.loadUint(32),
      _ = t.loadUint(32);
    return {
      flags: n,
      newCatchainIds: i,
      roundCandidates: l,
      nextCandidateDelay: a,
      consensusTimeout: c,
      fastAttempts: v,
      attemptDuration: g,
      catchainMaxDeps: b,
      maxBlockBytes: p,
      maxColaltedBytes: _,
    };
  } else if (e === 216) {
    const n = t.loadUint(7),
      i = t.loadBit(),
      l = t.loadUint(8),
      a = t.loadUint(32),
      c = t.loadUint(32),
      v = t.loadUint(32),
      g = t.loadUint(32),
      b = t.loadUint(32),
      p = t.loadUint(32),
      _ = t.loadUint(32),
      M = t.loadUint(16);
    return {
      flags: n,
      newCatchainIds: i,
      roundCandidates: l,
      nextCandidateDelay: a,
      consensusTimeout: c,
      fastAttempts: v,
      attemptDuration: g,
      catchainMaxDeps: b,
      maxBlockBytes: p,
      maxColaltedBytes: _,
      protoVersion: M,
    };
  } else if (e === 217) {
    const n = t.loadUint(7),
      i = t.loadBit(),
      l = t.loadUint(8),
      a = t.loadUint(32),
      c = t.loadUint(32),
      v = t.loadUint(32),
      g = t.loadUint(32),
      b = t.loadUint(32),
      p = t.loadUint(32),
      _ = t.loadUint(32),
      M = t.loadUint(16),
      S = t.loadUint(32);
    return {
      flags: n,
      newCatchainIds: i,
      roundCandidates: l,
      nextCandidateDelay: a,
      consensusTimeout: c,
      fastAttempts: v,
      attemptDuration: g,
      catchainMaxDeps: b,
      maxBlockBytes: p,
      maxColaltedBytes: _,
      protoVersion: M,
      catchainMaxBlocksCoeff: S,
    };
  }
  throw new Error("Invalid config");
}
Ct.configParse29 = q8;
function Gp(t) {
  if (t.loadUint(8) !== 54) throw new Error("Invalid config");
  const n = t.loadUint(8),
    i = t.loadUint(8),
    l = t.loadUint(8),
    a = t.loadUint(8),
    c = t.loadUint(32),
    v = t.loadUint(32),
    g = t.loadUint(32),
    b = t.loadUint(32);
  return {
    minTotalRounds: n,
    maxTotalRounds: i,
    minWins: l,
    maxLoses: a,
    minStoreSec: c,
    maxStoreSec: v,
    bitPrice: g,
    cellPrice: b,
  };
}
Ct.parseProposalSetup = Gp;
function z8(t) {
  if (!t) throw new Error("Invalid config");
  if (t.loadUint(8) !== 145) throw new Error("Invalid config");
  const n = Gp(t.loadRef().beginParse()),
    i = Gp(t.loadRef().beginParse());
  return { normalParams: n, criticalParams: i };
}
Ct.parseVotingSetup = z8;
function j8(t) {
  return Qr.Cell.fromBase64(t)
    .beginParse()
    .loadDictDirect(Qr.Dictionary.Keys.Int(32), Qr.Dictionary.Values.Cell());
}
function TT(t, e) {
  return j8(t).get(e);
}
Ct.loadConfigParamById = TT;
function PT(t) {
  const e = j8(t),
    n = /* @__PURE__ */ new Map();
  for (const [i, l] of e) n.set(i, l.beginParse());
  return n;
}
Ct.loadConfigParamsAsSlice = PT;
function RT(t) {
  return {
    configAddress: Wp(t.get(0)),
    electorAddress: Wp(t.get(1)),
    minterAddress: Jo(t.get(2)),
    feeCollectorAddress: Jo(t.get(3)),
    dnsRootAddress: Jo(t.get(4)),
    burningConfig: P8(t.get(5)),
    globalVersion: N8(t.get(8)),
    workchains: L8(t.get(12)),
    voting: z8(t.get(11)),
    validators: {
      ...R8(t.get(15)),
      ...I8(t.get(16)),
      ...O8(t.get(17)),
    },
    storagePrices: U8(t.get(18)),
    gasPrices: {
      masterchain: Kp(t.get(20)),
      workchain: Kp(t.get(21)),
    },
    msgPrices: {
      masterchain: Zp(t.get(24)),
      workchain: Zp(t.get(25)),
    },
    validatorSets: {
      prevValidators: wa(t.get(32)),
      prevTempValidators: wa(t.get(33)),
      currentValidators: wa(t.get(34)),
      currentTempValidators: wa(t.get(35)),
      nextValidators: wa(t.get(36)),
      nextTempValidators: wa(t.get(37)),
    },
    validatorsPunish: D8(t.get(40)),
    bridges: {
      ethereum: Wl(t.get(71)),
      binance: Wl(t.get(72)),
      polygon: Wl(t.get(73)),
    },
    catchain: F8(t.get(28)),
    consensus: q8(t.get(29)),
    // TODO: mint_new_price:Grams mint_add_price:Grams = ConfigParam 6;
    // TODO: to_mint:ExtraCurrencyCollection = ConfigParam 7
    // TODO: mandatory_params:(Hashmap 32 True) = ConfigParam 9
    // TODO: critical_params:(Hashmap 32 True) = ConfigParam 10
    // TODO: BlockCreateFees = ConfigParam 14
  };
}
Ct.parseFullConfig = RT;
var Mn = {};
Object.defineProperty(Mn, "__esModule", { value: !0 });
Mn.computeMessageForwardFees =
  Mn.computeExternalMessageFees =
  Mn.computeGasPrices =
  Mn.computeFwdFees =
  Mn.computeStorageFees =
    void 0;
const Y0 = _t;
function IT(t) {
  const { lastPaid: e, now: n, storagePrices: i, storageStat: l, special: a, masterchain: c } = t;
  if (n <= e || i.length === 0 || n < i[0].utime_since || a) return BigInt(0);
  let v = Math.max(e, i[0].utime_since),
    g = BigInt(0);
  for (let b = 0; b < i.length && v < n; b++) {
    let p = b < i.length - 1 ? Math.min(n, i[b + 1].utime_since) : n,
      _ = BigInt(0);
    if (v < p) {
      let M = p - v;
      (_ += BigInt(l.cells) * (c ? i[b].mc_cell_price_ps : i[b].cell_price_ps)),
        (_ += BigInt(l.bits) * (c ? i[b].mc_bit_price_ps : i[b].bit_price_ps)),
        (_ = _ * BigInt(M));
    }
    (v = p), (g += _);
  }
  return $8(g);
}
Mn.computeStorageFees = IT;
function Fm(t, e, n) {
  return t.lumpPrice + $8(t.bitPrice * n + t.cellPrice * e);
}
Mn.computeFwdFees = Fm;
function OT(t, e) {
  return t <= e.flatLimit ? e.flatPrice : e.flatPrice + ((e.price * (t - e.flatLimit)) >> 16n);
}
Mn.computeGasPrices = OT;
function UT(t, e) {
  let n = nu(e);
  return (n.bits -= e.bits.length), (n.cells -= 1), Fm(t, BigInt(n.cells), BigInt(n.bits));
}
Mn.computeExternalMessageFees = UT;
function NT(t, e) {
  let n = (0, Y0.loadMessageRelaxed)(e.beginParse()),
    i = { bits: 0, cells: 0 };
  if (n.init) {
    const g = new Y0.Cell().asBuilder();
    (0, Y0.storeStateInit)(n.init)(g);
    const b = g.endCell();
    let p = nu(b);
    (p.bits -= b.bits.length), (p.cells -= 1), (i.bits += p.bits), (i.cells += p.cells);
  }
  let l = nu(n.body);
  (l.bits -= n.body.bits.length), (l.cells -= 1), (i.bits += l.bits), (i.cells += l.cells);
  let a = Fm(t, BigInt(i.cells), BigInt(i.bits)),
    c = (a * BigInt(t.firstFrac)) >> 16n,
    v = a - c;
  return { fees: c, remaining: v };
}
Mn.computeMessageForwardFees = NT;
function nu(t) {
  let e = t.bits.length,
    n = 1;
  for (let i of t.refs) {
    let l = nu(i);
    (n += l.cells), (e += l.bits);
  }
  return { bits: e, cells: n };
}
function $8(t) {
  let e = t % 65536n,
    n = t >> 16n;
  return e !== 0n && (n += 1n), n;
}
(function (t) {
  var e =
      (mt && mt.__createBinding) ||
      (Object.create
        ? function (J, he, de, ne) {
            ne === void 0 && (ne = de);
            var Ae = Object.getOwnPropertyDescriptor(he, de);
            (!Ae || ("get" in Ae ? !he.__esModule : Ae.writable || Ae.configurable)) &&
              (Ae = {
                enumerable: !0,
                get: function () {
                  return he[de];
                },
              }),
              Object.defineProperty(J, ne, Ae);
          }
        : function (J, he, de, ne) {
            ne === void 0 && (ne = de), (J[ne] = he[de]);
          }),
    n =
      (mt && mt.__exportStar) ||
      function (J, he) {
        for (var de in J)
          de !== "default" && !Object.prototype.hasOwnProperty.call(he, de) && e(he, J, de);
      };
  Object.defineProperty(t, "__esModule", { value: !0 }),
    (t.computeStorageFees =
      t.computeMessageForwardFees =
      t.computeGasPrices =
      t.computeFwdFees =
      t.computeExternalMessageFees =
      t.loadConfigParamsAsSlice =
      t.loadConfigParamById =
      t.parseFullConfig =
      t.parseVotingSetup =
      t.parseValidatorSet =
      t.parseProposalSetup =
      t.parseBridge =
      t.configParseWorkchainDescriptor =
      t.configParseValidatorSet =
      t.configParseMsgPrices =
      t.configParseMasterAddressRequired =
      t.configParseMasterAddress =
      t.configParseGasLimitsPrices =
      t.configParseBridge =
      t.configParse40 =
      t.configParse29 =
      t.configParse28 =
      t.configParse18 =
      t.configParse17 =
      t.configParse16 =
      t.configParse15 =
      t.configParse13 =
      t.configParse12 =
      t.configParse8 =
      t.configParse5 =
      t.ElectorContract =
      t.MultisigWallet =
      t.MultisigOrderBuilder =
      t.MultisigOrder =
      t.JettonWallet =
      t.JettonMaster =
      t.WalletContractV4 =
      t.WalletContractV3R2 =
      t.WalletContractV3R1 =
      t.WalletContractV2R2 =
      t.WalletContractV2R1 =
      t.WalletContractV1R3 =
      t.WalletContractV1R2 =
      t.WalletContractV1R1 =
      t.TonClient4 =
      t.TonClient =
      t.HttpApi =
        void 0),
    n(_t, t);
  var i = Lf;
  Object.defineProperty(t, "HttpApi", {
    enumerable: !0,
    get: function () {
      return i.HttpApi;
    },
  });
  var l = dc;
  Object.defineProperty(t, "TonClient", {
    enumerable: !0,
    get: function () {
      return l.TonClient;
    },
  });
  var a = pc;
  Object.defineProperty(t, "TonClient4", {
    enumerable: !0,
    get: function () {
      return a.TonClient4;
    },
  });
  var c = vc;
  Object.defineProperty(t, "WalletContractV1R1", {
    enumerable: !0,
    get: function () {
      return c.WalletContractV1R1;
    },
  });
  var v = yc;
  Object.defineProperty(t, "WalletContractV1R2", {
    enumerable: !0,
    get: function () {
      return v.WalletContractV1R2;
    },
  });
  var g = bc;
  Object.defineProperty(t, "WalletContractV1R3", {
    enumerable: !0,
    get: function () {
      return g.WalletContractV1R3;
    },
  });
  var b = wc;
  Object.defineProperty(t, "WalletContractV2R1", {
    enumerable: !0,
    get: function () {
      return b.WalletContractV2R1;
    },
  });
  var p = _c;
  Object.defineProperty(t, "WalletContractV2R2", {
    enumerable: !0,
    get: function () {
      return p.WalletContractV2R2;
    },
  });
  var _ = xc;
  Object.defineProperty(t, "WalletContractV3R1", {
    enumerable: !0,
    get: function () {
      return _.WalletContractV3R1;
    },
  });
  var M = Mc;
  Object.defineProperty(t, "WalletContractV3R2", {
    enumerable: !0,
    get: function () {
      return M.WalletContractV3R2;
    },
  });
  var S = Sc;
  Object.defineProperty(t, "WalletContractV4", {
    enumerable: !0,
    get: function () {
      return S.WalletContractV4;
    },
  });
  var A = Ec;
  Object.defineProperty(t, "JettonMaster", {
    enumerable: !0,
    get: function () {
      return A.JettonMaster;
    },
  });
  var k = Ac;
  Object.defineProperty(t, "JettonWallet", {
    enumerable: !0,
    get: function () {
      return k.JettonWallet;
    },
  });
  var P = jf;
  Object.defineProperty(t, "MultisigOrder", {
    enumerable: !0,
    get: function () {
      return P.MultisigOrder;
    },
  });
  var B = kc;
  Object.defineProperty(t, "MultisigOrderBuilder", {
    enumerable: !0,
    get: function () {
      return B.MultisigOrderBuilder;
    },
  });
  var T = Bc;
  Object.defineProperty(t, "MultisigWallet", {
    enumerable: !0,
    get: function () {
      return T.MultisigWallet;
    },
  });
  var F = Cc;
  Object.defineProperty(t, "ElectorContract", {
    enumerable: !0,
    get: function () {
      return F.ElectorContract;
    },
  });
  var O = Ct;
  Object.defineProperty(t, "configParse5", {
    enumerable: !0,
    get: function () {
      return O.configParse5;
    },
  }),
    Object.defineProperty(t, "configParse8", {
      enumerable: !0,
      get: function () {
        return O.configParse8;
      },
    }),
    Object.defineProperty(t, "configParse12", {
      enumerable: !0,
      get: function () {
        return O.configParse12;
      },
    }),
    Object.defineProperty(t, "configParse13", {
      enumerable: !0,
      get: function () {
        return O.configParse13;
      },
    }),
    Object.defineProperty(t, "configParse15", {
      enumerable: !0,
      get: function () {
        return O.configParse15;
      },
    }),
    Object.defineProperty(t, "configParse16", {
      enumerable: !0,
      get: function () {
        return O.configParse16;
      },
    }),
    Object.defineProperty(t, "configParse17", {
      enumerable: !0,
      get: function () {
        return O.configParse17;
      },
    }),
    Object.defineProperty(t, "configParse18", {
      enumerable: !0,
      get: function () {
        return O.configParse18;
      },
    }),
    Object.defineProperty(t, "configParse28", {
      enumerable: !0,
      get: function () {
        return O.configParse28;
      },
    }),
    Object.defineProperty(t, "configParse29", {
      enumerable: !0,
      get: function () {
        return O.configParse29;
      },
    }),
    Object.defineProperty(t, "configParse40", {
      enumerable: !0,
      get: function () {
        return O.configParse40;
      },
    }),
    Object.defineProperty(t, "configParseBridge", {
      enumerable: !0,
      get: function () {
        return O.configParseBridge;
      },
    }),
    Object.defineProperty(t, "configParseGasLimitsPrices", {
      enumerable: !0,
      get: function () {
        return O.configParseGasLimitsPrices;
      },
    }),
    Object.defineProperty(t, "configParseMasterAddress", {
      enumerable: !0,
      get: function () {
        return O.configParseMasterAddress;
      },
    }),
    Object.defineProperty(t, "configParseMasterAddressRequired", {
      enumerable: !0,
      get: function () {
        return O.configParseMasterAddressRequired;
      },
    }),
    Object.defineProperty(t, "configParseMsgPrices", {
      enumerable: !0,
      get: function () {
        return O.configParseMsgPrices;
      },
    }),
    Object.defineProperty(t, "configParseValidatorSet", {
      enumerable: !0,
      get: function () {
        return O.configParseValidatorSet;
      },
    }),
    Object.defineProperty(t, "configParseWorkchainDescriptor", {
      enumerable: !0,
      get: function () {
        return O.configParseWorkchainDescriptor;
      },
    }),
    Object.defineProperty(t, "parseBridge", {
      enumerable: !0,
      get: function () {
        return O.parseBridge;
      },
    }),
    Object.defineProperty(t, "parseProposalSetup", {
      enumerable: !0,
      get: function () {
        return O.parseProposalSetup;
      },
    }),
    Object.defineProperty(t, "parseValidatorSet", {
      enumerable: !0,
      get: function () {
        return O.parseValidatorSet;
      },
    }),
    Object.defineProperty(t, "parseVotingSetup", {
      enumerable: !0,
      get: function () {
        return O.parseVotingSetup;
      },
    }),
    Object.defineProperty(t, "parseFullConfig", {
      enumerable: !0,
      get: function () {
        return O.parseFullConfig;
      },
    }),
    Object.defineProperty(t, "loadConfigParamById", {
      enumerable: !0,
      get: function () {
        return O.loadConfigParamById;
      },
    }),
    Object.defineProperty(t, "loadConfigParamsAsSlice", {
      enumerable: !0,
      get: function () {
        return O.loadConfigParamsAsSlice;
      },
    });
  var $ = Mn;
  Object.defineProperty(t, "computeExternalMessageFees", {
    enumerable: !0,
    get: function () {
      return $.computeExternalMessageFees;
    },
  }),
    Object.defineProperty(t, "computeFwdFees", {
      enumerable: !0,
      get: function () {
        return $.computeFwdFees;
      },
    }),
    Object.defineProperty(t, "computeGasPrices", {
      enumerable: !0,
      get: function () {
        return $.computeGasPrices;
      },
    }),
    Object.defineProperty(t, "computeMessageForwardFees", {
      enumerable: !0,
      get: function () {
        return $.computeMessageForwardFees;
      },
    }),
    Object.defineProperty(t, "computeStorageFees", {
      enumerable: !0,
      get: function () {
        return $.computeStorageFees;
      },
    });
})(Ir);
const DT = "https://toncenter.com/api/v2/jsonRPC",
  LT = "76809e5cf207153195814529b3d13e118db3c6e7f0847676332811c76f8b1053",
  H8 = "EQAzKpZeZBpahP5eUsbU7VE9yRkNZh5VjL-RLnsdMxk24Ele",
  J0 = "EQAINHkNPnw8mw4OBvzuc7nk0HIhJegsDjY0a6M_mREEvRfn";
var $f = class {
    constructor() {
      (this.listeners = /* @__PURE__ */ new Set()), (this.subscribe = this.subscribe.bind(this));
    }
    subscribe(t) {
      return (
        this.listeners.add(t),
        this.onSubscribe(),
        () => {
          this.listeners.delete(t), this.onUnsubscribe();
        }
      );
    }
    hasListeners() {
      return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
  },
  Ys = typeof window > "u" || "Deno" in globalThis;
function xn() {}
function FT(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Yp(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function V8(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function G2(t, e) {
  const { type: n = "all", exact: i, fetchStatus: l, predicate: a, queryKey: c, stale: v } = t;
  if (c) {
    if (i) {
      if (e.queryHash !== qm(c, e.options)) return !1;
    } else if (!of(e.queryKey, c)) return !1;
  }
  if (n !== "all") {
    const g = e.isActive();
    if ((n === "active" && !g) || (n === "inactive" && g)) return !1;
  }
  return !(
    (typeof v == "boolean" && e.isStale() !== v) ||
    (l && l !== e.state.fetchStatus) ||
    (a && !a(e))
  );
}
function Y2(t, e) {
  const { exact: n, status: i, predicate: l, mutationKey: a } = t;
  if (a) {
    if (!e.options.mutationKey) return !1;
    if (n) {
      if (sf(e.options.mutationKey) !== sf(a)) return !1;
    } else if (!of(e.options.mutationKey, a)) return !1;
  }
  return !((i && e.state.status !== i) || (l && !l(e)));
}
function qm(t, e) {
  return ((e == null ? void 0 : e.queryKeyHashFn) || sf)(t);
}
function sf(t) {
  return JSON.stringify(t, (e, n) =>
    Qp(n)
      ? Object.keys(n)
          .sort()
          .reduce((i, l) => ((i[l] = n[l]), i), {})
      : n
  );
}
function of(t, e) {
  return t === e
    ? !0
    : typeof t != typeof e
    ? !1
    : t && e && typeof t == "object" && typeof e == "object"
    ? !Object.keys(e).some((n) => !of(t[n], e[n]))
    : !1;
}
function W8(t, e) {
  if (t === e) return t;
  const n = J2(t) && J2(e);
  if (n || (Qp(t) && Qp(e))) {
    const i = n ? t : Object.keys(t),
      l = i.length,
      a = n ? e : Object.keys(e),
      c = a.length,
      v = n ? [] : {};
    let g = 0;
    for (let b = 0; b < c; b++) {
      const p = n ? b : a[b];
      !n && t[p] === void 0 && e[p] === void 0 && i.includes(p)
        ? ((v[p] = void 0), g++)
        : ((v[p] = W8(t[p], e[p])), v[p] === t[p] && t[p] !== void 0 && g++);
    }
    return l === c && g === l ? t : v;
  }
  return e;
}
function Jp(t, e) {
  if (!e || Object.keys(t).length !== Object.keys(e).length) return !1;
  for (const n in t) if (t[n] !== e[n]) return !1;
  return !0;
}
function J2(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function Qp(t) {
  if (!Q2(t)) return !1;
  const e = t.constructor;
  if (e === void 0) return !0;
  const n = e.prototype;
  return !(!Q2(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function Q2(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function qT(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function Xp(t, e, n) {
  return typeof n.structuralSharing == "function"
    ? n.structuralSharing(t, e)
    : n.structuralSharing !== !1
    ? W8(t, e)
    : e;
}
function zT(t, e, n = 0) {
  const i = [...t, e];
  return n && i.length > n ? i.slice(1) : i;
}
function jT(t, e, n = 0) {
  const i = [e, ...t];
  return n && i.length > n ? i.slice(0, -1) : i;
}
var ff = Symbol(),
  Aa,
  zi,
  Ms,
  b6,
  $T =
    ((b6 = class extends $f {
      constructor() {
        super();
        kt(this, Aa, void 0);
        kt(this, zi, void 0);
        kt(this, Ms, void 0);
        Mt(this, Ms, (e) => {
          if (!Ys && window.addEventListener) {
            const n = () => e();
            return (
              window.addEventListener("visibilitychange", n, !1),
              () => {
                window.removeEventListener("visibilitychange", n);
              }
            );
          }
        });
      }
      onSubscribe() {
        De(this, zi) || this.setEventListener(De(this, Ms));
      }
      onUnsubscribe() {
        var e;
        this.hasListeners() || ((e = De(this, zi)) == null || e.call(this), Mt(this, zi, void 0));
      }
      setEventListener(e) {
        var n;
        Mt(this, Ms, e),
          (n = De(this, zi)) == null || n.call(this),
          Mt(
            this,
            zi,
            e((i) => {
              typeof i == "boolean" ? this.setFocused(i) : this.onFocus();
            })
          );
      }
      setFocused(e) {
        De(this, Aa) !== e && (Mt(this, Aa, e), this.onFocus());
      }
      onFocus() {
        const e = this.isFocused();
        this.listeners.forEach((n) => {
          n(e);
        });
      }
      isFocused() {
        var e;
        return typeof De(this, Aa) == "boolean"
          ? De(this, Aa)
          : ((e = globalThis.document) == null ? void 0 : e.visibilityState) !== "hidden";
      }
    }),
    (Aa = new WeakMap()),
    (zi = new WeakMap()),
    (Ms = new WeakMap()),
    b6),
  zm = new $T(),
  Ss,
  ji,
  Es,
  w6,
  HT =
    ((w6 = class extends $f {
      constructor() {
        super();
        kt(this, Ss, !0);
        kt(this, ji, void 0);
        kt(this, Es, void 0);
        Mt(this, Es, (e) => {
          if (!Ys && window.addEventListener) {
            const n = () => e(!0),
              i = () => e(!1);
            return (
              window.addEventListener("online", n, !1),
              window.addEventListener("offline", i, !1),
              () => {
                window.removeEventListener("online", n), window.removeEventListener("offline", i);
              }
            );
          }
        });
      }
      onSubscribe() {
        De(this, ji) || this.setEventListener(De(this, Es));
      }
      onUnsubscribe() {
        var e;
        this.hasListeners() || ((e = De(this, ji)) == null || e.call(this), Mt(this, ji, void 0));
      }
      setEventListener(e) {
        var n;
        Mt(this, Es, e),
          (n = De(this, ji)) == null || n.call(this),
          Mt(this, ji, e(this.setOnline.bind(this)));
      }
      setOnline(e) {
        De(this, Ss) !== e &&
          (Mt(this, Ss, e),
          this.listeners.forEach((i) => {
            i(e);
          }));
      }
      isOnline() {
        return De(this, Ss);
      }
    }),
    (Ss = new WeakMap()),
    (ji = new WeakMap()),
    (Es = new WeakMap()),
    w6),
  iu = new HT();
function VT(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function jm(t) {
  return (t ?? "online") === "online" ? iu.isOnline() : !0;
}
var K8 = class {
  constructor(t) {
    (this.revert = t == null ? void 0 : t.revert), (this.silent = t == null ? void 0 : t.silent);
  }
};
function Q0(t) {
  return t instanceof K8;
}
function Z8(t) {
  let e = !1,
    n = 0,
    i = !1,
    l,
    a,
    c;
  const v = new Promise((P, B) => {
      (a = P), (c = B);
    }),
    g = (P) => {
      var B;
      i || (S(new K8(P)), (B = t.abort) == null || B.call(t));
    },
    b = () => {
      e = !0;
    },
    p = () => {
      e = !1;
    },
    _ = () => !zm.isFocused() || (t.networkMode !== "always" && !iu.isOnline()),
    M = (P) => {
      var B;
      i || ((i = !0), (B = t.onSuccess) == null || B.call(t, P), l == null || l(), a(P));
    },
    S = (P) => {
      var B;
      i || ((i = !0), (B = t.onError) == null || B.call(t, P), l == null || l(), c(P));
    },
    A = () =>
      new Promise((P) => {
        var B;
        (l = (T) => {
          const F = i || !_();
          return F && P(T), F;
        }),
          (B = t.onPause) == null || B.call(t);
      }).then(() => {
        var P;
        (l = void 0), i || (P = t.onContinue) == null || P.call(t);
      }),
    k = () => {
      if (i) return;
      let P;
      try {
        P = t.fn();
      } catch (B) {
        P = Promise.reject(B);
      }
      Promise.resolve(P)
        .then(M)
        .catch((B) => {
          var J;
          if (i) return;
          const T = t.retry ?? (Ys ? 0 : 3),
            F = t.retryDelay ?? VT,
            O = typeof F == "function" ? F(n, B) : F,
            $ = T === !0 || (typeof T == "number" && n < T) || (typeof T == "function" && T(n, B));
          if (e || !$) {
            S(B);
            return;
          }
          n++,
            (J = t.onFail) == null || J.call(t, n, B),
            qT(O)
              .then(() => {
                if (_()) return A();
              })
              .then(() => {
                e ? S(B) : k();
              });
        });
    };
  return (
    jm(t.networkMode) ? k() : A().then(k),
    {
      promise: v,
      cancel: g,
      continue: () => ((l == null ? void 0 : l()) ? v : Promise.resolve()),
      cancelRetry: b,
      continueRetry: p,
    }
  );
}
function WT() {
  let t = [],
    e = 0,
    n = (M) => {
      M();
    },
    i = (M) => {
      M();
    },
    l = (M) => setTimeout(M, 0);
  const a = (M) => {
      l = M;
    },
    c = (M) => {
      let S;
      e++;
      try {
        S = M();
      } finally {
        e--, e || b();
      }
      return S;
    },
    v = (M) => {
      e
        ? t.push(M)
        : l(() => {
            n(M);
          });
    },
    g =
      (M) =>
      (...S) => {
        v(() => {
          M(...S);
        });
      },
    b = () => {
      const M = t;
      (t = []),
        M.length &&
          l(() => {
            i(() => {
              M.forEach((S) => {
                n(S);
              });
            });
          });
    };
  return {
    batch: c,
    batchCalls: g,
    schedule: v,
    setNotifyFunction: (M) => {
      n = M;
    },
    setBatchNotifyFunction: (M) => {
      i = M;
    },
    setScheduler: a,
  };
}
var Ar = WT(),
  ka,
  _6,
  G8 =
    ((_6 = class {
      constructor() {
        kt(this, ka, void 0);
      }
      destroy() {
        this.clearGcTimeout();
      }
      scheduleGc() {
        this.clearGcTimeout(),
          Yp(this.gcTime) &&
            Mt(
              this,
              ka,
              setTimeout(() => {
                this.optionalRemove();
              }, this.gcTime)
            );
      }
      updateGcTime(t) {
        this.gcTime = Math.max(this.gcTime || 0, t ?? (Ys ? 1 / 0 : 5 * 60 * 1e3));
      }
      clearGcTimeout() {
        De(this, ka) && (clearTimeout(De(this, ka)), Mt(this, ka, void 0));
      }
    }),
    (ka = new WeakMap()),
    _6),
  As,
  ks,
  wn,
  Lr,
  xr,
  uf,
  Ba,
  Cn,
  di,
  x6,
  KT =
    ((x6 = class extends G8 {
      constructor(e) {
        super();
        kt(this, Cn);
        kt(this, As, void 0);
        kt(this, ks, void 0);
        kt(this, wn, void 0);
        kt(this, Lr, void 0);
        kt(this, xr, void 0);
        kt(this, uf, void 0);
        kt(this, Ba, void 0);
        Mt(this, Ba, !1),
          Mt(this, uf, e.defaultOptions),
          this.setOptions(e.options),
          Mt(this, xr, []),
          Mt(this, wn, e.cache),
          (this.queryKey = e.queryKey),
          (this.queryHash = e.queryHash),
          Mt(this, As, e.state || ZT(this.options)),
          (this.state = De(this, As)),
          this.scheduleGc();
      }
      get meta() {
        return this.options.meta;
      }
      setOptions(e) {
        (this.options = { ...De(this, uf), ...e }), this.updateGcTime(this.options.gcTime);
      }
      optionalRemove() {
        !De(this, xr).length && this.state.fetchStatus === "idle" && De(this, wn).remove(this);
      }
      setData(e, n) {
        const i = Xp(this.state.data, e, this.options);
        return (
          $t(this, Cn, di).call(this, {
            data: i,
            type: "success",
            dataUpdatedAt: n == null ? void 0 : n.updatedAt,
            manual: n == null ? void 0 : n.manual,
          }),
          i
        );
      }
      setState(e, n) {
        $t(this, Cn, di).call(this, { type: "setState", state: e, setStateOptions: n });
      }
      cancel(e) {
        var i, l;
        const n = (i = De(this, Lr)) == null ? void 0 : i.promise;
        return (
          (l = De(this, Lr)) == null || l.cancel(e), n ? n.then(xn).catch(xn) : Promise.resolve()
        );
      }
      destroy() {
        super.destroy(), this.cancel({ silent: !0 });
      }
      reset() {
        this.destroy(), this.setState(De(this, As));
      }
      isActive() {
        return De(this, xr).some((e) => e.options.enabled !== !1);
      }
      isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
      }
      isStale() {
        return this.state.isInvalidated
          ? !0
          : this.getObserversCount() > 0
          ? De(this, xr).some((e) => e.getCurrentResult().isStale)
          : this.state.data === void 0;
      }
      isStaleByTime(e = 0) {
        return (
          this.state.isInvalidated || this.state.data === void 0 || !V8(this.state.dataUpdatedAt, e)
        );
      }
      onFocus() {
        var n;
        const e = De(this, xr).find((i) => i.shouldFetchOnWindowFocus());
        e == null || e.refetch({ cancelRefetch: !1 }), (n = De(this, Lr)) == null || n.continue();
      }
      onOnline() {
        var n;
        const e = De(this, xr).find((i) => i.shouldFetchOnReconnect());
        e == null || e.refetch({ cancelRefetch: !1 }), (n = De(this, Lr)) == null || n.continue();
      }
      addObserver(e) {
        De(this, xr).includes(e) ||
          (De(this, xr).push(e),
          this.clearGcTimeout(),
          De(this, wn).notify({ type: "observerAdded", query: this, observer: e }));
      }
      removeObserver(e) {
        De(this, xr).includes(e) &&
          (Mt(
            this,
            xr,
            De(this, xr).filter((n) => n !== e)
          ),
          De(this, xr).length ||
            (De(this, Lr) &&
              (De(this, Ba) ? De(this, Lr).cancel({ revert: !0 }) : De(this, Lr).cancelRetry()),
            this.scheduleGc()),
          De(this, wn).notify({ type: "observerRemoved", query: this, observer: e }));
      }
      getObserversCount() {
        return De(this, xr).length;
      }
      invalidate() {
        this.state.isInvalidated || $t(this, Cn, di).call(this, { type: "invalidate" });
      }
      fetch(e, n) {
        var b, p, _;
        if (this.state.fetchStatus !== "idle") {
          if (this.state.data !== void 0 && n != null && n.cancelRefetch)
            this.cancel({ silent: !0 });
          else if (De(this, Lr)) return De(this, Lr).continueRetry(), De(this, Lr).promise;
        }
        if ((e && this.setOptions(e), !this.options.queryFn)) {
          const M = De(this, xr).find((S) => S.options.queryFn);
          M && this.setOptions(M.options);
        }
        Et.env.NODE_ENV !== "production" &&
          (Array.isArray(this.options.queryKey) ||
            console.error(
              "As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"
            ));
        const i = new AbortController(),
          l = {
            queryKey: this.queryKey,
            meta: this.meta,
          },
          a = (M) => {
            Object.defineProperty(M, "signal", {
              enumerable: !0,
              get: () => (Mt(this, Ba, !0), i.signal),
            });
          };
        a(l);
        const c = () => (
            Et.env.NODE_ENV !== "production" &&
              this.options.queryFn === ff &&
              console.error(
                `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${this.options.queryHash}'`
              ),
            !this.options.queryFn || this.options.queryFn === ff
              ? Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`))
              : (Mt(this, Ba, !1),
                this.options.persister
                  ? this.options.persister(this.options.queryFn, l, this)
                  : this.options.queryFn(l))
          ),
          v = {
            fetchOptions: n,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: c,
          };
        a(v),
          (b = this.options.behavior) == null || b.onFetch(v, this),
          Mt(this, ks, this.state),
          (this.state.fetchStatus === "idle" ||
            this.state.fetchMeta !== ((p = v.fetchOptions) == null ? void 0 : p.meta)) &&
            $t(this, Cn, di).call(this, {
              type: "fetch",
              meta: (_ = v.fetchOptions) == null ? void 0 : _.meta,
            });
        const g = (M) => {
          var S, A, k, P;
          (Q0(M) && M.silent) ||
            $t(this, Cn, di).call(this, {
              type: "error",
              error: M,
            }),
            Q0(M) ||
              ((A = (S = De(this, wn).config).onError) == null || A.call(S, M, this),
              (P = (k = De(this, wn).config).onSettled) == null ||
                P.call(k, this.state.data, M, this)),
            this.isFetchingOptimistic || this.scheduleGc(),
            (this.isFetchingOptimistic = !1);
        };
        return (
          Mt(
            this,
            Lr,
            Z8({
              fn: v.fetchFn,
              abort: i.abort.bind(i),
              onSuccess: (M) => {
                var S, A, k, P;
                if (M === void 0) {
                  Et.env.NODE_ENV !== "production" &&
                    console.error(
                      `Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`
                    ),
                    g(new Error(`${this.queryHash} data is undefined`));
                  return;
                }
                this.setData(M),
                  (A = (S = De(this, wn).config).onSuccess) == null || A.call(S, M, this),
                  (P = (k = De(this, wn).config).onSettled) == null ||
                    P.call(k, M, this.state.error, this),
                  this.isFetchingOptimistic || this.scheduleGc(),
                  (this.isFetchingOptimistic = !1);
              },
              onError: g,
              onFail: (M, S) => {
                $t(this, Cn, di).call(this, { type: "failed", failureCount: M, error: S });
              },
              onPause: () => {
                $t(this, Cn, di).call(this, { type: "pause" });
              },
              onContinue: () => {
                $t(this, Cn, di).call(this, { type: "continue" });
              },
              retry: v.options.retry,
              retryDelay: v.options.retryDelay,
              networkMode: v.options.networkMode,
            })
          ),
          De(this, Lr).promise
        );
      }
    }),
    (As = new WeakMap()),
    (ks = new WeakMap()),
    (wn = new WeakMap()),
    (Lr = new WeakMap()),
    (xr = new WeakMap()),
    (uf = new WeakMap()),
    (Ba = new WeakMap()),
    (Cn = new WeakSet()),
    (di = function (e) {
      const n = (i) => {
        switch (e.type) {
          case "failed":
            return {
              ...i,
              fetchFailureCount: e.failureCount,
              fetchFailureReason: e.error,
            };
          case "pause":
            return {
              ...i,
              fetchStatus: "paused",
            };
          case "continue":
            return {
              ...i,
              fetchStatus: "fetching",
            };
          case "fetch":
            return {
              ...i,
              ...Y8(i.data, this.options),
              fetchMeta: e.meta ?? null,
            };
          case "success":
            return {
              ...i,
              data: e.data,
              dataUpdateCount: i.dataUpdateCount + 1,
              dataUpdatedAt: e.dataUpdatedAt ?? Date.now(),
              error: null,
              isInvalidated: !1,
              status: "success",
              ...(!e.manual && {
                fetchStatus: "idle",
                fetchFailureCount: 0,
                fetchFailureReason: null,
              }),
            };
          case "error":
            const l = e.error;
            return Q0(l) && l.revert && De(this, ks)
              ? { ...De(this, ks), fetchStatus: "idle" }
              : {
                  ...i,
                  error: l,
                  errorUpdateCount: i.errorUpdateCount + 1,
                  errorUpdatedAt: Date.now(),
                  fetchFailureCount: i.fetchFailureCount + 1,
                  fetchFailureReason: l,
                  fetchStatus: "idle",
                  status: "error",
                };
          case "invalidate":
            return {
              ...i,
              isInvalidated: !0,
            };
          case "setState":
            return {
              ...i,
              ...e.state,
            };
        }
      };
      (this.state = n(this.state)),
        Ar.batch(() => {
          De(this, xr).forEach((i) => {
            i.onQueryUpdate();
          }),
            De(this, wn).notify({ query: this, type: "updated", action: e });
        });
    }),
    x6);
function Y8(t, e) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: jm(e.networkMode) ? "fetching" : "paused",
    ...(t === void 0 && {
      error: null,
      status: "pending",
    }),
  };
}
function ZT(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData,
    n = e !== void 0,
    i = n
      ? typeof t.initialDataUpdatedAt == "function"
        ? t.initialDataUpdatedAt()
        : t.initialDataUpdatedAt
      : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? i ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "pending",
    fetchStatus: "idle",
  };
}
var zn,
  M6,
  GT =
    ((M6 = class extends $f {
      constructor(e = {}) {
        super();
        kt(this, zn, void 0);
        (this.config = e), Mt(this, zn, /* @__PURE__ */ new Map());
      }
      build(e, n, i) {
        const l = n.queryKey,
          a = n.queryHash ?? qm(l, n);
        let c = this.get(a);
        return (
          c ||
            ((c = new KT({
              cache: this,
              queryKey: l,
              queryHash: a,
              options: e.defaultQueryOptions(n),
              state: i,
              defaultOptions: e.getQueryDefaults(l),
            })),
            this.add(c)),
          c
        );
      }
      add(e) {
        De(this, zn).has(e.queryHash) ||
          (De(this, zn).set(e.queryHash, e),
          this.notify({
            type: "added",
            query: e,
          }));
      }
      remove(e) {
        const n = De(this, zn).get(e.queryHash);
        n &&
          (e.destroy(),
          n === e && De(this, zn).delete(e.queryHash),
          this.notify({ type: "removed", query: e }));
      }
      clear() {
        Ar.batch(() => {
          this.getAll().forEach((e) => {
            this.remove(e);
          });
        });
      }
      get(e) {
        return De(this, zn).get(e);
      }
      getAll() {
        return [...De(this, zn).values()];
      }
      find(e) {
        const n = { exact: !0, ...e };
        return this.getAll().find((i) => G2(n, i));
      }
      findAll(e = {}) {
        const n = this.getAll();
        return Object.keys(e).length > 0 ? n.filter((i) => G2(e, i)) : n;
      }
      notify(e) {
        Ar.batch(() => {
          this.listeners.forEach((n) => {
            n(e);
          });
        });
      }
      onFocus() {
        Ar.batch(() => {
          this.getAll().forEach((e) => {
            e.onFocus();
          });
        });
      }
      onOnline() {
        Ar.batch(() => {
          this.getAll().forEach((e) => {
            e.onOnline();
          });
        });
      }
    }),
    (zn = new WeakMap()),
    M6),
  jn,
  cf,
  sn,
  Bs,
  $n,
  Di,
  S6,
  YT =
    ((S6 = class extends G8 {
      constructor(e) {
        super();
        kt(this, $n);
        kt(this, jn, void 0);
        kt(this, cf, void 0);
        kt(this, sn, void 0);
        kt(this, Bs, void 0);
        (this.mutationId = e.mutationId),
          Mt(this, cf, e.defaultOptions),
          Mt(this, sn, e.mutationCache),
          Mt(this, jn, []),
          (this.state = e.state || JT()),
          this.setOptions(e.options),
          this.scheduleGc();
      }
      setOptions(e) {
        (this.options = { ...De(this, cf), ...e }), this.updateGcTime(this.options.gcTime);
      }
      get meta() {
        return this.options.meta;
      }
      addObserver(e) {
        De(this, jn).includes(e) ||
          (De(this, jn).push(e),
          this.clearGcTimeout(),
          De(this, sn).notify({
            type: "observerAdded",
            mutation: this,
            observer: e,
          }));
      }
      removeObserver(e) {
        Mt(
          this,
          jn,
          De(this, jn).filter((n) => n !== e)
        ),
          this.scheduleGc(),
          De(this, sn).notify({
            type: "observerRemoved",
            mutation: this,
            observer: e,
          });
      }
      optionalRemove() {
        De(this, jn).length ||
          (this.state.status === "pending" ? this.scheduleGc() : De(this, sn).remove(this));
      }
      continue() {
        var e;
        return (
          ((e = De(this, Bs)) == null ? void 0 : e.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
          this.execute(this.state.variables)
        );
      }
      async execute(e) {
        var l, a, c, v, g, b, p, _, M, S, A, k, P, B, T, F, O, $, J, he;
        const n = () => (
            Mt(
              this,
              Bs,
              Z8({
                fn: () =>
                  this.options.mutationFn
                    ? this.options.mutationFn(e)
                    : Promise.reject(new Error("No mutationFn found")),
                onFail: (de, ne) => {
                  $t(this, $n, Di).call(this, { type: "failed", failureCount: de, error: ne });
                },
                onPause: () => {
                  $t(this, $n, Di).call(this, { type: "pause" });
                },
                onContinue: () => {
                  $t(this, $n, Di).call(this, { type: "continue" });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode,
              })
            ),
            De(this, Bs).promise
          ),
          i = this.state.status === "pending";
        try {
          if (!i) {
            $t(this, $n, Di).call(this, { type: "pending", variables: e }),
              await ((a = (l = De(this, sn).config).onMutate) == null
                ? void 0
                : a.call(l, e, this));
            const ne = await ((v = (c = this.options).onMutate) == null ? void 0 : v.call(c, e));
            ne !== this.state.context &&
              $t(this, $n, Di).call(this, {
                type: "pending",
                context: ne,
                variables: e,
              });
          }
          const de = await n();
          return (
            await ((b = (g = De(this, sn).config).onSuccess) == null
              ? void 0
              : b.call(g, de, e, this.state.context, this)),
            await ((_ = (p = this.options).onSuccess) == null
              ? void 0
              : _.call(p, de, e, this.state.context)),
            await ((S = (M = De(this, sn).config).onSettled) == null
              ? void 0
              : S.call(M, de, null, this.state.variables, this.state.context, this)),
            await ((k = (A = this.options).onSettled) == null
              ? void 0
              : k.call(A, de, null, e, this.state.context)),
            $t(this, $n, Di).call(this, { type: "success", data: de }),
            de
          );
        } catch (de) {
          try {
            throw (
              (await ((B = (P = De(this, sn).config).onError) == null
                ? void 0
                : B.call(P, de, e, this.state.context, this)),
              await ((F = (T = this.options).onError) == null
                ? void 0
                : F.call(T, de, e, this.state.context)),
              await (($ = (O = De(this, sn).config).onSettled) == null
                ? void 0
                : $.call(O, void 0, de, this.state.variables, this.state.context, this)),
              await ((he = (J = this.options).onSettled) == null
                ? void 0
                : he.call(J, void 0, de, e, this.state.context)),
              de)
            );
          } finally {
            $t(this, $n, Di).call(this, { type: "error", error: de });
          }
        }
      }
    }),
    (jn = new WeakMap()),
    (cf = new WeakMap()),
    (sn = new WeakMap()),
    (Bs = new WeakMap()),
    ($n = new WeakSet()),
    (Di = function (e) {
      const n = (i) => {
        switch (e.type) {
          case "failed":
            return {
              ...i,
              failureCount: e.failureCount,
              failureReason: e.error,
            };
          case "pause":
            return {
              ...i,
              isPaused: !0,
            };
          case "continue":
            return {
              ...i,
              isPaused: !1,
            };
          case "pending":
            return {
              ...i,
              context: e.context,
              data: void 0,
              failureCount: 0,
              failureReason: null,
              error: null,
              isPaused: !jm(this.options.networkMode),
              status: "pending",
              variables: e.variables,
              submittedAt: Date.now(),
            };
          case "success":
            return {
              ...i,
              data: e.data,
              failureCount: 0,
              failureReason: null,
              error: null,
              status: "success",
              isPaused: !1,
            };
          case "error":
            return {
              ...i,
              data: void 0,
              error: e.error,
              failureCount: i.failureCount + 1,
              failureReason: e.error,
              isPaused: !1,
              status: "error",
            };
        }
      };
      (this.state = n(this.state)),
        Ar.batch(() => {
          De(this, jn).forEach((i) => {
            i.onMutationUpdate(e);
          }),
            De(this, sn).notify({
              mutation: this,
              type: "updated",
              action: e,
            });
        });
    }),
    S6);
function JT() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0,
    submittedAt: 0,
  };
}
var _n,
  hf,
  Ca,
  E6,
  QT =
    ((E6 = class extends $f {
      constructor(e = {}) {
        super();
        kt(this, _n, void 0);
        kt(this, hf, void 0);
        kt(this, Ca, void 0);
        (this.config = e), Mt(this, _n, []), Mt(this, hf, 0);
      }
      build(e, n, i) {
        const l = new YT({
          mutationCache: this,
          mutationId: ++Vf(this, hf)._,
          options: e.defaultMutationOptions(n),
          state: i,
        });
        return this.add(l), l;
      }
      add(e) {
        De(this, _n).push(e), this.notify({ type: "added", mutation: e });
      }
      remove(e) {
        Mt(
          this,
          _n,
          De(this, _n).filter((n) => n !== e)
        ),
          this.notify({ type: "removed", mutation: e });
      }
      clear() {
        Ar.batch(() => {
          De(this, _n).forEach((e) => {
            this.remove(e);
          });
        });
      }
      getAll() {
        return De(this, _n);
      }
      find(e) {
        const n = { exact: !0, ...e };
        return De(this, _n).find((i) => Y2(n, i));
      }
      findAll(e = {}) {
        return De(this, _n).filter((n) => Y2(e, n));
      }
      notify(e) {
        Ar.batch(() => {
          this.listeners.forEach((n) => {
            n(e);
          });
        });
      }
      resumePausedMutations() {
        return (
          Mt(
            this,
            Ca,
            (De(this, Ca) ?? Promise.resolve())
              .then(() => {
                const e = De(this, _n).filter((n) => n.state.isPaused);
                return Ar.batch(() =>
                  e.reduce((n, i) => n.then(() => i.continue().catch(xn)), Promise.resolve())
                );
              })
              .then(() => {
                Mt(this, Ca, void 0);
              })
          ),
          De(this, Ca)
        );
      }
    }),
    (_n = new WeakMap()),
    (hf = new WeakMap()),
    (Ca = new WeakMap()),
    E6);
function XT(t) {
  return {
    onFetch: (e, n) => {
      const i = async () => {
        var A, k, P, B, T;
        const l = e.options,
          a =
            (P =
              (k = (A = e.fetchOptions) == null ? void 0 : A.meta) == null
                ? void 0
                : k.fetchMore) == null
              ? void 0
              : P.direction,
          c = ((B = e.state.data) == null ? void 0 : B.pages) || [],
          v = ((T = e.state.data) == null ? void 0 : T.pageParams) || [],
          g = { pages: [], pageParams: [] };
        let b = !1;
        const p = (F) => {
            Object.defineProperty(F, "signal", {
              enumerable: !0,
              get: () => (
                e.signal.aborted
                  ? (b = !0)
                  : e.signal.addEventListener("abort", () => {
                      b = !0;
                    }),
                e.signal
              ),
            });
          },
          _ =
            e.options.queryFn && e.options.queryFn !== ff
              ? e.options.queryFn
              : () => (
                  Et.env.NODE_ENV !== "production" &&
                    e.options.queryFn === ff &&
                    console.error(
                      `Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${e.options.queryHash}'`
                    ),
                  Promise.reject(new Error(`Missing queryFn: '${e.options.queryHash}'`))
                ),
          M = async (F, O, $) => {
            if (b) return Promise.reject();
            if (O == null && F.pages.length) return Promise.resolve(F);
            const J = {
              queryKey: e.queryKey,
              pageParam: O,
              direction: $ ? "backward" : "forward",
              meta: e.options.meta,
            };
            p(J);
            const he = await _(J),
              { maxPages: de } = e.options,
              ne = $ ? jT : zT;
            return {
              pages: ne(F.pages, he, de),
              pageParams: ne(F.pageParams, O, de),
            };
          };
        let S;
        if (a && c.length) {
          const F = a === "backward",
            O = F ? eP : X2,
            $ = {
              pages: c,
              pageParams: v,
            },
            J = O(l, $);
          S = await M($, J, F);
        } else {
          S = await M(g, v[0] ?? l.initialPageParam);
          const F = t ?? c.length;
          for (let O = 1; O < F; O++) {
            const $ = X2(l, S);
            S = await M(S, $);
          }
        }
        return S;
      };
      e.options.persister
        ? (e.fetchFn = () => {
            var l, a;
            return (a = (l = e.options).persister) == null
              ? void 0
              : a.call(
                  l,
                  i,
                  {
                    queryKey: e.queryKey,
                    meta: e.options.meta,
                    signal: e.signal,
                  },
                  n
                );
          })
        : (e.fetchFn = i);
    },
  };
}
function X2(t, { pages: e, pageParams: n }) {
  const i = e.length - 1;
  return t.getNextPageParam(e[i], e, n[i], n);
}
function eP(t, { pages: e, pageParams: n }) {
  var i;
  return (i = t.getPreviousPageParam) == null ? void 0 : i.call(t, e[0], e, n[0], n);
}
var mr,
  $i,
  Hi,
  Cs,
  Ts,
  Vi,
  Ps,
  Rs,
  A6,
  tP =
    ((A6 = class {
      constructor(t = {}) {
        kt(this, mr, void 0);
        kt(this, $i, void 0);
        kt(this, Hi, void 0);
        kt(this, Cs, void 0);
        kt(this, Ts, void 0);
        kt(this, Vi, void 0);
        kt(this, Ps, void 0);
        kt(this, Rs, void 0);
        Mt(this, mr, t.queryCache || new GT()),
          Mt(this, $i, t.mutationCache || new QT()),
          Mt(this, Hi, t.defaultOptions || {}),
          Mt(this, Cs, /* @__PURE__ */ new Map()),
          Mt(this, Ts, /* @__PURE__ */ new Map()),
          Mt(this, Vi, 0);
      }
      mount() {
        Vf(this, Vi)._++,
          De(this, Vi) === 1 &&
            (Mt(
              this,
              Ps,
              zm.subscribe(async (t) => {
                t && (await this.resumePausedMutations(), De(this, mr).onFocus());
              })
            ),
            Mt(
              this,
              Rs,
              iu.subscribe(async (t) => {
                t && (await this.resumePausedMutations(), De(this, mr).onOnline());
              })
            ));
      }
      unmount() {
        var t, e;
        Vf(this, Vi)._--,
          De(this, Vi) === 0 &&
            ((t = De(this, Ps)) == null || t.call(this),
            Mt(this, Ps, void 0),
            (e = De(this, Rs)) == null || e.call(this),
            Mt(this, Rs, void 0));
      }
      isFetching(t) {
        return De(this, mr).findAll({ ...t, fetchStatus: "fetching" }).length;
      }
      isMutating(t) {
        return De(this, $i).findAll({ ...t, status: "pending" }).length;
      }
      getQueryData(t) {
        var n;
        const e = this.defaultQueryOptions({ queryKey: t });
        return (n = De(this, mr).get(e.queryHash)) == null ? void 0 : n.state.data;
      }
      ensureQueryData(t) {
        const e = this.getQueryData(t.queryKey);
        if (e === void 0) return this.fetchQuery(t);
        {
          const n = this.defaultQueryOptions(t),
            i = De(this, mr).build(this, n);
          return (
            t.revalidateIfStale && i.isStaleByTime(n.staleTime) && this.prefetchQuery(n),
            Promise.resolve(e)
          );
        }
      }
      getQueriesData(t) {
        return this.getQueryCache()
          .findAll(t)
          .map(({ queryKey: e, state: n }) => {
            const i = n.data;
            return [e, i];
          });
      }
      setQueryData(t, e, n) {
        const i = this.defaultQueryOptions({ queryKey: t }),
          l = De(this, mr).get(i.queryHash),
          a = l == null ? void 0 : l.state.data,
          c = FT(e, a);
        if (c !== void 0)
          return De(this, mr)
            .build(this, i)
            .setData(c, { ...n, manual: !0 });
      }
      setQueriesData(t, e, n) {
        return Ar.batch(() =>
          this.getQueryCache()
            .findAll(t)
            .map(({ queryKey: i }) => [i, this.setQueryData(i, e, n)])
        );
      }
      getQueryState(t) {
        var n;
        const e = this.defaultQueryOptions({ queryKey: t });
        return (n = De(this, mr).get(e.queryHash)) == null ? void 0 : n.state;
      }
      removeQueries(t) {
        const e = De(this, mr);
        Ar.batch(() => {
          e.findAll(t).forEach((n) => {
            e.remove(n);
          });
        });
      }
      resetQueries(t, e) {
        const n = De(this, mr),
          i = {
            type: "active",
            ...t,
          };
        return Ar.batch(
          () => (
            n.findAll(t).forEach((l) => {
              l.reset();
            }),
            this.refetchQueries(i, e)
          )
        );
      }
      cancelQueries(t = {}, e = {}) {
        const n = { revert: !0, ...e },
          i = Ar.batch(() =>
            De(this, mr)
              .findAll(t)
              .map((l) => l.cancel(n))
          );
        return Promise.all(i).then(xn).catch(xn);
      }
      invalidateQueries(t = {}, e = {}) {
        return Ar.batch(() => {
          if (
            (De(this, mr)
              .findAll(t)
              .forEach((i) => {
                i.invalidate();
              }),
            t.refetchType === "none")
          )
            return Promise.resolve();
          const n = {
            ...t,
            type: t.refetchType ?? t.type ?? "active",
          };
          return this.refetchQueries(n, e);
        });
      }
      refetchQueries(t = {}, e) {
        const n = {
            ...e,
            cancelRefetch: (e == null ? void 0 : e.cancelRefetch) ?? !0,
          },
          i = Ar.batch(() =>
            De(this, mr)
              .findAll(t)
              .filter((l) => !l.isDisabled())
              .map((l) => {
                let a = l.fetch(void 0, n);
                return (
                  n.throwOnError || (a = a.catch(xn)),
                  l.state.fetchStatus === "paused" ? Promise.resolve() : a
                );
              })
          );
        return Promise.all(i).then(xn);
      }
      fetchQuery(t) {
        const e = this.defaultQueryOptions(t);
        e.retry === void 0 && (e.retry = !1);
        const n = De(this, mr).build(this, e);
        return n.isStaleByTime(e.staleTime) ? n.fetch(e) : Promise.resolve(n.state.data);
      }
      prefetchQuery(t) {
        return this.fetchQuery(t).then(xn).catch(xn);
      }
      fetchInfiniteQuery(t) {
        return (t.behavior = XT(t.pages)), this.fetchQuery(t);
      }
      prefetchInfiniteQuery(t) {
        return this.fetchInfiniteQuery(t).then(xn).catch(xn);
      }
      resumePausedMutations() {
        return iu.isOnline() ? De(this, $i).resumePausedMutations() : Promise.resolve();
      }
      getQueryCache() {
        return De(this, mr);
      }
      getMutationCache() {
        return De(this, $i);
      }
      getDefaultOptions() {
        return De(this, Hi);
      }
      setDefaultOptions(t) {
        Mt(this, Hi, t);
      }
      setQueryDefaults(t, e) {
        De(this, Cs).set(sf(t), {
          queryKey: t,
          defaultOptions: e,
        });
      }
      getQueryDefaults(t) {
        const e = [...De(this, Cs).values()];
        let n = {};
        return (
          e.forEach((i) => {
            of(t, i.queryKey) && (n = { ...n, ...i.defaultOptions });
          }),
          n
        );
      }
      setMutationDefaults(t, e) {
        De(this, Ts).set(sf(t), {
          mutationKey: t,
          defaultOptions: e,
        });
      }
      getMutationDefaults(t) {
        const e = [...De(this, Ts).values()];
        let n = {};
        return (
          e.forEach((i) => {
            of(t, i.mutationKey) && (n = { ...n, ...i.defaultOptions });
          }),
          n
        );
      }
      defaultQueryOptions(t) {
        if (t._defaulted) return t;
        const e = {
          ...De(this, Hi).queries,
          ...this.getQueryDefaults(t.queryKey),
          ...t,
          _defaulted: !0,
        };
        return (
          e.queryHash || (e.queryHash = qm(e.queryKey, e)),
          e.refetchOnReconnect === void 0 && (e.refetchOnReconnect = e.networkMode !== "always"),
          e.throwOnError === void 0 && (e.throwOnError = !!e.suspense),
          !e.networkMode && e.persister && (e.networkMode = "offlineFirst"),
          e.enabled !== !0 && e.queryFn === ff && (e.enabled = !1),
          e
        );
      }
      defaultMutationOptions(t) {
        return t != null && t._defaulted
          ? t
          : {
              ...De(this, Hi).mutations,
              ...((t == null ? void 0 : t.mutationKey) && this.getMutationDefaults(t.mutationKey)),
              ...t,
              _defaulted: !0,
            };
      }
      clear() {
        De(this, mr).clear(), De(this, $i).clear();
      }
    }),
    (mr = new WeakMap()),
    ($i = new WeakMap()),
    (Hi = new WeakMap()),
    (Cs = new WeakMap()),
    (Ts = new WeakMap()),
    (Vi = new WeakMap()),
    (Ps = new WeakMap()),
    (Rs = new WeakMap()),
    A6),
  Yr,
  nr,
  df,
  Fr,
  Ta,
  Is,
  Hn,
  pf,
  Os,
  Us,
  Pa,
  Ra,
  Wi,
  Ns,
  Ia,
  Go,
  mf,
  e1,
  vf,
  t1,
  gf,
  r1,
  yf,
  n1,
  bf,
  i1,
  wf,
  a1,
  _f,
  s1,
  hu,
  J8,
  k6,
  rP =
    ((k6 = class extends $f {
      constructor(e, n) {
        super();
        kt(this, Ia);
        kt(this, mf);
        kt(this, vf);
        kt(this, gf);
        kt(this, yf);
        kt(this, bf);
        kt(this, wf);
        kt(this, _f);
        kt(this, hu);
        kt(this, Yr, void 0);
        kt(this, nr, void 0);
        kt(this, df, void 0);
        kt(this, Fr, void 0);
        kt(this, Ta, void 0);
        kt(this, Is, void 0);
        kt(this, Hn, void 0);
        kt(this, pf, void 0);
        kt(this, Os, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        kt(this, Us, void 0);
        kt(this, Pa, void 0);
        kt(this, Ra, void 0);
        kt(this, Wi, void 0);
        kt(this, Ns, /* @__PURE__ */ new Set());
        (this.options = n),
          Mt(this, Yr, e),
          Mt(this, Hn, null),
          this.bindMethods(),
          this.setOptions(n);
      }
      bindMethods() {
        this.refetch = this.refetch.bind(this);
      }
      onSubscribe() {
        this.listeners.size === 1 &&
          (De(this, nr).addObserver(this),
          e6(De(this, nr), this.options) ? $t(this, Ia, Go).call(this) : this.updateResult(),
          $t(this, yf, n1).call(this));
      }
      onUnsubscribe() {
        this.hasListeners() || this.destroy();
      }
      shouldFetchOnReconnect() {
        return o1(De(this, nr), this.options, this.options.refetchOnReconnect);
      }
      shouldFetchOnWindowFocus() {
        return o1(De(this, nr), this.options, this.options.refetchOnWindowFocus);
      }
      destroy() {
        (this.listeners = /* @__PURE__ */ new Set()),
          $t(this, bf, i1).call(this),
          $t(this, wf, a1).call(this),
          De(this, nr).removeObserver(this);
      }
      setOptions(e, n) {
        const i = this.options,
          l = De(this, nr);
        if (
          ((this.options = De(this, Yr).defaultQueryOptions(e)),
          this.options.enabled !== void 0 && typeof this.options.enabled != "boolean")
        )
          throw new Error("Expected enabled to be a boolean");
        $t(this, _f, s1).call(this),
          De(this, nr).setOptions(this.options),
          i._defaulted &&
            !Jp(this.options, i) &&
            De(this, Yr)
              .getQueryCache()
              .notify({
                type: "observerOptionsUpdated",
                query: De(this, nr),
                observer: this,
              });
        const a = this.hasListeners();
        a && t6(De(this, nr), l, this.options, i) && $t(this, Ia, Go).call(this),
          this.updateResult(n),
          a &&
            (De(this, nr) !== l ||
              this.options.enabled !== i.enabled ||
              this.options.staleTime !== i.staleTime) &&
            $t(this, mf, e1).call(this);
        const c = $t(this, vf, t1).call(this);
        a &&
          (De(this, nr) !== l || this.options.enabled !== i.enabled || c !== De(this, Wi)) &&
          $t(this, gf, r1).call(this, c);
      }
      getOptimisticResult(e) {
        const n = De(this, Yr).getQueryCache().build(De(this, Yr), e),
          i = this.createResult(n, e);
        return (
          iP(this, i) &&
            (Mt(this, Fr, i), Mt(this, Is, this.options), Mt(this, Ta, De(this, nr).state)),
          i
        );
      }
      getCurrentResult() {
        return De(this, Fr);
      }
      trackResult(e, n) {
        const i = {};
        return (
          Object.keys(e).forEach((l) => {
            Object.defineProperty(i, l, {
              configurable: !1,
              enumerable: !0,
              get: () => (this.trackProp(l), n == null || n(l), e[l]),
            });
          }),
          i
        );
      }
      trackProp(e) {
        De(this, Ns).add(e);
      }
      getCurrentQuery() {
        return De(this, nr);
      }
      refetch({ ...e } = {}) {
        return this.fetch({
          ...e,
        });
      }
      fetchOptimistic(e) {
        const n = De(this, Yr).defaultQueryOptions(e),
          i = De(this, Yr).getQueryCache().build(De(this, Yr), n);
        return (i.isFetchingOptimistic = !0), i.fetch().then(() => this.createResult(i, n));
      }
      fetch(e) {
        return $t(this, Ia, Go)
          .call(this, {
            ...e,
            cancelRefetch: e.cancelRefetch ?? !0,
          })
          .then(() => (this.updateResult(), De(this, Fr)));
      }
      createResult(e, n) {
        var he;
        const i = De(this, nr),
          l = this.options,
          a = De(this, Fr),
          c = De(this, Ta),
          v = De(this, Is),
          b = e !== i ? e.state : De(this, df),
          { state: p } = e;
        let _ = { ...p },
          M = !1,
          S;
        if (n._optimisticResults) {
          const de = this.hasListeners(),
            ne = !de && e6(e, n),
            Ae = de && t6(e, i, n, l);
          (ne || Ae) &&
            (_ = {
              ..._,
              ...Y8(p.data, e.options),
            }),
            n._optimisticResults === "isRestoring" && (_.fetchStatus = "idle");
        }
        let { error: A, errorUpdatedAt: k, status: P } = _;
        if (n.select && _.data !== void 0)
          if (a && _.data === (c == null ? void 0 : c.data) && n.select === De(this, pf))
            S = De(this, Os);
          else
            try {
              Mt(this, pf, n.select),
                (S = n.select(_.data)),
                (S = Xp(a == null ? void 0 : a.data, S, n)),
                Mt(this, Os, S),
                Mt(this, Hn, null);
            } catch (de) {
              Mt(this, Hn, de);
            }
        else S = _.data;
        if (n.placeholderData !== void 0 && S === void 0 && P === "pending") {
          let de;
          if (
            a != null &&
            a.isPlaceholderData &&
            n.placeholderData === (v == null ? void 0 : v.placeholderData)
          )
            de = a.data;
          else if (
            ((de =
              typeof n.placeholderData == "function"
                ? n.placeholderData(
                    (he = De(this, Us)) == null ? void 0 : he.state.data,
                    De(this, Us)
                  )
                : n.placeholderData),
            n.select && de !== void 0)
          )
            try {
              (de = n.select(de)), Mt(this, Hn, null);
            } catch (ne) {
              Mt(this, Hn, ne);
            }
          de !== void 0 &&
            ((P = "success"), (S = Xp(a == null ? void 0 : a.data, de, n)), (M = !0));
        }
        De(this, Hn) && ((A = De(this, Hn)), (S = De(this, Os)), (k = Date.now()), (P = "error"));
        const B = _.fetchStatus === "fetching",
          T = P === "pending",
          F = P === "error",
          O = T && B,
          $ = S !== void 0;
        return {
          status: P,
          fetchStatus: _.fetchStatus,
          isPending: T,
          isSuccess: P === "success",
          isError: F,
          isInitialLoading: O,
          isLoading: O,
          data: S,
          dataUpdatedAt: _.dataUpdatedAt,
          error: A,
          errorUpdatedAt: k,
          failureCount: _.fetchFailureCount,
          failureReason: _.fetchFailureReason,
          errorUpdateCount: _.errorUpdateCount,
          isFetched: _.dataUpdateCount > 0 || _.errorUpdateCount > 0,
          isFetchedAfterMount:
            _.dataUpdateCount > b.dataUpdateCount || _.errorUpdateCount > b.errorUpdateCount,
          isFetching: B,
          isRefetching: B && !T,
          isLoadingError: F && !$,
          isPaused: _.fetchStatus === "paused",
          isPlaceholderData: M,
          isRefetchError: F && $,
          isStale: $m(e, n),
          refetch: this.refetch,
        };
      }
      updateResult(e) {
        const n = De(this, Fr),
          i = this.createResult(De(this, nr), this.options);
        if (
          (Mt(this, Ta, De(this, nr).state),
          Mt(this, Is, this.options),
          De(this, Ta).data !== void 0 && Mt(this, Us, De(this, nr)),
          Jp(i, n))
        )
          return;
        Mt(this, Fr, i);
        const l = {},
          a = () => {
            if (!n) return !0;
            const { notifyOnChangeProps: c } = this.options,
              v = typeof c == "function" ? c() : c;
            if (v === "all" || (!v && !De(this, Ns).size)) return !0;
            const g = new Set(v ?? De(this, Ns));
            return (
              this.options.throwOnError && g.add("error"),
              Object.keys(De(this, Fr)).some((b) => {
                const p = b;
                return De(this, Fr)[p] !== n[p] && g.has(p);
              })
            );
          };
        (e == null ? void 0 : e.listeners) !== !1 && a() && (l.listeners = !0),
          $t(this, hu, J8).call(this, { ...l, ...e });
      }
      onQueryUpdate() {
        this.updateResult(), this.hasListeners() && $t(this, yf, n1).call(this);
      }
    }),
    (Yr = new WeakMap()),
    (nr = new WeakMap()),
    (df = new WeakMap()),
    (Fr = new WeakMap()),
    (Ta = new WeakMap()),
    (Is = new WeakMap()),
    (Hn = new WeakMap()),
    (pf = new WeakMap()),
    (Os = new WeakMap()),
    (Us = new WeakMap()),
    (Pa = new WeakMap()),
    (Ra = new WeakMap()),
    (Wi = new WeakMap()),
    (Ns = new WeakMap()),
    (Ia = new WeakSet()),
    (Go = function (e) {
      $t(this, _f, s1).call(this);
      let n = De(this, nr).fetch(this.options, e);
      return (e != null && e.throwOnError) || (n = n.catch(xn)), n;
    }),
    (mf = new WeakSet()),
    (e1 = function () {
      if (($t(this, bf, i1).call(this), Ys || De(this, Fr).isStale || !Yp(this.options.staleTime)))
        return;
      const n = V8(De(this, Fr).dataUpdatedAt, this.options.staleTime) + 1;
      Mt(
        this,
        Pa,
        setTimeout(() => {
          De(this, Fr).isStale || this.updateResult();
        }, n)
      );
    }),
    (vf = new WeakSet()),
    (t1 = function () {
      return (
        (typeof this.options.refetchInterval == "function"
          ? this.options.refetchInterval(De(this, nr))
          : this.options.refetchInterval) ?? !1
      );
    }),
    (gf = new WeakSet()),
    (r1 = function (e) {
      $t(this, wf, a1).call(this),
        Mt(this, Wi, e),
        !(Ys || this.options.enabled === !1 || !Yp(De(this, Wi)) || De(this, Wi) === 0) &&
          Mt(
            this,
            Ra,
            setInterval(() => {
              (this.options.refetchIntervalInBackground || zm.isFocused()) &&
                $t(this, Ia, Go).call(this);
            }, De(this, Wi))
          );
    }),
    (yf = new WeakSet()),
    (n1 = function () {
      $t(this, mf, e1).call(this), $t(this, gf, r1).call(this, $t(this, vf, t1).call(this));
    }),
    (bf = new WeakSet()),
    (i1 = function () {
      De(this, Pa) && (clearTimeout(De(this, Pa)), Mt(this, Pa, void 0));
    }),
    (wf = new WeakSet()),
    (a1 = function () {
      De(this, Ra) && (clearInterval(De(this, Ra)), Mt(this, Ra, void 0));
    }),
    (_f = new WeakSet()),
    (s1 = function () {
      const e = De(this, Yr).getQueryCache().build(De(this, Yr), this.options);
      if (e === De(this, nr)) return;
      const n = De(this, nr);
      Mt(this, nr, e),
        Mt(this, df, e.state),
        this.hasListeners() && (n == null || n.removeObserver(this), e.addObserver(this));
    }),
    (hu = new WeakSet()),
    (J8 = function (e) {
      Ar.batch(() => {
        e.listeners &&
          this.listeners.forEach((n) => {
            n(De(this, Fr));
          }),
          De(this, Yr)
            .getQueryCache()
            .notify({
              query: De(this, nr),
              type: "observerResultsUpdated",
            });
      });
    }),
    k6);
function nP(t, e) {
  return (
    e.enabled !== !1 &&
    t.state.data === void 0 &&
    !(t.state.status === "error" && e.retryOnMount === !1)
  );
}
function e6(t, e) {
  return nP(t, e) || (t.state.data !== void 0 && o1(t, e, e.refetchOnMount));
}
function o1(t, e, n) {
  if (e.enabled !== !1) {
    const i = typeof n == "function" ? n(t) : n;
    return i === "always" || (i !== !1 && $m(t, e));
  }
  return !1;
}
function t6(t, e, n, i) {
  return (t !== e || i.enabled === !1) && (!n.suspense || t.state.status !== "error") && $m(t, n);
}
function $m(t, e) {
  return e.enabled !== !1 && t.isStaleByTime(e.staleTime);
}
function iP(t, e) {
  return !Jp(t.getCurrentResult(), e);
}
var Q8 = jt.createContext(void 0),
  aP = (t) => {
    const e = jt.useContext(Q8);
    if (t) return t;
    if (!e) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return e;
  },
  sP = ({ client: t, children: e }) => (
    jt.useEffect(
      () => (
        t.mount(),
        () => {
          t.unmount();
        }
      ),
      [t]
    ),
    /* @__PURE__ */ gt.jsx(Q8.Provider, { value: t, children: e })
  ),
  X8 = jt.createContext(!1),
  oP = () => jt.useContext(X8);
X8.Provider;
function fP() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t,
  };
}
var lP = jt.createContext(fP()),
  uP = () => jt.useContext(lP);
function cP(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
var hP = (t, e) => {
    (t.suspense || t.throwOnError) && (e.isReset() || (t.retryOnMount = !1));
  },
  dP = (t) => {
    jt.useEffect(() => {
      t.clearReset();
    }, [t]);
  },
  pP = ({ result: t, errorResetBoundary: e, throwOnError: n, query: i }) =>
    t.isError && !e.isReset() && !t.isFetching && i && cP(n, [t.error, i]),
  mP = (t) => {
    t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
  },
  vP = (t, e) => (t == null ? void 0 : t.suspense) && e.isPending,
  gP = (t, e, n) =>
    e.fetchOptimistic(t).catch(() => {
      n.clearReset();
    });
function yP(t, e, n) {
  if (Et.env.NODE_ENV !== "production" && (typeof t != "object" || Array.isArray(t)))
    throw new Error(
      'Bad argument type. Starting with v5, only the "Object" form is allowed when calling query related functions. Please use the error stack to find the culprit call. More info here: https://tanstack.com/query/latest/docs/react/guides/migrating-to-v5#supports-a-single-signature-one-object'
    );
  const i = aP(n),
    l = oP(),
    a = uP(),
    c = i.defaultQueryOptions(t);
  (c._optimisticResults = l ? "isRestoring" : "optimistic"), mP(c), hP(c, a), dP(a);
  const [v] = jt.useState(() => new e(i, c)),
    g = v.getOptimisticResult(c);
  if (
    (jt.useSyncExternalStore(
      jt.useCallback(
        (b) => {
          const p = l ? () => {} : v.subscribe(Ar.batchCalls(b));
          return v.updateResult(), p;
        },
        [v, l]
      ),
      () => v.getCurrentResult(),
      () => v.getCurrentResult()
    ),
    jt.useEffect(() => {
      v.setOptions(c, { listeners: !1 });
    }, [c, v]),
    vP(c, g))
  )
    throw gP(c, v, a);
  if (
    pP({
      result: g,
      errorResetBoundary: a,
      throwOnError: c.throwOnError,
      query: i.getQueryCache().get(c.queryHash),
    })
  )
    throw g.error;
  return c.notifyOnChangeProps ? g : v.trackResult(g);
}
function bP(t, e) {
  return yP(t, rP, e);
}
const au = new Ir.TonClient({
    endpoint: DT,
    apiKey: LT,
  }),
  wP = async ({ userAddress: t, jAddress: e }) => {
    try {
      const n = Ir.Address.parse(t),
        i = au.open(Z4.createFromAddress(Ir.Address.parse(e))),
        { address: l } = await i.getWalletAddress(n);
      return {
        data: (await au.open(G4.createFromAddress(l)).getBalance()).amount || BigInt(0),
      };
    } catch (n) {
      return {
        error: {
          status: 418,
          statusText: "something went wrong",
          data: n == null ? void 0 : n.toString(),
        },
      };
    }
  },
  _P = () => {
    const t = y_(),
      e = b_(),
      { data: n } = bP({
        queryFn: () =>
          wP({
            userAddress: t,
            jAddress: H8,
          }),
        queryKey: [t],
        refetchInterval: 5e3,
      }),
      i = 18;
    return {
      isConnected: !!e,
      address: t,
      balance: n == null ? void 0 : n.data,
      numberBalance: Number(tf((n == null ? void 0 : n.data) ?? BigInt(0), i)),
      decimals: i,
      symbol: "GGR",
    };
  };
var on = /* @__PURE__ */ ((t) => (
  (t[(t.Stake = 0)] = "Stake"),
  (t[(t.Staked = 1)] = "Staked"),
  (t[(t.RequestWithdraw = 2)] = "RequestWithdraw"),
  t
))(on || {});
const e_ = (t, e) => x_(t.split(" ")[0].replace(/\s/g, ""), e);
var t_ = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (t) {
  (function () {
    var e = {}.hasOwnProperty;
    function n() {
      for (var a = "", c = 0; c < arguments.length; c++) {
        var v = arguments[c];
        v && (a = l(a, i(v)));
      }
      return a;
    }
    function i(a) {
      if (typeof a == "string" || typeof a == "number") return a;
      if (typeof a != "object") return "";
      if (Array.isArray(a)) return n.apply(null, a);
      if (
        a.toString !== Object.prototype.toString &&
        !a.toString.toString().includes("[native code]")
      )
        return a.toString();
      var c = "";
      for (var v in a) e.call(a, v) && a[v] && (c = l(c, v));
      return c;
    }
    function l(a, c) {
      return c ? (a ? a + " " + c : a + c) : a;
    }
    t.exports ? ((n.default = n), (t.exports = n)) : (window.classNames = n);
  })();
})(t_);
var xP = t_.exports;
const Xr = /* @__PURE__ */ k_(xP);
function su(t) {
  "@babel/helpers - typeof";
  return (
    (su =
      typeof Symbol == "function" && typeof Symbol.iterator == "symbol"
        ? function (e) {
            return typeof e;
          }
        : function (e) {
            return e &&
              typeof Symbol == "function" &&
              e.constructor === Symbol &&
              e !== Symbol.prototype
              ? "symbol"
              : typeof e;
          }),
    su(t)
  );
}
function Sr(t, e) {
  if (e.length < t)
    throw new TypeError(
      t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present"
    );
}
function MP(t) {
  return (
    Sr(1, arguments),
    t instanceof Date ||
      (su(t) === "object" && Object.prototype.toString.call(t) === "[object Date]")
  );
}
function Vr(t) {
  Sr(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || (su(t) === "object" && e === "[object Date]")
    ? new Date(t.getTime())
    : typeof t == "number" || e === "[object Number]"
    ? new Date(t)
    : ((typeof t == "string" || e === "[object String]") &&
        typeof console < "u" &&
        (console.warn(
          "Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"
        ),
        console.warn(new Error().stack)),
      /* @__PURE__ */ new Date(NaN));
}
function SP(t) {
  if ((Sr(1, arguments), !MP(t) && typeof t != "number")) return !1;
  var e = Vr(t);
  return !isNaN(Number(e));
}
function sa(t) {
  if (t === null || t === !0 || t === !1) return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function EP(t, e) {
  Sr(2, arguments);
  var n = Vr(t).getTime(),
    i = sa(e);
  return new Date(n + i);
}
function AP(t, e) {
  Sr(2, arguments);
  var n = sa(e);
  return EP(t, -n);
}
var kP = 864e5;
function BP(t) {
  Sr(1, arguments);
  var e = Vr(t),
    n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var i = e.getTime(),
    l = n - i;
  return Math.floor(l / kP) + 1;
}
function ou(t) {
  Sr(1, arguments);
  var e = 1,
    n = Vr(t),
    i = n.getUTCDay(),
    l = (i < e ? 7 : 0) + i - e;
  return n.setUTCDate(n.getUTCDate() - l), n.setUTCHours(0, 0, 0, 0), n;
}
function r_(t) {
  Sr(1, arguments);
  var e = Vr(t),
    n = e.getUTCFullYear(),
    i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n + 1, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var l = ou(i),
    a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var c = ou(a);
  return e.getTime() >= l.getTime() ? n + 1 : e.getTime() >= c.getTime() ? n : n - 1;
}
function CP(t) {
  Sr(1, arguments);
  var e = r_(t),
    n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var i = ou(n);
  return i;
}
var TP = 6048e5;
function PP(t) {
  Sr(1, arguments);
  var e = Vr(t),
    n = ou(e).getTime() - CP(e).getTime();
  return Math.round(n / TP) + 1;
}
var RP = {};
function Tc() {
  return RP;
}
function fu(t, e) {
  var n, i, l, a, c, v, g, b;
  Sr(1, arguments);
  var p = Tc(),
    _ = sa(
      (n =
        (i =
          (l =
            (a = e == null ? void 0 : e.weekStartsOn) !== null && a !== void 0
              ? a
              : e == null ||
                (c = e.locale) === null ||
                c === void 0 ||
                (v = c.options) === null ||
                v === void 0
              ? void 0
              : v.weekStartsOn) !== null && l !== void 0
            ? l
            : p.weekStartsOn) !== null && i !== void 0
          ? i
          : (g = p.locale) === null || g === void 0 || (b = g.options) === null || b === void 0
          ? void 0
          : b.weekStartsOn) !== null && n !== void 0
        ? n
        : 0
    );
  if (!(_ >= 0 && _ <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var M = Vr(t),
    S = M.getUTCDay(),
    A = (S < _ ? 7 : 0) + S - _;
  return M.setUTCDate(M.getUTCDate() - A), M.setUTCHours(0, 0, 0, 0), M;
}
function n_(t, e) {
  var n, i, l, a, c, v, g, b;
  Sr(1, arguments);
  var p = Vr(t),
    _ = p.getUTCFullYear(),
    M = Tc(),
    S = sa(
      (n =
        (i =
          (l =
            (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0
              ? a
              : e == null ||
                (c = e.locale) === null ||
                c === void 0 ||
                (v = c.options) === null ||
                v === void 0
              ? void 0
              : v.firstWeekContainsDate) !== null && l !== void 0
            ? l
            : M.firstWeekContainsDate) !== null && i !== void 0
          ? i
          : (g = M.locale) === null || g === void 0 || (b = g.options) === null || b === void 0
          ? void 0
          : b.firstWeekContainsDate) !== null && n !== void 0
        ? n
        : 1
    );
  if (!(S >= 1 && S <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var A = /* @__PURE__ */ new Date(0);
  A.setUTCFullYear(_ + 1, 0, S), A.setUTCHours(0, 0, 0, 0);
  var k = fu(A, e),
    P = /* @__PURE__ */ new Date(0);
  P.setUTCFullYear(_, 0, S), P.setUTCHours(0, 0, 0, 0);
  var B = fu(P, e);
  return p.getTime() >= k.getTime() ? _ + 1 : p.getTime() >= B.getTime() ? _ : _ - 1;
}
function IP(t, e) {
  var n, i, l, a, c, v, g, b;
  Sr(1, arguments);
  var p = Tc(),
    _ = sa(
      (n =
        (i =
          (l =
            (a = e == null ? void 0 : e.firstWeekContainsDate) !== null && a !== void 0
              ? a
              : e == null ||
                (c = e.locale) === null ||
                c === void 0 ||
                (v = c.options) === null ||
                v === void 0
              ? void 0
              : v.firstWeekContainsDate) !== null && l !== void 0
            ? l
            : p.firstWeekContainsDate) !== null && i !== void 0
          ? i
          : (g = p.locale) === null || g === void 0 || (b = g.options) === null || b === void 0
          ? void 0
          : b.firstWeekContainsDate) !== null && n !== void 0
        ? n
        : 1
    ),
    M = n_(t, e),
    S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(M, 0, _), S.setUTCHours(0, 0, 0, 0);
  var A = fu(S, e);
  return A;
}
var OP = 6048e5;
function UP(t, e) {
  Sr(1, arguments);
  var n = Vr(t),
    i = fu(n, e).getTime() - IP(n, e).getTime();
  return Math.round(i / OP) + 1;
}
function Xt(t, e) {
  for (var n = t < 0 ? "-" : "", i = Math.abs(t).toString(); i.length < e; ) i = "0" + i;
  return n + i;
}
var NP = {
  // Year
  y: function (e, n) {
    var i = e.getUTCFullYear(),
      l = i > 0 ? i : 1 - i;
    return Xt(n === "yy" ? l % 100 : l, n.length);
  },
  // Month
  M: function (e, n) {
    var i = e.getUTCMonth();
    return n === "M" ? String(i + 1) : Xt(i + 1, 2);
  },
  // Day of the month
  d: function (e, n) {
    return Xt(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function (e, n) {
    var i = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return i.toUpperCase();
      case "aaa":
        return i;
      case "aaaaa":
        return i[0];
      case "aaaa":
      default:
        return i === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function (e, n) {
    return Xt(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function (e, n) {
    return Xt(e.getUTCHours(), n.length);
  },
  // Minute
  m: function (e, n) {
    return Xt(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function (e, n) {
    return Xt(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function (e, n) {
    var i = n.length,
      l = e.getUTCMilliseconds(),
      a = Math.floor(l * Math.pow(10, i - 3));
    return Xt(a, n.length);
  },
};
const Ri = NP;
var cs = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  DP = {
    // Era
    G: function (e, n, i) {
      var l = e.getUTCFullYear() > 0 ? 1 : 0;
      switch (n) {
        case "G":
        case "GG":
        case "GGG":
          return i.era(l, {
            width: "abbreviated",
          });
        case "GGGGG":
          return i.era(l, {
            width: "narrow",
          });
        case "GGGG":
        default:
          return i.era(l, {
            width: "wide",
          });
      }
    },
    // Year
    y: function (e, n, i) {
      if (n === "yo") {
        var l = e.getUTCFullYear(),
          a = l > 0 ? l : 1 - l;
        return i.ordinalNumber(a, {
          unit: "year",
        });
      }
      return Ri.y(e, n);
    },
    // Local week-numbering year
    Y: function (e, n, i, l) {
      var a = n_(e, l),
        c = a > 0 ? a : 1 - a;
      if (n === "YY") {
        var v = c % 100;
        return Xt(v, 2);
      }
      return n === "Yo"
        ? i.ordinalNumber(c, {
            unit: "year",
          })
        : Xt(c, n.length);
    },
    // ISO week-numbering year
    R: function (e, n) {
      var i = r_(e);
      return Xt(i, n.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function (e, n) {
      var i = e.getUTCFullYear();
      return Xt(i, n.length);
    },
    // Quarter
    Q: function (e, n, i) {
      var l = Math.ceil((e.getUTCMonth() + 1) / 3);
      switch (n) {
        case "Q":
          return String(l);
        case "QQ":
          return Xt(l, 2);
        case "Qo":
          return i.ordinalNumber(l, {
            unit: "quarter",
          });
        case "QQQ":
          return i.quarter(l, {
            width: "abbreviated",
            context: "formatting",
          });
        case "QQQQQ":
          return i.quarter(l, {
            width: "narrow",
            context: "formatting",
          });
        case "QQQQ":
        default:
          return i.quarter(l, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // Stand-alone quarter
    q: function (e, n, i) {
      var l = Math.ceil((e.getUTCMonth() + 1) / 3);
      switch (n) {
        case "q":
          return String(l);
        case "qq":
          return Xt(l, 2);
        case "qo":
          return i.ordinalNumber(l, {
            unit: "quarter",
          });
        case "qqq":
          return i.quarter(l, {
            width: "abbreviated",
            context: "standalone",
          });
        case "qqqqq":
          return i.quarter(l, {
            width: "narrow",
            context: "standalone",
          });
        case "qqqq":
        default:
          return i.quarter(l, {
            width: "wide",
            context: "standalone",
          });
      }
    },
    // Month
    M: function (e, n, i) {
      var l = e.getUTCMonth();
      switch (n) {
        case "M":
        case "MM":
          return Ri.M(e, n);
        case "Mo":
          return i.ordinalNumber(l + 1, {
            unit: "month",
          });
        case "MMM":
          return i.month(l, {
            width: "abbreviated",
            context: "formatting",
          });
        case "MMMMM":
          return i.month(l, {
            width: "narrow",
            context: "formatting",
          });
        case "MMMM":
        default:
          return i.month(l, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // Stand-alone month
    L: function (e, n, i) {
      var l = e.getUTCMonth();
      switch (n) {
        case "L":
          return String(l + 1);
        case "LL":
          return Xt(l + 1, 2);
        case "Lo":
          return i.ordinalNumber(l + 1, {
            unit: "month",
          });
        case "LLL":
          return i.month(l, {
            width: "abbreviated",
            context: "standalone",
          });
        case "LLLLL":
          return i.month(l, {
            width: "narrow",
            context: "standalone",
          });
        case "LLLL":
        default:
          return i.month(l, {
            width: "wide",
            context: "standalone",
          });
      }
    },
    // Local week of year
    w: function (e, n, i, l) {
      var a = UP(e, l);
      return n === "wo"
        ? i.ordinalNumber(a, {
            unit: "week",
          })
        : Xt(a, n.length);
    },
    // ISO week of year
    I: function (e, n, i) {
      var l = PP(e);
      return n === "Io"
        ? i.ordinalNumber(l, {
            unit: "week",
          })
        : Xt(l, n.length);
    },
    // Day of the month
    d: function (e, n, i) {
      return n === "do"
        ? i.ordinalNumber(e.getUTCDate(), {
            unit: "date",
          })
        : Ri.d(e, n);
    },
    // Day of year
    D: function (e, n, i) {
      var l = BP(e);
      return n === "Do"
        ? i.ordinalNumber(l, {
            unit: "dayOfYear",
          })
        : Xt(l, n.length);
    },
    // Day of week
    E: function (e, n, i) {
      var l = e.getUTCDay();
      switch (n) {
        case "E":
        case "EE":
        case "EEE":
          return i.day(l, {
            width: "abbreviated",
            context: "formatting",
          });
        case "EEEEE":
          return i.day(l, {
            width: "narrow",
            context: "formatting",
          });
        case "EEEEEE":
          return i.day(l, {
            width: "short",
            context: "formatting",
          });
        case "EEEE":
        default:
          return i.day(l, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // Local day of week
    e: function (e, n, i, l) {
      var a = e.getUTCDay(),
        c = (a - l.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "e":
          return String(c);
        case "ee":
          return Xt(c, 2);
        case "eo":
          return i.ordinalNumber(c, {
            unit: "day",
          });
        case "eee":
          return i.day(a, {
            width: "abbreviated",
            context: "formatting",
          });
        case "eeeee":
          return i.day(a, {
            width: "narrow",
            context: "formatting",
          });
        case "eeeeee":
          return i.day(a, {
            width: "short",
            context: "formatting",
          });
        case "eeee":
        default:
          return i.day(a, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // Stand-alone local day of week
    c: function (e, n, i, l) {
      var a = e.getUTCDay(),
        c = (a - l.weekStartsOn + 8) % 7 || 7;
      switch (n) {
        case "c":
          return String(c);
        case "cc":
          return Xt(c, n.length);
        case "co":
          return i.ordinalNumber(c, {
            unit: "day",
          });
        case "ccc":
          return i.day(a, {
            width: "abbreviated",
            context: "standalone",
          });
        case "ccccc":
          return i.day(a, {
            width: "narrow",
            context: "standalone",
          });
        case "cccccc":
          return i.day(a, {
            width: "short",
            context: "standalone",
          });
        case "cccc":
        default:
          return i.day(a, {
            width: "wide",
            context: "standalone",
          });
      }
    },
    // ISO day of week
    i: function (e, n, i) {
      var l = e.getUTCDay(),
        a = l === 0 ? 7 : l;
      switch (n) {
        case "i":
          return String(a);
        case "ii":
          return Xt(a, n.length);
        case "io":
          return i.ordinalNumber(a, {
            unit: "day",
          });
        case "iii":
          return i.day(l, {
            width: "abbreviated",
            context: "formatting",
          });
        case "iiiii":
          return i.day(l, {
            width: "narrow",
            context: "formatting",
          });
        case "iiiiii":
          return i.day(l, {
            width: "short",
            context: "formatting",
          });
        case "iiii":
        default:
          return i.day(l, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // AM or PM
    a: function (e, n, i) {
      var l = e.getUTCHours(),
        a = l / 12 >= 1 ? "pm" : "am";
      switch (n) {
        case "a":
        case "aa":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting",
          });
        case "aaa":
          return i
            .dayPeriod(a, {
              width: "abbreviated",
              context: "formatting",
            })
            .toLowerCase();
        case "aaaaa":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting",
          });
        case "aaaa":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // AM, PM, midnight, noon
    b: function (e, n, i) {
      var l = e.getUTCHours(),
        a;
      switch (
        (l === 12 ? (a = cs.noon) : l === 0 ? (a = cs.midnight) : (a = l / 12 >= 1 ? "pm" : "am"),
        n)
      ) {
        case "b":
        case "bb":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting",
          });
        case "bbb":
          return i
            .dayPeriod(a, {
              width: "abbreviated",
              context: "formatting",
            })
            .toLowerCase();
        case "bbbbb":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting",
          });
        case "bbbb":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function (e, n, i) {
      var l = e.getUTCHours(),
        a;
      switch (
        (l >= 17
          ? (a = cs.evening)
          : l >= 12
          ? (a = cs.afternoon)
          : l >= 4
          ? (a = cs.morning)
          : (a = cs.night),
        n)
      ) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(a, {
            width: "abbreviated",
            context: "formatting",
          });
        case "BBBBB":
          return i.dayPeriod(a, {
            width: "narrow",
            context: "formatting",
          });
        case "BBBB":
        default:
          return i.dayPeriod(a, {
            width: "wide",
            context: "formatting",
          });
      }
    },
    // Hour [1-12]
    h: function (e, n, i) {
      if (n === "ho") {
        var l = e.getUTCHours() % 12;
        return (
          l === 0 && (l = 12),
          i.ordinalNumber(l, {
            unit: "hour",
          })
        );
      }
      return Ri.h(e, n);
    },
    // Hour [0-23]
    H: function (e, n, i) {
      return n === "Ho"
        ? i.ordinalNumber(e.getUTCHours(), {
            unit: "hour",
          })
        : Ri.H(e, n);
    },
    // Hour [0-11]
    K: function (e, n, i) {
      var l = e.getUTCHours() % 12;
      return n === "Ko"
        ? i.ordinalNumber(l, {
            unit: "hour",
          })
        : Xt(l, n.length);
    },
    // Hour [1-24]
    k: function (e, n, i) {
      var l = e.getUTCHours();
      return (
        l === 0 && (l = 24),
        n === "ko"
          ? i.ordinalNumber(l, {
              unit: "hour",
            })
          : Xt(l, n.length)
      );
    },
    // Minute
    m: function (e, n, i) {
      return n === "mo"
        ? i.ordinalNumber(e.getUTCMinutes(), {
            unit: "minute",
          })
        : Ri.m(e, n);
    },
    // Second
    s: function (e, n, i) {
      return n === "so"
        ? i.ordinalNumber(e.getUTCSeconds(), {
            unit: "second",
          })
        : Ri.s(e, n);
    },
    // Fraction of second
    S: function (e, n) {
      return Ri.S(e, n);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = a.getTimezoneOffset();
      if (c === 0) return "Z";
      switch (n) {
        case "X":
          return n6(c);
        case "XXXX":
        case "XX":
          return _a(c);
        case "XXXXX":
        case "XXX":
        default:
          return _a(c, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = a.getTimezoneOffset();
      switch (n) {
        case "x":
          return n6(c);
        case "xxxx":
        case "xx":
          return _a(c);
        case "xxxxx":
        case "xxx":
        default:
          return _a(c, ":");
      }
    },
    // Timezone (GMT)
    O: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = a.getTimezoneOffset();
      switch (n) {
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + r6(c, ":");
        case "OOOO":
        default:
          return "GMT" + _a(c, ":");
      }
    },
    // Timezone (specific non-location)
    z: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = a.getTimezoneOffset();
      switch (n) {
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + r6(c, ":");
        case "zzzz":
        default:
          return "GMT" + _a(c, ":");
      }
    },
    // Seconds timestamp
    t: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = Math.floor(a.getTime() / 1e3);
      return Xt(c, n.length);
    },
    // Milliseconds timestamp
    T: function (e, n, i, l) {
      var a = l._originalDate || e,
        c = a.getTime();
      return Xt(c, n.length);
    },
  };
function r6(t, e) {
  var n = t > 0 ? "-" : "+",
    i = Math.abs(t),
    l = Math.floor(i / 60),
    a = i % 60;
  if (a === 0) return n + String(l);
  var c = e || "";
  return n + String(l) + c + Xt(a, 2);
}
function n6(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + Xt(Math.abs(t) / 60, 2);
  }
  return _a(t, e);
}
function _a(t, e) {
  var n = e || "",
    i = t > 0 ? "-" : "+",
    l = Math.abs(t),
    a = Xt(Math.floor(l / 60), 2),
    c = Xt(l % 60, 2);
  return i + a + n + c;
}
var i6 = function (e, n) {
    switch (e) {
      case "P":
        return n.date({
          width: "short",
        });
      case "PP":
        return n.date({
          width: "medium",
        });
      case "PPP":
        return n.date({
          width: "long",
        });
      case "PPPP":
      default:
        return n.date({
          width: "full",
        });
    }
  },
  i_ = function (e, n) {
    switch (e) {
      case "p":
        return n.time({
          width: "short",
        });
      case "pp":
        return n.time({
          width: "medium",
        });
      case "ppp":
        return n.time({
          width: "long",
        });
      case "pppp":
      default:
        return n.time({
          width: "full",
        });
    }
  },
  LP = function (e, n) {
    var i = e.match(/(P+)(p+)?/) || [],
      l = i[1],
      a = i[2];
    if (!a) return i6(e, n);
    var c;
    switch (l) {
      case "P":
        c = n.dateTime({
          width: "short",
        });
        break;
      case "PP":
        c = n.dateTime({
          width: "medium",
        });
        break;
      case "PPP":
        c = n.dateTime({
          width: "long",
        });
        break;
      case "PPPP":
      default:
        c = n.dateTime({
          width: "full",
        });
        break;
    }
    return c.replace("{{date}}", i6(l, n)).replace("{{time}}", i_(a, n));
  },
  FP = {
    p: i_,
    P: LP,
  };
function qP(t) {
  var e = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
var zP = ["D", "DD"],
  jP = ["YY", "YYYY"];
function $P(t) {
  return zP.indexOf(t) !== -1;
}
function HP(t) {
  return jP.indexOf(t) !== -1;
}
function a6(t, e, n) {
  if (t === "YYYY")
    throw new RangeError(
      "Use `yyyy` instead of `YYYY` (in `"
        .concat(e, "`) for formatting years to the input `")
        .concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md")
    );
  if (t === "YY")
    throw new RangeError(
      "Use `yy` instead of `YY` (in `"
        .concat(e, "`) for formatting years to the input `")
        .concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md")
    );
  if (t === "D")
    throw new RangeError(
      "Use `d` instead of `D` (in `"
        .concat(e, "`) for formatting days of the month to the input `")
        .concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md")
    );
  if (t === "DD")
    throw new RangeError(
      "Use `dd` instead of `DD` (in `"
        .concat(e, "`) for formatting days of the month to the input `")
        .concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md")
    );
}
var VP = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds",
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds",
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes",
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes",
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours",
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours",
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days",
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks",
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks",
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months",
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months",
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years",
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years",
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years",
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years",
    },
  },
  WP = function (e, n, i) {
    var l,
      a = VP[e];
    return (
      typeof a == "string"
        ? (l = a)
        : n === 1
        ? (l = a.one)
        : (l = a.other.replace("{{count}}", n.toString())),
      i != null && i.addSuffix ? (i.comparison && i.comparison > 0 ? "in " + l : l + " ago") : l
    );
  };
const KP = WP;
function X0(t) {
  return function () {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
      n = e.width ? String(e.width) : t.defaultWidth,
      i = t.formats[n] || t.formats[t.defaultWidth];
    return i;
  };
}
var ZP = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy",
  },
  GP = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a",
  },
  YP = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}",
  },
  JP = {
    date: X0({
      formats: ZP,
      defaultWidth: "full",
    }),
    time: X0({
      formats: GP,
      defaultWidth: "full",
    }),
    dateTime: X0({
      formats: YP,
      defaultWidth: "full",
    }),
  };
const QP = JP;
var XP = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P",
  },
  eR = function (e, n, i, l) {
    return XP[e];
  };
const tR = eR;
function Uo(t) {
  return function (e, n) {
    var i = n != null && n.context ? String(n.context) : "standalone",
      l;
    if (i === "formatting" && t.formattingValues) {
      var a = t.defaultFormattingWidth || t.defaultWidth,
        c = n != null && n.width ? String(n.width) : a;
      l = t.formattingValues[c] || t.formattingValues[a];
    } else {
      var v = t.defaultWidth,
        g = n != null && n.width ? String(n.width) : t.defaultWidth;
      l = t.values[g] || t.values[v];
    }
    var b = t.argumentCallback ? t.argumentCallback(e) : e;
    return l[b];
  };
}
var rR = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"],
  },
  nR = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
  },
  iR = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    wide: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  },
  aR = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  },
  sR = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night",
    },
  },
  oR = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night",
    },
  },
  fR = function (e, n) {
    var i = Number(e),
      l = i % 100;
    if (l > 20 || l < 10)
      switch (l % 10) {
        case 1:
          return i + "st";
        case 2:
          return i + "nd";
        case 3:
          return i + "rd";
      }
    return i + "th";
  },
  lR = {
    ordinalNumber: fR,
    era: Uo({
      values: rR,
      defaultWidth: "wide",
    }),
    quarter: Uo({
      values: nR,
      defaultWidth: "wide",
      argumentCallback: function (e) {
        return e - 1;
      },
    }),
    month: Uo({
      values: iR,
      defaultWidth: "wide",
    }),
    day: Uo({
      values: aR,
      defaultWidth: "wide",
    }),
    dayPeriod: Uo({
      values: sR,
      defaultWidth: "wide",
      formattingValues: oR,
      defaultFormattingWidth: "wide",
    }),
  };
const uR = lR;
function No(t) {
  return function (e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      i = n.width,
      l = (i && t.matchPatterns[i]) || t.matchPatterns[t.defaultMatchWidth],
      a = e.match(l);
    if (!a) return null;
    var c = a[0],
      v = (i && t.parsePatterns[i]) || t.parsePatterns[t.defaultParseWidth],
      g = Array.isArray(v)
        ? hR(v, function (_) {
            return _.test(c);
          })
        : cR(v, function (_) {
            return _.test(c);
          }),
      b;
    (b = t.valueCallback ? t.valueCallback(g) : g), (b = n.valueCallback ? n.valueCallback(b) : b);
    var p = e.slice(c.length);
    return {
      value: b,
      rest: p,
    };
  };
}
function cR(t, e) {
  for (var n in t) if (t.hasOwnProperty(n) && e(t[n])) return n;
}
function hR(t, e) {
  for (var n = 0; n < t.length; n++) if (e(t[n])) return n;
}
function dR(t) {
  return function (e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {},
      i = e.match(t.matchPattern);
    if (!i) return null;
    var l = i[0],
      a = e.match(t.parsePattern);
    if (!a) return null;
    var c = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    var v = e.slice(l.length);
    return {
      value: c,
      rest: v,
    };
  };
}
var pR = /^(\d+)(th|st|nd|rd)?/i,
  mR = /\d+/i,
  vR = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i,
  },
  gR = {
    any: [/^b/i, /^(a|c)/i],
  },
  yR = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i,
  },
  bR = {
    any: [/1/i, /2/i, /3/i, /4/i],
  },
  wR = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
  },
  _R = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [
      /^ja/i,
      /^f/i,
      /^mar/i,
      /^ap/i,
      /^may/i,
      /^jun/i,
      /^jul/i,
      /^au/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i,
    ],
  },
  xR = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
  },
  MR = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
  },
  SR = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
  },
  ER = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i,
    },
  },
  AR = {
    ordinalNumber: dR({
      matchPattern: pR,
      parsePattern: mR,
      valueCallback: function (e) {
        return parseInt(e, 10);
      },
    }),
    era: No({
      matchPatterns: vR,
      defaultMatchWidth: "wide",
      parsePatterns: gR,
      defaultParseWidth: "any",
    }),
    quarter: No({
      matchPatterns: yR,
      defaultMatchWidth: "wide",
      parsePatterns: bR,
      defaultParseWidth: "any",
      valueCallback: function (e) {
        return e + 1;
      },
    }),
    month: No({
      matchPatterns: wR,
      defaultMatchWidth: "wide",
      parsePatterns: _R,
      defaultParseWidth: "any",
    }),
    day: No({
      matchPatterns: xR,
      defaultMatchWidth: "wide",
      parsePatterns: MR,
      defaultParseWidth: "any",
    }),
    dayPeriod: No({
      matchPatterns: SR,
      defaultMatchWidth: "any",
      parsePatterns: ER,
      defaultParseWidth: "any",
    }),
  };
const kR = AR;
var BR = {
  code: "en-US",
  formatDistance: KP,
  formatLong: QP,
  formatRelative: tR,
  localize: uR,
  match: kR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1,
  },
};
const CR = BR;
var TR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
  PR = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
  RR = /^'([^]*?)'?$/,
  IR = /''/g,
  OR = /[a-zA-Z]/;
function Kl(t, e, n) {
  var i, l, a, c, v, g, b, p, _, M, S, A, k, P, B, T, F, O;
  Sr(2, arguments);
  var $ = String(e),
    J = Tc(),
    he =
      (i = (l = n == null ? void 0 : n.locale) !== null && l !== void 0 ? l : J.locale) !== null &&
      i !== void 0
        ? i
        : CR,
    de = sa(
      (a =
        (c =
          (v =
            (g = n == null ? void 0 : n.firstWeekContainsDate) !== null && g !== void 0
              ? g
              : n == null ||
                (b = n.locale) === null ||
                b === void 0 ||
                (p = b.options) === null ||
                p === void 0
              ? void 0
              : p.firstWeekContainsDate) !== null && v !== void 0
            ? v
            : J.firstWeekContainsDate) !== null && c !== void 0
          ? c
          : (_ = J.locale) === null || _ === void 0 || (M = _.options) === null || M === void 0
          ? void 0
          : M.firstWeekContainsDate) !== null && a !== void 0
        ? a
        : 1
    );
  if (!(de >= 1 && de <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var ne = sa(
    (S =
      (A =
        (k =
          (P = n == null ? void 0 : n.weekStartsOn) !== null && P !== void 0
            ? P
            : n == null ||
              (B = n.locale) === null ||
              B === void 0 ||
              (T = B.options) === null ||
              T === void 0
            ? void 0
            : T.weekStartsOn) !== null && k !== void 0
          ? k
          : J.weekStartsOn) !== null && A !== void 0
        ? A
        : (F = J.locale) === null || F === void 0 || (O = F.options) === null || O === void 0
        ? void 0
        : O.weekStartsOn) !== null && S !== void 0
      ? S
      : 0
  );
  if (!(ne >= 0 && ne <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!he.localize) throw new RangeError("locale must contain localize property");
  if (!he.formatLong) throw new RangeError("locale must contain formatLong property");
  var Ae = Vr(t);
  if (!SP(Ae)) throw new RangeError("Invalid time value");
  var x = qP(Ae),
    r = AP(Ae, x),
    o = {
      firstWeekContainsDate: de,
      weekStartsOn: ne,
      locale: he,
      _originalDate: Ae,
    },
    f = $.match(PR)
      .map(function (u) {
        var d = u[0];
        if (d === "p" || d === "P") {
          var y = FP[d];
          return y(u, he.formatLong);
        }
        return u;
      })
      .join("")
      .match(TR)
      .map(function (u) {
        if (u === "''") return "'";
        var d = u[0];
        if (d === "'") return UR(u);
        var y = DP[d];
        if (y)
          return (
            !(n != null && n.useAdditionalWeekYearTokens) && HP(u) && a6(u, e, String(t)),
            !(n != null && n.useAdditionalDayOfYearTokens) && $P(u) && a6(u, e, String(t)),
            y(r, u, he.localize, o)
          );
        if (d.match(OR))
          throw new RangeError(
            "Format string contains an unescaped latin alphabet character `" + d + "`"
          );
        return u;
      })
      .join("");
  return f;
}
function UR(t) {
  var e = t.match(RR);
  return e ? e[1].replace(IR, "'") : t;
}
function NR(t, e) {
  Sr(2, arguments);
  var n = Vr(t),
    i = Vr(e);
  return n.getTime() > i.getTime();
}
function DR(t, e) {
  Sr(2, arguments);
  var n = Vr(t),
    i = Vr(e);
  return n.getTime() < i.getTime();
}
const ep = (t) =>
    /* @__PURE__ */ jt.createElement(
      "svg",
      {
        width: 14,
        height: 6,
        viewBox: "0 0 14 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ jt.createElement(
        "mask",
        { id: "path-1-inside-1_349_5872", fill: "white" },
        /* @__PURE__ */ jt.createElement("path", {
          d: "M13.0004 2.70855L10.6754 0.383552C10.4088 0.116885 9.95877 0.300218 9.95877 0.675218L9.95877 2.16689L0.833471 2.16683C0.375137 2.16683 0.000137227 2.54183 0.000137242 3.00017C0.000137256 3.4585 0.375137 3.8335 0.833471 3.8335L9.95877 3.83355L9.95877 5.32522C9.95877 5.70022 10.4088 5.88355 10.6671 5.61689L12.9921 3.29189C13.1588 3.13355 13.1588 2.86688 13.0004 2.70855Z",
        })
      ),
      /* @__PURE__ */ jt.createElement("path", {
        d: "M13.0004 2.70855L10.6754 0.383552C10.4088 0.116885 9.95877 0.300218 9.95877 0.675218L9.95877 2.16689L0.833471 2.16683C0.375137 2.16683 0.000137227 2.54183 0.000137242 3.00017C0.000137256 3.4585 0.375137 3.8335 0.833471 3.8335L9.95877 3.83355L9.95877 5.32522C9.95877 5.70022 10.4088 5.88355 10.6671 5.61689L12.9921 3.29189C13.1588 3.13355 13.1588 2.86688 13.0004 2.70855Z",
        fill: "#EEF9FC",
      }),
      /* @__PURE__ */ jt.createElement("path", {
        d: "M13.0004 2.70855L28.0854 -12.3764L28.0854 -12.3764L13.0004 2.70855ZM10.6754 0.383552L-4.40951 15.4685L-4.4095 15.4685L10.6754 0.383552ZM9.95877 2.16689L9.95864 23.5002L31.2921 23.5003L31.2921 2.16688L9.95877 2.16689ZM0.833471 2.16683L0.833594 -19.1665L0.833471 -19.1665L0.833471 2.16683ZM0.833471 3.8335L0.833594 -17.4998L0.833471 -17.4998L0.833471 3.8335ZM9.95877 3.83355L31.2921 3.83355L31.2921 -17.4997L9.95889 -17.4998L9.95877 3.83355ZM10.6671 5.61689L-4.41784 -9.46807L-4.53755 -9.34835L-4.65535 -9.22675L10.6671 5.61689ZM12.9921 3.29189L-1.70121 -12.1748L-1.89947 -11.9864L-2.09284 -11.7931L12.9921 3.29189ZM28.0854 -12.3764L25.7604 -14.7014L-4.4095 15.4685L-2.0845 17.7935L28.0854 -12.3764ZM25.7604 -14.7014C12.373 -28.0888 -11.3746 -19.155 -11.3746 0.675218L31.2921 0.675217C31.2921 19.7555 8.44458 28.3226 -4.40951 15.4685L25.7604 -14.7014ZM-11.3746 0.675218L-11.3746 2.16689L31.2921 2.16688L31.2921 0.675217L-11.3746 0.675218ZM9.95889 -19.1664L0.833594 -19.1665L0.833349 23.5002L9.95864 23.5002L9.95889 -19.1664ZM0.833471 -19.1665C-11.4069 -19.1665 -21.3332 -9.24026 -21.3332 3.00017L21.3335 3.00017C21.3335 14.3239 12.1572 23.5002 0.833472 23.5002L0.833471 -19.1665ZM-21.3332 3.00017C-21.3332 15.2406 -11.4069 25.1668 0.833472 25.1668L0.833471 -17.4998C12.1572 -17.4998 21.3335 -8.32359 21.3335 3.00017L-21.3332 3.00017ZM0.833349 25.1668L9.95864 25.1669L9.95889 -17.4998L0.833594 -17.4998L0.833349 25.1668ZM-11.3746 3.83355L-11.3746 5.32522L31.2921 5.32522L31.2921 3.83355L-11.3746 3.83355ZM-11.3746 5.32522C-11.3746 24.5365 12.1615 34.7346 25.9896 20.4605L-4.65535 -9.22675C8.65605 -22.9675 31.2921 -13.136 31.2921 5.32522L-11.3746 5.32522ZM25.752 20.7018L28.077 18.3768L-2.09284 -11.7931L-4.41784 -9.46807L25.752 20.7018ZM27.6854 18.7585C36.6383 10.2533 36.6393 -3.82244 28.0854 -12.3764L-2.0845 17.7935C-10.3218 9.55621 -10.3207 -3.98624 -1.70121 -12.1748L27.6854 18.7585Z",
        fill: "#586579",
        fillOpacity: 0.24,
        mask: "url(#path-1-inside-1_349_5872)",
      })
    ),
  a_ = (t) => new Date((Number(t.updatedAt.toString()) + Number(t.lock.toString())) * 1e3),
  s_ = ({ currentStake: t, pools: e }) => {
    const n = e.find((i) => i.lock === t.lock);
    return n ? n.multiplier : null;
  },
  LR = (t) =>
    /* @__PURE__ */ jt.createElement(
      "svg",
      {
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ jt.createElement("path", {
        d: "M9 5H1M1 5L4.29412 1.5M1 5L4.29412 8.5",
        stroke: "currentColor",
        strokeWidth: 1.3,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      })
    ),
  FR = "_typography_iuw1x_1",
  qR = "_regular_iuw1x_5",
  zR = "_medium_iuw1x_9",
  jR = "_semiBold_iuw1x_13",
  $R = "_bold_iuw1x_17",
  HR = "_heading1_iuw1x_21",
  VR = "_heading2_iuw1x_27",
  WR = "_heading3_iuw1x_32",
  KR = "_heading4_iuw1x_37",
  ZR = "_paragraph1_iuw1x_43",
  GR = "_paragraph2_iuw1x_48",
  YR = "_paragraph3_iuw1x_54",
  JR = "_paragraph4_iuw1x_59",
  QR = "_paragraph5_iuw1x_65",
  qr = {
    typography: FR,
    regular: qR,
    medium: zR,
    semiBold: jR,
    bold: $R,
    heading1: HR,
    heading2: VR,
    heading3: WR,
    heading4: KR,
    paragraph1: ZR,
    paragraph2: GR,
    paragraph3: YR,
    paragraph4: JR,
    paragraph5: QR,
  },
  s6 = {
    heading1: qr.heading1,
    heading2: qr.heading2,
    heading3: qr.heading3,
    heading4: qr.heading4,
    paragraph1: qr.paragraph1,
    paragraph2: qr.paragraph2,
    paragraph3: qr.paragraph3,
    paragraph4: qr.paragraph4,
    paragraph5: qr.paragraph5,
  },
  o6 = {
    bold: qr.bold,
    regular: qr.regular,
    medium: qr.medium,
    semiBold: qr.semiBold,
  },
  XR = ({
    className: t,
    children: e,
    variant: n,
    weight: i = "regular",
    component: l,
    withHTML: a = !1,
    ...c
  }) => {
    const v = l || "p";
    return a
      ? /* @__PURE__ */ gt.jsx(v, {
          ...c,
          dangerouslySetInnerHTML: { __html: e },
          className: Xr(qr.typography, o6[i], s6[n], t),
        })
      : /* @__PURE__ */ gt.jsx(v, {
          ...c,
          className: Xr(qr.typography, o6[i], s6[n], t),
          children: e,
        });
  },
  vr = br.memo(XR),
  eI = "_btn_yuknb_1",
  tI = "_icon_yuknb_7",
  rI = "_text_yuknb_8",
  tp = {
    btn: eI,
    icon: tI,
    text: rI,
  },
  nI = ({ className: t, onClick: e }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: Xr(tp.btn, t),
      onClick: e,
      children: [
        /* @__PURE__ */ gt.jsx(LR, { className: tp.icon }),
        /* @__PURE__ */ gt.jsx(vr, { className: tp.text, variant: "paragraph3", children: "Back" }),
      ],
    }),
  o_ = br.memo(nI),
  iI = "_button_amk7b_1",
  aI = "_buttonDisabled_amk7b_24",
  sI = "_secondary_amk7b_33",
  oI = "_outlined_amk7b_38",
  fI = "_success_amk7b_46",
  lI = "_error_amk7b_56",
  uI = "_startAdornment_amk7b_70",
  cI = "_endAdornment_amk7b_76",
  yi = {
    button: iI,
    buttonDisabled: aI,
    default: "_default_amk7b_28",
    secondary: sI,
    outlined: oI,
    success: fI,
    error: lI,
    startAdornment: uI,
    endAdornment: cI,
  },
  hI = {
    default: yi.default,
    secondary: yi.secondary,
    outlined: yi.outlined,
    success: yi.success,
    error: yi.error,
  },
  dI = ({
    className: t,
    children: e,
    type: n = "button",
    variant: i = "default",
    startAdornment: l,
    endAdornment: a,
    disabled: c,
    onClick: v,
  }) =>
    /* @__PURE__ */ gt.jsxs("button", {
      className: Xr(
        yi.button,
        {
          [yi.buttonDisabled]: c,
        },
        hI[i],
        t
      ),
      type: n,
      disabled: c,
      onClick: v,
      children: [
        l && /* @__PURE__ */ gt.jsx("span", { className: yi.startAdornment, children: l }),
        e,
        a && /* @__PURE__ */ gt.jsx("span", { className: yi.endAdornment, children: a }),
      ],
    }),
  lf = br.memo(dI),
  pI = (t) => t.querySelector("input,textarea") || t,
  Hm = {
    mask: /^.*$/,
    preprocessors: [],
    postprocessors: [],
    plugins: [],
    overwriteMode: "shift",
  };
class mI {
  constructor() {
    (this.now = null), (this.past = []), (this.future = []);
  }
  undo() {
    const e = this.past.pop();
    e && this.now && (this.future.push(this.now), this.updateElement(e, "historyUndo"));
  }
  redo() {
    const e = this.future.pop();
    e && this.now && (this.past.push(this.now), this.updateElement(e, "historyRedo"));
  }
  updateHistory(e) {
    if (!this.now) {
      this.now = e;
      return;
    }
    const n = this.now.value !== e.value,
      i = this.now.selection.some((l, a) => l !== e.selection[a]);
    (!n && !i) || (n && (this.past.push(this.now), (this.future = [])), (this.now = e));
  }
  updateElement(e, n) {
    (this.now = e), this.updateElementState(e, { inputType: n, data: null });
  }
}
function vI(t, ...e) {
  return e.every(({ value: n }) => n === t.value);
}
function gI(t, ...e) {
  return e.every(
    ({ value: n, selection: i }) =>
      n === t.value && i[0] === t.selection[0] && i[1] === t.selection[1]
  );
}
function yI({ value: t, selection: e }, n, i) {
  const [l, a] = e,
    c = typeof i == "function" ? i({ value: t, selection: e }) : i;
  return {
    value: t,
    selection: c === "replace" ? [l, l + n.length] : [l, a],
  };
}
function Pc(t) {
  return typeof t == "string";
}
function f6(t, e, n, i) {
  let l = "";
  for (let a = e.length; a < t.length; a++) {
    const c = t[a],
      v = (i == null ? void 0 : i.value[a]) === c;
    if (!Pc(c) || (c === n && !v)) return l;
    l += c;
  }
  return l;
}
function f_(t, e) {
  return Array.isArray(e)
    ? t.length === e.length &&
        Array.from(t).every((n, i) => {
          const l = e[i];
          return Pc(l) ? n === l : n.match(l);
        })
    : e.test(t);
}
function bI(t, e, n) {
  let i = null,
    l = null;
  const a = Array.from(t.value).reduce((v, g, b) => {
      const p = f6(e, v, g, n),
        _ = v + p,
        M = e[_.length];
      return Pc(M)
        ? _ + M
        : g.match(M)
        ? (i === null && b >= t.selection[0] && (i = _.length),
          l === null && b >= t.selection[1] && (l = _.length),
          _ + g)
        : _;
    }, ""),
    c = f6(e, a, "", n);
  return {
    value: f_(a + c, e) ? a + c : a,
    selection: [i ?? a.length, l ?? a.length],
  };
}
function wI({ value: t, selection: e }, n) {
  const [i, l] = e;
  let a = i,
    c = l;
  return {
    value: Array.from(t).reduce((g, b, p) => {
      const _ = g + b;
      return i === p && (a = g.length), l === p && (c = g.length), _.match(n) ? _ : g;
    }, ""),
    selection: [a, c],
  };
}
function dl(t, e, n = null) {
  if (f_(t.value, e)) return t;
  const { value: i, selection: l } = Array.isArray(e) ? bI(t, e, n) : wI(t, e);
  return {
    selection: l,
    value: Array.isArray(e) ? i.slice(0, e.length) : i,
  };
}
function l6(t, e) {
  if (!Array.isArray(e)) return t;
  const [n, i] = t.selection,
    l = [],
    a = Array.from(t.value).reduce((c, v, g) => {
      const b = e[g];
      return g === n && l.push(c.length), g === i && l.push(c.length), Pc(b) && b === v ? c : c + v;
    }, "");
  return (
    l.length < 2 && l.push(...new Array(2 - l.length).fill(a.length)),
    {
      value: a,
      selection: [l[0], l[1]],
    }
  );
}
class f1 {
  constructor(e, n) {
    (this.initialElementState = e),
      (this.maskOptions = n),
      (this.value = ""),
      (this.selection = [0, 0]);
    const { value: i, selection: l } = dl(
      this.initialElementState,
      this.getMaskExpression(this.initialElementState)
    );
    (this.value = i), (this.selection = l);
  }
  addCharacters([e, n], i) {
    const { value: l } = this,
      a = this.getMaskExpression({
        value: l.slice(0, e) + i + l.slice(n),
        selection: [e + i.length, e + i.length],
      }),
      c = { value: l, selection: [e, n] },
      v = l6(c, a),
      [g, b] = yI(v, i, this.maskOptions.overwriteMode).selection,
      p = v.value.slice(0, g) + i,
      _ = p.length,
      M = dl(
        {
          value: p + v.value.slice(b),
          selection: [_, _],
        },
        a,
        c
      );
    if (
      // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
      l.slice(0, g) ===
        dl(
          {
            value: p,
            selection: [_, _],
          },
          a,
          c
        ).value ||
      gI(this, M)
    )
      throw new Error("Invalid mask value");
    (this.value = M.value), (this.selection = M.selection);
  }
  deleteCharacters([e, n]) {
    if (e === n || !n) return;
    const { value: i } = this,
      l = this.getMaskExpression({
        value: i.slice(0, e) + i.slice(n),
        selection: [e, e],
      }),
      a = { value: i, selection: [e, n] },
      c = l6(a, l),
      [v, g] = c.selection,
      b = c.value.slice(0, v) + c.value.slice(g),
      p = dl({ value: b, selection: [v, v] }, l, a);
    (this.value = p.value), (this.selection = p.selection);
  }
  getMaskExpression(e) {
    const { mask: n } = this.maskOptions;
    return typeof n == "function" ? n(e) : n;
  }
}
class _I {
  constructor(e) {
    (this.element = e), (this.listeners = []);
  }
  listen(e, n, i) {
    const l = n;
    this.element.addEventListener(e, l, i),
      this.listeners.push(() => this.element.removeEventListener(e, l));
  }
  destroy() {
    this.listeners.forEach((e) => e());
  }
}
const Rn = {
    CTRL: 1,
    ALT: 2,
    SHIFT: 4,
    META: 8,
  },
  Qo = {
    Y: 89,
    Z: 90,
  };
function Xo(t, e, n) {
  return (
    t.ctrlKey === !!(e & Rn.CTRL) &&
    t.altKey === !!(e & Rn.ALT) &&
    t.shiftKey === !!(e & Rn.SHIFT) &&
    t.metaKey === !!(e & Rn.META) &&
    /**
     * We intentionally use legacy {@link KeyboardEvent#keyCode `keyCode`} property. It is more
     * "keyboard-layout"-independent than {@link KeyboardEvent#key `key`} or {@link KeyboardEvent#code `code`} properties.
     * @see {@link https://github.com/taiga-family/maskito/issues/315 `KeyboardEvent#code` issue}
     */ // eslint-disable-next-line sonar/deprecation
    t.keyCode === n
  );
}
function xI(t) {
  return (
    Xo(t, Rn.CTRL, Qo.Y) || // Windows
    Xo(t, Rn.CTRL | Rn.SHIFT, Qo.Z) || // Windows & Android
    Xo(t, Rn.META | Rn.SHIFT, Qo.Z)
  );
}
function MI(t) {
  return (
    Xo(t, Rn.CTRL, Qo.Z) || // Windows & Android
    Xo(t, Rn.META, Qo.Z)
  );
}
function Rc(t, e) {
  var n;
  const i = t.value;
  if (typeof e == "string") t.value = e;
  else {
    const [l, a] = e.selection;
    (t.value = e.value),
      t.matches(":focus") &&
        ((n = t.setSelectionRange) === null || n === void 0 || n.call(t, l, a));
  }
  t.value !== i &&
    t.dispatchEvent(
      new Event(
        "input",
        /**
         * React handles this event only on bubbling phase
         *
         * here is the list of events that are processed in the capture stage, others are processed in the bubbling stage
         * https://github.com/facebook/react/blob/cb2439624f43c510007f65aea5c50a8bb97917e4/packages/react-dom-bindings/src/events/DOMPluginEventSystem.js#L222
         */
        { bubbles: !0 }
      )
    );
}
function SI({ value: t, selection: e }, n) {
  const [i, l] = e;
  if (i !== l) return [i, l];
  const a = n
    ? t.slice(i).indexOf(`
`) + 1 || t.length
    : t.slice(0, l).lastIndexOf(`
`) + 1;
  return [n ? i : a, n ? a : l];
}
function EI({ value: t, selection: e }, n) {
  const [i, l] = e;
  return i !== l
    ? [i, l]
    : (n ? [i, l + 1] : [i - 1, l]).map((c) => Math.min(Math.max(c, 0), t.length));
}
const AI = /\s+$/g,
  kI = /^\s+/g,
  u6 = /\s/;
function BI({ value: t, selection: e }, n) {
  const [i, l] = e;
  if (i !== l) return [i, l];
  if (n) {
    const g = t.slice(i),
      [b] = g.match(kI) || [""],
      p = g.trimStart().search(u6);
    return [i, p !== -1 ? i + b.length + p : t.length];
  }
  const a = t.slice(0, l),
    [c] = a.match(AI) || [""],
    v = a
      .trimEnd()
      .split("")
      .reverse()
      .findIndex((g) => g.match(u6));
  return [v !== -1 ? l - c.length - v : 0, l];
}
function lu(t = []) {
  return (e, ...n) => t.reduce((i, l) => Object.assign(Object.assign({}, i), l(i, ...n)), e);
}
function Vm(t, e) {
  const n = Object.assign(Object.assign({}, Hm), e),
    i = lu(n.preprocessors),
    l = lu(n.postprocessors),
    a = typeof t == "string" ? { value: t, selection: [0, 0] } : t,
    { elementState: c } = i({ elementState: a, data: "" }, "validation"),
    v = new f1(c, n),
    { value: g, selection: b } = l(v, a);
  return typeof t == "string" ? g : { value: g, selection: b };
}
class CI extends mI {
  constructor(e, n) {
    super(),
      (this.element = e),
      (this.maskitoOptions = n),
      (this.isTextArea = this.element.nodeName === "TEXTAREA"),
      (this.eventListener = new _I(this.element)),
      (this.options = Object.assign(Object.assign({}, Hm), this.maskitoOptions)),
      (this.preprocessor = lu(this.options.preprocessors)),
      (this.postprocessor = lu(this.options.postprocessors)),
      (this.teardowns = this.options.plugins.map((i) => i(this.element, this.options))),
      this.updateHistory(this.elementState),
      this.eventListener.listen("keydown", (i) => {
        if (xI(i)) return i.preventDefault(), this.redo();
        if (MI(i)) return i.preventDefault(), this.undo();
      }),
      this.eventListener.listen("beforeinput", (i) => {
        const l = i.inputType.includes("Forward");
        switch ((this.updateHistory(this.elementState), i.inputType)) {
          case "historyUndo":
            return i.preventDefault(), this.undo();
          case "historyRedo":
            return i.preventDefault(), this.redo();
          case "deleteByCut":
          case "deleteContentBackward":
          case "deleteContentForward":
            return this.handleDelete({
              event: i,
              isForward: l,
              selection: EI(this.elementState, l),
            });
          case "deleteWordForward":
          case "deleteWordBackward":
            return this.handleDelete({
              event: i,
              isForward: l,
              selection: BI(this.elementState, l),
              force: !0,
            });
          case "deleteSoftLineBackward":
          case "deleteSoftLineForward":
          case "deleteHardLineBackward":
          case "deleteHardLineForward":
            return this.handleDelete({
              event: i,
              isForward: l,
              selection: SI(this.elementState, l),
              force: !0,
            });
          case "insertCompositionText":
            return;
          case "insertLineBreak":
            return this.handleEnter(i);
          case "insertFromPaste":
          case "insertText":
          case "insertFromDrop":
          default:
            return this.handleInsert(i, i.data || "");
        }
      }),
      this.eventListener.listen("input", ({ inputType: i }) => {
        i !== "insertCompositionText" &&
          (this.ensureValueFitsMask(), this.updateHistory(this.elementState));
      }),
      this.eventListener.listen("compositionend", () => {
        this.ensureValueFitsMask(), this.updateHistory(this.elementState);
      });
  }
  get elementState() {
    const { value: e, selectionStart: n, selectionEnd: i } = this.element;
    return {
      value: e,
      selection: [n || 0, i || 0],
    };
  }
  get maxLength() {
    const { maxLength: e } = this.element;
    return e === -1 ? 1 / 0 : e;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((e) => (e == null ? void 0 : e()));
  }
  updateElementState(
    { value: e, selection: n },
    i = {
      inputType: "insertText",
      data: null,
    }
  ) {
    const l = this.elementState.value;
    this.updateValue(e), this.updateSelectionRange(n), l !== e && this.dispatchInputEvent(i);
  }
  updateSelectionRange([e, n]) {
    var i;
    const { element: l } = this;
    l.matches(":focus") &&
      (l.selectionStart !== e || l.selectionEnd !== n) &&
      ((i = l.setSelectionRange) === null || i === void 0 || i.call(l, e, n));
  }
  updateValue(e) {
    this.element.value = e;
  }
  ensureValueFitsMask() {
    this.updateElementState(Vm(this.elementState, this.options));
  }
  dispatchInputEvent(
    e = {
      inputType: "insertText",
      data: null,
    }
  ) {
    globalThis.InputEvent &&
      this.element.dispatchEvent(
        new InputEvent(
          "input",
          Object.assign(Object.assign({}, e), { bubbles: !0, cancelable: !1 })
        )
      );
  }
  handleDelete({ event: e, selection: n, isForward: i, force: l = !1 }) {
    const a = {
        value: this.elementState.value,
        selection: n,
      },
      [c, v] = a.selection,
      { elementState: g } = this.preprocessor(
        {
          elementState: a,
          data: "",
        },
        i ? "deleteForward" : "deleteBackward"
      ),
      b = new f1(g, this.options),
      [p, _] = g.selection;
    b.deleteCharacters([p, _]);
    const M = this.postprocessor(b, a);
    if (!(a.value.slice(0, c) + a.value.slice(v) === M.value && !l)) {
      if ((e.preventDefault(), vI(a, g, b, M)))
        return this.updateSelectionRange(i ? [_, _] : [p, p]);
      this.updateElementState(M, {
        inputType: e.inputType,
        data: null,
      }),
        this.updateHistory(M);
    }
  }
  handleInsert(e, n) {
    const i = this.elementState,
      { elementState: l, data: a = n } = this.preprocessor(
        {
          data: n,
          elementState: i,
        },
        "insert"
      ),
      c = new f1(l, this.options);
    try {
      c.addCharacters(l.selection, a);
    } catch {
      return e.preventDefault();
    }
    const [v, g] = l.selection,
      b = i.value.slice(0, v) + n + i.value.slice(g),
      p = this.postprocessor(c, i);
    if (p.value.length > this.maxLength) return e.preventDefault();
    b !== p.value &&
      (e.preventDefault(),
      this.updateElementState(p, {
        data: n,
        inputType: e.inputType,
      }),
      this.updateHistory(p));
  }
  handleEnter(e) {
    this.isTextArea &&
      this.handleInsert(
        e,
        `
`
      );
  }
}
const c6 = typeof window < "u" ? g_ : ip;
function TI(t) {
  return t && typeof t == "object" && "then" in t;
}
const PI = ({ options: t = null, elementPredicate: e = pI } = {}) => {
    const [n, i] = yn(null),
      [l, a] = yn(null),
      c = m_((g) => {
        i(g);
      }, []),
      v = v_(e);
    return (
      (v.current = e),
      c6(() => {
        if (!n) return;
        const g = e,
          b = g(n);
        TI(b)
          ? b.then((p) => {
              v.current === g && a(p);
            })
          : a(b);
      }, [n, e, v]),
      c6(() => {
        if (!l || !t) return;
        const g = new CI(l, t);
        return () => {
          g.destroy();
        };
      }, [t, l]),
      c
    );
  },
  l_ = (t) =>
    /* @__PURE__ */ jt.createElement(
      "svg",
      {
        width: 30,
        height: 30,
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
      },
      /* @__PURE__ */ jt.createElement("rect", {
        width: 30,
        height: 30,
        rx: 10,
        fill: "url(#paint0_linear_349_5634)",
      }),
      /* @__PURE__ */ jt.createElement(
        "g",
        { filter: "url(#filter0_d_349_5634)" },
        /* @__PURE__ */ jt.createElement("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.07093 15.5234C6.46572 18.3059 8.8925 20.1087 11.9491 20.2853C9.23904 20.3811 7.13228 19.646 6.54608 18.1799L6.5231 18.1232C6.02691 19.0489 5.9048 19.9271 6.24705 20.6556C7.26052 22.8127 11.962 22.8392 16.7482 20.7148C18.9718 19.7278 20.8224 18.4502 22.0651 17.1487C21.4143 16.6243 20.9998 15.8326 20.9998 14.9468C20.9998 13.3679 22.3167 12.0879 23.9411 12.0879C23.9503 12.0879 23.9594 12.0879 23.9686 12.088C22.7234 8.54654 19.2699 6 15.2046 6C11.9899 6 9.1579 7.59225 7.49774 10.0096C6.38308 11.9322 5.7824 13.4897 6.07093 15.5234ZM24.0055 17.805C23.9841 17.8054 23.9626 17.8056 23.9411 17.8056C23.516 17.8056 23.112 17.718 22.7471 17.5603C21.1979 19.3701 18.9393 21.1506 16.2419 22.3479C14.8877 22.949 13.6042 23.3446 12.4062 23.5817C13.289 23.8534 14.2292 24 15.2046 24C19.3108 24 22.7927 21.402 24.0055 17.805ZM17.5131 19.1079C16.6731 19.4252 15.8354 19.6772 15.0179 19.8658C12.2364 19.8606 9.9832 17.6654 9.9832 14.9583C9.9832 12.3198 12.1236 10.1676 14.8074 10.0554L14.8085 10.0506C16.8599 9.9943 18.2836 10.2005 18.8191 10.3134V12.0212C18.1556 11.8718 16.209 11.6755 14.8429 11.7474L14.843 11.7502C13.1064 11.8358 11.7254 13.2327 11.7254 14.9434C11.7254 16.7092 13.1969 18.1407 15.012 18.1407L15.0144 18.1407V18.139C16.2022 18.139 16.9866 18.0723 17.4961 17.9954V15.7226L19.241 15.236L19.241 18.3499C19.3323 18.306 19.4231 18.2616 19.5133 18.2168C18.8758 18.546 18.206 18.8462 17.5131 19.1079Z",
          fill: "#EEF9FC",
        })
      ),
      /* @__PURE__ */ jt.createElement(
        "defs",
        null,
        /* @__PURE__ */ jt.createElement(
          "filter",
          {
            id: "filter0_d_349_5634",
            x: 4.99902,
            y: 5.5,
            width: 20.0068,
            height: 20,
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
          },
          /* @__PURE__ */ jt.createElement("feFlood", {
            floodOpacity: 0,
            result: "BackgroundImageFix",
          }),
          /* @__PURE__ */ jt.createElement("feColorMatrix", {
            in: "SourceAlpha",
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
            result: "hardAlpha",
          }),
          /* @__PURE__ */ jt.createElement("feOffset", { dy: 0.5 }),
          /* @__PURE__ */ jt.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
          /* @__PURE__ */ jt.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ jt.createElement("feColorMatrix", {
            type: "matrix",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.39 0",
          }),
          /* @__PURE__ */ jt.createElement("feBlend", {
            mode: "normal",
            in2: "BackgroundImageFix",
            result: "effect1_dropShadow_349_5634",
          }),
          /* @__PURE__ */ jt.createElement("feBlend", {
            mode: "normal",
            in: "SourceGraphic",
            in2: "effect1_dropShadow_349_5634",
            result: "shape",
          })
        ),
        /* @__PURE__ */ jt.createElement(
          "linearGradient",
          {
            id: "paint0_linear_349_5634",
            x1: 1,
            y1: 29,
            x2: 30,
            y2: -7,
            gradientUnits: "userSpaceOnUse",
          },
          /* @__PURE__ */ jt.createElement("stop", { stopColor: "#3652E5" }),
          /* @__PURE__ */ jt.createElement("stop", { offset: 0.644597, stopColor: "#0098FF" }),
          /* @__PURE__ */ jt.createElement("stop", { offset: 1, stopColor: "#01C6FF" })
        )
      )
    ),
  RI = "_input_1c6qh_1",
  II = "_field_1c6qh_10",
  OI = "_icon_1c6qh_22",
  rp = {
    input: RI,
    field: II,
    icon: OI,
  },
  UI = ({ maskedInputRef: t, value: e, onChange: n }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: rp.input,
      children: [
        /* @__PURE__ */ gt.jsx(l_, { className: rp.icon }),
        /* @__PURE__ */ gt.jsx("input", {
          ref: t,
          className: rp.field,
          placeholder: "Please enter GGR amount",
          value: e,
          onInput: n,
        }),
      ],
    }),
  NI = br.memo(UI);
function uu(t, e, n) {
  const i = Math.min(Number(n), Math.max(Number(e), Number(t)));
  return t instanceof Date ? new Date(i) : i;
}
const DI = [".", ",", "б", "ю"],
  LI = [":", "."],
  FI = " ",
  qI = "​",
  u_ = "–",
  c_ = "—",
  cu = "-",
  l1 = "−",
  h_ = "ー",
  d_ = /[\\^$.*+?()[\]{}|]/g,
  zI = new RegExp(d_.source);
function en(t) {
  return t && zI.test(t) ? t.replaceAll(d_, "\\$&") : t;
}
function oi(t, { prefix: e, postfix: n }) {
  var i, l;
  const a = new RegExp(`^${en(e)}`),
    c = new RegExp(`${en(n)}$`),
    [v = ""] = (i = t.match(a)) !== null && i !== void 0 ? i : [],
    [g = ""] = (l = t.match(c)) !== null && l !== void 0 ? l : [],
    b = t.replace(a, "").replace(c, "");
  return { extractedPrefix: v, extractedPostfix: g, cleanValue: b };
}
function jI(t, e) {
  let n = "";
  for (let i = 0; i < t.length; i++) {
    if (t[i] !== e[i]) return n;
    n += t[i];
  }
  return n;
}
function Hf(t) {
  return t;
}
function h6(t) {
  return t.replaceAll(/[０-９]/g, (e) => String.fromCharCode(e.charCodeAt(0) - 65248));
}
function $I() {
  return ({ elementState: t, data: e }) => {
    const { value: n, selection: i } = t;
    return {
      elementState: {
        selection: i,
        value: h6(n),
      },
      data: h6(e),
    };
  };
}
function HI(t) {
  const e = new RegExp(`${en(t)}$`);
  return t
    ? ({ value: n, selection: i }, l) => {
        if (!n && !l.value.endsWith(t)) return { value: n, selection: i };
        if (!n.endsWith(t) && !l.value.endsWith(t)) return { selection: i, value: n + t };
        const a = l.value.replace(e, ""),
          c = l.selection[1] >= a.length,
          v = jI(a, n);
        return {
          selection: i,
          value: Array.from(t)
            .reverse()
            .reduce((g, b, p) => {
              const _ = g.length - 1 - p,
                M = v[_] === b && c;
              return g[_] !== b || M ? g.slice(0, _ + 1) + b + g.slice(_ + 1) : g;
            }, n),
        };
      }
    : Hf;
}
function VI(t) {
  return t
    ? ({ value: e, selection: n }, i) => {
        if (
          e.startsWith(t) || // already valid
          (!e && !i.value.startsWith(t))
        )
          return { value: e, selection: n };
        const [l, a] = n,
          c = Array.from(t).reduce(
            (g, b, p) => (g[p] === b ? g : g.slice(0, p) + b + g.slice(p)),
            e
          ),
          v = c.length - e.length;
        return {
          selection: [l + v, a + v],
          value: c,
        };
      }
    : Hf;
}
function Ic(t, e, n) {
  return (i, l) => {
    const a = () => e(i, l);
    return i.addEventListener(t, a, n), () => i.removeEventListener(t, a, n);
  };
}
function WI(t) {
  return (e) => {
    const n = e.ownerDocument;
    let i = 0;
    const l = () => i++,
      a = () => {
        i = Math.max(--i, 0);
      },
      c = () => {
        if (!e.matches(":focus")) return;
        if (i)
          return n.addEventListener("mouseup", c, {
            once: !0,
            passive: !0,
          });
        const v = e.selectionStart || 0,
          g = e.selectionEnd || 0,
          [b, p] = t(e.value, [v, g]);
        (b > v || p < g) && e.setSelectionRange(uu(v, b, p), uu(g, b, p));
      };
    return (
      n.addEventListener("selectionchange", c, { passive: !0 }),
      e.addEventListener("mousedown", l, { passive: !0 }),
      n.addEventListener("mouseup", a, { passive: !0 }),
      () => {
        n.removeEventListener("selectionchange", c),
          n.removeEventListener("mousedown", l),
          n.removeEventListener("mouseup", a);
      }
    );
  };
}
new RegExp(`[${LI.map(en).join("")}]$`);
function KI({ prefix: t, postfix: e }) {
  return ({ elementState: n, data: i }) => {
    const { cleanValue: l } = oi(i, {
      prefix: t,
      postfix: e,
    });
    return {
      elementState: n,
      data: l,
    };
  };
}
function p_({
  decimalSeparator: t,
  isNegativeAllowed: e,
  precision: n,
  thousandSeparator: i,
  prefix: l,
  postfix: a,
  decimalPseudoSeparators: c = [],
  pseudoMinuses: v = [],
  minusSign: g,
}) {
  const b = d6(l),
    p = "\\d",
    _ = e ? `[${g}${v.map((k) => `\\${k}`).join("")}]?` : "",
    M = i ? `[${p}${en(i).replaceAll(/\s/g, "\\s")}]*` : `[${p}]*`,
    S = n > 0 ? `([${en(t)}${c.map(en).join("")}]${p}{0,${Number.isFinite(n) ? n : ""}})?` : "",
    A = d6(a);
  return new RegExp(`^${b}${_}${M}${S}${A}$`);
}
function d6(t) {
  return t
    ? `${t
        .split("")
        .map((e) => `${en(e)}?`)
        .join("")}`
    : "";
}
function Wm(t, e = ".") {
  const n = !!t.match(new RegExp(`^\\D*[${l1}\\${cu}${u_}${c_}${h_}]`)),
    i = en(e),
    l = t
      .replaceAll(new RegExp(`${i}(?!\\d)`, "g"), "")
      .replaceAll(new RegExp(`[^\\d${i}]`, "g"), "")
      .replace(e, ".");
  return l ? Number((n ? cu : "") + l) : NaN;
}
function ZI(t) {
  const e = String(t),
    [n, i] = e.split("e-");
  let l = e;
  if (i) {
    const [, a] = n.split("."),
      c = Number(i) + ((a == null ? void 0 : a.length) || 0);
    l = t.toFixed(c);
  }
  return l;
}
function GI({ decimalSeparator: t, thousandSeparator: e, decimalPseudoSeparators: n = DI }) {
  return n.filter((i) => i !== e && i !== t);
}
function YI({ decimalSeparator: t, precision: e, decimalZeroPadding: n, prefix: i, postfix: l }) {
  return e <= 0 || !n
    ? Hf
    : ({ value: a, selection: c }) => {
        const {
          cleanValue: v,
          extractedPrefix: g,
          extractedPostfix: b,
        } = oi(a, {
          prefix: i,
          postfix: l,
        });
        if (Number.isNaN(Wm(v, t))) return { value: a, selection: c };
        const [p, _ = ""] = v.split(t);
        return {
          value: g + p + t + _.padEnd(e, "0") + b,
          selection: c,
        };
      };
}
function JI({
  decimalSeparator: t,
  decimalPseudoSeparators: e,
  pseudoMinuses: n,
  prefix: i,
  postfix: l,
  minusSign: a,
}) {
  let c = !0;
  const v = p_({
    decimalSeparator: t,
    decimalPseudoSeparators: e,
    pseudoMinuses: n,
    prefix: "",
    postfix: "",
    thousandSeparator: "",
    precision: 1 / 0,
    isNegativeAllowed: !0,
    minusSign: a,
  });
  return ({ elementState: g, data: b }) => {
    if (!c) return { elementState: g, data: b };
    c = !1;
    const { value: p, selection: _ } = g,
      [M, S] = _,
      {
        extractedPrefix: A,
        cleanValue: k,
        extractedPostfix: P,
      } = oi(p, {
        prefix: i,
        postfix: l,
      }),
      B = Vm(
        {
          selection: [Math.max(M - A.length, 0), uu(S - A.length, 0, k.length)],
          value: k,
        },
        {
          mask: v,
        }
      ),
      [T, F] = B.selection;
    return {
      elementState: {
        selection: [T + A.length, F + A.length],
        value: A + B.value + P,
      },
      data: b,
    };
  };
}
function QI({ decimalSeparator: t, thousandSeparator: e, prefix: n, postfix: i }) {
  const l = (c) => {
      const v = en(e);
      return c
        .replace(
          // all leading zeroes followed by another zero
          new RegExp(`^(\\D+)?[0${v}]+(?=0)`),
          "$1"
        )
        .replace(
          // zero followed by not-zero digit
          new RegExp(`^(\\D+)?[0${v}]+(?=[1-9])`),
          "$1"
        );
    },
    a = (c, v) => {
      const g = c.slice(0, v),
        b = c.slice(v).startsWith("0");
      return g.length - l(g).length + (b ? 1 : 0);
    };
  return ({ value: c, selection: v }) => {
    const [g, b] = v,
      {
        cleanValue: p,
        extractedPrefix: _,
        extractedPostfix: M,
      } = oi(c, {
        prefix: n,
        postfix: i,
      }),
      S = p.includes(t),
      [A, k = ""] = p.split(t),
      P = l(A);
    if (A === P) return { value: c, selection: v };
    const B = g - a(c, g),
      T = b - a(c, b);
    return {
      value: _ + P + (S ? t : "") + k + M,
      selection: [Math.max(B, 0), Math.max(T, 0)],
    };
  };
}
function XI({ min: t, max: e, decimalSeparator: n, minusSign: i }) {
  return ({ value: l, selection: a }) => {
    const c = Wm(l, n),
      v =
        /**
         * We cannot limit lower bound if user enters positive number.
         * The same for upper bound and negative number.
         * ___
         * @example (min = 5)
         * Empty input => Without this condition user cannot type 42 (the first digit will be rejected)
         * ___
         * @example (max = -10)
         * Value is -10 => Without this condition user cannot delete 0 to enter another digit
         */
        c > 0 ? Math.min(c, e) : Math.max(c, t);
    if (!Number.isNaN(c) && v !== c) {
      const g = `${v}`.replace(".", n).replace(cu, i);
      return {
        value: g,
        selection: [g.length, g.length],
      };
    }
    return {
      value: l,
      selection: a,
    };
  };
}
function eO({ decimalSeparator: t, thousandSeparator: e, decimalZeroPadding: n }) {
  return ({ elementState: i, data: l }, a) => {
    const { value: c, selection: v } = i,
      [g, b] = v,
      p = c.slice(g, b),
      _ = n ? [t, e] : [e],
      M = n && g > c.indexOf(t) && !!p.match(/^0+$/gi);
    return (a !== "deleteBackward" && a !== "deleteForward") || (!_.includes(p) && !M)
      ? {
          elementState: i,
          data: l,
        }
      : {
          elementState: {
            value: c,
            selection: a === "deleteForward" ? [b, b] : [g, g],
          },
          data: l,
        };
  };
}
function tO({ decimalSeparator: t, precision: e, prefix: n, postfix: i }) {
  const l = new RegExp(`^\\D*${en(t)}`);
  return ({ elementState: a, data: c }) => {
    const { value: v, selection: g } = a,
      { cleanValue: b } = oi(v, {
        prefix: n,
        postfix: i,
      }),
      [p] = g;
    if (e <= 0 || b.includes(t) || !c.match(l)) return { elementState: a, data: c };
    const _ = b.slice(0, p).match(/\d+/);
    return {
      elementState: a,
      data: _ ? c : `0${c}`,
    };
  };
}
function p6({ validCharacter: t, pseudoCharacters: e, prefix: n, postfix: i }) {
  const l = new RegExp(`[${e.join("")}]`, "gi");
  return ({ elementState: a, data: c }) => {
    const { value: v, selection: g } = a,
      {
        cleanValue: b,
        extractedPostfix: p,
        extractedPrefix: _,
      } = oi(v, {
        prefix: n,
        postfix: i,
      });
    return {
      elementState: {
        selection: g,
        value: _ + b.replace(l, t) + p,
      },
      data: c.replace(l, t),
    };
  };
}
function rO({ decimalSeparator: t, prefix: e, postfix: n }) {
  return ({ elementState: i, data: l }) => {
    const { value: a, selection: c } = i,
      [v, g] = c,
      { cleanValue: b } = oi(a, { prefix: e, postfix: n });
    return {
      elementState: i,
      data:
        !b.includes(t) || a.slice(v, g + 1).includes(t)
          ? l
          : l.replaceAll(new RegExp(en(t), "gi"), ""),
    };
  };
}
function nO({ thousandSeparator: t, decimalSeparator: e, prefix: n, postfix: i, minusSign: l }) {
  if (!t) return Hf;
  const a = (...c) => c.every((v) => /\s/.test(v));
  return ({ value: c, selection: v }) => {
    const {
        cleanValue: g,
        extractedPostfix: b,
        extractedPrefix: p,
      } = oi(c, {
        prefix: n,
        postfix: i,
      }),
      [_, M = ""] = g.replace(l, "").split(e),
      [S, A] = v;
    let [k, P] = v;
    const B = Array.from(_).reduceRight((T, F, O) => {
      const J = !(!O && F === t) && T.length && (T.length + 1) % 4 === 0;
      return J && (F === t || a(F, t))
        ? t + T
        : F === t && !J
        ? (O && O <= S && k--, O && O <= A && P--, T)
        : J
        ? (O <= S && k++, O <= A && P++, F + t + T)
        : F + T;
    }, "");
    return {
      value: p + (g.includes(l) ? l : "") + B + (g.includes(e) ? e : "") + M + b,
      selection: [k, P],
    };
  };
}
function iO({ precision: t, decimalSeparator: e, prefix: n, postfix: i }) {
  if (t > 0) return Hf;
  const l = new RegExp(`${en(e)}.*$`, "g");
  return ({ elementState: a, data: c }) => {
    const { value: v, selection: g } = a,
      {
        cleanValue: b,
        extractedPrefix: p,
        extractedPostfix: _,
      } = oi(v, {
        prefix: n,
        postfix: i,
      }),
      [M, S] = g,
      A = p + b.replace(l, "") + _;
    return {
      elementState: {
        selection: [Math.min(M, A.length), Math.min(S, A.length)],
        value: A,
      },
      data: c.replace(l, ""),
    };
  };
}
const m6 = [0, 0];
function aO({ decimalSeparator: t, thousandSeparator: e, prefix: n, postfix: i }) {
  const l = QI({
    decimalSeparator: t,
    thousandSeparator: e,
    prefix: n,
    postfix: i,
  });
  return Ic(
    "blur",
    (a) => {
      const c = l(
        {
          value: a.value,
          selection: m6,
        },
        { value: "", selection: m6 }
      ).value;
      Rc(a, c);
    },
    { capture: !0 }
  );
}
function sO({ min: t, max: e, decimalSeparator: n }) {
  return Ic(
    "blur",
    (i, l) => {
      const a = Wm(i.value, n),
        c = uu(a, t, e);
      !Number.isNaN(a) && a !== c && Rc(i, Vm(ZI(c), l));
    },
    { capture: !0 }
  );
}
function oO({ decimalSeparator: t, prefix: e, postfix: n }) {
  return Ic(
    "blur",
    (i) => {
      const {
          cleanValue: l,
          extractedPostfix: a,
          extractedPrefix: c,
        } = oi(i.value, { prefix: e, postfix: n }),
        v = c + l.replace(new RegExp(`^(\\D+)?${en(t)}`), `$10${t}`) + a;
      Rc(i, v);
    },
    { capture: !0 }
  );
}
function fO({
  max: t = Number.MAX_SAFE_INTEGER,
  min: e = Number.MIN_SAFE_INTEGER,
  precision: n = 0,
  thousandSeparator: i = FI,
  decimalSeparator: l = ".",
  decimalPseudoSeparators: a,
  decimalZeroPadding: c = !1,
  prefix: v = "",
  postfix: g = "",
  minusSign: b = l1,
} = {}) {
  const p = [cu, u_, c_, h_, l1].filter((S) => S !== i && S !== l && S !== b),
    _ = GI({
      decimalSeparator: l,
      thousandSeparator: i,
      decimalPseudoSeparators: a,
    }),
    M = v.endsWith(l) && n > 0 ? `${v}${qI}` : v;
  return Object.assign(Object.assign({}, Hm), {
    mask: p_({
      decimalSeparator: l,
      precision: n,
      thousandSeparator: i,
      prefix: M,
      postfix: g,
      isNegativeAllowed: e < 0,
      minusSign: b,
    }),
    preprocessors: [
      $I(),
      JI({
        decimalSeparator: l,
        decimalPseudoSeparators: _,
        pseudoMinuses: p,
        prefix: M,
        postfix: g,
        minusSign: b,
      }),
      KI({ prefix: M, postfix: g }),
      p6({
        validCharacter: b,
        pseudoCharacters: p,
        prefix: M,
        postfix: g,
      }),
      p6({
        validCharacter: l,
        pseudoCharacters: _,
        prefix: M,
        postfix: g,
      }),
      tO({
        decimalSeparator: l,
        precision: n,
        prefix: M,
        postfix: g,
      }),
      eO({
        decimalSeparator: l,
        decimalZeroPadding: c,
        thousandSeparator: i,
      }),
      iO({
        precision: n,
        decimalSeparator: l,
        prefix: M,
        postfix: g,
      }),
      rO({
        decimalSeparator: l,
        prefix: M,
        postfix: g,
      }),
    ],
    postprocessors: [
      XI({ decimalSeparator: l, min: e, max: t, minusSign: b }),
      VI(M),
      HI(g),
      nO({
        decimalSeparator: l,
        thousandSeparator: i,
        prefix: M,
        postfix: g,
        minusSign: b,
      }),
      YI({
        decimalSeparator: l,
        decimalZeroPadding: c,
        precision: n,
        prefix: M,
        postfix: g,
      }),
    ],
    plugins: [
      aO({
        decimalSeparator: l,
        thousandSeparator: i,
        prefix: M,
        postfix: g,
      }),
      oO({
        decimalSeparator: l,
        prefix: M,
        postfix: g,
      }),
      sO({ min: e, max: t, decimalSeparator: l }),
    ],
    overwriteMode: c
      ? ({ value: S, selection: [A] }) => (A <= S.indexOf(l) ? "shift" : "replace")
      : "shift",
  });
}
const lO = (t = "%", e = 100) => {
    const { plugins: n, ...i } = fO({
      postfix: t,
      decimalZeroPadding: !0,
      min: 0,
      max: e,
      precision: 2,
    });
    return {
      ...i,
      plugins: [
        ...n,
        WI((l) => [0, l.length]),
        Ic("blur", (l) => {
          l.value === t && Rc(l, `0${t}`);
        }),
      ],
    };
  },
  uO = ({ tonData: t, ...e }) => {
    const n = PI({
      options: lO(" " + t.symbol, t.numberBalance),
    });
    return /* @__PURE__ */ gt.jsx(NI, { ...e, maskedInputRef: n });
  },
  cO = br.memo(uO),
  hO = "_button_yv9b1_1",
  dO = "_text_yv9b1_16",
  v6 = {
    button: hO,
    text: dO,
  },
  pO = ({ className: t, onClick: e }) =>
    /* @__PURE__ */ gt.jsx("div", {
      className: Xr(v6.button, t),
      onClick: e,
      children: /* @__PURE__ */ gt.jsx(vr, {
        className: v6.text,
        variant: "paragraph5",
        weight: "semiBold",
        children: "MAX",
      }),
    }),
  mO = br.memo(pO),
  vO = "_enterPanel_19jrb_1",
  gO = "_balance_19jrb_7",
  yO = "_balanceText_19jrb_12",
  bO = "_inputs_19jrb_17",
  pl = {
    enterPanel: vO,
    balance: gO,
    balanceText: yO,
    inputs: bO,
  },
  wO = ({ className: t, tonData: e, currentInputValue: n, onChangeInputValue: i, onMaxClick: l }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: Xr(pl.enterPanel, t),
      children: [
        /* @__PURE__ */ gt.jsxs("div", {
          className: pl.balance,
          children: [
            /* @__PURE__ */ gt.jsxs(vr, {
              variant: "paragraph3",
              className: pl.balanceText,
              children: ["Balance: ", e.numberBalance.toFixed(2), " ", e.symbol],
            }),
            /* @__PURE__ */ gt.jsx(mO, { onClick: l }),
          ],
        }),
        /* @__PURE__ */ gt.jsx("div", {
          className: pl.inputs,
          children: /* @__PURE__ */ gt.jsx(cO, {
            value: n,
            tonData: e,
            onChange: i,
          }),
        }),
      ],
    }),
  _O = br.memo(wO),
  xO = "_root_4hx65_1",
  MO = "_vertical_4hx65_5",
  SO = "_value_4hx65_9",
  EO = "_horizontal_4hx65_13",
  AO = "_label_4hx65_19",
  ef = {
    root: xO,
    vertical: MO,
    value: SO,
    horizontal: EO,
    label: AO,
  },
  kO = {
    vertical: ef.vertical,
    horizontal: ef.horizontal,
  },
  BO = ({ className: t, label: e, variant: n = "horizontal", value: i }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: Xr(ef.root, kO[n], t),
      children: [
        /* @__PURE__ */ gt.jsx(vr, {
          className: ef.label,
          variant: "heading4",
          weight: "medium",
          children: e,
        }),
        /* @__PURE__ */ gt.jsx(vr, {
          className: ef.value,
          variant: "paragraph2",
          component: typeof i == "string" ? "p" : "div",
          children: typeof i == "string" ? i : i(),
        }),
      ],
    }),
  xs = br.memo(BO),
  CO = "_root_ux4rg_1",
  TO = "_title_ux4rg_7",
  PO = "_items_ux4rg_11",
  RO = "_itemsInner_ux4rg_19",
  IO = "_item_ux4rg_11",
  OO = "_itemSelected_ux4rg_37",
  UO = "_itemText_ux4rg_44",
  NO = "_itemDisabled_ux4rg_48",
  Ii = {
    root: CO,
    title: TO,
    items: PO,
    itemsInner: RO,
    item: IO,
    itemSelected: OO,
    itemText: UO,
    itemDisabled: NO,
  },
  DO = ({ className: t, pools: e, currentPool: n, currentStake: i, onChange: l }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: Xr(Ii.root, t),
      children: [
        /* @__PURE__ */ gt.jsx(vr, {
          className: Ii.title,
          variant: "heading4",
          weight: "medium",
          children: "LOCK TIME",
        }),
        /* @__PURE__ */ gt.jsx("div", {
          className: Ii.items,
          children: /* @__PURE__ */ gt.jsx("div", {
            className: Ii.itemsInner,
            children: e.map((a) =>
              /* @__PURE__ */ gt.jsx(
                "div",
                {
                  className: Xr(Ii.item, {
                    [Ii.itemSelected]: (n == null ? void 0 : n.lock) === a.lock,
                    [Ii.itemDisabled]: i && a.lock < i.lock,
                  }),
                  onClick: () => l(a),
                  children: /* @__PURE__ */ gt.jsxs(vr, {
                    className: Ii.itemText,
                    variant: "paragraph4",
                    weight: "medium",
                    children: [Math.floor(a.lock.toString() / 86400), "d"],
                  }),
                },
                a.lock
              )
            ),
          }),
        }),
      ],
    }),
  LO = br.memo(DO);
function FO(t, e) {
  Sr(2, arguments);
  var n = Vr(t),
    i = sa(e);
  return isNaN(i) ? /* @__PURE__ */ new Date(NaN) : (i && n.setDate(n.getDate() + i), n);
}
const g6 = (t) => FO(/* @__PURE__ */ new Date(), t.lock.toString() / 86400),
  qO = "_step_1d3rs_1",
  zO = "_backButton_1d3rs_6",
  jO = "_title_1d3rs_12",
  $O = "_enterPanel_1d3rs_16",
  HO = "_infoItem_1d3rs_20",
  VO = "_infoItemInner_1d3rs_24",
  WO = "_infoItemFromValue_1d3rs_30",
  KO = "_infoItemToValue_1d3rs_35",
  ZO = "_infoItemToValuePositive_1d3rs_39",
  GO = "_infoItemToValueNegative_1d3rs_43",
  YO = "_infoItemIcon_1d3rs_47",
  JO = "_action_1d3rs_51",
  rr = {
    step: qO,
    backButton: zO,
    title: jO,
    enterPanel: $O,
    infoItem: HO,
    infoItemInner: VO,
    infoItemFromValue: WO,
    infoItemToValue: KO,
    infoItemToValuePositive: ZO,
    infoItemToValueNegative: GO,
    infoItemIcon: YO,
    action: JO,
  },
  QO = ({
    pools: t,
    tonData: e,
    currentPool: n,
    currentStake: i,
    currentInputValue: l,
    onLockTimeChange: a,
    onMaxClick: c,
    onStakeClick: v,
    onChangeInputValue: g,
    onBackClick: b,
  }) => {
    const p = e_(l, e.decimals);
    return /* @__PURE__ */ gt.jsxs("div", {
      className: rr.step,
      children: [
        /* @__PURE__ */ gt.jsx(vr, {
          className: rr.title,
          variant: "paragraph2",
          weight: "semiBold",
          children: "Staking",
        }),
        i && /* @__PURE__ */ gt.jsx(o_, { className: rr.backButton, onClick: b }),
        /* @__PURE__ */ gt.jsx(_O, {
          className: rr.enterPanel,
          tonData: e,
          currentInputValue: l,
          onMaxClick: c,
          onChangeInputValue: g,
        }),
        /* @__PURE__ */ gt.jsxs("div", {
          className: rr.inner,
          children: [
            /* @__PURE__ */ gt.jsx(LO, {
              pools: t,
              currentPool: n,
              currentStake: i,
              onChange: a,
            }),
            /* @__PURE__ */ gt.jsx(xs, {
              className: rr.infoItem,
              label: "AP Multiplier",
              variant: i ? "vertical" : "horizontal",
              value: i
                ? () => {
                    const _ = s_({
                      currentStake: i,
                      pools: t,
                    });
                    return /* @__PURE__ */ gt.jsxs("div", {
                      className: rr.infoItemInner,
                      children: [
                        /* @__PURE__ */ gt.jsxs(vr, {
                          className: rr.infoItemFromValue,
                          variant: "paragraph2",
                          children: [_ == null ? void 0 : _.toString(), "%"],
                        }),
                        /* @__PURE__ */ gt.jsx(ep, { className: rr.infoItemIcon }),
                        /* @__PURE__ */ gt.jsxs(vr, {
                          className: Xr(rr.infoItemToValue, {
                            [rr.infoItemToValuePositive]:
                              (_ || BigInt(0)) < ((n == null ? void 0 : n.multiplier) || BigInt(0)),
                            [rr.infoItemToValueNegative]:
                              (_ || BigInt(0)) > ((n == null ? void 0 : n.multiplier) || BigInt(0)),
                          }),
                          variant: "paragraph2",
                          children: [n == null ? void 0 : n.multiplier.toString(), "%"],
                        }),
                      ],
                    });
                  }
                : `${n == null ? void 0 : n.multiplier.toString()}%`,
            }),
            /* @__PURE__ */ gt.jsx(xs, {
              className: rr.infoItem,
              label: "Locked till",
              variant: i ? "vertical" : "horizontal",
              value: i
                ? () => {
                    const _ = a_(i),
                      M = g6(n);
                    return /* @__PURE__ */ gt.jsxs("div", {
                      className: rr.infoItemInner,
                      children: [
                        /* @__PURE__ */ gt.jsx(vr, {
                          className: rr.infoItemFromValue,
                          variant: "paragraph2",
                          children: Kl(_, "dd.MM.yyyy hh:mm:ss"),
                        }),
                        /* @__PURE__ */ gt.jsx(ep, { className: rr.infoItemIcon }),
                        /* @__PURE__ */ gt.jsx(vr, {
                          className: Xr(rr.infoItemToValue, {
                            [rr.infoItemToValuePositive]: DR(_, M),
                            [rr.infoItemToValueNegative]: NR(_, M),
                          }),
                          variant: "paragraph2",
                          children: Kl(M, "dd.MM.yyyy hh:mm:ss"),
                        }),
                      ],
                    });
                  }
                : Kl(g6(n), "dd.MM.yyyy hh:mm:ss"),
            }),
            i &&
              /* @__PURE__ */ gt.jsx(xs, {
                className: rr.infoItem,
                label: "Total stake",
                variant: "vertical",
                value: () => {
                  const _ = i.amount;
                  return /* @__PURE__ */ gt.jsxs("div", {
                    className: rr.infoItemInner,
                    children: [
                      /* @__PURE__ */ gt.jsxs(vr, {
                        className: rr.infoItemFromValue,
                        variant: "paragraph2",
                        children: [tf(_, (e == null ? void 0 : e.decimals) ?? 0), " ", e.symbol],
                      }),
                      /* @__PURE__ */ gt.jsx(ep, { className: rr.infoItemIcon }),
                      /* @__PURE__ */ gt.jsxs(vr, {
                        className: Xr(rr.infoItemToValue, {
                          [rr.infoItemToValuePositive]: _ < _ + p,
                        }),
                        variant: "paragraph2",
                        children: [
                          tf(_ + p, (e == null ? void 0 : e.decimals) ?? 0),
                          " ",
                          e.symbol,
                        ],
                      }),
                    ],
                  });
                },
              }),
          ],
        }),
        /* @__PURE__ */ gt.jsx(lf, {
          className: rr.action,
          variant: "outlined",
          disabled: !(p > 0),
          onClick: v,
          children: "Stake GGR",
        }),
      ],
    });
  },
  XO = br.memo(QO),
  eU = "_step_bv5td_1",
  tU = "_title_bv5td_6",
  rU = "_infoItem_bv5td_10",
  nU = "_tokenIcon_bv5td_14",
  iU = "_actions_bv5td_20",
  aU = "_action_bv5td_20",
  ui = {
    step: eU,
    title: tU,
    infoItem: rU,
    tokenIcon: nU,
    actions: iU,
    action: aU,
  },
  sU = ({
    pools: t,
    currentStake: e,
    currentPool: n,
    tonData: i,
    onRestakeClick: l,
    onWithdrawClick: a,
  }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: ui.step,
      children: [
        /* @__PURE__ */ gt.jsx(vr, {
          className: ui.title,
          variant: "paragraph2",
          weight: "semiBold",
          children: "Staking",
        }),
        /* @__PURE__ */ gt.jsxs("div", {
          className: ui.inner,
          children: [
            /* @__PURE__ */ gt.jsx(xs, {
              className: ui.infoItem,
              label: "Your stake",
              value: `${tf(
                (e == null ? void 0 : e.amount) ?? BigInt(0),
                (i == null ? void 0 : i.decimals) ?? 0
              )} ${i.symbol}`,
            }),
            /* @__PURE__ */ gt.jsx(xs, {
              className: ui.infoItem,
              label: "AP Multiplier",
              value: e ? `${s_({ currentStake: e, pools: t })}%` : "N/A",
            }),
            /* @__PURE__ */ gt.jsx(xs, {
              className: ui.infoItem,
              label: "Locked till",
              value: e ? Kl(a_(e), "dd.MM.yyyy hh:mm:ss") : "N/A",
            }),
          ],
        }),
        /* @__PURE__ */ gt.jsxs("div", {
          className: ui.actions,
          children: [
            /* @__PURE__ */ gt.jsx(lf, {
              className: ui.action,
              variant: "outlined",
              disabled: !n,
              onClick: l,
              children: "Restake",
            }),
            /* @__PURE__ */ gt.jsx(lf, {
              className: ui.action,
              variant: "outlined",
              onClick: a,
              children: "Withdraw",
            }),
          ],
        }),
      ],
    }),
  oU = br.memo(sU),
  fU = "_step_e4elo_1",
  lU = "_backButton_e4elo_6",
  uU = "_title_e4elo_12",
  cU = "_text_e4elo_16",
  hU = "_textCaption_e4elo_21",
  dU = "_info_e4elo_25",
  pU = "_infoText_e4elo_31",
  mU = "_infoInner_e4elo_36",
  vU = "_infoIcon_e4elo_43",
  gU = "_infoValue_e4elo_48",
  yU = "_infoValueWithLose_e4elo_54",
  bU = "_actions_e4elo_58",
  wU = "_action_e4elo_58",
  Wr = {
    step: fU,
    backButton: lU,
    title: uU,
    text: cU,
    textCaption: hU,
    info: dU,
    infoText: pU,
    infoInner: mU,
    infoIcon: vU,
    infoValue: gU,
    infoValueWithLose: yU,
    actions: bU,
    action: wU,
  },
  _U = ({
    willLosePercent: t,
    estimatedWithdrawAmount: e,
    tonData: n,
    onBackClick: i,
    onWithdrawConfirmClick: l,
    onWithdrawCancelClick: a,
  }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: Wr.step,
      children: [
        /* @__PURE__ */ gt.jsx(o_, { className: Wr.backButton, onClick: i }),
        /* @__PURE__ */ gt.jsx(vr, {
          className: Wr.title,
          variant: "paragraph2",
          weight: "semiBold",
          children: "Withdraw",
        }),
        t &&
          /* @__PURE__ */ gt.jsxs(vr, {
            className: Wr.text,
            variant: "paragraph2",
            weight: "medium",
            children: [
              "If you withdraw tokens ahead of time, you will lose",
              " ",
              /* @__PURE__ */ gt.jsx(vr, {
                className: Wr.textCaption,
                variant: "paragraph2",
                weight: "medium",
                component: "span",
                children: "30%",
              }),
              " ",
              "of the amount of the lock, are you sure?",
            ],
          }),
        /* @__PURE__ */ gt.jsxs("div", {
          className: Wr.info,
          children: [
            /* @__PURE__ */ gt.jsx(vr, {
              className: Wr.infoText,
              variant: "heading4",
              children: "you will get",
            }),
            /* @__PURE__ */ gt.jsxs("div", {
              className: Wr.infoInner,
              children: [
                /* @__PURE__ */ gt.jsx(l_, { className: Wr.infoIcon }),
                /* @__PURE__ */ gt.jsxs(vr, {
                  className: Xr(Wr.infoValue, {
                    [Wr.infoValueWithLose]: t,
                  }),
                  variant: "heading3",
                  weight: "bold",
                  children: [
                    tf(e ?? BigInt(0), (n == null ? void 0 : n.decimals) ?? 0),
                    " ",
                    n.symbol,
                  ],
                }),
              ],
            }),
          ],
        }),
        /* @__PURE__ */ gt.jsxs("div", {
          className: Wr.actions,
          children: [
            /* @__PURE__ */ gt.jsx(lf, {
              className: Wr.action,
              variant: "error",
              onClick: l,
              children: "Yes",
            }),
            /* @__PURE__ */ gt.jsx(lf, {
              className: Wr.action,
              variant: "success",
              onClick: a,
              children: "No",
            }),
          ],
        }),
      ],
    }),
  xU = br.memo(_U),
  MU = "_loader_ga1u1_1",
  SU = "_loaderAnimation_ga1u1_1",
  EU = {
    loader: MU,
    loaderAnimation: SU,
  },
  AU = ({ className: t }) => /* @__PURE__ */ gt.jsx("div", { className: Xr(EU.loader, t) }),
  kU = br.memo(AU),
  BU = "_staking_1qai0_1",
  CU = "_loading_1qai0_12",
  y6 = {
    staking: BU,
    loading: CU,
  },
  TU = ({
    loading: t,
    confirmLoading: e,
    pools: n,
    tonData: i,
    currentPool: l,
    currentInputValue: a,
    currentStatus: c,
    currentStake: v,
    estimatedWithdrawAmount: g,
    onLockTimeChange: b,
    onChangeInputValue: p,
    onMaxClick: _,
    onStakeClick: M,
    onRestakeClick: S,
    onWithdrawClick: A,
    onWithdrawConfirmClick: k,
    onWithdrawCancelClick: P,
    onBackClick: B,
  }) =>
    /* @__PURE__ */ gt.jsxs("div", {
      className: y6.staking,
      children: [
        !i.isConnected && /* @__PURE__ */ gt.jsx(w_, {}),
        t || !i.isConnected || e
          ? /* @__PURE__ */ gt.jsx(kU, { className: y6.loading })
          : /* @__PURE__ */ gt.jsxs(gt.Fragment, {
              children: [
                c === on.Stake &&
                  /* @__PURE__ */ gt.jsx(XO, {
                    pools: n,
                    tonData: i,
                    currentPool: l,
                    currentStake: v,
                    currentInputValue: a,
                    onLockTimeChange: b,
                    onChangeInputValue: p,
                    onStakeClick: M,
                    onMaxClick: _,
                    onBackClick: B,
                  }),
                c === on.Staked &&
                  /* @__PURE__ */ gt.jsx(oU, {
                    pools: n,
                    currentStake: v,
                    currentPool: l,
                    tonData: i,
                    onRestakeClick: S,
                    onWithdrawClick: A,
                  }),
                c === on.RequestWithdraw &&
                  /* @__PURE__ */ gt.jsx(xU, {
                    willLosePercent: (v == null ? void 0 : v.amount) !== g,
                    estimatedWithdrawAmount: g,
                    tonData: i,
                    onBackClick: B,
                    onWithdrawConfirmClick: k,
                    onWithdrawCancelClick: P,
                  }),
              ],
            }),
      ],
    }),
  PU = br.memo(TU);
let np;
const RU = () => {
    const [t, e] = yn(!0),
      [n, i] = yn(!1),
      [l, a] = yn(null),
      [c, v] = yn([]),
      [g, b] = yn(""),
      [p, _] = yn(on.Stake),
      [M, S] = yn(null),
      [A, k] = yn(BigInt(0)),
      [P, B] = yn(),
      [T] = __(),
      F = _P();
    ip(() => {
      const o = async () => {
        try {
          const f = F.address,
            u = await au.open(await z0.createFromAddress(Ir.Address.parse(J0)));
          B(u);
          const d = (await u.getPools()).pools;
          v(d), a(d[0]);
          const { stake: y } = await u.getStake({
            owner: Ir.Address.parse(f),
          });
          if (y) {
            const w = d.filter((s) => s.lock >= y.lock);
            a(w.length > 0 ? w[0] : null), S(y), _(on.Staked);
            const { amount: h } = await u.getEstimateWithdrawAmount({
              owner: Ir.Address.parse(f),
            });
            k(h);
          }
          e(!1);
        } catch (f) {
          console.error(f), e(!1);
        }
      };
      F.isConnected && o();
    }, [F.isConnected]),
      ip(() => {
        const o = async () => {
          try {
            const f = F.address,
              { stake: u } = await P.getStake({
                owner: Ir.Address.parse(f),
              }),
              d = c.filter((y) => y.lock >= u.lock);
            if (u) {
              const { amount: y } = await P.getEstimateWithdrawAmount({
                owner: Ir.Address.parse(f),
              });
              k(y);
            }
            M &&
              M.amount < u.amount &&
              (S(u), a(d.length > 0 ? d[0] : null), i(!1), clearInterval(np)),
              !M && u && (S(u), i(!1), a(d.length > 0 ? d[0] : null), clearInterval(np));
          } catch {}
        };
        p === on.Staked &&
          n &&
          (np = setInterval(() => {
            o();
          }, 5e3));
      }, [c, n, M, p]);
    const O = (o) => {
        a(o);
      },
      $ = (o) => {
        b(o.target.value);
      },
      J = () => {
        b(`${F.numberBalance.toFixed(2)} ${F.symbol}`);
      },
      he = async () => {
        const o = Ir.Address.parse(F.address),
          f = Ir.Address.parse(H8),
          u = au.open(Z4.createFromAddress(f)),
          { address: d } = await u.getWalletAddress(o),
          y = G4.buildSendTransferMsg({
            destAddr: Ir.Address.parse(J0),
            jettonAmount: e_(g, F.decimals),
            responseAddr: o,
            forwardToncoinAmount: Ir.toNano("0.3"),
            forwardPayload: z0.buildStakeMsgBody({
              lock: (l == null ? void 0 : l.lock) ?? BigInt(0),
            }),
            customPayload: Ir.Dictionary.empty(),
          });
        await T.sendTransaction({
          validUntil: Date.now() + 1e6,
          messages: [
            {
              address: d.toString(),
              amount: Ir.toNano("0.5").toString(),
              payload: y.toBoc().toString("base64"),
            },
          ],
        }),
          i(!0),
          _(on.Staked);
      },
      de = async () => {
        _(on.Stake);
      },
      ne = async () => {
        _(on.RequestWithdraw);
      },
      Ae = () => {
        _(on.Staked);
      },
      x = async () => {
        try {
          i(!0),
            await T.sendTransaction({
              validUntil: Date.now() + 1e6,
              messages: [
                {
                  address: J0,
                  amount: Ir.toNano("0.5").toString(),
                  payload: z0.buildWithdrawPayload().toBoc().toString("base64"),
                },
              ],
            }),
            i(!1),
            _(on.Stake),
            a(c[0]),
            S(null);
        } catch {
          i(!1);
        }
      },
      r = () => {
        _(on.Staked);
      };
    return /* @__PURE__ */ gt.jsx(PU, {
      loading: t,
      confirmLoading: n,
      pools: c,
      tonData: F,
      currentPool: l,
      currentInputValue: g,
      currentStatus: p,
      currentStake: M,
      estimatedWithdrawAmount: A,
      onLockTimeChange: O,
      onChangeInputValue: $,
      onMaxClick: J,
      onStakeClick: he,
      onRestakeClick: de,
      onWithdrawClick: ne,
      onBackClick: Ae,
      onWithdrawConfirmClick: x,
      onWithdrawCancelClick: r,
    });
  },
  IU = br.memo(RU),
  OU = ({ children: t }) => {
    const [e] = yn(new tP());
    return /* @__PURE__ */ gt.jsx(sP, { client: e, children: t });
  },
  UU = br.memo(OU),
  NU = () => /* @__PURE__ */ gt.jsx(UU, { children: /* @__PURE__ */ gt.jsx(IU, {}) }),
  wN = br.memo(NU);
export { wN as StakingWidget };
